import { defineComponent as ke, inject as Nt, ref as R, computed as m, onMounted as dt, onBeforeUnmount as mt, reactive as sl, provide as nn, openBlock as c, createElementBlock as g, normalizeClass as C, renderSlot as Ae, useId as je, toValue as Rt, watch as $e, readonly as yx, shallowRef as Yl, onUpdated as Ki, nextTick as Ue, Fragment as ce, createBlock as H, resolveDynamicComponent as lt, mergeProps as Oe, withKeys as ut, withCtx as xe, Teleport as Dn, unref as I, toDisplayString as N, createCommentVNode as k, createVNode as re, Transition as wt, createTextVNode as et, createElementVNode as v, useSlots as Mn, withModifiers as Ye, normalizeStyle as Ne, useAttrs as Nn, normalizeProps as Zt, guardReactiveProps as tn, renderList as Re, mergeDefaults as Wb, toHandlers as Ml, h as Kn, onUnmounted as gt, shallowReactive as kx, createStaticVNode as to, Comment as $u, Text as wx, getCurrentInstance as Iu, watchEffect as qb, markRaw as Cx, customRef as Sx, toRef as wn, createSlots as ta, withDirectives as Jl, vModelText as Ub, onBeforeUpdate as $x, useModel as Gb, mergeModels as $d, vModelDynamic as Ix, vShow as Tu, useTemplateRef as Yn, TransitionGroup as Pr, isRef as Wo, toRefs as _c, resolveComponent as Tx } from "vue";
const Kb = Symbol("AccordionContext"), Yb = Symbol("AccordionItemContext"), Lx = ["data-accordion-root"], OW = /* @__PURE__ */ ke({
  __name: "Accordion",
  props: {
    variant: { default: "default" },
    size: { default: void 0 },
    multiple: { type: Boolean, default: void 0 },
    headingLevel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Nt(Yb, null), a = R(), l = R(!!t), r = m(() => l.value && (t == null ? void 0 : t.variant.value) === "multi-level");
    let o;
    dt(() => {
      var x, y;
      l.value = !!t && !!((y = (x = a.value) == null ? void 0 : x.parentElement) != null && y.closest("[data-accordion-item]")), l.value && (o = t == null ? void 0 : t.registerChildAccordion());
    }), mt(() => o == null ? void 0 : o());
    const i = m(() => r.value ? "multi-level" : n.variant), s = m(() => n.size ?? (r.value && t ? t.size.value : "md")), d = m(() => n.headingLevel ? n.headingLevel : l.value && t ? Math.min(t.headingLevel.value + 1, 6) : 3), u = m(
      () => n.multiple ?? !["separate-cards", "multi-level"].includes(i.value)
    ), f = sl(/* @__PURE__ */ new Set());
    function b(x) {
      f.has(x) ? f.delete(x) : (u.value || f.clear(), f.add(x));
    }
    function h(x) {
      f.add(x);
    }
    nn(Kb, {
      variant: i,
      size: s,
      headingLevel: d,
      isChildLevel: r,
      openItems: f,
      toggleItem: b,
      openItem: h
    });
    const p = m(() => {
      if (r.value) return "";
      switch (i.value) {
        case "flush":
          return "";
        case "separate-cards":
          return "flex flex-col gap-3";
        default:
          return "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden";
      }
    });
    return (x, y) => (c(), g("div", {
      ref_key: "rootEl",
      ref: a,
      class: C(p.value),
      "data-accordion-root": r.value ? void 0 : "",
      "data-testid": "accordion"
    }, [
      Ae(x.$slots, "default")
    ], 10, Lx));
  }
});
function Jb(e = {}) {
  const n = e.id ?? je(), t = `${n}-trigger`, a = `${n}-content`, l = R(!1), r = m(() => Rt(e.open) !== void 0), o = m(() => r.value ? Rt(e.open) : e.store ? e.store.isOpen() : l.value);
  dt(() => {
    r.value || !Rt(e.defaultOpen) || o.value || (e.store ? e.store.open() : l.value = !0);
  });
  const i = () => {
    var y;
    const x = !o.value;
    return r.value || (e.store ? e.store.toggle() : l.value = x), (y = e.onOpenChange) == null || y.call(e, x), x;
  }, s = R(!1), d = () => {
    var x;
    return typeof window < "u" && !!((x = window.matchMedia) != null && x.call(window, "(prefers-reduced-motion: reduce)").matches);
  };
  let u = !1;
  dt(() => requestAnimationFrame(() => u = !0)), $e(
    o,
    (x) => {
      s.value = x && (!u || d());
    },
    { immediate: !0 }
  );
  const f = (x) => {
    x.target === x.currentTarget && x.propertyName === "grid-template-rows" && o.value && (s.value = !0);
  }, b = m(() => ({
    id: t,
    "aria-expanded": o.value,
    "aria-controls": a
  })), h = m(() => ({
    id: a,
    role: "region",
    "aria-labelledby": t,
    "aria-hidden": !o.value,
    inert: !o.value || void 0
  })), p = m(() => [
    "accordion-content",
    { "accordion-content--expanded": o.value, "accordion-content--open": s.value }
  ]);
  return {
    id: n,
    triggerId: t,
    panelId: a,
    isOpen: o,
    isControlled: r,
    isFullyOpen: yx(s),
    toggle: i,
    onTransitionEnd: f,
    triggerProps: b,
    panelProps: h,
    panelClasses: p
  };
}
var dn = "top", An = "bottom", En = "right", un = "left", Lu = "auto", no = [dn, An, En, un], zl = "start", Fr = "end", Ax = "clippingParents", Xb = "viewport", nr = "popper", Ex = "reference", ef = /* @__PURE__ */ no.reduce(function(e, n) {
  return e.concat([n + "-" + zl, n + "-" + Fr]);
}, []), Zb = /* @__PURE__ */ [].concat(no, [Lu]).reduce(function(e, n) {
  return e.concat([n, n + "-" + zl, n + "-" + Fr]);
}, []), Rx = "beforeRead", Bx = "read", Dx = "afterRead", Mx = "beforeMain", zx = "main", Ox = "afterMain", Px = "beforeWrite", Fx = "write", Vx = "afterWrite", Nx = [Rx, Bx, Dx, Mx, zx, Ox, Px, Fx, Vx];
function Zn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function mn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function dl(e) {
  var n = mn(e).Element;
  return e instanceof n || e instanceof Element;
}
function Sn(e) {
  var n = mn(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function Au(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = mn(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function Hx(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(t) {
    var a = n.styles[t] || {}, l = n.attributes[t] || {}, r = n.elements[t];
    !Sn(r) || !Zn(r) || (Object.assign(r.style, a), Object.keys(l).forEach(function(o) {
      var i = l[o];
      i === !1 ? r.removeAttribute(o) : r.setAttribute(o, i === !0 ? "" : i);
    }));
  });
}
function jx(e) {
  var n = e.state, t = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow), function() {
    Object.keys(n.elements).forEach(function(a) {
      var l = n.elements[a], r = n.attributes[a] || {}, o = Object.keys(n.styles.hasOwnProperty(a) ? n.styles[a] : t[a]), i = o.reduce(function(s, d) {
        return s[d] = "", s;
      }, {});
      !Sn(l) || !Zn(l) || (Object.assign(l.style, i), Object.keys(r).forEach(function(s) {
        l.removeAttribute(s);
      }));
    });
  };
}
const Wx = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Hx,
  effect: jx,
  requires: ["computeStyles"]
};
function Jn(e) {
  return e.split("-")[0];
}
var nl = Math.max, ei = Math.min, Ol = Math.round;
function Id() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function Qb() {
  return !/^((?!chrome|android).)*safari/i.test(Id());
}
function Pl(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  var a = e.getBoundingClientRect(), l = 1, r = 1;
  n && Sn(e) && (l = e.offsetWidth > 0 && Ol(a.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && Ol(a.height) / e.offsetHeight || 1);
  var o = dl(e) ? mn(e) : window, i = o.visualViewport, s = !Qb() && t, d = (a.left + (s && i ? i.offsetLeft : 0)) / l, u = (a.top + (s && i ? i.offsetTop : 0)) / r, f = a.width / l, b = a.height / r;
  return {
    width: f,
    height: b,
    top: u,
    right: d + f,
    bottom: u + b,
    left: d,
    x: d,
    y: u
  };
}
function Eu(e) {
  var n = Pl(e), t = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(n.width - t) <= 1 && (t = n.width), Math.abs(n.height - a) <= 1 && (a = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: a
  };
}
function _b(e, n) {
  var t = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && Au(t)) {
    var a = n;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function fa(e) {
  return mn(e).getComputedStyle(e);
}
function qx(e) {
  return ["table", "td", "th"].indexOf(Zn(e)) >= 0;
}
function Ha(e) {
  return ((dl(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Yi(e) {
  return Zn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Au(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ha(e)
  );
}
function tf(e) {
  return !Sn(e) || // https://github.com/popperjs/popper-core/issues/837
  fa(e).position === "fixed" ? null : e.offsetParent;
}
function Ux(e) {
  var n = /firefox/i.test(Id()), t = /Trident/i.test(Id());
  if (t && Sn(e)) {
    var a = fa(e);
    if (a.position === "fixed")
      return null;
  }
  var l = Yi(e);
  for (Au(l) && (l = l.host); Sn(l) && ["html", "body"].indexOf(Zn(l)) < 0; ) {
    var r = fa(l);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || n && r.willChange === "filter" || n && r.filter && r.filter !== "none")
      return l;
    l = l.parentNode;
  }
  return null;
}
function ao(e) {
  for (var n = mn(e), t = tf(e); t && qx(t) && fa(t).position === "static"; )
    t = tf(t);
  return t && (Zn(t) === "html" || Zn(t) === "body" && fa(t).position === "static") ? n : t || Ux(e) || n;
}
function Ru(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function xr(e, n, t) {
  return nl(e, ei(n, t));
}
function Gx(e, n, t) {
  var a = xr(e, n, t);
  return a > t ? t : a;
}
function eg() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function tg(e) {
  return Object.assign({}, eg(), e);
}
function ng(e, n) {
  return n.reduce(function(t, a) {
    return t[a] = e, t;
  }, {});
}
var Kx = function(n, t) {
  return n = typeof n == "function" ? n(Object.assign({}, t.rects, {
    placement: t.placement
  })) : n, tg(typeof n != "number" ? n : ng(n, no));
};
function Yx(e) {
  var n, t = e.state, a = e.name, l = e.options, r = t.elements.arrow, o = t.modifiersData.popperOffsets, i = Jn(t.placement), s = Ru(i), d = [un, En].indexOf(i) >= 0, u = d ? "height" : "width";
  if (!(!r || !o)) {
    var f = Kx(l.padding, t), b = Eu(r), h = s === "y" ? dn : un, p = s === "y" ? An : En, x = t.rects.reference[u] + t.rects.reference[s] - o[s] - t.rects.popper[u], y = o[s] - t.rects.reference[s], w = ao(r), $ = w ? s === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, S = x / 2 - y / 2, L = f[h], T = $ - b[u] - f[p], E = $ / 2 - b[u] / 2 + S, A = xr(L, E, T), D = s;
    t.modifiersData[a] = (n = {}, n[D] = A, n.centerOffset = A - E, n);
  }
}
function Jx(e) {
  var n = e.state, t = e.options, a = t.element, l = a === void 0 ? "[data-popper-arrow]" : a;
  l != null && (typeof l == "string" && (l = n.elements.popper.querySelector(l), !l) || _b(n.elements.popper, l) && (n.elements.arrow = l));
}
const Xx = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Yx,
  effect: Jx,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Fl(e) {
  return e.split("-")[1];
}
var Zx = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Qx(e, n) {
  var t = e.x, a = e.y, l = n.devicePixelRatio || 1;
  return {
    x: Ol(t * l) / l || 0,
    y: Ol(a * l) / l || 0
  };
}
function nf(e) {
  var n, t = e.popper, a = e.popperRect, l = e.placement, r = e.variation, o = e.offsets, i = e.position, s = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, f = e.isFixed, b = o.x, h = b === void 0 ? 0 : b, p = o.y, x = p === void 0 ? 0 : p, y = typeof u == "function" ? u({
    x: h,
    y: x
  }) : {
    x: h,
    y: x
  };
  h = y.x, x = y.y;
  var w = o.hasOwnProperty("x"), $ = o.hasOwnProperty("y"), S = un, L = dn, T = window;
  if (d) {
    var E = ao(t), A = "clientHeight", D = "clientWidth";
    if (E === mn(t) && (E = Ha(t), fa(E).position !== "static" && i === "absolute" && (A = "scrollHeight", D = "scrollWidth")), E = E, l === dn || (l === un || l === En) && r === Fr) {
      L = An;
      var M = f && E === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        E[A]
      );
      x -= M - a.height, x *= s ? 1 : -1;
    }
    if (l === un || (l === dn || l === An) && r === Fr) {
      S = En;
      var F = f && E === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        E[D]
      );
      h -= F - a.width, h *= s ? 1 : -1;
    }
  }
  var X = Object.assign({
    position: i
  }, d && Zx), _ = u === !0 ? Qx({
    x: h,
    y: x
  }, mn(t)) : {
    x: h,
    y: x
  };
  if (h = _.x, x = _.y, s) {
    var Y;
    return Object.assign({}, X, (Y = {}, Y[L] = $ ? "0" : "", Y[S] = w ? "0" : "", Y.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + x + "px)" : "translate3d(" + h + "px, " + x + "px, 0)", Y));
  }
  return Object.assign({}, X, (n = {}, n[L] = $ ? x + "px" : "", n[S] = w ? h + "px" : "", n.transform = "", n));
}
function _x(e) {
  var n = e.state, t = e.options, a = t.gpuAcceleration, l = a === void 0 ? !0 : a, r = t.adaptive, o = r === void 0 ? !0 : r, i = t.roundOffsets, s = i === void 0 ? !0 : i, d = {
    placement: Jn(n.placement),
    variation: Fl(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: l,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, nf(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, nf(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const e0 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: _x,
  data: {}
};
var go = {
  passive: !0
};
function t0(e) {
  var n = e.state, t = e.instance, a = e.options, l = a.scroll, r = l === void 0 ? !0 : l, o = a.resize, i = o === void 0 ? !0 : o, s = mn(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return r && d.forEach(function(u) {
    u.addEventListener("scroll", t.update, go);
  }), i && s.addEventListener("resize", t.update, go), function() {
    r && d.forEach(function(u) {
      u.removeEventListener("scroll", t.update, go);
    }), i && s.removeEventListener("resize", t.update, go);
  };
}
const n0 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: t0,
  data: {}
};
var a0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function qo(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return a0[n];
  });
}
var l0 = {
  start: "end",
  end: "start"
};
function af(e) {
  return e.replace(/start|end/g, function(n) {
    return l0[n];
  });
}
function Bu(e) {
  var n = mn(e), t = n.pageXOffset, a = n.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: a
  };
}
function Du(e) {
  return Pl(Ha(e)).left + Bu(e).scrollLeft;
}
function r0(e, n) {
  var t = mn(e), a = Ha(e), l = t.visualViewport, r = a.clientWidth, o = a.clientHeight, i = 0, s = 0;
  if (l) {
    r = l.width, o = l.height;
    var d = Qb();
    (d || !d && n === "fixed") && (i = l.offsetLeft, s = l.offsetTop);
  }
  return {
    width: r,
    height: o,
    x: i + Du(e),
    y: s
  };
}
function o0(e) {
  var n, t = Ha(e), a = Bu(e), l = (n = e.ownerDocument) == null ? void 0 : n.body, r = nl(t.scrollWidth, t.clientWidth, l ? l.scrollWidth : 0, l ? l.clientWidth : 0), o = nl(t.scrollHeight, t.clientHeight, l ? l.scrollHeight : 0, l ? l.clientHeight : 0), i = -a.scrollLeft + Du(e), s = -a.scrollTop;
  return fa(l || t).direction === "rtl" && (i += nl(t.clientWidth, l ? l.clientWidth : 0) - r), {
    width: r,
    height: o,
    x: i,
    y: s
  };
}
function Mu(e) {
  var n = fa(e), t = n.overflow, a = n.overflowX, l = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + l + a);
}
function ag(e) {
  return ["html", "body", "#document"].indexOf(Zn(e)) >= 0 ? e.ownerDocument.body : Sn(e) && Mu(e) ? e : ag(Yi(e));
}
function yr(e, n) {
  var t;
  n === void 0 && (n = []);
  var a = ag(e), l = a === ((t = e.ownerDocument) == null ? void 0 : t.body), r = mn(a), o = l ? [r].concat(r.visualViewport || [], Mu(a) ? a : []) : a, i = n.concat(o);
  return l ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(yr(Yi(o)))
  );
}
function Td(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function i0(e, n) {
  var t = Pl(e, !1, n === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function lf(e, n, t) {
  return n === Xb ? Td(r0(e, t)) : dl(n) ? i0(n, t) : Td(o0(Ha(e)));
}
function s0(e) {
  var n = yr(Yi(e)), t = ["absolute", "fixed"].indexOf(fa(e).position) >= 0, a = t && Sn(e) ? ao(e) : e;
  return dl(a) ? n.filter(function(l) {
    return dl(l) && _b(l, a) && Zn(l) !== "body";
  }) : [];
}
function d0(e, n, t, a) {
  var l = n === "clippingParents" ? s0(e) : [].concat(n), r = [].concat(l, [t]), o = r[0], i = r.reduce(function(s, d) {
    var u = lf(e, d, a);
    return s.top = nl(u.top, s.top), s.right = ei(u.right, s.right), s.bottom = ei(u.bottom, s.bottom), s.left = nl(u.left, s.left), s;
  }, lf(e, o, a));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function lg(e) {
  var n = e.reference, t = e.element, a = e.placement, l = a ? Jn(a) : null, r = a ? Fl(a) : null, o = n.x + n.width / 2 - t.width / 2, i = n.y + n.height / 2 - t.height / 2, s;
  switch (l) {
    case dn:
      s = {
        x: o,
        y: n.y - t.height
      };
      break;
    case An:
      s = {
        x: o,
        y: n.y + n.height
      };
      break;
    case En:
      s = {
        x: n.x + n.width,
        y: i
      };
      break;
    case un:
      s = {
        x: n.x - t.width,
        y: i
      };
      break;
    default:
      s = {
        x: n.x,
        y: n.y
      };
  }
  var d = l ? Ru(l) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (r) {
      case zl:
        s[d] = s[d] - (n[u] / 2 - t[u] / 2);
        break;
      case Fr:
        s[d] = s[d] + (n[u] / 2 - t[u] / 2);
        break;
    }
  }
  return s;
}
function Vr(e, n) {
  n === void 0 && (n = {});
  var t = n, a = t.placement, l = a === void 0 ? e.placement : a, r = t.strategy, o = r === void 0 ? e.strategy : r, i = t.boundary, s = i === void 0 ? Ax : i, d = t.rootBoundary, u = d === void 0 ? Xb : d, f = t.elementContext, b = f === void 0 ? nr : f, h = t.altBoundary, p = h === void 0 ? !1 : h, x = t.padding, y = x === void 0 ? 0 : x, w = tg(typeof y != "number" ? y : ng(y, no)), $ = b === nr ? Ex : nr, S = e.rects.popper, L = e.elements[p ? $ : b], T = d0(dl(L) ? L : L.contextElement || Ha(e.elements.popper), s, u, o), E = Pl(e.elements.reference), A = lg({
    reference: E,
    element: S,
    placement: l
  }), D = Td(Object.assign({}, S, A)), M = b === nr ? D : E, F = {
    top: T.top - M.top + w.top,
    bottom: M.bottom - T.bottom + w.bottom,
    left: T.left - M.left + w.left,
    right: M.right - T.right + w.right
  }, X = e.modifiersData.offset;
  if (b === nr && X) {
    var _ = X[l];
    Object.keys(F).forEach(function(Y) {
      var B = [En, An].indexOf(Y) >= 0 ? 1 : -1, W = [dn, An].indexOf(Y) >= 0 ? "y" : "x";
      F[Y] += _[W] * B;
    });
  }
  return F;
}
function u0(e, n) {
  n === void 0 && (n = {});
  var t = n, a = t.placement, l = t.boundary, r = t.rootBoundary, o = t.padding, i = t.flipVariations, s = t.allowedAutoPlacements, d = s === void 0 ? Zb : s, u = Fl(a), f = u ? i ? ef : ef.filter(function(p) {
    return Fl(p) === u;
  }) : no, b = f.filter(function(p) {
    return d.indexOf(p) >= 0;
  });
  b.length === 0 && (b = f);
  var h = b.reduce(function(p, x) {
    return p[x] = Vr(e, {
      placement: x,
      boundary: l,
      rootBoundary: r,
      padding: o
    })[Jn(x)], p;
  }, {});
  return Object.keys(h).sort(function(p, x) {
    return h[p] - h[x];
  });
}
function c0(e) {
  if (Jn(e) === Lu)
    return [];
  var n = qo(e);
  return [af(e), n, af(n)];
}
function f0(e) {
  var n = e.state, t = e.options, a = e.name;
  if (!n.modifiersData[a]._skip) {
    for (var l = t.mainAxis, r = l === void 0 ? !0 : l, o = t.altAxis, i = o === void 0 ? !0 : o, s = t.fallbackPlacements, d = t.padding, u = t.boundary, f = t.rootBoundary, b = t.altBoundary, h = t.flipVariations, p = h === void 0 ? !0 : h, x = t.allowedAutoPlacements, y = n.options.placement, w = Jn(y), $ = w === y, S = s || ($ || !p ? [qo(y)] : c0(y)), L = [y].concat(S).reduce(function(me, ye) {
      return me.concat(Jn(ye) === Lu ? u0(n, {
        placement: ye,
        boundary: u,
        rootBoundary: f,
        padding: d,
        flipVariations: p,
        allowedAutoPlacements: x
      }) : ye);
    }, []), T = n.rects.reference, E = n.rects.popper, A = /* @__PURE__ */ new Map(), D = !0, M = L[0], F = 0; F < L.length; F++) {
      var X = L[F], _ = Jn(X), Y = Fl(X) === zl, B = [dn, An].indexOf(_) >= 0, W = B ? "width" : "height", U = Vr(n, {
        placement: X,
        boundary: u,
        rootBoundary: f,
        altBoundary: b,
        padding: d
      }), z = B ? Y ? En : un : Y ? An : dn;
      T[W] > E[W] && (z = qo(z));
      var P = qo(z), K = [];
      if (r && K.push(U[_] <= 0), i && K.push(U[z] <= 0, U[P] <= 0), K.every(function(me) {
        return me;
      })) {
        M = X, D = !1;
        break;
      }
      A.set(X, K);
    }
    if (D)
      for (var j = p ? 3 : 1, G = function(ye) {
        var Z = L.find(function(de) {
          var ge = A.get(de);
          if (ge)
            return ge.slice(0, ye).every(function(se) {
              return se;
            });
        });
        if (Z)
          return M = Z, "break";
      }, q = j; q > 0; q--) {
        var J = G(q);
        if (J === "break") break;
      }
    n.placement !== M && (n.modifiersData[a]._skip = !0, n.placement = M, n.reset = !0);
  }
}
const h0 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: f0,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function rf(e, n, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - t.y,
    right: e.right - n.width + t.x,
    bottom: e.bottom - n.height + t.y,
    left: e.left - n.width - t.x
  };
}
function of(e) {
  return [dn, En, An, un].some(function(n) {
    return e[n] >= 0;
  });
}
function b0(e) {
  var n = e.state, t = e.name, a = n.rects.reference, l = n.rects.popper, r = n.modifiersData.preventOverflow, o = Vr(n, {
    elementContext: "reference"
  }), i = Vr(n, {
    altBoundary: !0
  }), s = rf(o, a), d = rf(i, l, r), u = of(s), f = of(d);
  n.modifiersData[t] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const g0 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: b0
};
function m0(e, n, t) {
  var a = Jn(e), l = [un, dn].indexOf(a) >= 0 ? -1 : 1, r = typeof t == "function" ? t(Object.assign({}, n, {
    placement: e
  })) : t, o = r[0], i = r[1];
  return o = o || 0, i = (i || 0) * l, [un, En].indexOf(a) >= 0 ? {
    x: i,
    y: o
  } : {
    x: o,
    y: i
  };
}
function p0(e) {
  var n = e.state, t = e.options, a = e.name, l = t.offset, r = l === void 0 ? [0, 0] : l, o = Zb.reduce(function(u, f) {
    return u[f] = m0(f, n.rects, r), u;
  }, {}), i = o[n.placement], s = i.x, d = i.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += s, n.modifiersData.popperOffsets.y += d), n.modifiersData[a] = o;
}
const v0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: p0
};
function x0(e) {
  var n = e.state, t = e.name;
  n.modifiersData[t] = lg({
    reference: n.rects.reference,
    element: n.rects.popper,
    placement: n.placement
  });
}
const y0 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: x0,
  data: {}
};
function k0(e) {
  return e === "x" ? "y" : "x";
}
function w0(e) {
  var n = e.state, t = e.options, a = e.name, l = t.mainAxis, r = l === void 0 ? !0 : l, o = t.altAxis, i = o === void 0 ? !1 : o, s = t.boundary, d = t.rootBoundary, u = t.altBoundary, f = t.padding, b = t.tether, h = b === void 0 ? !0 : b, p = t.tetherOffset, x = p === void 0 ? 0 : p, y = Vr(n, {
    boundary: s,
    rootBoundary: d,
    padding: f,
    altBoundary: u
  }), w = Jn(n.placement), $ = Fl(n.placement), S = !$, L = Ru(w), T = k0(L), E = n.modifiersData.popperOffsets, A = n.rects.reference, D = n.rects.popper, M = typeof x == "function" ? x(Object.assign({}, n.rects, {
    placement: n.placement
  })) : x, F = typeof M == "number" ? {
    mainAxis: M,
    altAxis: M
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, M), X = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, _ = {
    x: 0,
    y: 0
  };
  if (E) {
    if (r) {
      var Y, B = L === "y" ? dn : un, W = L === "y" ? An : En, U = L === "y" ? "height" : "width", z = E[L], P = z + y[B], K = z - y[W], j = h ? -D[U] / 2 : 0, G = $ === zl ? A[U] : D[U], q = $ === zl ? -D[U] : -A[U], J = n.elements.arrow, me = h && J ? Eu(J) : {
        width: 0,
        height: 0
      }, ye = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : eg(), Z = ye[B], de = ye[W], ge = xr(0, A[U], me[U]), se = S ? A[U] / 2 - j - ge - Z - F.mainAxis : G - ge - Z - F.mainAxis, Se = S ? -A[U] / 2 + j + ge + de + F.mainAxis : q + ge + de + F.mainAxis, V = n.elements.arrow && ao(n.elements.arrow), Q = V ? L === "y" ? V.clientTop || 0 : V.clientLeft || 0 : 0, le = (Y = X == null ? void 0 : X[L]) != null ? Y : 0, ee = z + se - le - Q, O = z + Se - le, ne = xr(h ? ei(P, ee) : P, z, h ? nl(K, O) : K);
      E[L] = ne, _[L] = ne - z;
    }
    if (i) {
      var fe, ue = L === "x" ? dn : un, te = L === "x" ? An : En, oe = E[T], Le = T === "y" ? "height" : "width", Ie = oe + y[ue], ve = oe - y[te], we = [dn, un].indexOf(w) !== -1, he = (fe = X == null ? void 0 : X[T]) != null ? fe : 0, Me = we ? Ie : oe - A[Le] - D[Le] - he + F.altAxis, Ee = we ? oe + A[Le] + D[Le] - he - F.altAxis : ve, He = h && we ? Gx(Me, oe, Ee) : xr(h ? Me : Ie, oe, h ? Ee : ve);
      E[T] = He, _[T] = He - oe;
    }
    n.modifiersData[a] = _;
  }
}
const C0 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: w0,
  requiresIfExists: ["offset"]
};
function S0(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function $0(e) {
  return e === mn(e) || !Sn(e) ? Bu(e) : S0(e);
}
function I0(e) {
  var n = e.getBoundingClientRect(), t = Ol(n.width) / e.offsetWidth || 1, a = Ol(n.height) / e.offsetHeight || 1;
  return t !== 1 || a !== 1;
}
function T0(e, n, t) {
  t === void 0 && (t = !1);
  var a = Sn(n), l = Sn(n) && I0(n), r = Ha(n), o = Pl(e, l, t), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (a || !a && !t) && ((Zn(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Mu(r)) && (i = $0(n)), Sn(n) ? (s = Pl(n, !0), s.x += n.clientLeft, s.y += n.clientTop) : r && (s.x = Du(r))), {
    x: o.left + i.scrollLeft - s.x,
    y: o.top + i.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function L0(e) {
  var n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(r) {
    n.set(r.name, r);
  });
  function l(r) {
    t.add(r.name);
    var o = [].concat(r.requires || [], r.requiresIfExists || []);
    o.forEach(function(i) {
      if (!t.has(i)) {
        var s = n.get(i);
        s && l(s);
      }
    }), a.push(r);
  }
  return e.forEach(function(r) {
    t.has(r.name) || l(r);
  }), a;
}
function A0(e) {
  var n = L0(e);
  return Nx.reduce(function(t, a) {
    return t.concat(n.filter(function(l) {
      return l.phase === a;
    }));
  }, []);
}
function E0(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(t) {
      Promise.resolve().then(function() {
        n = void 0, t(e());
      });
    })), n;
  };
}
function R0(e) {
  var n = e.reduce(function(t, a) {
    var l = t[a.name];
    return t[a.name] = l ? Object.assign({}, l, a, {
      options: Object.assign({}, l.options, a.options),
      data: Object.assign({}, l.data, a.data)
    }) : a, t;
  }, {});
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}
var sf = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function df() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return !n.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function B0(e) {
  e === void 0 && (e = {});
  var n = e, t = n.defaultModifiers, a = t === void 0 ? [] : t, l = n.defaultOptions, r = l === void 0 ? sf : l;
  return function(i, s, d) {
    d === void 0 && (d = r);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, sf, r),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], b = !1, h = {
      state: u,
      setOptions: function(w) {
        var $ = typeof w == "function" ? w(u.options) : w;
        x(), u.options = Object.assign({}, r, u.options, $), u.scrollParents = {
          reference: dl(i) ? yr(i) : i.contextElement ? yr(i.contextElement) : [],
          popper: yr(s)
        };
        var S = A0(R0([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = S.filter(function(L) {
          return L.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var w = u.elements, $ = w.reference, S = w.popper;
          if (df($, S)) {
            u.rects = {
              reference: T0($, ao(S), u.options.strategy === "fixed"),
              popper: Eu(S)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(F) {
              return u.modifiersData[F.name] = Object.assign({}, F.data);
            });
            for (var L = 0; L < u.orderedModifiers.length; L++) {
              if (u.reset === !0) {
                u.reset = !1, L = -1;
                continue;
              }
              var T = u.orderedModifiers[L], E = T.fn, A = T.options, D = A === void 0 ? {} : A, M = T.name;
              typeof E == "function" && (u = E({
                state: u,
                options: D,
                name: M,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: E0(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        x(), b = !0;
      }
    };
    if (!df(i, s))
      return h;
    h.setOptions(d).then(function(y) {
      !b && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function p() {
      u.orderedModifiers.forEach(function(y) {
        var w = y.name, $ = y.options, S = $ === void 0 ? {} : $, L = y.effect;
        if (typeof L == "function") {
          var T = L({
            state: u,
            name: w,
            instance: h,
            options: S
          }), E = function() {
          };
          f.push(T || E);
        }
      });
    }
    function x() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var D0 = [n0, y0, e0, Wx, v0, h0, C0, Xx, g0], ja = /* @__PURE__ */ B0({
  defaultModifiers: D0
});
const Vl = [];
function Qn(e) {
  Vl.includes(e) || Vl.push(e);
}
function Rn(e) {
  const n = Vl.indexOf(e);
  n !== -1 && Vl.splice(n, 1);
}
function ha(e) {
  return Vl[Vl.length - 1] === e;
}
const Pn = Yl([]);
let rg = "";
function M0(e) {
  Pn.value.includes(e) || (Pn.value.length === 0 && (rg = document.body.style.overflow, document.body.style.overflow = "hidden"), Pn.value = [...Pn.value, e]);
}
function uf(e) {
  Pn.value.includes(e) && (Pn.value = Pn.value.filter((n) => n !== e), Pn.value.length === 0 && (document.body.style.overflow = rg));
}
const og = {
  top: ["bottom"],
  bottom: ["top"],
  left: ["right", "top", "bottom"],
  right: ["left", "top", "bottom"]
}, ig = 8, ba = [
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "object",
  "embed",
  "[contenteditable]",
  "[tabindex]:not([tabindex^='-'])"
].join(",");
function wa(e) {
  const n = Array.from(e.querySelectorAll(ba)).filter(
    (a) => a.offsetParent !== null && sg(a)
  ), t = z0(n);
  return n.filter((a) => !ti(a) || t.has(a));
}
function ti(e) {
  return e instanceof HTMLInputElement && e.type === "radio" && e.name !== "";
}
function Ld(e) {
  return e.form ?? e.getRootNode();
}
function cf(e, n) {
  return e === n ? !0 : !e || !ti(e) || !ti(n) ? !1 : e.name === n.name && Ld(e) === Ld(n);
}
function z0(e) {
  const n = /* @__PURE__ */ new Map();
  for (const a of e) {
    if (!ti(a)) continue;
    const l = Ld(a), r = n.get(l) ?? /* @__PURE__ */ new Map();
    r.set(a.name, [...r.get(a.name) ?? [], a]), n.set(l, r);
  }
  const t = /* @__PURE__ */ new Set();
  for (const a of n.values())
    for (const l of a.values()) t.add(l.find((r) => r.checked) ?? l[0]);
  return t;
}
function sg(e) {
  if (e.hasAttribute("disabled")) return !1;
  const n = e.getAttribute("tabindex");
  return n === null || !n.startsWith("-");
}
function O0(e) {
  return Array.from(e.querySelectorAll(ba)).filter(
    (n) => {
      var t;
      return (((t = n.checkVisibility) == null ? void 0 : t.call(n)) ?? !0) && sg(n);
    }
  );
}
const Ad = "[data-focus-trap-allow-outside]", P0 = "data-focus-trap-return";
function ff(e) {
  return e instanceof Element && e.closest(Ad) !== null;
}
const ar = [];
function Ji(e) {
  const {
    active: n,
    container: t,
    autoFocus: a = !0,
    restoreFocus: l = !0,
    restoreFocusTo: r,
    containFocus: o = !1,
    allowOutsideElements: i
  } = e, s = Symbol("focus-trap");
  let d = null, u = null, f = null;
  const b = () => ar[ar.length - 1] === s;
  function h(E) {
    if (!b() || E.key !== "Tab" || !t.value) return;
    if (!t.value.contains(document.activeElement) && ff(document.activeElement)) {
      if (E.shiftKey) return;
      const X = document.activeElement.closest(
        Ad
      ), _ = X ? wa(X) : [];
      if (!(_.length === 0 || document.activeElement === _[_.length - 1])) return;
      const B = wa(t.value);
      if (B.length === 0) {
        E.preventDefault();
        return;
      }
      const W = f ? B.indexOf(f) : -1;
      E.preventDefault(), B[W === -1 ? 0 : (W + 1) % B.length].focus();
      return;
    }
    const A = wa(t.value);
    if (A.length === 0) {
      E.preventDefault();
      return;
    }
    const D = A[0], M = A[A.length - 1], F = document.activeElement;
    E.shiftKey ? (cf(F, D) || !t.value.contains(F)) && (E.preventDefault(), M.focus()) : cf(F, M) && (E.preventDefault(), D.focus());
  }
  function p() {
    var E;
    t.value && ((E = wa(t.value)[0]) == null || E.focus({ preventScroll: !0 }));
  }
  function x(E) {
    if (!b() || !t.value) return;
    const A = E.target;
    A && t.value.contains(A) && (f = A);
  }
  function y(E) {
    return ff(E) ? !0 : i ? i().some((A) => A && E && A.contains(E)) : !1;
  }
  function w(E) {
    if (!b() || !t.value) return;
    const A = E.target;
    A && t.value.contains(A) || y(A) || p();
  }
  function $(E) {
    !b() || E.relatedTarget !== null || requestAnimationFrame(() => {
      !n.value || !b() || !t.value || t.value.contains(document.activeElement) || y(document.activeElement) || p();
    });
  }
  function S() {
    o && (document.addEventListener("focusin", w), document.addEventListener("focusout", $));
  }
  function L() {
    document.removeEventListener("focusin", w), document.removeEventListener("focusout", $);
  }
  function T() {
    const E = ar.indexOf(s);
    E !== -1 && ar.splice(E, 1);
  }
  $e(n, (E) => {
    var A;
    if (E)
      ar.push(s), d = document.activeElement, u = ((A = d == null ? void 0 : d.closest(Ad)) == null ? void 0 : A.getAttribute(P0)) ?? null, document.addEventListener("keydown", h), document.addEventListener("focusin", x), S(), a && requestAnimationFrame(() => {
        var M;
        if (!t.value || t.value.contains(document.activeElement) || y(document.activeElement)) return;
        (M = wa(t.value)[0]) == null || M.focus();
      });
    else if (T(), document.removeEventListener("keydown", h), L(), document.removeEventListener("focusin", x), f = null, l) {
      const D = (d == null ? void 0 : d.isConnected) === !1 && u ? document.getElementById(u) : null, M = (r == null ? void 0 : r()) ?? D ?? d;
      M == null || M.focus(), d = null, u = null;
    }
  }, { immediate: !0 }), mt(() => {
    T(), document.removeEventListener("keydown", h), L(), document.removeEventListener("focusin", x);
  });
}
const F0 = ["id"], V0 = 100, N0 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    text: {},
    position: { default: "top" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    as: { default: "div" },
    labelsTrigger: { type: Boolean, default: !1 }
  },
  setup(e, { expose: n }) {
    const t = e, a = je(), l = R(null), r = R(null), o = R(null), i = R(!1), s = m(() => t.disabled ? !1 : t.open !== void 0 ? t.open : i.value);
    let d = null, u = null, f = null, b = null;
    const h = (Y) => {
      if (Y.nodeType === Node.TEXT_NODE) return Y.textContent ?? "";
      if (!(Y instanceof Element) || Y.getAttribute("aria-hidden") === "true") return "";
      const B = Y.getAttribute("aria-label");
      return B !== null ? B : [...Y.childNodes].map(h).join(" ");
    }, p = () => {
      const Y = l.value;
      if (!Y) return null;
      const W = Y.hasAttribute("tabindex") && Y.getAttribute("tabindex") !== "-1" ? Y : Y.querySelector(ba) ?? Y, U = (P) => P.trim().replace(/\s+/g, " ").toLowerCase(), z = W.getAttribute("aria-label") ?? [...W.childNodes].map(h).join(" ");
      return U(z) === U(t.text) ? null : W;
    }, x = (Y) => {
      const B = (Y.getAttribute("aria-describedby") ?? "").split(/\s+/).filter(Boolean);
      B.includes(a) || Y.setAttribute("aria-describedby", [...B, a].join(" ")), b = Y;
    }, y = () => {
      if (!b) return;
      const Y = (b.getAttribute("aria-describedby") ?? "").split(/\s+/).filter((B) => B && B !== a);
      Y.length ? b.setAttribute("aria-describedby", Y.join(" ")) : b.removeAttribute("aria-describedby"), b = null;
    }, w = m(
      () => !t.labelsTrigger && !t.disabled && (t.open === void 0 || t.open)
    ), $ = () => {
      const Y = w.value ? p() : null;
      Y !== b && y(), Y && x(Y);
    };
    dt($), Ki($), $e(w, $, { flush: "post" });
    const S = Symbol("tooltip"), L = (Y) => {
      Y.key !== "Escape" || Y.defaultPrevented || ha(S) && _(Y);
    }, T = () => {
      document.removeEventListener("keydown", L), Rn(S);
    }, E = m(() => s.value && t.open === void 0);
    $e(E, (Y) => {
      Y ? (Qn(S), document.addEventListener("keydown", L)) : T();
    });
    const A = () => {
      d == null || d.destroy(), d = null;
    };
    $e(s, async (Y) => {
      Y && (await Ue(), l.value && r.value && (A(), d = ja(l.value, r.value, {
        // Fixed keeps the tooltip in the viewport layer so it does not expand
        // document scroll width/height (avoids double scrollbars with nested overflow:auto regions).
        strategy: "fixed",
        placement: t.position,
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 8] }
          },
          {
            name: "arrow",
            // Own class and an element ref, not the conventional `[data-popper-arrow]` /
            // `.tooltip-arrow` hooks: no global stylesheet aimed at those names can hide or redraw it.
            // Padding keeps the arrow off the corners when the bubble is shifted. At most
            // (36px one-line height - 16px arrow) / 2, or Popper pushes a left/right arrow off-centre.
            options: { element: o.value, padding: 10 }
          },
          {
            // Reflow at 320px (RGAA 10.11): when neither side has room, a left/right bubble moves
            // above or below instead of leaving the viewport.
            name: "flip",
            options: { fallbackPlacements: og[t.position] }
          },
          {
            name: "preventOverflow",
            options: { padding: ig }
          }
        ]
      })));
    }, { immediate: !0 });
    const D = () => {
      f && (clearTimeout(f), f = null);
    }, M = () => {
      t.disabled || (D(), !(u || i.value) && (u = setTimeout(() => {
        i.value = !0, u = null;
      }, t.delay)));
    }, F = () => {
      u && (clearTimeout(u), u = null), D(), i.value = !1;
    };
    $e(
      () => t.disabled,
      (Y) => {
        var B;
        Y ? F() : (B = l.value) != null && B.contains(document.activeElement) && M();
      }
    );
    const X = () => {
      u && (clearTimeout(u), u = null), i.value && (D(), f = setTimeout(() => {
        i.value = !1, f = null;
      }, V0));
    }, _ = (Y) => {
      t.open !== void 0 || !s.value || (Y.stopPropagation(), Y.preventDefault(), F());
    };
    return n({ isVisible: s, hide: F }), mt(() => {
      u && clearTimeout(u), f && clearTimeout(f), T(), y(), A();
    }), (Y, B) => (c(), g(ce, null, [
      (c(), H(lt(e.as), Oe({
        ref_key: "triggerRef",
        ref: l,
        class: "inline-flex"
      }, Y.$attrs, {
        onMouseenter: M,
        onMouseleave: X,
        onFocusin: M,
        onFocusout: F,
        onKeydown: ut(_, ["escape"])
      }), {
        default: xe(() => [
          Ae(Y.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16)),
      (c(), H(Dn, { to: "body" }, [
        e.labelsTrigger ? k("", !0) : (c(), g("span", {
          key: 0,
          id: I(a),
          hidden: ""
        }, N(e.text), 9, F0)),
        re(wt, {
          name: "tooltip",
          onAfterLeave: A
        }, {
          default: xe(() => [
            s.value ? (c(), g("div", {
              key: 0,
              ref_key: "bubbleRef",
              ref: r,
              role: "tooltip",
              class: "tooltip-bubble fixed z-9999 rounded-(--border-border-radius-rounded-l) shadow-(--shadow-m) min-w-33.5 max-w-50 py-2 px-3 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) wrap-break-word",
              onMouseenter: D,
              onMouseleave: X
            }, [
              et(N(e.text) + " ", 1),
              v("div", {
                ref_key: "arrowRef",
                ref: o,
                class: "tooltip-pointer",
                "aria-hidden": "true"
              }, [...B[0] || (B[0] = [
                v("svg", {
                  width: "16",
                  height: "8",
                  viewBox: "0 0 16 8"
                }, [
                  v("path", { d: "M0 0L6.59 6.59A2 2 0 0 0 9.41 6.59L16 0Z" })
                ], -1)
              ])], 512)
            ], 544)) : k("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), ot = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, l] of n)
    t[a] = l;
  return t;
}, ft = /* @__PURE__ */ ot(N0, [["__scopeId", "data-v-82534dc2"]]);
function H0(e, n, t = "horizontal") {
  const a = R(!1);
  let l = null;
  function r() {
    const o = e.value;
    a.value = !!o && (t === "vertical" ? o.scrollHeight > o.clientHeight : o.scrollWidth > o.offsetWidth);
  }
  return $e(
    e,
    (o) => {
      if (l == null || l.disconnect(), l = null, !o) {
        a.value = !1;
        return;
      }
      typeof ResizeObserver < "u" && (l = new ResizeObserver(r), l.observe(o)), r();
    },
    { flush: "post" }
  ), $e(n, r, { flush: "post" }), mt(() => {
    l == null || l.disconnect(), l = null;
  }), { isTruncated: a };
}
const j0 = ["id", "aria-hidden"], W0 = ["id", "aria-hidden"], ht = /* @__PURE__ */ ke({
  __name: "TruncatedText",
  props: {
    text: {},
    lines: { default: 1 },
    textClass: { default: "" },
    position: { default: "top" },
    focusable: { type: Boolean, default: !0 },
    open: { type: Boolean, default: void 0 }
  },
  setup(e, { expose: n }) {
    const t = e, a = R(null), { isTruncated: l } = H0(
      a,
      () => t.text,
      t.lines > 1 ? "vertical" : "horizontal"
    ), r = t.lines > 1 ? "line-clamp-2 break-words" : "truncate", o = R(!1), i = m(() => t.focusable && (l.value || o.value)), s = je(), d = je(), u = Mn();
    return n({ isTruncated: l, isTabStop: i }), (f, b) => (c(), H(ft, {
      as: "span",
      class: "w-full min-w-0 rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)",
      text: e.text,
      position: e.position,
      disabled: !I(l),
      open: e.open,
      "labels-trigger": "",
      tabindex: i.value ? 0 : void 0,
      role: i.value ? "group" : void 0,
      "aria-labelledby": i.value ? I(u).default ? `${I(s)} ${I(d)}` : I(s) : void 0,
      onFocusin: b[0] || (b[0] = (h) => o.value = !0),
      onFocusout: b[1] || (b[1] = (h) => o.value = !1)
    }, {
      default: xe(() => [
        v("span", {
          id: I(s),
          ref_key: "textEl",
          ref: a,
          "data-testid": "truncated-text",
          "aria-hidden": i.value ? "true" : void 0,
          class: C(["w-full min-w-0", I(r), e.textClass])
        }, N(e.text), 11, j0),
        I(u).default ? (c(), g("span", {
          key: 0,
          id: I(d),
          "aria-hidden": i.value ? "true" : void 0
        }, [
          Ae(f.$slots, "default")
        ], 8, W0)) : k("", !0)
      ]),
      _: 3
    }, 8, ["text", "position", "disabled", "open", "tabindex", "role", "aria-labelledby"]));
  }
}), q0 = ["src"], hf = /* @__PURE__ */ ke({
  __name: "AvatarCircle",
  props: {
    img: {},
    name: {},
    label: {},
    size: {},
    entity: {},
    avatarStyle: {},
    logo: { type: Boolean },
    presentational: { type: Boolean },
    as: {},
    imageError: { type: Boolean }
  },
  emits: ["image-error"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      // 3xs / 2xs: Badge only. Figma shows them with a picture; initials and square radius keep the xs values.
      "3xs": { container: "h-3 w-3", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      "2xs": { container: "h-3.5 w-3.5", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      xs: { container: "h-[18px] w-[18px]", text: "text-(length:--size-2xs) leading-(--line-height-s)" },
      sm: { container: "h-6 w-6", text: "text-(length:--size-sm) leading-(--line-height-l)" },
      md: { container: "h-9 w-9", text: "text-(length:--size-m) leading-(--line-height-l)" },
      lg: { container: "h-11 w-11", text: "text-(length:--size-xl) leading-(--line-height-xxl)" },
      xl: { container: "h-14 w-14", text: "text-(length:--size-xxl) leading-(--line-height-xxl)" },
      "2xl": { container: "h-16 w-16", text: "text-(length:--size-4xl) leading-(--line-height-xxl)" }
    }, r = m(() => l[t.size]), o = {
      "3xs": "rounded-(--border-border-radius-rounded-xs)",
      "2xs": "rounded-(--border-border-radius-rounded-xs)",
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, i = m(() => t.logo && !!t.img && !t.imageError), s = m(
      () => i.value ? "avatar-container--logo bg-(--background-background-white)" : (
        // Figma "Avatar gradient" (4230:55188) as CSS: its gradientTransform is skewed, so the
        // colour runs at 85deg with stops at 10.83 % / 86.95 % (the 138deg handle line is not it).
        "bg-[linear-gradient(85deg,var(--colors-avatar-gradient-start)_10.83%,var(--colors-avatar-gradient-end)_86.95%)]"
      )
    ), d = m(
      () => t.avatarStyle === "square" ? o[t.size] : "rounded-full"
    ), u = (b) => b.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toUpperCase(), f = m(() => {
      var x;
      const b = (x = t.name) == null ? void 0 : x.trim();
      if (!b)
        return "?";
      const h = b.split(/\s+/), p = t.entity === "organisation" ? 1 : 2;
      return h.slice(0, p).map(u).join("");
    });
    return (b, h) => (c(), H(lt(t.as), {
      class: C(["avatar-container flex shrink-0 items-center justify-center overflow-hidden", [r.value.container, d.value, s.value]]),
      role: e.presentational ? void 0 : "img",
      "aria-hidden": e.presentational ? "true" : void 0,
      "aria-label": e.presentational ? void 0 : t.label
    }, {
      default: xe(() => [
        t.img && !t.imageError ? (c(), g("img", {
          key: 0,
          src: t.img,
          alt: "",
          class: C(["h-full w-full", t.logo ? "object-contain" : "object-cover"]),
          loading: "lazy",
          onError: h[0] || (h[0] = (p) => a("image-error"))
        }, null, 42, q0)) : (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C(["font-(--weight-medium) text-(--text-text-body-subtle)", r.value.text])
        }, N(f.value), 3))
      ]),
      _: 1
    }, 8, ["class", "role", "aria-hidden", "aria-label"]));
  }
}), U0 = ["aria-label"], G0 = ["aria-label", "aria-disabled"], bf = "text-(length:--icon-size-xs)", ws = "text-(length:--size-sm)", gf = "text-(length:--icon-size-2xs)", K0 = "text-(length:--size-2xs)", mf = "absolute flex cursor-pointer items-center justify-center rounded-full focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']", Mt = /* @__PURE__ */ ke({
  __name: "Avatar",
  props: {
    img: { default: void 0 },
    name: {},
    email: { default: void 0 },
    size: { default: "md" },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    logo: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 },
    as: { default: "div" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    removable: { type: Boolean, default: !1 },
    removeLabel: { default: void 0 },
    editable: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    editDisabled: { type: Boolean, default: !1 }
  },
  emits: ["remove", "edit"],
  setup(e, { emit: n }) {
    var w;
    const t = ($) => $ !== "3xs" && $ !== "2xs", a = e, l = n, r = R(!1);
    $e(
      () => a.img,
      () => {
        r.value = !1;
      }
    );
    const o = m(() => !t(a.size)), i = m(
      () => !o.value && (!!a.status || a.removable || a.editable)
    ), s = m(() => t(a.size) ? a.size : "xs"), d = m(
      () => {
        var $;
        return a.status && !o.value ? ($ = a.statusLabel) == null ? void 0 : $.trim() : void 0;
      }
    ), u = m(
      () => {
        var $;
        return [($ = a.name) == null ? void 0 : $.trim(), d.value].filter(Boolean).join(", ") || a.name;
      }
    ), f = m(() => ({
      img: a.img,
      name: a.name,
      label: u.value,
      size: a.size,
      entity: a.entity,
      avatarStyle: a.avatarStyle,
      logo: a.logo,
      presentational: a.presentational,
      imageError: r.value
    })), b = {
      online: "bg-(--icons-icon-success-subtle)",
      offline: "bg-(--icons-icon-error)",
      alternative: "bg-(--icons-icon-disabled-strong)"
    }, h = {
      xs: "size-1.5 top-[1px] -right-[2px]",
      sm: "size-2 top-[1px] -right-[2px]",
      md: "size-3 top-[1px] right-[1px]",
      lg: "size-3 top-[4px] -right-[3px]",
      xl: "size-4 top-[2px] -right-[2px]",
      "2xl": "size-4 top-[4px] -right-[1px]"
    }, p = {
      xs: { button: "size-3.5 -top-[2px] -right-[8px]", icon: gf },
      sm: { button: "size-3.5 -top-[2px] -right-[6px]", icon: gf },
      md: { button: "size-4 top-0 -right-[4px]", icon: ws },
      lg: { button: "size-4 top-[3px] -right-[6px]", icon: ws },
      xl: { button: "size-5 top-[1px] -right-[6px]", icon: bf },
      "2xl": { button: "size-5 top-[3px] -right-[5px]", icon: bf }
    }, x = {
      ...p,
      xs: { button: "size-3 -top-[2px] -right-[6px]", icon: K0 },
      md: { button: "size-4 top-0 -right-[2px]", icon: ws }
    };
    return typeof process < "u" && ((w = process.env) == null ? void 0 : w.NODE_ENV) !== "production" && $e(
      () => [
        a.status,
        a.statusLabel,
        a.removable,
        a.removeLabel,
        a.editable,
        a.editLabel,
        a.presentational,
        a.as,
        a.size
      ],
      () => {
        var S, L, T;
        const $ = (E) => console.warn(`[OPAL Avatar] ${E}`);
        a.status && !((S = a.statusLabel) != null && S.trim()) && $("`status` is set without `statusLabel`: assistive tech gets no presence text (WCAG 1.1.1 / 4.1.2)."), a.removable && !((L = a.removeLabel) != null && L.trim()) && $("`removable` is set without `removeLabel`: the remove button has no accessible name."), a.editable && !((T = a.editLabel) != null && T.trim()) && $("`editable` is set without `editLabel`: the edit button has no accessible name."), o.value && (a.status || a.removable || a.editable) && $(`size "${a.size}" shows no status dot, remove or edit button.`), a.removable && a.editable && $("`removable` and `editable` are both set; they share the same corner. Use one."), (a.removable || a.editable) && (a.presentational || a.as === "span") && $(
          '`removable`/`editable` with `presentational` or `as="span"` means the avatar sits inside another control: its buttons would be nested inside that control.'
        );
      },
      { immediate: !0 }
    ), ($, S) => i.value ? (c(), H(lt(e.as), {
      key: 1,
      class: "relative flex w-fit shrink-0"
    }, {
      default: xe(() => [
        re(hf, Oe(f.value, {
          as: e.as === "span" ? "span" : "div",
          onImageError: S[1] || (S[1] = (L) => r.value = !0)
        }), null, 16, ["as"]),
        e.status ? (c(), g("span", {
          key: 0,
          class: C(["absolute rounded-full", [b[e.status], h[s.value]]]),
          "aria-hidden": "true",
          "data-testid": "avatar-status"
        }, null, 2)) : k("", !0),
        e.removable ? (c(), g("button", {
          key: 1,
          type: "button",
          class: C([
            mf,
            p[s.value].button,
            "bg-(--background-background-gray) text-(--icons-icon-dark-default)"
          ]),
          "aria-label": e.removeLabel,
          "data-testid": "avatar-remove",
          onClick: S[2] || (S[2] = Ye((L) => l("remove"), ["stop"]))
        }, [
          v("i", {
            class: C(["ri-close-fill", p[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, U0)) : k("", !0),
        e.editable ? (c(), g("button", {
          key: 2,
          type: "button",
          class: C([
            mf,
            x[s.value].button,
            "border border-(--border-border-white-full) bg-(--background-background-white)",
            e.editDisabled ? "cursor-not-allowed text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-dark-default) hover:border-transparent hover:text-(--icons-icon-hover)"
          ]),
          "aria-label": e.editLabel,
          "aria-disabled": e.editDisabled || void 0,
          "data-testid": "avatar-edit",
          onClick: S[3] || (S[3] = Ye((L) => !e.editDisabled && l("edit"), ["stop"]))
        }, [
          v("i", {
            class: C(["ri-pencil-line", x[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, G0)) : k("", !0)
      ]),
      _: 1
    })) : (c(), H(hf, Oe({ key: 0 }, f.value, {
      as: e.as,
      onImageError: S[0] || (S[0] = (L) => r.value = !0)
    }), null, 16, ["as"]));
  }
}), Y0 = ["role", "aria-hidden"], J0 = {
  class: "opal-spinner-rotate size-full",
  viewBox: "0 0 100 100",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}, X0 = { key: 0 }, Z0 = ["x1", "y1", "x2", "y2"], Q0 = ["r", "stroke-width"], _0 = ["d", "stroke", "stroke-width"], ey = {
  key: 0,
  class: "sr-only"
}, ty = { value: 0 }, ny = /* @__PURE__ */ ke({
  __name: "Spinner",
  props: {
    size: { default: "sm" },
    color: { default: "sky" },
    track: { type: Boolean, default: !0 },
    label: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      xs: "size-(--spacing-3)",
      sm: "size-(--spacing-6)",
      md: "size-[50px]",
      base: "size-[75px]",
      lg: "size-[100px]",
      inherit: "size-[1em]"
    }, a = { r: 42.5, width: 15, arc: "M 49.834 7.5 A 42.5 42.5 0 0 1 92.458 48.107" }, l = { r: 45.459, width: 9.081, arc: "M 42.9 5.099 A 45.459 45.459 0 0 1 92.594 34.116" }, r = m(
      () => n.size === "md" || n.size === "base" || n.size === "lg" ? l : a
    ), o = {
      sky: {
        x1: 3.01,
        y1: 0,
        x2: 85.17,
        y2: -7.21,
        start: "--colors-spinner-sky-start",
        end: "--colors-spinner-sky-end"
      },
      primary: {
        x1: 0,
        y1: 50,
        x2: 100,
        y2: 50,
        start: "--colors-spinner-primary-start",
        end: "--colors-spinner-primary-end"
      }
    }, i = {
      sky: { x1: 42.76, y1: 0, x2: 91.22, y2: -4.43 },
      primary: { x1: 40.98, y1: 28.31, x2: 100, y2: 28.31 }
    }, s = `opal-spinner-${++ty.value}`, d = m(() => {
      if (n.color === "current") return;
      const y = o[n.color];
      return n.size === "xs" ? { ...y, ...i[n.color] } : y;
    }), u = m(() => d.value ? `url(#${s})` : "currentColor"), f = m(
      () => n.color === "current" ? "var(--spinner-track, transparent)" : "var(--colors-spinner-track)"
    ), b = 100, h = R("");
    let p;
    const x = m(() => {
      var y;
      return ((y = n.label) == null ? void 0 : y.trim()) || void 0;
    });
    return $e(
      x,
      (y) => {
        clearTimeout(p), h.value = "", y && (p = setTimeout(() => h.value = y, b));
      },
      { immediate: !0 }
    ), mt(() => clearTimeout(p)), (y, w) => (c(), g("span", {
      class: C(["inline-flex shrink-0 align-middle", t[e.size]]),
      role: x.value ? "status" : void 0,
      "aria-hidden": x.value ? void 0 : "true",
      "data-testid": "spinner"
    }, [
      (c(), g("svg", J0, [
        d.value ? (c(), g("defs", X0, [
          v("linearGradient", {
            id: s,
            gradientUnits: "userSpaceOnUse",
            x1: d.value.x1,
            y1: d.value.y1,
            x2: d.value.x2,
            y2: d.value.y2
          }, [
            v("stop", {
              offset: "0",
              style: Ne({ stopColor: `var(${d.value.start})` })
            }, null, 4),
            v("stop", {
              offset: "1",
              style: Ne({ stopColor: `var(${d.value.end})` })
            }, null, 4)
          ], 8, Z0)
        ])) : k("", !0),
        e.track ? (c(), g("circle", {
          key: 1,
          cx: "50",
          cy: "50",
          r: r.value.r,
          "stroke-width": r.value.width,
          style: Ne({ stroke: f.value }),
          "data-testid": "spinner-track"
        }, null, 12, Q0)) : k("", !0),
        v("path", {
          d: r.value.arc,
          stroke: u.value,
          "stroke-width": r.value.width,
          "stroke-linecap": "round",
          "data-testid": "spinner-arc"
        }, null, 8, _0)
      ])),
      x.value ? (c(), g("span", ey, N(h.value), 1)) : k("", !0)
    ], 10, Y0));
  }
}), zu = /* @__PURE__ */ ot(ny, [["__scopeId", "data-v-1ef84c80"]]);
function Nl(e) {
  return e.startsWith("ri-");
}
const ay = /^ri-[a-z0-9-]+$/, ly = new RegExp("^(?:\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*(?:‍\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*)*|\\p{Regional_Indicator}{2})$", "u");
function mo(e) {
  return ay.test(e) || ly.test(e);
}
const dg = {
  label: "",
  theme: "neutral",
  size: "sm",
  type: "default",
  badgeStyle: "rounded",
  leftIcon: void 0,
  rightIcon: void 0,
  showLeftIcon: !0,
  showCloseIcon: !1,
  removeLabel: void 0,
  closeIconInactive: !1,
  showText: !0,
  dropdownIcon: !1,
  secondaryText: "",
  avatarSrc: void 0,
  avatarAlt: void 0,
  iconOnly: !1,
  textOnly: !1,
  value: void 0,
  truncate: !1,
  truncationFocusable: !0,
  tooltipText: void 0
}, ry = {
  // Figma component `eudonet` 4728:62829.
  eudonet: [
    "M24.0709 0C23.1879 0 22.3161 0.0495821 21.4578 0.141985C33.4426 1.44915 42.7738 11.6315 42.7738 24C42.7738 36.3685 33.4448 46.5531 21.4578 47.858C22.3161 47.9527 23.1879 48 24.0709 48C37.287 48 48 37.2542 48 23.9977C48 10.7413 37.2847 0 24.0709 0Z",
    "M23.0574 8.97662C22.5046 8.97662 21.9586 9.00818 21.4216 9.06677C28.9239 9.88488 34.7636 16.2584 34.7636 24.0023C34.7636 31.7461 28.9239 38.1196 21.4216 38.9377C21.9586 38.9963 22.5046 39.0279 23.0574 39.0279C31.3303 39.0279 38.035 32.3005 38.035 24.0045C38.035 15.7085 31.3281 8.98113 23.0574 8.98113V8.97662Z",
    "M22.525 16.4297C22.2464 16.4297 21.9723 16.4455 21.7004 16.4748C25.4819 16.8872 28.4253 20.0988 28.4253 24.0022C28.4253 27.9057 25.4819 31.1173 21.7004 31.5297C21.9723 31.559 22.2464 31.5748 22.525 31.5748C26.6952 31.5748 30.0745 28.1852 30.0745 24.0022C30.0745 19.8193 26.6952 16.4297 22.525 16.4297Z",
    "M17.2874 41.3424C17.9255 41.3424 18.5547 41.3064 19.1748 41.2388C10.5154 40.2944 3.77474 32.9383 3.77474 24.0022C3.77474 15.0662 10.5154 7.70772 19.1748 6.76566C18.5547 6.69805 17.9255 6.66199 17.2874 6.66199C7.74047 6.66199 0 14.4261 0 24.0022C0 33.5783 7.74047 41.3424 17.2874 41.3424Z",
    "M19.4895 35.0478C19.8962 35.0478 20.2961 35.0252 20.6916 34.9824C15.1755 34.3806 10.8817 29.6951 10.8817 24.0022C10.8817 18.3093 15.1755 13.6215 20.6916 13.022C20.2961 12.9792 19.8962 12.9567 19.4895 12.9567C13.4072 12.9567 8.47534 17.9036 8.47534 24.0045C8.47534 30.1053 13.4072 35.0523 19.4895 35.0523V35.0478Z"
  ]
}, oy = {
  class: "size-full",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false",
  "data-testid": "badge-brand-icon"
}, iy = ["d"], sy = {
  key: 5,
  class: "sr-only"
}, dy = ["aria-hidden"], uy = { "aria-hidden": "true" }, cy = ["id", "aria-hidden"], fy = ["id", "aria-hidden"], hy = ["aria-label"], by = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "BadgeBase",
  props: /* @__PURE__ */ Wb({
    brandIcon: {},
    fitWidth: { type: Boolean },
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, { ...dg, brandIcon: void 0, fitWidth: !1 }),
  emits: ["close"],
  setup(e, { emit: n }) {
    var j;
    const t = Nn(), a = m(() => {
      const { class: G, ...q } = t;
      return q;
    }), l = e, r = n, o = {
      disabled: {
        bg: "bg-(--components-badge-background-badge-disabled-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-disabled-strong-text)",
        icon: "text-(--components-badge-icon-badge-disabled-icon)",
        separator: "bg-(--components-badge-border-badge-white-default-border)",
        secondaryText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dot: "bg-(--components-badge-background-badge-gray-bg)",
        dotText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dotIcon: "text-(--components-badge-icon-badge-disabled-icon)",
        spinner: "text-(--components-badge-spinner-disabled-arc) [--spinner-track:var(--components-badge-spinner-disabled-track)]"
      },
      red: {
        bg: "bg-(--components-badge-background-badge-error-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-black-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-error-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-red-arc) [--spinner-track:var(--components-badge-spinner-red-track)]"
      },
      orange: {
        bg: "bg-(--components-badge-background-badge-orange-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--border-border-black-default)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-orange-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-icon)",
        spinner: "text-(--components-badge-spinner-orange-arc) [--spinner-track:var(--components-badge-spinner-orange-track)]"
      },
      yellow: {
        bg: "bg-(--components-badge-background-badge-yellow-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-yellow-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-yellow-arc) [--spinner-track:var(--components-badge-spinner-yellow-track)]"
      },
      green: {
        bg: "bg-(--components-badge-background-badge-green-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-green-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-green-arc) [--spinner-track:var(--components-badge-spinner-green-track)]"
      },
      indigo: {
        bg: "bg-(--components-badge-background-badge-indigo-soft-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      // OPAL-only (no Figma variant): accent fill with indigo text, Indigo's dot and spinner.
      active: {
        bg: "bg-(--components-badge-background-badge-accent-bg)",
        border: "",
        text: "text-(--components-badge-background-badge-indigo-strong-bg)",
        icon: "text-(--components-badge-background-badge-indigo-strong-bg)",
        separator: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        secondaryText: "text-(--components-badge-background-badge-indigo-strong-bg)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      violet: {
        bg: "bg-(--components-badge-background-badge-violet-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-violet-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-violet-arc) [--spinner-track:var(--components-badge-spinner-violet-track)]"
      },
      purple: {
        bg: "bg-(--components-badge-background-badge-purple-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-purple-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-purple-arc) [--spinner-track:var(--components-badge-spinner-purple-track)]"
      },
      neutral: {
        bg: "bg-(--components-badge-background-badge-neutral-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-neutral-arc) [--spinner-track:var(--components-badge-spinner-neutral-track)]"
      },
      // Only theme with a dark fill: light text and icon on the fill, dark text once `with-dot` drops it.
      dark: {
        bg: "bg-(--components-badge-background-badge-dark-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-white-default-text)",
        icon: "text-(--components-badge-icon-badge-white-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-white-default-text)",
        dot: "bg-(--components-badge-background-badge-dark-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-dark-icon)",
        spinner: "text-(--components-badge-spinner-dark-arc) [--spinner-track:var(--components-badge-spinner-dark-track)]"
      },
      cyan: {
        bg: "bg-(--components-badge-background-badge-cyan-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-cyan-strong-bg)",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-cyan-arc) [--spinner-track:var(--components-badge-spinner-cyan-track)]"
      },
      white: {
        bg: "bg-(--components-badge-background-badge-white-bg)",
        border: "border-(--components-badge-border-badge-base-soft-border)",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-white-arc) [--spinner-track:var(--components-badge-spinner-white-track)]"
      },
      "gradient-light": {
        bg: "badge-gradient-light",
        border: "border-transparent",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "badge-dot-gradient",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-gradient-light-arc) [--spinner-track:var(--components-badge-spinner-gradient-light-track)]"
      }
    }, i = m(() => o[l.theme]), s = {
      xs: {
        padding: "gap-1 px-1 h-[18px]",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-5 h-[18px]",
        compactCircle: "px-1 min-w-[18px] h-[18px]",
        text: "text-(length:--size-xs) leading-(--line-height-s)",
        countText: "text-(length:--size-xs) leading-(--line-height-s)",
        icon: "size-2.5",
        glyph: "text-(length:--icon-size-2xs)",
        secondaryGap: "gap-1",
        separator: "h-2.5",
        avatar: "3xs"
      },
      sm: {
        padding: "gap-1 px-1 min-h-6",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-[22px] h-5",
        compactCircle: "px-1 min-w-[22px] h-[22px]",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3",
        glyph: "text-(length:--size-sm)",
        secondaryGap: "gap-1.5",
        separator: "h-3",
        avatar: "2xs"
      },
      lg: {
        padding: "gap-1.5 px-1.5 min-h-7",
        withDot: "gap-1.5 px-1.5 min-h-[22px]",
        compact: "px-1 min-w-[22px] h-6",
        compactCircle: "px-1 min-w-6 h-6",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3.5",
        glyph: "text-(length:--icon-size-xs)",
        secondaryGap: "gap-2",
        separator: "h-3",
        avatar: "2xs"
      }
    }, d = m(() => l.iconOnly || l.textOnly), u = m(() => l.type === "with-dot" && !d.value), f = m(() => s[u.value && l.size === "xs" ? "sm" : l.size]), b = m(
      () => l.badgeStyle === "circle" ? "rounded-(--border-border-radius-rounded-full)" : "rounded-(--border-border-radius-rounded-xs)"
    ), h = m(() => {
      const G = i.value, q = f.value;
      let J = u.value ? q.withDot : q.padding;
      return d.value && (J = l.badgeStyle === "circle" ? q.compactCircle : q.compact), [
        "opal-badge inline-flex items-center justify-center font-inter whitespace-nowrap",
        b.value,
        u.value ? "bg-transparent" : [G.bg, G.border && ["border-solid border-[1px]", G.border]],
        u.value ? G.dotText : G.text,
        J
      ];
    }), p = m(() => [f.value.text, "font-(--weight-medium)", l.fitWidth && "min-w-0"]), x = m(() => [f.value.countText, "font-(--weight-medium)"]), y = m(() => [
      ...p.value,
      l.size === "xs" ? i.value.text : i.value.secondaryText
    ]), w = m(() => u.value ? i.value.dotIcon : i.value.icon), $ = m(() => !!l.leftIcon && Nl(l.leftIcon)), S = m(() => l.brandIcon ? ry[l.brandIcon] : void 0), L = m(
      () => (
        // Not a glyph (typo, extra classes): render nothing rather than the raw string as text.
        (!!S.value || !!l.leftIcon && mo(l.leftIcon)) && !l.textOnly && (l.iconOnly || l.showLeftIcon && ["default", "with-secondary-text", "with-dot"].includes(l.type))
      )
    ), T = m(() => !!l.rightIcon && Nl(l.rightIcon)), E = m(
      () => !!l.rightIcon && mo(l.rightIcon) && !d.value && ["default", "with-secondary-text", "with-dot"].includes(l.type)
    ), A = m(
      () => !d.value && l.showText && (!!l.label || l.type === "with-secondary-text" && !!l.secondaryText)
    ), D = m(() => l.showCloseIcon && !d.value && l.type !== "with-dot"), M = m(() => Array.from(l.label ?? "")), F = m(() => l.truncate && !l.textOnly && M.value.length > 14), X = m(
      () => F.value ? `${M.value.slice(0, 14).join("")}…` : l.label ?? ""
    ), _ = m(() => !!l.tooltipText || F.value), Y = (G, { slots: q }) => {
      var J;
      return (J = q.default) == null ? void 0 : J.call(q);
    }, B = m(() => l.truncationFocusable && F.value), W = m(() => B.value && A.value), U = je(), z = je(), P = m(
      () => _.value ? {
        text: l.tooltipText || l.label,
        labelsTrigger: W.value && !l.tooltipText,
        tabindex: B.value ? 0 : void 0,
        role: W.value ? "group" : void 0,
        "aria-labelledby": W.value ? l.type === "with-secondary-text" && l.secondaryText ? `${U} ${z}` : U : void 0,
        position: "top",
        as: "span"
      } : {}
    );
    return typeof process < "u" && ((j = process.env) == null ? void 0 : j.NODE_ENV) !== "production" && $e(
      () => [l.iconOnly, l.leftIcon, l.rightIcon, l.brandIcon, l.label, D.value, l.closeIconInactive, l.removeLabel],
      () => {
        var q, J;
        const G = (me) => console.warn(`[OPAL Badge] ${me}`);
        l.iconOnly && !l.leftIcon && !l.brandIcon && G("`iconOnly` is set without `leftIcon`: the badge renders empty."), l.leftIcon && !mo(l.leftIcon) && G(`\`leftIcon\` "${l.leftIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.rightIcon && !mo(l.rightIcon) && G(`\`rightIcon\` "${l.rightIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.iconOnly && !((q = l.label) != null && q.trim()) && G("`iconOnly` is set without `label`: the badge has no accessible name (WCAG 4.1.2)."), D.value && !l.closeIconInactive && !((J = l.removeLabel) != null && J.trim()) && G("`showCloseIcon` is set without `removeLabel`: the remove button has no accessible name.");
      },
      { immediate: !0 }
    ), (G, q) => (c(), H(lt(_.value ? ft : Y), Zt(tn(P.value)), {
      default: xe(() => [
        v("span", Oe(a.value, {
          class: [h.value, I(t).class]
        }), [
          u.value ? (c(), g("span", {
            key: 0,
            class: C(["size-1.5 shrink-0 rounded-(--border-border-radius-rounded-full)", i.value.dot]),
            "aria-hidden": "true",
            "data-testid": "badge-dot"
          }, null, 2)) : k("", !0),
          e.type === "with-avatar" && !d.value ? (c(), H(Mt, {
            key: 1,
            img: e.avatarSrc,
            name: e.avatarAlt || e.label,
            size: f.value.avatar,
            presentational: !e.avatarAlt,
            as: "span",
            class: C({ "opacity-60": e.theme === "disabled" })
          }, null, 8, ["img", "name", "size", "presentational", "class"])) : k("", !0),
          e.type === "with-loader" && !d.value ? (c(), H(zu, {
            key: 2,
            size: "xs",
            color: "current",
            class: C(i.value.spinner)
          }, null, 8, ["class"])) : k("", !0),
          L.value && S.value ? (c(), g("span", {
            key: 3,
            class: C([f.value.icon, "text-(--icons-icon-dark-default) shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            (c(), g("svg", oy, [
              (c(!0), g(ce, null, Re(S.value, (J, me) => (c(), g("path", {
                key: me,
                d: J
              }, null, 8, iy))), 128))
            ]))
          ], 2)) : L.value ? (c(), g("span", {
            key: 4,
            class: C([f.value.icon, f.value.glyph, w.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            $.value ? (c(), g("i", {
              key: 0,
              class: C(e.leftIcon)
            }, null, 2)) : (c(), g(ce, { key: 1 }, [
              et(N(e.leftIcon), 1)
            ], 64))
          ], 2)) : k("", !0),
          e.iconOnly && e.label ? (c(), g("span", sy, N(e.label), 1)) : k("", !0),
          e.textOnly ? (c(), g("span", {
            key: 6,
            class: C(x.value)
          }, N(e.value ?? e.label), 3)) : k("", !0),
          A.value ? (c(), g("span", {
            key: 7,
            class: C(e.type === "with-secondary-text" ? ["inline-flex items-center", f.value.secondaryGap] : "contents")
          }, [
            v("span", {
              class: C(p.value),
              "aria-hidden": W.value ? "true" : void 0
            }, [
              F.value ? (c(), g(ce, { key: 0 }, [
                v("span", uy, N(X.value), 1),
                v("span", {
                  id: I(U),
                  class: "sr-only",
                  "aria-hidden": W.value ? "true" : void 0
                }, N(e.label), 9, cy)
              ], 64)) : e.fitWidth ? (c(), H(ht, {
                key: 1,
                text: e.label ?? "",
                focusable: !1
              }, null, 8, ["text"])) : (c(), g(ce, { key: 2 }, [
                et(N(e.label), 1)
              ], 64))
            ], 10, dy),
            e.type === "with-secondary-text" ? (c(), g(ce, { key: 0 }, [
              v("span", {
                class: C(["w-px shrink-0", f.value.separator, i.value.separator]),
                "aria-hidden": "true",
                "data-testid": "badge-separator"
              }, null, 2),
              v("span", {
                id: I(z),
                class: C(y.value),
                "aria-hidden": W.value ? "true" : void 0
              }, N(e.secondaryText), 11, fy)
            ], 64)) : k("", !0)
          ], 2)) : k("", !0),
          E.value ? (c(), g("span", {
            key: 8,
            class: C([f.value.icon, f.value.glyph, w.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-right-icon"
          }, [
            T.value ? (c(), g("i", {
              key: 0,
              class: C(e.rightIcon)
            }, null, 2)) : (c(), g(ce, { key: 1 }, [
              et(N(e.rightIcon), 1)
            ], 64))
          ], 2)) : k("", !0),
          D.value && e.closeIconInactive ? (c(), g("span", {
            key: 9,
            class: C([f.value.icon, f.value.glyph, w.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-close-icon"
          }, [...q[3] || (q[3] = [
            v("i", { class: "ri-close-fill" }, null, -1)
          ])], 2)) : D.value ? (c(), g("button", {
            key: 10,
            type: "button",
            class: C([
              f.value.icon,
              f.value.glyph,
              w.value,
              "relative shrink-0 inline-flex items-center justify-center cursor-pointer bg-transparent border-none p-0",
              "rounded-(--border-border-radius-rounded-xs) hover:opacity-70 transition-opacity",
              "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
              "before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
            ]),
            "aria-label": e.removeLabel,
            onClick: q[0] || (q[0] = Ye((J) => r("close"), ["stop"])),
            onKeydown: [
              q[1] || (q[1] = ut(Ye(() => {
              }, ["stop"]), ["enter"])),
              q[2] || (q[2] = ut(Ye(() => {
              }, ["stop"]), ["space"]))
            ]
          }, [...q[4] || (q[4] = [
            v("i", {
              class: "ri-close-fill",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, hy)) : k("", !0),
          e.dropdownIcon && !d.value ? (c(), g("span", {
            key: 11,
            class: C([w.value, "size-3 shrink-0 inline-flex items-center justify-center text-(length:--size-sm)"]),
            "aria-hidden": "true",
            "data-testid": "badge-chevron"
          }, [...q[5] || (q[5] = [
            v("i", { class: "ri-arrow-down-s-line" }, null, -1)
          ])], 2)) : k("", !0),
          q[6] || (q[6] = v("span", { class: "sr-only" }, " ", -1))
        ], 16)
      ]),
      _: 1
    }, 16));
  }
}), Ou = /* @__PURE__ */ ot(by, [["__scopeId", "data-v-05eecf91"]]), ct = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Badge",
  props: /* @__PURE__ */ Wb({
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, dg),
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = Nn(), a = m(() => {
      const { brandIcon: o, "brand-icon": i, ...s } = t;
      return s;
    }), l = e, r = n;
    return (o, i) => (c(), H(Ou, Oe({ ...a.value, ...l }, {
      onClose: i[0] || (i[0] = (s) => r("close"))
    }), null, 16));
  }
}), gy = ["id"], my = {
  key: 1,
  class: "sr-only",
  "data-testid": "badge-overflow-names"
}, Pu = /* @__PURE__ */ ke({
  __name: "BadgeOverflow",
  props: {
    label: {},
    hiddenLabels: {},
    theme: { default: "neutral" },
    size: { default: "sm" },
    focusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = je();
    return (a, l) => (c(), H(ft, {
      text: n.hiddenLabels.join(", "),
      as: "span",
      position: "top",
      tabindex: e.focusable ? 0 : void 0,
      role: e.focusable ? "group" : void 0,
      "aria-labelledby": e.focusable ? I(t) : void 0,
      "data-testid": "badge-overflow"
    }, {
      default: xe(() => [
        e.focusable ? (c(), g("span", {
          key: 0,
          id: I(t),
          hidden: ""
        }, N(e.label), 9, gy)) : k("", !0),
        re(ct, {
          label: e.label,
          theme: e.theme,
          size: e.size,
          "show-left-icon": !1,
          "show-close-icon": !1,
          "aria-hidden": e.focusable ? "true" : void 0
        }, null, 8, ["label", "theme", "size", "aria-hidden"]),
        e.focusable ? k("", !0) : (c(), g("span", my, ": " + N(n.hiddenLabels.join(", ")), 1))
      ]),
      _: 1
    }, 8, ["text", "tabindex", "role", "aria-labelledby"]));
  }
});
function Fu(e) {
  return "hiddenLabels" in e;
}
function Vu(e, n) {
  const t = Number.isFinite(n) ? Math.max(0, Math.floor(n)) : e.length, a = e.slice(0, t), l = e.slice(a.length);
  return l.length > 0 ? [...a, { label: `+${l.length}`, hiddenLabels: l.map((r) => r.label) }] : a;
}
const py = /* @__PURE__ */ ke({
  __name: "IconShape",
  props: {
    color: {},
    size: { default: "md" },
    type: { default: "square" },
    variant: { default: "filled" },
    icon: { default: void 0 },
    label: { default: void 0 },
    as: { default: "div" }
  },
  setup(e) {
    const n = e, t = {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-9 w-9",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
      "2xl": "h-24 w-24"
    }, a = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, l = {
      xs: "border-(length:--border-border-width-border)",
      sm: "border-(length:--border-border-width-border)",
      md: "border-(length:--border-border-width-border-sm)",
      lg: "border-(length:--border-border-width-border-sm)",
      xl: "border-(length:--border-border-width-border-sm)",
      "2xl": "border-(length:--border-border-width-border-sm)"
    }, r = {
      xs: "text-(length:--icon-size-2xs)",
      sm: "text-(length:--icon-size-sm)",
      md: "text-(length:--icon-size-md)",
      lg: "text-(length:--icon-size-xl)",
      xl: "text-(length:--icon-size-2xl)",
      "2xl": "text-(length:--icon-size-3xl)"
    }, o = {
      xs: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
      sm: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      md: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      lg: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
      xl: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
      "2xl": "text-(length:--size-6xl) leading-(--line-height-6xl) font-(--weight-bold)"
    }, i = {
      red: { bg: "bg-(--components-icon-shape-background-iconshape-red-bg)", icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { bg: "bg-(--components-icon-shape-background-iconshape-orange-bg)", icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { bg: "bg-(--components-icon-shape-background-iconshape-yellow-bg)", icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { bg: "bg-(--components-icon-shape-background-iconshape-green-bg)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      purple: { bg: "bg-(--components-icon-shape-background-iconshape-purple-bg)", icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { bg: "bg-(--components-icon-shape-background-iconshape-violet-bg)", icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { bg: "bg-(--components-icon-shape-background-iconshape-indigo-bg)", icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      dark: { bg: "bg-(--components-icon-shape-background-iconshape-black-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-icon)" },
      white: { bg: "bg-(--components-icon-shape-background-iconshape-white-bg)", icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { bg: "bg-(--components-icon-shape-background-iconshape-cyan-bg)", icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { bg: "bg-(--components-icon-shape-background-iconshape-success-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      error: { bg: "bg-(--components-icon-shape-background-iconshape-error-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      text: {
        bg: "bg-(--components-icon-shape-background-iconshape-black-default-bg)",
        icon: "text-(--components-icon-shape-text-iconshape-white-default-text)",
        text: "text-(--components-icon-shape-text-iconshape-white-default-text)"
      },
      disabled: {
        bg: "bg-(--components-icon-shape-background-iconshape-disabled-bg)",
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-white-icon)", text: "text-(--components-icon-shape-text-iconshape-white-default-text)" },
      "sunny-gradient": {
        icon: "text-(--components-icon-shape-icon-iconshape-accent-gradient-icon)",
        text: "text-(--components-icon-shape-text-iconshape-accent-gradient-text)"
      }
    }, s = {
      ...i,
      red: { icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { icon: "text-(--components-icon-shape-icon-iconshape-green-icon)" },
      purple: { icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      white: { icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { border: "border-(--components-icon-shape-border-iconshape-success-border)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      error: { border: "border-(--components-icon-shape-border-iconshape-error-border)", icon: "text-(--components-icon-shape-icon-iconshape-error-icon)" },
      text: { icon: "text-(--components-icon-shape-text-iconshape-black-default-text)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" },
      disabled: {
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-brand-icon)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" }
    }, d = m(
      () => n.color === "white" || n.variant === "outlined" && n.color !== "dark"
    ), u = m(() => (d.value ? s : i)[n.color]), f = m(() => !n.icon && n.label !== void 0), b = m(() => !!n.icon && Nl(n.icon)), h = m(() => {
      if (n.color === "gradient") return "var(--gradient-brand-border)";
      if (n.color === "sunny-gradient" && d.value) return "var(--gradient-sunny)";
    }), p = m(() => {
      if (h.value) {
        const y = d.value ? "var(--components-icon-shape-background-iconshape-white-bg)" : "var(--components-icon-shape-background-iconshape-black-default-bg)";
        return { backgroundImage: `linear-gradient(${y}, ${y}), ${h.value}` };
      }
      if (n.color === "sunny-gradient") return { backgroundImage: "var(--gradient-sunny)" };
    }), x = m(() => {
      const y = u.value;
      return [
        t[n.size],
        n.type === "circle" ? "rounded-(--border-border-radius-rounded-full)" : a[n.size],
        "border-solid",
        l[n.size],
        h.value ? "icon-shape-gradient-ring border-transparent" : y.border ?? "border-(--components-icon-shape-border-iconshape-default-border)",
        h.value || n.color === "sunny-gradient" ? void 0 : y.bg ?? "bg-(--components-icon-shape-background-iconshape-white-bg)",
        f.value && y.text ? y.text : y.icon
      ];
    });
    return (y, w) => (c(), H(lt(e.as), {
      class: C(["flex shrink-0 items-center justify-center", x.value]),
      style: Ne(p.value),
      "aria-hidden": "true",
      "data-testid": "icon-shape"
    }, {
      default: xe(() => [
        b.value ? (c(), g("i", {
          key: 0,
          class: C([e.icon, r[e.size], "leading-none"])
        }, null, 2)) : e.icon ? (c(), g("span", {
          key: 1,
          class: C([r[e.size], "leading-none", e.color === "disabled" && "opacity-50"])
        }, N(e.icon), 3)) : e.label !== void 0 ? (c(), g("span", {
          key: 2,
          class: C(["font-inter whitespace-nowrap", o[e.size]])
        }, N(e.label), 3)) : k("", !0)
      ]),
      _: 1
    }, 8, ["class", "style"]));
  }
}), Vt = /* @__PURE__ */ ot(py, [["__scopeId", "data-v-3fd4680f"]]), Nu = Symbol("CheckboxGroupErrorId");
function ug(e) {
  const n = Nt(Nu, void 0);
  return m(() => {
    const t = [...e(), n == null ? void 0 : n.value].filter(Boolean);
    return t.length > 0 ? t.join(" ") : void 0;
  });
}
function vy() {
  nn(Nu, m(() => {
  }));
}
const Cs = "opal:checked-resync";
function xy(e) {
  if (e.type !== "radio" || e.name === "") return [e];
  const n = e.getRootNode();
  return Array.from(n.querySelectorAll('input[type="radio"]')).filter(
    (t) => t.name === e.name && t.form === e.form
  );
}
function Xi(e, n, t = () => !1) {
  const a = () => {
    e.value && (e.value.checked = n(), e.value.indeterminate = t());
  };
  $e(
    e,
    (r, o, i) => {
      r && (r.addEventListener(Cs, a), i(() => r.removeEventListener(Cs, a)));
    },
    { immediate: !0, flush: "post" }
  );
  function l() {
    const r = e.value;
    r && Ue(() => {
      for (const o of xy(r)) o.dispatchEvent(new Event(Cs));
    });
  }
  return { resync: l };
}
const cg = "mb-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)", fg = "flex items-center gap-1 text-(length:--size-sm) leading-(--line-height-m) text-(--text-text-error-strong) dark:text-(--text-text-error)", hg = "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)", yy = ["id", "name", "checked", "disabled", "indeterminate", "value", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-disabled"], ky = ["for"], wy = ["for"], Cy = {
  key: 0,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "checkbox-hit-area"
}, Sy = ["for"], $y = ["for"], Iy = ["id"], $n = /* @__PURE__ */ ke({
  __name: "Checkbox",
  props: {
    label: { default: void 0 },
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    labelPosition: { default: "right" },
    variant: { default: "default" },
    labelWrap: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    error: { default: void 0 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => t.disabled || t.ariaDisabled), l = je(), r = m(() => t.id ?? l), o = m(() => `${r.value}-error`), i = m(() => !!t.error && !t.presentational), s = m(() => t.presentational ? "span" : "div"), d = ug(() => [
      t.ariaDescribedby,
      i.value ? o.value : void 0
    ]), u = n, f = R(null), { resync: b } = Xi(
      f,
      () => t.modelValue,
      () => t.indeterminate
    ), h = m(() => t.modelValue || t.indeterminate), p = m(
      () => !t.presentational && !!t.label && (t.labelPosition === "left" || t.labelPosition === "right")
    ), x = m(() => {
      const A = "relative size-4 shrink-0 box-border flex items-center justify-center rounded-(--border-border-radius-rounded-xs) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent" + (p.value ? " mt-0.5" : ""), D = h.value ? "" : " peer-focus-visible:border-(--border-border-hover)";
      if (a.value)
        return `${A} bg-(--background-background-disabled-strong) border-(--border-border-disabled) cursor-not-allowed`;
      if (t.variant === "dark") {
        const M = h.value ? "bg-(--background-background-black-default)" : "bg-transparent";
        return `${A} ${M} border-(--border-border-white-full) cursor-pointer${D}`;
      }
      return h.value ? t.variant === "light" ? `${A} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-white-default) dark:border-(--border-border-base) cursor-pointer` : `${A} bg-(--background-background-black-default) border-(--border-border-base) cursor-pointer` : `${A} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) cursor-pointer${D}`;
    }), y = m(() => {
      const E = `${t.indeterminate ? "ri-subtract-fill" : "ri-check-fill"} text-(length:--size-l) leading-none forced-colors:forced-color-adjust-none`;
      return a.value ? `${E} text-(--icons-icon-disabled-strong) forced-colors:text-[GrayText]` : t.variant === "light" ? `${E} text-(--icons-icon-black) dark:text-(--icons-icon-white-default) forced-colors:text-[CanvasText]` : `${E} text-(--icons-icon-white-default) forced-colors:text-[CanvasText]`;
    }), w = m(() => {
      let E = "relative flex text-left font-inter text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) select-none";
      return t.labelPosition === "top" || t.labelPosition === "bottom" ? E += " flex-col items-center gap-2 w-auto" : E += p.value ? " flex-row items-start gap-2 w-full min-w-0" : " flex-row items-center gap-2 w-full min-w-0", p.value && (E += " min-h-6 px-px py-0.5"), i.value && (E += " flex-wrap"), t.presentational && (E += " pointer-events-none"), a.value ? `${E} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)` : t.variant === "dark" ? `${E} text-(--text-text-white-default)` : `${E} text-(--text-text-heading) dark:text-(--text-text-white-default)`;
    }), $ = m(() => {
      const E = "relative cursor-pointer flex-1 min-w-0";
      return t.labelWrap ? `${E} break-words` : E;
    }), S = (E) => {
      E.stopPropagation(), t.ariaDisabled && E.preventDefault();
    }, L = (E) => {
      if (E.preventDefault(), E.stopPropagation(), a.value) return;
      const A = !t.modelValue;
      u("update:modelValue", A), u("change", E);
    }, T = (E) => {
      if (a.value) return;
      const A = E.target;
      u("update:modelValue", A.checked), u("change", E), b();
    };
    return (E, A) => (c(), H(lt(s.value), Oe({
      class: w.value,
      "data-testid": "checkbox-container"
    }, Ml(e.presentational ? {} : { click: L })), {
      default: xe(() => [
        e.presentational ? k("", !0) : (c(), g("input", {
          key: 0,
          id: r.value,
          ref_key: "inputRef",
          ref: f,
          name: e.name,
          type: "checkbox",
          checked: e.modelValue,
          disabled: e.disabled,
          indeterminate: e.indeterminate || void 0,
          value: e.value,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          "aria-describedby": I(d),
          "aria-invalid": i.value ? "true" : void 0,
          "aria-disabled": e.ariaDisabled && !e.disabled ? "true" : void 0,
          class: "peer sr-only pointer-events-none",
          onChange: T,
          onClick: S
        }, null, 40, yy)),
        e.label && e.labelPosition === "top" ? (c(), g("label", {
          key: 1,
          for: r.value,
          class: "relative cursor-pointer text-center"
        }, N(e.label), 9, ky)) : k("", !0),
        e.label && e.labelPosition === "left" ? (c(), g("label", {
          key: 2,
          for: r.value,
          class: C($.value)
        }, [
          e.labelWrap ? (c(), g(ce, { key: 0 }, [
            et(N(e.label), 1)
          ], 64)) : (c(), H(ht, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, wy)) : k("", !0),
        (c(), H(lt(s.value), {
          class: C(x.value),
          "data-testid": "checkbox-box",
          "aria-hidden": "true"
        }, {
          default: xe(() => [
            e.presentational ? k("", !0) : (c(), g("span", Cy)),
            e.indeterminate || e.modelValue ? (c(), g("i", {
              key: 1,
              class: C(y.value),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0)
          ]),
          _: 1
        }, 8, ["class"])),
        e.label && e.labelPosition === "right" ? (c(), g("label", {
          key: 3,
          for: r.value,
          class: C($.value)
        }, [
          e.labelWrap ? (c(), g(ce, { key: 0 }, [
            et(N(e.label), 1)
          ], 64)) : (c(), H(ht, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, Sy)) : k("", !0),
        e.label && e.labelPosition === "bottom" ? (c(), g("label", {
          key: 4,
          for: r.value,
          class: "relative cursor-pointer text-center"
        }, N(e.label), 9, $y)) : k("", !0),
        i.value ? (c(), g("div", {
          key: 5,
          id: o.value,
          "data-testid": "checkbox-error",
          class: C(["basis-full self-stretch", I(fg)]),
          role: "alert",
          onClick: A[0] || (A[0] = Ye(() => {
          }, ["stop"]))
        }, [
          v("i", {
            class: C(I(hg)),
            "aria-hidden": "true"
          }, null, 2),
          v("span", null, N(e.error), 1)
        ], 10, Iy)) : k("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), Ty = {
  key: 0,
  class: "absolute left-5 top-1/2 z-[1] flex -translate-y-1/2"
}, Ly = ["id", "aria-expanded", "aria-controls", "aria-pressed", "aria-disabled", "disabled"], Ay = {
  key: 0,
  class: "flex-shrink-0",
  "aria-hidden": "true"
}, Ey = {
  key: 1,
  class: "flex flex-1 min-w-0 items-center gap-2"
}, Ry = {
  key: 0,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, By = {
  key: 4,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, Dy = ["id"], My = {
  key: 0,
  class: "sr-only"
}, zy = {
  key: 0,
  class: "flex max-w-full shrink-0 flex-wrap items-center gap-1",
  "data-testid": "accordion-item-badges"
}, Oy = ["id", "aria-labelledby", "aria-hidden", "inert"], Py = { class: "accordion-content-inner" }, Fy = /* @__PURE__ */ ke({
  __name: "AccordionItem",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    defaultOpen: { type: Boolean, default: !1 },
    type: { default: "default" },
    badgeLabel: { default: void 0 },
    badgeTheme: { default: "active" },
    expandable: { type: Boolean, default: !0 },
    selected: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    size: { default: void 0 },
    headingLevel: { default: void 0 },
    avatarSrc: { default: void 0 },
    avatarAlt: { default: void 0 },
    completed: { type: Boolean, default: !1 },
    completedLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    selectable: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "select", "update:open", "update:checked"],
  setup(e, { emit: n }) {
    var te;
    const t = e, a = n, l = {
      variant: R("default"),
      size: R("md"),
      headingLevel: R(3),
      isChildLevel: R(!1),
      openItems: /* @__PURE__ */ new Set(),
      toggleItem: () => {
      },
      openItem: () => {
      }
    }, r = Nt(Kb, l), o = je(), i = m(() => t.headingLevel ?? r.headingLevel.value), s = R(0);
    nn(Yb, {
      variant: r.variant,
      headingLevel: i,
      size: m(() => L.value),
      registerChildAccordion: () => (s.value++, () => s.value--)
    });
    const d = r === l, {
      triggerId: u,
      panelId: f,
      isOpen: b,
      isControlled: h,
      onTransitionEnd: p,
      panelClasses: x,
      toggle: y
    } = Jb({
      id: o,
      open: () => t.open,
      defaultOpen: () => t.defaultOpen && t.expandable,
      onOpenChange: (oe) => {
        h.value && a("update:open", oe);
      },
      store: d ? void 0 : {
        isOpen: () => r.openItems.has(o),
        toggle: () => r.toggleItem(o),
        open: () => r.openItem(o)
      }
    }), w = () => {
      if (!t.disabled) {
        if (!E.value) {
          a("select");
          return;
        }
        a("toggle", y());
      }
    }, $ = (oe) => {
      var he, Me, Ee, He;
      if (!E.value && ["Enter", " "].includes(oe.key)) {
        oe.preventDefault(), w();
        return;
      }
      if (!["ArrowUp", "ArrowDown", "Home", "End"].includes(oe.key)) return;
      const Le = oe.currentTarget, Ie = Le.closest("[data-accordion-root]");
      if (!Ie) return;
      const ve = Array.from(
        Ie.querySelectorAll(
          '[data-testid="accordion-item-trigger"]:not([disabled])'
        )
      ).filter((Ge) => {
        if (Ge.closest("[data-accordion-root]") !== Ie) return !1;
        const Ze = Ge.closest('[inert], [aria-hidden="true"]');
        return !Ze || !Ie.contains(Ze);
      }), we = ve.indexOf(Le);
      switch (oe.preventDefault(), oe.key) {
        case "ArrowDown":
          (he = ve[(we + 1) % ve.length]) == null || he.focus();
          break;
        case "ArrowUp":
          (Me = ve[(we - 1 + ve.length) % ve.length]) == null || Me.focus();
          break;
        case "Home":
          (Ee = ve[0]) == null || Ee.focus();
          break;
        case "End":
          (He = ve[ve.length - 1]) == null || He.focus();
          break;
      }
    }, S = r.variant, L = m(() => t.size ?? r.size.value), T = m(() => t.type === "time-slot"), E = m(() => t.expandable), A = m(() => r.isChildLevel.value), D = m(() => S.value === "flush"), M = m(() => S.value === "with-sub-header"), F = m(() => !!(t.avatarSrc || t.avatarAlt)), X = m(() => t.completed && M.value), _ = m(() => t.selectable && !T.value && !A.value), Y = m(() => `${o}-title`);
    typeof process < "u" && ((te = process.env) == null ? void 0 : te.NODE_ENV) !== "production" && $e(
      () => [X.value, t.completedLabel],
      ([oe, Le]) => {
        oe && !(Le != null && Le.trim()) && console.warn("[OPAL AccordionItem] `completed` is set without `completedLabel`: the done state is visual only (WCAG 1.1.1 / 1.3.1).");
      },
      { immediate: !0 }
    );
    const W = m(() => T.value ? "div" : `h${i.value}`), U = m(() => T.value ? [`[&:not(:last-child)]:mb-4 ${ee.value ? "overflow-visible" : "overflow-hidden"} rounded-xl`, O.value].join(" ") : S.value === "separate-cards" ? "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden shadow-(--blur-shadow-sm)" : D.value ? E.value && b.value ? "last:[&>.accordion-content>*>*]:border-b-0" : `last:[&>*>*>button]:border-b-0 ${K.value.restoreLast}` : A.value ? "" : [
      `[&:not(:first-child)>*>*>button]:border-t [&:not(:first-child)>*>*>button]:border-solid [&:not(:first-child)>*>*>button]:border-(--colors-border-base-soft) ${K.value.nonFirst}`,
      "first:[&>*>*>button]:rounded-t-(--border-border-radius-rounded-l)",
      E.value && b.value ? "" : "last:[&>*>*>button]:rounded-b-(--border-border-radius-rounded-l)"
    ].join(" ").trim()), z = m(() => T.value ? E.value && b.value ? "rounded-t-xl" : "rounded-xl" : S.value === "separate-cards" ? E.value && b.value ? "rounded-t-(--border-border-radius-rounded-l)" : "rounded-(--border-border-radius-rounded-l)" : ""), P = {
      1: {
        both: "py-1",
        lessBottom: "pt-1 pb-[calc(var(--spacing-1)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-1",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-1)-1px)]"
      },
      3: {
        both: "py-3",
        lessBottom: "pt-3 pb-[calc(var(--spacing-3)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-3",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-3)-1px)]"
      },
      5: {
        both: "py-5",
        lessBottom: "pt-5 pb-[calc(var(--spacing-5)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-5",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-5)-1px)]"
      }
    }, K = m(
      () => P[L.value === "sm" ? 1 : M.value || F.value || _.value ? 5 : 3]
    ), j = m(() => {
      if (T.value) return "p-3";
      if (A.value) return "pt-[calc(var(--spacing-5)-1px)] pr-6 pb-5 pl-12";
      const oe = D.value ? K.value.lessBottom : K.value.both, Le = _.value ? "pr-5 pl-[calc(var(--spacing-5)_+_var(--spacing-4)_+_var(--spacing-6))]" : "px-5";
      return `${oe} ${Le}`;
    }), G = m(() => T.value ? "gap-2.5" : M.value ? "gap-3.5" : "gap-6"), q = m(() => [
      G.value,
      "@max-[40rem]/row:flex-col @max-[40rem]/row:items-stretch @max-[40rem]/row:gap-2"
    ]), J = m(() => T.value || S.value === "separate-cards" ? "" : D.value ? "border-b border-solid border-(--colors-border-base-soft)" : A.value ? "border-t border-solid border-(--colors-border-base-soft)" : ""), me = m(() => T.value ? "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-info-strong)" : "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)"), ye = m(() => T.value ? t.disabled ? "cursor-not-allowed" : "cursor-pointer" : D.value ? t.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer" : t.disabled ? "cursor-not-allowed opacity-60 bg-(--background-background-white)" : [
      "cursor-pointer",
      b.value ? "bg-(--colors-background-selected)" : `bg-(--background-background-white) ${_.value ? "group-hover/header:" : "hover:"}bg-(--colors-background-hover)`
    ].join(" ")), Z = m(() => D.value && !t.disabled && !b.value), de = m(() => Z.value ? "group-hover/trigger:text-(--text-text-hover)" : ""), ge = m(() => [
      "text-(--icons-icon-dark-default)",
      Z.value ? "group-hover/trigger:text-(--icons-icon-hover)" : ""
    ]), se = m(() => [
      "text-(length:--size-l) leading-(--line-height-xxl) text-(--colors-text-heading)",
      A.value ? "font-(--weight-medium)" : "font-(--weight-bold)",
      de.value
    ]), Se = m(() => [
      "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)",
      de.value
    ]), V = m(() => L.value === "sm" ? "sm" : "md"), Q = m(() => S.value !== "separate-cards" || A.value ? "text-(length:--icon-size-lg)" : L.value === "sm" ? "text-(length:--icon-size-sm)" : "text-(length:--icon-size-md)"), le = m(
      () => Vu(t.badges, t.maxBadges).map((oe) => ({
        ...oe,
        theme: oe.theme ?? "gradient-light"
      }))
    ), ee = m(() => !t.disabled && E.value && b.value), O = m(() => T.value ? t.disabled || !E.value && t.selected ? "border border-(--border-border-base-medium)" : ee.value ? "relative border border-transparent accordion-time-slot-gradient-border" : "border border-(--border-border-info) hover:border-(--border-border-info-strong)" : ""), ne = m(() => T.value ? t.disabled ? "bg-(--background-background-disabled-subtle)" : !E.value && t.selected ? "bg-(--components-badge-background-badge-indigo-strong-bg)" : "bg-(--background-background-info)" : ""), fe = m(() => T.value ? t.disabled ? "font-medium text-(--text-text-disabled-strong) line-through" : !E.value && t.selected ? "font-bold text-(--colors-text-white-default)" : "font-medium text-(--text-text-link)" : ""), ue = m(() => T.value ? "flex flex-col gap-1 px-2 py-1.5 rounded-b-xl bg-(--background-background-white) dark:bg-(--colors-background-black-default)" : S.value === "multi-level" && !A.value && s.value > 0 ? "flex flex-col" : [
      "flex flex-col gap-3 bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--colors-border-base-soft)",
      D.value ? "border-b" : "border-t",
      L.value === "sm" ? "py-3 px-5" : "p-5"
    ].join(" "));
    return (oe, Le) => (c(), g("div", {
      class: C(U.value),
      "data-accordion-item": "",
      "data-testid": "accordion-item"
    }, [
      v("div", {
        class: C(T.value ? "contents" : ["relative group/header", le.value.length ? "@container/row" : ""]),
        "data-testid": "accordion-item-header"
      }, [
        _.value ? (c(), g("div", Ty, [
          re($n, {
            "model-value": e.checked,
            disabled: e.disabled,
            "aria-labelledby": Y.value,
            "data-testid": "accordion-item-checkbox",
            "onUpdate:modelValue": Le[0] || (Le[0] = (Ie) => a("update:checked", Ie))
          }, null, 8, ["model-value", "disabled", "aria-labelledby"])
        ])) : k("", !0),
        (c(), H(lt(W.value), {
          class: C(T.value ? "contents" : "m-0")
        }, {
          default: xe(() => [
            v("button", {
              id: T.value ? void 0 : I(u),
              type: "button",
              class: C(["flex w-full items-center text-left transition-colors", [
                z.value,
                G.value,
                J.value,
                j.value,
                ye.value,
                ne.value,
                me.value,
                T.value ? "" : "group/trigger",
                T.value && !E.value ? "justify-center" : ""
              ]]),
              "aria-expanded": E.value ? I(b) : void 0,
              "aria-controls": E.value ? I(f) : void 0,
              "aria-pressed": T.value && !E.value ? e.selected : void 0,
              "aria-disabled": T.value && e.disabled ? "true" : void 0,
              disabled: T.value ? !1 : e.disabled,
              "data-testid": "accordion-item-trigger",
              onClick: w,
              onKeydown: $
            }, [
              T.value ? (c(), g(ce, { key: 0 }, [
                e.icon && E.value ? (c(), g("div", Ay, [
                  v("i", {
                    class: C([
                      e.icon,
                      "text-[16px]",
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)"
                    ])
                  }, null, 2)
                ])) : k("", !0),
                v("div", {
                  class: C(["flex flex-1 min-w-0 flex-wrap items-center gap-2", E.value ? "" : "justify-center"]),
                  "data-testid": "accordion-item-time-wrapper"
                }, [
                  v("span", {
                    "data-testid": "accordion-item-time",
                    class: C(["text-base leading-6", fe.value])
                  }, N(e.title), 3),
                  e.badgeLabel && E.value ? (c(), H(ct, {
                    key: 0,
                    "data-testid": "accordion-item-badge",
                    label: e.badgeLabel,
                    theme: e.disabled ? "disabled" : e.badgeTheme,
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1
                  }, null, 8, ["label", "theme"])) : k("", !0)
                ], 2)
              ], 64)) : (c(), g("span", Ey, [
                A.value && E.value ? (c(), g("span", Ry, [
                  v("i", {
                    class: C(["ri-arrow-down-s-line text-(length:--icon-size-lg) leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [ge.value, I(b) ? "rotate-180" : ""]])
                  }, null, 2)
                ])) : F.value ? (c(), H(Mt, {
                  key: 1,
                  as: "span",
                  img: e.avatarSrc,
                  name: e.avatarAlt || e.title,
                  presentational: !e.avatarAlt,
                  size: L.value === "sm" ? "sm" : "md"
                }, null, 8, ["img", "name", "presentational", "size"])) : X.value ? (c(), H(Vt, {
                  key: 2,
                  as: "span",
                  color: "success",
                  variant: "filled",
                  type: "circle",
                  icon: "ri-check-fill",
                  size: V.value
                }, null, 8, ["size"])) : M.value && e.icon ? (c(), H(Vt, {
                  key: 3,
                  as: "span",
                  color: "white",
                  variant: "outlined",
                  type: "circle",
                  icon: e.icon,
                  size: V.value
                }, null, 8, ["icon", "size"])) : e.icon && !A.value ? (c(), g("span", By, [
                  v("i", {
                    class: C([e.icon, "text-(length:--icon-size-md) leading-none", ge.value])
                  }, null, 2)
                ])) : k("", !0),
                v("span", {
                  class: C(["flex min-w-0 flex-1 items-center", q.value])
                }, [
                  v("span", {
                    class: C(["flex min-w-0 flex-1 flex-col", M.value || F.value ? "gap-px" : ""])
                  }, [
                    v("span", {
                      id: Y.value,
                      class: C(se.value),
                      "data-testid": "accordion-item-title"
                    }, [
                      et(N(e.title), 1),
                      X.value && e.completedLabel ? (c(), g("span", My, ", " + N(e.completedLabel), 1)) : k("", !0)
                    ], 10, Dy),
                    e.subtitle ? (c(), g("span", {
                      key: 0,
                      class: C(Se.value),
                      "data-testid": "accordion-item-subtitle"
                    }, N(e.subtitle), 3)) : k("", !0)
                  ], 2),
                  le.value.length ? (c(), g("span", zy, [
                    (c(!0), g(ce, null, Re(le.value, (Ie, ve) => (c(), g(ce, { key: ve }, [
                      I(Fu)(Ie) ? (c(), H(Pu, {
                        key: 0,
                        label: Ie.label,
                        "hidden-labels": Ie.hiddenLabels,
                        theme: Ie.theme,
                        size: "xs",
                        focusable: !1
                      }, null, 8, ["label", "hidden-labels", "theme"])) : (c(), H(ct, {
                        key: 1,
                        label: Ie.label,
                        theme: Ie.theme,
                        size: "xs",
                        truncate: Ie.truncate ?? !1,
                        "truncation-focusable": !1,
                        "show-left-icon": !1,
                        "show-close-icon": !1
                      }, null, 8, ["label", "theme", "truncate"]))
                    ], 64))), 128))
                  ])) : k("", !0)
                ], 2)
              ])),
              E.value && !A.value ? (c(), H(lt(T.value ? "div" : "span"), {
                key: 2,
                class: C(T.value ? "flex-shrink-0 ml-auto" : "flex shrink-0 ml-auto"),
                "aria-hidden": "true"
              }, {
                default: xe(() => [
                  T.value ? (c(), g("i", {
                    key: 0,
                    class: C(["ri-arrow-down-s-line text-2xl transition-transform duration-300", [
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)",
                      I(b) ? "rotate-180" : ""
                    ]])
                  }, null, 2)) : (c(), g("i", {
                    key: 1,
                    class: C(["ri-arrow-down-s-line block leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [Q.value, ge.value, I(b) ? "rotate-180" : ""]])
                  }, null, 2))
                ]),
                _: 1
              }, 8, ["class"])) : k("", !0)
            ], 42, Ly)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 2),
      E.value ? (c(), g("div", {
        key: 0,
        id: I(f),
        class: C(I(x)),
        role: "region",
        "aria-labelledby": T.value ? void 0 : I(u),
        "aria-hidden": !I(b),
        inert: !I(b) || void 0,
        onTransitionend: Le[1] || (Le[1] = //@ts-ignore
        (...Ie) => I(p) && I(p)(...Ie))
      }, [
        v("div", Py, [
          v("div", {
            class: C(ue.value)
          }, [
            Ae(oe.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 42, Oy)) : k("", !0)
    ], 2));
  }
}), PW = /* @__PURE__ */ ot(Fy, [["__scopeId", "data-v-281355d5"]]);
function Vy(e, n) {
  return `${e}-tab-${String(n).replace(/\s+/g, "-")}`;
}
const bg = Symbol("ButtonGroupContext"), Ss = "bg-(--components-button-button-disabled) border-(--border-border-disabled) text-(--text-text-disabled-strong)", $l = "border-transparent text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", Ny = "border-transparent [background:var(--btn-fill-image,linear-gradient(var(--btn-fill),var(--btn-fill)))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]", pf = "border-(--border-border-disabled) text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", vf = "before:-inset-px before:[background:linear-gradient(var(--btn-ring-angle,85deg),var(--gradient-brand-start)_10.83%,var(--gradient-brand-end)_86.95%)] after:bg-(--background-background-white)", Hy = {
  tertiary: { label: "[--btn-ring-angle:69deg]", iconOnly: "[--btn-ring-angle:85deg]" },
  tab: { label: "[--btn-ring-angle:72deg]", iconOnly: "[--btn-ring-angle:85deg]" }
}, xf = "focus-visible:overflow-visible focus-visible:border-transparent focus-visible:before:opacity-100 focus-visible:after:opacity-100", jy = {
  primary: {
    shape: `rounded-full ${Ny}`,
    rest: "[--btn-fill:var(--components-button-primary-button-primary)] [--btn-stroke:var(--border-border-primary-button)] text-(--text-text-white-secondary) dark:text-(--text-text-white-default)",
    interactive: "hover:[--btn-fill-image:var(--gradient-button-primary-hover)] hover:[--btn-stroke:var(--border-border-primary-button-hover)] focus-visible:[--btn-stroke:var(--border-border-accent)]",
    labelInteractive: "dark:hover:[--btn-fill-image:linear-gradient(90deg,_var(--text-text-white-default),_var(--colors-indigo-100))] dark:hover:text-(--text-text-black-default)",
    disabled: "[--btn-fill:var(--components-button-button-disabled)] [--btn-stroke:var(--border-border-disabled)] text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  // Figma fades the Secondary hover in (Dissolve), hence the `before` layer.
  secondary: {
    shape: "rounded-full before:inset-0 before:[background:var(--gradient-button-secondary-hover)]",
    rest: "bg-(--components-button-secondary-button-secondary) border-(--border-border-secondary-button) text-(--text-text-black-default)",
    interactive: "hover:border-(--border-border-secondary-button-hover) hover:before:opacity-100 dark:hover:bg-(--components-button-secondary-button-secondary-hover) dark:hover:text-(--text-text-white-secondary) focus-visible:text-(--text-text-accent) focus-visible:border-(--border-border-accent)",
    disabled: Ss,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-focus-visible/button:text-(--icons-icon-accent)"
  },
  // background-hover has no dark value; the Tertiary hover token carries the dark one.
  tertiary: {
    shape: `${vf} after:inset-[calc(var(--border-border-width-border-sm)-1px)] dark:after:bg-(--components-button-tertiary-button-tertiary-focused)`,
    rest: "border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-secondary)",
    interactive: `hover:bg-(--background-background-hover) dark:hover:bg-(--components-button-tertiary-button-tertiary-hover) dark:hover:text-(--text-text-black-default) hover:border-(--border-border-tertiary-hover) dark:hover:border-(--components-button-tertiary-button-tertiary-hover) ${xf}`,
    disabled: $l,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  ghost: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--components-button-ghost-button-ghost-hover) dark:hover:text-(--text-text-black-default)",
    disabled: $l,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  text: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-text-button-text) dark:text-(--text-text-white-default)",
    interactive: "hover:text-(--components-button-text-button-text-hover) dark:hover:text-(--text-text-hover)",
    disabled: $l,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--icons-icon-hover)"
  },
  // Stroke on top and sides only; the bottom edge joins the content below. Figma rounds Initial to
  // rounded-sm and every other state to rounded-l; OPAL keeps rounded-l in all states so hover doesn't reshape the tab.
  tab: {
    shape: `rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-b-0 before:[clip-path:inset(0_0_1px_0)] dark:after:bg-(--components-button-tab-button-tab-active) after:inset-0 ${vf}`,
    rest: "bg-(--components-button-tab-button-tab-default) border-(--border-border-tab) text-(--text-text-black-default)",
    interactive: `hover:bg-(--components-button-tab-button-tab) hover:border-(--border-border-hover) ${xf}`,
    disabled: "bg-(--colors-white-50-opacity-light) dark:bg-(--components-button-button-disabled) border-(--border-border-disabled-subtle) dark:border-(--border-border-disabled) text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  success: {
    shape: "rounded-full",
    rest: "bg-(--components-button-functional-success-button-success) border-transparent text-(--text-text-white-secondary) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-success-button-success-hover) focus-visible:[--btn-fill:var(--components-button-functional-success-button-success-focused)] focus-visible:[--btn-stroke:var(--border-border-success)] dark:focus-visible:[--btn-stroke:var(--colors-border-success-sublte)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: Ss,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-success-button-success) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-success-button-success-hover) focus-visible:border-(--components-button-functional-success-button-success-focused)",
    disabled: pf,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  error: {
    shape: "rounded-full",
    // CONSTRAINT: white-default, not white-secondary like the other filled variants: #f2f0f0 on the
    // error red #d92d20 is 4.26:1 and fails WCAG AA (4.5:1); #fafafa reaches 4.63:1.
    rest: "bg-(--components-button-functional-desctructive-error-background-button-error) border-transparent text-(--text-text-white-default) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:[--btn-fill:var(--components-button-functional-desctructive-error-background-button-error-focused)] focus-visible:[--btn-stroke:var(--border-border-error)] dark:focus-visible:[--btn-stroke:var(--border-border-error-subtle)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: Ss,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-desctructive-error-background-button-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:border-(--components-button-functional-desctructive-error-background-button-error-focused)",
    disabled: pf,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  // Red at rest; icons follow the text colour through every state.
  "error-text": {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-functional-desctructive-error-background-button-error)",
    interactive: "hover:text-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:text-(--components-button-functional-desctructive-error-background-button-error-focused) focus-visible:border-(--components-button-functional-desctructive-error-icons-button-error-focused-icon)",
    iconOnlyInteractive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: $l,
    icon: "",
    iconInteractive: ""
  }
}, Wy = {
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-success) dark:hover:bg-transparent",
    disabled: $l,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: $l,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--components-button-functional-desctructive-error-icons-button-error-icon)"
  }
}, qy = /* @__PURE__ */ new Set(["primary", "secondary", "ghost"]), Uy = /* @__PURE__ */ new Set(["tertiary", "ghost", "text", "error-text"]);
function gg(e) {
  return Object.fromEntries(Object.entries(e).filter(([n]) => !/^onClick(?:Once|Capture|Passive)*$/.test(n)));
}
const Gy = ["src"], Ky = ["src"], Yy = {
  key: 1,
  class: "relative z-10 min-w-0 whitespace-nowrap *:align-top"
}, Jy = ["src"], Xy = "group/button relative inline-flex max-w-full items-center justify-center gap-1.5 overflow-hidden border border-solid font-inter font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden before:content-[''] before:absolute before:rounded-[inherit] before:opacity-0 before:transition-opacity before:duration-150 before:z-0 motion-reduce:before:transition-none after:content-[''] after:absolute after:rounded-[inherit] after:opacity-0 after:transition-opacity after:duration-150 after:z-[1] motion-reduce:after:transition-none", Zy = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    as: { default: "button" },
    variant: { default: "primary" },
    outline: { type: Boolean, default: !0 },
    label: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    dropdownIcon: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    shrink: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    active: { type: Boolean, default: !1 },
    value: { default: void 0 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    var q;
    const t = e, a = n, l = Nn(), r = Mn(), o = Nt(bg, null), i = R(null), s = m(() => t.value === void 0 || o == null ? void 0 : o.mode.value), d = m(
      () => s.value && t.value !== void 0 ? o.isSelected(t.value) : t.active
    ), u = {
      xs: {
        button: "py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-sm) leading-(--line-height-l)",
        tabBottom: "pb-1.5",
        iconOnly: "size-8 p-0"
      },
      sm: {
        button: "py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2",
        iconOnly: "size-9 p-0"
      },
      md: {
        button: "py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2.5",
        iconOnly: "size-10 p-0"
      },
      lg: {
        button: "py-[calc(--spacing(3)-1px)] px-[calc(--spacing(5)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3",
        iconOnly: "size-12 p-0"
      },
      xl: {
        button: "py-[calc(--spacing(3.5)-1px)] px-[calc(--spacing(6)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3.5",
        iconOnly: "size-13 p-0"
      }
    }, f = { font: "text-(length:--icon-size-xs) leading-(--icon-size-xs)", box: "size-(--icon-size-xs)" }, b = { font: "text-(length:--icon-size-sm) leading-(--icon-size-sm)", box: "size-(--icon-size-sm)" }, h = { font: "text-(length:--icon-size-md) leading-(--icon-size-md)", box: "size-(--icon-size-md)" }, p = { xs: f, sm: b, md: b, lg: b, xl: h }, x = { xs: f, sm: b, md: h, lg: h, xl: h }, y = m(() => (t.iconOnly ? x : p)[t.size]), w = m(
      () => !t.outline && (t.variant === "success-secondary" || t.variant === "error-secondary") ? Wy[t.variant] : jy[t.variant]
    ), $ = m(() => t.disabled && !t.loading && t.as === "button"), S = m(() => t.disabled || t.ariaDisabled || t.loading), L = m(() => (t.disabled || t.ariaDisabled) && !t.loading), T = m(() => !d.value || L.value ? "" : t.variant === "tertiary" ? "active bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] overflow-visible before:opacity-100 after:opacity-100" : t.variant === "tab" ? "bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] border-transparent text-(--text-text-black-default) overflow-visible before:opacity-100 after:opacity-100" : ""), E = m(() => {
      var me;
      const J = u[t.size];
      return [
        Xy,
        w.value.shape,
        (me = Hy[t.variant]) == null ? void 0 : me[t.iconOnly ? "iconOnly" : "label"],
        L.value ? ["cursor-not-allowed", w.value.disabled] : t.loading ? ["cursor-progress", !(d.value && t.variant === "tab") && w.value.rest] : [
          "cursor-pointer",
          // An active Tab replaces its rest colours instead of competing with them.
          !(d.value && t.variant === "tab") && w.value.rest,
          w.value.interactive,
          t.iconOnly ? w.value.iconOnlyInteractive : w.value.labelInteractive
        ],
        // The OPAL focus ring on every variant, also while `ariaDisabled`/`loading` keep the button
        // focusable: the Figma focus of Ghost and Text is too faint to see (RGAA 10.7).
        qy.has(t.variant) && !L.value ? "focus-visible:shadow-[var(--shadow-focus-l),var(--shadow-focus-s)]" : "focus-visible:shadow-(--shadow-focus-l)",
        Uy.has(t.variant) && (t.iconOnly ? "rounded-full" : "rounded-(--border-border-radius-rounded-base)"),
        t.iconOnly ? J.iconOnly : J.button,
        t.variant === "tab" && !t.iconOnly && J.tabBottom,
        t.fullWidth && !t.iconOnly && "w-full",
        t.shrink && !t.iconOnly ? "min-w-0" : "shrink-0",
        T.value
      ];
    }), A = m(() => [
      "relative z-10 inline-flex shrink-0 items-center justify-center dark:text-current",
      y.value.font,
      L.value ? "text-(--icons-icon-disabled-strong)" : [w.value.icon, !t.loading && w.value.iconInteractive]
    ]), D = m(() => {
      const J = L.value, me = t.variant === "error" || t.variant === "success" || t.variant === "error-text";
      return [
        "relative z-10 shrink-0",
        y.value.box,
        !J && !me && "dark:invert",
        J && "grayscale opacity-60"
      ];
    });
    function M(J) {
      return !!J && !J.includes("/");
    }
    const F = m(() => t.iconOnly ? `${t.variant}-icon-button` : `${t.variant}-button`);
    function X() {
      const J = S.value ? gg(l) : l;
      return {
        ...t.as === "button" ? { type: t.type, disabled: $.value || void 0 } : {},
        ...J,
        ...t.ariaLabel ? { "aria-label": t.ariaLabel } : {},
        ...S.value && !$.value ? { "aria-disabled": "true" } : {},
        ..._()
      };
    }
    if (o) {
      const J = o.register({
        value: () => t.value,
        unreachable: () => t.disabled || t.loading,
        blocked: () => S.value,
        el: () => i.value
      });
      dt(o.sort), mt(J);
    }
    function _() {
      if (!s.value || t.value === void 0) return {};
      const J = o.isTabStop(t.value), me = o.panelId();
      return {
        "data-button-group-item": "",
        tabindex: J ? 0 : -1,
        ...s.value === "tabs" ? { role: "tab", "aria-selected": String(d.value) } : { role: "radio", "aria-checked": String(d.value) },
        ...me && {
          id: l.id ?? Vy(me, t.value),
          "aria-controls": l["aria-controls"] ?? me
        }
      };
    }
    function Y(J) {
      if (S.value) {
        J.preventDefault();
        return;
      }
      s.value && t.value !== void 0 && o.select(t.value), a("click", J);
    }
    const B = R(null), W = R(!1), U = R(!1), z = m(() => U.value ? !1 : W.value ? !0 : void 0);
    function P(J) {
      try {
        W.value = J.target.matches(":focus-visible");
      } catch {
        W.value = !0;
      }
    }
    function K() {
      W.value = !1, U.value = !1;
    }
    $e(
      () => t.disabled,
      (J) => {
        J && K();
      }
    );
    function j(J) {
      var me;
      s.value && o.onItemKeydown(J), !(J.key !== "Escape" || U.value) && (!W.value || !((me = B.value) != null && me.isTruncated) || (J.stopPropagation(), J.preventDefault(), U.value = !0));
    }
    const G = typeof process < "u" && ((q = process.env) == null ? void 0 : q.NODE_ENV) !== "production";
    return $e(
      () => t.iconOnly && !t.ariaLabel,
      (J) => {
        G && J && !l["aria-label"] && !l["aria-labelledby"] && console.warn("[OPAL Button] `iconOnly` without `ariaLabel` or `aria-labelledby`: the button has no accessible name (WCAG 1.1.1 / 4.1.2).");
      },
      { immediate: !0 }
    ), (J, me) => (c(), H(lt(e.as), Oe({
      ref_key: "rootRef",
      ref: i,
      "data-testid": F.value
    }, X(), {
      class: E.value,
      onClick: Y,
      onFocus: P,
      onBlur: K,
      onKeydown: j
    }), {
      default: xe(() => [
        e.loading ? (c(), H(zu, {
          key: 0,
          size: "inherit",
          color: "current",
          label: e.loadingLabel,
          class: C(A.value)
        }, null, 8, ["label", "class"])) : k("", !0),
        !e.loading && e.iconOnly && (e.iconLeft || e.iconRight) ? (c(), g(ce, { key: 1 }, [
          M(e.iconLeft || e.iconRight) ? (c(), g("i", {
            key: 0,
            class: C([e.iconLeft || e.iconRight, A.value]),
            "aria-hidden": "true"
          }, null, 2)) : (c(), g("img", {
            key: 1,
            src: e.iconLeft || e.iconRight,
            class: C(D.value),
            alt: ""
          }, null, 10, Gy))
        ], 64)) : k("", !0),
        e.iconOnly ? k("", !0) : (c(), g(ce, { key: 2 }, [
          !e.loading && e.iconLeft ? (c(), g(ce, { key: 0 }, [
            M(e.iconLeft) ? (c(), g("i", {
              key: 0,
              class: C([e.iconLeft, A.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              src: e.iconLeft,
              class: C(D.value),
              alt: ""
            }, null, 10, Ky))
          ], 64)) : k("", !0),
          r.default ? (c(), g("span", Yy, [
            Ae(J.$slots, "default", {}, void 0, !0)
          ])) : e.label ? (c(), g("span", {
            key: 2,
            class: C(["relative z-10 flex min-w-0", e.variant === "tab" && "max-w-(--tab-label-max-width)"])
          }, [
            re(ht, {
              ref_key: "labelRef",
              ref: B,
              as: "span",
              text: e.label,
              focusable: !1,
              open: z.value
            }, null, 8, ["text", "open"])
          ], 2)) : k("", !0),
          !e.loading && e.iconRight ? (c(), g(ce, { key: 3 }, [
            M(e.iconRight) ? (c(), g("i", {
              key: 0,
              class: C([e.iconRight, A.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              src: e.iconRight,
              class: C(D.value),
              alt: ""
            }, null, 10, Jy))
          ], 64)) : k("", !0),
          e.dropdownIcon ? (c(), g("i", {
            key: 4,
            class: C(["ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none group-aria-expanded/button:rotate-180", A.value]),
            "aria-hidden": "true"
          }, null, 2)) : k("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["data-testid", "class"]));
  }
}), Be = /* @__PURE__ */ ot(Zy, [["__scopeId", "data-v-793b8637"]]), Hu = (e, n) => typeof e == "function" ? e(n) : e.replace("{count}", String(n)), Ja = /* @__PURE__ */ ke({
  __name: "ToggleSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    type: { default: "boolean" },
    size: { default: "base" },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.disabled || t.ariaDisabled), r = m(() => t.size === "lg"), o = m(() => t.type === "default"), i = m(() => o.value ? !t.modelValue : t.modelValue), s = m(() => {
      const p = `relative box-border inline-block ${r.value ? "h-6.5 w-11.5" : "h-5.5 w-9.5"} shrink-0 rounded-(--border-border-radius-rounded-full) border transition-[color,background-color,border-color] duration-100 ease-in-out motion-reduce:transition-none`, x = t.presentational ? "" : " focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent";
      if (l.value)
        return `${p}${x} cursor-not-allowed border-(--components-toggle-border-toggle-disabled-border) bg-(--components-toggle-background-toggle-disabled)`;
      const y = t.presentational ? "" : " cursor-pointer";
      return t.modelValue || o.value ? `${p}${x}${y} border-(--components-toggle-border-toggle-active-border) bg-(--components-toggle-background-toggle-active)` : `${p}${x}${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-unactive)`;
    }), d = m(() => {
      const p = `absolute top-0.5 box-border flex ${r.value ? "size-5" : "size-4"} border items-center justify-center rounded-(--border-border-radius-rounded-full) shadow-(--blur-shadow-xs) transition-[inset-inline-start] duration-150 ease-in-out motion-reduce:transition-none`, x = r.value ? "start-5.25" : "start-4.5", y = t.modelValue ? x : "start-0.5";
      return l.value ? `${p} ${y} border-transparent bg-(--components-toggle-background-toggle-disabled-switch)` : o.value ? `${p} ${y} border-transparent bg-(--components-toggle-background-toggle-active-switch)` : t.modelValue ? `${p} ${y} border-transparent bg-(--colors-background-white-secondary-soft)` : `${p} ${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-active-switch)`;
    }), u = m(() => {
      const h = r.value ? "text-(length:--icon-size-md)" : "text-(length:--icon-size-sm)";
      return l.value ? `ri-check-fill ${h} leading-none text-(--components-toggle-icon-toggle-icon-disabled)` : `ri-check-fill ${h} leading-none text-(--icons-icon-accent)`;
    }), f = m(
      () => t.presentational ? {} : {
        type: "button",
        role: "switch",
        "aria-checked": t.modelValue,
        "aria-disabled": t.ariaDisabled ? "true" : void 0,
        disabled: t.disabled
      }
    ), b = () => {
      t.presentational || l.value || a("update:modelValue", !t.modelValue);
    };
    return (h, p) => (c(), H(lt(e.presentational ? "span" : "button"), Oe(f.value, {
      class: s.value,
      onClick: b
    }), {
      default: xe(() => [
        v("span", {
          class: C(d.value)
        }, [
          re(wt, {
            "enter-active-class": "transition-opacity duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0"
          }, {
            default: xe(() => [
              i.value ? (c(), g("i", {
                key: 0,
                class: C(u.value),
                "aria-hidden": "true"
              }, null, 2)) : k("", !0)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
function mg(e, n) {
  const t = n.trim(), a = t ? new RegExp(t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i").exec(e) : null;
  if (!a) return { before: e, match: "", after: "" };
  const l = a.index;
  return {
    before: e.slice(0, l),
    match: a[0],
    after: e.slice(l + a[0].length)
  };
}
const pg = "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)", Wa = `${pg} shadow-(--blur-shadow-m)`, Qy = `${pg} shadow-(--shadow-l)`, ju = "text-(--text-text-black-default) dark:text-(--colors-text-white-default)", vg = "box-border flex flex-col gap-1.5 p-[calc(--spacing(2)-1px)]", ni = `${Wa} ${ju} ${vg}`, Wu = "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", _y = `flex min-h-8 w-full cursor-pointer items-center rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) transition-colors hover:bg-(--background-background-hover) ${Wu} dark:text-(--colors-text-white-default) dark:hover:bg-white/8`, ek = "bg-(--background-background-hover) dark:bg-white/8", xg = {
  success: "text-(--icons-icon-success)",
  base: "text-(--icons-icon-base)",
  error: "text-(--icons-icon-error)"
}, tk = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-checkbox"
}, nk = {
  key: 0,
  class: "h-5.5 w-9.5 shrink-0",
  "aria-hidden": "true",
  "data-testid": "dropdown-list-item-toggle-placeholder"
}, ak = ["src"], lk = ["id"], rk = ["id"], ok = {
  key: 1,
  class: "min-w-0 break-words"
}, ik = {
  class: "text-(--text-text-link)",
  "data-testid": "dropdown-list-item-highlight"
}, sk = {
  key: 1,
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, dk = {
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, uk = {
  key: 1,
  class: "flex shrink-0"
}, ck = {
  key: 4,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-more-actions"
}, fk = "inline-flex size-(--icon-size-sm) shrink-0 items-center justify-center", po = "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center shrink-0", Kt = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "DropdownListItem",
  props: {
    as: { default: "div" },
    type: { default: "default" },
    label: { default: void 0 },
    icon: { default: void 0 },
    iconColor: { default: void 0 },
    trailingIcon: { default: "ri-arrow-right-s-line" },
    secondaryLabel: { default: void 0 },
    secondaryIcon: { default: void 0 },
    flag: { default: void 0 },
    description: { default: void 0 },
    count: { default: void 0 },
    badge: { default: void 0 },
    checked: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    danger: { type: Boolean, default: !1 },
    header: { type: Boolean, default: !1 },
    moreActions: { default: void 0 },
    moreActionsLabel: { default: void 0 },
    moreActionsTabindex: { default: void 0 },
    labelWrap: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    highlight: { default: void 0 },
    keyboardActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = je(), a = je(), l = m(() => n.disabled || n.ariaDisabled || n.loading), r = m(() => n.selected && ["default", "two-icons", "two-labels", "flag", "secondary-text"].includes(n.type)), o = m(() => !!n.description), i = m(() => ["checkbox", "badge-checkbox", "checkbox-badge"].includes(n.type)), s = m(() => n.type === "badge" || n.type === "badge-checkbox"), d = m(() => ["default", "two-icons", "two-labels", "switch", "autocomplete", "secondary-text"].includes(n.type)), u = m(() => n.type === "flag"), f = m(() => n.type === "secondary-text"), b = m(() => n.type === "autocomplete"), h = m(() => !!n.badge && (n.type === "checkbox-badge" || b.value)), p = m(() => {
      if (!b.value || !n.highlight) return null;
      const se = mg(n.label ?? "", n.highlight);
      return se.match ? se : null;
    }), x = m(() => {
      var se;
      return n.type === "toggle" && !!((se = n.moreActions) != null && se.length);
    }), y = m(() => n.type === "checkbox" && l.value), w = m(() => {
      var se;
      return l.value ? "disabled" : ((se = n.badge) == null ? void 0 : se.theme) ?? "neutral";
    }), $ = m(() => n.as === "button" ? { type: "button", disabled: n.disabled || void 0, "aria-disabled": n.ariaDisabled ? "true" : void 0 } : { "aria-disabled": n.disabled || n.ariaDisabled ? "true" : void 0 }), S = R(!1), L = R(null), T = m(() => S.value || n.keyboardActive), E = m(() => T.value ? !0 : void 0), A = m(() => {
      var se;
      return T.value && !((se = L.value) != null && se.isTruncated) ? !0 : void 0;
    });
    function D(se) {
      if (se.target === se.currentTarget)
        try {
          S.value = se.target.matches(":focus-visible");
        } catch {
          S.value = !0;
        }
    }
    function M(se) {
      se.target === se.currentTarget && (S.value = !1);
    }
    const F = Nn(), X = m(() => {
      const se = { ...$.value, onFocusin: D, onFocusout: M };
      o.value && Object.assign(se, { "aria-labelledby": t, "aria-describedby": a });
      for (const Se of Object.keys(se)) se[Se] === void 0 && delete se[Se];
      return Oe(F, se);
    }), _ = ({ badge: se, theme: Se }) => [
      se && Kn(Ou, {
        label: se.label,
        theme: Se,
        leftIcon: se.icon,
        rightIcon: se.rightIcon,
        brandIcon: se.brandIcon,
        size: "sm",
        fitWidth: !0,
        class: "min-w-0 max-w-full",
        "aria-hidden": "true",
        "data-testid": "dropdown-list-item-badge"
      }),
      Kn("span", { class: "sr-only", "data-testid": "dropdown-list-item-badge-name" }, se == null ? void 0 : se.label)
    ];
    _.props = ["badge", "theme"];
    const Y = m(() => o.value ? "py-2" : b.value ? n.badge ? "py-1.5" : "py-2" : n.type === "switch" || n.type === "toggle" ? "py-[calc(--spacing(1.5)-1px)]" : n.type === "badge" || n.type === "badge-checkbox" || n.type === "checkbox-badge" ? "py-1" : "py-1.5"), B = m(() => l.value ? n.type === "two-labels" ? "text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)" : "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : r.value ? "text-(--colors-text-accent-strong)" : b.value ? "text-(--text-text-body) dark:text-(--colors-text-white-secondary)" : u.value ? n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)" : n.type === "toggle" || n.type === "switch" ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) group-hover:text-text-black-default dark:group-hover:text-text-black-default dark:text-(--colors-text-white-default)"), W = Wu, U = m(() => l.value ? "cursor-not-allowed" : "cursor-pointer"), z = m(() => [
      "group flex w-full min-w-0 min-h-8 items-center gap-1.5 text-left rounded-(--border-border-radius-rounded-sm) transition-colors",
      // With more actions the item element inside takes the start padding, the focus ring and the cursor.
      x.value ? "pe-2" : ["px-2", Y.value, W, U.value],
      B.value,
      !l.value && "hover:bg-background-hover dark:hover:bg-white/8",
      n.highlighted && !l.value && "bg-background-hover dark:bg-white/8",
      n.type === "toggle" && l.value && "bg-(--background-background-white)"
    ]), P = m(() => [
      "self-stretch ps-2 rounded-(--border-border-radius-rounded-sm)",
      Y.value,
      W,
      U.value
    ]), K = m(() => [
      "flex min-w-0 flex-1 items-center text-(length:--size-m) leading-(--line-height-l)",
      n.type === "checkbox-badge" ? "font-(--weight-regular)" : "font-(--weight-medium)",
      n.type === "toggle" ? "gap-2" : "gap-1.5"
    ]), j = m(() => {
      const se = "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)";
      return l.value ? "text-(--icons-icon-disabled-strong) dark:text-(--colors-text-disabled)" : n.danger ? se : r.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)";
    }), G = m(
      () => n.iconColor && !l.value && !n.danger && !r.value ? xg[n.iconColor] : j.value
    ), q = m(
      () => n.type === "two-labels" && r.value && !l.value ? "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)" : j.value
    ), J = m(() => {
      if (n.type === "two-icons") return r.value ? "ri-check-fill" : n.trailingIcon;
      if (n.type === "two-labels") return n.trailingIcon;
      if ((n.type === "default" || u.value || f.value) && r.value) return "ri-check-fill";
    }), me = m(() => [
      "min-w-0",
      n.labelWrap ? "break-words" : "flex",
      (n.type === "two-labels" || f.value) && "flex-1",
      !n.icon && n.danger && !l.value && "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)"
    ]), ye = m(() => [
      "shrink-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)",
      // Figma Left form Hover/Active turns the count to the label's black.
      l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--colors-text-body) dark:text-(--colors-text-white-secondary) group-hover:text-(--text-text-black-default) dark:group-hover:text-(--colors-text-white-default)"
    ]), Z = m(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)"), de = m(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : r.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)");
    function ge(se) {
      return se.startsWith("ri-");
    }
    return (se, Se) => (c(), H(lt(x.value ? "div" : e.as), Oe(x.value ? void 0 : X.value, { class: z.value }), {
      default: xe(() => [
        (c(), H(lt(x.value ? e.as : "div"), Oe({ "data-testid": "dropdown-list-item-content" }, x.value ? X.value : void 0, {
          class: x.value ? [K.value, P.value] : K.value
        }), {
          default: xe(() => [
            i.value ? (c(), g("span", tk, [
              re($n, {
                presentational: "",
                "model-value": e.checked,
                indeterminate: e.indeterminate,
                disabled: y.value
              }, null, 8, ["model-value", "indeterminate", "disabled"])
            ])) : k("", !0),
            e.type === "toggle" ? (c(), g(ce, { key: 1 }, [
              e.header ? (c(), g("span", nk)) : (c(), H(Ja, {
                key: 1,
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-toggle",
                "model-value": e.checked,
                disabled: l.value
              }, null, 8, ["model-value", "disabled"]))
            ], 64)) : k("", !0),
            u.value ? (c(), g("span", {
              key: 2,
              class: C(fk),
              "aria-hidden": "true",
              "data-testid": "dropdown-list-item-flag-box"
            }, [
              e.flag ? (c(), g("span", {
                key: 0,
                class: C(["fi", `fi-${e.flag.toLowerCase()}`, "fis", "rounded-full", "text-[13.33px]"]),
                "data-testid": "dropdown-list-item-flag"
              }, null, 2)) : k("", !0)
            ])) : k("", !0),
            d.value ? (c(), g(ce, { key: 3 }, [
              e.loading ? (c(), g("i", {
                key: 0,
                class: C(["dropdown-icon ri-loader-4-line animate-spin", po, j.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-icon"
              }, null, 2)) : b.value && e.avatar ? (c(), H(Mt, {
                key: 1,
                name: e.avatar.name,
                img: e.avatar.img,
                logo: e.avatar.logo ?? !1,
                size: "xs",
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-avatar"
              }, null, 8, ["name", "img", "logo"])) : e.icon ? (c(), g(ce, { key: 2 }, [
                ge(e.icon) ? (c(), g("i", {
                  key: 0,
                  class: C([e.icon, "dropdown-icon", po, G.value]),
                  "aria-hidden": "true",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 2)) : (c(), g("img", {
                  key: 1,
                  class: C(["dropdown-icon relative h-4 w-4 shrink-0 transition dark:invert dark:filter", [e.highlighted && "dark:invert-0", l.value ? "opacity-50" : "dark:group-hover:invert-0"]]),
                  src: e.icon,
                  alt: "",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 10, ak))
              ], 64)) : k("", !0)
            ], 64)) : k("", !0),
            o.value ? (c(), g("span", {
              key: 4,
              class: C(["flex min-w-0 flex-col gap-px", (e.type === "two-labels" || f.value) && "flex-1"])
            }, [
              v("span", {
                id: I(t),
                class: C(me.value),
                "data-testid": "dropdown-list-item-label"
              }, [
                s.value ? (c(), H(_, {
                  key: 0,
                  badge: e.badge,
                  theme: w.value
                }, null, 8, ["badge", "theme"])) : e.labelWrap ? (c(), g(ce, { key: 1 }, [
                  et(N(e.label), 1)
                ], 64)) : (c(), H(ht, {
                  key: 2,
                  ref_key: "labelRef",
                  ref: L,
                  text: e.label ?? "",
                  focusable: !1,
                  open: E.value
                }, null, 8, ["text", "open"]))
              ], 10, lk),
              v("span", {
                id: I(a),
                "data-testid": "dropdown-item-description",
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", !l.value && "text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"])
              }, N(e.description), 11, rk)
            ], 2)) : (c(), g("span", {
              key: 5,
              class: C(me.value),
              "data-testid": "dropdown-list-item-label"
            }, [
              s.value ? (c(), H(_, {
                key: 0,
                badge: e.badge,
                theme: w.value
              }, null, 8, ["badge", "theme"])) : p.value ? (c(), g("span", ok, [
                et(N(p.value.before), 1),
                v("span", ik, N(p.value.match), 1),
                et(N(p.value.after), 1)
              ])) : e.labelWrap ? (c(), g(ce, { key: 2 }, [
                et(N(e.label), 1)
              ], 64)) : (c(), H(ht, {
                key: 3,
                ref_key: "labelRef",
                ref: L,
                text: e.label ?? "",
                focusable: !1,
                open: E.value
              }, null, 8, ["text", "open"]))
            ], 2)),
            b.value && e.secondaryLabel ? (c(), g("span", {
              key: 6,
              class: C(["flex min-w-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)", !l.value && "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "dropdown-list-item-secondary-label"
            }, [
              re(ht, {
                text: e.secondaryLabel,
                focusable: !1,
                open: A.value
              }, null, 8, ["text", "open"])
            ], 2)) : k("", !0),
            f.value && (e.secondaryLabel || e.secondaryIcon) ? (c(), g("span", {
              key: 7,
              class: C(["flex min-w-0 max-w-1/2 shrink items-center justify-end gap-0.5 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", Z.value]),
              "data-testid": "dropdown-list-item-secondary"
            }, [
              e.secondaryIcon ? (c(), g("i", {
                key: 0,
                class: C([e.secondaryIcon, "size-3 shrink-0 text-(length:--size-sm) leading-(--size-sm) inline-flex items-center justify-center", de.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : k("", !0),
              e.secondaryLabel ? (c(), g("span", sk, [
                re(ht, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: A.value
                }, null, 8, ["text", "open"])
              ])) : k("", !0)
            ], 2)) : k("", !0),
            e.type === "two-labels" && e.secondaryLabel ? (c(), g(ce, { key: 8 }, [
              e.secondaryIcon ? (c(), g("i", {
                key: 0,
                class: C([e.secondaryIcon, po, j.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : k("", !0),
              v("span", dk, [
                re(ht, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: A.value
                }, null, 8, ["text", "open"])
              ])
            ], 64)) : k("", !0)
          ]),
          _: 1
        }, 16, ["class"])),
        e.type === "checkbox" && e.count !== void 0 && e.count !== "" ? (c(), g("span", {
          key: 0,
          class: C(ye.value),
          "data-testid": "dropdown-list-item-count"
        }, N(e.count), 3)) : k("", !0),
        h.value && e.badge ? (c(), g("span", uk, [
          re(_, {
            badge: e.badge,
            theme: w.value
          }, null, 8, ["badge", "theme"])
        ])) : k("", !0),
        e.type === "switch" ? (c(), H(Ja, {
          key: 2,
          presentational: "",
          class: "ms-auto shrink-0",
          "data-testid": "dropdown-list-item-toggle",
          "model-value": e.checked,
          disabled: l.value
        }, null, 8, ["model-value", "disabled"])) : k("", !0),
        J.value ? (c(), g("i", {
          key: 3,
          class: C([J.value, "ms-auto", po, q.value]),
          "aria-hidden": "true",
          "data-testid": "dropdown-list-item-trailing"
        }, null, 2)) : k("", !0),
        x.value ? (c(), g("span", ck, [
          re(ln, {
            items: e.moreActions,
            "menu-align": "right"
          }, {
            trigger: xe(({ triggerProps: V }) => [
              re(Be, Oe(V, {
                variant: "ghost",
                size: "xs",
                "icon-only": "",
                "icon-left": "ri-more-fill",
                "aria-label": e.moreActionsLabel,
                tabindex: e.moreActionsTabindex,
                "aria-disabled": l.value,
                "data-testid": "dropdown-list-item-more-actions-trigger"
              }), null, 16, ["aria-label", "tabindex", "aria-disabled"])
            ]),
            _: 1
          }, 8, ["items"])
        ])) : k("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), hk = ["role", "data-testid", "data-menu-label", "disabled", "aria-disabled", "aria-current", "aria-describedby"], bk = { class: "me-auto flex min-w-0 flex-col" }, gk = ["src"], mk = ["id"], yf = /* @__PURE__ */ ke({
  __name: "DropdownItemButton",
  props: {
    item: {},
    variant: { default: "default" },
    fallbackTestId: { default: "dropdown-item" },
    selectionStyle: { default: "highlight" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => !!(t.item.disabled || t.item.loading)), r = m(() => !!t.item.description), o = m(
      () => l.value && (!!t.item.tooltip || r.value)
    ), i = m(() => t.variant === "default" && !t.item.hasSwitch && t.item.active === !0), s = m(() => t.variant === "nav" ? "menuitem" : t.item.hasSwitch ? "menuitemcheckbox" : typeof t.item.active == "boolean" ? "menuitemradio" : "menuitem"), d = m(() => {
      if (s.value === "menuitemcheckbox") return !!t.item.switchChecked;
      if (s.value === "menuitemradio") return t.item.active === !0;
    }), u = m(
      () => t.item.danger && !l.value ? "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)" : void 0
    ), f = m(() => [
      Wu,
      // No vertical padding: a Figma Nav link is 20 high, rows 12 apart (pitch 32).
      "min-w-0 p-0",
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : [
        "cursor-pointer hover:text-(--text-text-hover)",
        t.item.active ? "text-(--text-text-link)" : "text-(--text-text-black-default)"
      ]
    ]), b = m(() => [
      "flex min-w-0 items-center gap-1.5 text-(length:--size-m) leading-(--line-height-l)",
      t.item.active ? "font-(--weight-semi-bold) underline" : "font-(--weight-semi-bold)",
      !l.value && "group-hover:font-(--weight-bold) group-hover:underline"
    ]), h = je(), p = m(() => t.variant === "nav" ? t.item.description : void 0), x = R(!1);
    function y(S) {
      try {
        x.value = S.target.matches(":focus-visible");
      } catch {
        x.value = !0;
      }
    }
    function w() {
      l.value || a("click", t.item);
    }
    function $(S) {
      return S.startsWith("ri-");
    }
    return (S, L) => e.variant === "default" ? (c(), H(Kt, {
      key: 0,
      as: "button",
      type: e.item.hasSwitch ? "switch" : "default",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      label: e.item.label,
      icon: e.item.icon,
      description: e.item.description,
      checked: !!e.item.switchChecked,
      selected: i.value && e.selectionStyle === "check",
      highlighted: i.value && e.selectionStyle === "highlight",
      disabled: l.value && !o.value,
      "aria-disabled": o.value,
      loading: e.item.loading,
      danger: e.item.danger,
      "aria-checked": d.value,
      "label-wrap": "",
      onClick: w
    }, null, 8, ["type", "role", "data-testid", "data-menu-label", "label", "icon", "description", "checked", "selected", "highlighted", "disabled", "aria-disabled", "loading", "danger", "aria-checked"])) : (c(), g("button", {
      key: 1,
      type: "button",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      disabled: o.value ? void 0 : l.value,
      "aria-disabled": o.value ? "true" : void 0,
      "aria-current": e.item.active ? "true" : void 0,
      "aria-describedby": p.value ? I(h) : void 0,
      class: C(["group inline-flex w-full items-center text-left rounded-(--border-border-radius-rounded-sm) transition-colors", f.value]),
      onFocusin: y,
      onFocusout: L[0] || (L[0] = (T) => x.value = !1),
      onClick: w
    }, [
      v("div", bk, [
        v("div", {
          "data-testid": "dropdown-item-label-row",
          class: C(b.value)
        }, [
          e.item.loading ? (c(), g("i", {
            key: 0,
            class: C(["dropdown-icon ri-loader-4-line animate-spin text-(length:--size-xl) leading-(--line-height-m) size-4.5 inline-flex items-center justify-center shrink-0", u.value]),
            "aria-hidden": "true"
          }, null, 2)) : e.item.icon ? (c(), g(ce, { key: 1 }, [
            $(e.item.icon) ? (c(), g("i", {
              key: 0,
              class: C([e.item.icon, "dropdown-icon text-(length:--size-xl) leading-(--line-height-m) size-4.5 inline-flex items-center justify-center shrink-0", u.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              class: C(["dropdown-icon relative size-4.5 shrink-0 transition dark:invert dark:filter dark:group-hover:invert-0", e.item.active && "dark:invert-0"]),
              src: e.item.icon,
              alt: ""
            }, null, 10, gk))
          ], 64)) : k("", !0),
          re(ht, {
            text: e.item.label,
            focusable: !1,
            open: x.value || void 0,
            "text-class": e.item.icon ? void 0 : u.value
          }, null, 8, ["text", "open", "text-class"])
        ], 2),
        p.value ? (c(), g("span", {
          key: 0,
          id: I(h),
          "data-testid": "dropdown-item-helper",
          "aria-hidden": "true",
          class: "min-w-0 text-(length:--size-sm) leading-(--line-height-m) font-(--weight-regular) text-(--text-text-body-subtle)"
        }, N(p.value), 9, mk)) : k("", !0)
      ])
    ], 42, hk));
  }
}), vo = /* @__PURE__ */ ke({
  __name: "DropdownMenuItem",
  props: {
    item: {},
    variant: {},
    fallbackTestId: {},
    selectionStyle: {},
    tooltipRef: { type: Function }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => e.item.tooltip ? (c(), H(ft, {
      key: 0,
      ref: e.tooltipRef,
      text: e.item.tooltip,
      class: "w-full"
    }, {
      default: xe(() => [
        re(yf, {
          item: e.item,
          variant: e.variant,
          "fallback-test-id": e.fallbackTestId,
          "selection-style": e.selectionStyle,
          onClick: t[0] || (t[0] = (a) => n.$emit("click", e.item))
        }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"])
      ]),
      _: 1
    }, 8, ["text"])) : (c(), H(yf, {
      key: 1,
      item: e.item,
      variant: e.variant,
      "fallback-test-id": e.fallbackTestId,
      "selection-style": e.selectionStyle,
      onClick: t[1] || (t[1] = (a) => n.$emit("click", e.item))
    }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"]));
  }
}), pk = {}, vk = {
  class: "w-full py-1",
  "data-testid": "dropdown-separator",
  "aria-hidden": "true"
};
function xk(e, n) {
  return c(), g("div", vk, [...n[0] || (n[0] = [
    v("div", { class: "border-t border-(--border-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)
  ])]);
}
const kf = /* @__PURE__ */ ot(pk, [["render", xk]]);
function Ma(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function qu(e, n) {
  return Ma(e).includes(Ma(n.trim()));
}
function yk(e) {
  return typeof e.getModifierState == "function" && e.getModifierState("AltGraph") ? !0 : e.ctrlKey && e.altKey;
}
function Uu(e = 500) {
  const n = R("");
  let t = null;
  function a() {
    n.value = "", t && (clearTimeout(t), t = null);
  }
  function l() {
    t && clearTimeout(t), t = setTimeout(a, e);
  }
  gt(() => {
    t && clearTimeout(t);
  });
  function r(o) {
    if (o.repeat) return !1;
    if (o.key === "Backspace")
      return n.value ? (n.value = n.value.slice(0, -1), n.value ? l() : a(), !0) : !1;
    if (o.isComposing) return !1;
    const i = yk(o);
    return o.key.length !== 1 || o.metaKey || o.ctrlKey && !i || o.altKey && !i ? !1 : (n.value += o.key, l(), !0);
  }
  return { query: n, handleKey: r, reset: a };
}
const kk = {
  key: 0,
  class: "flex items-center"
}, wk = { class: "flex items-center gap-0.5" }, Ck = { class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)" }, Sk = {
  key: 0,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, $k = ["id", "aria-expanded", "aria-label"], Ik = {
  key: 1,
  class: "flex items-center gap-1.5 px-3 py-1 text-(length:--size-sm) leading-(--line-height-l)"
}, Tk = ["src"], Lk = {
  key: 1,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, Ak = ["title"], Ek = ["src"], Rk = ["src"], Bk = ["role", "aria-labelledby", "aria-label", "data-focus-trap-return"], Dk = {
  key: 0,
  class: "flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--colors-background-white-secondary) p-2 px-3"
}, Mk = { class: "flex min-w-0 flex-1 flex-col gap-0.5 text-(length:--size-m) leading-(--line-height-l)" }, zk = { class: "truncate font-(--weight-semi-bold) text-(--colors-text-heading)" }, Ok = { class: "truncate font-(--weight-regular) text-(--colors-text-body)" }, Pk = {
  key: 1,
  class: "absolute top-3 right-3"
}, Fk = {
  key: 2,
  role: "presentation",
  "data-testid": "dropdown-menu-header",
  class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, Vk = ["id"], Nk = { class: "overflow-y-auto flex-1 min-h-0 pr-[calc(var(--spacing-6)-1px)] -my-0.5 -ml-0.5 py-0.5 pl-0.5" }, Hk = {
  key: 0,
  "data-testid": "dropdown-megamenu-col-header",
  role: "presentation",
  class: "leading-(--line-height-l) font-(--weight-semi-bold) text-(length:--size-sm) text-(--colors-text-body-subtle)"
}, jk = {
  key: 1,
  class: "flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-5"
}, Wk = ["role", "aria-label"], qk = { class: "w-full" }, $s = 5, ln = /* @__PURE__ */ ke({
  __name: "Dropdown",
  props: {
    label: { default: "Dropdown" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    triggerIconInfo: { default: void 0 },
    triggerIconInfoTooltip: { default: void 0 },
    items: { default: () => [] },
    groups: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    menuWidth: { default: "auto" },
    fullWidth: { type: Boolean, default: !1 },
    menuAlign: { default: "left" },
    fieldLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    ghost: { type: Boolean, default: !1 },
    tab: { type: Boolean, default: !1 },
    profileType: { default: void 0 },
    ariaLabel: { default: void 0 },
    menuHeader: { default: void 0 },
    bare: { type: Boolean, default: !1 },
    menuItemVariant: { default: "default" },
    selectionStyle: { default: "highlight" },
    columns: { default: void 0 },
    closeable: { type: Boolean, default: !1 },
    closeLabel: { default: void 0 },
    menuOffset: { default: 4 },
    menuReference: { default: null },
    menuSide: { default: "bottom" }
  },
  setup(e, { expose: n }) {
    const t = e, a = m(() => {
      var O;
      if (t.ariaLabel) return t.ariaLabel;
      if (t.avatar) {
        const ne = (O = t.avatar.name) == null ? void 0 : O.trim();
        return ne ? `Open account menu, ${ne}` : "Open account menu";
      }
    }), l = (O) => {
      var ne;
      ((ne = O.currentTarget) == null ? void 0 : ne.getAttribute("aria-disabled")) !== "true" && !r.value && (O.key === "ArrowDown" || O.key === "ArrowUp") && (O.preventDefault(), r.value = !0);
    }, r = R(t.defaultOpen), o = R(null), i = R(null), s = R(null), d = R(null), u = m(() => !t.tab && !t.avatar), f = () => {
      var O;
      return ((O = s.value) == null ? void 0 : O.$el) ?? i.value;
    }, b = je(), h = je(), p = R(void 0), x = () => {
      r.value = !r.value;
    }, y = () => {
      r.value = !1;
    }, w = m(() => ({
      id: h,
      "aria-haspopup": "menu",
      "aria-expanded": r.value,
      onClick: x,
      onKeydown: l
    })), $ = (O) => {
      var te, oe;
      const ne = O.target, fe = ((te = d.value) == null ? void 0 : te.contains(ne)) ?? !1, ue = ((oe = o.value) == null ? void 0 : oe.contains(ne)) ?? !1;
      !fe && !ue && y();
    };
    dt(() => document.addEventListener("mousedown", $)), gt(() => document.removeEventListener("mousedown", $));
    let S = null;
    const L = () => {
      const O = t.menuReference ?? f() ?? d.value;
      if (!O || !o.value) return;
      S == null || S.destroy();
      const ne = t.menuSide, fe = ne === "top" ? "bottom" : "top", ue = t.menuAlign === "right" ? "end" : "start", te = t.menuAlign === "right" ? "start" : "end";
      S = ja(O, o.value, {
        strategy: "fixed",
        placement: `${ne}-${ue}`,
        modifiers: [
          { name: "offset", options: { offset: [0, t.menuOffset] } },
          { name: "flip", options: { fallbackPlacements: [`${ne}-${te}`, `${fe}-${ue}`, `${fe}-${te}`] } },
          { name: "preventOverflow", options: { padding: 8 } },
          // Disable GPU acceleration so Popper uses top/left instead of transform,
          // avoiding conflict with the Vue Transition's transform: scale(...)
          { name: "computeStyles", options: { gpuAcceleration: !1 } }
        ]
      });
    };
    let T = null;
    const E = () => {
      T == null || T.disconnect(), !(!t.menuReference || typeof ResizeObserver > "u") && (T ?? (T = new ResizeObserver(() => S == null ? void 0 : S.update())), T.observe(t.menuReference));
    }, A = () => {
      S == null || S.destroy(), S = null, T == null || T.disconnect();
    };
    $e(
      () => [t.menuReference, t.menuSide, t.menuAlign, t.menuOffset],
      () => {
        r.value && (L(), E());
      }
    ), $e(r, async (O) => {
      var ne;
      O ? (de = !1, p.value = ((ne = Se()) == null ? void 0 : ne.id) || void 0, await Ue(), L(), E(), M()) : (F.reset(), A());
    }), dt(() => {
      var O;
      r.value && (p.value = ((O = Se()) == null ? void 0 : O.id) || void 0, Ue(L));
    }), gt(() => A());
    const D = () => o.value ? Array.from(
      o.value.querySelectorAll(
        '[role="menuitem"]:not([disabled]), [role="menuitemradio"]:not([disabled]), [role="menuitemcheckbox"]:not([disabled])'
      )
    ) : [], M = () => {
      Ue(() => {
        var ne;
        const O = D();
        (ne = O.find((fe) => fe.getAttribute("role") === "menuitemradio" && fe.getAttribute("aria-checked") === "true") ?? O[0]) == null || ne.focus();
      });
    }, F = Uu(), X = (O, ne) => {
      const fe = Ma(F.query.value), ue = fe.length === 1 ? ne + 1 : ne;
      for (let te = 0; te < O.length; te++) {
        const oe = O[(ue + te) % O.length];
        if (Ma(oe.dataset.menuLabel ?? oe.textContent ?? "").trim().startsWith(fe)) {
          oe.focus();
          return;
        }
      }
    }, _ = (O) => {
      var fe;
      const ne = D();
      (fe = ne[Math.max(0, Math.min(O, ne.length - 1))]) == null || fe.focus();
    }, Y = (O) => {
      if (!r.value) {
        O.key === "Tab" && V();
        return;
      }
      const ne = D(), fe = document.activeElement, ue = ne.indexOf(fe);
      if (ue !== -1 && !(O.key === " " && !F.query.value) && F.handleKey(O)) {
        O.preventDefault(), X(ne, ue);
        return;
      }
      switch (O.key) {
        case "ArrowDown":
          O.preventDefault(), _(ue < ne.length - 1 ? ue + 1 : 0);
          break;
        case "ArrowUp":
          O.preventDefault(), _(ue > 0 ? ue - 1 : ne.length - 1);
          break;
        case "Home":
          O.preventDefault(), _(0);
          break;
        case "End":
          O.preventDefault(), _(ne.length - 1);
          break;
        case "Escape":
          z(O);
          break;
        case "Tab":
          V(), y();
          break;
      }
    }, B = /* @__PURE__ */ new Map(), W = (O) => (ne) => {
      ne ? B.set(O, ne) : B.delete(O);
    }, U = () => {
      for (const O of B.values())
        if (O.isVisible) return O;
    }, z = (O) => {
      O.stopPropagation(), O.preventDefault();
      const ne = U();
      if (ne) {
        ne.hide();
        return;
      }
      ge();
    }, P = (O) => {
      r.value && z(O);
    }, K = m(() => {
      var ne;
      if (!t.columns || !((ne = t.groups) != null && ne.length)) return null;
      const O = t.groups.filter((fe) => fe.items.length > 0);
      return O.length > 0 ? O : null;
    }), j = m(
      () => K.value ? Math.min(K.value.length, t.columns ?? K.value.length) : 0
    ), G = m(() => {
      var ne;
      if (t.columns || !((ne = t.groups) != null && ne.length)) return null;
      const O = t.groups.filter((fe) => fe.items.length > 0);
      return O.length > 0 ? O : null;
    }), q = m(() => {
      if (!t.columns || K.value) return null;
      const O = Math.max(1, t.columns), ne = Math.min(O, Math.max(1, Math.ceil(t.items.length / $s))), fe = t.items.length > $s * O ? Math.ceil(t.items.length / O) : $s, ue = Array.from({ length: ne }, () => []);
      return t.items.forEach((te, oe) => {
        var Le;
        (Le = ue[Math.min(Math.floor(oe / fe), ne - 1)]) == null || Le.push(te);
      }), ue.filter((te) => te.length > 0);
    }), J = m(() => {
      var O;
      return K.value ? j.value : ((O = q.value) == null ? void 0 : O.length) ?? 0;
    }), me = m(() => J.value > 2), ye = m(() => !!(K.value || q.value)), Z = (O) => {
      O.disabled || O.loading || (O.onClick && O.onClick(), (!O.hasSwitch || t.menuItemVariant === "nav") && ge());
    };
    let de = !1;
    const ge = () => {
      de = !0, y();
    }, se = () => {
      if (!de) return;
      de = !1;
      const O = document.activeElement;
      O && O !== document.body || V();
    }, Se = () => {
      var O;
      return f() ?? ((O = d.value) == null ? void 0 : O.querySelector('button, [tabindex="0"], [tabindex]:not([tabindex="-1"])'));
    }, V = () => {
      var O;
      return (O = Se()) == null ? void 0 : O.focus();
    }, Q = m(() => t.menuSide === "top" ? t.menuAlign === "right" ? "origin-bottom-right" : "origin-bottom-left" : t.menuAlign === "right" ? "origin-top-right" : "origin-top-left"), le = m(() => {
      var O;
      return t.fullWidth ? { width: `${((O = d.value) == null ? void 0 : O.offsetWidth) ?? 0}px` } : t.menuWidth !== "auto" ? { width: t.menuWidth } : t.columns || t.bare ? {} : { minWidth: "208px", maxWidth: "320px" };
    }), ee = (O) => !!O && O.startsWith("ri-");
    return n({ isOpen: r, close: y }), (O, ne) => (c(), g("div", {
      class: C(["text-text-black-default relative text-left dark:text-(--colors-text-white-default)", [e.tab ? "flex h-full items-stretch" : "inline-block", { "w-full": e.fullWidth }]]),
      onKeydown: ut(P, ["escape"])
    }, [
      e.fieldLabel ? (c(), g("div", kk, [
        v("div", wk, [
          v("div", Ck, N(e.fieldLabel), 1),
          e.required ? (c(), g("div", Sk, " * ")) : k("", !0)
        ])
      ])) : k("", !0),
      v("div", {
        class: C(["text-text-black-default relative flex flex-col items-start text-left dark:text-(--colors-text-white-default)", { "w-full": e.fullWidth, "h-full": e.tab }])
      }, [
        v("div", {
          ref_key: "triggerWrapperRef",
          ref: d,
          class: C({ "w-full": e.fullWidth, "h-full": e.tab })
        }, [
          Ae(O.$slots, "trigger", {
            toggle: x,
            isOpen: r.value,
            triggerProps: w.value
          }, () => [
            u.value ? (c(), H(Be, Oe({
              key: 0,
              ref_key: "triggerButtonRef",
              ref: s,
              "data-testid": "dropdown-trigger",
              size: "xs",
              variant: e.ghost ? "ghost" : "secondary",
              label: e.label,
              "icon-left": e.triggerIconLeft,
              "icon-right": e.triggerIcon,
              "dropdown-icon": !!e.label && !e.triggerIcon,
              "icon-only": !e.label,
              "aria-label": e.ariaLabel,
              "full-width": e.fullWidth
            }, w.value), null, 16, ["variant", "label", "icon-left", "icon-right", "dropdown-icon", "icon-only", "aria-label", "full-width"])) : (c(), g("button", {
              key: 1,
              id: I(h),
              ref_key: "triggerRef",
              ref: i,
              type: "button",
              "data-testid": "dropdown-trigger",
              class: C(["focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue z-0 cursor-pointer transition-colors", [
                e.tab ? "focus-visible:ring-inset shrink-0 h-full flex items-center rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10 duration-200" : [
                  "focus-visible:ring-offset-2 rounded-(--border-border-radius-rounded-full) border border-solid duration-300",
                  "border-border-secondary-button hover:border-royalblue bg-white dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
                ],
                {
                  "w-full justify-between": e.fullWidth,
                  "justify-center": !e.fullWidth && !e.tab
                }
              ]]),
              "aria-expanded": r.value,
              "aria-haspopup": "menu",
              "aria-label": a.value,
              onClick: x,
              onKeydown: l
            }, [
              t.avatar ? (c(), H(Mt, {
                key: 0,
                presentational: "",
                as: "span",
                name: t.avatar.name,
                img: t.avatar.img
              }, null, 8, ["name", "img"])) : (c(), g("div", Ik, [
                e.triggerIconLeft ? (c(), g(ce, { key: 0 }, [
                  ee(e.triggerIconLeft) ? (c(), g("i", {
                    key: 0,
                    class: C([e.triggerIconLeft, "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"])
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4",
                    src: e.triggerIconLeft,
                    alt: ""
                  }, null, 8, Tk))
                ], 64)) : k("", !0),
                e.label ? (c(), g("div", Lk, N(e.label), 1)) : k("", !0),
                e.triggerIconInfo ? (c(), g("span", {
                  key: 2,
                  class: "inline-flex items-center",
                  title: e.triggerIconInfoTooltip,
                  onClick: ne[0] || (ne[0] = Ye(() => {
                  }, ["stop"]))
                }, [
                  ee(e.triggerIconInfo) ? (c(), g("i", {
                    key: 0,
                    class: C([e.triggerIconInfo, "dropdown-icon text-(length:--size-xl) leading-(--size-xl) size-(--size-xl) inline-flex items-center justify-center"])
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4.5 w-4.5",
                    src: e.triggerIconInfo,
                    alt: ""
                  }, null, 8, Ek))
                ], 8, Ak)) : k("", !0),
                e.triggerIcon ? (c(), g(ce, { key: 3 }, [
                  ee(e.triggerIcon) ? (c(), g("i", {
                    key: 0,
                    class: C([
                      e.triggerIcon,
                      "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center transition-transform duration-200 ease-in-out"
                    ]),
                    style: Ne({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" })
                  }, null, 6)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4 transition-transform duration-200 ease-in-out",
                    style: Ne({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" }),
                    src: e.triggerIcon,
                    alt: ""
                  }, null, 12, Rk))
                ], 64)) : e.label ? (c(), g("svg", {
                  key: 4,
                  class: "relative h-4 w-4 transition-transform duration-200 ease-in-out",
                  style: Ne({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" }),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [...ne[1] || (ne[1] = [
                  v("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 4)) : k("", !0)
              ]))
            ], 42, $k))
          ])
        ], 2),
        (c(), H(Dn, { to: "body" }, [
          re(wt, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0",
            onAfterLeave: se
          }, {
            default: xe(() => [
              r.value ? (c(), g("div", {
                key: 0,
                ref_key: "menuRef",
                ref: o,
                role: e.bare ? void 0 : "menu",
                "aria-labelledby": ye.value ? I(b) : e.bare ? void 0 : p.value,
                "aria-label": e.bare || ye.value ? void 0 : e.ariaLabel,
                "data-focus-trap-return": p.value,
                "data-testid": "dropdown-menu",
                "data-focus-trap-allow-outside": "",
                class: C(["fixed z-[350]", [
                  ye.value ? I(Qy) : I(Wa),
                  I(ju),
                  Q.value,
                  ye.value && "relative flex flex-col pt-[calc(var(--spacing-6)-1px)] pb-[calc(var(--spacing-6)-1px)] pl-[calc(var(--spacing-6)-1px)] max-h-[calc(100vh-90px)] max-w-[calc(100vw-32px)]",
                  !e.bare && !ye.value && [I(vg), "max-h-[min(400px,calc(100vh-24px))] items-start overflow-y-auto"],
                  e.bare && "max-h-[calc(100vh-90px)] overflow-y-auto"
                ]]),
                style: Ne(le.value),
                onKeydown: Y
              }, [
                t.avatar ? (c(), g("div", Dk, [
                  re(Mt, {
                    name: t.avatar.name,
                    img: t.avatar.img,
                    presentational: ""
                  }, null, 8, ["name", "img"]),
                  v("div", Mk, [
                    v("div", zk, N(t.avatar.name), 1),
                    v("div", Ok, N(t.avatar.email), 1)
                  ]),
                  t.profileType ? (c(), H(ct, {
                    key: 0,
                    class: "ms-auto",
                    theme: "white",
                    size: "sm",
                    label: t.profileType
                  }, null, 8, ["label"])) : k("", !0)
                ])) : k("", !0),
                e.closeable ? (c(), g("div", Pk, [
                  re(Be, {
                    "data-testid": "dropdown-close",
                    variant: "ghost",
                    "icon-only": "",
                    size: "sm",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.closeLabel,
                    onClick: y
                  }, null, 8, ["aria-label"])
                ])) : k("", !0),
                e.menuHeader && !t.avatar && !ye.value ? (c(), g("div", Fk, N(e.menuHeader), 1)) : k("", !0),
                Ae(O.$slots, "menu", { close: y }, () => [
                  ye.value ? (c(), g(ce, { key: 0 }, [
                    v("div", {
                      class: C(["mb-5", e.closeable ? "pr-[calc(var(--spacing-16)-1px)]" : "pr-[calc(var(--spacing-6)-1px)]"])
                    }, [
                      v("h5", {
                        id: I(b),
                        class: "text-(length:--size-xl) font-(--weight-semi-bold)",
                        style: { color: "var(--text-text-black-default)", "line-height": "var(--line-height-xl)" }
                      }, N(e.menuHeader), 9, Vk)
                    ], 2),
                    v("div", Nk, [
                      K.value ? (c(), g("div", {
                        key: 0,
                        "data-testid": "dropdown-megamenu-groups",
                        class: "grid grid-cols-1 gap-y-3 sm:grid-cols-[repeat(var(--dropdown-megamenu-cols),minmax(0,var(--dropdown-megamenu-col-w)))] sm:gap-x-5",
                        style: Ne({
                          "--dropdown-megamenu-cols": j.value,
                          "--dropdown-megamenu-col-w": me.value ? "240px" : "275px"
                        })
                      }, [
                        (c(!0), g(ce, null, Re(K.value, (fe) => (c(), g("div", {
                          key: fe.key,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3 min-w-0"
                        }, [
                          fe.label ? (c(), g("div", Hk, N(fe.label), 1)) : k("", !0),
                          (c(!0), g(ce, null, Re(fe.items, (ue, te) => (c(), H(vo, {
                            key: te,
                            item: ue,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": W(`${fe.key}-${te}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (oe) => Z(ue)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ]))), 128))
                      ], 4)) : (c(), g("div", jk, [
                        (c(!0), g(ce, null, Re(q.value, (fe, ue) => (c(), g("div", {
                          key: ue,
                          "data-testid": "dropdown-megamenu-col",
                          class: C(["flex flex-col items-start gap-3 w-full shrink-0 sm:shrink sm:min-w-0", me.value ? "sm:w-60" : "sm:w-68.75"])
                        }, [
                          (c(!0), g(ce, null, Re(fe, (te, oe) => (c(), H(vo, {
                            key: oe,
                            item: te,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": W(`col-${ue}-${oe}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (Le) => Z(te)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ], 2))), 128))
                      ]))
                    ])
                  ], 64)) : G.value ? (c(!0), g(ce, { key: 1 }, Re(G.value, (fe, ue) => (c(), g(ce, {
                    key: fe.key
                  }, [
                    ue > 0 ? (c(), H(kf, { key: 0 })) : k("", !0),
                    v("div", {
                      class: "flex w-full flex-col gap-1.5",
                      role: fe.items.length > 1 && fe.label ? "group" : void 0,
                      "aria-label": fe.items.length > 1 && fe.label ? fe.label : void 0
                    }, [
                      (c(!0), g(ce, null, Re(fe.items, (te, oe) => (c(), H(vo, {
                        key: oe,
                        item: te,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": W(`group-${fe.key}-${oe}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (Le) => Z(te)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                    ], 8, Wk)
                  ], 64))), 128)) : (c(!0), g(ce, { key: 2 }, Re(e.items, (fe, ue) => (c(), g(ce, { key: ue }, [
                    v("div", qk, [
                      re(vo, {
                        item: fe,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": W(`flat-${ue}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (te) => Z(fe)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"])
                    ]),
                    fe.hasDividerAfter && ue < e.items.length - 1 ? (c(), H(kf, { key: 0 })) : k("", !0)
                  ], 64))), 128))
                ])
              ], 46, Bk)) : k("", !0)
            ]),
            _: 3
          })
        ]))
      ], 2)
    ], 34));
  }
}), yg = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LinkBase",
  props: {
    as: { default: "button" },
    iconLeft: {},
    iconRight: {},
    size: { default: "m" },
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: [Boolean, String], default: !1 },
    underline: {}
  },
  setup(e) {
    const n = e, t = m(() => n.disabled && n.as === "button"), a = m(() => !!n.ariaDisabled && n.ariaDisabled !== "false"), l = m(() => n.disabled || a.value), r = Nn();
    function o() {
      const b = l.value ? gg(r) : r;
      return { ...n.as === "button" ? { type: "button" } : {}, ...b };
    }
    const i = {
      s: "text-(length:--size-sm) leading-(--line-height-l)",
      m: "text-(length:--size-m) leading-(--line-height-l)",
      l: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, s = m(() => [
      "group/link inline-flex items-center gap-1.5 py-0.5 font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      i[n.size],
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : "cursor-pointer text-(--text-text-link) hover:text-(--text-text-hover)"
    ]), d = m(() => [
      "text-num-16",
      l.value ? "text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-link) group-hover/link:text-(--icons-icon-hover)"
    ]), u = m(() => n.underline === "always" ? "underline" : l.value ? "" : "group-hover/link:underline group-focus-visible/link:underline");
    function f(b) {
      l.value && b.preventDefault();
    }
    return (b, h) => (c(), H(lt(e.as), Oe(o(), {
      "aria-label": e.ariaLabel,
      disabled: t.value || void 0,
      "aria-disabled": l.value && !t.value ? "true" : void 0,
      class: s.value,
      onClickCapture: f,
      onAuxclickCapture: f
    }), {
      default: xe(() => [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C([e.iconLeft, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : k("", !0),
        v("span", {
          class: C(u.value)
        }, [
          Ae(b.$slots, "default")
        ], 2),
        e.iconRight ? (c(), g("i", {
          key: 1,
          class: C([e.iconRight, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : k("", !0)
      ]),
      _: 3
    }, 16, ["aria-label", "disabled", "aria-disabled", "class"]));
  }
}), In = /* @__PURE__ */ ke({
  __name: "TextLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), H(yg, Oe(n, { underline: "hover" }), {
      default: xe(() => [
        Ae(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), kg = /* @__PURE__ */ ke({
  __name: "FieldLabelTooltip",
  props: {
    text: {}
  },
  setup(e) {
    return (n, t) => (c(), H(ft, {
      as: "span",
      text: e.text,
      class: "shrink-0",
      "data-field-label-tooltip": "",
      tabindex: "0",
      role: "group",
      "aria-label": e.text
    }, {
      default: xe(() => [...t[0] || (t[0] = [
        v("i", {
          class: "ri-information-line inline-flex size-3.5 shrink-0 items-center justify-center cursor-help text-(length:--size-m) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
          "aria-hidden": "true"
        }, null, -1)
      ])]),
      _: 1
    }, 8, ["text", "aria-label"]));
  }
}), Uk = {
  key: 1,
  class: "sr-only"
}, yt = /* @__PURE__ */ ke({
  __name: "FieldLabel",
  props: {
    text: {},
    inputId: { default: void 0 },
    id: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    tooltip: { default: void 0 },
    focused: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    testId: { default: void 0 },
    secondaryText: { default: void 0 },
    secondaryPosition: { default: "right" },
    textClass: { default: void 0 },
    as: { default: "div" }
  },
  setup(e, { expose: n }) {
    const t = e, a = R(null), l = R(!1), r = m(() => l.value ? !1 : t.focused ? !0 : void 0);
    $e(
      () => t.focused,
      (d) => {
        d || (l.value = !1);
      }
    ), n({ handleFieldKeydown: (d) => {
      var u;
      d.key !== "Escape" || l.value || !t.focused || !((u = a.value) != null && u.isTruncated) || (d.stopPropagation(), d.preventDefault(), l.value = !0);
    } });
    const i = m(
      () => t.textClass ?? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)"
    ), s = m(() => t.secondaryText && t.secondaryPosition === "below" ? [
      "grid min-w-0 max-w-full grid-cols-[minmax(0,auto)_auto] items-center justify-start gap-1",
      t.inline ? "shrink-0" : ""
    ] : [
      "flex min-w-0 max-w-full items-center gap-1",
      t.inline ? "shrink-0" : "",
      t.secondaryText && !t.inline ? "w-full" : ""
    ]);
    return (d, u) => (c(), H(lt(e.as), {
      class: C(s.value)
    }, {
      default: xe(() => [
        (c(), H(lt(e.inputId ? "label" : "span"), {
          id: e.id,
          for: e.inputId,
          "data-testid": e.testId,
          class: "flex min-w-0 items-center text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
        }, {
          default: xe(() => [
            re(ht, {
              ref_key: "labelRef",
              ref: a,
              text: e.text,
              lines: 1,
              "text-class": i.value,
              focusable: !1,
              open: r.value
            }, null, 8, ["text", "text-class", "open"]),
            e.required ? (c(), g("span", {
              key: 0,
              class: C(["shrink-0 whitespace-pre", i.value])
            }, N(` ${e.requiredIndicator}`), 3)) : k("", !0),
            e.secondaryText ? (c(), g("span", Uk, N(` ${e.secondaryText}`), 1)) : k("", !0)
          ]),
          _: 1
        }, 8, ["id", "for", "data-testid"])),
        e.tooltip ? (c(), H(kg, {
          key: 0,
          text: e.tooltip
        }, null, 8, ["text"])) : k("", !0),
        e.secondaryText ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.secondaryPosition === "below" ? "col-span-full min-w-0 break-words" : "ml-auto shrink-0 whitespace-nowrap"
          ])
        }, N(e.secondaryText), 3)) : k("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Gk = ["data-type"], Kk = ["id"], ul = /* @__PURE__ */ ke({
  __name: "DropdownPanelFooter",
  props: {
    type: {},
    buttons: { default: () => {
    } },
    label: { default: () => {
    } },
    seeAllLabel: { default: () => {
    } },
    createLabel: { default: () => {
    } },
    createIcon: { default: "ri-add-line" },
    seeAllOption: { default: () => {
    } },
    createOption: { default: () => {
    } },
    description: { default: () => {
    } }
  },
  emits: ["button-click", "see-all", "create", "option-hover"],
  setup(e, { emit: n }) {
    const t = je(), a = (r, o) => r ? {
      id: r.id,
      role: "option",
      "aria-selected": !!r.active,
      "aria-label": o,
      "data-testid": r.testId,
      class: [
        "w-full rounded-(--border-border-radius-rounded-full)",
        r.active && "shadow-(--shadow-focus-l)"
      ]
    } : { class: "contents" }, l = n;
    return (r, o) => (c(), g("div", {
      "data-testid": "dropdown-panel-footer",
      "data-type": e.type,
      class: C([
        "relative flex flex-col gap-1.5 rounded-b-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        e.label ? "items-start" : ""
      ])
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        text: e.label,
        "test-id": "dropdown-panel-footer-label"
      }, null, 8, ["text"])) : k("", !0),
      e.type === "see-all-create" ? (c(), g(ce, { key: 1 }, [
        e.seeAllLabel ? (c(), g("div", Oe({ key: 0 }, a(e.seeAllOption, e.seeAllLabel), {
          onMouseenter: o[1] || (o[1] = (i) => e.seeAllOption && l("option-hover", "see-all"))
        }), [
          re(Be, {
            variant: "secondary",
            size: "md",
            "icon-left": "ri-eye-line",
            label: e.seeAllLabel,
            "full-width": "",
            tabindex: e.seeAllOption ? -1 : void 0,
            "aria-hidden": e.seeAllOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-see-all",
            onClick: o[0] || (o[0] = (i) => l("see-all"))
          }, null, 8, ["label", "tabindex", "aria-hidden"])
        ], 16)) : k("", !0),
        e.createLabel ? (c(), g("div", Oe({ key: 1 }, a(e.createOption, e.createLabel), {
          onMouseenter: o[3] || (o[3] = (i) => e.createOption && l("option-hover", "create"))
        }), [
          re(In, {
            size: "m",
            "icon-left": e.createIcon,
            class: "w-full justify-center",
            tabindex: e.createOption ? -1 : void 0,
            "aria-hidden": e.createOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-create",
            onClick: o[2] || (o[2] = (i) => l("create"))
          }, {
            default: xe(() => [
              et(N(e.createLabel), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "tabindex", "aria-hidden"])
        ], 16)) : k("", !0)
      ], 64)) : e.buttons ? (c(), g("div", {
        key: 2,
        "data-testid": "dropdown-panel-footer-buttons",
        class: C(e.type === "buttons-inline" ? "flex w-full gap-1.5" : "flex w-full flex-col gap-3")
      }, [
        (c(!0), g(ce, null, Re(e.buttons, (i, s) => (c(), H(Be, {
          key: s,
          variant: i.variant ?? "secondary",
          size: "sm",
          label: i.label,
          "icon-left": i.icon,
          disabled: i.disabled,
          "aria-disabled": i.ariaDisabled,
          "aria-describedby": i.ariaDisabled && e.description ? I(t) : void 0,
          "full-width": "",
          shrink: e.type === "buttons-inline",
          class: C(e.type === "buttons-inline" ? "flex-1" : ""),
          "data-testid": i.testId ?? `dropdown-panel-footer-button-${s}`,
          onClick: (d) => l("button-click", s)
        }, null, 8, ["variant", "label", "icon-left", "disabled", "aria-disabled", "aria-describedby", "shrink", "class", "data-testid", "onClick"]))), 128))
      ], 2)) : k("", !0),
      e.description ? (c(), g("p", {
        key: 3,
        id: I(t),
        "data-testid": "dropdown-panel-footer-description",
        class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
      }, N(e.description), 9, Kk)) : k("", !0)
    ], 10, Gk));
  }
}), Yk = { class: "inline-flex min-w-0 max-w-full text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, Jk = {
  "data-testid": "label-dropdown-label",
  class: "inline-flex min-w-0 items-center gap-1 px-px"
}, Xk = {
  "data-testid": "label-dropdown-text-frame",
  class: "inline-flex min-w-0 whitespace-nowrap"
}, Zk = ["id"], Qk = { class: "sr-only" }, Nr = /* @__PURE__ */ ke({
  __name: "LabelDropdown",
  props: {
    label: {},
    type: { default: "14px" },
    infoLeft: { default: () => {
    } },
    iconLeft: { default: () => {
    } },
    infoRight: { default: () => {
    } },
    required: { type: Boolean, default: !1 },
    requiredLabel: { default: () => {
    } },
    id: { default: () => {
    } }
  },
  setup(e) {
    const n = {
      "14px": {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)"
      },
      h6: {
        text: "font-(family-name:--family-heading) text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      h5: {
        text: "font-(family-name:--family-heading) text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, t = m(() => n[e.type]);
    return (a, l) => (c(), g("span", Yk, [
      v("span", Jk, [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C([e.iconLeft, "shrink-0 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
          "aria-hidden": "true",
          "data-testid": "label-dropdown-icon-left"
        }, null, 2)) : k("", !0),
        e.infoLeft ? (c(), H(ft, {
          key: 1,
          as: "span",
          text: e.infoLeft,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoLeft,
          "data-testid": "label-dropdown-info-left",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: xe(() => [
            v("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0),
        v("span", Xk, [
          v("span", {
            "data-testid": "label-dropdown-text",
            class: C(["flex min-w-0", t.value.text])
          }, [
            Ae(a.$slots, "default", {}, () => [
              re(ht, { text: e.label }, null, 8, ["text"])
            ])
          ], 2),
          e.id ? (c(), g("span", {
            key: 0,
            id: e.id,
            hidden: "",
            "data-testid": "label-dropdown-name"
          }, N(e.label), 9, Zk)) : k("", !0),
          e.required ? (c(), g(ce, { key: 1 }, [
            l[0] || (l[0] = v("span", {
              "aria-hidden": "true",
              "data-testid": "label-dropdown-required",
              class: "w-(--spacing-2) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            }, "*", -1)),
            v("span", Qk, N(e.requiredLabel), 1)
          ], 64)) : k("", !0)
        ]),
        e.infoRight ? (c(), H(ft, {
          key: 2,
          as: "span",
          text: e.infoRight,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoRight,
          "data-testid": "label-dropdown-info-right",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: xe(() => [
            v("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0)
      ])
    ]));
  }
}), Is = 1;
function wg({ strip: e, arrow: n, backArrow: t, enabled: a, selection: l }) {
  const r = R(!1), o = R(!1), i = R(!1), s = m(() => r.value && o.value), d = m(() => r.value && i.value);
  function u() {
    const M = e.value;
    if (!M || !a()) {
      r.value = !1, o.value = !1, i.value = !1;
      return;
    }
    const F = M.scrollWidth - M.clientWidth;
    r.value = F > Is, o.value = r.value && M.scrollLeft < F - Is, i.value = r.value && M.scrollLeft > Is;
  }
  const f = () => {
    var M;
    return s.value ? ((M = n.value) == null ? void 0 : M.offsetWidth) ?? 0 : 0;
  }, b = () => {
    var M;
    return d.value ? ((M = t.value) == null ? void 0 : M.offsetWidth) ?? 0 : 0;
  }, h = (M) => f() || parseFloat(getComputedStyle(M).scrollPaddingInlineEnd) || 0, p = (M) => b() || parseFloat(getComputedStyle(M).scrollPaddingInlineStart) || 0;
  let x = !1;
  const y = () => (!s.value || !!n.value) && (!d.value || !!t.value);
  function w(M) {
    const F = M.querySelector(":scope > [aria-selected='true'], :scope > .active");
    if (F) return F;
    let X = M.querySelector("[role='tab'][aria-selected='true']");
    for (; X && X.parentElement !== M; ) X = X.parentElement;
    return X;
  }
  function $() {
    x = !1;
    const M = e.value;
    if (!M || !r.value) return;
    const F = w(M);
    if (!F) return;
    const X = M.getBoundingClientRect(), _ = F.getBoundingClientRect(), Y = X.left + M.clientLeft, B = p(M), W = h(M), U = Y + B, z = Y + M.clientWidth - W;
    if (_.left < U) {
      const P = M.scrollLeft - (U - _.left);
      M.scrollLeft = F === M.firstElementChild || P < B ? 0 : P;
    } else if (_.right > z) {
      const P = M.scrollWidth - M.clientWidth, K = M.scrollLeft + Math.min(_.right - z, _.left - U);
      M.scrollLeft = F === M.lastElementChild || K > P - W ? P : K;
    }
    u(), x = !y();
  }
  $e(
    () => (s.value || d.value) && y(),
    (M) => {
      M && x && $();
    },
    { flush: "post" }
  );
  function S(M) {
    const F = e.value;
    if (!F) return;
    const X = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches, _ = Math.max(F.clientWidth - f() - b(), 1);
    F.scrollBy({ left: M * _, behavior: X ? "auto" : "smooth" });
  }
  function L(M, F) {
    const X = e.value;
    if (!X || !M || document.activeElement !== M) return;
    const _ = X.querySelectorAll(":scope > [data-button-group-item]"), Y = _.length ? _ : X.querySelectorAll("[role='tab']"), B = F === "first" ? Y[0] ?? X.firstElementChild : Y[Y.length - 1] ?? X.lastElementChild;
    B == null || B.focus({ preventScroll: !0 });
  }
  $e(s, (M) => M || L(n.value, "last")), $e(d, (M) => M || L(t.value, "first"));
  let T = null, E = 0;
  const A = () => {
    cancelAnimationFrame(E), E = requestAnimationFrame(u);
  };
  function D() {
    if (!T) return;
    T.disconnect();
    const M = e.value;
    !M || !a() || (T.observe(M), Array.from(M.children).forEach((F) => T.observe(F)));
  }
  return dt(async () => {
    var M;
    typeof ResizeObserver < "u" && (T = new ResizeObserver(A)), D(), u(), await Ue(), u(), $(), (M = document.fonts) == null || M.ready.then(() => {
      u(), $();
    });
  }), Ki(() => {
    D(), u();
  }), $e(l, () => Ue($)), mt(() => {
    T == null || T.disconnect(), T = null, cancelAnimationFrame(E);
  }), {
    overflowing: r,
    showArrow: s,
    showBackArrow: d,
    measure: u,
    scrollForward: () => S(1),
    scrollBack: () => S(-1)
  };
}
const _k = {
  key: 0,
  class: "inline-flex flex-col gap-1"
}, ew = { class: "flex items-center justify-between gap-2.5 px-2" }, tw = ["role", "aria-labelledby"], nw = ["aria-label"], aw = ["role", "tabindex"], lw = ["aria-label"], rw = ["role"], ow = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "ButtonGroup",
  props: {
    variant: { default: "pill" },
    color: { default: () => {
    } },
    size: { default: "sm" },
    labelLeft: { default: () => {
    } },
    labelRight: { default: () => {
    } },
    labelLeftInfo: { default: () => {
    } },
    labelRightInfo: { default: () => {
    } },
    modelValue: { default: () => {
    } },
    panelId: { default: () => {
    } },
    overflowLabel: {},
    overflowPreviousLabel: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Mn();
    dt(() => {
      var K;
      const U = ((K = a.default) == null ? void 0 : K.call(a, {})) ?? [], z = e.variant === "tab" ? "tab" : "tertiary";
      U.some((j) => {
        var q;
        const G = (q = j.props) == null ? void 0 : q.variant;
        return G !== void 0 && G !== z;
      }) && console.warn(
        `[ButtonGroup] variant="${e.variant}" expects <Button variant="${z}"> children. Other button variants will not render the active state correctly.`
      );
    });
    const l = m(
      () => e.variant === "group" || e.variant === "pill" && e.color === "dark"
    ), r = m(() => l.value && (e.color ?? "dark") === "dark"), o = m(() => e.variant !== "tab" && !!(e.labelLeft || e.labelRight)), i = R(!1);
    let s = 0;
    function d() {
      i.value = !0, cancelAnimationFrame(s), s = requestAnimationFrame(() => {
        s = requestAnimationFrame(() => {
          i.value = !1;
        });
      });
    }
    $e(() => e.modelValue, (U, z) => {
      z !== void 0 && U !== z && d();
    }), mt(() => cancelAnimationFrame(s));
    const u = m(() => e.variant === "tab" ? ["inline-flex items-center gap-px shadow-(--blur-shadow-xs)", i.value && "button-group-strip--switching"] : [
      i.value && "button-group-strip--switching",
      "button-group-strip inline-flex items-center",
      "rounded-(--border-border-radius-rounded-base)",
      l.value ? ["border border-(--border-border-base-medium) -space-x-px bg-(--colors-white-50-opacity-light) shadow-(--blur-shadow-xs)", r.value && "button-group--dark"] : [
        "gap-0",
        // A scrolling strip clips its items at its padding box: the overflow wrapper's layer draws the surface instead.
        !A.overflowing.value && [
          "border border-(--border-border-base-medium) bg-(--colors-white-50-opacity-medium)",
          e.size !== "xs" && "shadow-(--blur-shadow-xs)"
        ]
      ]
    ]), f = m(() => e.variant === "pill" && !l.value && !o.value), b = R(null), h = R(null), p = {
      xs: { scroll: "scroll-px-8", arrow: "size-[calc(--spacing(8)-2px)]", icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)" },
      sm: { scroll: "scroll-px-9", arrow: "size-[calc(--spacing(9)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      md: { scroll: "scroll-px-10", arrow: "size-[calc(--spacing(10)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      lg: { scroll: "scroll-px-12", arrow: "size-[calc(--spacing(12)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" }
    }, x = m(() => {
      if (e.modelValue !== void 0)
        return l.value ? "radio" : "tabs";
    }), y = m(() => x.value === "radio" ? "radiogroup" : e.variant === "tab" || x.value === "tabs" ? "tablist" : "group"), w = Nn(), $ = je(), S = je();
    function L() {
      if (!(!x.value || !o.value || w["aria-label"] || w["aria-labelledby"]))
        return [e.labelLeft && $, e.labelRight && S].filter(Boolean).join(" ");
    }
    const T = kx([]), E = R(null), A = wg({
      strip: E,
      arrow: b,
      backArrow: h,
      enabled: () => f.value,
      selection: () => e.modelValue
    }), D = m(
      () => A.overflowing.value ? [
        "relative isolate inline-flex min-w-0 max-w-full",
        "before:pointer-events-none before:absolute before:inset-0 before:-z-1",
        "before:border before:border-(--border-border-base-medium) before:rounded-(--border-border-radius-rounded-base)",
        "before:bg-(--colors-white-50-opacity-medium)",
        e.size !== "xs" && "before:shadow-(--blur-shadow-xs)"
      ] : "contents"
    ), M = m(() => [
      "max-w-full",
      A.overflowing.value && ["button-group-strip--scroll min-w-0 overflow-x-auto overflow-y-hidden", p[e.size].scroll],
      A.showBackArrow.value && "button-group-strip--clip-start",
      A.showArrow.value && "button-group-strip--clip-end"
    ]), F = (U) => [
      "absolute top-px z-20 inline-flex items-center justify-center cursor-pointer",
      U,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      p[e.size].arrow
    ];
    function X() {
      T.sort((U, z) => {
        const P = U.el(), K = z.el();
        return !P || !K ? 0 : P.compareDocumentPosition(K) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
    }
    Ki(X);
    function _(U) {
      U !== e.modelValue && (d(), t("update:modelValue", U));
    }
    function Y(U) {
      const z = T.filter((K) => !K.unreachable() && K.value() !== void 0), P = z.find((K) => K.value() === e.modelValue) ?? z[0];
      return P !== void 0 && P.value() === U;
    }
    const B = (U) => T.find((z) => z.el() === U);
    function W(U) {
      if (!x.value || U.altKey || U.ctrlKey || U.metaKey || !(x.value === "radio" ? ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp", "Home", "End"] : ["ArrowRight", "ArrowLeft", "Home", "End"]).includes(U.key)) return;
      const P = E.value, K = U.currentTarget;
      if (!P || !K) return;
      const j = Array.from(P.querySelectorAll("[data-button-group-item]")).filter(
        (ye) => ye.closest("[data-button-group-strip]") === P
      ), G = (ye) => {
        var Z;
        return ((Z = B(ye)) == null ? void 0 : Z.unreachable()) === !1;
      }, q = j.filter(G);
      if (!q.length) return;
      let J;
      if (U.key === "Home") J = q[0];
      else if (U.key === "End") J = q[q.length - 1];
      else {
        const ye = U.key === "ArrowRight" || U.key === "ArrowDown" ? 1 : -1, Z = j.indexOf(K);
        for (let de = 1; de <= j.length && !J; de++) {
          const ge = j[((Z + ye * de) % j.length + j.length) % j.length];
          G(ge) && (J = ge);
        }
      }
      if (!J) return;
      U.preventDefault(), U.stopPropagation(), J.focus();
      const me = B(J);
      if (x.value === "radio" && me && !me.blocked()) {
        const ye = me.value();
        ye !== void 0 && _(ye);
      }
    }
    return nn(bg, {
      mode: x,
      isSelected: (U) => U === e.modelValue,
      select: _,
      isTabStop: Y,
      register(U) {
        return T.push(U), () => {
          const z = T.indexOf(U);
          z !== -1 && T.splice(z, 1);
        };
      },
      sort: X,
      onItemKeydown: W,
      panelId: () => x.value === "tabs" ? e.panelId : void 0
    }), (U, z) => o.value ? (c(), g("div", _k, [
      v("div", ew, [
        e.labelLeft ? (c(), H(Nr, {
          key: 0,
          id: I($),
          label: e.labelLeft,
          type: "14px",
          "info-right": e.labelLeftInfo,
          "data-testid": "button-group-label-left"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0),
        e.labelRight ? (c(), H(Nr, {
          key: 1,
          id: I(S),
          label: e.labelRight,
          type: "14px",
          "info-right": e.labelRightInfo,
          "data-testid": "button-group-label-right"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0)
      ]),
      v("div", Oe({
        ref_key: "stripRef",
        ref: E,
        role: y.value,
        "aria-labelledby": L(),
        "data-button-group-strip": ""
      }, U.$attrs, { class: u.value }), [
        Ae(U.$slots, "default", {}, void 0, !0)
      ], 16, tw)
    ])) : f.value ? (c(), g("div", {
      key: 1,
      class: C(D.value)
    }, [
      I(A).showBackArrow.value ? (c(), g("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "button-group-overflow-back-arrow",
        class: C(F("left-px")),
        onClick: z[0] || (z[0] = //@ts-ignore
        (...P) => I(A).scrollBack && I(A).scrollBack(...P))
      }, [
        v("i", {
          class: C(["ri-arrow-left-line", p[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, nw)) : k("", !0),
      v("div", Oe({
        ref_key: "stripRef",
        ref: E,
        role: y.value,
        tabindex: I(A).overflowing.value ? -1 : void 0,
        "data-button-group-strip": ""
      }, U.$attrs, {
        class: [u.value, M.value],
        onScrollPassive: z[1] || (z[1] = //@ts-ignore
        (...P) => I(A).measure && I(A).measure(...P))
      }), [
        Ae(U.$slots, "default", {}, void 0, !0)
      ], 16, aw),
      I(A).showArrow.value ? (c(), g("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: b,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "button-group-overflow-arrow",
        class: C(F("right-px")),
        onClick: z[2] || (z[2] = //@ts-ignore
        (...P) => I(A).scrollForward && I(A).scrollForward(...P))
      }, [
        v("i", {
          class: C(["ri-arrow-right-line", p[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, lw)) : k("", !0)
    ], 2)) : (c(), g("div", Oe({
      key: 2,
      ref_key: "stripRef",
      ref: E,
      role: y.value,
      "data-button-group-strip": ""
    }, U.$attrs, { class: u.value }), [
      Ae(U.$slots, "default", {}, void 0, !0)
    ], 16, rw));
  }
}), Cg = /* @__PURE__ */ ot(ow, [["__scopeId", "data-v-f3b2c0c4"]]), iw = ["id"], sw = ["id"], dw = ["aria-valuemax", "aria-valuenow", "aria-valuetext"], Ts = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", Gu = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "ProgressBar",
  props: {
    value: { default: 0 },
    max: { default: 100 },
    color: { default: "primary" },
    size: { default: "base" },
    labelPosition: { default: "top" },
    label: { default: void 0 },
    valueLabel: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    var E;
    const n = e, t = {
      base: "h-1.5",
      lg: "h-2.5"
    }, a = {
      primary: "bg-[linear-gradient(90deg,var(--gradient-brand-start)_7.4%,var(--gradient-brand-end)_90.2%)]",
      gray: "bg-(--border-border-accessibility)",
      dark: "bg-(--background-background-black-default)",
      success: "bg-(--border-border-success-strong)",
      danger: "bg-(--border-border-error-strong)",
      warning: "bg-(--border-border-warning)"
    }, l = {
      top: "flex-col",
      side: "flex-row items-center",
      bottom: "flex-col"
    }, r = Nn(), o = m(() => ({ class: r.class, style: r.style })), i = m(() => {
      const { class: A, style: D, ...M } = r;
      return M;
    }), s = je(), d = m(() => {
      var A;
      return ((A = n.label) == null ? void 0 : A.trim()) || void 0;
    }), u = m(() => {
      var A;
      return ((A = n.valueLabel) == null ? void 0 : A.trim()) || void 0;
    }), f = () => u.value ?? r["aria-valuetext"], b = m(() => !!(d.value || u.value)), h = m(() => n.labelPosition === "side"), p = m(
      () => n.labelPosition === "bottom" ? ["track", "row"] : ["row", "track"]
    ), x = m(() => Number.isFinite(n.max) && n.max > 0 ? n.max : 0), y = m(() => {
      const A = Number.isFinite(n.value) ? n.value : 0;
      return Math.min(Math.max(A, 0), x.value);
    }), w = m(() => x.value > 0 ? y.value / x.value * 100 : 0), $ = R(null), S = (A) => {
      $.value = A ?? null;
    }, L = m(() => {
      var M, F;
      if (r["aria-labelledby"]) return {};
      const A = h.value && !!((M = $.value) != null && M.isTabStop);
      return d.value && !A ? { "aria-labelledby": s } : { "aria-label": (d.value ?? ((F = n.ariaLabel) == null ? void 0 : F.trim())) || void 0 };
    });
    return typeof process < "u" && ((E = process.env) == null ? void 0 : E.NODE_ENV) !== "production" && $e(
      () => {
        var A;
        return !d.value && !((A = n.ariaLabel) != null && A.trim()) && !r["aria-labelledby"];
      },
      (A) => {
        A && console.warn("[OPAL ProgressBar] No `label` and no `ariaLabel`: the progress bar has no accessible name.");
      },
      { immediate: !0 }
    ), (A, D) => (c(), g("div", Oe(o.value, {
      class: ["flex w-full min-w-0 gap-1.5", l[e.labelPosition]],
      "data-testid": "progress-bar"
    }), [
      (c(!0), g(ce, null, Re(p.value, (M) => (c(), g(ce, { key: M }, [
        M === "row" && b.value ? (c(), g("div", {
          key: 0,
          class: C(h.value ? "contents" : "flex w-full min-w-0"),
          "data-testid": "progress-bar-label-row"
        }, [
          d.value && h.value ? (c(), g("span", {
            key: 0,
            id: I(s),
            class: "order-first flex min-w-0 max-w-1/2",
            "data-testid": "progress-bar-label"
          }, [
            re(ht, {
              ref_for: !0,
              ref: S,
              text: d.value,
              "text-class": Ts
            }, null, 8, ["text"])
          ], 8, iw)) : d.value ? (c(), g("span", {
            key: 1,
            id: I(s),
            class: C([Ts, "min-w-0 flex-1 break-words"]),
            "data-testid": "progress-bar-label"
          }, N(d.value), 11, sw)) : k("", !0),
          u.value ? (c(), g("span", {
            key: 2,
            class: C([Ts, "text-right", h.value ? "order-last max-w-1/4 shrink-0 break-words" : "min-w-0 flex-1 break-words"]),
            "aria-hidden": "true",
            "data-testid": "progress-bar-value-label"
          }, N(u.value), 3)) : k("", !0)
        ], 2)) : M === "track" ? (c(), g("div", Oe({
          key: 1,
          ref_for: !0
        }, { ...i.value, ...L.value }, {
          class: ["overflow-hidden rounded-(--border-border-radius-rounded-l) bg-(--background-background-gray)", [t[e.size], h.value ? "min-w-0 flex-1" : "w-full"]],
          role: "progressbar",
          "aria-valuemin": "0",
          "aria-valuemax": x.value > 0 ? x.value : 100,
          "aria-valuenow": y.value,
          "aria-valuetext": f(),
          "data-testid": "progress-bar-track"
        }), [
          v("div", {
            class: C(["h-full rounded-(--border-border-radius-rounded-l) transition-[width] duration-300 motion-reduce:transition-none", a[e.color]]),
            style: Ne({ width: `${w.value}%` }),
            "data-testid": "progress-bar-fill"
          }, null, 6)
        ], 16, dw)) : k("", !0)
      ], 64))), 128))
    ], 16));
  }
}), uw = ["id"], cw = ["id", "role"], fw = ["data-testid"], hw = {
  key: 3,
  class: "col-start-2 row-start-1 flex shrink-0 items-center"
}, bw = ["data-testid"], gw = ["data-testid"], mw = { class: "min-w-0 break-words" }, pw = ["data-testid"], vw = {
  key: 1,
  class: "flex min-w-0 flex-col gap-(--spacing-2-5)"
}, xw = ["id"], yw = ["aria-labelledby"], kw = { class: "sr-only" }, ww = ["data-testid"], Cw = ["data-testid"], Sw = {
  key: 0,
  class: "h-4.5 w-0 shrink-0 border-l-(length:--border-border-width-border) border-(--border-border-base-medium)",
  "aria-hidden": "true"
}, $w = { class: "flex min-w-0 items-center gap-1.5" }, Ls = "text-(length:--size-m) leading-(--line-height-l)", xt = /* @__PURE__ */ ke({
  __name: "FieldHelper",
  props: {
    hint: { default: void 0 },
    hintIcon: { default: void 0 },
    hintLines: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hintId: { default: void 0 },
    errorId: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    focused: { type: Boolean, default: !1 },
    testIdPrefix: { default: void 0 },
    endText: { default: void 0 },
    endIcon: { default: void 0 },
    progress: { default: void 0 },
    progressLabel: { default: void 0 },
    checklistTitle: { default: void 0 },
    checklist: { default: void 0 },
    features: { default: void 0 },
    tags: { default: void 0 },
    labels: { default: () => ({ met: "Met", unmet: "Not met", failed: "Failed", progress: "Progress" }) }
  },
  emits: ["endClick", "removeTag"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = m(() => !!a.endText), o = m(
      () => {
        var $;
        return a.progress !== void 0 || !!a.checklistTitle || !!(($ = a.checklist) != null && $.length);
      }
    ), i = je(), s = {
      met: { icon: "ri-checkbox-circle-fill text-(--icons-icon-success)", text: "text-(--text-text-success-strong)" },
      unmet: { icon: "ri-checkbox-blank-circle-line text-(--icons-icon-base)", text: "text-(--text-text-body-subtle)" },
      failed: { icon: "ri-close-circle-fill text-(--icons-icon-error)", text: "text-(--text-text-error-strong)" }
    }, d = m(
      () => r.value ? "min-h-5 grid min-w-0 self-stretch grid-cols-[minmax(0,1fr)_auto] items-center gap-x-(--spacing-2-5) gap-y-px" : "min-h-5 flex min-w-0 self-stretch flex-col gap-px"
    ), u = R(null), f = R(!1), b = m(() => f.value ? !1 : a.focused ? !0 : void 0);
    $e(
      () => a.focused,
      ($) => {
        $ || (f.value = !1);
      }
    );
    const h = ($) => {
      var S;
      $.key !== "Escape" || $.defaultPrevented || f.value || !a.focused || !a.hint || !((S = u.value) != null && S.isTruncated) || ($.stopPropagation(), $.preventDefault(), f.value = !0);
    }, p = R(null), x = R(null), y = R(null), w = ($) => {
      var S;
      y.value = { index: $, count: ((S = a.tags) == null ? void 0 : S.length) ?? 0 }, l("removeTag", $);
    };
    return $e(
      () => a.tags,
      ($) => {
        var E, A, D, M;
        const S = y.value;
        if (y.value = null, !S || (($ == null ? void 0 : $.length) ?? 0) >= S.count) return;
        const { index: L } = S, T = (E = x.value) == null ? void 0 : E.querySelectorAll(":scope > li button");
        if (T != null && T.length) {
          T[Math.min(Math.max(L - 1, 0), T.length - 1)].focus();
          return;
        }
        (M = (D = (A = p.value) == null ? void 0 : A.parentElement) == null ? void 0 : D.querySelector("input:not([type='hidden']), textarea, select")) == null || M.focus();
      },
      // deep: consumers also splice the array in place
      { flush: "post", deep: !0 }
    ), n({ handleFieldKeydown: h }), ($, S) => {
      var L, T, E, A;
      return c(), g("div", {
        ref_key: "rootRef",
        ref: p,
        "data-field-helper": "",
        class: C(d.value)
      }, [
        e.hint ? (c(), g("span", {
          key: 0,
          id: e.hintId,
          class: "sr-only"
        }, N(e.hint), 9, uw)) : k("", !0),
        e.error ? (c(), g("span", {
          key: 1,
          id: e.errorId,
          role: e.errorLive ? "alert" : void 0,
          class: "sr-only"
        }, N(e.error), 9, cw)) : k("", !0),
        e.hint ? (c(), g("div", {
          key: 2,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-hint` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 gap-1 text-(length:--size-sm) leading-(--line-height-l)",
            e.disabled ? "text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.hintLines === 2 ? "items-start" : "items-center"
          ])
        }, [
          !r.value || e.hintIcon ? (c(), g("i", {
            key: 0,
            class: C([
              e.hintIcon ?? "ri-error-warning-line",
              "inline-flex w-3 shrink-0 items-center justify-center text-(length:--size-sm)",
              e.disabled ? "text-(--icons-icon-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
              e.hintLines === 2 ? "h-(--line-height-l)" : "h-3"
            ]),
            "aria-hidden": "true"
          }, null, 2)) : k("", !0),
          (c(), H(ht, {
            ref_key: "hintRef",
            ref: u,
            key: e.hintLines,
            text: e.hint,
            lines: e.hintLines,
            "text-class": e.hintLines === 2 ? "whitespace-pre-line" : "",
            focusable: !1,
            open: b.value,
            position: "bottom"
          }, null, 8, ["text", "lines", "text-class", "open"]))
        ], 10, fw)) : k("", !0),
        r.value ? (c(), g("div", hw, [
          v("button", {
            type: "button",
            class: "relative inline-flex cursor-pointer items-center gap-1 rounded-(--border-border-radius-rounded-xs) before:absolute before:left-1/2 before:top-1/2 before:h-6 before:w-full before:min-w-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-link) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
            "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-end` : void 0,
            onClick: S[0] || (S[0] = (D) => l("endClick"))
          }, [
            e.endIcon ? (c(), g("i", {
              key: 0,
              class: C([e.endIcon, "inline-flex size-3 shrink-0 items-center justify-center text-(length:--size-sm) text-(--icons-icon-link)"]),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0),
            v("span", null, N(e.endText), 1)
          ], 8, bw)
        ])) : k("", !0),
        e.error ? (c(), g("div", {
          key: 4,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-error` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 items-start gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
            r.value ? "col-span-full" : ""
          ])
        }, [
          S[1] || (S[1] = v("span", { class: "inline-flex h-(--line-height-l) shrink-0 items-center" }, [
            v("i", {
              class: "ri-close-circle-line inline-flex size-3 items-center justify-center text-(length:--size-sm) text-(--icons-icon-error)",
              "aria-hidden": "true"
            })
          ], -1)),
          v("span", mw, N(e.error), 1)
        ], 10, gw)) : k("", !0),
        o.value ? (c(), g("div", {
          key: 5,
          class: "col-span-full flex min-w-0 flex-col gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-progress` : void 0
        }, [
          e.progress !== void 0 ? (c(), H(Gu, {
            key: 0,
            value: e.progress,
            "aria-label": e.progressLabel ?? e.labels.progress
          }, null, 8, ["value", "aria-label"])) : k("", !0),
          e.checklistTitle || (L = e.checklist) != null && L.length ? (c(), g("div", vw, [
            e.checklistTitle ? (c(), g("span", {
              key: 0,
              id: I(i),
              class: C([Ls, "font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)"])
            }, N(e.checklistTitle), 11, xw)) : k("", !0),
            (T = e.checklist) != null && T.length ? (c(), g("ul", {
              key: 1,
              class: "flex min-w-0 flex-col gap-1.5",
              "aria-labelledby": e.checklistTitle ? I(i) : void 0
            }, [
              (c(!0), g(ce, null, Re(e.checklist, (D, M) => (c(), g("li", {
                key: M,
                class: "flex min-w-0 items-center gap-1.5"
              }, [
                v("i", {
                  class: C([
                    s[D.status].icon,
                    "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)"
                  ]),
                  "aria-hidden": "true"
                }, null, 2),
                v("span", {
                  class: C([Ls, "min-w-0 flex-1 break-words font-(--weight-regular)", s[D.status].text])
                }, [
                  v("span", kw, N(`${D.statusLabel ?? e.labels[D.status]}: `), 1),
                  et(N(D.text), 1)
                ], 2)
              ]))), 128))
            ], 8, yw)) : k("", !0)
          ])) : k("", !0)
        ], 8, pw)) : k("", !0),
        (E = e.tags) != null && E.length ? (c(), g("ul", {
          key: 6,
          ref_key: "tagListRef",
          ref: x,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-tags` : void 0
        }, [
          (c(!0), g(ce, null, Re(e.tags, (D, M) => (c(), g("li", {
            key: `${D.label}-${M}`,
            class: "flex min-w-0"
          }, [
            re(ct, {
              label: D.label,
              theme: "white",
              size: "sm",
              type: "with-avatar",
              "avatar-src": D.avatarSrc,
              "avatar-alt": D.avatarAlt,
              "show-close-icon": "",
              "remove-label": D.removeLabel,
              onClose: (F) => w(M)
            }, null, 8, ["label", "avatar-src", "avatar-alt", "remove-label", "onClose"])
          ]))), 128))
        ], 8, ww)) : k("", !0),
        (A = e.features) != null && A.length ? (c(), g("ul", {
          key: 7,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-3",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-features` : void 0
        }, [
          (c(!0), g(ce, null, Re(e.features, (D, M) => (c(), g("li", {
            key: M,
            class: "flex min-w-0 items-center gap-3"
          }, [
            M > 0 ? (c(), g("span", Sw)) : k("", !0),
            v("span", $w, [
              v("i", {
                class: C([
                  D.icon,
                  "inline-flex size-4 shrink-0 items-center justify-center text-(length:--icon-size-sm) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
                ]),
                "aria-hidden": "true"
              }, null, 2),
              v("span", {
                class: C([
                  Ls,
                  "min-w-0 break-words font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                ])
              }, N(D.text), 3)
            ])
          ]))), 128))
        ], 8, Cw)) : k("", !0)
      ], 2);
    };
  }
}), Bn = /* @__PURE__ */ ke({
  __name: "FieldShell",
  props: {
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    focusScope: { default: "control" },
    hasValue: { type: Boolean, default: !1 },
    rounded: { default: "l" },
    flush: { type: Boolean, default: !1 },
    innerButton: { type: Boolean, default: !1 },
    stacked: { type: Boolean, default: !1 },
    tags: { type: Boolean, default: !1 },
    multiline: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = R(!1), a = R(null), l = R(!1), r = m(() => !n.disabled && (n.focused || l.value));
    function o(M) {
      var F;
      return !(M instanceof Element) || !((F = a.value) != null && F.contains(M)) ? !1 : n.focusScope === "any" || M === a.value || M.matches("input, textarea, select");
    }
    function i(M) {
      l.value = o(M.target);
    }
    function s(M) {
      l.value = o(M.relatedTarget);
    }
    $e(
      () => n.disabled,
      () => {
        l.value = o(document.activeElement);
      }
    );
    const d = {
      sm: {
        height: "h-[32px]",
        container: "h-[32px] px-[calc(--spacing(2)-1px)] py-[calc(--spacing(1.5)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        height: "h-[36px]",
        container: "h-[36px] px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        height: "h-[48px]",
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] py-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        height: "h-[52px]",
        container: "h-[52px] px-[calc(--spacing(4)-1px)] py-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, u = {
      sm: {
        height: "h-[48px] pr-[calc(--spacing(2)-1px)]",
        container: "h-[48px] pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2)-1px)] gap-2"
      },
      md: {
        height: "h-[52px] pr-[calc(--spacing(2.5)-1px)]",
        container: "h-[52px] pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(2.5)-1px)] gap-2"
      },
      lg: {
        height: "h-[56px] pr-[calc(--spacing(3)-1px)]",
        container: "h-[56px] pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3)-1px)] gap-2"
      },
      xl: {
        height: "h-[60px] pr-[calc(--spacing(3.5)-1px)]",
        container: "h-[60px] pl-[calc(--spacing(4)-1px)] pr-[calc(--spacing(3.5)-1px)] gap-2"
      }
    }, f = {
      sm: {
        container: "h-[56px] p-[calc(--spacing(2)-1px)] flex-col justify-center",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        container: "h-[62px] p-[calc(--spacing(2.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        container: "h-[70px] p-[calc(--spacing(3)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        container: "h-[74px] p-[calc(--spacing(3.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, b = {
      sm: "min-h-[32px] flex-wrap gap-2 py-[calc(--spacing(1)-1px)] px-[calc(--spacing(2)-1px)]",
      md: "min-h-[36px] flex-wrap gap-2 py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(2.5)-1px)]",
      lg: "min-h-[48px] flex-wrap gap-2 py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(3)-1px)]",
      xl: "min-h-[52px] flex-wrap gap-2 py-[calc(--spacing(3)-1px)] px-[calc(--spacing(3.5)-1px)]"
    }, h = m(() => d[n.size]), p = m(
      () => n.stacked ? f[n.size].text : h.value.text
    ), x = m(() => n.stacked ? f[n.size].topText : ""), y = m(() => {
      if (n.stacked) return f[n.size].container;
      if (n.tags) return b[n.size];
      if (n.multiline)
        return "h-[144px] overflow-hidden px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)]";
      if (n.innerButton) {
        const M = u[n.size];
        return n.flush ? M.height : M.container;
      }
      return n.flush ? `${h.value.height} overflow-hidden` : h.value.container;
    }), w = m(() => {
      const F = `relative ${n.rounded === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} border-solid box-border flex items-center text-left font-inter border-[1px]`, X = "shadow-[0_0_2px_2px_var(--background-background-hover)]", _ = r.value ? X : "dark:shadow-(--blur-shadow-m-dark)";
      if (n.disabled)
        return `${F} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)`;
      if (n.readonly) {
        const B = r.value ? `${X} border-(--border-border-accent)` : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${F} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${B} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (n.error)
        return `${F} ${_} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (n.success)
        return `${F} ${_} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (r.value)
        return `${F} ${X} bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (t.value)
        return `${F} ${X} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const Y = n.hasValue ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${F} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${Y} dark:text-(--text-text-white-default)`;
    }), $ = m(() => n.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : n.readonly ? "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)" : n.error ? "text-(--icons-icon-error)" : n.success ? "text-(--icons-icon-success)" : r.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"), S = m(() => n.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : n.readonly ? r.value ? "border-(--border-border-accent)" : "border-(--border-border-base-soft) dark:border-(--border-border-base)" : n.error ? "border-(--border-border-error-strong) dark:border-(--border-border-error)" : n.success ? "border-(--border-border-success-strong)" : r.value || t.value ? "border-(--border-border-accent)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"), L = m(() => n.disabled ? "text-(--text-text-disabled-light)" : n.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : n.error ? "text-(--text-text-error-strong) dark:text-(--text-text-error)" : n.success ? "text-(--text-text-success-strong)" : r.value ? "text-(--text-text-accent)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"), T = m(
      () => n.stacked && (n.size === "sm" || n.size === "md") ? "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)" : "inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l)"
    ), E = m(
      () => !n.stacked && (n.size === "lg" || n.size === "xl") ? "inline-flex size-5 shrink-0 items-center justify-center text-(length:--icon-size-md)" : T.value
    ), A = () => {
      !n.disabled && !n.readonly && !n.tags && (t.value = !0);
    }, D = () => {
      t.value = !1;
    };
    return (M, F) => (c(), g("div", {
      ref_key: "rootRef",
      ref: a,
      class: C([w.value, y.value]),
      onFocusin: i,
      onFocusout: s,
      onMouseenter: A,
      onMouseleave: D
    }, [
      Ae(M.$slots, "default", {
        hovered: t.value,
        borderColorClass: S.value,
        addonTextClass: L.value,
        iconBoxClass: T.value,
        leftIconBoxClass: E.value,
        iconColorClass: $.value,
        textClass: p.value,
        topTextClass: x.value
      })
    ], 34));
  }
});
function Sg(e, n) {
  return n === 1 ? "only" : e === 0 ? "first" : e === n - 1 ? "last" : "middle";
}
const Iw = { sm: "xs", md: "sm", lg: "lg", xl: "xl" }, Tw = { sm: "xs", md: "xs", lg: "sm", xl: "md" };
function za(e, n) {
  return (n === "stacked" ? Tw : Iw)[e];
}
const Lw = {
  l: { left: "rounded-l-(--border-border-radius-rounded-l)", right: "rounded-r-(--border-border-radius-rounded-l)" },
  full: { left: "rounded-l-full", right: "rounded-r-full" }
};
function $g(e, n) {
  const t = Lw[n], a = e === "first" || e === "only" ? "" : "-ml-px ", l = {
    first: `${t.left} rounded-r-none`,
    middle: "rounded-l-none rounded-r-none",
    last: `rounded-l-none ${t.right}`,
    only: `${t.left} ${t.right}`
  }[e];
  return { part: `${a}relative hover:z-[1] focus-within:z-[1]`, corners: l };
}
function Ig(e) {
  return `flex w-full items-stretch ${e === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} shadow-(--blur-shadow-xs)`;
}
function Xn(e, n) {
  return {
    variant: e.color ?? "secondary",
    label: e.iconOnly ? "" : e.label,
    iconLeft: e.icon,
    iconOnly: !!e.iconOnly,
    dropdownIcon: !!e.dropdown,
    ariaLabel: e.iconOnly ? e.label : e.ariaLabel,
    disabled: n || !!e.disabled,
    "data-field-button": e.id
  };
}
function Ku(e) {
  return { icon: "ri-delete-bin-line", ...e, iconOnly: !0 };
}
const lo = /* @__PURE__ */ ke({
  __name: "FieldButtons",
  props: {
    buttons: { default: () => [] },
    layout: { default: "attached" },
    size: { default: "md" },
    rounded: { default: "l" },
    disabled: { type: Boolean, default: !1 },
    buttonSize: { default: void 0 }
  },
  emits: ["button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Mn(), r = m(() => t.buttons.filter((S) => S.position === "start")), o = m(() => t.buttons.filter((S) => S.position !== "start")), i = m(
      () => t.layout === "stacked" ? [null, ...r.value, ...o.value] : [...r.value, null, ...o.value]
    ), s = m(
      () => t.buttonSize ?? za(t.size, t.layout)
    ), d = m(() => t.layout === "attached"), u = m(() => t.layout === "stacked" ? "flex w-full flex-col gap-4" : t.layout === "spaced" ? "flex w-full items-center gap-4" : Ig(t.rounded)), f = () => l.leading ? 1 : 0, b = () => f() + t.buttons.length > 0, h = () => f() + r.value.length + 1 + o.value.length, p = () => f() + r.value.length;
    function x(S) {
      return $g(Sg(S, h()), t.rounded);
    }
    function y() {
      return t.layout === "stacked" ? "w-full" : d.value ? `min-w-0 flex-1 ${x(p()).part}` : "min-w-0 flex-1";
    }
    function w() {
      return d.value ? x(p()).corners : "";
    }
    function $(S) {
      if (!d.value) return "";
      const { part: L, corners: T } = x(S);
      return `${L} ${T}`;
    }
    return (S, L) => b() ? (c(), g("div", {
      key: 1,
      class: C(u.value)
    }, [
      Ae(S.$slots, "leading", {
        partClass: $(0),
        buttonSize: s.value
      }),
      (c(!0), g(ce, null, Re(i.value, (T, E) => (c(), g(ce, {
        key: T ? `button-${T.id}` : "field"
      }, [
        T ? (c(), H(Be, Oe({
          key: 1,
          class: $(f() + E)
        }, { ref_for: !0 }, I(Xn)(T, e.disabled), {
          size: s.value,
          "full-width": e.layout === "stacked",
          onClick: (A) => a("button-click", T.id)
        }), null, 16, ["class", "size", "full-width", "onClick"])) : (c(), g("div", {
          key: 0,
          class: C(y())
        }, [
          Ae(S.$slots, "default", {
            fieldClass: w()
          })
        ], 2))
      ], 64))), 128))
    ], 2)) : Ae(S.$slots, "default", {
      key: 0,
      fieldClass: ""
    });
  }
});
function Xl(e, n, t) {
  return e && n ? {
    root: "grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-4 gap-y-0.5",
    label: "",
    field: "col-start-2",
    helper: "col-start-2",
    remove: "",
    removeInFieldRow: !0,
    reservesHelper: !1
  } : t ? {
    root: "grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-0.5",
    label: "col-start-1",
    field: "col-start-1",
    helper: "col-start-1",
    remove: `col-start-2 self-end ${n ? "row-start-2" : "row-start-1"}`,
    removeInFieldRow: !1,
    reservesHelper: !0
  } : {
    root: "flex flex-col items-start gap-0.5",
    label: "",
    field: "",
    helper: "",
    remove: "",
    removeInFieldRow: !1,
    reservesHelper: !0
  };
}
const Aw = ["src"], Ew = ["src"], Rw = ["id", "name", "value", "placeholder", "disabled", "aria-label", "aria-labelledby", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "role", "aria-controls", "aria-expanded", "aria-autocomplete", "aria-activedescendant"], Bw = ["aria-label", "onKeydown"], Dw = ["src"], Mw = /* @__PURE__ */ ke({
  __name: "SearchInput",
  props: {
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    showSearchIcon: { type: Boolean, default: !0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    rounded: { default: "full" },
    hint: { default: void 0 },
    error: { default: void 0 },
    labels: { default: () => ({ clear: "Clear search" }) },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaControls: { default: void 0 },
    ariaExpanded: { type: Boolean, default: !1 },
    ariaActivedescendant: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown", "search", "clear", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = je(), r = m(() => t.id || l), o = m(() => `${r.value}-hint`), i = m(() => `${r.value}-error`), s = R(!1), d = R(null), u = R(null), f = R(null), b = m(() => t.rounded === "full" ? "full" : "l"), h = m(() => !!t.modelValue && t.modelValue.trim() !== ""), p = m(() => !!t.hint || !!t.error), x = m(() => t.buttons.length > 0), y = m(() => {
      const B = [];
      return t.hint && B.push(o.value), t.error && B.push(i.value), B.length > 0 ? B.join(" ") : void 0;
    }), w = m(() => !!t.ariaControls), $ = m(() => s.value && h.value && !t.disabled), S = m(() => Xl(t.labelInline, !!t.label, !1)), L = m(() => t.fullWidth || t.width === void 0), T = m(() => t.labelInline && !!t.label && !L.value), E = (B) => !!B && B.startsWith("ri-"), A = m(() => L.value ? {} : { width: t.width }), D = m(() => x.value ? { style: A.value } : {}), M = (B) => {
      const W = B.target;
      a("update:modelValue", W.value), a("input", B);
    }, F = (B) => {
      var z, P;
      a("keydown", B), B.key === "Enter" && !B.isComposing && a("search", B.target.value);
      const U = w.value && t.ariaExpanded || B.defaultPrevented;
      B.key === "Escape" && !B.isComposing && t.modelValue && !t.disabled && !U && (B.preventDefault(), B.stopPropagation(), Y()), (z = u.value) == null || z.handleFieldKeydown(B), (P = f.value) == null || P.handleFieldKeydown(B);
    }, X = (B) => {
      t.disabled || (s.value = !0), a("focus", B);
    }, _ = (B) => {
      s.value = !1, a("blur", B);
    }, Y = () => {
      var B;
      a("update:modelValue", ""), a("clear"), (B = d.value) == null || B.focus();
    };
    return (B, W) => (c(), g("div", {
      class: C([
        "relative min-w-0 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter",
        T.value ? "w-fit" : "w-full",
        S.value.root
      ])
    }, [
      e.label ? (c(), g("div", {
        key: 0,
        class: C(["flex min-w-0 max-w-full items-center gap-1", S.value.label])
      }, [
        re(yt, {
          ref_key: "labelRef",
          ref: u,
          text: e.label,
          "input-id": r.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: s.value,
          inline: e.labelInline,
          "test-id": "search-input-label"
        }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"]),
        e.helpIcon && !e.labelTooltip ? (c(), g("img", {
          key: 0,
          src: e.helpIcon,
          class: "h-3 w-3 relative search-input-icon",
          alt: ""
        }, null, 8, Aw)) : k("", !0)
      ], 2)) : k("", !0),
      v("div", {
        class: C(["flex w-full", S.value.field])
      }, [
        re(lo, Oe({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          rounded: b.value,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, D.value, {
          onButtonClick: W[2] || (W[2] = (U) => a("button-click", U))
        }), {
          default: xe(({ fieldClass: U }) => [
            re(Bn, {
              size: e.size,
              rounded: b.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              error: !!e.error,
              "has-value": h.value,
              class: C([
                x.value || L.value ? "w-full" : "",
                x.value && e.buttonLayout === "attached" ? "min-h-full" : "",
                U
              ]),
              style: Ne(x.value ? {} : A.value)
            }, {
              default: xe(({ iconBoxClass: z, leftIconBoxClass: P, iconColorClass: K, textClass: j }) => [
                e.showSearchIcon ? (c(), g(ce, { key: 0 }, [
                  !e.iconLeft || E(e.iconLeft) ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft || "ri-search-line", P, K]),
                    "aria-hidden": "true"
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    src: e.iconLeft,
                    class: C([P, "search-input-icon"]),
                    alt: ""
                  }, null, 10, Ew))
                ], 64)) : k("", !0),
                v("input", {
                  id: r.value,
                  ref_key: "inputRef",
                  ref: d,
                  name: e.name,
                  "data-testid": "search-input",
                  type: "search",
                  value: e.modelValue,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  "aria-label": e.label || e.ariaLabelledby ? void 0 : e.ariaLabel ?? e.placeholder,
                  "aria-labelledby": e.label ? void 0 : e.ariaLabelledby,
                  "aria-disabled": e.disabled ? "true" : void 0,
                  "aria-invalid": e.error ? "true" : void 0,
                  "aria-describedby": y.value,
                  "aria-required": e.required ? "true" : void 0,
                  role: w.value ? "combobox" : void 0,
                  "aria-controls": e.ariaControls,
                  "aria-expanded": w.value ? e.ariaExpanded ? "true" : "false" : void 0,
                  "aria-autocomplete": w.value ? "list" : void 0,
                  "aria-activedescendant": w.value && e.ariaActivedescendant || void 0,
                  class: C([
                    "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none",
                    j
                  ]),
                  onInput: M,
                  onFocus: X,
                  onBlur: _,
                  onKeydown: F
                }, null, 42, Rw),
                $.value ? (c(), g("i", {
                  key: 1,
                  class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", z]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  "data-testid": "search-input-clear",
                  onMousedown: W[0] || (W[0] = Ye(() => {
                  }, ["prevent"])),
                  onClick: Ye(Y, ["stop"]),
                  onKeydown: [
                    ut(Y, ["enter"]),
                    ut(Ye(Y, ["prevent"]), ["space"])
                  ]
                }, null, 42, Bw)) : k("", !0),
                e.iconRight ? (c(), g("img", {
                  key: 2,
                  src: e.iconRight,
                  class: C([z, "search-input-icon"]),
                  alt: ""
                }, null, 10, Dw)) : k("", !0),
                e.innerButton ? (c(), H(Be, Oe({ key: 3 }, I(Xn)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: W[1] || (W[1] = (G) => a("button-click", e.innerButton.id))
                }), null, 16)) : k("", !0)
              ]),
              _: 1
            }, 8, ["size", "rounded", "inner-button", "disabled", "error", "has-value", "class", "style"])
          ]),
          _: 1
        }, 16, ["buttons", "layout", "size", "rounded", "disabled", "button-size"])
      ], 2),
      p.value ? (c(), H(xt, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        class: C(S.value.helper),
        focused: s.value,
        hint: e.hint,
        error: e.error,
        "hint-id": o.value,
        "error-id": i.value,
        disabled: e.disabled,
        "test-id-prefix": "search-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "disabled"])) : k("", !0)
    ], 2));
  }
}), Zi = /* @__PURE__ */ ot(Mw, [["__scopeId", "data-v-a3d6bac2"]]), zw = {
  key: 0,
  "data-testid": "dropdown-panel-header-labels",
  class: "flex items-center justify-between gap-2.5 px-2"
}, cl = /* @__PURE__ */ ke({
  __name: "DropdownPanelHeader",
  props: {
    labelLeft: { default: void 0 },
    labelLeftInfo: { default: void 0 },
    labelRight: { default: void 0 },
    labelRightInfo: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    activeGroup: { default: void 0 },
    groupLabelLeft: { default: void 0 },
    groupLabelLeftInfo: { default: void 0 },
    groupLabelRight: { default: void 0 },
    groupLabelRightInfo: { default: void 0 },
    groupAriaLabel: { default: void 0 }
  },
  emits: ["update:searchQuery", "update:activeGroup"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = je(), o = je(), i = m(() => !!(a.labelLeft || a.labelRight)), s = m(() => {
      if (!(a.searchLabel || !i.value))
        return [a.labelLeft && r, a.labelRight && o].filter(Boolean).join(" ");
    }), d = m(() => !!(a.groupLabelLeft || a.groupLabelRight)), u = R(null);
    function f() {
      var h;
      const b = (h = u.value) == null ? void 0 : h.querySelector('[data-testid="search-input"]');
      return b == null || b.focus({ preventScroll: !0 }), !!b;
    }
    return n({ focusSearch: f }), (b, h) => (c(), g("div", {
      ref_key: "rootRef",
      ref: u,
      "data-testid": "dropdown-panel-header",
      class: "relative flex flex-col gap-3 border-b border-(--border-border-base-soft) bg-(--background-background-white) px-3 pt-4 pb-[calc(--spacing(4)-1px)] shadow-(--shadow-bottom-dropdown) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--shadow-bottom-dropdown-dark)"
    }, [
      i.value ? (c(), g("div", zw, [
        e.labelLeft ? (c(), H(Nr, {
          key: 0,
          id: I(r),
          label: e.labelLeft,
          "info-right": e.labelLeftInfo,
          "data-testid": "dropdown-panel-header-label-left"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0),
        e.labelRight ? (c(), H(Nr, {
          key: 1,
          id: I(o),
          label: e.labelRight,
          "info-right": e.labelRightInfo,
          class: "ml-auto",
          "data-testid": "dropdown-panel-header-label-right"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0)
      ])) : k("", !0),
      e.showSearch ? (c(), H(Zi, {
        key: 1,
        "model-value": e.searchQuery,
        placeholder: e.searchPlaceholder,
        "aria-label": e.searchLabel,
        "aria-labelledby": s.value,
        labels: { clear: e.searchClearLabel },
        size: "sm",
        "full-width": "",
        "onUpdate:modelValue": h[0] || (h[0] = (p) => l("update:searchQuery", p))
      }, null, 8, ["model-value", "placeholder", "aria-label", "aria-labelledby", "labels"])) : k("", !0),
      e.groupButtons.length ? (c(), H(Cg, {
        key: 2,
        "model-value": e.activeGroup ?? "",
        variant: "group",
        color: "dark",
        size: "sm",
        "label-left": e.groupLabelLeft,
        "label-left-info": e.groupLabelLeftInfo,
        "label-right": e.groupLabelRight,
        "label-right-info": e.groupLabelRightInfo,
        "aria-label": d.value ? void 0 : e.groupAriaLabel,
        class: "w-full",
        "data-testid": "dropdown-panel-header-group",
        "onUpdate:modelValue": h[1] || (h[1] = (p) => l("update:activeGroup", String(p)))
      }, {
        default: xe(() => [
          (c(!0), g(ce, null, Re(e.groupButtons, (p) => (c(), H(Be, {
            key: p.value,
            variant: "tertiary",
            size: "sm",
            label: p.label,
            value: p.value,
            shrink: "",
            class: "flex-1"
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      }, 8, ["model-value", "label-left", "label-left-info", "label-right", "label-right-info", "aria-label"])) : k("", !0)
    ], 512));
  }
});
function ro() {
  const e = R(0);
  function n(o, i) {
    var s;
    o && ((s = o.querySelector(`[data-listbox-index="${i}"]`)) == null || s.focus());
  }
  function t(o, i) {
    for (let s = 0; s < o; s++)
      if (!(i != null && i(s))) return s;
    return 0;
  }
  function a(o, i, s) {
    if (i === 0) return;
    let d;
    switch (o.key) {
      case "ArrowDown":
        d = (e.value + 1) % i;
        break;
      case "ArrowUp":
        d = (e.value - 1 + i) % i;
        break;
      case "Home":
        d = 0;
        break;
      case "End":
        d = i - 1;
        break;
      default:
        return;
    }
    o.preventDefault(), o.stopPropagation(), e.value = d, n(s, d);
  }
  function l(o, i, s, { downIndex: d = 0, upIndex: u = i - 1 } = {}) {
    if (o.key !== "ArrowDown" && o.key !== "ArrowUp" || i === 0) return !1;
    const f = o.key === "ArrowDown" ? d : u, b = s == null ? void 0 : s.querySelector(`[data-listbox-index="${f}"]`);
    return b ? (o.preventDefault(), e.value = f, b.focus({ preventScroll: !0 }), b.scrollIntoView({ block: "nearest" }), !0) : !1;
  }
  function r(o) {
    e.value = Math.min(e.value, Math.max(0, o - 1));
  }
  return {
    focusedIndex: e,
    focusListboxOption: n,
    handleRovingKeydown: a,
    handleSearchFieldKeydown: l,
    clampFocusedIndex: r,
    firstEnabledIndex: t
  };
}
const Yu = Symbol("FieldGroup"), Ow = { part: "", corners: "" };
function Ju(e) {
  const n = Nt(Yu, null);
  let t = null;
  return dt(() => {
    t = e.value, n && t && n.register(t);
  }), mt(() => {
    n && t && n.unregister(t);
  }), {
    inGroup: !!n,
    groupPart: m(() => n ? n.partOf(e.value) : Ow)
  };
}
const Pw = ["src"], Fw = ["src"], Vw = ["name", "value"], Nw = ["id", "aria-expanded", "aria-haspopup", "aria-labelledby", "aria-label", "aria-describedby", "aria-disabled", "aria-readonly", "aria-required", "aria-invalid", "tabindex", "onClick", "onKeydown"], Hw = {
  key: 0,
  class: "inline-flex size-4 shrink-0 items-center justify-center",
  "aria-hidden": "true",
  "data-testid": "select-prefix-flag"
}, jw = ["src"], Ww = {
  key: 2,
  class: "flex min-w-0 flex-1",
  "data-testid": "select-value"
}, qw = ["src"], Uw = ["role", "aria-labelledby", "aria-label"], Gw = ["onKeydown"], Kw = {
  key: 1,
  "aria-live": "polite",
  role: "status",
  class: "sr-only",
  "data-testid": "select-status"
}, Yw = {
  key: 0,
  "data-testid": "select-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, Jw = ["aria-labelledby", "aria-label"], Xw = ["aria-labelledby"], Zw = ["id"], Qw = {
  "data-testid": "select-no-results",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, xo = -1, El = /* @__PURE__ */ ke({
  __name: "SelectInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    options: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    helpIcon: { default: void 0 },
    prefixIcon: { default: void 0 },
    prefixFlag: { default: void 0 },
    iconLeft: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    noResultsLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    resultsLabel: { default: void 0 },
    seeAllLabel: { default: void 0 },
    createLabel: { default: void 0 },
    createIcon: { default: "ri-add-line" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur", "see-all", "create", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = je(), r = m(() => t.id || l), o = m(() => t.label ? `${r.value}-label` : void 0), i = m(() => `${r.value}-error`), s = m(() => `${r.value}-hint`), d = m(() => !!t.error), u = m(
      () => t.options.find((ie) => !ie.heading && ie.value === t.modelValue) ?? null
    ), f = m(() => {
      var Ce;
      const ie = (Ce = u.value) == null ? void 0 : Ce.iconColor;
      return ie && !t.disabled ? xg[ie] : void 0;
    }), b = m(() => {
      var ie;
      return ((ie = u.value) == null ? void 0 : ie.label) ?? "";
    }), h = m(() => {
      const ie = [];
      return t.hint && ie.push(s.value), d.value && ie.push(i.value), ie.length > 0 ? ie.join(" ") : void 0;
    }), p = R(!1), x = R(null), y = R(null), w = R(null), $ = (ie) => {
      var Ce, Fe;
      (Ce = y.value) == null || Ce.handleFieldKeydown(ie), (Fe = w.value) == null || Fe.handleFieldKeydown(ie);
    }, S = {
      sm: { container: "h-8 px-[calc(--spacing(2)-1px)] gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      md: { container: "h-9 px-3 py-2 gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      lg: { container: "h-12 px-3.5 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" },
      xl: { container: "h-13 px-4 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" }
    }, L = m(() => S[t.size]), T = (ie) => {
      const Ce = "relative flex items-center w-full rounded-xl border border-solid box-border text-left font-inter transition-colors select-none focus:outline-none";
      if (t.disabled)
        return `${Ce} bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Fe = p.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${Ce} cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${Fe} text-text-black-default dark:text-(--colors-text-white-default)`;
      }
      if (d.value) {
        const Fe = p.value ? " shadow-[0px_0px_2px_var(--border-border-accent)]" : "";
        return `${Ce} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)${Fe}`;
      }
      return p.value || ie ? `${Ce} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-[rgba(255,255,255,0.05)] dark:text-(--colors-text-white-default)` : `${Ce} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    }, E = m(() => !!t.label || t.labelInline && !!t.iconLeft), A = m(() => t.labelInline && E.value), D = m(() => Xl(t.labelInline, E.value, !1)), M = R(null), { inGroup: F, groupPart: X } = Ju(M), _ = m(() => t.fullWidth || F), Y = m(() => {
      const ie = `relative ${F ? X.value.part : "pb-0.5"} text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter`, Ce = A.value ? D.value.root : "flex flex-col gap-0.5";
      return `${ie} ${Ce} ${_.value ? "w-full" : ""}`;
    }), B = {
      xs: "min-h-8",
      sm: "min-h-9",
      md: "min-h-10",
      lg: "min-h-12",
      xl: "min-h-13"
    }, W = m(
      () => t.buttons.length > 0 && t.buttonLayout === "attached" ? B[t.buttonSize ?? za(t.size, "attached")] : ""
    ), U = m(() => _.value ? {} : { width: t.width }), z = m(() => t.labelInline && !_.value ? { width: t.width } : _.value ? {} : { width: t.width }), P = (ie) => !!ie && ie.startsWith("ri-"), K = (ie) => {
      a("update:modelValue", ie), a("change", ie);
    }, j = (ie, Ce) => {
      ie.disabled || (K(ie.value), ge.reset(), Ce(), Ue(() => {
        var Fe;
        return (Fe = x.value) == null ? void 0 : Fe.focus();
      }));
    }, G = (ie, Ce, Fe) => {
      ge.query.value.length > 0 || (Fe.preventDefault(), Fe.stopPropagation(), j(ie, Ce));
    }, q = R(null), { focusedIndex: J, focusListboxOption: me, handleRovingKeydown: ye, handleSearchFieldKeydown: Z, firstEnabledIndex: de } = ro(), ge = Uu(), se = R(""), Se = R(null), V = R(null), Q = m(() => {
      const ie = Ma(ge.query.value.trim()), Ce = [{ options: [] }];
      let Fe = 0;
      return t.options.forEach((Ke, _e) => {
        if (Ke.disabled, Ke.label, Ke.value, Ke.heading) {
          Ce.push({ heading: Ke, headingId: `${r.value}-group-${_e}`, options: [] });
          return;
        }
        (t.searchable ? qu(Ke.label, se.value) : !ie || Ma(Ke.label).startsWith(ie)) && Ce[Ce.length - 1].options.push({ option: Ke, index: Fe++ });
      }), Ce.filter((Ke) => Ke.options.length > 0);
    }), le = m(
      () => Q.value.flatMap((ie) => ie.options.map(({ option: Ce }) => Ce))
    ), ee = (ie) => {
      var Ce;
      return ((Ce = le.value[ie]) == null ? void 0 : Ce.disabled) === !0;
    };
    function O() {
      if (le.value.length === 0) return xo;
      const ie = le.value.findIndex((Ce) => Ce.value === t.modelValue);
      return ie >= 0 ? ie : de(le.value.length, ee);
    }
    function ne(ie) {
      me(q.value, ie);
    }
    $e(
      q,
      (ie) => {
        var Ce;
        if (!ie) {
          ge.reset(), se.value = "";
          return;
        }
        if (J.value = O(), t.searchable) {
          (Ce = V.value) == null || Ce.focusSearch();
          return;
        }
        J.value === xo ? ie.focus() : ne(J.value);
      },
      { flush: "post" }
    ), $e(
      le,
      () => {
        var Ce, Fe, Ke;
        if (!q.value) return;
        if ((Ce = Se.value) != null && Ce.contains(document.activeElement)) {
          J.value = O();
          return;
        }
        if (document.activeElement !== q.value && q.value.contains(document.activeElement)) {
          const _e = Number(
            (Fe = document.activeElement.closest("[data-listbox-index]")) == null ? void 0 : Fe.dataset.listboxIndex
          );
          if (!Number.isNaN(_e)) {
            J.value = _e;
            return;
          }
        }
        J.value = Math.min(Math.max(J.value, 0), le.value.length - 1), J.value === xo ? t.searchable ? (Ke = V.value) == null || Ke.focusSearch() : q.value.focus() : ne(J.value);
      },
      { flush: "post" }
    );
    const fe = (ie) => ie.key.length === 1 && !ie.ctrlKey && !ie.metaKey && !ie.altKey;
    function ue(ie) {
      var Ce;
      if (t.searchable) {
        if (ie.key === "Tab" && (ie.shiftKey || ve.value)) {
          ie.stopPropagation();
          return;
        }
        const Fe = ie.key === "Backspace";
        if (Fe || fe(ie) && ie.key !== " ") {
          ie.preventDefault(), ie.stopPropagation(), se.value = Fe ? se.value.slice(0, -1) : se.value + ie.key, (Ce = V.value) == null || Ce.focusSearch();
          return;
        }
      } else if (ge.handleKey(ie)) {
        ie.preventDefault(), ie.stopPropagation();
        return;
      }
      ye(ie, le.value.length, q.value);
    }
    const te = (ie, Ce) => ({
      ...{
        type: ie.badgeTheme ? "badge" : t.searchable ? "autocomplete" : "default",
        label: ie.label,
        icon: ie.badgeTheme ? void 0 : ie.icon,
        iconColor: ie.iconColor,
        badge: ie.badgeTheme ? { label: ie.label, theme: ie.badgeTheme, icon: ie.icon } : void 0,
        highlighted: ie.value === t.modelValue,
        ariaDisabled: !!ie.disabled,
        description: ie.disabled ? ie.disabledReason : void 0
      },
      role: "option",
      "aria-selected": ie.value === t.modelValue,
      tabindex: Ce === J.value ? 0 : -1,
      "data-listbox-index": Ce,
      "data-testid": `select-option-${ie.value}`,
      style: ie.fontFamily ? { fontFamily: ie.fontFamily } : void 0
    }), oe = (ie, Ce, Fe) => ({
      click: () => j(ie, Fe),
      focus: () => {
        J.value = Ce;
      },
      keydown: (Ke) => {
        Ke.key === "Enter" ? (Ke.preventDefault(), j(ie, Fe)) : Ke.key === " " && G(ie, Fe, Ke);
      }
    }), Le = m(
      () => t.searchLabel ?? t.searchPlaceholder ?? t.label ?? t.ariaLabel
    ), Ie = m(() => {
      if (!(t.searchable ? se.value : ge.query.value)) return "";
      const Ce = le.value.length;
      return t.searchable ? Ce === 0 && t.noResultsLabel ? t.noResultsLabel : Hu(t.resultsCountLabel, Ce) : String(Ce);
    }), ve = m(() => t.searchable && !!(t.seeAllLabel || t.createLabel)), we = (ie) => {
      ie(), Ue(() => {
        var Ce;
        return (Ce = x.value) == null ? void 0 : Ce.focus();
      });
    };
    function he(ie, Ce) {
      we(Ce), a(ie === "see-all" ? "see-all" : "create");
    }
    function Me(ie, Ce) {
      const Fe = le.value.length;
      switch (ie.key) {
        case "ArrowDown":
        case "ArrowUp":
          ie.preventDefault(), ie.stopPropagation(), Z(ie, Fe, q.value, { downIndex: Math.max(J.value, 0) });
          break;
        case "Home":
        case "End":
          ie.stopPropagation();
          break;
        case "Tab":
          ie.shiftKey ? (ie.preventDefault(), ie.stopPropagation(), we(Ce)) : (J.value !== xo || ve.value) && ie.stopPropagation();
          break;
      }
    }
    function Ee(ie) {
      if (ie.key !== "Tab") return;
      const Ce = ie.currentTarget.querySelectorAll("button, a[href]");
      (ie.shiftKey || ie.target !== Ce[Ce.length - 1]) && ie.stopPropagation();
    }
    let He = !1;
    const Ge = (ie) => {
      var Ce;
      return ((Ce = ie.target) == null ? void 0 : Ce.closest("[data-field-label-tooltip]")) != null;
    }, Ze = (ie) => {
      Ge(ie) || (He = q.value !== null);
    }, ae = (ie) => {
      var Fe, Ke;
      if (Ge(ie)) return;
      const Ce = He;
      if (He = !1, !t.disabled) {
        if (Ce) {
          (Fe = x.value) == null || Fe.focus();
          return;
        }
        (Ke = x.value) == null || Ke.click();
      }
    };
    return (ie, Ce) => (c(), g("div", {
      ref_key: "rootRef",
      ref: M,
      class: C(Y.value),
      style: Ne(e.labelInline ? {} : U.value)
    }, [
      E.value ? (c(), g("div", {
        key: 0,
        class: C([
          "flex min-w-0 max-w-full items-center gap-1",
          e.labelInline ? "shrink-0" : "",
          !e.disabled && !e.readonly ? "cursor-pointer" : ""
        ]),
        onMousedown: Ze,
        onClick: ae
      }, [
        e.iconLeft && e.labelInline ? (c(), g("img", {
          key: 0,
          src: e.iconLeft,
          class: "mr-1 h-6 w-6 rounded-full object-cover shrink-0",
          alt: ""
        }, null, 8, Pw)) : k("", !0),
        e.label ? (c(), H(yt, {
          key: 1,
          id: o.value,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: p.value,
          inline: e.labelInline,
          "test-id": "select-label"
        }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "inline"])) : k("", !0),
        e.helpIcon && !e.labelTooltip ? (c(), g(ce, { key: 2 }, [
          P(e.helpIcon) ? (c(), g("i", {
            key: 0,
            class: C([e.helpIcon, "text-(length:--size-m) leading-(--line-height-s) text-(--text-text-body-subtle) ml-0.5 cursor-help"])
          }, null, 2)) : (c(), g("img", {
            key: 1,
            src: e.helpIcon,
            class: "h-3.5 w-3.5 ml-0.5 cursor-help",
            alt: "Help"
          }, null, 8, Fw))
        ], 64)) : k("", !0)
      ], 34)) : k("", !0),
      v("div", {
        style: Ne(z.value),
        class: C([{ "w-full": _.value }, A.value ? D.value.field : ""])
      }, [
        v("input", {
          type: "hidden",
          name: e.name,
          value: e.modelValue
        }, null, 8, Vw),
        re(lo, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: Ce[3] || (Ce[3] = (Fe) => a("button-click", Fe))
        }, {
          default: xe(({ fieldClass: Fe }) => [
            re(ln, {
              "full-width": !0,
              "menu-width": z.value.width ?? "100%",
              disabled: e.disabled,
              bare: ""
            }, {
              trigger: xe(({ toggle: Ke, isOpen: _e }) => {
                var Et, De, ze;
                return [
                  v("div", {
                    id: r.value,
                    ref_key: "triggerRef",
                    ref: x,
                    role: "combobox",
                    "aria-expanded": _e,
                    "aria-haspopup": e.searchable ? "dialog" : "listbox",
                    "aria-labelledby": o.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-describedby": h.value,
                    "aria-disabled": e.disabled ? "true" : void 0,
                    "aria-readonly": e.readonly ? "true" : void 0,
                    "aria-required": e.required ? "true" : void 0,
                    "aria-invalid": d.value ? "true" : void 0,
                    tabindex: e.disabled ? -1 : 0,
                    "data-testid": "select-input",
                    class: C([T(_e), L.value.container, W.value, Fe || I(X).corners]),
                    onClick: (We) => !e.disabled && !e.readonly && Ke(),
                    onKeydown: [
                      (We) => !_e && $(We),
                      ut(Ye((We) => !e.disabled && !e.readonly && Ke(), ["prevent"]), ["enter"]),
                      ut(Ye((We) => !e.disabled && !e.readonly && Ke(), ["prevent"]), ["space"])
                    ],
                    onFocus: Ce[0] || (Ce[0] = (We) => {
                      p.value = !0, ie.$emit("focus");
                    }),
                    onBlur: Ce[1] || (Ce[1] = (We) => {
                      p.value = !1, ie.$emit("blur");
                    })
                  }, [
                    e.prefixFlag ? (c(), g("span", Hw, [
                      v("span", {
                        class: C(["fi fis size-[13.33px] rounded-full", `fi-${e.prefixFlag.toLowerCase()}`])
                      }, null, 2)
                    ])) : e.prefixIcon ? (c(), g(ce, { key: 1 }, [
                      P(e.prefixIcon) ? (c(), g("i", {
                        key: 0,
                        class: C([e.prefixIcon, "shrink-0 text-base leading-none", L.value.icon])
                      }, null, 2)) : (c(), g("img", {
                        key: 1,
                        src: e.prefixIcon,
                        class: C(["shrink-0 object-cover", L.value.icon]),
                        alt: ""
                      }, null, 10, jw))
                    ], 64)) : k("", !0),
                    (Et = u.value) != null && Et.badgeTheme ? (c(), g("span", Ww, [
                      re(ct, {
                        label: u.value.label,
                        theme: u.value.badgeTheme,
                        "left-icon": u.value.icon,
                        size: "sm",
                        "data-testid": "select-value-badge"
                      }, null, 8, ["label", "theme", "left-icon"])
                    ])) : (c(), g(ce, { key: 3 }, [
                      (De = u.value) != null && De.icon && !e.prefixFlag && !e.prefixIcon ? (c(), g(ce, { key: 0 }, [
                        P(u.value.icon) ? (c(), g("i", {
                          key: 0,
                          class: C([u.value.icon, "shrink-0 text-(length:--icon-size-sm) leading-(--icon-size-sm)", L.value.icon, f.value]),
                          "aria-hidden": "true",
                          "data-testid": "select-value-icon"
                        }, null, 2)) : (c(), g("img", {
                          key: 1,
                          src: u.value.icon,
                          class: C(["shrink-0 object-cover", L.value.icon]),
                          alt: "",
                          "data-testid": "select-value-icon"
                        }, null, 10, qw))
                      ], 64)) : k("", !0),
                      v("span", {
                        class: C(["flex min-w-0 flex-1", [
                          L.value.text,
                          e.disabled ? "" : b.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                        ]]),
                        style: Ne((ze = u.value) != null && ze.fontFamily ? { fontFamily: u.value.fontFamily } : void 0),
                        "data-testid": "select-value"
                      }, [
                        re(ht, {
                          text: b.value || e.placeholder || "",
                          focusable: !1
                        }, null, 8, ["text"])
                      ], 6)
                    ], 64)),
                    v("i", {
                      class: C(["ri-arrow-down-s-line shrink-0 text-base leading-none transition-transform duration-200 ease-in-out", [L.value.icon, e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)"]]),
                      style: Ne({ transform: _e ? "rotate(180deg)" : "rotate(0deg)" })
                    }, null, 6)
                  ], 42, Nw)
                ];
              }),
              menu: xe(({ close: Ke }) => [
                v("div", {
                  role: e.searchable ? "dialog" : void 0,
                  "aria-labelledby": e.searchable ? o.value : void 0,
                  "aria-label": e.searchable && !e.label ? e.ariaLabel : void 0,
                  "data-testid": "select-panel",
                  class: C(
                    e.searchable ? "flex max-h-[calc(100vh-90px)] flex-col" : "box-border flex max-h-[min(400px,calc(100vh-24px))] flex-col gap-1.5 overflow-y-auto p-[calc(--spacing(2)-1px)]"
                  )
                }, [
                  e.searchable ? (c(), g("div", {
                    key: 0,
                    ref_key: "searchAreaRef",
                    ref: Se,
                    class: "shrink-0",
                    onKeydown: (_e) => Me(_e, Ke)
                  }, [
                    re(cl, {
                      ref_key: "headerRef",
                      ref: V,
                      "show-search": "",
                      "search-query": se.value,
                      "search-placeholder": e.searchPlaceholder,
                      "search-label": Le.value,
                      "onUpdate:searchQuery": Ce[2] || (Ce[2] = (_e) => se.value = _e)
                    }, null, 8, ["search-query", "search-placeholder", "search-label"])
                  ], 40, Gw)) : k("", !0),
                  e.searchable || I(ge).query.value ? (c(), g("span", Kw, N(Ie.value), 1)) : k("", !0),
                  v("div", {
                    "data-testid": "select-list",
                    class: C(
                      e.searchable ? ["flex max-h-100 min-h-0 flex-col overflow-y-auto p-1", !le.value.length && "hidden"] : "contents"
                    )
                  }, [
                    e.searchable && e.resultsLabel ? (c(), g("div", Yw, N(e.resultsLabel), 1)) : k("", !0),
                    v("ul", {
                      ref_key: "listboxRef",
                      ref: q,
                      role: "listbox",
                      "aria-labelledby": o.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      tabindex: "-1",
                      class: C(["flex w-full flex-col focus-visible:outline-none", !e.searchable && "gap-1.5"]),
                      onKeydown: ue
                    }, [
                      (c(!0), g(ce, null, Re(Q.value, (_e) => (c(), g(ce, {
                        key: _e.headingId ?? "ungrouped"
                      }, [
                        _e.heading ? (c(), g("li", {
                          key: 0,
                          role: "group",
                          "aria-labelledby": _e.headingId,
                          class: C(["flex flex-col", !e.searchable && "gap-1.5"])
                        }, [
                          v("div", {
                            id: _e.headingId,
                            role: "presentation",
                            "data-testid": "select-group-heading",
                            class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                          }, N(_e.heading.label), 9, Zw),
                          (c(!0), g(ce, null, Re(_e.options, ({ option: Et, index: De }) => (c(), H(Kt, Oe({
                            key: Et.value,
                            as: "div"
                          }, { ref_for: !0 }, te(Et, De), Ml(oe(Et, De, Ke))), null, 16))), 128))
                        ], 10, Xw)) : (c(!0), g(ce, { key: 1 }, Re(_e.options, ({ option: Et, index: De }) => (c(), H(Kt, Oe({
                          key: Et.value,
                          as: "li"
                        }, { ref_for: !0 }, te(Et, De), Ml(oe(Et, De, Ke))), null, 16))), 128))
                      ], 64))), 128))
                    ], 42, Jw)
                  ], 2),
                  le.value.length === 0 && e.noResultsLabel ? (c(), g("div", {
                    key: 2,
                    class: C(e.searchable && "p-1")
                  }, [
                    v("div", Qw, N(e.noResultsLabel), 1)
                  ], 2)) : k("", !0),
                  ve.value ? (c(), H(ul, {
                    key: 3,
                    type: "see-all-create",
                    "see-all-label": e.seeAllLabel,
                    "create-label": e.createLabel,
                    "create-icon": e.createIcon,
                    class: "shrink-0",
                    onKeydown: Ee,
                    onSeeAll: (_e) => he("see-all", Ke),
                    onCreate: (_e) => he("create", Ke)
                  }, null, 8, ["see-all-label", "create-label", "create-icon", "onSeeAll", "onCreate"])) : k("", !0)
                ], 10, Uw)
              ]),
              _: 2
            }, 1032, ["menu-width", "disabled"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"])
      ], 6),
      !I(F) && D.value.reservesHelper || e.hint || e.error ? (c(), H(xt, {
        key: 1,
        ref_key: "helperRef",
        ref: w,
        class: C(A.value ? D.value.helper : ""),
        focused: p.value,
        hint: e.hint,
        error: e.error,
        "hint-id": s.value,
        "error-id": i.value,
        "error-live": e.errorLive,
        "test-id-prefix": "select"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "error-live"])) : k("", !0)
    ], 6));
  }
}), As = "None", Ed = /* @__PURE__ */ ke({
  __name: "AccessLevelSelect",
  props: {
    modelValue: {},
    label: {},
    levels: {},
    allowNone: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    hint: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => [
      { value: "Edit", label: t.levels.edit, disabled: t.disabledLevels.includes("Edit") },
      { value: "View", label: t.levels.view, disabled: t.disabledLevels.includes("View") },
      ...t.allowNone ? [{ value: As, label: t.levels.none }] : []
    ]), r = m(() => t.modelValue ?? As), o = m(() => l.value.every((s) => s.disabled)), i = (s) => {
      a("update:modelValue", s === As ? null : s);
    };
    return (s, d) => (c(), H(El, {
      "model-value": r.value,
      options: l.value,
      label: e.label,
      disabled: e.disabled || o.value,
      hint: e.hint,
      "full-width": "",
      "onUpdate:modelValue": i
    }, null, 8, ["model-value", "options", "label", "disabled", "hint"]));
  }
});
function Qi(e, n, t = {}) {
  const { ignoreSelectors: a, ignoreElements: l, isActive: r } = t, o = (i) => {
    if (r && !r()) return;
    const s = e.value, d = i.target;
    if (!(!s || !d || s.contains(d)) && d.isConnected && !(l != null && l().some((u) => u && u.contains(d)))) {
      if (a != null && a.length) {
        const u = d instanceof Element ? d : d.parentElement;
        if (u && a.some((f) => u.closest(f))) return;
      }
      n();
    }
  };
  dt(() => {
    document.addEventListener("click", o, !0);
  }), gt(() => {
    document.removeEventListener("click", o, !0);
  });
}
function Zl(e = {}) {
  const { defaultOpen: n = !1, onClose: t, ignoreSelectors: a } = e, l = R(n), r = R(null), o = () => {
    l.value = !l.value;
  }, i = () => {
    l.value = !0;
  }, s = () => {
    l.value = !1, t == null || t();
  };
  return Qi(r, s, { ignoreSelectors: a }), {
    isOpen: l,
    dropdownRef: r,
    toggleDropdown: o,
    openDropdown: i,
    closeDropdown: s
  };
}
const FW = /* @__PURE__ */ ke({
  __name: "ButtonLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), H(yg, Oe(n, { underline: "always" }), {
      default: xe(() => [
        Ae(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function _w(e) {
  const n = R(null), t = R(null);
  function a(i) {
    n.value = i;
  }
  function l(i) {
    n.value !== i && (t.value = i);
  }
  function r(i) {
    const s = n.value;
    if (!s || s === i) return;
    const d = e.value.find((b) => b.id === s), u = e.value.find((b) => b.id === i);
    if (!d || !u || u.disabled) return;
    const f = d.order;
    d.order = u.order, u.order = f, n.value = null, t.value = null;
  }
  function o() {
    n.value = null, t.value = null;
  }
  return { draggedId: n, dragOverId: t, onDragStart: a, onDragOver: l, onDrop: r, onDragEnd: o };
}
const Xu = {
  m: "320px",
  l: "498px",
  xl: "768px"
}, e1 = ["aria-expanded"], t1 = ["src"], n1 = { class: "relative dark:text-(--colors-text-white-default)" }, a1 = ["src"], l1 = ["aria-label"], r1 = {
  key: 1,
  "data-testid": "filter-dropdown-content",
  class: "flex min-h-0 flex-col gap-1.5 pb-2"
}, o1 = ["role", "aria-label", "aria-multiselectable"], i1 = ["role"], s1 = ["role", "onFocusin"], d1 = { key: 1 }, wf = '[data-testid="dropdown-list-item-more-actions-trigger"]', Es = "text-(length:--icon-size-sm) leading-(--icon-size-sm)", Zu = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "FilterDropdown",
  props: {
    label: { default: "Filters" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    size: { default: void 0 },
    menuWidth: { default: "auto" },
    menuAlign: { default: "left" },
    tab: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    headerLabelLeft: { default: void 0 },
    headerLabelRight: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: "Search…" },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    groupButtonsLabel: { default: void 0 },
    activeGroupButton: { default: void 0 },
    items: { default: () => [] },
    maxListHeight: { default: void 0 },
    reserveListHeight: { type: Boolean, default: !1 },
    emptyLabel: { default: void 0 },
    emptyIcon: { default: void 0 },
    checkboxPosition: { default: void 0 },
    moreActionsLabel: { default: "More actions" },
    footerLabel: { default: void 0 },
    footerButtons: { default: () => [] },
    stickyItem: { default: void 0 },
    disableInternalSearchFilter: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    freezeOnOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:searchQuery", "update:activeGroupButton", "open", "close", "reorder"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, { isOpen: r, dropdownRef: o, toggleDropdown: i, openDropdown: s, closeDropdown: d } = Zl({
      defaultOpen: a.defaultOpen,
      ignoreSelectors: ['[data-testid="dropdown-menu"]']
    }), u = R(null), f = R(null), b = R(null), h = R(null), p = R(null), x = R(null);
    function y() {
      var Ce, Fe;
      const ae = ((Ce = f.value) == null ? void 0 : Ce.$el) ?? u.value;
      if (ae) return ae;
      const ie = ((Fe = o.value) == null ? void 0 : Fe.querySelectorAll("[aria-expanded]")) ?? [];
      return Array.from(ie).find((Ke) => !Ke.closest('[data-testid="filter-dropdown-menu"]')) ?? null;
    }
    function w() {
      if (!a.freezeOnOpen) return;
      const ae = y() ?? o.value;
      if (!ae) return;
      const ie = ae.getBoundingClientRect();
      x.value = a.menuAlign === "right" ? { top: ie.bottom + 4, right: Math.max(0, window.innerWidth - ie.right) } : { top: ie.bottom + 4, left: ie.left };
    }
    function $() {
      d(), Ue(() => {
        var ae;
        return (ae = y()) == null ? void 0 : ae.focus();
      });
    }
    const S = (ae) => {
      r.value && (ae.stopPropagation(), ae.preventDefault(), $());
    }, L = (ae) => {
      var Ce;
      const ie = a.footerButtons[ae];
      !ie || ie.disabled || ((Ce = ie.onClick) == null || Ce.call(ie), ie.keepOpen || $());
    };
    function T() {
      var ae, ie;
      (ae = p.value) != null && ae.focusSearch() || (ie = b.value) == null || ie.focus();
    }
    n({ openDropdown: s, closeDropdown: d, isOpen: r }), $e(
      r,
      (ae) => {
        ae ? (w(), l("open"), T()) : (x.value = null, l("close"));
      },
      { flush: "post" }
    );
    const E = m(() => {
      var Ce, Fe;
      let ae = a.items ?? [];
      a.activeGroupButton && ((Ce = a.groupButtons) != null && Ce.length) && (ae = ae.filter((Ke) => !Ke.group || Ke.group === a.activeGroupButton));
      const ie = (Fe = a.searchQuery) == null ? void 0 : Fe.trim().toLowerCase();
      return ie && !a.disableInternalSearchFilter && (ae = ae.filter((Ke) => Ke.label.toLowerCase().includes(ie))), ae;
    }), A = R([]);
    $e(
      E,
      (ae) => {
        A.value = ae.map((ie, Ce) => ({ id: ie.id, order: Ce, disabled: ie.disabled }));
      },
      { immediate: !0, deep: !1 }
    );
    const { onDragStart: D, onDragOver: M, onDrop: F, onDragEnd: X } = _w(A), _ = m(() => {
      if (!a.reorderable) return E.value;
      const ae = new Map(E.value.map((ie) => [ie.id, ie]));
      return [...A.value].sort((ie, Ce) => ie.order - Ce.order).map((ie) => ae.get(ie.id)).filter((ie) => !!ie);
    });
    function Y(ae) {
      F(ae), l("reorder", [...A.value].sort((ie, Ce) => ie.order - Ce.order).map((ie) => ie.id));
    }
    const B = m(
      () => {
        var ae, ie, Ce;
        return !!((ae = a.headerLabelLeft) != null && ae.text || (ie = a.headerLabelRight) != null && ie.text || a.showSearch || (Ce = a.groupButtons) != null && Ce.length);
      }
    ), W = m(() => !!a.stickyItem), U = m(() => _.value.length > 0), z = m(() => !U.value && !!a.emptyLabel), P = m(
      () => z.value || !U.value && a.reserveListHeight && !!a.maxListHeight
    ), K = m(() => W.value || U.value), j = m(() => {
      var ae;
      return a.ariaLabel || ((ae = a.headerLabelLeft) == null ? void 0 : ae.text) || a.label;
    }), G = m(
      () => {
        var ae, ie, Ce;
        return !!((ae = a.items) != null && ae.some((Fe) => Fe.hasCheckbox || Fe.hasSwitch)) || !!((ie = a.stickyItem) != null && ie.hasCheckbox) || !!((Ce = a.stickyItem) != null && Ce.hasSwitch);
      }
    ), q = m(() => {
      var ae;
      return !!((ae = a.items) != null && ae.some((ie) => {
        var Ce;
        return (Ce = ie.moreActions) == null ? void 0 : Ce.length;
      }));
    }), J = m(() => {
      var ae, ie;
      return !!((ae = a.items) != null && ae.some((Ce) => Ce.hasCheckbox)) || !!((ie = a.stickyItem) != null && ie.hasCheckbox);
    }), me = m(() => [
      "flex flex-col px-2",
      J.value ? "gap-0.5" : "gap-0",
      W.value ? "py-0.5" : "py-1.5"
    ]), ye = m(
      () => a.maxListHeight ? { [a.reserveListHeight ? "height" : "maxHeight"]: a.maxListHeight } : {}
    );
    function Z(ae) {
      return ae.hasSwitch ? "toggle" : ae.hasCheckbox ? ae.badgeTheme ? "badge-checkbox" : "checkbox" : ae.badgeTheme ? "badge" : "default";
    }
    function de(ae) {
      return ae.map((ie) => ({ label: ie.label, icon: ie.icon, danger: ie.variant === "danger", onClick: ie.onClick }));
    }
    const ge = m(() => {
      const ae = /* @__PURE__ */ new Map();
      for (const ie of [a.stickyItem, ...a.items ?? []])
        ie != null && ie.moreActions && ae.set(ie.id, de(ie.moreActions));
      return ae;
    });
    function se(ae) {
      return Z(ae) === "checkbox" && ae.count !== void 0 ? `(${ae.count})` : void 0;
    }
    function Se(ae, ie) {
      var Fe, Ke;
      const Ce = Z(ae);
      return {
        as: "div",
        type: Ce,
        label: ae.label,
        icon: Ce === "default" ? ae.icon : void 0,
        count: se(ae),
        badge: ae.badgeTheme ? { label: ae.label, theme: ae.badgeTheme, rightIcon: ae.badgeRightIcon } : void 0,
        checked: Ce === "toggle" ? !!ae.switchChecked : !!ae.checked,
        indeterminate: !!ae.indeterminate,
        ariaDisabled: !!ae.disabled,
        // The reason wins: it is what the user needs to know about a disabled option.
        description: ae.disabled && ae.disabledReason || ae.secondaryText,
        moreActions: ge.value.get(ae.id),
        moreActionsLabel: (Fe = ae.moreActions) != null && Fe.length ? a.moreActionsLabel : void 0,
        moreActionsTabindex: (Ke = ae.moreActions) != null && Ke.length ? fe(ie, 1) ? 0 : -1 : void 0
      };
    }
    function V(ae) {
      var ie;
      ae && !ae.disabled && ((ie = ae.onClick) == null || ie.call(ae));
    }
    const { focusedIndex: Q, handleRovingKeydown: le, handleSearchFieldKeydown: ee, clampFocusedIndex: O } = ro(), ne = R(0);
    function fe(ae, ie) {
      return Q.value === ae && (q.value ? ne.value === ie : ie === 0);
    }
    function ue(ae) {
      return W.value ? ae + 1 : ae;
    }
    const te = m(() => _.value.length + (W.value ? 1 : 0));
    $e(te, (ae) => O(ae));
    function oe(ae) {
      return ae.hasSwitch ? "switch" : ae.hasCheckbox ? "checkbox" : "button";
    }
    function Le(ae) {
      if (ae.hasSwitch) return ae.switchChecked ? "true" : "false";
      if (ae.hasCheckbox) return ae.indeterminate ? "mixed" : ae.checked ? "true" : "false";
    }
    function Ie(ae, ie) {
      return {
        role: q.value ? oe(ae) : "option",
        "aria-selected": q.value ? void 0 : !!(ae.checked || ae.switchChecked),
        "aria-checked": q.value ? Le(ae) : void 0,
        "aria-label": [ae.label, se(ae)].filter(Boolean).join(" "),
        tabindex: fe(ie, 0) ? 0 : -1,
        "data-listbox-index": ie,
        onClick: () => V(ae),
        onKeydown: ut(Ye(() => V(ae), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          Q.value = ie, ne.value = 0;
        }
      };
    }
    function ve(ae, ie) {
      var Ce;
      (Ce = ae.target) != null && Ce.closest(wf) && (Q.value = ie, ne.value = 1);
    }
    function we(ae) {
      if (ae.key !== "ArrowRight" && ae.key !== "ArrowLeft") return !1;
      const ie = ae.target, Ce = ie.closest('[role="listitem"]');
      if (!Ce) return !1;
      const Fe = Ce.querySelector("[data-listbox-index]"), Ke = Ce.querySelector(wf), _e = ae.key === "ArrowRight" ? Ke : Fe;
      return !_e || _e === ie || !Fe ? !1 : (ae.preventDefault(), Q.value = Number(Fe.dataset.listboxIndex), ne.value = _e === Ke ? 1 : 0, _e.focus(), !0);
    }
    function he(ae) {
      if (!ae.defaultPrevented) {
        if (q.value) {
          if (we(ae)) return;
          ["ArrowDown", "ArrowUp", "Home", "End"].includes(ae.key) && (ne.value = 0);
        }
        le(ae, te.value, h.value);
      }
    }
    function Me(ae) {
      if (ae.defaultPrevented) return;
      const ie = ae.target;
      !(ie instanceof HTMLTextAreaElement || ie instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit", "reset"].includes(ie.type)) && ie !== b.value || ee(ae, te.value, h.value) && (ne.value = 0);
    }
    const Ee = m(() => {
      const [ae, ie] = a.footerButtons.slice(0, 2).map((Fe) => ({ label: Fe.label, variant: Fe.variant, icon: Fe.icon, disabled: Fe.disabled }));
      if (!ae) return null;
      const Ce = a.footerLabel;
      return ie ? Ce ? { type: "buttons-column", buttons: [ae, ie], label: Ce } : { type: "buttons-inline", buttons: [ae, ie] } : Ce ? { type: "label-button", buttons: [ae], label: Ce } : { type: "button", buttons: [ae] };
    }), He = m(() => a.size ? { width: Xu[a.size] } : a.menuWidth && a.menuWidth !== "auto" ? { width: a.menuWidth, maxWidth: "594px" } : { maxWidth: "594px" }), Ge = m(() => {
      if (!x.value) return He.value;
      const ae = { position: "fixed", top: `${x.value.top}px` };
      return x.value.left !== void 0 ? ae.left = `${x.value.left}px` : x.value.right !== void 0 && (ae.right = `${x.value.right}px`), { ...ae, ...He.value };
    }), Ze = (ae) => !!ae && ae.startsWith("ri-");
    return (ae, ie) => (c(), g("div", Oe({
      ref_key: "dropdownRef",
      ref: o
    }, ae.$attrs, {
      class: ["relative dark:text-(--colors-text-white-default)", e.tab ? "flex h-full items-stretch" : "inline-block text-left"],
      onKeydown: ut(S, ["escape"])
    }), [
      Ae(ae.$slots, "trigger", {
        toggle: I(i),
        isOpen: I(r)
      }, () => [
        e.tab ? (c(), g("button", {
          key: 0,
          ref_key: "triggerRef",
          ref: u,
          type: "button",
          "data-testid": "filter-dropdown-trigger",
          class: "inline-flex shrink-0 h-full cursor-pointer items-center gap-1.5 px-3 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-black-default) transition-colors duration-200 hover:bg-whitesmoke focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10",
          "aria-expanded": I(r),
          "aria-haspopup": "dialog",
          onClick: ie[0] || (ie[0] = //@ts-ignore
          (...Ce) => I(i) && I(i)(...Ce))
        }, [
          e.triggerIconLeft ? (c(), g(ce, { key: 0 }, [
            Ze(e.triggerIconLeft) ? (c(), g("i", {
              key: 0,
              class: C([e.triggerIconLeft, Es]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              class: "h-4 w-4",
              src: e.triggerIconLeft,
              alt: ""
            }, null, 8, t1))
          ], 64)) : k("", !0),
          v("span", n1, N(e.label), 1),
          e.triggerIcon ? (c(), g(ce, { key: 1 }, [
            Ze(e.triggerIcon) ? (c(), g("i", {
              key: 0,
              class: C([e.triggerIcon, Es, "transition-transform duration-200 ease-in-out"]),
              style: Ne({ transform: I(r) ? "rotate(180deg)" : "rotate(0deg)" }),
              "aria-hidden": "true"
            }, null, 6)) : (c(), g("img", {
              key: 1,
              class: "h-4 w-4 transition-transform duration-200 ease-in-out",
              style: Ne({ transform: I(r) ? "rotate(180deg)" : "rotate(0deg)" }),
              src: e.triggerIcon,
              alt: ""
            }, null, 12, a1))
          ], 64)) : (c(), g("i", {
            key: 2,
            class: C(["ri-arrow-down-s-line", Es, "transition-transform duration-200 ease-in-out"]),
            style: Ne({ transform: I(r) ? "rotate(180deg)" : "rotate(0deg)" }),
            "aria-hidden": "true"
          }, null, 6))
        ], 8, e1)) : (c(), H(I(Be), {
          key: 1,
          ref_key: "triggerButtonRef",
          ref: f,
          "data-testid": "filter-dropdown-trigger",
          size: "xs",
          variant: "secondary",
          label: e.label,
          "icon-left": e.triggerIconLeft,
          "icon-right": e.triggerIcon,
          "dropdown-icon": !e.triggerIcon,
          "aria-expanded": I(r),
          "aria-haspopup": "dialog",
          onClick: I(i)
        }, null, 8, ["label", "icon-left", "icon-right", "dropdown-icon", "aria-expanded", "onClick"]))
      ]),
      re(wt, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: xe(() => {
          var Ce, Fe, Ke;
          return [
            I(r) ? (c(), g("div", {
              key: 0,
              ref_key: "menuRef",
              ref: b,
              role: "dialog",
              "aria-label": j.value,
              "data-testid": "filter-dropdown-menu",
              tabindex: "-1",
              class: C([
                I(Wa),
                "z-50 flex min-w-[220px] flex-col overflow-hidden focus-visible:outline-none",
                x.value ? "" : ["absolute top-full mt-1", e.menuAlign === "right" ? "right-0" : "left-0"]
              ]),
              style: Ne(Ge.value),
              onKeydown: Me
            }, [
              B.value ? (c(), H(cl, {
                key: 0,
                ref_key: "headerRef",
                ref: p,
                "label-left": (Ce = e.headerLabelLeft) == null ? void 0 : Ce.text,
                "label-right": (Fe = e.headerLabelRight) == null ? void 0 : Fe.text,
                "show-search": e.showSearch,
                "search-query": e.searchQuery,
                "search-placeholder": e.searchPlaceholder,
                "search-clear-label": e.searchClearLabel,
                "group-buttons": e.groupButtons,
                "active-group": e.activeGroupButton,
                "group-label-left": e.groupButtonsLabel,
                "group-aria-label": ((Ke = e.headerLabelLeft) == null ? void 0 : Ke.text) || e.label,
                class: "shrink-0",
                "onUpdate:searchQuery": ie[1] || (ie[1] = (_e) => l("update:searchQuery", _e)),
                "onUpdate:activeGroup": ie[2] || (ie[2] = (_e) => l("update:activeGroupButton", _e))
              }, null, 8, ["label-left", "label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"])) : k("", !0),
              K.value || P.value ? (c(), g("div", r1, [
                K.value ? (c(), g("div", {
                  key: 0,
                  ref_key: "listboxRef",
                  ref: h,
                  role: q.value ? "list" : "listbox",
                  "aria-label": j.value,
                  "aria-multiselectable": G.value && !q.value ? "true" : void 0,
                  class: "flex min-h-0 flex-col",
                  onKeydown: he
                }, [
                  e.stickyItem ? (c(), g("div", {
                    key: 0,
                    "data-testid": "filter-dropdown-select-all",
                    role: q.value ? "listitem" : void 0,
                    class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
                  }, [
                    re(Kt, Oe({ ...Se(e.stickyItem, 0), ...Ie(e.stickyItem, 0) }, { "data-testid": "filter-dropdown-sticky-item" }), null, 16)
                  ], 8, i1)) : k("", !0),
                  U.value ? (c(), g("div", {
                    key: 1,
                    "data-testid": "filter-dropdown-list",
                    class: C(["min-h-0", { "overflow-y-auto": !!e.maxListHeight }]),
                    style: Ne(ye.value)
                  }, [
                    v("div", {
                      class: C(me.value)
                    }, [
                      (c(!0), g(ce, null, Re(_.value, (_e, Et) => (c(), g("div", {
                        key: _e.id,
                        role: q.value ? "listitem" : void 0,
                        class: "flex",
                        onFocusin: (De) => ve(De, ue(Et))
                      }, [
                        re(Kt, Oe({ ref_for: !0 }, { ...Se(_e, ue(Et)), ...Ie(_e, ue(Et)) }, {
                          class: "filter-item-row",
                          "data-testid": `filter-dropdown-item-${_e.id}`,
                          draggable: e.reorderable && !_e.disabled,
                          onDragstart: (De) => e.reorderable && I(D)(_e.id),
                          onDragover: Ye((De) => e.reorderable && I(M)(_e.id), ["prevent"]),
                          onDrop: (De) => e.reorderable && Y(_e.id),
                          onDragend: ie[3] || (ie[3] = (De) => e.reorderable && I(X)())
                        }), null, 16, ["data-testid", "draggable", "onDragstart", "onDragover", "onDrop"])
                      ], 40, s1))), 128))
                    ], 2)
                  ], 6)) : k("", !0)
                ], 40, o1)) : k("", !0),
                P.value ? (c(), g("div", {
                  key: 1,
                  "data-testid": "filter-dropdown-empty",
                  class: C([{ "overflow-y-auto": e.reserveListHeight && !!e.maxListHeight }, "flex flex-col items-center justify-center gap-1.5 px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
                  style: Ne(e.reserveListHeight ? ye.value : void 0)
                }, [
                  e.emptyIcon && e.emptyLabel ? (c(), g("i", {
                    key: 0,
                    class: C([e.emptyIcon, "text-(length:--icon-size-md) leading-(--icon-size-md)"]),
                    "aria-hidden": "true",
                    "data-testid": "filter-dropdown-empty-icon"
                  }, null, 2)) : k("", !0),
                  e.emptyLabel ? (c(), g("span", d1, N(e.emptyLabel), 1)) : k("", !0)
                ], 6)) : k("", !0)
              ])) : k("", !0),
              Ee.value ? (c(), H(ul, Oe({ key: 2 }, Ee.value, {
                class: "shrink-0",
                onButtonClick: L
              }), null, 16)) : k("", !0)
            ], 46, l1)) : k("", !0)
          ];
        }),
        _: 1
      })
    ], 16));
  }
}), u1 = ["aria-label", "data-step"], c1 = { class: "flex min-h-0 flex-col pb-2" }, f1 = ["aria-label"], h1 = ["aria-label"], b1 = { class: "flex min-h-0 flex-col pb-2" }, g1 = ["aria-label"], m1 = ["aria-labelledby"], p1 = ["id"], v1 = {
  key: 1,
  role: "none",
  class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
  "data-testid": "sort-dropdown-field-list"
}, x1 = ["aria-label"], y1 = ["src"], k1 = { class: "leading-(--line-height-l) font-(--weight-medium)" }, VW = /* @__PURE__ */ ke({
  __name: "SortDropdown",
  props: {
    modelValue: { default: "" },
    options: { default: () => [] },
    fields: { default: void 0 },
    sort: { default: null },
    ariaLabel: { default: void 0 },
    align: { default: "right" },
    triggerIconLeft: { default: "ri-filter-3-fill" },
    headerLabel: { default: void 0 },
    searchPlaceholder: { default: "Search a field" },
    searchLabel: { default: void 0 },
    noResultsLabel: { default: void 0 },
    appliedSortLabel: { default: void 0 },
    directionsLabel: { default: "Sort direction" },
    backLabel: { default: "Back" },
    defaultOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:sort"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(
      () => {
        var V;
        return ((V = t.options.find((Q) => Q.value === t.modelValue)) == null ? void 0 : V.label) ?? "";
      }
    ), r = m(() => t.options.length === 1), o = m(
      () => t.options.map((V) => ({
        label: V.label,
        active: V.value === t.modelValue,
        testId: `sort-option-${V.value}`,
        onClick: () => a("update:modelValue", V.value)
      }))
    ), i = (V) => !!V && V.startsWith("ri-"), s = m(() => t.fields !== void 0), { isOpen: d, dropdownRef: u, toggleDropdown: f, closeDropdown: b } = Zl({ defaultOpen: t.defaultOpen }), h = R(null), p = R(null), x = R(null), y = R(null), w = R(null), $ = je(), S = R(""), L = R(null), T = { asc: "ri-sort-asc", desc: "ri-sort-desc" }, E = ["asc", "desc"], A = m(() => {
      var V;
      return (V = t.fields) == null ? void 0 : V.find((Q) => {
        var le;
        return Q.key === ((le = t.sort) == null ? void 0 : le.field);
      });
    }), D = m(() => {
      var V;
      return (V = t.fields) == null ? void 0 : V.find((Q) => Q.key === L.value);
    }), M = m(() => S.value.trim() ? void 0 : A.value), F = m(
      () => (t.fields ?? []).filter((V) => V !== M.value && qu(V.label, S.value))
    ), X = m(() => M.value ? [M.value, ...F.value] : F.value), _ = m(() => {
      var V;
      return ((V = A.value) == null ? void 0 : V.label) ?? t.headerLabel ?? "";
    }), { focusedIndex: Y, handleRovingKeydown: B, handleSearchFieldKeydown: W, clampFocusedIndex: U } = ro();
    $e(
      () => X.value.length,
      (V) => U(V)
    );
    function z() {
      var V;
      return ((V = h.value) == null ? void 0 : V.$el) ?? null;
    }
    function P(V, Q) {
      const le = V == null ? void 0 : V.querySelector(`[data-listbox-index="${Q}"]`);
      return le ? (Y.value = Q, le.focus({ preventScroll: !0 }), le.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function K() {
      var V, Q;
      (Q = (V = p.value) == null ? void 0 : V.querySelector('[data-testid="sort-dropdown-back"]')) == null || Q.focus();
    }
    function j() {
      b(), Ue(() => {
        var V;
        return (V = z()) == null ? void 0 : V.focus();
      });
    }
    $e(
      d,
      (V) => {
        var Q;
        V && (L.value = null, S.value = "", Y.value = 0, (Q = w.value) == null || Q.focusSearch());
      },
      { flush: "post" }
    );
    function G(V) {
      var le;
      if (V.disabled) return;
      L.value = V.key;
      const Q = ((le = t.sort) == null ? void 0 : le.field) === V.key ? E.indexOf(t.sort.direction) : 0;
      Y.value = Math.max(0, Q), Ue(K);
    }
    function q() {
      const V = L.value;
      L.value = null, Ue(() => {
        var le;
        const Q = X.value.findIndex((ee) => ee.key === V);
        P(x.value, Math.max(0, Q)) || (le = w.value) == null || le.focusSearch();
      });
    }
    function J(V) {
      L.value && (a("update:sort", { field: L.value, direction: V }), j());
    }
    function me(V) {
      d.value && (V.stopPropagation(), V.preventDefault(), j());
    }
    function ye(V) {
      V.target instanceof HTMLInputElement && W(V, X.value.length, x.value);
    }
    function Z(V) {
      B(V, X.value.length, x.value);
    }
    function de(V) {
      if (V.key === "ArrowLeft") {
        V.preventDefault(), q();
        return;
      }
      B(V, E.length, y.value);
    }
    const ge = m(() => [
      { label: t.backLabel, icon: "ri-arrow-left-line", variant: "secondary", testId: "sort-dropdown-back" }
    ]);
    function se(V) {
      return {
        tabindex: V === Y.value ? 0 : -1,
        "data-listbox-index": V,
        onFocus: () => {
          Y.value = V;
        }
      };
    }
    function Se(V) {
      return {
        as: "button",
        role: "menuitem",
        label: V.label,
        icon: V.icon,
        ariaDisabled: !!V.disabled,
        description: V.disabled ? V.disabledReason : void 0,
        onClick: () => G(V)
      };
    }
    return (V, Q) => s.value ? (c(), g("div", {
      key: 0,
      ref_key: "dropdownRef",
      ref: u,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      "data-testid": "sort-dropdown",
      onKeydown: ut(me, ["escape"])
    }, [
      re(Be, {
        ref_key: "triggerRef",
        ref: h,
        "data-testid": "sort-dropdown-trigger",
        size: "xs",
        variant: "ghost",
        label: _.value,
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": !!_.value,
        "icon-only": !_.value,
        "aria-label": e.ariaLabel,
        "aria-expanded": I(d),
        "aria-haspopup": "dialog",
        onClick: I(f)
      }, null, 8, ["label", "icon-left", "dropdown-icon", "icon-only", "aria-label", "aria-expanded", "onClick"]),
      re(wt, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: xe(() => [
          I(d) ? (c(), g("div", {
            key: 0,
            ref_key: "panelRef",
            ref: p,
            role: "dialog",
            "aria-label": e.headerLabel ?? e.ariaLabel,
            "data-testid": "sort-dropdown-panel",
            "data-step": D.value ? "directions" : "fields",
            class: C(["absolute top-full z-50 mt-1 flex max-h-105 w-80 max-w-[calc(100vw-32px)] flex-col overflow-hidden", [I(Wa), e.align === "right" ? "right-0 origin-top-right" : "left-0 origin-top-left"]])
          }, [
            D.value ? (c(), g(ce, { key: 0 }, [
              re(cl, {
                "label-left": D.value.label,
                class: "shrink-0"
              }, null, 8, ["label-left"]),
              v("div", c1, [
                v("div", {
                  ref_key: "directionMenuRef",
                  ref: y,
                  role: "menu",
                  "aria-label": e.directionsLabel,
                  class: "flex flex-col px-2 py-1.5",
                  "data-testid": "sort-dropdown-directions",
                  onKeydown: de
                }, [
                  v("div", {
                    role: "group",
                    "aria-label": D.value.label,
                    class: "flex flex-col"
                  }, [
                    (c(), g(ce, null, Re(E, (le, ee) => {
                      var O, ne;
                      return re(Kt, Oe({ key: le }, { ref_for: !0 }, se(ee), {
                        as: "button",
                        role: "menuitemradio",
                        "aria-checked": ((O = e.sort) == null ? void 0 : O.field) === D.value.key && e.sort.direction === le,
                        "aria-label": D.value.directions[le].ariaLabel,
                        label: D.value.directions[le].label,
                        icon: T[le],
                        selected: ((ne = e.sort) == null ? void 0 : ne.field) === D.value.key && e.sort.direction === le,
                        class: "shrink-0",
                        "data-testid": `sort-direction-${le}`,
                        onClick: (fe) => J(le)
                      }), null, 16, ["aria-checked", "aria-label", "label", "icon", "selected", "data-testid", "onClick"]);
                    }), 64))
                  ], 8, h1)
                ], 40, f1)
              ]),
              re(ul, {
                type: "button",
                buttons: ge.value,
                class: "shrink-0",
                onButtonClick: q
              }, null, 8, ["buttons"])
            ], 64)) : (c(), g(ce, { key: 1 }, [
              re(cl, {
                ref_key: "headerRef",
                ref: w,
                class: "shrink-0",
                "label-left": e.headerLabel,
                "show-search": "",
                "search-query": S.value,
                "search-placeholder": e.searchPlaceholder,
                "search-label": e.searchLabel ?? e.searchPlaceholder,
                onKeydown: ye,
                "onUpdate:searchQuery": Q[0] || (Q[0] = (le) => S.value = le)
              }, null, 8, ["label-left", "search-query", "search-placeholder", "search-label"]),
              v("div", b1, [
                X.value.length ? (c(), g("div", {
                  key: 0,
                  ref_key: "fieldMenuRef",
                  ref: x,
                  role: "menu",
                  "aria-label": e.headerLabel,
                  class: "flex min-h-0 flex-col",
                  "data-testid": "sort-dropdown-fields",
                  onKeydown: Z
                }, [
                  M.value && e.sort ? (c(), g("div", {
                    key: 0,
                    role: "group",
                    "aria-labelledby": e.appliedSortLabel ? I($) : void 0,
                    class: "flex shrink-0 flex-col border-b border-(--border-border-base-soft) pt-2 pe-3 ps-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)",
                    "data-testid": "sort-dropdown-applied"
                  }, [
                    e.appliedSortLabel ? (c(), g("span", {
                      key: 0,
                      id: I($),
                      class: "px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
                      "data-testid": "sort-dropdown-applied-heading"
                    }, N(e.appliedSortLabel), 9, p1)) : k("", !0),
                    re(Kt, Oe({ ...Se(M.value), ...se(0) }, {
                      type: "two-labels",
                      selected: "",
                      "secondary-icon": T[e.sort.direction],
                      "secondary-label": M.value.directions[e.sort.direction].label,
                      class: "shrink-0",
                      "data-testid": `sort-field-${M.value.key}`
                    }), null, 16, ["secondary-icon", "secondary-label", "data-testid"])
                  ], 8, m1)) : k("", !0),
                  F.value.length ? (c(), g("div", v1, [
                    (c(!0), g(ce, null, Re(F.value, (le, ee) => (c(), H(Kt, Oe({
                      key: le.key
                    }, { ref_for: !0 }, { ...Se(le), ...se(M.value ? ee + 1 : ee) }, {
                      type: "two-icons",
                      class: "shrink-0",
                      "data-testid": `sort-field-${le.key}`
                    }), null, 16, ["data-testid"]))), 128))
                  ])) : k("", !0)
                ], 40, g1)) : k("", !0),
                v("div", {
                  role: "status",
                  "aria-live": "polite",
                  class: C(X.value.length || !e.noResultsLabel ? "sr-only" : "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"),
                  "data-testid": "sort-dropdown-status"
                }, N(X.value.length ? "" : e.noResultsLabel), 3)
              ])
            ], 64))
          ], 10, u1)) : k("", !0)
        ]),
        _: 1
      })
    ], 544)) : r.value ? (c(), g("div", {
      key: 1,
      class: "inline-flex items-center gap-1.5 px-3 py-2 text-(length:--size-m) text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
      "aria-label": e.ariaLabel,
      "data-testid": "sort-dropdown-static"
    }, [
      e.triggerIconLeft ? (c(), g(ce, { key: 0 }, [
        i(e.triggerIconLeft) ? (c(), g("i", {
          key: 0,
          class: C([e.triggerIconLeft, "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"]),
          "aria-hidden": "true"
        }, null, 2)) : (c(), g("img", {
          key: 1,
          class: "relative h-4 w-4",
          src: e.triggerIconLeft,
          alt: ""
        }, null, 8, y1))
      ], 64)) : k("", !0),
      v("span", k1, N(l.value), 1)
    ], 8, x1)) : (c(), H(ln, {
      key: 2,
      label: l.value,
      "trigger-icon-left": e.triggerIconLeft,
      items: o.value,
      "menu-align": e.align,
      "selection-style": "check",
      "menu-header": e.headerLabel,
      "aria-label": e.ariaLabel,
      ghost: "",
      "data-testid": "sort-dropdown"
    }, null, 8, ["label", "trigger-icon-left", "items", "menu-align", "menu-header", "aria-label"]));
  }
}), w1 = { class: "flex flex-col gap-0.5 pb-0.5" }, C1 = {
  key: 0,
  class: "flex min-w-0 flex-1"
}, S1 = {
  key: 1,
  class: "inline-flex shrink-0"
}, $1 = {
  "data-field-controls": "",
  class: "ms-auto flex shrink-0 items-center gap-2"
}, I1 = ["aria-label"], T1 = /* @__PURE__ */ ke({
  __name: "MultipleSelect",
  props: {
    options: {},
    modelValue: { default: () => [] },
    draft: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    helpTooltip: { default: void 0 },
    placeholder: {},
    confirmLabel: {},
    seeAllLabel: { default: void 0 },
    seeAllThreshold: { default: 20 },
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    selectAllLabel: {},
    clearAllLabel: {},
    removeChipLabel: {},
    emptyLabel: {},
    error: { default: void 0 },
    hint: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    async: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    selectAllResolver: { type: Function, default: void 0 },
    chipTheme: { default: "neutral" },
    totalCount: { default: void 0 },
    maxListHeight: { default: "252px" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:draft", "see-all", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.async), r = je(), o = m(() => `${r}-input`), i = m(() => t.label ? `${r}-label` : void 0), s = `${r}-error`, d = `${r}-hint`, u = m(() => !!t.error), f = m(() => {
      const te = [];
      return t.hint && te.push(d), u.value && te.push(s), te.length > 0 ? te.join(" ") : void 0;
    }), b = m(
      () => t.options.filter((te) => (t.modelValue ?? []).includes(te.id))
    ), h = R([...t.modelValue ?? []]), p = R(!1), x = R(!1), y = (te, oe) => te.length === oe.length && te.every((Le, Ie) => Le === oe[Ie]);
    $e(
      () => t.draft,
      (te) => {
        te && !y(te, h.value) && (h.value = [...te]);
      }
    ), $e(h, (te) => {
      (!t.draft || !y(t.draft, te)) && a("update:draft", [...te]);
    });
    const w = () => {
      p.value = !0, h.value = [...t.modelValue ?? []];
    }, $ = () => {
      p.value = !1, h.value = [...t.modelValue ?? []];
    }, S = () => {
      a("update:modelValue", [...h.value]);
    }, L = R(null), T = R(null), E = m(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), A = m(() => t.disabled || t.readonly), D = m(
      () => t.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    function M(te) {
      te.currentTarget.contains(te.relatedTarget) || (x.value = !1);
    }
    const F = R(null), X = () => {
      var te;
      return ((te = F.value) == null ? void 0 : te.$el) ?? null;
    }, _ = R(1 / 0), Y = R(void 0);
    let B = null;
    const W = m(() => {
      const te = _.value === 1 / 0 ? b.value.length : Math.min(_.value, b.value.length);
      return b.value.slice(0, te);
    }), U = m(
      () => Math.max(0, b.value.length - W.value.length)
    ), z = async () => {
      _.value = 1 / 0, await Ue();
      const te = X();
      if (!te || b.value.length === 0) {
        _.value = b.value.length;
        return;
      }
      const oe = Array.from(te.querySelectorAll("[data-badge-chip]"));
      if (!oe.length) {
        _.value = b.value.length;
        return;
      }
      const Le = te.getBoundingClientRect(), Ie = getComputedStyle(te), ve = parseFloat(Ie.columnGap) || 0, we = te.querySelector("[data-field-controls]"), he = (parseFloat(Ie.paddingRight) || 0) + (we ? we.getBoundingClientRect().width + ve : 0), Me = 56, Ee = Le.right - he;
      let He = oe.length;
      for (let Ge = 0; Ge < oe.length; Ge++) {
        const Ze = oe[Ge].getBoundingClientRect().right;
        if ((Ge === oe.length - 1 ? Ze : Ze + Me) > Ee) {
          He = Ge;
          break;
        }
      }
      _.value = Math.max(He, 1);
    }, P = () => {
      const te = X();
      te && (Y.value = `${te.offsetWidth}px`);
    };
    dt(() => {
      B = new ResizeObserver(() => {
        P(), z();
      });
      const te = X();
      te && B.observe(te), P(), z();
    }), gt(() => {
      B == null || B.disconnect(), clearTimeout(j);
    }), $e(
      () => t.modelValue,
      (te) => {
        _.value = 1 / 0, z(), p.value || (h.value = [...te ?? []]);
      }
    );
    const K = R("");
    let j;
    $e(K, (te) => {
      t.async && (clearTimeout(j), j = setTimeout(() => a("search", te), 300));
    });
    const G = R(!1), q = m(() => t.loading || G.value), J = m(
      () => t.loading ? t.loadingLabel ?? t.emptyLabel : t.emptyLabel
    ), me = m(() => t.options.filter((te) => !te.disabled)), ye = m(
      () => me.value.length > 0 && me.value.every((te) => h.value.includes(te.id))
    ), Z = m(
      () => !ye.value && me.value.some((te) => h.value.includes(te.id))
    ), de = async () => {
      if (t.selectAllResolver) {
        G.value = !0;
        try {
          const te = await t.selectAllResolver(), oe = new Set(te);
          if (te.length > 0 && te.every((Ie) => h.value.includes(Ie)))
            h.value = h.value.filter((Ie) => !oe.has(Ie));
          else {
            const Ie = new Set(h.value);
            te.forEach((ve) => Ie.add(ve)), h.value = Array.from(Ie);
          }
        } catch {
        } finally {
          G.value = !1;
        }
        return;
      }
      if (ye.value)
        h.value = h.value.filter(
          (te) => !me.value.some((oe) => oe.id === te)
        );
      else {
        const te = new Set(h.value);
        me.value.forEach((oe) => te.add(oe.id)), h.value = Array.from(te);
      }
    }, ge = (te) => {
      h.value.includes(te) ? h.value = h.value.filter((oe) => oe !== te) : h.value = [...h.value, te];
    }, se = () => {
      const te = X();
      te && te !== document.activeElement && te.contains(document.activeElement) && te.focus();
    }, Se = (te) => {
      se(), h.value = h.value.filter((oe) => oe !== te), a(
        "update:modelValue",
        (t.modelValue ?? []).filter((oe) => oe !== te)
      );
    }, V = (te) => {
      te.stopPropagation(), se(), h.value = [], a("update:modelValue", []);
    }, Q = m(() => ({
      id: "__select-all__",
      label: t.selectAllLabel,
      hasCheckbox: !0,
      checked: ye.value,
      indeterminate: Z.value,
      onClick: de
    })), le = m(() => [
      ...t.options.map((te) => ({
        id: te.id,
        label: te.label,
        hasCheckbox: !0,
        checked: h.value.includes(te.id),
        badgeTheme: te.badgeTheme ?? t.chipTheme,
        badgeRightIcon: te.badgeRightIcon,
        secondaryText: te.secondaryText,
        disabled: te.disabled,
        onClick: () => ge(te.id)
      }))
    ]), ee = m(() => {
      const te = [], oe = t.totalCount ?? t.options.length;
      return t.seeAllLabel && oe > (t.seeAllThreshold ?? 20) && te.push({
        label: t.seeAllLabel,
        variant: "secondary",
        keepOpen: !0,
        onClick: () => a("see-all")
      }), te.push({ label: t.confirmLabel, variant: "primary", onClick: S }), te;
    }), O = (te, oe, Le) => {
      var Ie, ve;
      if (te.key === "Escape" && Le) {
        te.stopPropagation(), te.preventDefault(), oe();
        return;
      }
      if (Le || ((Ie = L.value) == null || Ie.handleFieldKeydown(te), (ve = T.value) == null || ve.handleFieldKeydown(te)), te.key === "Backspace" && te.target === te.currentTarget && !t.disabled && !t.readonly && b.value.length > 0) {
        const we = b.value[b.value.length - 1];
        h.value = h.value.filter((he) => he !== we.id), a(
          "update:modelValue",
          (t.modelValue ?? []).filter((he) => he !== we.id)
        );
      }
    };
    let ne = !1;
    const fe = () => {
      ne = p.value;
    }, ue = () => {
      var oe, Le;
      const te = ne;
      if (ne = !1, !t.disabled) {
        if (te || t.removeOnly) {
          (oe = X()) == null || oe.focus();
          return;
        }
        (Le = X()) == null || Le.click();
      }
    };
    return (te, oe) => (c(), g("div", w1, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: i.value,
        ref_key: "labelRef",
        ref: L,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.helpTooltip,
        focused: x.value,
        "test-id": "multiple-select-label",
        class: C(!e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"),
        onMousedown: fe,
        onClick: Ye(ue, ["stop"])
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : k("", !0),
      re(I(Zu), {
        "search-query": K.value,
        "onUpdate:searchQuery": oe[1] || (oe[1] = (Le) => K.value = Le),
        "aria-label": e.label || e.placeholder,
        items: le.value,
        "sticky-item": Q.value,
        "show-search": !0,
        "search-placeholder": e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "empty-label": J.value,
        "disable-internal-search-filter": l.value,
        "max-list-height": e.maxListHeight,
        "footer-buttons": ee.value,
        "menu-width": Y.value,
        class: "w-full",
        onOpen: w,
        onClose: $
      }, {
        trigger: xe(({ toggle: Le, isOpen: Ie }) => [
          re(Bn, {
            id: o.value,
            ref_key: "shellRef",
            ref: F,
            role: "combobox",
            "aria-expanded": Ie,
            "aria-haspopup": "dialog",
            "aria-labelledby": i.value,
            "aria-describedby": f.value,
            "aria-required": e.required ? "true" : void 0,
            "aria-invalid": u.value ? "true" : void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-readonly": e.readonly ? "true" : void 0,
            "aria-busy": q.value ? "true" : void 0,
            tabindex: e.disabled ? -1 : 0,
            tags: "",
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly || e.removeOnly,
            error: u.value,
            success: e.success,
            focused: Ie,
            "focus-scope": "any",
            "has-value": b.value.length > 0,
            class: C(["w-full flex-nowrap! overflow-hidden focus:outline-none", !e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"]),
            onClick: (ve) => !e.disabled && !e.readonly && !e.removeOnly && Le(),
            onKeydown: [
              (ve) => O(ve, Le, Ie),
              ut(Ye((ve) => !e.disabled && !e.readonly && !e.removeOnly && Le(), ["self", "prevent"]), ["enter"]),
              ut(Ye((ve) => !e.disabled && !e.readonly && !e.removeOnly && Le(), ["self", "prevent"]), ["space"])
            ],
            onFocusin: oe[0] || (oe[0] = (ve) => x.value = !0),
            onFocusout: M
          }, {
            default: xe(({ textClass: ve, iconBoxClass: we }) => [
              b.value.length === 0 ? (c(), g("span", C1, [
                re(ht, {
                  text: e.placeholder,
                  focusable: !1,
                  "text-class": [ve, e.disabled ? "" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"].join(" ")
                }, null, 8, ["text", "text-class"])
              ])) : k("", !0),
              (c(!0), g(ce, null, Re(W.value, (he) => (c(), g("div", {
                key: he.id,
                "data-badge-chip": "",
                class: "inline-flex shrink-0"
              }, [
                re(I(ct), {
                  label: he.label,
                  theme: e.disabled ? "disabled" : he.badgeTheme ?? e.chipTheme,
                  "tooltip-text": he.tooltipText,
                  "right-icon": he.badgeRightIcon,
                  size: E.value,
                  truncate: "",
                  "truncation-focusable": !1,
                  "show-close-icon": "",
                  "close-icon-inactive": A.value,
                  "remove-label": e.removeChipLabel(he.label),
                  onClose: (Me) => Se(he.id)
                }, null, 8, ["label", "theme", "tooltip-text", "right-icon", "size", "close-icon-inactive", "remove-label", "onClose"])
              ]))), 128)),
              U.value > 0 ? (c(), g("div", S1, [
                re(I(ct), {
                  label: `+${U.value}`,
                  theme: e.disabled ? "disabled" : e.chipTheme,
                  size: E.value,
                  "show-close-icon": !1
                }, null, 8, ["label", "theme", "size"])
              ])) : k("", !0),
              v("span", $1, [
                b.value.length > 0 && !e.disabled && !e.readonly ? (c(), g("button", {
                  key: 0,
                  type: "button",
                  class: C([
                    we,
                    "relative cursor-pointer rounded-(--border-border-radius-rounded-xs) border-none bg-transparent p-0 text-(--text-text-body-subtle) transition-colors hover:text-(--text-text-black-default) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden dark:text-(--colors-text-white-secondary) dark:hover:text-(--colors-text-white-default)",
                    "before:absolute before:top-1/2 before:left-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
                  ]),
                  "aria-label": e.clearAllLabel,
                  onClick: Ye(V, ["stop"])
                }, [...oe[2] || (oe[2] = [
                  v("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, I1)) : k("", !0),
                e.removeOnly ? k("", !0) : (c(), g("i", {
                  key: 1,
                  class: C([
                    "ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none",
                    we,
                    D.value
                  ]),
                  style: Ne({ transform: Ie ? "rotate(180deg)" : "rotate(0deg)" }),
                  "aria-hidden": "true"
                }, null, 6))
              ])
            ]),
            _: 2
          }, 1032, ["id", "aria-expanded", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "aria-disabled", "aria-readonly", "aria-busy", "tabindex", "size", "disabled", "readonly", "error", "success", "focused", "has-value", "class", "onClick", "onKeydown"])
        ]),
        _: 1
      }, 8, ["search-query", "aria-label", "items", "sticky-item", "search-placeholder", "search-clear-label", "empty-label", "disable-internal-search-filter", "max-list-height", "footer-buttons", "menu-width"]),
      re(xt, {
        ref_key: "helperRef",
        ref: T,
        focused: x.value,
        hint: e.hint,
        error: e.error,
        "hint-id": d,
        "error-id": s,
        "test-id-prefix": "multiple-select"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), L1 = ["aria-label"], A1 = { class: "w-full sm:w-56 sm:shrink-0" }, E1 = /* @__PURE__ */ ke({
  __name: "AccessRuleRow",
  props: {
    rule: {},
    position: {},
    options: {},
    labels: {},
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    levelHint: { default: void 0 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:userIds", "update:level", "remove", "search", "activate"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = R(null), r = () => {
      var i, s;
      (s = (i = l.value) == null ? void 0 : i.querySelector('[role="combobox"]')) == null || s.focus();
    }, o = (i) => {
      i && a("update:level", i);
    };
    return n({ focusPicker: r }), (i, s) => (c(), g("div", {
      role: "group",
      "aria-label": e.labels.ruleGroupLabel(e.position),
      "data-testid": "access-rule",
      class: "flex flex-col gap-3 sm:flex-row sm:items-start"
    }, [
      v("div", {
        ref_key: "pickerRef",
        ref: l,
        class: "min-w-0 flex-1",
        onFocusin: s[2] || (s[2] = (d) => a("activate"))
      }, [
        re(T1, {
          "model-value": e.rule.userIds,
          options: e.options,
          label: e.labels.rulePeopleLabel,
          placeholder: e.labels.pickerPlaceholder,
          "confirm-label": e.labels.pickerConfirm,
          "search-placeholder": e.labels.pickerSearchPlaceholder,
          "select-all-label": e.labels.pickerSelectAll,
          "clear-all-label": e.labels.pickerClearAll,
          "remove-chip-label": e.labels.removeUser,
          "empty-label": e.labels.pickerEmpty,
          "loading-label": e.labels.pickerLoading,
          loading: e.loading,
          disabled: e.disabled,
          "remove-only": e.removeOnly,
          async: "",
          "onUpdate:modelValue": s[0] || (s[0] = (d) => a("update:userIds", d)),
          onSearch: s[1] || (s[1] = (d) => a("search", d))
        }, null, 8, ["model-value", "options", "label", "placeholder", "confirm-label", "search-placeholder", "select-all-label", "clear-all-label", "remove-chip-label", "empty-label", "loading-label", "loading", "disabled", "remove-only"])
      ], 544),
      v("div", A1, [
        re(Ed, {
          "model-value": e.rule.level,
          label: e.labels.ruleLevelLabel,
          levels: e.labels.levels,
          "disabled-levels": e.disabledLevels,
          hint: e.levelHint,
          disabled: e.disabled,
          "onUpdate:modelValue": o
        }, null, 8, ["model-value", "label", "levels", "disabled-levels", "hint", "disabled"])
      ]),
      re(Be, {
        variant: "secondary",
        size: "sm",
        "icon-only": "",
        "icon-left": "ri-delete-bin-line",
        "aria-label": e.labels.removeRule,
        disabled: e.disabled,
        class: "self-start sm:mt-5.5",
        "data-testid": "access-rule-remove",
        onClick: s[3] || (s[3] = (d) => a("remove"))
      }, null, 8, ["aria-label", "disabled"])
    ], 8, L1));
  }
}), Rs = ["Edit", "View"];
function R1() {
  let e = 0;
  return () => `rule-${++e}`;
}
function Cf(e, n) {
  const t = /* @__PURE__ */ new Map();
  for (const { id: a, level: l } of e) {
    const r = t.get(a);
    (!r || Rs.indexOf(l) < Rs.indexOf(r)) && t.set(a, l);
  }
  return Rs.map((a) => ({
    key: n(),
    level: a,
    userIds: [...t].filter(([, l]) => l === a).map(([l]) => l)
  })).filter((a) => a.userIds.length > 0);
}
function Sf(e) {
  const n = /* @__PURE__ */ new Set(), t = [];
  for (const a of e)
    for (const l of a.userIds)
      n.has(l) || (n.add(l), t.push({ id: l, level: a.level }));
  return t;
}
function $f(e, n) {
  if (e.organization !== n.organization || e.users.length !== n.users.length) return !1;
  const t = new Map(e.users.map((a) => [a.id, a.level]));
  return n.users.every((a) => t.get(a.id) === a.level);
}
const B1 = {
  class: "flex flex-col gap-6",
  "data-testid": "access-settings"
}, D1 = ["aria-labelledby"], M1 = { class: "flex flex-col gap-1" }, z1 = ["id"], O1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, P1 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }, F1 = { "data-testid": "access-organization" }, V1 = ["aria-labelledby", "aria-describedby"], N1 = { class: "flex flex-col gap-1" }, H1 = ["id"], j1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, W1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, q1 = {
  "aria-live": "polite",
  "data-testid": "access-people-status"
}, U1 = ["id"], G1 = {
  key: 0,
  class: "flex flex-col rounded-xl border border-(--border-border-base-soft) dark:border-(--colors-border-base)"
}, K1 = { class: "self-start" }, Y1 = ["tabindex"], NW = /* @__PURE__ */ ke({
  __name: "AccessSettings",
  props: {
    modelValue: {},
    userOptions: {},
    knownUsers: { default: () => [] },
    usersLoading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showTeam: { type: Boolean, default: !0 },
    labels: {}
  },
  emits: ["update:modelValue", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = je(), r = je(), o = je(), i = R1(), s = R(Cf(t.modelValue.users, i));
    let d = null;
    const u = R(t.modelValue.organization), f = m(() => u.value === "Edit" ? ["Edit", "View"] : u.value === "View" ? ["View"] : []), b = m(() => u.value === "Edit"), h = m(() => u.value === "View" ? t.labels.viewWithoutEffect : void 0);
    $e(
      () => t.modelValue,
      (U) => {
        const z = { organization: u.value, users: Sf(s.value) };
        $f(U, z) || (s.value = Cf(U.users, i), u.value = U.organization, d = null);
      },
      { deep: !0 }
    );
    const p = (U = u.value) => {
      const z = { organization: U, users: Sf(s.value) };
      $f(z, d ?? t.modelValue) || (d = { organization: z.organization, users: z.users.map((P) => ({ ...P })) }, u.value = z.organization, a("update:modelValue", z));
    }, x = /* @__PURE__ */ new Map();
    let y = null, w = "";
    const $ = (U) => {
      U !== w && (w = U, a("search", U));
    }, S = (U, z) => {
      x.set(U, z), !(y !== null && y !== U) && (y = U, w = z, a("search", z));
    }, L = (U) => {
      y !== U && (y = U, $(x.get(U) ?? ""));
    }, T = R(/* @__PURE__ */ new Map());
    $e(
      () => [t.userOptions, t.knownUsers],
      ([U, z]) => {
        for (const P of [...U, ...z]) T.value.set(P.id, P);
      },
      { immediate: !0, deep: !0 }
    );
    const E = (U) => {
      const z = new Set(s.value.filter((K) => K.key !== U.key).flatMap((K) => K.userIds));
      return [.../* @__PURE__ */ new Set([...U.userIds, ...t.userOptions.map((K) => K.id)])].map((K) => {
        const j = T.value.get(K) ?? { name: K }, G = z.has(K), q = f.value.includes(U.level) && !U.userIds.includes(K);
        return {
          id: K,
          label: j.inactive ? t.labels.inactiveUser(j.name) : j.name,
          secondaryText: G ? t.labels.alreadyInOtherRule : j.secondaryText,
          disabled: G || q,
          // A warning colour, not the "disabled" theme: the chip stays removable, so its text must keep 4.5:1 contrast.
          badgeTheme: j.inactive ? "orange" : void 0
        };
      });
    }, A = /* @__PURE__ */ new Map(), D = (U) => (z) => {
      z ? A.set(U, z) : A.delete(U);
    }, M = R(null), F = R(null), X = () => {
      var U, z;
      return (z = b.value ? M.value : (U = F.value) == null ? void 0 : U.$el) == null ? void 0 : z.focus();
    }, _ = async () => {
      var z;
      const U = { key: i(), level: u.value === "View" ? "Edit" : "View", userIds: [] };
      s.value.push(U), L(U.key), await Ue(), (z = A.get(U.key)) == null || z.focusPicker();
    }, Y = async (U) => {
      var K;
      const [z] = s.value.splice(U, 1);
      z && x.delete(z.key), p(), await Ue();
      const P = s.value[U - 1] ?? s.value[U];
      P ? (K = A.get(P.key)) == null || K.focusPicker() : X();
    }, B = (U, z) => {
      s.value[U].userIds = z, p();
    }, W = (U, z) => {
      s.value[U].level = z, p();
    };
    return (U, z) => (c(), g("div", B1, [
      v("section", {
        role: "group",
        "aria-labelledby": I(l),
        class: "flex flex-col gap-3"
      }, [
        v("div", M1, [
          v("p", {
            id: I(l),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, N(e.labels.generalTitle), 9, z1),
          v("p", O1, N(e.labels.generalDescription), 1)
        ]),
        v("div", P1, [
          v("div", F1, [
            re(Ed, {
              "model-value": u.value,
              label: e.labels.organizationLabel,
              levels: e.labels.levels,
              disabled: e.disabled,
              "allow-none": "",
              "onUpdate:modelValue": z[0] || (z[0] = (P) => p(P))
            }, null, 8, ["model-value", "label", "levels", "disabled"])
          ]),
          e.showTeam ? (c(), H(ft, {
            key: 0,
            text: e.labels.teamUnavailableTooltip,
            role: "group",
            "aria-label": e.labels.teamLabel,
            "aria-disabled": "true",
            tabindex: "0",
            "data-testid": "access-team-row"
          }, {
            default: xe(() => [
              re(Ed, {
                "model-value": null,
                label: e.labels.teamLabel,
                levels: e.labels.levels,
                "allow-none": "",
                disabled: ""
              }, null, 8, ["label", "levels"])
            ]),
            _: 1
          }, 8, ["text", "aria-label"])) : k("", !0)
        ])
      ], 8, D1),
      v("section", {
        role: "group",
        "aria-labelledby": I(r),
        "aria-describedby": b.value ? I(o) : void 0,
        class: "flex flex-col gap-3"
      }, [
        v("div", N1, [
          v("p", {
            id: I(r),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, N(e.labels.peopleTitle), 9, H1),
          v("p", j1, N(e.labels.peopleDescription), 1),
          v("p", W1, N(e.labels.groupingHint), 1),
          v("div", q1, [
            b.value ? (c(), g("p", {
              key: 0,
              id: I(o),
              class: "text-sm leading-5 font-medium text-text-black-default dark:text-(--colors-text-white-default)",
              "data-testid": "access-people-without-effect"
            }, N(e.labels.peopleWithoutEffect), 9, U1)) : k("", !0)
          ])
        ]),
        s.value.length > 0 ? (c(), g("div", G1, [
          (c(!0), g(ce, null, Re(s.value, (P, K) => (c(), H(E1, {
            key: P.key,
            ref_for: !0,
            ref: D(P.key),
            class: "border-t border-(--border-border-base-soft) p-4 first:border-t-0 dark:border-(--colors-border-base)",
            rule: P,
            position: K + 1,
            options: E(P),
            "disabled-levels": f.value,
            "level-hint": h.value,
            "remove-only": b.value,
            labels: e.labels,
            loading: e.usersLoading,
            disabled: e.disabled,
            "onUpdate:userIds": (j) => B(K, j),
            "onUpdate:level": (j) => W(K, j),
            onRemove: (j) => Y(K),
            onSearch: (j) => S(P.key, j),
            onActivate: (j) => L(P.key)
          }, null, 8, ["rule", "position", "options", "disabled-levels", "level-hint", "remove-only", "labels", "loading", "disabled", "onUpdate:userIds", "onUpdate:level", "onRemove", "onSearch", "onActivate"]))), 128))
        ])) : k("", !0),
        v("div", K1, [
          re(ft, {
            text: e.labels.peopleWithoutEffect,
            disabled: !b.value
          }, {
            default: xe(() => [
              v("span", {
                ref_key: "addRuleStop",
                ref: M,
                class: "inline-flex rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2",
                tabindex: b.value ? 0 : void 0,
                "data-testid": "access-add-rule-stop"
              }, [
                re(Be, {
                  ref_key: "addRuleButton",
                  ref: F,
                  variant: "secondary",
                  size: "sm",
                  "icon-left": "ri-add-line",
                  label: e.labels.addRule,
                  disabled: e.disabled || b.value,
                  "data-testid": "access-add-rule",
                  onClick: _
                }, null, 8, ["label", "disabled"])
              ], 8, Y1)
            ]),
            _: 1
          }, 8, ["text", "disabled"])
        ])
      ], 8, V1)
    ]));
  }
}), HW = /* @__PURE__ */ ke({
  __name: "WeekNavigator",
  props: {
    weekStartDate: {},
    weekEndDate: {},
    locale: { default: "en" },
    previousLabel: { default: "Previous week" },
    nextLabel: { default: "Next week" },
    todayLabel: { default: "Today" },
    previousDisabled: { type: Boolean, default: !1 },
    todayDisabled: { type: Boolean, default: !1 },
    previousDisabledReason: { default: void 0 },
    todayDisabledReason: { default: void 0 },
    showToday: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !1 }
  },
  emits: ["previous-week", "next-week", "today-week"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => {
      const r = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        timeZone: "UTC"
      }), o = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        ...t.fullWidth ? { year: "numeric" } : {},
        timeZone: "UTC"
      }), i = r.format(/* @__PURE__ */ new Date(`${t.weekStartDate}T00:00:00Z`)), s = o.format(/* @__PURE__ */ new Date(`${t.weekEndDate}T00:00:00Z`));
      return `${i} - ${s}`;
    });
    return (r, o) => (c(), g("div", {
      class: C(["flex flex-wrap items-center gap-(--spacing-2)", e.fullWidth ? "w-full" : void 0])
    }, [
      e.showToday ? (c(), H(ft, {
        key: 0,
        text: e.todayDisabledReason ?? "",
        disabled: !e.todayDisabled || !e.todayDisabledReason,
        tabindex: e.todayDisabled && e.todayDisabledReason ? 0 : void 0
      }, {
        default: xe(() => [
          re(Be, {
            variant: "secondary",
            size: "sm",
            label: e.todayLabel,
            disabled: e.todayDisabled,
            "data-testid": "week-navigator-today",
            onClick: o[0] || (o[0] = (i) => a("today-week"))
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }, 8, ["text", "disabled", "tabindex"])) : k("", !0),
      v("div", {
        class: C(["flex items-center gap-(--spacing-2)", e.fullWidth ? "w-full justify-between" : void 0])
      }, [
        re(ft, {
          text: e.previousDisabledReason ?? "",
          disabled: !e.previousDisabled || !e.previousDisabledReason,
          tabindex: e.previousDisabled && e.previousDisabledReason ? 0 : void 0
        }, {
          default: xe(() => [
            re(Be, {
              variant: "ghost",
              size: e.fullWidth ? "md" : "sm",
              "icon-only": "",
              "icon-left": "ri-arrow-left-line",
              "aria-label": e.previousLabel,
              disabled: e.previousDisabled,
              onClick: o[1] || (o[1] = (i) => a("previous-week"))
            }, null, 8, ["size", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"]),
        v("p", {
          "aria-live": "polite",
          class: C([
            "font-(--weight-semi-bold)",
            e.fullWidth ? "flex-1 text-center text-(length:--size-xl) leading-(--line-height-xl)" : "text-(length:--size-m)"
          ])
        }, N(l.value), 3),
        re(Be, {
          variant: "ghost",
          size: e.fullWidth ? "md" : "sm",
          "icon-only": "",
          "icon-right": "ri-arrow-right-line",
          "aria-label": e.nextLabel,
          onClick: o[2] || (o[2] = (i) => a("next-week"))
        }, null, 8, ["size", "aria-label"])
      ], 2)
    ], 2));
  }
}), J1 = {
  "data-testid": "metric-card-simple",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-2"
}, X1 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, Z1 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, jW = /* @__PURE__ */ ke({
  __name: "MetricCardSimple",
  props: {
    value: { default: "" },
    label: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", J1, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-6 w-40" }, null, -1))
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("b", X1, N(e.value), 1),
        v("div", Z1, N(e.label), 1)
      ], 64))
    ]));
  }
}), Q1 = {
  "data-testid": "metric-card-with-icon",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border gap-3.5"
}, _1 = { class: "h-16 w-[63.9px] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border box-border flex items-center justify-center" }, e2 = ["src", "alt"], t2 = { class: "flex flex-col items-start gap-2" }, n2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, a2 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, WW = /* @__PURE__ */ ke({
  __name: "MetricCardWithIcon",
  props: {
    value: { default: "" },
    label: { default: "" },
    icon: { default: void 0 },
    iconAlt: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", Q1, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-16 w-[63.9px] rounded-num-12" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "flex flex-col items-start gap-2 flex-1" }, [
          v("div", { class: "skeleton h-[29px] w-24" }),
          v("div", { class: "skeleton h-6 w-40" })
        ], -1))
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("div", _1, [
          Ae(n.$slots, "icon", {}, () => [
            e.icon ? (c(), g("img", {
              key: 0,
              src: e.icon,
              alt: e.iconAlt,
              class: "h-9 w-9 relative"
            }, null, 8, e2)) : k("", !0)
          ])
        ]),
        v("div", t2, [
          v("b", n2, N(e.value), 1),
          v("div", a2, N(e.label), 1)
        ])
      ], 64))
    ]));
  }
}), l2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-3" }, r2 = { class: "flex flex-col items-center gap-2" }, o2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, i2 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, s2 = { class: "rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 gap-1 text-center text-[12px]" }, d2 = ["src"], u2 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, qW = /* @__PURE__ */ ke({
  __name: "MetricCardWithTrend",
  props: {
    value: { default: "" },
    label: { default: "" },
    trendText: { default: "" },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", l2, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "flex flex-col items-center gap-2" }, [
          v("div", { class: "skeleton h-[29px] w-24" }),
          v("div", { class: "skeleton h-6 w-40" })
        ], -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-5 w-32 rounded-sm" }, null, -1))
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("div", r2, [
          v("b", o2, N(e.value), 1),
          v("div", i2, N(e.label), 1)
        ]),
        v("div", s2, [
          Ae(n.$slots, "trend-icon", {}, () => [
            e.trendIcon ? (c(), g("img", {
              key: 0,
              src: e.trendIcon,
              alt: "trend",
              class: "h-3 w-3 relative"
            }, null, 8, d2)) : k("", !0)
          ]),
          v("div", u2, N(e.trendText), 1)
        ])
      ], 64))
    ]));
  }
}), c2 = {
  "data-testid": "metric-card-with-badge",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start justify-center p-num-24 box-border gap-2 relative"
}, f2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter z-0" }, h2 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)] z-1" }, b2 = {
  key: 0,
  class: "absolute top-[10px] right-[11px] rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 z-2 text-center text-[12px]"
}, g2 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, UW = /* @__PURE__ */ ke({
  __name: "MetricCardWithBadge",
  props: {
    value: { default: "" },
    label: { default: "" },
    badgeText: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", c2, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-6 w-40" }, null, -1)),
        t[2] || (t[2] = v("div", { class: "skeleton h-5 w-12 rounded-sm absolute top-[10px] right-[11px]" }, null, -1))
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("b", f2, N(e.value), 1),
        v("div", h2, N(e.label), 1),
        e.badgeText ? (c(), g("div", b2, [
          v("div", g2, N(e.badgeText), 1)
        ])) : k("", !0)
      ], 64))
    ]));
  }
}), m2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, p2 = {
  key: 0,
  class: "flex-1 flex flex-col items-start gap-3"
}, v2 = {
  key: 1,
  class: "flex-1 flex flex-col items-start gap-3"
}, x2 = { class: "flex items-center gap-2" }, y2 = ["src"], k2 = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, w2 = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, C2 = { class: "flex items-center gap-2 text-[14px] text-text-success dark:text-[var(--colors-text-success-subtle)]" }, S2 = { class: "flex items-center justify-end" }, $2 = ["src"], I2 = { class: "relative leading-num-20 font-medium" }, T2 = { class: "relative leading-num-20 text-dimgray dark:text-[var(--colors-text-white-secondary)]" }, GW = /* @__PURE__ */ ke({
  __name: "MetricCardWithChart",
  props: {
    title: { default: "" },
    value: { default: "" },
    trendValue: { default: "" },
    trendLabel: { default: "" },
    chartIcon: { default: void 0 },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", m2, [
      e.loading ? (c(), g("div", p2, [...t[0] || (t[0] = [
        to('<div class="flex items-center gap-2"><div class="skeleton h-5 w-5 rounded"></div><div class="skeleton h-6 w-28"></div></div><div class="skeleton h-[29px] w-32"></div><div class="flex items-center gap-2"><div class="skeleton h-5 w-16"></div><div class="skeleton h-5 w-24"></div></div>', 3)
      ])])) : (c(), g("div", v2, [
        v("div", x2, [
          Ae(n.$slots, "chart-icon", {}, () => [
            e.chartIcon ? (c(), g("img", {
              key: 0,
              src: e.chartIcon,
              alt: "chart",
              class: "h-5 w-5 relative"
            }, null, 8, y2)) : k("", !0)
          ]),
          v("div", k2, N(e.title), 1)
        ]),
        v("b", w2, N(e.value), 1),
        v("div", C2, [
          v("div", S2, [
            Ae(n.$slots, "trend-icon", {}, () => [
              e.trendIcon ? (c(), g("img", {
                key: 0,
                src: e.trendIcon,
                alt: "trend",
                class: "h-4 w-4 relative"
              }, null, 8, $2)) : k("", !0)
            ]),
            v("div", I2, N(e.trendValue), 1)
          ]),
          v("div", T2, N(e.trendLabel), 1)
        ])
      ]))
    ]));
  }
}), L2 = {
  class: "flex flex-col justify-center gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]",
  "data-testid": "metric-card-progress"
}, A2 = { class: "flex flex-col gap-2" }, E2 = {
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-title"
}, R2 = { class: "flex items-end gap-2" }, B2 = {
  class: "text-2xl leading-[29px] font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "metric-card-progress-value"
}, D2 = {
  key: 0,
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-target"
}, M2 = { class: "flex flex-col gap-1.5" }, z2 = ["aria-label", "aria-valuenow", "aria-valuetext"], O2 = {
  key: 0,
  class: "flex items-center justify-between gap-2"
}, P2 = {
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-label"
}, KW = /* @__PURE__ */ ke({
  __name: "MetricCardProgress",
  props: {
    title: { default: "" },
    value: { default: "" },
    target: { default: void 0 },
    used: { default: 0 },
    total: { default: 0 },
    unit: { default: "" },
    loading: { type: Boolean, default: !1 },
    progressFormat: { type: Function, default: void 0 },
    progressLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = m(() => n.total <= 0 ? 0 : Math.min(Math.max(n.used / n.total * 100, 0), 100)), a = m(() => n.progressLabel !== void 0 ? n.progressLabel : n.total <= 0 || !n.progressFormat ? "" : n.progressFormat(n.used, n.total, n.unit));
    return (l, r) => (c(), g("div", L2, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        r[0] || (r[0] = to('<div class="flex flex-col gap-2"><div class="skeleton h-6 w-32"></div><div class="skeleton h-[29px] w-24"></div></div><div class="flex flex-col gap-1.5"><div class="skeleton h-2.5 w-full rounded-full"></div><div class="skeleton h-5 w-40"></div></div>', 2))
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("div", A2, [
          v("span", E2, N(e.title), 1),
          v("div", R2, [
            v("b", B2, N(e.value), 1),
            e.target ? (c(), g("span", D2, "/ " + N(e.target), 1)) : k("", !0)
          ])
        ]),
        v("div", M2, [
          v("div", {
            class: "h-2.5 w-full overflow-hidden rounded-full bg-(--colors-background-gray)",
            role: "progressbar",
            "aria-label": e.title || void 0,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.total > 0 ? t.value : void 0,
            "aria-valuetext": a.value || void 0
          }, [
            v("div", {
              class: "h-full rounded-full transition-[width] duration-300",
              style: Ne({
                width: `${t.value}%`,
                backgroundImage: "var(--gradient-brand-horizontal)"
              })
            }, null, 4)
          ], 8, z2),
          a.value || l.$slots.trend ? (c(), g("div", O2, [
            v("span", P2, N(a.value), 1),
            Ae(l.$slots, "trend")
          ])) : k("", !0)
        ])
      ], 64))
    ]));
  }
}), F2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, V2 = {
  key: 0,
  class: "self-stretch flex flex-col items-start gap-2"
}, N2 = {
  key: 1,
  class: "self-stretch flex flex-col items-start gap-2"
}, H2 = { class: "self-stretch flex items-center justify-between gap-5" }, j2 = { class: "flex items-center gap-1.5" }, W2 = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, q2 = ["src"], U2 = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, G2 = { class: "relative leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, YW = /* @__PURE__ */ ke({
  __name: "MetricCardAction",
  props: {
    title: { default: "" },
    value: { default: "" },
    subtitle: { default: "" },
    actionText: { default: "" },
    dropdownIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(e) {
    return (n, t) => (c(), g("div", F2, [
      e.loading ? (c(), g("div", V2, [...t[1] || (t[1] = [
        to('<div class="self-stretch flex items-center justify-between gap-5"><div class="skeleton h-6 w-24"></div><div class="skeleton h-8 w-16 rounded"></div></div><div class="skeleton h-[29px] w-32"></div><div class="skeleton h-6 w-40"></div>', 3)
      ])])) : (c(), g("div", N2, [
        v("div", H2, [
          v("div", j2, [
            v("div", W2, N(e.title), 1),
            Ae(n.$slots, "dropdown-icon", {}, () => [
              e.dropdownIcon ? (c(), g("img", {
                key: 0,
                src: e.dropdownIcon,
                alt: "dropdown",
                class: "h-[18px] w-[18px] relative"
              }, null, 8, q2)) : k("", !0)
            ])
          ]),
          e.actionText ? (c(), H(I(Be), {
            key: 0,
            variant: "secondary",
            label: e.actionText,
            size: "sm",
            onClick: t[0] || (t[0] = (a) => n.$emit("action"))
          }, null, 8, ["label"])) : k("", !0)
        ]),
        v("b", U2, N(e.value), 1),
        v("div", G2, N(e.subtitle), 1)
      ]))
    ]));
  }
}), Tg = Symbol("FieldBelow"), Qu = (e) => e.some((n) => n.type === $u ? !1 : n.type === wx ? typeof n.children == "string" && n.children.trim() !== "" : n.type === ce ? Array.isArray(n.children) && Qu(n.children) : !0), K2 = new Proxy({}, { get: () => {
} });
function Yt() {
  const e = Mn();
  return (n) => {
    var t;
    return !!((t = e[n]) != null && t.call(e, K2).some((a) => a.type !== $u));
  };
}
const La = {
  sm: {
    addon: "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]",
    input: "pl-[calc(--spacing(2))]",
    inputEnd: "pr-[calc(--spacing(2)-1px)]"
  },
  md: {
    addon: "pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2.5)-1px)]",
    input: "pl-[calc(--spacing(2.5))]",
    inputEnd: "pr-[calc(--spacing(2.5)-1px)]"
  },
  lg: {
    addon: "pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(3)-1px)]",
    input: "pl-[calc(--spacing(3))]",
    inputEnd: "pr-[calc(--spacing(3)-1px)]"
  },
  xl: {
    addon: "pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3.5)-1px)]",
    input: "pl-[calc(--spacing(3.5))]",
    inputEnd: "pr-[calc(--spacing(3.5)-1px)]"
  }
}, Y2 = ["id", "name", "type", "value", "placeholder", "disabled", "readonly", "inputmode", "autocomplete", "pattern", "maxlength", "minlength", "min", "max", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required"], J2 = ["aria-label", "onKeydown"], X2 = {
  key: 0,
  class: "shrink-0"
}, Z2 = /* @__PURE__ */ ke({
  __name: "TextInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    type: { default: "text" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelInline: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    inputmode: { default: void 0 },
    autocomplete: { default: "off" },
    pattern: { default: void 0 },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: { default: "default" },
    showEditIcon: { type: Boolean, default: !0 },
    variant: { default: "default" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    prefix: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "keydown", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = (Q, { slots: le }) => {
      var ee;
      return (ee = le.default) == null ? void 0 : ee.call(le);
    }, l = n, r = R(!1), o = R(null), i = R(null), s = R(null), d = Mn(), u = Yt(), f = m(() => u("actions")), b = Nt(Tg, null), h = m(() => (b == null ? void 0 : b()) ?? null), p = m(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), x = m(() => !!t.error), y = je(), w = m(() => t.id || y), $ = m(() => t.label ? `${w.value}-label` : void 0), S = m(() => `${w.value}-error`), L = m(() => `${w.value}-hint`), T = m(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const Q = [];
      return t.hint && L.value && Q.push(L.value), x.value && S.value && Q.push(S.value), Q.length > 0 ? Q.join(" ") : void 0;
    }), E = m(() => x.value ? "true" : void 0), A = m(() => t.valueVariant === "link" ? "text-(--text-text-link) font-(--weight-semi-bold)" : ""), D = (Q) => t.showEditIcon && Q && !r.value && !t.disabled && !t.readonly, M = m(() => r.value && p.value && !t.disabled && !t.readonly), F = m(() => t.fullWidth || t.width === void 0), X = m(() => F.value ? "w-full" : ""), _ = m(() => F.value ? {} : { width: t.width }), Y = m(
      () => t.buttons.length > 0 && t.labelInline ? { style: _.value } : {}
    ), B = m(() => t.buttons.length > 0), W = m(
      () => Xl(t.labelInline, !!t.label && !q.value, !!t.removeButton)
    ), U = m(() => t.removeButton && Ku(t.removeButton)), z = R(null), { inGroup: P, groupPart: K } = Ju(z), j = m(() => `${`relative min-w-0 ${P ? K.value.part : "pb-0.5"} text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter`} ${W.value.root}${F.value ? " w-full" : ""}`), G = m(() => F.value || t.labelInline ? {} : { width: t.width }), q = m(() => t.variant === "stacked"), J = m(() => !!t.prefix && !q.value), me = m(() => {
      if (q.value)
        return { class: "relative flex w-full min-w-0 items-center justify-center gap-0.5 px-6" };
      if (J.value) {
        const Q = La[t.size];
        return {
          class: [
            "flex h-full min-w-0 flex-1 items-center gap-2",
            Q.input,
            t.innerButton ? "" : Q.inputEnd
          ]
        };
      }
      return null;
    }), ye = m(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : !t.readonly && !x.value && !t.success && !r.value && !p.value ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) dark:text-(--colors-text-white-default)"), Z = (Q) => {
      var ne;
      if (!q.value || t.disabled) return;
      const le = Q.target;
      if (le === o.value) return;
      const ee = Q.currentTarget, O = le == null ? void 0 : le.closest('button, a, [role="button"], input, select, textarea, [tabindex]');
      O && O !== ee && ee.contains(O) || (Q.preventDefault(), (ne = o.value) == null || ne.focus());
    }, de = (Q) => {
      const le = Q.target;
      l("update:modelValue", le.value), l("input", Q);
    }, ge = (Q) => {
      var le;
      t.disabled || (r.value = !0, (le = Q.target) == null || le.select()), l("focus", Q);
    }, se = (Q) => {
      r.value = !1, l("blur", Q);
    }, Se = (Q) => {
      var le, ee;
      l("keydown", Q), (le = i.value) == null || le.handleFieldKeydown(Q), (ee = s.value) == null || ee.handleFieldKeydown(Q);
    }, V = () => {
      l("update:modelValue", ""), l("clear");
    };
    return (Q, le) => (c(), g("div", {
      ref_key: "rootRef",
      ref: z,
      class: C(j.value),
      style: Ne(G.value)
    }, [
      e.label && !q.value ? (c(), H(yt, {
        key: 0,
        id: $.value,
        ref_key: "labelRef",
        ref: i,
        text: e.label,
        "input-id": w.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        inline: e.labelInline,
        class: C(W.value.label),
        "test-id": "text-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      v("div", {
        class: C(["flex items-end gap-3 w-full", W.value.field])
      }, [
        re(lo, Oe({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, Y.value, {
          onButtonClick: le[2] || (le[2] = (ee) => l("button-click", ee))
        }), {
          default: xe(({ fieldClass: ee }) => [
            re(Bn, {
              size: e.size,
              stacked: q.value,
              flush: J.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              readonly: e.readonly && e.readonlyChrome,
              error: x.value,
              success: e.success,
              "has-value": p.value,
              class: C([
                e.disabled && e.valueVariant === "link" ? "cursor-pointer" : "",
                B.value ? "w-full" : X.value,
                !B.value && f.value ? "flex-1 min-w-0" : "",
                ee || I(K).corners
              ]),
              style: Ne(B.value || f.value ? {} : _.value),
              onMousedown: Z
            }, {
              default: xe(({
                hovered: O,
                iconBoxClass: ne,
                leftIconBoxClass: fe,
                iconColorClass: ue,
                textClass: te,
                topTextClass: oe,
                borderColorClass: Le,
                addonTextClass: Ie
              }) => [
                q.value && e.label ? (c(), H(yt, {
                  key: 0,
                  id: $.value,
                  ref_key: "labelRef",
                  ref: i,
                  text: e.label,
                  "input-id": w.value,
                  required: e.required,
                  "required-indicator": e.requiredIndicator,
                  focused: r.value,
                  "text-class": `${oe} ${ye.value}`,
                  "test-id": "text-input-label"
                }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused", "text-class"])) : k("", !0),
                J.value ? (c(), g("span", {
                  key: 1,
                  "data-testid": "text-input-prefix",
                  class: C([
                    "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                    I(La)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    Le,
                    Ie
                  ])
                }, [
                  e.iconLeft ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft, fe, ue])
                  }, null, 2)) : k("", !0),
                  et(" " + N(e.prefix), 1)
                ], 2)) : k("", !0),
                (c(), H(lt(me.value ? "div" : a), Zt(tn(me.value ?? {})), {
                  default: xe(() => [
                    e.iconLeft && !J.value ? (c(), g("i", {
                      key: 0,
                      class: C([e.iconLeft, fe, ue])
                    }, null, 2)) : k("", !0),
                    v("input", {
                      id: w.value,
                      ref_key: "inputRef",
                      ref: o,
                      name: e.name,
                      type: e.type,
                      value: e.modelValue,
                      placeholder: e.placeholder,
                      disabled: e.disabled,
                      readonly: e.readonly,
                      inputmode: e.inputmode,
                      autocomplete: e.autocomplete,
                      pattern: e.pattern,
                      maxlength: e.maxlength,
                      minlength: e.minlength,
                      min: e.min,
                      max: e.max,
                      "aria-labelledby": $.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      "aria-disabled": e.disabled ? "true" : void 0,
                      "aria-invalid": E.value,
                      "aria-describedby": T.value,
                      "aria-required": e.required ? "true" : void 0,
                      "data-testid": "text-input",
                      class: C([
                        q.value ? "field-sizing-content not-supports-[field-sizing:content]:flex-1 max-w-full min-w-0 text-center text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) p-0" : "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) pl-0",
                        te,
                        e.readonly ? "cursor-default" : "",
                        A.value,
                        e.valueVariant === "link" ? "pointer-events-none" : ""
                      ]),
                      onInput: de,
                      onFocus: ge,
                      onBlur: se,
                      onKeydown: Se
                    }, null, 42, Y2),
                    Ae(Q.$slots, "suffix", {}, void 0, !0),
                    (c(), H(lt(q.value ? "span" : a), Zt(tn(
                      q.value ? { class: "absolute right-0 top-1/2 flex -translate-y-1/2 items-center" } : {}
                    )), {
                      default: xe(() => [
                        Ae(Q.$slots, "iconRight", {
                          iconColorClass: ue,
                          iconBoxClass: ne
                        }, void 0, !0),
                        !d.iconRight && D(O) ? (c(), g("i", {
                          key: 0,
                          class: C(["ri-pencil-line text-(--icons-icon-accent)", ne])
                        }, null, 2)) : !d.iconRight && M.value ? (c(), g("i", {
                          key: 1,
                          class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", ne]),
                          role: "button",
                          tabindex: "-1",
                          "aria-label": e.labels.clear,
                          onMousedown: le[0] || (le[0] = Ye(() => {
                          }, ["prevent"])),
                          onClick: Ye(V, ["stop"]),
                          onKeydown: [
                            ut(V, ["enter"]),
                            ut(Ye(V, ["prevent"]), ["space"])
                          ]
                        }, null, 42, J2)) : k("", !0)
                      ]),
                      _: 2
                    }, 1040))
                  ]),
                  _: 2
                }, 1040)),
                e.innerButton ? (c(), H(Be, Oe({ key: 2 }, I(Xn)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: le[1] || (le[1] = (ve) => l("button-click", e.innerButton.id))
                }), null, 16)) : k("", !0)
              ]),
              _: 3
            }, 8, ["size", "stacked", "flush", "inner-button", "disabled", "readonly", "error", "success", "has-value", "class", "style"])
          ]),
          _: 3
        }, 16, ["buttons", "layout", "size", "disabled", "button-size"]),
        f.value ? (c(), g("div", X2, [
          Ae(Q.$slots, "actions", {}, void 0, !0)
        ])) : k("", !0),
        U.value && W.value.removeInFieldRow ? (c(), H(Be, Oe({ key: 1 }, I(Xn)(U.value, e.disabled), {
          size: I(za)(e.size, "attached"),
          onClick: le[3] || (le[3] = (ee) => l("button-click", U.value.id))
        }), null, 16, ["size"])) : k("", !0)
      ], 2),
      h.value ? (c(), g("div", {
        key: 1,
        class: C(["w-full", W.value.helper])
      }, [
        (c(), H(lt(() => h.value)))
      ], 2)) : k("", !0),
      !I(P) && W.value.reservesHelper || e.hint || e.error ? (c(), H(xt, {
        key: 2,
        ref_key: "helperRef",
        ref: s,
        class: C(W.value.helper),
        focused: r.value,
        hint: e.hint,
        error: e.error,
        "hint-id": L.value,
        "error-id": S.value,
        "test-id-prefix": "text-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
      U.value && !W.value.removeInFieldRow ? (c(), H(Be, Oe({ key: 3 }, I(Xn)(U.value, e.disabled), {
        class: W.value.remove,
        size: I(za)(e.size, "attached"),
        onClick: le[4] || (le[4] = (ee) => l("button-click", U.value.id))
      }), null, 16, ["class", "size"])) : k("", !0)
    ], 6));
  }
}), Ot = /* @__PURE__ */ ot(Z2, [["__scopeId", "data-v-a4da8935"]]), Q2 = ["aria-labelledby", "aria-describedby"], _2 = { class: "mt-px flex min-w-0 flex-col gap-px" }, JW = /* @__PURE__ */ ke({
  __name: "FieldGroup",
  props: {
    label: {},
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    layout: { default: "attached" },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = je(), a = `${t}-hint`, l = `${t}-error`, r = `${t}-label`, o = m(
      () => [n.hint ? a : "", n.error ? l : ""].filter(Boolean).join(" ") || void 0
    ), i = Yl([]), s = (y, w) => y.compareDocumentPosition(w) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1, d = { part: "", corners: "" };
    nn(Yu, {
      register: (y) => {
        i.value = [...i.value, y].sort(s);
      },
      unregister: (y) => {
        i.value = i.value.filter((w) => w !== y);
      },
      partOf: (y) => {
        const w = y ? i.value.indexOf(y) : -1;
        return n.layout !== "attached" || w < 0 ? d : $g(Sg(w, i.value.length), "l");
      }
    });
    const u = m(
      () => n.layout === "attached" ? Ig("l") : "flex w-full items-start gap-(--spacing-2-5)"
    ), f = R(!1), b = R(null), h = R(null);
    function p(y) {
      const w = y.relatedTarget;
      (!w || !y.currentTarget.contains(w)) && (f.value = !1);
    }
    function x(y) {
      var w, $;
      (w = b.value) == null || w.handleFieldKeydown(y), ($ = h.value) == null || $.handleFieldKeydown(y);
    }
    return (y, w) => (c(), g("fieldset", {
      "aria-labelledby": e.labelTooltip ? r : void 0,
      "aria-describedby": o.value,
      class: C(["m-0 w-full min-w-0 border-0 p-0 font-inter", { "max-w-sm": !e.fullWidth }]),
      "data-testid": "field-group",
      onFocusin: w[0] || (w[0] = ($) => f.value = !0),
      onFocusout: p,
      onKeydown: x
    }, [
      re(yt, {
        id: r,
        ref_key: "labelRef",
        ref: b,
        as: "legend",
        class: "p-0",
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: f.value,
        "test-id": "field-group-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"]),
      v("div", _2, [
        v("div", {
          class: C([u.value, "*:min-w-0 *:flex-1"]),
          "data-testid": "field-group-row"
        }, [
          Ae(y.$slots, "default")
        ], 2),
        re(xt, {
          ref_key: "helperRef",
          ref: h,
          focused: f.value,
          hint: e.hint,
          error: e.error,
          "hint-id": a,
          "error-id": l,
          "test-id-prefix": "field-group"
        }, null, 8, ["focused", "hint", "error"])
      ])
    ], 42, Q2));
  }
}), eC = ["id", "value", "placeholder", "disabled", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], tC = {
  role: "status",
  class: "sr-only",
  "data-testid": "copy-input-status"
}, Bs = "copy-to-clipboard", nC = 2e3, XW = /* @__PURE__ */ ke({
  __name: "CopyInput",
  props: {
    modelValue: { default: "" },
    variant: { default: "attached" },
    iconOnly: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    width: { default: void 0 },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["copy", "copy-error", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.labels.copy ?? "Copy"), r = m(() => t.labels.copied ?? "Copied!"), o = R(!1), i = R("");
    let s, d = !1;
    async function u() {
      try {
        await navigator.clipboard.writeText(t.modelValue);
      } catch (A) {
        a("copy-error", A);
        return;
      }
      clearTimeout(s), i.value = "", await Ue(), !d && (o.value = !0, i.value = r.value, a("copy", t.modelValue), s = setTimeout(() => {
        o.value = !1, i.value = "";
      }, nC));
    }
    mt(() => {
      d = !0, clearTimeout(s);
    });
    const f = {
      attached: "ri-file-copy-2-line",
      spaced: void 0,
      inner: "ri-file-copy-line",
      large: "ri-file-copy-2-line"
    }, b = m(() => {
      const A = t.iconOnly && (t.variant === "attached" || t.variant === "spaced");
      return {
        id: Bs,
        label: o.value && !A ? r.value : l.value,
        // The button keeps its name so only the status announces the copy, not also a name change
        ariaLabel: o.value && !A ? l.value : void 0,
        icon: A ? "ri-file-copy-line" : f[t.variant],
        iconOnly: A,
        color: t.variant === "inner" || t.variant === "large" ? "tertiary" : "secondary",
        position: "end"
      };
    }), h = m(
      () => t.variant === "inner" ? t.buttons : [...t.buttons, b.value]
    );
    function p(A) {
      A === Bs ? u() : a("button-click", A);
    }
    const x = je(), y = m(() => t.id || x), w = m(() => t.label ? `${y.value}-label` : void 0), $ = m(() => `${y.value}-hint`), S = m(() => `${y.value}-error`), L = m(() => {
      const A = [t.hint ? $.value : "", t.error ? S.value : ""].filter(Boolean);
      return A.length ? A.join(" ") : void 0;
    }), T = R(!1), E = m(() => Xl(!1, !!t.label, !1));
    return (A, D) => (c(), g("div", {
      class: C(["relative min-w-0", e.width ? "" : "w-full"]),
      style: Ne(e.width ? { width: e.width } : void 0),
      "data-testid": "copy-input"
    }, [
      e.variant === "large" ? (c(), g("div", {
        key: 0,
        class: C([
          "relative w-full min-w-0 pb-0.5 text-left font-inter text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
          E.value.root
        ])
      }, [
        e.label ? (c(), H(yt, {
          key: 0,
          id: w.value,
          text: e.label,
          "input-id": y.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: T.value,
          "test-id": "copy-input-label"
        }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : k("", !0),
        re(Bn, {
          multiline: "",
          disabled: e.disabled,
          error: !!e.error,
          "has-value": !!e.modelValue,
          class: "w-full gap-2"
        }, {
          default: xe(() => [
            v("textarea", {
              id: y.value,
              value: e.modelValue,
              placeholder: e.placeholder,
              disabled: e.disabled,
              readonly: "",
              "aria-labelledby": w.value,
              "aria-label": e.label ? void 0 : e.ariaLabel,
              "aria-invalid": e.error ? "true" : void 0,
              "aria-describedby": L.value,
              "aria-required": e.required ? "true" : void 0,
              "data-testid": "copy-input-value",
              class: "h-full min-w-0 flex-1 self-stretch resize-none cursor-default border-0 bg-transparent p-0 text-(length:--size-sm) leading-(--line-height-l-tight) outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              onFocus: D[0] || (D[0] = (M) => T.value = !0),
              onBlur: D[1] || (D[1] = (M) => T.value = !1)
            }, null, 40, eC),
            re(Be, {
              class: "-mr-1 mt-[calc(--spacing(2)+1px)] shrink-0 self-start",
              variant: "tertiary",
              size: "xs",
              "icon-left": b.value.icon,
              label: b.value.label,
              "aria-label": b.value.ariaLabel,
              disabled: e.disabled,
              "data-field-button": Bs,
              onClick: u
            }, null, 8, ["icon-left", "label", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "error", "has-value"]),
        re(xt, {
          hint: e.hint,
          error: e.error,
          "hint-id": $.value,
          "error-id": S.value,
          focused: T.value,
          "test-id-prefix": "copy-input"
        }, null, 8, ["hint", "error", "hint-id", "error-id", "focused"])
      ], 2)) : (c(), H(Ot, {
        key: 1,
        id: e.id,
        "model-value": e.modelValue,
        readonly: "",
        "readonly-chrome": !1,
        placeholder: e.placeholder,
        label: e.label,
        "label-tooltip": e.labelTooltip,
        required: e.required,
        "aria-label": e.ariaLabel,
        hint: e.hint,
        error: e.error,
        disabled: e.disabled,
        size: e.size,
        "icon-left": e.iconLeft,
        prefix: e.prefix,
        buttons: h.value,
        "button-layout": e.variant === "spaced" ? "spaced" : "attached",
        "inner-button": e.variant === "inner" ? b.value : void 0,
        onButtonClick: p
      }, null, 8, ["id", "model-value", "placeholder", "label", "label-tooltip", "required", "aria-label", "hint", "error", "disabled", "size", "icon-left", "prefix", "buttons", "button-layout", "inner-button"])),
      v("span", tC, N(i.value), 1)
    ], 6));
  }
}), aC = ["id"], lC = ["id", "name", "value", "placeholder", "disabled", "readonly", "min", "max", "step", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], rC = ["aria-label", "onKeydown"], oC = /* @__PURE__ */ ke({
  __name: "NumberInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    iconLeft: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    prefix: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R(null), o = R(null), i = je(), s = m(() => t.id ?? i), d = m(() => t.label ? `${s.value}-label` : void 0), u = m(() => t.prefix ? `${s.value}-prefix` : void 0), f = m(() => `${s.value}-error`), b = m(() => `${s.value}-hint`), h = m(
      () => d.value ? [d.value, u.value].filter(Boolean).join(" ") : void 0
    ), p = m(() => !!t.error), x = m(
      () => t.modelValue !== void 0 && t.modelValue !== null && String(t.modelValue).trim() !== ""
    ), y = (U) => U && !l.value && !t.disabled && !t.readonly, w = m(
      () => l.value && x.value && !t.disabled && !t.readonly
    ), $ = m(() => {
      const U = [];
      return t.hint && U.push(b.value), p.value && U.push(f.value), U.join(" ") || void 0;
    }), S = m(() => t.fullWidth || t.width === void 0), L = m(
      () => Xl(t.labelInline, !!t.label, !!t.removeButton)
    ), T = m(() => t.removeButton && Ku(t.removeButton)), E = R(null), { inGroup: A, groupPart: D } = Ju(E), M = m(
      () => `relative min-w-0 ${A ? D.value.part : "pb-0.5"} text-left text-(length:--size-m) font-inter ${L.value.root}${S.value ? " w-full" : ""}`
    ), F = m(() => S.value ? {} : { width: t.width });
    function X(U) {
      a("update:modelValue", U.target.value), a("input", U);
    }
    function _(U) {
      t.disabled || (l.value = !0), a("focus", U);
    }
    function Y(U) {
      l.value = !1, a("blur", U);
    }
    function B(U) {
      var z, P;
      (z = r.value) == null || z.handleFieldKeydown(U), (P = o.value) == null || P.handleFieldKeydown(U);
    }
    function W() {
      a("update:modelValue", ""), a("clear");
    }
    return (U, z) => (c(), g("div", {
      ref_key: "rootRef",
      ref: E,
      class: C(M.value),
      style: Ne(F.value)
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": s.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: l.value,
        inline: e.labelInline,
        class: C(L.value.label),
        "test-id": "number-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      v("div", {
        class: C(["flex w-full items-end gap-3", L.value.field])
      }, [
        re(lo, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: z[1] || (z[1] = (P) => a("button-click", P))
        }, {
          default: xe(({ fieldClass: P }) => [
            re(Bn, {
              class: C(["w-full", P || I(D).corners]),
              flush: !!e.prefix,
              size: e.size,
              disabled: e.disabled,
              readonly: e.readonly,
              error: p.value,
              success: e.success,
              "has-value": x.value
            }, {
              default: xe(({ hovered: K, iconBoxClass: j, leftIconBoxClass: G, iconColorClass: q, borderColorClass: J, addonTextClass: me, textClass: ye }) => [
                e.prefix ? (c(), g("span", {
                  key: 0,
                  id: u.value,
                  class: C([
                    "flex shrink-0 select-none items-center self-stretch border-r",
                    I(La)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    J,
                    me
                  ])
                }, N(e.prefix), 11, aC)) : k("", !0),
                v("div", {
                  class: C(
                    e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", I(La)[e.size].input, I(La)[e.size].inputEnd] : "contents"
                  )
                }, [
                  e.iconLeft && !e.prefix ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft, G, q]),
                    "aria-hidden": "true"
                  }, null, 2)) : k("", !0),
                  v("input", {
                    id: s.value,
                    name: e.name,
                    type: "number",
                    value: e.modelValue,
                    placeholder: e.placeholder,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    min: e.min,
                    max: e.max,
                    step: e.step,
                    "aria-labelledby": h.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-invalid": p.value ? "true" : void 0,
                    "aria-describedby": $.value,
                    "aria-required": e.required ? "true" : void 0,
                    "data-testid": "number-input",
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      ye,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    onInput: X,
                    onFocus: _,
                    onBlur: Y,
                    onKeydown: B
                  }, null, 42, lC),
                  y(K) ? (c(), g("i", {
                    key: 1,
                    class: C(["ri-pencil-line text-(--icons-icon-accent)", j])
                  }, null, 2)) : w.value ? (c(), g("i", {
                    key: 2,
                    class: C([
                      "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                      j
                    ]),
                    role: "button",
                    tabindex: "-1",
                    "aria-label": e.labels.clear,
                    onMousedown: z[0] || (z[0] = Ye(() => {
                    }, ["prevent"])),
                    onClick: Ye(W, ["stop"]),
                    onKeydown: [
                      ut(W, ["enter"]),
                      ut(Ye(W, ["prevent"]), ["space"])
                    ]
                  }, null, 42, rC)) : k("", !0)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "flush", "size", "disabled", "readonly", "error", "success", "has-value"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"]),
        T.value && L.value.removeInFieldRow ? (c(), H(Be, Oe({ key: 0 }, I(Xn)(T.value, e.disabled), {
          size: I(za)(e.size, "attached"),
          onClick: z[2] || (z[2] = (P) => a("button-click", T.value.id))
        }), null, 16, ["size"])) : k("", !0)
      ], 2),
      !I(A) && L.value.reservesHelper || e.hint || e.error ? (c(), H(xt, {
        key: 1,
        ref_key: "helperRef",
        ref: o,
        class: C(L.value.helper),
        focused: l.value,
        hint: e.hint,
        error: e.error,
        "hint-id": b.value,
        "error-id": f.value,
        "test-id-prefix": "number-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
      T.value && !L.value.removeInFieldRow ? (c(), H(Be, Oe({ key: 2 }, I(Xn)(T.value, e.disabled), {
        class: L.value.remove,
        size: I(za)(e.size, "attached"),
        onClick: z[3] || (z[3] = (P) => a("button-click", T.value.id))
      }), null, 16, ["class", "size"])) : k("", !0)
    ], 6));
  }
}), If = /* @__PURE__ */ ot(oC, [["__scopeId", "data-v-2b2a52df"]]), iC = ["id", "name", "checked", "disabled", "value", "aria-label", "aria-labelledby", "aria-describedby"], sC = {
  key: 1,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "radio-hit-area"
}, dC = ["for"], uC = /* @__PURE__ */ ke({
  __name: "RadioButton",
  props: {
    label: { default: void 0 },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    presentational: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.modelValue === t.value), r = R(null), { resync: o } = Xi(r, () => l.value), i = je(), s = m(() => t.id ?? i), d = m(() => t.presentational ? "span" : "div"), u = m(() => !t.presentational && !!t.label), f = m(() => {
      const $ = "relative box-border flex size-4 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent", S = u.value ? " mt-0.5" : "";
      return t.disabled ? `${$}${S} bg-(--background-background-disabled) border-(--border-border-disabled) cursor-not-allowed` : l.value ? `${$}${S} bg-(--background-background-white) border-(--border-border-black-default) dark:bg-(--background-background-black-default) dark:border-(--border-border-base-medium) cursor-pointer` : `${$}${S} bg-(--background-background-white) border-(--border-border-base-medium) dark:bg-(--background-background-black-default) cursor-pointer peer-focus-visible:border-(--border-border-hover)`;
    }), b = m(() => {
      const $ = "size-2 rounded-(--border-border-radius-rounded-full)";
      return t.disabled ? `${$} bg-(--background-background-disabled-strong) forced-colors:bg-[GrayText]` : `${$} bg-(--background-background-black-default) dark:bg-(--background-background-white-secondary) forced-colors:bg-[CanvasText]`;
    }), h = m(() => t.presentational ? "pointer-events-none flex items-center justify-center" : `${u.value ? "min-h-6 px-px " : ""}self-stretch flex items-center`), p = m(() => u.value ? "flex min-w-0 items-start gap-2" : "flex items-center gap-2 shrink-0"), x = m(() => {
      const $ = "relative min-w-0 flex-1 break-words text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)";
      return t.disabled ? `${$} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled) cursor-not-allowed` : `${$} text-(--text-text-heading) dark:text-(--text-text-white-default) cursor-pointer`;
    }), y = ($) => {
      $.preventDefault(), !(t.disabled || l.value) && (t.value !== void 0 && a("update:modelValue", t.value), a("change", $));
    }, w = ($) => {
      if (t.disabled || l.value) return;
      $.target.checked && t.value !== void 0 && (a("update:modelValue", t.value), a("change", $), o());
    };
    return ($, S) => (c(), H(lt(d.value), Oe({
      "data-testid": "radio-container",
      class: h.value
    }, Ml(e.presentational ? {} : { click: y })), {
      default: xe(() => [
        (c(), H(lt(d.value), {
          class: C(p.value)
        }, {
          default: xe(() => [
            e.presentational ? k("", !0) : (c(), g("input", {
              key: 0,
              id: s.value,
              ref_key: "inputRef",
              ref: r,
              name: e.name,
              type: "radio",
              checked: l.value,
              disabled: e.disabled,
              value: e.value,
              "aria-label": e.ariaLabel,
              "aria-labelledby": e.ariaLabelledby,
              "aria-describedby": e.ariaDescribedby,
              class: "peer sr-only",
              onChange: w,
              onClick: S[0] || (S[0] = Ye(() => {
              }, ["stop"]))
            }, null, 40, iC)),
            (c(), H(lt(d.value), {
              "data-testid": "radio-button",
              class: C(f.value)
            }, {
              default: xe(() => [
                l.value ? (c(), H(lt(d.value), {
                  key: 0,
                  class: C(b.value)
                }, null, 8, ["class"])) : k("", !0),
                e.presentational ? k("", !0) : (c(), g("span", sC))
              ]),
              _: 1
            }, 8, ["class"])),
            !e.presentational && e.label ? (c(), g("label", {
              key: 1,
              for: s.value,
              class: C(x.value)
            }, N(e.label), 11, dC)) : k("", !0)
          ]),
          _: 1
        }, 8, ["class"]))
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), Lg = "rounded-(--border-border-radius-rounded-l) border border-solid", Ag = `${Lg} p-[calc(--spacing(4)-1px)]`, Eg = "shadow-(--blur-shadow-xs)", Rd = "transition-[border-color,box-shadow,background-color] motion-reduce:transition-none", Rg = "bg-(--background-background-white) dark:bg-(--colors-background-black-default)", Bg = "border-(--border-border-base-medium) dark:border-(--colors-border-base)", Dg = "hover:bg-(--background-background-hover) dark:hover:bg-white/5", Mg = "border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle)", zg = "bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled)", _i = "text-(--text-text-disabled-strong)", cC = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", fC = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", Og = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", hC = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", ai = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", bC = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", gC = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)";
function Pg(e) {
  return e ? _i : "text-(--text-text-heading) dark:text-(--colors-text-white-default)";
}
function Fg(e) {
  return e ? _i : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)";
}
const Bd = "[&_.opal-badge]:whitespace-normal [&_.opal-badge]:break-words [&_.opal-badge]:text-left [&_.opal-badge]:max-w-full";
function Vg(e, n) {
  return n ? "disabled" : e.theme ?? "neutral";
}
const Ng = "bg-(--background-background-selected)", Dd = "border-(--border-border-accent)", Md = "border-(--border-border-hover)", kr = "has-[[data-selectable-card-input]:focus-visible]:shadow-(--shadow-focus-l) has-[[data-selectable-card-input]:focus-visible]:outline-2 has-[[data-selectable-card-input]:focus-visible]:outline-transparent", Hg = "has-[[data-selectable-card-input]:focus-visible]:border-(--border-border-hover)", mC = ["id", "role", "aria-label", "data-name"], pC = ["id"], vC = ["id", "name", "value", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], xC = ["id"], yC = ["id"], kC = {
  key: 0,
  class: "flex flex-wrap items-center gap-1"
}, wC = ["id"], CC = ["id"], ZW = /* @__PURE__ */ ke({
  __name: "RadioForm",
  props: {
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    value: { type: [String, Number, Boolean] },
    label: {},
    helper: { default: void 0 },
    icon: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ctaLabel: { default: void 0 },
    ctaIcon: { default: "ri-eye-line" },
    ctaSecondaryLabel: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    badges: { default: void 0 },
    indicatorPosition: { default: "right" }
  },
  emits: ["update:modelValue", "cta", "cta-secondary"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Yt(), r = m(() => t.modelValue === t.value), o = m(() => t.type === "simple"), i = m(() => !t.readonly && !t.disabled), s = je(), d = je(), u = m(() => !!t.helper && !o.value), f = je(), b = je(), h = R(null), p = R(!1);
    $e(
      h,
      (ne, fe, ue) => {
        const te = () => {
          p.value = !!ne && !ne.querySelector(ba);
        };
        if (te(), !ne) return;
        const oe = new MutationObserver(te);
        oe.observe(ne, {
          childList: !0,
          subtree: !0,
          attributes: !0,
          attributeFilter: ["tabindex", "disabled", "href", "contenteditable", "type"]
        }), ue(() => oe.disconnect());
      },
      { immediate: !0, flush: "post" }
    );
    const x = m(() => {
      const ne = [];
      return u.value && ne.push(d), p.value && ne.push(b), t.labelTooltip && ne.push(f), ne.length > 0 ? ne.join(" ") : void 0;
    }), y = R(null), w = R(null), $ = R(null), { resync: S } = Xi($, () => r.value), L = R(null), T = R(null), E = R(!1), A = R(!1), D = m(() => {
      if (t.labelTooltip)
        return A.value ? !1 : E.value ? !0 : void 0;
    });
    function M(ne) {
      try {
        return ne.matches(":focus-visible");
      } catch {
        return !0;
      }
    }
    function F(ne) {
      var fe;
      return ne instanceof Node && !!((fe = y.value) != null && fe.contains(ne));
    }
    function X(ne) {
      t.labelTooltip && ne.target === $.value && ne.target instanceof Element && M(ne.target) && (E.value = !0);
    }
    function _(ne) {
      F(ne.relatedTarget) || (E.value = !1, A.value = !1);
    }
    const Y = m(
      () => t.labelTooltip ? "flex items-center gap-1" : ""
    ), B = m(
      () => t.disabled ? _i : "text-(--colors-icon-dark-default) dark:text-(--colors-text-white-default)"
    );
    function W() {
      E.value || (A.value = !1);
    }
    const U = m(() => {
      const ne = i.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return o.value ? `flex w-full flex-wrap items-center gap-3${ne}` : `flex w-full flex-wrap items-start ${t.type === "card" && t.icon && u.value ? "gap-3" : "gap-2"}${ne}`;
    }), z = m(() => o.value || !t.icon || u.value ? "none" : Nl(t.icon) ? "icon" : "emoji"), P = m(
      () => ({ none: "", icon: "pt-1.5", emoji: "pt-1" })[z.value]
    ), K = m(
      () => t.type === "card-cta" && !!t.ctaLabel && !t.readonly
    ), j = m(() => K.value && !!t.ctaSecondaryLabel), G = m(
      () => `relative flex flex-col gap-4 ${o.value ? "justify-center" : "min-w-60"} ${Ag} ${Rd} ${Bd}`
    ), q = () => l("default");
    function J() {
      return t.type !== "card" ? Dd : q() ? Md : t.icon && u.value ? Dd : Md;
    }
    function me() {
      const ne = `${Eg} ${Rg} ${Bg}`;
      return t.readonly ? `${G.value} ${ne}` : t.disabled ? `${G.value} ${zg} ${Mg} cursor-not-allowed` : r.value ? `${G.value} ${Ng} ${J()} cursor-pointer ${kr}` : `${G.value} ${ne} ${Dg} cursor-pointer ${kr} ${Hg}`;
    }
    const ye = m(() => Pg(t.disabled)), Z = () => t.type === "card-cta" || t.type === "card" && q() ? gC : ai, de = m(() => [Og, Fg(t.disabled)]);
    function ge() {
      i.value && (a("update:modelValue", t.value), S());
    }
    const se = `${ba},a,button,input,select,textarea,[aria-disabled="true"]`;
    function Se(ne) {
      var ue, te;
      if ((ue = L.value) != null && ue.contains(ne)) return !0;
      const fe = ne.closest(se);
      return !!fe && fe !== $.value && !!((te = y.value) != null && te.contains(fe));
    }
    function V(ne) {
      !i.value || !(ne.target instanceof Element) || Se(ne.target) || ne.preventDefault();
    }
    function Q(ne) {
      var ue, te, oe;
      if (!i.value || !(ne.target instanceof Element)) return;
      const fe = ne.target;
      (ue = w.value) != null && ue.contains(fe) || Se(fe) || ((te = $.value) == null || te.focus({ preventScroll: !0 }), (oe = $.value) == null || oe.click());
    }
    function le(ne) {
      var fe, ue;
      ne.key !== "Escape" || !t.labelTooltip || ((fe = T.value) != null && fe.isVisible && (ne.stopPropagation(), ne.preventDefault()), A.value = !0, (ue = T.value) == null || ue.hide());
    }
    function ee() {
      t.disabled || a("cta");
    }
    function O() {
      t.disabled || a("cta-secondary");
    }
    return (ne, fe) => (c(), g("div", {
      id: e.readonly ? e.id : void 0,
      ref_key: "cardRef",
      ref: y,
      "data-testid": "radio-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(me()),
      onMousedown: V,
      onClick: Q,
      onKeydown: le,
      onFocusin: X,
      onFocusout: _,
      onMouseleave: W
    }, [
      e.labelTooltip ? (c(), g("span", {
        key: 0,
        id: I(f),
        class: "sr-only"
      }, N(e.labelTooltip), 9, pC)) : k("", !0),
      (c(), H(lt(e.readonly ? "div" : "label"), {
        ref_key: "labelRef",
        ref: w,
        "data-testid": "radio-form-label",
        class: C(U.value)
      }, {
        default: xe(() => [
          e.readonly ? k("", !0) : (c(), g("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: $,
            type: "radio",
            class: "sr-only",
            name: e.name,
            value: String(e.value),
            checked: r.value,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : I(s),
            "aria-describedby": x.value,
            "data-selectable-card-input": "",
            onChange: ge
          }, null, 40, vC)),
          e.icon ? (c(), g(ce, { key: 1 }, [
            I(Nl)(e.icon) ? (c(), H(Vt, {
              key: 0,
              as: "span",
              size: "md",
              type: "square",
              variant: "outlined",
              color: e.disabled ? "disabled" : "white",
              icon: e.icon
            }, null, 8, ["color", "icon"])) : (c(), g("span", {
              key: 1,
              class: C(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
              "aria-hidden": "true"
            }, N(e.icon), 3))
          ], 64)) : k("", !0),
          o.value ? (c(), g("span", {
            key: 2,
            id: I(s),
            class: C(["min-w-0 flex-1", I(ai), Y.value, ye.value])
          }, [
            et(N(e.label) + " ", 1),
            e.labelTooltip ? (c(), H(ft, {
              key: 0,
              ref_key: "tooltipRef",
              ref: T,
              as: "span",
              text: e.labelTooltip,
              open: D.value,
              class: "shrink-0"
            }, {
              default: xe(() => [
                v("i", {
                  class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", B.value]),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["text", "open"])) : k("", !0)
          ], 10, xC)) : (c(), g("span", {
            key: 3,
            class: C(["flex min-w-0 flex-1 flex-col gap-1", P.value])
          }, [
            v("span", {
              "data-testid": "radio-form-title-row",
              class: C(["flex flex-wrap items-start justify-between gap-1", u.value ? "" : "min-h-6"])
            }, [
              v("span", {
                id: I(s),
                "data-testid": "radio-form-title",
                class: C(["min-w-0 grow", Z(), Y.value, ye.value])
              }, [
                et(N(e.label) + " ", 1),
                e.labelTooltip ? (c(), H(ft, {
                  key: 0,
                  ref_key: "tooltipRef",
                  ref: T,
                  as: "span",
                  text: e.labelTooltip,
                  open: D.value,
                  class: "shrink-0"
                }, {
                  default: xe(() => [
                    v("i", {
                      class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", B.value]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["text", "open"])) : k("", !0)
              ], 10, yC),
              e.badges && e.badges.length > 0 ? (c(), g("span", kC, [
                (c(!0), g(ce, null, Re(e.badges, (ue, te) => (c(), H(ct, Oe({ key: te }, { ref_for: !0 }, ue, {
                  theme: I(Vg)(ue, e.disabled),
                  "show-close-icon": !1,
                  "truncation-focusable": !1
                }), null, 16, ["theme"]))), 128))
              ])) : k("", !0)
            ], 2),
            u.value ? (c(), g("span", {
              key: 0,
              id: I(d),
              class: C(de.value)
            }, N(e.helper), 11, wC)) : k("", !0)
          ], 2)),
          e.readonly ? k("", !0) : (c(), g("span", {
            key: 4,
            "data-testid": "radio-form-indicator",
            class: C(["pointer-events-none w-4 shrink-0", [P.value, e.indicatorPosition === "left" ? "order-first" : void 0]]),
            "aria-hidden": "true"
          }, [
            v("span", {
              "data-testid": "radio-form-indicator-line",
              class: C(o.value || u.value ? "block" : "block py-1")
            }, [
              re(uC, {
                "model-value": e.modelValue,
                value: e.value,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "value", "disabled"])
            ], 2)
          ], 2))
        ]),
        _: 1
      }, 8, ["class"])),
      q() ? (c(), g("div", {
        key: 1,
        id: I(b),
        ref_key: "bodyRef",
        ref: h,
        "data-testid": "radio-form-body",
        class: "flex w-full flex-col gap-3"
      }, [
        Ae(ne.$slots, "default")
      ], 8, CC)) : k("", !0),
      K.value ? (c(), g("div", {
        key: 2,
        ref_key: "footerRef",
        ref: L,
        "data-testid": "radio-form-footer",
        class: "flex items-center justify-between gap-4"
      }, [
        re(Be, {
          "data-testid": "radio-form-cta",
          variant: "secondary",
          size: "xs",
          "icon-left": e.ctaIcon,
          label: e.ctaLabel,
          disabled: e.disabled,
          onClick: ee
        }, null, 8, ["icon-left", "label", "disabled"]),
        j.value ? (c(), H(Be, {
          key: 0,
          "data-testid": "radio-form-cta-secondary",
          variant: "secondary",
          size: "xs",
          label: e.ctaSecondaryLabel,
          disabled: e.disabled,
          onClick: O
        }, null, 8, ["label", "disabled"])) : k("", !0)
      ], 512)) : k("", !0)
    ], 42, mC));
  }
}), SC = ["aria-labelledby"], $C = ["id"], QW = /* @__PURE__ */ ke({
  __name: "RadioFormGroup",
  props: {
    legend: {}
  },
  setup(e) {
    const n = je();
    return (t, a) => (c(), g("div", {
      role: "radiogroup",
      "aria-labelledby": e.legend && !t.$attrs["aria-label"] ? I(n) : void 0
    }, [
      e.legend ? (c(), g("div", {
        key: 0,
        id: I(n),
        "data-testid": "radio-form-group-legend",
        class: C(I(cg))
      }, N(e.legend), 11, $C)) : k("", !0),
      Ae(t.$slots, "default")
    ], 8, SC));
  }
}), IC = ["aria-labelledby"], TC = {
  key: 0,
  "data-testid": "checkbox-group-required",
  class: "whitespace-pre"
}, LC = {
  "data-testid": "checkbox-group-items",
  class: "flex flex-wrap items-start gap-2 *:w-auto"
}, _W = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "CheckboxGroup",
  props: {
    legend: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Nn(), a = Mn(), l = je(), r = `${l}-error`, o = `${l}-legend`, i = m(
      () => n.ariaLabelledby ?? (n.labelTooltip && (n.legend || a.legend) ? o : void 0)
    ), s = m(() => {
      const d = [t["aria-describedby"], n.error ? r : void 0].filter(Boolean);
      return d.length > 0 ? d.join(" ") : void 0;
    });
    return nn(
      Nu,
      m(() => n.error ? r : void 0)
    ), (d, u) => (c(), g("fieldset", Oe({ ...I(t), "aria-describedby": s.value }, {
      "aria-labelledby": i.value,
      class: "m-0 min-w-0 border-0 p-0"
    }), [
      e.legend || I(a).legend ? (c(), g("legend", {
        key: 0,
        "data-testid": "checkbox-group-legend",
        class: C([I(cg), "p-0", e.labelTooltip ? "flex items-center gap-1" : ""])
      }, [
        v("span", { id: o }, [
          Ae(d.$slots, "legend", {}, () => [
            et(N(e.legend), 1)
          ]),
          e.required ? (c(), g("span", TC, N(` ${e.requiredIndicator}`), 1)) : k("", !0)
        ]),
        e.labelTooltip ? (c(), H(kg, {
          key: 0,
          text: e.labelTooltip
        }, null, 8, ["text"])) : k("", !0)
      ], 2)) : k("", !0),
      v("div", LC, [
        Ae(d.$slots, "default")
      ]),
      e.error ? (c(), g("div", {
        key: 1,
        id: r,
        "data-testid": "checkbox-group-error",
        role: "alert",
        class: C(["mt-2", I(fg)])
      }, [
        v("i", {
          class: C(I(hg)),
          "aria-hidden": "true"
        }, null, 2),
        v("span", null, N(e.error), 1)
      ], 2)) : k("", !0)
    ], 16, IC));
  }
}), AC = ["id", "role", "aria-label", "data-name"], EC = ["id", "name", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], RC = ["id"], BC = {
  key: 2,
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, DC = ["src"], MC = { class: "flex w-full flex-col gap-1" }, zC = ["id"], OC = ["id"], PC = ["id"], FC = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-3"
}, VC = {
  key: 1,
  class: "flex flex-wrap items-center gap-3"
}, NC = ["id"], HC = ["id"], eq = /* @__PURE__ */ ke({
  __name: "CheckboxForm",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    helper: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ariaLabel: { default: void 0 },
    align: { default: void 0 },
    badgesAlign: { default: void 0 },
    badges: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    imageSrc: { default: void 0 },
    icon: { default: void 0 },
    subtitle: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Yt(), r = m(() => !t.readonly && !t.disabled), o = m(() => t.type === "inline"), i = je(), s = je(), d = je(), u = m(() => t.type === "simple" && !t.icon), f = m(() => !!t.helper && !u.value), b = m(() => !!t.subtitle && t.type === "card"), h = m(() => t.type === "card" ? t.avatar : void 0), p = m(() => t.type === "card" ? t.icon : void 0), x = () => !u.value && t.type !== "big-card" && l("trailing"), y = m(() => !!t.icon && (t.type === "simple" || t.type === "card")), w = ug(() => [
      b.value ? d : void 0,
      f.value ? s : void 0
    ]);
    vy();
    const $ = R(null), { resync: S } = Xi($, () => t.modelValue), L = R(null), T = m(() => (t.align ?? (t.avatar ? "center" : void 0) ?? (t.type === "simple" && t.icon ? "center" : void 0) ?? "top") === "center" ? "items-center" : "items-start"), E = m(
      () => t.badgesAlign ?? (t.avatar || b.value ? "title" : "end")
    ), A = m(() => o.value ? "flex flex-wrap items-start gap-1" : E.value === "title" ? "flex flex-wrap items-center gap-3" : "flex flex-wrap items-start justify-between gap-1"), D = `group relative flex flex-wrap gap-2 p-px min-w-60 ${Bd}`, M = `relative flex flex-wrap ${Ag} ${Rd} ${Bd}`, F = `relative flex items-center justify-center ${Lg} px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] ${Rd}`, X = m(() => {
      const de = t.type === "simple" ? "gap-3" : "gap-2";
      return `flex ${T.value} min-w-0 flex-1 ${de}`;
    });
    function _() {
      if (o.value)
        return t.readonly ? D : t.disabled ? `${D} cursor-not-allowed` : `${D} cursor-pointer ${kr}`;
      const de = t.type === "big-card" ? "min-w-46" : "min-w-60", ge = u.value ? F : `${M} ${de} ${h.value ? "gap-2" : "gap-1"}`, Se = `${x() || b.value ? "" : `${Eg} `}${Rg} ${Bg}`;
      if (t.readonly) return `${ge} ${Se}`;
      if (t.disabled)
        return `${ge} ${zg} ${Mg} cursor-not-allowed`;
      if (t.modelValue) {
        const V = y.value ? Md : Dd;
        return `${ge} ${Ng} ${V} cursor-pointer ${kr}`;
      }
      return `${ge} ${Se} ${Dg} cursor-pointer ${kr} ${Hg}`;
    }
    const Y = m(() => Pg(t.disabled)), B = m(
      () => t.type === "inline" && r.value ? "group-hover:text-(--text-text-hover)" : ""
    ), W = m(() => t.type === "advanced" && t.modelValue), U = m(() => {
      if (u.value) return `${ai} text-center ${Y.value}`;
      if (t.type === "simple" || p.value) return `min-w-0 flex-1 ${ai} ${Y.value}`;
      const de = t.type === "big-card" ? bC : hC, ge = o.value ? "min-w-0 flex-1" : "min-w-0", se = W.value ? " line-through" : "";
      return `${ge} ${de} ${Y.value} ${B.value}${se}`;
    }), z = m(
      () => t.disabled ? _i : "text-(--text-text-black-default) dark:text-(--colors-text-white-secondary)"
    ), P = m(() => {
      if (b.value || h.value)
        return `${cC} ${z.value}`;
      const de = Fg(t.disabled), ge = W.value ? " line-through" : "";
      return `${Og} ${de} ${B.value}${ge}`;
    }), K = m(() => `${fC} ${z.value}`), j = m(() => `flex min-w-0 flex-1 flex-col ${h.value ? "gap-1" : "gap-3"}`), G = m(() => `flex flex-wrap items-center ${h.value ? "gap-3" : "gap-4"}`), q = m(() => b.value ? "flex flex-col gap-px" : t.avatar || t.type === "simple" || p.value ? "flex flex-col gap-1" : "flex flex-col gap-0.5"), J = m(() => {
      const de = r.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return `flex min-w-0 flex-1${u.value ? " justify-center" : ""}${de}`;
    });
    function me(de) {
      const ge = de.target;
      a("update:modelValue", ge.checked), S();
    }
    function ye(de) {
      var Se;
      const ge = de.currentTarget;
      if (!r.value || !(de.target instanceof Element) || (Se = L.value) != null && Se.contains(de.target)) return;
      const se = de.target.closest(ba);
      se && se !== $.value && ge.contains(se) || de.preventDefault();
    }
    function Z(de) {
      var ge, se;
      !r.value || de.target !== de.currentTarget || ((ge = $.value) == null || ge.focus({ preventScroll: !0 }), (se = $.value) == null || se.click());
    }
    return (de, ge) => (c(), g("div", {
      id: e.readonly ? e.id : void 0,
      "data-testid": "checkbox-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(_()),
      onMousedown: ye,
      onClick: Z
    }, [
      (c(), H(lt(e.readonly ? "div" : "label"), {
        "data-testid": "checkbox-form-label",
        class: C(J.value)
      }, {
        default: xe(() => [
          e.readonly ? k("", !0) : (c(), g("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: $,
            type: "checkbox",
            class: "sr-only",
            name: e.name,
            checked: e.modelValue,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : I(i),
            "aria-describedby": I(w),
            "data-selectable-card-input": "",
            onChange: me
          }, null, 40, EC)),
          u.value ? (c(), g("span", {
            key: 1,
            id: I(i),
            class: C(U.value)
          }, N(e.label), 11, RC)) : e.type === "big-card" ? (c(), g("span", BC, [
            e.imageSrc ? (c(), g("img", {
              key: 0,
              src: e.imageSrc,
              alt: "",
              class: "size-8 shrink-0 object-contain"
            }, null, 8, DC)) : k("", !0),
            v("span", MC, [
              v("span", {
                id: I(i),
                class: C(U.value)
              }, N(e.label), 11, zC),
              f.value ? (c(), g("span", {
                key: 0,
                id: I(s),
                class: C(P.value)
              }, N(e.helper), 11, OC)) : k("", !0)
            ])
          ])) : (c(), g("span", {
            key: 3,
            "data-testid": "checkbox-form-content-group",
            class: C(X.value)
          }, [
            !e.readonly && e.type !== "simple" ? (c(), g("span", {
              key: 0,
              "data-testid": "checkbox-form-indicator",
              class: C(["pointer-events-none w-4 shrink-0 py-1", p.value ? "me-1" : ""]),
              "aria-hidden": "true"
            }, [
              re($n, {
                "model-value": e.modelValue,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "disabled"])
            ], 2)) : k("", !0),
            y.value && e.icon ? (c(), g(ce, { key: 1 }, [
              I(Nl)(e.icon) ? (c(), H(Vt, {
                key: 0,
                as: "span",
                size: "md",
                type: "square",
                variant: "outlined",
                color: e.disabled ? "disabled" : e.type === "card" ? "default" : "white",
                icon: e.icon
              }, null, 8, ["color", "icon"])) : (c(), g("span", {
                key: 1,
                class: C([
                  "text-num-32 leading-none shrink-0",
                  e.disabled ? "opacity-50" : "",
                  e.type === "card" ? "me-1" : ""
                ]),
                "aria-hidden": "true"
              }, N(e.icon), 3))
            ], 64)) : k("", !0),
            h.value ? (c(), H(Mt, {
              key: 2,
              img: h.value.img,
              name: h.value.name,
              as: "span",
              size: "md",
              presentational: ""
            }, null, 8, ["img", "name"])) : k("", !0),
            v("span", {
              class: C(j.value)
            }, [
              v("span", {
                class: C(q.value)
              }, [
                v("span", {
                  "data-testid": "checkbox-form-title-row",
                  class: C(A.value)
                }, [
                  v("span", {
                    id: I(i),
                    class: C(U.value)
                  }, N(e.label), 11, PC),
                  e.badges && e.badges.length > 0 || e.icons && e.icons.length > 0 ? (c(), g("span", FC, [
                    e.badges && e.badges.length > 0 ? (c(), g("span", {
                      key: 0,
                      class: C(["flex flex-wrap items-center", E.value === "title" ? "gap-3" : "gap-1"])
                    }, [
                      (c(!0), g(ce, null, Re(e.badges, (se, Se) => (c(), H(ct, Oe({ key: Se }, { ref_for: !0 }, se, {
                        theme: I(Vg)(se, e.disabled),
                        "show-close-icon": !1,
                        "truncation-focusable": !1
                      }), null, 16, ["theme"]))), 128))
                    ], 2)) : k("", !0),
                    e.icons && e.icons.length > 0 ? (c(), g("span", VC, [
                      (c(!0), g(ce, null, Re(e.icons, (se, Se) => (c(), g("i", {
                        key: Se,
                        class: C([`ri-${se}`, "text-(length:--size-4xl) leading-none"]),
                        "aria-hidden": "true"
                      }, null, 2))), 128))
                    ])) : k("", !0)
                  ])) : k("", !0)
                ], 2),
                b.value ? (c(), g("span", {
                  key: 0,
                  id: I(d),
                  "data-testid": "checkbox-form-subtitle",
                  class: C(K.value)
                }, N(e.subtitle), 11, NC)) : k("", !0),
                f.value ? (c(), g("span", {
                  key: 1,
                  id: I(s),
                  class: C(P.value)
                }, N(e.helper), 11, HC)) : k("", !0)
              ], 2),
              (e.type === "advanced" || e.type === "card") && I(l)("details") ? (c(), g("span", {
                key: 0,
                "data-testid": "checkbox-form-details",
                class: C(G.value)
              }, [
                Ae(de.$slots, "details")
              ], 2)) : k("", !0)
            ], 2)
          ], 2))
        ]),
        _: 3
      }, 8, ["class"])),
      x() ? (c(), g("div", {
        key: 0,
        ref_key: "trailingRef",
        ref: L,
        "data-testid": "checkbox-form-trailing",
        class: "flex shrink-0 items-start justify-end"
      }, [
        Ae(de.$slots, "trailing")
      ], 512)) : k("", !0)
    ], 42, AC));
  }
}), jC = { class: "w-full flex flex-col gap-2" }, WC = {
  key: 0,
  class: "text-sm font-medium text-text-black-default dark:text-(--colors-text-white-default)"
}, qC = { class: "flex flex-col items-center gap-2" }, UC = ["src"], GC = { class: "relative text-sm leading-5 dark:text-(--colors-text-white-default)" }, KC = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, YC = { class: "flex-1 flex flex-col items-center gap-1.5" }, JC = { class: "flex-1 flex flex-col items-center gap-1.5" }, XC = { class: "flex-1 flex flex-col items-center gap-1.5" }, ZC = ["id", "name", "accept", "disabled"], QC = {
  key: 1,
  class: "text-sm text-red-600 dark:text-red-400"
}, _C = /* @__PURE__ */ ke({
  __name: "ImageInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    browseButtonText: { default: "Browse file" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => !!t.error), l = m(() => typeof t.error == "string" ? t.error : void 0), r = n, o = R(null), i = R(!1), s = R(!1), d = je(), u = `${d}-browse`, f = `${d}-library`, b = `${d}-link`, p = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], x = m(() => {
      const B = t.variant === "buttons" ? "border-border-base" : "border-border-primary-button", W = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${p.container}`;
      return t.disabled ? `${W} bg-background-disabled-subtle dark:bg-(--colors-background-disabled) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) cursor-not-allowed` : a.value ? `${W} bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] text-[#B42318] dark:text-[#B42318] cursor-pointer` : t.success ? `${W} bg-background-white dark:bg-(--colors-background-black-default) border-[#009966] dark:border-[#009966] text-text-body dark:text-(--colors-text-white-default) cursor-pointer` : i.value ? `${W} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : s.value ? `${W} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : `${W} bg-background-white dark:bg-(--colors-background-black-default) ${B} dark:border-(--colors-border-base) text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer`;
    }), y = (B) => {
      if (!B || B.length === 0 || t.disabled) return;
      const W = Array.from(B);
      if (W.filter((K) => K.size > t.maxFileSize).length > 0) {
        r("error", `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`);
        return;
      }
      const z = W.length === 1 ? W[0] : W;
      r("update:modelValue", z);
      const P = new Event("change", { bubbles: !0 });
      r("change", P);
    }, w = () => {
      var B;
      t.disabled || (B = o.value) == null || B.click();
    }, $ = (B) => {
      var W;
      t.disabled || (r("browse", B), (W = o.value) == null || W.click());
    }, S = (B) => {
      t.disabled || r("library", B);
    }, L = (B) => {
      t.disabled || r("link", B);
    }, T = (B) => {
      const W = B.target;
      y(W.files);
    }, E = (B) => {
      B.preventDefault(), B.stopPropagation(), t.disabled || (i.value = !0);
    }, A = (B) => {
      B.preventDefault(), B.stopPropagation(), i.value = !1;
    }, D = (B) => {
      var U;
      if (B.preventDefault(), B.stopPropagation(), i.value = !1, t.disabled) return;
      const W = (U = B.dataTransfer) == null ? void 0 : U.files;
      W && y(W);
    }, M = () => {
      var B;
      t.disabled || (B = o.value) == null || B.click();
    }, F = (B, W) => {
      try {
        if (B.startsWith("data:image/svg+xml")) {
          const U = B.split(",")[1];
          if (!U) return B;
          const P = decodeURIComponent(U).replace(/fill=["']currentColor["']/gi, `fill="${W}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${W}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(P)}`;
        }
        return B.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${W.slice(1)}`);
      } catch {
        return B;
      }
    }, X = m(() => {
      if (t.browseIcon)
        return t.success && t.variant === "buttons" ? F(t.browseIcon, "#007A55") : t.browseIcon;
    }), _ = m(() => {
      if (t.libraryIcon)
        return t.success && t.variant === "buttons" ? F(t.libraryIcon, "#007A55") : t.libraryIcon;
    }), Y = m(() => {
      if (t.linkIcon)
        return t.success && t.variant === "buttons" ? F(t.linkIcon, "#007A55") : t.linkIcon;
    });
    return (B, W) => (c(), g("div", jC, [
      e.label ? (c(), g("div", WC, N(e.label), 1)) : k("", !0),
      v("div", {
        class: C(x.value),
        onDragover: E,
        onDragleave: A,
        onDrop: D,
        onClick: W[0] || (W[0] = (U) => e.variant === "default" ? M() : void 0),
        onMouseenter: W[1] || (W[1] = (U) => s.value = !0),
        onMouseleave: W[2] || (W[2] = (U) => s.value = !1)
      }, [
        e.variant === "default" ? (c(), g("div", {
          key: 0,
          class: C(["flex flex-col items-center", I(p).gap])
        }, [
          v("div", qC, [
            e.uploadIcon ? (c(), g("img", {
              key: 0,
              src: e.uploadIcon,
              class: C([I(p).icon, "relative", "image-input-icon"]),
              alt: ""
            }, null, 10, UC)) : k("", !0),
            v("div", GC, N(e.uploadText), 1),
            v("div", {
              class: C([
                "relative text-xs! leading-4 font-medium",
                e.success ? "text-[#007A55] dark:text-[#007A55]" : !e.disabled && !e.error ? "text-text-body dark:text-(--colors-text-white-default)" : "dark:text-(--colors-text-disabled)"
              ])
            }, N(e.maxFileSizeText), 3)
          ]),
          re(I(Be), {
            variant: "primary",
            label: e.browseButtonText,
            "icon-left": e.browseButtonIcon,
            size: "xs",
            disabled: e.disabled,
            type: "button",
            onClick: Ye(w, ["stop"])
          }, null, 8, ["label", "icon-left", "disabled"])
        ], 2)) : (c(), g("div", KC, [
          v("div", {
            class: C([
              "relative leading-5 text-sm!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-text-body dark:text-(--colors-text-white-default)" : "text-text-black-default dark:text-(--colors-text-white-default)"
            ])
          }, N(e.dragDropText), 3),
          v("div", {
            class: C([
              "self-stretch flex items-start gap-6 text-xs!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : "text-text-body dark:text-(--colors-text-white-default)"
            ])
          }, [
            v("div", YC, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                X.value ? (c(), H(I(Be), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": X.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": u,
                  onClick: Ye($, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : k("", !0)
              ], 2),
              v("div", {
                id: u,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, N(e.browseLabel), 3)
            ]),
            v("div", JC, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                _.value ? (c(), H(I(Be), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": _.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": f,
                  onClick: Ye(S, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : k("", !0)
              ], 2),
              v("div", {
                id: f,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, N(e.libraryLabel), 3)
            ]),
            v("div", XC, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                Y.value ? (c(), H(I(Be), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": Y.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": b,
                  onClick: Ye(L, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : k("", !0)
              ], 2),
              v("div", {
                id: b,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, N(e.linkLabel), 3)
            ])
          ], 2)
        ])),
        v("input", {
          id: e.id,
          ref_key: "fileInputRef",
          ref: o,
          "data-testid": "image-input",
          name: e.name,
          type: "file",
          accept: e.accept,
          disabled: e.disabled,
          class: "sr-only",
          onChange: T
        }, null, 40, ZC)
      ], 34),
      l.value ? (c(), g("div", QC, N(l.value), 1)) : k("", !0)
    ]));
  }
}), tq = /* @__PURE__ */ ot(_C, [["__scopeId", "data-v-5b729c92"]]), eS = { class: "w-full flex flex-col gap-2" }, tS = {
  key: 1,
  class: "flex flex-col gap-0.5"
}, nS = { class: "relative" }, aS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], lS = ["disabled"], rS = ["aria-label"], oS = {
  key: 2,
  class: "w-full flex flex-col gap-4"
}, iS = { class: "flex flex-col gap-0.5" }, sS = { class: "flex flex-col items-center gap-2" }, dS = { class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--text-text-white-default) text-center" }, uS = { class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body) dark:text-(--text-text-white-default) text-center whitespace-pre-line" }, cS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], fS = {
  key: 0,
  class: "flex flex-col gap-3"
}, hS = { class: "flex flex-1 items-center gap-2.5 min-w-0" }, bS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  class: "shrink-0"
}, gS = ["id"], mS = ["stroke", "stroke-dashoffset"], pS = { class: "flex flex-col min-w-0" }, vS = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" }, xS = { class: "flex gap-2 text-(length:--size-sm)" }, yS = { class: "font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, kS = { class: "flex items-center gap-1 shrink-0" }, wS = {
  key: 1,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, CS = {
  key: 2,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, SS = {
  key: 3,
  class: "flex flex-col gap-0.5"
}, $S = { class: "flex flex-col items-center gap-2" }, IS = ["src"], TS = { class: "flex flex-col items-center gap-2" }, LS = ["src"], AS = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, ES = { class: "flex-1 flex flex-col items-center gap-1.5" }, RS = { class: "flex-1 flex flex-col items-center gap-1.5" }, BS = { class: "flex-1 flex flex-col items-center gap-1.5" }, DS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], MS = {
  key: 4,
  class: "mt-3 space-y-1"
}, zS = { class: "flex-shrink-0" }, OS = {
  key: 0,
  class: "w-5 h-5 text-(--text-text-success-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, PS = {
  key: 1,
  class: "w-5 h-5 text-(--text-text-error-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, FS = { class: "flex-1 min-w-0" }, VS = { key: 0 }, NS = ["disabled", "onClick"], Ds = 10.2, Tf = 3.6, HS = /* @__PURE__ */ ke({
  __name: "FileUploadInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    hint: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    browseButtonText: { default: "Select file" },
    placeholder: { default: "Placeholder text" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null },
    uploadedFile: { default: null },
    uploadedFiles: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    addFilesText: { default: "Add file(s)" },
    addMoreText: { default: "Add more" },
    addMoreIcon: { default: void 0 },
    progressFiles: { default: () => [] },
    pauseLabel: { default: "Pause" },
    resumeLabel: { default: "Resume" },
    removeLabel: { default: "Remove file" },
    clearFileLabel: { default: "Clear file" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link", "addMore", "fileClick", "removeFile", "pauseFile", "resumeFile", "removeProgressFile", "clear"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => !!t.error), l = m(() => typeof t.error == "string" ? t.error : void 0), r = je(), o = `${r}-browse`, i = `${r}-library`, s = `${r}-link`, d = m(() => !!t.uploadedFile), u = (ue) => ue ? ue < 1024 ? `${ue}B` : ue < 1024 * 1024 ? `${(ue / 1024).toFixed(0)}Ko` : `${(ue / (1024 * 1024)).toFixed(1)}Mo` : "", f = m(() => {
      if (!t.uploadedFile) return "";
      const ue = t.uploadedFile.name, te = t.uploadedFile.size ? ` (${u(t.uploadedFile.size)})` : "";
      return `${ue}${te}`;
    }), b = n;
    function h() {
      p.value && (p.value.value = ""), b("update:modelValue", null), b("clear");
    }
    const p = R(null), x = je(), y = m(() => t.id || x), w = R(!1), $ = R(null), S = R(null), L = m(() => `${y.value}-hint`), T = m(() => `${y.value}-error`), E = m(() => t.hint ? t.hint : (t.variant === "basic" || t.variant === "dropzone") && t.maxFileSizeText || void 0), A = m(() => {
      var ue;
      return (ue = E.value) != null && ue.includes(`
`) ? 2 : 1;
    }), D = m(() => {
      const ue = [];
      return E.value && ue.push(L.value), l.value && ue.push(T.value), ue.length > 0 ? ue.join(" ") : void 0;
    });
    function M(ue) {
      var te, oe;
      (te = $.value) == null || te.handleFieldKeydown(ue), (oe = S.value) == null || oe.handleFieldKeydown(ue);
    }
    const F = R(!1), X = R(!1), _ = R(/* @__PURE__ */ new Set());
    function Y(ue) {
      _.value.has(ue) ? (_.value.delete(ue), b("resumeFile", ue)) : (_.value.add(ue), b("pauseFile", ue)), _.value = new Set(_.value);
    }
    const B = 2 * Math.PI * Ds;
    function W(ue) {
      return B * (1 - Math.min(Math.max(ue, 0), 100) / 100);
    }
    const z = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], P = m(() => {
      const ue = t.variant === "dropzone" ? "border-(--border-border-base)" : "border-(--border-border-primary-button)", te = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${z.container}`;
      return t.disabled ? `${te} bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed` : a.value ? `${te} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : t.success || d.value ? `${te} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : F.value ? `${te} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : X.value ? `${te} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : `${te} bg-(--background-background-white) dark:bg-(--background-background-black-default) ${ue} dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer`;
    }), K = (ue, te) => {
      if (!te || te === "*" || te === "*/*") return !0;
      const oe = te.split(",").map((ve) => ve.trim().toLowerCase()).filter((ve) => ve.length > 0);
      if (oe.length === 0) return !0;
      const Le = (ue.type || "").toLowerCase(), Ie = (ue.name || "").toLowerCase();
      return oe.some((ve) => ve.startsWith(".") ? Ie.endsWith(ve) : ve.endsWith("/*") ? Le.startsWith(ve.slice(0, -1)) : Le === ve);
    }, j = (ue) => {
      if (!ue || ue.length === 0 || t.disabled) return;
      const te = Array.from(ue);
      if (te.filter((we) => !K(we, t.accept)).length > 0) {
        b("error", t.fileTypeErrorText || "File type not supported.");
        return;
      }
      if (te.filter((we) => we.size > t.maxFileSize).length > 0) {
        b(
          "error",
          t.fileSizeErrorText || `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`
        );
        return;
      }
      const Ie = t.multiple ? te : te[0];
      b("update:modelValue", Ie);
      const ve = new Event("change", { bubbles: !0 });
      b("change", ve);
    }, G = () => {
      var ue;
      t.disabled || (ue = p.value) == null || ue.click();
    }, q = (ue) => {
      var te;
      t.disabled || (b("browse", ue), (te = p.value) == null || te.click());
    }, J = (ue) => {
      t.disabled || b("library", ue);
    }, me = (ue) => {
      t.disabled || b("link", ue);
    }, ye = (ue) => {
      var te;
      t.disabled || (b("addMore", ue), (te = p.value) == null || te.click());
    }, Z = () => {
      t.uploadedFile && b("fileClick", t.uploadedFile);
    }, de = (ue, te) => {
      t.disabled || b("removeFile", ue, te);
    }, ge = (ue) => {
      const te = ue.target;
      j(te.files);
    }, se = (ue) => {
      ue.preventDefault(), ue.stopPropagation(), t.disabled || (F.value = !0);
    }, Se = (ue) => {
      ue.preventDefault(), ue.stopPropagation(), F.value = !1;
    }, V = (ue) => {
      var oe;
      if (ue.preventDefault(), ue.stopPropagation(), F.value = !1, t.disabled) return;
      const te = (oe = ue.dataTransfer) == null ? void 0 : oe.files;
      te && j(te);
    }, Q = () => {
      var ue;
      t.disabled || d.value || (ue = p.value) == null || ue.click();
    }, le = (ue, te) => {
      try {
        if (ue.startsWith("data:image/svg+xml")) {
          const oe = ue.split(",")[1];
          if (!oe) return ue;
          const Ie = decodeURIComponent(oe).replace(/fill=["']currentColor["']/gi, `fill="${te}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${te}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Ie)}`;
        }
        return ue.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${te.slice(1)}`);
      } catch {
        return ue;
      }
    }, ee = {
      // --icons-icon-dark-default
      error: "#b42318",
      // --icons-icon-error
      success: "#007a55",
      // --text-text-success-strong
      disabled: "#99a1af"
      // --icons-icon-disabled-light
    }, O = m(() => {
      if (t.browseIcon)
        return t.disabled && t.variant === "dropzone" ? le(t.browseIcon, ee.disabled) : a.value && t.variant === "dropzone" ? le(t.browseIcon, ee.error) : (t.success || d.value) && t.variant === "dropzone" ? le(t.browseIcon, ee.success) : t.browseIcon;
    }), ne = m(() => {
      if (t.libraryIcon)
        return t.disabled && t.variant === "dropzone" ? le(t.libraryIcon, ee.disabled) : a.value && t.variant === "dropzone" ? le(t.libraryIcon, ee.error) : (t.success || d.value) && t.variant === "dropzone" ? le(t.libraryIcon, ee.success) : t.libraryIcon;
    }), fe = m(() => {
      if (t.linkIcon)
        return t.disabled && t.variant === "dropzone" ? le(t.linkIcon, ee.disabled) : a.value && t.variant === "dropzone" ? le(t.linkIcon, ee.error) : (t.success || d.value) && t.variant === "dropzone" ? le(t.linkIcon, ee.success) : t.linkIcon;
    });
    return (ue, te) => (c(), g("div", eS, [
      e.label ? (c(), H(yt, {
        key: 0,
        ref_key: "labelRef",
        ref: $,
        text: e.label,
        "input-id": y.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: w.value,
        "test-id": "file-upload-label"
      }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      e.variant === "basic" ? (c(), g("div", tS, [
        v("div", nS, [
          v("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: p,
            "data-testid": "file-upload-input-basic",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": D.value,
            "aria-invalid": a.value ? "true" : void 0,
            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10",
            onChange: ge,
            onFocus: te[0] || (te[0] = (oe) => w.value = !0),
            onBlur: te[1] || (te[1] = (oe) => w.value = !1),
            onKeydown: M
          }, null, 40, aS),
          v("div", {
            class: C([
              "flex items-center w-full bg-(--background-background-white) dark:bg-(--background-background-black-default) border rounded-lg shadow-xs transition-colors",
              e.disabled ? "border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) cursor-not-allowed" : a.value ? "border-(--border-border-error-strong) dark:border-(--border-border-error-strong) focus-within:ring-4 focus-within:ring-(--border-border-error-medium)" : "border-(--border-border-base-medium) dark:border-(--border-border-base) focus-within:ring-4 focus-within:ring-(--border-border-hover-medium) focus-within:border-(--border-border-hover)"
            ])
          }, [
            v("button", {
              type: "button",
              class: C([
                "flex-shrink-0 px-3 py-2 text-sm font-medium rounded-l-lg border-r transition-colors",
                e.disabled ? "bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:bg-(--background-background-hover) dark:hover:bg-[rgba(255,255,255,0.05)]"
              ]),
              disabled: e.disabled,
              onClick: Ye(G, ["stop"])
            }, N(e.browseButtonText), 11, lS),
            v("div", {
              class: C([
                "flex-1 px-3 py-2 text-sm pointer-events-none truncate",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.modelValue ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, N(e.modelValue ? Array.isArray(e.modelValue) ? `${e.modelValue.length} file(s) selected` : e.modelValue.name : e.placeholder), 3),
            e.modelValue && !e.disabled ? (c(), g("button", {
              key: 0,
              type: "button",
              class: "relative z-20 shrink-0 flex items-center justify-center px-2 self-stretch text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:text-(--text-text-body)",
              "aria-label": e.clearFileLabel,
              onClick: Ye(h, ["stop"])
            }, [...te[9] || (te[9] = [
              v("i", {
                class: "ri-close-fill text-base",
                "aria-hidden": "true"
              }, null, -1)
            ])], 8, rS)) : k("", !0)
          ], 2)
        ]),
        re(xt, {
          ref_key: "helperRef",
          ref: S,
          focused: w.value,
          hint: E.value,
          "hint-lines": A.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": L.value,
          "error-id": T.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])) : e.variant === "advanced" ? (c(), g("div", oS, [
        v("div", iS, [
          v("div", {
            class: "w-full rounded-xl border border-dashed border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white-secondary-soft) dark:bg-(--background-background-black-default) flex h-[228px] flex-col items-center justify-center gap-4 px-5",
            onDragover: se,
            onDragleave: Se,
            onDrop: V
          }, [
            v("div", sS, [
              te[10] || (te[10] = v("i", {
                class: "ri-upload-2-line text-(length:--size-xl) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1)),
              v("p", dS, N(e.uploadText), 1),
              v("p", uS, N(e.maxFileSizeText), 1)
            ]),
            re(I(Be), {
              variant: "primary",
              label: e.addFilesText,
              "icon-left": "ri-add-line",
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: Ye(G, ["stop"])
            }, null, 8, ["label", "disabled"]),
            v("input", {
              id: y.value,
              ref_key: "fileInputRef",
              ref: p,
              "data-testid": "file-upload-input",
              name: e.name,
              type: "file",
              accept: e.accept,
              disabled: e.disabled,
              multiple: e.multiple,
              "aria-describedby": D.value,
              "aria-invalid": a.value ? "true" : void 0,
              class: "sr-only",
              onChange: ge,
              onFocus: te[2] || (te[2] = (oe) => w.value = !0),
              onBlur: te[3] || (te[3] = (oe) => w.value = !1),
              onKeydown: M
            }, null, 40, cS)
          ], 32),
          re(xt, {
            ref_key: "helperRef",
            ref: S,
            focused: w.value,
            hint: E.value,
            "hint-lines": A.value,
            disabled: e.disabled,
            error: l.value,
            "hint-id": L.value,
            "error-id": T.value,
            "error-live": e.errorLive,
            "test-id-prefix": "file-upload"
          }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
        ]),
        e.progressFiles.length ? (c(), g("div", fS, [
          (c(!0), g(ce, null, Re(e.progressFiles, (oe) => (c(), g("div", {
            key: oe.id,
            "data-testid": "upload-progress-row",
            class: "flex w-full items-center justify-between gap-2.5"
          }, [
            v("div", hS, [
              (c(), g("svg", bS, [
                v("defs", null, [
                  v("linearGradient", {
                    id: `upload-ring-gradient-${oe.id}`,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "100%"
                  }, [...te[11] || (te[11] = [
                    v("stop", {
                      offset: "0%",
                      style: { "stop-color": "var(--gradient-brand-start)" }
                    }, null, -1),
                    v("stop", {
                      offset: "100%",
                      style: { "stop-color": "var(--gradient-brand-end)" }
                    }, null, -1)
                  ])], 8, gS)
                ]),
                v("circle", {
                  cx: "12",
                  cy: "12",
                  r: Ds,
                  fill: "none",
                  "stroke-width": Tf,
                  class: "stroke-(--border-border-base-soft) dark:stroke-(--border-border-base-soft)"
                }),
                v("circle", {
                  "data-testid": "progress-ring-fill",
                  cx: "12",
                  cy: "12",
                  r: Ds,
                  fill: "none",
                  "stroke-width": Tf,
                  "stroke-linecap": "round",
                  transform: "rotate(-90 12 12)",
                  stroke: `url(#upload-ring-gradient-${oe.id})`,
                  "stroke-dasharray": B,
                  "stroke-dashoffset": W(oe.percent)
                }, null, 8, mS)
              ])),
              v("div", pS, [
                v("p", vS, N(oe.name), 1),
                v("div", xS, [
                  v("span", yS, N(oe.percent) + "%", 1),
                  v("span", {
                    class: C(
                      oe.status === "success" ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : oe.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                    )
                  }, N(oe.statusText), 3)
                ])
              ])
            ]),
            v("div", kS, [
              oe.status === "uploading" ? (c(), H(I(Be), {
                key: 0,
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": _.value.has(oe.id) ? "ri-play-line" : "ri-pause-line",
                "aria-label": _.value.has(oe.id) ? e.resumeLabel : e.pauseLabel,
                "data-testid": "pause-icon",
                onClick: (Le) => Y(oe.id)
              }, null, 8, ["icon-left", "aria-label", "onClick"])) : k("", !0),
              oe.status === "success" ? (c(), g("span", wS, [...te[12] || (te[12] = [
                v("i", {
                  "data-testid": "progress-success-icon",
                  class: "ri-checkbox-circle-line text-(length:--size-xxl) text-(--icons-icon-success) dark:text-(--icons-icon-success)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : oe.status === "error" ? (c(), g("span", CS, [...te[13] || (te[13] = [
                v("i", {
                  "data-testid": "progress-error-icon",
                  class: "ri-error-warning-line text-(length:--size-xxl) text-(--icons-icon-error) dark:text-(--icons-icon-error)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : k("", !0),
              re(I(Be), {
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": "ri-close-line",
                "aria-label": e.removeLabel,
                "data-testid": "delete-icon",
                onClick: (Le) => b("removeProgressFile", oe.id)
              }, null, 8, ["aria-label", "onClick"])
            ])
          ]))), 128))
        ])) : k("", !0)
      ])) : (c(), g("div", SS, [
        v("div", {
          class: C(P.value),
          onDragover: se,
          onDragleave: Se,
          onDrop: V,
          onClick: te[6] || (te[6] = (oe) => e.variant === "default" ? Q() : void 0),
          onMouseenter: te[7] || (te[7] = (oe) => X.value = !0),
          onMouseleave: te[8] || (te[8] = (oe) => X.value = !1)
        }, [
          e.variant === "default" ? (c(), g(ce, { key: 0 }, [
            d.value ? (c(), g("div", {
              key: 1,
              class: C(["flex flex-col items-center", I(z).gap])
            }, [
              v("div", TS, [
                e.uploadIcon ? (c(), g("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    I(z).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, LS)) : k("", !0),
                v("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, N(e.uploadText), 3),
                v("button", {
                  type: "button",
                  class: C([
                    "relative text-sm leading-5 font-medium cursor-pointer hover:underline",
                    a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)"
                  ]),
                  onClick: Ye(Z, ["stop"])
                }, N(f.value), 3)
              ]),
              re(I(Be), {
                variant: "secondary",
                label: `+ ${e.addMoreText}`,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: Ye(ye, ["stop"])
              }, null, 8, ["label", "disabled"])
            ], 2)) : (c(), g("div", {
              key: 0,
              class: C(["flex flex-col items-center", I(z).gap])
            }, [
              v("div", $S, [
                e.uploadIcon ? (c(), g("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    I(z).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, IS)) : k("", !0),
                v("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, N(e.uploadText), 3),
                v("div", {
                  class: C([
                    "relative text-xs! leading-4 font-medium",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.success || d.value || e.error ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                  ])
                }, N(e.maxFileSizeText), 3)
              ]),
              re(I(Be), {
                variant: "primary",
                label: e.browseButtonText,
                "icon-left": e.browseButtonIcon,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: Ye(G, ["stop"])
              }, null, 8, ["label", "icon-left", "disabled"])
            ], 2))
          ], 64)) : (c(), g("div", AS, [
            v("div", {
              class: C([
                "relative leading-5 text-sm!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, N(e.dragDropText), 3),
            v("div", {
              class: C([
                "self-stretch flex items-start gap-6 text-xs!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, [
              v("div", ES, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  O.value ? (c(), H(I(Be), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": O.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": o,
                    onClick: Ye(q, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : k("", !0)
                ], 2),
                v("div", {
                  id: o,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, N(e.browseLabel), 3)
              ]),
              v("div", RS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  ne.value ? (c(), H(I(Be), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": ne.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": i,
                    onClick: Ye(J, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : k("", !0)
                ], 2),
                v("div", {
                  id: i,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, N(e.libraryLabel), 3)
              ]),
              v("div", BS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  fe.value ? (c(), H(I(Be), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": fe.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": s,
                    onClick: Ye(me, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : k("", !0)
                ], 2),
                v("div", {
                  id: s,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, N(e.linkLabel), 3)
              ])
            ], 2)
          ])),
          v("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: p,
            "data-testid": "file-upload-input",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": D.value,
            "aria-invalid": a.value ? "true" : void 0,
            class: "sr-only",
            onChange: ge,
            onFocus: te[4] || (te[4] = (oe) => w.value = !0),
            onBlur: te[5] || (te[5] = (oe) => w.value = !1),
            onKeydown: M
          }, null, 40, DS)
        ], 34),
        re(xt, {
          ref_key: "helperRef",
          ref: S,
          focused: w.value,
          hint: E.value,
          "hint-lines": A.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": L.value,
          "error-id": T.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])),
      e.variant === "dropzone" && e.uploadedFiles && e.uploadedFiles.length > 0 ? (c(), g("div", MS, [
        (c(!0), g(ce, null, Re(e.uploadedFiles, (oe, Le) => (c(), g("div", {
          key: `file-${Le}-${oe.name}`,
          class: "flex items-center gap-2"
        }, [
          v("div", zS, [
            oe.status === "success" ? (c(), g("svg", OS, [...te[14] || (te[14] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 13l4 4L19 7"
              }, null, -1)
            ])])) : oe.status === "error" ? (c(), g("svg", PS, [...te[15] || (te[15] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              }, null, -1)
            ])])) : k("", !0)
          ]),
          v("div", FS, [
            v("p", {
              class: C([
                "text-sm truncate",
                oe.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, [
              et(N(oe.name) + " ", 1),
              oe.size ? (c(), g("span", VS, " (" + N(u(oe.size)) + ") ", 1)) : k("", !0)
            ], 2)
          ]),
          v("button", {
            type: "button",
            class: "flex-shrink-0 p-0.5 transition-colors",
            disabled: e.disabled,
            onClick: (Ie) => de(oe, Le)
          }, [
            (c(), g("svg", {
              class: C([
                "w-5 h-5",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [...te[16] || (te[16] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              }, null, -1)
            ])], 2))
          ], 8, NS)
        ]))), 128))
      ])) : k("", !0)
    ]));
  }
}), jS = /* @__PURE__ */ ot(HS, [["__scopeId", "data-v-8ebe268e"]]), WS = {
  "aria-hidden": "true",
  focusable: "false",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "textarea-icon pointer-events-none text-(--colors-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, jg = /* @__PURE__ */ ke({
  __name: "ResizeGrip",
  setup(e) {
    return (n, t) => (c(), g("svg", WS, [...t[0] || (t[0] = [
      v("path", {
        d: "M21 11L11 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      v("path", {
        d: "M21 15L15 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      v("path", {
        d: "M21 19L19 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1)
    ])]));
  }
}), qS = { class: "flex min-w-0 items-center gap-4" }, US = {
  key: 0,
  class: "flex items-center gap-1"
}, li = /* @__PURE__ */ ke({
  __name: "TextareaFooter",
  props: {
    labels: { default: () => ({}) },
    actions: { default: () => [] },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["send", "action"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.labels.send ?? "Send message");
    return (r, o) => (c(), g("div", qS, [
      re(Be, {
        variant: "primary",
        size: "sm",
        label: l.value,
        disabled: e.disabled,
        "data-testid": "field-footer-send",
        onClick: o[0] || (o[0] = (i) => a("send"))
      }, null, 8, ["label", "disabled"]),
      e.actions.length ? (c(), g("div", US, [
        (c(!0), g(ce, null, Re(e.actions, (i) => (c(), H(Be, {
          key: i.id,
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": i.icon,
          "aria-label": i.label,
          disabled: e.disabled,
          "data-field-footer-action": i.id,
          onClick: (s) => a("action", i.id)
        }, null, 8, ["icon-left", "aria-label", "disabled", "data-field-footer-action", "onClick"]))), 128))
      ])) : k("", !0)
    ]));
  }
}), GS = ["data-type"], KS = {
  key: 0,
  class: "flex min-w-0 max-w-full items-center gap-1"
}, YS = ["src"], JS = {
  key: 0,
  class: "flex w-full items-center gap-2 p-2 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-white-secondary) dark:bg-(--background-background-black-default)",
  "data-testid": "textarea-chatroom"
}, XS = {
  key: 0,
  class: "flex shrink-0 items-center gap-1"
}, ZS = { class: "self-stretch flex flex-1 min-h-0 p-2" }, QS = ["rows"], _S = {
  key: 0,
  class: "absolute bottom-2 right-2 flex items-center justify-center"
}, e$ = ["src"], t$ = {
  key: 1,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, n$ = {
  key: 1,
  class: "flex items-center gap-4",
  "data-testid": "textarea-footer"
}, a$ = "border border-solid rounded-b-(--border-border-radius-rounded-l) p-[calc(--spacing(2.5)-1px)] border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white) dark:bg-(--background-background-black-default)", Lf = "w-full relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)", l$ = "w-full relative flex flex-col items-start gap-0.5 pb-0.5 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter", r$ = /* @__PURE__ */ ke({
  __name: "Textarea",
  props: {
    type: { default: "Default" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    placeholder: { default: void 0 },
    showPlaceholder: { type: Boolean, default: void 0 },
    modelValue: { default: "" },
    bottomRightIcon: { default: void 0 },
    helpText: { default: void 0 },
    helpTextIcon: { default: void 0 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    rows: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    height: { default: void 0 },
    maxLength: { default: void 0 },
    resizable: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    labels: { default: () => ({}) },
    submitLabel: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "send", "action"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = je(), r = m(() => t.id || l), o = m(() => t.label ? `${r.value}-label` : void 0), i = m(() => `${r.value}-error`), s = m(() => `${r.value}-help`), d = R(!1), u = R(null), f = R(null), b = m(() => t.type === "Chatroom"), h = m(() => t.type === "Buttons inside"), p = m(() => t.type === "Buttons outside"), x = m(() => !!t.error), y = m(() => t.showError !== void 0 ? t.showError : x.value), w = m(() => {
      const Z = [];
      return y.value && x.value && Z.push(i.value), t.helpText && Z.push(s.value), Z.length ? Z.join(" ") : void 0;
    }), $ = m(() => !!t.modelValue), S = m(() => t.showPlaceholder === !1 ? !1 : t.showPlaceholder === !0 ? !0 : !$.value), L = m(() => S.value ? t.placeholder : void 0), T = R("auto"), E = R(null), A = { send: "Send message", field: "Message" }, D = m(() => ({ ...A, ...t.labels })), M = m(() => {
      const de = `relative self-stretch box-border flex flex-col items-start justify-between gap-2 border-solid px-[calc(--spacing(1)-1px)] pt-[calc(--spacing(1)-1px)] font-inter ${h.value ? "rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-x border-t border-b-0 pb-1" : "rounded-(--border-border-radius-rounded-l) border pb-[calc(--spacing(1)-1px)]"}`, ge = "shadow-[0_0_2px_2px_var(--background-background-hover)]", se = "shadow-(--blur-shadow-xs)", Se = "dark:shadow-(--blur-shadow-m-dark)";
      if (t.disabled)
        return `${de} ${se} ${Se} bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)`;
      if (t.readonly)
        return `${de} ${se} ${Se} bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-soft) dark:border-(--border-border-base)`;
      if (x.value)
        return `${de} ${d.value ? ge : `${se} ${Se}`} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)`;
      if (d.value)
        return `${de} ${ge} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)`;
      const V = $.value ? "" : se;
      return `${de} ${V} ${Se} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    }), F = m(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : t.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : d.value || $.value ? "text-(--text-text-body) dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-default)"), X = m(() => !t.fullWidth && t.width ? { width: t.width } : {}), _ = m(() => [
      "flex flex-col",
      p.value ? "gap-4" : "",
      h.value ? "rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)" : "",
      "w-full"
    ]), Y = m(() => {
      const Z = t.height ?? (t.type === "Default" ? "204px" : "184px");
      return t.resizable ? { minHeight: Z } : { height: Z };
    }), B = m(() => {
      var Z;
      if (t.maxLength)
        return ((Z = t.modelValue) == null ? void 0 : Z.length) || 0;
    }), W = m(() => t.resizable ? "resize-y" : "resize-none"), U = m(() => ({
      id: r.value,
      "data-testid": "textarea",
      name: t.name,
      autocomplete: t.autocomplete,
      value: t.modelValue,
      placeholder: L.value,
      disabled: t.disabled,
      readonly: t.readonly,
      maxlength: t.maxLength,
      "aria-labelledby": o.value,
      // Without `label` or `ariaLabel` the Chatroom field still needs a name: its row has no room for a visible label.
      // `||`, not `??`: an empty `ariaLabel` names nothing (axe aria-input-field-name), so it counts as absent.
      "aria-label": t.label ? void 0 : t.ariaLabel || (b.value ? D.value.field : void 0),
      "aria-required": t.required ? !0 : void 0,
      "aria-invalid": x.value ? !0 : void 0,
      "aria-disabled": t.disabled,
      "aria-describedby": w.value
    })), z = (Z) => {
      const de = Z.target;
      a("update:modelValue", de.value), a("input", Z);
    }, P = (Z) => {
      t.disabled || (d.value = !0), a("focus", Z);
    }, K = (Z) => {
      d.value = !1, a("blur", Z);
    }, j = (Z) => {
      var de, ge;
      (de = u.value) == null || de.handleFieldKeydown(Z), (ge = f.value) == null || ge.handleFieldKeydown(Z);
    }, G = m(() => t.disabled || t.readonly), q = () => a("send", t.modelValue), J = (Z) => a("action", Z), me = () => {
      if (E.value && t.resizable) {
        const Z = E.value.offsetHeight;
        Z > 0 && (T.value = `${Z}px`);
      }
    };
    $e(
      () => t.resizable,
      (Z) => {
        Z || (T.value = "auto");
      }
    );
    let ye = null;
    return dt(() => {
      t.resizable && E.value && (ye = new ResizeObserver(() => {
        me();
      }), ye.observe(E.value));
    }), gt(() => {
      ye && ye.disconnect();
    }), $e(
      () => E.value,
      (Z) => {
        ye && ye.disconnect(), Z && t.resizable && (ye = new ResizeObserver(() => {
          me();
        }), ye.observe(Z));
      }
    ), (Z, de) => (c(), g("div", {
      class: C(l$),
      style: Ne(X.value),
      "data-type": e.type
    }, [
      e.label ? (c(), g("div", KS, [
        re(yt, {
          id: o.value,
          ref_key: "labelRef",
          ref: u,
          text: e.label,
          "input-id": r.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: d.value,
          "test-id": "textarea-label"
        }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"]),
        e.helpIcon && !e.labelTooltip ? (c(), g("img", {
          key: 0,
          class: "h-3.5 w-3.5 relative textarea-icon",
          src: e.helpIcon,
          alt: ""
        }, null, 8, YS)) : k("", !0)
      ])) : k("", !0),
      v("div", {
        class: C(_.value),
        "data-testid": "textarea-field"
      }, [
        b.value ? (c(), g("div", JS, [
          e.actions.length ? (c(), g("div", XS, [
            (c(!0), g(ce, null, Re(e.actions, (ge) => (c(), H(Be, {
              key: ge.id,
              variant: "tertiary",
              size: "xs",
              "icon-only": "",
              "icon-left": ge.icon,
              "aria-label": ge.label,
              disabled: G.value,
              "data-textarea-action": ge.id,
              onClick: (se) => J(ge.id)
            }, null, 8, ["icon-left", "aria-label", "disabled", "data-textarea-action", "onClick"]))), 128))
          ])) : k("", !0),
          re(Bn, {
            size: "sm",
            flush: "",
            disabled: e.disabled,
            readonly: e.readonly,
            error: x.value,
            "has-value": $.value,
            class: "min-w-0 flex-1"
          }, {
            default: xe(() => [
              v("textarea", Oe({
                ref_key: "textareaRef",
                ref: E
              }, U.value, {
                rows: "1",
                class: [Lf, F.value, "h-5 resize-none overflow-hidden px-[calc(--spacing(2.5)-1px)]"],
                onInput: z,
                onFocus: P,
                onBlur: K,
                onKeydown: j
              }), null, 16)
            ]),
            _: 1
          }, 8, ["disabled", "readonly", "error", "has-value"]),
          re(Be, {
            variant: "tertiary",
            size: "xs",
            "icon-only": "",
            "icon-left": "ri-send-plane-2-line",
            "aria-label": D.value.send,
            disabled: G.value,
            "data-testid": "textarea-send",
            onClick: q
          }, null, 8, ["aria-label", "disabled"])
        ])) : (c(), g(ce, { key: 1 }, [
          v("div", {
            class: C(M.value),
            style: Ne(Y.value),
            "data-testid": "textarea-box"
          }, [
            v("div", ZS, [
              v("textarea", Oe({
                ref_key: "textareaRef",
                ref: E
              }, U.value, {
                rows: e.rows,
                style: { height: T.value },
                class: [Lf, F.value, W.value],
                onInput: z,
                onFocus: P,
                onBlur: K,
                onKeydown: j
              }), null, 16, QS)
            ]),
            e.bottomRightIcon || e.maxLength || e.resizable ? (c(), g("div", _S, [
              e.bottomRightIcon ? (c(), g("img", {
                key: 0,
                class: "w-[24.2px] h-[24.2px] textarea-icon",
                src: e.bottomRightIcon,
                alt: ""
              }, null, 8, e$)) : e.maxLength ? (c(), g("div", t$, N(B.value) + "/" + N(e.maxLength), 1)) : e.resizable ? (c(), H(jg, { key: 2 })) : k("", !0)
            ])) : k("", !0)
          ], 6),
          h.value ? (c(), H(li, {
            key: 0,
            class: C(a$),
            labels: { send: D.value.send },
            actions: e.actions,
            disabled: G.value,
            "data-testid": "textarea-footer",
            onSend: q,
            onAction: J
          }, null, 8, ["labels", "actions", "disabled"])) : k("", !0),
          p.value ? (c(), g("div", n$, [
            re(li, {
              class: "shrink-0",
              labels: { send: D.value.send },
              actions: e.actions,
              disabled: G.value,
              onSend: q,
              onAction: J
            }, null, 8, ["labels", "actions", "disabled"]),
            re(xt, {
              ref_key: "helperRef",
              ref: f,
              class: "min-w-0 flex-1",
              focused: d.value,
              hint: e.helpText,
              error: y.value ? e.error : void 0,
              "hint-id": s.value,
              "error-id": i.value,
              "hint-icon": e.helpTextIcon,
              "test-id-prefix": "textarea"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])
          ])) : k("", !0)
        ], 64))
      ], 2),
      p.value ? k("", !0) : (c(), H(xt, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        focused: d.value,
        hint: e.helpText,
        error: y.value ? e.error : void 0,
        "hint-id": s.value,
        "error-id": i.value,
        "hint-icon": e.helpTextIcon,
        "test-id-prefix": "textarea"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])),
      e.submitLabel && !h.value && !p.value && !b.value ? (c(), H(Be, {
        key: 2,
        variant: "primary",
        size: "xs",
        label: e.submitLabel,
        disabled: G.value,
        "data-testid": "textarea-submit",
        onClick: q
      }, null, 8, ["label", "disabled"])) : k("", !0)
    ], 12, GS));
  }
}), nq = /* @__PURE__ */ ot(r$, [["__scopeId", "data-v-d926decc"]]);
function Wt(e) {
  this.content = e;
}
Wt.prototype = {
  constructor: Wt,
  find: function(e) {
    for (var n = 0; n < this.content.length; n += 2)
      if (this.content[n] === e) return n;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var n = this.find(e);
    return n == -1 ? void 0 : this.content[n + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, n, t) {
    var a = t && t != e ? this.remove(t) : this, l = a.find(e), r = a.content.slice();
    return l == -1 ? r.push(t || e, n) : (r[l + 1] = n, t && (r[l] = t)), new Wt(r);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var n = this.find(e);
    if (n == -1) return this;
    var t = this.content.slice();
    return t.splice(n, 2), new Wt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, n) {
    return new Wt([e, n].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, n) {
    var t = this.remove(e).content.slice();
    return t.push(e, n), new Wt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, n, t) {
    var a = this.remove(n), l = a.content.slice(), r = a.find(e);
    return l.splice(r == -1 ? l.length : r, 0, n, t), new Wt(l);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var n = 0; n < this.content.length; n += 2)
      e(this.content[n], this.content[n + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = Wt.from(e), e.size ? new Wt(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = Wt.from(e), e.size ? new Wt(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var n = this;
    e = Wt.from(e);
    for (var t = 0; t < e.content.length; t += 2)
      n = n.remove(e.content[t]);
    return n;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(n, t) {
      e[n] = t;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Wt.from = function(e) {
  if (e instanceof Wt) return e;
  var n = [];
  if (e) for (var t in e) n.push(t, e[t]);
  return new Wt(n);
};
function Wg(e, n, t) {
  for (let a = 0; ; a++) {
    if (a == e.childCount || a == n.childCount)
      return e.childCount == n.childCount ? null : t;
    let l = e.child(a), r = n.child(a);
    if (l == r) {
      t += l.nodeSize;
      continue;
    }
    if (!l.sameMarkup(r))
      return t;
    if (l.isText && l.text != r.text) {
      for (let o = 0; l.text[o] == r.text[o]; o++)
        t++;
      return t;
    }
    if (l.content.size || r.content.size) {
      let o = Wg(l.content, r.content, t + 1);
      if (o != null)
        return o;
    }
    t += l.nodeSize;
  }
}
function qg(e, n, t, a) {
  for (let l = e.childCount, r = n.childCount; ; ) {
    if (l == 0 || r == 0)
      return l == r ? null : { a: t, b: a };
    let o = e.child(--l), i = n.child(--r), s = o.nodeSize;
    if (o == i) {
      t -= s, a -= s;
      continue;
    }
    if (!o.sameMarkup(i))
      return { a: t, b: a };
    if (o.isText && o.text != i.text) {
      let d = 0, u = Math.min(o.text.length, i.text.length);
      for (; d < u && o.text[o.text.length - d - 1] == i.text[i.text.length - d - 1]; )
        d++, t--, a--;
      return { a: t, b: a };
    }
    if (o.content.size || i.content.size) {
      let d = qg(o.content, i.content, t - 1, a - 1);
      if (d)
        return d;
    }
    t -= s, a -= s;
  }
}
class Pe {
  /**
  @internal
  */
  constructor(n, t) {
    if (this.content = n, this.size = t || 0, t == null)
      for (let a = 0; a < n.length; a++)
        this.size += n[a].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(n, t, a, l = 0, r) {
    for (let o = 0, i = 0; i < t; o++) {
      let s = this.content[o], d = i + s.nodeSize;
      if (d > n && a(s, l + i, r || null, o) !== !1 && s.content.size) {
        let u = i + 1;
        s.nodesBetween(Math.max(0, n - u), Math.min(s.content.size, t - u), a, l + u);
      }
      i = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(n) {
    this.nodesBetween(0, this.size, n);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(n, t, a, l) {
    let r = "", o = !0;
    return this.nodesBetween(n, t, (i, s) => {
      let d = i.isText ? i.text.slice(Math.max(n, s) - s, t - s) : i.isLeaf ? l ? typeof l == "function" ? l(i) : l : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && d || i.isTextblock) && a && (o ? o = !1 : r += a), r += d;
    }, 0), r;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(n) {
    if (!n.size)
      return this;
    if (!this.size)
      return n;
    let t = this.lastChild, a = n.firstChild, l = this.content.slice(), r = 0;
    for (t.isText && t.sameMarkup(a) && (l[l.length - 1] = t.withText(t.text + a.text), r = 1); r < n.content.length; r++)
      l.push(n.content[r]);
    return new Pe(l, this.size + n.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(n, t = this.size) {
    if (n == 0 && t == this.size)
      return this;
    let a = [], l = 0;
    if (t > n)
      for (let r = 0, o = 0; o < t; r++) {
        let i = this.content[r], s = o + i.nodeSize;
        s > n && ((o < n || s > t) && (i.isText ? i = i.cut(Math.max(0, n - o), Math.min(i.text.length, t - o)) : i = i.cut(Math.max(0, n - o - 1), Math.min(i.content.size, t - o - 1))), a.push(i), l += i.nodeSize), o = s;
      }
    return new Pe(a, l);
  }
  /**
  @internal
  */
  cutByIndex(n, t) {
    return n == t ? Pe.empty : n == 0 && t == this.content.length ? this : new Pe(this.content.slice(n, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(n, t) {
    let a = this.content[n];
    if (a == t)
      return this;
    let l = this.content.slice(), r = this.size + t.nodeSize - a.nodeSize;
    return l[n] = t, new Pe(l, r);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(n) {
    return new Pe([n].concat(this.content), this.size + n.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(n) {
    return new Pe(this.content.concat(n), this.size + n.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(n) {
    if (this.content.length != n.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(n.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(n) {
    let t = this.content[n];
    if (!t)
      throw new RangeError("Index " + n + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(n) {
    return this.content[n] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(n) {
    for (let t = 0, a = 0; t < this.content.length; t++) {
      let l = this.content[t];
      n(l, a, t), a += l.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(n, t = 0) {
    return Wg(this, n, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(n, t = this.size, a = n.size) {
    return qg(this, n, t, a);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(n) {
    if (n == 0)
      return yo(0, n);
    if (n == this.size)
      return yo(this.content.length, n);
    if (n > this.size || n < 0)
      throw new RangeError(`Position ${n} outside of fragment (${this})`);
    for (let t = 0, a = 0; ; t++) {
      let l = this.child(t), r = a + l.nodeSize;
      if (r >= n)
        return r == n ? yo(t + 1, r) : yo(t, a);
      a = r;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((n) => n.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      return Pe.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return Pe.fromArray(t.map(n.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(n) {
    if (!n.length)
      return Pe.empty;
    let t, a = 0;
    for (let l = 0; l < n.length; l++) {
      let r = n[l];
      a += r.nodeSize, l && r.isText && n[l - 1].sameMarkup(r) ? (t || (t = n.slice(0, l)), t[t.length - 1] = r.withText(t[t.length - 1].text + r.text)) : t && t.push(r);
    }
    return new Pe(t || n, a);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(n) {
    if (!n)
      return Pe.empty;
    if (n instanceof Pe)
      return n;
    if (Array.isArray(n))
      return this.fromArray(n);
    if (n.attrs)
      return new Pe([n], n.nodeSize);
    throw new RangeError("Can not convert " + n + " to a Fragment" + (n.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Pe.empty = new Pe([], 0);
const Ms = { index: 0, offset: 0 };
function yo(e, n) {
  return Ms.index = e, Ms.offset = n, Ms;
}
function ri(e, n) {
  if (e === n)
    return !0;
  if (!(e && typeof e == "object") || !(n && typeof n == "object"))
    return !1;
  let t = Array.isArray(e);
  if (Array.isArray(n) != t)
    return !1;
  if (t) {
    if (e.length != n.length)
      return !1;
    for (let a = 0; a < e.length; a++)
      if (!ri(e[a], n[a]))
        return !1;
  } else {
    for (let a in e)
      if (!(a in n) || !ri(e[a], n[a]))
        return !1;
    for (let a in n)
      if (!(a in e))
        return !1;
  }
  return !0;
}
let vt = class zd {
  /**
  @internal
  */
  constructor(n, t) {
    this.type = n, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(n) {
    let t, a = !1;
    for (let l = 0; l < n.length; l++) {
      let r = n[l];
      if (this.eq(r))
        return n;
      if (this.type.excludes(r.type))
        t || (t = n.slice(0, l));
      else {
        if (r.type.excludes(this.type))
          return n;
        !a && r.type.rank > this.type.rank && (t || (t = n.slice(0, l)), t.push(this), a = !0), t && t.push(r);
      }
    }
    return t || (t = n.slice()), a || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(n) {
    for (let t = 0; t < n.length; t++)
      if (this.eq(n[t]))
        return n.slice(0, t).concat(n.slice(t + 1));
    return n;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(n) {
    for (let t = 0; t < n.length; t++)
      if (this.eq(n[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(n) {
    return this == n || this.type == n.type && ri(this.attrs, n.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let n = { type: this.type.name };
    for (let t in this.attrs) {
      n.attrs = this.attrs;
      break;
    }
    return n;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(n, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let a = n.marks[t.type];
    if (!a)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let l = a.create(t.attrs);
    return a.checkAttrs(l.attrs), l;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(n, t) {
    if (n == t)
      return !0;
    if (n.length != t.length)
      return !1;
    for (let a = 0; a < n.length; a++)
      if (!n[a].eq(t[a]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(n) {
    if (!n || Array.isArray(n) && n.length == 0)
      return zd.none;
    if (n instanceof zd)
      return [n];
    let t = n.slice();
    return t.sort((a, l) => a.type.rank - l.type.rank), t;
  }
};
vt.none = [];
class oi extends Error {
}
class Je {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(n, t, a) {
    this.content = n, this.openStart = t, this.openEnd = a;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(n, t) {
    let a = Gg(this.content, n + this.openStart, t, this.openStart + 1, this.openEnd + 1);
    return a && new Je(a, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(n, t) {
    return new Je(Ug(this.content, n + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(n) {
    return this.content.eq(n.content) && this.openStart == n.openStart && this.openEnd == n.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let n = { content: this.content.toJSON() };
    return this.openStart > 0 && (n.openStart = this.openStart), this.openEnd > 0 && (n.openEnd = this.openEnd), n;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      return Je.empty;
    let a = t.openStart || 0, l = t.openEnd || 0;
    if (typeof a != "number" || typeof l != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Je(Pe.fromJSON(n, t.content), a, l);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(n, t = !0) {
    let a = 0, l = 0;
    for (let r = n.firstChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.firstChild)
      a++;
    for (let r = n.lastChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.lastChild)
      l++;
    return new Je(n, a, l);
  }
}
Je.empty = new Je(Pe.empty, 0, 0);
function Ug(e, n, t) {
  let { index: a, offset: l } = e.findIndex(n), r = e.maybeChild(a), { index: o, offset: i } = e.findIndex(t);
  if (l == n || r.isText) {
    if (i != t && !e.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, n).append(e.cut(t));
  }
  if (a != o)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(a, r.copy(Ug(r.content, n - l - 1, t - l - 1)));
}
function Gg(e, n, t, a, l, r) {
  let { index: o, offset: i } = e.findIndex(n), s = e.maybeChild(o);
  if (i == n || s.isText)
    return r && a <= 0 && l <= 0 && !r.canReplace(o, o, t) ? null : e.cut(0, n).append(t).append(e.cut(n));
  let d = Gg(s.content, n - i - 1, t, o == 0 ? a - 1 : 0, o == e.childCount - 1 ? l - 1 : 0, s);
  return d && e.replaceChild(o, s.copy(d));
}
function o$(e, n, t) {
  if (t.openStart > e.depth)
    throw new oi("Inserted content deeper than insertion position");
  if (e.depth - t.openStart != n.depth - t.openEnd)
    throw new oi("Inconsistent open depths");
  return Kg(e, n, t, 0);
}
function Kg(e, n, t, a) {
  let l = e.index(a), r = e.node(a);
  if (l == n.index(a) && a < e.depth - t.openStart) {
    let o = Kg(e, n, t, a + 1);
    return r.copy(r.content.replaceChild(l, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && e.depth == a && n.depth == a) {
      let o = e.parent, i = o.content;
      return ll(o, i.cut(0, e.parentOffset).append(t.content).append(i.cut(n.parentOffset)));
    } else {
      let { start: o, end: i } = i$(t, e);
      return ll(r, Jg(e, o, i, n, a));
    }
  else return ll(r, ii(e, n, a));
}
function Yg(e, n) {
  if (!n.type.compatibleContent(e.type))
    throw new oi("Cannot join " + n.type.name + " onto " + e.type.name);
}
function Od(e, n, t) {
  let a = e.node(t);
  return Yg(a, n.node(t)), a;
}
function al(e, n) {
  let t = n.length - 1;
  t >= 0 && e.isText && e.sameMarkup(n[t]) ? n[t] = e.withText(n[t].text + e.text) : n.push(e);
}
function wr(e, n, t, a) {
  let l = (n || e).node(t), r = 0, o = n ? n.index(t) : l.childCount;
  e && (r = e.index(t), e.depth > t ? r++ : e.textOffset && (al(e.nodeAfter, a), r++));
  for (let i = r; i < o; i++)
    al(l.child(i), a);
  n && n.depth == t && n.textOffset && al(n.nodeBefore, a);
}
function ll(e, n) {
  return e.type.checkContent(n), e.copy(n);
}
function Jg(e, n, t, a, l) {
  let r = e.depth > l && Od(e, n, l + 1), o = a.depth > l && Od(t, a, l + 1), i = [];
  return wr(null, e, l, i), r && o && n.index(l) == t.index(l) ? (Yg(r, o), al(ll(r, Jg(e, n, t, a, l + 1)), i)) : (r && al(ll(r, ii(e, n, l + 1)), i), wr(n, t, l, i), o && al(ll(o, ii(t, a, l + 1)), i)), wr(a, null, l, i), new Pe(i);
}
function ii(e, n, t) {
  let a = [];
  if (wr(null, e, t, a), e.depth > t) {
    let l = Od(e, n, t + 1);
    al(ll(l, ii(e, n, t + 1)), a);
  }
  return wr(n, null, t, a), new Pe(a);
}
function i$(e, n) {
  let t = n.depth - e.openStart, l = n.node(t).copy(e.content);
  for (let r = t - 1; r >= 0; r--)
    l = n.node(r).copy(Pe.from(l));
  return {
    start: l.resolveNoCache(e.openStart + t),
    end: l.resolveNoCache(l.content.size - e.openEnd - t)
  };
}
class Hr {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.pos = n, this.path = t, this.parentOffset = a, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(n) {
    return n == null ? this.depth : n < 0 ? this.depth + n : n;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(n) {
    return this.path[this.resolveDepth(n) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(n) {
    return this.path[this.resolveDepth(n) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(n) {
    return n = this.resolveDepth(n), this.index(n) + (n == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(n) {
    return n = this.resolveDepth(n), n == 0 ? 0 : this.path[n * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(n) {
    return n = this.resolveDepth(n), this.start(n) + this.node(n).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(n) {
    if (n = this.resolveDepth(n), !n)
      throw new RangeError("There is no position before the top-level node");
    return n == this.depth + 1 ? this.pos : this.path[n * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(n) {
    if (n = this.resolveDepth(n), !n)
      throw new RangeError("There is no position after the top-level node");
    return n == this.depth + 1 ? this.pos : this.path[n * 3 - 1] + this.path[n * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let n = this.parent, t = this.index(this.depth);
    if (t == n.childCount)
      return null;
    let a = this.pos - this.path[this.path.length - 1], l = n.child(t);
    return a ? n.child(t).cut(a) : l;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let n = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(n).cut(0, t) : n == 0 ? null : this.parent.child(n - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(n, t) {
    t = this.resolveDepth(t);
    let a = this.path[t * 3], l = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let r = 0; r < n; r++)
      l += a.child(r).nodeSize;
    return l;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let n = this.parent, t = this.index();
    if (n.content.size == 0)
      return vt.none;
    if (this.textOffset)
      return n.child(t).marks;
    let a = n.maybeChild(t - 1), l = n.maybeChild(t);
    if (!a) {
      let i = a;
      a = l, l = i;
    }
    let r = a.marks;
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!l || !r[o].isInSet(l.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(n) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let a = t.marks, l = n.parent.maybeChild(n.index());
    for (var r = 0; r < a.length; r++)
      a[r].type.spec.inclusive === !1 && (!l || !a[r].isInSet(l.marks)) && (a = a[r--].removeFromSet(a));
    return a;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(n) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= n && this.end(t) >= n)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(n = this, t) {
    if (n.pos < this.pos)
      return n.blockRange(this);
    for (let a = this.depth - (this.parent.inlineContent || this.pos == n.pos ? 1 : 0); a >= 0; a--)
      if (n.pos <= this.end(a) && (!t || t(this.node(a))))
        return new si(this, n, a);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(n) {
    return this.pos - this.parentOffset == n.pos - n.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(n) {
    return n.pos > this.pos ? n : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(n) {
    return n.pos < this.pos ? n : this;
  }
  /**
  @internal
  */
  toString() {
    let n = "";
    for (let t = 1; t <= this.depth; t++)
      n += (n ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return n + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(n, t) {
    if (!(t >= 0 && t <= n.content.size))
      throw new RangeError("Position " + t + " out of range");
    let a = [], l = 0, r = t;
    for (let o = n; ; ) {
      let { index: i, offset: s } = o.content.findIndex(r), d = r - s;
      if (a.push(o, i, l + s), !d || (o = o.child(i), o.isText))
        break;
      r = d - 1, l += s + 1;
    }
    return new Hr(t, a, r);
  }
  /**
  @internal
  */
  static resolveCached(n, t) {
    let a = Af.get(n);
    if (a)
      for (let r = 0; r < a.elts.length; r++) {
        let o = a.elts[r];
        if (o.pos == t)
          return o;
      }
    else
      Af.set(n, a = new s$());
    let l = a.elts[a.i] = Hr.resolve(n, t);
    return a.i = (a.i + 1) % d$, l;
  }
}
class s$ {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const d$ = 12, Af = /* @__PURE__ */ new WeakMap();
class si {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(n, t, a) {
    this.$from = n, this.$to = t, this.depth = a;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const u$ = /* @__PURE__ */ Object.create(null);
let Aa = class Pd {
  /**
  @internal
  */
  constructor(n, t, a, l = vt.none) {
    this.type = n, this.attrs = t, this.marks = l, this.content = a || Pe.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(n) {
    return this.content.child(n);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(n) {
    return this.content.maybeChild(n);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(n) {
    this.content.forEach(n);
  }
  /**
  Invoke a callback for all descendant nodes recursively overlapping
  the given two positions that are relative to start of this
  node's content. This includes all ancestors of the nodes
  containing the two positions. The callback is invoked with the
  node, its position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(n, t, a, l = 0) {
    this.content.nodesBetween(n, t, a, l, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(n) {
    this.nodesBetween(0, this.content.size, n);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(n, t, a, l) {
    return this.content.textBetween(n, t, a, l);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(n) {
    return this == n || this.sameMarkup(n) && this.content.eq(n.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(n) {
    return this.hasMarkup(n.type, n.attrs, n.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(n, t, a) {
    return this.type == n && ri(this.attrs, t || n.defaultAttrs || u$) && vt.sameSet(this.marks, a || vt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(n = null) {
    return n == this.content ? this : new Pd(this.type, this.attrs, n, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(n) {
    return n == this.marks ? this : new Pd(this.type, this.attrs, this.content, n);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(n, t = this.content.size) {
    return n == 0 && t == this.content.size ? this : this.copy(this.content.cut(n, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(n, t = this.content.size, a = !1) {
    if (n == t)
      return Je.empty;
    let l = this.resolve(n), r = this.resolve(t), o = a ? 0 : l.sharedDepth(t), i = l.start(o), d = l.node(o).content.cut(l.pos - i, r.pos - i);
    return new Je(d, l.depth - o, r.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(n, t, a) {
    return o$(this.resolve(n), this.resolve(t), a);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(n) {
    for (let t = this; ; ) {
      let { index: a, offset: l } = t.content.findIndex(n);
      if (t = t.maybeChild(a), !t)
        return null;
      if (l == n || t.isText)
        return t;
      n -= l + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(n) {
    let { index: t, offset: a } = this.content.findIndex(n);
    return { node: this.content.maybeChild(t), index: t, offset: a };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(n) {
    if (n == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: a } = this.content.findIndex(n);
    if (a < n)
      return { node: this.content.child(t), index: t, offset: a };
    let l = this.content.child(t - 1);
    return { node: l, index: t - 1, offset: a - l.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(n) {
    return Hr.resolveCached(this, n);
  }
  /**
  @internal
  */
  resolveNoCache(n) {
    return Hr.resolve(this, n);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(n, t, a) {
    let l = !1;
    return t > n && this.nodesBetween(n, t, (r) => (a.isInSet(r.marks) && (l = !0), !l)), l;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let n = this.type.name;
    return this.content.size && (n += "(" + this.content.toStringInner() + ")"), Xg(this.marks, n);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(n) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, n);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(n, t, a = Pe.empty, l = 0, r = a.childCount) {
    let o = this.contentMatchAt(n).matchFragment(a, l, r), i = o && o.matchFragment(this.content, t);
    if (!i || !i.validEnd)
      return !1;
    for (let s = l; s < r; s++)
      if (!this.type.allowsMarks(a.child(s).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(n, t, a, l) {
    if (l && !this.type.allowsMarks(l))
      return !1;
    let r = this.contentMatchAt(n).matchType(a), o = r && r.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(n) {
    return n.content.size ? this.canReplace(this.childCount, this.childCount, n.content) : this.type.compatibleContent(n.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let n = vt.none;
    for (let t = 0; t < this.marks.length; t++) {
      let a = this.marks[t];
      a.type.checkAttrs(a.attrs), n = a.addToSet(n);
    }
    if (!vt.sameSet(n, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let n = { type: this.type.name };
    for (let t in this.attrs) {
      n.attrs = this.attrs;
      break;
    }
    return this.content.size && (n.content = this.content.toJSON()), this.marks.length && (n.marks = this.marks.map((t) => t.toJSON())), n;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let a;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      a = t.marks.map(n.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return n.text(t.text, a);
    }
    let l = Pe.fromJSON(n, t.content), r = n.nodeType(t.type).create(t.attrs, l, a);
    return r.type.checkAttrs(r.attrs), r;
  }
};
Aa.prototype.text = void 0;
class di extends Aa {
  /**
  @internal
  */
  constructor(n, t, a, l) {
    if (super(n, t, null, l), !a)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = a;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Xg(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(n, t) {
    return this.text.slice(n, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(n) {
    return n == this.marks ? this : new di(this.type, this.attrs, this.text, n);
  }
  withText(n) {
    return n == this.text ? this : new di(this.type, this.attrs, n, this.marks);
  }
  cut(n = 0, t = this.text.length) {
    return n == 0 && t == this.text.length ? this : this.withText(this.text.slice(n, t));
  }
  eq(n) {
    return this.sameMarkup(n) && this.text == n.text;
  }
  toJSON() {
    let n = super.toJSON();
    return n.text = this.text, n;
  }
}
function Xg(e, n) {
  for (let t = e.length - 1; t >= 0; t--)
    n = e[t].type.name + "(" + n + ")";
  return n;
}
class fl {
  /**
  @internal
  */
  constructor(n) {
    this.validEnd = n, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(n, t) {
    let a = new c$(n, t);
    if (a.next == null)
      return fl.empty;
    let l = Zg(a);
    a.next && a.err("Unexpected trailing text");
    let r = v$(p$(l));
    return x$(r, a), r;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(n) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == n)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(n, t = 0, a = n.childCount) {
    let l = this;
    for (let r = t; l && r < a; r++)
      l = l.matchType(n.child(r).type);
    return l;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let n = 0; n < this.next.length; n++) {
      let { type: t } = this.next[n];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(n) {
    for (let t = 0; t < this.next.length; t++)
      for (let a = 0; a < n.next.length; a++)
        if (this.next[t].type == n.next[a].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(n, t = !1, a = 0) {
    let l = [this];
    function r(o, i) {
      let s = o.matchFragment(n, a);
      if (s && (!t || s.validEnd))
        return Pe.from(i.map((d) => d.createAndFill()));
      for (let d = 0; d < o.next.length; d++) {
        let { type: u, next: f } = o.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && l.indexOf(f) == -1) {
          l.push(f);
          let b = r(f, i.concat(u));
          if (b)
            return b;
        }
      }
      return null;
    }
    return r(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(n) {
    for (let a = 0; a < this.wrapCache.length; a += 2)
      if (this.wrapCache[a] == n)
        return this.wrapCache[a + 1];
    let t = this.computeWrapping(n);
    return this.wrapCache.push(n, t), t;
  }
  /**
  @internal
  */
  computeWrapping(n) {
    let t = /* @__PURE__ */ Object.create(null), a = [{ match: this, type: null, via: null }];
    for (; a.length; ) {
      let l = a.shift(), r = l.match;
      if (r.matchType(n)) {
        let o = [];
        for (let i = l; i.type; i = i.via)
          o.push(i.type);
        return o.reverse();
      }
      for (let o = 0; o < r.next.length; o++) {
        let { type: i, next: s } = r.next[o];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in t) && (!l.type || s.validEnd) && (a.push({ match: i.contentMatch, type: i, via: l }), t[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(n) {
    if (n >= this.next.length)
      throw new RangeError(`There's no ${n}th edge in this content match`);
    return this.next[n];
  }
  /**
  @internal
  */
  toString() {
    let n = [];
    function t(a) {
      n.push(a);
      for (let l = 0; l < a.next.length; l++)
        n.indexOf(a.next[l].next) == -1 && t(a.next[l].next);
    }
    return t(this), n.map((a, l) => {
      let r = l + (a.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < a.next.length; o++)
        r += (o ? ", " : "") + a.next[o].type.name + "->" + n.indexOf(a.next[o].next);
      return r;
    }).join(`
`);
  }
}
fl.empty = new fl(!0);
class c$ {
  constructor(n, t) {
    this.string = n, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = n.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(n) {
    return this.next == n && (this.pos++ || !0);
  }
  err(n) {
    throw new SyntaxError(n + " (in content expression '" + this.string + "')");
  }
}
function Zg(e) {
  let n = [];
  do
    n.push(f$(e));
  while (e.eat("|"));
  return n.length == 1 ? n[0] : { type: "choice", exprs: n };
}
function f$(e) {
  let n = [];
  do
    n.push(h$(e));
  while (e.next && e.next != ")" && e.next != "|");
  return n.length == 1 ? n[0] : { type: "seq", exprs: n };
}
function h$(e) {
  let n = m$(e);
  for (; ; )
    if (e.eat("+"))
      n = { type: "plus", expr: n };
    else if (e.eat("*"))
      n = { type: "star", expr: n };
    else if (e.eat("?"))
      n = { type: "opt", expr: n };
    else if (e.eat("{"))
      n = b$(e, n);
    else
      break;
  return n;
}
function Ef(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let n = Number(e.next);
  return e.pos++, n;
}
function b$(e, n) {
  let t = Ef(e), a = t;
  return e.eat(",") && (e.next != "}" ? a = Ef(e) : a = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: t, max: a, expr: n };
}
function g$(e, n) {
  let t = e.nodeTypes, a = t[n];
  if (a)
    return [a];
  let l = [];
  for (let r in t) {
    let o = t[r];
    o.isInGroup(n) && l.push(o);
  }
  return l.length == 0 && e.err("No node type or group '" + n + "' found"), l;
}
function m$(e) {
  if (e.eat("(")) {
    let n = Zg(e);
    return e.eat(")") || e.err("Missing closing paren"), n;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let n = g$(e, e.next).map((t) => (e.inline == null ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), { type: "name", value: t }));
    return e.pos++, n.length == 1 ? n[0] : { type: "choice", exprs: n };
  }
}
function p$(e) {
  let n = [[]];
  return l(r(e, 0), t()), n;
  function t() {
    return n.push([]) - 1;
  }
  function a(o, i, s) {
    let d = { term: s, to: i };
    return n[o].push(d), d;
  }
  function l(o, i) {
    o.forEach((s) => s.to = i);
  }
  function r(o, i) {
    if (o.type == "choice")
      return o.exprs.reduce((s, d) => s.concat(r(d, i)), []);
    if (o.type == "seq")
      for (let s = 0; ; s++) {
        let d = r(o.exprs[s], i);
        if (s == o.exprs.length - 1)
          return d;
        l(d, i = t());
      }
    else if (o.type == "star") {
      let s = t();
      return a(i, s), l(r(o.expr, s), s), [a(s)];
    } else if (o.type == "plus") {
      let s = t();
      return l(r(o.expr, i), s), l(r(o.expr, s), s), [a(s)];
    } else {
      if (o.type == "opt")
        return [a(i)].concat(r(o.expr, i));
      if (o.type == "range") {
        let s = i;
        for (let d = 0; d < o.min; d++) {
          let u = t();
          l(r(o.expr, s), u), s = u;
        }
        if (o.max == -1)
          l(r(o.expr, s), s);
        else
          for (let d = o.min; d < o.max; d++) {
            let u = t();
            a(s, u), l(r(o.expr, s), u), s = u;
          }
        return [a(s)];
      } else {
        if (o.type == "name")
          return [a(i, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Qg(e, n) {
  return n - e;
}
function Rf(e, n) {
  let t = [];
  return a(n), t.sort(Qg);
  function a(l) {
    let r = e[l];
    if (r.length == 1 && !r[0].term)
      return a(r[0].to);
    t.push(l);
    for (let o = 0; o < r.length; o++) {
      let { term: i, to: s } = r[o];
      !i && t.indexOf(s) == -1 && a(s);
    }
  }
}
function v$(e) {
  let n = /* @__PURE__ */ Object.create(null);
  return t(Rf(e, 0));
  function t(a) {
    let l = [];
    a.forEach((o) => {
      e[o].forEach(({ term: i, to: s }) => {
        if (!i)
          return;
        let d;
        for (let u = 0; u < l.length; u++)
          l[u][0] == i && (d = l[u][1]);
        Rf(e, s).forEach((u) => {
          d || l.push([i, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let r = n[a.join(",")] = new fl(a.indexOf(e.length - 1) > -1);
    for (let o = 0; o < l.length; o++) {
      let i = l[o][1].sort(Qg);
      r.next.push({ type: l[o][0], next: n[i.join(",")] || t(i) });
    }
    return r;
  }
}
function x$(e, n) {
  for (let t = 0, a = [e]; t < a.length; t++) {
    let l = a[t], r = !l.validEnd, o = [];
    for (let i = 0; i < l.next.length; i++) {
      let { type: s, next: d } = l.next[i];
      o.push(s.name), r && !(s.isText || s.hasRequiredAttrs()) && (r = !1), a.indexOf(d) == -1 && a.push(d);
    }
    r && n.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function _g(e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e) {
    let a = e[t];
    if (!a.hasDefault)
      return null;
    n[t] = a.default;
  }
  return n;
}
function em(e, n) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let a in e) {
    let l = n && n[a];
    if (l === void 0) {
      let r = e[a];
      if (r.hasDefault)
        l = r.default;
      else
        throw new RangeError("No value supplied for attribute " + a);
    }
    t[a] = l;
  }
  return t;
}
function tm(e, n, t, a) {
  for (let l in n)
    if (!(l in e))
      throw new RangeError(`Unsupported attribute ${l} for ${t} of type ${l}`);
  for (let l in e) {
    let r = e[l];
    r.validate && r.validate(n[l]);
  }
}
function nm(e, n) {
  let t = /* @__PURE__ */ Object.create(null);
  if (n)
    for (let a in n)
      t[a] = new k$(e, a, n[a]);
  return t;
}
let Bf = class am {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.name = n, this.schema = t, this.spec = a, this.markSet = null, this.groups = a.group ? a.group.split(" ") : [], this.attrs = nm(n, a.attrs), this.defaultAttrs = _g(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(a.inline || n == "text"), this.isText = n == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == fl.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(n) {
    return this.groups.indexOf(n) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let n in this.attrs)
      if (this.attrs[n].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(n) {
    return this == n || this.contentMatch.compatible(n.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(n) {
    return !n && this.defaultAttrs ? this.defaultAttrs : em(this.attrs, n);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(n = null, t, a) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Aa(this, this.computeAttrs(n), Pe.from(t), vt.setFrom(a));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(n = null, t, a) {
    return t = Pe.from(t), this.checkContent(t), new Aa(this, this.computeAttrs(n), t, vt.setFrom(a));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(n = null, t, a) {
    if (n = this.computeAttrs(n), t = Pe.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let l = this.contentMatch.matchFragment(t), r = l && l.fillBefore(Pe.empty, !0);
    return r ? new Aa(this, n, t.append(r), vt.setFrom(a)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(n) {
    let t = this.contentMatch.matchFragment(n);
    if (!t || !t.validEnd)
      return !1;
    for (let a = 0; a < n.childCount; a++)
      if (!this.allowsMarks(n.child(a).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(n) {
    if (!this.validContent(n))
      throw new RangeError(`Invalid content for node ${this.name}: ${n.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(n) {
    tm(this.attrs, n, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(n) {
    return this.markSet == null || this.markSet.indexOf(n) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(n) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < n.length; t++)
      if (!this.allowsMarkType(n[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(n) {
    if (this.markSet == null)
      return n;
    let t;
    for (let a = 0; a < n.length; a++)
      this.allowsMarkType(n[a].type) ? t && t.push(n[a]) : t || (t = n.slice(0, a));
    return t ? t.length ? t : vt.none : n;
  }
  /**
  @internal
  */
  static compile(n, t) {
    let a = /* @__PURE__ */ Object.create(null);
    n.forEach((r, o) => a[r] = new am(r, t, o));
    let l = t.spec.topNode || "doc";
    if (!a[l])
      throw new RangeError("Schema is missing its top node type ('" + l + "')");
    if (!a.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let r in a.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return a;
  }
};
function y$(e, n, t) {
  let a = t.split("|");
  return (l) => {
    let r = l === null ? "null" : typeof l;
    if (a.indexOf(r) < 0)
      throw new RangeError(`Expected value of type ${a} for attribute ${n} on type ${e}, got ${r}`);
  };
}
class k$ {
  constructor(n, t, a) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(a, "default"), this.default = a.default, this.validate = typeof a.validate == "string" ? y$(n, t, a.validate) : a.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class es {
  /**
  @internal
  */
  constructor(n, t, a, l) {
    this.name = n, this.rank = t, this.schema = a, this.spec = l, this.attrs = nm(n, l.attrs), this.excluded = null;
    let r = _g(this.attrs);
    this.instance = r ? new vt(this, r) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(n = null) {
    return !n && this.instance ? this.instance : new vt(this, em(this.attrs, n));
  }
  /**
  @internal
  */
  static compile(n, t) {
    let a = /* @__PURE__ */ Object.create(null), l = 0;
    return n.forEach((r, o) => a[r] = new es(r, l++, t, o)), a;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(n) {
    for (var t = 0; t < n.length; t++)
      n[t].type == this && (n = n.slice(0, t).concat(n.slice(t + 1)), t--);
    return n;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(n) {
    for (let t = 0; t < n.length; t++)
      if (n[t].type == this)
        return n[t];
  }
  /**
  @internal
  */
  checkAttrs(n) {
    tm(this.attrs, n, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(n) {
    return this.excluded.indexOf(n) > -1;
  }
}
class lm {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(n) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let l in n)
      t[l] = n[l];
    t.nodes = Wt.from(n.nodes), t.marks = Wt.from(n.marks || {}), this.nodes = Bf.compile(this.spec.nodes, this), this.marks = es.compile(this.spec.marks, this);
    let a = /* @__PURE__ */ Object.create(null);
    for (let l in this.nodes) {
      if (l in this.marks)
        throw new RangeError(l + " can not be both a node and a mark");
      let r = this.nodes[l], o = r.spec.content || "", i = r.spec.marks;
      if (r.contentMatch = a[o] || (a[o] = fl.parse(o, this.nodes)), r.inlineContent = r.contentMatch.inlineContent, r.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!r.isInline || !r.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = r;
      }
      r.markSet = i == "_" ? null : i ? Df(this, i.split(" ")) : i == "" || !r.inlineContent ? [] : null;
    }
    for (let l in this.marks) {
      let r = this.marks[l], o = r.spec.excludes;
      r.excluded = o == null ? [r] : o == "" ? [] : Df(this, o.split(" "));
    }
    this.nodeFromJSON = (l) => Aa.fromJSON(this, l), this.markFromJSON = (l) => vt.fromJSON(this, l), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(n, t = null, a, l) {
    if (typeof n == "string")
      n = this.nodeType(n);
    else if (n instanceof Bf) {
      if (n.schema != this)
        throw new RangeError("Node type from different schema used (" + n.name + ")");
    } else throw new RangeError("Invalid node type: " + n);
    return n.createChecked(t, a, l);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(n, t) {
    let a = this.nodes.text;
    return new di(a, a.defaultAttrs, n, vt.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(n, t) {
    return typeof n == "string" && (n = this.marks[n]), n.create(t);
  }
  /**
  @internal
  */
  nodeType(n) {
    let t = this.nodes[n];
    if (!t)
      throw new RangeError("Unknown node type: " + n);
    return t;
  }
}
function Df(e, n) {
  let t = [];
  for (let a = 0; a < n.length; a++) {
    let l = n[a], r = e.marks[l], o = r;
    if (r)
      t.push(r);
    else
      for (let i in e.marks) {
        let s = e.marks[i];
        (l == "_" || s.spec.group && s.spec.group.split(" ").indexOf(l) > -1) && t.push(o = s);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + n[a] + "'");
  }
  return t;
}
function w$(e) {
  return e.tag != null;
}
function C$(e) {
  return e.style != null;
}
class Ea {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(n, t) {
    this.schema = n, this.rules = t, this.tags = [], this.styles = [];
    let a = this.matchedStyles = [];
    t.forEach((l) => {
      if (w$(l))
        this.tags.push(l);
      else if (C$(l)) {
        let r = /[^=]*/.exec(l.style)[0];
        a.indexOf(r) < 0 && a.push(r), this.styles.push(l);
      }
    }), this.normalizeLists = !this.tags.some((l) => {
      if (!/^(ul|ol)\b/.test(l.tag) || !l.node)
        return !1;
      let r = n.nodes[l.node];
      return r.contentMatch.matchType(r);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(n, t = {}) {
    let a = new zf(this, t, !1);
    return a.addAll(n, vt.none, t.from, t.to), a.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(n, t = {}) {
    let a = new zf(this, t, !0);
    return a.addAll(n, vt.none, t.from, t.to), Je.maxOpen(a.finish());
  }
  /**
  @internal
  */
  matchTag(n, t, a) {
    for (let l = a ? this.tags.indexOf(a) + 1 : 0; l < this.tags.length; l++) {
      let r = this.tags[l];
      if (I$(n, r.tag) && (r.namespace === void 0 || n.namespaceURI == r.namespace) && (!r.context || t.matchesContext(r.context))) {
        if (r.getAttrs) {
          let o = r.getAttrs(n);
          if (o === !1)
            continue;
          r.attrs = o || void 0;
        }
        return r;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(n, t, a, l) {
    for (let r = l ? this.styles.indexOf(l) + 1 : 0; r < this.styles.length; r++) {
      let o = this.styles[r], i = o.style;
      if (!(i.indexOf(n) != 0 || o.context && !a.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > n.length && (i.charCodeAt(n.length) != 61 || i.slice(n.length + 1) != t))) {
        if (o.getAttrs) {
          let s = o.getAttrs(t);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(n) {
    let t = [];
    function a(l) {
      let r = l.priority == null ? 50 : l.priority, o = 0;
      for (; o < t.length; o++) {
        let i = t[o];
        if ((i.priority == null ? 50 : i.priority) < r)
          break;
      }
      t.splice(o, 0, l);
    }
    for (let l in n.marks) {
      let r = n.marks[l].spec.parseDOM;
      r && r.forEach((o) => {
        a(o = Of(o)), o.mark || o.ignore || o.clearMark || (o.mark = l);
      });
    }
    for (let l in n.nodes) {
      let r = n.nodes[l].spec.parseDOM;
      r && r.forEach((o) => {
        a(o = Of(o)), o.node || o.ignore || o.mark || (o.node = l);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(n) {
    return n.cached.domParser || (n.cached.domParser = new Ea(n, Ea.schemaRules(n)));
  }
}
const rm = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, S$ = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, om = { ol: !0, ul: !0 }, jr = 1, Fd = 2, Cr = 4;
function Mf(e, n, t) {
  return n != null ? (n ? jr : 0) | (n === "full" ? Fd : 0) : e && e.whitespace == "pre" ? jr | Fd : t & ~Cr;
}
class ko {
  constructor(n, t, a, l, r, o) {
    this.type = n, this.attrs = t, this.marks = a, this.solid = l, this.options = o, this.content = [], this.activeMarks = vt.none, this.match = r || (o & Cr ? null : n.contentMatch);
  }
  findWrapping(n) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Pe.from(n));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let a = this.type.contentMatch, l;
        return (l = a.findWrapping(n.type)) ? (this.match = a, l) : null;
      }
    }
    return this.match.findWrapping(n.type);
  }
  finish(n) {
    if (!(this.options & jr)) {
      let a = this.content[this.content.length - 1], l;
      if (a && a.isText && (l = /[ \t\r\n\u000c]+$/.exec(a.text))) {
        let r = a;
        a.text.length == l[0].length ? this.content.pop() : this.content[this.content.length - 1] = r.withText(r.text.slice(0, r.text.length - l[0].length));
      }
    }
    let t = Pe.from(this.content);
    return !n && this.match && (t = t.append(this.match.fillBefore(Pe.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(n) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : n.parentNode && !rm.hasOwnProperty(n.parentNode.nodeName.toLowerCase());
  }
}
class zf {
  constructor(n, t, a) {
    this.parser = n, this.options = t, this.isOpen = a, this.open = 0, this.localPreserveWS = !1;
    let l = t.topNode, r, o = Mf(null, t.preserveWhitespace, 0) | (a ? Cr : 0);
    l ? r = new ko(l.type, l.attrs, vt.none, !0, t.topMatch || l.type.contentMatch, o) : a ? r = new ko(null, null, vt.none, !0, null, o) : r = new ko(n.schema.topNodeType, null, vt.none, !0, null, o), this.nodes = [r], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(n, t) {
    n.nodeType == 3 ? this.addTextNode(n, t) : n.nodeType == 1 && this.addElement(n, t);
  }
  addTextNode(n, t) {
    let a = n.nodeValue, l = this.top, r = l.options & Fd ? "full" : this.localPreserveWS || (l.options & jr) > 0, { schema: o } = this.parser;
    if (r === "full" || l.inlineContext(n) || /[^ \t\r\n\u000c]/.test(a)) {
      if (r)
        if (r === "full")
          a = a.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(a) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let i = a.split(/\r?\n|\r/);
          for (let s = 0; s < i.length; s++)
            s && this.insertNode(o.linebreakReplacement.create(), t, !0), i[s] && this.insertNode(o.text(i[s]), t, !/\S/.test(i[s]));
          a = "";
        } else
          a = a.replace(/\r?\n|\r/g, " ");
      else if (a = a.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(a) && this.open == this.nodes.length - 1) {
        let i = l.content[l.content.length - 1], s = n.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (a = a.slice(1));
      }
      a && this.insertNode(o.text(a), t, !/\S/.test(a)), this.findInText(n);
    } else
      this.findInside(n);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(n, t, a) {
    let l = this.localPreserveWS, r = this.top;
    (n.tagName == "PRE" || /pre/.test(n.style && n.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = n.nodeName.toLowerCase(), i;
    om.hasOwnProperty(o) && this.parser.normalizeLists && $$(n);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(n) || (i = this.parser.matchTag(n, this, a));
    e: if (s ? s.ignore : S$.hasOwnProperty(o))
      this.findInside(n), this.ignoreFallback(n, t);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (n = s.skip);
      let d, u = this.needsBlock;
      if (rm.hasOwnProperty(o))
        r.content.length && r.content[0].isInline && this.open && (this.open--, r = this.top), d = !0, r.type || (this.needsBlock = !0);
      else if (!n.firstChild) {
        this.leafFallback(n, t);
        break e;
      }
      let f = s && s.skip ? t : this.readStyles(n, t);
      f && this.addAll(n, f), d && this.sync(r), this.needsBlock = u;
    } else {
      let d = this.readStyles(n, t);
      d && this.addElementByRule(n, s, d, s.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = l;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(n, t) {
    n.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(n.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(n, t) {
    n.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(n, t) {
    let a = n.style;
    if (a && a.length)
      for (let l = 0; l < this.parser.matchedStyles.length; l++) {
        let r = this.parser.matchedStyles[l], o = a.getPropertyValue(r);
        if (o)
          for (let i = void 0; ; ) {
            let s = this.parser.matchStyle(r, o, this, i);
            if (!s)
              break;
            if (s.ignore)
              return null;
            if (s.clearMark ? t = t.filter((d) => !s.clearMark(d)) : t = t.concat(this.parser.schema.marks[s.mark].create(s.attrs)), s.consuming === !1)
              i = s;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(n, t, a, l) {
    let r, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), a, n.nodeName == "BR") || this.leafFallback(n, a);
      else {
        let s = this.enter(o, t.attrs || null, a, t.preserveWhitespace);
        s && (r = !0, a = s);
      }
    else {
      let s = this.parser.schema.marks[t.mark];
      a = a.concat(s.create(t.attrs));
    }
    let i = this.top;
    if (o && o.isLeaf)
      this.findInside(n);
    else if (l)
      this.addElement(n, a, l);
    else if (t.getContent)
      this.findInside(n), t.getContent(n, this.parser.schema).forEach((s) => this.insertNode(s, a, !1));
    else {
      let s = n;
      typeof t.contentElement == "string" ? s = n.querySelector(t.contentElement) : typeof t.contentElement == "function" ? s = t.contentElement(n) : t.contentElement && (s = t.contentElement), this.findAround(n, s, !0), this.addAll(s, a), this.findAround(n, s, !1);
    }
    r && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(n, t, a, l) {
    let r = a || 0;
    for (let o = a ? n.childNodes[a] : n.firstChild, i = l == null ? null : n.childNodes[l]; o != i; o = o.nextSibling, ++r)
      this.findAtPoint(n, r), this.addDOM(o, t);
    this.findAtPoint(n, r);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(n, t, a) {
    let l, r;
    for (let o = this.open, i = 0; o >= 0; o--) {
      let s = this.nodes[o], d = s.findWrapping(n);
      if (d && (!l || l.length > d.length + i) && (l = d, r = s, !d.length))
        break;
      if (s.solid) {
        if (a)
          break;
        i += 2;
      }
    }
    if (!l)
      return null;
    this.sync(r);
    for (let o = 0; o < l.length; o++)
      t = this.enterInner(l[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(n, t, a) {
    if (n.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (t = this.enterInner(r, null, t));
    }
    let l = this.findPlace(n, t, a);
    if (l) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(n.type));
      let o = vt.none;
      for (let i of l.concat(n.marks))
        (r.type ? r.type.allowsMarkType(i.type) : Pf(i.type, n.type)) && (o = i.addToSet(o));
      return r.content.push(n.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(n, t, a, l) {
    let r = this.findPlace(n.create(t), a, !1);
    return r && (r = this.enterInner(n, t, a, !0, l)), r;
  }
  // Open a node of the given type
  enterInner(n, t, a, l = !1, r) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(n);
    let i = Mf(n, r, o.options);
    o.options & Cr && o.content.length == 0 && (i |= Cr);
    let s = vt.none;
    return a = a.filter((d) => (o.type ? o.type.allowsMarkType(d.type) : Pf(d.type, n)) ? (s = d.addToSet(s), !1) : !0), this.nodes.push(new ko(n, t, s, l, null, i)), this.open++, a;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(n = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(n));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(n) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == n)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= jr);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let n = 0;
    for (let t = this.open; t >= 0; t--) {
      let a = this.nodes[t].content;
      for (let l = a.length - 1; l >= 0; l--)
        n += a[l].nodeSize;
      t && n++;
    }
    return n;
  }
  findAtPoint(n, t) {
    if (this.find)
      for (let a = 0; a < this.find.length; a++)
        this.find[a].node == n && this.find[a].offset == t && (this.find[a].pos = this.currentPos);
  }
  findInside(n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && n.nodeType == 1 && n.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(n, t, a) {
    if (n != t && this.find)
      for (let l = 0; l < this.find.length; l++)
        this.find[l].pos == null && n.nodeType == 1 && n.contains(this.find[l].node) && t.compareDocumentPosition(this.find[l].node) & (a ? 2 : 4) && (this.find[l].pos = this.currentPos);
  }
  findInText(n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == n && (this.find[t].pos = this.currentPos - (n.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(n) {
    if (n.indexOf("|") > -1)
      return n.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = n.split("/"), a = this.options.context, l = !this.isOpen && (!a || a.parent.type == this.nodes[0].type), r = -(a ? a.depth + 1 : 0) + (l ? 0 : 1), o = (i, s) => {
      for (; i >= 0; i--) {
        let d = t[i];
        if (d == "") {
          if (i == t.length - 1 || i == 0)
            continue;
          for (; s >= r; s--)
            if (o(i - 1, s))
              return !0;
          return !1;
        } else {
          let u = s > 0 || s == 0 && l ? this.nodes[s].type : a && s >= r ? a.node(s - r).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          s--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let n = this.options.context;
    if (n)
      for (let t = n.depth; t >= 0; t--) {
        let a = n.node(t).contentMatchAt(n.indexAfter(t)).defaultType;
        if (a && a.isTextblock && a.defaultAttrs)
          return a;
      }
    for (let t in this.parser.schema.nodes) {
      let a = this.parser.schema.nodes[t];
      if (a.isTextblock && a.defaultAttrs)
        return a;
    }
  }
}
function $$(e) {
  for (let n = e.firstChild, t = null; n; n = n.nextSibling) {
    let a = n.nodeType == 1 ? n.nodeName.toLowerCase() : null;
    a && om.hasOwnProperty(a) && t ? (t.appendChild(n), n = t) : a == "li" ? t = n : a && (t = null);
  }
}
function I$(e, n) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, n);
}
function Of(e) {
  let n = {};
  for (let t in e)
    n[t] = e[t];
  return n;
}
function Pf(e, n) {
  let t = n.schema.nodes;
  for (let a in t) {
    let l = t[a];
    if (!l.allowsMarkType(e))
      continue;
    let r = [], o = (i) => {
      r.push(i);
      for (let s = 0; s < i.edgeCount; s++) {
        let { type: d, next: u } = i.edge(s);
        if (d == n || r.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(l.contentMatch))
      return !0;
  }
}
class pl {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(n, t) {
    this.nodes = n, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(n, t = {}, a) {
    a || (a = wo(t).createDocumentFragment());
    let l = a, r = [];
    return n.forEach((o) => {
      if (r.length || o.marks.length) {
        let i = 0, s = 0;
        for (; i < r.length && s < o.marks.length; ) {
          let d = o.marks[s];
          if (!this.marks[d.type.name]) {
            s++;
            continue;
          }
          if (!d.eq(r[i][0]) || d.type.spec.spanning === !1)
            break;
          i++, s++;
        }
        for (; i < r.length; )
          l = r.pop()[1];
        for (; s < o.marks.length; ) {
          let d = o.marks[s++], u = this.serializeMark(d, o.isInline, t);
          u && (r.push([d, l]), l.appendChild(u.dom), l = u.contentDOM || u.dom);
        }
      }
      l.appendChild(this.serializeNodeInner(o, t));
    }), a;
  }
  /**
  @internal
  */
  serializeNodeInner(n, t) {
    if (n.isText)
      return wo(t).createTextNode(n.text);
    let { dom: a, contentDOM: l } = Uo(wo(t), this.nodes[n.type.name](n), null, n.attrs);
    if (l) {
      if (n.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(n.content, t, l);
    }
    return a;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(n, t = {}) {
    let a = this.serializeNodeInner(n, t);
    for (let l = n.marks.length - 1; l >= 0; l--) {
      let r = this.serializeMark(n.marks[l], n.isInline, t);
      r && ((r.contentDOM || r.dom).appendChild(a), a = r.dom);
    }
    return a;
  }
  /**
  @internal
  */
  serializeMark(n, t, a = {}) {
    let l = this.marks[n.type.name];
    return l && Uo(wo(a), l(n, t), null, n.attrs);
  }
  static renderSpec(n, t, a = null, l) {
    return typeof t == "string" ? { dom: n.createTextNode(t) } : Uo(n, t, a, l);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(n) {
    return n.cached.domSerializer || (n.cached.domSerializer = new pl(this.nodesFromSchema(n), this.marksFromSchema(n)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(n) {
    let t = Ff(n.nodes);
    return t.text || (t.text = (a) => a.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(n) {
    return Ff(n.marks);
  }
}
function Ff(e) {
  let n = {};
  for (let t in e) {
    let a = e[t].spec.toDOM;
    a && (n[t] = a);
  }
  return n;
}
function wo(e) {
  return e.document || window.document;
}
const Vf = /* @__PURE__ */ new WeakMap();
function T$(e) {
  let n = Vf.get(e);
  return n === void 0 && Vf.set(e, n = L$(e)), n;
}
function L$(e) {
  let n = null;
  function t(a) {
    if (a && typeof a == "object")
      if (Array.isArray(a))
        if (typeof a[0] == "string")
          n || (n = []), n.push(a);
        else
          for (let l = 0; l < a.length; l++)
            t(a[l]);
      else
        for (let l in a)
          t(a[l]);
  }
  return t(e), n;
}
function Uo(e, n, t, a) {
  if (n.nodeType == 1)
    return { dom: n };
  if (n.dom && n.dom.nodeType == 1)
    return n;
  let l = n[0], r;
  if (typeof l != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (a && (r = T$(a)) && r.indexOf(n) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = l.indexOf(" ");
  o > 0 && (t = l.slice(0, o), l = l.slice(o + 1));
  let i, s = t ? e.createElementNS(t, l) : e.createElement(l), d = n[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let f in d)
      if (d[f] != null) {
        let b = f.indexOf(" ");
        b > 0 ? s.setAttributeNS(f.slice(0, b), f.slice(b + 1), d[f]) : f == "style" && s.style ? s.style.cssText = d[f] : s.setAttribute(f, d[f]);
      }
  }
  for (let f = u; f < n.length; f++) {
    let b = n[f];
    if (b === 0) {
      if (f < n.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: s, contentDOM: s };
    } else if (typeof b == "string")
      s.appendChild(e.createTextNode(b));
    else {
      let { dom: h, contentDOM: p } = Uo(e, b, t, a);
      if (s.appendChild(h), p) {
        if (i)
          throw new RangeError("Multiple content holes");
        i = p;
      }
    }
  }
  return { dom: s, contentDOM: i };
}
const im = 65535, sm = Math.pow(2, 16);
function A$(e, n) {
  return e + n * sm;
}
function Nf(e) {
  return e & im;
}
function E$(e) {
  return (e - (e & im)) / sm;
}
const dm = 1, um = 2, Go = 4, cm = 8;
class Vd {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.pos = n, this.delInfo = t, this.recover = a;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & cm) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (dm | Go)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (um | Go)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Go) > 0;
  }
}
class bn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(n, t = !1) {
    if (this.ranges = n, this.inverted = t, !n.length && bn.empty)
      return bn.empty;
  }
  /**
  @internal
  */
  recover(n) {
    let t = 0, a = Nf(n);
    if (!this.inverted)
      for (let l = 0; l < a; l++)
        t += this.ranges[l * 3 + 2] - this.ranges[l * 3 + 1];
    return this.ranges[a * 3] + t + E$(n);
  }
  mapResult(n, t = 1) {
    return this._map(n, t, !1);
  }
  map(n, t = 1) {
    return this._map(n, t, !0);
  }
  /**
  @internal
  */
  _map(n, t, a) {
    let l = 0, r = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? l : 0);
      if (s > n)
        break;
      let d = this.ranges[i + r], u = this.ranges[i + o], f = s + d;
      if (n <= f) {
        let b = d ? n == s ? -1 : n == f ? 1 : t : t, h = s + l + (b < 0 ? 0 : u);
        if (a)
          return h;
        let p = n == (t < 0 ? s : f) ? null : A$(i / 3, n - s), x = n == s ? um : n == f ? dm : Go;
        return (t < 0 ? n != s : n != f) && (x |= cm), new Vd(h, x, p);
      }
      l += u - d;
    }
    return a ? n + l : new Vd(n + l, 0, null);
  }
  /**
  @internal
  */
  touches(n, t) {
    let a = 0, l = Nf(t), r = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? a : 0);
      if (s > n)
        break;
      let d = this.ranges[i + r], u = s + d;
      if (n <= u && i == l * 3)
        return !0;
      a += this.ranges[i + o] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(n) {
    let t = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let l = 0, r = 0; l < this.ranges.length; l += 3) {
      let o = this.ranges[l], i = o - (this.inverted ? r : 0), s = o + (this.inverted ? 0 : r), d = this.ranges[l + t], u = this.ranges[l + a];
      n(i, i + d, s, s + u), r += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new bn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(n) {
    return n == 0 ? bn.empty : new bn(n < 0 ? [0, -n, 0] : [0, 0, n]);
  }
}
bn.empty = new bn([]);
class Wr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(n, t, a = 0, l = n ? n.length : 0) {
    this.mirror = t, this.from = a, this.to = l, this._maps = n || [], this.ownData = !(n || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(n = 0, t = this.maps.length) {
    return new Wr(this._maps, this.mirror, n, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(n, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(n), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(n) {
    for (let t = 0, a = this._maps.length; t < n._maps.length; t++) {
      let l = n.getMirror(t);
      this.appendMap(n._maps[t], l != null && l < t ? a + l : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(n) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == n)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(n, t) {
    this.mirror || (this.mirror = []), this.mirror.push(n, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(n) {
    for (let t = n.maps.length - 1, a = this._maps.length + n._maps.length; t >= 0; t--) {
      let l = n.getMirror(t);
      this.appendMap(n._maps[t].invert(), l != null && l > t ? a - l - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let n = new Wr();
    return n.appendMappingInverted(this), n;
  }
  /**
  Map a position through this mapping.
  */
  map(n, t = 1) {
    if (this.mirror)
      return this._map(n, t, !0);
    for (let a = this.from; a < this.to; a++)
      n = this._maps[a].map(n, t);
    return n;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(n, t = 1) {
    return this._map(n, t, !1);
  }
  /**
  @internal
  */
  _map(n, t, a) {
    let l = 0;
    for (let r = this.from; r < this.to; r++) {
      let o = this._maps[r], i = o.mapResult(n, t);
      if (i.recover != null) {
        let s = this.getMirror(r);
        if (s != null && s > r && s < this.to) {
          r = s, n = this._maps[s].recover(i.recover);
          continue;
        }
      }
      l |= i.delInfo, n = i.pos;
    }
    return a ? n : new Vd(n, l, null);
  }
}
const zs = /* @__PURE__ */ Object.create(null);
class en {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return bn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(n) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(n, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let a = zs[t.stepType];
    if (!a)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return a.fromJSON(n, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(n, t) {
    if (n in zs)
      throw new RangeError("Duplicate use of step JSON ID " + n);
    return zs[n] = t, t.prototype.jsonID = n, t;
  }
}
class Dt {
  /**
  @internal
  */
  constructor(n, t) {
    this.doc = n, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(n) {
    return new Dt(n, null);
  }
  /**
  Create a failed step result.
  */
  static fail(n) {
    return new Dt(null, n);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(n, t, a, l) {
    try {
      return Dt.ok(n.replace(t, a, l));
    } catch (r) {
      if (r instanceof oi)
        return Dt.fail(r.message);
      throw r;
    }
  }
}
function _u(e, n, t) {
  let a = [];
  for (let l = 0; l < e.childCount; l++) {
    let r = e.child(l);
    r.content.size && (r = r.copy(_u(r.content, n, r))), r.isInline && (r = n(r, t, l)), a.push(r);
  }
  return Pe.fromArray(a);
}
class Sa extends en {
  /**
  Create a mark step.
  */
  constructor(n, t, a) {
    super(), this.from = n, this.to = t, this.mark = a;
  }
  apply(n) {
    let t = n.slice(this.from, this.to), a = n.resolve(this.from), l = a.node(a.sharedDepth(this.to)), r = new Je(_u(t.content, (o, i) => !o.isAtom || !i.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), l), t.openStart, t.openEnd);
    return Dt.fromReplace(n, this.from, this.to, r);
  }
  invert() {
    return new Fn(this.from, this.to, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1);
    return t.deleted && a.deleted || t.pos >= a.pos ? null : new Sa(t.pos, a.pos, this.mark);
  }
  merge(n) {
    return n instanceof Sa && n.mark.eq(this.mark) && this.from <= n.to && this.to >= n.from ? new Sa(Math.min(this.from, n.from), Math.max(this.to, n.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Sa(t.from, t.to, n.markFromJSON(t.mark));
  }
}
en.jsonID("addMark", Sa);
class Fn extends en {
  /**
  Create a mark-removing step.
  */
  constructor(n, t, a) {
    super(), this.from = n, this.to = t, this.mark = a;
  }
  apply(n) {
    let t = n.slice(this.from, this.to), a = new Je(_u(t.content, (l) => l.mark(this.mark.removeFromSet(l.marks)), n), t.openStart, t.openEnd);
    return Dt.fromReplace(n, this.from, this.to, a);
  }
  invert() {
    return new Sa(this.from, this.to, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1);
    return t.deleted && a.deleted || t.pos >= a.pos ? null : new Fn(t.pos, a.pos, this.mark);
  }
  merge(n) {
    return n instanceof Fn && n.mark.eq(this.mark) && this.from <= n.to && this.to >= n.from ? new Fn(Math.min(this.from, n.from), Math.max(this.to, n.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Fn(t.from, t.to, n.markFromJSON(t.mark));
  }
}
en.jsonID("removeMark", Fn);
class $a extends en {
  /**
  Create a node mark step.
  */
  constructor(n, t) {
    super(), this.pos = n, this.mark = t;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Dt.fail("No node at mark step's position");
    let a = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Dt.fromReplace(n, this.pos, this.pos + 1, new Je(Pe.from(a), 0, t.isLeaf ? 0 : 1));
  }
  invert(n) {
    let t = n.nodeAt(this.pos);
    if (t) {
      let a = this.mark.addToSet(t.marks);
      if (a.length == t.marks.length) {
        for (let l = 0; l < t.marks.length; l++)
          if (!t.marks[l].isInSet(a))
            return new $a(this.pos, t.marks[l]);
        return new $a(this.pos, this.mark);
      }
    }
    return new hl(this.pos, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new $a(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new $a(t.pos, n.markFromJSON(t.mark));
  }
}
en.jsonID("addNodeMark", $a);
class hl extends en {
  /**
  Create a mark-removing step.
  */
  constructor(n, t) {
    super(), this.pos = n, this.mark = t;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Dt.fail("No node at mark step's position");
    let a = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Dt.fromReplace(n, this.pos, this.pos + 1, new Je(Pe.from(a), 0, t.isLeaf ? 0 : 1));
  }
  invert(n) {
    let t = n.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new $a(this.pos, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new hl(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new hl(t.pos, n.markFromJSON(t.mark));
  }
}
en.jsonID("removeNodeMark", hl);
class Bt extends en {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(n, t, a, l = !1) {
    super(), this.from = n, this.to = t, this.slice = a, this.structure = l;
  }
  apply(n) {
    return this.structure && Nd(n, this.from, this.to) ? Dt.fail("Structure replace would overwrite content") : Dt.fromReplace(n, this.from, this.to, this.slice);
  }
  getMap() {
    return new bn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(n) {
    return new Bt(this.from, this.from + this.slice.size, n.slice(this.from, this.to));
  }
  map(n) {
    let t = n.mapResult(this.to, -1), a = this.from == this.to && Bt.MAP_BIAS < 0 ? t : n.mapResult(this.from, 1);
    return a.deletedAcross && t.deletedAcross ? null : new Bt(a.pos, Math.max(a.pos, t.pos), this.slice, this.structure);
  }
  merge(n) {
    if (!(n instanceof Bt) || n.structure || this.structure)
      return null;
    if (this.from + this.slice.size == n.from && !this.slice.openEnd && !n.slice.openStart) {
      let t = this.slice.size + n.slice.size == 0 ? Je.empty : new Je(this.slice.content.append(n.slice.content), this.slice.openStart, n.slice.openEnd);
      return new Bt(this.from, this.to + (n.to - n.from), t, this.structure);
    } else if (n.to == this.from && !this.slice.openStart && !n.slice.openEnd) {
      let t = this.slice.size + n.slice.size == 0 ? Je.empty : new Je(n.slice.content.append(this.slice.content), n.slice.openStart, this.slice.openEnd);
      return new Bt(n.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let n = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (n.slice = this.slice.toJSON()), this.structure && (n.structure = !0), n;
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Bt(t.from, t.to, Je.fromJSON(n, t.slice), !!t.structure);
  }
}
Bt.MAP_BIAS = 1;
en.jsonID("replace", Bt);
class Ht extends en {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(n, t, a, l, r, o, i = !1) {
    super(), this.from = n, this.to = t, this.gapFrom = a, this.gapTo = l, this.slice = r, this.insert = o, this.structure = i;
  }
  apply(n) {
    if (this.structure && (Nd(n, this.from, this.gapFrom) || Nd(n, this.gapTo, this.to)))
      return Dt.fail("Structure gap-replace would overwrite content");
    let t = n.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Dt.fail("Gap is not a flat range");
    let a = this.slice.insertAt(this.insert, t.content);
    return a ? Dt.fromReplace(n, this.from, this.to, a) : Dt.fail("Content does not fit in gap");
  }
  getMap() {
    return new bn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(n) {
    let t = this.gapTo - this.gapFrom;
    return new Ht(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, n.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1), l = this.from == this.gapFrom ? t.pos : n.map(this.gapFrom, -1), r = this.to == this.gapTo ? a.pos : n.map(this.gapTo, 1);
    return t.deletedAcross && a.deletedAcross || l < t.pos || r > a.pos ? null : new Ht(t.pos, a.pos, l, r, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let n = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (n.slice = this.slice.toJSON()), this.structure && (n.structure = !0), n;
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Ht(t.from, t.to, t.gapFrom, t.gapTo, Je.fromJSON(n, t.slice), t.insert, !!t.structure);
  }
}
en.jsonID("replaceAround", Ht);
function Nd(e, n, t) {
  let a = e.resolve(n), l = t - n, r = a.depth;
  for (; l > 0 && r > 0 && a.indexAfter(r) == a.node(r).childCount; )
    r--, l--;
  if (l > 0) {
    let o = a.node(r).maybeChild(a.indexAfter(r));
    for (; l > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, l--;
    }
  }
  return !1;
}
function R$(e, n, t, a) {
  let l = [], r = [], o, i;
  e.doc.nodesBetween(n, t, (s, d, u) => {
    if (!s.isInline)
      return;
    let f = s.marks;
    if (!a.isInSet(f) && u.type.allowsMarkType(a.type)) {
      let b = Math.max(d, n), h = Math.min(d + s.nodeSize, t), p = a.addToSet(f);
      for (let x = 0; x < f.length; x++)
        f[x].isInSet(p) || (o && o.to == b && o.mark.eq(f[x]) ? o.to = h : l.push(o = new Fn(b, h, f[x])));
      i && i.to == b ? i.to = h : r.push(i = new Sa(b, h, a));
    }
  }), l.forEach((s) => e.step(s)), r.forEach((s) => e.step(s));
}
function B$(e, n, t, a) {
  let l = [], r = 0;
  e.doc.nodesBetween(n, t, (o, i) => {
    if (!o.isInline)
      return;
    r++;
    let s = null;
    if (a instanceof es) {
      let d = o.marks, u;
      for (; u = a.isInSet(d); )
        (s || (s = [])).push(u), d = u.removeFromSet(d);
    } else a ? a.isInSet(o.marks) && (s = [a]) : s = o.marks;
    if (s && s.length) {
      let d = Math.min(i + o.nodeSize, t);
      for (let u = 0; u < s.length; u++) {
        let f = s[u], b;
        for (let h = 0; h < l.length; h++) {
          let p = l[h];
          p.step == r - 1 && f.eq(l[h].style) && (b = p);
        }
        b ? (b.to = d, b.step = r) : l.push({ style: f, from: Math.max(i, n), to: d, step: r });
      }
    }
  }), l.forEach((o) => e.step(new Fn(o.from, o.to, o.style)));
}
function ec(e, n, t, a = t.contentMatch, l = !0) {
  let r = e.doc.nodeAt(n), o = [], i = n + 1;
  for (let s = 0; s < r.childCount; s++) {
    let d = r.child(s), u = i + d.nodeSize, f = a.matchType(d.type);
    if (!f)
      o.push(new Bt(i, u, Je.empty));
    else {
      a = f;
      for (let b = 0; b < d.marks.length; b++)
        t.allowsMarkType(d.marks[b].type) || e.step(new Fn(i, u, d.marks[b]));
      if (l && d.isText && t.whitespace != "pre") {
        let b, h = /\r?\n|\r/g, p;
        for (; b = h.exec(d.text); )
          p || (p = new Je(Pe.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), o.push(new Bt(i + b.index, i + b.index + b[0].length, p));
      }
    }
    i = u;
  }
  if (!a.validEnd) {
    let s = a.fillBefore(Pe.empty, !0);
    e.replace(i, i, new Je(s, 0, 0));
  }
  for (let s = o.length - 1; s >= 0; s--)
    e.step(o[s]);
}
function D$(e, n, t) {
  return (n == 0 || e.canReplace(n, e.childCount)) && (t == e.childCount || e.canReplace(0, t));
}
function Ql(e) {
  let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let a = e.depth, l = 0, r = 0; ; --a) {
    let o = e.$from.node(a), i = e.$from.index(a) + l, s = e.$to.indexAfter(a) - r;
    if (a < e.depth && o.canReplace(i, s, t))
      return a;
    if (a == 0 || o.type.spec.isolating || !D$(o, i, s))
      break;
    i && (l = 1), s < o.childCount && (r = 1);
  }
  return null;
}
function M$(e, n, t) {
  let { $from: a, $to: l, depth: r } = n, o = a.before(r + 1), i = l.after(r + 1), s = o, d = i, u = Pe.empty, f = 0;
  for (let p = r, x = !1; p > t; p--)
    x || a.index(p) > 0 ? (x = !0, u = Pe.from(a.node(p).copy(u)), f++) : s--;
  let b = Pe.empty, h = 0;
  for (let p = r, x = !1; p > t; p--)
    x || l.after(p + 1) < l.end(p) ? (x = !0, b = Pe.from(l.node(p).copy(b)), h++) : d++;
  e.step(new Ht(s, d, o, i, new Je(u.append(b), f, h), u.size - f, !0));
}
function tc(e, n, t = null, a = e) {
  let l = z$(e, n), r = l && O$(a, n);
  return r ? l.map(Hf).concat({ type: n, attrs: t }).concat(r.map(Hf)) : null;
}
function Hf(e) {
  return { type: e, attrs: null };
}
function z$(e, n) {
  let { parent: t, startIndex: a, endIndex: l } = e, r = t.contentMatchAt(a).findWrapping(n);
  if (!r)
    return null;
  let o = r.length ? r[0] : n;
  return t.canReplaceWith(a, l, o) ? r : null;
}
function O$(e, n) {
  let { parent: t, startIndex: a, endIndex: l } = e, r = t.child(a), o = n.contentMatch.findWrapping(r.type);
  if (!o)
    return null;
  let s = (o.length ? o[o.length - 1] : n).contentMatch;
  for (let d = a; s && d < l; d++)
    s = s.matchType(t.child(d).type);
  return !s || !s.validEnd ? null : o;
}
function P$(e, n, t) {
  let a = Pe.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (a.size) {
      let i = t[o].type.contentMatch.matchFragment(a);
      if (!i || !i.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    a = Pe.from(t[o].type.create(t[o].attrs, a));
  }
  let l = n.start, r = n.end;
  e.step(new Ht(l, r, l, r, new Je(a, 0, 0), t.length, !0));
}
function F$(e, n, t, a, l) {
  if (!a.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let r = e.steps.length;
  e.doc.nodesBetween(n, t, (o, i) => {
    let s = typeof l == "function" ? l(o) : l;
    if (o.isTextblock && !o.hasMarkup(a, s) && V$(e.doc, e.mapping.slice(r).map(i), a)) {
      let d = null;
      if (a.schema.linebreakReplacement) {
        let h = a.whitespace == "pre", p = !!a.contentMatch.matchType(a.schema.linebreakReplacement);
        h && !p ? d = !1 : !h && p && (d = !0);
      }
      d === !1 && hm(e, o, i, r), ec(e, e.mapping.slice(r).map(i, 1), a, void 0, d === null);
      let u = e.mapping.slice(r), f = u.map(i, 1), b = u.map(i + o.nodeSize, 1);
      return e.step(new Ht(f, b, f + 1, b - 1, new Je(Pe.from(a.create(s, null, o.marks)), 0, 0), 1, !0)), d === !0 && fm(e, o, i, r), !1;
    }
  });
}
function fm(e, n, t, a) {
  n.forEach((l, r) => {
    if (l.isText) {
      let o, i = /\r?\n|\r/g;
      for (; o = i.exec(l.text); ) {
        let s = e.mapping.slice(a).map(t + 1 + r + o.index);
        e.replaceWith(s, s + 1, n.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function hm(e, n, t, a) {
  n.forEach((l, r) => {
    if (l.type == l.type.schema.linebreakReplacement) {
      let o = e.mapping.slice(a).map(t + 1 + r);
      e.replaceWith(o, o + 1, n.type.schema.text(`
`));
    }
  });
}
function V$(e, n, t) {
  let a = e.resolve(n), l = a.index();
  return a.parent.canReplaceWith(l, l + 1, t);
}
function N$(e, n, t, a, l) {
  let r = e.doc.nodeAt(n);
  if (!r)
    throw new RangeError("No node at given position");
  t || (t = r.type);
  let o = t.create(a, null, l || r.marks);
  if (r.isLeaf)
    return e.replaceWith(n, n + r.nodeSize, o);
  if (!t.validContent(r.content))
    throw new RangeError("Invalid content for node type " + t.name);
  e.step(new Ht(n, n + r.nodeSize, n + 1, n + r.nodeSize - 1, new Je(Pe.from(o), 0, 0), 1, !0));
}
function ua(e, n, t = 1, a) {
  let l = e.resolve(n), r = l.depth - t, o = a && a[a.length - 1] || l.parent;
  if (r < 0 || l.parent.type.spec.isolating || !l.parent.canReplace(l.index(), l.parent.childCount) || !o.type.validContent(l.parent.content.cutByIndex(l.index(), l.parent.childCount)))
    return !1;
  for (let d = l.depth - 1, u = t - 2; d > r; d--, u--) {
    let f = l.node(d), b = l.index(d);
    if (f.type.spec.isolating)
      return !1;
    let h = f.content.cutByIndex(b, f.childCount), p = a && a[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let x = a && a[u] || f;
    if (!f.canReplace(b + 1, f.childCount) || !x.type.validContent(h))
      return !1;
  }
  let i = l.indexAfter(r), s = a && a[0];
  return l.node(r).canReplaceWith(i, i, s ? s.type : l.node(r + 1).type);
}
function H$(e, n, t = 1, a) {
  let l = e.doc.resolve(n), r = Pe.empty, o = Pe.empty;
  for (let i = l.depth, s = l.depth - t, d = t - 1; i > s; i--, d--) {
    r = Pe.from(l.node(i).copy(r));
    let u = a && a[d];
    o = Pe.from(u ? u.type.create(u.attrs, o) : l.node(i).copy(o));
  }
  e.step(new Bt(n, n, new Je(r.append(o), t, t), !0));
}
function qa(e, n) {
  let t = e.resolve(n), a = t.index();
  return bm(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(a, a + 1);
}
function j$(e, n) {
  n.content.size || e.type.compatibleContent(n.type);
  let t = e.contentMatchAt(e.childCount), { linebreakReplacement: a } = e.type.schema;
  for (let l = 0; l < n.childCount; l++) {
    let r = n.child(l), o = r.type == a ? e.type.schema.nodes.text : r.type;
    if (t = t.matchType(o), !t || !e.type.allowsMarks(r.marks))
      return !1;
  }
  return t.validEnd;
}
function bm(e, n) {
  return !!(e && n && !e.isLeaf && j$(e, n));
}
function ts(e, n, t = -1) {
  let a = e.resolve(n);
  for (let l = a.depth; ; l--) {
    let r, o, i = a.index(l);
    if (l == a.depth ? (r = a.nodeBefore, o = a.nodeAfter) : t > 0 ? (r = a.node(l + 1), i++, o = a.node(l).maybeChild(i)) : (r = a.node(l).maybeChild(i - 1), o = a.node(l + 1)), r && !r.isTextblock && bm(r, o) && a.node(l).canReplace(i, i + 1))
      return n;
    if (l == 0)
      break;
    n = t < 0 ? a.before(l) : a.after(l);
  }
}
function W$(e, n, t) {
  let a = null, { linebreakReplacement: l } = e.doc.type.schema, r = e.doc.resolve(n - t), o = r.node().type;
  if (l && o.inlineContent) {
    let u = o.whitespace == "pre", f = !!o.contentMatch.matchType(l);
    u && !f ? a = !1 : !u && f && (a = !0);
  }
  let i = e.steps.length;
  if (a === !1) {
    let u = e.doc.resolve(n + t);
    hm(e, u.node(), u.before(), i);
  }
  o.inlineContent && ec(e, n + t - 1, o, r.node().contentMatchAt(r.index()), a == null);
  let s = e.mapping.slice(i), d = s.map(n - t);
  if (e.step(new Bt(d, s.map(n + t, -1), Je.empty, !0)), a === !0) {
    let u = e.doc.resolve(d);
    fm(e, u.node(), u.before(), e.steps.length);
  }
  return e;
}
function q$(e, n, t) {
  let a = e.resolve(n);
  if (a.parent.canReplaceWith(a.index(), a.index(), t))
    return n;
  if (a.parentOffset == 0)
    for (let l = a.depth - 1; l >= 0; l--) {
      let r = a.index(l);
      if (a.node(l).canReplaceWith(r, r, t))
        return a.before(l + 1);
      if (r > 0)
        return null;
    }
  if (a.parentOffset == a.parent.content.size)
    for (let l = a.depth - 1; l >= 0; l--) {
      let r = a.indexAfter(l);
      if (a.node(l).canReplaceWith(r, r, t))
        return a.after(l + 1);
      if (r < a.node(l).childCount)
        return null;
    }
  return null;
}
function gm(e, n, t) {
  let a = e.resolve(n);
  if (!t.content.size)
    return n;
  let l = t.content;
  for (let r = 0; r < t.openStart; r++)
    l = l.firstChild.content;
  for (let r = 1; r <= (t.openStart == 0 && t.size ? 2 : 1); r++)
    for (let o = a.depth; o >= 0; o--) {
      let i = o == a.depth ? 0 : a.pos <= (a.start(o + 1) + a.end(o + 1)) / 2 ? -1 : 1, s = a.index(o) + (i > 0 ? 1 : 0), d = a.node(o), u = !1;
      if (r == 1)
        u = d.canReplace(s, s, l);
      else {
        let f = d.contentMatchAt(s).findWrapping(l.firstChild.type);
        u = f && d.canReplaceWith(s, s, f[0]);
      }
      if (u)
        return i == 0 ? a.pos : i < 0 ? a.before(o + 1) : a.after(o + 1);
    }
  return null;
}
function ns(e, n, t = n, a = Je.empty) {
  if (n == t && !a.size)
    return null;
  let l = e.resolve(n), r = e.resolve(t);
  return mm(l, r, a) ? new Bt(n, t, a) : new U$(l, r, a).fit();
}
function mm(e, n, t) {
  return !t.openStart && !t.openEnd && e.start() == n.start() && e.parent.canReplace(e.index(), n.index(), t.content);
}
class U$ {
  constructor(n, t, a) {
    this.$from = n, this.$to = t, this.unplaced = a, this.frontier = [], this.placed = Pe.empty;
    for (let l = 0; l <= n.depth; l++) {
      let r = n.node(l);
      this.frontier.push({
        type: r.type,
        match: r.contentMatchAt(n.indexAfter(l))
      });
    }
    for (let l = n.depth; l > 0; l--)
      this.placed = Pe.from(n.node(l).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let n = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, a = this.$from, l = this.close(n < 0 ? this.$to : a.doc.resolve(n));
    if (!l)
      return null;
    let r = this.placed, o = a.depth, i = l.depth;
    for (; o && i && r.childCount == 1; )
      r = r.firstChild.content, o--, i--;
    let s = new Je(r, o, i);
    return n > -1 ? new Ht(a.pos, n, this.$to.pos, this.$to.end(), s, t) : s.size || a.pos != this.$to.pos ? new Bt(a.pos, l.pos, s) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let n = this.unplaced.openStart;
    for (let t = this.unplaced.content, a = 0, l = this.unplaced.openEnd; a < n; a++) {
      let r = t.firstChild;
      if (t.childCount > 1 && (l = 0), r.type.spec.isolating && l <= a) {
        n = a;
        break;
      }
      t = r.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let a = t == 1 ? n : this.unplaced.openStart; a >= 0; a--) {
        let l, r = null;
        a ? (r = Os(this.unplaced.content, a - 1).firstChild, l = r.content) : l = this.unplaced.content;
        let o = l.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: s, match: d } = this.frontier[i], u, f = null;
          if (t == 1 && (o ? d.matchType(o.type) || (f = d.fillBefore(Pe.from(o), !1)) : r && s.compatibleContent(r.type)))
            return { sliceDepth: a, frontierDepth: i, parent: r, inject: f };
          if (t == 2 && o && (u = d.findWrapping(o.type)))
            return { sliceDepth: a, frontierDepth: i, parent: r, wrap: u };
          if (r && d.matchType(r.type))
            break;
        }
      }
  }
  openMore() {
    let { content: n, openStart: t, openEnd: a } = this.unplaced, l = Os(n, t);
    return !l.childCount || l.firstChild.isLeaf ? !1 : (this.unplaced = new Je(n, t + 1, Math.max(a, l.size + t >= n.size - a ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: n, openStart: t, openEnd: a } = this.unplaced, l = Os(n, t);
    if (l.childCount <= 1 && t > 0) {
      let r = n.size - t <= t + l.size;
      this.unplaced = new Je(hr(n, t - 1, 1), t - 1, r ? t - 1 : a);
    } else
      this.unplaced = new Je(hr(n, t, 1), t, a);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: n, frontierDepth: t, parent: a, inject: l, wrap: r }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (r)
      for (let x = 0; x < r.length; x++)
        this.openFrontierNode(r[x]);
    let o = this.unplaced, i = a ? a.content : o.content, s = o.openStart - n, d = 0, u = [], { match: f, type: b } = this.frontier[t];
    if (l) {
      for (let x = 0; x < l.childCount; x++)
        u.push(l.child(x));
      f = f.matchFragment(l);
    }
    let h = i.size + n - (o.content.size - o.openEnd);
    for (; d < i.childCount; ) {
      let x = i.child(d), y = f.matchType(x.type);
      if (!y)
        break;
      d++, (d > 1 || s == 0 || x.content.size) && (f = y, u.push(pm(x.mark(b.allowedMarks(x.marks)), d == 1 ? s : 0, d == i.childCount ? h : -1)));
    }
    let p = d == i.childCount;
    p || (h = -1), this.placed = br(this.placed, t, Pe.from(u)), this.frontier[t].match = f, p && h < 0 && a && a.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let x = 0, y = i; x < h; x++) {
      let w = y.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), y = w.content;
    }
    this.unplaced = p ? n == 0 ? Je.empty : new Je(hr(o.content, n - 1, 1), n - 1, h < 0 ? o.openEnd : n - 1) : new Je(hr(o.content, n, d), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let n = this.frontier[this.depth], t;
    if (!n.type.isTextblock || !Ps(this.$to, this.$to.depth, n.type, n.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: a } = this.$to, l = this.$to.after(a);
    for (; a > 1 && l == this.$to.end(--a); )
      ++l;
    return l;
  }
  findCloseLevel(n) {
    e: for (let t = Math.min(this.depth, n.depth); t >= 0; t--) {
      let { match: a, type: l } = this.frontier[t], r = t < n.depth && n.end(t + 1) == n.pos + (n.depth - (t + 1)), o = Ps(n, t, l, a, r);
      if (o) {
        for (let i = t - 1; i >= 0; i--) {
          let { match: s, type: d } = this.frontier[i], u = Ps(n, i, d, s, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: r ? n.doc.resolve(n.after(t + 1)) : n };
      }
    }
  }
  close(n) {
    let t = this.findCloseLevel(n);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = br(this.placed, t.depth, t.fit)), n = t.move;
    for (let a = t.depth + 1; a <= n.depth; a++) {
      let l = n.node(a), r = l.type.contentMatch.fillBefore(l.content, !0, n.index(a));
      this.openFrontierNode(l.type, l.attrs, r);
    }
    return n;
  }
  openFrontierNode(n, t = null, a) {
    let l = this.frontier[this.depth];
    l.match = l.match.matchType(n), this.placed = br(this.placed, this.depth, Pe.from(n.create(t, a))), this.frontier.push({ type: n, match: n.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Pe.empty, !0);
    t.childCount && (this.placed = br(this.placed, this.frontier.length, t));
  }
}
function hr(e, n, t) {
  return n == 0 ? e.cutByIndex(t, e.childCount) : e.replaceChild(0, e.firstChild.copy(hr(e.firstChild.content, n - 1, t)));
}
function br(e, n, t) {
  return n == 0 ? e.append(t) : e.replaceChild(e.childCount - 1, e.lastChild.copy(br(e.lastChild.content, n - 1, t)));
}
function Os(e, n) {
  for (let t = 0; t < n; t++)
    e = e.firstChild.content;
  return e;
}
function pm(e, n, t) {
  if (n <= 0)
    return e;
  let a = e.content;
  return n > 1 && (a = a.replaceChild(0, pm(a.firstChild, n - 1, a.childCount == 1 ? t - 1 : 0))), n > 0 && (a = e.type.contentMatch.fillBefore(a).append(a), t <= 0 && (a = a.append(e.type.contentMatch.matchFragment(a).fillBefore(Pe.empty, !0)))), e.copy(a);
}
function Ps(e, n, t, a, l) {
  let r = e.node(n), o = l ? e.indexAfter(n) : e.index(n);
  if (o == r.childCount && !t.compatibleContent(r.type))
    return null;
  let i = a.fillBefore(r.content, !0, o);
  return i && !G$(t, r.content, o) ? i : null;
}
function G$(e, n, t) {
  for (let a = t; a < n.childCount; a++)
    if (!e.allowsMarks(n.child(a).marks))
      return !0;
  return !1;
}
function K$(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function Y$(e, n, t, a) {
  if (!a.size)
    return e.deleteRange(n, t);
  let l = e.doc.resolve(n), r = e.doc.resolve(t);
  if (mm(l, r, a))
    return e.step(new Bt(n, t, a));
  let o = xm(l, r);
  o[o.length - 1] == 0 && o.pop();
  let i = -(l.depth + 1);
  o.unshift(i);
  for (let b = l.depth, h = l.pos - 1; b > 0; b--, h--) {
    let p = l.node(b).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(b) > -1 ? i = b : l.before(b) == h && o.splice(1, 0, -b);
  }
  let s = o.indexOf(i), d = [], u = a.openStart;
  for (let b = a.content, h = 0; ; h++) {
    let p = b.firstChild;
    if (d.push(p), h == a.openStart)
      break;
    b = p.content;
  }
  for (let b = u - 1; b >= 0; b--) {
    let h = d[b], p = K$(h.type);
    if (p && !h.sameMarkup(l.node(Math.abs(i) - 1)))
      u = b;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let b = a.openStart; b >= 0; b--) {
    let h = (b + u + 1) % (a.openStart + 1), p = d[h];
    if (p)
      for (let x = 0; x < o.length; x++) {
        let y = o[(x + s) % o.length], w = !0;
        y < 0 && (w = !1, y = -y);
        let $ = l.node(y - 1), S = l.index(y - 1);
        if ($.canReplaceWith(S, S, p.type, p.marks))
          return e.replace(l.before(y), w ? r.after(y) : t, new Je(vm(a.content, 0, a.openStart, h), h, a.openEnd));
      }
  }
  let f = e.steps.length;
  for (let b = o.length - 1; b >= 0 && (e.replace(n, t, a), !(e.steps.length > f)); b--) {
    let h = o[b];
    h < 0 || (n = l.before(h), t = r.after(h));
  }
}
function vm(e, n, t, a, l) {
  if (n < t) {
    let r = e.firstChild;
    e = e.replaceChild(0, r.copy(vm(r.content, n + 1, t, a, r)));
  }
  if (n > a) {
    let r = l.contentMatchAt(0), o = r.fillBefore(e).append(e);
    e = o.append(r.matchFragment(o).fillBefore(Pe.empty, !0));
  }
  return e;
}
function J$(e, n, t, a) {
  if (!a.isInline && n == t && e.doc.resolve(n).parent.content.size) {
    let l = q$(e.doc, n, a.type);
    l != null && (n = t = l);
  }
  e.replaceRange(n, t, new Je(Pe.from(a), 0, 0));
}
function X$(e, n, t) {
  let a = e.doc.resolve(n), l = e.doc.resolve(t);
  if (a.parent.isTextblock && l.parent.isTextblock && a.start() != l.start() && a.parentOffset == 0 && l.parentOffset == 0) {
    let o = a.sharedDepth(t), i = !1;
    for (let s = a.depth; s > o; s--)
      a.node(s).type.spec.isolating && (i = !0);
    for (let s = l.depth; s > o; s--)
      l.node(s).type.spec.isolating && (i = !0);
    if (!i) {
      for (let s = a.depth; s > 0 && n == a.start(s); s--)
        n = a.before(s);
      for (let s = l.depth; s > 0 && t == l.start(s); s--)
        t = l.before(s);
      a = e.doc.resolve(n), l = e.doc.resolve(t);
    }
  }
  let r = xm(a, l);
  for (let o = 0; o < r.length; o++) {
    let i = r[o], s = o == r.length - 1;
    if (s && i == 0 || a.node(i).type.contentMatch.validEnd)
      return e.delete(a.start(i), l.end(i));
    if (i > 0 && (s || a.node(i - 1).canReplace(a.index(i - 1), l.indexAfter(i - 1))))
      return e.delete(a.before(i), l.after(i));
  }
  for (let o = 1; o <= a.depth && o <= l.depth; o++)
    if (n - a.start(o) == a.depth - o && t > a.end(o) && l.end(o) - t != l.depth - o && a.start(o - 1) == l.start(o - 1) && a.node(o - 1).canReplace(a.index(o - 1), l.index(o - 1)))
      return e.delete(a.before(o), t);
  e.delete(n, t);
}
function xm(e, n) {
  let t = [], a = Math.min(e.depth, n.depth);
  for (let l = a; l >= 0; l--) {
    let r = e.start(l);
    if (r < e.pos - (e.depth - l) || n.end(l) > n.pos + (n.depth - l) || e.node(l).type.spec.isolating || n.node(l).type.spec.isolating)
      break;
    (r == n.start(l) || l == e.depth && l == n.depth && e.parent.inlineContent && n.parent.inlineContent && l && n.start(l - 1) == r - 1) && t.push(l);
  }
  return t;
}
class Rl extends en {
  /**
  Construct an attribute step.
  */
  constructor(n, t, a) {
    super(), this.pos = n, this.attr = t, this.value = a;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Dt.fail("No node at attribute step's position");
    let a = /* @__PURE__ */ Object.create(null);
    for (let r in t.attrs)
      a[r] = t.attrs[r];
    a[this.attr] = this.value;
    let l = t.type.create(a, null, t.marks);
    return Dt.fromReplace(n, this.pos, this.pos + 1, new Je(Pe.from(l), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return bn.empty;
  }
  invert(n) {
    return new Rl(this.pos, this.attr, n.nodeAt(this.pos).attrs[this.attr]);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Rl(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(n, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Rl(t.pos, t.attr, t.value);
  }
}
en.jsonID("attr", Rl);
class qr extends en {
  /**
  Construct an attribute step.
  */
  constructor(n, t) {
    super(), this.attr = n, this.value = t;
  }
  apply(n) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let l in n.attrs)
      t[l] = n.attrs[l];
    t[this.attr] = this.value;
    let a = n.type.create(t, n.content, n.marks);
    return Dt.ok(a);
  }
  getMap() {
    return bn.empty;
  }
  invert(n) {
    return new qr(this.attr, n.attrs[this.attr]);
  }
  map(n) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(n, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new qr(t.attr, t.value);
  }
}
en.jsonID("docAttr", qr);
let Hl = class extends Error {
};
Hl = function e(n) {
  let t = Error.call(this, n);
  return t.__proto__ = e.prototype, t;
};
Hl.prototype = Object.create(Error.prototype);
Hl.prototype.constructor = Hl;
Hl.prototype.name = "TransformError";
class ym {
  /**
  Create a transform that starts with the given document.
  */
  constructor(n) {
    this.doc = n, this.steps = [], this.docs = [], this.mapping = new Wr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(n) {
    let t = this.maybeStep(n);
    if (t.failed)
      throw new Hl(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(n) {
    let t = n.apply(this.doc);
    return t.failed || this.addStep(n, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let n = 1e9, t = -1e9;
    for (let a = 0; a < this.mapping.maps.length; a++) {
      let l = this.mapping.maps[a];
      a && (n = l.map(n, 1), t = l.map(t, -1)), l.forEach((r, o, i, s) => {
        n = Math.min(n, i), t = Math.max(t, s);
      });
    }
    return n == 1e9 ? null : { from: n, to: t };
  }
  /**
  @internal
  */
  addStep(n, t) {
    this.docs.push(this.doc), this.steps.push(n), this.mapping.appendMap(n.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(n, t = n, a = Je.empty) {
    let l = ns(this.doc, n, t, a);
    return l && this.step(l), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(n, t, a) {
    return this.replace(n, t, new Je(Pe.from(a), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(n, t) {
    return this.replace(n, t, Je.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(n, t) {
    return this.replaceWith(n, n, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(n, t, a) {
    return Y$(this, n, t, a), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(n, t, a) {
    return J$(this, n, t, a), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(n, t) {
    return X$(this, n, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(n, t) {
    return M$(this, n, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(n, t = 1) {
    return W$(this, n, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(n, t) {
    return P$(this, n, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(n, t = n, a, l = null) {
    return F$(this, n, t, a, l), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(n, t, a = null, l) {
    return N$(this, n, t, a, l), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(n, t, a) {
    return this.step(new Rl(n, t, a)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(n, t) {
    return this.step(new qr(n, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(n, t) {
    return this.step(new $a(n, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(n, t) {
    let a = this.doc.nodeAt(n);
    if (!a)
      throw new RangeError("No node at position " + n);
    if (t instanceof vt)
      t.isInSet(a.marks) && this.step(new hl(n, t));
    else {
      let l = a.marks, r, o = [];
      for (; r = t.isInSet(l); )
        o.push(new hl(n, r)), l = r.removeFromSet(l);
      for (let i = o.length - 1; i >= 0; i--)
        this.step(o[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(n, t = 1, a) {
    return H$(this, n, t, a), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(n, t, a) {
    return R$(this, n, t, a), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(n, t, a) {
    return B$(this, n, t, a), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(n, t, a) {
    return ec(this, n, t, a), this;
  }
}
const Fs = /* @__PURE__ */ Object.create(null);
class rt {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(n, t, a) {
    this.$anchor = n, this.$head = t, this.ranges = a || [new Z$(n.min(t), n.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let n = this.ranges;
    for (let t = 0; t < n.length; t++)
      if (n[t].$from.pos != n[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(n, t = Je.empty) {
    let a = t.content.lastChild, l = null;
    for (let i = 0; i < t.openEnd; i++)
      l = a, a = a.lastChild;
    let r = n.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: s, $to: d } = o[i], u = n.mapping.slice(r);
      n.replaceRange(u.map(s.pos), u.map(d.pos), i ? Je.empty : t), i == 0 && qf(n, r, (a ? a.isInline : l && l.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(n, t) {
    let a = n.steps.length, l = this.ranges;
    for (let r = 0; r < l.length; r++) {
      let { $from: o, $to: i } = l[r], s = n.mapping.slice(a), d = s.map(o.pos), u = s.map(i.pos);
      r ? n.deleteRange(d, u) : (n.replaceRangeWith(d, u, t), qf(n, a, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(n, t, a = !1) {
    let l = n.parent.inlineContent ? new at(n) : wl(n.node(0), n.parent, n.pos, n.index(), t, a);
    if (l)
      return l;
    for (let r = n.depth - 1; r >= 0; r--) {
      let o = t < 0 ? wl(n.node(0), n.node(r), n.before(r + 1), n.index(r), t, a) : wl(n.node(0), n.node(r), n.after(r + 1), n.index(r) + 1, t, a);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(n, t = 1) {
    return this.findFrom(n, t) || this.findFrom(n, -t) || new gn(n.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(n) {
    return wl(n, n, 0, 0, 1) || new gn(n);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(n) {
    return wl(n, n, n.content.size, n.childCount, -1) || new gn(n);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(n, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let a = Fs[t.type];
    if (!a)
      throw new RangeError(`No selection type ${t.type} defined`);
    return a.fromJSON(n, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(n, t) {
    if (n in Fs)
      throw new RangeError("Duplicate use of selection JSON ID " + n);
    return Fs[n] = t, t.prototype.jsonID = n, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return at.between(this.$anchor, this.$head).getBookmark();
  }
}
rt.prototype.visible = !0;
class Z$ {
  /**
  Create a range.
  */
  constructor(n, t) {
    this.$from = n, this.$to = t;
  }
}
let jf = !1;
function Wf(e) {
  !jf && !e.parent.inlineContent && (jf = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class at extends rt {
  /**
  Construct a text selection between the given points.
  */
  constructor(n, t = n) {
    Wf(n), Wf(t), super(n, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(n, t) {
    let a = n.resolve(t.map(this.head));
    if (!a.parent.inlineContent)
      return rt.near(a);
    let l = n.resolve(t.map(this.anchor));
    return new at(l.parent.inlineContent ? l : a, a);
  }
  replace(n, t = Je.empty) {
    if (super.replace(n, t), t == Je.empty) {
      let a = this.$from.marksAcross(this.$to);
      a && n.ensureMarks(a);
    }
  }
  eq(n) {
    return n instanceof at && n.anchor == this.anchor && n.head == this.head;
  }
  getBookmark() {
    return new as(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new at(n.resolve(t.anchor), n.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(n, t, a = t) {
    let l = n.resolve(t);
    return new this(l, a == t ? l : n.resolve(a));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(n, t, a) {
    let l = n.pos - t.pos;
    if ((!a || l) && (a = l >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let r = rt.findFrom(t, a, !0) || rt.findFrom(t, -a, !0);
      if (r)
        t = r.$head;
      else
        return rt.near(t, a);
    }
    return n.parent.inlineContent || (l == 0 ? n = t : (n = (rt.findFrom(n, -a, !0) || rt.findFrom(n, a, !0)).$anchor, n.pos < t.pos != l < 0 && (n = t))), new at(n, t);
  }
}
rt.jsonID("text", at);
class as {
  constructor(n, t) {
    this.anchor = n, this.head = t;
  }
  map(n) {
    return new as(n.map(this.anchor), n.map(this.head));
  }
  resolve(n) {
    return at.between(n.resolve(this.anchor), n.resolve(this.head));
  }
}
class Qe extends rt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(n) {
    let t = n.nodeAfter, a = n.node(0).resolve(n.pos + t.nodeSize);
    super(n, a), this.node = t;
  }
  map(n, t) {
    let { deleted: a, pos: l } = t.mapResult(this.anchor), r = n.resolve(l);
    return a ? rt.near(r) : new Qe(r);
  }
  content() {
    return new Je(Pe.from(this.node), 0, 0);
  }
  eq(n) {
    return n instanceof Qe && n.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new nc(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Qe(n.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(n, t) {
    return new Qe(n.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(n) {
    return !n.isText && n.type.spec.selectable !== !1;
  }
}
Qe.prototype.visible = !1;
rt.jsonID("node", Qe);
class nc {
  constructor(n) {
    this.anchor = n;
  }
  map(n) {
    let { deleted: t, pos: a } = n.mapResult(this.anchor);
    return t ? new as(a, a) : new nc(a);
  }
  resolve(n) {
    let t = n.resolve(this.anchor), a = t.nodeAfter;
    return a && Qe.isSelectable(a) ? new Qe(t) : rt.near(t);
  }
}
class gn extends rt {
  /**
  Create an all-selection over the given document.
  */
  constructor(n) {
    super(n.resolve(0), n.resolve(n.content.size));
  }
  replace(n, t = Je.empty) {
    if (t == Je.empty) {
      n.delete(0, n.doc.content.size);
      let a = rt.atStart(n.doc);
      a.eq(n.selection) || n.setSelection(a);
    } else
      super.replace(n, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(n) {
    return new gn(n);
  }
  map(n) {
    return new gn(n);
  }
  eq(n) {
    return n instanceof gn;
  }
  getBookmark() {
    return Q$;
  }
}
rt.jsonID("all", gn);
const Q$ = {
  map() {
    return this;
  },
  resolve(e) {
    return new gn(e);
  }
};
function wl(e, n, t, a, l, r = !1) {
  if (n.inlineContent)
    return at.create(e, t);
  for (let o = a - (l > 0 ? 0 : 1); l > 0 ? o < n.childCount : o >= 0; o += l) {
    let i = n.child(o);
    if (i.isAtom) {
      if (!r && Qe.isSelectable(i))
        return Qe.create(e, t - (l < 0 ? i.nodeSize : 0));
    } else {
      let s = wl(e, i, t + l, l < 0 ? i.childCount : 0, l, r);
      if (s)
        return s;
    }
    t += i.nodeSize * l;
  }
  return null;
}
function qf(e, n, t) {
  let a = e.steps.length - 1;
  if (a < n)
    return;
  let l = e.steps[a];
  if (!(l instanceof Bt || l instanceof Ht))
    return;
  let r = e.mapping.maps[a], o;
  r.forEach((i, s, d, u) => {
    o == null && (o = u);
  }), e.setSelection(rt.near(e.doc.resolve(o), t));
}
const Uf = 1, Co = 2, Gf = 4;
class _$ extends ym {
  /**
  @internal
  */
  constructor(n) {
    super(n.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = n.selection, this.storedMarks = n.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(n) {
    if (n.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = n, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Uf) & ~Co, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Uf) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(n) {
    return this.storedMarks = n, this.updated |= Co, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(n) {
    return vt.sameSet(this.storedMarks || this.selection.$from.marks(), n) || this.setStoredMarks(n), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(n) {
    return this.ensureMarks(n.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(n) {
    return this.ensureMarks(n.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Co) > 0;
  }
  /**
  @internal
  */
  addStep(n, t) {
    super.addStep(n, t), this.updated = this.updated & ~Co, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(n) {
    return this.time = n, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(n) {
    return this.selection.replace(this, n), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(n, t = !0) {
    let a = this.selection;
    return t && (n = n.mark(this.storedMarks || (a.empty ? a.$from.marks() : a.$from.marksAcross(a.$to) || vt.none))), a.replaceWith(this, n), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(n, t, a) {
    let l = this.doc.type.schema;
    if (t == null)
      return n ? this.replaceSelectionWith(l.text(n), !0) : this.deleteSelection();
    {
      if (a == null && (a = t), !n)
        return this.deleteRange(t, a);
      let r = this.storedMarks;
      if (!r) {
        let o = this.doc.resolve(t);
        r = a == t ? o.marks() : o.marksAcross(this.doc.resolve(a));
      }
      return this.replaceRangeWith(t, a, l.text(n, r)), !this.selection.empty && this.selection.to == t + n.length && this.setSelection(rt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(n, t) {
    return this.meta[typeof n == "string" ? n : n.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(n) {
    return this.meta[typeof n == "string" ? n : n.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let n in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Gf, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Gf) > 0;
  }
}
function Kf(e, n) {
  return !n || !e ? e : e.bind(n);
}
class gr {
  constructor(n, t, a) {
    this.name = n, this.init = Kf(t.init, a), this.apply = Kf(t.apply, a);
  }
}
const eI = [
  new gr("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new gr("selection", {
    init(e, n) {
      return e.selection || rt.atStart(n.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new gr("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, n, t, a) {
      return a.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new gr("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, n) {
      return e.scrolledIntoView ? n + 1 : n;
    }
  })
];
class Vs {
  constructor(n, t) {
    this.schema = n, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = eI.slice(), t && t.forEach((a) => {
      if (this.pluginsByKey[a.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + a.key + ")");
      this.plugins.push(a), this.pluginsByKey[a.key] = a, a.spec.state && this.fields.push(new gr(a.key, a.spec.state, a));
    });
  }
}
class Il {
  /**
  @internal
  */
  constructor(n) {
    this.config = n;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(n) {
    return this.applyTransaction(n).state;
  }
  /**
  @internal
  */
  filterTransaction(n, t = -1) {
    for (let a = 0; a < this.config.plugins.length; a++)
      if (a != t) {
        let l = this.config.plugins[a];
        if (l.spec.filterTransaction && !l.spec.filterTransaction.call(l, n, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(n) {
    if (!this.filterTransaction(n))
      return { state: this, transactions: [] };
    let t = [n], a = this.applyInner(n), l = null;
    for (; ; ) {
      let r = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let i = this.config.plugins[o];
        if (i.spec.appendTransaction) {
          let s = l ? l[o].n : 0, d = l ? l[o].state : this, u = s < t.length && i.spec.appendTransaction.call(i, s ? t.slice(s) : t, d, a);
          if (u && a.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", n), !l) {
              l = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                l.push(f < o ? { state: a, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), a = a.applyInner(u), r = !0;
          }
          l && (l[o] = { state: a, n: t.length });
        }
      }
      if (!r)
        return { state: a, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(n) {
    if (!n.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Il(this.config), a = this.config.fields;
    for (let l = 0; l < a.length; l++) {
      let r = a[l];
      t[r.name] = r.apply(n, this[r.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new _$(this);
  }
  /**
  Create a new state.
  */
  static create(n) {
    let t = new Vs(n.doc ? n.doc.type.schema : n.schema, n.plugins), a = new Il(t);
    for (let l = 0; l < t.fields.length; l++)
      a[t.fields[l].name] = t.fields[l].init(n, a);
    return a;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(n) {
    let t = new Vs(this.schema, n.plugins), a = t.fields, l = new Il(t);
    for (let r = 0; r < a.length; r++) {
      let o = a[r].name;
      l[o] = this.hasOwnProperty(o) ? this[o] : a[r].init(n, l);
    }
    return l;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(n) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((a) => a.toJSON())), n && typeof n == "object")
      for (let a in n) {
        if (a == "doc" || a == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let l = n[a], r = l.spec.state;
        r && r.toJSON && (t[a] = r.toJSON.call(l, this[l.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(n, t, a) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!n.schema)
      throw new RangeError("Required config field 'schema' missing");
    let l = new Vs(n.schema, n.plugins), r = new Il(l);
    return l.fields.forEach((o) => {
      if (o.name == "doc")
        r.doc = Aa.fromJSON(n.schema, t.doc);
      else if (o.name == "selection")
        r.selection = rt.fromJSON(r.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (r.storedMarks = t.storedMarks.map(n.schema.markFromJSON));
      else {
        if (a)
          for (let i in a) {
            let s = a[i], d = s.spec.state;
            if (s.key == o.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(t, i)) {
              r[o.name] = d.fromJSON.call(s, n, t[i], r);
              return;
            }
          }
        r[o.name] = o.init(n, r);
      }
    }), r;
  }
}
function km(e, n, t) {
  for (let a in e) {
    let l = e[a];
    l instanceof Function ? l = l.bind(n) : a == "handleDOMEvents" && (l = km(l, n, {})), t[a] = l;
  }
  return t;
}
class Tt {
  /**
  Create a plugin.
  */
  constructor(n) {
    this.spec = n, this.props = {}, n.props && km(n.props, this, this.props), this.key = n.key ? n.key.key : wm("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(n) {
    return n[this.key];
  }
}
const Ns = /* @__PURE__ */ Object.create(null);
function wm(e) {
  return e in Ns ? e + "$" + ++Ns[e] : (Ns[e] = 0, e + "$");
}
class Pt {
  /**
  Create a plugin key.
  */
  constructor(n = "key") {
    this.key = wm(n);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(n) {
    return n.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(n) {
    return n[this.key];
  }
}
const Cm = (e, n) => e.selection.empty ? !1 : (n && n(e.tr.deleteSelection().scrollIntoView()), !0);
function Sm(e, n) {
  let { $cursor: t } = e.selection;
  return !t || (n ? !n.endOfTextblock("backward", e) : t.parentOffset > 0) ? null : t;
}
const $m = (e, n, t) => {
  let a = Sm(e, t);
  if (!a)
    return !1;
  let l = ac(a);
  if (!l) {
    let o = a.blockRange(), i = o && Ql(o);
    return i == null ? !1 : (n && n(e.tr.lift(o, i).scrollIntoView()), !0);
  }
  let r = l.nodeBefore;
  if (Mm(e, l, n, -1))
    return !0;
  if (a.parent.content.size == 0 && (jl(r, "end") || Qe.isSelectable(r)))
    for (let o = a.depth; ; o--) {
      let i = ns(e.doc, a.before(o), a.after(o), Je.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (n) {
          let s = e.tr.step(i);
          s.setSelection(jl(r, "end") ? rt.findFrom(s.doc.resolve(s.mapping.map(l.pos, -1)), -1) : Qe.create(s.doc, l.pos - r.nodeSize)), n(s.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || a.node(o - 1).childCount > 1)
        break;
    }
  return r.isAtom && l.depth == a.depth - 1 ? (n && n(e.tr.delete(l.pos - r.nodeSize, l.pos).scrollIntoView()), !0) : !1;
}, tI = (e, n, t) => {
  let a = Sm(e, t);
  if (!a)
    return !1;
  let l = ac(a);
  return l ? Im(e, l, n) : !1;
}, nI = (e, n, t) => {
  let a = Lm(e, t);
  if (!a)
    return !1;
  let l = lc(a);
  return l ? Im(e, l, n) : !1;
};
function Im(e, n, t) {
  let a = n.nodeBefore, l = a, r = n.pos - 1;
  for (; !l.isTextblock; r--) {
    if (l.type.spec.isolating)
      return !1;
    let u = l.lastChild;
    if (!u)
      return !1;
    l = u;
  }
  let o = n.nodeAfter, i = o, s = n.pos + 1;
  for (; !i.isTextblock; s++) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.firstChild;
    if (!u)
      return !1;
    i = u;
  }
  let d = ns(e.doc, r, s, Je.empty);
  if (!d || d.from != r || d instanceof Bt && d.slice.size >= s - r)
    return !1;
  if (t) {
    let u = e.tr.step(d);
    u.setSelection(at.create(u.doc, r)), t(u.scrollIntoView());
  }
  return !0;
}
function jl(e, n, t = !1) {
  for (let a = e; a; a = n == "start" ? a.firstChild : a.lastChild) {
    if (a.isTextblock)
      return !0;
    if (t && a.childCount != 1)
      return !1;
  }
  return !1;
}
const Tm = (e, n, t) => {
  let { $head: a, empty: l } = e.selection, r = a;
  if (!l)
    return !1;
  if (a.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", e) : a.parentOffset > 0)
      return !1;
    r = ac(a);
  }
  let o = r && r.nodeBefore;
  return !o || !Qe.isSelectable(o) ? !1 : (n && n(e.tr.setSelection(Qe.create(e.doc, r.pos - o.nodeSize)).scrollIntoView()), !0);
};
function ac(e) {
  if (!e.parent.type.spec.isolating)
    for (let n = e.depth - 1; n >= 0; n--) {
      if (e.index(n) > 0)
        return e.doc.resolve(e.before(n + 1));
      if (e.node(n).type.spec.isolating)
        break;
    }
  return null;
}
function Lm(e, n) {
  let { $cursor: t } = e.selection;
  return !t || (n ? !n.endOfTextblock("forward", e) : t.parentOffset < t.parent.content.size) ? null : t;
}
const Am = (e, n, t) => {
  let a = Lm(e, t);
  if (!a)
    return !1;
  let l = lc(a);
  if (!l)
    return !1;
  let r = l.nodeAfter;
  if (Mm(e, l, n, 1))
    return !0;
  if (a.parent.content.size == 0 && (jl(r, "start") || Qe.isSelectable(r))) {
    let o = ns(e.doc, a.before(), a.after(), Je.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (n) {
        let i = e.tr.step(o);
        i.setSelection(jl(r, "start") ? rt.findFrom(i.doc.resolve(i.mapping.map(l.pos)), 1) : Qe.create(i.doc, i.mapping.map(l.pos))), n(i.scrollIntoView());
      }
      return !0;
    }
  }
  return r.isAtom && l.depth == a.depth - 1 ? (n && n(e.tr.delete(l.pos, l.pos + r.nodeSize).scrollIntoView()), !0) : !1;
}, Em = (e, n, t) => {
  let { $head: a, empty: l } = e.selection, r = a;
  if (!l)
    return !1;
  if (a.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", e) : a.parentOffset < a.parent.content.size)
      return !1;
    r = lc(a);
  }
  let o = r && r.nodeAfter;
  return !o || !Qe.isSelectable(o) ? !1 : (n && n(e.tr.setSelection(Qe.create(e.doc, r.pos)).scrollIntoView()), !0);
};
function lc(e) {
  if (!e.parent.type.spec.isolating)
    for (let n = e.depth - 1; n >= 0; n--) {
      let t = e.node(n);
      if (e.index(n) + 1 < t.childCount)
        return e.doc.resolve(e.after(n + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const aI = (e, n) => {
  let t = e.selection, a = t instanceof Qe, l;
  if (a) {
    if (t.node.isTextblock || !qa(e.doc, t.from))
      return !1;
    l = t.from;
  } else if (l = ts(e.doc, t.from, -1), l == null)
    return !1;
  if (n) {
    let r = e.tr.join(l);
    a && r.setSelection(Qe.create(r.doc, l - e.doc.resolve(l).nodeBefore.nodeSize)), n(r.scrollIntoView());
  }
  return !0;
}, lI = (e, n) => {
  let t = e.selection, a;
  if (t instanceof Qe) {
    if (t.node.isTextblock || !qa(e.doc, t.to))
      return !1;
    a = t.to;
  } else if (a = ts(e.doc, t.to, 1), a == null)
    return !1;
  return n && n(e.tr.join(a).scrollIntoView()), !0;
}, rI = (e, n) => {
  let { $from: t, $to: a } = e.selection, l = t.blockRange(a), r = l && Ql(l);
  return r == null ? !1 : (n && n(e.tr.lift(l, r).scrollIntoView()), !0);
}, Rm = (e, n) => {
  let { $head: t, $anchor: a } = e.selection;
  return !t.parent.type.spec.code || !t.sameParent(a) ? !1 : (n && n(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function rc(e) {
  for (let n = 0; n < e.edgeCount; n++) {
    let { type: t } = e.edge(n);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const oI = (e, n) => {
  let { $head: t, $anchor: a } = e.selection;
  if (!t.parent.type.spec.code || !t.sameParent(a))
    return !1;
  let l = t.node(-1), r = t.indexAfter(-1), o = rc(l.contentMatchAt(r));
  if (!o || !l.canReplaceWith(r, r, o))
    return !1;
  if (n) {
    let i = t.after(), s = e.tr.replaceWith(i, i, o.createAndFill());
    s.setSelection(rt.near(s.doc.resolve(i), 1)), n(s.scrollIntoView());
  }
  return !0;
}, Bm = (e, n) => {
  let t = e.selection, { $from: a, $to: l } = t;
  if (t instanceof gn || a.parent.inlineContent || l.parent.inlineContent)
    return !1;
  let r = rc(l.parent.contentMatchAt(l.indexAfter()));
  if (!r || !r.isTextblock)
    return !1;
  if (n) {
    let o = (!a.parentOffset && l.index() < l.parent.childCount ? a : l).pos, i = e.tr.insert(o, r.createAndFill());
    i.setSelection(at.create(i.doc, o + 1)), n(i.scrollIntoView());
  }
  return !0;
}, Dm = (e, n) => {
  let { $cursor: t } = e.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let r = t.before();
    if (ua(e.doc, r))
      return n && n(e.tr.split(r).scrollIntoView()), !0;
  }
  let a = t.blockRange(), l = a && Ql(a);
  return l == null ? !1 : (n && n(e.tr.lift(a, l).scrollIntoView()), !0);
};
function iI(e) {
  return (n, t) => {
    let { $from: a, $to: l } = n.selection;
    if (n.selection instanceof Qe && n.selection.node.isBlock)
      return !a.parentOffset || !ua(n.doc, a.pos) ? !1 : (t && t(n.tr.split(a.pos).scrollIntoView()), !0);
    if (!a.depth)
      return !1;
    let r = [], o, i, s = !1, d = !1;
    for (let h = a.depth; ; h--)
      if (a.node(h).isBlock) {
        s = a.end(h) == a.pos + (a.depth - h), d = a.start(h) == a.pos - (a.depth - h), i = rc(a.node(h - 1).contentMatchAt(a.indexAfter(h - 1))), r.unshift(s && i ? { type: i } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        r.unshift(null);
      }
    let u = n.tr;
    (n.selection instanceof at || n.selection instanceof gn) && u.deleteSelection();
    let f = u.mapping.map(a.pos), b = ua(u.doc, f, r.length, r);
    if (b || (r[0] = i ? { type: i } : null, b = ua(u.doc, f, r.length, r)), !b)
      return !1;
    if (u.split(f, r.length, r), !s && d && a.node(o).type != i) {
      let h = u.mapping.map(a.before(o)), p = u.doc.resolve(h);
      i && a.node(o - 1).canReplaceWith(p.index(), p.index() + 1, i) && u.setNodeMarkup(u.mapping.map(a.before(o)), i);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const sI = iI(), dI = (e, n) => {
  let { $from: t, to: a } = e.selection, l, r = t.sharedDepth(a);
  return r == 0 ? !1 : (l = t.before(r), n && n(e.tr.setSelection(Qe.create(e.doc, l))), !0);
};
function uI(e, n, t) {
  let a = n.nodeBefore, l = n.nodeAfter, r = n.index();
  return !a || !l || !a.type.compatibleContent(l.type) ? !1 : !a.content.size && n.parent.canReplace(r - 1, r) ? (t && t(e.tr.delete(n.pos - a.nodeSize, n.pos).scrollIntoView()), !0) : !n.parent.canReplace(r, r + 1) || !(l.isTextblock || qa(e.doc, n.pos)) ? !1 : (t && t(e.tr.join(n.pos).scrollIntoView()), !0);
}
function Mm(e, n, t, a) {
  let l = n.nodeBefore, r = n.nodeAfter, o, i, s = l.type.spec.isolating || r.type.spec.isolating;
  if (!s && uI(e, n, t))
    return !0;
  let d = !s && n.parent.canReplace(n.index(), n.index() + 1);
  if (d && (o = (i = l.contentMatchAt(l.childCount)).findWrapping(r.type)) && i.matchType(o[0] || r.type).validEnd) {
    if (t) {
      let h = n.pos + r.nodeSize, p = Pe.empty;
      for (let w = o.length - 1; w >= 0; w--)
        p = Pe.from(o[w].create(null, p));
      p = Pe.from(l.copy(p));
      let x = e.tr.step(new Ht(n.pos - 1, h, n.pos, h, new Je(p, 1, 0), o.length, !0)), y = x.doc.resolve(h + 2 * o.length);
      y.nodeAfter && y.nodeAfter.type == l.type && qa(x.doc, y.pos) && x.join(y.pos), t(x.scrollIntoView());
    }
    return !0;
  }
  let u = r.type.spec.isolating || a > 0 && s ? null : rt.findFrom(n, 1), f = u && u.$from.blockRange(u.$to), b = f && Ql(f);
  if (b != null && b >= n.depth)
    return t && t(e.tr.lift(f, b).scrollIntoView()), !0;
  if (d && jl(r, "start", !0) && jl(l, "end")) {
    let h = l, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let x = r, y = 1;
    for (; !x.isTextblock; x = x.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, x.content)) {
      if (t) {
        let w = Pe.empty;
        for (let S = p.length - 1; S >= 0; S--)
          w = Pe.from(p[S].copy(w));
        let $ = e.tr.step(new Ht(n.pos - p.length, n.pos + r.nodeSize, n.pos + y, n.pos + r.nodeSize - y, new Je(w, p.length, 0), 0, !0));
        t($.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function zm(e) {
  return function(n, t) {
    let a = n.selection, l = e < 0 ? a.$from : a.$to, r = l.depth;
    for (; l.node(r).isInline; ) {
      if (!r)
        return !1;
      r--;
    }
    return l.node(r).isTextblock ? (t && t(n.tr.setSelection(at.create(n.doc, e < 0 ? l.start(r) : l.end(r)))), !0) : !1;
  };
}
const cI = zm(-1), fI = zm(1);
function hI(e, n = null) {
  return function(t, a) {
    let { $from: l, $to: r } = t.selection, o = l.blockRange(r), i = o && tc(o, e, n);
    return i ? (a && a(t.tr.wrap(o, i).scrollIntoView()), !0) : !1;
  };
}
function Yf(e, n = null) {
  return function(t, a) {
    let l = !1;
    for (let r = 0; r < t.selection.ranges.length && !l; r++) {
      let { $from: { pos: o }, $to: { pos: i } } = t.selection.ranges[r];
      t.doc.nodesBetween(o, i, (s, d) => {
        if (l)
          return !1;
        if (!(!s.isTextblock || s.hasMarkup(e, n)))
          if (s.type == e)
            l = !0;
          else {
            let u = t.doc.resolve(d), f = u.index();
            l = u.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!l)
      return !1;
    if (a) {
      let r = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: i }, $to: { pos: s } } = t.selection.ranges[o];
        r.setBlockType(i, s, e, n);
      }
      a(r.scrollIntoView());
    }
    return !0;
  };
}
function oc(...e) {
  return function(n, t, a) {
    for (let l = 0; l < e.length; l++)
      if (e[l](n, t, a))
        return !0;
    return !1;
  };
}
oc(Cm, $m, Tm);
oc(Cm, Am, Em);
oc(Rm, Bm, Dm, sI);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function bI(e, n = null) {
  return function(t, a) {
    let { $from: l, $to: r } = t.selection, o = l.blockRange(r);
    if (!o)
      return !1;
    let i = a ? t.tr : null;
    return gI(i, o, e, n) ? (a && a(i.scrollIntoView()), !0) : !1;
  };
}
function gI(e, n, t, a = null) {
  let l = !1, r = n, o = n.$from.doc;
  if (n.depth >= 2 && n.$from.node(n.depth - 1).type.compatibleContent(t) && n.startIndex == 0) {
    if (n.$from.index(n.depth - 1) == 0)
      return !1;
    let s = o.resolve(n.start - 2);
    r = new si(s, s, n.depth), n.endIndex < n.parent.childCount && (n = new si(n.$from, o.resolve(n.$to.end(n.depth)), n.depth)), l = !0;
  }
  let i = tc(r, t, a, n);
  return i ? (e && mI(e, n, i, l, t), !0) : !1;
}
function mI(e, n, t, a, l) {
  let r = Pe.empty;
  for (let u = t.length - 1; u >= 0; u--)
    r = Pe.from(t[u].type.create(t[u].attrs, r));
  e.step(new Ht(n.start - (a ? 2 : 0), n.end, n.start, n.end, new Je(r, 0, 0), t.length, !0));
  let o = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == l && (o = u + 1);
  let i = t.length - o, s = n.start + t.length - (a ? 2 : 0), d = n.parent;
  for (let u = n.startIndex, f = n.endIndex, b = !0; u < f; u++, b = !1)
    !b && ua(e.doc, s, i) && (e.split(s, i), s += 2 * i), s += d.child(u).nodeSize;
  return e;
}
function pI(e) {
  return function(n, t) {
    let { $from: a, $to: l } = n.selection, r = a.blockRange(l, (o) => o.childCount > 0 && o.firstChild.type == e);
    return r ? t ? a.node(r.depth - 1).type == e ? vI(n, t, e, r) : xI(n, t, r) : !0 : !1;
  };
}
function vI(e, n, t, a) {
  let l = e.tr, r = a.end, o = a.$to.end(a.depth);
  r < o && (l.step(new Ht(r - 1, o, r, o, new Je(Pe.from(t.create(null, a.parent.copy())), 1, 0), 1, !0)), a = new si(l.doc.resolve(a.$from.pos), l.doc.resolve(o), a.depth));
  const i = Ql(a);
  if (i == null)
    return !1;
  l.lift(a, i);
  let s = l.doc.resolve(l.mapping.map(r, -1) - 1);
  return qa(l.doc, s.pos) && s.nodeBefore.type == s.nodeAfter.type && l.join(s.pos), n(l.scrollIntoView()), !0;
}
function xI(e, n, t) {
  let a = e.tr, l = t.parent;
  for (let h = t.end, p = t.endIndex - 1, x = t.startIndex; p > x; p--)
    h -= l.child(p).nodeSize, a.delete(h - 1, h + 1);
  let r = a.doc.resolve(t.start), o = r.nodeAfter;
  if (a.mapping.map(t.end) != t.start + r.nodeAfter.nodeSize)
    return !1;
  let i = t.startIndex == 0, s = t.endIndex == l.childCount, d = r.node(-1), u = r.index(-1);
  if (!d.canReplace(u + (i ? 0 : 1), u + 1, o.content.append(s ? Pe.empty : Pe.from(l))))
    return !1;
  let f = r.pos, b = f + o.nodeSize;
  return a.step(new Ht(f - (i ? 1 : 0), b + (s ? 1 : 0), f + 1, b - 1, new Je((i ? Pe.empty : Pe.from(l.copy(Pe.empty))).append(s ? Pe.empty : Pe.from(l.copy(Pe.empty))), i ? 0 : 1, s ? 0 : 1), i ? 0 : 1)), n(a.scrollIntoView()), !0;
}
function yI(e) {
  return function(n, t) {
    let { $from: a, $to: l } = n.selection, r = a.blockRange(l, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!r)
      return !1;
    let o = r.startIndex;
    if (o == 0)
      return !1;
    let i = r.parent, s = i.child(o - 1);
    if (s.type != e)
      return !1;
    if (t) {
      let d = s.lastChild && s.lastChild.type == i.type, u = Pe.from(d ? e.create() : null), f = new Je(Pe.from(e.create(null, Pe.from(i.type.create(null, u)))), d ? 3 : 1, 0), b = r.start, h = r.end;
      t(n.tr.step(new Ht(b - (d ? 3 : 1), h, b, h, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const qt = function(e) {
  for (var n = 0; ; n++)
    if (e = e.previousSibling, !e)
      return n;
}, Wl = function(e) {
  let n = e.assignedSlot || e.parentNode;
  return n && n.nodeType == 11 ? n.host : n;
};
let Hd = null;
const oa = function(e, n, t) {
  let a = Hd || (Hd = document.createRange());
  return a.setEnd(e, t ?? e.nodeValue.length), a.setStart(e, n || 0), a;
}, kI = function() {
  Hd = null;
}, bl = function(e, n, t, a) {
  return t && (Jf(e, n, t, a, -1) || Jf(e, n, t, a, 1));
}, wI = /^(img|br|input|textarea|hr)$/i;
function Jf(e, n, t, a, l) {
  for (var r; ; ) {
    if (e == t && n == a)
      return !0;
    if (n == (l < 0 ? 0 : kn(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || oo(e) || wI.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      n = qt(e) + (l < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      let o = e.childNodes[n + (l < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((r = o.pmViewDesc) === null || r === void 0) && r.ignoreForSelection)
          n += l;
        else
          return !1;
      else
        e = o, n = l < 0 ? kn(e) : 0;
    } else
      return !1;
  }
}
function kn(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function CI(e, n) {
  for (; ; ) {
    if (e.nodeType == 3 && n)
      return e;
    if (e.nodeType == 1 && n > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[n - 1], n = kn(e);
    } else if (e.parentNode && !oo(e))
      n = qt(e), e = e.parentNode;
    else
      return null;
  }
}
function SI(e, n) {
  for (; ; ) {
    if (e.nodeType == 3 && n < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && n < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[n], n = 0;
    } else if (e.parentNode && !oo(e))
      n = qt(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function $I(e, n, t) {
  for (let a = n == 0, l = n == kn(e); a || l; ) {
    if (e == t)
      return !0;
    let r = qt(e);
    if (e = e.parentNode, !e)
      return !1;
    a = a && r == 0, l = l && r == kn(e);
  }
}
function oo(e) {
  let n;
  for (let t = e; t && !(n = t.pmViewDesc); t = t.parentNode)
    ;
  return n && n.node && n.node.isBlock && (n.dom == e || n.contentDOM == e);
}
const ls = function(e) {
  return e.focusNode && bl(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function Xa(e, n) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = e, t.key = t.code = n, t;
}
function II(e) {
  let n = e.activeElement;
  for (; n && n.shadowRoot; )
    n = n.shadowRoot.activeElement;
  return n;
}
function TI(e, n, t) {
  if (e.caretPositionFromPoint)
    try {
      let a = e.caretPositionFromPoint(n, t);
      if (a)
        return { node: a.offsetNode, offset: Math.min(kn(a.offsetNode), a.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let a = e.caretRangeFromPoint(n, t);
    if (a)
      return { node: a.startContainer, offset: Math.min(kn(a.startContainer), a.startOffset) };
  }
}
const _n = typeof navigator < "u" ? navigator : null, Xf = typeof document < "u" ? document : null, Ua = _n && _n.userAgent || "", jd = /Edge\/(\d+)/.exec(Ua), Om = /MSIE \d/.exec(Ua), Wd = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ua), cn = !!(Om || Wd || jd), Ra = Om ? document.documentMode : Wd ? +Wd[1] : jd ? +jd[1] : 0, Tn = !cn && /gecko\/(\d+)/i.test(Ua);
Tn && +(/Firefox\/(\d+)/.exec(Ua) || [0, 0])[1];
const qd = !cn && /Chrome\/(\d+)/.exec(Ua), Gt = !!qd, Pm = qd ? +qd[1] : 0, _t = !cn && !!_n && /Apple Computer/.test(_n.vendor), ql = _t && (/Mobile\/\w+/.test(Ua) || !!_n && _n.maxTouchPoints > 2), yn = ql || (_n ? /Mac/.test(_n.platform) : !1), Fm = _n ? /Win/.test(_n.platform) : !1, da = /Android \d/.test(Ua), io = !!Xf && "webkitFontSmoothing" in Xf.documentElement.style, LI = io ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function AI(e) {
  let n = e.defaultView && e.defaultView.visualViewport;
  return n ? {
    left: 0,
    right: n.width,
    top: 0,
    bottom: n.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function na(e, n) {
  return typeof e == "number" ? e : e[n];
}
function EI(e) {
  let n = e.getBoundingClientRect(), t = n.width / e.offsetWidth || 1, a = n.height / e.offsetHeight || 1;
  return {
    left: n.left,
    right: n.left + e.clientWidth * t,
    top: n.top,
    bottom: n.top + e.clientHeight * a
  };
}
function Zf(e, n, t) {
  let a = e.someProp("scrollThreshold") || 0, l = e.someProp("scrollMargin") || 5, r = e.dom.ownerDocument;
  for (let o = t || e.dom; o; ) {
    if (o.nodeType != 1) {
      o = Wl(o);
      continue;
    }
    let i = o, s = i == r.body, d = s ? AI(r) : EI(i), u = 0, f = 0;
    if (n.top < d.top + na(a, "top") ? f = -(d.top - n.top + na(l, "top")) : n.bottom > d.bottom - na(a, "bottom") && (f = n.bottom - n.top > d.bottom - d.top ? n.top + na(l, "top") - d.top : n.bottom - d.bottom + na(l, "bottom")), n.left < d.left + na(a, "left") ? u = -(d.left - n.left + na(l, "left")) : n.right > d.right - na(a, "right") && (u = n.right - d.right + na(l, "right")), u || f)
      if (s)
        r.defaultView.scrollBy(u, f);
      else {
        let h = i.scrollLeft, p = i.scrollTop;
        f && (i.scrollTop += f), u && (i.scrollLeft += u);
        let x = i.scrollLeft - h, y = i.scrollTop - p;
        n = { left: n.left - x, top: n.top - y, right: n.right - x, bottom: n.bottom - y };
      }
    let b = s ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(b))
      break;
    o = b == "absolute" ? o.offsetParent : Wl(o);
  }
}
function RI(e) {
  let n = e.dom.getBoundingClientRect(), t = Math.max(0, n.top), a, l;
  for (let r = (n.left + n.right) / 2, o = t + 1; o < Math.min(innerHeight, n.bottom); o += 5) {
    let i = e.root.elementFromPoint(r, o);
    if (!i || i == e.dom || !e.dom.contains(i))
      continue;
    let s = i.getBoundingClientRect();
    if (s.top >= t - 20) {
      a = i, l = s.top;
      break;
    }
  }
  return { refDOM: a, refTop: l, stack: Vm(e.dom) };
}
function Vm(e) {
  let n = [], t = e.ownerDocument;
  for (let a = e; a && (n.push({ dom: a, top: a.scrollTop, left: a.scrollLeft }), e != t); a = Wl(a))
    ;
  return n;
}
function BI({ refDOM: e, refTop: n, stack: t }) {
  let a = e ? e.getBoundingClientRect().top : 0;
  Nm(t, a == 0 ? 0 : a - n);
}
function Nm(e, n) {
  for (let t = 0; t < e.length; t++) {
    let { dom: a, top: l, left: r } = e[t];
    a.scrollTop != l + n && (a.scrollTop = l + n), a.scrollLeft != r && (a.scrollLeft = r);
  }
}
let vl = null;
function DI(e) {
  if (e.setActive)
    return e.setActive();
  if (vl)
    return e.focus(vl);
  let n = Vm(e);
  e.focus(vl == null ? {
    get preventScroll() {
      return vl = { preventScroll: !0 }, !0;
    }
  } : void 0), vl || (vl = !1, Nm(n, 0));
}
function Hm(e, n) {
  let t, a = 2e8, l, r = 0, o = n.top, i = n.top, s, d;
  for (let u = e.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let b;
    if (u.nodeType == 1)
      b = u.getClientRects();
    else if (u.nodeType == 3)
      b = oa(u).getClientRects();
    else
      continue;
    for (let h = 0; h < b.length; h++) {
      let p = b[h];
      if (p.top <= o && p.bottom >= i) {
        o = Math.max(p.bottom, o), i = Math.min(p.top, i);
        let x = p.left > n.left ? p.left - n.left : p.right < n.left ? n.left - p.right : 0;
        if (x < a) {
          t = u, a = x, l = x && t.nodeType == 3 ? {
            left: p.right < n.left ? p.right : p.left,
            top: n.top
          } : n, u.nodeType == 1 && x && (r = f + (n.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > n.top && !s && p.left <= n.left && p.right >= n.left && (s = u, d = { left: Math.max(p.left, Math.min(p.right, n.left)), top: p.top });
      !t && (n.left >= p.right && n.top >= p.top || n.left >= p.left && n.top >= p.bottom) && (r = f + 1);
    }
  }
  return !t && s && (t = s, l = d, a = 0), t && t.nodeType == 3 ? MI(t, l) : !t || a && t.nodeType == 1 ? { node: e, offset: r } : Hm(t, l);
}
function MI(e, n) {
  let t = e.nodeValue.length, a = document.createRange(), l;
  for (let r = 0; r < t; r++) {
    a.setEnd(e, r + 1), a.setStart(e, r);
    let o = va(a, 1);
    if (o.top != o.bottom && ic(n, o)) {
      l = { node: e, offset: r + (n.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return a.detach(), l || { node: e, offset: 0 };
}
function ic(e, n) {
  return e.left >= n.left - 1 && e.left <= n.right + 1 && e.top >= n.top - 1 && e.top <= n.bottom + 1;
}
function zI(e, n) {
  let t = e.parentNode;
  return t && /^li$/i.test(t.nodeName) && n.left < e.getBoundingClientRect().left ? t : e;
}
function OI(e, n, t) {
  let { node: a, offset: l } = Hm(n, t), r = -1;
  if (a.nodeType == 1 && !a.firstChild) {
    let o = a.getBoundingClientRect();
    r = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(a, l, r);
}
function PI(e, n, t, a) {
  let l = -1;
  for (let r = n, o = !1; r != e.dom; ) {
    let i = e.docView.nearestDesc(r, !0), s;
    if (!i)
      return null;
    if (i.dom.nodeType == 1 && (i.node.isBlock && i.parent || !i.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((s = i.dom.getBoundingClientRect()).width || s.height) && (i.node.isBlock && i.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(i.dom.nodeName) && (!o && s.left > a.left || s.top > a.top ? l = i.posBefore : (!o && s.right < a.left || s.bottom < a.top) && (l = i.posAfter), o = !0), !i.contentDOM && l < 0 && !i.node.isText))
      return (i.node.isBlock ? a.top < (s.top + s.bottom) / 2 : a.left < (s.left + s.right) / 2) ? i.posBefore : i.posAfter;
    r = i.dom.parentNode;
  }
  return l > -1 ? l : e.docView.posFromDOM(n, t, -1);
}
function jm(e, n, t) {
  let a = e.childNodes.length;
  if (a && t.top < t.bottom)
    for (let l = Math.max(0, Math.min(a - 1, Math.floor(a * (n.top - t.top) / (t.bottom - t.top)) - 2)), r = l; ; ) {
      let o = e.childNodes[r];
      if (o.nodeType == 1) {
        let i = o.getClientRects();
        for (let s = 0; s < i.length; s++) {
          let d = i[s];
          if (ic(n, d))
            return jm(o, n, d);
        }
      }
      if ((r = (r + 1) % a) == l)
        break;
    }
  return e;
}
function FI(e, n) {
  let t = e.dom.ownerDocument, a, l = 0, r = TI(t, n.left, n.top);
  r && ({ node: a, offset: l } = r);
  let o = (e.root.elementFromPoint ? e.root : t).elementFromPoint(n.left, n.top), i;
  if (!o || !e.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let d = e.dom.getBoundingClientRect();
    if (!ic(n, d) || (o = jm(e.dom, n, d), !o))
      return null;
  }
  if (_t)
    for (let d = o; a && d; d = Wl(d))
      d.draggable && (a = void 0);
  if (o = zI(o, n), a) {
    if (Tn && a.nodeType == 1 && (l = Math.min(l, a.childNodes.length), l < a.childNodes.length)) {
      let u = a.childNodes[l], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= n.left && f.bottom > n.top && l++;
    }
    let d;
    io && l && a.nodeType == 1 && (d = a.childNodes[l - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= n.top && l--, a == e.dom && l == a.childNodes.length - 1 && a.lastChild.nodeType == 1 && n.top > a.lastChild.getBoundingClientRect().bottom ? i = e.state.doc.content.size : (l == 0 || a.nodeType != 1 || a.childNodes[l - 1].nodeName != "BR") && (i = PI(e, a, l, n));
  }
  i == null && (i = OI(e, o, n));
  let s = e.docView.nearestDesc(o, !0);
  return { pos: i, inside: s ? s.posAtStart - s.border : -1 };
}
function Qf(e) {
  return e.top < e.bottom || e.left < e.right;
}
function va(e, n) {
  let t = e.getClientRects();
  if (t.length) {
    let a = t[n < 0 ? 0 : t.length - 1];
    if (Qf(a))
      return a;
  }
  return Array.prototype.find.call(t, Qf) || e.getBoundingClientRect();
}
const VI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Wm(e, n, t) {
  let { node: a, offset: l, atom: r } = e.docView.domFromPos(n, t < 0 ? -1 : 1), o = io || Tn;
  if (a.nodeType == 3)
    if (o && (VI.test(a.nodeValue) || (t < 0 ? !l : l == a.nodeValue.length))) {
      let s = va(oa(a, l, l), t);
      if (Tn && l && /\s/.test(a.nodeValue[l - 1]) && l < a.nodeValue.length) {
        let d = va(oa(a, l - 1, l - 1), -1);
        if (d.top == s.top) {
          let u = va(oa(a, l, l + 1), -1);
          if (u.top != s.top)
            return lr(u, u.left < d.left);
        }
      }
      return s;
    } else {
      let s = l, d = l, u = t < 0 ? 1 : -1;
      return t < 0 && !l ? (d++, u = -1) : t >= 0 && l == a.nodeValue.length ? (s--, u = 1) : t < 0 ? s-- : d++, lr(va(oa(a, s, d), u), u < 0);
    }
  if (!e.state.doc.resolve(n - (r || 0)).parent.inlineContent) {
    if (r == null && l && (t < 0 || l == kn(a))) {
      let s = a.childNodes[l - 1];
      if (s.nodeType == 1)
        return Hs(s.getBoundingClientRect(), !1);
    }
    if (r == null && l < kn(a)) {
      let s = a.childNodes[l];
      if (s.nodeType == 1)
        return Hs(s.getBoundingClientRect(), !0);
    }
    return Hs(a.getBoundingClientRect(), t >= 0);
  }
  if (r == null && l && (t < 0 || l == kn(a))) {
    let s = a.childNodes[l - 1], d = s.nodeType == 3 ? oa(s, kn(s) - (o ? 0 : 1)) : s.nodeType == 1 && (s.nodeName != "BR" || !s.nextSibling) ? s : null;
    if (d)
      return lr(va(d, 1), !1);
  }
  if (r == null && l < kn(a)) {
    let s = a.childNodes[l];
    for (; s.pmViewDesc && s.pmViewDesc.ignoreForCoords; )
      s = s.nextSibling;
    let d = s ? s.nodeType == 3 ? oa(s, 0, o ? 0 : 1) : s.nodeType == 1 ? s : null : null;
    if (d)
      return lr(va(d, -1), !0);
  }
  return lr(va(a.nodeType == 3 ? oa(a) : a, -t), t >= 0);
}
function lr(e, n) {
  if (e.width == 0)
    return e;
  let t = n ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: t, right: t };
}
function Hs(e, n) {
  if (e.height == 0)
    return e;
  let t = n ? e.top : e.bottom;
  return { top: t, bottom: t, left: e.left, right: e.right };
}
function qm(e, n, t) {
  let a = e.state, l = e.root.activeElement;
  a != n && e.updateState(n), l != e.dom && e.focus();
  try {
    return t();
  } finally {
    a != n && e.updateState(a), l != e.dom && l && l.focus();
  }
}
function NI(e, n, t) {
  let a = n.selection, l = t == "up" ? a.$from : a.$to;
  return qm(e, n, () => {
    let { node: r } = e.docView.domFromPos(l.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let i = e.docView.nearestDesc(r, !0);
      if (!i)
        break;
      if (i.node.isBlock) {
        r = i.contentDOM || i.dom;
        break;
      }
      r = i.dom.parentNode;
    }
    let o = Wm(e, l.pos, 1);
    for (let i = r.firstChild; i; i = i.nextSibling) {
      let s;
      if (i.nodeType == 1)
        s = i.getClientRects();
      else if (i.nodeType == 3)
        s = oa(i, 0, i.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < s.length; d++) {
        let u = s[d];
        if (u.bottom > u.top + 1 && (t == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const HI = /[\u0590-\u08ac]/;
function jI(e, n, t) {
  let { $head: a } = n.selection;
  if (!a.parent.isTextblock)
    return !1;
  let l = a.parentOffset, r = !l, o = l == a.parent.content.size, i = e.domSelection();
  return i ? !HI.test(a.parent.textContent) || !i.modify ? t == "left" || t == "backward" ? r : o : qm(e, n, () => {
    let { focusNode: s, focusOffset: d, anchorNode: u, anchorOffset: f } = e.domSelectionRange(), b = i.caretBidiLevel;
    i.modify("move", t, "character");
    let h = a.depth ? e.docView.domAfterPos(a.before()) : e.dom, { focusNode: p, focusOffset: x } = e.domSelectionRange(), y = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || s == p && d == x;
    try {
      i.collapse(u, f), s && (s != u || d != f) && i.extend && i.extend(s, d);
    } catch {
    }
    return b != null && (i.caretBidiLevel = b), y;
  }) : a.pos == a.start() || a.pos == a.end();
}
let _f = null, eh = null, th = !1;
function WI(e, n, t) {
  return _f == n && eh == t ? th : (_f = n, eh = t, th = t == "up" || t == "down" ? NI(e, n, t) : jI(e, n, t));
}
const Ln = 0, nh = 1, Za = 2, ea = 3;
class so {
  constructor(n, t, a, l) {
    this.parent = n, this.children = t, this.dom = a, this.contentDOM = l, this.dirty = Ln, a.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(n) {
    return !1;
  }
  matchesMark(n) {
    return !1;
  }
  matchesNode(n, t, a) {
    return !1;
  }
  matchesHack(n) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(n) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let n = 0;
    for (let t = 0; t < this.children.length; t++)
      n += this.children[t].size;
    return n;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let n = 0; n < this.children.length; n++)
      this.children[n].destroy();
  }
  posBeforeChild(n) {
    for (let t = 0, a = this.posAtStart; ; t++) {
      let l = this.children[t];
      if (l == n)
        return a;
      a += l.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(n, t, a) {
    if (this.contentDOM && this.contentDOM.contains(n.nodeType == 1 ? n : n.parentNode))
      if (a < 0) {
        let r, o;
        if (n == this.contentDOM)
          r = n.childNodes[t - 1];
        else {
          for (; n.parentNode != this.contentDOM; )
            n = n.parentNode;
          r = n.previousSibling;
        }
        for (; r && !((o = r.pmViewDesc) && o.parent == this); )
          r = r.previousSibling;
        return r ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let r, o;
        if (n == this.contentDOM)
          r = n.childNodes[t];
        else {
          for (; n.parentNode != this.contentDOM; )
            n = n.parentNode;
          r = n.nextSibling;
        }
        for (; r && !((o = r.pmViewDesc) && o.parent == this); )
          r = r.nextSibling;
        return r ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let l;
    if (n == this.dom && this.contentDOM)
      l = t > qt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      l = n.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let r = n; ; r = r.parentNode) {
          if (r == this.dom) {
            l = !1;
            break;
          }
          if (r.previousSibling)
            break;
        }
      if (l == null && t == n.childNodes.length)
        for (let r = n; ; r = r.parentNode) {
          if (r == this.dom) {
            l = !0;
            break;
          }
          if (r.nextSibling)
            break;
        }
    }
    return l ?? a > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(n, t = !1) {
    for (let a = !0, l = n; l; l = l.parentNode) {
      let r = this.getDesc(l), o;
      if (r && (!t || r.node))
        if (a && (o = r.nodeDOM) && !(o.nodeType == 1 ? o.contains(n.nodeType == 1 ? n : n.parentNode) : o == n))
          a = !1;
        else
          return r;
    }
  }
  getDesc(n) {
    let t = n.pmViewDesc;
    for (let a = t; a; a = a.parent)
      if (a == this)
        return t;
  }
  posFromDOM(n, t, a) {
    for (let l = n; l; l = l.parentNode) {
      let r = this.getDesc(l);
      if (r)
        return r.localPosFromDOM(n, t, a);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(n) {
    for (let t = 0, a = 0; t < this.children.length; t++) {
      let l = this.children[t], r = a + l.size;
      if (a == n && r != a) {
        for (; !l.border && l.children.length; )
          for (let o = 0; o < l.children.length; o++) {
            let i = l.children[o];
            if (i.size) {
              l = i;
              break;
            }
          }
        return l;
      }
      if (n < r)
        return l.descAt(n - a - l.border);
      a = r;
    }
  }
  domFromPos(n, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: n + 1 };
    let a = 0, l = 0;
    for (let r = 0; a < this.children.length; a++) {
      let o = this.children[a], i = r + o.size;
      if (i > n || o instanceof Gm) {
        l = n - r;
        break;
      }
      r = i;
    }
    if (l)
      return this.children[a].domFromPos(l - this.children[a].border, t);
    for (let r; a && !(r = this.children[a - 1]).size && r instanceof Um && r.side >= 0; a--)
      ;
    if (t <= 0) {
      let r, o = !0;
      for (; r = a ? this.children[a - 1] : null, !(!r || r.dom.parentNode == this.contentDOM); a--, o = !1)
        ;
      return r && t && o && !r.border && !r.domAtom ? r.domFromPos(r.size, t) : { node: this.contentDOM, offset: r ? qt(r.dom) + 1 : 0 };
    } else {
      let r, o = !0;
      for (; r = a < this.children.length ? this.children[a] : null, !(!r || r.dom.parentNode == this.contentDOM); a++, o = !1)
        ;
      return r && o && !r.border && !r.domAtom ? r.domFromPos(0, t) : { node: this.contentDOM, offset: r ? qt(r.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(n, t, a = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: n, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let l = -1, r = -1;
    for (let o = a, i = 0; ; i++) {
      let s = this.children[i], d = o + s.size;
      if (l == -1 && n <= d) {
        let u = o + s.border;
        if (n >= u && t <= d - s.border && s.node && s.contentDOM && this.contentDOM.contains(s.contentDOM))
          return s.parseRange(n, t, u);
        n = o;
        for (let f = i; f > 0; f--) {
          let b = this.children[f - 1];
          if (b.size && b.dom.parentNode == this.contentDOM && !b.emptyChildAt(1)) {
            l = qt(b.dom) + 1;
            break;
          }
          n -= b.size;
        }
        l == -1 && (l = 0);
      }
      if (l > -1 && (d > t || i == this.children.length - 1)) {
        t = d;
        for (let u = i + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            r = qt(f.dom);
            break;
          }
          t += f.size;
        }
        r == -1 && (r = this.contentDOM.childNodes.length);
        break;
      }
      o = d;
    }
    return { node: this.contentDOM, from: n, to: t, fromOffset: l, toOffset: r };
  }
  emptyChildAt(n) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[n < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(n);
  }
  domAfterPos(n) {
    let { node: t, offset: a } = this.domFromPos(n, 0);
    if (t.nodeType != 1 || a == t.childNodes.length)
      throw new RangeError("No node after pos " + n);
    return t.childNodes[a];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(n, t, a, l = !1) {
    let r = Math.min(n, t), o = Math.max(n, t);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let x = this.children[h], y = p + x.size;
      if (r > p && o < y)
        return x.setSelection(n - p - x.border, t - p - x.border, a, l);
      p = y;
    }
    let i = this.domFromPos(n, n ? -1 : 1), s = t == n ? i : this.domFromPos(t, t ? -1 : 1), d = a.root.getSelection(), u = a.domSelectionRange(), f = !1;
    if ((Tn || _t) && n == t) {
      let { node: h, offset: p } = i;
      if (h.nodeType == 3) {
        if (f = !!(p && h.nodeValue[p - 1] == `
`), f && p == h.nodeValue.length)
          for (let x = h, y; x; x = x.parentNode) {
            if (y = x.nextSibling) {
              y.nodeName == "BR" && (i = s = { node: y.parentNode, offset: qt(y) + 1 });
              break;
            }
            let w = x.pmViewDesc;
            if (w && w.node && w.node.isBlock)
              break;
          }
      } else {
        let x = h.childNodes[p - 1];
        f = x && (x.nodeName == "BR" || x.contentEditable == "false");
      }
    }
    if (Tn && u.focusNode && u.focusNode != s.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (l = !0);
    }
    if (!(l || f && _t) && bl(i.node, i.offset, u.anchorNode, u.anchorOffset) && bl(s.node, s.offset, u.focusNode, u.focusOffset))
      return;
    let b = !1;
    if ((d.extend || n == t) && !(f && Tn)) {
      d.collapse(i.node, i.offset);
      try {
        n != t && d.extend(s.node, s.offset), b = !0;
      } catch {
      }
    }
    if (!b) {
      if (n > t) {
        let p = i;
        i = s, s = p;
      }
      let h = document.createRange();
      h.setEnd(s.node, s.offset), h.setStart(i.node, i.offset), d.removeAllRanges(), d.addRange(h);
    }
  }
  ignoreMutation(n) {
    return !this.contentDOM && n.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(n, t) {
    for (let a = 0, l = 0; l < this.children.length; l++) {
      let r = this.children[l], o = a + r.size;
      if (a == o ? n <= o && t >= a : n < o && t > a) {
        let i = a + r.border, s = o - r.border;
        if (n >= i && t <= s) {
          this.dirty = n == a || t == o ? Za : nh, n == i && t == s && (r.contentLost || r.dom.parentNode != this.contentDOM) ? r.dirty = ea : r.markDirty(n - i, t - i);
          return;
        } else
          r.dirty = r.dom == r.contentDOM && r.dom.parentNode == this.contentDOM && !r.children.length ? Za : ea;
      }
      a = o;
    }
    this.dirty = Za;
  }
  markParentsDirty() {
    let n = 1;
    for (let t = this.parent; t; t = t.parent, n++) {
      let a = n == 1 ? Za : nh;
      t.dirty < a && (t.dirty = a);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(n) {
    return !1;
  }
}
class Um extends so {
  constructor(n, t, a, l) {
    let r, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(a, () => {
      if (!r)
        return l;
      if (r.parent)
        return r.parent.posBeforeChild(r);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let i = document.createElement("span");
        i.appendChild(o), o = i;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(n, [], o, null), this.widget = t, this.widget = t, r = this;
  }
  matchesWidget(n) {
    return this.dirty == Ln && n.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(n) {
    let t = this.widget.spec.stopEvent;
    return t ? t(n) : !1;
  }
  ignoreMutation(n) {
    return n.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class qI extends so {
  constructor(n, t, a, l) {
    super(n, [], t, null), this.textDOM = a, this.text = l;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(n, t) {
    return n != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(n) {
    return { node: this.textDOM, offset: n };
  }
  ignoreMutation(n) {
    return n.type === "characterData" && n.target.nodeValue == n.oldValue;
  }
}
class gl extends so {
  constructor(n, t, a, l, r) {
    super(n, [], a, l), this.mark = t, this.spec = r;
  }
  static create(n, t, a, l) {
    let r = l.nodeViews[t.type.name], o = r && r(t, l, a);
    return (!o || !o.dom) && (o = pl.renderSpec(document, t.type.spec.toDOM(t, a), null, t.attrs)), new gl(n, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & ea || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(n) {
    return this.dirty != ea && this.mark.eq(n);
  }
  markDirty(n, t) {
    if (super.markDirty(n, t), this.dirty != Ln) {
      let a = this.parent;
      for (; !a.node; )
        a = a.parent;
      a.dirty < this.dirty && (a.dirty = this.dirty), this.dirty = Ln;
    }
  }
  slice(n, t, a) {
    let l = gl.create(this.parent, this.mark, !0, a), r = this.children, o = this.size;
    t < o && (r = Gd(r, t, o, a)), n > 0 && (r = Gd(r, 0, n, a));
    for (let i = 0; i < r.length; i++)
      r[i].parent = l;
    return l.children = r, l;
  }
  ignoreMutation(n) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(n) : super.ignoreMutation(n);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Ba extends so {
  constructor(n, t, a, l, r, o, i, s, d) {
    super(n, [], r, o), this.node = t, this.outerDeco = a, this.innerDeco = l, this.nodeDOM = i;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(n, t, a, l, r, o) {
    let i = r.nodeViews[t.type.name], s, d = i && i(t, r, () => {
      if (!s)
        return o;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    }, a, l), u = d && d.dom, f = d && d.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = pl.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !f && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let b = u;
    return u = Jm(u, a, t), d ? s = new UI(n, t, a, l, u, f || null, b, d, r, o + 1) : t.isText ? new rs(n, t, a, l, u, b, r) : new Ba(n, t, a, l, u, f || null, b, r, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let n = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (n.preserveWhitespace = "full"), !this.contentDOM)
      n.getContent = () => this.node.content;
    else if (!this.contentLost)
      n.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let a = this.children[t];
        if (this.dom.contains(a.dom.parentNode)) {
          n.contentElement = a.dom.parentNode;
          break;
        }
      }
      n.contentElement || (n.getContent = () => Pe.empty);
    }
    return n;
  }
  matchesNode(n, t, a) {
    return this.dirty == Ln && n.eq(this.node) && ui(t, this.outerDeco) && a.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(n, t) {
    let a = this.node.inlineContent, l = t, r = n.composing ? this.localCompositionInfo(n, t) : null, o = r && r.pos > -1 ? r : null, i = r && r.pos < 0, s = new KI(this, o && o.node, n);
    XI(this.node, this.innerDeco, (d, u, f) => {
      d.spec.marks ? s.syncToMarks(d.spec.marks, a, n, u) : d.type.side >= 0 && !f && s.syncToMarks(u == this.node.childCount ? vt.none : this.node.child(u).marks, a, n, u), s.placeWidget(d, n, l);
    }, (d, u, f, b) => {
      s.syncToMarks(d.marks, a, n, b);
      let h;
      s.findNodeMatch(d, u, f, b) || i && n.state.selection.from > l && n.state.selection.to < l + d.nodeSize && (h = s.findIndexWithChild(r.node)) > -1 && s.updateNodeAt(d, u, f, h, n) || s.updateNextNode(d, u, f, n, b, l) || s.addNode(d, u, f, n, l), l += d.nodeSize;
    }), s.syncToMarks([], a, n, 0), this.node.isTextblock && s.addTextblockHacks(), s.destroyRest(), (s.changed || this.dirty == Za) && (o && this.protectLocalComposition(n, o), Km(this.contentDOM, this.children, n), ql && ZI(this.dom));
  }
  localCompositionInfo(n, t) {
    let { from: a, to: l } = n.state.selection;
    if (!(n.state.selection instanceof at) || a < t || l > t + this.node.content.size)
      return null;
    let r = n.input.compositionNode;
    if (!r || !this.dom.contains(r.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = r.nodeValue, i = QI(this.node.content, o, a - t, l - t);
      return i < 0 ? null : { node: r, pos: i, text: o };
    } else
      return { node: r, pos: -1, text: "" };
  }
  protectLocalComposition(n, { node: t, pos: a, text: l }) {
    if (this.getDesc(t))
      return;
    let r = t;
    for (; r.parentNode != this.contentDOM; r = r.parentNode) {
      for (; r.previousSibling; )
        r.parentNode.removeChild(r.previousSibling);
      for (; r.nextSibling; )
        r.parentNode.removeChild(r.nextSibling);
      r.pmViewDesc && (r.pmViewDesc = void 0);
    }
    let o = new qI(this, r, t, l);
    n.input.compositionNodes.push(o), this.children = Gd(this.children, a, a + l.length, n, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(n, t, a, l) {
    return this.dirty == ea || !n.sameMarkup(this.node) ? !1 : (this.updateInner(n, t, a, l), !0);
  }
  updateInner(n, t, a, l) {
    this.updateOuterDeco(t), this.node = n, this.innerDeco = a, this.contentDOM && this.updateChildren(l, this.posAtStart), this.dirty = Ln;
  }
  updateOuterDeco(n) {
    if (ui(n, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, a = this.dom;
    this.dom = Ym(this.dom, this.nodeDOM, Ud(this.outerDeco, this.node, t), Ud(n, this.node, t)), this.dom != a && (a.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = n;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function ah(e, n, t, a, l) {
  Jm(a, n, e);
  let r = new Ba(void 0, e, n, t, a, a, a, l, 0);
  return r.contentDOM && r.updateChildren(l, 0), r;
}
class rs extends Ba {
  constructor(n, t, a, l, r, o, i) {
    super(n, t, a, l, r, null, o, i, 0);
  }
  parseRule() {
    let n = this.nodeDOM.parentNode;
    for (; n && n != this.dom && !n.pmIsDeco; )
      n = n.parentNode;
    return { skip: n || !0 };
  }
  update(n, t, a, l) {
    return this.dirty == ea || this.dirty != Ln && !this.inParent() || !n.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Ln || n.text != this.node.text) && n.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = n.text, l.trackWrites == this.nodeDOM && (l.trackWrites = null)), this.node = n, this.dirty = Ln, !0);
  }
  inParent() {
    let n = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == n)
        return !0;
    return !1;
  }
  domFromPos(n) {
    return { node: this.nodeDOM, offset: n };
  }
  localPosFromDOM(n, t, a) {
    return n == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(n, t, a);
  }
  ignoreMutation(n) {
    return n.type != "characterData" && n.type != "selection";
  }
  slice(n, t, a) {
    let l = this.node.cut(n, t), r = document.createTextNode(l.text);
    return new rs(this.parent, l, this.outerDeco, this.innerDeco, r, r, a);
  }
  markDirty(n, t) {
    super.markDirty(n, t), this.dom != this.nodeDOM && (n == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = ea);
  }
  get domAtom() {
    return !1;
  }
  isText(n) {
    return this.node.text == n;
  }
}
class Gm extends so {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(n) {
    return this.dirty == Ln && this.dom.nodeName == n;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class UI extends Ba {
  constructor(n, t, a, l, r, o, i, s, d, u) {
    super(n, t, a, l, r, o, i, d, u), this.spec = s;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(n, t, a, l) {
    if (this.dirty == ea)
      return !1;
    if (this.spec.update && (this.node.type == n.type || this.spec.multiType)) {
      let r = this.spec.update(n, t, a);
      return r && this.updateInner(n, t, a, l), r;
    } else return !this.contentDOM && !n.isLeaf ? !1 : super.update(n, t, a, l);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(n, t, a, l) {
    this.spec.setSelection ? this.spec.setSelection(n, t, a.root) : super.setSelection(n, t, a, l);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(n) {
    return this.spec.stopEvent ? this.spec.stopEvent(n) : !1;
  }
  ignoreMutation(n) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(n) : super.ignoreMutation(n);
  }
}
function Km(e, n, t) {
  let a = e.firstChild, l = !1;
  for (let r = 0; r < n.length; r++) {
    let o = n[r], i = o.dom;
    if (i.parentNode == e) {
      for (; i != a; )
        a = lh(a), l = !0;
      a = a.nextSibling;
    } else
      l = !0, e.insertBefore(i, a);
    if (o instanceof gl) {
      let s = a ? a.previousSibling : e.lastChild;
      Km(o.contentDOM, o.children, t), a = s ? s.nextSibling : e.firstChild;
    }
  }
  for (; a; )
    a = lh(a), l = !0;
  l && t.trackWrites == e && (t.trackWrites = null);
}
const Sr = function(e) {
  e && (this.nodeName = e);
};
Sr.prototype = /* @__PURE__ */ Object.create(null);
const Qa = [new Sr()];
function Ud(e, n, t) {
  if (e.length == 0)
    return Qa;
  let a = t ? Qa[0] : new Sr(), l = [a];
  for (let r = 0; r < e.length; r++) {
    let o = e[r].type.attrs;
    if (o) {
      o.nodeName && l.push(a = new Sr(o.nodeName));
      for (let i in o) {
        let s = o[i];
        s != null && (t && l.length == 1 && l.push(a = new Sr(n.isInline ? "span" : "div")), i == "class" ? a.class = (a.class ? a.class + " " : "") + s : i == "style" ? a.style = (a.style ? a.style + ";" : "") + s : i != "nodeName" && (a[i] = s));
      }
    }
  }
  return l;
}
function Ym(e, n, t, a) {
  if (t == Qa && a == Qa)
    return n;
  let l = n;
  for (let r = 0; r < a.length; r++) {
    let o = a[r], i = t[r];
    if (r) {
      let s;
      i && i.nodeName == o.nodeName && l != e && (s = l.parentNode) && s.nodeName.toLowerCase() == o.nodeName || (s = document.createElement(o.nodeName), s.pmIsDeco = !0, s.appendChild(l), i = Qa[0]), l = s;
    }
    GI(l, i || Qa[0], o);
  }
  return l;
}
function GI(e, n, t) {
  for (let a in n)
    a != "class" && a != "style" && a != "nodeName" && !(a in t) && e.removeAttribute(a);
  for (let a in t)
    a != "class" && a != "style" && a != "nodeName" && t[a] != n[a] && e.setAttribute(a, t[a]);
  if (n.class != t.class) {
    let a = n.class ? n.class.split(" ").filter(Boolean) : [], l = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let r = 0; r < a.length; r++)
      l.indexOf(a[r]) == -1 && e.classList.remove(a[r]);
    for (let r = 0; r < l.length; r++)
      a.indexOf(l[r]) == -1 && e.classList.add(l[r]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (n.style != t.style) {
    if (n.style) {
      let a = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, l;
      for (; l = a.exec(n.style); )
        e.style.removeProperty(l[1]);
    }
    t.style && (e.style.cssText += t.style);
  }
}
function Jm(e, n, t) {
  return Ym(e, e, Qa, Ud(n, t, e.nodeType != 1));
}
function ui(e, n) {
  if (e.length != n.length)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!e[t].type.eq(n[t].type))
      return !1;
  return !0;
}
function lh(e) {
  let n = e.nextSibling;
  return e.parentNode.removeChild(e), n;
}
class KI {
  constructor(n, t, a) {
    this.lock = t, this.view = a, this.index = 0, this.stack = [], this.changed = !1, this.top = n, this.preMatch = YI(n.node.content, n);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(n, t) {
    if (n != t) {
      for (let a = n; a < t; a++)
        this.top.children[a].destroy();
      this.top.children.splice(n, t - n), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(n, t, a, l) {
    let r = 0, o = this.stack.length >> 1, i = Math.min(o, n.length);
    for (; r < i && (r == o - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(n[r]) && n[r].type.spec.spanning !== !1; )
      r++;
    for (; r < o; )
      this.destroyRest(), this.top.dirty = Ln, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < n.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1, d = this.top.children.length;
      l < this.preMatch.index && (d = Math.min(this.index + 3, d));
      for (let u = this.index; u < d; u++) {
        let f = this.top.children[u];
        if (f.matchesMark(n[o]) && !this.isLocked(f.dom)) {
          s = u;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let u = gl.create(this.top, n[o], t, a);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(n, t, a, l) {
    let r = -1, o;
    if (l >= this.preMatch.index && (o = this.preMatch.matches[l - this.preMatch.index]).parent == this.top && o.matchesNode(n, t, a))
      r = this.top.children.indexOf(o, this.index);
    else
      for (let i = this.index, s = Math.min(this.top.children.length, i + 5); i < s; i++) {
        let d = this.top.children[i];
        if (d.matchesNode(n, t, a) && !this.preMatch.matched.has(d)) {
          r = i;
          break;
        }
      }
    return r < 0 ? !1 : (this.destroyBetween(this.index, r), this.index++, !0);
  }
  updateNodeAt(n, t, a, l, r) {
    let o = this.top.children[l];
    return o.dirty == ea && o.dom == o.contentDOM && (o.dirty = Za), o.update(n, t, a, r) ? (this.destroyBetween(this.index, l), this.index++, !0) : !1;
  }
  findIndexWithChild(n) {
    for (; ; ) {
      let t = n.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let a = n.pmViewDesc;
        if (a) {
          for (let l = this.index; l < this.top.children.length; l++)
            if (this.top.children[l] == a)
              return l;
        }
        return -1;
      }
      n = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(n, t, a, l, r, o) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let s = this.top.children[i];
      if (s instanceof Ba) {
        let d = this.preMatch.matched.get(s);
        if (d != null && d != r)
          return !1;
        let u = s.dom, f, b = this.isLocked(u) && !(n.isText && s.node && s.node.isText && s.nodeDOM.nodeValue == n.text && s.dirty != ea && ui(t, s.outerDeco));
        if (!b && s.update(n, t, a, l))
          return this.destroyBetween(this.index, i), s.dom != u && (this.changed = !0), this.index++, !0;
        if (!b && (f = this.recreateWrapper(s, n, t, a, l, o)))
          return this.destroyBetween(this.index, i), this.top.children[this.index] = f, f.contentDOM && (f.dirty = Za, f.updateChildren(l, o + 1), f.dirty = Ln), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(n, t, a, l, r, o) {
    if (n.dirty || t.isAtom || !n.children.length || !n.node.content.eq(t.content) || !ui(a, n.outerDeco) || !l.eq(n.innerDeco))
      return null;
    let i = Ba.create(this.top, t, a, l, r, o);
    if (i.contentDOM) {
      i.children = n.children, n.children = [];
      for (let s of i.children)
        s.parent = i;
    }
    return n.destroy(), i;
  }
  // Insert the node as a newly created node desc.
  addNode(n, t, a, l, r) {
    let o = Ba.create(this.top, n, t, a, l, r);
    o.contentDOM && o.updateChildren(l, r + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(n, t, a) {
    let l = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (l && l.matchesWidget(n) && (n == l.widget || !l.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let r = new Um(this.top, n, t, a);
      this.top.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let n = this.top.children[this.index - 1], t = this.top;
    for (; n instanceof gl; )
      t = n, n = t.children[t.children.length - 1];
    (!n || // Empty textblock
    !(n instanceof rs) || /\n$/.test(n.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(n.node.text)) && ((_t || Gt) && n && n.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(n, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(n))
      this.index++;
    else {
      let a = document.createElement(n);
      n == "IMG" && (a.className = "ProseMirror-separator", a.alt = ""), n == "BR" && (a.className = "ProseMirror-trailingBreak");
      let l = new Gm(this.top, [], a, null);
      t != this.top ? t.children.push(l) : t.children.splice(this.index++, 0, l), this.changed = !0;
    }
  }
  isLocked(n) {
    return this.lock && (n == this.lock || n.nodeType == 1 && n.contains(this.lock.parentNode));
  }
}
function YI(e, n) {
  let t = n, a = t.children.length, l = e.childCount, r = /* @__PURE__ */ new Map(), o = [];
  e: for (; l > 0; ) {
    let i;
    for (; ; )
      if (a) {
        let d = t.children[a - 1];
        if (d instanceof gl)
          t = d, a = d.children.length;
        else {
          i = d, a--;
          break;
        }
      } else {
        if (t == n)
          break e;
        a = t.parent.children.indexOf(t), t = t.parent;
      }
    let s = i.node;
    if (s) {
      if (s != e.child(l - 1))
        break;
      --l, r.set(i, l), o.push(i);
    }
  }
  return { index: l, matched: r, matches: o.reverse() };
}
function JI(e, n) {
  return e.type.side - n.type.side;
}
function XI(e, n, t, a) {
  let l = n.locals(e), r = 0;
  if (l.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let u = e.child(d);
      a(u, l, n.forChild(r, u), d), r += u.nodeSize;
    }
    return;
  }
  let o = 0, i = [], s = null;
  for (let d = 0; ; ) {
    let u, f;
    for (; o < l.length && l[o].to == r; ) {
      let y = l[o++];
      y.widget && (u ? (f || (f = [u])).push(y) : u = y);
    }
    if (u)
      if (f) {
        f.sort(JI);
        for (let y = 0; y < f.length; y++)
          t(f[y], d, !!s);
      } else
        t(u, d, !!s);
    let b, h;
    if (s)
      h = -1, b = s, s = null;
    else if (d < e.childCount)
      h = d, b = e.child(d++);
    else
      break;
    for (let y = 0; y < i.length; y++)
      i[y].to <= r && i.splice(y--, 1);
    for (; o < l.length && l[o].from <= r && l[o].to > r; )
      i.push(l[o++]);
    let p = r + b.nodeSize;
    if (b.isText) {
      let y = p;
      o < l.length && l[o].from < y && (y = l[o].from);
      for (let w = 0; w < i.length; w++)
        i[w].to < y && (y = i[w].to);
      y < p && (s = b.cut(y - r), b = b.cut(0, y - r), p = y, h = -1);
    } else
      for (; o < l.length && l[o].to < p; )
        o++;
    let x = b.isInline && !b.isLeaf ? i.filter((y) => !y.inline) : i.slice();
    a(b, x, n.forChild(r, b), h), r = p;
  }
}
function ZI(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let n = e.style.cssText;
    e.style.cssText = n + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = n;
  }
}
function QI(e, n, t, a) {
  for (let l = 0, r = 0; l < e.childCount && r <= a; ) {
    let o = e.child(l++), i = r;
    if (r += o.nodeSize, !o.isText)
      continue;
    let s = o.text;
    for (; l < e.childCount; ) {
      let d = e.child(l++);
      if (r += d.nodeSize, !d.isText)
        break;
      s += d.text;
    }
    if (r >= t) {
      if (r >= a && s.slice(a - n.length - i, a - i) == n)
        return a - n.length;
      let d = i < a ? s.lastIndexOf(n, a - i - 1) : -1;
      if (d >= 0 && d + n.length + i >= t)
        return i + d;
      if (t == a && s.length >= a + n.length - i && s.slice(a - i, a - i + n.length) == n)
        return a;
    }
  }
  return -1;
}
function Gd(e, n, t, a, l) {
  let r = [];
  for (let o = 0, i = 0; o < e.length; o++) {
    let s = e[o], d = i, u = i += s.size;
    d >= t || u <= n ? r.push(s) : (d < n && r.push(s.slice(0, n - d, a)), l && (r.push(l), l = void 0), u > t && r.push(s.slice(t - d, s.size, a)));
  }
  return r;
}
function sc(e, n = null) {
  let t = e.domSelectionRange(), a = e.state.doc;
  if (!t.focusNode)
    return null;
  let l = e.docView.nearestDesc(t.focusNode), r = l && l.size == 0, o = e.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let i = a.resolve(o), s, d;
  if (ls(t)) {
    for (s = o; l && !l.node; )
      l = l.parent;
    let f = l.node;
    if (l && f.isAtom && Qe.isSelectable(f) && l.parent && !(f.isInline && $I(t.focusNode, t.focusOffset, l.dom))) {
      let b = l.posBefore;
      d = new Qe(o == b ? i : a.resolve(b));
    }
  } else {
    if (t instanceof e.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let f = o, b = o;
      for (let h = 0; h < t.rangeCount; h++) {
        let p = t.getRangeAt(h);
        f = Math.min(f, e.docView.posFromDOM(p.startContainer, p.startOffset, 1)), b = Math.max(b, e.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (f < 0)
        return null;
      [s, o] = b == e.state.selection.anchor ? [b, f] : [f, b], i = a.resolve(o);
    } else
      s = e.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (s < 0)
      return null;
  }
  let u = a.resolve(s);
  if (!d) {
    let f = n == "pointer" || e.state.selection.head < i.pos && !r ? 1 : -1;
    d = dc(e, u, i, f);
  }
  return d;
}
function Xm(e) {
  return e.editable ? e.hasFocus() : Qm(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function ca(e, n = !1) {
  let t = e.state.selection;
  if (Zm(e, t), !!Xm(e)) {
    if (!n && e.input.mouseDown && e.input.mouseDown.allowDefault && Gt) {
      let a = e.domSelectionRange(), l = e.domObserver.currentSelection;
      if (a.anchorNode && l.anchorNode && bl(a.anchorNode, a.anchorOffset, l.anchorNode, l.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      eT(e);
    else {
      let { anchor: a, head: l } = t, r, o;
      rh && !(t instanceof at) && (t.$from.parent.inlineContent || (r = oh(e, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = oh(e, t.to))), e.docView.setSelection(a, l, e, n), rh && (r && ih(r), o && ih(o)), t.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && _I(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const rh = _t || Gt && Pm < 63;
function oh(e, n) {
  let { node: t, offset: a } = e.docView.domFromPos(n, 0), l = a < t.childNodes.length ? t.childNodes[a] : null, r = a ? t.childNodes[a - 1] : null;
  if (_t && l && l.contentEditable == "false")
    return js(l);
  if ((!l || l.contentEditable == "false") && (!r || r.contentEditable == "false")) {
    if (l)
      return js(l);
    if (r)
      return js(r);
  }
}
function js(e) {
  return e.contentEditable = "true", _t && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function ih(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function _I(e) {
  let n = e.dom.ownerDocument;
  n.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let t = e.domSelectionRange(), a = t.anchorNode, l = t.anchorOffset;
  n.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (t.anchorNode != a || t.anchorOffset != l) && (n.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!Xm(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function eT(e) {
  let n = e.domSelection();
  if (!n)
    return;
  let t = e.cursorWrapper.dom, a = t.nodeName == "IMG";
  a ? n.collapse(t.parentNode, qt(t) + 1) : n.collapse(t, 0), !a && !e.state.selection.visible && cn && Ra <= 11 && (t.disabled = !0, t.disabled = !1);
}
function Zm(e, n) {
  if (n instanceof Qe) {
    let t = e.docView.descAt(n.from);
    t != e.lastSelectedViewDesc && (sh(e), t && t.selectNode(), e.lastSelectedViewDesc = t);
  } else
    sh(e);
}
function sh(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function dc(e, n, t, a) {
  return e.someProp("createSelectionBetween", (l) => l(e, n, t)) || at.between(n, t, a);
}
function dh(e) {
  return e.editable && !e.hasFocus() ? !1 : Qm(e);
}
function Qm(e) {
  let n = e.domSelectionRange();
  if (!n.anchorNode)
    return !1;
  try {
    return e.dom.contains(n.anchorNode.nodeType == 3 ? n.anchorNode.parentNode : n.anchorNode) && (e.editable || e.dom.contains(n.focusNode.nodeType == 3 ? n.focusNode.parentNode : n.focusNode));
  } catch {
    return !1;
  }
}
function tT(e) {
  let n = e.docView.domFromPos(e.state.selection.anchor, 0), t = e.domSelectionRange();
  return bl(n.node, n.offset, t.anchorNode, t.anchorOffset);
}
function Kd(e, n) {
  let { $anchor: t, $head: a } = e.selection, l = n > 0 ? t.max(a) : t.min(a), r = l.parent.inlineContent ? l.depth ? e.doc.resolve(n > 0 ? l.after() : l.before()) : null : l;
  return r && rt.findFrom(r, n);
}
function xa(e, n) {
  return e.dispatch(e.state.tr.setSelection(n).scrollIntoView()), !0;
}
function uh(e, n, t) {
  let a = e.state.selection;
  if (a instanceof at)
    if (t.indexOf("s") > -1) {
      let { $head: l } = a, r = l.textOffset ? null : n < 0 ? l.nodeBefore : l.nodeAfter;
      if (!r || r.isText || !r.isLeaf)
        return !1;
      let o = e.state.doc.resolve(l.pos + r.nodeSize * (n < 0 ? -1 : 1));
      return xa(e, new at(a.$anchor, o));
    } else if (a.empty) {
      if (e.endOfTextblock(n > 0 ? "forward" : "backward")) {
        let l = Kd(e.state, n);
        return l && l instanceof Qe ? xa(e, l) : !1;
      } else if (!(yn && t.indexOf("m") > -1)) {
        let l = a.$head, r = l.textOffset ? null : n < 0 ? l.nodeBefore : l.nodeAfter, o;
        if (!r || r.isText)
          return !1;
        let i = n < 0 ? l.pos - r.nodeSize : l.pos;
        return r.isAtom || (o = e.docView.descAt(i)) && !o.contentDOM ? Qe.isSelectable(r) ? xa(e, new Qe(n < 0 ? e.state.doc.resolve(l.pos - r.nodeSize) : l)) : io ? xa(e, new at(e.state.doc.resolve(n < 0 ? i : i + r.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (a instanceof Qe && a.node.isInline)
      return xa(e, new at(n > 0 ? a.$to : a.$from));
    {
      let l = Kd(e.state, n);
      return l ? xa(e, l) : !1;
    }
  }
}
function ci(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function $r(e, n) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (n < 0 || e.nextSibling || e.nodeName != "BR");
}
function xl(e, n) {
  return n < 0 ? nT(e) : aT(e);
}
function nT(e) {
  let n = e.domSelectionRange(), t = n.focusNode, a = n.focusOffset;
  if (!t)
    return;
  let l, r, o = !1;
  for (Tn && t.nodeType == 1 && a < ci(t) && $r(t.childNodes[a], -1) && (o = !0); ; )
    if (a > 0) {
      if (t.nodeType != 1)
        break;
      {
        let i = t.childNodes[a - 1];
        if ($r(i, -1))
          l = t, r = --a;
        else if (i.nodeType == 3)
          t = i, a = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (_m(t))
        break;
      {
        let i = t.previousSibling;
        for (; i && $r(i, -1); )
          l = t.parentNode, r = qt(i), i = i.previousSibling;
        if (i)
          t = i, a = ci(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          a = 0;
        }
      }
    }
  o ? Yd(e, t, a) : l && Yd(e, l, r);
}
function aT(e) {
  let n = e.domSelectionRange(), t = n.focusNode, a = n.focusOffset;
  if (!t)
    return;
  let l = ci(t), r, o;
  for (; ; )
    if (a < l) {
      if (t.nodeType != 1)
        break;
      let i = t.childNodes[a];
      if ($r(i, 1))
        r = t, o = ++a;
      else
        break;
    } else {
      if (_m(t))
        break;
      {
        let i = t.nextSibling;
        for (; i && $r(i, 1); )
          r = i.parentNode, o = qt(i) + 1, i = i.nextSibling;
        if (i)
          t = i, a = 0, l = ci(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          a = l = 0;
        }
      }
    }
  r && Yd(e, r, o);
}
function _m(e) {
  let n = e.pmViewDesc;
  return n && n.node && n.node.isBlock;
}
function lT(e, n) {
  for (; e && n == e.childNodes.length && !oo(e); )
    n = qt(e) + 1, e = e.parentNode;
  for (; e && n < e.childNodes.length; ) {
    let t = e.childNodes[n];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, n = 0;
  }
}
function rT(e, n) {
  for (; e && !n && !oo(e); )
    n = qt(e), e = e.parentNode;
  for (; e && n; ) {
    let t = e.childNodes[n - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, n = e.childNodes.length;
  }
}
function Yd(e, n, t) {
  if (n.nodeType != 3) {
    let r, o;
    (o = lT(n, t)) ? (n = o, t = 0) : (r = rT(n, t)) && (n = r, t = r.nodeValue.length);
  }
  let a = e.domSelection();
  if (!a)
    return;
  if (ls(a)) {
    let r = document.createRange();
    r.setEnd(n, t), r.setStart(n, t), a.removeAllRanges(), a.addRange(r);
  } else a.extend && a.extend(n, t);
  e.domObserver.setCurSelection();
  let { state: l } = e;
  setTimeout(() => {
    e.state == l && ca(e);
  }, 50);
}
function ch(e, n) {
  let t = e.state.doc.resolve(n);
  if (!(Gt || Fm) && t.parent.inlineContent) {
    let l = e.coordsAtPos(n);
    if (n > t.start()) {
      let r = e.coordsAtPos(n - 1), o = (r.top + r.bottom) / 2;
      if (o > l.top && o < l.bottom && Math.abs(r.left - l.left) > 1)
        return r.left < l.left ? "ltr" : "rtl";
    }
    if (n < t.end()) {
      let r = e.coordsAtPos(n + 1), o = (r.top + r.bottom) / 2;
      if (o > l.top && o < l.bottom && Math.abs(r.left - l.left) > 1)
        return r.left > l.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function fh(e, n, t) {
  let a = e.state.selection;
  if (a instanceof at && !a.empty || t.indexOf("s") > -1 || yn && t.indexOf("m") > -1)
    return !1;
  let { $from: l, $to: r } = a;
  if (!l.parent.inlineContent || e.endOfTextblock(n < 0 ? "up" : "down")) {
    let o = Kd(e.state, n);
    if (o && o instanceof Qe)
      return xa(e, o);
  }
  if (!l.parent.inlineContent) {
    let o = n < 0 ? l : r, i = a instanceof gn ? rt.near(o, n) : rt.findFrom(o, n);
    return i ? xa(e, i) : !1;
  }
  return !1;
}
function hh(e, n) {
  if (!(e.state.selection instanceof at))
    return !0;
  let { $head: t, $anchor: a, empty: l } = e.state.selection;
  if (!t.sameParent(a))
    return !0;
  if (!l)
    return !1;
  if (e.endOfTextblock(n > 0 ? "forward" : "backward"))
    return !0;
  let r = !t.textOffset && (n < 0 ? t.nodeBefore : t.nodeAfter);
  if (r && !r.isText) {
    let o = e.state.tr;
    return n < 0 ? o.delete(t.pos - r.nodeSize, t.pos) : o.delete(t.pos, t.pos + r.nodeSize), e.dispatch(o), !0;
  }
  return !1;
}
function bh(e, n, t) {
  e.domObserver.stop(), n.contentEditable = t, e.domObserver.start();
}
function oT(e) {
  if (!_t || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: n, focusOffset: t } = e.domSelectionRange();
  if (n && n.nodeType == 1 && t == 0 && n.firstChild && n.firstChild.contentEditable == "false") {
    let a = n.firstChild;
    bh(e, a, "true"), setTimeout(() => bh(e, a, "false"), 20);
  }
  return !1;
}
function iT(e) {
  let n = "";
  return e.ctrlKey && (n += "c"), e.metaKey && (n += "m"), e.altKey && (n += "a"), e.shiftKey && (n += "s"), n;
}
function sT(e, n) {
  let t = n.keyCode, a = iT(n);
  if (t == 8 || yn && t == 72 && a == "c")
    return hh(e, -1) || xl(e, -1);
  if (t == 46 && !n.shiftKey || yn && t == 68 && a == "c")
    return hh(e, 1) || xl(e, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || yn && t == 66 && a == "c") {
    let l = t == 37 ? ch(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return uh(e, l, a) || xl(e, l);
  } else if (t == 39 || yn && t == 70 && a == "c") {
    let l = t == 39 ? ch(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return uh(e, l, a) || xl(e, l);
  } else {
    if (t == 38 || yn && t == 80 && a == "c")
      return fh(e, -1, a) || xl(e, -1);
    if (t == 40 || yn && t == 78 && a == "c")
      return oT(e) || fh(e, 1, a) || xl(e, 1);
    if (a == (yn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function uc(e, n) {
  e.someProp("transformCopied", (h) => {
    n = h(n, e);
  });
  let t = [], { content: a, openStart: l, openEnd: r } = n;
  for (; l > 1 && r > 1 && a.childCount == 1 && a.firstChild.childCount == 1; ) {
    l--, r--;
    let h = a.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), a = h.content;
  }
  let o = e.someProp("clipboardSerializer") || pl.fromSchema(e.state.schema), i = rp(), s = i.createElement("div");
  s.appendChild(o.serializeFragment(a, { document: i }));
  let d = s.firstChild, u, f = 0;
  for (; d && d.nodeType == 1 && (u = lp[d.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = i.createElement(u[h]);
      for (; s.firstChild; )
        p.appendChild(s.firstChild);
      s.appendChild(p), f++;
    }
    d = s.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${l} ${r}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let b = e.someProp("clipboardTextSerializer", (h) => h(n, e)) || n.content.textBetween(0, n.content.size, `

`);
  return { dom: s, text: b, slice: n };
}
function ep(e, n, t, a, l) {
  let r = l.parent.type.spec.code, o, i;
  if (!t && !n)
    return null;
  let s = !!n && (a || r || !t);
  if (s) {
    if (e.someProp("transformPastedText", (b) => {
      n = b(n, r || a, e);
    }), r)
      return i = new Je(Pe.from(e.state.schema.text(n.replace(/\r\n?/g, `
`))), 0, 0), e.someProp("transformPasted", (b) => {
        i = b(i, e, !0);
      }), i;
    let f = e.someProp("clipboardTextParser", (b) => b(n, l, a, e));
    if (f)
      i = f;
    else {
      let b = l.marks(), { schema: h } = e.state, p = pl.fromSchema(h);
      o = document.createElement("div"), n.split(/(?:\r\n?|\n)+/).forEach((x) => {
        let y = o.appendChild(document.createElement("p"));
        x && y.appendChild(p.serializeNode(h.text(x, b)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      t = f(t, e);
    }), o = fT(t), io && hT(o);
  let d = o && o.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let b = o.firstChild;
      for (; b && b.nodeType != 1; )
        b = b.nextSibling;
      if (!b)
        break;
      o = b;
    }
  if (i || (i = (e.someProp("clipboardParser") || e.someProp("domParser") || Ea.fromSchema(e.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(s || u),
    context: l,
    ruleFromNode(b) {
      return b.nodeName == "BR" && !b.nextSibling && b.parentNode && !dT.test(b.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    i = bT(gh(i, +u[1], +u[2]), u[4]);
  else if (i = Je.maxOpen(uT(i.content, l), !0), i.openStart || i.openEnd) {
    let f = 0, b = 0;
    for (let h = i.content.firstChild; f < i.openStart && !h.type.spec.isolating; f++, h = h.firstChild)
      ;
    for (let h = i.content.lastChild; b < i.openEnd && !h.type.spec.isolating; b++, h = h.lastChild)
      ;
    i = gh(i, f, b);
  }
  return e.someProp("transformPasted", (f) => {
    i = f(i, e, s);
  }), i;
}
const dT = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function uT(e, n) {
  if (e.childCount < 2)
    return e;
  for (let t = n.depth; t >= 0; t--) {
    let l = n.node(t).contentMatchAt(n.index(t)), r, o = [];
    if (e.forEach((i) => {
      if (!o)
        return;
      let s = l.findWrapping(i.type), d;
      if (!s)
        return o = null;
      if (d = o.length && r.length && np(s, r, i, o[o.length - 1], 0))
        o[o.length - 1] = d;
      else {
        o.length && (o[o.length - 1] = ap(o[o.length - 1], r.length));
        let u = tp(i, s);
        o.push(u), l = l.matchType(u.type), r = s;
      }
    }), o)
      return Pe.from(o);
  }
  return e;
}
function tp(e, n, t = 0) {
  for (let a = n.length - 1; a >= t; a--)
    e = n[a].create(null, Pe.from(e));
  return e;
}
function np(e, n, t, a, l) {
  if (l < e.length && l < n.length && e[l] == n[l]) {
    let r = np(e, n, t, a.lastChild, l + 1);
    if (r)
      return a.copy(a.content.replaceChild(a.childCount - 1, r));
    if (a.contentMatchAt(a.childCount).matchType(l == e.length - 1 ? t.type : e[l + 1]))
      return a.copy(a.content.append(Pe.from(tp(t, e, l + 1))));
  }
}
function ap(e, n) {
  if (n == 0)
    return e;
  let t = e.content.replaceChild(e.childCount - 1, ap(e.lastChild, n - 1)), a = e.contentMatchAt(e.childCount).fillBefore(Pe.empty, !0);
  return e.copy(t.append(a));
}
function Jd(e, n, t, a, l, r) {
  let o = n < 0 ? e.firstChild : e.lastChild, i = o.content;
  return e.childCount > 1 && (r = 0), l < a - 1 && (i = Jd(i, n, t, a, l + 1, r)), l >= t && (i = n < 0 ? o.contentMatchAt(0).fillBefore(i, r <= l).append(i) : i.append(o.contentMatchAt(o.childCount).fillBefore(Pe.empty, !0))), e.replaceChild(n < 0 ? 0 : e.childCount - 1, o.copy(i));
}
function gh(e, n, t) {
  return n < e.openStart && (e = new Je(Jd(e.content, -1, n, e.openStart, 0, e.openEnd), n, e.openEnd)), t < e.openEnd && (e = new Je(Jd(e.content, 1, t, e.openEnd, 0, 0), e.openStart, t)), e;
}
const lp = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let mh = null;
function rp() {
  return mh || (mh = document.implementation.createHTMLDocument("title"));
}
let Ws = null;
function cT(e) {
  let n = window.trustedTypes;
  return n ? (Ws || (Ws = n.defaultPolicy || n.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), Ws.createHTML(e)) : e;
}
function fT(e) {
  let n = /^(\s*<meta [^>]*>)*/.exec(e);
  n && (e = e.slice(n[0].length));
  let t = rp().createElement("div"), a = /<([a-z][^>\s]+)/i.exec(e), l;
  if ((l = a && lp[a[1].toLowerCase()]) && (e = l.map((r) => "<" + r + ">").join("") + e + l.map((r) => "</" + r + ">").reverse().join("")), t.innerHTML = cT(e), l)
    for (let r = 0; r < l.length; r++)
      t = t.querySelector(l[r]) || t;
  return t;
}
function hT(e) {
  let n = e.querySelectorAll(Gt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < n.length; t++) {
    let a = n[t];
    a.childNodes.length == 1 && a.textContent == " " && a.parentNode && a.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), a);
  }
}
function bT(e, n) {
  if (!e.size)
    return e;
  let t = e.content.firstChild.type.schema, a;
  try {
    a = JSON.parse(n);
  } catch {
    return e;
  }
  let { content: l, openStart: r, openEnd: o } = e;
  for (let i = a.length - 2; i >= 0; i -= 2) {
    let s = t.nodes[a[i]];
    if (!s || s.hasRequiredAttrs())
      break;
    l = Pe.from(s.create(a[i + 1], l)), r++, o++;
  }
  return new Je(l, r, o);
}
const rn = {}, on = {}, gT = { touchstart: !0, touchmove: !0 };
class mT {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function pT(e) {
  for (let n in rn) {
    let t = rn[n];
    e.dom.addEventListener(n, e.input.eventHandlers[n] = (a) => {
      xT(e, a) && !cc(e, a) && (e.editable || !(a.type in on)) && t(e, a);
    }, gT[n] ? { passive: !0 } : void 0);
  }
  _t && e.dom.addEventListener("input", () => null), Xd(e);
}
function Ia(e, n) {
  e.input.lastSelectionOrigin = n, e.input.lastSelectionTime = Date.now();
}
function vT(e) {
  e.domObserver.stop();
  for (let n in e.input.eventHandlers)
    e.dom.removeEventListener(n, e.input.eventHandlers[n]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Xd(e) {
  e.someProp("handleDOMEvents", (n) => {
    for (let t in n)
      e.input.eventHandlers[t] || e.dom.addEventListener(t, e.input.eventHandlers[t] = (a) => cc(e, a));
  });
}
function cc(e, n) {
  return e.someProp("handleDOMEvents", (t) => {
    let a = t[n.type];
    return a ? a(e, n) || n.defaultPrevented : !1;
  });
}
function xT(e, n) {
  if (!n.bubbles)
    return !0;
  if (n.defaultPrevented)
    return !1;
  for (let t = n.target; t != e.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(n))
      return !1;
  return !0;
}
function yT(e, n) {
  !cc(e, n) && rn[n.type] && (e.editable || !(n.type in on)) && rn[n.type](e, n);
}
on.keydown = (e, n) => {
  let t = n;
  if (e.input.shiftKey = t.keyCode == 16 || t.shiftKey, !ip(e, t) && (e.input.lastKeyCode = t.keyCode, e.input.lastKeyCodeTime = Date.now(), !(da && Gt && t.keyCode == 13)))
    if (t.keyCode != 229 && e.domObserver.forceFlush(), ql && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let a = Date.now();
      e.input.lastIOSEnter = a, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == a && (e.someProp("handleKeyDown", (l) => l(e, Xa(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (a) => a(e, t)) || sT(e, t) ? t.preventDefault() : Ia(e, "key");
};
on.keyup = (e, n) => {
  n.keyCode == 16 && (e.input.shiftKey = !1);
};
on.keypress = (e, n) => {
  let t = n;
  if (ip(e, t) || !t.charCode || t.ctrlKey && !t.altKey || yn && t.metaKey)
    return;
  if (e.someProp("handleKeyPress", (l) => l(e, t))) {
    t.preventDefault();
    return;
  }
  let a = e.state.selection;
  if (!(a instanceof at) || !a.$from.sameParent(a.$to)) {
    let l = String.fromCharCode(t.charCode), r = () => e.state.tr.insertText(l).scrollIntoView();
    !/[\r\n]/.test(l) && !e.someProp("handleTextInput", (o) => o(e, a.$from.pos, a.$to.pos, l, r)) && e.dispatch(r()), t.preventDefault();
  }
};
function is(e) {
  return { left: e.clientX, top: e.clientY };
}
function kT(e, n) {
  let t = n.x - e.clientX, a = n.y - e.clientY;
  return t * t + a * a < 100;
}
function fc(e, n, t, a, l) {
  if (a == -1)
    return !1;
  let r = e.state.doc.resolve(a);
  for (let o = r.depth + 1; o > 0; o--)
    if (e.someProp(n, (i) => o > r.depth ? i(e, t, r.nodeAfter, r.before(o), l, !0) : i(e, t, r.node(o), r.before(o), l, !1)))
      return !0;
  return !1;
}
function Bl(e, n, t) {
  if (e.focused || e.focus(), e.state.selection.eq(n))
    return;
  let a = e.state.tr.setSelection(n);
  a.setMeta("pointer", !0), e.dispatch(a);
}
function wT(e, n) {
  if (n == -1)
    return !1;
  let t = e.state.doc.resolve(n), a = t.nodeAfter;
  return a && a.isAtom && Qe.isSelectable(a) ? (Bl(e, new Qe(t)), !0) : !1;
}
function CT(e, n) {
  if (n == -1)
    return !1;
  let t = e.state.selection, a, l;
  t instanceof Qe && (a = t.node);
  let r = e.state.doc.resolve(n);
  for (let o = r.depth + 1; o > 0; o--) {
    let i = o > r.depth ? r.nodeAfter : r.node(o);
    if (Qe.isSelectable(i)) {
      a && t.$from.depth > 0 && o >= t.$from.depth && r.before(t.$from.depth + 1) == t.$from.pos ? l = r.before(t.$from.depth) : l = r.before(o);
      break;
    }
  }
  return l != null ? (Bl(e, Qe.create(e.state.doc, l)), !0) : !1;
}
function ST(e, n, t, a, l) {
  return fc(e, "handleClickOn", n, t, a) || e.someProp("handleClick", (r) => r(e, n, a)) || (l ? CT(e, t) : wT(e, t));
}
function $T(e, n, t, a) {
  return fc(e, "handleDoubleClickOn", n, t, a) || e.someProp("handleDoubleClick", (l) => l(e, n, a));
}
function IT(e, n, t, a) {
  return fc(e, "handleTripleClickOn", n, t, a) || e.someProp("handleTripleClick", (l) => l(e, n, a)) || TT(e, t, a);
}
function TT(e, n, t) {
  if (t.button != 0)
    return !1;
  let a = e.state.doc;
  if (n == -1)
    return a.inlineContent ? (Bl(e, at.create(a, 0, a.content.size)), !0) : !1;
  let l = a.resolve(n);
  for (let r = l.depth + 1; r > 0; r--) {
    let o = r > l.depth ? l.nodeAfter : l.node(r), i = l.before(r);
    if (o.inlineContent)
      Bl(e, at.create(a, i + 1, i + 1 + o.content.size));
    else if (Qe.isSelectable(o))
      Bl(e, Qe.create(a, i));
    else
      continue;
    return !0;
  }
}
function hc(e) {
  return fi(e);
}
const op = yn ? "metaKey" : "ctrlKey";
rn.mousedown = (e, n) => {
  let t = n;
  e.input.shiftKey = t.shiftKey;
  let a = hc(e), l = Date.now(), r = "singleClick";
  l - e.input.lastClick.time < 500 && kT(t, e.input.lastClick) && !t[op] && e.input.lastClick.button == t.button && (e.input.lastClick.type == "singleClick" ? r = "doubleClick" : e.input.lastClick.type == "doubleClick" && (r = "tripleClick")), e.input.lastClick = { time: l, x: t.clientX, y: t.clientY, type: r, button: t.button };
  let o = e.posAtCoords(is(t));
  o && (r == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new LT(e, o, t, !!a)) : (r == "doubleClick" ? $T : IT)(e, o.pos, o.inside, t) ? t.preventDefault() : Ia(e, "pointer"));
};
class LT {
  constructor(n, t, a, l) {
    this.view = n, this.pos = t, this.event = a, this.flushed = l, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = n.state.doc, this.selectNode = !!a[op], this.allowDefault = a.shiftKey;
    let r, o;
    if (t.inside > -1)
      r = n.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let u = n.state.doc.resolve(t.pos);
      r = u.parent, o = u.depth ? u.before() : 0;
    }
    const i = l ? null : a.target, s = i ? n.docView.nearestDesc(i, !0) : null;
    this.target = s && s.nodeDOM.nodeType == 1 ? s.nodeDOM : null;
    let { selection: d } = n.state;
    a.button == 0 && (r.type.spec.draggable && r.type.spec.selectable !== !1 || d instanceof Qe && d.from <= o && d.to > o) && (this.mightDrag = {
      node: r,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Tn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), n.root.addEventListener("mouseup", this.up = this.up.bind(this)), n.root.addEventListener("mousemove", this.move = this.move.bind(this)), Ia(n, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => ca(this.view)), this.view.input.mouseDown = null;
  }
  up(n) {
    if (this.done(), !this.view.dom.contains(n.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(is(n))), this.updateAllowDefault(n), this.allowDefault || !t ? Ia(this.view, "pointer") : ST(this.view, t.pos, t.inside, n, this.selectNode) ? n.preventDefault() : n.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    _t && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Gt && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Bl(this.view, rt.near(this.view.state.doc.resolve(t.pos))), n.preventDefault()) : Ia(this.view, "pointer");
  }
  move(n) {
    this.updateAllowDefault(n), Ia(this.view, "pointer"), n.buttons == 0 && this.done();
  }
  updateAllowDefault(n) {
    !this.allowDefault && (Math.abs(this.event.x - n.clientX) > 4 || Math.abs(this.event.y - n.clientY) > 4) && (this.allowDefault = !0);
  }
}
rn.touchstart = (e) => {
  e.input.lastTouch = Date.now(), hc(e), Ia(e, "pointer");
};
rn.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Ia(e, "pointer");
};
rn.contextmenu = (e) => hc(e);
function ip(e, n) {
  return e.composing ? !0 : _t && Math.abs(n.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const AT = da ? 5e3 : -1;
on.compositionstart = on.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: n } = e, t = n.selection.$to;
    if (n.selection instanceof at && (n.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((a) => a.type.spec.inclusive === !1) || Gt && Fm && ET(e)))
      e.markCursor = e.state.storedMarks || t.marks(), fi(e, !0), e.markCursor = null;
    else if (fi(e, !n.selection.empty), Tn && n.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let a = e.domSelectionRange();
      for (let l = a.focusNode, r = a.focusOffset; l && l.nodeType == 1 && r != 0; ) {
        let o = r < 0 ? l.lastChild : l.childNodes[r - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let i = e.domSelection();
          i && i.collapse(o, o.nodeValue.length);
          break;
        } else
          l = o, r = -1;
      }
    }
    e.input.composing = !0;
  }
  sp(e, AT);
};
function ET(e) {
  let { focusNode: n, focusOffset: t } = e.domSelectionRange();
  if (!n || n.nodeType != 1 || t >= n.childNodes.length)
    return !1;
  let a = n.childNodes[t];
  return a.nodeType == 1 && a.contentEditable == "false";
}
on.compositionend = (e, n) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = n.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, sp(e, 20));
};
function sp(e, n) {
  clearTimeout(e.input.composingTimeout), n > -1 && (e.input.composingTimeout = setTimeout(() => fi(e), n));
}
function dp(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = BT()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function RT(e) {
  let n = e.domSelectionRange();
  if (!n.focusNode)
    return null;
  let t = CI(n.focusNode, n.focusOffset), a = SI(n.focusNode, n.focusOffset);
  if (t && a && t != a) {
    let l = a.pmViewDesc, r = e.domObserver.lastChangedTextNode;
    if (t == r || a == r)
      return r;
    if (!l || !l.isText(a.nodeValue))
      return a;
    if (e.input.compositionNode == a) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return a;
    }
  }
  return t || a;
}
function BT() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function fi(e, n = !1) {
  if (!(da && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), dp(e), n || e.docView && e.docView.dirty) {
      let t = sc(e), a = e.state.selection;
      return t && !t.eq(a) ? e.dispatch(e.state.tr.setSelection(t)) : (e.markCursor || n) && !a.$from.node(a.$from.sharedDepth(a.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function DT(e, n) {
  if (!e.dom.parentNode)
    return;
  let t = e.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(n), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let a = getSelection(), l = document.createRange();
  l.selectNodeContents(n), e.dom.blur(), a.removeAllRanges(), a.addRange(l), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), e.focus();
  }, 50);
}
const Ur = cn && Ra < 15 || ql && LI < 604;
rn.copy = on.cut = (e, n) => {
  let t = n, a = e.state.selection, l = t.type == "cut";
  if (a.empty)
    return;
  let r = Ur ? null : t.clipboardData, o = a.content(), { dom: i, text: s } = uc(e, o);
  r ? (t.preventDefault(), r.clearData(), r.setData("text/html", i.innerHTML), r.setData("text/plain", s)) : DT(e, i), l && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function MT(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function zT(e, n) {
  if (!e.dom.parentNode)
    return;
  let t = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, a = e.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (a.contentEditable = "true"), a.style.cssText = "position: fixed; left: -10000px; top: 10px", a.focus();
  let l = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), a.parentNode && a.parentNode.removeChild(a), t ? Gr(e, a.value, null, l, n) : Gr(e, a.textContent, a.innerHTML, l, n);
  }, 50);
}
function Gr(e, n, t, a, l) {
  let r = ep(e, n, t, a, e.state.selection.$from);
  if (e.someProp("handlePaste", (s) => s(e, l, r || Je.empty)))
    return !0;
  if (!r)
    return !1;
  let o = MT(r), i = o ? e.state.tr.replaceSelectionWith(o, a) : e.state.tr.replaceSelection(r);
  return e.dispatch(i.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function up(e) {
  let n = e.getData("text/plain") || e.getData("Text");
  if (n)
    return n;
  let t = e.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
on.paste = (e, n) => {
  let t = n;
  if (e.composing && !da)
    return;
  let a = Ur ? null : t.clipboardData, l = e.input.shiftKey && e.input.lastKeyCode != 45;
  a && Gr(e, up(a), a.getData("text/html"), l, t) ? t.preventDefault() : zT(e, t);
};
class cp {
  constructor(n, t, a) {
    this.slice = n, this.move = t, this.node = a;
  }
}
const OT = yn ? "altKey" : "ctrlKey";
function fp(e, n) {
  let t;
  return e.someProp("dragCopies", (a) => {
    t = t || a(n);
  }), t != null ? !t : !n[OT];
}
rn.dragstart = (e, n) => {
  let t = n, a = e.input.mouseDown;
  if (a && a.done(), !t.dataTransfer)
    return;
  let l = e.state.selection, r = l.empty ? null : e.posAtCoords(is(t)), o;
  if (!(r && r.pos >= l.from && r.pos <= (l instanceof Qe ? l.to - 1 : l.to))) {
    if (a && a.mightDrag)
      o = Qe.create(e.state.doc, a.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let f = e.docView.nearestDesc(t.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (o = Qe.create(e.state.doc, f.posBefore));
    }
  }
  let i = (o || e.state.selection).content(), { dom: s, text: d, slice: u } = uc(e, i);
  (!t.dataTransfer.files.length || !Gt || Pm > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(Ur ? "Text" : "text/html", s.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Ur || t.dataTransfer.setData("text/plain", d), e.dragging = new cp(u, fp(e, t), o);
};
rn.dragend = (e) => {
  let n = e.dragging;
  window.setTimeout(() => {
    e.dragging == n && (e.dragging = null);
  }, 50);
};
on.dragover = on.dragenter = (e, n) => n.preventDefault();
on.drop = (e, n) => {
  try {
    PT(e, n, e.dragging);
  } finally {
    e.dragging = null;
  }
};
function PT(e, n, t) {
  if (!n.dataTransfer)
    return;
  let a = e.posAtCoords(is(n));
  if (!a)
    return;
  let l = e.state.doc.resolve(a.pos), r = t && t.slice;
  r ? e.someProp("transformPasted", (h) => {
    r = h(r, e, !1);
  }) : r = ep(e, up(n.dataTransfer), Ur ? null : n.dataTransfer.getData("text/html"), !1, l);
  let o = !!(t && fp(e, n));
  if (e.someProp("handleDrop", (h) => h(e, n, r || Je.empty, o))) {
    n.preventDefault();
    return;
  }
  if (!r)
    return;
  n.preventDefault();
  let i = r ? gm(e.state.doc, l.pos, r) : l.pos;
  i == null && (i = l.pos);
  let s = e.state.tr;
  if (o) {
    let { node: h } = t;
    h ? h.replace(s) : s.deleteSelection();
  }
  let d = s.mapping.map(i), u = r.openStart == 0 && r.openEnd == 0 && r.content.childCount == 1, f = s.doc;
  if (u ? s.replaceRangeWith(d, d, r.content.firstChild) : s.replaceRange(d, d, r), s.doc.eq(f))
    return;
  let b = s.doc.resolve(d);
  if (u && Qe.isSelectable(r.content.firstChild) && b.nodeAfter && b.nodeAfter.sameMarkup(r.content.firstChild))
    s.setSelection(new Qe(b));
  else {
    let h = s.mapping.map(i);
    s.mapping.maps[s.mapping.maps.length - 1].forEach((p, x, y, w) => h = w), s.setSelection(dc(e, b, s.doc.resolve(h)));
  }
  e.focus(), e.dispatch(s.setMeta("uiEvent", "drop"));
}
rn.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && ca(e);
  }, 20));
};
rn.blur = (e, n) => {
  let t = n;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), t.relatedTarget && e.dom.contains(t.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
rn.beforeinput = (e, n) => {
  if (Gt && da && n.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: a } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != a || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (r) => r(e, Xa(8, "Backspace")))))
        return;
      let { $cursor: l } = e.state.selection;
      l && l.pos > 0 && e.dispatch(e.state.tr.delete(l.pos - 1, l.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in on)
  rn[e] = on[e];
function Kr(e, n) {
  if (e == n)
    return !0;
  for (let t in e)
    if (e[t] !== n[t])
      return !1;
  for (let t in n)
    if (!(t in e))
      return !1;
  return !0;
}
class hi {
  constructor(n, t) {
    this.toDOM = n, this.spec = t || rl, this.side = this.spec.side || 0;
  }
  map(n, t, a, l) {
    let { pos: r, deleted: o } = n.mapResult(t.from + l, this.side < 0 ? -1 : 1);
    return o ? null : new an(r - a, r - a, this);
  }
  valid() {
    return !0;
  }
  eq(n) {
    return this == n || n instanceof hi && (this.spec.key && this.spec.key == n.spec.key || this.toDOM == n.toDOM && Kr(this.spec, n.spec));
  }
  destroy(n) {
    this.spec.destroy && this.spec.destroy(n);
  }
}
class Da {
  constructor(n, t) {
    this.attrs = n, this.spec = t || rl;
  }
  map(n, t, a, l) {
    let r = n.map(t.from + l, this.spec.inclusiveStart ? -1 : 1) - a, o = n.map(t.to + l, this.spec.inclusiveEnd ? 1 : -1) - a;
    return r >= o ? null : new an(r, o, this);
  }
  valid(n, t) {
    return t.from < t.to;
  }
  eq(n) {
    return this == n || n instanceof Da && Kr(this.attrs, n.attrs) && Kr(this.spec, n.spec);
  }
  static is(n) {
    return n.type instanceof Da;
  }
  destroy() {
  }
}
class bc {
  constructor(n, t) {
    this.attrs = n, this.spec = t || rl;
  }
  map(n, t, a, l) {
    let r = n.mapResult(t.from + l, 1);
    if (r.deleted)
      return null;
    let o = n.mapResult(t.to + l, -1);
    return o.deleted || o.pos <= r.pos ? null : new an(r.pos - a, o.pos - a, this);
  }
  valid(n, t) {
    let { index: a, offset: l } = n.content.findIndex(t.from), r;
    return l == t.from && !(r = n.child(a)).isText && l + r.nodeSize == t.to;
  }
  eq(n) {
    return this == n || n instanceof bc && Kr(this.attrs, n.attrs) && Kr(this.spec, n.spec);
  }
  destroy() {
  }
}
class an {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.from = n, this.to = t, this.type = a;
  }
  /**
  @internal
  */
  copy(n, t) {
    return new an(n, t, this.type);
  }
  /**
  @internal
  */
  eq(n, t = 0) {
    return this.type.eq(n.type) && this.from + t == n.from && this.to + t == n.to;
  }
  /**
  @internal
  */
  map(n, t, a) {
    return this.type.map(n, this, t, a);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(n, t, a) {
    return new an(n, n, new hi(t, a));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(n, t, a, l) {
    return new an(n, t, new Da(a, l));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(n, t, a, l) {
    return new an(n, t, new bc(a, l));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Da;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof hi;
  }
}
const Cl = [], rl = {};
class $t {
  /**
  @internal
  */
  constructor(n, t) {
    this.local = n.length ? n : Cl, this.children = t.length ? t : Cl;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(n, t) {
    return t.length ? bi(t, n, 0, rl) : Qt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(n, t, a) {
    let l = [];
    return this.findInner(n ?? 0, t ?? 1e9, l, 0, a), l;
  }
  findInner(n, t, a, l, r) {
    for (let o = 0; o < this.local.length; o++) {
      let i = this.local[o];
      i.from <= t && i.to >= n && (!r || r(i.spec)) && a.push(i.copy(i.from + l, i.to + l));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > n) {
        let i = this.children[o] + 1;
        this.children[o + 2].findInner(n - i, t - i, a, l + i, r);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(n, t, a) {
    return this == Qt || n.maps.length == 0 ? this : this.mapInner(n, t, 0, 0, a || rl);
  }
  /**
  @internal
  */
  mapInner(n, t, a, l, r) {
    let o;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i].map(n, a, l);
      s && s.type.valid(t, s) ? (o || (o = [])).push(s) : r.onRemove && r.onRemove(this.local[i].spec);
    }
    return this.children.length ? FT(this.children, o || [], n, t, a, l, r) : o ? new $t(o.sort(ol), Cl) : Qt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(n, t) {
    return t.length ? this == Qt ? $t.create(n, t) : this.addInner(n, t, 0) : this;
  }
  addInner(n, t, a) {
    let l, r = 0;
    n.forEach((i, s) => {
      let d = s + a, u;
      if (u = bp(t, i, d)) {
        for (l || (l = this.children.slice()); r < l.length && l[r] < s; )
          r += 3;
        l[r] == s ? l[r + 2] = l[r + 2].addInner(i, u, d + 1) : l.splice(r, 0, s, s + i.nodeSize, bi(u, i, d + 1, rl)), r += 3;
      }
    });
    let o = hp(r ? gp(t) : t, -a);
    for (let i = 0; i < o.length; i++)
      o[i].type.valid(n, o[i]) || o.splice(i--, 1);
    return new $t(o.length ? this.local.concat(o).sort(ol) : this.local, l || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(n) {
    return n.length == 0 || this == Qt ? this : this.removeInner(n, 0);
  }
  removeInner(n, t) {
    let a = this.children, l = this.local;
    for (let r = 0; r < a.length; r += 3) {
      let o, i = a[r] + t, s = a[r + 1] + t;
      for (let u = 0, f; u < n.length; u++)
        (f = n[u]) && f.from > i && f.to < s && (n[u] = null, (o || (o = [])).push(f));
      if (!o)
        continue;
      a == this.children && (a = this.children.slice());
      let d = a[r + 2].removeInner(o, i + 1);
      d != Qt ? a[r + 2] = d : (a.splice(r, 3), r -= 3);
    }
    if (l.length) {
      for (let r = 0, o; r < n.length; r++)
        if (o = n[r])
          for (let i = 0; i < l.length; i++)
            l[i].eq(o, t) && (l == this.local && (l = this.local.slice()), l.splice(i--, 1));
    }
    return a == this.children && l == this.local ? this : l.length || a.length ? new $t(l, a) : Qt;
  }
  forChild(n, t) {
    if (this == Qt)
      return this;
    if (t.isLeaf)
      return $t.empty;
    let a, l;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= n) {
        this.children[i] == n && (a = this.children[i + 2]);
        break;
      }
    let r = n + 1, o = r + t.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i];
      if (s.from < o && s.to > r && s.type instanceof Da) {
        let d = Math.max(r, s.from) - r, u = Math.min(o, s.to) - r;
        d < u && (l || (l = [])).push(s.copy(d, u));
      }
    }
    if (l) {
      let i = new $t(l.sort(ol), Cl);
      return a ? new Ca([i, a]) : i;
    }
    return a || Qt;
  }
  /**
  @internal
  */
  eq(n) {
    if (this == n)
      return !0;
    if (!(n instanceof $t) || this.local.length != n.local.length || this.children.length != n.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(n.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != n.children[t] || this.children[t + 1] != n.children[t + 1] || !this.children[t + 2].eq(n.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(n) {
    return gc(this.localsInner(n));
  }
  /**
  @internal
  */
  localsInner(n) {
    if (this == Qt)
      return Cl;
    if (n.inlineContent || !this.local.some(Da.is))
      return this.local;
    let t = [];
    for (let a = 0; a < this.local.length; a++)
      this.local[a].type instanceof Da || t.push(this.local[a]);
    return t;
  }
  forEachSet(n) {
    n(this);
  }
}
$t.empty = new $t([], []);
$t.removeOverlap = gc;
const Qt = $t.empty;
class Ca {
  constructor(n) {
    this.members = n;
  }
  map(n, t) {
    const a = this.members.map((l) => l.map(n, t, rl));
    return Ca.from(a);
  }
  forChild(n, t) {
    if (t.isLeaf)
      return $t.empty;
    let a = [];
    for (let l = 0; l < this.members.length; l++) {
      let r = this.members[l].forChild(n, t);
      r != Qt && (r instanceof Ca ? a = a.concat(r.members) : a.push(r));
    }
    return Ca.from(a);
  }
  eq(n) {
    if (!(n instanceof Ca) || n.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(n.members[t]))
        return !1;
    return !0;
  }
  locals(n) {
    let t, a = !0;
    for (let l = 0; l < this.members.length; l++) {
      let r = this.members[l].localsInner(n);
      if (r.length)
        if (!t)
          t = r;
        else {
          a && (t = t.slice(), a = !1);
          for (let o = 0; o < r.length; o++)
            t.push(r[o]);
        }
    }
    return t ? gc(a ? t : t.sort(ol)) : Cl;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(n) {
    switch (n.length) {
      case 0:
        return Qt;
      case 1:
        return n[0];
      default:
        return new Ca(n.every((t) => t instanceof $t) ? n : n.reduce((t, a) => t.concat(a instanceof $t ? a : a.members), []));
    }
  }
  forEachSet(n) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(n);
  }
}
function FT(e, n, t, a, l, r, o) {
  let i = e.slice();
  for (let d = 0, u = r; d < t.maps.length; d++) {
    let f = 0;
    t.maps[d].forEach((b, h, p, x) => {
      let y = x - p - (h - b);
      for (let w = 0; w < i.length; w += 3) {
        let $ = i[w + 1];
        if ($ < 0 || b > $ + u - f)
          continue;
        let S = i[w] + u - f;
        h >= S ? i[w + 1] = b <= S ? -2 : -1 : b >= u && y && (i[w] += y, i[w + 1] += y);
      }
      f += y;
    }), u = t.maps[d].map(u, -1);
  }
  let s = !1;
  for (let d = 0; d < i.length; d += 3)
    if (i[d + 1] < 0) {
      if (i[d + 1] == -2) {
        s = !0, i[d + 1] = -1;
        continue;
      }
      let u = t.map(e[d] + r), f = u - l;
      if (f < 0 || f >= a.content.size) {
        s = !0;
        continue;
      }
      let b = t.map(e[d + 1] + r, -1), h = b - l, { index: p, offset: x } = a.content.findIndex(f), y = a.maybeChild(p);
      if (y && x == f && x + y.nodeSize == h) {
        let w = i[d + 2].mapInner(t, y, u + 1, e[d] + r + 1, o);
        w != Qt ? (i[d] = f, i[d + 1] = h, i[d + 2] = w) : (i[d + 1] = -2, s = !0);
      } else
        s = !0;
    }
  if (s) {
    let d = VT(i, e, n, t, l, r, o), u = bi(d, a, 0, o);
    n = u.local;
    for (let f = 0; f < i.length; f += 3)
      i[f + 1] < 0 && (i.splice(f, 3), f -= 3);
    for (let f = 0, b = 0; f < u.children.length; f += 3) {
      let h = u.children[f];
      for (; b < i.length && i[b] < h; )
        b += 3;
      i.splice(b, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new $t(n.sort(ol), i);
}
function hp(e, n) {
  if (!n || !e.length)
    return e;
  let t = [];
  for (let a = 0; a < e.length; a++) {
    let l = e[a];
    t.push(new an(l.from + n, l.to + n, l.type));
  }
  return t;
}
function VT(e, n, t, a, l, r, o) {
  function i(s, d) {
    for (let u = 0; u < s.local.length; u++) {
      let f = s.local[u].map(a, l, d);
      f ? t.push(f) : o.onRemove && o.onRemove(s.local[u].spec);
    }
    for (let u = 0; u < s.children.length; u += 3)
      i(s.children[u + 2], s.children[u] + d + 1);
  }
  for (let s = 0; s < e.length; s += 3)
    e[s + 1] == -1 && i(e[s + 2], n[s] + r + 1);
  return t;
}
function bp(e, n, t) {
  if (n.isLeaf)
    return null;
  let a = t + n.nodeSize, l = null;
  for (let r = 0, o; r < e.length; r++)
    (o = e[r]) && o.from > t && o.to < a && ((l || (l = [])).push(o), e[r] = null);
  return l;
}
function gp(e) {
  let n = [];
  for (let t = 0; t < e.length; t++)
    e[t] != null && n.push(e[t]);
  return n;
}
function bi(e, n, t, a) {
  let l = [], r = !1;
  n.forEach((i, s) => {
    let d = bp(e, i, s + t);
    if (d) {
      r = !0;
      let u = bi(d, i, t + s + 1, a);
      u != Qt && l.push(s, s + i.nodeSize, u);
    }
  });
  let o = hp(r ? gp(e) : e, -t).sort(ol);
  for (let i = 0; i < o.length; i++)
    o[i].type.valid(n, o[i]) || (a.onRemove && a.onRemove(o[i].spec), o.splice(i--, 1));
  return o.length || l.length ? new $t(o, l) : Qt;
}
function ol(e, n) {
  return e.from - n.from || e.to - n.to;
}
function gc(e) {
  let n = e;
  for (let t = 0; t < n.length - 1; t++) {
    let a = n[t];
    if (a.from != a.to)
      for (let l = t + 1; l < n.length; l++) {
        let r = n[l];
        if (r.from == a.from) {
          r.to != a.to && (n == e && (n = e.slice()), n[l] = r.copy(r.from, a.to), ph(n, l + 1, r.copy(a.to, r.to)));
          continue;
        } else {
          r.from < a.to && (n == e && (n = e.slice()), n[t] = a.copy(a.from, r.from), ph(n, l, a.copy(r.from, a.to)));
          break;
        }
      }
  }
  return n;
}
function ph(e, n, t) {
  for (; n < e.length && ol(t, e[n]) > 0; )
    n++;
  e.splice(n, 0, t);
}
function qs(e) {
  let n = [];
  return e.someProp("decorations", (t) => {
    let a = t(e.state);
    a && a != Qt && n.push(a);
  }), e.cursorWrapper && n.push($t.create(e.state.doc, [e.cursorWrapper.deco])), Ca.from(n);
}
const NT = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, HT = cn && Ra <= 11;
class jT {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(n) {
    this.anchorNode = n.anchorNode, this.anchorOffset = n.anchorOffset, this.focusNode = n.focusNode, this.focusOffset = n.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(n) {
    return n.anchorNode == this.anchorNode && n.anchorOffset == this.anchorOffset && n.focusNode == this.focusNode && n.focusOffset == this.focusOffset;
  }
}
class WT {
  constructor(n, t) {
    this.view = n, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new jT(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((a) => {
      for (let l = 0; l < a.length; l++)
        this.queue.push(a[l]);
      cn && Ra <= 11 && a.some((l) => l.type == "childList" && l.removedNodes.length || l.type == "characterData" && l.oldValue.length > l.target.nodeValue.length) ? this.flushSoon() : _t && n.composing && a.some((l) => l.type == "childList" && l.target.nodeName == "TR") ? (n.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), HT && (this.onCharData = (a) => {
      this.queue.push({ target: a.target, type: "characterData", oldValue: a.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, NT)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let n = this.observer.takeRecords();
      if (n.length) {
        for (let t = 0; t < n.length; t++)
          this.queue.push(n[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (dh(this.view)) {
      if (this.suppressingSelectionUpdates)
        return ca(this.view);
      if (cn && Ra <= 11 && !this.view.state.selection.empty) {
        let n = this.view.domSelectionRange();
        if (n.focusNode && bl(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(n) {
    if (!n.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), a;
    for (let r = n.focusNode; r; r = Wl(r))
      t.add(r);
    for (let r = n.anchorNode; r; r = Wl(r))
      if (t.has(r)) {
        a = r;
        break;
      }
    let l = a && this.view.docView.nearestDesc(a);
    if (l && l.ignoreMutation({
      type: "selection",
      target: a.nodeType == 3 ? a.parentNode : a
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let n of this.observer.takeRecords())
        this.queue.push(n);
    return this.queue;
  }
  flush() {
    let { view: n } = this;
    if (!n.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let a = n.domSelectionRange(), l = !this.suppressingSelectionUpdates && !this.currentSelection.eq(a) && dh(n) && !this.ignoreSelectionChange(a), r = -1, o = -1, i = !1, s = [];
    if (n.editable)
      for (let u = 0; u < t.length; u++) {
        let f = this.registerMutation(t[u], s);
        f && (r = r < 0 ? f.from : Math.min(f.from, r), o = o < 0 ? f.to : Math.max(f.to, o), f.typeOver && (i = !0));
      }
    if (s.some((u) => u.nodeName == "BR") && (n.input.lastKeyCode == 8 || n.input.lastKeyCode == 46)) {
      for (let u of s)
        if (u.nodeName == "BR" && u.parentNode) {
          let f = u.nextSibling;
          for (; f && f.nodeType == 1; ) {
            if (f.contentEditable == "false") {
              u.parentNode.removeChild(u);
              break;
            }
            f = f.firstChild;
          }
        }
    } else if (Tn && s.length) {
      let u = s.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, b] = u;
        f.parentNode && f.parentNode.parentNode == b.parentNode ? b.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let b of u) {
          let h = b.parentNode;
          h && h.nodeName == "LI" && (!f || GT(n, f) != h) && b.remove();
        }
      }
    }
    let d = null;
    r < 0 && l && n.input.lastFocus > Date.now() - 200 && Math.max(n.input.lastTouch, n.input.lastClick.time) < Date.now() - 300 && ls(a) && (d = sc(n)) && d.eq(rt.near(n.state.doc.resolve(0), 1)) ? (n.input.lastFocus = 0, ca(n), this.currentSelection.set(a), n.scrollToSelection()) : (r > -1 || l) && (r > -1 && (n.docView.markDirty(r, o), qT(n)), n.input.badSafariComposition && (n.input.badSafariComposition = !1, KT(n, s)), this.handleDOMChange(r, o, i, s), n.docView && n.docView.dirty ? n.updateState(n.state) : this.currentSelection.eq(a) || ca(n), this.currentSelection.set(a));
  }
  registerMutation(n, t) {
    if (t.indexOf(n.target) > -1)
      return null;
    let a = this.view.docView.nearestDesc(n.target);
    if (n.type == "attributes" && (a == this.view.docView || n.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    n.attributeName == "style" && !n.oldValue && !n.target.getAttribute("style")) || !a || a.ignoreMutation(n))
      return null;
    if (n.type == "childList") {
      for (let u = 0; u < n.addedNodes.length; u++) {
        let f = n.addedNodes[u];
        t.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (a.contentDOM && a.contentDOM != a.dom && !a.contentDOM.contains(n.target))
        return { from: a.posBefore, to: a.posAfter };
      let l = n.previousSibling, r = n.nextSibling;
      if (cn && Ra <= 11 && n.addedNodes.length)
        for (let u = 0; u < n.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: b } = n.addedNodes[u];
          (!f || Array.prototype.indexOf.call(n.addedNodes, f) < 0) && (l = f), (!b || Array.prototype.indexOf.call(n.addedNodes, b) < 0) && (r = b);
        }
      let o = l && l.parentNode == n.target ? qt(l) + 1 : 0, i = a.localPosFromDOM(n.target, o, -1), s = r && r.parentNode == n.target ? qt(r) : n.target.childNodes.length, d = a.localPosFromDOM(n.target, s, 1);
      return { from: i, to: d };
    } else return n.type == "attributes" ? { from: a.posAtStart - a.border, to: a.posAtEnd + a.border } : (this.lastChangedTextNode = n.target, {
      from: a.posAtStart,
      to: a.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: n.target.nodeValue == n.oldValue
    });
  }
}
let vh = /* @__PURE__ */ new WeakMap(), xh = !1;
function qT(e) {
  if (!vh.has(e) && (vh.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = Tn, xh)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), xh = !0;
  }
}
function yh(e, n) {
  let t = n.startContainer, a = n.startOffset, l = n.endContainer, r = n.endOffset, o = e.domAtPos(e.state.selection.anchor);
  return bl(o.node, o.offset, l, r) && ([t, a, l, r] = [l, r, t, a]), { anchorNode: t, anchorOffset: a, focusNode: l, focusOffset: r };
}
function UT(e, n) {
  if (n.getComposedRanges) {
    let l = n.getComposedRanges(e.root)[0];
    if (l)
      return yh(e, l);
  }
  let t;
  function a(l) {
    l.preventDefault(), l.stopImmediatePropagation(), t = l.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", a, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", a, !0), t ? yh(e, t) : null;
}
function GT(e, n) {
  for (let t = n.parentNode; t && t != e.dom; t = t.parentNode) {
    let a = e.docView.nearestDesc(t, !0);
    if (a && a.node.isBlock)
      return t;
  }
  return null;
}
function KT(e, n) {
  var t;
  let { focusNode: a, focusOffset: l } = e.domSelectionRange();
  for (let r of n)
    if (((t = r.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let o = r.nextSibling;
      for (; o && o.nodeName != "TD" && o.nodeName != "TH"; )
        o = o.nextSibling;
      if (o) {
        let i = o;
        for (; ; ) {
          let s = i.firstChild;
          if (!s || s.nodeType != 1 || s.contentEditable == "false" || /^(BR|IMG)$/.test(s.nodeName))
            break;
          i = s;
        }
        i.insertBefore(r, i.firstChild), a == r && e.domSelection().collapse(r, l);
      } else
        r.parentNode.removeChild(r);
    }
}
function YT(e, n, t) {
  let { node: a, fromOffset: l, toOffset: r, from: o, to: i } = e.docView.parseRange(n, t), s = e.domSelectionRange(), d, u = s.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: s.anchorOffset }], ls(s) || d.push({ node: s.focusNode, offset: s.focusOffset })), Gt && e.input.lastKeyCode === 8)
    for (let y = r; y > l; y--) {
      let w = a.childNodes[y - 1], $ = w.pmViewDesc;
      if (w.nodeName == "BR" && !$) {
        r = y;
        break;
      }
      if (!$ || $.size)
        break;
    }
  let f = e.state.doc, b = e.someProp("domParser") || Ea.fromSchema(e.state.schema), h = f.resolve(o), p = null, x = b.parse(a, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: l,
    to: r,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: JT,
    context: h
  });
  if (d && d[0].pos != null) {
    let y = d[0].pos, w = d[1] && d[1].pos;
    w == null && (w = y), p = { anchor: y + o, head: w + o };
  }
  return { doc: x, sel: p, from: o, to: i };
}
function JT(e) {
  let n = e.pmViewDesc;
  if (n)
    return n.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (_t && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (e.parentNode.lastChild == e || _t && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const XT = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function ZT(e, n, t, a, l) {
  let r = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, n < 0) {
    let A = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, D = sc(e, A);
    if (D && !e.state.selection.eq(D)) {
      if (Gt && da && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (F) => F(e, Xa(13, "Enter"))))
        return;
      let M = e.state.tr.setSelection(D);
      A == "pointer" ? M.setMeta("pointer", !0) : A == "key" && M.scrollIntoView(), r && M.setMeta("composition", r), e.dispatch(M);
    }
    return;
  }
  let o = e.state.doc.resolve(n), i = o.sharedDepth(t);
  n = o.before(i + 1), t = e.state.doc.resolve(t).after(i + 1);
  let s = e.state.selection, d = YT(e, n, t), u = e.state.doc, f = u.slice(d.from, d.to), b, h;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (b = e.state.selection.to, h = "end") : (b = e.state.selection.from, h = "start"), e.input.lastKeyCode = null;
  let p = eL(f.content, d.doc.content, d.from, b, h);
  if (p && e.input.domChangeCount++, (ql && e.input.lastIOSEnter > Date.now() - 225 || da) && l.some((A) => A.nodeType == 1 && !XT.test(A.nodeName)) && (!p || p.endA >= p.endB) && e.someProp("handleKeyDown", (A) => A(e, Xa(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (a && s instanceof at && !s.empty && s.$head.sameParent(s.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      p = { start: s.from, endA: s.to, endB: s.to };
    else {
      if (d.sel) {
        let A = kh(e, e.state.doc, d.sel);
        if (A && !A.eq(e.state.selection)) {
          let D = e.state.tr.setSelection(A);
          r && D.setMeta("composition", r), e.dispatch(D);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && p.start == p.endB && e.state.selection instanceof at && (p.start > e.state.selection.from && p.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? p.start = e.state.selection.from : p.endA < e.state.selection.to && p.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (p.endB += e.state.selection.to - p.endA, p.endA = e.state.selection.to)), cn && Ra <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > d.from && d.doc.textBetween(p.start - d.from - 1, p.start - d.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let x = d.doc.resolveNoCache(p.start - d.from), y = d.doc.resolveNoCache(p.endB - d.from), w = u.resolve(p.start), $ = x.sameParent(y) && x.parent.inlineContent && w.end() >= p.endA;
  if ((ql && e.input.lastIOSEnter > Date.now() - 225 && (!$ || l.some((A) => A.nodeName == "DIV" || A.nodeName == "P")) || !$ && x.pos < d.doc.content.size && (!x.sameParent(y) || !x.parent.inlineContent) && x.pos < y.pos && !/\S/.test(d.doc.textBetween(x.pos, y.pos, "", ""))) && e.someProp("handleKeyDown", (A) => A(e, Xa(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > p.start && _T(u, p.start, p.endA, x, y) && e.someProp("handleKeyDown", (A) => A(e, Xa(8, "Backspace")))) {
    da && Gt && e.domObserver.suppressSelectionUpdates();
    return;
  }
  Gt && p.endB == p.start && (e.input.lastChromeDelete = Date.now()), da && !$ && x.start() != y.start() && y.parentOffset == 0 && x.depth == y.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == p.endA && (p.endB -= 2, y = d.doc.resolveNoCache(p.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(A) {
      return A(e, Xa(13, "Enter"));
    });
  }, 20));
  let S = p.start, L = p.endA, T = (A) => {
    let D = A || e.state.tr.replace(S, L, d.doc.slice(p.start - d.from, p.endB - d.from));
    if (d.sel) {
      let M = kh(e, D.doc, d.sel);
      M && !(Gt && e.composing && M.empty && (p.start != p.endB || e.input.lastChromeDelete < Date.now() - 100) && (M.head == S || M.head == D.mapping.map(L) - 1) || cn && M.empty && M.head == S) && D.setSelection(M);
    }
    return r && D.setMeta("composition", r), D.scrollIntoView();
  }, E;
  if ($)
    if (x.pos == y.pos) {
      cn && Ra <= 11 && x.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => ca(e), 20));
      let A = T(e.state.tr.delete(S, L)), D = u.resolve(p.start).marksAcross(u.resolve(p.endA));
      D && A.ensureMarks(D), e.dispatch(A);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (E = QT(x.parent.content.cut(x.parentOffset, y.parentOffset), w.parent.content.cut(w.parentOffset, p.endA - w.start())))
    ) {
      let A = T(e.state.tr);
      E.type == "add" ? A.addMark(S, L, E.mark) : A.removeMark(S, L, E.mark), e.dispatch(A);
    } else if (x.parent.child(x.index()).isText && x.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let A = x.parent.textBetween(x.parentOffset, y.parentOffset), D = () => T(e.state.tr.insertText(A, S, L));
      e.someProp("handleTextInput", (M) => M(e, S, L, A, D)) || e.dispatch(D());
    } else
      e.dispatch(T());
  else
    e.dispatch(T());
}
function kh(e, n, t) {
  return Math.max(t.anchor, t.head) > n.content.size ? null : dc(e, n.resolve(t.anchor), n.resolve(t.head));
}
function QT(e, n) {
  let t = e.firstChild.marks, a = n.firstChild.marks, l = t, r = a, o, i, s;
  for (let u = 0; u < a.length; u++)
    l = a[u].removeFromSet(l);
  for (let u = 0; u < t.length; u++)
    r = t[u].removeFromSet(r);
  if (l.length == 1 && r.length == 0)
    i = l[0], o = "add", s = (u) => u.mark(i.addToSet(u.marks));
  else if (l.length == 0 && r.length == 1)
    i = r[0], o = "remove", s = (u) => u.mark(i.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < n.childCount; u++)
    d.push(s(n.child(u)));
  if (Pe.from(d).eq(e))
    return { mark: i, type: o };
}
function _T(e, n, t, a, l) {
  if (
    // The content must have shrunk
    t - n <= l.pos - a.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Us(a, !0, !1) < l.pos
  )
    return !1;
  let r = e.resolve(n);
  if (!a.parent.isTextblock) {
    let i = r.nodeAfter;
    return i != null && t == n + i.nodeSize;
  }
  if (r.parentOffset < r.parent.content.size || !r.parent.isTextblock)
    return !1;
  let o = e.resolve(Us(r, !0, !0));
  return !o.parent.isTextblock || o.pos > t || Us(o, !0, !1) < t ? !1 : a.parent.content.cut(a.parentOffset).eq(o.parent.content);
}
function Us(e, n, t) {
  let a = e.depth, l = n ? e.end() : e.pos;
  for (; a > 0 && (n || e.indexAfter(a) == e.node(a).childCount); )
    a--, l++, n = !1;
  if (t) {
    let r = e.node(a).maybeChild(e.indexAfter(a));
    for (; r && !r.isLeaf; )
      r = r.firstChild, l++;
  }
  return l;
}
function eL(e, n, t, a, l) {
  let r = e.findDiffStart(n, t);
  if (r == null)
    return null;
  let { a: o, b: i } = e.findDiffEnd(n, t + e.size, t + n.size);
  if (l == "end") {
    let s = Math.max(0, r - Math.min(o, i));
    a -= o + s - r;
  }
  if (o < r && e.size < n.size) {
    let s = a <= r && a >= o ? r - a : 0;
    r -= s, r && r < n.size && wh(n.textBetween(r - 1, r + 1)) && (r += s ? 1 : -1), i = r + (i - o), o = r;
  } else if (i < r) {
    let s = a <= r && a >= i ? r - a : 0;
    r -= s, r && r < e.size && wh(e.textBetween(r - 1, r + 1)) && (r += s ? 1 : -1), o = r + (o - i), i = r;
  }
  return { start: r, endA: o, endB: i };
}
function wh(e) {
  if (e.length != 2)
    return !1;
  let n = e.charCodeAt(0), t = e.charCodeAt(1);
  return n >= 56320 && n <= 57343 && t >= 55296 && t <= 56319;
}
class mp {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(n, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new mT(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Th), this.dispatch = this.dispatch.bind(this), this.dom = n && n.mount || document.createElement("div"), n && (n.appendChild ? n.appendChild(this.dom) : typeof n == "function" ? n(this.dom) : n.mount && (this.mounted = !0)), this.editable = $h(this), Sh(this), this.nodeViews = Ih(this), this.docView = ah(this.state.doc, Ch(this), qs(this), this.dom, this), this.domObserver = new WT(this, (a, l, r, o) => ZT(this, a, l, r, o)), this.domObserver.start(), pT(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let n = this._props;
      this._props = {};
      for (let t in n)
        this._props[t] = n[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(n) {
    n.handleDOMEvents != this._props.handleDOMEvents && Xd(this);
    let t = this._props;
    this._props = n, n.plugins && (n.plugins.forEach(Th), this.directPlugins = n.plugins), this.updateStateInner(n.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(n) {
    let t = {};
    for (let a in this._props)
      t[a] = this._props[a];
    t.state = this.state;
    for (let a in n)
      t[a] = n[a];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(n) {
    this.updateStateInner(n, this._props);
  }
  updateStateInner(n, t) {
    var a;
    let l = this.state, r = !1, o = !1;
    n.storedMarks && this.composing && (dp(this), o = !0), this.state = n;
    let i = l.plugins != n.plugins || this._props.plugins != t.plugins;
    if (i || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = Ih(this);
      nL(h, this.nodeViews) && (this.nodeViews = h, r = !0);
    }
    (i || t.handleDOMEvents != this._props.handleDOMEvents) && Xd(this), this.editable = $h(this), Sh(this);
    let s = qs(this), d = Ch(this), u = l.plugins != n.plugins && !l.doc.eq(n.doc) ? "reset" : n.scrollToSelection > l.scrollToSelection ? "to selection" : "preserve", f = r || !this.docView.matchesNode(n.doc, d, s);
    (f || !n.selection.eq(l.selection)) && (o = !0);
    let b = u == "preserve" && o && this.dom.style.overflowAnchor == null && RI(this);
    if (o) {
      this.domObserver.stop();
      let h = f && (cn || Gt) && !this.composing && !l.selection.empty && !n.selection.empty && tL(l.selection, n.selection);
      if (f) {
        let p = Gt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = RT(this)), (r || !this.docView.update(n.doc, d, s, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = ah(n.doc, d, s, this.dom, this)), p && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && tT(this)) ? ca(this, h) : (Zm(this, n.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(l), !((a = this.dragging) === null || a === void 0) && a.node && !l.doc.eq(n.doc) && this.updateDraggedNode(this.dragging, l), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : b && BI(b);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let n = this.domSelectionRange().focusNode;
    if (!(!n || !this.dom.contains(n.nodeType == 1 ? n : n.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof Qe) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Zf(this, t.getBoundingClientRect(), n);
      } else
        Zf(this, this.coordsAtPos(this.state.selection.head, 1), n);
    }
  }
  destroyPluginViews() {
    let n;
    for (; n = this.pluginViews.pop(); )
      n.destroy && n.destroy();
  }
  updatePluginViews(n) {
    if (!n || n.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let a = this.directPlugins[t];
        a.spec.view && this.pluginViews.push(a.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let a = this.state.plugins[t];
        a.spec.view && this.pluginViews.push(a.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let a = this.pluginViews[t];
        a.update && a.update(this, n);
      }
  }
  updateDraggedNode(n, t) {
    let a = n.node, l = -1;
    if (a.from < this.state.doc.content.size && this.state.doc.nodeAt(a.from) == a.node)
      l = a.from;
    else {
      let r = a.from + (this.state.doc.content.size - t.doc.content.size);
      (r > 0 && r < this.state.doc.content.size && this.state.doc.nodeAt(r)) == a.node && (l = r);
    }
    this.dragging = new cp(n.slice, n.move, l < 0 ? void 0 : Qe.create(this.state.doc, l));
  }
  someProp(n, t) {
    let a = this._props && this._props[n], l;
    if (a != null && (l = t ? t(a) : a))
      return l;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let i = this.directPlugins[o].props[n];
      if (i != null && (l = t ? t(i) : i))
        return l;
    }
    let r = this.state.plugins;
    if (r)
      for (let o = 0; o < r.length; o++) {
        let i = r[o].props[n];
        if (i != null && (l = t ? t(i) : i))
          return l;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (cn) {
      let n = this.root.activeElement;
      if (n == this.dom)
        return !0;
      if (!n || !this.dom.contains(n))
        return !1;
      for (; n && this.dom != n && this.dom.contains(n); ) {
        if (n.contentEditable == "false")
          return !1;
        n = n.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && DI(this.dom), ca(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let n = this._root;
    if (n == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return n || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(n) {
    return FI(this, n);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(n, t = 1) {
    return Wm(this, n, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(n, t = 0) {
    return this.docView.domFromPos(n, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(n) {
    let t = this.docView.descAt(n);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(n, t, a = -1) {
    let l = this.docView.posFromDOM(n, t, a);
    if (l == null)
      throw new RangeError("DOM position not inside the editor");
    return l;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(n, t) {
    return WI(this, t || this.state, n);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(n, t) {
    return Gr(this, "", n, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(n, t) {
    return Gr(this, n, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(n) {
    return uc(this, n);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (vT(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], qs(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, kI());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(n) {
    return yT(this, n);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let n = this.domSelection();
    return n ? _t && this.root.nodeType === 11 && II(this.dom.ownerDocument) == this.dom && UT(this, n) || n : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
mp.prototype.dispatch = function(e) {
  let n = this._props.dispatchTransaction;
  n ? n.call(this, e) : this.updateState(this.state.apply(e));
};
function Ch(e) {
  let n = /* @__PURE__ */ Object.create(null);
  return n.class = "ProseMirror", n.contenteditable = String(e.editable), e.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(e.state)), t)
      for (let a in t)
        a == "class" ? n.class += " " + t[a] : a == "style" ? n.style = (n.style ? n.style + ";" : "") + t[a] : !n[a] && a != "contenteditable" && a != "nodeName" && (n[a] = String(t[a]));
  }), n.translate || (n.translate = "no"), [an.node(0, e.state.doc.content.size, n)];
}
function Sh(e) {
  if (e.markCursor) {
    let n = document.createElement("img");
    n.className = "ProseMirror-separator", n.setAttribute("mark-placeholder", "true"), n.setAttribute("alt", ""), e.cursorWrapper = { dom: n, deco: an.widget(e.state.selection.from, n, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function $h(e) {
  return !e.someProp("editable", (n) => n(e.state) === !1);
}
function tL(e, n) {
  let t = Math.min(e.$anchor.sharedDepth(e.head), n.$anchor.sharedDepth(n.head));
  return e.$anchor.start(t) != n.$anchor.start(t);
}
function Ih(e) {
  let n = /* @__PURE__ */ Object.create(null);
  function t(a) {
    for (let l in a)
      Object.prototype.hasOwnProperty.call(n, l) || (n[l] = a[l]);
  }
  return e.someProp("nodeViews", t), e.someProp("markViews", t), n;
}
function nL(e, n) {
  let t = 0, a = 0;
  for (let l in e) {
    if (e[l] != n[l])
      return !0;
    t++;
  }
  for (let l in n)
    a++;
  return t != a;
}
function Th(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Oa = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, gi = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, aL = typeof navigator < "u" && /Mac/.test(navigator.platform), lL = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ut = 0; Ut < 10; Ut++) Oa[48 + Ut] = Oa[96 + Ut] = String(Ut);
for (var Ut = 1; Ut <= 24; Ut++) Oa[Ut + 111] = "F" + Ut;
for (var Ut = 65; Ut <= 90; Ut++)
  Oa[Ut] = String.fromCharCode(Ut + 32), gi[Ut] = String.fromCharCode(Ut);
for (var Gs in Oa) gi.hasOwnProperty(Gs) || (gi[Gs] = Oa[Gs]);
function rL(e) {
  var n = aL && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || lL && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", t = !n && e.key || (e.shiftKey ? gi : Oa)[e.keyCode] || e.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const oL = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), iL = typeof navigator < "u" && /Win/.test(navigator.platform);
function sL(e) {
  let n = e.split(/-(?!$)/), t = n[n.length - 1];
  t == "Space" && (t = " ");
  let a, l, r, o;
  for (let i = 0; i < n.length - 1; i++) {
    let s = n[i];
    if (/^(cmd|meta|m)$/i.test(s))
      o = !0;
    else if (/^a(lt)?$/i.test(s))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      r = !0;
    else if (/^mod$/i.test(s))
      oL ? o = !0 : l = !0;
    else
      throw new Error("Unrecognized modifier name: " + s);
  }
  return a && (t = "Alt-" + t), l && (t = "Ctrl-" + t), o && (t = "Meta-" + t), r && (t = "Shift-" + t), t;
}
function dL(e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e)
    n[sL(t)] = e[t];
  return n;
}
function Ks(e, n, t = !0) {
  return n.altKey && (e = "Alt-" + e), n.ctrlKey && (e = "Ctrl-" + e), n.metaKey && (e = "Meta-" + e), t && n.shiftKey && (e = "Shift-" + e), e;
}
function uL(e) {
  return new Tt({ props: { handleKeyDown: pp(e) } });
}
function pp(e) {
  let n = dL(e);
  return function(t, a) {
    let l = rL(a), r, o = n[Ks(l, a)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (l.length == 1 && l != " ") {
      if (a.shiftKey) {
        let i = n[Ks(l, a, !1)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
      if ((a.altKey || a.metaKey || a.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(iL && a.ctrlKey && a.altKey) && (r = Oa[a.keyCode]) && r != l) {
        let i = n[Ks(r, a)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var cL = Object.defineProperty, mc = (e, n) => {
  for (var t in n)
    cL(e, t, { get: n[t], enumerable: !0 });
};
function ss(e) {
  const { state: n, transaction: t } = e;
  let { selection: a } = t, { doc: l } = t, { storedMarks: r } = t;
  return {
    ...n,
    apply: n.apply.bind(n),
    applyTransaction: n.applyTransaction.bind(n),
    plugins: n.plugins,
    schema: n.schema,
    reconfigure: n.reconfigure.bind(n),
    toJSON: n.toJSON.bind(n),
    get storedMarks() {
      return r;
    },
    get selection() {
      return a;
    },
    get doc() {
      return l;
    },
    get tr() {
      return a = t.selection, l = t.doc, r = t.storedMarks, t;
    }
  };
}
var ds = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: t } = this, { view: a } = n, { tr: l } = t, r = this.buildProps(l);
    return Object.fromEntries(
      Object.entries(e).map(([o, i]) => [o, (...d) => {
        const u = i(...d)(r);
        return !l.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(l), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: t, editor: a, state: l } = this, { view: r } = a, o = [], i = !!e, s = e || l.tr, d = () => (!i && n && !s.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(s), o.every((f) => f === !0)), u = {
      ...Object.fromEntries(
        Object.entries(t).map(([f, b]) => [f, (...p) => {
          const x = this.buildProps(s, n), y = b(...p)(x);
          return o.push(y), u;
        }])
      ),
      run: d
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: n, state: t } = this, a = !1, l = e || t.tr, r = this.buildProps(l, a);
    return {
      ...Object.fromEntries(
        Object.entries(n).map(([i, s]) => [i, (...d) => s(...d)({ ...r, dispatch: void 0 })])
      ),
      chain: () => this.createChain(l, a)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: t, editor: a, state: l } = this, { view: r } = a, o = {
      tr: e,
      editor: a,
      view: r,
      state: ss({
        state: l,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([i, s]) => [i, (...d) => s(...d)(o)])
        );
      }
    };
    return o;
  }
}, vp = {};
mc(vp, {
  blur: () => fL,
  clearContent: () => hL,
  clearNodes: () => bL,
  command: () => gL,
  createParagraphNear: () => mL,
  cut: () => pL,
  deleteCurrentNode: () => vL,
  deleteNode: () => xL,
  deleteRange: () => yL,
  deleteSelection: () => CL,
  enter: () => SL,
  exitCode: () => $L,
  extendMarkRange: () => IL,
  first: () => TL,
  focus: () => AL,
  forEach: () => EL,
  insertContent: () => RL,
  insertContentAt: () => ML,
  joinBackward: () => PL,
  joinDown: () => OL,
  joinForward: () => FL,
  joinItemBackward: () => VL,
  joinItemForward: () => NL,
  joinTextblockBackward: () => HL,
  joinTextblockForward: () => jL,
  joinUp: () => zL,
  keyboardShortcut: () => qL,
  lift: () => UL,
  liftEmptyBlock: () => GL,
  liftListItem: () => KL,
  newlineInCode: () => YL,
  resetAttributes: () => JL,
  scrollIntoView: () => XL,
  selectAll: () => ZL,
  selectNodeBackward: () => QL,
  selectNodeForward: () => _L,
  selectParentNode: () => eA,
  selectTextblockEnd: () => tA,
  selectTextblockStart: () => nA,
  setContent: () => aA,
  setMark: () => SA,
  setMeta: () => $A,
  setNode: () => IA,
  setNodeSelection: () => TA,
  setTextDirection: () => LA,
  setTextSelection: () => AA,
  sinkListItem: () => EA,
  splitBlock: () => RA,
  splitListItem: () => BA,
  toggleList: () => MA,
  toggleMark: () => zA,
  toggleNode: () => OA,
  toggleWrap: () => PA,
  undoInputRule: () => FA,
  unsetAllMarks: () => VA,
  unsetMark: () => NA,
  unsetTextDirection: () => HA,
  updateAttributes: () => jA,
  wrapIn: () => WA,
  wrapInList: () => qA
});
var fL = () => ({ editor: e, view: n }) => (requestAnimationFrame(() => {
  var t;
  e.isDestroyed || (n.dom.blur(), (t = window == null ? void 0 : window.getSelection()) == null || t.removeAllRanges());
}), !0), hL = (e = !0) => ({ commands: n }) => n.setContent("", { emitUpdate: e }), bL = () => ({ state: e, tr: n, dispatch: t }) => {
  const { selection: a } = n, { ranges: l } = a;
  return t && l.forEach(({ $from: r, $to: o }) => {
    e.doc.nodesBetween(r.pos, o.pos, (i, s) => {
      if (i.type.isText)
        return;
      const { doc: d, mapping: u } = n, f = d.resolve(u.map(s)), b = d.resolve(u.map(s + i.nodeSize)), h = f.blockRange(b);
      if (!h)
        return;
      const p = Ql(h);
      if (i.type.isTextblock) {
        const { defaultType: x } = f.parent.contentMatchAt(f.index());
        n.setNodeMarkup(h.start, x);
      }
      (p || p === 0) && n.lift(h, p);
    });
  }), !0;
}, gL = (e) => (n) => e(n), mL = () => ({ state: e, dispatch: n }) => Bm(e, n), pL = (e, n) => ({ editor: t, tr: a }) => {
  const { state: l } = t, r = l.doc.slice(e.from, e.to);
  a.deleteRange(e.from, e.to);
  const o = a.mapping.map(n);
  return a.insert(o, r.content), a.setSelection(new at(a.doc.resolve(Math.max(o - 1, 0)))), !0;
}, vL = () => ({ tr: e, dispatch: n }) => {
  const { selection: t } = e, a = t.$anchor.node();
  if (a.content.size > 0)
    return !1;
  const l = e.selection.$anchor;
  for (let r = l.depth; r > 0; r -= 1)
    if (l.node(r).type === a.type) {
      if (n) {
        const i = l.before(r), s = l.after(r);
        e.delete(i, s).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function zt(e, n) {
  if (typeof e == "string") {
    if (!n.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return n.nodes[e];
  }
  return e;
}
var xL = (e) => ({ tr: n, state: t, dispatch: a }) => {
  const l = zt(e, t.schema), r = n.selection.$anchor;
  for (let o = r.depth; o > 0; o -= 1)
    if (r.node(o).type === l) {
      if (a) {
        const s = r.before(o), d = r.after(o);
        n.delete(s, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, yL = (e) => ({ tr: n, dispatch: t }) => {
  const { from: a, to: l } = e;
  return t && n.delete(a, l), !0;
}, kL = (e) => e.content ? /^text(\*|\+)/.test(e.content) : !1, Lh = (e, n, t) => {
  if (!e.parent.isInline || t === "left" && e.pos > e.start() || t === "right" && e.pos < e.end())
    return e.pos;
  const a = n.nodes[e.parent.type.name].spec;
  return kL(a) ? t === "left" ? e.start() - 1 : e.end() + 1 : e.pos;
}, wL = (e, n, t) => {
  const a = Lh(e, t, "left"), l = Lh(n, t, "right");
  return { from: a, to: l };
}, CL = () => ({ state: e, dispatch: n }) => {
  const { $from: t, $to: a } = e.selection;
  if (e.selection.empty)
    return !1;
  const { from: l, to: r } = wL(t, a, e.schema);
  return n && (e.tr.deleteRange(l, r).scrollIntoView(), n(e.tr)), !0;
}, SL = () => ({ commands: e }) => e.keyboardShortcut("Enter"), $L = () => ({ state: e, dispatch: n }) => oI(e, n);
function pc(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function mi(e, n, t = { strict: !0 }) {
  const a = Object.keys(n);
  return a.length ? a.every((l) => t.strict ? n[l] === e[l] : pc(n[l]) ? n[l].test(e[l]) : n[l] === e[l]) : !0;
}
function xp(e, n, t = {}) {
  return e.find((a) => a.type === n && mi(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((l) => [l, a.attrs[l]])),
    t
  ));
}
function Ah(e, n, t = {}) {
  return !!xp(e, n, t);
}
function vc(e, n, t) {
  if (!e || !n)
    return;
  let a = e.parent.childAfter(e.parentOffset);
  if ((!a.node || !a.node.marks.some((d) => d.type === n)) && (a = e.parent.childBefore(e.parentOffset)), !a.node || !a.node.marks.some((d) => d.type === n))
    return;
  if (!t) {
    const d = a.node.marks.find((u) => u.type === n);
    d && (t = d.attrs);
  }
  if (!xp([...a.node.marks], n, t))
    return;
  let r = a.index, o = e.start() + a.offset, i = r + 1, s = o + a.node.nodeSize;
  for (; r > 0 && Ah([...e.parent.child(r - 1).marks], n, t); )
    r -= 1, o -= e.parent.child(r).nodeSize;
  for (; i < e.parent.childCount && Ah([...e.parent.child(i).marks], n, t); )
    s += e.parent.child(i).nodeSize, i += 1;
  return {
    from: o,
    to: s
  };
}
function ga(e, n) {
  if (typeof e == "string") {
    if (!n.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return n.marks[e];
  }
  return e;
}
var IL = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  const r = ga(e, a.schema), { doc: o, selection: i } = t, { $from: s, from: d, to: u } = i;
  if (l) {
    const f = vc(s, r, n);
    if (f && f.from <= d && f.to >= u) {
      const b = at.create(o, f.from, f.to);
      t.setSelection(b);
    }
  }
  return !0;
}, TL = (e) => (n) => {
  const t = typeof e == "function" ? e(n) : e;
  for (let a = 0; a < t.length; a += 1)
    if (t[a](n))
      return !0;
  return !1;
};
function yp(e) {
  return e instanceof at;
}
function _a(e = 0, n = 0, t = 0) {
  return Math.min(Math.max(e, n), t);
}
function kp(e, n = null) {
  if (!n)
    return null;
  const t = rt.atStart(e), a = rt.atEnd(e);
  if (n === "start" || n === !0)
    return t;
  if (n === "end")
    return a;
  const l = t.from, r = a.to;
  return n === "all" ? at.create(e, _a(0, l, r), _a(e.content.size, l, r)) : at.create(e, _a(n, l, r), _a(n, l, r));
}
function Eh() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function pi() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function LL() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var AL = (e = null, n = {}) => ({ editor: t, view: a, tr: l, dispatch: r }) => {
  n = {
    scrollIntoView: !0,
    ...n
  };
  const o = () => {
    (pi() || Eh()) && a.dom.focus(), LL() && !pi() && !Eh() && a.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      t.isDestroyed || (a.focus(), n != null && n.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  try {
    if (a.hasFocus() && e === null || e === !1)
      return !0;
  } catch {
    return !1;
  }
  if (r && e === null && !yp(t.state.selection))
    return o(), !0;
  const i = kp(l.doc, e) || t.state.selection, s = t.state.selection.eq(i);
  return r && (s || l.setSelection(i), s && l.storedMarks && l.setStoredMarks(l.storedMarks), o()), !0;
}, EL = (e, n) => (t) => e.every((a, l) => n(a, { ...t, index: l })), RL = (e, n) => ({ tr: t, commands: a }) => a.insertContentAt({ from: t.selection.from, to: t.selection.to }, e, n), wp = (e) => {
  const n = e.childNodes;
  for (let t = n.length - 1; t >= 0; t -= 1) {
    const a = n[t];
    a.nodeType === 3 && a.nodeValue && /^(\n\s\s|\n)$/.test(a.nodeValue) ? e.removeChild(a) : a.nodeType === 1 && wp(a);
  }
  return e;
};
function So(e) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const n = `<body>${e}</body>`, t = new window.DOMParser().parseFromString(n, "text/html").body;
  return wp(t);
}
function Yr(e, n, t) {
  if (e instanceof Aa || e instanceof Pe)
    return e;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const a = typeof e == "object" && e !== null, l = typeof e == "string";
  if (a)
    try {
      if (Array.isArray(e) && e.length > 0)
        return Pe.fromArray(e.map((i) => n.nodeFromJSON(i)));
      const o = n.nodeFromJSON(e);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (r) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: r });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", r), Yr("", n, t);
    }
  if (l) {
    if (t.errorOnInvalidContent) {
      let o = !1, i = "";
      const s = new lm({
        topNode: n.spec.topNode,
        marks: n.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: n.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (o = !0, i = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Ea.fromSchema(s).parseSlice(So(e), t.parseOptions) : Ea.fromSchema(s).parse(So(e), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${i}`)
        });
    }
    const r = Ea.fromSchema(n);
    return t.slice ? r.parseSlice(So(e), t.parseOptions).content : r.parse(So(e), t.parseOptions);
  }
  return Yr("", n, t);
}
function BL(e, n, t) {
  const a = e.steps.length - 1;
  if (a < n)
    return;
  const l = e.steps[a];
  if (!(l instanceof Bt || l instanceof Ht))
    return;
  const r = e.mapping.maps[a];
  let o = 0;
  r.forEach((i, s, d, u) => {
    o === 0 && (o = u);
  }), e.setSelection(rt.near(e.doc.resolve(o), t));
}
var DL = (e) => !("type" in e), ML = (e, n, t) => ({ tr: a, dispatch: l, editor: r }) => {
  var o;
  if (l) {
    t = {
      parseOptions: r.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let i;
    const s = (y) => {
      r.emit("contentError", {
        editor: r,
        error: y,
        disableCollaboration: () => {
          "collaboration" in r.storage && typeof r.storage.collaboration == "object" && r.storage.collaboration && (r.storage.collaboration.isDisabled = !0);
        }
      });
    }, d = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !r.options.enableContentCheck && r.options.emitContentError)
      try {
        Yr(n, r.schema, {
          parseOptions: d,
          errorOnInvalidContent: !0
        });
      } catch (y) {
        s(y);
      }
    try {
      i = Yr(n, r.schema, {
        parseOptions: d,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) != null ? o : r.options.enableContentCheck
      });
    } catch (y) {
      return s(y), !1;
    }
    let { from: u, to: f } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, b = !0, h = !0;
    if ((DL(i) ? i : [i]).forEach((y) => {
      y.check(), b = b ? y.isText && y.marks.length === 0 : !1, h = h ? y.isBlock : !1;
    }), u === f && h) {
      const { parent: y } = a.doc.resolve(u);
      y.isTextblock && !y.type.spec.code && !y.childCount && (u -= 1, f += 1);
    }
    let x;
    if (b) {
      if (Array.isArray(n))
        x = n.map((y) => y.text || "").join("");
      else if (n instanceof Pe) {
        let y = "";
        n.forEach((w) => {
          w.text && (y += w.text);
        }), x = y;
      } else typeof n == "object" && n && n.text ? x = n.text : x = n;
      a.insertText(x, u, f);
    } else {
      x = i;
      const y = a.doc.resolve(u), w = y.node(), $ = y.parentOffset === 0, S = w.isText || w.isTextblock, L = w.content.size > 0;
      $ && S && L && h && (u = Math.max(0, u - 1)), a.replaceWith(u, f, x);
    }
    t.updateSelection && BL(a, a.steps.length - 1, -1), t.applyInputRules && a.setMeta("applyInputRules", { from: u, text: x }), t.applyPasteRules && a.setMeta("applyPasteRules", { from: u, text: x });
  }
  return !0;
}, zL = () => ({ state: e, dispatch: n }) => aI(e, n), OL = () => ({ state: e, dispatch: n }) => lI(e, n), PL = () => ({ state: e, dispatch: n }) => $m(e, n), FL = () => ({ state: e, dispatch: n }) => Am(e, n), VL = () => ({ state: e, dispatch: n, tr: t }) => {
  try {
    const a = ts(e.doc, e.selection.$from.pos, -1);
    return a == null ? !1 : (t.join(a, 2), n && n(t), !0);
  } catch {
    return !1;
  }
}, NL = () => ({ state: e, dispatch: n, tr: t }) => {
  try {
    const a = ts(e.doc, e.selection.$from.pos, 1);
    return a == null ? !1 : (t.join(a, 2), n && n(t), !0);
  } catch {
    return !1;
  }
}, HL = () => ({ state: e, dispatch: n }) => tI(e, n), jL = () => ({ state: e, dispatch: n }) => nI(e, n);
function Cp() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function WL(e) {
  const n = e.split(/-(?!$)/);
  let t = n[n.length - 1];
  t === "Space" && (t = " ");
  let a, l, r, o;
  for (let i = 0; i < n.length - 1; i += 1) {
    const s = n[i];
    if (/^(cmd|meta|m)$/i.test(s))
      o = !0;
    else if (/^a(lt)?$/i.test(s))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      r = !0;
    else if (/^mod$/i.test(s))
      pi() || Cp() ? o = !0 : l = !0;
    else
      throw new Error(`Unrecognized modifier name: ${s}`);
  }
  return a && (t = `Alt-${t}`), l && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), r && (t = `Shift-${t}`), t;
}
var qL = (e) => ({ editor: n, view: t, tr: a, dispatch: l }) => {
  const r = WL(e).split(/-(?!$)/), o = r.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), i = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: r.includes("Alt"),
    ctrlKey: r.includes("Ctrl"),
    metaKey: r.includes("Meta"),
    shiftKey: r.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), s = n.captureTransaction(() => {
    t.someProp("handleKeyDown", (d) => d(t, i));
  });
  return s == null || s.steps.forEach((d) => {
    const u = d.map(a.mapping);
    u && l && a.maybeStep(u);
  }), !0;
};
function Pa(e, n, t = {}) {
  const { from: a, to: l, empty: r } = e.selection, o = n ? zt(n, e.schema) : null, i = [];
  e.doc.nodesBetween(a, l, (f, b) => {
    if (f.isText)
      return;
    const h = Math.max(a, b), p = Math.min(l, b + f.nodeSize);
    i.push({
      node: f,
      from: h,
      to: p
    });
  });
  const s = l - a, d = i.filter((f) => o ? o.name === f.node.type.name : !0).filter((f) => mi(f.node.attrs, t, { strict: !1 }));
  return r ? !!d.length : d.reduce((f, b) => f + b.to - b.from, 0) >= s;
}
var UL = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = zt(e, t.schema);
  return Pa(t, l, n) ? rI(t, a) : !1;
}, GL = () => ({ state: e, dispatch: n }) => Dm(e, n), KL = (e) => ({ state: n, dispatch: t }) => {
  const a = zt(e, n.schema);
  return pI(a)(n, t);
}, YL = () => ({ state: e, dispatch: n }) => Rm(e, n);
function us(e, n) {
  return n.nodes[e] ? "node" : n.marks[e] ? "mark" : null;
}
function Rh(e, n) {
  const t = typeof n == "string" ? [n] : n;
  return Object.keys(e).reduce((a, l) => (t.includes(l) || (a[l] = e[l]), a), {});
}
var JL = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  let r = null, o = null;
  const i = us(
    typeof e == "string" ? e : e.name,
    a.schema
  );
  if (!i)
    return !1;
  i === "node" && (r = zt(e, a.schema)), i === "mark" && (o = ga(e, a.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    a.doc.nodesBetween(d.$from.pos, d.$to.pos, (u, f) => {
      r && r === u.type && (s = !0, l && t.setNodeMarkup(f, void 0, Rh(u.attrs, n))), o && u.marks.length && u.marks.forEach((b) => {
        o === b.type && (s = !0, l && t.addMark(f, f + u.nodeSize, o.create(Rh(b.attrs, n))));
      });
    });
  }), s;
}, XL = () => ({ tr: e, dispatch: n }) => (n && e.scrollIntoView(), !0), ZL = () => ({ tr: e, dispatch: n }) => {
  if (n) {
    const t = new gn(e.doc);
    e.setSelection(t);
  }
  return !0;
}, QL = () => ({ state: e, dispatch: n }) => Tm(e, n), _L = () => ({ state: e, dispatch: n }) => Em(e, n), eA = () => ({ state: e, dispatch: n }) => dI(e, n), tA = () => ({ state: e, dispatch: n }) => fI(e, n), nA = () => ({ state: e, dispatch: n }) => cI(e, n);
function Zd(e, n, t = {}, a = {}) {
  return Yr(e, n, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: a.errorOnInvalidContent
  });
}
var aA = (e, { errorOnInvalidContent: n, emitUpdate: t = !0, parseOptions: a = {} } = {}) => ({ editor: l, tr: r, dispatch: o, commands: i }) => {
  const { doc: s } = r;
  if (a.preserveWhitespace !== "full") {
    const d = Zd(e, l.schema, a, {
      errorOnInvalidContent: n ?? l.options.enableContentCheck
    });
    return o && r.replaceWith(0, s.content.size, d).setMeta("preventUpdate", !t), !0;
  }
  return o && r.setMeta("preventUpdate", !t), i.insertContentAt({ from: 0, to: s.content.size }, e, {
    parseOptions: a,
    errorOnInvalidContent: n ?? l.options.enableContentCheck
  });
};
function Sp(e, n) {
  const t = ga(n, e.schema), { from: a, to: l, empty: r } = e.selection, o = [];
  r ? (e.storedMarks && o.push(...e.storedMarks), o.push(...e.selection.$head.marks())) : e.doc.nodesBetween(a, l, (s) => {
    o.push(...s.marks);
  });
  const i = o.find((s) => s.type.name === t.name);
  return i ? { ...i.attrs } : {};
}
function $p(e, n) {
  const t = new ym(e);
  return n.forEach((a) => {
    a.steps.forEach((l) => {
      t.step(l);
    });
  }), t;
}
function lA(e) {
  for (let n = 0; n < e.edgeCount; n += 1) {
    const { type: t } = e.edge(n);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function rA(e, n, t) {
  const a = [];
  return e.nodesBetween(n.from, n.to, (l, r) => {
    t(l) && a.push({
      node: l,
      pos: r
    });
  }), a;
}
function oA(e, n) {
  for (let t = e.depth; t > 0; t -= 1) {
    const a = e.node(t);
    if (n(a))
      return {
        pos: t > 0 ? e.before(t) : 0,
        start: e.start(t),
        depth: t,
        node: a
      };
  }
}
function cs(e) {
  return (n) => oA(n.$from, e);
}
function Xe(e, n, t) {
  return e.config[n] === void 0 && e.parent ? Xe(e.parent, n, t) : typeof e.config[n] == "function" ? e.config[n].bind({
    ...t,
    parent: e.parent ? Xe(e.parent, n, t) : null
  }) : e.config[n];
}
function xc(e) {
  return e.map((n) => {
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    }, a = Xe(n, "addExtensions", t);
    return a ? [n, ...xc(a())] : n;
  }).flat(10);
}
function yc(e, n) {
  const t = pl.fromSchema(n).serializeFragment(e), l = document.implementation.createHTMLDocument().createElement("div");
  return l.appendChild(t), l.innerHTML;
}
function Ip(e) {
  return typeof e == "function";
}
function bt(e, n = void 0, ...t) {
  return Ip(e) ? n ? e.bind(n)(...t) : e(...t) : e;
}
function iA(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function Ul(e) {
  const n = e.filter((l) => l.type === "extension"), t = e.filter((l) => l.type === "node"), a = e.filter((l) => l.type === "mark");
  return {
    baseExtensions: n,
    nodeExtensions: t,
    markExtensions: a
  };
}
function Tp(e) {
  const n = [], { nodeExtensions: t, markExtensions: a } = Ul(e), l = [...t, ...a], r = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, o = t.filter((d) => d.name !== "text").map((d) => d.name), i = a.map((d) => d.name), s = [...o, ...i];
  return e.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      extensions: l
    }, f = Xe(
      d,
      "addGlobalAttributes",
      u
    );
    if (!f)
      return;
    f().forEach((h) => {
      let p;
      Array.isArray(h.types) ? p = h.types : h.types === "*" ? p = s : h.types === "nodes" ? p = o : h.types === "marks" ? p = i : p = [], p.forEach((x) => {
        Object.entries(h.attributes).forEach(([y, w]) => {
          n.push({
            type: x,
            name: y,
            attribute: {
              ...r,
              ...w
            }
          });
        });
      });
    });
  }), l.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage
    }, f = Xe(
      d,
      "addAttributes",
      u
    );
    if (!f)
      return;
    const b = f();
    Object.entries(b).forEach(([h, p]) => {
      const x = {
        ...r,
        ...p
      };
      typeof (x == null ? void 0 : x.default) == "function" && (x.default = x.default()), x != null && x.isRequired && (x == null ? void 0 : x.default) === void 0 && delete x.default, n.push({
        type: d.name,
        name: h,
        attribute: x
      });
    });
  }), n;
}
function sA(e) {
  const n = [];
  let t = "", a = !1, l = !1, r = 0;
  const o = e.length;
  for (let i = 0; i < o; i += 1) {
    const s = e[i];
    if (s === "'" && !l) {
      a = !a, t += s;
      continue;
    }
    if (s === '"' && !a) {
      l = !l, t += s;
      continue;
    }
    if (!a && !l) {
      if (s === "(") {
        r += 1, t += s;
        continue;
      }
      if (s === ")" && r > 0) {
        r -= 1, t += s;
        continue;
      }
      if (s === ";" && r === 0) {
        n.push(t), t = "";
        continue;
      }
    }
    t += s;
  }
  return t && n.push(t), n;
}
function Bh(e) {
  const n = [], t = sA(e || ""), a = t.length;
  for (let l = 0; l < a; l += 1) {
    const r = t[l], o = r.indexOf(":");
    if (o === -1)
      continue;
    const i = r.slice(0, o).trim(), s = r.slice(o + 1).trim();
    i && s && n.push([i, s]);
  }
  return n;
}
function It(...e) {
  return e.filter((n) => !!n).reduce((n, t) => {
    const a = { ...n };
    return Object.entries(t).forEach(([l, r]) => {
      if (!a[l]) {
        a[l] = r;
        return;
      }
      if (l === "class") {
        const i = r ? String(r).split(" ") : [], s = a[l] ? a[l].split(" ") : [], d = i.filter((u) => !s.includes(u));
        a[l] = [...s, ...d].join(" ");
      } else if (l === "style") {
        const i = new Map([...Bh(a[l]), ...Bh(r)]);
        a[l] = Array.from(i.entries()).map(([s, d]) => `${s}: ${d}`).join("; ");
      } else
        a[l] = r;
    }), a;
  }, {});
}
function Jr(e, n) {
  return n.filter((t) => t.type === e.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : {
    [t.name]: e.attrs[t.name]
  }).reduce((t, a) => It(t, a), {});
}
function dA(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function Dh(e, n) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (t) => {
      const a = e.getAttrs ? e.getAttrs(t) : e.attrs;
      if (a === !1)
        return !1;
      const l = n.reduce((r, o) => {
        const i = o.attribute.parseHTML ? o.attribute.parseHTML(t) : dA(t.getAttribute(o.name));
        return i == null ? r : {
          ...r,
          [o.name]: i
        };
      }, {});
      return { ...a, ...l };
    }
  };
}
function Mh(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([n, t]) => n === "attrs" && iA(t) ? !1 : t != null)
  );
}
function zh(e) {
  var n, t;
  const a = {};
  return !((n = e == null ? void 0 : e.attribute) != null && n.isRequired) && "default" in ((e == null ? void 0 : e.attribute) || {}) && (a.default = e.attribute.default), ((t = e == null ? void 0 : e.attribute) == null ? void 0 : t.validate) !== void 0 && (a.validate = e.attribute.validate), [e.name, a];
}
function uA(e, n) {
  var t;
  const a = Tp(e), { nodeExtensions: l, markExtensions: r } = Ul(e), o = (t = l.find((d) => Xe(d, "topNode"))) == null ? void 0 : t.name, i = Object.fromEntries(
    l.map((d) => {
      const u = a.filter((w) => w.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: n
      }, b = e.reduce((w, $) => {
        const S = Xe($, "extendNodeSchema", f);
        return {
          ...w,
          ...S ? S(d) : {}
        };
      }, {}), h = Mh({
        ...b,
        content: bt(Xe(d, "content", f)),
        marks: bt(Xe(d, "marks", f)),
        group: bt(Xe(d, "group", f)),
        inline: bt(Xe(d, "inline", f)),
        atom: bt(Xe(d, "atom", f)),
        selectable: bt(Xe(d, "selectable", f)),
        draggable: bt(Xe(d, "draggable", f)),
        code: bt(Xe(d, "code", f)),
        whitespace: bt(Xe(d, "whitespace", f)),
        linebreakReplacement: bt(
          Xe(d, "linebreakReplacement", f)
        ),
        defining: bt(Xe(d, "defining", f)),
        isolating: bt(Xe(d, "isolating", f)),
        attrs: Object.fromEntries(u.map(zh))
      }), p = bt(Xe(d, "parseHTML", f));
      p && (h.parseDOM = p.map(
        (w) => Dh(w, u)
      ));
      const x = Xe(d, "renderHTML", f);
      x && (h.toDOM = (w) => x({
        node: w,
        HTMLAttributes: Jr(w, u)
      }));
      const y = Xe(d, "renderText", f);
      return y && (h.toText = y), [d.name, h];
    })
  ), s = Object.fromEntries(
    r.map((d) => {
      const u = a.filter((y) => y.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: n
      }, b = e.reduce((y, w) => {
        const $ = Xe(w, "extendMarkSchema", f);
        return {
          ...y,
          ...$ ? $(d) : {}
        };
      }, {}), h = Mh({
        ...b,
        inclusive: bt(Xe(d, "inclusive", f)),
        excludes: bt(Xe(d, "excludes", f)),
        group: bt(Xe(d, "group", f)),
        spanning: bt(Xe(d, "spanning", f)),
        code: bt(Xe(d, "code", f)),
        attrs: Object.fromEntries(u.map(zh))
      }), p = bt(Xe(d, "parseHTML", f));
      p && (h.parseDOM = p.map(
        (y) => Dh(y, u)
      ));
      const x = Xe(d, "renderHTML", f);
      return x && (h.toDOM = (y) => x({
        mark: y,
        HTMLAttributes: Jr(y, u)
      })), [d.name, h];
    })
  );
  return new lm({
    topNode: o,
    nodes: i,
    marks: s
  });
}
function cA(e) {
  const n = e.filter((t, a) => e.indexOf(t) !== a);
  return Array.from(new Set(n));
}
function Ir(e) {
  return e.sort((t, a) => {
    const l = Xe(t, "priority") || 100, r = Xe(a, "priority") || 100;
    return l > r ? -1 : l < r ? 1 : 0;
  });
}
function Lp(e) {
  const n = Ir(xc(e)), t = cA(n.map((a) => a.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((a) => `'${a}'`).join(", ")}]. This can lead to issues.`
  ), n;
}
function Ap(e, n, t) {
  const { from: a, to: l } = n, { blockSeparator: r = `

`, textSerializers: o = {} } = t || {};
  let i = "";
  return e.nodesBetween(a, l, (s, d, u, f) => {
    var b;
    s.isBlock && d > a && (i += r);
    const h = o == null ? void 0 : o[s.type.name];
    if (h)
      return u && (i += h({
        node: s,
        pos: d,
        parent: u,
        index: f,
        range: n
      })), !1;
    s.isText && (i += (b = s == null ? void 0 : s.text) == null ? void 0 : b.slice(Math.max(a, d) - d, l - d));
  }), i;
}
function fA(e, n) {
  const t = {
    from: 0,
    to: e.content.size
  };
  return Ap(e, t, n);
}
function Ep(e) {
  return Object.fromEntries(
    Object.entries(e.nodes).filter(([, n]) => n.spec.toText).map(([n, t]) => [n, t.spec.toText])
  );
}
function hA(e, n) {
  const t = zt(n, e.schema), { from: a, to: l } = e.selection, r = [];
  e.doc.nodesBetween(a, l, (i) => {
    r.push(i);
  });
  const o = r.reverse().find((i) => i.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function Rp(e, n) {
  const t = us(
    typeof n == "string" ? n : n.name,
    e.schema
  );
  return t === "node" ? hA(e, n) : t === "mark" ? Sp(e, n) : {};
}
function bA(e, n = JSON.stringify) {
  const t = {};
  return e.filter((a) => {
    const l = n(a);
    return Object.prototype.hasOwnProperty.call(t, l) ? !1 : t[l] = !0;
  });
}
function gA(e) {
  const n = bA(e);
  return n.length === 1 ? n : n.filter((t, a) => !n.filter((r, o) => o !== a).some((r) => t.oldRange.from >= r.oldRange.from && t.oldRange.to <= r.oldRange.to && t.newRange.from >= r.newRange.from && t.newRange.to <= r.newRange.to));
}
function Bp(e) {
  const { mapping: n, steps: t } = e, a = [];
  return n.maps.forEach((l, r) => {
    const o = [];
    if (l.ranges.length)
      l.forEach((i, s) => {
        o.push({ from: i, to: s });
      });
    else {
      const { from: i, to: s } = t[r];
      if (i === void 0 || s === void 0)
        return;
      o.push({ from: i, to: s });
    }
    o.forEach(({ from: i, to: s }) => {
      const d = n.slice(r).map(i, -1), u = n.slice(r).map(s), f = n.invert().map(d, -1), b = n.invert().map(u);
      a.push({
        oldRange: {
          from: f,
          to: b
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), gA(a);
}
function kc(e, n, t) {
  const a = [];
  return e === n ? t.resolve(e).marks().forEach((l) => {
    const r = t.resolve(e), o = vc(r, l.type);
    o && a.push({
      mark: l,
      ...o
    });
  }) : t.nodesBetween(e, n, (l, r) => {
    !l || (l == null ? void 0 : l.nodeSize) === void 0 || a.push(
      ...l.marks.map((o) => ({
        from: r,
        to: r + l.nodeSize,
        mark: o
      }))
    );
  }), a;
}
var mA = (e, n, t, a = 20) => {
  const l = e.doc.resolve(t);
  let r = a, o = null;
  for (; r > 0 && o === null; ) {
    const i = l.node(r);
    (i == null ? void 0 : i.type.name) === n ? o = i : r -= 1;
  }
  return [o, r];
};
function rr(e, n) {
  return n.nodes[e] || n.marks[e] || null;
}
function Ko(e, n, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([a]) => {
      const l = e.find((r) => r.type === n && r.name === a);
      return l ? l.attribute.keepOnSplit : !1;
    })
  );
}
var pA = (e, n = 500) => {
  let t = "";
  const a = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, a - n), a, (l, r, o, i) => {
    var s, d;
    const u = ((d = (s = l.type.spec).toText) == null ? void 0 : d.call(s, {
      node: l,
      pos: r,
      parent: o,
      index: i
    })) || l.textContent || "%leaf%";
    t += l.isAtom && !l.isText ? u : u.slice(0, Math.max(0, a - r));
  }), t;
};
function Qd(e, n, t = {}) {
  const { empty: a, ranges: l } = e.selection, r = n ? ga(n, e.schema) : null;
  if (a)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => r ? r.name === f.type.name : !0).find((f) => mi(f.attrs, t, { strict: !1 }));
  let o = 0;
  const i = [];
  if (l.forEach(({ $from: f, $to: b }) => {
    const h = f.pos, p = b.pos;
    e.doc.nodesBetween(h, p, (x, y) => {
      if (r && x.inlineContent && !x.type.allowsMarkType(r))
        return !1;
      if (!x.isText && !x.marks.length)
        return;
      const w = Math.max(h, y), $ = Math.min(p, y + x.nodeSize), S = $ - w;
      o += S, i.push(
        ...x.marks.map((L) => ({
          mark: L,
          from: w,
          to: $
        }))
      );
    });
  }), o === 0)
    return !1;
  const s = i.filter((f) => r ? r.name === f.mark.type.name : !0).filter((f) => mi(f.mark.attrs, t, { strict: !1 })).reduce((f, b) => f + b.to - b.from, 0), d = i.filter((f) => r ? f.mark.type !== r && f.mark.type.excludes(r) : !0).reduce((f, b) => f + b.to - b.from, 0);
  return (s > 0 ? s + d : s) >= o;
}
function vA(e, n, t = {}) {
  if (!n)
    return Pa(e, null, t) || Qd(e, null, t);
  const a = us(n, e.schema);
  return a === "node" ? Pa(e, n, t) : a === "mark" ? Qd(e, n, t) : !1;
}
var xA = (e, n) => {
  const { $from: t, $to: a, $anchor: l } = e.selection;
  if (n) {
    const r = cs((i) => i.type.name === n)(e.selection);
    if (!r)
      return !1;
    const o = e.doc.resolve(r.pos + 1);
    return l.pos + 1 === o.end();
  }
  return !(a.parentOffset < a.parent.nodeSize - 2 || t.pos !== a.pos);
}, yA = (e) => {
  const { $from: n, $to: t } = e.selection;
  return !(n.parentOffset > 0 || n.pos !== t.pos);
};
function Oh(e, n) {
  return Array.isArray(n) ? n.some((t) => (typeof t == "string" ? t : t.name) === e.name) : n;
}
function Ys(e, n) {
  const { nodeExtensions: t } = Ul(n), a = t.find((o) => o.name === e);
  if (!a)
    return !1;
  const l = {
    name: a.name,
    options: a.options,
    storage: a.storage
  }, r = bt(Xe(a, "group", l));
  return typeof r != "string" ? !1 : r.split(" ").includes("list");
}
function Xr(e, {
  checkChildren: n = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var a;
  if (t) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return !/\S/.test((a = e.text) != null ? a : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (n) {
    let l = !0;
    return e.content.forEach((r) => {
      l !== !1 && (Xr(r, { ignoreWhitespace: t, checkChildren: n }) || (l = !1));
    }), l;
  }
  return !1;
}
function Dp(e) {
  return e instanceof Qe;
}
var Mp = class zp {
  constructor(n) {
    this.position = n;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(n) {
    return new zp(n.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function kA(e, n) {
  const t = n.mapping.mapResult(e.position);
  return {
    position: new Mp(t.pos),
    mapResult: t
  };
}
function wA(e) {
  return new Mp(e);
}
function CA(e, n, t) {
  var a;
  const { selection: l } = n;
  let r = null;
  if (yp(l) && (r = l.$cursor), r) {
    const i = (a = e.storedMarks) != null ? a : r.marks();
    return r.parent.type.allowsMarkType(t) && (!!t.isInSet(i) || !i.some((d) => d.type.excludes(t)));
  }
  const { ranges: o } = l;
  return o.some(({ $from: i, $to: s }) => {
    let d = i.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(t) : !1;
    return e.doc.nodesBetween(i.pos, s.pos, (u, f, b) => {
      if (d)
        return !1;
      if (u.isInline) {
        const h = !b || b.type.allowsMarkType(t), p = !!t.isInSet(u.marks) || !u.marks.some((x) => x.type.excludes(t));
        d = h && p;
      }
      return !d;
    }), d;
  });
}
var SA = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  const { selection: r } = t, { empty: o, ranges: i } = r, s = ga(e, a.schema);
  if (l)
    if (o) {
      const d = Sp(a, s);
      t.addStoredMark(
        s.create({
          ...d,
          ...n
        })
      );
    } else
      i.forEach((d) => {
        const u = d.$from.pos, f = d.$to.pos;
        a.doc.nodesBetween(u, f, (b, h) => {
          const p = Math.max(h, u), x = Math.min(h + b.nodeSize, f);
          b.marks.find((w) => w.type === s) ? b.marks.forEach((w) => {
            s === w.type && t.addMark(
              p,
              x,
              s.create({
                ...w.attrs,
                ...n
              })
            );
          }) : t.addMark(p, x, s.create(n));
        });
      });
  return CA(a, t, s);
}, $A = (e, n) => ({ tr: t }) => (t.setMeta(e, n), !0), IA = (e, n = {}) => ({ state: t, dispatch: a, chain: l }) => {
  const r = zt(e, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), r.isTextblock ? l().command(({ commands: i }) => Yf(r, { ...o, ...n })(t) ? !0 : i.clearNodes()).command(({ state: i }) => Yf(r, { ...o, ...n })(i, a)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, TA = (e) => ({ tr: n, dispatch: t }) => {
  if (t) {
    const { doc: a } = n, l = _a(e, 0, a.content.size), r = Qe.create(a, l);
    n.setSelection(r);
  }
  return !0;
}, LA = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  const { selection: r } = a;
  let o, i;
  return typeof n == "number" ? (o = n, i = n) : n && "from" in n && "to" in n ? (o = n.from, i = n.to) : (o = r.from, i = r.to), l && t.doc.nodesBetween(o, i, (s, d) => {
    s.isText || t.setNodeMarkup(d, void 0, {
      ...s.attrs,
      dir: e
    });
  }), !0;
}, AA = (e) => ({ tr: n, dispatch: t }) => {
  if (t) {
    const { doc: a } = n, { from: l, to: r } = typeof e == "number" ? { from: e, to: e } : e, o = at.atStart(a).from, i = at.atEnd(a).to, s = _a(l, o, i), d = _a(r, o, i), u = at.create(a, s, d);
    n.setSelection(u);
  }
  return !0;
}, EA = (e) => ({ state: n, dispatch: t }) => {
  const a = zt(e, n.schema);
  return yI(a)(n, t);
};
function Ph(e, n) {
  const t = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (t) {
    const a = t.filter((l) => n == null ? void 0 : n.includes(l.type.name));
    e.tr.ensureMarks(a);
  }
}
var RA = ({ keepMarks: e = !0 } = {}) => ({ tr: n, state: t, dispatch: a, editor: l }) => {
  const { selection: r, doc: o } = n, { $from: i, $to: s } = r, d = l.extensionManager.attributes, u = Ko(d, i.node().type.name, i.node().attrs);
  if (r instanceof Qe && r.node.isBlock)
    return !i.parentOffset || !ua(o, i.pos) ? !1 : (a && (e && Ph(t, l.extensionManager.splittableMarks), n.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const f = s.parentOffset === s.parent.content.size, b = i.depth === 0 ? void 0 : lA(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let h = f && b ? [
    {
      type: b,
      attrs: u
    }
  ] : void 0, p = ua(n.doc, n.mapping.map(i.pos), 1, h);
  if (!h && !p && ua(n.doc, n.mapping.map(i.pos), 1, b ? [{ type: b }] : void 0) && (p = !0, h = b ? [
    {
      type: b,
      attrs: u
    }
  ] : void 0), a) {
    if (p && (r instanceof at && n.deleteSelection(), n.split(n.mapping.map(i.pos), 1, h), b && !f && !i.parentOffset && i.parent.type !== b)) {
      const x = n.mapping.map(i.before()), y = n.doc.resolve(x);
      i.node(-1).canReplaceWith(y.index(), y.index() + 1, b) && n.setNodeMarkup(n.mapping.map(i.before()), b);
    }
    e && Ph(t, l.extensionManager.splittableMarks), n.scrollIntoView();
  }
  return p;
}, BA = (e, n = {}) => ({ tr: t, state: a, dispatch: l, editor: r }) => {
  var o;
  const i = zt(e, a.schema), { $from: s, $to: d } = a.selection, u = a.selection.node;
  if (u && u.isBlock || s.depth < 2 || !s.sameParent(d))
    return !1;
  const f = s.node(-1);
  if (f.type !== i)
    return !1;
  const b = r.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== i || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (l) {
      let w = Pe.empty;
      const $ = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let D = s.depth - $; D >= s.depth - 3; D -= 1)
        w = Pe.from(s.node(D).copy(w));
      const S = (
        // eslint-disable-next-line no-nested-ternary
        s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3
      ), L = {
        ...Ko(b, s.node().type.name, s.node().attrs),
        ...n
      }, T = ((o = i.contentMatch.defaultType) == null ? void 0 : o.createAndFill(L)) || void 0;
      w = w.append(Pe.from(i.createAndFill(null, T) || void 0));
      const E = s.before(s.depth - ($ - 1));
      t.replace(E, s.after(-S), new Je(w, 4 - $, 0));
      let A = -1;
      t.doc.nodesBetween(E, t.doc.content.size, (D, M) => {
        if (A > -1)
          return !1;
        D.isTextblock && D.content.size === 0 && (A = M + 1);
      }), A > -1 && t.setSelection(at.near(t.doc.resolve(A))), t.scrollIntoView();
    }
    return !0;
  }
  const h = d.pos === s.end() ? f.contentMatchAt(0).defaultType : null, p = {
    ...Ko(b, f.type.name, f.attrs),
    ...n
  }, x = {
    ...Ko(b, s.node().type.name, s.node().attrs),
    ...n
  };
  t.delete(s.pos, d.pos);
  const y = h ? [
    { type: i, attrs: p },
    { type: h, attrs: x }
  ] : [{ type: i, attrs: p }];
  if (!ua(t.doc, s.pos, 2))
    return !1;
  if (l) {
    const { selection: w, storedMarks: $ } = a, { splittableMarks: S } = r.extensionManager, L = $ || w.$to.parentOffset && w.$from.marks();
    if (t.split(s.pos, 2, y).scrollIntoView(), !L || !l)
      return !0;
    const T = L.filter((E) => S.includes(E.type.name));
    t.ensureMarks(T);
  }
  return !0;
}, Js = (e, n) => {
  const t = cs((o) => o.type === n)(e.selection);
  if (!t)
    return !0;
  const a = e.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (a === void 0)
    return !0;
  const l = e.doc.nodeAt(a);
  return t.node.type === (l == null ? void 0 : l.type) && qa(e.doc, t.pos) && e.join(t.pos), !0;
}, Xs = (e, n) => {
  const t = cs((o) => o.type === n)(e.selection);
  if (!t)
    return !0;
  const a = e.doc.resolve(t.start).after(t.depth);
  if (a === void 0)
    return !0;
  const l = e.doc.nodeAt(a);
  return t.node.type === (l == null ? void 0 : l.type) && qa(e.doc, a) && e.join(a), !0;
};
function DA(e) {
  const n = e.doc, t = n.firstChild;
  if (!t)
    return null;
  const a = n.resolve(1), l = n.resolve(t.nodeSize - 1);
  return at.between(a, l);
}
var MA = (e, n, t, a = {}) => ({ editor: l, tr: r, state: o, dispatch: i, chain: s, commands: d, can: u }) => {
  const { extensions: f, splittableMarks: b } = l.extensionManager, h = zt(e, o.schema), p = zt(n, o.schema), { selection: x, storedMarks: y } = o, { $from: w, $to: $ } = x, S = w.blockRange($), L = y || x.$to.parentOffset && x.$from.marks();
  if (!S)
    return !1;
  const T = cs((Y) => Ys(Y.type.name, f))(x), E = x.from === 0 && x.to === o.doc.content.size, A = o.doc.content.content, D = A.length === 1 ? A[0] : null, M = E && D && Ys(D.type.name, f) ? {
    node: D,
    pos: 0
  } : null, F = T ?? M, X = !!T && S.depth >= 1 && S.depth - T.depth <= 1, _ = !!M;
  if ((X || _) && F) {
    if (F.node.type === h)
      return E && _ ? s().command(({ tr: Y, dispatch: B }) => {
        const W = DA(Y);
        return W ? (Y.setSelection(W), B && B(Y), !0) : !1;
      }).liftListItem(p).run() : d.liftListItem(p);
    if (Ys(F.node.type.name, f) && h.validContent(F.node.content))
      return s().command(() => (r.setNodeMarkup(F.pos, h), !0)).command(() => Js(r, h)).command(() => Xs(r, h)).run();
  }
  return !t || !L || !i ? s().command(() => u().wrapInList(h, a) ? !0 : d.clearNodes()).wrapInList(h, a).command(() => Js(r, h)).command(() => Xs(r, h)).run() : s().command(() => {
    const Y = u().wrapInList(h, a), B = L.filter((W) => b.includes(W.type.name));
    return r.ensureMarks(B), Y ? !0 : d.clearNodes();
  }).wrapInList(h, a).command(() => Js(r, h)).command(() => Xs(r, h)).run();
}, zA = (e, n = {}, t = {}) => ({ state: a, commands: l }) => {
  const { extendEmptyMarkRange: r = !1 } = t, o = ga(e, a.schema);
  return Qd(a, o, n) ? l.unsetMark(o, { extendEmptyMarkRange: r }) : l.setMark(o, n);
}, OA = (e, n, t = {}) => ({ state: a, commands: l }) => {
  const r = zt(e, a.schema), o = zt(n, a.schema), i = Pa(a, r, t);
  let s;
  return a.selection.$anchor.sameParent(a.selection.$head) && (s = a.selection.$anchor.parent.attrs), i ? l.setNode(o, s) : l.setNode(r, { ...s, ...t });
}, PA = (e, n = {}) => ({ state: t, commands: a }) => {
  const l = zt(e, t.schema);
  return Pa(t, l, n) ? a.lift(l) : a.wrapIn(l, n);
}, FA = () => ({ state: e, dispatch: n }) => {
  const t = e.plugins;
  for (let a = 0; a < t.length; a += 1) {
    const l = t[a];
    let r;
    if (l.spec.isInputRules && (r = l.getState(e))) {
      if (n) {
        const o = e.tr, i = r.transform;
        for (let s = i.steps.length - 1; s >= 0; s -= 1)
          o.step(i.steps[s].invert(i.docs[s]));
        if (r.text) {
          const s = o.doc.resolve(r.from).marks();
          o.replaceWith(r.from, r.to, e.schema.text(r.text, s));
        } else
          o.delete(r.from, r.to);
      }
      return !0;
    }
  }
  return !1;
}, VA = () => ({ tr: e, dispatch: n }) => {
  const { selection: t } = e, { empty: a, ranges: l } = t;
  return a || n && l.forEach((r) => {
    e.removeMark(r.$from.pos, r.$to.pos);
  }), !0;
}, NA = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  var r;
  const { extendEmptyMarkRange: o = !1 } = n, { selection: i } = t, s = ga(e, a.schema), { $from: d, empty: u, ranges: f } = i;
  if (!l)
    return !0;
  if (u && o) {
    let { from: b, to: h } = i;
    const p = (r = d.marks().find((y) => y.type === s)) == null ? void 0 : r.attrs, x = vc(d, s, p);
    x && (b = x.from, h = x.to), t.removeMark(b, h, s);
  } else
    f.forEach((b) => {
      t.removeMark(b.$from.pos, b.$to.pos, s);
    });
  return t.removeStoredMark(s), !0;
}, HA = (e) => ({ tr: n, state: t, dispatch: a }) => {
  const { selection: l } = t;
  let r, o;
  return typeof e == "number" ? (r = e, o = e) : e && "from" in e && "to" in e ? (r = e.from, o = e.to) : (r = l.from, o = l.to), a && n.doc.nodesBetween(r, o, (i, s) => {
    if (i.isText)
      return;
    const d = { ...i.attrs };
    delete d.dir, n.setNodeMarkup(s, void 0, d);
  }), !0;
}, jA = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  let r = null, o = null;
  const i = us(
    typeof e == "string" ? e : e.name,
    a.schema
  );
  if (!i)
    return !1;
  i === "node" && (r = zt(e, a.schema)), i === "mark" && (o = ga(e, a.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    const u = d.$from.pos, f = d.$to.pos;
    let b, h, p, x;
    t.selection.empty ? a.doc.nodesBetween(u, f, (y, w) => {
      r && r === y.type && (s = !0, p = Math.max(w, u), x = Math.min(w + y.nodeSize, f), b = w, h = y);
    }) : a.doc.nodesBetween(u, f, (y, w) => {
      w < u && r && r === y.type && (s = !0, p = Math.max(w, u), x = Math.min(w + y.nodeSize, f), b = w, h = y), w >= u && w <= f && (r && r === y.type && (s = !0, l && t.setNodeMarkup(w, void 0, {
        ...y.attrs,
        ...n
      })), o && y.marks.length && y.marks.forEach(($) => {
        if (o === $.type && (s = !0, l)) {
          const S = Math.max(w, u), L = Math.min(w + y.nodeSize, f);
          t.addMark(
            S,
            L,
            o.create({
              ...$.attrs,
              ...n
            })
          );
        }
      }));
    }), h && (b !== void 0 && l && t.setNodeMarkup(b, void 0, {
      ...h.attrs,
      ...n
    }), o && h.marks.length && h.marks.forEach((y) => {
      o === y.type && l && t.addMark(
        p,
        x,
        o.create({
          ...y.attrs,
          ...n
        })
      );
    }));
  }), s;
}, WA = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = zt(e, t.schema);
  return hI(l, n)(t, a);
}, qA = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = zt(e, t.schema);
  return bI(l, n)(t, a);
}, UA = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const t = this.callbacks[e];
    return t && t.forEach((a) => a.apply(this, n)), this;
  }
  off(e, n) {
    const t = this.callbacks[e];
    return t && (n ? this.callbacks[e] = t.filter((a) => a !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const t = (...a) => {
      this.off(e, t), n.apply(this, a);
    };
    return this.on(e, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, fs = class {
  constructor(e) {
    var n;
    this.find = e.find, this.handler = e.handler, this.undoable = (n = e.undoable) != null ? n : !0;
  }
}, GA = (e, n) => {
  if (pc(n))
    return n.exec(e);
  const t = n(e);
  if (!t)
    return null;
  const a = [t.text];
  return a.index = t.index, a.input = e, a.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), a.push(t.replaceWith)), a;
};
function $o(e) {
  var n;
  const { editor: t, from: a, to: l, text: r, rules: o, plugin: i } = e, { view: s } = t;
  if (s.composing)
    return !1;
  const d = s.state.doc.resolve(a);
  if (
    // check for code node
    d.parent.type.spec.code || (n = d.nodeBefore || d.nodeAfter) != null && n.marks.find((b) => b.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = pA(d) + r;
  return o.forEach((b) => {
    if (u)
      return;
    const h = GA(f, b.find);
    if (!h)
      return;
    const p = s.state.tr, x = ss({
      state: s.state,
      transaction: p
    }), y = {
      from: a - (h[0].length - r.length),
      to: l
    }, { commands: w, chain: $, can: S } = new ds({
      editor: t,
      state: x
    });
    b.handler({
      state: x,
      range: y,
      match: h,
      commands: w,
      chain: $,
      can: S
    }) === null || !p.steps.length || (b.undoable && p.setMeta(i, {
      transform: p,
      from: a,
      to: l,
      text: r
    }), s.dispatch(p), u = !0);
  }), u;
}
function KA(e) {
  const { editor: n, rules: t } = e, a = new Tt({
    state: {
      init() {
        return null;
      },
      apply(l, r, o) {
        const i = l.getMeta(a);
        if (i)
          return i;
        const s = l.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          let { text: u } = s;
          typeof u == "string" ? u = u : u = yc(Pe.from(u), o.schema);
          const { from: f } = s, b = f + u.length;
          $o({
            editor: n,
            from: f,
            to: b,
            text: u,
            rules: t,
            plugin: a
          });
        }), l.selectionSet || l.docChanged ? null : r;
      }
    },
    props: {
      handleTextInput(l, r, o, i) {
        return $o({
          editor: n,
          from: r,
          to: o,
          text: i,
          rules: t,
          plugin: a
        });
      },
      handleDOMEvents: {
        compositionend: (l) => (setTimeout(() => {
          const { $cursor: r } = l.state.selection;
          r && $o({
            editor: n,
            from: r.pos,
            to: r.pos,
            text: "",
            rules: t,
            plugin: a
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(l, r) {
        if (r.key !== "Enter")
          return !1;
        const { $cursor: o } = l.state.selection;
        return o ? $o({
          editor: n,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: a
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return a;
}
function YA(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Io(e) {
  return YA(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function Op(e, n) {
  const t = { ...e };
  return Io(e) && Io(n) && Object.keys(n).forEach((a) => {
    Io(n[a]) && Io(e[a]) ? t[a] = Op(e[a], n[a]) : t[a] = n[a];
  }), t;
}
var wc = class {
  constructor(e = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...bt(
        Xe(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...bt(
        Xe(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Op(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, this.child = null, n;
  }
  extend(e = {}) {
    const n = new this.constructor({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = "name" in e ? e.name : n.parent.name, n;
  }
}, ma = class Pp extends wc {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new Pp(t);
  }
  static handleExit({ editor: n, mark: t }) {
    const { tr: a } = n.state, l = n.state.selection.$from;
    if (l.pos === l.end()) {
      const o = l.marks();
      if (!!!o.find((d) => (d == null ? void 0 : d.type.name) === t.name))
        return !1;
      const s = o.find((d) => (d == null ? void 0 : d.type.name) === t.name);
      return s && a.removeStoredMark(s), a.insertText(" ", l.pos), n.view.dispatch(a), !0;
    }
    return !1;
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
};
function JA(e) {
  return typeof e == "number";
}
var XA = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}, ZA = (e, n, t) => {
  if (pc(n))
    return [...e.matchAll(n)];
  const a = n(e, t);
  return a ? a.map((l) => {
    const r = [l.text];
    return r.index = l.index, r.input = e, r.data = l.data, l.replaceWith && (l.text.includes(l.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), r.push(l.replaceWith)), r;
  }) : [];
};
function QA(e) {
  const { editor: n, state: t, from: a, to: l, rule: r, pasteEvent: o, dropEvent: i } = e, { commands: s, chain: d, can: u } = new ds({
    editor: n,
    state: t
  }), f = [];
  return t.doc.nodesBetween(a, l, (h, p) => {
    var x, y, w, $, S;
    if ((y = (x = h.type) == null ? void 0 : x.spec) != null && y.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const L = (S = ($ = (w = h.content) == null ? void 0 : w.size) != null ? $ : h.nodeSize) != null ? S : 0, T = Math.max(a, p), E = Math.min(l, p + L);
    if (T >= E)
      return;
    const A = h.isText ? h.text || "" : h.textBetween(T - p, E - p, void 0, "￼");
    ZA(A, r.find, o).forEach((M) => {
      if (M.index === void 0)
        return;
      const F = T + M.index + 1, X = F + M[0].length, _ = {
        from: t.tr.mapping.map(F),
        to: t.tr.mapping.map(X)
      }, Y = r.handler({
        state: t,
        range: _,
        match: M,
        commands: s,
        chain: d,
        can: u,
        pasteEvent: o,
        dropEvent: i
      });
      f.push(Y);
    });
  }), f.every((h) => h !== null);
}
var To = null, _A = (e) => {
  var n;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (n = t.clipboardData) == null || n.setData("text/html", e), t;
};
function eE(e) {
  const { editor: n, rules: t } = e;
  let a = null, l = !1, r = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, i;
  try {
    i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    i = null;
  }
  const s = ({
    state: u,
    from: f,
    to: b,
    rule: h,
    pasteEvt: p
  }) => {
    const x = u.tr, y = ss({
      state: u,
      transaction: x
    });
    if (!(!QA({
      editor: n,
      state: y,
      from: Math.max(f - 1, 0),
      to: b.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: i
    }) || !x.steps.length)) {
      try {
        i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        i = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, x;
    }
  };
  return t.map((u) => new Tt({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const b = (p) => {
        var x;
        a = (x = f.dom.parentElement) != null && x.contains(p.target) ? f.dom.parentElement : null, a && (To = n);
      }, h = () => {
        To && (To = null);
      };
      return window.addEventListener("dragstart", b), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", b), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, b) => {
          if (r = a === f.dom.parentElement, i = b, !r) {
            const h = To;
            h != null && h.isEditable && setTimeout(() => {
              const p = h.state.selection;
              p && h.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, b) => {
          var h;
          const p = (h = b.clipboardData) == null ? void 0 : h.getData("text/html");
          return o = b, l = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, b, h) => {
      const p = f[0], x = p.getMeta("uiEvent") === "paste" && !l, y = p.getMeta("uiEvent") === "drop" && !r, w = p.getMeta("applyPasteRules"), $ = !!w;
      if (!x && !y && !$)
        return;
      if ($) {
        let { text: T } = w;
        typeof T == "string" ? T = T : T = yc(Pe.from(T), h.schema);
        const { from: E } = w, A = E + T.length, D = _A(T);
        return s({
          rule: u,
          state: h,
          from: E,
          to: { b: A },
          pasteEvt: D
        });
      }
      const S = b.doc.content.findDiffStart(h.doc.content), L = b.doc.content.findDiffEnd(h.doc.content);
      if (!(!JA(S) || !L || S === L.b))
        return s({
          rule: u,
          state: h,
          from: S,
          to: L,
          pasteEvt: o
        });
    }
  }));
}
var hs = class {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.baseExtensions = e, this.extensions = Lp(e), this.schema = uA(this.extensions, n), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const t = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: this.editor,
        type: rr(n.name, this.schema)
      }, a = Xe(n, "addCommands", t);
      return a ? {
        ...e,
        ...a()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this;
    return Ir([...this.extensions].reverse()).flatMap((a) => {
      const l = {
        name: a.name,
        options: a.options,
        storage: this.editor.extensionStorage[a.name],
        editor: e,
        type: rr(a.name, this.schema)
      }, r = [], o = Xe(
        a,
        "addKeyboardShortcuts",
        l
      );
      let i = {};
      if (a.type === "mark" && Xe(a, "exitable", l) && (i.ArrowRight = () => ma.handleExit({ editor: e, mark: a })), o) {
        const b = Object.fromEntries(
          Object.entries(o()).map(([h, p]) => [h, () => p({ editor: e })])
        );
        i = { ...i, ...b };
      }
      const s = uL(i);
      r.push(s);
      const d = Xe(a, "addInputRules", l);
      if (Oh(a, e.options.enableInputRules) && d) {
        const b = d();
        if (b && b.length) {
          const h = KA({
            editor: e,
            rules: b
          }), p = Array.isArray(h) ? h : [h];
          r.push(...p);
        }
      }
      const u = Xe(a, "addPasteRules", l);
      if (Oh(a, e.options.enablePasteRules) && u) {
        const b = u();
        if (b && b.length) {
          const h = eE({ editor: e, rules: b });
          r.push(...h);
        }
      }
      const f = Xe(
        a,
        "addProseMirrorPlugins",
        l
      );
      if (f) {
        const b = f();
        r.push(...b);
      }
      return r;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Tp(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = Ul(this.extensions);
    return Object.fromEntries(
      n.filter((t) => !!Xe(t, "addNodeView")).map((t) => {
        const a = this.attributes.filter((s) => s.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: zt(t.name, this.schema)
        }, r = Xe(t, "addNodeView", l);
        if (!r)
          return [];
        const o = r();
        if (!o)
          return [];
        const i = (s, d, u, f, b) => {
          const h = Jr(s, a);
          return o({
            // pass-through
            node: s,
            view: d,
            getPos: u,
            decorations: f,
            innerDecorations: b,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: h
          });
        };
        return [t.name, i];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(e) {
    const { editor: n } = this;
    return Ir([...this.extensions].reverse()).reduceRight((a, l) => {
      const r = {
        name: l.name,
        options: l.options,
        storage: this.editor.extensionStorage[l.name],
        editor: n,
        type: rr(l.name, this.schema)
      }, o = Xe(
        l,
        "dispatchTransaction",
        r
      );
      return o ? (i) => {
        o.call(r, { transaction: i, next: a });
      } : a;
    }, e);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(e) {
    const { editor: n } = this;
    return Ir([...this.extensions]).reduce(
      (a, l) => {
        const r = {
          name: l.name,
          options: l.options,
          storage: this.editor.extensionStorage[l.name],
          editor: n,
          type: rr(l.name, this.schema)
        }, o = Xe(
          l,
          "transformPastedHTML",
          r
        );
        return o ? (i, s) => {
          const d = a(i, s);
          return o.call(r, d);
        } : a;
      },
      e || ((a) => a)
    );
  }
  get markViews() {
    const { editor: e } = this, { markExtensions: n } = Ul(this.extensions);
    return Object.fromEntries(
      n.filter((t) => !!Xe(t, "addMarkView")).map((t) => {
        const a = this.attributes.filter((i) => i.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: ga(t.name, this.schema)
        }, r = Xe(t, "addMarkView", l);
        if (!r)
          return [];
        const o = (i, s, d) => {
          const u = Jr(i, a);
          return r()({
            // pass-through
            mark: i,
            view: s,
            inline: d,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: u,
            updateAttributes: (f) => {
              gE(i, e, f);
            }
          });
        };
        return [t.name, o];
      })
    );
  }
  /**
   * Destroy the extension manager and clean up all extension references
   * to prevent memory leaks through parent/child extension chains.
   *
   * Walks each extension's full parent chain and nulls every forward
   * `parent.child → current` link where the parent still points to the
   * current node. This breaks the retention path from module-scope
   * singleton roots through deep extend() chains.
   *
   * Only ancestor `.child` links matching the current chain are cleared.
   * The `.parent` pointer on ancestors is never touched — extensions
   * may be shared across live editors, so their own backward references
   * and non-matching forward links must remain intact.
   */
  destroy() {
    this.extensions.forEach((e) => {
      let n = e;
      for (; n.parent; ) {
        const t = n.parent;
        t.child === n && (t.child = null), n = t;
      }
    }), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const e = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      e.map((n) => [n.name, n.storage])
    ), e.forEach((n) => {
      var t;
      const a = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: this.editor,
        type: rr(n.name, this.schema)
      };
      n.type === "mark" && ((t = bt(Xe(n, "keepOnSplit", a))) == null || t) && this.splittableMarks.push(n.name);
      const l = Xe(n, "onBeforeCreate", a), r = Xe(n, "onCreate", a), o = Xe(n, "onUpdate", a), i = Xe(
        n,
        "onSelectionUpdate",
        a
      ), s = Xe(n, "onTransaction", a), d = Xe(n, "onFocus", a), u = Xe(n, "onBlur", a), f = Xe(n, "onDestroy", a);
      l && this.editor.on("beforeCreate", l), r && this.editor.on("create", r), o && this.editor.on("update", o), i && this.editor.on("selectionUpdate", i), s && this.editor.on("transaction", s), d && this.editor.on("focus", d), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
};
hs.resolve = Lp;
hs.sort = Ir;
hs.flatten = xc;
var tE = {};
mc(tE, {
  ClipboardTextSerializer: () => Vp,
  Commands: () => Np,
  Delete: () => Hp,
  Drop: () => jp,
  Editable: () => Wp,
  FocusEvents: () => Up,
  Keymap: () => Gp,
  Paste: () => Kp,
  Tabindex: () => Yp,
  TextDirection: () => Jp,
  focusEventsPluginKey: () => qp
});
var pt = class Fp extends wc {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new Fp(t);
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
}, Vp = pt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: n, schema: t } = e, { doc: a, selection: l } = n, { ranges: r } = l, o = Math.min(...r.map((u) => u.$from.pos)), i = Math.max(...r.map((u) => u.$to.pos)), s = Ep(t);
            return Ap(a, { from: o, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: s
            });
          }
        }
      })
    ];
  }
}), Np = pt.create({
  name: "commands",
  addCommands() {
    return {
      ...vp
    };
  }
}), Hp = pt.create({
  name: "delete",
  onUpdate({ transaction: e, appendedTransactions: n }) {
    var t, a, l;
    const r = () => {
      var o, i, s, d;
      if ((d = (s = (i = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : i.filterTransaction) == null ? void 0 : s.call(i, e)) != null ? d : e.getMeta("y-sync$"))
        return;
      const u = $p(e.before, [e, ...n]);
      Bp(u).forEach((h) => {
        u.mapping.mapResult(h.oldRange.from).deletedAfter && u.mapping.mapResult(h.oldRange.to).deletedBefore && u.before.nodesBetween(h.oldRange.from, h.oldRange.to, (p, x) => {
          const y = x + p.nodeSize - 2, w = h.oldRange.from <= x && y <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: x,
            to: y,
            newFrom: u.mapping.map(x),
            newTo: u.mapping.map(y),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !w,
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        });
      });
      const b = u.mapping;
      u.steps.forEach((h, p) => {
        var x, y;
        if (h instanceof Fn) {
          const w = b.slice(p).map(h.from, -1), $ = b.slice(p).map(h.to), S = b.invert().map(w, -1), L = b.invert().map($), T = w > 0 ? (x = u.doc.nodeAt(w - 1)) == null ? void 0 : x.marks.some((A) => A.eq(h.mark)) : !1, E = (y = u.doc.nodeAt($)) == null ? void 0 : y.marks.some((A) => A.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: S,
              to: L
            },
            newRange: {
              from: w,
              to: $
            },
            partial: !!(E || T),
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        }
      });
    };
    (l = (a = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : a.async) == null || l ? setTimeout(r, 0) : r();
  }
}), jp = pt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("tiptapDrop"),
        props: {
          handleDrop: (e, n, t, a) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: n,
              slice: t,
              moved: a
            });
          }
        }
      })
    ];
  }
}), Wp = pt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), qp = new Pt("focusEvents"), Up = pt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Tt({
        key: qp,
        props: {
          handleDOMEvents: {
            focus: (n, t) => {
              e.isFocused = !0;
              const a = e.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return n.dispatch(a), !1;
            },
            blur: (n, t) => {
              e.isFocused = !1;
              const a = e.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return n.dispatch(a), !1;
            }
          }
        }
      })
    ];
  }
}), Gp = pt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: i }) => {
        const { selection: s, doc: d } = i, { empty: u, $anchor: f } = s, { pos: b, parent: h } = f, p = f.parent.isTextblock && b > 0 ? i.doc.resolve(b - 1) : f, x = p.parent.type.spec.isolating, y = f.pos - f.parentOffset, w = x && p.parent.childCount === 1 ? y === f.pos : rt.atStart(d).from === b;
        return !u || !h.type.isTextblock || h.textContent.length || !w || w && f.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), a = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: n,
      "Mod-Delete": n,
      "Mod-a": () => this.editor.commands.selectAll()
    }, l = {
      ...a
    }, r = {
      ...a,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": n,
      "Ctrl-Alt-Backspace": n,
      "Alt-Delete": n,
      "Alt-d": n,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return pi() || Cp() ? r : l;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Tt({
        key: new Pt("clearDocument"),
        appendTransaction: (e, n, t) => {
          if (e.some((x) => x.getMeta("composition")))
            return;
          const a = e.some((x) => x.docChanged) && !n.doc.eq(t.doc), l = e.some((x) => x.getMeta("preventClearDocument"));
          if (!a || l)
            return;
          const { empty: r, from: o, to: i } = n.selection, s = rt.atStart(n.doc).from, d = rt.atEnd(n.doc).to;
          if (r || !(o === s && i === d) || !Xr(t.doc))
            return;
          const b = t.tr, h = ss({
            state: t,
            transaction: b
          }), { commands: p } = new ds({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!b.steps.length)
            return b;
        }
      })
    ];
  }
}), Kp = pt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("tiptapPaste"),
        props: {
          handlePaste: (e, n, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: n,
              slice: t
            });
          }
        }
      })
    ];
  }
}), Yp = pt.create({
  name: "tabindex",
  addOptions() {
    return {
      value: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("tabindex"),
        props: {
          attributes: () => {
            var e;
            return !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: (e = this.options.value) != null ? e : "0" };
          }
        }
      })
    ];
  }
}), Jp = pt.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: e } = Ul(this.extensions);
    return [
      {
        types: e.filter((n) => n.name !== "text").map((n) => n.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (n) => {
              const t = n.getAttribute("dir");
              return t && (t === "ltr" || t === "rtl" || t === "auto") ? t : this.options.direction;
            },
            renderHTML: (n) => n.dir ? {
              dir: n.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("textDirection"),
        props: {
          attributes: () => {
            const e = this.options.direction;
            return e ? {
              dir: e
            } : {};
          }
        }
      })
    ];
  }
}), nE = class mr {
  constructor(n, t, a = !1, l = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = a, this.resolvedPos = n, this.editor = t, this.currentNode = l;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var n;
    return (n = this.actualDepth) != null ? n : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(n) {
    let t = this.from, a = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, a = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: a }, n);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const n = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(n);
    return new mr(t, this.editor);
  }
  get before() {
    let n = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return n.depth !== this.depth && (n = this.resolvedPos.doc.resolve(this.from - 3)), new mr(n, this.editor);
  }
  get after() {
    let n = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return n.depth !== this.depth && (n = this.resolvedPos.doc.resolve(this.to + 3)), new mr(n, this.editor);
  }
  get children() {
    const n = [];
    return this.node.content.forEach((t, a) => {
      const l = t.isBlock && !t.isTextblock, r = t.isAtom && !t.isText, o = t.isInline, i = this.pos + a + (r ? 0 : 1);
      if (i < 0 || i > this.resolvedPos.doc.nodeSize - 2)
        return;
      const s = this.resolvedPos.doc.resolve(i);
      if (!l && !o && s.depth <= this.depth)
        return;
      const d = new mr(s, this.editor, l, l || o ? t : null);
      l && (d.actualDepth = this.depth + 1), n.push(d);
    }), n;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const n = this.children;
    return n[n.length - 1] || null;
  }
  closest(n, t = {}) {
    let a = null, l = this.parent;
    for (; l && !a; ) {
      if (l.node.type.name === n)
        if (Object.keys(t).length > 0) {
          const r = l.node.attrs, o = Object.keys(t);
          for (let i = 0; i < o.length; i += 1) {
            const s = o[i];
            if (r[s] !== t[s])
              break;
          }
        } else
          a = l;
      l = l.parent;
    }
    return a;
  }
  querySelector(n, t = {}) {
    return this.querySelectorAll(n, t, !0)[0] || null;
  }
  querySelectorAll(n, t = {}, a = !1) {
    let l = [];
    if (!this.children || this.children.length === 0)
      return l;
    const r = Object.keys(t);
    return this.children.forEach((o) => {
      a && l.length > 0 || (o.node.type.name === n && r.every((s) => t[s] === o.node.attrs[s]) && l.push(o), !(a && l.length > 0) && (l = l.concat(o.querySelectorAll(n, t, a))));
    }), l;
  }
  setAttribute(n) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...n
    }), this.editor.view.dispatch(t);
  }
}, aE = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function lE(e, n, t) {
  const a = document.querySelector("style[data-tiptap-style]");
  if (a !== null)
    return a;
  const l = document.createElement("style");
  return n && l.setAttribute("nonce", n), l.setAttribute("data-tiptap-style", ""), l.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(l), l;
}
var rE = class extends UA {
  constructor(n = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: l }) => {
        throw l;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: kA,
      createMappablePosition: wA
    }, this.setOptions(n), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: l, slice: r, moved: o }) => this.options.onDrop(l, r, o)), this.on("paste", ({ event: l, slice: r }) => this.options.onPaste(l, r)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), a = kp(t, this.options.autofocus);
    this.editorState = Il.create({
      doc: t,
      schema: this.schema,
      selection: a || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(n) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(n), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const n = this.editorView.dom;
      n != null && n.editor && delete n.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (n) {
        console.warn("Failed to remove CSS element:", n);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = lE(aE, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(n = {}) {
    this.options = {
      ...this.options,
      ...n
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(n, t = !0) {
    this.setOptions({ editable: n }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (n) => {
          this.editorState = n;
        },
        dispatch: (n) => {
          this.dispatchTransaction(n);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (n, t) => {
          if (this.editorView)
            return this.editorView[t];
          if (t === "state")
            return this.editorState;
          if (t in n)
            return Reflect.get(n, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(n, t) {
    const a = Ip(t) ? t(n, [...this.state.plugins]) : [...this.state.plugins, n], l = this.state.reconfigure({ plugins: a });
    return this.view.updateState(l), l;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(n) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let a = t;
    if ([].concat(n).forEach((r) => {
      const o = typeof r == "string" ? `${r}$` : r.key;
      a = a.filter((i) => !i.key.startsWith(o));
    }), t.length === a.length)
      return;
    const l = this.state.reconfigure({
      plugins: a
    });
    return this.view.updateState(l), l;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var n, t, a, l;
    const o = [...this.options.enableCoreExtensions ? [
      Wp,
      Vp.configure({
        blockSeparator: (t = (n = this.options.coreExtensionOptions) == null ? void 0 : n.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      Np,
      Up,
      Gp,
      Yp.configure({
        value: (l = (a = this.options.coreExtensionOptions) == null ? void 0 : a.tabindex) == null ? void 0 : l.value
      }),
      jp,
      Kp,
      Hp,
      Jp.configure({
        direction: this.options.textDirection
      })
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new hs(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new ds({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let n;
    try {
      n = Zd(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = Zd(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return n;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(n) {
    const { editorProps: t, enableExtensionDispatchTransaction: a } = this.options, l = t.dispatchTransaction || this.dispatchTransaction.bind(this), r = a ? this.extensionManager.dispatchTransaction(l) : l, o = t.transformPastedHTML, i = this.extensionManager.transformPastedHTML(o);
    this.editorView = new mp(n, {
      ...t,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...t == null ? void 0 : t.attributes
      },
      dispatchTransaction: r,
      transformPastedHTML: i,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const s = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(s), this.prependClass(), this.injectCSS();
    const d = this.view.dom;
    d.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(n) {
    this.isCapturingTransaction = !0, n(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(n) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = n;
        return;
      }
      n.steps.forEach((u) => {
        var f;
        return (f = this.capturedTransaction) == null ? void 0 : f.step(u);
      });
      return;
    }
    const { state: t, transactions: a } = this.state.applyTransaction(n), l = !this.state.selection.eq(t.selection), r = a.includes(n), o = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: n,
      nextState: t
    }), !r)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: n,
      appendedTransactions: a.slice(1)
    }), l && this.emit("selectionUpdate", {
      editor: this,
      transaction: n
    });
    const i = a.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), s = i == null ? void 0 : i.getMeta("focus"), d = i == null ? void 0 : i.getMeta("blur");
    s && this.emit("focus", {
      editor: this,
      event: s.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), d && this.emit("blur", {
      editor: this,
      event: d.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), !(n.getMeta("preventUpdate") || !a.some((u) => u.docChanged) || o.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: n,
      appendedTransactions: a.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(n) {
    return Rp(this.state, n);
  }
  isActive(n, t) {
    const a = typeof n == "string" ? n : null, l = typeof n == "string" ? t : n;
    return vA(this.state, a, l);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return yc(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(n) {
    const { blockSeparator: t = `

`, textSerializers: a = {} } = n || {};
    return fA(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...Ep(this.schema),
        ...a
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Xr(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var n, t;
    return (t = (n = this.editorView) == null ? void 0 : n.isDestroyed) != null ? t : !0;
  }
  $node(n, t) {
    var a;
    return ((a = this.$doc) == null ? void 0 : a.querySelector(n, t)) || null;
  }
  $nodes(n, t) {
    var a;
    return ((a = this.$doc) == null ? void 0 : a.querySelectorAll(n, t)) || null;
  }
  $pos(n) {
    const t = this.state.doc.resolve(n), a = n > 0 && t.nodeAfter && !t.nodeAfter.isText ? t.nodeAfter : null;
    return new nE(t, this, !1, a);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function ml(e) {
  return new fs({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = bt(e.getAttributes, void 0, a);
      if (l === !1 || l === null)
        return null;
      const { tr: r } = n, o = a[a.length - 1], i = a[0];
      if (o) {
        const s = i.search(/\S/), d = t.from + i.indexOf(o), u = d + o.length;
        if (kc(t.from, t.to, n.doc).filter((h) => h.mark.type.excluded.find((x) => x === e.type && x !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        u < t.to && r.delete(u, t.to), d > t.from && r.delete(t.from + s, d);
        const b = t.from + s + o.length;
        r.addMark(t.from + s, b, e.type.create(l || {})), r.removeStoredMark(e.type);
      }
    },
    undoable: e.undoable
  });
}
function Xp(e) {
  return new fs({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = bt(e.getAttributes, void 0, a) || {}, { tr: r } = n, o = t.from;
      let i = t.to;
      const s = e.type.create(l);
      if (a[1]) {
        const d = a[0].lastIndexOf(a[1]);
        let u = o + d;
        u > i ? u = i : i = u + a[1].length;
        const f = a[0][a[0].length - 1];
        r.insertText(f, o + a[0].length - 1), r.replaceWith(u, i, s);
      } else if (a[0]) {
        const d = e.type.isInline ? o : o - 1;
        r.insert(d, e.type.create(l)).delete(r.mapping.map(o), r.mapping.map(i));
      }
      r.scrollIntoView();
    },
    undoable: e.undoable
  });
}
function _d(e) {
  return new fs({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = n.doc.resolve(t.from), r = bt(e.getAttributes, void 0, a) || {};
      if (!l.node(-1).canReplaceWith(l.index(-1), l.indexAfter(-1), e.type))
        return null;
      n.tr.delete(t.from, t.to).setBlockType(t.from, t.from, e.type, r);
    },
    undoable: e.undoable
  });
}
function Gl(e) {
  return new fs({
    find: e.find,
    handler: ({ state: n, range: t, match: a, chain: l }) => {
      const r = bt(e.getAttributes, void 0, a) || {}, o = n.tr.delete(t.from, t.to), s = o.doc.resolve(t.from).blockRange(), d = s && tc(s, e.type, r);
      if (!d)
        return null;
      if (o.wrap(s, d), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: b } = n, { splittableMarks: h } = e.editor.extensionManager, p = b || f.$to.parentOffset && f.$from.marks();
        if (p) {
          const x = p.filter((y) => h.includes(y.type.name));
          o.ensureMarks(x);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        l().updateAttributes(f, r).run();
      }
      const u = o.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === e.type && qa(o.doc, t.from - 1) && (!e.joinPredicate || e.joinPredicate(a, u)) && o.join(t.from - 1);
    },
    undoable: e.undoable
  });
}
var oE = (e) => "touches" in e, iE = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(e) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.clientX - this.startX, d = i.clientY - this.startY;
      this.handleResize(s, d);
    }, this.handleTouchMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.touches[0];
      if (!s)
        return;
      const d = s.clientX - this.startX, u = s.clientY - this.startY;
      this.handleResize(d, u);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const i = this.element.offsetWidth, s = this.element.offsetHeight;
      this.onCommit(i, s), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var n, t, a, l, r, o;
    this.node = e.node, this.editor = e.editor, this.element = e.element, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, (n = e.options) != null && n.min && (this.minSize = {
      ...this.minSize,
      ...e.options.min
    }), (t = e.options) != null && t.max && (this.maxSize = e.options.max), (a = e == null ? void 0 : e.options) != null && a.directions && (this.directions = e.options.directions), (l = e.options) != null && l.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), (r = e.options) != null && r.className && (this.classNames = {
      container: e.options.className.container || "",
      wrapper: e.options.className.wrapper || "",
      handle: e.options.className.handle || "",
      resizing: e.options.className.resizing || ""
    }), (o = e.options) != null && o.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var e;
    return (e = this.contentElement) != null ? e : null;
  }
  handleEditorUpdate() {
    const e = this.editor.isEditable;
    e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(e, n, t) {
    return e.type !== this.node.type ? !1 : (this.node = e, this.onUpdate ? this.onUpdate(e, n, t) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const e = document.createElement("div");
    return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const e = document.createElement("div");
    return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(e) {
    const n = document.createElement("div");
    return n.dataset.resizeHandle = e, n.style.position = "absolute", this.classNames.handle && (n.className = this.classNames.handle), n;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(e, n) {
    const t = n.includes("top"), a = n.includes("bottom"), l = n.includes("left"), r = n.includes("right");
    t && (e.style.top = "0"), a && (e.style.bottom = "0"), l && (e.style.left = "0"), r && (e.style.right = "0"), (n === "top" || n === "bottom") && (e.style.left = "0", e.style.right = "0"), (n === "left" || n === "right") && (e.style.top = "0", e.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((e) => {
      let n;
      this.createCustomHandle ? n = this.createCustomHandle(e) : n = this.createHandle(e), n instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`
      ), n = this.createHandle(e)), this.createCustomHandle || this.positionHandle(n, e), n.addEventListener("mousedown", (t) => this.handleResizeStart(t, e)), n.addEventListener("touchstart", (t) => this.handleResizeStart(t, e)), this.handleMap.set(e, n), this.wrapper.appendChild(n);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const e = this.node.attrs.width, n = this.node.attrs.height;
    e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, n ? (this.element.style.height = `${n}px`, this.initialHeight = n) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(e, n) {
    e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = n, oE(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(e, n) {
    if (!this.activeHandle)
      return;
    const t = this.preserveAspectRatio || this.isShiftKeyPressed, { width: a, height: l } = this.calculateNewDimensions(this.activeHandle, e, n), r = this.applyConstraints(a, l, t);
    this.element.style.width = `${r.width}px`, this.element.style.height = `${r.height}px`, this.onResize && this.onResize(r.width, r.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(e, n, t) {
    let a = this.startWidth, l = this.startHeight;
    const r = e.includes("right"), o = e.includes("left"), i = e.includes("bottom"), s = e.includes("top");
    return r ? a = this.startWidth + n : o && (a = this.startWidth - n), i ? l = this.startHeight + t : s && (l = this.startHeight - t), (e === "right" || e === "left") && (a = this.startWidth + (r ? n : -n)), (e === "top" || e === "bottom") && (l = this.startHeight + (i ? t : -t)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(a, l, e) : { width: a, height: l };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(e, n, t) {
    var a, l, r, o;
    if (!t) {
      let d = Math.max(this.minSize.width, e), u = Math.max(this.minSize.height, n);
      return (a = this.maxSize) != null && a.width && (d = Math.min(this.maxSize.width, d)), (l = this.maxSize) != null && l.height && (u = Math.min(this.maxSize.height, u)), { width: d, height: u };
    }
    let i = e, s = n;
    return i < this.minSize.width && (i = this.minSize.width, s = i / this.aspectRatio), s < this.minSize.height && (s = this.minSize.height, i = s * this.aspectRatio), (r = this.maxSize) != null && r.width && i > this.maxSize.width && (i = this.maxSize.width, s = i / this.aspectRatio), (o = this.maxSize) != null && o.height && s > this.maxSize.height && (s = this.maxSize.height, i = s * this.aspectRatio), { width: i, height: s };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(e, n, t) {
    const a = t === "left" || t === "right", l = t === "top" || t === "bottom";
    return a ? {
      width: e,
      height: e / this.aspectRatio
    } : l ? {
      width: n * this.aspectRatio,
      height: n
    } : {
      width: e,
      height: e / this.aspectRatio
    };
  }
};
function sE(e, n) {
  const { selection: t } = e, { $from: a } = t;
  if (t instanceof Qe) {
    const r = a.index();
    return a.parent.canReplaceWith(r, r + 1, n);
  }
  let l = a.depth;
  for (; l >= 0; ) {
    const r = a.index(l);
    if (a.node(l).contentMatchAt(r).matchType(n))
      return !0;
    l -= 1;
  }
  return !1;
}
function _l(e, n) {
  const t = e.getAttribute("style");
  if (!t)
    return null;
  const a = t.split(";").map((r) => r.trim()).filter(Boolean), l = n.toLowerCase();
  for (let r = a.length - 1; r >= 0; r -= 1) {
    const o = a[r], i = o.indexOf(":");
    if (i === -1)
      continue;
    if (o.slice(0, i).trim().toLowerCase() === l)
      return o.slice(i + 1).trim();
  }
  return null;
}
var dE = {};
mc(dE, {
  createAtomBlockMarkdownSpec: () => uE,
  createBlockMarkdownSpec: () => cE,
  createInlineMarkdownSpec: () => bE,
  parseAttributes: () => Cc,
  parseIndentedBlocks: () => eu,
  renderNestedMarkdownContent: () => $c,
  serializeAttributes: () => Sc
});
function Cc(e) {
  if (!(e != null && e.trim()))
    return {};
  const n = {}, t = [], a = e.replace(/["']([^"']*)["']/g, (d) => (t.push(d), `__QUOTED_${t.length - 1}__`)), l = a.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (l) {
    const d = l.map((u) => u.trim().slice(1));
    n.class = d.join(" ");
  }
  const r = a.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  r && (n.id = r[1]);
  const o = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(a.matchAll(o)).forEach(([, d, u]) => {
    var f;
    const b = parseInt(((f = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), h = t[b];
    h && (n[d] = h.slice(1, -1));
  });
  const s = a.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return s && s.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (n[u] = !0);
  }), n;
}
function Sc(e) {
  if (!e || Object.keys(e).length === 0)
    return "";
  const n = [];
  return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((a) => n.push(`.${a}`)), e.id && n.push(`#${e.id}`), Object.entries(e).forEach(([t, a]) => {
    t === "class" || t === "id" || (a === !0 ? n.push(t) : a !== !1 && a != null && n.push(`${t}="${String(a)}"`));
  }), n.join(" ");
}
function uE(e) {
  const {
    nodeName: n,
    name: t,
    parseAttributes: a = Cc,
    serializeAttributes: l = Sc,
    defaultAttributes: r = {},
    requiredAttributes: o = [],
    allowedAttributes: i
  } = e, s = t || n, d = (u) => {
    if (!i)
      return u;
    const f = {};
    return i.forEach((b) => {
      b in u && (f[b] = u[b]);
    }), f;
  };
  return {
    parseMarkdown: (u, f) => {
      const b = { ...r, ...u.attributes };
      return f.createNode(n, b, []);
    },
    markdownTokenizer: {
      name: n,
      level: "block",
      start(u) {
        var f;
        const b = new RegExp(`^:::${s}(?:\\s|$)`, "m"), h = (f = u.match(b)) == null ? void 0 : f.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(u, f, b) {
        const h = new RegExp(`^:::${s}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), p = u.match(h);
        if (!p)
          return;
        const x = p[1] || "", y = a(x);
        if (!o.find(($) => !($ in y)))
          return {
            type: n,
            raw: p[0],
            attributes: y
          };
      }
    },
    renderMarkdown: (u) => {
      const f = d(u.attrs || {}), b = l(f), h = b ? ` {${b}}` : "";
      return `:::${s}${h} :::`;
    }
  };
}
function cE(e) {
  const {
    nodeName: n,
    name: t,
    getContent: a,
    parseAttributes: l = Cc,
    serializeAttributes: r = Sc,
    defaultAttributes: o = {},
    content: i = "block",
    allowedAttributes: s
  } = e, d = t || n, u = (f) => {
    if (!s)
      return f;
    const b = {};
    return s.forEach((h) => {
      h in f && (b[h] = f[h]);
    }), b;
  };
  return {
    parseMarkdown: (f, b) => {
      let h;
      if (a) {
        const x = a(f);
        h = typeof x == "string" ? [{ type: "text", text: x }] : x;
      } else i === "block" ? h = b.parseChildren(f.tokens || []) : h = b.parseInline(f.tokens || []);
      const p = { ...o, ...f.attributes };
      return b.createNode(n, p, h);
    },
    markdownTokenizer: {
      name: n,
      level: "block",
      start(f) {
        var b;
        const h = new RegExp(`^:::${d}`, "m"), p = (b = f.match(h)) == null ? void 0 : b.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(f, b, h) {
        var p;
        const x = new RegExp(`^:::${d}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), y = f.match(x);
        if (!y)
          return;
        const [w, $ = ""] = y, S = l($);
        let L = 1;
        const T = w.length;
        let E = "";
        const A = /^:::([\w-]*)(\s.*)?/gm, D = f.slice(T);
        for (A.lastIndex = 0; ; ) {
          const M = A.exec(D);
          if (M === null)
            break;
          const F = M.index, X = M[1];
          if (!((p = M[2]) != null && p.endsWith(":::"))) {
            if (X)
              L += 1;
            else if (L -= 1, L === 0) {
              const _ = D.slice(0, F);
              E = _.trim();
              const Y = f.slice(0, T + F + M[0].length);
              let B = [];
              if (E)
                if (i === "block")
                  for (B = h.blockTokens(_), B.forEach((W) => {
                    W.text && (!W.tokens || W.tokens.length === 0) && (W.tokens = h.inlineTokens(W.text));
                  }); B.length > 0; ) {
                    const W = B[B.length - 1];
                    if (W.type === "paragraph" && (!W.text || W.text.trim() === ""))
                      B.pop();
                    else
                      break;
                  }
                else
                  B = h.inlineTokens(E);
              return {
                type: n,
                raw: Y,
                attributes: S,
                content: E,
                tokens: B
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, b) => {
      const h = u(f.attrs || {}), p = r(h), x = p ? ` {${p}}` : "", y = b.renderChildren(f.content || [], `

`);
      return `:::${d}${x}

${y}

:::`;
    }
  };
}
function fE(e) {
  if (!e.trim())
    return {};
  const n = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let a = t.exec(e);
  for (; a !== null; ) {
    const [, l, r, o] = a;
    n[l] = r || o, a = t.exec(e);
  }
  return n;
}
function hE(e) {
  return Object.entries(e).filter(([, n]) => n != null).map(([n, t]) => `${n}="${t}"`).join(" ");
}
function bE(e) {
  const {
    nodeName: n,
    name: t,
    getContent: a,
    parseAttributes: l = fE,
    serializeAttributes: r = hE,
    defaultAttributes: o = {},
    selfClosing: i = !1,
    allowedAttributes: s
  } = e, d = t || n, u = (b) => {
    if (!s)
      return b;
    const h = {};
    return s.forEach((p) => {
      const x = typeof p == "string" ? p : p.name, y = typeof p == "string" ? void 0 : p.skipIfDefault;
      if (x in b) {
        const w = b[x];
        if (y !== void 0 && w === y)
          return;
        h[x] = w;
      }
    }), h;
  }, f = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (b, h) => {
      const p = { ...o, ...b.attributes };
      if (i)
        return h.createNode(n, p);
      const x = a ? a(b) : b.content || "";
      return x ? h.createNode(n, p, [h.createTextNode(x)]) : h.createNode(n, p, []);
    },
    markdownTokenizer: {
      name: n,
      level: "inline",
      start(b) {
        const h = i ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), p = b.match(h), x = p == null ? void 0 : p.index;
        return x !== void 0 ? x : -1;
      },
      tokenize(b, h, p) {
        const x = i ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), y = b.match(x);
        if (!y)
          return;
        let w = "", $ = "";
        if (i) {
          const [, L] = y;
          $ = L;
        } else {
          const [, L, T] = y;
          $ = L, w = T || "";
        }
        const S = l($.trim());
        return {
          type: n,
          raw: y[0],
          content: w.trim(),
          attributes: S
        };
      }
    },
    renderMarkdown: (b) => {
      let h = "";
      a ? h = a(b) : b.content && b.content.length > 0 && (h = b.content.filter((w) => w.type === "text").map((w) => w.text).join(""));
      const p = u(b.attrs || {}), x = r(p), y = x ? ` ${x}` : "";
      return i ? `[${d}${y}]` : `[${d}${y}]${h}[/${d}]`;
    }
  };
}
function eu(e, n, t) {
  var a, l, r, o;
  const i = e.split(`
`), s = [];
  let d = "", u = 0;
  const f = n.baseIndentSize || 2;
  for (; u < i.length; ) {
    const b = i[u], h = b.match(n.itemPattern);
    if (!h) {
      if (s.length > 0)
        break;
      if (b.trim() === "") {
        u += 1, d = `${d}${b}
`;
        continue;
      } else
        return;
    }
    const p = n.extractItemData(h), { indentLevel: x, mainContent: y } = p;
    d = `${d}${b}
`;
    const w = [y];
    for (u += 1; u < i.length; ) {
      const T = i[u];
      if (T.trim() === "") {
        const A = i.slice(u + 1).findIndex((F) => F.trim() !== "");
        if (A === -1)
          break;
        if ((((l = (a = i[u + 1 + A].match(/^(\s*)/)) == null ? void 0 : a[1]) == null ? void 0 : l.length) || 0) > x) {
          w.push(T), d = `${d}${T}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((o = (r = T.match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0) > x)
        w.push(T), d = `${d}${T}
`, u += 1;
      else
        break;
    }
    let $;
    const S = w.slice(1);
    if (S.length > 0) {
      const T = S.map((E) => E.slice(x + f)).join(`
`);
      T.trim() && (n.customNestedParser ? $ = n.customNestedParser(T) : $ = t.blockTokens(T));
    }
    const L = n.createToken(p, $);
    s.push(L);
  }
  if (s.length !== 0)
    return {
      items: s,
      raw: d
    };
}
function $c(e, n, t, a) {
  if (!e || !Array.isArray(e.content))
    return "";
  const l = typeof t == "function" ? t(a) : t, [r, ...o] = e.content, i = n.renderChildren([r]);
  let s = `${l}${i}`;
  return o && o.length > 0 && o.forEach((d, u) => {
    var f, b;
    const h = (b = (f = n.renderChild) == null ? void 0 : f.call(n, d, u + 1)) != null ? b : n.renderChildren([d]);
    if (h != null) {
      const p = h.split(`
`).map((x) => x ? n.indent(x) : n.indent("")).join(`
`);
      s += d.type === "paragraph" ? `

${p}` : `
${p}`;
    }
  }), s;
}
function gE(e, n, t = {}) {
  const { state: a } = n, { doc: l, tr: r } = a, o = e;
  l.descendants((i, s) => {
    const d = r.mapping.map(s), u = r.mapping.map(s) + i.nodeSize;
    let f = null;
    if (i.marks.forEach((h) => {
      if (h !== o)
        return !1;
      f = h;
    }), !f)
      return;
    let b = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== f.attrs[h] && (b = !0);
    }), b) {
      const h = e.type.create({
        ...e.attrs,
        ...t
      });
      r.removeMark(d, u, e.type), r.addMark(d, u, h);
    }
  }), r.docChanged && n.view.dispatch(r);
}
var fn = class Zp extends wc {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new Zp(t);
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
};
function Fa(e) {
  return new XA({
    find: e.find,
    handler: ({ state: n, range: t, match: a, pasteEvent: l }) => {
      const r = bt(e.getAttributes, void 0, a, l);
      if (r === !1 || r === null)
        return null;
      const { tr: o } = n, i = a[a.length - 1], s = a[0];
      let d = t.to;
      if (i) {
        const u = s.search(/\S/), f = t.from + s.indexOf(i), b = f + i.length;
        if (kc(t.from, t.to, n.doc).filter((x) => x.mark.type.excluded.find((w) => w === e.type && w !== x.mark.type)).filter((x) => x.to > f).length)
          return null;
        b < t.to && o.delete(b, t.to), f > t.from && o.delete(t.from + u, f), d = t.from + u + i.length, o.addMark(t.from + u, d, e.type.create(r || {})), a.index !== void 0 && a.input !== void 0 && a.index + a[0].length >= a.input.length || o.removeStoredMark(e.type);
      }
    }
  });
}
function Fh(e) {
  return Sx((n, t) => ({
    get() {
      return n(), e;
    },
    set(a) {
      e = a, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
var mE = class extends rE {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = Fh(this.view.state), this.reactiveExtensionStorage = Fh(this.extensionStorage), this.on("beforeTransaction", ({ nextState: n }) => {
      this.reactiveState.value = n, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), Cx(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, n) {
    const t = super.registerPlugin(e, n);
    return this.reactiveState && (this.reactiveState.value = t), t;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const n = super.unregisterPlugin(e);
    return this.reactiveState && n && (this.reactiveState.value = n), n;
  }
}, pE = ke({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const n = R(), t = Iu();
    return qb(() => {
      const a = e.editor;
      a && a.options.element && n.value && Ue(() => {
        var l;
        if (!n.value || !((l = a.view.dom) != null && l.parentNode))
          return;
        const r = I(n.value);
        n.value.append(...a.view.dom.parentNode.childNodes), a.contentComponent = t.ctx._, t && (a.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), a.setOptions({
          element: r
        }), a.createNodeViews();
      });
    }), mt(() => {
      const a = e.editor;
      a && (a.contentComponent = null, a.appContext = null);
    }), { rootEl: n };
  },
  render() {
    return Kn("div", {
      ref: (e) => {
        this.rootEl = e;
      }
    });
  }
});
ke({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return Kn(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
ke({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, n;
    return Kn(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (n = (e = this.$slots).default) == null ? void 0 : n.call(e)
    );
  }
});
var vE = (e = {}) => {
  const n = Yl();
  return dt(() => {
    n.value = new mE(e);
  }), mt(() => {
    var t;
    (t = n.value) == null || t.destroy();
  }), n;
};
ke({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return Kn(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var vi = (e, n) => {
  if (e === "slot")
    return 0;
  if (e instanceof Function)
    return e(n);
  const { children: t, ...a } = n ?? {};
  if (e === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [e, a, t];
}, xE = /^\s*>\s$/, yE = fn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ vi("blockquote", { ...It(this.options.HTMLAttributes, e), children: /* @__PURE__ */ vi("slot", {}) });
  },
  parseMarkdown: (e, n) => {
    var t;
    const a = (t = n.parseBlockChildren) != null ? t : n.parseChildren;
    return n.createNode("blockquote", void 0, a(e.tokens || []));
  },
  renderMarkdown: (e, n) => {
    if (!e.content)
      return "";
    const t = ">", a = [];
    return e.content.forEach((l, r) => {
      var o, i;
      const u = ((i = (o = n.renderChild) == null ? void 0 : o.call(n, l, r)) != null ? i : n.renderChildren([l])).split(`
`).map((f) => f.trim() === "" ? t : `${t} ${f}`);
      a.push(u.join(`
`));
    }), a.join(`
${t}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Gl({
        find: xE,
        type: this.type
      })
    ];
  }
}), kE = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, wE = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, CE = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, SE = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, $E = ma.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ vi("strong", { ...It(this.options.HTMLAttributes, e), children: /* @__PURE__ */ vi("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (e, n) => n.applyMark("bold", n.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<strong>",
      close: "</strong>"
    }
  },
  renderMarkdown: (e, n) => `**${n.renderChildren(e)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      ml({
        find: kE,
        type: this.type
      }),
      ml({
        find: CE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fa({
        find: wE,
        type: this.type
      }),
      Fa({
        find: SE,
        type: this.type
      })
    ];
  }
}), IE = /(^|[^`])`([^`]+)`(?!`)$/, TE = /(^|[^`])`([^`]+)`(?!`)/g, LE = ma.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (e, n) => n.applyMark("code", [{ type: "text", text: e.text || "" }]),
  renderMarkdown: (e, n) => e.content ? `\`${n.renderChildren(e.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      ml({
        find: IE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fa({
        find: TE,
        type: this.type
      })
    ];
  }
}), Zs = 4, AE = /^```([a-z]+)?[\s\n]$/, EE = /^~~~([a-z]+)?[\s\n]$/, RE = fn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: Zs,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var n;
          const { languageClassPrefix: t } = this.options;
          if (!t)
            return null;
          const r = [...((n = e.firstElementChild) == null ? void 0 : n.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return r || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [
      "pre",
      It(this.options.HTMLAttributes, n),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (e, n) => {
    var t, a;
    return ((t = e.raw) == null ? void 0 : t.startsWith("```")) === !1 && ((a = e.raw) == null ? void 0 : a.startsWith("~~~")) === !1 && e.codeBlockStyle !== "indented" ? [] : n.createNode(
      "codeBlock",
      { language: e.lang || null },
      e.text ? [n.createTextNode(e.text)] : []
    );
  },
  renderMarkdown: (e, n) => {
    var t;
    let a = "";
    const l = ((t = e.attrs) == null ? void 0 : t.language) || "";
    return e.content ? a = [`\`\`\`${l}`, n.renderChildren(e.content), "```"].join(`
`) : a = `\`\`\`${l}

\`\`\``, a;
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: n }) => n.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: n }) => n.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: n } = this.editor.state.selection, t = n.pos === 1;
        return !e || n.parent.type.name !== this.name ? !1 : t || !n.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: e }) => {
        var n;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (n = this.options.tabSize) != null ? n : Zs, { state: a } = e, { selection: l } = a, { $from: r, empty: o } = l;
        if (r.parent.type !== this.type)
          return !1;
        const i = " ".repeat(t);
        return o ? e.commands.insertContent(i) : e.commands.command(({ tr: s }) => {
          const { from: d, to: u } = l, h = a.doc.textBetween(d, u, `
`, `
`).split(`
`).map((p) => i + p).join(`
`);
          return s.replaceWith(d, u, a.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: e }) => {
        var n;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (n = this.options.tabSize) != null ? n : Zs, { state: a } = e, { selection: l } = a, { $from: r, empty: o } = l;
        return r.parent.type !== this.type ? !1 : o ? e.commands.command(({ tr: i }) => {
          var s;
          const { pos: d } = r, u = r.start(), f = r.end(), h = a.doc.textBetween(u, f, `
`, `
`).split(`
`);
          let p = 0, x = 0;
          const y = d - u;
          for (let E = 0; E < h.length; E += 1) {
            if (x + h[E].length >= y) {
              p = E;
              break;
            }
            x += h[E].length + 1;
          }
          const $ = ((s = h[p].match(/^ */)) == null ? void 0 : s[0]) || "", S = Math.min($.length, t);
          if (S === 0)
            return !0;
          let L = u;
          for (let E = 0; E < p; E += 1)
            L += h[E].length + 1;
          return i.delete(L, L + S), d - L <= S && i.setSelection(at.create(i.doc, L)), !0;
        }) : e.commands.command(({ tr: i }) => {
          const { from: s, to: d } = l, b = a.doc.textBetween(s, d, `
`, `
`).split(`
`).map((h) => {
            var p;
            const x = ((p = h.match(/^ */)) == null ? void 0 : p[0]) || "", y = Math.min(x.length, t);
            return h.slice(y);
          }).join(`
`);
          return i.replaceWith(s, d, a.schema.text(b)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: n } = e, { selection: t } = n, { $from: a, empty: l } = t;
        if (!l || a.parent.type !== this.type)
          return !1;
        const r = a.parentOffset === a.parent.nodeSize - 2, o = a.parent.textContent.endsWith(`

`);
        return !r || !o ? !1 : e.chain().command(({ tr: i }) => (i.delete(a.pos - 2, a.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: n } = e, { selection: t, doc: a } = n, { $from: l, empty: r } = t;
        if (!r || l.parent.type !== this.type || !(l.parentOffset === l.parent.nodeSize - 2))
          return !1;
        const i = l.after();
        return i === void 0 ? !1 : a.nodeAt(i) ? e.commands.command(({ tr: d }) => (d.setSelection(rt.near(a.resolve(i))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      _d({
        find: AE,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      _d({
        find: EE,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Tt({
        key: new Pt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, n) => {
            if (!n.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = n.clipboardData.getData("text/plain"), a = n.clipboardData.getData("vscode-editor-data"), l = a ? JSON.parse(a) : void 0, r = l == null ? void 0 : l.mode;
            if (!t || !r)
              return !1;
            const { tr: o, schema: i } = e.state, s = i.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: r }, s)), o.selection.$from.parent.type !== this.type && o.setSelection(at.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), e.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), BE = fn.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `

`) : ""
}), DE = fn.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", It(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: n, state: t, editor: a }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: l, storedMarks: r } = t;
          if (l.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: i } = a.extensionManager, s = r || l.$to.parentOffset && l.$from.marks();
          return n().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && s && o) {
              const f = s.filter((b) => i.includes(b.type.name));
              d.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), ME = fn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, It(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown: (e, n) => n.createNode("heading", { level: e.depth || 1 }, n.parseInline(e.tokens || [])),
  renderMarkdown: (e, n) => {
    var t;
    const a = (t = e.attrs) != null && t.level ? parseInt(e.attrs.level, 10) : 1, l = "#".repeat(a);
    return e.content ? `${l} ${n.renderChildren(e.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: n }) => this.options.levels.includes(e.level) ? n.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: n }) => this.options.levels.includes(e.level) ? n.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, n) => ({
        ...e,
        [`Mod-Alt-${n}`]: () => this.editor.commands.toggleHeading({ level: n })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => _d({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), zE = fn.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", It(this.options.HTMLAttributes, e)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (e, n) => n.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: n }) => {
        if (!sE(n, n.schema.nodes[this.name]))
          return !1;
        const { selection: t } = n, { $to: a } = t, l = e();
        return Dp(t) ? l.insertContentAt(a.pos, {
          type: this.name
        }) : l.insertContent({ type: this.name }), l.command(({ state: r, tr: o, dispatch: i }) => {
          if (i) {
            const { $to: s } = o.selection, d = s.end();
            if (s.nodeAfter)
              s.nodeAfter.isTextblock ? o.setSelection(at.create(o.doc, s.pos + 1)) : s.nodeAfter.isBlock ? o.setSelection(Qe.create(o.doc, s.pos)) : o.setSelection(at.create(o.doc, s.pos));
            else {
              const u = r.schema.nodes[this.options.nextNodeType] || s.parent.type.contentMatch.defaultType, f = u == null ? void 0 : u.create();
              f && (o.insert(d, f), o.setSelection(at.create(o.doc, d + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Xp({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), OE = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, PE = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, FE = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, VE = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, NE = ma.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", It(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (e, n) => n.applyMark("italic", n.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<em>",
      close: "</em>"
    }
  },
  renderMarkdown: (e, n) => `*${n.renderChildren(e)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      ml({
        find: OE,
        type: this.type
      }),
      ml({
        find: FE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fa({
        find: PE,
        type: this.type
      }),
      Fa({
        find: VE,
        type: this.type
      })
    ];
  }
});
const HE = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", jE = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", tu = "numeric", nu = "ascii", au = "alpha", Tr = "asciinumeric", pr = "alphanumeric", lu = "domain", Qp = "emoji", WE = "scheme", qE = "slashscheme", Qs = "whitespace";
function UE(e, n) {
  return e in n || (n[e] = []), n[e];
}
function el(e, n, t) {
  n[tu] && (n[Tr] = !0, n[pr] = !0), n[nu] && (n[Tr] = !0, n[au] = !0), n[Tr] && (n[pr] = !0), n[au] && (n[pr] = !0), n[pr] && (n[lu] = !0), n[Qp] && (n[lu] = !0);
  for (const a in n) {
    const l = UE(a, t);
    l.indexOf(e) < 0 && l.push(e);
  }
}
function GE(e, n) {
  const t = {};
  for (const a in n)
    n[a].indexOf(e) >= 0 && (t[a] = !0);
  return t;
}
function sn(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
sn.groups = {};
sn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const n = this, t = n.j[e];
    if (t)
      return t;
    for (let a = 0; a < n.jr.length; a++) {
      const l = n.jr[a][0], r = n.jr[a][1];
      if (r && l.test(e))
        return r;
    }
    return n.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, n = !1) {
    return n ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, n, t, a) {
    for (let l = 0; l < e.length; l++)
      this.tt(e[l], n, t, a);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, n, t, a) {
    a = a || sn.groups;
    let l;
    return n && n.j ? l = n : (l = new sn(n), t && a && el(n, t, a)), this.jr.push([e, l]), l;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, n, t, a) {
    let l = this;
    const r = e.length;
    if (!r)
      return l;
    for (let o = 0; o < r - 1; o++)
      l = l.tt(e[o]);
    return l.tt(e[r - 1], n, t, a);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, n, t, a) {
    a = a || sn.groups;
    const l = this;
    if (n && n.j)
      return l.j[e] = n, n;
    const r = n;
    let o, i = l.go(e);
    if (i ? (o = new sn(), Object.assign(o.j, i.j), o.jr.push.apply(o.jr, i.jr), o.jd = i.jd, o.t = i.t) : o = new sn(), r) {
      if (a)
        if (o.t && typeof o.t == "string") {
          const s = Object.assign(GE(o.t, a), t);
          el(r, s, a);
        } else t && el(r, t, a);
      o.t = r;
    }
    return l.j[e] = o, o;
  }
};
const st = (e, n, t, a, l) => e.ta(n, t, a, l), Lt = (e, n, t, a, l) => e.tr(n, t, a, l), Vh = (e, n, t, a, l) => e.ts(n, t, a, l), Ve = (e, n, t, a, l) => e.tt(n, t, a, l), ra = "WORD", ru = "UWORD", _p = "ASCIINUMERICAL", ev = "ALPHANUMERICAL", Zr = "LOCALHOST", ou = "TLD", iu = "UTLD", Yo = "SCHEME", Sl = "SLASH_SCHEME", Ic = "NUM", su = "WS", Tc = "NL", Lr = "OPENBRACE", Ar = "CLOSEBRACE", xi = "OPENBRACKET", yi = "CLOSEBRACKET", ki = "OPENPAREN", wi = "CLOSEPAREN", Ci = "OPENANGLEBRACKET", Si = "CLOSEANGLEBRACKET", $i = "FULLWIDTHLEFTPAREN", Ii = "FULLWIDTHRIGHTPAREN", Ti = "LEFTCORNERBRACKET", Li = "RIGHTCORNERBRACKET", Ai = "LEFTWHITECORNERBRACKET", Ei = "RIGHTWHITECORNERBRACKET", Ri = "FULLWIDTHLESSTHAN", Bi = "FULLWIDTHGREATERTHAN", Di = "AMPERSAND", Mi = "APOSTROPHE", zi = "ASTERISK", ya = "AT", Oi = "BACKSLASH", Pi = "BACKTICK", Fi = "CARET", tl = "COLON", Lc = "COMMA", Vi = "DOLLAR", jn = "DOT", Ni = "EQUALS", Ac = "EXCLAMATION", xn = "HYPHEN", Er = "PERCENT", Hi = "PIPE", ji = "PLUS", Wi = "POUND", Rr = "QUERY", Ec = "QUOTE", tv = "FULLWIDTHMIDDLEDOT", Rc = "SEMI", Wn = "SLASH", Br = "TILDE", qi = "UNDERSCORE", nv = "EMOJI", Ui = "SYM";
var av = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: ev,
  AMPERSAND: Di,
  APOSTROPHE: Mi,
  ASCIINUMERICAL: _p,
  ASTERISK: zi,
  AT: ya,
  BACKSLASH: Oi,
  BACKTICK: Pi,
  CARET: Fi,
  CLOSEANGLEBRACKET: Si,
  CLOSEBRACE: Ar,
  CLOSEBRACKET: yi,
  CLOSEPAREN: wi,
  COLON: tl,
  COMMA: Lc,
  DOLLAR: Vi,
  DOT: jn,
  EMOJI: nv,
  EQUALS: Ni,
  EXCLAMATION: Ac,
  FULLWIDTHGREATERTHAN: Bi,
  FULLWIDTHLEFTPAREN: $i,
  FULLWIDTHLESSTHAN: Ri,
  FULLWIDTHMIDDLEDOT: tv,
  FULLWIDTHRIGHTPAREN: Ii,
  HYPHEN: xn,
  LEFTCORNERBRACKET: Ti,
  LEFTWHITECORNERBRACKET: Ai,
  LOCALHOST: Zr,
  NL: Tc,
  NUM: Ic,
  OPENANGLEBRACKET: Ci,
  OPENBRACE: Lr,
  OPENBRACKET: xi,
  OPENPAREN: ki,
  PERCENT: Er,
  PIPE: Hi,
  PLUS: ji,
  POUND: Wi,
  QUERY: Rr,
  QUOTE: Ec,
  RIGHTCORNERBRACKET: Li,
  RIGHTWHITECORNERBRACKET: Ei,
  SCHEME: Yo,
  SEMI: Rc,
  SLASH: Wn,
  SLASH_SCHEME: Sl,
  SYM: Ui,
  TILDE: Br,
  TLD: ou,
  UNDERSCORE: qi,
  UTLD: iu,
  UWORD: ru,
  WORD: ra,
  WS: su
});
const aa = /[a-z]/, or = new RegExp("\\p{L}", "u"), _s = new RegExp("\\p{Emoji}", "u"), la = /\d/, ed = /\s/, Nh = "\r", td = `
`, KE = "️", YE = "‍", nd = "￼";
let Lo = null, Ao = null;
function JE(e = []) {
  const n = {};
  sn.groups = n;
  const t = new sn();
  Lo == null && (Lo = Hh(HE)), Ao == null && (Ao = Hh(jE)), Ve(t, "'", Mi), Ve(t, "{", Lr), Ve(t, "}", Ar), Ve(t, "[", xi), Ve(t, "]", yi), Ve(t, "(", ki), Ve(t, ")", wi), Ve(t, "<", Ci), Ve(t, ">", Si), Ve(t, "（", $i), Ve(t, "）", Ii), Ve(t, "「", Ti), Ve(t, "」", Li), Ve(t, "『", Ai), Ve(t, "』", Ei), Ve(t, "＜", Ri), Ve(t, "＞", Bi), Ve(t, "&", Di), Ve(t, "*", zi), Ve(t, "@", ya), Ve(t, "`", Pi), Ve(t, "^", Fi), Ve(t, ":", tl), Ve(t, ",", Lc), Ve(t, "$", Vi), Ve(t, ".", jn), Ve(t, "=", Ni), Ve(t, "!", Ac), Ve(t, "-", xn), Ve(t, "%", Er), Ve(t, "|", Hi), Ve(t, "+", ji), Ve(t, "#", Wi), Ve(t, "?", Rr), Ve(t, '"', Ec), Ve(t, "/", Wn), Ve(t, ";", Rc), Ve(t, "~", Br), Ve(t, "_", qi), Ve(t, "\\", Oi), Ve(t, "・", tv);
  const a = Lt(t, la, Ic, {
    [tu]: !0
  });
  Lt(a, la, a);
  const l = Lt(a, aa, _p, {
    [Tr]: !0
  }), r = Lt(a, or, ev, {
    [pr]: !0
  }), o = Lt(t, aa, ra, {
    [nu]: !0
  });
  Lt(o, la, l), Lt(o, aa, o), Lt(l, la, l), Lt(l, aa, l);
  const i = Lt(t, or, ru, {
    [au]: !0
  });
  Lt(i, aa), Lt(i, la, r), Lt(i, or, i), Lt(r, la, r), Lt(r, aa), Lt(r, or, r);
  const s = Ve(t, td, Tc, {
    [Qs]: !0
  }), d = Ve(t, Nh, su, {
    [Qs]: !0
  }), u = Lt(t, ed, su, {
    [Qs]: !0
  });
  Ve(t, nd, u), Ve(d, td, s), Ve(d, nd, u), Lt(d, ed, u), Ve(u, Nh), Ve(u, td), Lt(u, ed, u), Ve(u, nd, u);
  const f = Lt(t, _s, nv, {
    [Qp]: !0
  });
  Ve(f, "#"), Lt(f, _s, f), Ve(f, KE, f);
  const b = Ve(f, YE);
  Ve(b, "#"), Lt(b, _s, f);
  const h = [[aa, o], [la, l]], p = [[aa, null], [or, i], [la, r]];
  for (let x = 0; x < Lo.length; x++)
    pa(t, Lo[x], ou, ra, h);
  for (let x = 0; x < Ao.length; x++)
    pa(t, Ao[x], iu, ru, p);
  el(ou, {
    tld: !0,
    ascii: !0
  }, n), el(iu, {
    utld: !0,
    alpha: !0
  }, n), pa(t, "file", Yo, ra, h), pa(t, "mailto", Yo, ra, h), pa(t, "http", Sl, ra, h), pa(t, "https", Sl, ra, h), pa(t, "ftp", Sl, ra, h), pa(t, "ftps", Sl, ra, h), el(Yo, {
    scheme: !0,
    ascii: !0
  }, n), el(Sl, {
    slashscheme: !0,
    ascii: !0
  }, n), e = e.sort((x, y) => x[0] > y[0] ? 1 : -1);
  for (let x = 0; x < e.length; x++) {
    const y = e[x][0], $ = e[x][1] ? {
      [WE]: !0
    } : {
      [qE]: !0
    };
    y.indexOf("-") >= 0 ? $[lu] = !0 : aa.test(y) ? la.test(y) ? $[Tr] = !0 : $[nu] = !0 : $[tu] = !0, Vh(t, y, y, $);
  }
  return Vh(t, "localhost", Zr, {
    ascii: !0
  }), t.jd = new sn(Ui), {
    start: t,
    tokens: Object.assign({
      groups: n
    }, av)
  };
}
function lv(e, n) {
  const t = XE(n.replace(/[A-Z]/g, (i) => i.toLowerCase())), a = t.length, l = [];
  let r = 0, o = 0;
  for (; o < a; ) {
    let i = e, s = null, d = 0, u = null, f = -1, b = -1;
    for (; o < a && (s = i.go(t[o])); )
      i = s, i.accepts() ? (f = 0, b = 0, u = i) : f >= 0 && (f += t[o].length, b++), d += t[o].length, r += t[o].length, o++;
    r -= f, o -= b, d -= f, l.push({
      t: u.t,
      // token type/name
      v: n.slice(r - d, r),
      // string value
      s: r - d,
      // start index
      e: r
      // end index (excluding)
    });
  }
  return l;
}
function XE(e) {
  const n = [], t = e.length;
  let a = 0;
  for (; a < t; ) {
    let l = e.charCodeAt(a), r, o = l < 55296 || l > 56319 || a + 1 === t || (r = e.charCodeAt(a + 1)) < 56320 || r > 57343 ? e[a] : e.slice(a, a + 2);
    n.push(o), a += o.length;
  }
  return n;
}
function pa(e, n, t, a, l) {
  let r;
  const o = n.length;
  for (let i = 0; i < o - 1; i++) {
    const s = n[i];
    e.j[s] ? r = e.j[s] : (r = new sn(a), r.jr = l.slice(), e.j[s] = r), e = r;
  }
  return r = new sn(t), r.jr = l.slice(), e.j[n[o - 1]] = r, r;
}
function Hh(e) {
  const n = [], t = [];
  let a = 0, l = "0123456789";
  for (; a < e.length; ) {
    let r = 0;
    for (; l.indexOf(e[a + r]) >= 0; )
      r++;
    if (r > 0) {
      n.push(t.join(""));
      for (let o = parseInt(e.substring(a, a + r), 10); o > 0; o--)
        t.pop();
      a += r;
    } else
      t.push(e[a]), a++;
  }
  return n;
}
const Qr = {
  defaultProtocol: "http",
  events: null,
  format: jh,
  formatHref: jh,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Bc(e, n = null) {
  let t = Object.assign({}, Qr);
  e && (t = Object.assign(t, e instanceof Bc ? e.o : e));
  const a = t.ignoreTags, l = [];
  for (let r = 0; r < a.length; r++)
    l.push(a[r].toUpperCase());
  this.o = t, n && (this.defaultRender = n), this.ignoreTags = l;
}
Bc.prototype = {
  o: Qr,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, n, t) {
    const a = n != null;
    let l = this.o[e];
    return l && (typeof l == "object" ? (l = t.t in l ? l[t.t] : Qr[e], typeof l == "function" && a && (l = l(n, t))) : typeof l == "function" && a && (l = l(n, t.t, t)), l);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, n, t) {
    let a = this.o[e];
    return typeof a == "function" && n != null && (a = a(n, t.t, t)), a;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const n = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(n, e.t, e);
  }
};
function jh(e) {
  return e;
}
function rv(e, n) {
  this.t = "token", this.v = e, this.tk = n;
}
rv.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const n = this.toString(), t = e.get("truncate", n, this), a = e.get("format", n, this);
    return t && a.length > t ? a.substring(0, t) + "…" : a;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = Qr.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const n = this, t = this.toHref(e.get("defaultProtocol")), a = e.get("formatHref", t, this), l = e.get("tagName", t, n), r = this.toFormattedString(e), o = {}, i = e.get("className", t, n), s = e.get("target", t, n), d = e.get("rel", t, n), u = e.getObj("attributes", t, n), f = e.getObj("events", t, n);
    return o.href = a, i && (o.class = i), s && (o.target = s), d && (o.rel = d), u && Object.assign(o, u), {
      tagName: l,
      attributes: o,
      content: r,
      eventListeners: f
    };
  }
};
function bs(e, n) {
  class t extends rv {
    constructor(l, r) {
      super(l, r), this.t = e;
    }
  }
  for (const a in n)
    t.prototype[a] = n[a];
  return t.t = e, t;
}
const ZE = bs("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Wh = bs("text"), QE = bs("nl"), Eo = bs("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = Qr.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== Zr && e[1].t === tl;
  }
}), vn = (e) => new sn(e);
function _E({
  groups: e
}) {
  const n = e.domain.concat([Di, zi, ya, Oi, Pi, Fi, Vi, Ni, xn, Ic, Er, Hi, ji, Wi, Wn, Ui, Br, qi]), t = [Mi, tl, Lc, jn, Ac, Er, Rr, Ec, Rc, Ci, Si, Lr, Ar, yi, xi, ki, wi, $i, Ii, Ti, Li, Ai, Ei, Ri, Bi], a = [Di, Mi, zi, Oi, Pi, Fi, Vi, Ni, xn, Lr, Ar, Er, Hi, ji, Wi, Rr, Wn, Ui, Br, qi], l = vn(), r = Ve(l, Br);
  st(r, a, r), st(r, e.domain, r);
  const o = vn(), i = vn(), s = vn();
  st(l, e.domain, o), st(l, e.scheme, i), st(l, e.slashscheme, s), st(o, a, r), st(o, e.domain, o);
  const d = Ve(o, ya);
  Ve(r, ya, d), Ve(i, ya, d), Ve(s, ya, d);
  const u = Ve(r, jn);
  st(u, a, r), st(u, e.domain, r);
  const f = vn();
  st(d, e.domain, f), st(f, e.domain, f);
  const b = Ve(f, jn);
  st(b, e.domain, f);
  const h = vn(ZE);
  st(b, e.tld, h), st(b, e.utld, h), Ve(d, Zr, h);
  const p = Ve(f, xn);
  Ve(p, xn, p), st(p, e.domain, f), st(h, e.domain, f), Ve(h, jn, b), Ve(h, xn, p);
  const x = Ve(o, xn), y = Ve(o, jn);
  Ve(x, xn, x), st(x, e.domain, o), st(y, a, r), st(y, e.domain, o);
  const w = vn(Eo);
  st(y, e.tld, w), st(y, e.utld, w), st(w, e.domain, o), st(w, a, r), Ve(w, jn, y), Ve(w, xn, x), Ve(w, ya, d);
  const $ = Ve(w, tl), S = vn(Eo);
  st($, e.numeric, S);
  const L = vn(Eo), T = vn();
  st(L, n, L), st(L, t, T), st(T, n, L), st(T, t, T), Ve(w, Wn, L), Ve(S, Wn, L);
  const E = Ve(i, tl), A = Ve(s, tl), D = Ve(A, Wn), M = Ve(D, Wn);
  st(i, e.domain, o), Ve(i, jn, y), Ve(i, xn, x), st(s, e.domain, o), Ve(s, jn, y), Ve(s, xn, x), st(E, e.domain, L), Ve(E, Wn, L), Ve(E, Rr, L), st(M, e.domain, L), st(M, n, L), Ve(M, Wn, L);
  const F = [
    [Lr, Ar],
    // {}
    [xi, yi],
    // []
    [ki, wi],
    // ()
    [Ci, Si],
    // <>
    [$i, Ii],
    // （）
    [Ti, Li],
    // 「」
    [Ai, Ei],
    // 『』
    [Ri, Bi]
    // ＜＞
  ];
  for (let X = 0; X < F.length; X++) {
    const [_, Y] = F[X], B = Ve(L, _);
    Ve(T, _, B);
    const W = vn(Eo);
    st(B, n, W);
    const U = vn();
    st(B, t, U), Ve(B, Y, L), st(W, n, W), st(W, t, U), st(U, n, W), st(U, t, U), Ve(W, Y, L), Ve(U, Y, L);
  }
  return Ve(l, Zr, w), Ve(l, Tc, QE), {
    start: l,
    tokens: av
  };
}
function e5(e, n, t) {
  let a = t.length, l = 0, r = [], o = [];
  for (; l < a; ) {
    let i = e, s = null, d = null, u = 0, f = null, b = -1;
    for (; l < a && !(s = i.go(t[l].t)); )
      o.push(t[l++]);
    for (; l < a && (d = s || i.go(t[l].t)); )
      s = null, i = d, i.accepts() ? (b = 0, f = i) : b >= 0 && b++, l++, u++;
    if (b < 0)
      l -= u, l < a && (o.push(t[l]), l++);
    else {
      o.length > 0 && (r.push(ad(Wh, n, o)), o = []), l -= b, u -= b;
      const h = f.t, p = t.slice(l - u, l);
      r.push(ad(h, n, p));
    }
  }
  return o.length > 0 && r.push(ad(Wh, n, o)), r;
}
function ad(e, n, t) {
  const a = t[0].s, l = t[t.length - 1].e, r = n.slice(a, l);
  return new e(r, t);
}
const t5 = typeof console < "u" && console && console.warn || (() => {
}), n5 = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", kt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function a5() {
  return sn.groups = {}, kt.scanner = null, kt.parser = null, kt.tokenQueue = [], kt.pluginQueue = [], kt.customSchemes = [], kt.initialized = !1, kt;
}
function qh(e, n = !1) {
  if (kt.initialized && t5(`linkifyjs: already initialized - will not register custom scheme "${e}" ${n5}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  kt.customSchemes.push([e, n]);
}
function l5() {
  kt.scanner = JE(kt.customSchemes);
  for (let e = 0; e < kt.tokenQueue.length; e++)
    kt.tokenQueue[e][1]({
      scanner: kt.scanner
    });
  kt.parser = _E(kt.scanner.tokens);
  for (let e = 0; e < kt.pluginQueue.length; e++)
    kt.pluginQueue[e][1]({
      scanner: kt.scanner,
      parser: kt.parser
    });
  return kt.initialized = !0, kt;
}
function Dc(e) {
  return kt.initialized || l5(), e5(kt.parser.start, e, lv(kt.scanner.start, e));
}
Dc.scan = lv;
function ov(e, n = null, t = null) {
  if (n && typeof n == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${n}; must be a string`);
    t = n, n = null;
  }
  const a = new Bc(t), l = Dc(e), r = [];
  for (let o = 0; o < l.length; o++) {
    const i = l[o];
    i.isLink && (!n || i.t === n) && a.check(i) && r.push(i.toFormattedObject(a));
  }
  return r;
}
var Mc = "[\0-   ᠎ -\u2029 　]", r5 = new RegExp(Mc), o5 = new RegExp(`${Mc}$`), i5 = new RegExp(Mc, "g");
function s5(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function d5(e) {
  return new Tt({
    key: new Pt("autolink"),
    appendTransaction: (n, t, a) => {
      const l = n.some((d) => d.docChanged) && !t.doc.eq(a.doc), r = n.some((d) => d.getMeta("preventAutolink"));
      if (!l || r)
        return;
      const { tr: o } = a, i = $p(t.doc, [...n]);
      if (Bp(i).forEach(({ newRange: d }) => {
        const u = rA(a.doc, d, (h) => h.isTextblock);
        let f, b;
        if (u.length > 1)
          f = u[0], b = a.doc.textBetween(
            f.pos,
            f.pos + f.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const h = a.doc.textBetween(d.from, d.to, " ", " ");
          if (!o5.test(h))
            return;
          f = u[0], b = a.doc.textBetween(f.pos, d.to, void 0, " ");
        }
        if (f && b) {
          const h = b.split(r5).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], x = f.pos + b.lastIndexOf(p);
          if (!p)
            return !1;
          const y = Dc(p).map((w) => w.toObject(e.defaultProtocol));
          if (!s5(y))
            return !1;
          y.filter((w) => w.isLink).map((w) => ({
            ...w,
            from: x + w.start + 1,
            to: x + w.end + 1
          })).filter((w) => a.schema.marks.code ? !a.doc.rangeHasMark(w.from, w.to, a.schema.marks.code) : !0).filter((w) => e.validate(w.value)).filter((w) => e.shouldAutoLink(w.value)).forEach((w) => {
            kc(w.from, w.to, a.doc).some(($) => $.mark.type === e.type) || o.addMark(
              w.from,
              w.to,
              e.type.create({
                href: w.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function u5(e) {
  return new Tt({
    key: new Pt("handleClickLink"),
    props: {
      handleClick: (n, t, a) => {
        var l, r;
        if (a.button !== 0 || !n.editable)
          return !1;
        let o = null;
        if (a.target instanceof HTMLAnchorElement)
          o = a.target;
        else {
          const s = a.target;
          if (!s)
            return !1;
          const d = e.editor.view.dom;
          o = s.closest("a"), o && !d.contains(o) && (o = null);
        }
        if (!o)
          return !1;
        let i = !1;
        if (e.enableClickSelection && (i = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
          const s = Rp(n.state, e.type.name), d = (l = o.href) != null ? l : s.href, u = (r = o.target) != null ? r : s.target;
          d && (window.open(d, u), i = !0);
        }
        return i;
      }
    }
  });
}
function c5(e) {
  return new Tt({
    key: new Pt("handlePasteLink"),
    props: {
      handlePaste: (n, t, a) => {
        const { shouldAutoLink: l } = e, { state: r } = n, { selection: o } = r, { empty: i } = o;
        if (i)
          return !1;
        let s = "";
        a.content.forEach((u) => {
          s += u.textContent;
        });
        const d = ov(s, { defaultProtocol: e.defaultProtocol }).find(
          (u) => u.isLink && u.value === s
        );
        return !s || !d || l !== void 0 && !l(d.value) ? !1 : e.editor.commands.setMark(e.type, {
          href: d.href
        });
      }
    }
  });
}
function Ka(e, n) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return n && n.forEach((a) => {
    const l = typeof a == "string" ? a : a.scheme;
    l && t.push(l);
  }), !e || e.replace(i5, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var f5 = ma.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        qh(e);
        return;
      }
      qh(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    a5();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, n) => !!Ka(e, n.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => {
        const n = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), t = /^[a-z][a-z0-9+.-]*:/i.test(e);
        if (n || t && !e.includes("@"))
          return !0;
        const l = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(l) || !/\./.test(l));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const n = e.getAttribute("href");
          return !n || !this.options.isAllowedUri(n, {
            defaultValidate: (t) => !!Ka(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (n) => !!Ka(n, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", It(this.options.HTMLAttributes, e), 0] : ["a", It(this.options.HTMLAttributes, { ...e, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (e, n) => n.applyMark("link", n.parseInline(e.tokens || []), {
    href: e.href,
    title: e.title || null
  }),
  renderMarkdown: (e, n) => {
    var t, a, l, r;
    const o = (a = (t = e.attrs) == null ? void 0 : t.href) != null ? a : "", i = (r = (l = e.attrs) == null ? void 0 : l.title) != null ? r : "", s = n.renderChildren(e);
    return i ? `[${s}](${o} "${i}")` : `[${s}](${o})`;
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: n }) => {
        const { href: t } = e;
        return this.options.isAllowedUri(t, {
          defaultValidate: (a) => !!Ka(a, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? n().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: n }) => {
        const { href: t } = e || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (a) => !!Ka(a, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : n().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Fa({
        find: (e) => {
          const n = [];
          if (e) {
            const { protocols: t, defaultProtocol: a } = this.options, l = ov(e).filter(
              (r) => r.isLink && this.options.isAllowedUri(r.value, {
                defaultValidate: (o) => !!Ka(o, t),
                protocols: t,
                defaultProtocol: a
              })
            );
            l.length && l.forEach((r) => {
              this.options.shouldAutoLink(r.value) && n.push({
                text: r.value,
                data: {
                  href: r.href
                },
                index: r.start
              });
            });
          }
          return n;
        },
        type: this.type,
        getAttributes: (e) => {
          var n;
          return {
            href: (n = e.data) == null ? void 0 : n.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: n, defaultProtocol: t } = this.options;
    return this.options.autolink && e.push(
      d5({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (a) => this.options.isAllowedUri(a, {
          defaultValidate: (l) => !!Ka(l, n),
          protocols: n,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e.push(
      u5({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && e.push(
      c5({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e;
  }
}), h5 = Object.defineProperty, b5 = (e, n) => {
  for (var t in n)
    h5(e, t, { get: n[t], enumerable: !0 });
}, g5 = "listItem", Uh = "textStyle", Gh = /^\s*([-+*])\s$/, iv = fn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, n) => e.type !== "list" || e.ordered ? [] : {
    type: "bulletList",
    content: e.items ? n.parseChildren(e.items) : []
  },
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: n }) => this.options.keepAttributes ? n().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(g5, this.editor.getAttributes(Uh)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = Gl({
      find: Gh,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = Gl({
      find: Gh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Uh),
      editor: this.editor
    })), [e];
  }
});
function m5(e) {
  var n, t;
  const a = (n = e.tokens) == null ? void 0 : n[0];
  return !!(e.text && ((t = e.tokens) == null ? void 0 : t.length) === 1 && (a == null ? void 0 : a.type) === "list" && a.ordered && a.raw === e.text);
}
function p5(e, n) {
  return n.tokenizeInline ? n.parseInline(n.tokenizeInline(e)) : n.parseInline([
    {
      type: "text",
      raw: e,
      text: e
    }
  ]);
}
var sv = fn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (e, n) => {
    var t;
    if (e.type !== "list_item")
      return [];
    const a = (t = n.parseBlockChildren) != null ? t : n.parseChildren;
    let l = [];
    if (e.tokens && e.tokens.length > 0) {
      if (m5(e))
        return {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: p5(e.text || "", n)
            }
          ]
        };
      if (e.tokens.some((o) => o.type === "paragraph"))
        l = a(e.tokens);
      else {
        const o = e.tokens[0];
        if (o && o.type === "text" && o.tokens && o.tokens.length > 0) {
          if (l = [
            {
              type: "paragraph",
              content: n.parseInline(o.tokens)
            }
          ], e.tokens.length > 1) {
            const s = e.tokens.slice(1), d = a(s);
            l.push(...d);
          }
        } else
          l = a(e.tokens);
      }
    }
    return l.length === 0 && (l = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: l
    };
  },
  renderMarkdown: (e, n, t) => $c(
    e,
    n,
    (a) => {
      var l, r;
      return a.parentType === "bulletList" ? "- " : a.parentType === "orderedList" ? `${(((r = (l = a.meta) == null ? void 0 : l.parentAttrs) == null ? void 0 : r.start) || 1) + a.index}. ` : "- ";
    },
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), v5 = {};
b5(v5, {
  findListItemPos: () => uo,
  getNextListDepth: () => zc,
  handleBackspace: () => du,
  handleDelete: () => uu,
  hasListBefore: () => dv,
  hasListItemAfter: () => x5,
  hasListItemBefore: () => uv,
  listItemHasSubList: () => cv,
  nextListIsDeeper: () => fv,
  nextListIsHigher: () => hv
});
var uo = (e, n) => {
  const { $from: t } = n.selection, a = zt(e, n.schema);
  let l = null, r = t.depth, o = t.pos, i = null;
  for (; r > 0 && i === null; )
    l = t.node(r), l.type === a ? i = r : (r -= 1, o -= 1);
  return i === null ? null : { $pos: n.doc.resolve(o), depth: i };
}, zc = (e, n) => {
  const t = uo(e, n);
  if (!t)
    return !1;
  const [, a] = mA(n, e, t.$pos.pos + 4);
  return a;
}, dv = (e, n, t) => {
  const { $anchor: a } = e.selection, l = Math.max(0, a.pos - 2), r = e.doc.resolve(l).node();
  return !(!r || !t.includes(r.type.name));
}, uv = (e, n) => {
  var t;
  const { $anchor: a } = n.selection, l = n.doc.resolve(a.pos - 2);
  return !(l.index() === 0 || ((t = l.nodeBefore) == null ? void 0 : t.type.name) !== e);
}, cv = (e, n, t) => {
  if (!t)
    return !1;
  const a = zt(e, n.schema);
  let l = !1;
  return t.descendants((r) => {
    r.type === a && (l = !0);
  }), l;
}, du = (e, n, t) => {
  if (e.commands.undoInputRule())
    return !0;
  if (e.state.selection.from !== e.state.selection.to)
    return !1;
  if (!Pa(e.state, n) && dv(e.state, n, t)) {
    const { $anchor: i } = e.state.selection, s = e.state.doc.resolve(i.before() - 1), d = [];
    s.node().descendants((b, h) => {
      b.type.name === n && d.push({ node: b, pos: h });
    });
    const u = d.at(-1);
    if (!u)
      return !1;
    const f = e.state.doc.resolve(s.start() + u.pos + 1);
    return e.chain().cut({ from: i.start() - 1, to: i.end() + 1 }, f.end()).joinForward().run();
  }
  if (!Pa(e.state, n) || !yA(e.state))
    return !1;
  const a = uo(n, e.state);
  if (!a)
    return !1;
  const r = e.state.doc.resolve(a.$pos.pos - 2).node(a.depth), o = cv(n, e.state, r);
  return uv(n, e.state) && !o ? e.commands.joinItemBackward() : e.chain().liftListItem(n).run();
}, fv = (e, n) => {
  const t = zc(e, n), a = uo(e, n);
  return !a || !t ? !1 : t > a.depth;
}, hv = (e, n) => {
  const t = zc(e, n), a = uo(e, n);
  return !a || !t ? !1 : t < a.depth;
}, uu = (e, n) => {
  if (!Pa(e.state, n) || !xA(e.state, n))
    return !1;
  const { selection: t } = e.state, { $from: a, $to: l } = t;
  return !t.empty && a.sameParent(l) ? !1 : fv(n, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(n).joinBackward().run() : hv(n, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, x5 = (e, n) => {
  var t;
  const { $anchor: a } = n.selection, l = n.doc.resolve(a.pos - a.parentOffset - 2);
  return !(l.index() === l.parent.childCount - 1 || ((t = l.nodeAfter) == null ? void 0 : t.type.name) !== e);
}, bv = pt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && uu(e, t) && (n = !0);
        }), n;
      },
      "Mod-Delete": ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && uu(e, t) && (n = !0);
        }), n;
      },
      Backspace: ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: a }) => {
          e.state.schema.nodes[t] !== void 0 && du(e, t, a) && (n = !0);
        }), n;
      },
      "Mod-Backspace": ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: a }) => {
          e.state.schema.nodes[t] !== void 0 && du(e, t, a) && (n = !0);
        }), n;
      }
    };
  }
}), Kh = /^(\s*)(\d+)\.\s+(.*)$/, y5 = /^\s/;
function k5(e) {
  const n = e.trimStart();
  return /^[-+*]\s+/.test(n) || /^\d+\.\s+/.test(n) || /^>\s?/.test(n) || /^```/.test(n) || /^~~~/.test(n);
}
function w5(e) {
  const n = [], t = [];
  let a = !1;
  return e.forEach((l) => {
    if (a) {
      t.push(l);
      return;
    }
    if (l.trim() === "") {
      a = !0, t.push(l);
      return;
    }
    if (n.length > 0 && k5(l)) {
      a = !0, t.push(l);
      return;
    }
    n.push(l);
  }), {
    paragraphLines: n,
    blockLines: t
  };
}
function C5(e) {
  const n = [];
  let t = 0, a = 0;
  for (; t < e.length; ) {
    const l = e[t], r = l.match(Kh);
    if (!r)
      break;
    const [, o, i, s] = r, d = o.length, u = [s];
    let f = t + 1;
    const b = [l];
    let h = !1;
    for (; f < e.length; ) {
      const p = e[f];
      if (p.match(Kh))
        break;
      if (p.trim() === "")
        b.push(p), u.push(""), h = !0, f += 1;
      else if (p.match(y5))
        b.push(p), u.push(p.slice(d + 2)), f += 1;
      else {
        if (h)
          break;
        b.push(p), u.push(p), f += 1;
      }
    }
    n.push({
      indent: d,
      number: parseInt(i, 10),
      content: u.join(`
`).trim(),
      contentLines: u,
      raw: b.join(`
`)
    }), a = f, t = f;
  }
  return [n, a];
}
function gv(e, n, t) {
  const a = [];
  let l = 0;
  for (; l < e.length; ) {
    const r = e[l];
    if (r.indent === n) {
      const { paragraphLines: o, blockLines: i } = w5(r.contentLines), s = o.join(`
`).trim(), d = [];
      s && d.push({
        type: "paragraph",
        raw: s,
        tokens: t.inlineTokens(s)
      });
      const u = i.join(`
`).trim();
      if (u) {
        const h = t.blockTokens(u);
        d.push(...h);
      }
      let f = l + 1;
      const b = [];
      for (; f < e.length && e[f].indent > n; )
        b.push(e[f]), f += 1;
      if (b.length > 0) {
        const h = Math.min(...b.map((x) => x.indent)), p = gv(b, h, t);
        d.push({
          type: "list",
          ordered: !0,
          start: b[0].number,
          items: p,
          raw: b.map((x) => x.raw).join(`
`)
        });
      }
      a.push({
        type: "list_item",
        raw: r.raw,
        tokens: d
      }), l = f;
    } else
      l += 1;
  }
  return a;
}
function S5(e, n) {
  return e.map((t) => {
    if (t.type !== "list_item")
      return n.parseChildren([t])[0];
    const a = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((l) => {
      if (l.type === "paragraph" || l.type === "list" || l.type === "blockquote" || l.type === "code")
        a.push(...n.parseChildren([l]));
      else if (l.type === "text" && l.tokens) {
        const r = n.parseChildren([l]);
        a.push({
          type: "paragraph",
          content: r
        });
      } else {
        const r = n.parseChildren([l]);
        r.length > 0 && a.push(...r);
      }
    }), {
      type: "listItem",
      content: a
    };
  });
}
var $5 = "listItem", Yh = "textStyle", Jh = /^(\d+)\.\s$/, mv = fn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: n, ...t } = e;
    return n === 1 ? ["ol", It(this.options.HTMLAttributes, t), 0] : ["ol", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, n) => {
    if (e.type !== "list" || !e.ordered)
      return [];
    const t = e.start || 1, a = e.items ? S5(e.items, n) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: a
    } : {
      type: "orderedList",
      content: a
    };
  },
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (e) => {
      const n = e.match(/^(\s*)(\d+)\.\s+/), t = n == null ? void 0 : n.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (e, n, t) => {
      var a;
      const l = e.split(`
`), [r, o] = C5(l);
      if (r.length === 0)
        return;
      const i = gv(r, 0, t);
      return i.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((a = r[0]) == null ? void 0 : a.number) || 1,
        items: i,
        raw: l.slice(0, o).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: n }) => this.options.keepAttributes ? n().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($5, this.editor.getAttributes(Yh)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = Gl({
      find: Jh,
      type: this.type,
      getAttributes: (n) => ({ start: +n[1] }),
      joinPredicate: (n, t) => t.childCount + t.attrs.start === +n[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = Gl({
      find: Jh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (n) => ({ start: +n[1], ...this.editor.getAttributes(Yh) }),
      joinPredicate: (n, t) => t.childCount + t.attrs.start === +n[1],
      editor: this.editor
    })), [e];
  }
}), I5 = /^\s*(\[([( |x])?\])\s$/, T5 = fn.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (e) => {
          const n = e.getAttribute("data-checked");
          return n === "" || n === "true";
        },
        renderHTML: (e) => ({
          "data-checked": e.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [
      "li",
      It(this.options.HTMLAttributes, n, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: e.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (e, n) => {
    const t = [];
    if (e.tokens && e.tokens.length > 0 ? t.push(n.createNode("paragraph", {}, n.parseInline(e.tokens))) : e.text ? t.push(n.createNode("paragraph", {}, [n.createNode("text", { text: e.text })])) : t.push(n.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
      const a = n.parseChildren(e.nestedTokens);
      t.push(...a);
    }
    return n.createNode("taskItem", { checked: e.checked || !1 }, t);
  },
  renderMarkdown: (e, n) => {
    var t;
    const l = `- [${(t = e.attrs) != null && t.checked ? "x" : " "}] `;
    return $c(e, n, l);
  },
  addKeyboardShortcuts() {
    const e = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...e,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : e;
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: n, getPos: t, editor: a }) => {
      const l = document.createElement("li"), r = document.createElement("label"), o = document.createElement("span"), i = document.createElement("input"), s = document.createElement("div"), d = (f) => {
        var b, h;
        i.ariaLabel = ((h = (b = this.options.a11y) == null ? void 0 : b.checkboxLabel) == null ? void 0 : h.call(b, f, i.checked)) || `Task item checkbox for ${f.textContent || "empty task item"}`;
      };
      d(e), r.contentEditable = "false", i.type = "checkbox", i.addEventListener("mousedown", (f) => f.preventDefault()), i.addEventListener("change", (f) => {
        if (!a.isEditable && !this.options.onReadOnlyChecked) {
          i.checked = !i.checked;
          return;
        }
        const { checked: b } = f.target;
        a.isEditable && typeof t == "function" && a.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const p = t();
          if (typeof p != "number")
            return !1;
          const x = h.doc.nodeAt(p);
          return h.setNodeMarkup(p, void 0, {
            ...x == null ? void 0 : x.attrs,
            checked: b
          }), !0;
        }).run(), !a.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, b) || (i.checked = !i.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([f, b]) => {
        l.setAttribute(f, b);
      }), l.dataset.checked = e.attrs.checked, i.checked = e.attrs.checked, r.append(i, o), l.append(r, s), Object.entries(n).forEach(([f, b]) => {
        l.setAttribute(f, b);
      });
      let u = new Set(Object.keys(n));
      return {
        dom: l,
        contentDOM: s,
        update: (f) => {
          if (f.type !== this.type)
            return !1;
          l.dataset.checked = f.attrs.checked, i.checked = f.attrs.checked, d(f);
          const b = a.extensionManager.attributes, h = Jr(f, b), p = new Set(Object.keys(h)), x = this.options.HTMLAttributes;
          return u.forEach((y) => {
            p.has(y) || (y in x ? l.setAttribute(y, x[y]) : l.removeAttribute(y));
          }), Object.entries(h).forEach(([y, w]) => {
            w == null ? y in x ? l.setAttribute(y, x[y]) : l.removeAttribute(y) : l.setAttribute(y, w);
          }), u = p, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      Gl({
        find: I5,
        type: this.type,
        getAttributes: (e) => ({
          checked: e[e.length - 1] === "x"
        })
      })
    ];
  }
}), L5 = fn.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", It(this.options.HTMLAttributes, e, { "data-type": this.name }), 0];
  },
  parseMarkdown: (e, n) => n.createNode("taskList", {}, n.parseChildren(e.items || [])),
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(e) {
      var n;
      const t = (n = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : n.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(e, n, t) {
      const a = (r) => {
        const o = eu(
          r,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (i) => ({
              indentLevel: i[1].length,
              mainContent: i[4],
              checked: i[3].toLowerCase() === "x"
            }),
            createToken: (i, s) => ({
              type: "taskItem",
              raw: "",
              mainContent: i.mainContent,
              indentLevel: i.indentLevel,
              checked: i.checked,
              text: i.mainContent,
              tokens: t.inlineTokens(i.mainContent),
              nestedTokens: s
            }),
            // Allow recursive nesting
            customNestedParser: a
          },
          t
        );
        return o ? [
          {
            type: "taskList",
            raw: o.raw,
            items: o.items
          }
        ] : t.blockTokens(r);
      }, l = eu(
        e,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (r) => ({
            indentLevel: r[1].length,
            mainContent: r[4],
            checked: r[3].toLowerCase() === "x"
          }),
          createToken: (r, o) => ({
            type: "taskItem",
            raw: "",
            mainContent: r.mainContent,
            indentLevel: r.indentLevel,
            checked: r.checked,
            text: r.mainContent,
            tokens: t.inlineTokens(r.mainContent),
            nestedTokens: o
          }),
          // Use the recursive parser for nested content
          customNestedParser: a
        },
        t
      );
      if (l)
        return {
          type: "taskList",
          raw: l.raw,
          items: l.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
pt.create({
  name: "listKit",
  addExtensions() {
    const e = [];
    return this.options.bulletList !== !1 && e.push(iv.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(sv.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(bv.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(mv.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(T5.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(L5.configure(this.options.taskList)), e;
  }
});
var Ro = "&nbsp;", ld = " ", A5 = fn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", It(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (e, n) => {
    const t = e.tokens || [];
    if (t.length === 1 && t[0].type === "image")
      return n.parseChildren([t[0]]);
    const a = n.parseInline(t);
    return t.length === 1 && t[0].type === "text" && (t[0].raw === Ro || t[0].text === Ro || t[0].raw === ld || t[0].text === ld) && a.length === 1 && a[0].type === "text" && (a[0].text === Ro || a[0].text === ld) ? n.createNode("paragraph", void 0, []) : n.createNode("paragraph", void 0, a);
  },
  renderMarkdown: (e, n, t) => {
    var a, l;
    if (!e)
      return "";
    const r = Array.isArray(e.content) ? e.content : [];
    if (r.length === 0) {
      const o = Array.isArray((a = t == null ? void 0 : t.previousNode) == null ? void 0 : a.content) ? t.previousNode.content : [];
      return ((l = t == null ? void 0 : t.previousNode) == null ? void 0 : l.type) === "paragraph" && o.length === 0 ? Ro : "";
    }
    return n.renderChildren(r);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), E5 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, R5 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, B5 = ma.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (e, n) => n.applyMark("strike", n.parseInline(e.tokens || [])),
  renderMarkdown: (e, n) => `~~${n.renderChildren(e)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      ml({
        find: E5,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fa({
        find: R5,
        type: this.type
      })
    ];
  }
}), D5 = fn.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), M5 = ma.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", It(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown(e, n) {
    return n.applyMark(this.name || "underline", n.parseInline(e.tokens || []));
  },
  renderMarkdown(e, n) {
    return `++${n.renderChildren(e)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(e) {
      return e.indexOf("++");
    },
    tokenize(e, n, t) {
      const l = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
      if (!l)
        return;
      const r = l[2].trim();
      return {
        type: "underline",
        raw: l[0],
        text: r,
        tokens: t.inlineTokens(r)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function z5(e = {}) {
  return new Tt({
    view(n) {
      return new O5(n, e);
    }
  });
}
class O5 {
  constructor(n, t) {
    var a;
    this.editorView = n, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (a = t.width) !== null && a !== void 0 ? a : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((l) => {
      let r = (o) => {
        this[l](o);
      };
      return n.dom.addEventListener(l, r), { name: l, handler: r };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: n, handler: t }) => this.editorView.dom.removeEventListener(n, t));
  }
  update(n, t) {
    this.cursorPos != null && t.doc != n.state.doc && (this.cursorPos > n.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(n) {
    n != this.cursorPos && (this.cursorPos = n, n == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let n = this.editorView.state.doc.resolve(this.cursorPos), t = !n.parent.inlineContent, a, l = this.editorView.dom, r = l.getBoundingClientRect(), o = r.width / l.offsetWidth, i = r.height / l.offsetHeight;
    if (t) {
      let f = n.nodeBefore, b = n.nodeAfter;
      if (f || b) {
        let h = this.editorView.nodeDOM(this.cursorPos - (f ? f.nodeSize : 0));
        if (h) {
          let p = h.getBoundingClientRect(), x = f ? p.bottom : p.top;
          f && b && (x = (x + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let y = this.width / 2 * i;
          a = { left: p.left, right: p.right, top: x - y, bottom: x + y };
        }
      }
    }
    if (!a) {
      let f = this.editorView.coordsAtPos(this.cursorPos), b = this.width / 2 * o;
      a = { left: f.left - b, right: f.left + b, top: f.top, bottom: f.bottom };
    }
    let s = this.editorView.dom.offsetParent;
    this.element || (this.element = s.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let d, u;
    if (!s || s == document.body && getComputedStyle(s).position == "static")
      d = -pageXOffset, u = -pageYOffset;
    else {
      let f = s.getBoundingClientRect(), b = f.width / s.offsetWidth, h = f.height / s.offsetHeight;
      d = f.left - s.scrollLeft * b, u = f.top - s.scrollTop * h;
    }
    this.element.style.left = (a.left - d) / o + "px", this.element.style.top = (a.top - u) / i + "px", this.element.style.width = (a.right - a.left) / o + "px", this.element.style.height = (a.bottom - a.top) / i + "px";
  }
  scheduleRemoval(n) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), n);
  }
  dragover(n) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: n.clientX, top: n.clientY }), a = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), l = a && a.type.spec.disableDropCursor, r = typeof l == "function" ? l(this.editorView, t, n) : l;
    if (t && !r) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let i = gm(this.editorView.state.doc, o, this.editorView.dragging.slice);
        i != null && (o = i);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(n) {
    this.editorView.dom.contains(n.relatedTarget) || this.setCursor(null);
  }
}
class At extends rt {
  /**
  Create a gap cursor.
  */
  constructor(n) {
    super(n, n);
  }
  map(n, t) {
    let a = n.resolve(t.map(this.head));
    return At.valid(a) ? new At(a) : rt.near(a);
  }
  content() {
    return Je.empty;
  }
  eq(n) {
    return n instanceof At && n.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new At(n.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Oc(this.anchor);
  }
  /**
  @internal
  */
  static valid(n) {
    let t = n.parent;
    if (t.inlineContent || !P5(n) || !F5(n))
      return !1;
    let a = t.type.spec.allowGapCursor;
    if (a != null)
      return a;
    let l = t.contentMatchAt(n.index()).defaultType;
    return l && l.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(n, t, a = !1) {
    e: for (; ; ) {
      if (!a && At.valid(n))
        return n;
      let l = n.pos, r = null;
      for (let o = n.depth; ; o--) {
        let i = n.node(o);
        if (t > 0 ? n.indexAfter(o) < i.childCount : n.index(o) > 0) {
          r = i.child(t > 0 ? n.indexAfter(o) : n.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        l += t;
        let s = n.doc.resolve(l);
        if (At.valid(s))
          return s;
      }
      for (; ; ) {
        let o = t > 0 ? r.firstChild : r.lastChild;
        if (!o) {
          if (r.isAtom && !r.isText && !Qe.isSelectable(r)) {
            n = n.doc.resolve(l + r.nodeSize * t), a = !1;
            continue e;
          }
          break;
        }
        r = o, l += t;
        let i = n.doc.resolve(l);
        if (At.valid(i))
          return i;
      }
      return null;
    }
  }
}
At.prototype.visible = !1;
At.findFrom = At.findGapCursorFrom;
rt.jsonID("gapcursor", At);
class Oc {
  constructor(n) {
    this.pos = n;
  }
  map(n) {
    return new Oc(n.map(this.pos));
  }
  resolve(n) {
    let t = n.resolve(this.pos);
    return At.valid(t) ? new At(t) : rt.near(t);
  }
}
function pv(e) {
  return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function P5(e) {
  for (let n = e.depth; n >= 0; n--) {
    let t = e.index(n), a = e.node(n);
    if (t == 0) {
      if (a.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = a.child(t - 1); ; l = l.lastChild) {
      if (l.childCount == 0 && !l.inlineContent || pv(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function F5(e) {
  for (let n = e.depth; n >= 0; n--) {
    let t = e.indexAfter(n), a = e.node(n);
    if (t == a.childCount) {
      if (a.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = a.child(t); ; l = l.firstChild) {
      if (l.childCount == 0 && !l.inlineContent || pv(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function V5() {
  return new Tt({
    props: {
      decorations: W5,
      createSelectionBetween(e, n, t) {
        return n.pos == t.pos && At.valid(t) ? new At(t) : null;
      },
      handleClick: H5,
      handleKeyDown: N5,
      handleDOMEvents: { beforeinput: j5 }
    }
  });
}
const N5 = pp({
  ArrowLeft: Bo("horiz", -1),
  ArrowRight: Bo("horiz", 1),
  ArrowUp: Bo("vert", -1),
  ArrowDown: Bo("vert", 1)
});
function Bo(e, n) {
  const t = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
  return function(a, l, r) {
    let o = a.selection, i = n > 0 ? o.$to : o.$from, s = o.empty;
    if (o instanceof at) {
      if (!r.endOfTextblock(t) || i.depth == 0)
        return !1;
      s = !1, i = a.doc.resolve(n > 0 ? i.after() : i.before());
    }
    let d = At.findGapCursorFrom(i, n, s);
    return d ? (l && l(a.tr.setSelection(new At(d))), !0) : !1;
  };
}
function H5(e, n, t) {
  if (!e || !e.editable)
    return !1;
  let a = e.state.doc.resolve(n);
  if (!At.valid(a))
    return !1;
  let l = e.posAtCoords({ left: t.clientX, top: t.clientY });
  return l && l.inside > -1 && Qe.isSelectable(e.state.doc.nodeAt(l.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new At(a))), !0);
}
function j5(e, n) {
  if (n.inputType != "insertCompositionText" || !(e.state.selection instanceof At))
    return !1;
  let { $from: t } = e.state.selection, a = t.parent.contentMatchAt(t.index()).findWrapping(e.state.schema.nodes.text);
  if (!a)
    return !1;
  let l = Pe.empty;
  for (let o = a.length - 1; o >= 0; o--)
    l = Pe.from(a[o].createAndFill(null, l));
  let r = e.state.tr.replace(t.pos, t.pos, new Je(l, 0, 0));
  return r.setSelection(at.near(r.doc.resolve(t.pos + 1))), e.dispatch(r), !1;
}
function W5(e) {
  if (!(e.selection instanceof At))
    return null;
  let n = document.createElement("div");
  return n.className = "ProseMirror-gapcursor", $t.create(e.doc, [an.widget(e.selection.head, n, { key: "gapcursor" })]);
}
var Gi = 200, jt = function() {
};
jt.prototype.append = function(n) {
  return n.length ? (n = jt.from(n), !this.length && n || n.length < Gi && this.leafAppend(n) || this.length < Gi && n.leafPrepend(this) || this.appendInner(n)) : this;
};
jt.prototype.prepend = function(n) {
  return n.length ? jt.from(n).append(this) : this;
};
jt.prototype.appendInner = function(n) {
  return new q5(this, n);
};
jt.prototype.slice = function(n, t) {
  return n === void 0 && (n = 0), t === void 0 && (t = this.length), n >= t ? jt.empty : this.sliceInner(Math.max(0, n), Math.min(this.length, t));
};
jt.prototype.get = function(n) {
  if (!(n < 0 || n >= this.length))
    return this.getInner(n);
};
jt.prototype.forEach = function(n, t, a) {
  t === void 0 && (t = 0), a === void 0 && (a = this.length), t <= a ? this.forEachInner(n, t, a, 0) : this.forEachInvertedInner(n, t, a, 0);
};
jt.prototype.map = function(n, t, a) {
  t === void 0 && (t = 0), a === void 0 && (a = this.length);
  var l = [];
  return this.forEach(function(r, o) {
    return l.push(n(r, o));
  }, t, a), l;
};
jt.from = function(n) {
  return n instanceof jt ? n : n && n.length ? new vv(n) : jt.empty;
};
var vv = /* @__PURE__ */ function(e) {
  function n(a) {
    e.call(this), this.values = a;
  }
  e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return n.prototype.flatten = function() {
    return this.values;
  }, n.prototype.sliceInner = function(l, r) {
    return l == 0 && r == this.length ? this : new n(this.values.slice(l, r));
  }, n.prototype.getInner = function(l) {
    return this.values[l];
  }, n.prototype.forEachInner = function(l, r, o, i) {
    for (var s = r; s < o; s++)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, n.prototype.forEachInvertedInner = function(l, r, o, i) {
    for (var s = r - 1; s >= o; s--)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, n.prototype.leafAppend = function(l) {
    if (this.length + l.length <= Gi)
      return new n(this.values.concat(l.flatten()));
  }, n.prototype.leafPrepend = function(l) {
    if (this.length + l.length <= Gi)
      return new n(l.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(n.prototype, t), n;
}(jt);
jt.empty = new vv([]);
var q5 = /* @__PURE__ */ function(e) {
  function n(t, a) {
    e.call(this), this.left = t, this.right = a, this.length = t.length + a.length, this.depth = Math.max(t.depth, a.depth) + 1;
  }
  return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, n.prototype.getInner = function(a) {
    return a < this.left.length ? this.left.get(a) : this.right.get(a - this.left.length);
  }, n.prototype.forEachInner = function(a, l, r, o) {
    var i = this.left.length;
    if (l < i && this.left.forEachInner(a, l, Math.min(r, i), o) === !1 || r > i && this.right.forEachInner(a, Math.max(l - i, 0), Math.min(this.length, r) - i, o + i) === !1)
      return !1;
  }, n.prototype.forEachInvertedInner = function(a, l, r, o) {
    var i = this.left.length;
    if (l > i && this.right.forEachInvertedInner(a, l - i, Math.max(r, i) - i, o + i) === !1 || r < i && this.left.forEachInvertedInner(a, Math.min(l, i), r, o) === !1)
      return !1;
  }, n.prototype.sliceInner = function(a, l) {
    if (a == 0 && l == this.length)
      return this;
    var r = this.left.length;
    return l <= r ? this.left.slice(a, l) : a >= r ? this.right.slice(a - r, l - r) : this.left.slice(a, r).append(this.right.slice(0, l - r));
  }, n.prototype.leafAppend = function(a) {
    var l = this.right.leafAppend(a);
    if (l)
      return new n(this.left, l);
  }, n.prototype.leafPrepend = function(a) {
    var l = this.left.leafPrepend(a);
    if (l)
      return new n(l, this.right);
  }, n.prototype.appendInner = function(a) {
    return this.left.depth >= Math.max(this.right.depth, a.depth) + 1 ? new n(this.left, new n(this.right, a)) : new n(this, a);
  }, n;
}(jt);
const U5 = 500;
class On {
  constructor(n, t) {
    this.items = n, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(n, t) {
    if (this.eventCount == 0)
      return null;
    let a = this.items.length;
    for (; ; a--)
      if (this.items.get(a - 1).selection) {
        --a;
        break;
      }
    let l, r;
    t && (l = this.remapping(a, this.items.length), r = l.maps.length);
    let o = n.tr, i, s, d = [], u = [];
    return this.items.forEach((f, b) => {
      if (!f.step) {
        l || (l = this.remapping(a, b + 1), r = l.maps.length), r--, u.push(f);
        return;
      }
      if (l) {
        u.push(new qn(f.map));
        let h = f.step.map(l.slice(r)), p;
        h && o.maybeStep(h).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], d.push(new qn(p, void 0, void 0, d.length + u.length))), r--, p && l.appendMap(p, r);
      } else
        o.maybeStep(f.step);
      if (f.selection)
        return i = l ? f.selection.map(l.slice(r)) : f.selection, s = new On(this.items.slice(0, a).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: s, transform: o, selection: i };
  }
  // Create a new branch with the given transform added.
  addTransform(n, t, a, l) {
    let r = [], o = this.eventCount, i = this.items, s = !l && i.length ? i.get(i.length - 1) : null;
    for (let u = 0; u < n.steps.length; u++) {
      let f = n.steps[u].invert(n.docs[u]), b = new qn(n.mapping.maps[u], f, t), h;
      (h = s && s.merge(b)) && (b = h, u ? r.pop() : i = i.slice(0, i.length - 1)), r.push(b), t && (o++, t = void 0), l || (s = b);
    }
    let d = o - a.depth;
    return d > K5 && (i = G5(i, d), o -= d), new On(i.append(r), o);
  }
  remapping(n, t) {
    let a = new Wr();
    return this.items.forEach((l, r) => {
      let o = l.mirrorOffset != null && r - l.mirrorOffset >= n ? a.maps.length - l.mirrorOffset : void 0;
      a.appendMap(l.map, o);
    }, n, t), a;
  }
  addMaps(n) {
    return this.eventCount == 0 ? this : new On(this.items.append(n.map((t) => new qn(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(n, t) {
    if (!this.eventCount)
      return this;
    let a = [], l = Math.max(0, this.items.length - t), r = n.mapping, o = n.steps.length, i = this.eventCount;
    this.items.forEach((b) => {
      b.selection && i--;
    }, l);
    let s = t;
    this.items.forEach((b) => {
      let h = r.getMirror(--s);
      if (h == null)
        return;
      o = Math.min(o, h);
      let p = r.maps[h];
      if (b.step) {
        let x = n.steps[h].invert(n.docs[h]), y = b.selection && b.selection.map(r.slice(s + 1, h));
        y && i++, a.push(new qn(p, x, y));
      } else
        a.push(new qn(p));
    }, l);
    let d = [];
    for (let b = t; b < o; b++)
      d.push(new qn(r.maps[b]));
    let u = this.items.slice(0, l).append(d).append(a), f = new On(u, i);
    return f.emptyItemCount() > U5 && (f = f.compress(this.items.length - a.length)), f;
  }
  emptyItemCount() {
    let n = 0;
    return this.items.forEach((t) => {
      t.step || n++;
    }), n;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(n = this.items.length) {
    let t = this.remapping(0, n), a = t.maps.length, l = [], r = 0;
    return this.items.forEach((o, i) => {
      if (i >= n)
        l.push(o), o.selection && r++;
      else if (o.step) {
        let s = o.step.map(t.slice(a)), d = s && s.getMap();
        if (a--, d && t.appendMap(d, a), s) {
          let u = o.selection && o.selection.map(t.slice(a));
          u && r++;
          let f = new qn(d.invert(), s, u), b, h = l.length - 1;
          (b = l.length && l[h].merge(f)) ? l[h] = b : l.push(f);
        }
      } else o.map && a--;
    }, this.items.length, 0), new On(jt.from(l.reverse()), r);
  }
}
On.empty = new On(jt.empty, 0);
function G5(e, n) {
  let t;
  return e.forEach((a, l) => {
    if (a.selection && n-- == 0)
      return t = l, !1;
  }), e.slice(t);
}
class qn {
  constructor(n, t, a, l) {
    this.map = n, this.step = t, this.selection = a, this.mirrorOffset = l;
  }
  merge(n) {
    if (this.step && n.step && !n.selection) {
      let t = n.step.merge(this.step);
      if (t)
        return new qn(t.getMap().invert(), t, this.selection);
    }
  }
}
class ka {
  constructor(n, t, a, l, r) {
    this.done = n, this.undone = t, this.prevRanges = a, this.prevTime = l, this.prevComposition = r;
  }
}
const K5 = 20;
function Y5(e, n, t, a) {
  let l = t.getMeta(il), r;
  if (l)
    return l.historyState;
  t.getMeta(Z5) && (e = new ka(e.done, e.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return e;
  if (o && o.getMeta(il))
    return o.getMeta(il).redo ? new ka(e.done.addTransform(t, void 0, a, Jo(n)), e.undone, Xh(t.mapping.maps), e.prevTime, e.prevComposition) : new ka(e.done, e.undone.addTransform(t, void 0, a, Jo(n)), null, e.prevTime, e.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let i = t.getMeta("composition"), s = e.prevTime == 0 || !o && e.prevComposition != i && (e.prevTime < (t.time || 0) - a.newGroupDelay || !J5(t, e.prevRanges)), d = o ? rd(e.prevRanges, t.mapping) : Xh(t.mapping.maps);
    return new ka(e.done.addTransform(t, s ? n.selection.getBookmark() : void 0, a, Jo(n)), On.empty, d, t.time, i ?? e.prevComposition);
  } else return (r = t.getMeta("rebased")) ? new ka(e.done.rebased(t, r), e.undone.rebased(t, r), rd(e.prevRanges, t.mapping), e.prevTime, e.prevComposition) : new ka(e.done.addMaps(t.mapping.maps), e.undone.addMaps(t.mapping.maps), rd(e.prevRanges, t.mapping), e.prevTime, e.prevComposition);
}
function J5(e, n) {
  if (!n)
    return !1;
  if (!e.docChanged)
    return !0;
  let t = !1;
  return e.mapping.maps[0].forEach((a, l) => {
    for (let r = 0; r < n.length; r += 2)
      a <= n[r + 1] && l >= n[r] && (t = !0);
  }), t;
}
function Xh(e) {
  let n = [];
  for (let t = e.length - 1; t >= 0 && n.length == 0; t--)
    e[t].forEach((a, l, r, o) => n.push(r, o));
  return n;
}
function rd(e, n) {
  if (!e)
    return null;
  let t = [];
  for (let a = 0; a < e.length; a += 2) {
    let l = n.map(e[a], 1), r = n.map(e[a + 1], -1);
    l <= r && t.push(l, r);
  }
  return t;
}
function X5(e, n, t) {
  let a = Jo(n), l = il.get(n).spec.config, r = (t ? e.undone : e.done).popEvent(n, a);
  if (!r)
    return null;
  let o = r.selection.resolve(r.transform.doc), i = (t ? e.done : e.undone).addTransform(r.transform, n.selection.getBookmark(), l, a), s = new ka(t ? i : r.remaining, t ? r.remaining : i, null, 0, -1);
  return r.transform.setSelection(o).setMeta(il, { redo: t, historyState: s });
}
let od = !1, Zh = null;
function Jo(e) {
  let n = e.plugins;
  if (Zh != n) {
    od = !1, Zh = n;
    for (let t = 0; t < n.length; t++)
      if (n[t].spec.historyPreserveItems) {
        od = !0;
        break;
      }
  }
  return od;
}
const il = new Pt("history"), Z5 = new Pt("closeHistory");
function Q5(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new Tt({
    key: il,
    state: {
      init() {
        return new ka(On.empty, On.empty, null, 0, -1);
      },
      apply(n, t, a) {
        return Y5(t, a, n, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(n, t) {
          let a = t.inputType, l = a == "historyUndo" ? yv : a == "historyRedo" ? kv : null;
          return !l || !n.editable ? !1 : (t.preventDefault(), l(n.state, n.dispatch));
        }
      }
    }
  });
}
function xv(e, n) {
  return (t, a) => {
    let l = il.getState(t);
    if (!l || (e ? l.undone : l.done).eventCount == 0)
      return !1;
    if (a) {
      let r = X5(l, t, e);
      r && a(n ? r.scrollIntoView() : r);
    }
    return !0;
  };
}
const yv = xv(!1, !0), kv = xv(!0, !0);
pt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      autoTrim: !0,
      mode: "textSize",
      textCounter: (e) => e.length,
      wordCounter: (e) => e.split(" ").filter((n) => n !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (e) => {
      const n = (e == null ? void 0 : e.node) || this.editor.state.doc;
      if (((e == null ? void 0 : e.mode) || this.options.mode) === "textSize") {
        const a = n.textBetween(0, n.content.size, void 0, " ");
        return this.options.textCounter(a);
      }
      return n.nodeSize;
    }, this.storage.words = (e) => {
      const n = (e == null ? void 0 : e.node) || this.editor.state.doc, t = n.textBetween(0, n.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let e = !1;
    return [
      new Tt({
        key: new Pt("characterCount"),
        appendTransaction: (n, t, a) => {
          if (e)
            return;
          const l = this.options.limit, r = this.options.autoTrim;
          if (l == null || l === 0 || r === !1) {
            e = !0;
            return;
          }
          const o = this.storage.characters({ node: a.doc });
          if (o > l) {
            const i = o - l, s = 0, d = i;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${l} characters. Content was automatically trimmed.`
            );
            const u = a.tr.deleteRange(s, d);
            return e = !0, u;
          }
          e = !0;
        },
        filterTransaction: (n, t) => {
          const a = this.options.limit;
          if (!n.docChanged || a === 0 || a === null || a === void 0)
            return !0;
          const l = this.storage.characters({ node: t.doc }), r = this.storage.characters({ node: n.doc });
          if (r <= a || l > a && r > a && r <= l)
            return !0;
          if (l > a && r > a && r > l || !n.getMeta("paste"))
            return !1;
          const i = n.selection.$head.pos, s = r - a, d = i - s, u = i;
          return n.deleteRange(d, u), !(this.storage.characters({ node: n.doc }) > a);
        }
      })
    ];
  }
});
var _5 = pt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [z5(this.options)];
  }
});
pt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Pt("focus"),
        props: {
          decorations: ({ doc: e, selection: n }) => {
            const { isEditable: t, isFocused: a } = this.editor, { anchor: l } = n, r = [];
            if (!t || !a)
              return $t.create(e, []);
            let o = 0;
            this.options.mode === "deepest" && e.descendants((s, d) => {
              if (s.isText)
                return;
              if (!(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              o += 1;
            });
            let i = 0;
            return e.descendants((s, d) => {
              if (s.isText || !(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              if (i += 1, this.options.mode === "deepest" && o - i > 0 || this.options.mode === "shallowest" && i > 1)
                return this.options.mode === "deepest";
              r.push(
                an.node(d, d + s.nodeSize, {
                  class: this.options.className
                })
              );
            }), $t.create(e, r);
          }
        }
      })
    ];
  }
});
var eR = pt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [V5()];
  },
  extendNodeSchema(e) {
    var n;
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (n = bt(Xe(e, "allowGapCursor", t))) != null ? n : null
    };
  }
});
function Qh(e) {
  const {
    editor: n,
    placeholder: t,
    dataAttribute: a,
    pos: l,
    node: r,
    isEmptyDoc: o,
    hasAnchor: i,
    classes: { emptyNode: s, emptyEditor: d }
  } = e, u = [s];
  return o && u.push(d), an.node(l, l + r.nodeSize, {
    class: u.join(" "),
    [a]: typeof t == "function" ? t({
      editor: n,
      node: r,
      pos: l,
      hasAnchor: i
    }) : t
  });
}
function tR(e) {
  const n = getComputedStyle(e), t = `${n.overflow} ${n.overflowY} ${n.overflowX}`;
  return /auto|scroll|overlay/.test(t);
}
function nR(e) {
  let n = e;
  for (; n; ) {
    if (tR(n))
      return n;
    const t = n.parentElement;
    if (!t) {
      const a = n.getRootNode();
      if (a instanceof ShadowRoot) {
        n = a.host;
        continue;
      }
      return window;
    }
    n = t;
  }
  return window;
}
function aR(e) {
  return e === window ? { top: 0, bottom: window.innerHeight } : e.getBoundingClientRect();
}
function lR({
  doc: e,
  view: n,
  scrollContainer: t
}) {
  const a = n.dom.getBoundingClientRect(), l = t ? aR(t) : { top: 0, bottom: window.innerHeight }, r = Math.max(a.top, l.top), o = Math.min(a.bottom, l.bottom);
  if (r >= o)
    return { top: 0, bottom: e.content.size };
  const s = getComputedStyle(n.dom).direction === "rtl" ? Math.max(a.right - 2, a.left + 2) : a.left + 2, d = n.posAtCoords({ left: s, top: r + 2 }), u = n.posAtCoords({ left: s, top: o - 2 });
  return {
    top: d ? d.pos : 0,
    bottom: u ? u.pos : e.content.size
  };
}
function rR(e, n) {
  let t = null;
  return { call: (...r) => {
    t || (e(...r), t = setTimeout(() => {
      t = null;
    }, n));
  }, cancel: () => {
    t && (clearTimeout(t), t = null);
  } };
}
var _h = "placeholder";
function oR(e) {
  return e.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var ir = new Pt("tiptap__placeholder");
pt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: _h,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const e = this.options.dataAttribute ? `data-${oR(this.options.dataAttribute)}` : `data-${_h}`;
    return [
      new Tt({
        state: {
          init() {
            return {
              // null means "no viewport info yet" — decoration callback falls
              // back to full document scan until the scroll handler fires.
              topPos: null,
              bottomPos: null
            };
          },
          apply(n, t) {
            const a = n.getMeta(ir);
            return a != null && a.positions ? {
              topPos: a.positions.top,
              bottomPos: a.positions.bottom
            } : n.docChanged ? {
              topPos: t.topPos !== null ? n.mapping.map(t.topPos) : null,
              bottomPos: t.bottomPos !== null ? n.mapping.map(t.bottomPos) : null
            } : t;
          }
        },
        key: ir,
        view(n) {
          const t = nR(n.dom), a = () => {
            const i = lR({
              view: n,
              doc: n.state.doc,
              scrollContainer: t
            }), s = ir.getState(n.state);
            if (s.topPos === i.top && s.bottomPos === i.bottom)
              return;
            const d = n.state.tr.setMeta(ir, { positions: i }).setMeta("tiptap__viewportUpdate", !0);
            n.dispatch(d);
          }, { call: l, cancel: r } = rR(a, 250), o = t;
          return o.addEventListener("scroll", l, { passive: !0 }), a(), {
            update(i, s) {
              n.state.doc.content.size !== s.doc.content.size && a();
            },
            destroy: () => {
              r(), o.removeEventListener("scroll", l);
            }
          };
        },
        props: {
          decorations: ({ doc: n, selection: t }) => {
            var a, l;
            if (!(this.editor.isEditable || !this.options.showOnlyWhenEditable))
              return null;
            const { anchor: o } = t, i = [], s = this.editor.isEmpty;
            if (this.options.showOnlyCurrent && !this.options.includeChildren) {
              const u = n.resolve(o);
              if (u.depth > 0) {
                const f = u.node(1), b = u.before(1);
                if (f.type.isTextblock && Xr(f)) {
                  const h = o >= b && o <= b + f.nodeSize, p = Qh({
                    node: f,
                    dataAttribute: e,
                    hasAnchor: h,
                    placeholder: this.options.placeholder,
                    classes: {
                      emptyEditor: this.options.emptyEditorClass,
                      emptyNode: this.options.emptyNodeClass
                    },
                    editor: this.editor,
                    isEmptyDoc: s,
                    pos: u.before(1)
                  });
                  i.push(p);
                }
              }
            } else {
              const u = ir.getState(this.editor.state), f = (a = u.topPos) != null ? a : 0, b = (l = u.bottomPos) != null ? l : n.content.size;
              n.nodesBetween(f, b, (h, p) => {
                const x = o >= p && o <= p + h.nodeSize, y = !h.isLeaf && Xr(h);
                if (!h.type.isTextblock)
                  return this.options.includeChildren;
                if ((x || !this.options.showOnlyCurrent) && y) {
                  const w = Qh({
                    classes: { emptyEditor: this.options.emptyEditorClass, emptyNode: this.options.emptyNodeClass },
                    editor: this.editor,
                    isEmptyDoc: s,
                    dataAttribute: e,
                    hasAnchor: x,
                    placeholder: this.options.placeholder,
                    node: h,
                    pos: p
                  });
                  i.push(w);
                }
                return this.options.includeChildren;
              });
            }
            return $t.create(n, i);
          }
        }
      })
    ];
  }
});
pt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: e, options: n } = this;
    return [
      new Tt({
        key: new Pt("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || e.isFocused || !e.isEditable || Dp(t.selection) || e.view.dragging ? null : $t.create(t.doc, [
              an.inline(t.selection.from, t.selection.to, {
                class: n.className
              })
            ]);
          }
        }
      })
    ];
  }
});
var iR = "skipTrailingNode";
function eb({ types: e, node: n }) {
  return n && Array.isArray(e) && e.includes(n.type) || (n == null ? void 0 : n.type) === e;
}
var sR = pt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var e;
    const n = new Pt(this.name), t = this.options.node || ((e = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : e.name) || "paragraph", a = Object.entries(this.editor.schema.nodes).map(([, l]) => l).filter((l) => (this.options.notAfter || []).concat(t).includes(l.name));
    return [
      new Tt({
        key: n,
        appendTransaction: (l, r, o) => {
          const { doc: i, tr: s, schema: d } = o, u = n.getState(o), f = i.content.size, b = d.nodes[t];
          if (!l.some((h) => h.getMeta(iR)) && u)
            return s.insert(f, b.create());
        },
        state: {
          init: (l, r) => {
            const o = r.tr.doc.lastChild;
            return !eb({ node: o, types: a });
          },
          apply: (l, r) => {
            if (!l.docChanged || l.getMeta("__uniqueIDTransaction"))
              return r;
            const o = l.doc.lastChild;
            return !eb({ node: o, types: a });
          }
        }
      })
    ];
  }
}), dR = pt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: n }) => yv(e, n),
      redo: () => ({ state: e, dispatch: n }) => kv(e, n)
    };
  },
  addProseMirrorPlugins() {
    return [Q5(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), uR = pt.create({
  name: "starterKit",
  addExtensions() {
    var e, n, t, a;
    const l = [];
    return this.options.bold !== !1 && l.push($E.configure(this.options.bold)), this.options.blockquote !== !1 && l.push(yE.configure(this.options.blockquote)), this.options.bulletList !== !1 && l.push(iv.configure(this.options.bulletList)), this.options.code !== !1 && l.push(LE.configure(this.options.code)), this.options.codeBlock !== !1 && l.push(RE.configure(this.options.codeBlock)), this.options.document !== !1 && l.push(BE.configure(this.options.document)), this.options.dropcursor !== !1 && l.push(_5.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && l.push(eR.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && l.push(DE.configure(this.options.hardBreak)), this.options.heading !== !1 && l.push(ME.configure(this.options.heading)), this.options.undoRedo !== !1 && l.push(dR.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && l.push(zE.configure(this.options.horizontalRule)), this.options.italic !== !1 && l.push(NE.configure(this.options.italic)), this.options.listItem !== !1 && l.push(sv.configure(this.options.listItem)), this.options.listKeymap !== !1 && l.push(bv.configure((e = this.options) == null ? void 0 : e.listKeymap)), this.options.link !== !1 && l.push(f5.configure((n = this.options) == null ? void 0 : n.link)), this.options.orderedList !== !1 && l.push(mv.configure(this.options.orderedList)), this.options.paragraph !== !1 && l.push(A5.configure(this.options.paragraph)), this.options.strike !== !1 && l.push(B5.configure(this.options.strike)), this.options.text !== !1 && l.push(D5.configure(this.options.text)), this.options.underline !== !1 && l.push(M5.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && l.push(sR.configure((a = this.options) == null ? void 0 : a.trailingNode)), l;
  }
}), cR = uR, fR = pt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => {
              const n = e.style.textAlign;
              return this.options.alignments.includes(n) ? n : this.options.defaultAlignment;
            },
            renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: n }) => this.options.alignments.includes(e) ? this.options.types.map((t) => n.updateAttributes(t, { textAlign: e })).some((t) => t) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((n) => e.resetAttributes(n, "textAlign")).some((n) => n),
      toggleTextAlign: (e) => ({ editor: n, commands: t }) => this.options.alignments.includes(e) ? n.isActive({ textAlign: e }) ? t.unsetTextAlign() : t.setTextAlign(e) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), hR = fR, bR = 20, wv = (e, n = 0) => {
  const t = [];
  return !e.children.length || n > bR || Array.from(e.children).forEach((a) => {
    a.tagName === "SPAN" ? t.push(a) : a.children.length && t.push(...wv(a, n + 1));
  }), t;
}, gR = (e) => {
  if (!e.children.length)
    return;
  const n = wv(e);
  n && n.forEach((t) => {
    var a, l;
    const r = t.getAttribute("style"), o = (l = (a = t.parentElement) == null ? void 0 : a.closest("span")) == null ? void 0 : l.getAttribute("style");
    t.setAttribute("style", `${o};${r}`);
  });
}, Cv = ma.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (e) => e.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && gR(e), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", It(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (e) => ({ commands: n }) => n.toggleMark(this.name, e),
      removeEmptyTextStyle: () => ({ tr: e }) => {
        const { selection: n } = e;
        return e.doc.nodesBetween(n.from, n.to, (t, a) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((l) => l.type === this.type).some((l) => Object.values(l.attrs).some((r) => !!r)) || e.removeMark(a, a + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), mR = pt.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (e) => {
              var n;
              const t = (n = _l(e, "background-color")) != null ? n : e.style.backgroundColor;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.backgroundColor ? {
              style: `background-color: ${e.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (e) => ({ chain: n }) => n().setMark("textStyle", { backgroundColor: e }).run(),
      unsetBackgroundColor: () => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), Sv = pt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var n;
              const t = (n = _l(e, "color")) != null ? n : e.style.color;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: n }) => n().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), pR = pt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            // Prefer the raw inline `style` attribute so unquoted or
            // single-quoted multi-word names are preserved instead of being
            // canonicalized by `element.style.fontFamily`, which forces double
            // quotes that then get HTML-encoded to `&quot;` on serialization.
            parseHTML: (e) => {
              var n;
              return (n = _l(e, "font-family")) != null ? n : e.style.fontFamily;
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: n }) => n().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), $v = pt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.fontSize`.
            parseHTML: (e) => {
              var n;
              return (n = _l(e, "font-size")) != null ? n : e.style.fontSize;
            },
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: n }) => n().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), Iv = pt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.lineHeight`.
            parseHTML: (e) => {
              var n;
              return (n = _l(e, "line-height")) != null ? n : e.style.lineHeight;
            },
            renderHTML: (e) => e.lineHeight ? {
              style: `line-height: ${e.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ chain: n }) => n().setMark("textStyle", { lineHeight: e }).run(),
      unsetLineHeight: () => ({ chain: e }) => e().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
pt.create({
  name: "textStyleKit",
  addExtensions() {
    const e = [];
    return this.options.backgroundColor !== !1 && e.push(mR.configure(this.options.backgroundColor)), this.options.color !== !1 && e.push(Sv.configure(this.options.color)), this.options.fontFamily !== !1 && e.push(pR.configure(this.options.fontFamily)), this.options.fontSize !== !1 && e.push($v.configure(this.options.fontSize)), this.options.lineHeight !== !1 && e.push(Iv.configure(this.options.lineHeight)), this.options.textStyle !== !1 && e.push(Cv.configure(this.options.textStyle)), e;
  }
});
var vR = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, xR = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, yR = ma.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        // Prefer `data-color` (set by our own `renderHTML`) for lossless
        // round-trips. Otherwise parse the raw inline `style` attribute so
        // the original color format (e.g. `#rrggbb`) is preserved instead of
        // the canonicalized `rgb(...)` value from `element.style.backgroundColor`.
        parseHTML: (e) => e.getAttribute("data-color") || _l(e, "background-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", It(this.options.HTMLAttributes, e), 0];
  },
  renderMarkdown: (e, n) => `==${n.renderChildren(e)}==`,
  parseMarkdown: (e, n) => n.applyMark("highlight", n.parseInline(e.tokens || [])),
  markdownTokenizer: {
    name: "highlight",
    level: "inline",
    start: (e) => e.indexOf("=="),
    tokenize(e, n, t) {
      const l = /^(==)([^=]+)(==)/.exec(e);
      if (l) {
        const r = l[2].trim(), o = t.inlineTokens(r);
        return {
          type: "highlight",
          raw: l[0],
          text: r,
          tokens: o
        };
      }
    }
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: n }) => n.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: n }) => n.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      ml({
        find: vR,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fa({
        find: xR,
        type: this.type
      })
    ];
  }
}), kR = yR, wR = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, CR = fn.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", It(this.options.HTMLAttributes, e)];
  },
  parseMarkdown: (e, n) => n.createNode("image", {
    src: e.href,
    title: e.title,
    alt: e.text
  }),
  renderMarkdown: (e) => {
    var n, t, a, l, r, o;
    const i = (t = (n = e.attrs) == null ? void 0 : n.src) != null ? t : "", s = (l = (a = e.attrs) == null ? void 0 : a.alt) != null ? l : "", d = (o = (r = e.attrs) == null ? void 0 : r.title) != null ? o : "";
    return d ? `![${s}](${i} "${d}")` : `![${s}](${i})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: e, minWidth: n, minHeight: t, alwaysPreserveAspectRatio: a } = this.options.resize;
    return ({ node: l, getPos: r, HTMLAttributes: o, editor: i }) => {
      const s = document.createElement("img");
      Object.entries(o).forEach(([f, b]) => {
        if (b != null)
          switch (f) {
            case "width":
            case "height":
              break;
            default:
              s.setAttribute(f, b);
              break;
          }
      }), s.src = o.src;
      const d = new iE({
        element: s,
        editor: i,
        node: l,
        getPos: r,
        onResize: (f, b) => {
          s.style.width = `${f}px`, s.style.height = `${b}px`;
        },
        onCommit: (f, b) => {
          const h = r();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: f,
            height: b
          }).run();
        },
        onUpdate: (f, b, h) => f.type === l.type,
        options: {
          directions: e,
          min: {
            width: n,
            height: t
          },
          preserveAspectRatio: a === !0
        }
      }), u = d.dom;
      return u.style.visibility = "hidden", u.style.pointerEvents = "none", s.onload = () => {
        u.style.visibility = "", u.style.pointerEvents = "";
      }, d;
    };
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      Xp({
        find: wR,
        type: this.type,
        getAttributes: (e) => {
          const [, , n, t, a] = e;
          return { src: t, alt: n, title: a };
        }
      })
    ];
  }
}), SR = CR;
const tb = 60, $R = 10, IR = 290;
function Tv(e) {
  const n = Symbol("opal-overlay-layer");
  $e(
    e,
    (r) => r ? M0(n) : uf(n),
    { immediate: !0 }
  ), gt(() => uf(n));
  let t = tb;
  const a = m(() => {
    const r = Pn.value.indexOf(n);
    return r >= 0 && (t = Math.min(tb + r * $R, IR)), t;
  }), l = m(() => Pn.value[Pn.value.length - 1] === n);
  return { zIndex: a, isTop: l };
}
const TR = ["aria-label", "aria-labelledby", "aria-describedby", "aria-modal"], LR = {
  "data-testid": "modal-pre-header",
  class: "flex items-center justify-end h-9"
}, AR = {
  key: 0,
  class: "flex-1 min-w-0"
}, ER = ["data-testid"], RR = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: void 0 },
    avatar: { default: void 0 },
    headerAlign: { default: "stacked" },
    headerPosition: { default: "left" },
    actions: { default: () => [] },
    footerAlign: { default: "right" },
    footerPosition: { default: "right" },
    initialFocus: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderBorder: { type: Boolean, default: !1 },
    showFooterBorder: { type: Boolean, default: !1 },
    contentClass: { default: void 0 },
    headerClass: { default: void 0 },
    overlayClass: { default: void 0 },
    borderGradient: { default: void 0 },
    ariaCloseLabel: { default: "Close modal" }
  },
  emits: ["update:modelValue", "close", "action"],
  setup(e, { emit: n }) {
    var ne;
    const t = Nn(), a = () => Object.fromEntries(Object.entries(t).filter(([, fe]) => fe !== void 0)), l = Mn();
    nn(Yu, null);
    const r = e, o = n, i = (fe) => {
      var ue;
      (ue = fe.onClick) == null || ue.call(fe), o("action", fe.id);
    }, s = () => {
      o("update:modelValue", !1), o("close");
    }, d = () => {
      r.dismissable && s();
    }, u = Symbol("opal-modal"), f = () => Qn(u), b = () => Rn(u), h = (fe) => {
      fe.key !== "Escape" || !r.closeOnEscape || !r.modelValue || ha(u) && (fe.defaultPrevented || (fe.preventDefault(), s()));
    }, { zIndex: p, isTop: x } = Tv(wn(r, "modelValue"));
    $e(
      () => r.modelValue,
      (fe) => {
        fe ? f() : b();
      }
    ), dt(() => {
      document.addEventListener("keydown", h), r.modelValue && f();
    }), gt(() => {
      document.removeEventListener("keydown", h), b();
    });
    const y = {
      xs: "max-w-[384px]",
      sm: "max-w-[500px]",
      md: "max-w-[704px]",
      lg: "max-w-[996px]",
      xl: "max-w-[1340px]",
      "2xl": "max-w-full"
    }, w = {
      left: "justify-start text-left",
      center: "justify-center text-center"
    }, $ = {
      right: "justify-end",
      center: "justify-center",
      split: "justify-between"
    }, S = je(), L = `${S}-title`, T = `${S}-subtitle`, E = (fe) => {
      const ue = l[fe];
      return !!ue && Qu(ue({ titleId: L, subtitleId: T }));
    }, A = () => E("header"), D = () => E("footer"), M = () => r.showHeader && (!!r.title || !!r.icon || !!r.avatar || A()), F = () => r.showFooter && (D() || r.actions.length > 0), X = () => M() && !A() && !!r.title, _ = () => M() && !A() && !!r.subtitle, Y = () => r.ariaLabelledby || (X() ? L : void 0), B = () => _() ? T : void 0, W = m(() => `h${r.headingLevel}`), U = m(() => r.headerAlign === "middle-stacked"), z = m(() => !r.icon && !r.avatar || r.headerAlign === "aligned"), P = m(() => z.value ? "flex-row items-start" : U.value ? "flex-col items-center" : "flex-col items-start"), K = m(
      () => r.footerAlign === "split" && r.actions.length < 2 ? "right" : r.footerAlign
    ), j = m(() => (K.value === "split" ? [
      { side: "start", actions: r.actions.slice(0, 1) },
      { side: "end", actions: r.actions.slice(1) }
    ] : [{ side: "all", actions: r.actions }]).filter((ue) => ue.actions.length > 0)), G = m(() => y[r.size]), q = () => A() ? w[r.headerPosition] : w[U.value ? "center" : "left"], J = () => $[D() ? r.footerPosition : K.value], me = m(() => r.size === "2xl"), ye = m(
      () => r.borderGradient ? { "--Border-gradient": r.borderGradient } : void 0
    ), Z = R(null);
    Ji({
      active: wn(r, "modelValue"),
      container: Z,
      containFocus: !0
    });
    const de = typeof process < "u" && ((ne = process.env) == null ? void 0 : ne.NODE_ENV) !== "production", ge = (fe) => {
      var ue;
      if (typeof fe != "string") return fe;
      try {
        return (ue = Z.value) == null ? void 0 : ue.querySelector(fe);
      } catch {
        de && console.warn(`[OPAL Modal] \`initialFocus\` "${fe}" is not a valid CSS selector.`);
        return;
      }
    }, se = 96, Se = R(!1), V = () => {
      const fe = Z.value, ue = fe == null ? void 0 : fe.querySelector('[data-testid="modal-content"]');
      if (!fe || !ue) return;
      const te = getComputedStyle(fe), oe = parseFloat(te.maxHeight);
      if (!Number.isFinite(oe)) {
        Se.value = !1;
        return;
      }
      let Ie = ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"].reduce((ve, we) => ve + (parseFloat(te[we]) || 0), 0);
      for (const ve of Array.from(fe.children)) ve !== ue && (Ie += ve.offsetHeight);
      Se.value = oe - Ie < Math.min(ue.scrollHeight, se);
    };
    let Q, le;
    const ee = () => {
      Q == null || Q.disconnect(), Q = void 0, le == null || le.disconnect(), le = void 0, window.removeEventListener("resize", V);
    }, O = (fe) => {
      if (!Q) return;
      Q.observe(fe);
      for (const te of Array.from(fe.children)) Q.observe(te);
      const ue = fe.querySelector('[data-testid="modal-content"]');
      for (const te of Array.from((ue == null ? void 0 : ue.children) ?? [])) Q.observe(te);
    };
    return $e(Z, (fe) => {
      if (ee(), Se.value = !1, !(!fe || typeof ResizeObserver > "u")) {
        if (Q = new ResizeObserver(V), O(fe), typeof MutationObserver < "u") {
          le = new MutationObserver(() => {
            O(fe), V();
          }), le.observe(fe, { childList: !0 });
          const ue = fe.querySelector('[data-testid="modal-content"]');
          ue && le.observe(ue, { childList: !0 });
        }
        window.addEventListener("resize", V), V();
      }
    }), gt(ee), $e(
      () => r.modelValue,
      async (fe) => {
        var ue;
        fe && (await Ue(), !(!r.modelValue || !r.initialFocus) && ((ue = ge(r.initialFocus)) == null || ue.focus()));
      },
      { immediate: !0 }
    ), (fe, ue) => (c(), H(Dn, { to: "body" }, [
      re(wt, { name: "modal-fade" }, {
        default: xe(() => [
          e.modelValue ? (c(), g("div", {
            key: 0,
            "data-testid": "modal-backdrop",
            class: C([
              "fixed inset-0 flex overflow-y-auto overflow-x-hidden",
              me.value ? "p-0" : "p-4",
              e.overlayClass
            ]),
            style: Ne({ zIndex: I(p) }),
            onClick: Ye(d, ["self"])
          }, [
            v("div", {
              class: "fixed inset-0 bg-black/50 dark:bg-black/70",
              onClick: d
            }),
            v("div", Oe({
              "data-testid": "modal-container",
              "aria-label": e.ariaLabel,
              "aria-labelledby": Y(),
              "aria-describedby": B()
            }, a(), {
              role: "dialog",
              "aria-modal": I(x) ? "true" : void 0,
              class: ["relative z-10 w-full m-auto", G.value, me.value ? "h-full" : ""],
              onClick: ue[0] || (ue[0] = Ye(() => {
              }, ["stop"]))
            }), [
              v("div", {
                ref_key: "panelRef",
                ref: Z,
                class: C([
                  // overflow-y-auto: the whole panel scrolls only in the `cramped` state (see measureCramped).
                  "relative flex flex-col overflow-y-auto bg-(--colors-background-white) dark:bg-(--colors-background-black-default) modal-container",
                  me.value ? "rounded-none h-full border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-xl" : (
                    // DS rule: constant 30px vertical margin — beyond that the content scrolls
                    // internally and the footer stays pinned (except in the `cramped` state, see
                    // measureCramped). Figma's 8px padding
                    // includes its INSIDE stroke, so the CSS border is subtracted.
                    "rounded-[var(--border-border-radius-rounded-base,24px)] p-[calc(var(--spacing-2)_-_var(--border-border-width-border-sm))] shadow-(--shadow-xl) max-h-[calc(100dvh-60px)]"
                  ),
                  e.contentClass
                ]),
                style: Ne(ye.value)
              }, [
                v("div", LR, [
                  e.showCloseButton ? (c(), H(Be, {
                    key: 0,
                    "data-testid": "modal-close-button",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.ariaCloseLabel,
                    onClick: s
                  }, null, 8, ["aria-label"])) : k("", !0)
                ]),
                M() ? (c(), g("div", {
                  key: 0,
                  "data-testid": "modal-header",
                  class: C([
                    [
                      "flex items-center gap-5 pt-0 pb-6 px-6",
                      e.showHeaderBorder && "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    q(),
                    e.headerClass
                  ])
                }, [
                  A() ? (c(), g("div", AR, [
                    Ae(fe.$slots, "header", {
                      titleId: L,
                      subtitleId: T
                    }, void 0, !0)
                  ])) : (c(), g("div", {
                    key: 1,
                    "data-testid": "modal-heading-lead",
                    class: C(["flex flex-1 min-w-0 gap-2", P.value])
                  }, [
                    e.icon ? (c(), H(Vt, {
                      key: 0,
                      icon: e.icon,
                      size: "lg",
                      type: "square",
                      variant: "outlined",
                      color: "white",
                      "data-testid": "modal-header-icon",
                      class: "shrink-0"
                    }, null, 8, ["icon"])) : e.avatar ? (c(), H(Mt, {
                      key: 1,
                      name: e.avatar.name,
                      img: e.avatar.img,
                      entity: e.avatar.entity,
                      size: "xl",
                      "avatar-style": "circle",
                      presentational: "",
                      class: "shrink-0"
                    }, null, 8, ["name", "img", "entity"])) : k("", !0),
                    v("div", {
                      "data-testid": "modal-heading-text",
                      class: C([
                        "flex min-w-0 flex-col justify-center gap-0.5 self-stretch",
                        z.value && "flex-1",
                        U.value && "items-center text-center"
                      ])
                    }, [
                      e.title ? (c(), H(lt(W.value), {
                        key: 0,
                        id: L,
                        "data-testid": "modal-title",
                        class: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]"
                      }, {
                        default: xe(() => [
                          et(N(e.title), 1)
                        ]),
                        _: 1
                      })) : k("", !0),
                      e.subtitle ? (c(), g("p", {
                        key: 1,
                        id: T,
                        "data-testid": "modal-subtitle",
                        class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]"
                      }, N(e.subtitle), 1)) : k("", !0)
                    ], 2)
                  ], 2))
                ], 2)) : k("", !0),
                v("div", {
                  "data-testid": "modal-content",
                  class: C([
                    "flex flex-col gap-5 pt-0 px-6",
                    Se.value ? "flex-none" : "flex-1 overflow-y-auto",
                    F() ? "pb-0" : "pb-6"
                  ])
                }, [
                  Ae(fe.$slots, "default", {}, void 0, !0)
                ], 2),
                F() ? (c(), g("div", {
                  key: 1,
                  "data-testid": "modal-footer",
                  class: C([
                    [
                      "flex flex-wrap items-center gap-4 pt-6 pb-6 px-6",
                      e.showFooterBorder && "border-t border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    J()
                  ])
                }, [
                  D() ? Ae(fe.$slots, "footer", { key: 0 }, void 0, !0) : (c(!0), g(ce, { key: 1 }, Re(j.value, (te) => (c(), g("div", {
                    key: te.side,
                    "data-testid": `modal-actions-${te.side}`,
                    class: "flex flex-wrap items-center gap-4"
                  }, [
                    (c(!0), g(ce, null, Re(te.actions, (oe) => (c(), H(Be, {
                      key: oe.id,
                      "data-testid": oe.testId ?? `modal-action-${oe.id}`,
                      size: "md",
                      label: oe.label,
                      variant: oe.variant,
                      "icon-left": oe.icon,
                      disabled: oe.disabled,
                      "aria-disabled": oe.ariaDisabled,
                      loading: oe.loading,
                      "loading-label": oe.loadingLabel,
                      type: oe.type,
                      form: oe.form,
                      onClick: (Le) => i(oe)
                    }, null, 8, ["data-testid", "label", "variant", "icon-left", "disabled", "aria-disabled", "loading", "loading-label", "type", "form", "onClick"]))), 128))
                  ], 8, ER))), 128))
                ], 2)) : k("", !0)
              ], 6)
            ], 16, TR)
          ], 6)) : k("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Va = /* @__PURE__ */ ot(RR, [["__scopeId", "data-v-6fa2d15b"]]), BR = ["data-type"], DR = ["aria-label"], MR = { class: "flex items-center gap-1 flex-wrap" }, zR = ["disabled", "aria-label", "title"], OR = ["disabled", "aria-label", "title"], PR = ["disabled", "aria-label", "title"], FR = ["disabled", "aria-label", "title"], VR = ["disabled", "aria-label", "title"], NR = ["title"], HR = ["aria-label", "disabled"], jR = ["title"], WR = ["aria-label", "disabled"], qR = ["disabled", "aria-expanded", "aria-label", "title"], UR = ["aria-label"], GR = ["disabled", "aria-label", "title"], KR = ["disabled", "aria-label", "title"], YR = ["disabled", "aria-label", "title"], JR = { class: "flex items-center gap-2 flex-wrap" }, XR = ["disabled", "aria-expanded", "aria-label"], ZR = { class: "leading-(--line-height-l)" }, QR = ["aria-label"], _R = ["disabled", "aria-label", "title"], eB = ["disabled", "aria-label", "title"], tB = ["disabled", "aria-label", "title"], nB = ["disabled", "aria-label", "title"], aB = ["disabled", "aria-label", "title"], lB = ["disabled", "aria-expanded", "aria-label", "title"], rB = ["aria-label"], oB = { class: "min-h-0 flex-1 overflow-y-auto" }, iB = {
  key: 0,
  "aria-hidden": "true",
  "data-testid": "rich-text-editor-placeholder",
  class: "pointer-events-none absolute top-[calc(--spacing(3)-1px)] left-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle)"
}, sB = {
  key: 0,
  class: "flex items-start gap-4",
  "data-testid": "rich-text-editor-footer"
}, dB = "w-full flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter", uB = /* @__PURE__ */ ke({
  __name: "RichTextEditor",
  props: {
    type: { default: "Default" },
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    helpText: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    minHeight: { default: "184px" },
    resizable: { type: Boolean, default: !1 },
    id: { default: void 0 },
    labels: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "focus", "blur", "send", "action"],
  setup(e, { emit: n }) {
    const t = `absolute top-[calc(100%+4px)] z-20 min-w-50 w-max ${ni}`, a = {
      toolbar: "Rich text formatting",
      bold: "Bold",
      clearFormatting: "Clear formatting",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      textColor: "Text color",
      highlight: "Highlight",
      alignLeft: "Align left",
      alignCenter: "Align center",
      alignRight: "Align right",
      textFormat: "Text format",
      paragraph: "Paragraph",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      insertLink: "Insert link",
      insertImage: "Insert image",
      bulletList: "Bullet list",
      orderedList: "Ordered list",
      blockquote: "Blockquote",
      closeDialog: "Close modal",
      linkDialogTitle: "Insert link",
      linkUrlLabel: "URL",
      linkUrlPlaceholder: "https://example.com",
      linkInsert: "Insert",
      linkRemove: "Remove link",
      imageDialogTitle: "Insert image",
      imageUrlLabel: "Image URL",
      imageUrlPlaceholder: "https://example.com/image.png",
      imageInsert: "Insert",
      cancel: "Cancel",
      invalidUrl: "Enter a valid http(s) URL.",
      send: "Send message",
      fontSize: "Font size",
      lineHeight: "Line height",
      defaultStyle: "Default"
    }, l = e, r = m(() => ({ ...a, ...l.labels })), o = n, i = je(), s = m(() => l.id || i), d = m(() => l.label ? `${s.value}-label` : void 0), u = m(() => `${s.value}-error`), f = m(() => `${s.value}-help`), b = m(() => !!l.error), h = m(() => {
      const be = [];
      return b.value && be.push(u.value), l.helpText && be.push(f.value), be.length ? be.join(" ") : void 0;
    }), p = m(() => d.value ? { "aria-labelledby": d.value } : l.ariaLabel ? { "aria-label": l.ariaLabel } : {}), x = m(
      () => h.value ? { "aria-describedby": h.value } : {}
    ), y = m(() => ({
      id: s.value,
      role: "textbox",
      "aria-multiline": "true",
      "aria-disabled": l.disabled ? "true" : "false",
      "aria-required": l.required ? "true" : "false",
      ...p.value,
      "aria-invalid": b.value ? "true" : "false",
      ...x.value,
      class: "prose prose-sm max-w-none focus:outline-none text-(--text-text-black-default) dark:text-(--colors-text-white-default) min-h-full"
    })), w = ["paragraph", "heading"], $ = vE({
      content: l.modelValue,
      editable: !l.disabled,
      extensions: [
        cR.configure({
          // StarterKit v3 already bundles Underline, Link, lists.
          link: {
            openOnClick: !1,
            autolink: !0,
            defaultProtocol: "https"
          }
        }),
        hR.configure({ types: ["heading", "paragraph"] }),
        Cv,
        $v,
        Iv.configure({ types: w }),
        Sv,
        kR.configure({ multicolor: !0 }),
        SR.configure({ inline: !1 })
      ],
      editorProps: { attributes: y.value },
      onUpdate({ editor: be }) {
        o("update:modelValue", be.getHTML());
      },
      onFocus() {
        S.value = !0, o("focus");
      },
      onBlur() {
        S.value = !1, o("blur");
      }
    }), S = R(!1), L = R(null), T = R(null);
    $e(
      () => l.modelValue,
      (be) => {
        var Te, qe;
        const pe = (Te = $.value) == null ? void 0 : Te.getHTML();
        be !== void 0 && be !== pe && ((qe = $.value) == null || qe.commands.setContent(be || "", { emitUpdate: !1 }));
      }
    ), $e(
      () => l.disabled,
      (be) => {
        var pe;
        (pe = $.value) == null || pe.setEditable(!be);
      }
    ), $e(y, (be) => {
      var pe;
      (pe = $.value) == null || pe.setOptions({ editorProps: { attributes: be } });
    }), mt(() => {
      var be;
      (be = $.value) == null || be.destroy();
    });
    const E = m(() => [
      { value: "paragraph", label: r.value.paragraph, shortcut: "⌘⌥0" },
      { value: "h1", label: r.value.heading1, shortcut: "⌘⌥1" },
      { value: "h2", label: r.value.heading2, shortcut: "⌘⌥2" },
      { value: "h3", label: r.value.heading3, shortcut: "⌘⌥3" }
    ]), A = ["12px", "14px", "16px", "18px", "20px", "24px"], D = ["1", "1.25", "1.5", "2"], M = m(() => [
      { value: "", label: r.value.defaultStyle },
      ...A.map((be) => ({ value: be, label: be.replace("px", " px") }))
    ]), F = m(() => [
      { value: "", label: r.value.defaultStyle },
      ...D.map((be) => ({ value: be, label: be }))
    ]), X = (be) => {
      var Te;
      const pe = (Te = $.value) == null ? void 0 : Te.chain().focus();
      if (pe) {
        if (be === "paragraph")
          pe.setParagraph().run();
        else {
          const qe = Number(be.replace("h", ""));
          pe.toggleHeading({ level: qe }).run();
        }
        B.value = null;
      }
    }, _ = (be) => {
      var Te;
      const pe = (Te = $.value) == null ? void 0 : Te.chain().focus();
      be ? pe == null || pe.setFontSize(be).run() : pe == null || pe.unsetFontSize().run(), B.value = null;
    }, Y = (be) => {
      var pe;
      (pe = $.value) == null || pe.chain().focus().command(
        ({ commands: Te }) => w.map((qe) => Te.updateAttributes(qe, { lineHeight: be || null })).some(Boolean)
      ).run(), B.value = null;
    }, B = R(null), W = R(null), U = R(null), z = R(null), P = { format: W, fontSize: U, lineHeight: z }, K = (be) => {
      l.disabled || (B.value = B.value === be ? null : be);
    }, j = R(null), G = R(!1), q = async () => {
      var qe;
      G.value = !1;
      const be = B.value;
      if (!be) return;
      await Ue();
      const pe = (qe = P[be].value) == null ? void 0 : qe.querySelector('[role="menu"]'), Te = j.value;
      !pe || !Te || B.value !== be || (G.value = pe.getBoundingClientRect().right > Te.getBoundingClientRect().right);
    };
    $e(B, q);
    const J = (be) => Array.from(be.querySelectorAll('[role="menuitemradio"]'));
    $e(B, async (be) => {
      var qe, St;
      if (!be) return;
      await Ue();
      const pe = (qe = P[be].value) == null ? void 0 : qe.querySelector('[role="menu"]');
      if (!pe) return;
      const Te = J(pe);
      (St = Te.find((Ga) => Ga.getAttribute("aria-checked") === "true") ?? Te[0]) == null || St.focus();
    });
    const me = (be) => {
      if (be.key === "Tab") {
        B.value = null;
        return;
      }
      const pe = J(be.currentTarget), Te = pe.indexOf(document.activeElement), qe = {
        ArrowDown: (Te + 1) % pe.length,
        ArrowUp: (Te - 1 + pe.length) % pe.length,
        Home: 0,
        End: pe.length - 1
      }[be.key];
      qe === void 0 || !pe.length || (be.preventDefault(), pe[qe].focus());
    }, ye = (be) => {
      var pe, Te;
      return (Te = (pe = P[be].value) == null ? void 0 : pe.querySelector('[aria-haspopup="menu"]')) == null ? void 0 : Te.focus();
    }, Z = () => {
      B.value && q();
    }, de = (be) => {
      if (!B.value) return;
      const pe = P[B.value].value;
      pe && !pe.contains(be.target) && (B.value = null);
    }, ge = (be) => {
      if (B.value && be.key === "Escape") {
        be.stopPropagation(), be.preventDefault();
        const pe = B.value;
        B.value = null, ye(pe);
      }
    };
    dt(() => {
      document.addEventListener("mousedown", de), document.addEventListener("keydown", ge), window.addEventListener("resize", Z);
    }), mt(() => {
      document.removeEventListener("mousedown", de), document.removeEventListener("keydown", ge), window.removeEventListener("resize", Z);
    });
    const se = (be) => {
      var Te;
      const pe = be.target.value;
      (Te = $.value) == null || Te.chain().focus().setColor(pe).run();
    }, Se = (be) => {
      var Te;
      const pe = be.target.value;
      (Te = $.value) == null || Te.chain().focus().toggleHighlight({ color: pe }).run();
    }, V = R(!1), Q = R(""), le = R(!1), ee = R(!1), O = R(""), ne = R(!1);
    function fe(be) {
      try {
        const pe = new URL(be);
        return pe.protocol === "http:" || pe.protocol === "https:";
      } catch {
        return !1;
      }
    }
    const ue = (be) => {
      var pe;
      return (pe = be == null ? void 0 : be.currentTarget) == null ? void 0 : pe.focus();
    }, te = (be) => {
      var Te;
      if (l.disabled) return;
      ue(be);
      const pe = (Te = $.value) == null ? void 0 : Te.getAttributes("link").href;
      Q.value = pe ?? "", le.value = !1, V.value = !0;
    }, oe = () => {
      var be;
      (be = $.value) == null || be.chain().extendMarkRange("link").unsetLink().run(), V.value = !1;
    }, Le = () => {
      var pe;
      const be = Q.value.trim();
      if (be === "") {
        oe();
        return;
      }
      if (!fe(be)) {
        le.value = !0;
        return;
      }
      (pe = $.value) == null || pe.chain().extendMarkRange("link").setLink({ href: be, target: "_blank", rel: "noopener noreferrer" }).run(), V.value = !1;
    }, Ie = () => {
      V.value = !1;
    }, ve = (be) => {
      l.disabled || (ue(be), O.value = "", ne.value = !1, ee.value = !0);
    }, we = () => {
      var pe;
      const be = O.value.trim();
      if (!fe(be)) {
        ne.value = !0;
        return;
      }
      (pe = $.value) == null || pe.chain().setImage({ src: be }).run(), ee.value = !1;
    }, he = () => {
      ee.value = !1;
    }, Me = m(() => [
      { id: "remove", label: r.value.linkRemove, variant: "tertiary", onClick: oe },
      { id: "cancel", label: r.value.cancel, variant: "secondary", onClick: Ie },
      { id: "insert", label: r.value.linkInsert, variant: "primary", onClick: Le }
    ]), Ee = m(() => [
      { id: "cancel", label: r.value.cancel, variant: "secondary", onClick: he },
      { id: "insert", label: r.value.imageInsert, variant: "primary", onClick: we }
    ]), He = (be, pe) => {
      be.key === "Enter" && (be.preventDefault(), pe());
    }, Ge = () => {
      var be;
      (be = $.value) == null || be.chain().focus().clearNodes().unsetAllMarks().run();
    }, Ze = (be, pe) => $.value ? typeof be == "string" ? $.value.isActive(be, {}) : $.value.isActive(be) : !1, ae = m(() => $.value ? $.value.isActive("heading", { level: 1 }) ? "h1" : $.value.isActive("heading", { level: 2 }) ? "h2" : $.value.isActive("heading", { level: 3 }) ? "h3" : "paragraph" : "paragraph"), ie = m(
      () => {
        var be;
        return ((be = $.value) == null ? void 0 : be.getAttributes("textStyle").fontSize) ?? "";
      }
    ), Ce = m(() => w.map((pe) => {
      var Te;
      return (Te = $.value) == null ? void 0 : Te.getAttributes(pe).lineHeight;
    }).find(Boolean) ?? ""), Fe = m(
      () => {
        var be;
        return ((be = E.value.find((pe) => pe.value === ae.value)) == null ? void 0 : be.label) ?? r.value.paragraph;
      }
    ), Ke = m(() => l.type === "Buttons inside"), _e = m(() => l.type === "Buttons outside"), Et = m(() => !!$.value && !$.value.isEmpty), De = m(() => {
      var Te;
      const be = (Te = $.value) == null ? void 0 : Te.state.doc, pe = (be == null ? void 0 : be.childCount) === 1 ? be.firstChild : null;
      return !!l.placeholder && (pe == null ? void 0 : pe.type.name) === "paragraph" && pe.content.size === 0;
    }), ze = m(
      () => l.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"
    ), We = m(
      () => l.disabled ? `bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) ${ze.value}` : `bg-(--background-background-white) dark:bg-(--background-background-black-default) ${ze.value}`
    ), it = m(() => l.type === "Default"), Ct = m(() => {
      const be = "flex flex-col rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)";
      if (it.value) return `${be} gap-0.5`;
      const pe = `${be} dark:shadow-(--blur-shadow-m-dark)`;
      return Ke.value ? `${pe} border border-solid ${ze.value}` : pe;
    }), Jt = m(
      () => it.value ? "flex flex-col rounded-(--border-border-radius-rounded-l) dark:shadow-(--blur-shadow-m-dark)" : "flex flex-col"
    ), zn = m(() => `flex flex-col gap-2 border-solid rounded-t-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-[calc(--spacing(3)-1px)] ${Ke.value ? "-mx-px -mt-px border-x border-t pb-3" : "border pb-[calc(--spacing(3)-1px)]"} ${We.value}`), vs = m(() => {
      const be = Ke.value ? "-mx-px" : "rounded-b-(--border-border-radius-rounded-l)", pe = l.resizable && !l.disabled ? "resize-y" : "", Te = `relative flex flex-col overflow-hidden border border-solid p-[calc(--spacing(3)-1px)] ${be} ${pe}`, qe = Ke.value ? "" : "border-t-transparent dark:border-t-transparent", St = "shadow-[0_0_2px_2px_var(--background-background-hover)]", Ga = "shadow-(--blur-shadow-xs) dark:shadow-(--blur-shadow-m-dark)";
      return l.disabled ? `${Te} ${qe} ${We.value} cursor-not-allowed` : b.value ? `${Te} ${S.value ? St : Ga} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : S.value ? `${Te} ${St} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${Te} ${qe} ${Et.value ? "" : Ga} ${We.value}`;
    }), xs = m(
      () => `-mx-px -mb-px flex items-center gap-4 border-x border-b border-solid rounded-b-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-3 pb-[calc(--spacing(3)-1px)] ${We.value}`
    ), co = () => {
      var be;
      return o("send", ((be = $.value) == null ? void 0 : be.getHTML()) ?? l.modelValue);
    }, fo = (be) => o("action", be), ho = m(() => l.fullWidth ? {} : l.width ? { width: l.width } : {}), bo = (be) => {
      var pe, Te;
      l.disabled || (pe = be.target) != null && pe.closest("[data-field-label-tooltip]") || (Te = $.value) == null || Te.commands.focus();
    };
    return (be, pe) => (c(), g("div", {
      class: C(dB),
      style: Ne(ho.value),
      "data-type": e.type
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: L,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: S.value,
        "test-id": "rich-text-editor-label",
        class: C(!e.disabled && "cursor-pointer"),
        onClick: bo
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : k("", !0),
      v("div", {
        class: C(["self-stretch flex flex-col", _e.value && "gap-4"])
      }, [
        v("div", {
          ref_key: "fieldRef",
          ref: j,
          class: C(Ct.value),
          "data-testid": "rich-text-editor-field"
        }, [
          v("div", {
            class: C(Jt.value),
            "data-testid": "rich-text-editor-box"
          }, [
            v("div", {
              class: C(zn.value),
              role: "toolbar",
              "aria-label": r.value.toolbar,
              "data-testid": "rich-text-editor-toolbar"
            }, [
              v("div", MR, [
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("bold") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.bold,
                  title: r.value.bold,
                  onClick: pe[0] || (pe[0] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleBold().run();
                  })
                }, [...pe[20] || (pe[20] = [
                  v("i", {
                    class: "ri-bold",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, zR),
                v("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": r.value.clearFormatting,
                  title: r.value.clearFormatting,
                  onClick: Ge
                }, [...pe[21] || (pe[21] = [
                  v("i", {
                    class: "ri-format-clear",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, OR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("italic") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.italic,
                  title: r.value.italic,
                  onClick: pe[1] || (pe[1] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleItalic().run();
                  })
                }, [...pe[22] || (pe[22] = [
                  v("i", {
                    class: "ri-italic",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, PR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("underline") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.underline,
                  title: r.value.underline,
                  onClick: pe[2] || (pe[2] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleUnderline().run();
                  })
                }, [...pe[23] || (pe[23] = [
                  v("i", {
                    class: "ri-underline",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, FR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("strike") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.strikethrough,
                  title: r.value.strikethrough,
                  onClick: pe[3] || (pe[3] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleStrike().run();
                  })
                }, [...pe[24] || (pe[24] = [
                  v("i", {
                    class: "ri-strikethrough",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, VR),
                v("label", {
                  class: C(["toolbar-btn relative cursor-pointer", { "opacity-50 cursor-not-allowed": e.disabled }]),
                  title: r.value.textColor
                }, [
                  pe[25] || (pe[25] = v("i", {
                    class: "ri-font-color",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("input", {
                    type: "color",
                    "aria-label": r.value.textColor,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: se
                  }, null, 40, HR)
                ], 10, NR),
                v("label", {
                  class: C(["toolbar-btn relative cursor-pointer", {
                    "is-active": Ze("highlight"),
                    "opacity-50 cursor-not-allowed": e.disabled
                  }]),
                  title: r.value.highlight
                }, [
                  pe[26] || (pe[26] = v("i", {
                    class: "ri-mark-pen-line",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("input", {
                    type: "color",
                    "aria-label": r.value.highlight,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: Se
                  }, null, 40, WR)
                ], 10, jR),
                v("div", {
                  ref_key: "fontSizeWrapperRef",
                  ref: U,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": B.value === "fontSize" }]),
                    disabled: e.disabled,
                    "aria-expanded": B.value === "fontSize",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.fontSize,
                    title: r.value.fontSize,
                    onClick: pe[4] || (pe[4] = (Te) => K("fontSize"))
                  }, [...pe[27] || (pe[27] = [
                    v("i", {
                      class: "ri-font-size",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, qR),
                  B.value === "fontSize" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.fontSize,
                    class: C([t, G.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: me
                  }, [
                    (c(!0), g(ce, null, Re(M.value, (Te) => (c(), H(Kt, {
                      key: Te.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Te.label,
                      selected: ie.value === Te.value,
                      "aria-checked": ie.value === Te.value,
                      onClick: (qe) => _(Te.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, UR)) : k("", !0)
                ], 512),
                pe[31] || (pe[31] = v("span", {
                  class: "mx-1 inline-block w-px h-4 bg-(--colors-background-gray)",
                  "aria-hidden": "true"
                }, null, -1)),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze({ textAlign: "left" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignLeft,
                  title: r.value.alignLeft,
                  onClick: pe[5] || (pe[5] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().setTextAlign("left").run();
                  })
                }, [...pe[28] || (pe[28] = [
                  v("i", {
                    class: "ri-align-left",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, GR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze({ textAlign: "center" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignCenter,
                  title: r.value.alignCenter,
                  onClick: pe[6] || (pe[6] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().setTextAlign("center").run();
                  })
                }, [...pe[29] || (pe[29] = [
                  v("i", {
                    class: "ri-align-center",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, KR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze({ textAlign: "right" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignRight,
                  title: r.value.alignRight,
                  onClick: pe[7] || (pe[7] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().setTextAlign("right").run();
                  })
                }, [...pe[30] || (pe[30] = [
                  v("i", {
                    class: "ri-align-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, YR)
              ]),
              v("div", JR, [
                v("div", {
                  ref_key: "formatWrapperRef",
                  ref: W,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["format-btn", { "is-open": B.value === "format" }]),
                    disabled: e.disabled,
                    "aria-expanded": B.value === "format",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.textFormat,
                    onClick: pe[8] || (pe[8] = (Te) => K("format"))
                  }, [
                    v("span", ZR, N(Fe.value), 1),
                    pe[32] || (pe[32] = v("i", {
                      class: "ri-arrow-down-s-line text-(length:--size-m)",
                      "aria-hidden": "true"
                    }, null, -1))
                  ], 10, XR),
                  B.value === "format" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.textFormat,
                    class: C([t, G.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: me
                  }, [
                    (c(!0), g(ce, null, Re(E.value, (Te) => (c(), H(Kt, {
                      key: Te.value,
                      as: "button",
                      type: "secondary-text",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Te.label,
                      "secondary-label": Te.shortcut,
                      "aria-label": Te.label,
                      selected: ae.value === Te.value,
                      "aria-checked": ae.value === Te.value,
                      onClick: (qe) => X(Te.value)
                    }, null, 8, ["label", "secondary-label", "aria-label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, QR)) : k("", !0)
                ], 512),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("link") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.insertLink,
                  title: r.value.insertLink,
                  onClick: te
                }, [...pe[33] || (pe[33] = [
                  v("i", {
                    class: "ri-link",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, _R),
                v("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": r.value.insertImage,
                  title: r.value.insertImage,
                  onClick: ve
                }, [...pe[34] || (pe[34] = [
                  v("i", {
                    class: "ri-image-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, eB),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("bulletList") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.bulletList,
                  title: r.value.bulletList,
                  onClick: pe[9] || (pe[9] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleBulletList().run();
                  })
                }, [...pe[35] || (pe[35] = [
                  v("i", {
                    class: "ri-list-unordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, tB),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("orderedList") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.orderedList,
                  title: r.value.orderedList,
                  onClick: pe[10] || (pe[10] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleOrderedList().run();
                  })
                }, [...pe[36] || (pe[36] = [
                  v("i", {
                    class: "ri-list-ordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, nB),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Ze("blockquote") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.blockquote,
                  title: r.value.blockquote,
                  onClick: pe[11] || (pe[11] = (Te) => {
                    var qe;
                    return (qe = I($)) == null ? void 0 : qe.chain().focus().toggleBlockquote().run();
                  })
                }, [...pe[37] || (pe[37] = [
                  v("i", {
                    class: "ri-double-quotes-l",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, aB),
                v("div", {
                  ref_key: "lineHeightWrapperRef",
                  ref: z,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": B.value === "lineHeight" }]),
                    disabled: e.disabled,
                    "aria-expanded": B.value === "lineHeight",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.lineHeight,
                    title: r.value.lineHeight,
                    onClick: pe[12] || (pe[12] = (Te) => K("lineHeight"))
                  }, [...pe[38] || (pe[38] = [
                    v("i", {
                      class: "ri-line-height",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, lB),
                  B.value === "lineHeight" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.lineHeight,
                    class: C([t, G.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: me
                  }, [
                    (c(!0), g(ce, null, Re(F.value, (Te) => (c(), H(Kt, {
                      key: Te.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Te.label,
                      selected: Ce.value === Te.value,
                      "aria-checked": Ce.value === Te.value,
                      onClick: (qe) => Y(Te.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, rB)) : k("", !0)
                ], 512)
              ])
            ], 10, DR),
            v("div", {
              class: C(vs.value),
              style: Ne({ minHeight: e.minHeight }),
              "data-testid": "rich-text-editor-content"
            }, [
              v("div", oB, [
                I($) ? (c(), H(I(pE), {
                  key: 0,
                  editor: I($),
                  "data-testid": "rich-text-editor",
                  class: "text-(length:--size-m) leading-(--line-height-l)",
                  onKeydown: pe[13] || (pe[13] = (Te) => {
                    var qe, St;
                    (qe = L.value) == null || qe.handleFieldKeydown(Te), (St = T.value) == null || St.handleFieldKeydown(Te);
                  })
                }, null, 8, ["editor"])) : k("", !0)
              ]),
              De.value ? (c(), g("span", iB, N(e.placeholder), 1)) : k("", !0),
              e.resizable && !e.disabled ? (c(), H(jg, {
                key: 1,
                class: "absolute right-[calc(--spacing(2)-1px)] bottom-[calc(--spacing(2)-1px)]"
              })) : k("", !0)
            ], 6)
          ], 2),
          it.value ? (c(), H(xt, {
            key: 0,
            ref_key: "helperRef",
            ref: T,
            focused: S.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": u.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
          Ke.value ? (c(), g("div", {
            key: 1,
            class: C(xs.value),
            "data-testid": "rich-text-editor-footer"
          }, [
            re(li, {
              class: "shrink-0",
              labels: { send: r.value.send },
              actions: e.actions,
              disabled: e.disabled,
              onSend: co,
              onAction: fo
            }, null, 8, ["labels", "actions", "disabled"]),
            re(xt, {
              ref_key: "helperRef",
              ref: T,
              class: "min-w-0 flex-1",
              focused: S.value,
              hint: e.helpText,
              error: e.error,
              "hint-id": f.value,
              "error-id": u.value,
              "test-id-prefix": "rich-text-editor"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
          ], 2)) : k("", !0)
        ], 2),
        _e.value ? (c(), g("div", sB, [
          re(li, {
            class: "shrink-0",
            labels: { send: r.value.send },
            actions: e.actions,
            disabled: e.disabled,
            onSend: co,
            onAction: fo
          }, null, 8, ["labels", "actions", "disabled"]),
          re(xt, {
            ref_key: "helperRef",
            ref: T,
            class: "min-w-0 flex-1",
            focused: S.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": u.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
        ])) : k("", !0)
      ], 2),
      re(Va, {
        modelValue: V.value,
        "onUpdate:modelValue": pe[16] || (pe[16] = (Te) => V.value = Te),
        size: "sm",
        title: r.value.linkDialogTitle,
        "aria-close-label": r.value.closeDialog,
        "footer-align": "split",
        actions: Me.value
      }, {
        default: xe(() => [
          re(Ot, {
            "model-value": Q.value,
            type: "url",
            label: r.value.linkUrlLabel,
            placeholder: r.value.linkUrlPlaceholder,
            error: le.value ? r.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": pe[14] || (pe[14] = (Te) => {
              Q.value = Te, le.value = !1;
            }),
            onKeydown: pe[15] || (pe[15] = (Te) => He(Te, Le))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions"]),
      re(Va, {
        modelValue: ee.value,
        "onUpdate:modelValue": pe[19] || (pe[19] = (Te) => ee.value = Te),
        size: "xs",
        title: r.value.imageDialogTitle,
        "aria-close-label": r.value.closeDialog,
        actions: Ee.value
      }, {
        default: xe(() => [
          re(Ot, {
            "model-value": O.value,
            type: "url",
            label: r.value.imageUrlLabel,
            placeholder: r.value.imageUrlPlaceholder,
            error: ne.value ? r.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": pe[17] || (pe[17] = (Te) => {
              O.value = Te, ne.value = !1;
            }),
            onKeydown: pe[18] || (pe[18] = (Te) => He(Te, we))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions"])
    ], 12, BR));
  }
}), lq = /* @__PURE__ */ ot(uB, [["__scopeId", "data-v-8601a4c1"]]), cB = /* @__PURE__ */ ke({
  __name: "EmailInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidEmailMessage: { default: "Please enter a valid email address" },
    requiredMessage: { default: "Email is required" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "validation-change"],
  setup(e, { expose: n, emit: t }) {
    const a = Yt(), l = e, r = t, o = R(void 0), i = R(!1), s = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, d = (w) => {
      if (l.validator)
        return l.validator(w) ?? void 0;
      if (l.required && !w.trim())
        return l.requiredMessage;
      if (w.trim() && !s.test(w))
        return l.invalidEmailMessage;
    }, u = () => {
      const w = d(l.modelValue ?? "");
      o.value = w, r("validation-change", !w, w);
    }, f = m(() => {
      if (l.error) return l.error;
      if (i.value) return o.value;
    }), b = (w) => {
      const $ = w.target;
      r("update:modelValue", $.value), r("input", w), l.validateOnInput && u();
    }, h = (w) => {
      r("focus", w);
    }, p = (w) => {
      i.value = !0, r("blur", w), l.validateOnBlur && u();
    };
    return $e(
      () => l.modelValue,
      () => {
        i.value && (l.validateOnBlur || l.validateOnInput) && u();
      }
    ), $e(
      () => l.error,
      (w) => {
        w && (o.value = void 0);
      }
    ), n({
      validate: () => (i.value = !0, u(), !o.value),
      resetValidation: () => {
        i.value = !1, o.value = void 0;
      }
    }), (w, $) => (c(), H(Ot, {
      id: e.id,
      "model-value": e.modelValue,
      placeholder: e.placeholder,
      label: e.label,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      success: e.success,
      "label-tooltip": e.labelTooltip,
      labels: e.labels,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "icon-left": e.iconLeft,
      hint: e.hint,
      "label-inline": e.labelInline,
      error: f.value,
      type: "email",
      inputmode: "email",
      autocomplete: e.autocomplete,
      "data-testid": "email-input",
      "onUpdate:modelValue": $[0] || ($[0] = (S) => r("update:modelValue", S)),
      onInput: b,
      onFocus: h,
      onBlur: p
    }, ta({ _: 2 }, [
      I(a)("actions") ? {
        name: "actions",
        fn: xe(() => [
          Ae(w.$slots, "actions")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "model-value", "placeholder", "label", "required", "required-indicator", "success", "label-tooltip", "labels", "disabled", "readonly", "size", "name", "full-width", "width", "icon-left", "hint", "label-inline", "error", "autocomplete"]));
  }
}), fB = ["disabled", "aria-pressed", "aria-controls", "aria-label"], rq = /* @__PURE__ */ ke({
  __name: "PasswordInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "current-password" },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    labels: { default: () => ({}) },
    remember: { type: Boolean, default: !1 },
    rememberLabel: { default: void 0 },
    forgotLabel: { default: void 0 },
    forgotHref: { default: void 0 }
  },
  emits: ["update:modelValue", "update:remember", "forgot", "focus", "blur"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = je(), r = m(() => t.id ?? l), o = R(!1), i = m(() => t.labels.show ?? "Show password"), s = m(() => !!t.rememberLabel || !!t.forgotLabel), d = m(() => t.disabled ? "cursor-not-allowed" : "cursor-pointer");
    function u() {
      t.forgotHref || a("forgot");
    }
    return nn(
      Tg,
      () => s.value ? Kn("div", { class: "flex w-full items-center justify-between gap-1", "data-testid": "password-input-row" }, [
        t.rememberLabel ? Kn($n, {
          modelValue: t.remember,
          label: t.rememberLabel,
          disabled: t.disabled,
          "onUpdate:modelValue": (f) => a("update:remember", f)
        }) : null,
        t.forgotLabel ? Kn(
          In,
          {
            class: "ml-auto shrink-0",
            "data-testid": "password-input-forgot",
            as: t.forgotHref ? "a" : "button",
            href: t.forgotHref,
            disabled: t.disabled,
            onClick: u
          },
          () => t.forgotLabel
        ) : null
      ]) : null
    ), (f, b) => (c(), H(Ot, {
      id: r.value,
      "model-value": e.modelValue,
      type: o.value ? "text" : "password",
      "icon-left": "ri-lock-2-line",
      placeholder: e.placeholder,
      label: e.label,
      "label-tooltip": e.labelTooltip,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      "aria-label": e.ariaLabel,
      hint: e.hint,
      error: e.error,
      success: e.success,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "label-inline": e.labelInline,
      autocomplete: e.autocomplete,
      maxlength: e.maxlength,
      minlength: e.minlength,
      "onUpdate:modelValue": b[1] || (b[1] = (h) => a("update:modelValue", h)),
      onFocus: b[2] || (b[2] = (h) => a("focus", h)),
      onBlur: b[3] || (b[3] = (h) => a("blur", h))
    }, {
      iconRight: xe(({ iconColorClass: h, iconBoxClass: p }) => [
        v("button", {
          type: "button",
          "data-testid": "password-input-toggle",
          class: C([
            p,
            h,
            d.value,
            "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
          ]),
          disabled: e.disabled,
          "aria-pressed": o.value,
          "aria-controls": r.value,
          "aria-label": i.value,
          onClick: b[0] || (b[0] = (x) => o.value = !o.value)
        }, [
          v("i", {
            class: C(o.value ? "ri-eye-off-line" : "ri-eye-line"),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, fB)
      ]),
      _: 1
    }, 8, ["id", "model-value", "type", "placeholder", "label", "label-tooltip", "required", "required-indicator", "aria-label", "hint", "error", "success", "disabled", "readonly", "size", "name", "full-width", "width", "label-inline", "autocomplete", "maxlength", "minlength"]));
  }
});
function Lv(e) {
  if (!e || !/^[dmy/\-. ]+$/.test(e) || !/[dmy]/.test(e)) return null;
  for (const n of e.match(/([dmy])\1*/g) ?? [])
    if (n.length < 2) return null;
  return e.replace(/[dmy]/g, "0");
}
function cu(e) {
  const n = new Set([...e].filter((l) => /\D/.test(l)));
  if (n.size !== 1) return null;
  const [t] = [...n], a = e.split(t).map((l) => l.length).filter((l) => l > 0);
  return a.length === 0 ? null : { groupSizes: a, separator: t };
}
function hB(e) {
  if (!e) return null;
  const n = e.match(/[Xx]+/g);
  if (!n) return null;
  const t = e.split(/[Xx]+/);
  if (t[0] !== "" || t[t.length - 1] !== "") return null;
  const a = t.slice(1, -1);
  if (a.length === 0) return null;
  const [l] = a;
  return l === "" || a.some((r) => r !== l) ? null : { groupSizes: n.map((r) => r.length), separator: l };
}
function _r(e, n) {
  if (!e) return "";
  const t = [];
  let a = 0;
  for (const l of n.groupSizes) {
    if (a >= e.length) break;
    t.push(e.slice(a, a + l)), a += l;
  }
  return a < e.length && t.push(e.slice(a)), t.join(n.separator);
}
function bB(e, n) {
  if (n <= 0) return 0;
  let t = 0;
  for (let a = 0; a < e.length; a++)
    if (/\d/.test(e[a]) && (t += 1, t === n))
      return a + 1;
  return e.length;
}
function Av(e, n, t) {
  const a = e.value, l = e.selectionStart ?? a.length, r = n(a.slice(0, l)).length, o = n(a), i = t(o);
  e.value = i;
  const s = bB(i, r);
  try {
    e.setSelectionRange(s, s);
  } catch {
  }
  return i;
}
function nb(e, n, t) {
  return Av(
    e,
    n,
    (a) => t ? _r(a, t) : a
  );
}
function Ev(e, n, t) {
  if (e.key !== "Backspace" && e.key !== "Delete" || e.ctrlKey || e.altKey || e.metaKey) return !1;
  const a = n.selectionStart, l = n.selectionEnd;
  if (a === null || l === null || a !== l) return !1;
  const r = n.value, o = (d) => d !== void 0 && /\d/.test(d);
  let i, s;
  if (e.key === "Backspace") {
    if (a === 0 || o(r[a - 1])) return !1;
    let d = a - 1;
    for (; d >= 0 && !o(r[d]); ) d -= 1;
    if (d < 0) return !1;
    i = d, s = d;
  } else {
    if (a >= r.length || o(r[a])) return !1;
    let d = a;
    for (; d < r.length && !o(r[d]); ) d += 1;
    if (d >= r.length) return !1;
    i = d, s = a;
  }
  n.value = r.slice(0, i) + r.slice(i + 1);
  try {
    n.setSelectionRange(s, s);
  } catch {
  }
  return e.preventDefault(), t(n), !0;
}
const Gn = {
  FR: { placeholder: "6 12 34 56 78", min: 9, max: 9, name: "France", hasTrunkZero: !0 },
  GB: {
    placeholder: "7911 123456",
    min: 9,
    max: 10,
    name: "United Kingdom",
    hasTrunkZero: !0
  },
  CA: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "Canada",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  US: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "United States",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  NL: { placeholder: "6 12345678", min: 9, max: 9, name: "Netherlands", hasTrunkZero: !0 },
  DE: { placeholder: "176 12345678", min: 10, max: 11, name: "Germany", hasTrunkZero: !0 },
  // min: 8 covers landline numbers behind a 2-digit area code (Brussels "02 XXX XX XX" = 8
  // significant digits); mobiles and other landlines are 9 (the placeholder's own length).
  BE: { placeholder: "470 12 34 56", min: 8, max: 9, name: "Belgium", hasTrunkZero: !0 },
  CH: { placeholder: "78 123 45 67", min: 9, max: 9, name: "Switzerland", hasTrunkZero: !0 },
  // The leading "0" is a significant digit of the Italian landline numbering plan (mandatory,
  // not a trunk prefix) — hasTrunkZero: false so it is never split out, stripped, or parenthesised
  // anywhere (input, display, validation count). min/max count the "0" itself, so hasTrunkZero:
  // false means nothing strips it before counting. min: 9 covers a shorter landline behind a
  // 2-digit area code ("02 1234 567" = 9 digits); max: 10 matches the placeholder (mobiles and
  // longer landlines).
  IT: { placeholder: "06 1234 5678", min: 9, max: 10, name: "Italy", hasTrunkZero: !1 },
  ES: { placeholder: "612 34 56 78", min: 9, max: 9, name: "Spain", hasTrunkZero: !1 },
  PT: { placeholder: "912 345 678", min: 9, max: 9, name: "Portugal", hasTrunkZero: !1 },
  GR: { placeholder: "691 234 5678", min: 10, max: 10, name: "Greece", hasTrunkZero: !1 },
  DK: { placeholder: "20 12 34 56", min: 8, max: 8, name: "Denmark", hasTrunkZero: !1 },
  NO: { placeholder: "406 12 345", min: 8, max: 8, name: "Norway", hasTrunkZero: !1 }
}, Tl = {
  placeholder: "123 456 789",
  min: 6,
  max: Number.POSITIVE_INFINITY,
  name: "",
  hasTrunkZero: !1
}, ab = "FR", Rv = {
  FR: "+33",
  GB: "+44",
  CA: "+1",
  US: "+1",
  NL: "+31",
  DE: "+49",
  BE: "+32",
  CH: "+41",
  IT: "+39",
  ES: "+34",
  PT: "+351",
  GR: "+30",
  DK: "+45",
  NO: "+47"
}, Pc = Object.entries(Rv).sort((e, n) => n[1].length - e[1].length), gB = Object.entries(
  Gn
).reduce((e, [n, t]) => {
  const a = Rv[n];
  return a in e || (e[a] = t), e;
}, {});
function lb(e) {
  const n = e.replace(/^0+/, "");
  return n.length > 0 ? n : e;
}
function rb(e, n) {
  const t = Gn[n] ?? Tl, a = cu(t.placeholder);
  if (!a) return e;
  const l = t.displaySeparator ?? a.separator;
  return _r(e, { groupSizes: a.groupSizes, separator: l });
}
function sr(e, n, t) {
  if (!e) return "";
  if (!t) {
    const i = cu(n);
    return i ? _r(e, i) : e;
  }
  if (/^0*$/.test(e)) return e;
  const a = e.startsWith("0"), l = a ? "0" : "", r = a ? e.slice(1) : e, o = cu(n);
  return l + (o ? _r(r, o) : r);
}
function Fc(e, n) {
  return /^0*$/.test(e) ? "" : n && e.startsWith("0") ? e.slice(1) : e;
}
function oq(e) {
  const n = (e ?? "").trim();
  if (!n.startsWith("+")) return e;
  const t = Pc.find(([, i]) => n.startsWith(i));
  if (!t) return e;
  const [a, l] = t;
  if (!Gn[a].hasTrunkZero) return e;
  const o = n.slice(l.length).replace(/\D/g, "");
  return !o || o.startsWith("0") ? e : `${l}0${o}`;
}
function iq(e) {
  const n = (e ?? "").trim();
  if (!n.startsWith("+")) return e;
  const t = Pc.find(([, s]) => n.startsWith(s));
  if (!t) return e;
  const [a, l] = t, r = Gn[a], o = n.slice(l.length).replace(/\D/g, ""), i = r.hasTrunkZero ? Fc(o, !0) : o;
  return i ? `${l}${i}` : e;
}
function mB(e) {
  const n = (e ?? "").trim();
  if (!n) return e;
  if (n.startsWith("+")) {
    const i = Pc.find(([, x]) => n.startsWith(x));
    if (!i) return e;
    const [s, d] = i, u = Gn[s], f = n.slice(d.length).replace(/\D/g, ""), b = u.hasTrunkZero ? lb(f) : f;
    if (!b) return e;
    const h = rb(b, s), p = u.hasTrunkZero ? "(0)" : "";
    return `${d} ${p}${h}`;
  }
  const t = lb(n.replace(/\D/g, ""));
  if (!t) return e;
  const { min: a, max: l } = Gn[ab];
  if (t.length < a || t.length > l) return e;
  const r = rb(t, ab);
  return `${n.replace(/\D/g, "").startsWith("0") ? "0" : ""}${r}`;
}
const pB = ["id"], vB = { class: "relative min-w-0 flex-1" }, xB = { class: "inline-flex items-center gap-1.5" }, yB = { class: "inline-flex size-4 shrink-0 items-center justify-center" }, kB = ["title"], wB = ["id", "autocomplete", "disabled", "readonly", "aria-labelledby", "aria-invalid", "aria-describedby", "placeholder"], CB = ["aria-label"], SB = {
  key: 0,
  class: "shrink-0"
}, $B = /* @__PURE__ */ ke({
  __name: "PhoneInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disableInternalValidation: { type: Boolean, default: !1 },
    showCountrySelector: { type: Boolean, default: !0 },
    showVerificationButton: { type: Boolean, default: !1 },
    verificationOptions: { default: () => [
      { id: "sms", label: "Send SMS" },
      { id: "call", label: "Call" }
    ] },
    countries: { default: () => [
      { code: "FR", name: "France", dialCode: "+33" },
      { code: "GB", name: "United Kingdom", dialCode: "+44" },
      { code: "CA", name: "Canada", dialCode: "+1" },
      { code: "NL", name: "Netherlands", dialCode: "+31" },
      { code: "DE", name: "Germany", dialCode: "+49" },
      { code: "BE", name: "Belgium", dialCode: "+32" },
      { code: "CH", name: "Switzerland", dialCode: "+41" },
      { code: "IT", name: "Italy", dialCode: "+39" },
      { code: "ES", name: "Spain", dialCode: "+34" },
      { code: "PT", name: "Portugal", dialCode: "+351" },
      { code: "GR", name: "Greece", dialCode: "+30" },
      { code: "DK", name: "Denmark", dialCode: "+45" },
      { code: "NO", name: "Norway", dialCode: "+47" }
    ] },
    countryListLabel: { default: "Country" },
    locale: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "md" },
    autocomplete: { default: "tel" },
    maskInput: { type: Boolean, default: !0 },
    formatHintLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "focus", "blur", "validation-change", "verification-click", "country-change", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = Yt(), l = m(() => a("actions")), r = n, o = R(!1), i = R(!1), s = R(""), d = R(t.countries[0]), u = R(t.verificationOptions[0]), f = R(!1), b = R(void 0), h = R(null), p = R(null), x = m(() => {
      var De;
      return ((De = h.value) == null ? void 0 : De.$el) ?? null;
    }), y = R(null), w = m(
      () => {
        var De;
        return ((De = p.value) == null ? void 0 : De.$el) ?? null;
      }
    ), $ = R(null), S = Uu(), L = m(() => {
      if (!t.locale) return null;
      try {
        return new Intl.DisplayNames([t.locale], { type: "region", fallback: "none" });
      } catch {
        return null;
      }
    }), T = (De) => {
      var ze;
      return ((ze = L.value) == null ? void 0 : ze.of(De.code)) ?? De.name;
    }, E = (De) => {
      var ze;
      return De.placeholder || ((ze = Gn[De.code]) == null ? void 0 : ze.placeholder) || Tl.placeholder;
    }, A = (De) => {
      const ze = De.replace(/\s/g, "");
      return [...t.countries].sort((it, Ct) => Ct.dialCode.length - it.dialCode.length).find((it) => ze.startsWith(it.dialCode));
    }, D = () => {
      if (!t.modelValue) {
        s.value = "";
        return;
      }
      const De = A(t.modelValue);
      if (De) {
        d.value = De;
        const ze = t.modelValue.slice(De.dialCode.length);
        s.value = t.maskInput && t.showCountrySelector ? sr(
          ze.replace(/\D/g, ""),
          E(De),
          (Gn[De.code] ?? Tl).hasTrunkZero
        ) : ze;
        return;
      }
      s.value = t.modelValue.replace(/^\+/, "");
    };
    D();
    const M = m(() => {
      const De = s.value.replace(/\D/g, "");
      return !De || !/[1-9]/.test(De) ? "" : t.showCountrySelector ? `${d.value.dialCode}${De}` : `+${De}`;
    }), F = m(() => Gn[d.value.code] || Tl), X = m(() => t.showCountrySelector ? E(d.value) : "+33612345678"), _ = m(() => {
      if (t.error) return t.error;
      if (!t.disableInternalValidation && f.value)
        return b.value;
    }), Y = () => {
      const De = s.value.replace(/\D/g, "");
      if (t.required && !De)
        return "Phone number is required";
      if (!De)
        return;
      const ze = Fc(De, F.value.hasTrunkZero), { min: We, max: it } = F.value;
      if (ze.length < We || ze.length > it)
        return `Phone number must be ${We === it ? `${We}` : `${We}–${it}`} digits for ${d.value.name}`;
    }, B = () => {
      const De = Y();
      b.value = De, r("validation-change", !De, De);
    }, W = () => {
      b.value = void 0;
    }, U = (De) => Av(
      De,
      (ze) => ze.replace(/\D/g, ""),
      (ze) => sr(ze, X.value, F.value.hasTrunkZero)
    ), z = (De) => {
      const ze = De.target;
      if (W(), t.maskInput && t.showCountrySelector) {
        s.value = U(ze);
        return;
      }
      const We = ze.value.replace(/[^\d\s\-()]/g, "");
      s.value = We, ze.value = We;
    }, P = (De) => {
      var it, Ct;
      if ((it = Me.value) == null || it.handleFieldKeydown(De), (Ct = Ee.value) == null || Ct.handleFieldKeydown(De), t.readonly || t.disabled || !(t.maskInput && t.showCountrySelector)) return;
      const ze = De.target;
      Ev(De, ze, (Jt) => U(Jt)) && (W(), s.value = ze.value);
    }, K = (De) => {
      if (he.value = !1, f.value = !0, t.showCountrySelector) {
        const ze = s.value.replace(/\D/g, "");
        s.value = t.maskInput ? sr(
          ze,
          X.value,
          F.value.hasTrunkZero
        ) : ze;
      }
      B(), r("blur", De);
    }, j = (De) => {
      he.value = !0, r("focus", De);
    }, G = (De) => {
      var Jt;
      if (!t.showCountrySelector) return;
      const ze = (((Jt = De.clipboardData) == null ? void 0 : Jt.getData("text")) ?? "").trim();
      if (!ze.startsWith("+")) return;
      const We = A(ze);
      if (!We) return;
      De.preventDefault(), W(), d.value = We;
      const it = Gn[We.code] ?? Tl, Ct = ze.replace(/\D/g, "").slice(We.dialCode.replace(/\D/g, "").length);
      s.value = t.maskInput ? sr(Ct, E(We), it.hasTrunkZero) : Ct;
    }, q = (De) => {
      d.value = De, Q("country"), t.maskInput && t.showCountrySelector && s.value && (s.value = sr(
        s.value.replace(/\D/g, ""),
        X.value,
        F.value.hasTrunkZero
      )), f.value && B();
    }, J = (De, ze) => {
      ze.stopPropagation(), q(De);
    }, me = (De) => De === "country" ? o : i, ye = (De) => De === "country" ? x.value : w.value, Z = (De) => De === "country" ? y.value : $.value, de = (De) => {
      var ze;
      return Array.from(((ze = Z(De)) == null ? void 0 : ze.querySelectorAll("[data-popup-row]")) ?? []);
    }, ge = (De) => De.findIndex((ze) => ze.getAttribute("aria-selected") === "true" || ze.getAttribute("aria-checked") === "true"), se = (De, ze) => {
      const We = De[(ze + De.length) % De.length];
      We == null || We.focus({ preventScroll: !0 }), We == null || We.scrollIntoView({ block: "nearest" });
    }, Se = (De, ze) => {
      const We = ge(De);
      se(De, We !== -1 ? We : ze === "first" ? 0 : De.length - 1);
    }, V = async (De, ze = "first") => {
      me(De).value = !0, await Ue(), Se(de(De), ze);
    }, Q = (De) => {
      var ze, We;
      (ze = Z(De)) != null && ze.contains(document.activeElement) && ((We = ye(De)) == null || We.focus()), me(De).value = !1;
    }, le = (De, ze) => {
      t.disabled || (ze.stopPropagation(), me(De).value ? Q(De) : ze.detail === 0 ? V(De) : me(De).value = !0);
    }, ee = (De, ze) => {
      const We = Ma(S.query.value), it = /^(.)\1+$/u.test(We) ? We[0] : We, Ct = it.length === 1 ? ze + 1 : Math.max(ze, 0);
      for (let Jt = 0; Jt < t.countries.length; Jt++) {
        const zn = (Ct + Jt) % t.countries.length;
        if (Ma(T(t.countries[zn])).startsWith(it)) {
          se(De, zn);
          return;
        }
      }
    }, O = (De, ze) => {
      var Ct;
      if (!me(De).value) {
        (ze.key === "ArrowDown" || ze.key === "ArrowUp") && (ze.preventDefault(), V(De, ze.key === "ArrowDown" ? "first" : "last"));
        return;
      }
      const We = de(De), it = We.indexOf(document.activeElement);
      if (De === "country" && !(ze.key === " " && !S.query.value) && S.handleKey(ze)) {
        ze.preventDefault(), ze.stopPropagation(), ee(We, it);
        return;
      }
      switch (ze.key) {
        case "ArrowDown":
        case "ArrowUp":
          ze.preventDefault(), it === -1 ? Se(We, ze.key === "ArrowDown" ? "first" : "last") : se(We, it + (ze.key === "ArrowDown" ? 1 : -1));
          break;
        case "Home":
        case "End":
          ze.preventDefault(), se(We, ze.key === "Home" ? 0 : We.length - 1);
          break;
        case "Enter":
        case " ":
          if (it === -1) return;
          ze.preventDefault(), ze.stopPropagation(), We[it].click();
          break;
        case "Escape":
          ze.preventDefault(), ze.stopPropagation(), Q(De), (Ct = ye(De)) == null || Ct.focus();
          break;
        case "Tab":
          Q(De);
          break;
      }
    }, ne = (De) => le("country", De), fe = (De) => le("verification", De), ue = (De, ze) => {
      ze.stopPropagation(), u.value = De, Q("verification"), r("verification-click", De.id);
    }, te = (De) => {
      const ze = De.target, We = !x.value || !x.value.contains(ze), it = !y.value || !y.value.contains(ze);
      We && it && (o.value = !1);
      const Ct = !w.value || !w.value.contains(ze), Jt = !$.value || !$.value.contains(ze);
      Ct && Jt && (i.value = !1);
    };
    $e([s, d], () => {
      if (r("update:modelValue", M.value), t.showCountrySelector) {
        const De = s.value.replace(/\D/g, "");
        r("country-change", d.value, De);
      }
    }), $e(
      () => t.modelValue,
      (De) => {
        De !== M.value && (W(), D());
      }
    ), $e([o, i], ([De, ze]) => {
      De || ze ? document.addEventListener("click", te) : document.removeEventListener("click", te), De || S.reset();
    }), dt(() => {
      t.maskInput && t.showCountrySelector && t.modelValue && t.countries.some((De) => t.modelValue.startsWith(De.dialCode)) && M.value !== t.modelValue && r("update:modelValue", M.value);
    }), gt(() => {
      document.removeEventListener("click", te);
    });
    const oe = m(
      () => Xl(t.labelInline, !!t.label, !!t.removeButton)
    ), Le = m(() => t.removeButton && Ku(t.removeButton)), Ie = m(() => !!t.innerButton || t.showVerificationButton), ve = m(
      () => t.size === "md" ? "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]" : ""
    ), we = je(), he = R(!1), Me = R(null), Ee = R(null), He = m(() => `${we}-phone`), Ge = m(() => t.label ? `${we}-label` : void 0), Ze = m(() => `${we}-error`), ae = m(() => `${we}-hint`), ie = m(() => `${we}-format-hint`), Ce = `${we}-countries`, Fe = `${we}-verification`, Ke = `${we}-verification-menu`, _e = m(() => t.formatHintLabel ? `${t.formatHintLabel} ${X.value}` : t.showCountrySelector ? X.value : ""), Et = m(() => {
      const De = [];
      return _e.value && De.push(ie.value), t.hint && De.push(ae.value), _.value && De.push(Ze.value), De.length > 0 ? De.join(" ") : void 0;
    });
    return (De, ze) => (c(), g("div", {
      class: C(["relative w-full pb-0.5", oe.value.root])
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: Ge.value,
        ref_key: "labelRef",
        ref: Me,
        text: e.label,
        "input-id": He.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: he.value,
        inline: e.labelInline,
        class: C(oe.value.label),
        "test-id": "phone-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      _e.value ? (c(), g("span", {
        key: 1,
        id: ie.value,
        class: "sr-only"
      }, N(_e.value), 9, pB)) : k("", !0),
      v("div", {
        class: C(["flex w-full items-end gap-3", oe.value.field])
      }, [
        v("div", vB, [
          re(lo, {
            buttons: e.buttons,
            layout: e.buttonLayout,
            size: e.size,
            disabled: e.disabled,
            "button-size": e.buttonSize,
            onButtonClick: ze[4] || (ze[4] = (We) => r("button-click", We))
          }, ta({
            default: xe(({ fieldClass: We }) => [
              re(Bn, {
                class: C(["w-full", We]),
                size: e.size,
                "inner-button": Ie.value,
                disabled: e.disabled,
                readonly: e.readonly,
                error: !!_.value,
                "has-value": !!s.value
              }, {
                default: xe(({ leftIconBoxClass: it, iconColorClass: Ct, textClass: Jt }) => [
                  v("i", {
                    class: C(["ri-phone-fill", it, Ct]),
                    "aria-hidden": "true"
                  }, null, 2),
                  Jl(v("input", {
                    id: He.value,
                    "onUpdate:modelValue": ze[1] || (ze[1] = (zn) => s.value = zn),
                    type: "tel",
                    inputmode: "tel",
                    autocomplete: e.autocomplete,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "aria-labelledby": Ge.value,
                    "aria-invalid": !!_.value,
                    "aria-describedby": Et.value,
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      Jt,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    placeholder: X.value,
                    onInput: z,
                    onKeydown: P,
                    onPaste: G,
                    onBlur: K,
                    onFocus: j
                  }, null, 42, wB), [
                    [Ub, s.value]
                  ]),
                  e.innerButton ? (c(), H(Be, Oe({ key: 0 }, I(Xn)(e.innerButton, e.disabled), {
                    size: "xs",
                    onClick: ze[2] || (ze[2] = (zn) => r("button-click", e.innerButton.id))
                  }), null, 16)) : k("", !0),
                  e.showVerificationButton ? (c(), H(Be, {
                    key: 1,
                    id: Fe,
                    ref_key: "verificationButtonRef",
                    ref: p,
                    variant: "tertiary",
                    size: "xs",
                    class: C(e.size === "md" ? "-mr-0.5" : ""),
                    label: u.value.label,
                    disabled: e.disabled || e.readonly,
                    "aria-haspopup": "menu",
                    "aria-expanded": i.value,
                    "aria-controls": i.value ? Ke : void 0,
                    "dropdown-icon": "",
                    onClick: fe,
                    onKeydown: ze[3] || (ze[3] = (zn) => O("verification", zn))
                  }, null, 8, ["class", "label", "disabled", "aria-expanded", "aria-controls"])) : k("", !0)
                ]),
                _: 1
              }, 8, ["class", "size", "inner-button", "disabled", "readonly", "error", "has-value"])
            ]),
            _: 2
          }, [
            e.showCountrySelector ? {
              name: "leading",
              fn: xe(({ partClass: We, buttonSize: it }) => [
                re(Be, {
                  ref_key: "countryButtonRef",
                  ref: h,
                  variant: "secondary",
                  size: it,
                  class: C([We, ve.value]),
                  disabled: e.disabled || e.readonly,
                  "aria-haspopup": "listbox",
                  "aria-expanded": o.value,
                  "aria-controls": o.value ? Ce : void 0,
                  "dropdown-icon": "",
                  onClick: ne,
                  onKeydown: ze[0] || (ze[0] = (Ct) => O("country", Ct))
                }, {
                  default: xe(() => [
                    v("span", xB, [
                      v("span", yB, [
                        v("span", {
                          class: C(["fi fis size-[13.33px] rounded-full", `fi-${d.value.code.toLowerCase()}`]),
                          title: T(d.value)
                        }, null, 10, kB)
                      ]),
                      v("span", null, N(d.value.dialCode), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["size", "class", "disabled", "aria-expanded", "aria-controls"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["buttons", "layout", "size", "disabled", "button-size"]),
          e.showCountrySelector && o.value ? (c(), g("div", {
            key: 0,
            ref_key: "countryDropdownMenuRef",
            ref: y,
            class: C(["absolute left-0 top-full z-50 mt-1 w-56 max-h-[min(400px,calc(100vh-24px))] overflow-y-auto", I(ni)]),
            onKeydown: ze[5] || (ze[5] = (We) => O("country", We))
          }, [
            v("ul", {
              id: Ce,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "listbox",
              "aria-label": e.countryListLabel
            }, [
              (c(!0), g(ce, null, Re(e.countries, (We) => (c(), H(Kt, {
                key: We.code,
                as: "li",
                type: "flag",
                role: "option",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-selected": We.code === d.value.code,
                label: T(We),
                flag: We.code,
                selected: We.code === d.value.code,
                "data-testid": `phone-country-${We.code}`,
                onClick: (it) => J(We, it)
              }, null, 8, ["aria-selected", "label", "flag", "selected", "data-testid", "onClick"]))), 128))
            ], 8, CB)
          ], 34)) : k("", !0),
          e.showVerificationButton && i.value ? (c(), g("div", {
            key: 1,
            ref_key: "verificationDropdownMenuRef",
            ref: $,
            class: C(["absolute right-0 top-full z-50 mt-1 min-w-36 w-max", I(ni)]),
            onKeydown: ze[6] || (ze[6] = (We) => O("verification", We))
          }, [
            v("ul", {
              id: Ke,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "menu",
              "aria-labelledby": Fe
            }, [
              (c(!0), g(ce, null, Re(e.verificationOptions, (We) => (c(), H(Kt, {
                key: We.id,
                as: "li",
                type: "default",
                role: "menuitemradio",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-checked": We.id === u.value.id,
                label: We.label,
                selected: We.id === u.value.id,
                onClick: (it) => ue(We, it)
              }, null, 8, ["aria-checked", "label", "selected", "onClick"]))), 128))
            ])
          ], 34)) : k("", !0)
        ]),
        l.value ? (c(), g("div", SB, [
          Ae(De.$slots, "actions", {}, void 0, !0)
        ])) : k("", !0),
        Le.value && oe.value.removeInFieldRow ? (c(), H(Be, Oe({ key: 1 }, I(Xn)(Le.value, e.disabled), {
          size: I(za)(e.size, "attached"),
          onClick: ze[7] || (ze[7] = (We) => r("button-click", Le.value.id))
        }), null, 16, ["size"])) : k("", !0)
      ], 2),
      oe.value.reservesHelper || e.hint || _.value ? (c(), H(xt, {
        key: 2,
        ref_key: "helperRef",
        ref: Ee,
        class: C(oe.value.helper),
        focused: he.value,
        hint: e.hint,
        error: _.value,
        "hint-id": ae.value,
        "error-id": Ze.value,
        "test-id-prefix": "phone-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
      Le.value && !oe.value.removeInFieldRow ? (c(), H(Be, Oe({ key: 3 }, I(Xn)(Le.value, e.disabled), {
        class: oe.value.remove,
        size: I(za)(e.size, "attached"),
        onClick: ze[8] || (ze[8] = (We) => r("button-click", Le.value.id))
      }), null, 16, ["class", "size"])) : k("", !0)
    ], 2));
  }
}), IB = /* @__PURE__ */ ot($B, [["__scopeId", "data-v-da8fce2b"]]), TB = ["href", "aria-label"], LB = { key: 1 }, sq = /* @__PURE__ */ ke({
  __name: "PhoneDisplay",
  props: {
    value: {},
    link: { type: Boolean, default: !0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = m(() => mB(n.value)), a = m(() => `tel:${n.value.replace(/[^\d+]/g, "")}`);
    return (l, r) => e.link ? (c(), g("a", {
      key: 0,
      href: a.value,
      "aria-label": e.ariaLabel
    }, N(t.value), 9, TB)) : (c(), g("span", LB, N(t.value), 1));
  }
}), AB = ["id"], dq = /* @__PURE__ */ ke({
  __name: "MaskedInput",
  props: {
    modelValue: { default: "" },
    mask: {},
    label: { default: void 0 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    formatHintLabel: { default: void 0 },
    showEditIcon: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Yt(), r = m(() => hB(t.mask)), o = ($) => $.replace(/\D/g, ""), i = m(() => {
      const $ = o(t.modelValue ?? "");
      return r.value ? _r($, r.value) : $;
    }), s = je(), d = m(() => t.id || `${s}-masked`), u = m(() => `${d.value}-format-hint`), f = m(
      () => t.formatHintLabel ? `${t.formatHintLabel} ${t.mask}` : t.mask
    ), b = m(() => {
      const $ = [u.value];
      return t.hint && $.push(`${d.value}-hint`), t.error && $.push(`${d.value}-error`), $.join(" ");
    }), h = ($) => {
      const S = $.target, L = nb(S, o, r.value);
      a("update:modelValue", L), a("input", $);
    }, p = ($) => {
      if (t.readonly || t.disabled) return;
      const S = $.target;
      Ev(
        $,
        S,
        (T) => nb(T, o, r.value)
      ) && a("update:modelValue", S.value);
    }, x = ($) => a("focus", $), y = ($) => a("blur", $), w = () => {
      a("update:modelValue", ""), a("clear");
    };
    return ($, S) => (c(), g("div", null, [
      v("span", {
        id: u.value,
        class: "sr-only"
      }, N(f.value), 9, AB),
      re(Ot, {
        id: d.value,
        "model-value": i.value,
        placeholder: e.placeholder,
        label: e.label,
        hint: e.hint,
        error: e.error,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        success: e.success,
        "label-tooltip": e.labelTooltip,
        labels: e.labels,
        readonly: e.readonly,
        size: e.size,
        name: e.name,
        "full-width": e.fullWidth,
        width: e.width,
        "icon-left": e.iconLeft,
        "show-edit-icon": e.showEditIcon,
        "label-inline": e.labelInline,
        autocomplete: e.autocomplete,
        "aria-describedby": b.value,
        type: "text",
        inputmode: "numeric",
        "data-testid": "masked-input",
        onInput: h,
        onKeydown: p,
        onFocus: x,
        onBlur: y,
        onClear: w
      }, ta({ _: 2 }, [
        I(l)("actions") ? {
          name: "actions",
          fn: xe(() => [
            Ae($.$slots, "actions")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "model-value", "placeholder", "label", "hint", "error", "required", "required-indicator", "disabled", "success", "label-tooltip", "labels", "readonly", "size", "name", "full-width", "width", "icon-left", "show-edit-icon", "label-inline", "autocomplete", "aria-describedby"])
    ]));
  }
}), EB = ["disabled", "aria-disabled", "aria-label", "data-testid"], RB = {
  key: 2,
  role: "status",
  class: "sr-only"
}, BB = 2e3, id = /* @__PURE__ */ ke({
  __name: "ListItemActionButton",
  props: {
    action: {},
    appearance: {},
    variant: {},
    muted: { type: Boolean },
    rowHover: { type: Boolean },
    keepFocusable: { type: Boolean }
  },
  setup(e, { expose: n }) {
    const t = e, a = m(() => t.action.disabled ? t.action.disabledReason : void 0), l = m(() => !!t.action.disabled), r = m(() => l.value && !a.value && !t.keepFocusable), o = m(() => l.value && !r.value), i = m(() => t.muted || l.value ? "text-(--icons-icon-base)" : t.rowHover ? "text-(--icons-icon-base-strong) group-hover/row:text-(--icons-icon-hover)" : "text-(--icons-icon-base-strong)"), s = R(null), d = R(null), u = R(!1);
    let f, b = !1;
    const h = m(() => "copiedLabel" in t.action ? t.action.copiedLabel : void 0);
    async function p(w) {
      l.value || (clearTimeout(f), u.value = !1, await t.action.onClick(w), await Ue(), !(!h.value || b) && (u.value = !0, f = setTimeout(() => u.value = !1, BB)));
    }
    mt(() => {
      b = !0, clearTimeout(f);
    });
    const x = m(() => (u.value ? h.value : a.value) ?? "");
    function y() {
      var $;
      const w = d.value ?? (($ = s.value) == null ? void 0 : $.$el) ?? null;
      return !w || r.value ? !1 : (w.focus(), !0);
    }
    return n({ focus: y }), (w, $) => (c(), H(ft, {
      text: x.value,
      disabled: !x.value,
      open: u.value ? !0 : void 0,
      as: "span",
      class: "shrink-0"
    }, {
      default: xe(() => [
        e.appearance === "inline-icon" ? (c(), g("button", {
          key: 0,
          ref_key: "inlineRef",
          ref: d,
          type: "button",
          class: C(["inline-flex size-6 -mx-1 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-xs) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", l.value ? "cursor-default" : "cursor-pointer"]),
          disabled: r.value,
          "aria-disabled": o.value ? "true" : void 0,
          "aria-label": e.action.label,
          "data-testid": e.action.testId ?? "list-item-copy-action",
          onClick: p
        }, [
          v("i", {
            class: C(["ri-file-copy-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", i.value]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, EB)) : (c(), H(Be, Oe({
          key: 1,
          ref_key: "buttonRef",
          ref: s,
          variant: e.variant,
          size: "xs",
          "icon-only": e.appearance === "icon",
          "icon-left": "icon" in e.action ? e.action.icon : void 0,
          label: e.appearance === "label" ? e.action.label : void 0,
          "aria-label": e.appearance === "icon" ? e.action.label : void 0,
          disabled: r.value,
          "aria-disabled": o.value
        }, e.action.testId ? { "data-testid": e.action.testId } : {}, {
          onClick: e.action.onClick
        }), null, 16, ["variant", "icon-only", "icon-left", "label", "aria-label", "disabled", "aria-disabled", "onClick"])),
        e.appearance === "inline-icon" ? (c(), g("span", RB, N(u.value ? h.value : ""), 1)) : k("", !0)
      ]),
      _: 1
    }, 8, ["text", "disabled", "open"]));
  }
}), DB = ["id"], MB = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, zB = {
  key: 1,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, OB = {
  key: 0,
  class: "flex",
  "data-testid": "list-item-top-badge"
}, PB = ["id"], FB = ["id"], VB = ["id"], NB = {
  key: 3,
  class: "flex min-w-0 items-end justify-between gap-1.5",
  "data-testid": "list-item-amount-row"
}, HB = { class: "flex min-w-0 items-end gap-1.5" }, jB = ["id"], WB = ["id"], qB = ["id"], UB = ["id"], GB = ["id"], KB = {
  key: 6,
  class: "flex flex-wrap gap-1",
  "data-testid": "list-item-label-badge"
}, YB = ["id"], JB = ["id"], XB = {
  key: 5,
  class: "flex shrink-0",
  "data-testid": "list-item-right-icon"
}, ZB = {
  key: 6,
  class: "ml-0.5 flex shrink-0 items-center gap-1.5",
  "data-testid": "list-item-icons"
}, QB = ["id", "src", "alt"], _B = ["id", "role", "aria-label", "aria-hidden"], eD = {
  key: 0,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-trend"
}, tD = { class: "flex items-center" }, nD = ["id"], aD = ["id"], ob = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", ib = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", sb = "@max-[24rem]/item:flex-col-reverse", db = "pt-3.5 pr-3.5", lD = 2, rD = "ri-arrow-right-line", oD = "cursor-pointer text-left disabled:cursor-default aria-disabled:cursor-default focus-visible:outline-hidden after:absolute after:inset-0 after:content-[''] after:rounded-(--border-border-radius-rounded-xs) focus-visible:after:ring-2 focus-visible:after:ring-(--border-border-accent) focus-visible:after:outline-2 focus-visible:after:outline-transparent", iD = /* @__PURE__ */ ke({
  __name: "ListItem",
  props: {
    type: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    value: { default: void 0 },
    rightIcon: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    iconShape: { default: void 0 },
    helperText: { default: void 0 },
    extraText: { default: void 0 },
    labelBadge: { default: void 0 },
    badge: { default: void 0 },
    status: { default: void 0 },
    copyAction: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    trend: { default: void 0 },
    progress: { default: void 0 },
    max: { default: void 0 },
    amount: { default: void 0 },
    total: { default: void 0 },
    sideText: { default: void 0 },
    percentText: { default: void 0 },
    valueTone: { default: void 0 },
    meta: { default: void 0 },
    author: { default: void 0 },
    badges: { default: void 0 },
    selected: { type: Boolean, default: void 0 }
  },
  emits: ["click"],
  setup(e, { expose: n, emit: t }) {
    var ee;
    const a = e, l = t, r = {
      root: "items-center justify-between gap-1.5",
      main: "flex-1",
      height: "min-h-6",
      labelText: ob,
      extra: ib,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      gap: "gap-1.5",
      align: "items-center",
      value: "text-(--text-text-black-default)",
      valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      valueBox: "shrink-0",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: sb,
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      mutedBadges: !0,
      mutedIconShape: !0
    }, o = {
      root: "items-center justify-between gap-0.5",
      main: "flex-1",
      height: "",
      gap: "gap-2",
      labelText: ob,
      extra: ib,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      value: "",
      valueText: "",
      valueBox: "",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: sb,
      mutedBadges: !0,
      mutedIconShape: !0
    }, i = {
      ...o,
      root: "items-center justify-between gap-1.5",
      height: "",
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      value: "text-(--text-text-body)",
      valueText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      // Figma puts the value in the root, 6 px after `Left content`; here it sits in the main zone,
      // whose gap is the 8 px of `Left content`.
      valueBox: "shrink-0 -ml-0.5",
      align: "items-center",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      // Figma Disabled object rows keep the Icon Shape colours.
      mutedIconShape: !1
    }, s = `${db} pl-3.5 pb-[calc(--spacing(3.5)-1px)]`, d = `${s} border-b border-(--border-border-disabled-subtle) bg-(--background-background-disabled-opacity)`, u = `${s} border-b border-(--border-border-disabled) bg-(--background-background-disabled-opacity)`, f = {
      ...i,
      root: "items-center justify-between gap-2",
      gap: "gap-2",
      labelText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)",
      label: "text-(--text-text-black-default)",
      column: "gap-1",
      labelGap: "gap-0",
      hoverRecolour: !1,
      surface: `${s} border-b border-(--border-border-base-soft) bg-(--background-background-white)`,
      surfaceHover: "hover:pl-[calc(--spacing(3.5)-2px)] hover:pb-3.5 hover:border-b-0 hover:border-l-2 hover:border-l-(--border-border-hover) hover:bg-(--background-background-hover)",
      surfaceActive: `${db} pl-[calc(--spacing(3.5)-2px)] pb-3.5 border-l-2 border-(--border-border-hover) bg-(--background-background-hover)`,
      surfaceMuted: d,
      mutedIconShape: !0
    }, b = {
      avatar: !0,
      helperText: !0,
      extraText: !0,
      labelBadge: !0,
      badge: !0,
      secondaryAction: !0
    }, h = {
      default: { ...r, props: { icon: !0 } },
      "with-number": { ...r, props: { icon: !0, value: !0 } },
      "with-badge": { ...r, props: { icon: !0, badge: !0 } },
      "with-right-icon": { ...r, props: { icon: !0, rightIcon: !0 } },
      "with-icons": { ...r, root: "items-center justify-start gap-2", main: "flex-initial", props: { icon: !0, icons: !0 } },
      "image-number": { ...i, props: { avatar: !0, helperText: !0, value: !0 } },
      "icon-number": {
        ...i,
        root: "items-start justify-start gap-2",
        main: "flex-initial",
        valueBox: "shrink-0 self-start",
        props: { iconShape: !0, helperText: !0, value: !0 }
      },
      // Figma Disabled 12773:10692, 15346:13357, 12773:13407 keep the Badge theme.
      "icon-number-badge": {
        ...i,
        badgePlacement: "above",
        mutedBadges: !1,
        props: { iconShape: !0, helperText: !0, badge: !0 }
      },
      "icon-badge": { ...i, mutedBadges: !1, props: { iconShape: !0, helperText: !0, badge: !0 } },
      "badge-name": { ...i, badgePlacement: "above", mutedBadges: !1, props: { badge: !0, helperText: !0 } },
      "image-buttons": {
        ...i,
        trailingGap: "gap-1.5",
        // Two buttons: on screen in their Tab order.
        trailingStack: "@max-[24rem]/item:flex-col",
        secondaryVariant: "ghost",
        props: { avatar: !0, helperText: !0, primaryAction: !0, secondaryAction: !0 }
      },
      transaction: {
        ...i,
        label: "text-(--text-text-black-default)",
        helper: "text-(--text-text-black-default)",
        valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        value: "text-(--text-text-black-default)",
        end: "column",
        shape: "square",
        props: { iconShape: !0, helperText: !0, value: !0, status: !0 }
      },
      // Figma 19619:3015: only the label and extra text recolour (hover and disabled).
      "data-list": {
        ...i,
        root: "items-center justify-between gap-1.5 pb-1.5",
        height: "",
        gap: "gap-1.5",
        labelText: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
        label: "text-(--text-text-heading)",
        extra: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        helper: "text-(--text-text-black-default)",
        column: "gap-0.5",
        trailingGap: "gap-1.5",
        props: { extraText: !0, trend: !0 }
      },
      // Figma 19563:13185: hover and disabled change the fill only.
      progress: {
        ...i,
        root: "flex-col items-stretch gap-1.5 p-1 pt-0 rounded-(--border-border-radius-rounded-xs)",
        main: "w-full",
        gap: "gap-0",
        labelText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        labelGap: "gap-4",
        labelRow: "items-end",
        column: "gap-0",
        surfaceHover: "hover:bg-(--background-background-hover)",
        surfaceMuted: "bg-(--background-background-disabled-opacity)",
        recolour: !1,
        hoverRecolour: !1,
        props: {
          progress: !0,
          max: !0,
          amount: !0,
          total: !0,
          sideText: !0,
          percentText: !0,
          valueTone: !0
        }
      },
      "tab-document": {
        ...f,
        shape: "square",
        props: { iconShape: !0, meta: !0, author: !0, selected: !0 }
      },
      // The Figma raw binds a stronger disabled border on these two than on tab-document.
      "tab-badge": { ...f, badgePlacement: "below", surfaceMuted: u, props: { badge: !0, selected: !0 } },
      "tab-history": {
        ...f,
        surfaceMuted: u,
        props: { meta: !0, author: !0, badges: !0, selected: !0 }
      },
      "avatar-text-badge": {
        ...o,
        props: { ...b, copyAction: !0 },
        label: "text-(--text-text-body)",
        helper: "text-(--text-text-body)",
        align: "items-center",
        labelRow: "items-center",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      },
      "avatar-text-two-badges": {
        ...o,
        props: b,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-start",
        labelRow: "items-start",
        leading: "py-1",
        badgePlacement: "label-row",
        secondaryVariant: "secondary"
      },
      "contact-item-badge": {
        ...o,
        props: b,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-center",
        labelRow: "items-start",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      }
    }, p = m(() => h[a.type] ?? h.default), x = m(() => a.disabled || a.ariaDisabled), y = [
      "icon",
      "value",
      "rightIcon",
      "icons",
      "avatar",
      "iconShape",
      "helperText",
      "extraText",
      "labelBadge",
      "badge",
      "status",
      "copyAction",
      "primaryAction",
      "secondaryAction",
      "trend",
      "progress",
      "max",
      "amount",
      "total",
      "sideText",
      "percentText",
      "valueTone",
      "meta",
      "author",
      "badges",
      "selected"
    ];
    function w(O) {
      return !!p.value.props[O];
    }
    const $ = m(() => {
      const O = w("copyAction") ? a.copyAction : void 0;
      return O && x.value ? { ...O, disabled: !0, disabledReason: void 0 } : O;
    }), S = m(() => {
      var fe;
      const O = (ue) => w(ue) ? a[ue] : void 0, ne = p.value.badgePlacement;
      return {
        icon: O("icon"),
        value: O("value"),
        rightIcon: w("rightIcon") ? a.rightIcon ?? rD : void 0,
        icons: O("icons"),
        avatar: O("avatar"),
        iconShape: O("iconShape"),
        status: O("status"),
        helperText: O("helperText"),
        extraText: O("extraText"),
        labelBadge: O("labelBadge"),
        belowBadges: [
          w("labelBadge") ? a.labelBadge : void 0,
          ne === "below" ? a.badge : void 0,
          ...w("badges") ? (a.badges ?? []).slice(0, lD) : []
        ].filter((ue) => !!ue),
        meta: w("meta") && ((fe = a.meta) != null && fe.length) ? a.meta.join(" · ") : void 0,
        author: O("author"),
        selected: w("selected") && a.interactive && !!a.selected,
        rowBadge: ne === "label-row" ? O("badge") : void 0,
        topBadge: ne === "above" ? O("badge") : void 0,
        trailingBadge: ne === "trailing" ? O("badge") : void 0,
        copyAction: $.value,
        primaryAction: O("primaryAction"),
        secondaryAction: O("secondaryAction"),
        trend: O("trend"),
        progress: O("progress"),
        max: O("max"),
        amount: O("amount"),
        total: O("total"),
        sideText: O("sideText"),
        percentText: O("percentText")
      };
    }), L = {
      neutral: "text-(--text-text-body)",
      success: "text-(--text-text-success)",
      warning: "text-(--text-text-warning)",
      destructive: "text-(--text-text-error-strong)",
      info: "text-(--text-text-info)"
    }, T = m(() => L[a.valueTone ?? "neutral"]), E = je(), A = je(), D = (O) => `${A}-${O}`, M = m(() => {
      var fe;
      const O = S.value;
      return [
        O.topBadge && D("top-badge"),
        O.sideText && D("side"),
        O.rowBadge && D("row-badge"),
        O.helperText && D("helper"),
        O.extraText && D("extra"),
        O.amount && D("amount"),
        O.amount && O.total && D("total"),
        O.amount && O.percentText && D("percent"),
        O.meta && D("meta"),
        O.author && D("author"),
        ...O.belowBadges.map((ue, te) => D(`below-badge-${te}`)),
        O.value && D("value"),
        O.value && O.status && p.value.end === "column" && D("status"),
        ...(O.icons ?? []).flatMap((ue, te) => ue.label ? [D(`icon-${te}`)] : []),
        O.trend && D("trend-value"),
        ((fe = O.trend) == null ? void 0 : fe.caption) && D("trend-caption"),
        O.trailingBadge && D("trailing-badge")
      ].filter((ue) => !!ue).join(" ") || void 0;
    }), F = m(() => x.value ? p.value.surfaceMuted : S.value.selected ? p.value.surfaceActive : a.interactive ? [p.value.surface, p.value.surfaceHover] : p.value.surface), X = m(() => x.value ? "text-(--text-text-disabled-strong)" : p.value.caption), _ = m(
      () => !!(S.value.trailingBadge || S.value.primaryAction || S.value.secondaryAction || S.value.trend)
    ), Y = m(() => {
      if (x.value && p.value.recolour) return "text-(--text-text-disabled-strong)";
      const O = p.value.label;
      return a.interactive && p.value.hoverRecolour ? `${O} group-hover/row:text-(--text-text-hover)` : O;
    }), B = m(() => {
      if (x.value && p.value.recolour) return "text-(--text-text-disabled-strong)";
      const O = p.value.helper;
      return a.interactive && p.value.hoverRecolour ? `${O} group-hover/row:text-(--text-text-hover)` : O;
    }), W = m(() => {
      if (x.value) return "text-(--icons-icon-disabled-strong)";
      const O = "text-(--icons-icon-dark-default)";
      return a.interactive ? `${O} group-hover/row:text-(--icons-icon-hover)` : O;
    }), U = m(() => {
      if (x.value) return `${p.value.valueText} text-(--text-text-disabled-strong)`;
      const O = `${p.value.valueText} ${p.value.value}`;
      return a.interactive ? `${O} group-hover/row:text-(--text-text-hover)` : O;
    }), z = m(() => x.value ? "grayscale opacity-60" : "");
    function P(O) {
      return x.value && p.value.mutedBadges ? "disabled" : O.theme;
    }
    const K = m(() => a.interactive && !x.value ? "group-hover/row:text-(--text-text-hover)" : "");
    function j(O) {
      x.value || l("click", O);
    }
    const G = m(
      () => a.interactive ? {
        type: "button",
        disabled: a.disabled,
        "aria-disabled": a.ariaDisabled && !a.disabled ? "true" : void 0,
        "aria-current": S.value.selected ? "true" : void 0,
        "aria-labelledby": E,
        "aria-describedby": M.value,
        "data-row-button": "",
        "data-testid": "list-item-row-button"
      } : {}
    ), q = R(null), J = R(null), me = R(null);
    function ye(O) {
      const ne = { primary: q, secondary: J, copy: me }[O].value;
      return (ne == null ? void 0 : ne.focus()) ?? !1;
    }
    n({ focusAction: ye });
    const Z = R(null), de = R(!1), ge = R(!1), se = m(() => ge.value ? !1 : de.value ? !0 : void 0);
    function Se(O) {
      try {
        de.value = O.target.matches(":focus-visible");
      } catch {
        de.value = !0;
      }
    }
    function V() {
      de.value = !1, ge.value = !1;
    }
    $e(
      () => [a.disabled, a.interactive],
      ([O, ne]) => {
        (O || !ne) && V();
      }
    );
    function Q(O) {
      var ne;
      O.key !== "Escape" || ge.value || !de.value || !((ne = Z.value) != null && ne.isTruncated) || (O.stopPropagation(), O.preventDefault(), ge.value = !0);
    }
    const le = typeof process < "u" && ((ee = process.env) == null ? void 0 : ee.NODE_ENV) !== "production";
    return $e(
      () => [a.type, a.interactive, a.selected, ...y.map((O) => a[O] !== void 0)].join(),
      () => {
        if (!le) return;
        if (!(a.type in h)) {
          console.warn(`[OPAL ListItem] unknown type "${a.type}": rendered as "default".`);
          return;
        }
        const O = y.filter((ne) => a[ne] !== void 0 && !w(ne));
        O.length && console.warn(`[OPAL ListItem] type "${a.type}" takes no ${O.map((ne) => `\`${ne}\``).join(", ")}: ignored.`), a.selected && !a.interactive && console.warn("[OPAL ListItem] `selected` needs `interactive`: ignored.");
      },
      { immediate: !0 }
    ), (O, ne) => {
      var fe;
      return c(), g("li", {
        class: C(["@container/item flex w-full min-w-0", [p.value.root, p.value.height, F.value, e.interactive ? "group/row relative" : ""]]),
        "data-testid": "list-item"
      }, [
        e.interactive || S.value.progress !== void 0 ? (c(), g("span", {
          key: 0,
          id: I(E),
          hidden: ""
        }, N(e.label), 9, DB)) : k("", !0),
        v("div", {
          class: C(["flex min-w-0", [p.value.main, p.value.gap, p.value.align]]),
          "data-testid": "list-item-main"
        }, [
          S.value.icon ? (c(), g("div", MB, [
            v("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [S.value.icon, W.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : k("", !0),
          S.value.iconShape ? (c(), g("div", zB, [
            re(Vt, {
              icon: S.value.iconShape.icon,
              color: x.value && p.value.mutedIconShape ? "disabled" : S.value.iconShape.color ?? "default",
              type: p.value.shape,
              variant: "outlined",
              size: "md",
              as: "span"
            }, null, 8, ["icon", "color", "type"])
          ])) : k("", !0),
          S.value.avatar ? (c(), g("div", {
            key: 2,
            class: C(["flex shrink-0", p.value.leading]),
            "data-testid": "list-item-leading"
          }, [
            re(Mt, {
              name: S.value.avatar.name,
              img: S.value.avatar.img,
              entity: S.value.avatar.entity,
              size: "md",
              as: "span",
              presentational: ""
            }, null, 8, ["name", "img", "entity"])
          ], 2)) : k("", !0),
          v("div", {
            class: C(["flex flex-1 min-w-0 flex-col", p.value.column])
          }, [
            S.value.topBadge ? (c(), g("div", OB, [
              re(ct, {
                id: D("top-badge"),
                label: S.value.topBadge.label,
                theme: P(S.value.topBadge),
                "left-icon": S.value.topBadge.leftIcon,
                "show-left-icon": !!S.value.topBadge.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])
            ])) : k("", !0),
            v("div", {
              class: C(["flex min-w-0", [p.value.labelGap, p.value.labelRow]]),
              "data-testid": "list-item-label-row"
            }, [
              (c(), H(lt(e.interactive ? "button" : "span"), Oe({
                class: ["flex min-w-0", [S.value.copyAction ? "" : "flex-1", e.interactive ? oD : ""]]
              }, G.value, Ml(e.interactive ? { click: j, focus: Se, blur: V, keydown: Q } : {})), {
                default: xe(() => [
                  re(ht, {
                    ref_key: "labelRef",
                    ref: Z,
                    as: "span",
                    class: C(e.interactive ? "relative z-1" : ""),
                    text: e.label,
                    focusable: !e.interactive,
                    open: e.interactive ? se.value : void 0,
                    "text-class": `${p.value.labelText} @max-[24rem]/item:whitespace-normal @max-[24rem]/item:wrap-break-word ${Y.value}`,
                    "data-testid": "list-item-label"
                  }, null, 8, ["class", "text", "focusable", "open", "text-class"])
                ]),
                _: 1
              }, 16, ["class"])),
              S.value.sideText ? (c(), g("div", {
                key: 0,
                id: D("side"),
                class: "block min-w-0 max-w-1/2 shrink-0 wrap-break-word text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                "data-testid": "list-item-side-text"
              }, N(S.value.sideText), 9, PB)) : k("", !0),
              S.value.copyAction ? (c(), H(id, {
                key: 1,
                ref_key: "copyRef",
                ref: me,
                class: C(e.interactive ? "relative z-1" : ""),
                action: S.value.copyAction,
                appearance: "inline-icon",
                muted: x.value,
                "row-hover": e.interactive,
                "keep-focusable": e.ariaDisabled && !e.disabled
              }, null, 8, ["class", "action", "muted", "row-hover", "keep-focusable"])) : k("", !0),
              S.value.rowBadge ? (c(), H(ct, {
                key: 2,
                id: D("row-badge"),
                class: "shrink-0",
                label: S.value.rowBadge.label,
                theme: P(S.value.rowBadge),
                "left-icon": S.value.rowBadge.leftIcon,
                "show-left-icon": !!S.value.rowBadge.leftIcon,
                size: "sm",
                "data-testid": "list-item-badge"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : k("", !0)
            ], 2),
            S.value.helperText ? (c(), g("span", {
              key: 1,
              id: D("helper"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", B.value]),
              "data-testid": "list-item-helper"
            }, N(S.value.helperText), 11, FB)) : k("", !0),
            S.value.extraText ? (c(), g("span", {
              key: 2,
              id: D("extra"),
              class: C(["block min-w-0 wrap-break-word", [p.value.extra, B.value]]),
              "data-testid": "list-item-extra"
            }, N(S.value.extraText), 11, VB)) : k("", !0),
            S.value.amount ? (c(), g("div", NB, [
              v("div", HB, [
                v("span", {
                  id: D("amount"),
                  class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading)",
                  "data-testid": "list-item-amount"
                }, N(S.value.amount), 9, jB),
                S.value.total ? (c(), g("span", {
                  key: 0,
                  id: D("total"),
                  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                  "data-testid": "list-item-total"
                }, N(S.value.total), 9, WB)) : k("", !0)
              ]),
              S.value.percentText ? (c(), g("span", {
                key: 0,
                id: D("percent"),
                class: C(["shrink-0 text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", T.value]),
                "data-testid": "list-item-percent"
              }, N(S.value.percentText), 11, qB)) : k("", !0)
            ])) : k("", !0),
            S.value.meta ? (c(), g("span", {
              key: 4,
              id: D("meta"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-s) font-(--weight-regular)", X.value]),
              "data-testid": "list-item-meta"
            }, N(S.value.meta), 11, UB)) : k("", !0),
            S.value.author ? (c(), g("span", {
              key: 5,
              id: D("author"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", X.value]),
              "data-testid": "list-item-author"
            }, N(S.value.author), 11, GB)) : k("", !0),
            S.value.belowBadges.length ? (c(), g("div", KB, [
              (c(!0), g(ce, null, Re(S.value.belowBadges, (ue, te) => (c(), H(ct, {
                id: D(`below-badge-${te}`),
                key: te,
                label: ue.label,
                theme: P(ue),
                "left-icon": ue.leftIcon,
                "show-left-icon": !!ue.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"]))), 128))
            ])) : k("", !0)
          ], 2),
          S.value.value && p.value.end === "column" ? (c(), g("div", {
            key: 3,
            class: C(["flex shrink-0 flex-col items-end", p.value.valueBox]),
            "data-testid": "list-item-end"
          }, [
            v("span", {
              id: D("value"),
              class: C(U.value),
              "data-testid": "list-item-value"
            }, N(S.value.value), 11, YB),
            S.value.status ? (c(), H(ct, {
              key: 0,
              id: D("status"),
              label: S.value.status.label,
              theme: P(S.value.status),
              type: "with-dot",
              size: "sm",
              class: C(K.value),
              "data-testid": "list-item-status"
            }, null, 8, ["id", "label", "theme", "class"])) : k("", !0)
          ], 2)) : S.value.value ? (c(), g("span", {
            key: 4,
            id: D("value"),
            class: C([p.value.valueBox, U.value]),
            "data-testid": "list-item-value"
          }, N(S.value.value), 11, JB)) : k("", !0),
          S.value.rightIcon ? (c(), g("div", XB, [
            v("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [S.value.rightIcon, W.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : k("", !0),
          (fe = S.value.icons) != null && fe.length ? (c(), g("div", ZB, [
            (c(!0), g(ce, null, Re(S.value.icons, (ue, te) => (c(), g(ce, { key: te }, [
              ue.src ? (c(), g("img", {
                key: 0,
                id: ue.label ? D(`icon-${te}`) : void 0,
                class: C(["size-4.5 shrink-0 object-contain", z.value]),
                src: ue.src,
                alt: ue.label,
                "data-testid": "list-item-icons-entry"
              }, null, 10, QB)) : (c(), g("i", {
                key: 1,
                id: ue.label ? D(`icon-${te}`) : void 0,
                class: C(["inline-flex size-4.5 items-center justify-center text-[18px] leading-[18px]", [ue.icon, W.value]]),
                role: ue.label ? "img" : void 0,
                "aria-label": ue.label,
                "aria-hidden": ue.label ? void 0 : "true",
                "data-testid": "list-item-icons-entry"
              }, null, 10, _B))
            ], 64))), 128))
          ])) : k("", !0)
        ], 2),
        S.value.progress !== void 0 ? (c(), H(Gu, {
          key: 1,
          value: S.value.progress,
          max: S.value.max,
          size: "lg",
          "aria-labelledby": I(E),
          "aria-valuetext": S.value.percentText,
          "data-testid": "list-item-progress"
        }, null, 8, ["value", "max", "aria-labelledby", "aria-valuetext"])) : k("", !0),
        _.value ? (c(), g("div", {
          key: 2,
          class: C(["flex shrink-0 items-center @max-[24rem]/item:items-end @max-[24rem]/item:gap-2", [p.value.trailingGap, p.value.trailingStack]]),
          "data-testid": "list-item-trailing"
        }, [
          S.value.trend ? (c(), g("div", eD, [
            v("span", tD, [
              ne[0] || (ne[0] = v("i", {
                class: "ri-arrow-right-up-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-success)",
                "aria-hidden": "true"
              }, null, -1)),
              v("span", {
                id: D("trend-value"),
                class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-success)",
                "data-testid": "list-item-trend-value"
              }, N(S.value.trend.value), 9, nD)
            ]),
            S.value.trend.caption ? (c(), g("span", {
              key: 0,
              id: D("trend-caption"),
              class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
              "data-testid": "list-item-trend-caption"
            }, N(S.value.trend.caption), 9, aD)) : k("", !0)
          ])) : k("", !0),
          S.value.trailingBadge ? (c(), H(ct, {
            key: 1,
            id: D("trailing-badge"),
            label: S.value.trailingBadge.label,
            theme: P(S.value.trailingBadge),
            "left-icon": S.value.trailingBadge.leftIcon,
            "show-left-icon": !!S.value.trailingBadge.leftIcon,
            size: "sm",
            "data-testid": "list-item-badge"
          }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : k("", !0),
          S.value.primaryAction ? (c(), H(id, {
            key: 2,
            ref_key: "primaryRef",
            ref: q,
            class: C(e.interactive ? "relative z-1" : ""),
            action: S.value.primaryAction,
            appearance: "label",
            variant: "secondary"
          }, null, 8, ["class", "action"])) : k("", !0),
          S.value.secondaryAction ? (c(), H(id, {
            key: 3,
            ref_key: "secondaryRef",
            ref: J,
            class: C(e.interactive ? "relative z-1" : ""),
            action: S.value.secondaryAction,
            appearance: "icon",
            variant: p.value.secondaryVariant
          }, null, 8, ["class", "action", "variant"])) : k("", !0)
        ], 2)) : k("", !0)
      ], 2);
    };
  }
}), sD = /* @__PURE__ */ ke({
  __name: "ListItemGroup",
  props: {
    divider: { type: Boolean, default: !1 },
    dividerColor: { default: "var(--border-border-base-soft)" }
  },
  setup(e) {
    const n = e, t = m(() => n.divider ? { "--list-item-group-divider": n.dividerColor } : void 0);
    return (a, l) => (c(), g("ul", {
      role: "list",
      class: C(["m-0 flex w-full min-w-0 list-none flex-col p-0", e.divider ? "gap-3 [&>li+li]:border-t [&>li+li]:border-solid [&>li+li]:border-(--list-item-group-divider) [&>li+li]:pt-3" : "gap-4"]),
      style: Ne(t.value),
      "data-testid": "list-item-group"
    }, [
      Ae(a.$slots, "default")
    ], 6));
  }
});
function Bv(e) {
  return m(() => {
    const n = e(), t = n.border !== !1, a = [
      `flex items-center rounded-(--border-border-radius-rounded-l) border border-solid w-full transition-[color,background-color,border-color,box-shadow] duration-200 ${n.padding}`,
      n.gap
    ];
    return n.minHeight && a.push(n.minHeight), n.alwaysClasses && a.push(n.alwaysClasses), n.disabled ? (a.push("bg-(--background-background-disabled-opacity) cursor-default"), a.push(t ? "border-(--border-border-disabled)" : "border-transparent"), a) : (n.selected ? a.push("bg-(--background-background-accent) border-(--border-border-accent)") : (a.push("bg-(--background-background-white) hover:bg-(--background-background-hover)"), a.push(
      t ? "border-(--border-border-base-medium) hover:border-(--border-border-hover)" : "border-transparent"
    )), n.restingClasses && a.push(n.restingClasses), n.grabbed && a.push("ring-2 ring-(--border-border-accent)"), a);
  });
}
const dD = {
  key: 0,
  class: "min-w-0 flex-1"
}, uD = ["aria-label"], cD = /* @__PURE__ */ ke({
  __name: "EditableTitle",
  props: {
    modelValue: {},
    editable: { type: Boolean, default: !0 },
    showPen: { type: Boolean, default: !0 },
    size: { default: "md" },
    placeholder: { default: void 0 },
    emptyText: { default: void 0 },
    maxlength: { default: void 0 },
    error: { default: void 0 },
    editLabel: {},
    saveLabel: {},
    penVariant: { default: "secondary" },
    inputWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    warnPattern: { default: void 0 },
    warnLabel: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 }
  },
  emits: ["save", "cancel", "edit-start", "edit-end"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      sm: {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
        gap: "gap-1.5",
        pen: "xs"
      },
      md: {
        text: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-3",
        pen: "xs"
      },
      lg: {
        text: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-2",
        pen: "xs"
      }
    }, r = m(() => l[t.size]), o = m(() => t.modelValue || t.emptyText || ""), i = R(!1), s = R(""), d = R(null), u = R(null), f = m(
      () => t.maxWidth && !i.value ? { maxWidth: t.maxWidth } : void 0
    ), b = m(() => !!t.warnPattern && t.warnPattern.test(s.value));
    function h() {
      var T;
      const S = (T = d.value) == null ? void 0 : T.$el, L = S == null ? void 0 : S.querySelector("input");
      L == null || L.focus(), L == null || L.select();
    }
    async function p() {
      t.editable && (s.value = t.modelValue, i.value = !0, await Ue(), h());
    }
    async function x() {
      var S, L;
      i.value = !1, await Ue(), (L = (S = u.value) == null ? void 0 : S.$el) == null || L.focus();
    }
    function y() {
      x(), a("cancel");
    }
    function w() {
      const S = s.value.trim();
      if (S.length === 0 || S === t.modelValue) {
        y();
        return;
      }
      a("save", S), x();
    }
    function $(S) {
      S.key === "Enter" ? (S.preventDefault(), w()) : S.key === "Escape" && (S.preventDefault(), y());
    }
    return $e(
      () => t.error,
      async (S) => {
        S && !i.value && (i.value = !0, await Ue(), h());
      }
    ), $e(i, (S) => {
      a(S ? "edit-start" : "edit-end");
    }), $e(
      () => t.autoEdit,
      (S) => {
        S && t.editable && !i.value && p();
      },
      { immediate: !0 }
    ), (S, L) => (c(), g("div", {
      class: C(["inline-flex min-w-0 items-center", i.value ? "gap-3" : r.value.gap]),
      style: Ne(f.value),
      "data-testid": "editable-title"
    }, [
      i.value ? (c(), g(ce, { key: 1 }, [
        re(Ot, {
          ref_key: "inputRef",
          ref: d,
          modelValue: s.value,
          "onUpdate:modelValue": L[0] || (L[0] = (T) => s.value = T),
          size: "md",
          placeholder: e.placeholder,
          maxlength: e.maxlength,
          "aria-label": e.editLabel,
          "full-width": !e.inputWidth,
          width: e.inputWidth,
          "data-testid": "editable-title-input",
          onKeydown: $
        }, ta({ _: 2 }, [
          b.value ? {
            name: "iconRight",
            fn: xe(() => [
              re(ft, {
                text: e.warnLabel ?? "",
                disabled: !e.warnLabel,
                position: "bottom"
              }, {
                default: xe(() => [
                  v("i", {
                    class: "ri-alert-fill inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l) text-(--icons-icon-warning)",
                    role: "img",
                    "aria-label": e.warnLabel,
                    "data-testid": "editable-title-warning"
                  }, null, 8, uD)
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "placeholder", "maxlength", "aria-label", "full-width", "width"]),
        re(Be, {
          variant: "secondary",
          size: "sm",
          "icon-only": "",
          "icon-left": "ri-save-3-fill",
          "aria-label": e.saveLabel,
          "data-testid": "editable-title-save",
          onMousedown: L[1] || (L[1] = Ye(() => {
          }, ["prevent"])),
          onClick: w
        }, null, 8, ["aria-label"])
      ], 64)) : (c(), g(ce, { key: 0 }, [
        e.maxWidth ? (c(), g("div", dD, [
          re(ht, {
            text: o.value,
            position: "bottom",
            "text-class": r.value.text,
            "data-testid": "editable-title-text"
          }, null, 8, ["text", "text-class"])
        ])) : (c(), g("span", {
          key: 1,
          class: C([r.value.text, "truncate"]),
          "data-testid": "editable-title-text"
        }, N(o.value), 3)),
        e.editable && e.showPen ? (c(), H(Be, {
          key: 2,
          ref_key: "penRef",
          ref: u,
          variant: e.penVariant,
          size: r.value.pen,
          "icon-only": "",
          "icon-left": "ri-pencil-line",
          "aria-label": e.editLabel,
          "data-testid": "editable-title-edit",
          onClick: p
        }, null, 8, ["variant", "size", "aria-label"])) : k("", !0)
      ], 64))
    ], 6));
  }
}), Vc = /* @__PURE__ */ ot(cD, [["__scopeId", "data-v-b33d760d"]]), fD = { class: "flex flex-1 min-w-0 items-center gap-2" }, hD = { class: "flex-1 min-w-0 flex flex-col gap-0" }, bD = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, gD = { class: "flex flex-1 min-w-0 flex-col gap-0" }, mD = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, pD = {
  key: 0,
  class: "ml-auto flex min-w-0 flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing"
}, vD = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing-actions"
}, xD = {
  key: 0,
  class: "flex items-center gap-6",
  "data-testid": "list-item-stats"
}, yD = { class: "flex min-w-0 grow shrink basis-32 flex-col" }, kD = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-4 gap-y-3",
  "data-testid": "list-item-stats"
}, wD = {
  key: 1,
  class: "flex min-h-12.5 w-[153px] max-w-full shrink-0 flex-col justify-center gap-1.5",
  "data-testid": "list-item-progress"
}, CD = ["id"], SD = ["id"], $D = {
  key: 2,
  class: "flex shrink-0 items-center gap-4",
  "data-testid": "list-item-trailing-actions"
}, ID = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, TD = ["aria-label", "aria-pressed", "disabled"], LD = { class: "flex flex-1 min-w-0 flex-col gap-0" }, AD = {
  key: 1,
  class: "w-full min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
  "data-testid": "list-item-title"
}, ED = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, RD = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3.5",
  "data-testid": "list-item-trailing"
}, BD = ["aria-label", "aria-pressed", "disabled"], DD = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "ListItemCard",
  props: {
    type: { default: "default" },
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: void 0 },
    dragHandleLabel: { default: void 0 },
    grabbed: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    showEdit: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    saveLabel: { default: void 0 },
    maxlength: { default: void 0 },
    editError: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 },
    editInputWidth: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    progress: { default: void 0 },
    max: { default: 100 },
    progressLabel: { default: void 0 }
  },
  emits: ["rename", "grab", "grab-cancel", "select"],
  setup(e, { emit: n }) {
    const t = ["draggable-edit", "draggable-collapsed"], a = ["card-item", "draggable-edit"], l = e, r = n, o = Yt();
    let i = {};
    $x(() => {
      i = {};
    });
    const s = (D) => i[D] ?? (i[D] = o(D)), d = R(!1), u = m(() => t.includes(l.type)), f = m(
      () => l.type === "draggable-collapsed" ? {
        role: "button",
        tabindex: l.disabled ? void 0 : 0,
        "aria-pressed": l.selected || void 0,
        // The row IS the button here, so it carries the disabled state (other types' roots have a
        // role that supports none). Only set when disabled, so a forwarded attr is not clobbered.
        ...l.disabled ? { "aria-disabled": "true" } : {}
      } : {}
    ), b = m(() => !u.value || l.reorderable === !1 ? !1 : l.reorderable === !0 ? !0 : !l.disabled), h = {
      default: { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", shadow: !0 },
      "card-item": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-6", minHeight: "min-h-[74px]", shadow: !1 },
      "draggable-edit": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", minHeight: "min-h-[74px]", shadow: !0 },
      "draggable-collapsed": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-2", minHeight: "min-h-14", shadow: !0 },
      progression: {
        padding: "pt-[calc(--spacing(4.5)-1px)] pr-[calc(--spacing(5)-1px)] pb-[calc(--spacing(4.5)-1px)] pl-[calc(--spacing(6)-1px)]",
        gap: "gap-4",
        shadow: !0
      }
    }, p = Bv(() => {
      const D = h[l.type];
      return {
        padding: D.padding,
        gap: D.gap,
        minHeight: D.minHeight,
        // The draggable Figma variants drop the DS card shadow on hover and when disabled.
        restingClasses: D.shadow ? l.type === "progression" ? "shadow-(--blur-shadow-s)" : "shadow-(--blur-shadow-s) hover:shadow-none" : void 0,
        // The trailing zone wraps under the text only when it no longer fits beside a 12rem text
        // block (`basis-48` below; Figma has no narrow card), 12px below it. The drag rows of a
        // drawer (`default`) and the palette (`draggable-collapsed`) stay on one line.
        alwaysClasses: a.includes(l.type) ? "flex-wrap gap-y-3" : l.type === "progression" ? "flex-wrap justify-between gap-y-3" : void 0,
        disabled: l.disabled,
        // selected wins over the resting border (collapsed palette pick); grabbed is the
        // keyboard-grabbed accent ring (Rule n°4 feedback) — both are no-ops outside their own type.
        selected: l.selected,
        grabbed: l.grabbed
      };
    }), x = je(), y = je(), w = m(() => {
      var D;
      return ((D = l.progressLabel) == null ? void 0 : D.trim()) || void 0;
    }), $ = m(
      () => l.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    function S() {
      b.value && r("grab");
    }
    function L() {
      r("grab-cancel");
    }
    function T(D) {
      r("rename", D);
    }
    function E() {
      l.disabled || l.type !== "draggable-collapsed" || r("select");
    }
    function A(D) {
      l.type !== "draggable-collapsed" || l.disabled || (D.key === "Enter" || D.key === " ") && (D.preventDefault(), r("select"));
    }
    return (D, M) => (c(), g("div", Oe({ ...D.$attrs, ...f.value }, {
      class: I(p),
      onClick: E,
      onKeydown: A
    }), [
      e.type === "default" ? (c(), g(ce, { key: 0 }, [
        v("div", fD, [
          s("icon") || s("leading") ? (c(), g("div", {
            key: 0,
            class: C(["shrink-0 flex items-center", { "opacity-40": e.disabled }])
          }, [
            Ae(D.$slots, "leading", {}, () => [
              Ae(D.$slots, "icon")
            ])
          ], 2)) : k("", !0),
          v("div", hD, [
            v("p", {
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) w-full truncate", $.value])
            }, N(e.label), 3),
            e.subtitle ? (c(), g("p", {
              key: 0,
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) w-full", $.value])
            }, N(e.subtitle), 3)) : k("", !0)
          ])
        ]),
        Ae(D.$slots, "badge"),
        Ae(D.$slots, "actions")
      ], 64)) : e.type === "card-item" ? (c(), g(ce, { key: 1 }, [
        v("div", bD, [
          Ae(D.$slots, "leading"),
          v("div", gD, [
            re(ht, {
              text: e.label,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-title"
            }, null, 8, ["text"]),
            Ae(D.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), g("p", mD, N(e.subtitle), 1)) : k("", !0)
            ])
          ])
        ]),
        s("badge") || s("stats") || s("actions") ? (c(), g("div", pD, [
          Ae(D.$slots, "badge"),
          s("stats") || s("actions") ? (c(), g("div", vD, [
            s("stats") ? (c(), g("div", xD, [
              Ae(D.$slots, "stats")
            ])) : k("", !0),
            Ae(D.$slots, "actions")
          ])) : k("", !0)
        ])) : k("", !0)
      ], 64)) : e.type === "progression" ? (c(), g(ce, { key: 2 }, [
        v("div", yD, [
          re(ht, {
            text: e.label,
            "text-class": "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-heading)",
            "data-testid": "list-item-title"
          }, null, 8, ["text"])
        ]),
        s("stats") ? (c(), g("div", kD, [
          Ae(D.$slots, "stats")
        ])) : k("", !0),
        e.progress !== void 0 ? (c(), g("div", wD, [
          w.value ? (c(), g("span", {
            key: 0,
            id: I(x),
            class: "min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-s) font-(--weight-regular) text-(--text-text-black-default)",
            "data-testid": "list-item-progress-label"
          }, N(w.value), 9, CD)) : k("", !0),
          re(Gu, Oe({
            value: e.progress,
            max: e.max
          }, w.value ? { "aria-labelledby": `${I(y)} ${I(x)}` } : { ariaLabel: e.label }), null, 16, ["value", "max"]),
          w.value ? (c(), g("span", {
            key: 1,
            id: I(y),
            hidden: ""
          }, N(e.label), 9, SD)) : k("", !0)
        ])) : k("", !0),
        s("actions") ? (c(), g("div", $D, [
          Ae(D.$slots, "actions")
        ])) : k("", !0)
      ], 64)) : e.type === "draggable-edit" ? (c(), g(ce, { key: 3 }, [
        v("div", ID, [
          v("button", {
            type: "button",
            class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
              b.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
              e.grabbed ? "text-(--text-text-accent)" : ""
            ]]),
            "aria-label": e.dragHandleLabel,
            "aria-roledescription": "draggable",
            "aria-pressed": e.grabbed || void 0,
            disabled: e.disabled || !b.value,
            "data-testid": "list-item-drag-handle",
            onClick: S,
            onKeydown: ut(L, ["esc"])
          }, null, 42, TD),
          Ae(D.$slots, "leading"),
          v("div", LD, [
            e.editable ? (c(), H(Vc, {
              key: 0,
              "model-value": e.label,
              editable: !e.disabled,
              "show-pen": e.showEdit && !e.disabled,
              size: "sm",
              "pen-variant": "tertiary",
              maxlength: e.maxlength,
              error: e.editError,
              "auto-edit": e.autoEdit,
              "input-width": e.editInputWidth,
              "edit-label": e.editLabel ?? "",
              "save-label": e.saveLabel ?? "",
              class: "w-full min-w-0 min-h-8",
              onSave: T,
              onEditStart: M[0] || (M[0] = (F) => d.value = !0),
              onEditEnd: M[1] || (M[1] = (F) => d.value = !1)
            }, null, 8, ["model-value", "editable", "show-pen", "maxlength", "error", "auto-edit", "input-width", "edit-label", "save-label"])) : (c(), g("p", AD, N(e.label), 1)),
            Ae(D.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), g("p", ED, N(e.subtitle), 1)) : k("", !0)
            ])
          ])
        ]),
        !d.value && (s("badge") || s("actions")) ? (c(), g("div", RD, [
          Ae(D.$slots, "badge"),
          Ae(D.$slots, "actions")
        ])) : k("", !0)
      ], 64)) : (c(), g(ce, { key: 4 }, [
        v("button", {
          type: "button",
          class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
            b.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
            e.grabbed ? "text-(--text-text-accent)" : ""
          ]]),
          "aria-label": e.dragHandleLabel,
          "aria-roledescription": "draggable",
          "aria-pressed": e.grabbed || void 0,
          disabled: e.disabled || !b.value,
          "data-testid": "list-item-drag-handle",
          onClick: Ye(S, ["stop"]),
          onKeydown: ut(L, ["esc"])
        }, null, 42, BD),
        Ae(D.$slots, "leading"),
        v("span", {
          class: C(["flex-1 min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", e.disabled ? "text-(--text-text-disabled-strong)" : e.selected ? "text-(--text-text-accent)" : "text-(--text-text-body)"]),
          "data-testid": "list-item-label"
        }, N(e.label), 3),
        Ae(D.$slots, "badge"),
        Ae(D.$slots, "actions")
      ], 64))
    ], 16));
  }
}), MD = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "DraggableListItem",
  props: {
    reorderable: { type: Boolean, default: void 0 },
    type: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    dragHandleLabel: {},
    grabbed: { type: Boolean },
    editable: { type: Boolean },
    showEdit: { type: Boolean },
    editLabel: {},
    saveLabel: {},
    maxlength: {},
    editError: {},
    autoEdit: { type: Boolean },
    editInputWidth: {},
    selected: { type: Boolean },
    progress: {},
    max: {},
    progressLabel: {}
  },
  setup(e) {
    const n = e, t = Yt(), a = m(() => n.reorderable === !1 ? !1 : n.reorderable === !0 ? !0 : !n.disabled);
    return (l, r) => (c(), H(DD, Oe(l.$attrs, {
      label: n.label,
      subtitle: n.subtitle,
      disabled: n.disabled,
      draggable: a.value ? "true" : "false"
    }), ta({
      icon: xe(() => [
        v("i", {
          class: C(["ri-draggable text-(length:--icon-size-lg) leading-none select-none text-(--icons-icon-dark-default)", a.value ? "cursor-grab" : "opacity-40"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      _: 2
    }, [
      I(t)("badge") ? {
        name: "badge",
        fn: xe(() => [
          v("div", null, [
            Ae(l.$slots, "badge")
          ])
        ]),
        key: "0"
      } : void 0,
      I(t)("actions") ? {
        name: "actions",
        fn: xe(() => [
          Ae(l.$slots, "actions")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["label", "subtitle", "disabled", "draggable"]));
  }
}), zD = ["aria-level"], OD = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body-subtle)",
  "data-testid": "date-group-header-label"
}, uq = /* @__PURE__ */ ke({
  __name: "DateGroupHeader",
  props: {
    label: {},
    count: {},
    ariaLevel: { default: 3 },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      class: C([
        "flex items-center gap-2.5 rounded-md bg-(--background-background-white-tertiary) px-4 py-1",
        e.fullWidth ? "w-full" : "w-fit"
      ]),
      role: "heading",
      "aria-level": e.ariaLevel
    }, [
      v("span", OD, N(e.label), 1),
      re(ct, {
        theme: "gradient-light",
        size: "sm",
        "badge-style": "circle",
        "text-only": "",
        value: e.count,
        "data-testid": "date-group-header-count"
      }, null, 8, ["value"])
    ], 10, zD));
  }
}), PD = ["role", "aria-label", "aria-hidden"], Dv = /* @__PURE__ */ ke({
  __name: "AvatarGroup",
  props: {
    avatars: {},
    size: { default: "md" },
    max: { default: 4 },
    ariaLabel: { default: void 0 },
    ringClass: { default: "ring-(--border-border-white-full)" }
  },
  setup(e) {
    const n = e, t = m(() => n.avatars.slice(0, n.max)), a = m(() => Math.max(n.avatars.length - n.max, 0)), l = m(() => (n.ariaLabel ?? "").trim().length > 0), r = {
      sm: { item: "-ml-2 first:ml-0 ring-1", bubble: "h-6 w-6 text-(length:--size-2xs)" },
      md: { item: "-ml-3.5 first:ml-0 ring-2", bubble: "h-9 w-9 text-(length:--size-sm)" },
      lg: { item: "-ml-4 first:ml-0 ring-2", bubble: "h-11 w-11 text-(length:--size-m)" }
    };
    return (o, i) => (c(), g("div", {
      class: "flex items-center",
      role: l.value ? "img" : void 0,
      "aria-label": l.value ? e.ariaLabel : void 0,
      "aria-hidden": l.value ? void 0 : "true",
      "data-testid": "avatar-group"
    }, [
      (c(!0), g(ce, null, Re(t.value, (s, d) => (c(), H(Mt, {
        key: d,
        name: s.name,
        img: s.img,
        size: e.size,
        "avatar-style": "circle",
        presentational: !0,
        class: C([e.ringClass, r[e.size].item]),
        "data-testid": "avatar-group-avatar",
        "aria-hidden": "true"
      }, null, 8, ["name", "img", "size", "class"]))), 128)),
      a.value > 0 ? (c(), g("span", {
        key: 0,
        class: C(["flex shrink-0 items-center justify-center rounded-full bg-(--colors-indigo-100) font-(--weight-medium) text-(--icons-icon-dark-default)", [e.ringClass, r[e.size].item, r[e.size].bubble]]),
        "data-testid": "avatar-group-overflow",
        "aria-hidden": "true"
      }, "+" + N(a.value), 3)) : k("", !0)
    ], 8, PD));
  }
}), FD = { class: "flex grow shrink basis-64 min-w-0 flex-wrap items-center gap-5" }, VD = {
  class: "flex grow shrink basis-64 min-w-0 flex-col gap-1",
  "data-testid": "list-item-interaction-content"
}, ND = {
  class: "flex items-center gap-2",
  "data-testid": "list-item-interaction-header"
}, HD = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
  "data-testid": "list-item-interaction-date-time"
}, jD = {
  class: "flex min-w-0 flex-col gap-1.5",
  "data-testid": "list-item-interaction-body"
}, WD = {
  key: 0,
  class: "w-full min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, qD = {
  key: 1,
  class: "flex flex-col gap-1 rounded-(--border-border-radius-rounded-sm) border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) px-4 py-3 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-call-summary"
}, UD = {
  key: 0,
  class: "flex items-center gap-1.5"
}, GD = {
  class: "font-(--weight-medium)",
  "data-testid": "list-item-call-duration"
}, KD = {
  key: 1,
  class: "wrap-break-word font-(--weight-regular)",
  "data-testid": "list-item-call-summary-text"
}, YD = {
  key: 2,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-interaction-meta"
}, JD = {
  key: 3,
  class: "flex items-center gap-1",
  "data-testid": "list-item-person"
}, XD = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-person-name"
}, ZD = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-attachment-label"
}, QD = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3",
  "data-testid": "list-item-trailing-actions"
}, cq = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "InteractionListItem",
  props: {
    label: {},
    subtitle: { default: void 0 },
    cancelled: { type: Boolean, default: !1 },
    kind: { default: void 0 },
    typeLabel: { default: "" },
    date: { default: void 0 },
    time: { default: void 0 },
    dotTheme: { default: "green" },
    people: { default: void 0 },
    peopleLabel: { default: void 0 },
    attachmentLabel: { default: void 0 },
    durationLabel: { default: void 0 },
    summary: { default: void 0 },
    summaryBadgeLabel: { default: void 0 }
  },
  setup(e) {
    const n = {
      call: "ri-phone-fill",
      email: "ri-mail-line",
      "face-to-face": "ri-user-line",
      event: "ri-group-2-line",
      meeting: "ri-calendar-2-line"
    }, t = e, a = Yt(), l = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange",
      dark: "dark"
    }, r = m(() => l[t.dotTheme]), o = m(
      () => t.cancelled ? "text-(--text-text-disabled-strong) line-through" : "text-(--text-text-heading)"
    ), i = m(() => [t.date, t.time].filter(Boolean).join(" · ")), s = m(() => t.kind ? n[t.kind] : void 0);
    return $e(
      () => {
        var d;
        return [((d = t.people) == null ? void 0 : d.length) ?? 0, t.peopleLabel];
      },
      ([d, u]) => {
        d > 0 && !(u != null && u.trim()) && console.warn(
          "[InteractionListItem] `people` is set without `peopleLabel` — the avatar group has no accessible name for assistive tech (WCAG 1.1.1). Pass a pre-formatted `peopleLabel`."
        );
      },
      { immediate: !0 }
    ), (d, u) => {
      var f;
      return c(), g("div", Oe({
        class: "flex w-full min-w-64 flex-wrap items-start gap-4",
        "data-testid": "list-item-interaction-row"
      }, d.$attrs), [
        s.value ? (c(), H(Vt, {
          key: 0,
          size: "md",
          type: "square",
          variant: "outlined",
          color: e.cancelled ? "disabled" : "default",
          icon: s.value,
          class: "shrink-0"
        }, null, 8, ["color", "icon"])) : k("", !0),
        v("div", FD, [
          v("div", VD, [
            v("div", ND, [
              re(ct, {
                type: "with-dot",
                theme: r.value,
                label: e.typeLabel,
                size: "lg",
                "data-testid": "list-item-interaction-type-label"
              }, null, 8, ["theme", "label"]),
              Ae(d.$slots, "header-badges"),
              i.value ? (c(), g("span", HD, N(i.value), 1)) : k("", !0)
            ]),
            v("div", jD, [
              v("p", {
                class: C(["w-full min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", o.value]),
                "data-testid": "list-item-title"
              }, N(e.label), 3),
              e.subtitle ? (c(), g("p", WD, N(e.subtitle), 1)) : k("", !0),
              e.durationLabel || e.summary || e.summaryBadgeLabel ? (c(), g("div", qD, [
                e.durationLabel || e.summaryBadgeLabel ? (c(), g("div", UD, [
                  e.durationLabel ? (c(), g(ce, { key: 0 }, [
                    u[0] || (u[0] = v("i", {
                      class: "ri-timer-line shrink-0 leading-none",
                      "aria-hidden": "true"
                    }, null, -1)),
                    v("span", GD, N(e.durationLabel), 1)
                  ], 64)) : k("", !0),
                  e.summaryBadgeLabel ? (c(), H(ct, {
                    key: 1,
                    label: e.summaryBadgeLabel,
                    theme: "purple",
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1,
                    "data-testid": "list-item-call-summary-badge"
                  }, null, 8, ["label"])) : k("", !0)
                ])) : k("", !0),
                e.summary ? (c(), g("p", KD, N(e.summary), 1)) : k("", !0)
              ])) : k("", !0),
              I(a)("interaction-meta") ? (c(), g("div", YD, [
                Ae(d.$slots, "interaction-meta")
              ])) : k("", !0),
              (f = e.people) != null && f.length ? (c(), g("div", JD, [
                re(Dv, {
                  avatars: e.people,
                  "ring-class": "ring-(--background-background-white)",
                  size: "sm"
                }, null, 8, ["avatars"]),
                v("span", XD, N(e.peopleLabel), 1),
                e.attachmentLabel ? (c(), g(ce, { key: 0 }, [
                  u[1] || (u[1] = v("span", {
                    class: "text-(length:--size-m) font-(--weight-medium) text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, "·", -1)),
                  u[2] || (u[2] = v("i", {
                    class: "ri-attachment-2 shrink-0 text-(length:--size-sm) leading-none text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("span", ZD, N(e.attachmentLabel), 1)
                ], 64)) : k("", !0)
              ])) : k("", !0)
            ])
          ]),
          I(a)("cta") || I(a)("actions") ? (c(), g("div", QD, [
            Ae(d.$slots, "cta"),
            Ae(d.$slots, "actions")
          ])) : k("", !0)
        ])
      ], 16);
    };
  }
}), _D = {
  class: "flex flex-1 min-w-0 flex-col gap-2 py-3.5 pl-6 @[calc(44rem-25px)]/meeting:flex-row @[calc(44rem-25px)]/meeting:items-center @[calc(44rem-25px)]/meeting:gap-0 @[calc(44rem-25px)]/meeting:py-0 @[calc(44rem-25px)]/meeting:pl-0",
  "data-testid": "list-item-content-row"
}, eM = {
  class: "flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 @[calc(44rem-25px)]/meeting:contents",
  "data-testid": "list-item-time-meta"
}, tM = { class: "flex items-center self-stretch shrink-0" }, nM = {
  key: 0,
  class: "flex items-center self-stretch shrink-0 overflow-hidden @[calc(44rem-25px)]/meeting:px-5 @[calc(44rem-25px)]/meeting:w-[185px]",
  "data-testid": "list-item-meta-badge"
}, aM = { class: "flex flex-1 min-w-0 flex-col gap-0.5 @[calc(44rem-25px)]/meeting:basis-64 @[calc(44rem-25px)]/meeting:px-6 @[calc(44rem-25px)]/meeting:py-3.5" }, lM = { class: "flex w-full min-w-0 items-start gap-1.5" }, rM = ["aria-label"], oM = { class: "flex flex-wrap items-center gap-x-2 gap-y-1 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-start @[calc(44rem-25px)]/meeting:gap-1 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-2" }, iM = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, sM = {
  key: 0,
  class: "flex min-w-min flex-wrap items-center justify-end gap-x-4 gap-y-3 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-end @[calc(44rem-25px)]/meeting:gap-3 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-4",
  "data-testid": "list-item-trailing-actions"
}, dM = { class: "flex flex-1 min-w-0 flex-col gap-3 py-4" }, uM = { class: "flex flex-col gap-0.5 min-w-0" }, cM = { class: "flex items-center justify-between gap-2" }, fM = { class: "flex w-full min-w-0 items-start gap-1.5" }, hM = ["aria-label"], bM = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, gM = {
  key: 1,
  class: "flex items-start gap-3",
  "data-testid": "list-item-cta"
}, fq = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "MeetingListItem",
  props: {
    layout: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    time: { default: void 0 },
    statusTheme: { default: "green" },
    statusLabel: { default: "" },
    struckThrough: { type: Boolean, default: !1 },
    metaBadge: { default: void 0 },
    personName: { default: void 0 },
    personAvatarUrl: { default: void 0 },
    date: { default: void 0 },
    urgencyLabel: { default: void 0 },
    titleIcon: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Yt(), a = {
      long: { padding: "pl-0 pr-[calc(--spacing(6)-1px)] py-0", gap: "gap-6", minHeight: "min-h-[100px]" },
      short: { padding: "pl-0 pr-[calc(--spacing(4)-1px)] py-0", gap: "gap-4" }
    }, l = Bv(() => {
      const f = a[n.layout];
      return {
        padding: f.padding,
        gap: f.gap,
        minHeight: f.minHeight,
        disabled: n.disabled,
        border: n.border,
        // Only Long queries its own width; Short keeps its content-based width.
        alwaysClasses: `overflow-hidden min-w-64 ${n.layout === "long" ? "@container/meeting" : ""}`,
        restingClasses: "shadow-(--blur-shadow-s)"
      };
    }), r = m(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), o = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange"
    }, i = {
      green: "bg-(--components-badge-background-badge-green-strong-bg)",
      active: "bg-(--components-badge-background-badge-indigo-strong-bg)",
      red: "bg-(--components-badge-background-badge-error-strong-bg)",
      disabled: "bg-(--components-badge-background-badge-neutral-strong-bg)",
      orange: "bg-(--components-badge-background-badge-orange-strong-bg)"
    }, s = m(() => o[n.statusTheme]), d = m(() => i[n.statusTheme]), u = m(() => [n.date, n.time].filter(Boolean).join(" · "));
    return (f, b) => (c(), g("div", Oe(f.$attrs, { class: I(l) }), [
      e.layout === "long" ? (c(), g(ce, { key: 0 }, [
        v("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        v("div", _D, [
          v("div", eM, [
            v("div", tM, [
              v("p", {
                class: C(["whitespace-nowrap text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", r.value]),
                "data-testid": "list-item-time"
              }, N(e.time), 3)
            ]),
            e.metaBadge ? (c(), g("div", nM, [
              re(ct, {
                label: e.metaBadge.label,
                theme: e.metaBadge.theme ?? "cyan",
                size: "sm",
                truncate: "",
                "show-left-icon": !1,
                "show-close-icon": !1
              }, null, 8, ["label", "theme"])
            ])) : k("", !0)
          ]),
          v("div", aM, [
            re(ct, {
              type: "with-dot",
              theme: s.value,
              label: e.statusLabel,
              size: "sm",
              class: "self-start",
              "data-testid": "list-item-status-badge"
            }, null, 8, ["theme", "label"]),
            v("div", lM, [
              e.titleIcon ? (c(), g("i", {
                key: 0,
                class: C([[e.titleIcon.icon, r.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, rM)) : k("", !0),
              re(ht, {
                text: e.label,
                lines: 2,
                "text-class": ["text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", r.value, e.struckThrough ? "line-through" : ""].join(" "),
                "data-testid": "list-item-title"
              }, null, 8, ["text", "text-class"])
            ]),
            v("div", oM, [
              e.subtitle ? (c(), g("p", {
                key: 0,
                class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l)", r.value]),
                "data-testid": "list-item-subtitle"
              }, N(e.subtitle), 3)) : k("", !0),
              e.personName ? (c(), g("div", iM, [
                re(Mt, {
                  name: e.personName,
                  img: e.personAvatarUrl,
                  size: "sm",
                  presentational: !0,
                  class: C({ "opacity-70": e.disabled })
                }, null, 8, ["name", "img", "class"]),
                v("span", {
                  class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", r.value])
                }, N(e.personName), 3)
              ])) : k("", !0)
            ])
          ]),
          I(t)("cta") || I(t)("actions") ? (c(), g("div", sM, [
            Ae(f.$slots, "cta"),
            Ae(f.$slots, "actions")
          ])) : k("", !0)
        ])
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        v("div", dM, [
          v("div", uM, [
            v("div", cM, [
              v("p", {
                class: C(["whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", r.value]),
                "data-testid": "list-item-date-time"
              }, N(u.value), 3),
              re(ct, {
                type: "with-dot",
                theme: s.value,
                label: e.statusLabel,
                size: "sm",
                "data-testid": "list-item-status-badge"
              }, null, 8, ["theme", "label"])
            ]),
            v("div", fM, [
              e.titleIcon ? (c(), g("i", {
                key: 0,
                class: C([[e.titleIcon.icon, r.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, hM)) : k("", !0),
              v("p", {
                class: C(["w-full min-w-0 break-words text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", [r.value, e.struckThrough ? "line-through" : ""]]),
                "data-testid": "list-item-title"
              }, N(e.label), 3)
            ]),
            e.subtitle ? (c(), g("p", {
              key: 0,
              class: C(["w-full min-w-0 break-words text-(length:--size-m) leading-(--line-height-l)", r.value]),
              "data-testid": "list-item-subtitle"
            }, N(e.subtitle), 3)) : k("", !0),
            e.personName ? (c(), g("div", bM, [
              re(Mt, {
                name: e.personName,
                img: e.personAvatarUrl,
                size: "sm",
                presentational: !0,
                class: C({ "opacity-70": e.disabled })
              }, null, 8, ["name", "img", "class"]),
              v("span", {
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", r.value])
              }, N(e.personName), 3)
            ])) : k("", !0)
          ]),
          e.urgencyLabel ? (c(), H(ct, {
            key: 0,
            theme: "red",
            size: "xs",
            label: e.urgencyLabel,
            "show-close-icon": !1,
            "data-testid": "list-item-urgency-badge",
            "left-icon": "ri-alert-line"
          }, null, 8, ["label"])) : k("", !0),
          I(t)("cta") ? (c(), g("div", gM, [
            Ae(f.$slots, "cta")
          ])) : k("", !0)
        ])
      ], 64))
    ], 16));
  }
}), mM = {
  class: "flex min-w-0 flex-col gap-3",
  "data-testid": "list-item-accordion"
}, pM = { class: "border-b border-solid border-(--border-border-base-soft) pb-3" }, vM = ["aria-expanded", "aria-controls"], xM = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, yM = { class: "flex shrink-0 items-center gap-1.5" }, kM = {
  class: "flex size-8 items-center justify-center",
  "aria-hidden": "true"
}, wM = ["id", "hidden"], hq = /* @__PURE__ */ ke({
  __name: "ListItemAccordion",
  props: /* @__PURE__ */ $d({
    title: {},
    icon: { default: void 0 },
    count: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const n = Gb(e, "open"), t = je(), a = R(null), l = R(!1), r = R(!1), o = m(() => r.value ? !1 : l.value ? !0 : void 0);
    function i(u) {
      try {
        l.value = u.target.matches(":focus-visible");
      } catch {
        l.value = !0;
      }
    }
    function s() {
      l.value = !1, r.value = !1;
    }
    function d(u) {
      var f;
      u.key !== "Escape" || r.value || !l.value || !((f = a.value) != null && f.isTruncated) || (u.stopPropagation(), u.preventDefault(), r.value = !0);
    }
    return (u, f) => (c(), g("div", mM, [
      v("div", pM, [
        v("button", {
          type: "button",
          class: "flex h-8 w-full min-w-0 cursor-pointer items-center justify-between gap-1.5 rounded-(--border-border-radius-rounded-xs) border-0 bg-transparent p-0 text-left focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-expanded": n.value,
          "aria-controls": I(t),
          "data-testid": "list-item-accordion-header",
          onClick: f[0] || (f[0] = (b) => n.value = !n.value),
          onFocus: i,
          onBlur: s,
          onKeydown: d
        }, [
          v("span", xM, [
            e.icon ? (c(), g("i", {
              key: 0,
              class: C([e.icon, "shrink-0 text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
              "aria-hidden": "true",
              "data-testid": "list-item-accordion-icon"
            }, null, 2)) : k("", !0),
            re(ht, {
              ref_key: "titleRef",
              ref: a,
              as: "span",
              class: "min-w-0",
              text: e.title,
              focusable: !1,
              open: o.value,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-accordion-title"
            }, null, 8, ["text", "open"])
          ]),
          v("span", yM, [
            e.count !== void 0 ? (c(), H(ct, {
              key: 0,
              label: String(e.count),
              theme: "gradient-light",
              size: "lg",
              "badge-style": "circle",
              "text-only": "",
              "data-testid": "list-item-accordion-count"
            }, null, 8, ["label"])) : k("", !0),
            v("span", kM, [
              v("i", {
                class: C([n.value ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line", "text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
                "data-testid": "list-item-accordion-chevron"
              }, null, 2)
            ])
          ])
        ], 40, vM)
      ]),
      v("ul", {
        id: I(t),
        role: "list",
        class: "m-0 list-none flex-col gap-3 p-0 [&:not([hidden])]:flex",
        hidden: !n.value,
        "data-testid": "list-item-accordion-body"
      }, [
        Ae(u.$slots, "default")
      ], 8, wM)
    ]));
  }
}), CM = {
  class: "m-0 min-w-0 list-none border-b border-solid border-(--border-border-base-soft) pb-3",
  "data-testid": "list-item-accordion-row"
}, SM = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, bq = /* @__PURE__ */ ke({
  __name: "ListItemAccordionRow",
  props: {
    label: {},
    value: { default: void 0 },
    variant: { default: "default" },
    icon: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      default: {
        row: "min-h-5 pl-6",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: ""
      },
      header: {
        row: "min-h-5",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: "size-(--icon-size-sm) text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      title: {
        row: "min-h-6",
        label: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default)",
        icon: "size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    };
    return (a, l) => (c(), g("li", CM, [
      v("div", {
        class: C(["flex min-w-0 items-center justify-between gap-1.5", t[n.variant].row])
      }, [
        v("div", SM, [
          e.icon && e.variant !== "default" ? (c(), g("i", {
            key: 0,
            class: C([e.icon, t[n.variant].icon, "inline-flex shrink-0 items-center justify-center text-(--icons-icon-dark-default)"]),
            "aria-hidden": "true",
            "data-testid": "list-item-accordion-row-icon"
          }, null, 2)) : k("", !0),
          re(ht, {
            class: "min-w-0",
            text: e.label,
            "text-class": t[n.variant].label,
            "data-testid": "list-item-accordion-row-label"
          }, null, 8, ["text", "text-class"])
        ]),
        e.value !== void 0 ? (c(), g("span", {
          key: 0,
          class: C(["shrink-0", t[n.variant].value]),
          "data-testid": "list-item-accordion-row-value"
        }, N(e.value), 3)) : k("", !0)
      ], 2)
    ]));
  }
}), $M = iD, IM = { class: "flex w-full min-w-0 items-start gap-2" }, TM = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, LM = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col"
}, AM = { class: "flex min-w-0 items-center gap-2" }, EM = { class: "flex min-w-0 flex-1 flex-col gap-2" }, RM = {
  key: 0,
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, BM = {
  key: 1,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
}, DM = { class: "accordion-content-inner" }, MM = { class: "min-w-0 pt-2" }, zM = /* @__PURE__ */ ke({
  __name: "AlertDuplicatesList",
  props: {
    duplicates: {},
    heading: {},
    message: {},
    icon: {},
    iconTint: {},
    listBorderClass: {},
    listDividerVar: {},
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    labels: {}
  },
  emits: ["update:open", "remove"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: l, toggle: r, triggerProps: o, panelProps: i, panelClasses: s, onTransitionEnd: d } = Jb({
      open: () => t.open,
      defaultOpen: () => t.defaultOpen,
      onOpenChange: ($) => a("update:open", $)
    }), u = R(null), f = R(null), b = /* @__PURE__ */ new Map();
    function h($, S) {
      S ? b.set($, S) : b.delete($);
    }
    const p = m(() => t.labels.toggleButton ?? (t.heading || t.message || "Show duplicates"));
    function x($) {
      var L, T;
      const S = $.helperText ? `${$.label}, ${$.helperText}` : $.label;
      return ((T = (L = t.labels).removeDuplicate) == null ? void 0 : T.call(L, $)) ?? `Remove ${S}`;
    }
    $e(l, ($) => {
      var S, L;
      !$ && ((S = f.value) != null && S.contains(document.activeElement)) && ((L = u.value) == null || L.$el.focus());
    });
    let y = null;
    function w($, S) {
      y = { id: $.id, index: S }, a("remove", $);
    }
    return $e(
      () => t.duplicates.map(($) => $.id),
      async ($, S) => {
        var M;
        const L = y;
        if (!L) return;
        const T = !$.includes(L.id);
        if (!T && $.length >= S.length || (y = null, !T)) return;
        await Ue();
        const E = document.activeElement;
        if (E && E !== document.body && E.isConnected) return;
        const A = $[Math.min(L.index, $.length - 1)], D = A !== void 0 ? b.get(A) : void 0;
        D != null && D.focusAction("secondary") || (M = u.value) == null || M.$el.focus();
      }
    ), ($, S) => (c(), g("div", IM, [
      v("div", TM, [
        v("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      v("div", LM, [
        v("div", AM, [
          v("div", EM, [
            e.heading ? (c(), g("p", RM, N(e.heading), 1)) : k("", !0),
            e.message ? (c(), g("p", BM, N(e.message), 1)) : k("", !0)
          ]),
          re(I(Be), Oe({
            ref_key: "toggleRef",
            ref: u
          }, I(o), {
            "data-testid": "alert-duplicates-toggle",
            variant: "tertiary",
            size: "md",
            "icon-only": "",
            "icon-left": I(l) ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line",
            "aria-label": p.value,
            class: "shrink-0",
            onClick: I(r)
          }), null, 16, ["icon-left", "aria-label", "onClick"])
        ]),
        v("div", Oe({
          ref_key: "panelRef",
          ref: f
        }, I(i), {
          class: I(s),
          "data-testid": "alert-duplicates-panel",
          onTransitionend: S[0] || (S[0] = //@ts-ignore
          (...L) => I(d) && I(d)(...L))
        }), [
          v("div", DM, [
            v("div", MM, [
              v("div", {
                "data-testid": "alert-duplicates-list",
                class: C(["min-w-0 border-y-(length:--border-border-width-border) border-solid py-3", e.listBorderClass])
              }, [
                re(I(sD), {
                  divider: "",
                  "divider-color": `var(${e.listDividerVar})`
                }, {
                  default: xe(() => [
                    (c(!0), g(ce, null, Re(e.duplicates, (L, T) => (c(), H(I($M), {
                      key: L.id,
                      ref_for: !0,
                      ref: (E) => h(L.id, E),
                      type: "avatar-text-badge",
                      label: L.label,
                      "helper-text": L.helperText,
                      "label-badge": L.badge ? { label: L.badge, theme: "orange" } : void 0,
                      "secondary-action": {
                        label: x(L),
                        icon: "ri-delete-bin-line",
                        testId: "alert-duplicate-remove",
                        onClick: () => w(L, T)
                      }
                    }, null, 8, ["label", "helper-text", "label-badge", "secondary-action"]))), 128))
                  ]),
                  _: 1
                }, 8, ["divider-color"])
              ], 2)
            ])
          ])
        ], 16)
      ])
    ]));
  }
}), OM = { class: "flex w-full min-w-0 items-start gap-2" }, PM = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, FM = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, VM = {
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, NM = {
  key: 0,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
}, HM = {
  key: 1,
  "data-testid": "alert-error-links",
  class: "flex flex-col gap-1"
}, jM = /* @__PURE__ */ ke({
  __name: "AlertErrorSummary",
  props: {
    errors: {},
    message: {},
    showLinks: { type: Boolean },
    icon: {},
    iconTint: {},
    labels: {}
  },
  setup(e) {
    const n = e, t = m(() => {
      var r, o;
      const l = n.errors.length;
      return ((o = (r = n.labels).errorSummaryHeading) == null ? void 0 : o.call(r, l)) ?? (l === 1 ? "1 error" : `${l} errors`);
    });
    function a(l, r) {
      const o = document.getElementById(r);
      o && (l.preventDefault(), o.scrollIntoView({ block: "center" }), o.focus({ preventScroll: !0 }));
    }
    return (l, r) => (c(), g("div", OM, [
      v("div", PM, [
        v("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      v("div", FM, [
        v("h2", VM, N(t.value), 1),
        e.message ? (c(), g("p", NM, N(e.message), 1)) : k("", !0),
        e.showLinks ? (c(), g("ul", HM, [
          (c(!0), g(ce, null, Re(e.errors, (o) => (c(), g("li", {
            key: o.fieldId
          }, [
            re(I(In), {
              as: "a",
              href: `#${o.fieldId}`,
              onClick: (i) => a(i, o.fieldId)
            }, {
              default: xe(() => [
                et(N(o.message), 1)
              ]),
              _: 2
            }, 1032, ["href", "onClick"])
          ]))), 128))
        ])) : k("", !0)
      ])
    ]));
  }
}), WM = {
  "data-testid": "alert-pill-link",
  class: "flex min-w-0 flex-1 items-center gap-0.5"
}, qM = {
  key: 4,
  "data-testid": "alert-inline-row",
  class: "flex w-full items-start gap-2"
}, UM = { class: "flex-1 flex flex-col gap-3" }, GM = {
  "data-testid": "alert-text-group",
  class: "flex flex-col gap-1"
}, KM = {
  key: 5,
  "data-testid": "alert-compact-row",
  class: "flex w-full items-start gap-2"
}, YM = { class: "flex-1 flex flex-col gap-2" }, JM = { class: "flex flex-col gap-1" }, XM = {
  key: 1,
  class: "flex items-center gap-1"
}, ZM = {
  key: 0,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, QM = {
  key: 1,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, _M = {
  key: 2,
  "data-testid": "alert-right-column",
  class: "flex flex-col items-end justify-center gap-2 shrink-0"
}, ub = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", ez = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", cb = "text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", Kl = /* @__PURE__ */ ke({
  __name: "Alert",
  props: /* @__PURE__ */ $d({
    color: { default: "success" },
    surface: { default: "card" },
    layout: { default: "inline" },
    heading: { default: void 0 },
    message: { default: "" },
    closable: { type: Boolean, default: !1 },
    percentage: { default: void 0 },
    buttons: { default: () => [] },
    buttonsPosition: { default: "bottom" },
    compact: { type: Boolean, default: !1 },
    href: { default: void 0 },
    optionalIcon: { default: void 0 },
    checkbox: { default: void 0 },
    duplicates: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    errors: { default: void 0 },
    labels: { default: () => ({}) }
  }, {
    checked: { type: Boolean, default: !1 },
    checkedModifiers: {}
  }),
  emits: /* @__PURE__ */ $d(["close", "navigate", "update:open", "remove"], ["update:checked"]),
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = Gb(e, "checked"), o = R(!1), i = {
      success: {
        bg: "bg-(--background-background-success)",
        borderClass: "border-(--border-border-success)",
        borderTopClass: "border-(--border-border-success)",
        pillHoverBorderClass: "hover:border-(--background-background-success)",
        icon: "ri-checkbox-circle-line",
        iconTint: "text-(--icons-icon-success)",
        badgeTheme: "green",
        listBorderClass: "border-(--border-border-success-sublte)",
        listDividerVar: "--border-border-success-sublte"
      },
      danger: {
        bg: "bg-(--background-background-error)",
        borderClass: "border-(--border-border-error-subtle)",
        borderTopClass: "border-(--border-border-error-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-error)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-error)",
        badgeTheme: "red",
        listBorderClass: "border-(--border-border-error-strong)",
        listDividerVar: "--border-border-error-strong"
      },
      warning: {
        bg: "bg-(--background-background-warning)",
        borderClass: "border-(--border-border-warning-subtle)",
        borderTopClass: "border-(--border-border-warning)",
        pillHoverBorderClass: "hover:border-(--background-background-warning)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-warning)",
        badgeTheme: "orange",
        listBorderClass: "border-(--border-border-warning)",
        listDividerVar: "--border-border-warning"
      },
      info: {
        bg: "bg-(--background-background-info)",
        borderClass: "border-(--border-border-info-subtle)",
        borderTopClass: "border-(--border-border-info-subtle)",
        pillHoverBorderClass: "hover:border-(--background-background-info)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-info)",
        badgeTheme: "indigo",
        listBorderClass: "border-(--border-border-info-strong)",
        listDividerVar: "--border-border-info-strong"
      },
      default: {
        bg: "bg-(--background-background-white)",
        borderClass: "border-(--border-border-base-medium)",
        borderTopClass: "border-(--border-border-base-medium)",
        pillHoverBorderClass: "hover:border-(--background-background-white)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-dark-default)",
        badgeTheme: "neutral",
        listBorderClass: "border-(--border-border-base)",
        listDividerVar: "--border-border-base"
      },
      ia: {
        bg: "bg-(--background-background-ia)",
        borderClass: "border-(--border-border-ia)",
        borderTopClass: "border-(--colors-border-ia-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-ia)",
        icon: "ri-magic-line",
        iconTint: "text-(--icons-icon-ia)",
        badgeTheme: "purple",
        listBorderClass: "border-(--border-border-ia)",
        listDividerVar: "--border-border-ia"
      }
    }, s = m(() => {
      var z;
      return i[(z = a.errors) != null && z.length ? "danger" : a.color];
    }), d = m(() => s.value.badgeTheme), u = m(
      () => a.color === "danger" ? { role: "alert", ariaLive: "assertive", ariaAtomic: "true" } : { role: "status", ariaLive: "polite", ariaAtomic: void 0 }
    ), f = m(() => a.surface === "pill"), b = m(() => {
      var z;
      return (((z = a.errors) == null ? void 0 : z.length) ?? 0) > 10;
    }), h = m(() => f.value ? a.href ? "a" : "button" : "div"), p = m(() => {
      var z;
      return f.value ? a.href ? { href: a.href } : { type: "button" } : a.duplicates ? {} : (z = a.errors) != null && z.length ? { tabindex: -1, role: "group" } : {
        role: u.value.role,
        "aria-live": u.value.ariaLive,
        "aria-atomic": u.value.ariaAtomic
      };
    }), x = m(() => a.surface === "pill" ? "rounded-(--border-border-radius-rounded-full) border-(length:--border-border-width-border) border-solid flex-row items-center gap-2 py-[calc(--spacing(1)-1px)] pr-[calc(--spacing(2)-1px)] pl-[calc(--spacing(1)-1px)] w-full" : a.surface === "borderTop" ? "rounded-none border-t-(length:--border-border-width-border-lg) border-solid flex-col items-start gap-4 px-4 pb-4 pt-[calc(--spacing(4)-4px)] w-full" : "rounded-(--border-border-radius-rounded-l) border-(length:--border-border-width-border) border-solid flex-col items-start gap-4 p-[calc(--spacing(4)-1px)] w-full"), y = m(() => [
      b.value ? "sticky top-0 z-10 max-h-[40vh] overflow-y-auto" : "relative",
      "box-border flex min-w-64 text-left font-inter transition-all duration-300",
      s.value.bg,
      a.surface === "borderTop" ? s.value.borderTopClass : s.value.borderClass,
      "text-(--text-text-heading)",
      x.value,
      f.value ? ["cursor-pointer", "transition-colors", s.value.pillHoverBorderClass] : ""
    ]), w = m(() => a.percentage !== void 0 || a.layout === "stacked" && a.buttonsPosition === "bottom" ? "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)" : "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"), $ = m(() => !!a.heading && a.surface !== "borderTop"), S = m(
      () => a.surface === "borderTop" ? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)" : ub
    ), L = m(
      () => a.closable && a.percentage === void 0 && !f.value && !a.compact
    ), T = m(
      () => a.buttonsPosition === "right" && (L.value || a.buttons.length > 0)
    ), E = m(
      () => a.buttonsPosition === "right" && (!a.message || a.buttons.length > 0 && a.buttons.every((z) => z.variant === "tertiary"))
    ), A = m(
      () => !!a.checkbox && !f.value && !a.compact && !a.heading && !a.message
    ), D = m(() => a.percentage !== void 0), M = m(() => {
      var z;
      return ((z = a.labels) == null ? void 0 : z.closeButton) ?? "Dismiss alert";
    });
    function F() {
      o.value = !0, l("close");
    }
    function X() {
      l("navigate");
    }
    function _(z) {
      var P;
      (P = z.onClick) == null || P.call(z);
    }
    function Y(z) {
      return {
        as: z.href ? "a" : "button",
        href: z.href,
        ariaLabel: z.ariaLabel,
        iconLeft: z.iconPosition !== "right" ? z.icon : void 0,
        iconRight: z.iconPosition === "right" ? z.icon : void 0,
        size: "s",
        onClick: () => _(z)
      };
    }
    function B(z) {
      return {
        label: z.label,
        variant: z.variant ?? (a.buttonsPosition === "right" ? "primary" : "secondary"),
        as: z.href ? "a" : "button",
        href: z.href,
        // Passed as a literal HTML attribute key, not a declared Button prop —
        // Button.vue never declares `ariaLabel`, so this lands in Button's
        // $attrs and Vue's default attrs inheritance forwards it straight to
        // the root <button>/<a> element, overriding nothing else. Declaring a
        // real `ariaLabel` prop on Button.vue would close the automatic $attrs
        // fallthrough for that attribute name for every consumer in the
        // monorepo (many icon-only Button call sites rely on a raw, undeclared
        // :aria-label falling through) — see Refs: #OP-5881 fix commit.
        "aria-label": z.ariaLabel,
        iconLeft: z.iconPosition !== "right" ? z.icon : void 0,
        iconRight: z.iconPosition === "right" ? z.icon : void 0,
        size: "xs",
        loading: z.loading,
        onClick: () => _(z)
      };
    }
    const W = R(null);
    n({
      /** Moves focus to the Alert; only the error summary (`errors`) can take it. */
      focus: () => {
        var z;
        return (z = W.value) == null ? void 0 : z.focus();
      }
    });
    function U() {
      f.value && !a.href && X();
    }
    return (z, P) => o.value ? k("", !0) : (c(), H(lt(h.value), Oe({
      key: 0,
      ref_key: "rootRef",
      ref: W
    }, p.value, { class: y.value }, Ml(f.value ? { click: U } : {})), {
      default: xe(() => {
        var K;
        return [
          A.value && !z.$slots.body ? (c(), H($n, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": P[0] || (P[0] = (j) => r.value = j),
            label: e.checkbox.label,
            "label-wrap": ""
          }, null, 8, ["modelValue", "label"])) : f.value ? (c(), g(ce, { key: 1 }, [
            re(I(ct), {
              "data-testid": "alert-badge",
              label: e.heading,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "h-5! min-h-5! min-w-0! max-w-1/2 rounded-(--border-border-radius-rounded-full)! px-2! py-0! [&>span>span]:min-w-0 [&>span>span]:truncate"
            }, null, 8, ["label", "theme"]),
            v("span", WM, [
              e.message ? (c(), g("span", {
                key: 0,
                "data-testid": "alert-message",
                class: C([w.value, "min-w-0 truncate"])
              }, N(e.message), 3)) : k("", !0),
              P[5] || (P[5] = v("i", {
                class: "ri-arrow-right-line inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l) shrink-0",
                "aria-hidden": "true"
              }, null, -1))
            ])
          ], 64)) : e.duplicates ? (c(), H(zM, {
            key: 2,
            duplicates: e.duplicates,
            heading: e.heading,
            message: e.message,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            "list-border-class": s.value.listBorderClass,
            "list-divider-var": s.value.listDividerVar,
            open: e.open,
            "default-open": e.defaultOpen,
            labels: e.labels,
            "onUpdate:open": P[1] || (P[1] = (j) => l("update:open", j)),
            onRemove: P[2] || (P[2] = (j) => l("remove", j))
          }, null, 8, ["duplicates", "heading", "message", "icon", "icon-tint", "list-border-class", "list-divider-var", "open", "default-open", "labels"])) : (K = e.errors) != null && K.length ? (c(), H(jM, {
            key: 3,
            errors: e.errors,
            message: e.message,
            "show-links": b.value,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            labels: e.labels
          }, null, 8, ["errors", "message", "show-links", "icon", "icon-tint", "labels"])) : e.layout === "inline" ? (c(), g("div", qM, [
            v("div", {
              "data-testid": "alert-icon-column",
              class: C(["flex items-center shrink-0", $.value ? "py-1" : "py-0.5"])
            }, [
              v("i", {
                class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                "aria-hidden": "true"
              }, null, 2)
            ], 2),
            v("div", UM, [
              v("div", GM, [
                e.heading ? (c(), g("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(S.value)
                }, N(e.heading), 3)) : k("", !0),
                e.message ? (c(), g("p", {
                  key: 1,
                  "data-testid": "alert-message",
                  class: C(w.value)
                }, N(e.message), 3)) : k("", !0)
              ]),
              e.checkbox ? (c(), H($n, {
                key: 0,
                modelValue: r.value,
                "onUpdate:modelValue": P[3] || (P[3] = (j) => r.value = j),
                label: e.checkbox.label,
                "label-wrap": ""
              }, null, 8, ["modelValue", "label"])) : k("", !0)
            ]),
            L.value ? (c(), H(I(Be), {
              key: 0,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": M.value,
              class: C(["-mx-2 shrink-0", $.value ? "-my-1" : "-my-1.5"]),
              onClick: F
            }, null, 8, ["aria-label", "class"])) : k("", !0)
          ])) : e.compact ? (c(), g("div", KM, [
            D.value ? (c(), H(I(ct), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : k("", !0),
            v("div", YM, [
              v("div", JM, [
                e.heading ? (c(), g("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(ez)
                }, N(e.heading), 1)) : k("", !0),
                e.optionalIcon ? (c(), g("div", XM, [
                  Ae(z.$slots, "body", {}, () => [
                    e.message ? (c(), g("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(cb)
                    }, N(e.message), 1)) : k("", !0)
                  ]),
                  re(I(Vt), {
                    icon: e.optionalIcon,
                    color: "yellow",
                    size: "xs",
                    type: "square",
                    variant: "outlined"
                  }, null, 8, ["icon"])
                ])) : Ae(z.$slots, "body", { key: 2 }, () => [
                  e.message ? (c(), g("p", {
                    key: 0,
                    "data-testid": "alert-message",
                    class: C(cb)
                  }, N(e.message), 1)) : k("", !0)
                ])
              ]),
              e.buttons.length ? (c(), g("div", ZM, [
                (c(!0), g(ce, null, Re(e.buttons, (j, G) => (c(), g(ce, { key: G }, [
                  j.component === "link" ? (c(), H(I(In), Oe({
                    key: 0,
                    ref_for: !0
                  }, Y(j)), {
                    default: xe(() => [
                      et(N(j.label), 1)
                    ]),
                    _: 2
                  }, 1040)) : (c(), H(I(Be), Oe({
                    key: 1,
                    ref_for: !0
                  }, B(j)), null, 16))
                ], 64))), 128))
              ])) : k("", !0)
            ])
          ])) : (c(), g("div", {
            key: 6,
            "data-testid": "alert-main-row",
            class: C(["flex w-full", [
              E.value ? "items-center" : "items-start",
              D.value ? "gap-1 ps-5" : "gap-2 ps-6",
              { "flex-wrap": T.value }
            ]])
          }, [
            v("div", {
              class: C(["relative flex min-h-6 min-w-0", T.value ? "grow basis-40" : "flex-1"])
            }, [
              v("div", {
                "data-testid": "alert-icon-column",
                class: C(["absolute top-0 flex items-start py-1", D.value ? "-start-5" : "-start-6"])
              }, [
                v("i", {
                  class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 2),
              v("div", {
                "data-testid": "alert-text-column",
                class: C(["flex min-w-0 flex-1 flex-col", e.checkbox ? "gap-3" : "gap-2"])
              }, [
                v("div", {
                  "data-testid": "alert-text-group",
                  class: C(e.checkbox ? "flex flex-col gap-1" : "contents")
                }, [
                  e.heading ? (c(), g("p", {
                    key: 0,
                    "data-testid": "alert-heading",
                    class: C(ub)
                  }, N(e.heading), 1)) : k("", !0),
                  Ae(z.$slots, "body", {}, () => [
                    e.message ? (c(), g("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(w.value)
                    }, N(e.message), 3)) : k("", !0)
                  ])
                ], 2),
                e.checkbox ? (c(), H($n, {
                  key: 0,
                  modelValue: r.value,
                  "onUpdate:modelValue": P[4] || (P[4] = (j) => r.value = j),
                  label: e.checkbox.label,
                  "label-wrap": ""
                }, null, 8, ["modelValue", "label"])) : k("", !0),
                e.buttons.length && e.buttonsPosition === "bottom" ? (c(), g("div", QM, [
                  (c(!0), g(ce, null, Re(e.buttons, (j, G) => (c(), g(ce, { key: G }, [
                    j.component === "link" ? (c(), H(I(In), Oe({
                      key: 0,
                      ref_for: !0
                    }, Y(j)), {
                      default: xe(() => [
                        et(N(j.label), 1)
                      ]),
                      _: 2
                    }, 1040)) : (c(), H(I(Be), Oe({
                      key: 1,
                      ref_for: !0
                    }, B(j)), null, 16))
                  ], 64))), 128))
                ])) : k("", !0)
              ], 2)
            ], 2),
            D.value ? (c(), H(I(ct), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "shrink-0 min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : k("", !0),
            L.value && e.buttonsPosition !== "right" ? (c(), H(I(Be), {
              key: 1,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": M.value,
              class: "-mx-2 -my-1 shrink-0",
              onClick: F
            }, null, 8, ["aria-label"])) : k("", !0),
            T.value ? (c(), g("div", _M, [
              L.value ? (c(), H(I(Be), {
                key: 0,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-close-line",
                size: "xs",
                "aria-label": M.value,
                class: "-m-2",
                onClick: F
              }, null, 8, ["aria-label"])) : k("", !0),
              (c(!0), g(ce, null, Re(e.buttons, (j, G) => (c(), g(ce, { key: G }, [
                j.component === "link" ? (c(), H(I(In), Oe({
                  key: 0,
                  ref_for: !0
                }, Y(j)), {
                  default: xe(() => [
                    et(N(j.label), 1)
                  ]),
                  _: 2
                }, 1040)) : (c(), H(I(Be), Oe({
                  key: 1,
                  ref_for: !0
                }, B(j)), null, 16))
              ], 64))), 128))
            ])) : k("", !0)
          ], 2))
        ];
      }),
      _: 3
    }, 16, ["class"]));
  }
}), tz = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"/></svg>', fb = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"/></svg>', nz = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"/></svg>', az = ["src", "alt"], lz = ["aria-label", "disabled", "aria-describedby"], rz = { class: "flex flex-col gap-4" }, oz = { class: "flex items-start gap-4" }, iz = {
  "data-testid": "image-upload-preview",
  class: "shrink-0"
}, sz = ["src", "alt"], dz = { class: "flex-1 min-w-0" }, uz = { key: 0 }, hb = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23c0c0c0'/%3E%3Crect x='30' y='30' width='140' height='140' rx='4' fill='%23e0e0e0'/%3E%3Ccircle cx='80' cy='82' r='14' fill='%23b0b0b0'/%3E%3Cpath d='M50 140 l30-40 l20 25 l15-18 l35 45 H50z' fill='%23b0b0b0'/%3E%3C/svg%3E", gq = /* @__PURE__ */ ke({
  __name: "ImageUploadInput",
  props: {
    imageUrl: { default: void 0 },
    imageAlt: { default: "Profile picture" },
    avatarSize: { default: 64 },
    label: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    maxFileSizeText: { default: "SVG, PNG, JPG or GIF (MAX. 800x400px)." },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    fileInputLabel: { default: void 0 },
    browseButtonText: { default: "Choose files" },
    placeholder: { default: "No file chosen" },
    removeButtonLabel: { default: "Remove current picture" },
    alertHeading: { default: "Important" },
    alertMessage: { default: "In order for new users to access their accounts, they must receive approval from an administrator to verify their eligibility." },
    alertVariant: { default: "info" },
    showAlert: { type: Boolean, default: !0 },
    cancelButtonLabel: { default: "Cancel" },
    uploadButtonLabel: { default: "Upload new picture" },
    modalTitle: { default: "Upload profile picture" },
    modalSize: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    editButtonLabel: { default: "Edit profile picture" },
    closeModalLabel: { default: "Close modal" }
  },
  emits: ["upload", "remove", "cancel"],
  setup(e, { expose: n, emit: t }) {
    const a = (_, Y) => {
      const B = _.replace('fill="currentColor"', `fill="${Y}"`).replace("<svg", '<svg width="16" height="16"');
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(B)}`;
    }, l = {
      arrowLeftDark: a(tz, "#242424"),
      arrowRightDark: a(fb, "#242424"),
      arrowRightLight: a(fb, "#f2f0f0"),
      deleteDark: a(nz, "#242424")
    }, r = e, o = t, i = R(!1), s = R(!1), d = R(null), u = je(), f = `${u}-hint`, b = `${u}-error`, h = m(() => {
      const _ = [];
      return r.hint && _.push(f), r.error && _.push(b), _.length > 0 ? _.join(" ") : void 0;
    }), p = R(null), x = R(void 0), y = R(null), w = m(() => ({
      width: `${r.avatarSize}px`,
      height: `${r.avatarSize}px`
    })), $ = m(() => {
      const _ = "flex text-left text-sm font-inter";
      return r.labelInline ? `${_} flex-row items-center gap-4` : `${_} flex-col items-start gap-2`;
    }), S = () => {
      r.disabled || (p.value = null, x.value = r.imageUrl, y.value = null, i.value = !0);
    };
    n({
      /** Opens the upload modal, as the edit button does (no-op while `disabled`). */
      open: S
    });
    const L = () => {
      i.value = !1, p.value = null, x.value = void 0;
    }, T = () => {
      o("cancel"), L();
    }, E = (_) => {
      !_ || Array.isArray(_) || (y.value = null, p.value = _, x.value = URL.createObjectURL(_));
    }, A = (_) => {
      y.value = _, p.value = null;
    }, D = () => {
      p.value = null, x.value = void 0, o("remove");
    }, M = () => {
      p.value && (o("upload", p.value), L());
    }, F = m(() => !!p.value), X = m(() => !!x.value);
    return $e(i, (_) => {
      !_ && x.value && x.value !== r.imageUrl && URL.revokeObjectURL(x.value);
    }), (_, Y) => (c(), g("div", {
      "data-testid": "image-upload-input",
      class: C($.value)
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        inline: e.labelInline,
        "test-id": "image-upload-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "inline"])) : k("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-col items-start gap-0.5", e.labelInline ? "flex-1" : "self-stretch"])
      }, [
        v("div", {
          class: "relative inline-block",
          style: Ne(w.value)
        }, [
          v("div", {
            "data-testid": "image-upload-trigger",
            class: C(["w-full h-full rounded-(--border-border-radius-rounded-l) overflow-hidden border border-(--colors-border-base-soft) dark:border-(--colors-border-base)", e.disabled ? "opacity-50" : ""])
          }, [
            v("img", {
              src: e.imageUrl || hb,
              alt: e.imageAlt,
              class: "w-full h-full object-cover"
            }, null, 8, az)
          ], 2),
          v("button", {
            "data-testid": "image-upload-edit-button",
            type: "button",
            "aria-label": e.editButtonLabel,
            class: C(["absolute -top-2 -right-2 flex items-center justify-center w-8 h-8 rounded-full bg-(--background-background-white) dark:bg-(--colors-background-black-default) border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-sm transition-colors duration-200 hover:bg-(--colors-background-hover) dark:hover:bg-[rgba(255,255,255,0.1)]", e.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"]),
            disabled: e.disabled,
            "aria-describedby": h.value,
            onClick: S,
            onFocus: Y[0] || (Y[0] = (B) => s.value = !0),
            onBlur: Y[1] || (Y[1] = (B) => s.value = !1),
            onKeydown: Y[2] || (Y[2] = (B) => {
              var W;
              return (W = d.value) == null ? void 0 : W.handleFieldKeydown(B);
            })
          }, [...Y[4] || (Y[4] = [
            v("i", {
              class: "ri-pencil-line text-(length:--size-m) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, lz)
        ], 4),
        e.hint || e.error ? (c(), H(xt, {
          key: 0,
          ref_key: "helperRef",
          ref: d,
          focused: s.value,
          hint: e.hint,
          error: e.error,
          "hint-id": f,
          "error-id": b,
          "error-live": e.errorLive,
          "test-id-prefix": "image-upload"
        }, null, 8, ["focused", "hint", "error", "error-live"])) : k("", !0)
      ], 2),
      re(I(Va), {
        modelValue: i.value,
        "onUpdate:modelValue": Y[3] || (Y[3] = (B) => i.value = B),
        size: e.modalSize,
        title: e.modalTitle,
        "aria-close-label": e.closeModalLabel
      }, {
        footer: xe(() => [
          re(I(Be), {
            "data-testid": "image-upload-cancel-button",
            variant: "secondary",
            label: e.cancelButtonLabel,
            "icon-left": l.arrowLeftDark,
            onClick: T
          }, null, 8, ["label", "icon-left"]),
          re(I(Be), {
            "data-testid": "image-upload-submit-button",
            variant: "primary",
            label: e.uploadButtonLabel,
            "icon-right": l.arrowRightLight,
            disabled: !F.value,
            onClick: M
          }, null, 8, ["label", "icon-right", "disabled"])
        ]),
        default: xe(() => [
          v("div", rz, [
            v("div", oz, [
              v("div", iz, [
                v("img", {
                  src: x.value || hb,
                  alt: e.imageAlt,
                  class: "w-16 h-16 rounded-xl object-cover border border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                }, null, 8, sz)
              ]),
              v("div", dz, [
                re(I(jS), {
                  variant: "basic",
                  accept: e.accept,
                  "max-file-size": e.maxFileSize,
                  "max-file-size-text": e.maxFileSizeText,
                  "file-type-error-text": e.fileTypeErrorText,
                  "file-size-error-text": e.fileSizeErrorText,
                  label: e.fileInputLabel,
                  "browse-button-text": e.browseButtonText,
                  placeholder: e.placeholder,
                  "model-value": p.value,
                  error: y.value ?? void 0,
                  "onUpdate:modelValue": E,
                  onError: A
                }, null, 8, ["accept", "max-file-size", "max-file-size-text", "file-type-error-text", "file-size-error-text", "label", "browse-button-text", "placeholder", "model-value", "error"])
              ])
            ]),
            X.value ? (c(), g("div", uz, [
              re(I(Be), {
                "data-testid": "image-upload-remove-button",
                variant: "secondary",
                label: e.removeButtonLabel,
                "icon-left": l.deleteDark,
                size: "sm",
                onClick: D
              }, null, 8, ["label", "icon-left"])
            ])) : k("", !0),
            e.showAlert ? (c(), H(I(Kl), {
              key: 1,
              heading: e.alertHeading,
              message: e.alertMessage,
              color: e.alertVariant === "error" ? "danger" : e.alertVariant,
              closable: !1
            }, null, 8, ["heading", "message", "color"])) : k("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "size", "title", "aria-close-label"])
    ], 2));
  }
}), cz = ["id", "aria-label", "data-testid"], fz = {
  key: 0,
  class: "flex w-full items-center gap-3"
}, Mv = /* @__PURE__ */ ke({
  __name: "DatepickerPanel",
  props: {
    open: { type: Boolean, default: !1 },
    anchorEl: {},
    dialogLabel: {},
    testId: {},
    widthClass: {},
    id: { default: void 0 },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    additionalAnchorEls: { default: () => [] },
    placement: { default: "bottom-start" }
  },
  emits: ["update:open", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null);
    let o = null;
    function i(p) {
      return p.startsWith("bottom") ? p.replace("bottom", "top") : p.replace("top", "bottom");
    }
    function s() {
      r.value && (o == null || o.destroy(), o = ja(a.anchorEl, r.value, {
        strategy: "fixed",
        placement: a.placement,
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: [i(a.placement)] } },
          { name: "preventOverflow", options: { padding: 8 } }
        ]
      }));
    }
    function d() {
      o == null || o.destroy(), o = null;
    }
    function u() {
      o == null || o.update();
    }
    function f() {
      l("update:open", !1), l("close");
    }
    Ji({
      active: wn(a, "open"),
      container: r,
      containFocus: !0,
      restoreFocusTo: () => a.anchorEl,
      // See keepAnchorFocusable's doc above: without this, a consumer whose anchor IS its own
      // typing surface can never place a caret in it while the panel is open — containFocus treats
      // the click as focus escaping the trap and yanks it straight back to the panel's first
      // focusable cell.
      allowOutsideElements: a.keepAnchorFocusable ? () => [a.anchorEl, ...a.additionalAnchorEls] : void 0
    }), Qi(r, f, {
      isActive: () => a.open,
      ignoreElements: () => [a.anchorEl, ...a.additionalAnchorEls]
    });
    const b = Symbol("datepicker-panel");
    function h(p) {
      p.key !== "Escape" || !a.open || ha(b) && (p.defaultPrevented || (p.stopPropagation(), p.preventDefault(), f()));
    }
    return $e(
      () => a.open,
      async (p) => {
        p ? (Qn(b), await Ue(), s()) : (Rn(b), d());
      },
      { immediate: !0 }
    ), $e(
      () => a.anchorEl,
      () => {
        a.open && s();
      }
    ), dt(() => {
      document.addEventListener("keydown", h);
    }), mt(() => {
      document.removeEventListener("keydown", h), Rn(b), d();
    }), n({ updatePosition: u }), (p, x) => (c(), H(Dn, { to: "body" }, [
      e.open ? (c(), g("div", {
        key: 0,
        id: e.id,
        ref_key: "panelRef",
        ref: r,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": e.dialogLabel,
        "data-focus-trap-allow-outside": "",
        "data-testid": e.testId,
        class: C([
          "z-[350] flex flex-col items-center gap-4 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-5 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
          e.widthClass
        ])
      }, [
        Ae(p.$slots, "default"),
        p.$slots.actions ? (c(), g("div", fz, [
          Ae(p.$slots, "actions")
        ])) : k("", !0)
      ], 10, cz)) : k("", !0)
    ]));
  }
}), hz = ["aria-disabled", "data-state", "aria-current"], Ya = "relative inline-flex items-center justify-center font-inter focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1", bz = "flex size-9 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid datepicker-cell--gradient-white", yl = "text-(length:--size-sm) leading-(--line-height-l)", gz = /* @__PURE__ */ ke({
  __name: "DatepickerCell",
  props: {
    type: { default: "Day" },
    state: { default: "Initial" },
    text: { default: "" },
    muted: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.state === "Disabled");
    function r(u) {
      l.value || a("click", u);
    }
    const o = m(
      () => t.type === "Day" && (t.state === "Active start" || t.state === "Active end")
    ), i = m(() => {
      switch (t.type) {
        case "Month":
          return "h-9 min-w-[78px] flex-1";
        case "Year":
        case "Wheel":
          return "h-9 min-w-[57px] flex-1";
        default:
          return "size-9 shrink-0";
      }
    }), s = m(() => {
      switch (t.state) {
        case "Hover":
          return `${Ya} bg-(--background-background-accent) rounded-(--border-border-radius-rounded-base)`;
        case "Active":
          return `${Ya} datepicker-cell--gradient-white border border-solid rounded-(--border-border-radius-rounded-full)`;
        case "Active start":
          return `${Ya} bg-(--background-background-accent) rounded-l-(--border-border-radius-rounded-base)`;
        case "Active between":
          return `${Ya} bg-(--background-background-accent)`;
        case "Active end":
          return `${Ya} bg-(--background-background-accent) rounded-r-(--border-border-radius-rounded-base)`;
        case "Today":
          return `${Ya} datepicker-cell--gradient-black border border-solid rounded-(--border-border-radius-rounded-full)`;
        default:
          return `${Ya} rounded-(--border-border-radius-rounded-base)`;
      }
    }), d = m(() => {
      switch (t.state) {
        case "Active":
        case "Active start":
        case "Active end":
          return `${yl} font-(--weight-semi-bold) text-(--text-text-accent)`;
        case "Today":
          return `${yl} font-(--weight-semi-bold) text-(--text-text-white-default)`;
        case "Disabled":
          return `${yl} font-(--weight-medium) text-(--text-text-disabled-light)`;
        case "Hover":
        case "Active between":
          return `${yl} font-(--weight-medium) text-(--text-text-black-default)`;
        default:
          return t.muted ? `${yl} font-(--weight-medium) text-(--text-text-disabled-strong) dark:text-(--text-text-disabled-light)` : `${yl} font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)`;
      }
    });
    return (u, f) => (c(), g("button", {
      type: "button",
      "aria-disabled": l.value ? "true" : void 0,
      class: C([s.value, i.value, l.value ? "cursor-not-allowed" : "cursor-pointer"]),
      "data-state": e.state,
      "aria-current": e.state === "Today" ? "date" : void 0,
      "data-testid": "datepicker-cell",
      onClick: r
    }, [
      o.value ? (c(), g("span", {
        key: 0,
        class: C(bz),
        "data-testid": "datepicker-cell-inner"
      }, [
        v("span", {
          class: C(d.value)
        }, N(e.text), 3)
      ])) : (c(), g("span", {
        key: 1,
        class: C(d.value)
      }, N(e.text), 3))
    ], 10, hz));
  }
}), Dr = /* @__PURE__ */ ot(gz, [["__scopeId", "data-v-c4eaa4a3"]]);
function sd(e, n) {
  const t = R(0);
  function a() {
    const s = e.value.findIndex((d) => d.value === n.value);
    t.value = s >= 0 ? s : Math.max(e.value.findIndex((d) => !d.disabled), 0);
  }
  a();
  function l(s) {
    const d = e.value[s];
    !d || d.disabled || (t.value = s, n.value = d.value);
  }
  function r(s) {
    if (s < 0 || s >= e.value.length) return;
    t.value = s;
    const d = e.value[s];
    d.disabled || (n.value = d.value);
  }
  function o(s) {
    r(t.value + s);
  }
  function i(s) {
    const d = e.value;
    r(s === "start" ? 0 : d.length - 1);
  }
  return { focusedIndex: t, selectIndex: l, moveFocus: o, moveToEdge: i, syncFocusToSelected: a };
}
const mz = { class: "w-full text-center text-(length:--size-m) font-(--weight-semi-bold) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, pz = { class: "flex w-full flex-wrap content-start items-start justify-between" }, vz = ["aria-label"], xz = ["aria-label"], yz = ["aria-label"], kz = 120, wz = 10, Cz = 200, Sz = 200, $z = /* @__PURE__ */ ke({
  __name: "DatepickerDobPicker",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    anchorEl: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    defaultDate: { default: void 0 },
    id: { default: void 0 },
    autoFocusOnOpen: { type: Boolean, default: !0 },
    title: {},
    yearColumnLabel: {},
    monthColumnLabel: {},
    dayColumnLabel: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {}
  },
  emits: ["update:open", "update:modelValue", "clear", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t;
    function r(V) {
      return String(V).padStart(2, "0");
    }
    function o(V, Q, le) {
      return `${V}-${r(Q + 1)}-${r(le)}`;
    }
    function i(V, Q) {
      return new Date(V, Q + 1, 0).getDate();
    }
    function s() {
      const V = a.modelValue || a.defaultDate, Q = V ? /* @__PURE__ */ new Date(`${V}T00:00:00`) : /* @__PURE__ */ new Date();
      return { year: Q.getFullYear(), month: Q.getMonth(), day: Q.getDate() };
    }
    const d = s(), u = R(d.year), f = R(d.month), b = R(d.day);
    function h(V) {
      const Q = (/* @__PURE__ */ new Date()).getFullYear();
      return Math.min(Math.max(V, Q - Cz), Q + Sz);
    }
    const p = m(() => a.minDate ? h(Number(a.minDate.slice(0, 4))) : void 0), x = m(() => a.maxDate ? h(Number(a.maxDate.slice(0, 4))) : void 0), y = m(() => {
      const V = (/* @__PURE__ */ new Date()).getFullYear(), Q = [V - kz, V + wz];
      return p.value !== void 0 && Q.push(p.value), x.value !== void 0 && Q.push(x.value), Q.push(h(u.value)), {
        min: Math.min(...Q),
        max: Math.max(...Q)
      };
    });
    function w(V) {
      const { minDate: Q, maxDate: le } = a;
      return !!(Q && V < Q.slice(0, V.length) || le && V > le.slice(0, V.length));
    }
    const $ = m(() => {
      const { min: V, max: Q } = y.value, le = [];
      for (let ee = V; ee <= Q; ee++) {
        const O = String(ee);
        w(O) || le.push({ value: ee, label: O, disabled: !1 });
      }
      return le;
    }), S = m(() => {
      const V = [];
      return a.monthShortLabels.forEach((Q, le) => {
        const ee = `${u.value}-${r(le + 1)}`;
        w(ee) || V.push({ value: le, label: Q, disabled: !1 });
      }), V;
    }), L = m(() => {
      const V = i(u.value, f.value), Q = [];
      for (let le = 0; le < V; le++) {
        const ee = le + 1, O = o(u.value, f.value, ee);
        w(O) || Q.push({ value: ee, label: String(ee), disabled: !1 });
      }
      return Q;
    }), T = sd($, u), E = sd(S, f), A = sd(L, b);
    function D() {
      l("update:modelValue", o(u.value, f.value, b.value));
    }
    function M(V) {
      u.value = h(u.value), x.value !== void 0 && u.value > x.value && (u.value = x.value), p.value !== void 0 && u.value < p.value && (u.value = p.value);
      const Q = i(u.value, f.value);
      if (b.value > Q && (b.value = Q), a.maxDate) {
        const [O, ne, fe] = a.maxDate.split("-").map(Number);
        u.value === O && f.value > ne - 1 && (f.value = ne - 1, b.value = Math.min(b.value, i(u.value, f.value))), u.value === O && f.value === ne - 1 && b.value > fe && (b.value = fe);
      }
      if (a.minDate) {
        const [O, ne, fe] = a.minDate.split("-").map(Number);
        u.value === O && f.value < ne - 1 && (f.value = ne - 1, b.value = Math.min(b.value, i(u.value, f.value))), u.value === O && f.value === ne - 1 && b.value < fe && (b.value = fe);
      }
      const le = V ?? me, ee = ["year", "month", "day"].filter((O) => O !== le);
      ee.forEach((O) => J.value.add(O)), V !== void 0 && (me = V), T.syncFocusToSelected(), E.syncFocusToSelected(), A.syncFocusToSelected(), Ue(() => {
        ee.forEach((O) => J.value.delete(O)), V !== void 0 && (me = void 0);
      });
    }
    $e([u, f], () => M());
    function F(V) {
      T.selectIndex(V), M("year"), D();
    }
    function X(V) {
      E.selectIndex(V), M("month"), D();
    }
    function _(V) {
      A.selectIndex(V), D();
    }
    const Y = { year: T, month: E, day: A }, B = {
      year: u,
      month: f,
      day: b
    }, W = ["year", "month", "day"];
    function U(V, Q) {
      const le = W.indexOf(V) + Q;
      if (le < 0 || le >= W.length) return;
      const ee = W[le], O = q[ee].value, ne = O == null ? void 0 : O.querySelectorAll('[role="option"]')[Y[ee].focusedIndex.value];
      ne == null || ne.focus({ preventScroll: !0 }), ne == null || ne.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    function z() {
      l("update:open", !1), l("close");
    }
    function P(V, Q) {
      if (V.key === "ArrowLeft" || V.key === "ArrowRight") {
        V.preventDefault(), U(Q, V.key === "ArrowLeft" ? -1 : 1);
        return;
      }
      if (V.key === "Enter" || V.key === " ") {
        V.preventDefault(), z();
        return;
      }
      const le = Y[Q], ee = B[Q], O = ee.value;
      switch (V.key) {
        case "ArrowDown":
          V.preventDefault(), le.moveFocus(1);
          break;
        case "ArrowUp":
          V.preventDefault(), le.moveFocus(-1);
          break;
        case "Home":
          V.preventDefault(), le.moveToEdge("start");
          break;
        case "End":
          V.preventDefault(), le.moveToEdge("end");
          break;
        default:
          return;
      }
      ee.value !== O && (Q !== "day" && M(Q), D());
    }
    const K = R(null), j = R(null), G = R(null), q = { year: K, month: j, day: G }, J = R(/* @__PURE__ */ new Set());
    let me;
    function ye(V) {
      const Q = q[V].value, le = Q == null ? void 0 : Q.querySelectorAll('[role="option"]')[Y[V].focusedIndex.value];
      J.value.has(V) || le == null || le.focus({ preventScroll: !0 }), le == null || le.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    $e(T.focusedIndex, () => ye("year"), { flush: "post" }), $e(E.focusedIndex, () => ye("month"), { flush: "post" }), $e(A.focusedIndex, () => ye("day"), { flush: "post" });
    function Z(V, Q) {
      return V.value === Q ? "Active" : "Initial";
    }
    function de() {
      l("clear");
    }
    async function ge() {
      const V = s();
      u.value = V.year, f.value = V.month, b.value = V.day, M(), J.value.add("year"), J.value.add("month"), J.value.add("day"), T.syncFocusToSelected(), E.syncFocusToSelected(), A.syncFocusToSelected(), await Ue(), J.value.delete("year"), J.value.delete("month"), J.value.delete("day");
      const Q = ["year", "month", "day"].map(
        (le) => {
          var ee;
          return (ee = q[le].value) == null ? void 0 : ee.querySelectorAll('[role="option"]')[Y[le].focusedIndex.value];
        }
      );
      return Q.forEach((le) => le == null ? void 0 : le.scrollIntoView({ block: "center" })), Q[0];
    }
    async function se() {
      const V = await ge();
      V == null || V.focus({ preventScroll: !0 });
    }
    $e(
      () => a.open,
      (V) => {
        V && (a.autoFocusOnOpen ? se() : ge());
      },
      // DatePickerInput's openDobPicker() sets
      // dobMounted/isDobOpen true in the SAME synchronous call, so this component can mount with
      // `open` ALREADY true on first open — without `immediate`, this watcher would never fire for
      // that case (a plain watch only fires on a subsequent CHANGE), and the explicit year-column
      // focus above would never run on the very first open at all.
      { immediate: !0 }
    );
    function Se() {
      se();
    }
    return n({ focusYearColumn: Se }), $e(
      () => a.modelValue,
      (V) => {
        if (!a.open || V === o(u.value, f.value, b.value)) return;
        const Q = s();
        u.value = Q.year, f.value = Q.month, b.value = Q.day, M();
      }
    ), (V, Q) => (c(), H(Mv, {
      id: e.id,
      open: e.open,
      "anchor-el": e.anchorEl,
      "keep-anchor-focusable": "",
      "dialog-label": e.title,
      "test-id": "datepicker-dob-picker",
      "width-class": "w-[224px]",
      "onUpdate:open": Q[3] || (Q[3] = (le) => l("update:open", le)),
      onClose: Q[4] || (Q[4] = (le) => l("close"))
    }, {
      actions: xe(() => [
        re(Be, {
          variant: "secondary",
          size: "sm",
          class: "flex-1",
          "full-width": "",
          label: e.clearLabel,
          "data-testid": "datepicker-dob-picker-clear",
          onClick: de
        }, null, 8, ["label"])
      ]),
      default: xe(() => [
        v("p", mz, N(e.title), 1),
        v("div", pz, [
          v("div", {
            ref_key: "yearListRef",
            ref: K,
            role: "listbox",
            "aria-label": e.yearColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: Q[0] || (Q[0] = (le) => P(le, "year"))
          }, [
            (c(!0), g(ce, null, Re($.value, (le, ee) => (c(), H(Dr, {
              key: le.value,
              type: "Wheel",
              state: Z(le, u.value),
              text: le.label,
              role: "option",
              class: "snap-center",
              "aria-selected": le.value === u.value ? "true" : void 0,
              tabindex: ee === I(T).focusedIndex.value ? 0 : -1,
              "aria-label": le.label,
              onClick: (O) => F(ee)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, vz),
          v("div", {
            ref_key: "monthListRef",
            ref: j,
            role: "listbox",
            "aria-label": e.monthColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: Q[1] || (Q[1] = (le) => P(le, "month"))
          }, [
            (c(!0), g(ce, null, Re(S.value, (le, ee) => (c(), H(Dr, {
              key: le.value,
              type: "Wheel",
              state: Z(le, f.value),
              text: le.label,
              role: "option",
              class: "snap-center",
              "aria-selected": le.value === f.value ? "true" : void 0,
              tabindex: ee === I(E).focusedIndex.value ? 0 : -1,
              "aria-label": e.monthLabels[le.value],
              onClick: (O) => X(ee)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, xz),
          v("div", {
            ref_key: "dayListRef",
            ref: G,
            role: "listbox",
            "aria-label": e.dayColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: Q[2] || (Q[2] = (le) => P(le, "day"))
          }, [
            (c(!0), g(ce, null, Re(L.value, (le, ee) => (c(), H(Dr, {
              key: le.value,
              type: "Wheel",
              state: Z(le, b.value),
              text: le.label,
              role: "option",
              class: "snap-center",
              "aria-selected": le.value === b.value ? "true" : void 0,
              tabindex: ee === I(A).focusedIndex.value ? 0 : -1,
              "aria-label": le.label,
              onClick: (O) => _(ee)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, yz)
        ])
      ]),
      _: 1
    }, 8, ["id", "open", "anchor-el", "dialog-label"]));
  }
}), Iz = /* @__PURE__ */ ot($z, [["__scopeId", "data-v-f30f2f82"]]), Tz = { class: "flex w-full items-center justify-between" }, Lz = ["disabled"], Az = /* @__PURE__ */ ke({
  __name: "DatepickerControls",
  props: {
    label: {},
    previousLabel: {},
    nextLabel: {},
    labelDisabled: { type: Boolean, default: !1 },
    previousDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next", "drill-up"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", Tz, [
      re(Be, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-left": "ri-arrow-left-line",
        "aria-label": e.previousLabel,
        disabled: e.previousDisabled,
        "data-testid": "datepicker-controls-prev",
        onClick: l[0] || (l[0] = (r) => t("prev"))
      }, null, 8, ["aria-label", "disabled"]),
      v("button", {
        type: "button",
        "aria-live": "polite",
        disabled: e.labelDisabled,
        class: "font-(--weight-semi-bold) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) dark:text-(--colors-text-white-default) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1 rounded-(--border-border-radius-rounded-sm) cursor-pointer disabled:cursor-not-allowed disabled:opacity-60",
        "data-testid": "datepicker-controls-label",
        onClick: l[1] || (l[1] = (r) => t("drill-up"))
      }, N(e.label), 9, Lz),
      re(Be, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-right": "ri-arrow-right-line",
        "aria-label": e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "datepicker-controls-next",
        onClick: l[2] || (l[2] = (r) => t("next"))
      }, null, 8, ["aria-label", "disabled"])
    ]));
  }
});
function fu(e) {
  return String(e).padStart(2, "0");
}
function bb(e, n, t) {
  const a = e * 12 + n + t;
  return { year: Math.floor(a / 12), month: (a % 12 + 12) % 12 };
}
function Nc(e, n, t) {
  return `${e}-${fu(n + 1)}-${fu(t)}`;
}
function hu(e, n) {
  return `${e}-${fu(n + 1)}`;
}
function Cn(e, n) {
  return e < n ? -1 : e > n ? 1 : 0;
}
function Xo() {
  const e = /* @__PURE__ */ new Date();
  return Nc(e.getFullYear(), e.getMonth(), e.getDate());
}
function Hc(e, n, t) {
  const { selectedIso: a, selectedEndIso: l, todayIso: r, minIso: o, maxIso: i } = n, s = r.substring(0, e.length), d = a !== void 0 ? a.substring(0, e.length) : void 0, u = l !== void 0 ? l.substring(0, e.length) : void 0;
  if (o !== void 0 && Cn(e, o) < 0 || i !== void 0 && Cn(e, i) > 0) return "Disabled";
  if (d !== void 0 && u !== void 0) {
    if (e === d) return "Active start";
    if (e === u) return "Active end";
    if (Cn(e, d) > 0 && Cn(e, u) < 0) return "Active between";
  } else {
    if (d !== void 0 && e === d)
      return "Active";
    if (u !== void 0 && e === u)
      return "Active";
  }
  return e === s ? "Today" : t;
}
function Ez(e, n, t) {
  const l = (new Date(e, n, 1).getDay() + 6) % 7, r = new Date(e, n, 1 - l), o = [];
  for (let i = 0; i < 42; i++) {
    const s = new Date(r);
    s.setDate(r.getDate() + i);
    const d = Nc(s.getFullYear(), s.getMonth(), s.getDate()), u = s.getMonth() === n && s.getFullYear() === e, f = Hc(d, t, "Initial");
    o.push({ iso: d, label: String(s.getDate()), state: f, inMonth: u });
  }
  return o;
}
function Rz(e, n, t) {
  return n.map((a, l) => {
    const r = hu(e, l);
    return { iso: r, label: a, state: Hc(r, t, "Initial"), inMonth: !0 };
  });
}
function Bz(e, n) {
  return Array.from({ length: 12 }, (t, a) => {
    const l = e + a, r = String(l);
    return { iso: r, label: r, state: Hc(r, n, "Initial"), inMonth: !0 };
  });
}
const Dz = {
  key: 0,
  class: "flex w-[252px] flex-col"
}, Mz = {
  role: "row",
  "data-testid": "datepicker-weekday-header-row",
  class: "mb-1.5 flex items-center"
}, jc = /* @__PURE__ */ ke({
  __name: "DatepickerDropdownMenu",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    startDate: { default: void 0 },
    endDate: { default: void 0 },
    seedField: { default: "start" },
    anchorEl: {},
    additionalAnchorEls: { default: () => [] },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    todayButtonMode: { default: "highlight" },
    mode: { default: "day" },
    showTodayButton: { type: Boolean, default: !0 },
    showClearButton: { type: Boolean, default: !0 },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    rangeStartLabel: { default: "start of selected range" },
    rangeEndLabel: { default: "end of selected range" },
    rangeBetweenLabel: { default: "in selected range" },
    dialogLabel: {},
    id: { default: void 0 },
    placement: { default: "bottom-start" },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    autoFocusOnOpen: { type: Boolean, default: !0 }
  },
  emits: ["update:open", "update:modelValue", "select", "range-select", "clear", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = m(() => a.startDate !== void 0 || a.endDate !== void 0), o = R(/* @__PURE__ */ new Date()), i = m(() => {
      const ee = o.value;
      return `${ee.getFullYear()}-${String(ee.getMonth() + 1).padStart(2, "0")}-${String(ee.getDate()).padStart(2, "0")}`;
    });
    function s(ee) {
      const O = ee ?? a.seedField, ne = O === "end" ? a.endDate : a.startDate, fe = O === "end" ? a.startDate : a.endDate, ue = r.value ? ne || fe : a.modelValue;
      if (ue) {
        const [te, oe, Le] = ue.split("-").map(Number);
        return { year: te, month: oe - 1, day: Le };
      }
      return { year: o.value.getFullYear(), month: o.value.getMonth(), day: o.value.getDate() };
    }
    const d = s(), u = R(d.year), f = R(d.month), b = R(d.day), h = R(a.mode), p = R(o.value.getFullYear() - o.value.getFullYear() % 12), x = m(
      () => Ez(u.value, f.value, {
        todayIso: i.value,
        // "" (not yet picked) is normalized to undefined here — cellState's own selectedEndIso
        // contract treats any DEFINED value, empty string included, as a real endpoint, which would
        // otherwise render the lone startDate cell "Active start" instead of plain "Active" before an
        // end date is chosen.
        selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
        selectedEndIso: r.value && a.endDate || void 0,
        minIso: a.minDate,
        maxIso: a.maxDate
      })
    ), y = m(
      () => {
        var ee, O;
        return Rz(u.value, a.monthShortLabels, {
          todayIso: i.value,
          selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
          selectedEndIso: r.value && a.endDate || void 0,
          minIso: (ee = a.minDate) == null ? void 0 : ee.slice(0, 7),
          maxIso: (O = a.maxDate) == null ? void 0 : O.slice(0, 7)
        });
      }
    ), w = m(
      () => {
        var ee, O;
        return Bz(p.value, {
          todayIso: i.value,
          selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
          selectedEndIso: r.value && a.endDate || void 0,
          minIso: (ee = a.minDate) == null ? void 0 : ee.slice(0, 4),
          maxIso: (O = a.maxDate) == null ? void 0 : O.slice(0, 4)
        });
      }
    ), $ = m(() => h.value === "month" ? y.value : h.value === "year" ? w.value : x.value), S = m(() => {
      const ee = [];
      for (let O = 0; O < 6; O++)
        ee.push(
          x.value.slice(O * 7, O * 7 + 7).map((ne, fe) => ({ cell: ne, index: O * 7 + fe }))
        );
      return ee;
    }), L = m(() => h.value === "day" ? 7 : h.value === "month" ? 3 : 4), T = m(() => {
      const ee = L.value, O = $.value, ne = [];
      for (let fe = 0; fe < O.length; fe += ee)
        ne.push(O.slice(fe, fe + ee).map((ue, te) => ({ cell: ue, index: fe + te })));
      return ne;
    }), E = R(null);
    function A(ee) {
      return ee.state === "Initial" && E.value === ee.iso ? "Hover" : ee.state;
    }
    const D = /* @__PURE__ */ new Set([
      "Active",
      "Active start",
      "Active between",
      "Active end"
    ]);
    function M(ee) {
      const [O, ne] = ee.iso.split("-").map(Number), fe = `${a.monthLabels[ne - 1]} ${ee.label}, ${O}`;
      return ee.state === "Disabled" ? `${fe}, ${a.unavailableLabel}` : ee.state === "Active start" ? `${fe}, ${a.rangeStartLabel}` : ee.state === "Active end" ? `${fe}, ${a.rangeEndLabel}` : ee.state === "Active between" ? `${fe}, ${a.rangeBetweenLabel}` : fe;
    }
    function F(ee) {
      const O = Number(ee.iso.split("-")[1]), ne = a.monthLabels[O - 1];
      return ee.state === "Disabled" ? `${ne}, ${a.unavailableLabel}` : ne;
    }
    const X = m(() => h.value === "month" ? String(u.value) : h.value === "year" ? `${p.value}-${p.value + 11}` : `${a.monthLabels[f.value]} ${u.value}`), _ = m(() => a.mode !== "day" || h.value === "year"), Y = m(() => {
      var O;
      if (h.value === "day") {
        if (a.minDate === void 0) return !1;
        const ne = (O = x.value[0]) == null ? void 0 : O.iso;
        return ne !== void 0 && Cn(ne, a.minDate) <= 0;
      }
      if (a.minDate === void 0) return !1;
      const ee = Number(a.minDate.slice(0, 4));
      return h.value === "month" ? u.value <= ee : p.value <= ee;
    }), B = m(() => {
      var O;
      if (h.value === "day") {
        if (a.maxDate === void 0) return !1;
        const ne = (O = x.value[41]) == null ? void 0 : O.iso;
        return ne !== void 0 && Cn(ne, a.maxDate) >= 0;
      }
      if (a.maxDate === void 0) return !1;
      const ee = Number(a.maxDate.slice(0, 4));
      return h.value === "month" ? u.value >= ee : p.value + 11 >= ee;
    }), W = m(() => {
      var ue, te;
      const ee = a.mode === "month" ? 7 : a.mode === "year" ? 4 : 10, O = i.value.slice(0, ee), ne = (ue = a.minDate) == null ? void 0 : ue.slice(0, ee), fe = (te = a.maxDate) == null ? void 0 : te.slice(0, ee);
      return ne !== void 0 && Cn(O, ne) < 0 || fe !== void 0 && Cn(O, fe) > 0;
    });
    async function U() {
      await Ue(), se(ye.value);
    }
    function z() {
      var ee;
      return ((ee = document.activeElement) == null ? void 0 : ee.getAttribute("data-testid")) === "datepicker-cell";
    }
    async function P() {
      if (Y.value) return;
      const ee = z();
      if (h.value === "day") {
        const { year: O, month: ne } = bb(u.value, f.value, -1);
        u.value = O, f.value = ne;
      } else h.value === "month" ? u.value -= 1 : p.value -= 12;
      ee && await U();
    }
    async function K() {
      if (B.value) return;
      const ee = z();
      if (h.value === "day") {
        const { year: O, month: ne } = bb(u.value, f.value, 1);
        u.value = O, f.value = ne;
      } else h.value === "month" ? u.value += 1 : p.value += 12;
      ee && await U();
    }
    async function j() {
      const ee = z();
      if (h.value === "day")
        h.value = "month";
      else if (h.value === "month")
        p.value = u.value - u.value % 12, h.value = "year";
      else
        return;
      ee && await U();
    }
    function G() {
      l("clear");
    }
    async function q() {
      if (!W.value) {
        if (a.mode === "month") {
          if (u.value = o.value.getFullYear(), a.todayButtonMode === "select") {
            J(hu(o.value.getFullYear(), o.value.getMonth()));
            return;
          }
          await Ue(), se(y.value.findIndex((ee) => ee.iso === i.value.slice(0, 7)));
          return;
        }
        if (a.mode === "year") {
          if (p.value = o.value.getFullYear() - o.value.getFullYear() % 12, a.todayButtonMode === "select") {
            J(String(o.value.getFullYear()));
            return;
          }
          await Ue(), se(w.value.findIndex((ee) => ee.iso === i.value.slice(0, 4)));
          return;
        }
        if (h.value = "day", u.value = o.value.getFullYear(), f.value = o.value.getMonth(), a.todayButtonMode === "select") {
          if (r.value) {
            l("range-select", i.value);
            return;
          }
          l("update:modelValue", i.value), l("select", i.value), V();
          return;
        }
        await Ue(), se(x.value.findIndex((ee) => ee.iso === i.value));
      }
    }
    function J(ee) {
      l("update:modelValue", ee), l("select", ee), V();
    }
    async function me(ee) {
      if (ee.state !== "Disabled") {
        if (h.value === "year") {
          if (a.mode === "year") {
            J(ee.iso);
            return;
          }
          u.value = Number(ee.iso), h.value = "month", await U();
          return;
        }
        if (h.value === "month") {
          if (a.mode === "month") {
            J(ee.iso);
            return;
          }
          f.value = Number(ee.iso.slice(5)) - 1, h.value = "day", await U();
          return;
        }
        if (r.value) {
          l("range-select", ee.iso);
          return;
        }
        J(ee.iso);
      }
    }
    const ye = R(0);
    function Z() {
      const ee = $.value;
      let O;
      if (h.value === "day") {
        const fe = new Date(u.value, f.value + 1, 0).getDate();
        O = Nc(u.value, f.value, Math.min(b.value, fe));
      } else h.value === "month" ? O = hu(u.value, f.value) : O = String(u.value);
      const ne = ee.findIndex((fe) => fe.iso === O);
      ye.value = ne >= 0 ? ne : Math.max(ee.findIndex((fe) => fe.state !== "Disabled"), 0);
    }
    Z(), $e([u, f, h, p], Z);
    const de = R(null), ge = R(null);
    function se(ee) {
      var O, ne;
      if (ye.value = ee, h.value === "day") {
        const fe = x.value[ee];
        fe && (b.value = Number(fe.iso.slice(8, 10)));
      }
      (ne = (O = de.value) == null ? void 0 : O.querySelectorAll('[data-testid="datepicker-cell"]')[ee]) == null || ne.focus({ preventScroll: !0 });
    }
    function Se(ee) {
      const O = $.value, ne = O.length, fe = ye.value, ue = L.value, te = fe - fe % ue;
      switch (ee.key) {
        case "ArrowRight":
          ee.preventDefault(), fe < ne - 1 && se(fe + 1);
          break;
        case "ArrowLeft":
          ee.preventDefault(), fe > 0 && se(fe - 1);
          break;
        case "ArrowDown":
          ee.preventDefault(), fe + ue < ne && se(fe + ue);
          break;
        case "ArrowUp":
          ee.preventDefault(), fe - ue >= 0 && se(fe - ue);
          break;
        case "Home":
          ee.preventDefault(), se(te);
          break;
        case "End":
          ee.preventDefault(), se(Math.min(te + ue - 1, ne - 1));
          break;
        case "PageUp":
          h.value === "day" && (ee.preventDefault(), P());
          break;
        case "PageDown":
          h.value === "day" && (ee.preventDefault(), K());
          break;
        case "Enter":
        case " ":
          ee.preventDefault(), me(O[fe]);
          break;
      }
    }
    function V() {
      l("update:open", !1), l("close");
    }
    function Q(ee) {
      o.value = /* @__PURE__ */ new Date(), h.value = a.mode;
      const O = s(ee);
      u.value = O.year, f.value = O.month, b.value = O.day, p.value = O.year - O.year % 12, Z();
    }
    $e(
      () => a.open,
      (ee) => {
        ee ? (Q(), a.autoFocusOnOpen && Ue(() => se(ye.value))) : E.value = null;
      },
      { immediate: !0 }
    ), $e(h, async () => {
      var ee;
      await Ue(), (ee = ge.value) == null || ee.updatePosition();
    });
    async function le(ee) {
      Q(ee), await Ue(), se(ye.value);
    }
    return n({ focusGrid: le, reseedVisibleGrid: Q }), (ee, O) => (c(), H(Mv, {
      id: e.id,
      ref_key: "panelComponent",
      ref: ge,
      open: e.open,
      "anchor-el": e.anchorEl,
      "additional-anchor-els": e.additionalAnchorEls,
      "dialog-label": e.dialogLabel,
      "test-id": "datepicker-dropdown-menu",
      "width-class": "w-[292px]",
      placement: e.placement,
      "keep-anchor-focusable": e.keepAnchorFocusable,
      "onUpdate:open": O[2] || (O[2] = (ne) => l("update:open", ne)),
      onClose: O[3] || (O[3] = (ne) => l("close"))
    }, ta({
      default: xe(() => [
        v("div", {
          ref_key: "contentRef",
          ref: de,
          class: "contents"
        }, [
          re(Az, {
            label: X.value,
            "previous-label": e.previousLabel,
            "next-label": e.nextLabel,
            "label-disabled": _.value,
            "previous-disabled": Y.value,
            "next-disabled": B.value,
            onPrev: P,
            onNext: K,
            onDrillUp: j
          }, null, 8, ["label", "previous-label", "next-label", "label-disabled", "previous-disabled", "next-disabled"]),
          h.value === "day" ? (c(), g("div", Dz, [
            v("div", {
              role: "grid",
              class: "flex flex-col gap-0.5",
              onKeydown: Se
            }, [
              v("div", Mz, [
                (c(!0), g(ce, null, Re(e.weekdayLabels, (ne, fe) => (c(), g("span", {
                  key: fe,
                  role: "columnheader",
                  "data-testid": "datepicker-weekday-header",
                  class: "w-9 flex-1 text-center text-(length:--size-sm) font-(--weight-medium) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                }, N(ne), 1))), 128))
              ]),
              (c(!0), g(ce, null, Re(S.value, (ne, fe) => (c(), g("div", {
                key: fe,
                role: "row",
                "data-testid": "datepicker-day-row",
                class: "flex items-center"
              }, [
                (c(!0), g(ce, null, Re(ne, ({ cell: ue, index: te }) => (c(), H(Dr, {
                  key: ue.iso,
                  type: "Day",
                  state: A(ue),
                  text: ue.label,
                  muted: !ue.inMonth,
                  role: "gridcell",
                  tabindex: te === ye.value ? 0 : -1,
                  "aria-selected": I(D).has(ue.state) ? "true" : void 0,
                  "aria-label": M(ue),
                  onClick: (oe) => me(ue),
                  onMouseover: (oe) => E.value = ue.iso,
                  onMouseout: O[0] || (O[0] = (oe) => E.value = null)
                }, null, 8, ["state", "text", "muted", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
              ]))), 128))
            ], 32)
          ])) : (c(), g("div", {
            key: 1,
            role: "grid",
            class: "flex w-[252px] flex-col gap-1.5",
            onKeydown: Se
          }, [
            (c(!0), g(ce, null, Re(T.value, (ne, fe) => (c(), g("div", {
              key: fe,
              role: "row",
              "data-testid": "datepicker-grid-row",
              class: "flex gap-1.5"
            }, [
              (c(!0), g(ce, null, Re(ne, ({ cell: ue, index: te }) => (c(), H(Dr, {
                key: ue.iso,
                type: h.value === "month" ? "Month" : "Year",
                state: A(ue),
                text: ue.label,
                role: "gridcell",
                tabindex: te === ye.value ? 0 : -1,
                "aria-selected": I(D).has(ue.state) ? "true" : void 0,
                "aria-label": h.value === "month" ? F(ue) : ue.state === "Disabled" ? `${ue.label}, ${e.unavailableLabel}` : ue.label,
                onClick: (oe) => me(ue),
                onMouseover: (oe) => E.value = ue.iso,
                onMouseout: O[1] || (O[1] = (oe) => E.value = null)
              }, null, 8, ["type", "state", "text", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
            ]))), 128))
          ], 32))
        ], 512)
      ]),
      _: 2
    }, [
      e.showClearButton || e.showTodayButton ? {
        name: "actions",
        fn: xe(() => [
          e.showClearButton ? (c(), H(Be, {
            key: 0,
            variant: "secondary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.clearLabel,
            "data-testid": "datepicker-dropdown-menu-clear",
            onClick: G
          }, null, 8, ["label"])) : k("", !0),
          e.showTodayButton ? (c(), H(Be, {
            key: 1,
            variant: "primary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.todayLabel,
            disabled: W.value,
            "data-testid": "datepicker-dropdown-menu-today",
            onClick: q
          }, null, 8, ["label", "disabled"])) : k("", !0)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "open", "anchor-el", "additional-anchor-els", "dialog-label", "placement", "keep-anchor-focusable"]));
  }
}), zz = {
  en: "mm/yyyy",
  fr: "mm/yyyy",
  nl: "mm-yyyy"
};
function Oz(e) {
  return e ?? "";
}
function Pz(e) {
  return /^\d{4}$/.test(e) ? e : void 0;
}
function zv(e) {
  return e.replace(/[my]/g, "");
}
function Fz(e, n) {
  if (!e) return "";
  const [t, a] = e.split("-");
  return `${a}${zv(n)}${t}`;
}
function Vz(e, n) {
  const t = zv(n), [a, l] = e.split(t);
  if (!a || !l || !/^\d{2}$/.test(a) || !/^\d{4}$/.test(l)) return;
  const r = Number(a);
  if (!(r < 1 || r > 12))
    return `${l}-${a}`;
}
function hn(e, n) {
  if (!e) return "";
  const [t, a, l] = e.split("-");
  return !t || !a || !l ? "" : n.replace(/y+/, t).replace(/m+/, a).replace(/d+/, l);
}
function Nz(e) {
  const n = e.match(/([dmy])\1*|[^dmy]+/g) ?? [], t = [];
  let a = "^";
  for (const r of n)
    /^[dmy]+$/.test(r) ? (t.push({ field: r[0], length: r.length }), a += r.length > 1 ? `(\\d{${r.length}})` : "(\\d{1,2})") : a += r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  a += "$";
  const l = t.map((r) => r.field);
  if (l.filter((r) => r === "d").length === 1 && l.filter((r) => r === "m").length === 1 && l.filter((r) => r === "y").length === 1)
    return { tokens: t, regex: new RegExp(a) };
}
function Ft(e, n) {
  const t = Nz(n);
  if (!t) return;
  const a = t.regex.exec(e);
  if (!a) return;
  let l, r, o;
  if (t.tokens.forEach((s, d) => {
    const u = Number(a[d + 1]);
    s.field === "d" ? l = u : s.field === "m" ? r = u : o = u;
  }), l === void 0 || r === void 0 || o === void 0 || r < 1 || r > 12) return;
  const i = new Date(o, r, 0).getDate();
  if (!(l < 1 || l > i))
    return `${String(o).padStart(4, "0")}-${String(r).padStart(2, "0")}-${String(l).padStart(2, "0")}`;
}
function bu(e) {
  const { inputRef: n, format: t, maskEnabled: a, disabled: l, readonly: r, onAccept: o, resolveRevertValue: i, resolveResyncValue: s } = e;
  let d = null, u = null, f = 0, b = !1;
  const h = R(!1), p = R(!1), x = R(!1), y = R(e.initialDisplayValue), w = m(() => a.value ? Lv(t.value) : null), $ = () => {
    if (!u || !n.value || w.value === null) return;
    S();
    const B = y.value || n.value.value;
    d = u(n.value, { mask: w.value, lazy: !0 }), d.value = B ?? "", x.value = !0, d.on("accept", () => {
      if (!d) return;
      const W = b;
      if (b = !1, r.value || l.value) {
        const z = i();
        d.value = z, y.value = z;
        return;
      }
      const U = d.value;
      y.value = U, !W && o(U);
    });
  }, S = () => {
    d == null || d.destroy(), d = null, x.value = !1;
  };
  dt(async () => {
    if (n.value && w.value !== null) {
      const B = ++f;
      if (u = (await import("./index-CZ98n4Cf.js")).default, !n.value || B !== f) return;
      $();
    }
  }), gt(() => {
    S();
  }), $e(w, async (B) => {
    const W = ++f;
    S(), B !== null && (u || (u = (await import("./index-CZ98n4Cf.js")).default), W === f && $());
  });
  const L = () => {
    l.value || (p.value = !0);
  }, T = () => {
    p.value = !1;
  }, E = () => {
    l.value || (h.value = !0);
  }, A = (B) => {
    y.value = B, d && (b = !0, d.value = B, b = !1);
  }, D = () => {
    h.value = !1, A(s());
  }, M = (B) => {
    if (d) return;
    const W = B.target.value;
    y.value = W, o(W);
  }, F = (B) => {
    d ? d.value = B : (y.value = B, o(B));
  };
  let X = !1;
  return {
    displayValue: y,
    isFocused: h,
    isHovered: p,
    datePattern: w,
    isMaskAttached: x,
    handleMouseEnter: L,
    handleMouseLeave: T,
    handleFocus: E,
    handleBlur: D,
    handleInput: M,
    setValue: F,
    syncDisplayValue: A,
    armMouseDown: (B) => {
      X = B;
    },
    consumeClick: () => {
      const B = X;
      return X = !1, B;
    }
  };
}
const Ov = {
  weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  monthLabels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthShortLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  clearLabel: "Clear",
  todayLabel: "Today",
  previousLabel: "Previous month",
  nextLabel: "Next month",
  unavailableLabel: "Unavailable",
  dialogLabel: "Choose date",
  rangeStartLabel: "start of selected range",
  rangeEndLabel: "end of selected range",
  rangeBetweenLabel: "in selected range",
  rangeDialogLabel: "Choose date range",
  clearStartLabel: "Clear start date",
  clearEndLabel: "Clear end date"
}, Pv = {
  fr: {
    weekdayLabels: ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
    monthLabels: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    monthShortLabels: [
      "janv.",
      "févr.",
      "mars",
      "avril",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    clearLabel: "Effacer",
    todayLabel: "Aujourd'hui",
    previousLabel: "Mois précédent",
    nextLabel: "Mois suivant",
    unavailableLabel: "Indisponible",
    dialogLabel: "Choisir une date",
    rangeStartLabel: "début de la période sélectionnée",
    rangeEndLabel: "fin de la période sélectionnée",
    rangeBetweenLabel: "dans la période sélectionnée",
    rangeDialogLabel: "Choisir une période",
    clearStartLabel: "Effacer la date de début",
    clearEndLabel: "Effacer la date de fin"
  },
  nl: {
    weekdayLabels: ["ma", "di", "wo", "do", "vr", "za", "zo"],
    monthLabels: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthShortLabels: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    clearLabel: "Wissen",
    todayLabel: "Vandaag",
    previousLabel: "Vorige maand",
    nextLabel: "Volgende maand",
    unavailableLabel: "Niet beschikbaar",
    dialogLabel: "Kies een datum",
    rangeStartLabel: "begin van de geselecteerde periode",
    rangeEndLabel: "einde van de geselecteerde periode",
    rangeBetweenLabel: "in de geselecteerde periode",
    rangeDialogLabel: "Kies een periode",
    clearStartLabel: "Startdatum wissen",
    clearEndLabel: "Einddatum wissen"
  }
}, Hz = ["id", "name", "inputmode", "value", "placeholder", "disabled", "readonly", "autocomplete", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "aria-expanded", "aria-controls", "data-testid"], gu = /* @__PURE__ */ ke({
  __name: "DatePickerInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    autohide: { type: Boolean, default: !0 },
    buttons: { type: Boolean, default: !0 },
    orientation: { default: "auto" },
    weekStart: { default: 1 },
    language: { default: "en" },
    title: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    showHint: { type: Boolean, default: !0 },
    labelInline: { type: Boolean, default: !1 },
    id: { default: void 0 },
    name: { default: void 0 },
    autocomplete: { default: void 0 },
    testId: { default: void 0 },
    maskInput: { type: Boolean, default: !0 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "default" },
    dobLabels: { default: void 0 },
    dobDefaultDate: { default: void 0 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue", "changeDate", "show", "hide"],
  setup(e, { emit: n }) {
    var ve;
    const t = e, a = n, l = R(null), r = R(null), o = R(null), i = m(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), s = m(() => !!t.error), d = je(), u = m(() => t.id || d), f = m(() => t.label ? `${u.value}-label` : void 0), b = m(() => `${u.value}-error`), h = m(() => `${u.value}-hint`), p = m(() => t.language.slice(0, 2).toLowerCase()), x = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, y = m(() => t.format !== void 0 ? t.format : x[p.value] ?? "dd/mm/yyyy"), w = m(
      () => t.labels ?? Pv[p.value] ?? Ov
    ), $ = m(
      () => t.minDate ? Ft(t.minDate, y.value) ?? t.minDate : void 0
    ), S = m(
      () => t.maxDate ? Ft(t.maxDate, y.value) ?? t.maxDate : void 0
    ), L = {
      fr: { d: "j", y: "a" },
      // jour / année
      nl: { y: "j" }
      // jaar
    }, T = m(() => {
      const we = L[p.value];
      return we ? y.value.replace(/d+|m+|y+/g, (he) => {
        const Me = we[he[0]];
        return Me ? Me.repeat(he.length) : he;
      }) : y.value;
    }), E = m(() => {
      var he;
      const we = (he = t.hint) == null ? void 0 : he.trim();
      return we && we.length > 0 ? we : s.value ? void 0 : T.value;
    }), A = m(() => {
      var he;
      const we = (he = t.placeholder) == null ? void 0 : he.trim();
      return we && we.length > 0 ? we : T.value;
    }), D = m(() => {
      const we = [];
      return t.showHint && E.value && we.push(h.value), s.value && we.push(b.value), we.length > 0 ? we.join(" ") : void 0;
    }), M = m(() => s.value ? "true" : void 0), F = m(() => {
      const we = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Ee = P.isFocused.value ? "shadow-[0px_0px_2px_var(--border-border-accent)] border-(--border-border-accent)" : "shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${we} border-[1px] ${Ee} bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (s.value)
        return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (P.isFocused.value)
        return `${we} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (P.isHovered.value)
        return `${we} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const he = i.value ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${he} dark:text-(--text-text-white-default)`;
    }), _ = {
      sm: {
        container: "h-[32px] px-2 py-1.5 gap-2",
        text: "text-sm leading-5"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5"
      },
      lg: {
        container: "h-[48px] px-3.5 py-3 gap-2",
        text: "text-base leading-6"
      },
      xl: {
        container: "h-[52px] px-4 py-3.5 gap-2",
        text: "text-base leading-6"
      }
    }[t.size], Y = m(() => t.fullWidth ? "w-full" : ""), B = m(() => t.fullWidth ? {} : { width: t.width }), W = m(() => {
      const we = "relative flex pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return t.labelInline ? `${we} flex-row items-center gap-2${t.fullWidth ? " w-full" : ""}` : `${we} flex-col items-start gap-0.5${t.fullWidth ? " w-full" : ""}`;
    }), U = m(() => t.fullWidth || t.labelInline ? {} : { width: t.width });
    function z(we) {
      if (we === "") {
        t.modelValue && a("update:modelValue", "");
        return;
      }
      const he = Ft(we, y.value);
      he !== void 0 && he !== t.modelValue && a("update:modelValue", he);
    }
    const P = bu({
      inputRef: l,
      format: y,
      maskEnabled: m(() => t.maskInput),
      disabled: wn(t, "disabled"),
      readonly: wn(t, "readonly"),
      initialDisplayValue: t.type === "dob" ? hn(t.modelValue, y.value) : t.modelValue,
      onAccept: (we) => {
        if (t.type === "dob") {
          z(we);
          return;
        }
        (!P.isMaskAttached.value || we === "" || Ft(we, y.value) !== void 0) && we !== t.modelValue && a("update:modelValue", we);
      },
      resolveRevertValue: () => t.type === "dob" ? hn(t.modelValue, y.value) : t.modelValue ?? "",
      resolveResyncValue: () => t.type === "dob" ? hn(t.modelValue, y.value) : t.modelValue
    });
    $e(
      () => t.modelValue,
      (we) => {
        if (P.isFocused.value) return;
        const he = t.type === "dob" ? hn(we, y.value) : we;
        P.syncDisplayValue(he);
      }
    ), $e([y, p], ([we], [he]) => {
      if (t.type === "dob" && !P.isFocused.value && P.syncDisplayValue(hn(t.modelValue, we)), t.type === "default" && !P.isFocused.value && we !== he) {
        const Me = Ft(P.displayValue.value, he);
        Me !== void 0 && P.syncDisplayValue(hn(Me, we));
      }
    });
    const K = R(!1), j = R(!1), G = m(() => `${u.value}-dob-dialog`), q = R(null), J = typeof process < "u" && ((ve = process.env) == null ? void 0 : ve.NODE_ENV) !== "production";
    function me() {
      if (!(t.type !== "dob" || t.disabled || t.readonly) && !K.value) {
        if (!t.dobLabels) {
          J && console.error(
            '[OPAL DatePickerInput] type="dob" requires the `dobLabels` prop (see DatepickerDobLabels) — the wheel picker was not opened.'
          );
          return;
        }
        K.value = !0, j.value = !0, a("show");
      }
    }
    function ye(we) {
      P.setValue(hn(we, y.value)), a("changeDate", we);
    }
    function Z() {
      P.setValue(""), a("changeDate", "");
    }
    function de() {
      var we;
      K.value = !1, a("hide"), (we = l.value) == null || we.focus();
    }
    const ge = R(!1), se = R(!1), Se = m(() => `${u.value}-default-dialog`), V = R(null), Q = R(!0), le = m(
      () => Ft(P.displayValue.value, y.value) ?? ""
    ), ee = m(() => {
      const we = t.orientation.includes("right") ? "end" : "start";
      return `${t.orientation.includes("top") ? "top" : "bottom"}-${we}`;
    });
    function O() {
      t.type !== "default" || t.disabled || t.readonly || ge.value || (ge.value = !0, se.value = !0, a("show"));
    }
    function ne(we) {
      const he = hn(we, y.value);
      P.setValue(he), a("changeDate", he);
    }
    function fe() {
      P.setValue(""), a("changeDate", "");
    }
    function ue() {
      var we;
      ge.value = !1, a("hide"), (we = l.value) == null || we.focus();
    }
    function te() {
      t.type === "dob" ? me() : O();
    }
    function oe() {
      P.armMouseDown(t.type === "dob" ? K.value : ge.value);
    }
    function Le() {
      var we;
      t.disabled || t.readonly || P.consumeClick() || (Q.value = !1, te(), (we = l.value) == null || we.focus());
    }
    function Ie(we) {
      var he, Me, Ee, He;
      if (!K.value && !ge.value && ((he = r.value) == null || he.handleFieldKeydown(we), (Me = o.value) == null || Me.handleFieldKeydown(we)), !(t.disabled || t.readonly)) {
        if (we.key === "Enter") {
          K.value ? de() : ge.value && ue();
          const Ge = Xo(), Ze = ($.value === void 0 || Cn(Ge, $.value) >= 0) && (S.value === void 0 || Cn(Ge, S.value) <= 0);
          (P.displayValue.value ?? "").trim() === "" && Ze && (t.type === "dob" ? ye(Ge) : ne(Ge));
          return;
        }
        if (we.key === "ArrowDown") {
          if (we.preventDefault(), K.value) {
            (Ee = q.value) == null || Ee.focusYearColumn();
            return;
          }
          if (ge.value) {
            (He = V.value) == null || He.focusGrid();
            return;
          }
          Q.value = !0, te();
        }
      }
    }
    return (we, he) => (c(), g("div", {
      class: C(W.value),
      style: Ne(U.value),
      "data-testid": "date-picker-wrapper"
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: f.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": u.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: I(P).isFocused.value,
        inline: e.labelInline,
        class: C(e.labelInline ? "" : "order-1"),
        "test-id": "date-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      v("div", {
        class: C(e.labelInline ? "flex flex-col gap-0.5" : "contents")
      }, [
        re(xt, {
          ref_key: "helperRef",
          ref: o,
          focused: I(P).isFocused.value,
          class: "order-3",
          hint: e.showHint ? E.value : void 0,
          error: e.error,
          "hint-id": h.value,
          "error-id": b.value,
          "error-live": e.errorLive,
          "test-id-prefix": "date-picker"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "error-live"]),
        v("div", {
          class: C([F.value, I(_).container, Y.value, "order-2"]),
          style: Ne(B.value),
          "data-testid": "date-picker-container",
          onMouseenter: he[3] || (he[3] = //@ts-ignore
          (...Me) => I(P).handleMouseEnter && I(P).handleMouseEnter(...Me)),
          onMouseleave: he[4] || (he[4] = //@ts-ignore
          (...Me) => I(P).handleMouseLeave && I(P).handleMouseLeave(...Me)),
          onMousedown: oe,
          onClick: Le
        }, [
          v("i", {
            "aria-hidden": "true",
            "data-testid": "date-picker-calendar-icon",
            class: C([
              "ri-calendar-line",
              I(_).text,
              e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            ])
          }, null, 2),
          v("input", {
            id: u.value,
            ref_key: "inputRef",
            ref: l,
            name: e.name,
            type: "text",
            inputmode: I(P).datePattern.value ? "numeric" : void 0,
            value: I(P).displayValue.value,
            placeholder: A.value,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete ?? "off",
            "aria-labelledby": f.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-invalid": M.value,
            "aria-describedby": D.value,
            "aria-required": e.required ? "true" : void 0,
            role: "combobox",
            "aria-haspopup": "dialog",
            "aria-expanded": e.type === "dob" ? K.value : ge.value,
            "aria-controls": e.type === "dob" ? j.value ? G.value : void 0 : se.value ? Se.value : void 0,
            "data-testid": e.testId ?? "date-picker-input",
            class: C([
              "flex-1 min-w-0 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) pl-0",
              !e.disabled && !e.readonly && "cursor-text",
              I(_).text
            ]),
            onFocus: he[0] || (he[0] = //@ts-ignore
            (...Me) => I(P).handleFocus && I(P).handleFocus(...Me)),
            onBlur: he[1] || (he[1] = //@ts-ignore
            (...Me) => I(P).handleBlur && I(P).handleBlur(...Me)),
            onInput: he[2] || (he[2] = //@ts-ignore
            (...Me) => I(P).handleInput && I(P).handleInput(...Me)),
            onKeydown: Ie
          }, null, 42, Hz)
        ], 38)
      ], 2),
      e.type === "dob" && l.value && j.value ? (c(), H(Iz, Oe({ key: 1 }, e.dobLabels, {
        id: G.value,
        ref_key: "dobPickerRef",
        ref: q,
        open: K.value,
        "model-value": e.modelValue,
        "anchor-el": l.value,
        "auto-focus-on-open": Q.value,
        "min-date": $.value,
        "max-date": S.value,
        "default-date": e.dobDefaultDate,
        "onUpdate:open": he[5] || (he[5] = (Me) => K.value = Me),
        "onUpdate:modelValue": ye,
        onClear: Z,
        onClose: de
      }), null, 16, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "default-date"])) : k("", !0),
      e.type === "default" && l.value && se.value ? (c(), H(jc, {
        key: 2,
        id: Se.value,
        ref_key: "defaultDropdownMenuRef",
        ref: V,
        open: ge.value,
        "model-value": le.value,
        "anchor-el": l.value,
        "keep-anchor-focusable": "",
        "auto-focus-on-open": Q.value,
        "min-date": $.value,
        "max-date": S.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        placement: ee.value,
        "weekday-labels": w.value.weekdayLabels,
        "month-labels": w.value.monthLabels,
        "month-short-labels": w.value.monthShortLabels,
        "clear-label": w.value.clearLabel,
        "today-label": w.value.todayLabel,
        "previous-label": w.value.previousLabel,
        "next-label": w.value.nextLabel,
        "unavailable-label": w.value.unavailableLabel,
        "dialog-label": w.value.dialogLabel,
        "onUpdate:open": he[6] || (he[6] = (Me) => ge.value = Me),
        "onUpdate:modelValue": ne,
        onClear: fe,
        onClose: ue
      }, null, 8, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "show-today-button", "show-clear-button", "placement", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : k("", !0)
    ], 6));
  }
}), jz = { class: "relative flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter" }, Wz = ["id", "inputmode", "value", "disabled", "aria-labelledby", "aria-required", "aria-invalid", "aria-describedby", "aria-expanded", "data-testid"], mq = /* @__PURE__ */ ke({
  __name: "YearMonthPickerInput",
  props: {
    type: {},
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    showTodayButton: { type: Boolean, default: !1 },
    todayButtonMode: { default: "highlight" },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    dialogLabel: {},
    testId: { default: void 0 }
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.language.slice(0, 2).toLowerCase()), r = m(() => zz[l.value] ?? "mm/yyyy"), o = m(() => t.type === "year" ? "yyyy" : r.value), i = m(() => Lv(o.value));
    function s(q) {
      return t.type === "year" ? Oz(q) : Fz(q, r.value);
    }
    function d(q) {
      return t.type === "year" ? Pz(q) : Vz(q, r.value);
    }
    const u = R(null), f = R(null), b = R(!1), h = R(!1), p = R(null), x = R(null), y = R(s(t.modelValue));
    let w = null, $ = null, S = 0;
    function L() {
      w == null || w.destroy(), w = null;
    }
    function T() {
      !$ || !u.value || i.value === null || (L(), w = $(u.value, { mask: i.value, lazy: !0 }), w.value = y.value, w.on("accept", () => {
        if (!w) return;
        const q = w.value;
        if (y.value = q, q === "") {
          t.modelValue !== "" && a("update:modelValue", "");
          return;
        }
        const J = d(q);
        J !== void 0 && J !== t.modelValue && a("update:modelValue", J);
      }));
    }
    dt(async () => {
      if (!u.value || i.value === null) return;
      const q = ++S;
      $ = (await import("./index-CZ98n4Cf.js")).default, !(!u.value || q !== S) && T();
    }), gt(() => {
      L();
    }), $e(
      () => t.modelValue,
      (q) => {
        if (h.value) return;
        const J = s(q);
        y.value = J, w && (w.value = J);
      }
    ), $e([i], async () => {
      const q = ++S;
      L(), i.value !== null && ($ || ($ = (await import("./index-CZ98n4Cf.js")).default), q === S && T());
    });
    function E() {
      t.disabled || (h.value = !0);
    }
    function A() {
      h.value = !1;
      const q = s(t.modelValue);
      y.value = q, w && (w.value = q);
    }
    function D(q) {
      if (w) return;
      const J = q.target.value;
      y.value = J;
      const me = d(J);
      me !== void 0 && a("update:modelValue", me);
    }
    function M() {
      t.disabled || (b.value = !0);
    }
    function F(q) {
      var J, me;
      b.value || ((J = p.value) == null || J.handleFieldKeydown(q), (me = x.value) == null || me.handleFieldKeydown(q)), !(q.key !== "Enter" && q.key !== " " && q.key !== "ArrowDown") && (q.preventDefault(), M());
    }
    function X(q) {
      a("select", q);
    }
    function _() {
      var q;
      (q = u.value) == null || q.focus();
    }
    const B = je(), W = m(() => t.label ? `${B}-label` : void 0), U = `${B}-dialog`, z = `${B}-hint`, P = `${B}-error`, K = m(() => {
      const q = [];
      return t.hint && q.push(z), t.error && q.push(P), q.length > 0 ? q.join(" ") : void 0;
    }), j = m(() => t.disabled ? "border-border-disabled-subtle bg-gainsboro-200 dark:border-(--colors-border-disabled-subtle) dark:bg-(--colors-background-disabled)" : t.error ? "border-(--border-border-error-strong) bg-(--background-background-white) dark:border-(--border-border-error) dark:bg-(--background-background-black-default)" : "border-(--border-border-base-medium) bg-(--background-background-white) dark:border-(--border-border-base) dark:bg-(--background-background-black-default)"), G = m(
      () => t.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    return (q, J) => (c(), g("div", jz, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: W.value,
        ref_key: "labelRef",
        ref: p,
        text: e.label,
        "input-id": I(B),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: h.value,
        "test-id": "year-month-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      v("div", {
        ref_key: "triggerRef",
        ref: f,
        class: C([
          "relative flex h-[36px] items-center gap-2 rounded-xl border-[1px] border-solid px-3 py-2",
          j.value
        ])
      }, [
        v("i", {
          "aria-hidden": "true",
          class: C(["ri-calendar-line text-sm", G.value])
        }, null, 2),
        v("input", {
          id: I(B),
          ref_key: "inputRef",
          ref: u,
          type: "text",
          inputmode: i.value ? "numeric" : void 0,
          value: y.value,
          disabled: e.disabled,
          "aria-labelledby": W.value,
          "aria-required": e.required ? "true" : void 0,
          "aria-invalid": e.error ? "true" : void 0,
          "aria-describedby": K.value,
          "aria-haspopup": "dialog",
          "aria-expanded": b.value,
          "aria-controls": U,
          "data-testid": e.testId ?? "year-month-picker-input",
          class: "min-w-0 flex-1 border-0 bg-transparent text-(length:--size-m) leading-(--line-height-l) outline-none placeholder:text-text-body-subtle focus:outline-none focus:ring-0",
          onFocus: E,
          onBlur: A,
          onInput: D,
          onClick: M,
          onKeydown: F
        }, null, 40, Wz)
      ], 2),
      re(xt, {
        ref_key: "helperRef",
        ref: x,
        class: "self-stretch",
        focused: h.value,
        hint: e.hint,
        error: e.error,
        "hint-id": z,
        "error-id": P,
        "error-live": e.errorLive,
        "test-id-prefix": "year-month-picker"
      }, null, 8, ["focused", "hint", "error", "error-live"]),
      f.value ? (c(), H(jc, {
        key: 1,
        id: U,
        open: b.value,
        "onUpdate:open": J[0] || (J[0] = (me) => b.value = me),
        "model-value": e.modelValue,
        "anchor-el": f.value,
        mode: e.type,
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "show-today-button": e.showTodayButton,
        "today-button-mode": e.todayButtonMode,
        "weekday-labels": e.weekdayLabels,
        "month-labels": e.monthLabels,
        "month-short-labels": e.monthShortLabels,
        "clear-label": e.clearLabel,
        "today-label": e.todayLabel,
        "previous-label": e.previousLabel,
        "next-label": e.nextLabel,
        "unavailable-label": e.unavailableLabel,
        "dialog-label": e.dialogLabel,
        "onUpdate:modelValue": J[1] || (J[1] = (me) => a("update:modelValue", me)),
        onSelect: X,
        onClear: J[2] || (J[2] = (me) => a("update:modelValue", "")),
        onClose: _
      }, null, 8, ["open", "model-value", "anchor-el", "mode", "min-date", "max-date", "show-today-button", "today-button-mode", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : k("", !0)
    ]));
  }
}), qz = {
  class: "flex flex-col gap-0.5 pb-0.5",
  "data-testid": "date-range-wrapper"
}, Uz = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], Gz = ["aria-label"], Kz = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], Yz = ["aria-label"], Jz = /* @__PURE__ */ ke({
  __name: "DateRangePickerInput",
  props: {
    startDate: { default: "" },
    endDate: { default: "" },
    startLabel: { default: "From" },
    endLabel: { default: "To" },
    startPlaceholder: { default: "Select date start" },
    endPlaceholder: { default: "Select date end" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    buttons: { type: Boolean, default: !0 },
    weekStart: { default: 1 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    readonly: { type: Boolean, default: !0 },
    labels: { default: void 0 }
  },
  emits: ["update:startDate", "update:endDate", "changeDate"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(null), r = R(null), o = je(), i = m(() => t.language.slice(0, 2).toLowerCase()), s = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, d = m(() => t.format !== void 0 ? t.format : s[i.value] ?? "mm/dd/yyyy"), u = m(
      () => t.labels ?? Pv[i.value] ?? Ov
    ), f = m(() => !!t.error), b = je(), h = m(() => `${b}-start-input`), p = m(() => `${b}-end-input`), x = m(() => t.startLabel ? `${b}-start-label` : void 0), y = m(() => t.endLabel ? `${b}-end-label` : void 0), w = m(() => `${b}-hint`), $ = R(null), S = R(null), L = R(null), T = m(() => `${b}-error`), E = m(() => {
      const ve = [];
      return t.hint && ve.push(w.value), f.value && ve.push(T.value), ve.length > 0 ? ve.join(" ") : void 0;
    }), A = R(!1), D = R(null), M = R(null), F = R("start"), X = R("start"), _ = R(!1), Y = R(!0), B = bu({
      inputRef: l,
      format: d,
      maskEnabled: m(() => !t.readonly),
      disabled: wn(t, "disabled"),
      readonly: wn(t, "readonly"),
      initialDisplayValue: t.startDate,
      onAccept: (ve) => {
        if (ve === "") {
          t.startDate !== "" && (a("update:startDate", ""), a("changeDate", { startDate: "", endDate: W.displayValue.value }));
          return;
        }
        Ft(ve, d.value) !== void 0 && ve !== t.startDate && (a("update:startDate", ve), a("changeDate", { startDate: ve, endDate: W.displayValue.value }));
      },
      resolveRevertValue: () => t.startDate,
      resolveResyncValue: () => t.startDate
    }), W = bu({
      inputRef: r,
      format: d,
      maskEnabled: m(() => !t.readonly),
      disabled: wn(t, "disabled"),
      readonly: wn(t, "readonly"),
      initialDisplayValue: t.endDate,
      onAccept: (ve) => {
        if (ve === "") {
          t.endDate !== "" && (a("update:endDate", ""), a("changeDate", { startDate: B.displayValue.value, endDate: "" }));
          return;
        }
        Ft(ve, d.value) !== void 0 && ve !== t.endDate && (a("update:endDate", ve), a("changeDate", { startDate: B.displayValue.value, endDate: ve }));
      },
      resolveRevertValue: () => t.endDate,
      resolveResyncValue: () => t.endDate
    });
    $e(
      () => t.startDate,
      (ve) => {
        B.isFocused.value || B.syncDisplayValue(ve);
      }
    ), $e(
      () => t.endDate,
      (ve) => {
        W.isFocused.value || W.syncDisplayValue(ve);
      }
    ), $e([d], ([ve], [we]) => {
      if (ve !== we) {
        if (!B.isFocused.value) {
          const he = Ft(B.displayValue.value, we);
          he !== void 0 && B.syncDisplayValue(hn(he, ve));
        }
        if (!W.isFocused.value) {
          const he = Ft(W.displayValue.value, we);
          he !== void 0 && W.syncDisplayValue(hn(he, ve));
        }
      }
    });
    const U = (ve, we, he) => {
      const Me = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      return t.disabled ? `${Me} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : f.value ? `${Me} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : ve || we ? `${Me} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : `${Me} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${he ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)"} dark:text-(--text-text-white-default)`;
    }, z = m(
      () => U(B.isFocused.value, B.isHovered.value, !!t.startDate)
    ), P = m(
      () => U(W.isFocused.value, W.isHovered.value, !!t.endDate)
    ), j = {
      sm: { container: "h-[32px] px-2 py-1.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 py-3 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 py-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }[t.size], G = m(
      () => t.fullWidth ? "flex flex-col items-start gap-0.5 flex-1 min-w-0" : "flex flex-col items-start gap-0.5"
    ), q = m(() => t.fullWidth ? "w-full" : "w-[180px]"), J = m(
      () => t.fullWidth ? "flex flex-row gap-4 w-full" : "flex flex-row gap-4"
    ), me = m(() => Ft(t.startDate, d.value) ?? ""), ye = m(() => Ft(t.endDate, d.value) ?? ""), Z = m(
      () => t.minDate ? Ft(t.minDate, d.value) ?? t.minDate : void 0
    ), de = m(
      () => t.maxDate ? Ft(t.maxDate, d.value) ?? t.maxDate : void 0
    );
    function ge() {
      const ve = Xo();
      return (Z.value === void 0 || Cn(ve, Z.value) >= 0) && (de.value === void 0 || Cn(ve, de.value) <= 0);
    }
    function se(ve) {
      var Me;
      D.value = ve;
      const we = ve === r.value ? "end" : "start";
      X.value = we;
      const he = we === "end" ? t.endDate !== "" : t.startDate !== "";
      _.value = he, F.value = _.value ? we : t.startDate === "" ? "start" : "end", A.value = !0, (Me = M.value) == null || Me.reseedVisibleGrid(we);
    }
    function Se() {
      B.armMouseDown(A.value && D.value === l.value);
    }
    function V() {
      var ve;
      t.disabled || B.consumeClick() || (Y.value = !1, se(l.value), (ve = l.value) == null || ve.focus());
    }
    function Q(ve) {
      var he;
      if (t.disabled) return;
      ve.preventDefault();
      const we = A.value;
      Y.value = !0, se(l.value), we && ((he = M.value) == null || he.focusGrid("start"));
    }
    function le(ve) {
      var he, Me;
      if (A.value || ((he = $.value) == null || he.handleFieldKeydown(ve), (Me = L.value) == null || Me.handleFieldKeydown(ve)), ve.key === "ArrowDown") {
        Q(ve);
        return;
      }
      if (ve.key !== "Enter" || t.disabled || t.readonly) return;
      A.value && (A.value = !1), B.displayValue.value.trim() === "" && ge() && B.setValue(hn(Xo(), d.value));
    }
    function ee() {
      W.armMouseDown(A.value && D.value === r.value);
    }
    function O() {
      var ve;
      t.disabled || W.consumeClick() || (Y.value = !1, se(r.value), (ve = r.value) == null || ve.focus());
    }
    function ne(ve) {
      var he;
      if (t.disabled) return;
      ve.preventDefault();
      const we = A.value;
      Y.value = !0, se(r.value), we && ((he = M.value) == null || he.focusGrid("end"));
    }
    function fe(ve) {
      var he, Me;
      if (A.value || ((he = S.value) == null || he.handleFieldKeydown(ve), (Me = L.value) == null || Me.handleFieldKeydown(ve)), ve.key === "ArrowDown") {
        ne(ve);
        return;
      }
      if (ve.key !== "Enter" || t.disabled || t.readonly) return;
      A.value && (A.value = !1), W.displayValue.value.trim() === "" && ge() && W.setValue(hn(Xo(), d.value));
    }
    function ue(ve) {
      const we = hn(ve, d.value);
      if (_.value) {
        if (F.value === "start") {
          B.setValue(we);
          const Me = Ft(t.endDate, d.value);
          Me !== void 0 && ve > Me && W.setValue("");
        } else {
          W.setValue(we);
          const Me = Ft(t.startDate, d.value);
          Me !== void 0 && ve < Me && B.setValue("");
        }
        A.value = !1;
        return;
      }
      if (F.value === "start") {
        B.setValue(we);
        const Me = Ft(t.endDate, d.value);
        Me !== void 0 && ve > Me && W.setValue(""), F.value = "end";
        return;
      }
      const he = Ft(t.startDate, d.value);
      if (he !== void 0 && ve < he) {
        B.setValue(we), W.setValue(""), F.value = "end";
        return;
      }
      W.setValue(we), A.value = !1;
    }
    function te() {
      A.value = !1;
    }
    function oe() {
      B.setValue(""), W.setValue(""), F.value = "start", _.value = !1;
    }
    function Le() {
      B.consumeClick(), B.setValue("");
    }
    function Ie() {
      W.consumeClick(), W.setValue("");
    }
    return (ve, we) => (c(), g("div", qz, [
      v("div", {
        class: C(J.value),
        "data-testid": "date-range-row"
      }, [
        v("div", {
          class: C(G.value)
        }, [
          e.startLabel ? (c(), H(yt, {
            key: 0,
            id: x.value,
            ref_key: "startLabelRef",
            ref: $,
            text: e.startLabel,
            "input-id": h.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            tooltip: e.labelTooltip,
            focused: I(B).isFocused.value,
            "test-id": "date-range-start-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
          v("div", {
            class: C([z.value, I(j).container, q.value]),
            "data-testid": "date-range-start-container",
            onMouseenter: we[3] || (we[3] = //@ts-ignore
            (...he) => I(B).handleMouseEnter && I(B).handleMouseEnter(...he)),
            onMouseleave: we[4] || (we[4] = //@ts-ignore
            (...he) => I(B).handleMouseLeave && I(B).handleMouseLeave(...he)),
            onMousedown: Se,
            onClick: V
          }, [
            v("i", {
              class: C([
                "ri-calendar-line",
                I(j).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            v("input", {
              id: h.value,
              ref_key: "startInputRef",
              ref: l,
              name: "start",
              type: "text",
              value: I(B).displayValue.value,
              placeholder: e.startPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: I(B).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": A.value && D.value === l.value,
              "aria-controls": A.value && D.value === l.value ? I(o) : void 0,
              "aria-labelledby": x.value,
              "aria-label": x.value ? void 0 : e.startPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": E.value,
              "data-testid": "date-range-start-input",
              class: C([
                // forced-colors:focus-visible: mirrors DatePickerInput.vue's own gap fix — the
                // designed focus indicator lives on the CONTAINER (startInputClasses, CSS-var
                // border + box-shadow), and Windows High Contrast Mode suppresses both, so a real
                // outline is re-added here, painted by the UA in the system Highlight color.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                I(j).text
              ]),
              onFocus: we[0] || (we[0] = //@ts-ignore
              (...he) => I(B).handleFocus && I(B).handleFocus(...he)),
              onBlur: we[1] || (we[1] = //@ts-ignore
              (...he) => I(B).handleBlur && I(B).handleBlur(...he)),
              onInput: we[2] || (we[2] = //@ts-ignore
              (...he) => I(B).handleInput && I(B).handleInput(...he)),
              onKeydown: le
            }, null, 42, Uz),
            e.disabled ? k("", !0) : (c(), g("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-start-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.startDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": u.value.clearStartLabel,
              onClick: Ye(Le, ["stop"])
            }, [
              v("i", {
                class: C(["ri-close-line", I(j).icon])
              }, null, 2)
            ], 10, Gz))
          ], 34)
        ], 2),
        v("div", {
          class: C(G.value)
        }, [
          e.endLabel ? (c(), H(yt, {
            key: 0,
            id: y.value,
            ref_key: "endLabelRef",
            ref: S,
            text: e.endLabel,
            "input-id": p.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            focused: I(W).isFocused.value,
            "test-id": "date-range-end-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused"])) : k("", !0),
          v("div", {
            class: C([P.value, I(j).container, q.value]),
            "data-testid": "date-range-end-container",
            onMouseenter: we[8] || (we[8] = //@ts-ignore
            (...he) => I(W).handleMouseEnter && I(W).handleMouseEnter(...he)),
            onMouseleave: we[9] || (we[9] = //@ts-ignore
            (...he) => I(W).handleMouseLeave && I(W).handleMouseLeave(...he)),
            onMousedown: ee,
            onClick: O
          }, [
            v("i", {
              class: C([
                "ri-calendar-line",
                I(j).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            v("input", {
              id: p.value,
              ref_key: "endInputRef",
              ref: r,
              name: "end",
              type: "text",
              value: I(W).displayValue.value,
              placeholder: e.endPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: I(W).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": A.value && D.value === r.value,
              "aria-controls": A.value && D.value === r.value ? I(o) : void 0,
              "aria-labelledby": y.value,
              "aria-label": y.value ? void 0 : e.endPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": E.value,
              "data-testid": "date-range-end-input",
              class: C([
                // See the Start input's own class comment above — same forced-colors rationale.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                I(j).text
              ]),
              onFocus: we[5] || (we[5] = //@ts-ignore
              (...he) => I(W).handleFocus && I(W).handleFocus(...he)),
              onBlur: we[6] || (we[6] = //@ts-ignore
              (...he) => I(W).handleBlur && I(W).handleBlur(...he)),
              onInput: we[7] || (we[7] = //@ts-ignore
              (...he) => I(W).handleInput && I(W).handleInput(...he)),
              onKeydown: fe
            }, null, 42, Kz),
            e.disabled ? k("", !0) : (c(), g("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-end-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.endDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": u.value.clearEndLabel,
              onClick: Ye(Ie, ["stop"])
            }, [
              v("i", {
                class: C(["ri-close-line", I(j).icon])
              }, null, 2)
            ], 10, Yz))
          ], 34)
        ], 2)
      ], 2),
      re(xt, {
        ref_key: "helperRef",
        ref: L,
        focused: I(B).isFocused.value || I(W).isFocused.value,
        hint: e.hint,
        error: e.error,
        "hint-id": w.value,
        "error-id": T.value,
        "test-id-prefix": "date-range"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"]),
      D.value ? (c(), H(jc, {
        key: 0,
        id: I(o),
        ref_key: "dropdownMenuRef",
        ref: M,
        open: A.value,
        "anchor-el": D.value,
        "additional-anchor-els": [l.value, r.value],
        "keep-anchor-focusable": "",
        "auto-focus-on-open": Y.value,
        "start-date": me.value,
        "end-date": ye.value,
        "seed-field": X.value,
        "min-date": Z.value,
        "max-date": de.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        "weekday-labels": u.value.weekdayLabels,
        "month-labels": u.value.monthLabels,
        "month-short-labels": u.value.monthShortLabels,
        "clear-label": u.value.clearLabel,
        "today-label": u.value.todayLabel,
        "previous-label": u.value.previousLabel,
        "next-label": u.value.nextLabel,
        "unavailable-label": u.value.unavailableLabel,
        "range-start-label": u.value.rangeStartLabel,
        "range-end-label": u.value.rangeEndLabel,
        "range-between-label": u.value.rangeBetweenLabel,
        "dialog-label": u.value.rangeDialogLabel,
        "onUpdate:open": we[10] || (we[10] = (he) => A.value = he),
        onRangeSelect: ue,
        onClear: oe,
        onClose: te
      }, null, 8, ["id", "open", "anchor-el", "additional-anchor-els", "auto-focus-on-open", "start-date", "end-date", "seed-field", "min-date", "max-date", "show-today-button", "show-clear-button", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "range-start-label", "range-end-label", "range-between-label", "dialog-label"])) : k("", !0)
    ]));
  }
}), Xz = { class: "flex w-full items-end gap-3" }, Zz = ["id", "value", "name", "title", "placeholder", "disabled", "readonly", "required", "autocomplete", "aria-labelledby", "aria-invalid", "aria-describedby", "aria-required", "aria-disabled"], Qz = ["aria-label", "onKeydown"], _z = /* @__PURE__ */ ke({
  __name: "UrlInput",
  props: {
    modelValue: { default: "" },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidUrlMessage: { default: "Please enter a valid URL" },
    requiredMessage: { default: "URL is required" },
    buttonLabels: { default: () => ({
      label: "",
      labelWhenCopied: ""
    }) },
    resolvedUrl: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "validation-change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(!1), o = R(null), i = R(null), s = R(!1), d = R(!1), u = R(void 0), f = (q) => {
      if (a.validator)
        return a.validator(q) ?? void 0;
      if (a.required && !q.trim())
        return a.requiredMessage;
      if (q.trim())
        try {
          const J = !a.prefix && /^https?:\/\/|^ftps?:\/\//i.test(q), ye = new URL(J ? q : (a.prefix || "https://") + q).hostname.split("."), Z = ye[ye.length - 1];
          if (ye.length < 2 || Z.length < 2)
            return a.invalidUrlMessage;
        } catch {
          return a.invalidUrlMessage;
        }
    }, b = () => {
      const q = f(a.modelValue ?? "");
      u.value = q, l("validation-change", !q, q);
    }, h = m(() => {
      if (a.error) return a.error;
      if (d.value && s.value) return u.value;
    }), p = m(() => !!(a.modelValue ?? "").trim()), x = m(
      () => d.value && s.value && !h.value && p.value
    ), y = (q) => q && !r.value && !a.disabled && !a.readonly, w = m(
      () => r.value && p.value && !a.disabled && !a.readonly
    ), $ = m(() => {
      var q;
      return !!((q = a.buttonLabels) != null && q.label);
    }), S = m(() => a.fullWidth || a.width === void 0), L = (q) => {
      const J = q.target;
      d.value = !0, l("update:modelValue", J.value), l("input", q), a.validateOnInput && b();
    }, T = (q) => {
      r.value = !0, l("focus", q);
    }, E = (q) => {
      r.value = !1, s.value = !0, l("blur", q), a.validateOnBlur && b();
    }, A = (q) => {
      var J, me;
      (J = o.value) == null || J.handleFieldKeydown(q), (me = i.value) == null || me.handleFieldKeydown(q);
    }, D = () => {
      l("update:modelValue", ""), l("clear");
    }, M = R("idle"), F = m(() => {
      if (a.resolvedUrl !== void 0) return a.resolvedUrl;
      const q = a.modelValue ?? "";
      return q.trim() ? !a.prefix && /^https?:\/\/|^ftps?:\/\//i.test(q) ? q : (a.prefix ?? "") + q : "";
    });
    async function X() {
      if (F.value)
        try {
          await navigator.clipboard.writeText(F.value), M.value = "copied", setTimeout(() => {
            M.value = "idle";
          }, 2e3);
        } catch (q) {
          console.error("Copy failed", q);
        }
    }
    const _ = m(() => a.buttonLabels ? M.value === "copied" ? a.buttonLabels.labelWhenCopied : a.buttonLabels.label : ""), Y = m(
      () => M.value === "copied" ? "ri-check-line" : "ri-file-copy-2-line"
    );
    $e(
      () => a.modelValue,
      () => {
        s.value && (a.validateOnBlur || a.validateOnInput) && b();
      }
    ), $e(
      () => a.error,
      (q) => {
        q && (u.value = void 0);
      }
    ), n({ validate: () => (s.value = !0, b(), !u.value), resetValidation: () => {
      s.value = !1, u.value = void 0;
    } });
    const U = je(), z = m(() => a.id ?? `${U}-url`), P = m(() => a.label ? `${U}-label` : void 0), K = m(() => `${U}-error`), j = m(() => `${U}-hint`), G = m(() => {
      const q = [];
      return a.hint && q.push(j.value), h.value && q.push(K.value), q.join(" ") || void 0;
    });
    return (q, J) => (c(), g("div", {
      class: C([
        "relative flex min-w-0 pb-0.5 text-left font-inter",
        e.labelInline ? "flex-row items-center gap-2" : "flex-col items-start gap-0.5",
        S.value ? "w-full" : ""
      ]),
      style: Ne(S.value ? void 0 : { width: e.width })
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: P.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": z.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        inline: e.labelInline,
        "test-id": "url-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"])) : k("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-col gap-0.5", S.value || e.labelInline ? "w-full flex-1" : "w-full"])
      }, [
        v("div", Xz, [
          re(Bn, {
            class: "min-w-0 flex-1",
            flush: !!e.prefix,
            "inner-button": $.value,
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly,
            error: !!h.value,
            success: x.value,
            "has-value": p.value,
            "data-testid": "url-input-shell"
          }, {
            default: xe(({ hovered: me, iconBoxClass: ye, leftIconBoxClass: Z, iconColorClass: de, borderColorClass: ge, addonTextClass: se, textClass: Se }) => [
              e.iconLeft && !e.prefix ? (c(), g("i", {
                key: 0,
                class: C([e.iconLeft, Z, de])
              }, null, 2)) : k("", !0),
              e.prefix ? (c(), g("span", {
                key: 1,
                "data-testid": "url-input-prefix",
                class: C([
                  "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                  I(La)[e.size].addon,
                  "text-(length:--size-m) leading-(--line-height-l)",
                  ge,
                  se
                ])
              }, [
                e.iconLeft ? (c(), g("i", {
                  key: 0,
                  class: C([e.iconLeft, Z, de])
                }, null, 2)) : k("", !0),
                et(" " + N(e.prefix), 1)
              ], 2)) : k("", !0),
              v("div", {
                class: C([
                  e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", I(La)[e.size].input] : "contents",
                  e.prefix && !$.value ? I(La)[e.size].inputEnd : ""
                ])
              }, [
                v("input", {
                  id: z.value,
                  value: e.modelValue,
                  name: e.name,
                  title: F.value || void 0,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  required: e.required,
                  type: "url",
                  inputmode: "url",
                  autocomplete: e.autocomplete,
                  "aria-labelledby": P.value,
                  "aria-invalid": !!h.value,
                  "aria-describedby": G.value,
                  "aria-required": e.required || void 0,
                  "aria-disabled": e.disabled || void 0,
                  "data-testid": "url-input",
                  class: C([
                    "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                    Se,
                    e.readonly ? "cursor-default" : ""
                  ]),
                  onInput: L,
                  onFocus: T,
                  onBlur: E,
                  onKeydown: A
                }, null, 42, Zz),
                y(me) ? (c(), g("i", {
                  key: 0,
                  class: C(["ri-pencil-line text-(--icons-icon-accent)", ye])
                }, null, 2)) : w.value ? (c(), g("i", {
                  key: 1,
                  class: C([
                    "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                    ye
                  ]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  onMousedown: J[0] || (J[0] = Ye(() => {
                  }, ["prevent"])),
                  onClick: Ye(D, ["stop"]),
                  onKeydown: [
                    ut(D, ["enter"]),
                    ut(Ye(D, ["prevent"]), ["space"])
                  ]
                }, null, 42, Qz)) : k("", !0),
                $.value ? (c(), H(Be, {
                  key: 2,
                  variant: "secondary",
                  size: "xs",
                  "icon-left": Y.value,
                  label: _.value,
                  "aria-label": _.value,
                  disabled: e.disabled || !e.modelValue,
                  onClick: X
                }, null, 8, ["icon-left", "label", "aria-label", "disabled"])) : k("", !0)
              ], 2)
            ]),
            _: 1
          }, 8, ["flush", "inner-button", "size", "disabled", "readonly", "error", "success", "has-value"]),
          Ae(q.$slots, "actions", {}, void 0, !0)
        ]),
        re(xt, {
          ref_key: "helperRef",
          ref: i,
          focused: r.value,
          hint: e.hint,
          error: h.value,
          "hint-id": j.value,
          "error-id": K.value,
          "test-id-prefix": "url-input"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
      ], 2)
    ], 6));
  }
}), pq = /* @__PURE__ */ ot(_z, [["__scopeId", "data-v-3d78c675"]]), Wc = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  }
}, e3 = {
  indigo: "indigo",
  amber: "orange",
  green: "green",
  red: "red"
}, Fv = (e) => e.badge ? {
  label: e.badge,
  theme: e.badgeTheme ?? e3[e.badgeVariant ?? "indigo"],
  icon: e.badgeIcon,
  brandIcon: e.badgeBrandIcon
} : void 0, t3 = ["aria-expanded", "aria-activedescendant", "aria-required", "aria-invalid", "aria-disabled", "aria-describedby", "disabled", "placeholder"], n3 = ["aria-label"], a3 = { class: "flex items-start justify-between gap-2" }, l3 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "autocomplete-status"
}, r3 = {
  key: 0,
  class: "flex justify-center py-4"
}, o3 = {
  key: 1,
  "data-testid": "autocomplete-empty",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, i3 = {
  key: 2,
  "data-testid": "autocomplete-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, s3 = ["aria-labelledby", "aria-label"], d3 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "AutoComplete",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean },
    requiredIndicator: { default: "*" },
    placeholder: { default: void 0 },
    iconLeft: { default: "ri-map-pin-2-line" },
    iconRight: { default: "ri-search-line" },
    options: { default: void 0 },
    loading: { type: Boolean },
    emptyLabel: { default: void 0 },
    resultsLabel: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disabled: { type: Boolean },
    fullWidth: { type: Boolean, default: !0 },
    showAddMoreDetails: { type: Boolean },
    addMoreDetailsLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    debounce: { default: 300 },
    minSearchLength: { default: 1 },
    maxVisibleOptions: { default: 5 },
    keepInputOnEdit: { type: Boolean },
    clearable: { type: Boolean, default: !0 },
    clearLabel: { default: "Clear" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    seeAllLabel: { type: [String, Function], default: void 0 },
    createLabel: { type: [String, Function], default: void 0 },
    createIcon: { default: "ri-add-line" }
  },
  emits: ["update:modelValue", "search", "select", "clear", "addMoreDetails", "blur", "see-all", "create"],
  setup(e, { expose: n, emit: t }) {
    var ve, we;
    const a = e, l = t, r = je(), o = `autocomplete-input-${r}`, i = `autocomplete-listbox-${r}`, s = `autocomplete-error-${r}`, d = `autocomplete-hint-${r}`, u = `autocomplete-label-${r}`, f = m(() => {
      const he = [];
      return a.hint && he.push(d), a.error && he.push(s), he.length > 0 ? he.join(" ") : void 0;
    }), b = R(
      a.modelValue ? ((we = (ve = a.options) == null ? void 0 : ve.find((he) => he.value === a.modelValue)) == null ? void 0 : we.label) ?? a.modelValue : ""
    ), h = R(!1), p = R(!1), x = R(!1), y = R(null), w = R(null), $ = R(!1), S = R(-1), L = R(), T = R(), E = R(), A = R(null), D = R(!1), M = R(!1);
    let F = null, X = null, _ = !1, Y = !1, B = !1;
    const W = m(
      () => h.value && !p.value && b.value.length >= (a.minSearchLength ?? 1) && !a.disabled
    ), U = m(() => (a.options ?? []).slice(0, a.maxVisibleOptions)), z = (he) => he.image !== void 0 ? { name: he.label, img: he.image ?? void 0, logo: he.logo } : void 0, P = m(() => {
      if (!W.value || a.loading || M.value) return "";
      const he = U.value.length;
      return he === 0 ? a.emptyLabel ?? "No results" : Hu(a.resultsCountLabel, he);
    }), K = (he) => typeof he == "function" ? he(b.value) : he, j = m(() => K(a.seeAllLabel)), G = m(() => K(a.createLabel)), q = m(() => !!(j.value || G.value)), J = m(() => !!a.modelValue), me = m(
      () => a.clearable && !!b.value && !a.disabled && ($.value || h.value)
    ), ye = m(() => a.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : h.value ? "text-(--border-border-accent)" : J.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), Z = m(() => a.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : $.value && !h.value ? "text-(--border-border-accent)" : J.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), de = m(() => {
      const he = "relative rounded-(--border-border-radius-rounded-l) border-solid box-border flex items-center gap-2 px-3 h-9 font-inter";
      return a.disabled ? `${he} border-[1px] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : a.error ? `${he} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : h.value ? `${he} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent)` : $.value ? `${he} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${he} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    });
    $e(W, async (he) => {
      he ? (await Ue(), F = ja(L.value, E.value, {
        placement: "bottom-start",
        onFirstUpdate: () => {
          D.value = !0;
        },
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Wc
        ]
      })) : (F == null || F.destroy(), F = null, D.value = !1);
    }), $e(D, async (he) => {
      he && (await Ue(), await (F == null ? void 0 : F.update()));
    }), $e(
      [() => a.options, () => a.loading],
      async () => {
        var he;
        if (!h.value && a.modelValue) {
          const Me = (he = a.options) == null ? void 0 : he.find((Ee) => Ee.value === a.modelValue);
          Me && (b.value = Me.label);
        }
        S.value = -1, await Ue(), await (F == null ? void 0 : F.update());
      }
    ), $e(W, (he) => {
      he || (S.value = -1);
    }), $e(
      () => a.modelValue,
      (he) => {
        var Ee;
        if (!he) {
          _ || (b.value = ""), _ = !1;
          return;
        }
        const Me = (Ee = a.options) == null ? void 0 : Ee.find((He) => He.value === he);
        b.value = Me ? Me.label : he;
      },
      { immediate: !0 }
    ), mt(() => {
      F == null || F.destroy(), F = null, X && clearTimeout(X);
    });
    const ge = (he) => {
      if (Y) {
        Y = !1;
        return;
      }
      h.value = !0, p.value = !1, he.target.select();
    }, se = () => {
      a.disabled || (h.value = !0, p.value = !1);
    }, Se = (he) => {
      var Me;
      if (B || (Me = E.value) != null && Me.contains(he.relatedTarget)) {
        B = !1;
        return;
      }
      h.value = !1, l("blur");
    }, V = () => {
      p.value = !1, a.modelValue && (a.keepInputOnEdit && (_ = !0), l("update:modelValue", "")), M.value = !0, X && clearTimeout(X), X = setTimeout(() => {
        M.value = !1, l("search", b.value);
      }, a.debounce ?? 300);
    }, Q = (he) => {
      he.disabled || (b.value = he.label, l("update:modelValue", he.value), l("select", he), ee());
    }, le = () => {
      b.value = "", l("update:modelValue", ""), l("clear");
    }, ee = () => {
      p.value = !0;
    }, O = () => {
      ee(), T.value && document.activeElement !== T.value && (Y = !0, T.value.focus());
    }, ne = () => {
      var he, Me;
      return Array.from(
        ((Me = (he = A.value) == null ? void 0 : he.$el) == null ? void 0 : Me.querySelectorAll("button, a[href]")) ?? []
      );
    };
    function fe(he) {
      const Me = b.value;
      O(), l(he === "see-all" ? "see-all" : "create", Me);
    }
    function ue(he) {
      var Ee, He;
      const Me = ne();
      he.key === "Escape" ? (he.preventDefault(), he.stopPropagation(), O()) : he.key === "Tab" && he.shiftKey && he.target === Me[0] ? (he.preventDefault(), (Ee = T.value) == null || Ee.focus()) : he.key === "Tab" && !he.shiftKey && he.target === Me[Me.length - 1] && (Y = !0, (He = T.value) == null || He.focus(), ee());
    }
    function te(he) {
      var Ee;
      const Me = he.relatedTarget;
      Me === T.value || (Ee = E.value) != null && Ee.contains(Me) || (h.value = !1, l("blur"));
    }
    function oe(he, Me) {
      he.disabled || (S.value = Me, x.value = !1);
    }
    const Le = async () => {
      var he;
      await Ue(), (he = document.getElementById(`${i}-option-${S.value}`)) == null || he.scrollIntoView({ block: "nearest" });
    }, Ie = (he) => {
      var He, Ge;
      if (!W.value) {
        if (p.value && (he.key === "ArrowDown" || he.key === "ArrowUp")) {
          he.preventDefault(), p.value = !1;
          return;
        }
        (He = y.value) == null || He.handleFieldKeydown(he), (Ge = w.value) == null || Ge.handleFieldKeydown(he);
        return;
      }
      if (he.key === "Escape") {
        he.stopPropagation(), he.preventDefault(), ee();
        return;
      }
      const Me = U.value.length;
      if (!Me && he.key !== "Tab") return;
      const Ee = S.value < Me ? S.value : -1;
      switch (he.key) {
        case "ArrowDown": {
          he.preventDefault(), S.value = (Ee + 1) % Me, x.value = !0, Le();
          break;
        }
        case "ArrowUp": {
          he.preventDefault(), S.value = Ee === -1 ? Me - 1 : Ee - 1, x.value = !0, Le();
          break;
        }
        case "Enter": {
          he.preventDefault(), S.value >= 0 && U.value[S.value] && Q(U.value[S.value]);
          break;
        }
        case "Tab": {
          if (!he.shiftKey && S.value >= 0 && U.value[S.value])
            Q(U.value[S.value]);
          else if (!he.shiftKey && ne()[0]) {
            he.preventDefault(), B = !0, ne()[0].focus();
            break;
          }
          ee();
          break;
        }
      }
    };
    return n({ focus: () => {
      var he;
      return (he = T.value) == null ? void 0 : he.focus();
    } }), (he, Me) => (c(), g(ce, null, [
      v("div", {
        class: C(["font-inter text-(length:--size-m) leading-(--line-height-l) flex flex-col gap-0.5 pb-0.5", e.fullWidth ? "w-full" : ""])
      }, [
        e.label ? (c(), H(yt, {
          key: 0,
          id: u,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          "input-id": o,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: h.value,
          "test-id": "autocomplete-label"
        }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
        v("div", {
          ref_key: "inputRef",
          ref: L,
          class: C(de.value),
          onMouseenter: Me[2] || (Me[2] = (Ee) => $.value = !0),
          onMouseleave: Me[3] || (Me[3] = (Ee) => $.value = !1)
        }, [
          e.iconLeft ? (c(), g("i", {
            key: 0,
            class: C([e.iconLeft, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", ye.value])
          }, null, 2)) : k("", !0),
          Jl(v("input", Oe(he.$attrs, {
            id: o,
            ref_key: "nativeInputRef",
            ref: T,
            "onUpdate:modelValue": Me[0] || (Me[0] = (Ee) => b.value = Ee),
            role: "combobox",
            "aria-expanded": W.value,
            "aria-autocomplete": "list",
            "aria-controls": i,
            "aria-activedescendant": S.value >= 0 ? `${i}-option-${S.value}` : void 0,
            "aria-haspopup": "listbox",
            "aria-required": e.required || void 0,
            "aria-invalid": !!e.error || void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-describedby": f.value,
            autocomplete: "off",
            disabled: e.disabled,
            placeholder: e.placeholder,
            class: ["flex-1 min-w-0 truncate bg-transparent outline-none text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle)", e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"],
            onInput: V,
            onFocus: ge,
            onClick: se,
            onBlur: Se,
            onKeydown: Ie
          }), null, 16, t3), [
            [Ix, b.value]
          ]),
          me.value ? (c(), g("button", {
            key: 1,
            type: "button",
            "aria-label": e.clearLabel,
            "data-testid": "autocomplete-clear",
            class: C(["-m-1 inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", Z.value]),
            onMousedown: Me[1] || (Me[1] = Ye(() => {
            }, ["prevent"])),
            onClick: le
          }, [...Me[8] || (Me[8] = [
            v("i", {
              class: "ri-close-line text-(length:--icon-size-sm) leading-(--line-height-xxl)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, n3)) : e.iconRight ? (c(), g("i", {
            key: 2,
            class: C([e.iconRight, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", Z.value])
          }, null, 2)) : k("", !0)
        ], 34),
        v("div", a3, [
          re(xt, {
            ref_key: "helperRef",
            ref: w,
            focused: h.value,
            class: "flex-1",
            hint: e.hint,
            error: e.error,
            "hint-id": d,
            "error-id": s,
            "test-id-prefix": "autocomplete"
          }, null, 8, ["focused", "hint", "error"]),
          re(wt, {
            "enter-active-class": "transition duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0 -translate-y-1 motion-reduce:translate-y-0",
            "enter-to-class": "opacity-100 translate-y-0"
          }, {
            default: xe(() => [
              e.showAddMoreDetails ? (c(), H(I(In), {
                key: 0,
                "data-testid": "autocomplete-add-more-details",
                "icon-right": "ri-pencil-line",
                class: "shrink-0 ml-2",
                disabled: e.disabled,
                onClick: Me[4] || (Me[4] = (Ee) => l("addMoreDetails"))
              }, {
                default: xe(() => [
                  et(N(e.addMoreDetailsLabel ?? "Add more details"), 1)
                ]),
                _: 1
              }, 8, ["disabled"])) : k("", !0)
            ]),
            _: 1
          })
        ]),
        v("span", l3, N(P.value), 1)
      ], 2),
      (c(), H(Dn, { to: "body" }, [
        W.value ? (c(), g("div", {
          key: 0,
          ref_key: "panelRef",
          ref: E,
          class: "fixed z-[200]",
          "data-focus-trap-allow-outside": "",
          onMousedown: Me[7] || (Me[7] = Ye(() => {
          }, ["prevent"])),
          onFocusout: te
        }, [
          re(wt, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: xe(() => [
              D.value ? (c(), g("div", {
                key: 0,
                "data-testid": "autocomplete-panel",
                class: C([
                  "flex w-full flex-col overflow-hidden",
                  // Without a footer the border is medium and there is no blur, so only the footer panel is the shared surface.
                  q.value ? I(Wa) : "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-medium) bg-(--background-background-white) shadow-(--blur-shadow-m) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
                ])
              }, [
                v("div", {
                  "data-testid": "autocomplete-list",
                  class: C([
                    "flex min-h-0 flex-col",
                    q.value ? "p-1" : "gap-1.5 p-[calc(--spacing(2)-1px)]"
                  ])
                }, [
                  e.loading ? (c(), g("div", r3, [...Me[9] || (Me[9] = [
                    v("i", {
                      class: "ri-loader-4-line animate-spin text-(--text-text-body-subtle)",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])])) : !U.value.length && !M.value ? (c(), g("div", o3, N(e.emptyLabel ?? "No results"), 1)) : e.resultsLabel ? (c(), g("div", i3, N(e.resultsLabel), 1)) : k("", !0),
                  v("ul", {
                    id: i,
                    role: "listbox",
                    "aria-labelledby": e.label ? u : void 0,
                    "aria-label": e.label ? void 0 : e.resultsLabel,
                    class: C([
                      "flex flex-col",
                      !q.value && "gap-1.5",
                      (e.loading || !U.value.length) && "hidden"
                    ])
                  }, [
                    (c(!0), g(ce, null, Re(U.value, (Ee, He) => (c(), H(Kt, {
                      id: `${i}-option-${He}`,
                      key: Ee.value,
                      as: "li",
                      type: "autocomplete",
                      role: "option",
                      "aria-selected": He === S.value,
                      label: Ee.label,
                      highlight: b.value,
                      icon: Ee.icon,
                      avatar: z(Ee),
                      "secondary-label": Ee.description,
                      badge: I(Fv)(Ee),
                      description: Ee.disabled ? Ee.disabledReason : void 0,
                      "aria-disabled": !!Ee.disabled,
                      highlighted: He === S.value,
                      "keyboard-active": x.value && He === S.value,
                      "data-testid": `autocomplete-option-${Ee.value}`,
                      onClick: (Ge) => Q(Ee),
                      onMouseenter: (Ge) => oe(Ee, He)
                    }, null, 8, ["id", "aria-selected", "label", "highlight", "icon", "avatar", "secondary-label", "badge", "description", "aria-disabled", "highlighted", "keyboard-active", "data-testid", "onClick", "onMouseenter"]))), 128))
                  ], 10, s3)
                ], 2),
                q.value ? (c(), H(ul, {
                  key: 0,
                  ref_key: "footerRef",
                  ref: A,
                  type: "see-all-create",
                  "see-all-label": j.value,
                  "create-label": G.value,
                  "create-icon": e.createIcon,
                  class: "shrink-0",
                  onKeydown: ue,
                  onSeeAll: Me[5] || (Me[5] = (Ee) => fe("see-all")),
                  onCreate: Me[6] || (Me[6] = (Ee) => fe("create"))
                }, null, 8, ["see-all-label", "create-label", "create-icon"])) : k("", !0)
              ], 2)) : k("", !0)
            ]),
            _: 1
          })
        ], 544)) : k("", !0)
      ]))
    ], 64));
  }
}), u3 = { class: "flex w-full flex-col" }, c3 = { class: "@container flex flex-col" }, f3 = {
  "data-testid": "address-input-zip-city",
  class: "grid grid-cols-1 gap-x-4 @sm:grid-cols-2"
}, h3 = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, b3 = "ri-map-pin-2-line", gb = "ri-search-line", vq = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "AddressInput",
  props: {
    modelValue: { default: "" },
    details: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    options: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    countries: { default: () => [] },
    formatAddress: { type: Function, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "update:details", "search", "select", "clear", "blur", "addMoreDetails"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = { line1: "", line2: "", line3: "", zip: "", city: "", country: "" }, r = m(() => ({
      addMoreDetails: t.labels.addMoreDetails ?? "Add more details",
      modalTitle: t.labels.modalTitle ?? "Edit address",
      line1: t.labels.line1 ?? "Address line 1",
      line2: t.labels.line2 ?? "Address line 2 (optional)",
      line3: t.labels.line3 ?? "Address line 3 (optional)",
      linePlaceholder: t.labels.linePlaceholder ?? "Enter a new address line",
      zip: t.labels.zip ?? "Zip code",
      city: t.labels.city ?? "City",
      country: t.labels.country ?? "Country",
      save: t.labels.save ?? "Save",
      cancel: t.labels.cancel ?? "Cancel",
      closeModal: t.labels.closeModal ?? "Close modal"
    })), o = R(t.modelValue);
    $e(
      () => t.modelValue,
      (X) => {
        o.value = X;
      }
    );
    const i = R({ ...l, ...t.details });
    $e(
      () => t.details,
      (X) => {
        i.value = { ...l, ...X };
      },
      { deep: !0 }
    );
    const s = m(() => !!o.value), d = R(null);
    function u() {
      t.details || (i.value = { ...l });
    }
    function f(X) {
      u(), a("select", X);
    }
    function b() {
      i.value = { ...l }, a("clear");
    }
    function h(X) {
      o.value = X, a("update:modelValue", X);
    }
    function p(X) {
      u(), h(X);
    }
    function x(X) {
      var _, Y;
      t.disabled || (_ = X.target) != null && _.closest(`.${gb}`) && ((Y = d.value) == null || Y.focus());
    }
    const y = m(() => [
      "[&_.ri-search-line]:cursor-pointer",
      // AutoComplete sizes its icons `text-base`, a 24 px line box; Figma's icons are 16 px squares.
      "[&_.ri-map-pin-2-line]:text-(length:--icon-size-sm) [&_.ri-map-pin-2-line]:leading-(--icon-size-sm)",
      "[&_.ri-search-line]:text-(length:--icon-size-sm) [&_.ri-search-line]:leading-(--icon-size-sm)",
      s.value && !t.disabled ? "[&_input]:text-(--text-text-link) [&_input]:font-(--weight-medium)" : ""
    ]), w = R(!1), $ = sl({ ...l }), S = `address-input-description-${je()}`;
    function L(X) {
      var B;
      const _ = ((B = t.countries.find((W) => W.value === X.country)) == null ? void 0 : B.label) ?? X.country, Y = [X.zip, X.city].filter((W) => W.trim()).join(" ");
      return [X.line1, X.line2, X.line3, Y, _].filter((W) => W.trim());
    }
    const T = (X) => t.formatAddress ? t.formatAddress(X) : L(X).join(", "), E = m(() => L($));
    function A() {
      Object.assign($, i.value), w.value = !0, a("addMoreDetails");
    }
    function D() {
      const X = { ...$ }, _ = T(X);
      w.value = !1, _ && (i.value = X, a("update:details", X), h(_));
    }
    function M() {
      w.value = !1;
    }
    const F = m(() => [
      { id: "cancel", label: r.value.cancel, variant: "secondary", onClick: M, testId: "address-input-cancel" },
      { id: "save", label: r.value.save, variant: "primary", onClick: D, testId: "address-input-save" }
    ]);
    return (X, _) => (c(), g("div", u3, [
      v("div", {
        "data-testid": "address-input-field",
        class: C(y.value),
        onClick: x
      }, [
        re(d3, Oe({
          ref_key: "autoCompleteRef",
          ref: d
        }, X.$attrs, {
          "model-value": o.value,
          label: e.label,
          required: e.required,
          placeholder: e.placeholder,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "label-tooltip": e.labelTooltip,
          options: e.options,
          loading: e.loading,
          hint: e.hint,
          error: e.error,
          disabled: e.disabled,
          "icon-left": b3,
          "icon-right": gb,
          "keep-input-on-edit": "",
          "show-add-more-details": s.value,
          "add-more-details-label": r.value.addMoreDetails,
          onAddMoreDetails: A,
          "onUpdate:modelValue": p,
          onSearch: _[0] || (_[0] = (Y) => a("search", Y)),
          onSelect: f,
          onClear: b,
          onBlur: _[1] || (_[1] = (Y) => a("blur"))
        }), null, 16, ["model-value", "label", "required", "placeholder", "aria-label", "label-tooltip", "options", "loading", "hint", "error", "disabled", "show-add-more-details", "add-more-details-label"])
      ], 2),
      re(Va, {
        modelValue: w.value,
        "onUpdate:modelValue": _[8] || (_[8] = (Y) => w.value = Y),
        size: "sm",
        title: r.value.modalTitle,
        "aria-close-label": r.value.closeModal,
        actions: F.value,
        "aria-describedby": E.value.length ? S : void 0
      }, {
        default: xe(() => [
          v("div", c3, [
            re(Ot, {
              modelValue: $.line1,
              "onUpdate:modelValue": _[2] || (_[2] = (Y) => $.line1 = Y),
              "data-testid": "address-input-line1",
              label: r.value.line1,
              "full-width": ""
            }, null, 8, ["modelValue", "label"]),
            re(Ot, {
              modelValue: $.line2,
              "onUpdate:modelValue": _[3] || (_[3] = (Y) => $.line2 = Y),
              "data-testid": "address-input-line2",
              label: r.value.line2,
              placeholder: r.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            re(Ot, {
              modelValue: $.line3,
              "onUpdate:modelValue": _[4] || (_[4] = (Y) => $.line3 = Y),
              "data-testid": "address-input-line3",
              label: r.value.line3,
              placeholder: r.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            v("div", f3, [
              re(Ot, {
                modelValue: $.zip,
                "onUpdate:modelValue": _[5] || (_[5] = (Y) => $.zip = Y),
                "data-testid": "address-input-zip",
                label: r.value.zip,
                "full-width": ""
              }, null, 8, ["modelValue", "label"]),
              re(Ot, {
                modelValue: $.city,
                "onUpdate:modelValue": _[6] || (_[6] = (Y) => $.city = Y),
                "data-testid": "address-input-city",
                label: r.value.city,
                "full-width": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            re(El, {
              modelValue: $.country,
              "onUpdate:modelValue": _[7] || (_[7] = (Y) => $.country = Y),
              "data-testid": "address-input-country",
              label: r.value.country,
              options: e.countries,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "options"]),
            E.value.length ? (c(), H(Kl, {
              key: 0,
              id: S,
              "data-testid": "address-input-description",
              color: "default",
              layout: "stacked",
              "aria-live": "off"
            }, {
              body: xe(() => [
                v("p", h3, [
                  (c(!0), g(ce, null, Re(E.value, (Y, B) => (c(), g("span", {
                    key: B,
                    class: "block"
                  }, N(Y), 1))), 128))
                ])
              ]),
              _: 1
            })) : k("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions", "aria-describedby"])
    ]));
  }
}), g3 = { class: "flex w-full flex-col" }, m3 = { class: "box-border flex w-full flex-col gap-1.5 p-[calc(--spacing(2)-1px)]" }, p3 = ["id"], v3 = {
  key: 1,
  class: "flex justify-center py-2"
}, x3 = {
  key: 2,
  class: "px-2 py-2 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "relation-input-empty"
}, y3 = ["id", "aria-labelledby", "aria-label", "aria-owns", "aria-busy"], k3 = ["id", "aria-selected", "onClick", "onMouseenter"], w3 = { class: "flex min-w-0 flex-1 flex-col gap-px" }, C3 = {
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "relation-input-option-name"
}, S3 = {
  key: 0,
  class: "bg-transparent text-(--text-text-accent)"
}, $3 = {
  key: 0,
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-secondary)"
}, I3 = /* @__PURE__ */ ke({
  __name: "RelationListbox",
  props: {
    listboxId: {},
    items: {},
    activeIndex: {},
    query: {},
    heading: {},
    name: {},
    loading: { type: Boolean },
    loadingLabel: {},
    emptyText: {}
  },
  emits: ["choose", "hover"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => `${t.listboxId}-heading`), r = m(
      () => t.items.map((f, b) => ({ item: f, index: b })).filter(
        (f) => f.item.kind === "record"
      )
    ), o = m(
      () => t.items.map((f, b) => ({ item: f, index: b })).filter(
        (f) => f.item.kind !== "record"
      )
    ), i = m(() => o.value.find((f) => f.item.kind === "viewAll")), s = m(() => o.value.find((f) => f.item.kind === "create")), d = m(() => o.value.map((f) => f.item.id).join(" ") || void 0), u = (f) => f.role ?? f.email;
    return (f, b) => {
      var h, p;
      return c(), g("div", g3, [
        v("div", m3, [
          e.heading ? (c(), g("div", {
            key: 0,
            id: l.value,
            class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
          }, N(e.heading), 9, p3)) : k("", !0),
          e.loading ? (c(), g("div", v3, [
            re(zu, {
              size: "sm",
              label: e.loadingLabel
            }, null, 8, ["label"])
          ])) : e.emptyText ? (c(), g("div", x3, N(e.emptyText), 1)) : k("", !0),
          v("div", {
            id: e.listboxId,
            role: "listbox",
            "aria-labelledby": e.heading ? l.value : void 0,
            "aria-label": e.heading ? void 0 : e.name,
            "aria-owns": d.value,
            "aria-busy": e.loading || void 0,
            class: C(["flex flex-col gap-1.5", d.value ? "empty:sr-only" : "empty:hidden"]),
            "data-testid": "relation-input-listbox"
          }, [
            (c(!0), g(ce, null, Re(r.value, ({ item: x, index: y }) => (c(), g("div", {
              id: x.id,
              key: x.id,
              role: "option",
              "aria-selected": y === e.activeIndex,
              "data-testid": "relation-input-option",
              class: C([
                "flex h-[46px] cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2",
                y === e.activeIndex ? "bg-(--background-background-hover) dark:bg-white/8" : "hover:bg-(--background-background-hover) dark:hover:bg-white/8"
              ]),
              onClick: (w) => a("choose", x),
              onMouseenter: (w) => a("hover", y)
            }, [
              re(Mt, {
                name: x.record.label,
                img: x.record.avatarSrc,
                size: "sm",
                presentational: ""
              }, null, 8, ["name", "img"]),
              v("span", w3, [
                v("span", C3, [
                  (c(!0), g(ce, null, Re([I(mg)(x.record.label, e.query)], (w, $) => (c(), g(ce, { key: $ }, [
                    et(N(w.before), 1),
                    w.match ? (c(), g("mark", S3, N(w.match), 1)) : k("", !0),
                    et(N(w.after), 1)
                  ], 64))), 128))
                ]),
                u(x.record) ? (c(), g("span", $3, N(u(x.record)), 1)) : k("", !0)
              ]),
              x.record.badge ? (c(), H(ct, {
                key: 0,
                label: x.record.badge.label,
                theme: x.record.badge.color,
                size: "sm",
                "show-left-icon": !1,
                class: "shrink-0",
                "data-testid": "relation-input-option-badge"
              }, null, 8, ["label", "theme"])) : k("", !0)
            ], 42, k3))), 128))
          ], 10, y3)
        ]),
        o.value.length ? (c(), H(ul, {
          key: 0,
          type: "see-all-create",
          "see-all-label": (h = i.value) == null ? void 0 : h.item.label,
          "see-all-option": i.value && {
            id: i.value.item.id,
            active: i.value.index === e.activeIndex,
            testId: "relation-input-view-all"
          },
          "create-label": (p = s.value) == null ? void 0 : p.item.label,
          "create-option": s.value && {
            id: s.value.item.id,
            active: s.value.index === e.activeIndex,
            testId: "relation-input-create"
          },
          onSeeAll: b[0] || (b[0] = (x) => i.value && a("choose", i.value.item)),
          onCreate: b[1] || (b[1] = (x) => s.value && a("choose", s.value.item)),
          onOptionHover: b[2] || (b[2] = (x) => a("hover", (x === "see-all" ? i.value : s.value).index))
        }, null, 8, ["see-all-label", "see-all-option", "create-label", "create-option"])) : k("", !0)
      ]);
    };
  }
}), kl = Yl(null), T3 = ["id", "role", "aria-labelledby"], L3 = { class: "opal-popover-inner" }, A3 = { class: "opal-popover-header flex h-8 items-center justify-between ps-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, E3 = {
  key: 0,
  class: "opal-popover-record mb-1 flex min-w-0 flex-col"
}, R3 = {
  key: 0,
  class: "flex items-start justify-between gap-2"
}, B3 = {
  key: 0,
  class: "opal-popover-avatar"
}, D3 = {
  key: 1,
  class: "opal-popover-action ml-auto shrink-0"
}, M3 = {
  key: 2,
  class: "opal-popover-badges mt-px flex flex-wrap gap-1.5"
}, z3 = { class: "opal-popover-content" }, O3 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    header: {},
    position: { default: "bottom" },
    delay: { default: 400 },
    closeDelay: { default: 100 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    interactive: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !1 },
    closeLabel: { default: "Close" },
    minWidth: { default: void 0 },
    maxWidth: { default: "255px" }
  },
  emits: ["update:open"],
  setup(e, { emit: n }) {
    var Me;
    const t = Iu(), a = e, l = n, r = Yt(), o = () => ["avatar", "title", "badges", "action"].some(r), i = je(), s = `${i}-header`, d = `${i}-body`, u = R(a.position), f = () => u.value === "bottom" ? "var(--background-background-white-secondary)" : "var(--colors-white-50-opacity-bold)", b = R(null), h = R(null), p = R(!1), x = R(!1), y = Symbol("popover"), w = m(() => a.open !== void 0), $ = m(() => w.value ? a.open === !0 : p.value), S = m(() => a.interactive || a.closable), L = typeof process < "u" && ((Me = process.env) == null ? void 0 : Me.NODE_ENV) !== "production", T = m(
      () => S.value ? {
        "aria-haspopup": "dialog",
        "aria-expanded": $.value,
        "aria-controls": $.value ? i : void 0
      } : { "aria-describedby": $.value ? d : void 0 }
    );
    let E = null, A = null, D = null, M = null, F = !1, X = null, _ = !1;
    const Y = (Ee) => Ee === "top" || Ee === "bottom", B = {
      name: "syncSide",
      enabled: !0,
      phase: "afterWrite",
      fn: ({ state: Ee, instance: He }) => {
        const Ge = u.value;
        u.value = Ee.placement.split("-")[0], Y(Ge) !== Y(u.value) && Ue(() => He.update());
      }
    }, W = () => {
      X == null || X.disconnect(), X = null, E == null || E.destroy(), E = null;
    };
    $e(
      $,
      async (Ee) => {
        if (!Ee) {
          _ = !1, P();
          return;
        }
        if (u.value = a.position, await Ue(), !$.value || !b.value || !h.value) return;
        W();
        const He = ja(b.value, h.value, {
          placement: a.position,
          modifiers: [
            // Arrow height: the caret tip touches the trigger.
            { name: "offset", options: { offset: [0, 10] } },
            { name: "arrow", options: { element: ".opal-popover-arrow", padding: 12 } },
            {
              name: "flip",
              // altAxis off: near the top or bottom edge a side bubble is shifted, not flipped.
              options: { fallbackPlacements: og[a.position], altAxis: !1 }
            },
            { name: "preventOverflow", options: { padding: ig } },
            B
          ],
          // The first pass measures the caret before the side's CSS (10×40 on left/right) applies.
          onFirstUpdate: () => void He.update()
        });
        E = He, typeof ResizeObserver < "u" && (X = new ResizeObserver(() => void He.update()), X.observe(h.value));
      },
      { immediate: !0 }
    );
    const U = () => {
      A && (clearTimeout(A), A = null);
    }, z = () => {
      D && (clearTimeout(D), D = null);
    };
    function P() {
      kl.value === y && (kl.value = null), x.value = !1, document.removeEventListener("pointerdown", j, !0);
    }
    const K = () => {
      if (w.value) {
        l("update:open", !1);
        return;
      }
      P(), p.value = !1;
    };
    function j(Ee) {
      ye(b.value, Ee.target) || ye(h.value, Ee.target) || K();
    }
    const G = () => {
      !a.closable || a.disabled || w.value || x.value || (U(), z(), kl.value = y, x.value = !0, p.value = !0, document.addEventListener("pointerdown", j, !0));
    };
    $e(kl, (Ee) => {
      x.value && Ee !== y && K();
    });
    const q = () => !a.disabled && !w.value && !(kl.value && kl.value !== y), J = () => {
      q() && (z(), !A && (A = setTimeout(() => {
        p.value = !0, A = null;
      }, a.delay)));
    }, me = () => {
      w.value || (U(), z(), D = setTimeout(K, a.closeDelay));
    }, ye = (Ee, He) => !!Ee && He instanceof Node && Ee.contains(He), Z = () => {
      x.value || ye(h.value, document.activeElement) || ye(b.value, document.activeElement) || me();
    }, de = () => (M != null && M.isConnected ? M : null) ?? (b.value ? wa(b.value)[0] ?? null : null), ge = (Ee) => {
      Ee.target instanceof HTMLElement && (M = Ee.target), F || J();
    }, se = () => {
      _ = !0, z();
    }, Se = () => {
      _ = !1, Z();
    }, V = (Ee) => Ee.relatedTarget === null && (document.activeElement === Ee.target || _), Q = () => x.value ? K() : me(), le = (Ee) => {
      V(Ee) || ye(h.value, Ee.relatedTarget) || Q();
    }, ee = (Ee) => {
      V(Ee) || ye(h.value, Ee.relatedTarget) || ye(b.value, Ee.relatedTarget) || Q();
    }, O = (Ee) => void Ue(
      () => (
        // Two frames: the first can already be pending and fire in the same task as the re-render.
        requestAnimationFrame(
          () => requestAnimationFrame(() => {
            F = !0;
            try {
              Ee == null || Ee.focus();
            } finally {
              F = !1;
            }
          })
        )
      )
    ), ne = () => {
      const Ee = de();
      K(), w.value || O(Ee);
    }, fe = (Ee) => {
      var ae;
      if (!$.value) return;
      Ee.stopPropagation(), Ee.preventDefault();
      const He = document.activeElement, Ge = ye(h.value, He) || x.value && (!He || He === document.body), Ze = de();
      K(), L && w.value && !((ae = t == null ? void 0 : t.vnode.props) != null && ae["onUpdate:open"]) && console.warn(
        "[OPAL Popover] Escape was consumed and emitted as `update:open(false)`, but no `update:open` listener is bound: nothing can close this controlled popover. Listen for the emit (`v-model:open`), or Escape does nothing."
      ), !(!Ge || w.value) && O(Ze);
    }, ue = Symbol("popover"), te = (Ee) => {
      Ee.key !== "Escape" || Ee.defaultPrevented || ha(ue) && fe(Ee);
    }, oe = () => {
      document.removeEventListener("keydown", te), Rn(ue);
    }, Le = m(() => $.value && !w.value);
    $e(Le, (Ee) => {
      Ee ? (Qn(ue), document.addEventListener("keydown", te)) : oe();
    });
    const Ie = (Ee) => {
      if (Ee.key === "Escape") {
        fe(Ee);
        return;
      }
      if ((Ee.key === "Enter" || Ee.key === " ") && !Ee.repeat && Ee.target instanceof Element && Ee.target.matches("[aria-haspopup='dialog']") && a.interactive && !a.closable && !$.value && q()) {
        Ee.key === " " && Ee.preventDefault(), U(), z(), p.value = !0;
        return;
      }
      if (Ee.key !== "Tab" || Ee.shiftKey || !S.value || !$.value || !h.value)
        return;
      const He = wa(h.value)[0];
      He && (ve(Ee), He.focus());
    }, ve = (Ee) => {
      Ee.preventDefault(), Ee.stopPropagation();
    }, we = () => {
      const Ee = de();
      if (!Ee) return;
      const He = O0(document.body).filter((Ze) => {
        if (ye(h.value, Ze)) return !1;
        const ae = Ze.closest("[role='dialog'], [role='alertdialog']");
        return !ae || ae.contains(Ee);
      }), Ge = He.indexOf(Ee);
      return Ge < 0 ? void 0 : He[Ge + 1];
    }, he = (Ee) => {
      var Ze;
      if (Ee.key === "Escape") {
        fe(Ee);
        return;
      }
      if (Ee.key !== "Tab" || !S.value || !h.value) return;
      const He = wa(h.value), Ge = document.activeElement;
      if (Ee.shiftKey && Ge === He[0])
        ve(Ee), (Ze = de()) == null || Ze.focus();
      else if (!Ee.shiftKey && Ge === He[He.length - 1]) {
        const ae = we();
        if (!ae) return;
        ve(Ee), ae.focus(), w.value || K();
      }
    };
    return mt(() => {
      U(), z(), P(), oe(), W();
    }), (Ee, He) => (c(), g(ce, null, [
      v("div", Oe({
        ref_key: "triggerRef",
        ref: b,
        class: "inline-flex"
      }, Ee.$attrs, {
        onMouseenter: J,
        onMouseleave: Z,
        onFocusin: ge,
        onFocusout: le,
        onKeydown: Ie,
        onClick: G
      }), [
        Ae(Ee.$slots, "trigger", { triggerProps: T.value }, void 0, !0)
      ], 16),
      (c(), H(Dn, { to: "body" }, [
        re(wt, {
          name: "opal-popover",
          onAfterLeave: W
        }, {
          default: xe(() => [
            $.value ? (c(), g("div", {
              key: 0,
              id: I(i),
              ref_key: "bubbleRef",
              ref: h,
              role: S.value ? "dialog" : "tooltip",
              "aria-labelledby": S.value ? s : void 0,
              class: C(["opal-popover absolute z-9999", `opal-popover--${u.value}`]),
              style: Ne({ minWidth: a.minWidth, maxWidth: a.maxWidth }),
              "data-focus-trap-allow-outside": "",
              onMouseenter: se,
              onMouseleave: Se,
              onFocusin: G,
              onFocusout: ee,
              onKeydown: he
            }, [
              v("div", L3, [
                v("div", A3, [
                  v("span", {
                    id: s,
                    class: "min-w-0"
                  }, N(a.header), 1),
                  a.closable ? (c(), H(Be, {
                    key: 0,
                    variant: "ghost",
                    size: "xs",
                    "icon-only": "",
                    "icon-left": "ri-close-line",
                    "aria-label": a.closeLabel,
                    class: "opal-popover-close shrink-0",
                    onClick: ne
                  }, null, 8, ["aria-label"])) : k("", !0)
                ]),
                v("div", {
                  id: d,
                  class: "opal-popover-body p-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
                }, [
                  o() ? (c(), g("div", E3, [
                    I(r)("avatar") || I(r)("action") ? (c(), g("div", R3, [
                      I(r)("avatar") ? (c(), g("div", B3, [
                        Ae(Ee.$slots, "avatar", {}, void 0, !0)
                      ])) : k("", !0),
                      I(r)("action") ? (c(), g("div", D3, [
                        Ae(Ee.$slots, "action", {}, void 0, !0)
                      ])) : k("", !0)
                    ])) : k("", !0),
                    I(r)("title") ? (c(), g("div", {
                      key: 1,
                      class: C(["opal-popover-title min-w-0 font-(--weight-semi-bold)", { "mt-0.5": I(r)("avatar") || I(r)("action") }])
                    }, [
                      Ae(Ee.$slots, "title", {}, void 0, !0)
                    ], 2)) : k("", !0),
                    I(r)("badges") ? (c(), g("div", M3, [
                      Ae(Ee.$slots, "badges", {}, void 0, !0)
                    ])) : k("", !0)
                  ])) : k("", !0),
                  v("div", z3, [
                    Ae(Ee.$slots, "default", {}, void 0, !0)
                  ])
                ])
              ]),
              v("div", {
                class: "opal-popover-arrow",
                "aria-hidden": "true",
                style: Ne({ "--arrow-bg": f() })
              }, [...He[0] || (He[0] = [
                v("svg", {
                  viewBox: "0 0 40 10",
                  width: "40",
                  height: "10",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  v("path", {
                    class: "opal-popover-arrow-fill",
                    d: "M 0 0 L 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0 L 40 0 Z"
                  }),
                  v("path", {
                    class: "opal-popover-arrow-outline",
                    d: "M 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0"
                  })
                ], -1)
              ])], 4)
            ], 46, T3)) : k("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}), Vv = /* @__PURE__ */ ot(O3, [["__scopeId", "data-v-0eb73eba"]]), P3 = {
  key: 0,
  class: "block truncate"
}, F3 = {
  key: 1,
  class: "block truncate text-(--text-text-body)"
}, V3 = /* @__PURE__ */ ke({
  __name: "RelationPopover",
  props: {
    record: {},
    linkId: {},
    header: {},
    viewRecordLabel: {},
    disabled: { type: Boolean },
    linkClass: {}
  },
  setup(e) {
    return (n, t) => (c(), H(Vv, {
      header: e.header,
      position: "top",
      interactive: "",
      delay: 0,
      "min-width": "260px",
      "max-width": "none",
      disabled: e.disabled,
      class: "min-w-0 max-w-full"
    }, ta({
      trigger: xe(({ triggerProps: a }) => [
        (c(), H(lt(e.record.href ? "a" : "span"), Oe({ id: e.linkId }, a, {
          href: e.record.href,
          tabindex: e.record.href ? void 0 : 0,
          role: e.record.href ? void 0 : "button",
          "data-testid": "relation-input-link",
          class: ["min-w-0 truncate rounded-(--border-border-radius-rounded-xs) font-(--weight-medium) hover:underline focus-visible:underline focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden", e.linkClass]
        }), {
          default: xe(() => [
            et(N(e.record.label), 1)
          ]),
          _: 1
        }, 16, ["id", "href", "tabindex", "role", "class"]))
      ]),
      avatar: xe(() => [
        re(Mt, {
          name: e.record.label,
          img: e.record.avatarSrc,
          size: "md"
        }, null, 8, ["name", "img"])
      ]),
      title: xe(() => [
        re(ht, {
          text: e.record.label
        }, null, 8, ["text"])
      ]),
      default: xe(() => [
        e.record.email ? (c(), g("span", P3, N(e.record.email), 1)) : k("", !0),
        e.record.role ? (c(), g("span", F3, N(e.record.role), 1)) : k("", !0)
      ]),
      _: 2
    }, [
      e.record.href ? {
        name: "action",
        fn: xe(() => [
          re(Be, {
            as: "a",
            href: e.record.href,
            variant: "primary",
            size: "xs",
            label: e.viewRecordLabel
          }, null, 8, ["href", "label"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["header", "disabled"]));
  }
}), N3 = ["id", "value", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-required", "aria-invalid", "aria-label", "aria-describedby", "placeholder"], H3 = ["aria-label"], j3 = ["id", "value", "readonly", "disabled", "placeholder", "aria-label", "aria-describedby"], W3 = {
  class: "sr-only",
  role: "status",
  "data-testid": "relation-input-status"
}, xq = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "RelationInput",
  props: {
    modelValue: { default: null },
    recentRecords: { default: () => [] },
    results: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    resultsCount: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "select", "search", "clear", "restore", "view-all", "create"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = m(() => ({
      recent: a.labels.recent ?? "Recently viewed",
      viewAll: a.labels.viewAll ?? "View all results",
      linkRemoved: a.labels.linkRemoved ?? "Link removed",
      restore: a.labels.restore ?? "Restore",
      clear: a.labels.clear ?? "Remove link",
      viewRecord: a.labels.viewRecord ?? "View record",
      noResults: a.labels.noResults ?? "No results",
      recordDetails: a.labels.recordDetails ?? "Record details",
      resultCount: a.labels.resultCount ?? ((O) => `${O} results`),
      loading: a.labels.loading ?? "Loading"
    })), o = je(), i = m(() => a.id ?? `relation-input-${o}`), s = `relation-input-listbox-${o}`, d = `relation-input-hint-${o}`, u = `relation-input-error-${o}`, f = R(null), b = R(null), h = R(null), p = R(null), x = R(null), y = R(""), w = R(!1), $ = R(!1), S = R(!1), L = R(-1), T = R(null), E = m(() => !a.readonly && !a.disabled), A = m(() => y.value.trim() !== ""), D = m(() => !!a.modelValue), M = m(() => D.value && !A.value), F = `relation-input-link-${o}`, X = m(() => {
      const O = [M.value && E.value && F, a.hint && d, a.error && u].filter(Boolean);
      return O.length ? O.join(" ") : void 0;
    }), _ = m(() => a.resultsCount ?? a.results.length), Y = m(() => {
      const O = a.labels.create;
      if (O)
        return typeof O == "function" ? O(y.value.trim()) : O;
    }), B = m(() => {
      const O = A.value ? a.results : a.recentRecords, ne = a.loading ? [] : O.map((fe, ue) => ({ kind: "record", id: `${s}-option-${ue}`, record: fe }));
      return A.value && (!a.loading && _.value > 0 && ne.push({ kind: "viewAll", id: `${s}-view-all`, label: `${r.value.viewAll} (${_.value})` }), Y.value && ne.push({ kind: "create", id: `${s}-create`, label: Y.value })), ne;
    }), W = m(
      () => A.value && !a.loading && a.results.length === 0 ? r.value.noResults : void 0
    ), U = m(
      () => w.value && E.value && (A.value || a.loading || a.recentRecords.length > 0)
    ), z = m(() => !U.value || !A.value || a.loading ? "" : a.results.length ? r.value.resultCount(_.value) : r.value.noResults), P = m(() => {
      var O;
      return (O = B.value[L.value]) == null ? void 0 : O.id;
    });
    $e(B, () => {
      L.value = -1;
    }), $e(
      () => a.modelValue,
      (O) => {
        O && (T.value = null);
      }
    );
    let K = null;
    $e(U, async (O) => {
      var fe;
      if (K == null || K.destroy(), K = null, !O) return;
      await Ue();
      const ne = (fe = b.value) == null ? void 0 : fe.$el;
      !ne || !h.value || (K = ja(ne, h.value, {
        placement: "bottom-start",
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Wc
        ]
      }));
    }), $e(B, async () => {
      await Ue(), await (K == null ? void 0 : K.update());
    }), mt(() => K == null ? void 0 : K.destroy());
    function j() {
      E.value && (T.value = null, w.value = !0);
    }
    function G() {
      w.value = !1, L.value = -1;
    }
    function q(O) {
      T.value = null, y.value = "", G(), l("update:modelValue", O), l("select", O);
    }
    function J(O) {
      if (O.kind === "record") {
        q(O.record);
        return;
      }
      const ne = y.value.trim();
      G(), O.kind === "viewAll" ? l("view-all", ne) : l("create", ne);
    }
    function me() {
      var ne;
      const O = a.modelValue;
      O && (T.value = O, y.value = "", G(), l("update:modelValue", null), l("clear", O), (ne = f.value) == null || ne.focus());
    }
    function ye() {
      var ne;
      const O = T.value;
      O && (T.value = null, l("update:modelValue", O), l("restore", O), (ne = f.value) == null || ne.focus());
    }
    function Z(O) {
      y.value = O.target.value, T.value = null, j(), l("search", y.value);
    }
    function de(O) {
      var fe;
      if (!E.value) return;
      const ne = O.target;
      ne != null && ne.closest("a, button") || (ne !== f.value && (O.preventDefault(), (fe = f.value) == null || fe.focus()), j());
    }
    function ge() {
      $.value = !1, G(), y.value = "";
    }
    function se(O) {
      const ne = B.value.length;
      ne && (L.value = L.value === -1 ? O === 1 ? 0 : ne - 1 : (L.value + O + ne) % ne, Ue(() => {
        var fe, ue;
        return (ue = (fe = document.getElementById(P.value ?? "")) == null ? void 0 : fe.scrollIntoView) == null ? void 0 : ue.call(fe, { block: "nearest" });
      }));
    }
    function Se(O) {
      var fe, ue;
      const ne = U.value;
      switch (O.key) {
        case "ArrowDown":
        case "ArrowUp": {
          O.preventDefault();
          const te = O.key === "ArrowDown" ? 1 : -1;
          if (!ne) {
            if (j(), O.altKey) return;
            Ue(() => se(te));
            return;
          }
          O.altKey || se(te);
          return;
        }
        case "Enter": {
          if (!ne) {
            A.value || (O.preventDefault(), j());
            return;
          }
          O.preventDefault();
          const te = B.value[L.value];
          te && J(te);
          return;
        }
        case " ": {
          !ne && !A.value && (O.preventDefault(), j());
          return;
        }
        case "Escape": {
          if (ne) {
            O.preventDefault(), O.stopPropagation(), G();
            return;
          }
          if (A.value || T.value) {
            O.preventDefault(), O.stopPropagation(), y.value = "", T.value = null;
            return;
          }
          (fe = p.value) == null || fe.handleFieldKeydown(O), (ue = x.value) == null || ue.handleFieldKeydown(O);
          return;
        }
        case "Tab": {
          const te = B.value[L.value];
          ne && (te == null ? void 0 : te.kind) === "record" && q(te.record);
          return;
        }
      }
    }
    function V(O) {
      const ne = O.currentTarget;
      S.value = ne.contains(O.relatedTarget);
    }
    const Q = (O) => O || $.value || U.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", le = (O) => E.value && D.value && (O || S.value || U.value), ee = m(
      () => a.disabled ? "text-(--text-text-link)/44" : "text-(--text-text-link) dark:text-(--colors-text-link)"
    );
    return n({ focus: () => {
      var O;
      return (O = f.value) == null ? void 0 : O.focus();
    } }), (O, ne) => (c(), g(ce, null, [
      v("div", Oe(O.$attrs, {
        class: "flex w-full flex-col gap-px font-inter",
        "data-testid": "relation-input",
        onFocusin: ne[2] || (ne[2] = (fe) => S.value = !0),
        onFocusout: V
      }), [
        e.label ? (c(), H(yt, {
          key: 0,
          ref_key: "labelRef",
          ref: p,
          text: e.label,
          "input-id": i.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: $.value,
          "test-id": "relation-input-label"
        }, null, 8, ["text", "input-id", "required", "tooltip", "focused"])) : k("", !0),
        re(Bn, {
          ref_key: "shellRef",
          ref: b,
          size: e.size,
          disabled: e.disabled,
          readonly: e.readonly,
          error: !!e.error,
          focused: U.value,
          "has-value": D.value,
          class: C(E.value ? "cursor-text" : ""),
          "data-testid": "relation-input-field",
          onMousedown: de
        }, {
          default: xe(({ hovered: fe, iconBoxClass: ue, textClass: te }) => {
            var oe;
            return [
              E.value ? (c(), g(ce, { key: 0 }, [
                M.value && e.modelValue ? (c(), H(V3, {
                  key: 0,
                  record: e.modelValue,
                  header: r.value.recordDetails,
                  "view-record-label": r.value.viewRecord,
                  "link-id": F,
                  disabled: U.value,
                  "link-class": [te, ee.value]
                }, null, 8, ["record", "header", "view-record-label", "disabled", "link-class"])) : k("", !0),
                v("input", {
                  id: i.value,
                  ref_key: "inputRef",
                  ref: f,
                  value: y.value,
                  type: "text",
                  role: "combobox",
                  "aria-autocomplete": "list",
                  "aria-haspopup": "listbox",
                  "aria-expanded": U.value,
                  "aria-controls": U.value ? s : void 0,
                  "aria-activedescendant": U.value ? P.value : void 0,
                  "aria-required": e.required || void 0,
                  "aria-invalid": !!e.error || void 0,
                  "aria-label": e.label ? void 0 : e.ariaLabel,
                  "aria-describedby": X.value,
                  autocomplete: "off",
                  placeholder: D.value ? void 0 : e.placeholder,
                  "data-testid": "relation-input-input",
                  class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) text-(--text-text-black-default) outline-none placeholder:text-(--text-text-disabled-strong) dark:text-(--text-text-white-default) dark:placeholder:text-(--colors-text-white-secondary)", te]),
                  onInput: Z,
                  onFocus: ne[0] || (ne[0] = (Le) => $.value = !0),
                  onBlur: ge,
                  onKeydown: Se
                }, null, 42, N3),
                le(fe) ? (c(), g("button", {
                  key: 1,
                  type: "button",
                  "aria-label": r.value.clear,
                  "data-testid": "relation-input-clear",
                  class: C(["cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(--icons-icon-dark-default) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) dark:text-(--icons-icon-white-default)", ue]),
                  onMousedown: ne[1] || (ne[1] = Ye(() => {
                  }, ["prevent"])),
                  onClick: me
                }, [...ne[5] || (ne[5] = [
                  v("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 42, H3)) : (c(), g("i", {
                  key: 2,
                  class: C(["ri-search-line", [ue, Q(fe)]]),
                  "aria-hidden": "true",
                  "data-testid": "relation-input-search-icon"
                }, null, 2))
              ], 64)) : (c(), g("input", {
                key: 1,
                id: i.value,
                value: ((oe = e.modelValue) == null ? void 0 : oe.label) ?? "",
                type: "text",
                readonly: e.readonly,
                disabled: e.disabled,
                placeholder: e.placeholder,
                "aria-label": e.label ? void 0 : e.ariaLabel,
                "aria-describedby": X.value,
                "data-testid": "relation-input-input",
                class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) outline-none placeholder:text-(--text-text-disabled-strong)", [te, ee.value, e.readonly ? "cursor-default" : "cursor-not-allowed"]])
              }, null, 10, j3))
            ];
          }),
          _: 1
        }, 8, ["size", "disabled", "readonly", "error", "focused", "has-value", "class"]),
        T.value && E.value ? (c(), H(Kl, {
          key: 1,
          class: "mt-1",
          color: "info",
          layout: "stacked",
          "buttons-position": "right",
          message: r.value.linkRemoved,
          buttons: [{ label: r.value.restore, variant: "tertiary", icon: "ri-arrow-left-line", onClick: ye }],
          "data-testid": "relation-input-removed"
        }, null, 8, ["message", "buttons"])) : k("", !0),
        re(xt, {
          ref_key: "helperRef",
          ref: x,
          focused: $.value,
          hint: e.hint,
          error: e.error,
          "hint-id": d,
          "error-id": u,
          "test-id-prefix": "relation-input"
        }, null, 8, ["focused", "hint", "error"]),
        v("span", W3, N(z.value), 1)
      ], 16),
      (c(), H(Dn, { to: "body" }, [
        U.value ? (c(), g("div", {
          key: 0,
          ref_key: "panelRef",
          ref: h,
          class: C(["fixed z-[200] overflow-y-auto", [I(Wa), I(ju)]]),
          "data-focus-trap-allow-outside": "",
          onMousedown: ne[4] || (ne[4] = Ye(() => {
          }, ["prevent"]))
        }, [
          re(I3, {
            "listbox-id": s,
            items: B.value,
            "active-index": L.value,
            query: y.value,
            heading: A.value ? void 0 : r.value.recent,
            name: e.label ?? r.value.recent,
            loading: e.loading,
            "loading-label": r.value.loading,
            "empty-text": W.value,
            onChoose: J,
            onHover: ne[3] || (ne[3] = (fe) => L.value = fe)
          }, null, 8, ["items", "active-index", "query", "heading", "name", "loading", "loading-label", "empty-text"])
        ], 34)) : k("", !0)
      ]))
    ], 64));
  }
}), q3 = {
  key: 0,
  class: "sr-only"
}, U3 = {
  key: 1,
  class: "flex flex-wrap gap-1.5",
  "data-testid": "avatar-label-badges"
}, yq = /* @__PURE__ */ ke({
  __name: "AvatarLabel",
  props: {
    name: {},
    helperText: { default: void 0 },
    type: { default: "heading-helper" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    img: { default: void 0 },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    truncationFocusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = {
      "heading-helper": {
        sm: {
          avatar: "sm",
          gap: "gap-1.5",
          name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
          helper: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
        },
        md: {
          avatar: "md",
          gap: "gap-2",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
        },
        lg: {
          avatar: "lg",
          gap: "gap-2.5",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)"
        },
        xl: {
          avatar: "xl",
          gap: "gap-2.5",
          name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)",
          helper: "text-(length:--size-xl) leading-(--line-height-xxl) font-(--weight-regular)"
        }
      },
      text: {
        sm: { avatar: "xs", gap: "gap-1.5", name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)" },
        md: { avatar: "sm", gap: "gap-1.5", name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)" },
        lg: { avatar: "lg", gap: "gap-2", name: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)" },
        xl: { avatar: "xl", gap: "gap-2", name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)" }
      }
    }, a = m(() => t[n.type][n.size]), l = m(() => {
      var b;
      return n.type === "heading-helper" && !!((b = n.helperText) != null && b.trim());
    }), r = m(() => n.type === "heading-helper" ? "xs" : "sm"), o = m(
      () => Vu(n.badges, n.maxBadges).map((b) => ({
        ...b,
        theme: n.disabled ? "disabled" : b.theme ?? "neutral"
      }))
    ), i = m(() => n.type === "heading-helper" && o.value.length > 0), s = m(() => i.value ? "items-start" : "items-center"), d = m(
      () => i.value ? n.size === "xl" ? "mt-0.5" : "mt-1" : void 0
    ), u = m(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), f = m(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    return (b, h) => (c(), g("div", {
      class: C(["flex min-w-0", [a.value.gap, s.value]]),
      "data-testid": "avatar-label"
    }, [
      re(Mt, {
        name: e.name,
        img: e.img,
        size: a.value.avatar,
        entity: e.entity,
        "avatar-style": e.avatarStyle,
        status: e.status,
        "status-label": e.statusLabel,
        presentational: "",
        class: C([{ "opacity-70": e.disabled }, d.value])
      }, null, 8, ["name", "img", "size", "entity", "avatar-style", "status", "status-label", "class"]),
      v("div", {
        class: C(["flex min-w-0 flex-1 flex-col", e.type === "text" ? "gap-1" : "gap-px"])
      }, [
        v("div", {
          class: C(["flex min-w-0", [a.value.name, u.value]]),
          "data-testid": "avatar-label-name"
        }, [
          re(ht, {
            text: e.name,
            focusable: e.truncationFocusable
          }, {
            default: xe(() => {
              var p;
              return [
                e.status && ((p = e.statusLabel) != null && p.trim()) ? (c(), g("span", q3, ", " + N(e.statusLabel.trim()), 1)) : k("", !0)
              ];
            }),
            _: 1
          }, 8, ["text", "focusable"])
        ], 2),
        l.value ? (c(), g("div", {
          key: 0,
          class: C(["flex min-w-0", [a.value.helper, f.value]]),
          "data-testid": "avatar-label-helper"
        }, [
          re(ht, {
            text: e.helperText,
            focusable: e.truncationFocusable
          }, null, 8, ["text", "focusable"])
        ], 2)) : k("", !0),
        o.value.length ? (c(), g("div", U3, [
          (c(!0), g(ce, null, Re(o.value, (p, x) => (c(), g(ce, { key: x }, [
            I(Fu)(p) ? (c(), H(Pu, {
              key: 0,
              label: p.label,
              "hidden-labels": p.hiddenLabels,
              theme: p.theme,
              size: r.value,
              focusable: e.truncationFocusable
            }, null, 8, ["label", "hidden-labels", "theme", "size", "focusable"])) : (c(), H(ct, {
              key: 1,
              label: p.label,
              theme: p.theme,
              size: r.value,
              truncate: p.truncate ?? !1,
              "truncation-focusable": e.truncationFocusable,
              "show-close-icon": !1
            }, null, 8, ["label", "theme", "size", "truncate", "truncation-focusable"]))
          ], 64))), 128))
        ])) : k("", !0)
      ], 2)
    ], 2));
  }
}), G3 = { class: "modal-scrollbar border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl p-1 overflow-y-auto max-h-135" }, K3 = {
  key: 0,
  class: "flex justify-center py-8"
}, Y3 = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, J3 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, X3 = {
  key: 2,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, Z3 = { class: "text-sm text-(--text-text-body-subtle)" }, Q3 = ["aria-label"], _3 = ["aria-selected", "onClick"], e4 = { class: "flex items-center gap-1.5 min-w-0 flex-1" }, t4 = { class: "flex flex-col min-w-0" }, n4 = { class: "text-xs leading-5 font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, a4 = {
  key: 0,
  class: "text-xs leading-5 text-(--text-text-body) dark:text-(--text-text-white-default)"
}, kq = /* @__PURE__ */ ke({
  __name: "AutoCompleteAllResultsModal",
  props: {
    modelValue: { type: Boolean },
    options: {},
    title: {},
    subtitle: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    loadErrorLabel: { default: void 0 },
    emptyLabel: { default: void 0 },
    closeLabel: { default: void 0 },
    selectLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(null);
    $e(
      () => t.modelValue,
      (d) => {
        d && (l.value = null);
      }
    );
    function r(d) {
      var u;
      return ((u = d.meta) == null ? void 0 : u.uniqueKey) ?? d.value;
    }
    function o(d) {
      const u = Fv(d);
      return { label: u == null ? void 0 : u.label, theme: u == null ? void 0 : u.theme, leftIcon: u == null ? void 0 : u.icon, brandIcon: u == null ? void 0 : u.brandIcon };
    }
    const i = m(() => [
      {
        id: "close",
        label: t.closeLabel ?? "Close",
        variant: "secondary",
        testId: "autocomplete-all-results-close",
        onClick: () => a("update:modelValue", !1)
      },
      {
        id: "select",
        label: t.selectLabel ?? "Select",
        variant: "primary",
        testId: "autocomplete-all-results-select",
        icon: "ri-check-line",
        disabled: !l.value,
        onClick: s
      }
    ]);
    function s() {
      l.value && (a("confirm", l.value), a("update:modelValue", !1));
    }
    return (d, u) => (c(), H(I(Va), {
      "model-value": e.modelValue,
      size: "lg",
      "show-close-button": !0,
      "footer-align": "split",
      "overlay-class": "!z-[300]",
      "content-class": "!max-h-[748px]",
      "header-class": "pt-0!",
      title: e.title,
      subtitle: e.subtitle,
      actions: i.value,
      "onUpdate:modelValue": u[0] || (u[0] = (f) => d.$emit("update:modelValue", f))
    }, {
      default: xe(() => [
        v("div", G3, [
          e.loading ? (c(), g("div", K3, [...u[1] || (u[1] = [
            v("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1)
          ])])) : e.error ? (c(), g("div", Y3, [
            u[2] || (u[2] = v("i", { class: "ri-error-warning-line text-2xl text-red-500" }, null, -1)),
            v("span", J3, N(e.loadErrorLabel ?? "Unable to load results."), 1)
          ])) : e.options.length ? (c(), g("div", {
            key: 3,
            role: "listbox",
            "aria-label": e.title,
            class: "flex flex-col gap-0.5"
          }, [
            (c(!0), g(ce, null, Re(e.options, (f) => (c(), g("button", {
              key: r(f),
              type: "button",
              role: "option",
              "aria-selected": !!l.value && r(l.value) === r(f),
              class: C([
                "flex items-center justify-between h-11.5 w-full p-2 rounded-lg cursor-pointer transition-colors text-left",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
                l.value && r(l.value) === r(f) ? "bg-(--colors-background-accent) dark:bg-indigo-950/20" : "bg-transparent hover:bg-(--colors-background-hover) dark:hover:bg-(--colors-background-hover)"
              ]),
              onClick: (b) => l.value = f
            }, [
              v("span", e4, [
                f.image !== void 0 ? (c(), H(I(Mt), {
                  key: 0,
                  as: "span",
                  img: f.image ?? void 0,
                  name: f.label,
                  size: "sm",
                  presentational: !0,
                  class: "border border-(--border-border-base-soft)"
                }, null, 8, ["img", "name"])) : k("", !0),
                v("span", t4, [
                  v("span", n4, N(f.label), 1),
                  f.description ? (c(), g("span", a4, N(f.description), 1)) : k("", !0)
                ])
              ]),
              f.badge ? (c(), H(Ou, Oe({
                key: 0,
                ref_for: !0
              }, o(f), {
                size: "sm",
                class: "shrink-0 ml-2",
                "data-testid": "autocomplete-all-results-badge"
              }), null, 16)) : k("", !0)
            ], 10, _3))), 128))
          ], 8, Q3)) : (c(), g("div", X3, [
            v("span", Z3, N(e.emptyLabel ?? "No results to display."), 1)
          ]))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title", "subtitle", "actions"]));
  }
}), l4 = ["id", "name", "value", "placeholder", "disabled", "required", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-activedescendant"], r4 = ["id", "aria-label"], o4 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 dark:text-(--colors-text-white-secondary)"
}, i4 = ["id", "data-index", "aria-selected", "aria-disabled", "onMousedown", "onMouseenter"], s4 = /* @__PURE__ */ ke({
  __name: "TimePickerInput",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    placeholder: { default: "HH:mm" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    hint: { default: void 0 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    minuteStep: { default: 15 },
    minTime: { default: void 0 },
    maxTime: { default: void 0 },
    gridStartTime: { default: void 0 },
    gridEndTime: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    groupPosition: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R(!1), o = R(null), i = R(null), s = R(""), d = R(-1), u = R(null), f = R(null), b = R(null);
    let h = null;
    const p = () => {
      !f.value || !u.value || (h == null || h.destroy(), h = ja(f.value, u.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Wc
        ]
      }));
    }, x = () => {
      h == null || h.destroy(), h = null;
    }, y = je(), w = m(() => t.id || y), $ = m(() => t.label ? `${w.value}-label` : void 0), S = m(() => `${w.value}-error`), L = m(() => `${w.value}-hint`), T = m(() => `${w.value}-listbox`), E = m(() => !!t.error), A = m(
      () => t.showError !== void 0 ? t.showError : E.value
    ), D = m(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const Q = [];
      return t.hint && Q.push(L.value), E.value && A.value && Q.push(S.value), Q.length > 0 ? Q.join(" ") : void 0;
    }), M = m(() => {
      const Q = [], le = t.minuteStep, ee = t.gridStartTime ? X(t.gridStartTime) : 0, O = t.gridEndTime ? X(t.gridEndTime) : 24 * 60 - 1;
      for (let ne = ee; ne <= O; ne += le) {
        const fe = Math.floor(ne / 60).toString().padStart(2, "0"), ue = (ne % 60).toString().padStart(2, "0");
        Q.push(`${fe}:${ue}`);
      }
      return Q;
    }), F = m(() => {
      if (!s.value) return M.value;
      const Q = s.value.replace(/[^0-9:]/g, "");
      return M.value.filter((le) => le.includes(Q));
    });
    function X(Q) {
      const [le, ee] = Q.split(":").map(Number);
      return le * 60 + ee;
    }
    function _(Q) {
      if (!t.minTime && !t.maxTime) return !1;
      const le = X(Q), ee = t.minTime ? X(t.minTime) : 0, O = t.maxTime ? X(t.maxTime) : 24 * 60 - 1;
      return le < ee || le > O;
    }
    function Y(Q) {
      const le = Q.findIndex((ee) => !_(ee));
      return le >= 0 ? le : 0;
    }
    function B(Q, le, ee) {
      let O = Q;
      for (let ne = 0; ne < ee.length; ne++) {
        if (O += le, O < 0 || O >= ee.length) return Q;
        if (!_(ee[O])) return O;
      }
      return Q;
    }
    const U = {
      sm: {
        container: "h-[36px] px-2.5 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      lg: {
        container: "h-[48px] px-3.5 gap-2",
        text: "text-base leading-6",
        icon: "h-5 w-5"
      }
    }[t.size], z = m(() => t.groupPosition === "start" ? "rounded-r-none! border-r-0!" : t.groupPosition === "end" ? "rounded-l-none!" : ""), P = m(() => {
      const Q = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${Q} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (E.value)
        return `${Q} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-white dark:bg-(--colors-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-text-black-default dark:text-(--colors-text-white-default)`;
      if (r.value)
        return `${Q} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-text-black-default dark:text-(--colors-text-white-default)`;
      const ee = t.modelValue !== void 0 && t.modelValue !== "" ? "text-text-black-default" : "text-text-body-subtle";
      return `${Q} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) hover:border-(--border-border-accent) dark:border-(--colors-border-base) transition-colors ${ee} dark:text-(--colors-text-white-default)`;
    }), K = m(() => t.fullWidth ? "w-full" : ""), j = m(() => t.fullWidth ? {} : { width: t.width }), G = m(() => `relative flex items-start pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter flex-col gap-0.5 ${t.fullWidth ? "w-full" : ""}`), q = m(() => t.fullWidth ? {} : { width: t.width }), J = () => {
      if (t.disabled) return;
      l.value = !0, s.value = "";
      const Q = M.value.indexOf(t.modelValue || "");
      Q >= 0 ? d.value = Q : t.modelValue ? d.value = -1 : d.value = Y(M.value), Se();
    }, me = () => {
      l.value = !1, s.value = "", d.value = -1;
    }, ye = (Q) => {
      var le;
      _(Q) || (a("update:modelValue", Q), a("change", Q), me(), (le = f.value) == null || le.focus());
    }, Z = (Q) => {
      t.disabled || (r.value = !0, a("focus", Q));
    }, de = (Q) => {
      setTimeout(() => {
        var le;
        (le = b.value) != null && le.contains(document.activeElement) || (r.value = !1, me(), a("blur", Q));
      }, 150);
    }, ge = (Q) => {
      const le = Q.target;
      s.value = le.value, l.value || J(), d.value = 0;
    }, se = (Q) => {
      var ee, O;
      l.value || ((ee = o.value) == null || ee.handleFieldKeydown(Q), (O = i.value) == null || O.handleFieldKeydown(Q));
      const le = F.value;
      switch (Q.key) {
        case "ArrowDown":
          Q.preventDefault(), l.value ? (d.value = B(d.value, 1, le), Se()) : J();
          break;
        case "ArrowUp":
          Q.preventDefault(), l.value && (d.value = B(d.value, -1, le), Se());
          break;
        case "Enter":
          Q.preventDefault(), l.value && d.value >= 0 && d.value < le.length ? ye(le[d.value]) : l.value || J();
          break;
        case "Escape":
          l.value && (Q.stopPropagation(), Q.preventDefault(), me());
          break;
        case "Tab":
          me();
          break;
      }
    }, Se = () => {
      requestAnimationFrame(() => {
        var le;
        const Q = (le = u.value) == null ? void 0 : le.querySelector(`[data-index="${d.value}"]`);
        Q == null || Q.scrollIntoView({ block: "nearest" });
      });
    }, V = (Q) => {
      b.value && !b.value.contains(Q.target) && (me(), r.value = !1);
    };
    return dt(() => {
      document.addEventListener("mousedown", V);
    }), gt(() => {
      document.removeEventListener("mousedown", V), x();
    }), $e(l, async (Q) => {
      Q ? (await Ue(), p()) : x();
    }), $e(s, () => {
      d.value = 0;
    }), (Q, le) => (c(), g("div", {
      ref_key: "containerRef",
      ref: b,
      class: C(G.value),
      style: Ne(q.value)
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: $.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": w.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        "test-id": "time-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      v("div", {
        class: C(["relative", K.value]),
        style: Ne(j.value)
      }, [
        v("div", {
          class: C([P.value, I(U).container, K.value, z.value]),
          style: Ne(j.value),
          onClick: J
        }, [
          v("i", {
            class: C(["ri-time-line flex-shrink-0", [
              I(U).icon,
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#7c86ff]" : "text-gray-400 dark:text-(--colors-text-white-secondary)"
            ]])
          }, null, 2),
          v("input", {
            id: w.value,
            ref_key: "inputRef",
            ref: f,
            type: "text",
            name: e.name,
            value: l.value ? s.value : e.modelValue || "",
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            autocomplete: "off",
            "data-testid": "time-picker-input",
            role: "combobox",
            "aria-expanded": l.value,
            "aria-controls": T.value,
            "aria-labelledby": $.value,
            "aria-label": e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : "false",
            "aria-invalid": E.value ? "true" : void 0,
            "aria-describedby": D.value,
            "aria-activedescendant": l.value && d.value >= 0 ? `${w.value}-option-${d.value}` : void 0,
            class: C([
              "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 w-full",
              I(U).text,
              !e.disabled && "cursor-text"
            ]),
            onFocus: Z,
            onBlur: de,
            onInput: ge,
            onKeydown: se
          }, null, 42, l4)
        ], 6),
        Jl(v("div", {
          id: T.value,
          ref_key: "dropdownRef",
          ref: u,
          role: "listbox",
          "aria-label": e.label || e.ariaLabel || "Time selection",
          class: "fixed z-50 max-h-[200px] overflow-auto rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark)",
          "data-testid": "time-picker-dropdown"
        }, [
          F.value.length === 0 ? (c(), g("div", o4, " Aucun horaire disponible ")) : k("", !0),
          (c(!0), g(ce, null, Re(F.value, (ee, O) => (c(), g("div", {
            id: `${w.value}-option-${O}`,
            key: ee,
            "data-index": O,
            role: "option",
            "aria-selected": ee === e.modelValue,
            "aria-disabled": _(ee) ? "true" : void 0,
            class: C(["px-3 py-2 text-sm transition-colors", [
              _(ee) ? "cursor-not-allowed text-text-disabled dark:text-(--colors-text-disabled)" : "cursor-pointer",
              !_(ee) && ee === e.modelValue ? "bg-[#7c86ff]/10 text-[#7c86ff] font-medium" : "",
              !_(ee) && ee !== e.modelValue && O === d.value ? "bg-gray-100 dark:bg-[rgba(255,255,255,0.08)] text-text-black-default dark:text-(--colors-text-white-default)" : "",
              !_(ee) && ee !== e.modelValue && O !== d.value ? "text-text-black-default dark:text-(--colors-text-white-default) hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)]" : ""
            ]]),
            onMousedown: Ye((ne) => ye(ee), ["prevent"]),
            onMouseenter: (ne) => !_(ee) && (d.value = O)
          }, N(ee), 43, i4))), 128))
        ], 8, r4), [
          [Tu, l.value]
        ])
      ], 6),
      re(xt, {
        ref_key: "helperRef",
        ref: i,
        focused: r.value,
        hint: e.hint,
        error: A.value ? e.error : void 0,
        "hint-id": L.value,
        "error-id": S.value,
        "test-id-prefix": "time-picker"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
    ], 6));
  }
}), wq = /* @__PURE__ */ ot(s4, [["__scopeId", "data-v-60bc77d5"]]), d4 = {
  "data-testid": "number-range-input",
  class: "flex flex-col gap-4 w-full"
}, u4 = {
  key: 0,
  "data-testid": "number-range-slider",
  class: "relative w-full h-5"
}, c4 = ["min", "max", "step", "value", "disabled", "aria-label"], f4 = ["min", "max", "step", "value", "disabled", "aria-label"], h4 = { class: "flex flex-1 min-w-0 flex-col gap-px" }, b4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], g4 = { class: "shrink-0 py-2 font-(--weight-medium) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, m4 = { class: "flex flex-1 min-w-0 flex-col gap-px" }, p4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], v4 = {
  key: 1,
  "data-testid": "number-range-hint",
  class: "text-(length:--size-xs) leading-(--line-height-s) text-(--text-text-body-subtle) dark:text-(--colors-text-body-subtle) m-0"
}, x4 = /* @__PURE__ */ ke({
  __name: "NumberRangeInput",
  props: {
    minValue: { default: null },
    maxValue: { default: null },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minPlaceholder: { default: "0" },
    maxPlaceholder: { default: "" },
    separatorLabel: { default: "to" },
    showSlider: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    minAriaLabel: { default: "Minimum value" },
    maxAriaLabel: { default: "Maximum value" },
    minLabel: { default: void 0 },
    maxLabel: { default: void 0 },
    clampInputToBounds: { type: Boolean, default: !0 },
    dataMin: { default: null },
    dataMax: { default: null },
    hintLabel: { default: "" }
  },
  emits: ["update:minValue", "update:maxValue"],
  setup(e, { emit: n }) {
    const t = e, a = je(), l = je(), r = n, o = (T) => Math.max(t.min, Math.min(T, t.max)), i = R(o(t.minValue ?? t.min)), s = R(o(t.maxValue ?? t.max));
    $e(
      () => t.minValue,
      (T) => {
        i.value = o(T ?? t.min);
      }
    ), $e(
      () => t.maxValue,
      (T) => {
        s.value = o(T ?? t.max);
      }
    );
    const d = m(() => t.max - t.min || 1), u = m(() => (i.value - t.min) / d.value * 100), f = m(() => (s.value - t.min) / d.value * 100), b = m(() => ({
      left: `${u.value}%`,
      width: `${f.value - u.value}%`
    })), h = m(() => u.value > 50), p = m(
      () => t.dataMin != null && t.dataMax != null && t.dataMax > t.dataMin
    ), x = m(
      () => t.dataMin != null ? Math.max(0, Math.min(100, (t.dataMin - t.min) / d.value * 100)) : 0
    ), y = m(
      () => t.dataMax != null ? Math.max(0, Math.min(100, (t.dataMax - t.min) / d.value * 100)) : 100
    );
    function w(T) {
      const E = T.target, A = Number(E.value), D = Math.min(A, s.value - t.step);
      i.value = D, A !== D && (E.value = String(D)), r("update:minValue", D);
    }
    function $(T) {
      const E = T.target, A = Number(E.value), D = Math.max(A, i.value + t.step);
      s.value = D, A !== D && (E.value = String(D)), r("update:maxValue", D);
    }
    function S(T) {
      const E = T.target, A = E.value;
      if (A === "") {
        r("update:minValue", null);
        return;
      }
      const D = Number(A);
      if (Number.isFinite(D))
        if (i.value = o(D), t.clampInputToBounds) {
          const M = o(D);
          D !== M && (E.value = String(M)), r("update:minValue", M);
        } else
          r("update:minValue", D);
    }
    function L(T) {
      const E = T.target, A = E.value;
      if (A === "") {
        r("update:maxValue", null);
        return;
      }
      const D = Number(A);
      if (Number.isFinite(D))
        if (s.value = o(D), t.clampInputToBounds) {
          const M = o(D);
          D !== M && (E.value = String(M)), r("update:maxValue", M);
        } else
          r("update:maxValue", D);
    }
    return (T, E) => (c(), g("div", d4, [
      e.showSlider ? (c(), g("div", u4, [
        E[0] || (E[0] = v("div", { class: "absolute top-1/2 -translate-y-1/2 w-full h-2 rounded-(--border-border-radius-rounded-base) bg-(--background-background-gray)" }, null, -1)),
        p.value ? (c(), g(ce, { key: 0 }, [
          v("div", {
            "data-testid": "number-range-data-marker-min",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ne({ left: `${x.value}%` }),
            "aria-hidden": "true"
          }, null, 4),
          v("div", {
            "data-testid": "number-range-data-marker-max",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ne({ left: `${y.value}%` }),
            "aria-hidden": "true"
          }, null, 4)
        ], 64)) : k("", !0),
        v("div", {
          class: "absolute top-1/2 -translate-y-1/2 h-2 rounded-(--border-border-radius-rounded-base)",
          style: Ne({ ...b.value, background: "linear-gradient(36deg, #716FF2 11%, #52DBF5 87%)" })
        }, null, 4),
        v("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: i.value,
          disabled: e.disabled,
          "aria-label": e.minAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-30" : "z-20"]),
          onInput: w
        }, null, 42, c4),
        v("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: s.value,
          disabled: e.disabled,
          "aria-label": e.maxAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-20" : "z-30"]),
          onInput: $
        }, null, 42, f4)
      ])) : k("", !0),
      v("div", {
        class: C(["flex gap-6 w-full", e.minLabel || e.maxLabel ? "items-end" : "items-center"])
      }, [
        v("div", h4, [
          e.minLabel ? (c(), H(yt, {
            key: 0,
            text: e.minLabel,
            "input-id": I(a),
            "test-id": "number-range-min-label"
          }, null, 8, ["text", "input-id"])) : k("", !0),
          v("input", {
            id: I(a),
            type: "number",
            "data-testid": "number-range-min",
            value: e.minValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.minPlaceholder,
            disabled: e.disabled,
            "aria-label": e.minLabel ? void 0 : e.minAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: S
          }, null, 40, b4)
        ]),
        v("span", g4, N(e.separatorLabel), 1),
        v("div", m4, [
          e.maxLabel ? (c(), H(yt, {
            key: 0,
            text: e.maxLabel,
            "input-id": I(l),
            "test-id": "number-range-max-label"
          }, null, 8, ["text", "input-id"])) : k("", !0),
          v("input", {
            id: I(l),
            type: "number",
            "data-testid": "number-range-max",
            value: e.maxValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.maxPlaceholder,
            disabled: e.disabled,
            "aria-label": e.maxLabel ? void 0 : e.maxAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: L
          }, null, 40, p4)
        ])
      ], 2),
      e.hintLabel ? (c(), g("p", v4, N(e.hintLabel), 1)) : k("", !0)
    ]));
  }
}), Nv = /* @__PURE__ */ ot(x4, [["__scopeId", "data-v-61d0ad59"]]), y4 = { class: "inline-flex min-w-0 items-center gap-1" }, k4 = { class: "inline-flex min-w-0 items-center gap-0.5" }, w4 = ["for"], C4 = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, dd = /* @__PURE__ */ ke({
  __name: "ToggleLabel",
  props: {
    forId: {},
    text: {},
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    unavailable: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("span", y4, [
      v("span", k4, [
        v("label", {
          for: e.forId,
          class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)", e.unavailable ? "cursor-not-allowed" : "cursor-pointer"])
        }, N(e.text), 11, w4),
        e.required ? (c(), g("span", C4, "*")) : k("", !0)
      ]),
      e.labelTooltip ? (c(), H(ft, {
        key: 0,
        text: e.labelTooltip,
        as: "span",
        "labels-trigger": "",
        role: "img",
        tabindex: "0",
        "aria-label": e.labelTooltip,
        class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
      }, {
        default: xe(() => [...t[0] || (t[0] = [
          v("i", {
            class: "ri-question-line text-(length:--icon-size-xs) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["text", "aria-label"])) : k("", !0)
    ]));
  }
}), Hv = Symbol("ToggleGroup"), S4 = { class: "flex min-w-0 flex-[1_1_11rem] flex-col gap-2" }, $4 = { class: "flex h-8 w-22.5 shrink-0 items-center" }, I4 = ["for"], T4 = ["id"], L4 = ["data-testid"], A4 = ["id", "name", "checked", "disabled", "aria-disabled", "onChange"], E4 = {
  key: 0,
  class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, R4 = { class: "sr-only" }, B4 = { class: "flex min-w-0 items-start justify-between gap-2" }, D4 = ["id"], M4 = ["id"], z4 = { class: "flex min-w-0 flex-[1_1_11rem] items-center gap-2.5" }, O4 = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, P4 = ["id"], F4 = "label, a, button, input, select, textarea, summary, [role=button], [role=link], [tabindex]", ud = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)", dr = "min-w-0 rounded-(--border-border-radius-rounded-l) border border-(--colors-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-xs) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)", Cq = /* @__PURE__ */ ke({
  __name: "ToggleInput",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    description: { default: void 0 },
    type: { default: void 0 },
    icon: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    leftLabel: { default: void 0 },
    rightLabel: { default: void 0 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Nt(Hv, void 0), r = m(() => t.type ?? (l == null ? void 0 : l.value) ?? "advanced"), o = m(() => r.value === "left-right-label" || r.value === "left-right-icons"), i = m(() => r.value !== "default" && !o.value), s = m(() => t.disabled || t.ariaDisabled), d = je(), u = m(() => t.id ?? d), f = m(() => `${u.value}-description`), b = m(() => {
      const M = !!t.description && !o.value, F = [t.ariaDescribedby, M ? f.value : void 0].filter(Boolean);
      return F.length > 0 ? F.join(" ") : void 0;
    }), h = m(() => ({
      id: u.value,
      modelValue: t.modelValue,
      disabled: t.disabled,
      ariaDisabled: t.ariaDisabled,
      "aria-describedby": b.value,
      "onUpdate:modelValue": (M) => a("update:modelValue", M)
    })), p = Yn("toggleSwitch");
    function x(M) {
      var W;
      const F = M.currentTarget, X = M.target;
      if (M.detail > 1) {
        const U = X == null ? void 0 : X.closest("label");
        U && F.contains(U) && M.preventDefault();
        return;
      }
      if (!i.value) return;
      const _ = (W = p.value) == null ? void 0 : W.$el;
      if (!_ || !X || _.contains(X) || _.disabled) return;
      const Y = X.closest(F4);
      if (Y && F.contains(Y)) return;
      const B = window.getSelection();
      B && !B.isCollapsed && F.contains(B.anchorNode) || (M.stopPropagation(), _.click());
    }
    const y = Yn("leftRadio"), w = Yn("rightRadio"), $ = m(() => [
      { key: "left", right: !1, text: t.leftLabel, icon: t.leftIcon },
      { key: "right", right: !0, text: t.rightLabel, icon: t.rightIcon }
    ]);
    function S(M) {
      t.ariaDisabled && M.preventDefault();
    }
    function L(M, F = !1) {
      var X, _;
      s.value || t.modelValue === M || (a("update:modelValue", M), F && ((_ = (X = (M ? w : y).value) == null ? void 0 : X[0]) == null || _.focus()));
    }
    async function T(M) {
      var X;
      L(M), await Ue();
      const F = (X = (t.modelValue ? w : y).value) == null ? void 0 : X[0];
      F && !F.checked && (F.checked = !0);
    }
    const E = m(() => {
      const M = s.value ? "" : " cursor-pointer";
      switch (r.value) {
        case "default":
          return "flex min-w-0 items-start gap-2";
        case "simple":
          return `${dr} flex items-start gap-2.5 p-4${M}`;
        case "logo":
          return `${dr} flex flex-wrap items-start justify-between gap-x-16 gap-y-3 p-4${M}`;
        case "title-toggle":
          return `${dr} flex flex-col gap-2 p-4${M}`;
        case "toggle-text":
          return `${dr} flex items-center gap-2.5 px-4 py-3${M}`;
        case "left-right-label":
        case "left-right-icons":
          return "group inline-flex items-center gap-3";
        default:
          return `${dr} flex flex-wrap items-center justify-between gap-x-16 gap-y-3 px-4 py-3${M}`;
      }
    }), A = m(() => s.value ? "relative flex cursor-not-allowed" : "relative flex cursor-pointer"), D = m(
      () => o.value ? { role: "radiogroup", "aria-label": t.label, "aria-describedby": t.ariaDescribedby } : {}
    );
    return (M, F) => (c(), g("div", Oe({ class: E.value }, D.value, { onClick: x }), [
      r.value === "logo" ? (c(), g(ce, { key: 0 }, [
        v("div", S4, [
          v("div", $4, [
            Ae(M.$slots, "logo")
          ]),
          v("label", {
            for: u.value,
            class: "sr-only"
          }, N(e.label), 9, I4),
          e.description ? (c(), g("p", {
            key: 0,
            id: f.value,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
          }, N(e.description), 9, T4)) : k("", !0)
        ]),
        re(Ja, Oe({
          ref_key: "toggleSwitch",
          ref: p
        }, h.value), null, 16)
      ], 64)) : o.value ? (c(!0), g(ce, { key: 1 }, Re($.value, (X) => (c(), g(ce, {
        key: X.key
      }, [
        X.right ? (c(), H(Ja, {
          key: 0,
          type: "default",
          presentational: "",
          "aria-hidden": "true",
          "data-testid": "toggle-input-switch",
          class: C(["group-has-focus-visible:shadow-(--shadow-focus-l) group-has-focus-visible:outline-2 group-has-focus-visible:outline-transparent", s.value ? "cursor-not-allowed" : "cursor-pointer"]),
          "model-value": e.modelValue,
          disabled: e.disabled,
          "aria-disabled": e.ariaDisabled,
          onClick: F[0] || (F[0] = (_) => L(!e.modelValue, !0))
        }, null, 8, ["class", "model-value", "disabled", "aria-disabled"])) : k("", !0),
        v("label", {
          class: C(A.value),
          "data-testid": `toggle-input-${X.key}`
        }, [
          v("input", {
            id: `${u.value}-${X.key}`,
            ref_for: !0,
            ref: X.right ? "rightRadio" : "leftRadio",
            type: "radio",
            class: "absolute inset-0 m-0 size-full cursor-[inherit] appearance-none opacity-0",
            name: u.value,
            checked: e.modelValue === X.right,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled ? "true" : void 0,
            onClick: S,
            onChange: (_) => T(X.right)
          }, null, 40, A4),
          r.value === "left-right-label" ? (c(), g("span", E4, N(X.text), 1)) : (c(), g(ce, { key: 1 }, [
            v("i", {
              "aria-hidden": "true",
              class: C([X.icon, "block text-(length:--icon-size-md) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"])
            }, null, 2),
            v("span", R4, N(X.text), 1)
          ], 64))
        ], 10, L4)
      ], 64))), 128)) : r.value === "title-toggle" ? (c(), g(ce, { key: 2 }, [
        v("div", B4, [
          re(dd, {
            "for-id": u.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          re(Ja, Oe({
            ref_key: "toggleSwitch",
            ref: p
          }, h.value), null, 16)
        ]),
        e.description ? (c(), g("p", {
          key: 0,
          id: f.value,
          class: C(ud)
        }, N(e.description), 9, D4)) : k("", !0)
      ], 64)) : r.value === "default" || r.value === "simple" || r.value === "toggle-text" ? (c(), g(ce, { key: 3 }, [
        re(Ja, Oe({
          ref_key: "toggleSwitch",
          ref: p
        }, h.value), null, 16),
        v("div", {
          class: C(["flex min-w-0 flex-col", r.value === "default" ? "gap-0.5" : r.value === "simple" ? "flex-1 gap-1" : "flex-1 gap-0.5"])
        }, [
          re(dd, {
            "for-id": u.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          e.description ? (c(), g("p", {
            key: 0,
            id: f.value,
            class: C(ud)
          }, N(e.description), 9, M4)) : k("", !0)
        ], 2)
      ], 64)) : (c(), g(ce, { key: 4 }, [
        v("div", z4, [
          e.icon ? (c(), H(Vt, {
            key: 0,
            icon: e.icon,
            color: "white",
            size: "md",
            type: "square"
          }, null, 8, ["icon"])) : k("", !0),
          v("div", O4, [
            re(dd, {
              "for-id": u.value,
              text: e.label,
              required: e.required,
              "label-tooltip": e.labelTooltip,
              unavailable: s.value
            }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
            e.description ? (c(), g("p", {
              key: 0,
              id: f.value,
              class: C(ud)
            }, N(e.description), 9, P4)) : k("", !0)
          ])
        ]),
        re(Ja, Oe({
          ref_key: "toggleSwitch",
          ref: p
        }, h.value), null, 16)
      ], 64))
    ], 16));
  }
}), V4 = ["aria-label"], Sq = /* @__PURE__ */ ke({
  __name: "ToggleGroup",
  props: {
    type: { default: "default" },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      default: "simple",
      integration: "logo",
      settings: "advanced"
    };
    return nn(
      Hv,
      m(() => t[n.type])
    ), (a, l) => (c(), g("div", {
      role: "group",
      "aria-label": e.ariaLabel,
      class: "flex min-w-0 flex-col gap-4"
    }, [
      Ae(a.$slots, "default")
    ], 8, V4));
  }
}), N4 = ["value", "placeholder", "aria-label", "title", "disabled"], H4 = ["aria-label"], j4 = /* @__PURE__ */ ke({
  __name: "CollapsibleSearch",
  props: {
    modelValue: {},
    placeholder: { default: "Search..." },
    labels: { default: void 0 },
    maxWidth: { default: "175px" },
    disabled: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !0 },
    debounce: { default: 0 }
  },
  emits: ["update:modelValue", "expand", "collapse", "clear", "pending"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = { closeSearch: "Clear search" }, o = m(() => ({ ...r, ...a.labels })), i = R(a.modelValue.length > 0), s = R(null), d = R(null), u = R(a.modelValue);
    let f;
    function b() {
      f !== void 0 && (clearTimeout(f), f = void 0, l("pending", !1));
    }
    function h(T) {
      b(), T !== a.modelValue && l("update:modelValue", T);
    }
    $e(
      () => a.modelValue,
      (T) => {
        T.length > 0 && (i.value = !0), T !== u.value && (b(), u.value = T);
      }
    ), mt(b);
    function p() {
      a.disabled || (i.value = !0, l("expand"), a.autoFocus && Ue(() => {
        var T;
        return (T = s.value) == null ? void 0 : T.focus();
      }));
    }
    function x() {
      u.value.length > 0 || (i.value = !1, l("collapse"));
    }
    function y() {
      b(), u.value = "", l("update:modelValue", ""), l("clear"), i.value = !1, Ue(() => {
        var T, E;
        return (E = (T = d.value) == null ? void 0 : T.$el) == null ? void 0 : E.focus();
      });
    }
    function w(T) {
      T.preventDefault(), T.stopPropagation(), y();
    }
    function $(T) {
      if (u.value = T.target.value, a.debounce <= 0 || u.value === "") {
        h(u.value);
        return;
      }
      if (u.value === a.modelValue) {
        b();
        return;
      }
      f === void 0 ? l("pending", !0) : clearTimeout(f), f = setTimeout(() => h(u.value), a.debounce);
    }
    function S() {
      f !== void 0 && h(u.value);
    }
    function L(T) {
      b(), u.value = T;
    }
    return n({ discardPending: L }), (T, E) => i.value ? (c(), H(wt, {
      key: 1,
      "enter-active-class": "transition-all duration-200 ease-out",
      "enter-from-class": "opacity-0 w-0!",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-all duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0 w-0!"
    }, {
      default: xe(() => [
        v("div", {
          class: "flex h-8 items-center gap-2 p-2 rounded-(--border-border-radius-rounded-l) overflow-hidden group w-(--cs-w)",
          style: Ne({ "--cs-w": e.maxWidth })
        }, [
          v("i", {
            class: C(["ri-search-line text-(length:--icon-size-sm) leading-(--icon-size-sm) shrink-0 transition-colors text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", u.value ? "group-focus-within:text-(--icons-icon-accent)" : ""]),
            "aria-hidden": "true"
          }, null, 2),
          v("input", {
            ref_key: "inputRef",
            ref: s,
            type: "text",
            "data-testid": "collapsible-search-input",
            value: u.value,
            placeholder: e.placeholder,
            "aria-label": o.value.input ?? e.placeholder,
            title: u.value || void 0,
            disabled: e.disabled,
            class: "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 p-0 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) text-ellipsis overflow-hidden",
            onInput: $,
            onBlur: x,
            onKeydown: [
              ut(w, ["escape"]),
              ut(S, ["enter"])
            ]
          }, null, 40, N4),
          v("button", {
            type: "button",
            class: "shrink-0 inline-flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) cursor-pointer rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
            "aria-label": o.value.closeSearch,
            "data-testid": "collapsible-search-clear",
            onClick: y
          }, [...E[0] || (E[0] = [
            v("i", {
              class: "ri-close-circle-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 8, H4)
        ], 4)
      ]),
      _: 1
    })) : (c(), H(Be, {
      key: 0,
      ref_key: "toggleRef",
      ref: d,
      variant: "tertiary",
      "icon-left": "ri-search-line",
      "icon-only": "",
      size: "xs",
      class: "[&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
      "aria-label": e.placeholder,
      disabled: e.disabled,
      "data-testid": "collapsible-search-toggle",
      onClick: p
    }, null, 8, ["aria-label", "disabled"]));
  }
}), W4 = ["id", "value", "placeholder", "aria-labelledby", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly"], q4 = /* @__PURE__ */ ke({
  __name: "TagInput",
  props: {
    modelValue: {},
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    removeLabel: { default: void 0 },
    truncate: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(""), r = je(), o = m(() => `${r}-error`), i = `${r}-hint`, s = m(() => t.label ? `${r}-label` : void 0), d = m(() => {
      const q = [];
      return t.hint && q.push(i), t.error && q.push(o.value), q.length > 0 ? q.join(" ") : void 0;
    }), u = R(!1), f = R(null), b = R(null), h = R(null), p = R(null), x = m(() => t.disabled || t.readonly), y = m(() => t.modelValue.length > 0 || l.value !== ""), w = m(() => t.fullWidth || t.width === void 0), $ = m(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), S = m(() => t.disabled ? "disabled" : "white"), L = m(() => t.disabled ? void 0 : "border-(--border-border-base-medium)!");
    function T(q) {
      q.currentTarget.contains(q.relatedTarget) || (u.value = !1);
    }
    const E = m(() => !u.value && t.modelValue.length > 0), A = R(Number.POSITIVE_INFINITY), D = m(
      () => E.value ? Math.max(0, t.modelValue.length - A.value) : 0
    ), M = m(() => t.modelValue.slice(t.modelValue.length - D.value)), F = (q) => {
      var ye, Z;
      if (t.disabled) return;
      const J = q.currentTarget, me = (ye = q.target) == null ? void 0 : ye.closest('button, a, [role="button"], input, [tabindex]');
      me && me !== J && J.contains(me) || (q.preventDefault(), (Z = h.value) == null || Z.focus());
    }, X = (q) => E.value && q >= A.value;
    function _() {
      var Se, V;
      const q = (Se = p.value) == null ? void 0 : Se.$el;
      if (!q || !E.value) return;
      const J = getComputedStyle(q), me = parseFloat(J.columnGap) || 0, ye = q.clientWidth - (parseFloat(J.paddingLeft) || 0) - (parseFloat(J.paddingRight) || 0), Z = Array.from(q.querySelectorAll(":scope > [data-tag-chip]")).map(
        (Q) => Q.getBoundingClientRect().width
      );
      if (Z.reduce((Q, le, ee) => Q + le + (ee > 0 ? me : 0), 0) <= ye) {
        A.value = Z.length;
        return;
      }
      let ge = ((V = q.querySelector(":scope > [data-tag-overflow]")) == null ? void 0 : V.getBoundingClientRect().width) ?? 0, se = 0;
      for (const Q of Z) {
        if (ge + me + Q > ye) break;
        ge += me + Q, se++;
      }
      A.value = se;
    }
    let Y = null, B = 0;
    const W = () => {
      cancelAnimationFrame(B), B = requestAnimationFrame(_);
    };
    function U() {
      var J;
      const q = (J = p.value) == null ? void 0 : J.$el;
      !Y || !q || (Y.disconnect(), Y.observe(q), q.querySelectorAll(":scope > [data-tag-chip], :scope > [data-tag-overflow]").forEach((me) => Y.observe(me)));
    }
    dt(() => {
      typeof ResizeObserver < "u" && (Y = new ResizeObserver(W)), U(), _();
    }), Ki(() => {
      U(), _();
    }), mt(() => {
      Y == null || Y.disconnect(), Y = null, cancelAnimationFrame(B);
    });
    function z(q) {
      l.value = "";
      const J = q.split(",").map((ye) => ye.trim()).filter((ye) => ye.length > 0), me = [...t.modelValue];
      for (const ye of J)
        me.includes(ye) || me.push(ye);
      me.length !== t.modelValue.length && a("update:modelValue", me);
    }
    function P(q) {
      const J = q.target.value;
      if (J.endsWith(",")) {
        z(J.slice(0, -1));
        return;
      }
      l.value = J;
    }
    function K(q) {
      q.preventDefault(), !t.readonly && z(l.value);
    }
    function j() {
      t.readonly || l.value === "" && t.modelValue.length > 0 && a("update:modelValue", t.modelValue.slice(0, -1));
    }
    function G(q) {
      var J;
      a("update:modelValue", t.modelValue.filter((me, ye) => ye !== q)), (J = h.value) == null || J.focus();
    }
    return (q, J) => (c(), g("div", {
      class: C(["flex min-w-0 flex-col gap-0.5", w.value ? "w-full" : ""]),
      style: Ne(w.value ? void 0 : { width: e.width })
    }, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: s.value,
        ref_key: "labelRef",
        ref: f,
        text: e.label,
        "input-id": I(r),
        required: e.required,
        tooltip: e.labelTooltip,
        focused: u.value,
        "test-id": "tag-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : k("", !0),
      re(Bn, {
        ref_key: "shellRef",
        ref: p,
        role: "group",
        "aria-labelledby": s.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        "aria-describedby": d.value,
        class: C(["w-full", E.value ? "flex-nowrap! overflow-hidden" : ""]),
        tags: "",
        size: e.size,
        disabled: e.disabled,
        readonly: e.readonly,
        error: !!e.error,
        success: e.success,
        "has-value": y.value,
        "focus-scope": "any",
        onFocusin: J[2] || (J[2] = (me) => u.value = !0),
        onFocusout: T,
        onMousedown: F
      }, {
        default: xe(({ textClass: me }) => [
          (c(!0), g(ce, null, Re(e.modelValue, (ye, Z) => (c(), g("span", {
            key: `${ye}-${Z}`,
            "data-tag-chip": "",
            class: C(["inline-flex", { "shrink-0": E.value, "order-2 invisible": X(Z) }])
          }, [
            re(ct, {
              label: ye,
              size: $.value,
              theme: S.value,
              truncate: e.truncate,
              class: C(L.value),
              "show-close-icon": "",
              "close-icon-inactive": x.value,
              "remove-label": `${e.removeLabel ?? ""} ${ye}`.trim(),
              onClose: (de) => G(Z)
            }, null, 8, ["label", "size", "theme", "truncate", "class", "close-icon-inactive", "remove-label", "onClose"])
          ], 2))), 128)),
          D.value > 0 ? (c(), g("span", {
            key: 0,
            "data-tag-overflow": "",
            class: "order-1 inline-flex shrink-0 cursor-pointer",
            onClick: J[0] || (J[0] = (ye) => {
              var Z;
              return (Z = h.value) == null ? void 0 : Z.focus();
            })
          }, [
            re(ct, {
              label: `+${D.value}`,
              size: $.value,
              theme: S.value,
              class: C(L.value),
              "tooltip-text": M.value.join(", ")
            }, null, 8, ["label", "size", "theme", "class", "tooltip-text"])
          ])) : k("", !0),
          v("input", {
            id: I(r),
            ref_key: "inputRef",
            ref: h,
            value: l.value,
            type: "text",
            class: C([
              "flex-1 border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              me,
              E.value ? "order-1 min-w-0" : "min-w-20",
              e.readonly ? "cursor-default" : ""
            ]),
            placeholder: e.modelValue.length > 0 ? void 0 : e.placeholder,
            "aria-labelledby": s.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-invalid": e.error ? "true" : void 0,
            "aria-required": e.required ? "true" : void 0,
            "aria-describedby": d.value,
            disabled: e.disabled,
            readonly: e.readonly,
            onKeydown: [
              J[1] || (J[1] = (ye) => {
                var Z, de;
                (Z = f.value) == null || Z.handleFieldKeydown(ye), (de = b.value) == null || de.handleFieldKeydown(ye);
              }),
              ut(K, ["enter"]),
              ut(j, ["delete"])
            ],
            onInput: P
          }, null, 42, W4)
        ]),
        _: 1
      }, 8, ["aria-labelledby", "aria-label", "aria-describedby", "class", "size", "disabled", "readonly", "error", "success", "has-value"]),
      re(xt, {
        ref_key: "helperRef",
        ref: b,
        focused: u.value,
        hint: e.hint,
        error: e.error,
        "hint-id": i,
        "error-id": o.value,
        "test-id-prefix": "tag-input"
      }, null, 8, ["focused", "hint", "error", "error-id"])
    ], 6));
  }
}), U4 = { class: "inline-flex max-w-full min-w-0 flex-col gap-1" }, G4 = ["aria-labelledby", "aria-label"], K4 = {
  key: 0,
  "data-otp-separator": "",
  "aria-hidden": "true",
  class: "h-0 w-3 shrink-0 border-t-(length:--border-border-width-border-base) border-(--border-border-black-default) dark:border-(--border-border-white-default)"
}, Y4 = ["id", "value", "inputmode", "autocomplete", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly", "onInput", "onPaste", "onKeydown"], $q = /* @__PURE__ */ ke({
  __name: "OtpInput",
  props: {
    modelValue: {},
    length: { default: 6 },
    size: { default: "md" },
    type: { default: "default" },
    numeric: { type: Boolean, default: !0 },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = { cell: "Digit {index} of {length}" }, r = m(() => ({ ...l, ...t.labels })), o = (j) => r.value.cell.replace("{index}", String(j + 1)).replace("{length}", String(t.length)), i = je(), s = (j) => `${i}-cell-${j}`, d = m(() => t.label ? `${i}-label` : void 0), u = `${i}-hint`, f = `${i}-error`, b = m(() => {
      const j = [];
      return t.hint && j.push(u), t.error && j.push(f), j.length > 0 ? j.join(" ") : void 0;
    }), h = (j) => Array.from({ length: t.length }, (G, q) => j[q] ?? ""), p = R(h(t.modelValue));
    $e(
      () => [t.modelValue, t.length],
      ([j]) => {
        (j !== p.value.join("") || p.value.length !== t.length) && (p.value = h(j));
      }
    );
    const x = R([]), y = R(!1), w = R(null), $ = R(null), S = (j) => {
      const G = Array.from(j.replace(/\s/g, ""));
      return t.numeric ? G.filter((q) => /\d/.test(q)) : G;
    };
    function L() {
      a("update:modelValue", p.value.join(""));
    }
    function T(j) {
      const G = x.value[Math.max(0, Math.min(j, t.length - 1))];
      G == null || G.focus(), G == null || G.select();
    }
    function E(j, G) {
      const q = G.length >= t.length ? 0 : j, J = G.slice(0, t.length - q);
      J.forEach((me, ye) => {
        p.value[q + ye] = me;
      }), L(), T(q + J.length);
    }
    function A(j, G) {
      const q = G.target, J = G, me = J.inputType === "insertText" && J.data ? J.data : q.value, ye = S(me);
      if (ye.length > 1) {
        q.value = p.value[j], E(j, ye);
        return;
      }
      if (ye.length === 0) {
        q.value === "" ? (p.value[j] = "", L()) : q.value = p.value[j];
        return;
      }
      p.value[j] = ye[0], q.value = ye[0], L(), j < t.length - 1 && T(j + 1);
    }
    function D(j, G) {
      var J;
      if (G.preventDefault(), t.readonly || t.disabled) return;
      const q = S(((J = G.clipboardData) == null ? void 0 : J.getData("text")) ?? "");
      q.length > 0 && E(j, q);
    }
    function M(j, G) {
      var q, J;
      switch ((q = w.value) == null || q.handleFieldKeydown(G), (J = $.value) == null || J.handleFieldKeydown(G), G.key) {
        case "ArrowLeft":
          G.preventDefault(), T(j - 1);
          return;
        case "ArrowRight":
          G.preventDefault(), T(j + 1);
          return;
        case "Home":
          G.preventDefault(), T(0);
          return;
        case "End":
          G.preventDefault(), T(t.length - 1);
          return;
        case "Backspace":
          if (G.preventDefault(), t.readonly) return;
          p.value[j] ? (p.value[j] = "", L()) : j > 0 && (p.value[j - 1] = "", L(), T(j - 1));
          return;
        case "Delete":
          if (G.preventDefault(), t.readonly || !p.value[j]) return;
          p.value[j] = "", L();
          return;
      }
    }
    function F(j) {
      var G, q;
      y.value = !0, (q = (G = j.target).select) == null || q.call(G);
    }
    function X(j) {
      j.currentTarget.contains(j.relatedTarget) || (y.value = !1);
    }
    const _ = 3, Y = m(() => t.type === "separator" || t.type === "separator-spaced"), B = m(() => t.type === "spaced" || t.type === "separator-spaced"), W = m(() => {
      const j = Y.value ? _ : t.length, G = [];
      for (let q = 0; q < t.length; q += j)
        G.push(Array.from({ length: Math.min(j, t.length - q) }, (J, me) => q + me));
      return G;
    }), U = {
      sm: "size-9 text-(length:--size-l) leading-(--line-height-xxl)",
      md: "size-10 text-(length:--size-l) leading-(--line-height-xxl)",
      lg: "size-12 text-(length:--size-4xl) leading-(--line-height-4xl)",
      xl: "size-13 text-(length:--size-4xl) leading-(--line-height-4xl)"
    }, z = "focus:shadow-[0_0_2px_2px_var(--background-background-hover)]", P = m(() => {
      if (t.disabled)
        return "bg-(--background-background-disabled-subtle) dark:bg-(--colors-background-disabled) border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled) cursor-not-allowed";
      if (t.readonly)
        return `bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${z} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      const j = "bg-(--background-background-white) dark:bg-(--background-background-black-default) text-(--text-text-black-default) dark:text-(--text-text-white-default)";
      return t.error ? `${j} border-(--border-border-error-strong) dark:border-(--border-border-error) ${z}` : t.success ? `${j} border-(--border-border-success-strong) ${z}` : `${j} border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${z}`;
    });
    function K(j, G) {
      const q = B.value ? "rounded-(--border-border-radius-rounded-l)" : [
        G === 0 ? "rounded-l-(--border-border-radius-rounded-l)" : "-ml-px",
        G === j.length - 1 ? "rounded-r-(--border-border-radius-rounded-l)" : ""
      ].join(" ");
      return [
        "relative box-border border border-solid p-0 text-center font-inter font-(--weight-bold) outline-none focus:z-10 focus:outline-none focus:ring-0",
        U[t.size],
        q,
        P.value
      ];
    }
    return (j, G) => (c(), g("div", U4, [
      e.label ? (c(), H(yt, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: w,
        text: e.label,
        "input-id": s(0),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: y.value,
        "test-id": "otp-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      v("div", {
        role: "group",
        "data-otp-cells": "",
        "aria-labelledby": d.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        class: C(["flex items-center", Y.value || B.value ? "gap-2" : ""]),
        onFocusin: F,
        onFocusout: X
      }, [
        (c(!0), g(ce, null, Re(W.value, (q, J) => (c(), g(ce, { key: J }, [
          J > 0 && Y.value ? (c(), g("span", K4)) : k("", !0),
          v("div", {
            class: C(["flex items-center", B.value ? "gap-2" : ""])
          }, [
            (c(!0), g(ce, null, Re(q, (me, ye) => (c(), g("input", {
              id: s(me),
              key: me,
              ref_for: !0,
              ref: (Z) => {
                Z && (x.value[me] = Z);
              },
              value: p.value[me],
              type: "text",
              inputmode: e.numeric ? "numeric" : "text",
              autocomplete: me === 0 ? "one-time-code" : "off",
              "aria-label": o(me),
              "aria-invalid": e.error ? "true" : void 0,
              "aria-required": e.required ? "true" : void 0,
              "aria-describedby": b.value,
              disabled: e.disabled,
              readonly: e.readonly,
              class: C(K(q, ye)),
              onInput: (Z) => A(me, Z),
              onPaste: (Z) => D(me, Z),
              onKeydown: (Z) => M(me, Z)
            }, null, 42, Y4))), 128))
          ], 2)
        ], 64))), 128))
      ], 42, G4),
      re(xt, {
        ref_key: "helperRef",
        ref: $,
        focused: y.value,
        hint: e.hint,
        error: e.error,
        "hint-id": u,
        "error-id": f,
        "test-id-prefix": "otp-input"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), J4 = ["data-status", "aria-label", "disabled"], Iq = /* @__PURE__ */ ke({
  __name: "LookupInput",
  props: {
    placeholder: {},
    modelValue: {},
    iconLeft: {},
    size: {},
    disabled: { type: Boolean },
    success: { type: Boolean },
    type: {},
    name: {},
    id: {},
    fullWidth: { type: Boolean },
    width: {},
    label: {},
    labelTooltip: {},
    required: { type: Boolean },
    requiredIndicator: {},
    labelInline: { type: Boolean },
    ariaLabel: {},
    inputmode: {},
    autocomplete: {},
    pattern: {},
    maxlength: {},
    minlength: {},
    min: {},
    max: {},
    error: {},
    hint: {},
    ariaDescribedby: {},
    readonly: { type: Boolean },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: {},
    showEditIcon: { type: Boolean, default: !0 },
    variant: {},
    buttons: {},
    buttonLayout: {},
    buttonSize: {},
    innerButton: {},
    prefix: {},
    removeButton: {},
    status: { default: null },
    statusTitle: { default: void 0 },
    statusText: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:open", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      recognized: { icon: "ri-check-fill", color: "text-(--icons-icon-success)" },
      unrecognized: { icon: "ri-alert-line", color: "text-(--icons-icon-warning)" }
    }, r = m(() => t.statusTitle ? t.statusTitle : t.status === "unrecognized" ? t.labels.unrecognized ?? "Not recognized" : t.labels.recognized ?? "Recognized"), o = /* @__PURE__ */ new Set(["status", "statusTitle", "statusText", "open", "labels"]), i = m(
      () => Object.fromEntries(Object.entries(t).filter(([d]) => !o.has(d)))
    ), s = m(() => t.labels.clear ? { clear: t.labels.clear } : void 0);
    return (d, u) => (c(), H(Ot, Oe(i.value, {
      labels: s.value,
      "onUpdate:modelValue": u[1] || (u[1] = (f) => a("update:modelValue", f))
    }), ta({ _: 2 }, [
      e.status ? {
        name: "iconRight",
        fn: xe(({ iconBoxClass: f }) => [
          re(Vv, {
            header: r.value,
            position: "top",
            delay: 0,
            open: e.open,
            disabled: !e.statusText || e.disabled,
            "onUpdate:open": u[0] || (u[0] = (b) => a("update:open", b))
          }, {
            trigger: xe(({ triggerProps: b }) => [
              v("button", Oe({ type: "button" }, b, {
                "data-testid": "lookup-input-status",
                "data-status": e.status,
                "aria-label": r.value,
                disabled: e.disabled,
                class: [
                  f,
                  l[e.status].color,
                  "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
                ]
              }), [
                v("i", {
                  class: C(l[e.status].icon),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, J4)
            ]),
            default: xe(() => [
              et(" " + N(e.statusText), 1)
            ]),
            _: 2
          }, 1032, ["header", "open", "disabled"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["labels"]));
  }
}), X4 = ["disabled", "aria-current"], Z4 = "inline-flex h-9 min-w-9 shrink-0 items-center justify-center whitespace-nowrap rounded-full border border-solid px-[calc(--spacing(2.5)-1px)] text-(length:--size-m) leading-(--line-height-m) font-(--weight-semi-bold) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", Q4 = "cursor-pointer border-(--border-border-white-default) bg-(--background-background-white) text-(--text-text-black-default) hover:border-(--border-border-hover) hover:bg-(--background-background-hover) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default) dark:hover:border-(--border-border-hover) dark:hover:bg-(--background-background-hover) dark:hover:text-(--text-text-black-default)", _4 = "cursor-default border-(--border-border-black-default) bg-(--background-background-black-default) text-(--icons-icon-white-default) dark:border-(--background-background-white) dark:bg-(--background-background-white) dark:text-(--text-text-black-default)", eO = "cursor-not-allowed border-(--border-border-disabled) bg-(--components-button-button-disabled) text-(--icons-icon-disabled-strong)", tO = /* @__PURE__ */ ke({
  __name: "PageNumber",
  props: {
    page: {},
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("button", {
      type: "button",
      disabled: e.disabled,
      "aria-current": e.active ? "page" : void 0,
      class: C([Z4, e.disabled ? eO : e.active ? _4 : Q4]),
      onClick: l[0] || (l[0] = (r) => t("select", e.page))
    }, N(e.page), 11, X4));
  }
});
function jv(e, n, t, a) {
  $e(
    n,
    () => {
      const l = document.activeElement;
      if (!e.value || !(l instanceof HTMLButtonElement) || !l.disabled) return;
      const r = e.value.querySelector(`[data-testid="${t}"]`), o = e.value.querySelector(`[data-testid="${a}"]`), i = l === o ? r : l === r ? o : null;
      i && !i.disabled && i.focus();
    },
    { flush: "post" }
  );
}
const nO = ["aria-label"], aO = {
  key: 0,
  class: "@4xl/pager:col-start-1 flex min-w-0 flex-wrap items-center gap-3"
}, lO = {
  key: 0,
  class: "flex items-center gap-3"
}, rO = ["id", "for"], oO = ["id", "aria-labelledby", "disabled", "aria-expanded", "aria-controls"], iO = { class: "min-w-0 flex-1 truncate" }, sO = ["id", "aria-labelledby"], dO = ["aria-selected", "tabindex", "onClick", "onKeydown", "onKeyup"], uO = {
  key: 1,
  "data-testid": "pager-items-count",
  class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, cO = { class: "flex min-w-0 flex-wrap items-center justify-center gap-1.5" }, fO = {
  key: 0,
  "data-testid": "pager-ellipsis",
  class: "flex size-9 shrink-0 select-none items-center justify-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
  "aria-hidden": "true"
}, hO = {
  key: 2,
  class: "@4xl/pager:col-start-3 ml-auto flex min-w-0 flex-wrap items-center justify-end gap-3"
}, bO = { class: "flex min-w-0 items-center gap-2" }, gO = ["for"], mO = ["id", "max", "disabled", "aria-invalid", "aria-describedby"], pO = ["id"], vO = 1500, xO = /* @__PURE__ */ ke({
  __name: "Pager",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    totalItems: { default: 0 },
    itemsPerPage: { default: 10 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    disabled: { type: Boolean, default: !1 },
    rowsPerPageOptions: { default: () => [10, 30, 50] },
    rowsPerPageLabel: { default: "Rows per page" },
    showRowsPerPage: { type: Boolean, default: !0 },
    showItemsCount: { type: Boolean, default: !1 },
    itemsCountSeparator: { default: "of" },
    itemsCountFormat: { type: Function, default: void 0 },
    maxVisiblePages: { default: 5 },
    alwaysShowPages: { type: Boolean, default: !1 },
    pageAlign: { default: "center" },
    showGoToPage: { type: Boolean, default: !1 },
    goToPageLabel: { default: "Go to page" },
    goLabel: { default: "Go" },
    goToPageErrorLabel: { default: void 0 },
    navLabel: { default: void 0 }
  },
  emits: ["page-change", "items-per-page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => {
      const V = t.totalPages, Q = t.currentPage, le = Math.max(5, t.maxVisiblePages);
      if (V <= le)
        return Array.from({ length: V }, (ne, fe) => fe + 1);
      const ee = Math.floor((le - 5) / 2);
      if (Q <= ee + 2)
        return [...Array.from({ length: le - 2 }, (fe, ue) => ue + 1), "ellipsis-end", V];
      if (Q >= V - ee - 1) {
        const ne = V - le + 3;
        return [1, "ellipsis-start", ...Array.from({ length: le - 2 }, (ue, te) => ne + te)];
      }
      return [1, "ellipsis-start", ...Array.from({ length: ee * 2 + 1 }, (ne, fe) => Q - ee + fe), "ellipsis-end", V];
    }), r = m(() => t.currentPage > 1 && !t.disabled), o = m(() => t.currentPage < t.totalPages && !t.disabled), i = m(() => {
      if (t.totalItems === 0) return `0 ${t.itemsCountSeparator} 0`;
      const V = (t.currentPage - 1) * t.itemsPerPage + 1, Q = Math.min(t.currentPage * t.itemsPerPage, t.totalItems);
      return t.itemsCountFormat ? t.itemsCountFormat(V, Q, t.totalItems) : `${V}-${Q} ${t.itemsCountSeparator} ${t.totalItems}`;
    }), s = m(
      () => t.rowsPerPageOptions.map((V) => ({
        value: String(V),
        label: String(V)
      }))
    ), d = (V) => {
      t.disabled || V < 1 || V > t.totalPages || V !== t.currentPage && a("page-change", V);
    }, u = () => {
      r.value && d(t.currentPage - 1);
    }, f = () => {
      o.value && d(t.currentPage + 1);
    }, b = (V) => {
      a("items-per-page-change", Number(V));
    }, h = je(), p = je(), x = Mn(), y = (V) => {
      const Q = x[V];
      return Q && Q({}).length;
    }, w = je(), $ = R(""), S = R(!1), L = R(0);
    let T = null;
    function E() {
      T && clearTimeout(T), T = null;
    }
    const A = m(() => t.disabled || t.totalPages === 0), D = () => {
      E(), S.value = !1;
    };
    $e(
      [
        () => t.currentPage,
        () => t.totalPages,
        () => t.itemsPerPage,
        A,
        () => t.goToPageErrorLabel
      ],
      () => {
        T && ($.value = ""), E(), S.value = !1;
      }
    );
    const M = () => {
      E();
      const V = parseInt($.value, 10);
      if (isNaN(V) || V < 1 || V > t.totalPages) {
        S.value = !0, L.value += 1, t.goToPageErrorLabel || (T = setTimeout(() => {
          $.value = "", S.value = !1, T = null;
        }, vO));
        return;
      }
      S.value = !1, d(V), $.value = "";
    };
    mt(() => {
      document.removeEventListener("click", Z), j(), E();
    });
    const F = R(!1), X = R(null), _ = R(null), Y = R(null);
    let B = !1;
    const W = R([]), U = R(0);
    function z(V) {
      var le;
      const Q = s.value.length;
      U.value = (V + Q) % Q, (le = W.value[U.value]) == null || le.focus();
    }
    async function P() {
      const V = s.value.findIndex((Q) => Q.value === String(t.itemsPerPage));
      U.value = Math.max(V, 0), F.value = !0, await Ue(), z(U.value);
    }
    function K() {
      var V;
      F.value = !1, (V = _.value) == null || V.focus();
    }
    function j() {
      B = !1, document.removeEventListener("mouseup", j, !0);
    }
    function G() {
      B = !0, document.addEventListener("mouseup", j, !0);
    }
    function q() {
      j(), !t.disabled && (F.value ? K() : P());
    }
    function J(V) {
      K(), b(V);
    }
    function me(V, Q) {
      const le = {
        ArrowDown: Q + 1,
        ArrowUp: Q - 1,
        Home: 0,
        End: s.value.length - 1
      };
      V.key in le && (V.preventDefault(), z(le[V.key]));
    }
    function ye(V) {
      var le;
      if (!F.value || B) return;
      const Q = V.relatedTarget;
      Q && ((le = Y.value) != null && le.contains(Q)) || (F.value = !1);
    }
    function Z(V) {
      F.value && X.value && !X.value.contains(V.target) && (F.value = !1);
    }
    function de(V) {
      V.key !== "Escape" || !F.value || (V.stopPropagation(), V.preventDefault(), K());
    }
    $e(F, (V) => {
      V ? document.addEventListener("click", Z) : document.removeEventListener("click", Z);
    });
    const ge = m(() => t.alwaysShowPages || t.totalPages > 1), se = () => !!y("info") || t.showRowsPerPage || t.showItemsCount, Se = R(null);
    return jv(Se, () => t.currentPage, "pager-previous", "pager-next"), (V, Q) => (c(), g("div", {
      ref_key: "rootRef",
      ref: Se,
      class: "@container/pager"
    }, [
      se() || ge.value || e.showGoToPage ? (c(), g("nav", {
        key: 0,
        class: "flex flex-wrap items-center justify-between gap-x-6 gap-y-3 text-(length:--size-m) leading-(--line-height-l) @4xl/pager:grid @4xl/pager:grid-cols-[1fr_auto_1fr] @4xl/pager:gap-x-0 @4xl/pager:gap-y-0",
        "aria-label": e.navLabel,
        "data-testid": "pager-nav"
      }, [
        se() ? (c(), g("div", aO, [
          y("info") ? Ae(V.$slots, "info", { key: 0 }) : k("", !0),
          e.showRowsPerPage || e.showItemsCount ? (c(), g(ce, { key: 1 }, [
            e.showRowsPerPage ? (c(), g("div", lO, [
              v("label", {
                id: `${I(h)}-label`,
                for: I(h),
                class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
              }, N(e.rowsPerPageLabel), 9, rO),
              v("div", {
                ref_key: "rowsMenuRef",
                ref: X,
                class: "relative",
                onKeydown: de,
                onFocusout: ye
              }, [
                re(Bn, {
                  size: "sm",
                  flush: "",
                  "has-value": "",
                  disabled: e.disabled,
                  "focus-scope": "any",
                  class: "min-w-16 shrink-0"
                }, {
                  default: xe(({ iconBoxClass: le, iconColorClass: ee, textClass: O }) => [
                    v("button", {
                      id: I(h),
                      ref_key: "rowsTriggerRef",
                      ref: _,
                      type: "button",
                      "aria-labelledby": `${I(h)}-label ${I(h)}`,
                      disabled: e.disabled,
                      "aria-haspopup": "listbox",
                      "aria-expanded": F.value,
                      "aria-controls": `${I(h)}-listbox`,
                      class: C([
                        "flex h-full w-full min-w-0 items-center gap-2 px-[calc(--spacing(2)-1px)] text-left focus-visible:outline-hidden focus-visible:-outline-offset-2 disabled:cursor-not-allowed",
                        O
                      ]),
                      "data-testid": "pager-rows-trigger",
                      onMousedown: G,
                      onClick: q
                    }, [
                      v("span", iO, N(e.itemsPerPage), 1),
                      v("i", {
                        class: C(["ri-arrow-down-s-line", le, ee]),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 42, oO)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                F.value ? (c(), g("ul", {
                  key: 0,
                  id: `${I(h)}-listbox`,
                  ref_key: "rowsListboxRef",
                  ref: Y,
                  role: "listbox",
                  "aria-labelledby": `${I(h)}-label`,
                  class: C([I(ni), "absolute bottom-full left-0 z-30 mb-px min-w-full"]),
                  "data-testid": "pager-rows-menu"
                }, [
                  (c(!0), g(ce, null, Re(s.value, (le, ee) => (c(), g("li", {
                    key: le.value,
                    ref_for: !0,
                    ref_key: "rowsOptionRefs",
                    ref: W,
                    role: "option",
                    "aria-selected": String(e.itemsPerPage) === le.value,
                    tabindex: ee === U.value ? 0 : -1,
                    class: C([I(_y), String(e.itemsPerPage) === le.value ? I(ek) : ""]),
                    onClick: (O) => J(le.value),
                    onKeydown: [
                      ut(Ye((O) => J(le.value), ["prevent"]), ["enter"]),
                      Q[0] || (Q[0] = ut(Ye(() => {
                      }, ["prevent"]), ["space"])),
                      (O) => me(O, ee)
                    ],
                    onKeyup: ut(Ye((O) => J(le.value), ["prevent"]), ["space"])
                  }, N(le.label), 43, dO))), 128))
                ], 10, sO)) : k("", !0)
              ], 544)
            ])) : k("", !0),
            e.showItemsCount ? (c(), g("div", uO, N(i.value), 1)) : k("", !0)
          ], 64)) : k("", !0)
        ])) : k("", !0),
        ge.value ? (c(), g("div", {
          key: 1,
          class: C([
            "flex min-w-0 max-w-full items-center gap-x-4",
            e.pageAlign === "end" ? [
              "justify-end",
              // CONSTRAINT: never alone in a `1fr` side track: long page numbers would wrap there.
              e.showGoToPage ? "@4xl/pager:col-start-2" : se() ? "@4xl/pager:col-start-2 @4xl/pager:col-span-2" : "@4xl/pager:col-span-full @4xl/pager:justify-end"
            ] : "@4xl/pager:col-start-2 justify-center",
            // Alone at the start of the wrapping row, justify-between would push the centred pages to the left.
            e.pageAlign === "center" && !se() ? "mx-auto @4xl/pager:mx-0" : "",
            e.pageAlign === "end" && !se() ? "ml-auto @4xl/pager:ml-0" : ""
          ])
        }, [
          re(I(Be), {
            variant: "secondary",
            size: "sm",
            "icon-only": "",
            "icon-left": "ri-arrow-left-s-line",
            disabled: !r.value,
            "aria-label": e.previousLabel,
            "data-testid": "pager-previous",
            class: "shrink-0",
            onClick: u
          }, null, 8, ["disabled", "aria-label"]),
          v("div", cO, [
            (c(!0), g(ce, null, Re(l.value, (le) => (c(), g(ce, { key: le }, [
              String(le).startsWith("ellipsis") ? (c(), g("span", fO, " ... ")) : (c(), H(tO, {
                key: 1,
                page: le,
                active: le === e.currentPage,
                disabled: e.disabled,
                "data-testid": "pager-page",
                onSelect: d
              }, null, 8, ["page", "active", "disabled"]))
            ], 64))), 128))
          ]),
          re(I(Be), {
            variant: "secondary",
            size: "sm",
            "icon-only": "",
            "icon-right": "ri-arrow-right-s-line",
            disabled: !o.value,
            "aria-label": e.nextLabel,
            "data-testid": "pager-next",
            class: "shrink-0",
            onClick: f
          }, null, 8, ["disabled", "aria-label"])
        ], 2)) : k("", !0),
        e.showGoToPage ? (c(), g("div", hO, [
          v("div", bO, [
            v("label", {
              for: I(p),
              class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
            }, N(e.goToPageLabel), 9, gO),
            re(Bn, {
              size: "sm",
              disabled: A.value,
              error: S.value,
              "has-value": $.value !== "",
              class: "w-16 shrink-0"
            }, {
              default: xe(({ textClass: le }) => [
                Jl(v("input", {
                  id: I(p),
                  "onUpdate:modelValue": Q[1] || (Q[1] = (ee) => $.value = ee),
                  type: "number",
                  min: "1",
                  max: e.totalPages,
                  disabled: A.value,
                  "aria-invalid": S.value || void 0,
                  "aria-describedby": S.value && e.goToPageErrorLabel ? I(w) : void 0,
                  "data-testid": "pager-go-to-page",
                  class: C([
                    "min-w-0 flex-1 border-0 bg-transparent p-0 outline-none focus:ring-0 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                    le
                  ]),
                  onInput: D,
                  onKeydown: ut(M, ["enter"])
                }, null, 42, mO), [
                  [Ub, $.value]
                ])
              ]),
              _: 1
            }, 8, ["disabled", "error", "has-value"])
          ]),
          re(I(Be), {
            variant: "primary",
            size: "xs",
            label: e.goLabel,
            disabled: A.value,
            "data-testid": "pager-go-button",
            onClick: M
          }, null, 8, ["label", "disabled"])
        ])) : k("", !0),
        e.showGoToPage && e.goToPageErrorLabel && S.value ? (c(), g("p", {
          id: I(w),
          key: L.value,
          role: "alert",
          "data-testid": "pager-go-to-page-error",
          class: "basis-full text-right text-balance text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--border-border-error-subtle) @4xl/pager:col-start-3 @4xl/pager:row-start-2 @4xl/pager:pt-1"
        }, N(e.goToPageErrorLabel), 9, pO)) : k("", !0)
      ], 8, nO)) : k("", !0)
    ], 512));
  }
}), Wv = "enabled:z-10 hover:enabled:z-20 focus-visible:z-20", qv = `${Wv} rounded-r-none -mr-px`, Uv = `${Wv} rounded-l-none`, yO = ["aria-label"], kO = {
  key: 0,
  "data-testid": "compact-pager-helper",
  class: "text-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, wO = { class: "inline-flex shadow-(--blur-shadow-xs)" }, CO = ["id"], SO = { class: "inline-flex" }, $O = { "aria-hidden": "true" }, IO = { class: "sr-only" }, Do = "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", cd = "border border-solid border-(--border-border-secondary-button) bg-(--components-button-secondary-button-secondary)", Tq = /* @__PURE__ */ ke({
  __name: "CompactPager",
  props: {
    type: { default: "arrows" },
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    pageStatusFormat: { type: Function, default: void 0 },
    navLabel: { default: void 0 },
    helperText: { default: void 0 },
    totalPagesFormat: { type: Function, default: void 0 },
    pageSelectLabel: { default: "Page" }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => !t.disabled && t.currentPage > 1), r = m(() => !t.disabled && t.currentPage < t.totalPages), o = m(
      () => t.pageStatusFormat ? t.pageStatusFormat(t.currentPage, t.totalPages) : `${t.currentPage} of ${t.totalPages}`
    ), i = m(
      () => t.totalPagesFormat ? t.totalPagesFormat(t.totalPages) : `of ${t.totalPages} pages`
    ), s = je(), d = (S) => String(S).padStart(2, "0"), u = m(
      () => Array.from({ length: Math.max(t.totalPages, 0) }, (S, L) => {
        const T = L + 1;
        return {
          label: d(T),
          active: T === t.currentPage,
          testId: `compact-pager-page-${T}`,
          onClick: () => {
            t.disabled || T > t.totalPages || T === t.currentPage || a("page-change", T);
          }
        };
      })
    );
    function f() {
      l.value && a("page-change", t.currentPage - 1);
    }
    function b() {
      r.value && a("page-change", t.currentPage + 1);
    }
    const h = {
      "arrow-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      arrows: { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      "arrows-text": { variant: "text", size: "xs", content: "icon", fused: !1 },
      "arrows-number": { variant: "secondary", size: "sm", content: "icon", fused: !1 },
      "two-buttons": { variant: "secondary", size: "xs", content: "icon-label", fused: !1 },
      "buttons-helper": { variant: "secondary", size: "xs", content: "label", fused: !0 },
      "dropdown-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 }
    };
    function p(S) {
      const L = h[t.type], T = S === "previous", E = T ? t.previousLabel : t.nextLabel, A = L.content === "label" ? void 0 : `ri-arrow-${T ? "left" : "right"}-s-line`;
      return {
        variant: L.variant,
        size: L.size,
        iconOnly: L.content === "icon",
        iconLeft: T ? A : void 0,
        iconRight: T ? void 0 : A,
        label: L.content === "icon" ? void 0 : E,
        ariaLabel: L.content === "icon" ? E : void 0,
        disabled: T ? !l.value : !r.value,
        "data-testid": `compact-pager-${S}`,
        class: L.fused ? T ? qv : Uv : void 0,
        onClick: T ? f : b
      };
    }
    const x = m(() => p("previous")), y = m(() => p("next")), w = R(null);
    jv(w, () => t.currentPage, "compact-pager-previous", "compact-pager-next");
    const $ = {
      "arrow-buttons": "shadow-(--blur-shadow-xs)",
      arrows: "shadow-(--blur-shadow-xs)",
      "arrows-text": "",
      "arrows-number": "gap-1 shadow-(--blur-shadow-xs)",
      "two-buttons": "gap-3 shadow-(--blur-shadow-xs)",
      "buttons-helper": "flex-col gap-4",
      "dropdown-buttons": "gap-3 shadow-(--blur-shadow-xs)"
    };
    return (S, L) => (c(), g("nav", {
      ref_key: "rootRef",
      ref: w,
      "aria-label": e.navLabel,
      "data-testid": "compact-pager",
      class: C(["inline-flex items-center", $[e.type]])
    }, [
      e.type === "two-buttons" || e.type === "arrow-buttons" ? (c(), g(ce, { key: 0 }, [
        re(I(Be), Zt(tn(x.value)), null, 16),
        re(I(Be), Zt(tn(y.value)), null, 16)
      ], 64)) : e.type === "arrows" ? (c(), g(ce, { key: 1 }, [
        re(I(Be), Zt(tn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C([
            "relative z-5 -mr-px self-stretch inline-flex items-center px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            cd,
            Do
          ])
        }, N(o.value), 3),
        re(I(Be), Zt(tn(y.value)), null, 16)
      ], 64)) : e.type === "arrows-text" ? (c(), g(ce, { key: 2 }, [
        re(I(Be), Zt(tn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C(["px-3 py-1.5", Do, "dark:text-(--text-text-white-default)"])
        }, N(o.value), 3),
        re(I(Be), Zt(tn(y.value)), null, 16)
      ], 64)) : e.type === "buttons-helper" ? (c(), g(ce, { key: 3 }, [
        e.helperText ? (c(), g("span", kO, N(e.helperText), 1)) : k("", !0),
        v("div", wO, [
          re(I(Be), Zt(tn(x.value)), null, 16),
          re(I(Be), Zt(tn(y.value)), null, 16)
        ])
      ], 64)) : e.type === "dropdown-buttons" ? (c(), g(ce, { key: 4 }, [
        re(ln, { items: u.value }, {
          trigger: xe(({ triggerProps: T }) => [
            re(I(Be), Oe({
              variant: "secondary",
              size: "xs",
              label: d(e.currentPage),
              "dropdown-icon": "",
              "aria-label": `${e.pageSelectLabel} ${d(e.currentPage)}`,
              "aria-describedby": I(s),
              disabled: e.disabled,
              "data-testid": "compact-pager-page-select"
            }, T), null, 16, ["label", "aria-label", "aria-describedby", "disabled"])
          ]),
          _: 1
        }, 8, ["items"]),
        v("span", {
          id: I(s),
          "data-testid": "compact-pager-status",
          class: C([
            "inline-flex items-center rounded-(--border-border-radius-rounded-base) px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            cd,
            Do
          ])
        }, N(i.value), 11, CO),
        v("div", SO, [
          re(I(Be), Zt(tn(x.value)), null, 16),
          re(I(Be), Zt(tn(y.value)), null, 16)
        ])
      ], 64)) : e.type === "arrows-number" ? (c(), g(ce, { key: 5 }, [
        re(I(Be), Zt(tn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C(["inline-flex size-9 shrink-0 items-center justify-center rounded-full", cd, Do])
        }, [
          v("span", $O, N(e.currentPage), 1),
          v("span", IO, N(o.value), 1)
        ], 2),
        re(I(Be), Zt(tn(y.value)), null, 16)
      ], 64)) : k("", !0)
    ], 10, yO));
  }
});
function Lq(e, n) {
  return {
    result: e.data.map(n),
    currentPage: e.pagination.page,
    pageSize: e.pagination.perPage,
    totalItems: e.pagination.totalItems,
    totalPages: e.pagination.totalPages
  };
}
const er = Symbol("tableQuery"), gs = Symbol("tableViews"), TO = Symbol(
  "tableColumnSettings"
), Gv = Symbol("tablePermissions"), Kv = Symbol("tableLabels"), Yv = Symbol("tableViewPanel");
function Jv(e, n) {
  return `${e}-tab-${n}`;
}
const Xv = {
  tableLabel: "Table",
  filterButton: "Filter",
  eraseAll: "Erase all",
  hideFilters: (e) => `Hide filters (${e})`,
  showFilters: (e) => `Show filters (${e})`,
  saveView: "Save",
  shareView: "Share",
  closeSearch: "Close search",
  removeFilter: (e) => `Remove ${e} filter`,
  renameView: "Rename view",
  setAsDefault: "Set as default",
  deleteView: "Delete view",
  manageViews: "Manage views",
  viewSettingsLabel: "View settings",
  viewModeTable: "Table",
  viewModeBoard: "Board",
  viewModeCalendar: "Calendar",
  viewModeGantt: "Gantt",
  viewTabsLabel: "Pre-filtered lists",
  viewTabsOverflowLabel: "lists"
};
function tr() {
  return Nt(
    Kv,
    m(() => Xv)
  );
}
const LO = ["aria-label"], AO = ["id", "aria-controls", "aria-selected", "tabindex", "data-testid", "data-active", "onClick"], EO = {
  "data-tab-label": "",
  class: "truncate min-w-0"
}, RO = {
  key: 0,
  "data-tab-count": "",
  "data-testid": "table-view-tab-count",
  class: "shrink-0 whitespace-pre"
}, mb = "ri-arrow-down-s-line", BO = "ri-information-line", DO = 6, MO = 233, fd = 1, zO = /* @__PURE__ */ ke({
  __name: "TableViewTabs",
  props: {
    tabDropdowns: { default: () => [] },
    overflowLabel: { default: void 0 }
  },
  emits: ["tab-requested", "tab-reordered"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Nt(er), r = Nt(gs), o = R(null), i = R(null), s = R(null), d = R(/* @__PURE__ */ new Map()), u = R([]), f = /* @__PURE__ */ new Map(), b = (se) => {
      var Se;
      return ((Se = f.get(se)) == null ? void 0 : Se.width) ?? 0;
    };
    let h = 0;
    const p = m(() => (r == null ? void 0 : r.presetViews.value) ?? []), x = tr(), y = Nt(Yv, null);
    function w(se) {
      return se.count === void 0 ? se.label : `${se.label} (${se.count})`;
    }
    const $ = R([]);
    function S() {
      const se = p.value.filter((Se) => {
        var Q;
        const V = (Q = d.value.get(Se.id)) == null ? void 0 : Q.querySelector("[data-tab-label]");
        return !!V && V.scrollWidth > V.offsetWidth;
      }).map((Se) => Se.id);
      se.join("\0") !== $.value.join("\0") && ($.value = se);
    }
    const L = m(
      () => p.value.map((se) => se.id).filter((se) => !u.value.includes(se))
    ), T = m(() => D.value ? A.value : L.value[0] ?? null);
    function E(se) {
      var le;
      const Se = L.value, V = Se.findIndex((ee) => d.value.get(ee) === document.activeElement);
      if (V < 0 || Se.length === 0) return;
      let Q;
      switch (se.key) {
        case "ArrowRight":
          Q = (V + 1) % Se.length;
          break;
        case "ArrowLeft":
          Q = (V - 1 + Se.length) % Se.length;
          break;
        case "Home":
          Q = 0;
          break;
        case "End":
          Q = Se.length - 1;
          break;
        default:
          return;
      }
      se.preventDefault(), (le = d.value.get(Se[Q])) == null || le.focus();
    }
    const A = m(() => (l == null ? void 0 : l.state.activeViewId) ?? null), D = m(() => !!A.value && p.value.some((se) => se.id === A.value)), M = m(() => t.tabDropdowns), F = m(
      () => {
        var se;
        return ((se = M.value.find((Se) => Se.overflowLabel)) == null ? void 0 : se.overflowLabel) ?? t.overflowLabel ?? x.value.viewTabsOverflowLabel;
      }
    ), X = m(
      () => {
        var se;
        return (se = M.value.find((Se) => Se.overflowInfoTooltip)) == null ? void 0 : se.overflowInfoTooltip;
      }
    ), _ = R(
      t.tabDropdowns.reduce((se, Se, V) => {
        var Q, le;
        return (le = (Q = Se.groupButtons) == null ? void 0 : Q[0]) != null && le.value && (se[V] = Se.groupButtons[0].value), se;
      }, {})
    ), Y = (se, Se) => {
      _.value[se] = Se;
    }, B = R({}), W = (se, Se) => {
      B.value[se] = Se;
    }, U = R({}), z = (se, Se) => {
      const V = U.value[se] ?? [];
      V.indexOf(Se) >= 0 ? U.value[se] = V.filter((le) => le !== Se) : U.value[se] = [...V, Se];
    }, P = m(
      () => M.value.map(
        (se, Se) => {
          if (!se.showHeader) return { left: void 0, right: void 0 };
          const V = se.controlledSelection ? se.items.filter((le) => le.switchChecked).length : (U.value[Se] ?? []).length, Q = se.selectedCountSuffix ?? "selected";
          return {
            left: { text: se.label },
            right: { text: `${V}/${se.items.length} ${Q}` }
          };
        }
      )
    ), K = m(
      () => M.value.map(
        (se, Se) => se.items.map((V) => se.controlledSelection ? {
          id: V.id,
          label: V.label,
          group: V.group,
          hasSwitch: !0,
          switchChecked: V.switchChecked === !0,
          disabled: V.disabled === !0,
          onClick: V.onClick,
          moreActions: V.moreActions
        } : {
          id: V.id,
          label: V.label,
          group: V.group,
          hasSwitch: !0,
          switchChecked: (U.value[Se] ?? []).includes(V.id),
          onClick: () => z(Se, V.id),
          moreActions: V.moreActions
        })
      )
    ), j = m(
      () => M.value.map(
        (se, Se) => (se.footerButtons ?? []).map((V) => se.controlledSelection ? {
          label: V.label,
          variant: V.variant,
          keepOpen: V.keepOpen,
          disabled: V.disabled,
          onClick: () => {
            var Q;
            return (Q = V.onClick) == null ? void 0 : Q.call(V, []);
          }
        } : {
          label: V.label,
          variant: V.variant,
          keepOpen: V.keepOpen,
          onClick: () => {
            var ee;
            const Q = U.value[Se] ?? [], le = se.items.filter((O) => Q.includes(O.id));
            a("tab-requested", Se, le), (ee = V.onClick) == null || ee.call(V, le), U.value = { ...U.value, [Se]: [] };
          }
        })
      )
    ), G = m(
      () => p.value.filter((se) => u.value.includes(se.id)).map((se) => ({
        label: w(se),
        onClick: () => l == null ? void 0 : l.setView(se.id)
      }))
    );
    let q = 0;
    function J() {
      return typeof window > "u" ? 0.72 : window.innerWidth >= 1920 ? 0.8 : 0.72;
    }
    function me(se) {
      return se.reduce((Se, V) => Se + b(V), 0) + fd * Math.max(0, se.length - 1);
    }
    function ye(se) {
      var fe, ue;
      const Se = se.getBoundingClientRect().width, V = ((fe = se.querySelector("[data-tab-label]")) == null ? void 0 : fe.scrollWidth) ?? 0;
      if (Se === 0 && V === 0) return 0;
      const Q = getComputedStyle(se), ee = ["paddingLeft", "paddingRight", "borderLeftWidth", "borderRightWidth"].reduce((te, oe) => te + (parseFloat(Q[oe]) || 0), 0), O = ((ue = se.querySelector("[data-tab-count]")) == null ? void 0 : ue.getBoundingClientRect().width) ?? 0, ne = Math.ceil(ee + V + O);
      return Math.min(MO, Math.max(Se, ne));
    }
    function Z() {
      var Ee, He;
      if (q >= DO) return;
      const se = o.value, Se = i.value;
      if (!se || !Se) {
        u.value = [];
        return;
      }
      const V = se.getBoundingClientRect().width;
      if (V <= 0) return;
      let Q = !1;
      for (const Ge of p.value) {
        if (((Ee = f.get(Ge.id)) == null ? void 0 : Ee.label) === w(Ge)) continue;
        const Ze = d.value.get(Ge.id);
        if (Ze) {
          const ae = ye(Ze);
          ae > 0 ? f.set(Ge.id, { label: w(Ge), width: ae }) : Q = !0;
        } else
          Q = !0;
      }
      if (Q) {
        u.value = [], q++, Ue(Z);
        return;
      }
      S();
      const le = ((He = s.value) == null ? void 0 : He.$el) ?? null;
      let ee = 0, O = 0;
      for (let Ge = 0; Ge < se.children.length; Ge++) {
        const Ze = se.children[Ge];
        Ze !== Se && (le && (Ze === le || Ze.contains(le)) || (ee += Ze.getBoundingClientRect().width, O++));
      }
      const ne = (typeof window < "u" ? window.innerWidth : V) * J(), fe = Math.min(V, ne), ue = Math.floor(fe - ee - fd * O), te = p.value.map((Ge) => Ge.id);
      if (me(te) <= ue - 1) {
        const Ge = JSON.stringify(u.value);
        u.value = [], JSON.stringify([]) !== Ge ? (q++, Ue(Z)) : q = 0;
        return;
      }
      if (le) {
        const Ge = le.getBoundingClientRect().width;
        Ge > 0 && (h = Ge);
      }
      const oe = Math.floor(
        fe - ee - h - fd * (O + 1)
      ), Le = (Ge) => me(Ge) <= oe - 1, Ie = [], ve = [];
      for (const Ge of te) (Le([...ve, Ge]) ? ve : Ie).push(Ge);
      const we = A.value;
      if (we && Ie.includes(we)) {
        for (; ve.length > 0 && !Le([...ve, we]); ) Ie.push(ve.pop());
        Ie.splice(Ie.indexOf(we), 1), ve.push(we);
      }
      ve.length === 0 && Ie.length > 0 && ve.push(Ie.shift());
      const he = JSON.stringify(u.value), Me = JSON.stringify(Ie);
      u.value = Ie, he !== Me ? (q++, Ue(Z)) : q = 0;
    }
    function de() {
      q = 0, Ue(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(Z);
        });
      });
    }
    let ge = null;
    return dt(() => {
      var se;
      de(), ge = new ResizeObserver(() => {
        h = 0, de();
      }), o.value && ge.observe(o.value), (se = document.fonts) == null || se.ready.then(() => {
        f.clear(), h = 0, de();
      });
    }), gt(() => ge == null ? void 0 : ge.disconnect()), $e(
      p,
      (se) => {
        const Se = new Set(se.map((V) => V.id));
        for (const [V] of f)
          Se.has(V) || f.delete(V);
        h = 0, de();
      },
      // CONSTRAINT: deep, so a counter mutated in place on the same view object still re-measures.
      { deep: !0 }
    ), $e(A, () => {
      de();
    }), $e([F, X], () => {
      de();
    }), (se, Se) => (c(), g("div", {
      ref_key: "outerRef",
      ref: o,
      class: "flex items-stretch gap-px min-w-0 flex-1"
    }, [
      v("div", {
        ref_key: "containerRef",
        ref: i,
        "data-testid": "tab-container",
        role: "tablist",
        "aria-label": I(x).viewTabsLabel,
        class: "flex items-stretch gap-px min-w-0 overflow-hidden",
        onKeydown: E
      }, [
        (c(!0), g(ce, null, Re(p.value, (V) => (c(), H(I(ft), {
          key: V.id,
          role: "presentation",
          class: C(["min-w-0", { "hidden!": u.value.includes(V.id) }]),
          text: w(V),
          disabled: !$.value.includes(V.id),
          "labels-trigger": ""
        }, {
          default: xe(() => {
            var Q;
            return [
              Jl(v("button", {
                id: I(y) ? I(Jv)(I(y).id, V.id) : void 0,
                ref_for: !0,
                ref: (le) => {
                  le && d.value.set(V.id, le);
                },
                type: "button",
                role: "tab",
                "aria-controls": (Q = I(y)) != null && Q.isTabpanel.value ? I(y).id : void 0,
                "aria-selected": A.value === V.id ? "true" : "false",
                tabindex: T.value === V.id ? 0 : -1,
                "data-testid": `table-view-tab-${V.id}`,
                "data-active": A.value === V.id ? "true" : "false",
                class: C([
                  "min-w-0 px-3 flex items-center text-xs leading-5 font-medium transition-colors duration-200 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) max-w-[233px] overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue",
                  A.value === V.id ? "tab-active tab-active--has-left -mb-px text-gray-900 dark:text-white" : "border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10"
                ]),
                onClick: (le) => {
                  var ee;
                  return (ee = I(l)) == null ? void 0 : ee.setView(V.id);
                }
              }, [
                v("span", EO, N(V.label), 1),
                V.count !== void 0 ? (c(), g("span", RO, " (" + N(V.count) + ")", 1)) : k("", !0)
              ], 10, AO), [
                [Tu, !u.value.includes(V.id)]
              ])
            ];
          }),
          _: 2
        }, 1032, ["class", "text", "disabled"]))), 128))
      ], 40, LO),
      G.value.length > 0 ? (c(), H(I(ln), {
        key: 0,
        ref_key: "overflowDropdownRef",
        ref: s,
        class: "shrink-0",
        label: `+${G.value.length} ${F.value}`,
        items: G.value,
        "trigger-icon-info": X.value ? BO : void 0,
        "trigger-icon-info-tooltip": X.value,
        "trigger-icon": mb,
        "menu-align": "left",
        "menu-width": "220px",
        tab: !0
      }, null, 8, ["label", "items", "trigger-icon-info", "trigger-icon-info-tooltip"])) : k("", !0),
      (c(!0), g(ce, null, Re(M.value, (V, Q) => (c(), g("div", {
        key: Q,
        class: "flex items-center gap-1 shrink-0"
      }, [
        re(I(Zu), {
          class: "shrink-0",
          label: V.label,
          "trigger-icon-left": V.iconLeft,
          "trigger-icon": mb,
          tab: !0,
          "header-label-left": P.value[Q].left,
          "header-label-right": P.value[Q].right,
          "show-search": V.showSearch,
          "search-query": B.value[Q] ?? "",
          "search-placeholder": V.searchPlaceholder,
          "search-clear-label": V.searchClearLabel,
          "group-buttons": V.groupButtons,
          "active-group-button": _.value[Q],
          items: K.value[Q],
          "footer-buttons": j.value[Q],
          reorderable: V.reorderable === !0,
          "freeze-on-open": !0,
          "menu-align": "left",
          size: V.size ?? "m",
          "max-list-height": "280px",
          "reserve-list-height": V.reserveListHeight !== !1,
          "empty-label": V.emptyLabel,
          "onUpdate:searchQuery": (le) => W(Q, le),
          "onUpdate:activeGroupButton": (le) => Y(Q, le),
          onReorder: (le) => a("tab-reordered", Q, le)
        }, null, 8, ["label", "trigger-icon-left", "header-label-left", "header-label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group-button", "items", "footer-buttons", "reorderable", "size", "reserve-list-height", "empty-label", "onUpdate:searchQuery", "onUpdate:activeGroupButton", "onReorder"])
      ]))), 128))
    ], 512));
  }
}), OO = /* @__PURE__ */ ot(zO, [["__scopeId", "data-v-b1c338bb"]]), ms = 300;
function Aq(e = {}) {
  const { initialViewMode: n, filterLabels: t, filterItems: a, filterFieldConfigs: l, ...r } = e, o = R(n ?? "table"), i = R(!1), s = R(0), d = sl({
    search: "",
    filters: {},
    sort: null,
    activeViewId: null,
    page: 1,
    pageSize: 10,
    ...r
  }), u = m(() => Object.keys(d.filters).length > 0), f = m(() => Object.keys(d.filters).length), b = m(() => {
    const M = Rt(t), F = Rt(a), X = Rt(l);
    return Object.entries(d.filters).map(([_, Y]) => {
      const B = {
        key: _,
        label: (M == null ? void 0 : M[_]) ?? _,
        valueLabel: PO(Y, F == null ? void 0 : F[_]),
        value: Y
      };
      F != null && F[_] && (B.items = F[_]);
      const W = X == null ? void 0 : X[_];
      return W && (W.placeholder && (B.placeholder = W.placeholder), W.rangeConfig && (B.rangeConfig = W.rangeConfig), W.dateRangeConfig && (B.dateRangeConfig = W.dateRangeConfig)), B;
    });
  });
  function h(M, F) {
    d.filters[M] = F, d.page = 1;
  }
  function p(M) {
    delete d.filters[M], d.page = 1;
  }
  function x() {
    d.filters = {}, d.page = 1;
  }
  function y(M) {
    d.search = M, d.page = 1, s.value++;
  }
  function w(M) {
    i.value = M;
  }
  function $(M, F) {
    d.sort = { column: M, direction: F };
  }
  function S() {
    d.sort = null;
  }
  function L(M) {
    d.page = M;
  }
  function T(M) {
    d.pageSize = M, d.page = 1;
  }
  function E(M) {
    d.activeViewId = M, d.page = 1;
  }
  function A(M) {
    o.value = M;
  }
  function D(M) {
    Object.assign(d, M);
  }
  return {
    state: d,
    viewMode: o,
    searchPending: i,
    searchRevision: s,
    hasActiveFilters: u,
    activeFilterCount: f,
    activeFilterPills: b,
    setFilter: h,
    removeFilter: p,
    clearAllFilters: x,
    setSearch: y,
    setSearchPending: w,
    setSort: $,
    clearSort: S,
    setPage: L,
    setPageSize: T,
    setView: E,
    setViewMode: A,
    patch: D
  };
}
function PO(e, n) {
  switch (e.type) {
    case "equals":
      return String(e.value);
    case "in": {
      const t = (a) => {
        var l;
        return ((l = n == null ? void 0 : n.find((r) => r.id === a)) == null ? void 0 : l.label) ?? a;
      };
      return e.values.length === 1 ? t(e.values[0]) : `${t(e.values[0])} (${e.values.length})`;
    }
    case "range":
      return e.min != null && e.max != null ? `${e.min} – ${e.max}` : e.min != null ? `≥ ${e.min}` : e.max != null ? `≤ ${e.max}` : "";
    case "dateRange":
      return e.from && e.to ? `${e.from} – ${e.to}` : e.from ? `≥ ${e.from}` : e.to ? `≤ ${e.to}` : "";
    case "boolean":
      return e.value ? "Yes" : "No";
  }
}
const FO = /* @__PURE__ */ ke({
  __name: "TableSearch",
  props: {
    placeholder: { default: "Search..." },
    debounce: { default: ms }
  },
  setup(e) {
    const n = Nt(er), t = tr(), a = R(null);
    $e(
      () => n == null ? void 0 : n.searchRevision.value,
      () => {
        var r;
        return (r = a.value) == null ? void 0 : r.discardPending((n == null ? void 0 : n.state.search) ?? "");
      }
    );
    function l(r) {
      n == null || n.setSearch(r);
    }
    return (r, o) => {
      var i;
      return c(), H(j4, {
        ref_key: "searchRef",
        ref: a,
        "data-table-search": "",
        "model-value": ((i = I(n)) == null ? void 0 : i.state.search) ?? "",
        placeholder: e.placeholder,
        labels: { closeSearch: I(t).closeSearch },
        debounce: e.debounce,
        "onUpdate:modelValue": l,
        onPending: o[0] || (o[0] = (s) => {
          var d;
          return (d = I(n)) == null ? void 0 : d.setSearchPending(s);
        })
      }, null, 8, ["model-value", "placeholder", "labels", "debounce"]);
    };
  }
}), VO = {
  key: 0,
  class: "inline-flex items-center px-3 py-2 text-(length:--size-m) leading-[20px] font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "table-view-selector-static"
}, NO = /* @__PURE__ */ ke({
  __name: "TableViewSelector",
  emits: ["rename-view", "delete-view", "set-default"],
  setup(e, { emit: n }) {
    const t = n, a = Nt(er), l = Nt(gs), r = tr(), o = m(
      () => l == null ? void 0 : l.views.value.find((d) => d.id === (a == null ? void 0 : a.state.activeViewId))
    ), i = m(() => !!(o.value && !o.value.isPreset)), s = m(() => i.value ? [
      { label: r.value.renameView, onClick: () => t("rename-view", o.value.id) },
      {
        label: r.value.setAsDefault,
        hasDividerAfter: !0,
        onClick: () => {
          l == null || l.setDefault(o.value.id), t("set-default", o.value.id);
        }
      },
      { label: r.value.deleteView, onClick: () => t("delete-view", o.value.id) }
    ] : []);
    return (d, u) => i.value ? (c(), H(I(ln), {
      key: 1,
      label: I(r).viewModeTable,
      items: s.value,
      "menu-align": "right",
      "menu-width": "180px",
      ghost: !0
    }, null, 8, ["label", "items"])) : (c(), g("div", VO, N(I(r).viewModeTable), 1));
  }
}), HO = { class: "@container/topbar relative flex flex-wrap items-stretch border-gainsboro dark:border-(--colors-border-base)" }, jO = {
  key: 1,
  class: "flex-1"
}, Zv = /* @__PURE__ */ ke({
  __name: "TableTopbar",
  props: {
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: ms },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "tab-requested", "tab-reordered"],
  setup(e, { emit: n }) {
    const t = n, a = Nt(gs), l = m(() => ((a == null ? void 0 : a.presetViews.value.length) ?? 0) > 0);
    return (r, o) => (c(), g("div", HO, [
      v("div", {
        class: C(["h-9 items-stretch w-full @2xl/topbar:w-[73%] min-w-0", l.value ? "flex" : "hidden @2xl/topbar:flex"]),
        "data-testid": "table-topbar-tabs"
      }, [
        l.value ? (c(), H(OO, {
          key: 0,
          "tab-dropdowns": e.tabDropdowns,
          onTabRequested: o[0] || (o[0] = (i, s) => t("tab-requested", i, s)),
          onTabReordered: o[1] || (o[1] = (i, s) => t("tab-reordered", i, s))
        }, null, 8, ["tab-dropdowns"])) : (c(), g("div", jO))
      ], 2),
      v("div", {
        class: C(["order-first flex h-9 items-center justify-end gap-1 w-full @2xl/topbar:order-none @2xl/topbar:w-[27%] px-4 py-1", l.value ? "border-gainsboro dark:border-(--colors-border-base)" : ""]),
        "data-testid": "table-topbar-search"
      }, [
        e.showSearch ? (c(), H(FO, {
          key: 0,
          placeholder: e.searchPlaceholder,
          debounce: e.searchDebounce
        }, null, 8, ["placeholder", "debounce"])) : k("", !0),
        e.showViewSelector ? (c(), H(NO, {
          key: 1,
          onRenameView: o[2] || (o[2] = (i) => t("rename-view", i)),
          onDeleteView: o[3] || (o[3] = (i) => t("delete-view", i)),
          onSetDefault: o[4] || (o[4] = (i) => t("set-default", i))
        })) : k("", !0)
      ], 2)
    ]));
  }
}), WO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14%2014V20L10%2022V14L4%205V3H20V5L14%2014ZM6.4037%205L12%2013.3944L17.5963%205H6.4037Z'/%3e%3c/svg%3e", qO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.8827%2019.2968C16.1814%2020.3755%2014.1638%2021.0002%2012.0003%2021.0002C6.60812%2021.0002%202.12215%2017.1204%201.18164%2012.0002C1.61832%209.62282%202.81932%207.5129%204.52047%205.93457L1.39366%202.80777L2.80788%201.39355L22.6069%2021.1925L21.1927%2022.6068L17.8827%2019.2968ZM5.9356%207.3497C4.60673%208.56015%203.6378%2010.1672%203.22278%2012.0002C4.14022%2016.0521%207.7646%2019.0002%2012.0003%2019.0002C13.5997%2019.0002%2015.112%2018.5798%2016.4243%2017.8384L14.396%2015.8101C13.7023%2016.2472%2012.8808%2016.5002%2012.0003%2016.5002C9.51498%2016.5002%207.50026%2014.4854%207.50026%2012.0002C7.50026%2011.1196%207.75317%2010.2981%208.19031%209.60442L5.9356%207.3497ZM12.9139%2014.328L9.67246%2011.0866C9.5613%2011.3696%209.50026%2011.6777%209.50026%2012.0002C9.50026%2013.3809%2010.6196%2014.5002%2012.0003%2014.5002C12.3227%2014.5002%2012.6309%2014.4391%2012.9139%2014.328ZM20.8068%2016.5925L19.376%2015.1617C20.0319%2014.2268%2020.5154%2013.1586%2020.7777%2012.0002C19.8603%207.94818%2016.2359%205.00016%2012.0003%205.00016C11.1544%205.00016%2010.3329%205.11773%209.55249%205.33818L7.97446%203.76015C9.22127%203.26959%2010.5793%203.00016%2012.0003%203.00016C17.3924%203.00016%2021.8784%206.87992%2022.8189%2012.0002C22.5067%2013.6998%2021.8038%2015.2628%2020.8068%2016.5925ZM11.7229%207.50857C11.8146%207.50299%2011.9071%207.50016%2012.0003%207.50016C14.4855%207.50016%2016.5003%209.51488%2016.5003%2012.0002C16.5003%2012.0933%2016.4974%2012.1858%2016.4919%2012.2775L11.7229%207.50857Z'/%3e%3c/svg%3e", UO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.0003%203C17.3924%203%2021.8784%206.87976%2022.8189%2012C21.8784%2017.1202%2017.3924%2021%2012.0003%2021C6.60812%2021%202.12215%2017.1202%201.18164%2012C2.12215%206.87976%206.60812%203%2012.0003%203ZM12.0003%2019C16.2359%2019%2019.8603%2016.052%2020.7777%2012C19.8603%207.94803%2016.2359%205%2012.0003%205C7.7646%205%204.14022%207.94803%203.22278%2012C4.14022%2016.052%207.7646%2019%2012.0003%2019ZM12.0003%2016.5C9.51498%2016.5%207.50026%2014.4853%207.50026%2012C7.50026%209.51472%209.51498%207.5%2012.0003%207.5C14.4855%207.5%2016.5003%209.51472%2016.5003%2012C16.5003%2014.4853%2014.4855%2016.5%2012.0003%2016.5ZM12.0003%2014.5C13.381%2014.5%2014.5003%2013.3807%2014.5003%2012C14.5003%2010.6193%2013.381%209.5%2012.0003%209.5C10.6196%209.5%209.50026%2010.6193%209.50026%2012C9.50026%2013.3807%2010.6196%2014.5%2012.0003%2014.5Z'/%3e%3c/svg%3e", GO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%203H18L20.7071%205.70711C20.8946%205.89464%2021%206.149%2021%206.41421V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM7%204V9H16V4H7ZM6%2012V19H18V12H6ZM13%205H15V8H13V5Z'/%3e%3c/svg%3e", Dl = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2013.1714L16.9497%208.22168L18.3639%209.63589L11.9999%2015.9999L5.63599%209.63589L7.0502%208.22168L11.9999%2013.1714Z'/%3e%3c/svg%3e", Zo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2010.8284L7.0502%2015.7782L5.63599%2014.364L11.9999%208L18.3639%2014.364L16.9497%2015.7782L11.9999%2010.8284Z'/%3e%3c/svg%3e", Qv = /* @__PURE__ */ ke({
  __name: "TableControls",
  props: {
    isFilterPanelOpen: { type: Boolean, default: !1 },
    isFilterBarVisible: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["toggle-filter-panel", "toggle-filter-bar", "save-view", "share-view", "focus-fallback"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = Nt(er), r = Nt(Gv), o = tr(), i = m(() => (l == null ? void 0 : l.hasActiveFilters.value) ?? !1), s = m(() => (l == null ? void 0 : l.activeFilterCount.value) ?? 0), d = Yn("filterTrigger");
    function u() {
      var h;
      const b = (h = d.value) == null ? void 0 : h.querySelector(ba);
      return b == null || b.focus(), !!b && document.activeElement === b;
    }
    async function f() {
      l == null || l.clearAllFilters(), await Ue(), u() || a("focus-fallback");
    }
    return n({ focusFilterTrigger: u }), (b, h) => {
      var p, x;
      return c(), g("div", {
        class: C([
          "flex flex-wrap items-center gap-3 p-3 bg-white dark:bg-(--colors-background-black-default) rounded-tr-[12px]",
          e.bordered && "border-b border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
        ])
      }, [
        e.showFilter ? (c(), g("div", {
          key: 0,
          ref_key: "filterTrigger",
          ref: d,
          class: "contents"
        }, [
          b.$slots.filter ? Ae(b.$slots, "filter", { key: 0 }) : (c(), H(I(Be), {
            key: 1,
            variant: "tertiary",
            "icon-left": I(WO),
            "icon-right": I(Dl),
            size: "sm",
            active: e.isFilterPanelOpen,
            onClick: h[0] || (h[0] = (y) => a("toggle-filter-panel"))
          }, {
            default: xe(() => [
              et(N(I(o).filterButton), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "icon-right", "active"]))
        ], 512)) : k("", !0),
        i.value ? (c(), g("button", {
          key: 1,
          type: "button",
          class: "shrink-0 text-sm font-medium text-blue-600 underline cursor-pointer hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors",
          onClick: f
        }, N(I(o).eraseAll), 1)) : k("", !0),
        i.value ? (c(), H(I(Be), {
          key: 2,
          variant: "tertiary",
          "icon-left": e.isFilterBarVisible ? I(qO) : I(UO),
          "icon-right": e.isFilterBarVisible ? I(Zo) : I(Dl),
          size: "sm",
          "aria-expanded": e.isFilterBarVisible,
          "data-testid": "table-controls-filter-bar-toggle",
          onClick: h[1] || (h[1] = (y) => a("toggle-filter-bar"))
        }, {
          default: xe(() => [
            et(N(e.isFilterBarVisible ? I(o).hideFilters(s.value) : I(o).showFilters(s.value)), 1)
          ]),
          _: 1
        }, 8, ["icon-left", "icon-right", "aria-expanded"])) : k("", !0),
        Ae(b.$slots, "controls-info"),
        h[4] || (h[4] = v("div", { class: "flex-1" }, null, -1)),
        Ae(b.$slots, "controls-actions"),
        ((p = I(r)) == null ? void 0 : p.canSaveView) !== !1 ? (c(), H(I(Be), {
          key: 3,
          variant: "secondary",
          label: I(o).saveView,
          "icon-left": I(GO),
          "icon-right": I(Dl),
          size: "sm",
          disabled: !i.value,
          onClick: h[2] || (h[2] = (y) => a("save-view"))
        }, null, 8, ["label", "icon-left", "icon-right", "disabled"])) : k("", !0),
        ((x = I(r)) == null ? void 0 : x.canShareView) !== !1 ? (c(), H(I(Be), {
          key: 4,
          variant: "secondary",
          label: I(o).shareView,
          size: "sm",
          onClick: h[3] || (h[3] = (y) => a("share-view"))
        }, null, 8, ["label"])) : k("", !0)
      ], 2);
    };
  }
}), KO = { class: "pill-gradient relative inline-flex shrink-0 items-stretch rounded-full" }, YO = { class: "flex items-stretch rounded-full bg-white dark:bg-(--colors-background-black-default)" }, JO = { class: "whitespace-nowrap text-sm font-medium text-slategray dark:text-(--colors-text-white-secondary)" }, XO = ["title"], ZO = {
  key: 1,
  class: "ml-0.5 whitespace-nowrap text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
}, QO = ["aria-label"], _O = /* @__PURE__ */ ke({
  __name: "FilterPill",
  props: {
    pill: {}
  },
  emits: ["remove", "edit"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = tr(), r = m(
      () => t.pill.value.type === "in" ? t.pill.value.values.length : null
    ), o = m(() => r.value !== null && r.value > 1);
    function i() {
      a("edit", t.pill.key);
    }
    return (s, d) => (c(), g("div", KO, [
      v("div", YO, [
        v("button", {
          type: "button",
          class: "inline-flex cursor-pointer items-center gap-1 py-1 pl-3 pr-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1 rounded-l-full",
          onClick: Ye(i, ["stop"])
        }, [
          v("span", JO, N(e.pill.label), 1),
          o.value ? (c(), g("span", ZO, " (" + N(r.value) + ") ", 1)) : (c(), g(ce, { key: 0 }, [
            d[1] || (d[1] = v("span", { class: "text-sm text-slategray dark:text-(--colors-text-white-secondary)" }, " : ", -1)),
            v("span", {
              class: "max-w-50 truncate text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
              title: e.pill.valueLabel
            }, N(e.pill.valueLabel), 9, XO)
          ], 64)),
          d[2] || (d[2] = v("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "ml-0.5 h-3 w-3 shrink-0 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            v("path", { d: "M6 9l6 6 6-6" })
          ], -1))
        ]),
        d[4] || (d[4] = v("div", { class: "my-1.5 w-px bg-gainsboro dark:bg-(--colors-border-base)" }, null, -1)),
        v("button", {
          type: "button",
          class: "inline-flex w-7 cursor-pointer items-center justify-center rounded-r-full transition-colors duration-150 hover:bg-gray-100 dark:hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1",
          "aria-label": I(l).removeFilter(e.pill.label),
          "data-filter-pill-remove": "",
          onClick: d[0] || (d[0] = Ye((u) => a("remove", e.pill.key), ["stop"]))
        }, [...d[3] || (d[3] = [
          v("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "h-2.5 w-2.5 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            v("path", { d: "M18 6 6 18M6 6l12 12" })
          ], -1)
        ])], 8, QO)
      ])
    ]));
  }
}), eP = /* @__PURE__ */ ot(_O, [["__scopeId", "data-v-41b3792d"]]), _v = /* @__PURE__ */ ke({
  __name: "TableFilterBar",
  props: {
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["edit-filter", "last-filter-removed"],
  setup(e, { emit: n }) {
    const t = n, a = Nt(er), l = m(() => (a == null ? void 0 : a.activeFilterPills.value) ?? []), r = Yn("pillList");
    async function o(i) {
      var u, f;
      const s = l.value.findIndex((b) => b.key === i);
      if (a == null || a.removeFilter(i), await Ue(), l.value.length === 0) {
        t("last-filter-removed");
        return;
      }
      const d = ((u = r.value) == null ? void 0 : u.querySelectorAll("[data-filter-pill-remove]")) ?? [];
      (f = d[Math.min(s, d.length - 1)]) == null || f.focus();
    }
    return (i, s) => (c(), H(wt, {
      "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
      "enter-from-class": "max-h-0",
      "enter-to-class": "max-h-60",
      "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
      "leave-from-class": "max-h-60",
      "leave-to-class": "max-h-0"
    }, {
      default: xe(() => [
        l.value.length > 0 ? (c(), g("div", {
          key: 0,
          class: C([
            "flex items-start gap-2 px-4 py-2 bg-white dark:bg-(--colors-background-black-default)",
            e.bordered && "border-b border-gainsboro dark:border-(--colors-border-base)"
          ])
        }, [
          v("div", {
            ref_key: "pillList",
            ref: r,
            class: "flex items-center gap-2 flex-1 flex-wrap"
          }, [
            (c(!0), g(ce, null, Re(l.value, (d) => (c(), H(eP, {
              key: d.key,
              pill: d,
              onRemove: o,
              onEdit: s[0] || (s[0] = (u) => t("edit-filter", u))
            }, null, 8, ["pill"]))), 128))
          ], 512)
        ], 2)) : k("", !0)
      ]),
      _: 1
    }));
  }
}), tP = {
  "data-testid": "table-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, nP = {
  key: 0,
  class: "flex border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, aP = /* @__PURE__ */ ke({
  __name: "TableSkeleton",
  props: {
    columns: { default: 5 },
    rows: { default: 10 },
    showHeader: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = [85, 45, 30, 65, 40, 55, 35, 75];
    function t(a, l) {
      return `${n[(a + l) % n.length]}%`;
    }
    return (a, l) => (c(), g("div", tP, [
      e.showHeader ? (c(), g("div", nP, [
        (c(!0), g(ce, null, Re(e.columns, (r) => (c(), g("div", {
          key: `skeleton-header-${r}`,
          class: "flex-1 h-11 px-5 flex items-center"
        }, [...l[0] || (l[0] = [
          v("div", { class: "skeleton h-2.5 w-full max-w-[140px] rounded-full" }, null, -1)
        ])]))), 128))
      ])) : k("", !0),
      (c(!0), g(ce, null, Re(e.rows, (r) => (c(), g("div", {
        key: `skeleton-row-${r}`,
        class: "flex border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base) last:border-b-0"
      }, [
        (c(!0), g(ce, null, Re(e.columns, (o) => (c(), g("div", {
          key: `skeleton-cell-${r}-${o}`,
          class: "flex-1 h-14 px-5 flex items-center"
        }, [
          v("div", {
            class: "skeleton h-2.5 rounded-full",
            style: Ne({ width: t(r, o) })
          }, null, 4)
        ]))), 128))
      ]))), 128))
    ]));
  }
}), lP = { class: "flex items-center gap-1.5 justify-center" }, rP = ["src"], oP = ["src"], iP = { class: "self-stretch flex flex-col items-start gap-2" }, sP = {
  key: 0,
  class: "self-stretch flex flex-col items-start"
}, dP = ["onClick"], uP = ["src"], cP = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, fP = {
  key: 2,
  class: "relative leading-num-24 font-medium"
}, hP = ["src"], bP = ["onClick"], gP = { class: "flex-1 flex items-center py-num-0 pl-0.5 pr-num-0 shrink-0 relative z-10" }, mP = { class: "relative leading-num-24 font-medium" }, pP = ["onClick"], vP = ["src"], xP = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, yP = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10"
}, kP = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-colors-text-black-default relative z-10"
}, wP = { class: "relative leading-5 font-medium z-10" }, CP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cline x1=%2218%22 y1=%226%22 x2=%226%22 y2=%2218%22/%3E%3Cline x1=%226%22 y1=%226%22 x2=%2218%22 y2=%2218%22/%3E%3C/svg%3E", SP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%229 18 15 12 9 6%22/%3E%3C/svg%3E", $P = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%226 9 12 15 18 9%22/%3E%3C/svg%3E", IP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%2218 15 12 9 6 15%22/%3E%3C/svg%3E", TP = /* @__PURE__ */ ke({
  __name: "MainDrawer",
  props: {
    logoIcon: { default: "/logo-eudonet.svg" },
    logoText: { default: void 0 },
    closeIcon: { default: void 0 },
    items: { default: () => [
      {
        label: "Overview",
        children: []
      },
      {
        label: "Pages",
        children: []
      },
      {
        label: "Ecommerce",
        icon: void 0,
        children: [
          { label: "All products" },
          { label: "Billing", active: !0 },
          { label: "Invoice" },
          { label: "Transactions" }
        ]
      },
      {
        label: "Messages",
        badge: 4,
        children: []
      },
      {
        label: "Users",
        children: []
      },
      {
        label: "Support",
        children: []
      }
    ] },
    modelValue: { type: Boolean, default: !0 },
    width: { default: "100%" }
  },
  emits: ["update:modelValue", "close", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R({
      Ecommerce: !0
    }), r = R(!1), o = m(() => t.items), i = (x) => {
      l.value[x] = !l.value[x];
    }, s = (x) => l.value[x] === !0, d = (x) => {
      x.children && x.children.length > 0 && !r.value && i(x.label), x.onClick && x.onClick(), a("item-click", x);
    }, u = () => {
      const x = !r.value;
      r.value = x, x && Object.keys(l.value).forEach((y) => {
        l.value[y] = !1;
      });
    }, f = m(() => r.value ? "/logo-eudonet-small.svg" : t.logoIcon || "/logo-eudonet.svg"), b = (x) => {
      const y = 'self-stretch flex items-center py-num-6 pl-8 pr-num-8 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300 relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
      return x.active ? `${y} h-9 rounded-[48px] bg-white overflow-visible before:opacity-100 after:opacity-100` : `${y} rounded-num-12 hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden before:opacity-0 after:opacity-0`;
    }, h = (x) => {
      const y = "self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300";
      return x.active ? `${y} relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 before:opacity-100 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1] after:opacity-100 bg-white overflow-visible` : `${y} hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden`;
    }, p = () => 'h-[22px] w-[22px] rounded-[9999px] relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-[9999px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[9999px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
    return (x, y) => e.modelValue ? (c(), g("div", {
      key: 0,
      role: "dialog",
      class: C(["drawer h-[1184px] relative bg-white flex flex-col items-start box-border gap-5 text-left text-num-16 text-colors-text-body font-inter transition-all duration-300", { "w-20 p-2 overflow-visible": r.value, "p-5 overflow-hidden": !r.value }]),
      style: Ne(r.value ? { width: "80px" } : { width: e.width })
    }, [
      v("div", {
        class: C([
          "self-stretch border-colors-border-black-default border-solid border-b-[1px] pt-num-0 px-num-0 relative",
          r.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-4"
        ])
      }, [
        v("div", lP, [
          f.value ? (c(), g("img", {
            key: 0,
            class: "h-[30px] w-auto relative",
            src: f.value,
            alt: "Eudonet"
          }, null, 8, rP)) : k("", !0),
          e.logoText && !r.value ? (c(), g("img", {
            key: 1,
            class: "h-[30px] w-[73.8px] relative",
            src: e.logoText,
            alt: "Eudonet"
          }, null, 8, oP)) : k("", !0)
        ]),
        r.value ? (c(), H(I(Be), {
          key: 1,
          variant: "tertiary",
          "icon-left": SP,
          "icon-only": "",
          size: "md",
          "aria-label": "Expand",
          class: "drawer-expand-button flex-shrink-0",
          onClick: u
        })) : (c(), H(I(Be), {
          key: 0,
          variant: "tertiary",
          "icon-left": e.closeIcon || CP,
          "icon-only": "",
          size: "md",
          "aria-label": "Close",
          class: "drawer-close-button flex-shrink-0",
          onClick: u
        }, null, 8, ["icon-left"]))
      ], 2),
      v("div", iP, [
        (c(!0), g(ce, null, Re(o.value, (w, $) => (c(), g(ce, { key: $ }, [
          w.children && w.children.length > 0 ? (c(), g("div", sP, [
            v("button", {
              type: "button",
              class: C(["self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden transition-[background,border-color] duration-300", { "justify-center": r.value }]),
              onClick: (S) => d(w)
            }, [
              v("div", {
                class: C(["flex-1 flex items-center gap-1.5", { "justify-center": r.value }])
              }, [
                w.icon ? (c(), g("img", {
                  key: 0,
                  class: "h-5 w-5 relative flex-shrink-0",
                  src: w.icon,
                  alt: ""
                }, null, 8, uP)) : (c(), g("div", cP)),
                r.value ? k("", !0) : (c(), g("div", fP, N(w.label), 1))
              ], 2),
              r.value ? k("", !0) : (c(), g("img", {
                key: 0,
                class: "h-4 w-4 relative transition-transform duration-200",
                src: s(w.label) ? IP : $P,
                alt: ""
              }, null, 8, hP))
            ], 10, dP),
            re(Pr, {
              name: "submenu",
              tag: "div",
              class: C([
                "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                { "submenu-open": s(w.label) }
              ])
            }, {
              default: xe(() => [
                (c(!0), g(ce, null, Re(s(w.label) ? w.children : [], (S, L) => (c(), g("button", {
                  key: `${w.label}-${L}`,
                  type: "button",
                  class: C(b(S)),
                  onClick: (T) => d(S)
                }, [
                  v("div", gP, [
                    v("div", mP, N(S.label), 1)
                  ])
                ], 10, bP))), 128))
              ]),
              _: 2
            }, 1032, ["class"])
          ])) : (c(), g("button", {
            key: 1,
            type: "button",
            class: C([h(w), { "justify-center": r.value }]),
            onClick: (S) => d(w)
          }, [
            v("div", {
              class: C(["flex-1 flex items-center gap-1.5 relative z-10", { "justify-center": r.value }])
            }, [
              w.icon ? (c(), g("img", {
                key: 0,
                class: "h-5 w-5 relative flex-shrink-0 z-10",
                src: w.icon,
                alt: ""
              }, null, 8, vP)) : (c(), g("div", xP)),
              r.value ? k("", !0) : (c(), g("div", yP, N(w.label), 1))
            ], 2),
            w.badge && !r.value ? (c(), g("div", kP, [
              v("div", {
                class: C(p())
              }, [
                v("div", wP, N(w.badge), 1)
              ], 2)
            ])) : k("", !0)
          ], 10, pP))
        ], 64))), 128))
      ])
    ], 6)) : k("", !0);
  }
}), Eq = /* @__PURE__ */ ot(TP, [["__scopeId", "data-v-ce4179bf"]]), LP = ["aria-label"], AP = { class: "flex min-w-0 flex-wrap items-center gap-2.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, EP = {
  key: 1,
  class: "sr-only"
}, RP = ["aria-current"], BP = {
  key: 1,
  class: "sr-only"
}, DP = {
  key: 2,
  "data-testid": "breadcrumb-separator",
  class: "ri-arrow-right-s-line inline-flex size-3.5 shrink-0 items-center justify-center text-num-14 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
  "aria-hidden": "true"
}, pb = "inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs)", MP = "text-(--text-text-heading) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", vb = "inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", zP = /* @__PURE__ */ ke({
  __name: "Breadcrumb",
  props: {
    items: {},
    type: { default: "default" },
    ariaLabel: {},
    linkAs: { default: "a" }
  },
  setup(e) {
    var y;
    const n = e, t = m(() => [
      "flex w-fit max-w-full min-w-0 items-center text-(--text-text-heading) dark:text-(--text-text-white-default)",
      n.type === "background" ? "border border-(--border-border-white-default) bg-(--background-background-white) p-[calc(--spacing(2.5)-1px)] rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs) dark:bg-(--background-background-black-default) dark:border-(--border-border-base)" : "rounded-(--border-border-radius-rounded-xs)"
    ]);
    function a(w) {
      return w === n.items.length - 1;
    }
    function l(w) {
      return w.to != null && n.linkAs !== "a";
    }
    function r(w, $) {
      return !a($) && (l(w) || w.href !== void 0);
    }
    const o = typeof process < "u" && ((y = process.env) == null ? void 0 : y.NODE_ENV) !== "production";
    $e(
      () => n.items,
      (w) => {
        o && n.linkAs === "a" && w.some(($) => $.to != null) && console.warn(
          "[OPAL Breadcrumb] items with `to` need `linkAs` (e.g. RouterLink); they render as text."
        );
      },
      { immediate: !0 }
    );
    function i(w) {
      return !!(w.hideLabel && w.icon);
    }
    const s = R([]), d = R(null), u = R(!1);
    function f(w) {
      if (d.value === w)
        return !u.value;
    }
    function b(w, $) {
      let S;
      try {
        S = $.target.matches(":focus-visible");
      } catch {
        S = !0;
      }
      d.value = S ? w : null;
    }
    function h() {
      d.value = null, u.value = !1;
    }
    function p(w, $) {
      var S;
      $.key !== "Escape" || u.value || d.value !== w || !((S = s.value[w]) != null && S.isTruncated) || ($.stopPropagation(), $.preventDefault(), u.value = !0);
    }
    const x = R(null);
    return $e(
      () => n.items,
      () => {
        var w;
        (w = x.value) != null && w.contains(document.activeElement) || h();
      },
      { deep: 1, flush: "post" }
    ), (w, $) => (c(), g("nav", {
      ref_key: "navEl",
      ref: x,
      "aria-label": e.ariaLabel,
      "data-testid": "breadcrumb",
      class: C(t.value)
    }, [
      v("ol", AP, [
        (c(!0), g(ce, null, Re(e.items, (S, L) => (c(), g("li", {
          key: L,
          "data-testid": "breadcrumb-item",
          class: "flex min-w-0 max-w-full items-center gap-1.5"
        }, [
          r(S, L) ? (c(), H(lt(l(S) ? e.linkAs : "a"), Oe({
            key: 0,
            ref_for: !0
          }, l(S) ? { to: S.to } : { href: S.href }, {
            "data-testid": "breadcrumb-link",
            class: [pb, MP],
            onFocus: (T) => b(L, T),
            onBlur: h,
            onKeydown: (T) => p(L, T)
          }), {
            default: xe(() => [
              S.icon ? (c(), g("i", {
                key: 0,
                class: C([S.icon, vb]),
                "aria-hidden": "true"
              }, null, 2)) : k("", !0),
              i(S) ? (c(), g("span", EP, N(S.label), 1)) : (c(), H(ht, {
                key: 2,
                ref_for: !0,
                ref: (T) => s.value[L] = T,
                text: S.label,
                focusable: !1,
                open: f(L)
              }, null, 8, ["text", "open"]))
            ]),
            _: 2
          }, 1040, ["class", "onFocus", "onKeydown"])) : (c(), g("span", {
            key: 1,
            "data-testid": "breadcrumb-text",
            "aria-current": a(L) && i(S) ? "page" : void 0,
            class: C([
              pb,
              a(L) ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-heading) dark:text-(--text-text-white-default)"
            ])
          }, [
            S.icon ? (c(), g("i", {
              key: 0,
              class: C([S.icon, vb]),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0),
            i(S) ? (c(), g("span", BP, N(S.label), 1)) : (c(), H(ht, {
              key: 2,
              text: S.label,
              "aria-current": a(L) ? "page" : void 0
            }, null, 8, ["text", "aria-current"]))
          ], 10, RP)),
          L < e.items.length - 1 ? (c(), g("i", DP)) : k("", !0)
        ]))), 128))
      ])
    ], 10, LP));
  }
}), OP = ["id", "aria-modal", "aria-label", "aria-labelledby", "aria-describedby"], PP = {
  key: 0,
  class: "flex-1 min-w-0"
}, FP = ["src", "alt"], VP = { class: "min-w-0 break-words [overflow-wrap:anywhere]" }, NP = {
  key: 2,
  "data-testid": "drawer-heading-badges",
  class: "flex flex-wrap items-start gap-1.5"
}, HP = {
  key: 3,
  "data-testid": "drawer-heading-actions",
  class: "flex shrink-0 items-center gap-2"
}, jP = {
  key: 1,
  "data-testid": "drawer-subheader",
  class: "shrink-0 px-5 pt-5 pb-3"
}, WP = {
  "data-testid": "drawer-content",
  class: "flex-1 overflow-y-auto px-5 py-5"
}, qP = ["data-layout"];
let UP = 0;
const GP = () => `drawer-${++UP}`, KP = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Drawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: { default: void 0 },
    position: { default: "right" },
    subtitle: { default: void 0 },
    headingLevel: { default: 2 },
    back: { default: void 0 },
    icon: { default: void 0 },
    logo: { default: void 0 },
    avatar: { default: void 0 },
    avatars: { default: void 0 },
    badges: { default: void 0 },
    headerActions: { default: void 0 },
    breadcrumb: { default: void 0 },
    size: { default: "md" },
    actions: { default: void 0 },
    actionsLayout: { default: void 0 },
    showCloseButton: { type: Boolean, default: !0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    backdropClass: { default: void 0 },
    panelClass: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaCloseLabel: { default: "Close drawer" },
    variant: { default: "default" },
    beforeClose: { type: Function, default: void 0 }
  },
  emits: ["update:modelValue", "close", "back", "header-action", "action"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = Mn(), r = (ee) => {
      const O = l[ee];
      return !!O && Qu(O({ titleId: w, subtitleId: $ }));
    }, o = () => r("header"), i = () => {
      var ee;
      return a.showCloseButton || !!a.title || !!a.subtitle || !!a.back || !!a.breadcrumb || !!((ee = a.headerActions) != null && ee.length) || !!U.value || z.value || o();
    }, s = m(() => {
      var O;
      if (a.actionsLayout) return a.actionsLayout;
      const ee = ((O = a.actions) == null ? void 0 : O.length) ?? 0;
      return ee === 1 ? "one" : ee === 2 ? "two" : ee === 3 ? "three" : "stacked";
    }), d = {
      one: "items-center justify-end gap-4",
      two: "items-center justify-end gap-4",
      three: "items-center justify-between gap-3",
      stacked: "flex-col gap-4"
    }, u = m(() => {
      const ee = a.actions ?? [];
      return s.value === "three" ? [ee.slice(0, 1), ee.slice(1)] : [ee];
    }), f = (ee) => s.value === "three" && ee === 1 ? "flex items-center gap-4" : "contents", b = m(() => s.value === "one" || s.value === "stacked"), h = (ee) => {
      var O;
      (O = ee.onClick) == null || O.call(ee), x("action", ee.id);
    }, p = (ee) => [
      "flex shrink-0 pt-[calc(--spacing(5)-1px)] pb-5 border-t border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
      ee,
      a.variant === "column" ? "px-5" : "mx-5"
    ], x = t, y = GP(), w = `${y}-title`, $ = `${y}-subtitle`, S = Symbol("opal-drawer"), L = () => {
      x("update:modelValue", !1), x("close");
    };
    let T = !1, E = 0;
    $e(
      () => a.modelValue,
      (ee) => {
        ee && E++;
      }
    );
    const A = async () => {
      if (T) return;
      if (!a.beforeClose) {
        L();
        return;
      }
      T = !0;
      const ee = E;
      try {
        await a.beforeClose() !== !1 && a.modelValue && ee === E && L();
      } catch {
      } finally {
        T = !1;
      }
    }, D = () => {
      a.dismissable && A();
    }, M = (ee) => {
      ee.key !== "Escape" || !a.closeOnEscape || !a.modelValue || ha(S) && (ee.defaultPrevented || (ee.preventDefault(), A()));
    }, { zIndex: F, isTop: X } = Tv(wn(a, "modelValue"));
    $e(
      () => a.modelValue,
      (ee) => {
        ee ? Qn(S) : Rn(S);
      }
    ), dt(() => {
      document.addEventListener("keydown", M), a.modelValue && Qn(S);
    }), gt(() => {
      document.removeEventListener("keydown", M), Rn(S);
    });
    const _ = {
      md: "w-80",
      lg: "w-96",
      xl: "w-[min(80%,1280px)]"
    }, Y = m(() => a.variant === "column" ? "w-[512px]" : _[a.size]), B = m(() => `h${a.headingLevel}`), W = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]", U = m(() => {
      if (a.icon) return "icon";
      if (a.logo) return "logo";
      if (a.avatar) return "avatar";
      if (a.avatars) return "avatars";
    }), z = m(() => {
      var ee;
      return !!((ee = a.badges) != null && ee.length);
    }), P = m(() => {
      var ee;
      return !!((ee = a.headerActions) != null && ee.length);
    }), K = () => !!a.breadcrumb && !o(), j = () => o() || !U.value && !z.value && !P.value && !a.breadcrumb, G = () => !o() && !K() && U.value === "avatars", q = () => j() ? "pb-[calc(--spacing(4)-1px)]" : "pb-[calc(--spacing(5)-1px)]", J = () => {
      if (!j())
        return G() ? "flex-wrap gap-x-6 gap-y-2" : "gap-6";
    }, me = () => K() ? "items-center" : "items-start", ye = m(() => {
      if (U.value)
        return U.value === "icon" ? "items-start gap-2.5" : "items-center gap-2.5";
    }), Z = () => !!a.title && !K(), de = m(() => a.position === "left" ? "left-0" : "right-0"), ge = m(
      () => a.variant === "column" ? a.position === "left" ? "border-r" : "border-l" : void 0
    ), se = m(() => `drawer-slide-${a.position}`), Se = () => a.subtitle && i() && !K() ? $ : void 0, V = () => a.ariaLabelledby ?? (a.ariaLabel || !Z() ? void 0 : w);
    n({ focusTitle: () => {
      var ee;
      (ee = document.getElementById(w)) == null || ee.focus();
    } });
    const le = R(null);
    return Ji({
      active: wn(a, "modelValue"),
      container: le
    }), (ee, O) => (c(), H(Dn, { to: "body" }, [
      re(wt, { name: "drawer-fade" }, {
        default: xe(() => [
          e.modelValue && e.showBackdrop ? (c(), g("div", {
            key: 0,
            "data-testid": "drawer-backdrop",
            "aria-hidden": "true",
            class: C(["fixed inset-0 bg-(--colors-background-overlay) dark:bg-(--colors-background-overlay-dark)", e.backdropClass]),
            style: Ne({ zIndex: I(F) }),
            onClick: D
          }, null, 6)) : k("", !0)
        ]),
        _: 1
      }),
      re(wt, { name: se.value }, {
        default: xe(() => {
          var ne;
          return [
            e.modelValue ? (c(), g("div", Oe({
              key: 0,
              id: I(y),
              ref_key: "panelRef",
              ref: le
            }, ee.$attrs, {
              "data-testid": "drawer-panel",
              role: "dialog",
              "aria-modal": I(X) ? "true" : void 0,
              "aria-label": e.ariaLabel,
              "aria-labelledby": V(),
              "aria-describedby": Se(),
              class: [
                "fixed inset-y-0 flex flex-col",
                "bg-(--background-background-white) dark:bg-(--colors-background-black-default)",
                "border-(--colors-border-base-soft) dark:border-(--colors-border-base)",
                e.variant === "column" ? "shadow-(--shadow-drawer-column)" : "shadow-(--shadow-drawer)",
                Y.value,
                de.value,
                ge.value,
                e.panelClass
              ],
              style: { zIndex: I(F) + 1 }
            }), [
              i() ? (c(), g("div", {
                key: 0,
                "data-testid": "drawer-header",
                class: C([
                  "flex shrink-0 justify-between mx-5 mt-5 border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
                  me(),
                  J(),
                  q()
                ])
              }, [
                o() ? (c(), g("div", PP, [
                  Ae(ee.$slots, "header", {
                    titleId: w,
                    subtitleId: $
                  }, void 0, !0)
                ])) : e.breadcrumb ? (c(), H(zP, Zt(Oe({ key: 1 }, e.breadcrumb)), null, 16)) : (c(), g("div", {
                  key: 2,
                  "data-testid": "drawer-heading-lead",
                  class: C(["flex flex-1 min-w-0", ye.value])
                }, [
                  U.value === "icon" ? (c(), H(Vt, {
                    key: 0,
                    "data-testid": "drawer-heading-icon",
                    icon: e.icon,
                    size: "lg",
                    type: "square",
                    variant: "outlined",
                    color: "white",
                    class: "shrink-0"
                  }, null, 8, ["icon"])) : U.value === "logo" && e.logo ? (c(), g("img", {
                    key: 1,
                    "data-testid": "drawer-heading-logo",
                    src: e.logo.src,
                    alt: e.logo.alt,
                    class: "size-12 shrink-0 object-contain"
                  }, null, 8, FP)) : U.value === "avatar" && e.avatar ? (c(), H(Mt, {
                    key: 2,
                    "data-testid": "drawer-heading-avatar",
                    name: e.avatar.name,
                    img: e.avatar.img,
                    entity: e.avatar.entity,
                    size: "lg",
                    "avatar-style": "circle",
                    presentational: "",
                    class: "shrink-0"
                  }, null, 8, ["name", "img", "entity"])) : U.value === "avatars" && e.avatars ? (c(), H(Dv, {
                    key: 3,
                    "data-testid": "drawer-heading-avatars",
                    avatars: e.avatars.avatars,
                    max: e.avatars.max,
                    "aria-label": e.avatars.ariaLabel,
                    size: "lg",
                    class: "shrink-0"
                  }, null, 8, ["avatars", "max", "aria-label"])) : k("", !0),
                  v("div", {
                    class: C(["flex flex-1 min-w-0 flex-col", z.value ? "gap-0.5" : void 0])
                  }, [
                    e.back ? (c(), g("button", {
                      key: 0,
                      type: "button",
                      "data-testid": "drawer-heading-back",
                      class: "inline-flex w-fit max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
                      onClick: O[0] || (O[0] = (fe) => x("back"))
                    }, [
                      O[1] || (O[1] = v("i", {
                        class: "ri-arrow-left-line inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                        "aria-hidden": "true"
                      }, null, -1)),
                      v("span", VP, N(e.back.label), 1)
                    ])) : k("", !0),
                    e.title ? (c(), H(lt(B.value), {
                      key: 1,
                      id: w,
                      "data-testid": "drawer-title",
                      tabindex: "-1",
                      class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere] focus:outline-hidden"
                    }, {
                      default: xe(() => [
                        et(N(e.title), 1)
                      ]),
                      _: 1
                    })) : k("", !0),
                    z.value ? (c(), g("div", NP, [
                      (c(!0), g(ce, null, Re(e.badges, (fe, ue) => (c(), H(ct, Oe({ key: ue }, { ref_for: !0 }, fe, { size: "sm" }), null, 16))), 128))
                    ])) : k("", !0),
                    e.subtitle && !G() ? (c(), g("p", {
                      key: 3,
                      id: $,
                      "data-testid": "drawer-subtitle",
                      class: C(W)
                    }, N(e.subtitle), 1)) : k("", !0)
                  ], 2)
                ], 2)),
                P.value || e.showCloseButton ? (c(), g("div", HP, [
                  (c(!0), g(ce, null, Re(e.headerActions, (fe) => (c(), H(Be, {
                    key: fe.id,
                    "data-testid": "drawer-header-action",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": fe.icon,
                    "aria-label": fe.label,
                    onClick: (ue) => x("header-action", fe.id)
                  }, null, 8, ["icon-left", "aria-label", "onClick"]))), 128)),
                  e.showCloseButton ? (c(), H(Be, {
                    key: 0,
                    "data-testid": "drawer-close-button",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.ariaCloseLabel,
                    onClick: A
                  }, null, 8, ["aria-label"])) : k("", !0)
                ])) : k("", !0),
                e.subtitle && G() ? (c(), g("p", {
                  key: 4,
                  id: $,
                  "data-testid": "drawer-subtitle",
                  class: C(["basis-full", W])
                }, N(e.subtitle), 3)) : k("", !0)
              ], 2)) : k("", !0),
              r("subheader") ? (c(), g("div", jP, [
                Ae(ee.$slots, "subheader", {}, void 0, !0)
              ])) : k("", !0),
              v("div", WP, [
                Ae(ee.$slots, "default", {}, void 0, !0)
              ]),
              (ne = e.actions) != null && ne.length ? (c(), g("div", {
                key: 2,
                "data-testid": "drawer-footer",
                "data-layout": s.value,
                class: C(p(d[s.value]))
              }, [
                (c(!0), g(ce, null, Re(u.value, (fe, ue) => (c(), g("div", {
                  key: ue,
                  class: C(f(ue))
                }, [
                  (c(!0), g(ce, null, Re(fe, (te) => (c(), H(Be, {
                    key: te.id,
                    "data-testid": te.testId ?? `drawer-action-${te.id}`,
                    variant: te.variant,
                    size: s.value === "one" ? "md" : "sm",
                    "full-width": b.value,
                    label: te.label,
                    "icon-left": te.icon,
                    disabled: te.disabled,
                    "aria-disabled": te.ariaDisabled,
                    loading: te.loading,
                    "loading-label": te.loadingLabel,
                    type: te.type,
                    form: te.form,
                    onClick: (oe) => h(te)
                  }, null, 8, ["data-testid", "variant", "size", "full-width", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label", "type", "form", "onClick"]))), 128))
                ], 2))), 128))
              ], 10, qP)) : r("footer") ? (c(), g("div", {
                key: 3,
                "data-testid": "drawer-footer",
                class: C(p("items-center justify-end gap-4"))
              }, [
                Ae(ee.$slots, "footer", {}, void 0, !0)
              ], 2)) : k("", !0)
            ], 16, OP)) : k("", !0)
          ];
        }),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), YP = /* @__PURE__ */ ot(KP, [["__scopeId", "data-v-b34a8a79"]]), JP = {
  class: "inline-flex min-w-0 max-w-full items-stretch rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs)",
  "data-testid": "split-button"
}, XP = "rounded-r-none! hover:z-10 focus-visible:z-10", ZP = "flex! rounded-l-none! hover:z-10 focus-visible:z-10", QP = /* @__PURE__ */ ke({
  __name: "SplitButton",
  props: {
    label: {},
    menu: {},
    menuLabel: {},
    variant: { default: "secondary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    menuAlign: { default: "right" }
  },
  emits: ["click", "select"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(
      () => t.menu.map((r) => ({
        ...r,
        onClick: () => {
          var o;
          (o = r.onClick) == null || o.call(r), a("select", r);
        }
      }))
    );
    return (r, o) => (c(), g("div", JP, [
      re(Be, {
        variant: e.variant,
        size: e.size,
        label: e.label,
        "icon-left": e.icon,
        disabled: e.disabled,
        "aria-disabled": e.ariaDisabled,
        shrink: "",
        loading: e.loading,
        "loading-label": e.loadingLabel,
        class: C(XP),
        "data-testid": "split-button-label",
        onClick: o[0] || (o[0] = (i) => a("click", i))
      }, null, 8, ["variant", "size", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label"]),
      re(ln, {
        items: l.value,
        "menu-align": e.menuAlign,
        class: "-ml-px shrink-0"
      }, {
        trigger: xe(({ triggerProps: i }) => [
          re(Be, Oe({
            "icon-only": "",
            "icon-left": "ri-arrow-down-s-line",
            variant: e.variant,
            size: e.size,
            "aria-label": e.menuLabel,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled,
            class: ZP,
            "data-testid": "split-button-chevron"
          }, i), null, 16, ["variant", "size", "aria-label", "disabled", "aria-disabled"])
        ]),
        _: 1
      }, 8, ["items", "menu-align"])
    ]));
  }
}), Mr = 3, _P = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  "data-testid": "faceted-reorder-live"
}, e8 = { class: "flex flex-col gap-3 px-5 py-4" }, t8 = { class: "shadow-(--blur-shadow-xs)" }, n8 = { class: "flex-1 overflow-y-auto px-5 pb-1" }, a8 = { key: "visible" }, l8 = ["aria-labelledby"], r8 = ["id"], o8 = { class: "flex flex-col gap-4" }, i8 = { class: "shrink-0 w-4.5" }, s8 = ["for"], d8 = { class: "flex items-center gap-3 shrink-0" }, u8 = ["aria-labelledby", "aria-label"], c8 = ["id"], f8 = { class: "flex flex-col gap-4" }, h8 = { class: "shrink-0 w-4.5" }, b8 = ["for"], g8 = { class: "flex items-center gap-3 shrink-0" }, m8 = ["disabled", "aria-label", "aria-pressed", "onClick"], p8 = {
  key: 1,
  class: "flex items-center justify-center py-8 text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body-subtle) font-inter"
}, v8 = { key: "order" }, x8 = {
  key: 0,
  class: "flex items-center gap-1.5 text-(length:--size-sm) leading-(--line-height-l) text-(--colors-text-body-subtle) mb-2 font-inter"
}, y8 = ["aria-label"], k8 = ["aria-label"], w8 = ["disabled", "aria-label", "aria-pressed", "onClick"], C8 = {
  key: 1,
  class: "flex items-center justify-center py-8 text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body-subtle) font-inter"
}, S8 = /* @__PURE__ */ ke({
  __name: "FacetedSearchDrawer",
  props: {
    modelValue: { type: Boolean },
    columns: {},
    defaultColumns: { default: () => [] },
    columnOrder: { default: () => [] },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "save", "reset"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = {
      fige: "Pinned",
      "actif-indigo": "Active",
      "actif-orange": "Active",
      fixe: "Fixed"
    }, o = m(() => ({
      title: t.labels.title ?? "Customize columns",
      subtitle: t.labels.subtitle ?? ((oe, Le) => `${oe} of ${Le} selected`),
      searchPlaceholder: t.labels.searchPlaceholder ?? "Search a column",
      searchClearLabel: t.labels.searchClearLabel ?? "Clear search",
      visibleTab: t.labels.visibleTab ?? "Visible",
      orderTab: t.labels.orderTab ?? "Order",
      defaultColumnHeader: t.labels.defaultColumnHeader ?? "Default fixed column",
      pinnedBadge: t.labels.pinnedBadge ?? "Pinned",
      resetLabel: t.labels.resetLabel ?? "Reset columns",
      cancelLabel: t.labels.cancelLabel ?? "Cancel",
      saveLabel: t.labels.saveLabel ?? "Save",
      closeAriaLabel: t.labels.closeAriaLabel ?? "Close",
      emptySearchText: t.labels.emptySearchText ?? "No columns found",
      emptyOrderText: t.labels.emptyOrderText ?? "No visible columns",
      orderSearchHint: t.labels.orderSearchHint ?? "Showing filtered results. Drag to reorder within visible columns.",
      pinTooltip: t.labels.pinTooltip ?? "Locked column",
      pinAriaLabelPinned: t.labels.pinAriaLabelPinned ?? "Unfreeze column",
      pinAriaLabelUnpinned: t.labels.pinAriaLabelUnpinned ?? "Freeze column",
      pinLimitTooltip: t.labels.pinLimitTooltip ?? `You can freeze up to ${Mr} columns. Unfreeze a column to freeze another.`,
      badgeLabels: {
        ...r,
        ...t.labels.badgeLabels ?? {}
      },
      reorderMoved: t.labels.reorderMoved ?? ((oe, Le, Ie) => `${oe} moved to position ${Le} of ${Ie}`),
      reorderPickedUp: t.labels.reorderPickedUp ?? ((oe) => `${oe} picked up. Use arrow keys to move, space to drop, escape to cancel.`),
      reorderCancelled: t.labels.reorderCancelled ?? ((oe) => `${oe} reorder cancelled`),
      orderListLabel: t.labels.orderListLabel ?? "Column order"
    })), i = R(null), s = R([]), d = R(""), u = R("visible"), f = R(null), b = R(null), h = R(null), p = R(null);
    let x = null;
    const y = je();
    function w(oe) {
      return `${y}-section-${oe.replace(/\s+/g, "-").toLowerCase() || "ungrouped"}`;
    }
    function $(oe) {
      return `${y}-column-${oe.replace(/\s+/g, "-")}`;
    }
    const S = R("");
    function L(oe, Le, Ie) {
      S.value = o.value.reorderMoved(oe, Le, Ie);
    }
    function T(oe) {
      return oe.map((Le) => ({
        ...Le,
        visible: Le.disabled || Le.alwaysVisible ? !0 : Le.visible
      }));
    }
    function E() {
      const oe = T(t.columns);
      if (t.columnOrder.length > 0) {
        const Le = new Map(t.columnOrder.map((Ie, ve) => [Ie, ve]));
        oe.sort((Ie, ve) => (Le.get(Ie.key) ?? 1 / 0) - (Le.get(ve.key) ?? 1 / 0));
      }
      s.value = ge(oe);
    }
    $e(
      () => t.modelValue,
      (oe) => {
        oe && (E(), d.value = "", u.value = "visible", p.value = null, x = null, l.value = !1);
      },
      { immediate: !0 }
    ), $e(
      () => t.modelValue ? `${t.columnOrder.join("|")}::${t.columns.map((oe) => oe.key).join("|")}` : null,
      (oe) => {
        oe !== null && p.value === null && E();
      }
    );
    const A = {
      fige: "bg-white ring-1 ring-(--colors-border-base-soft) text-(--colors-text-black-default)",
      "actif-indigo": "bg-(--colors-indigo-100) text-(--colors-text-black-default)",
      "actif-orange": "bg-(--colors-warning-100) text-(--colors-text-black-default)",
      fixe: "bg-(--colors-indigo-100) text-(--colors-text-black-default)"
    };
    function D(oe) {
      return A[oe];
    }
    function M(oe) {
      return oe.badge ? o.value.badgeLabels[oe.badge] : oe.pinned || P(oe) ? o.value.pinnedBadge : "";
    }
    const F = m(() => s.value.filter((oe) => oe.visible).length), X = m(() => s.value.length), _ = m(
      () => o.value.subtitle(F.value, X.value)
    ), Y = m(() => {
      const oe = d.value.toLowerCase().trim();
      return oe ? s.value.filter((Le) => Le.label.toLowerCase().includes(oe)) : s.value;
    }), B = m(
      () => Y.value.filter((oe) => oe.alwaysVisible || oe.disabled)
    ), W = m(
      () => Y.value.filter((oe) => !oe.alwaysVisible && !oe.disabled)
    ), U = m(() => {
      const oe = [], Le = /* @__PURE__ */ new Map(), Ie = [];
      for (const ve of W.value)
        ve.group ? (Le.has(ve.group) || Le.set(ve.group, []), Le.get(ve.group).push(ve)) : Ie.push(ve);
      for (const [ve, we] of Le)
        oe.push({ name: ve, items: we });
      return Ie.length > 0 && oe.push({ name: "", items: Ie }), oe;
    }), z = m(() => {
      const oe = d.value.toLowerCase().trim(), Le = s.value.filter((Ie) => Ie.visible);
      return oe ? Le.filter((Ie) => Ie.label.toLowerCase().includes(oe)) : Le;
    });
    function P(oe) {
      return !!(oe.disabled || oe.alwaysVisible);
    }
    const K = m(
      () => s.value.filter((oe) => oe.visible && (P(oe) || oe.pinned)).length
    ), j = m(() => K.value >= Mr);
    function G(oe) {
      return !oe.visible || P(oe) ? !1 : oe.pinned || !j.value;
    }
    function q(oe) {
      return oe.pinned ? o.value.pinAriaLabelPinned : o.value.pinAriaLabelUnpinned;
    }
    function J(oe) {
      return oe.visible && !oe.pinned && j.value ? o.value.pinLimitTooltip : q(oe);
    }
    function me(oe) {
      return !P(oe);
    }
    function ye(oe) {
      return P(oe) ? "locked" : oe.pinned ? "pinned" : "regular";
    }
    function Z(oe, Le) {
      return ye(oe) === ye(Le);
    }
    function de(oe) {
      const Le = [], Ie = [], ve = [];
      for (const we of oe)
        P(we) ? Le.push(we) : we.pinned ? Ie.push(we) : ve.push(we);
      return [...Le, ...Ie, ...ve];
    }
    function ge(oe = s.value) {
      const Le = [], Ie = [];
      for (const ve of oe)
        (ve.visible ? Le : Ie).push(ve);
      return [...de(Le), ...Ie];
    }
    function se(oe) {
      P(oe) || (oe.visible = !oe.visible, oe.visible || (oe.pinned = !1));
    }
    function Se(oe) {
      G(oe) && (oe.pinned = !oe.pinned, s.value = ge());
    }
    function V() {
      a("update:modelValue", !1);
    }
    function Q() {
      l.value && a("reset"), a(
        "save",
        s.value.map((oe) => ({ ...oe }))
      ), a("update:modelValue", !1);
    }
    const le = m(() => [
      {
        id: "reset",
        label: o.value.resetLabel,
        variant: "ghost",
        icon: "ri-restart-line",
        onClick: ee
      },
      { id: "cancel", label: o.value.cancelLabel, variant: "secondary", onClick: V },
      { id: "save", label: o.value.saveLabel, variant: "primary", onClick: Q }
    ]);
    function ee() {
      s.value = ge(T(t.defaultColumns)), l.value = !0;
    }
    function O(oe, Le) {
      f.value = oe, Le.dataTransfer && (Le.dataTransfer.effectAllowed = "move");
    }
    function ne(oe) {
      const Le = z.value[oe], Ie = f.value !== null ? z.value[f.value] : null;
      if (!Le || !me(Le)) {
        b.value = null;
        return;
      }
      if (Ie && !Z(Ie, Le)) {
        b.value = null;
        return;
      }
      b.value = oe;
    }
    function fe(oe) {
      if (f.value === null || f.value === oe) {
        f.value = null, b.value = null;
        return;
      }
      const Le = z.value[f.value], Ie = z.value[oe];
      if (!Le || !Ie || !me(Le) || !me(Ie) || !Z(Le, Ie)) {
        f.value = null, b.value = null;
        return;
      }
      const ve = Le.key, we = Ie.key, he = [...s.value], Me = he.findIndex((Ge) => Ge.key === ve), Ee = he.findIndex((Ge) => Ge.key === we), [He] = he.splice(Me, 1);
      he.splice(Ee, 0, He), f.value = null, b.value = null, requestAnimationFrame(() => {
        s.value = ge(he);
        const Ge = s.value.findIndex((ae) => ae.key === ve) + 1, Ze = s.value.filter((ae) => ae.visible).length;
        L(Le.label, Ge, Ze);
      });
    }
    function ue() {
      f.value = null, b.value = null;
    }
    function te(oe, Le) {
      const Ie = z.value[oe];
      if (!Ie) return;
      if (Le.key === "Escape" && p.value !== null) {
        Le.preventDefault(), x && (s.value = x), p.value = null, x = null, S.value = o.value.reorderCancelled(Ie.label);
        return;
      }
      if (Le.key === " " || Le.key === "Enter") {
        if (p.value === null) {
          if (!me(Ie)) return;
          Le.preventDefault(), p.value = oe, x = s.value.map((Ke) => ({ ...Ke })), S.value = o.value.reorderPickedUp(Ie.label);
          return;
        }
        Le.preventDefault();
        const Ce = z.value[p.value], Fe = z.value.length;
        L((Ce == null ? void 0 : Ce.label) ?? Ie.label, p.value + 1, Fe), p.value = null, x = null;
        return;
      }
      if (p.value === null || Le.key !== "ArrowUp" && Le.key !== "ArrowDown") return;
      const ve = p.value, we = z.value[ve];
      if (!we) return;
      let he = Le.key === "ArrowUp" ? ve - 1 : ve + 1;
      for (; he >= 0 && he < z.value.length && (!me(z.value[he]) || !Z(we, z.value[he])); )
        he += Le.key === "ArrowUp" ? -1 : 1;
      if (he < 0 || he >= z.value.length) return;
      Le.preventDefault();
      const Me = z.value[ve].key, Ee = z.value[he].key, He = [...s.value], Ge = He.findIndex((Ce) => Ce.key === Me), Ze = He.findIndex((Ce) => Ce.key === Ee), [ae] = He.splice(Ge, 1);
      He.splice(Ze, 0, ae), s.value = ge(He), p.value = he, h.value = he;
      const ie = s.value.filter((Ce) => Ce.visible).length;
      L(Ie.label, he + 1, ie), requestAnimationFrame(() => {
        var Fe, Ke;
        const Ce = (Fe = i.value) == null ? void 0 : Fe.querySelectorAll("[role='listitem']");
        (Ke = Ce == null ? void 0 : Ce[he]) == null || Ke.focus();
      });
    }
    return (oe, Le) => (c(), H(I(YP), {
      "model-value": e.modelValue,
      position: "right",
      variant: "column",
      title: o.value.title,
      subtitle: _.value,
      "aria-close-label": o.value.closeAriaLabel,
      actions: le.value,
      dismissable: !0,
      "onUpdate:modelValue": Le[2] || (Le[2] = (Ie) => a("update:modelValue", Ie))
    }, {
      default: xe(() => [
        v("div", {
          ref_key: "drawerContainerRef",
          ref: i,
          class: "flex flex-col h-full -mx-5 -mt-4 -mb-5 gap-1"
        }, [
          v("div", _P, N(S.value), 1),
          v("div", e8, [
            v("div", t8, [
              re(I(Zi), {
                modelValue: d.value,
                "onUpdate:modelValue": Le[0] || (Le[0] = (Ie) => d.value = Ie),
                placeholder: o.value.searchPlaceholder,
                labels: { clear: o.value.searchClearLabel },
                size: "sm",
                "full-width": ""
              }, null, 8, ["modelValue", "placeholder", "labels"])
            ]),
            re(I(Cg), {
              modelValue: u.value,
              "onUpdate:modelValue": Le[1] || (Le[1] = (Ie) => u.value = Ie),
              variant: "group",
              color: "dark",
              size: "sm",
              class: "w-full",
              "aria-label": o.value.title,
              "data-testid": "faceted-view-switch"
            }, {
              default: xe(() => [
                re(I(Be), {
                  value: "visible",
                  variant: "tertiary",
                  size: "sm",
                  label: o.value.visibleTab,
                  class: "flex-1"
                }, null, 8, ["label"]),
                re(I(Be), {
                  value: "order",
                  variant: "tertiary",
                  size: "sm",
                  label: o.value.orderTab,
                  class: "flex-1"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "aria-label"])
          ]),
          v("div", n8, [
            re(wt, {
              name: "faceted-tab-fade",
              mode: "out-in"
            }, {
              default: xe(() => [
                u.value === "visible" ? (c(), g("div", a8, [
                  B.value.length > 0 ? (c(), g("div", {
                    key: 0,
                    class: "mb-8",
                    role: "group",
                    "aria-labelledby": w("default-fixed")
                  }, [
                    v("div", {
                      id: w("default-fixed"),
                      class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-heading) mb-4 font-inter"
                    }, N(o.value.defaultColumnHeader), 9, r8),
                    v("div", o8, [
                      (c(!0), g(ce, null, Re(B.value, (Ie) => (c(), g("div", {
                        key: Ie.key,
                        class: "flex items-center gap-(--spacing-2-5) p-px"
                      }, [
                        v("div", i8, [
                          re(I($n), {
                            id: $(Ie.key),
                            "model-value": !0,
                            disabled: !0,
                            variant: "light"
                          }, null, 8, ["id"])
                        ]),
                        v("label", {
                          for: $(Ie.key),
                          class: "flex-1 min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) font-inter truncate cursor-not-allowed text-(--colors-text-body-subtle)"
                        }, N(Ie.label), 9, s8),
                        v("div", d8, [
                          v("span", {
                            class: C(["inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", D(Ie.badge ?? "fige")])
                          }, N(M(Ie)), 3),
                          Le[3] || (Le[3] = v("i", {
                            class: "ri-pushpin-2-fill text-(length:--icon-size-lg) leading-(--line-height-xxl) text-(--colors-text-body-subtle)",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ]))), 128))
                    ])
                  ], 8, l8)) : k("", !0),
                  (c(!0), g(ce, null, Re(U.value, (Ie) => (c(), g("div", {
                    key: Ie.name,
                    class: "mb-8 last:mb-0",
                    role: "group",
                    "aria-labelledby": Ie.name ? w(Ie.name) : void 0,
                    "aria-label": Ie.name ? void 0 : o.value.visibleTab
                  }, [
                    Ie.name ? (c(), g("div", {
                      key: 0,
                      id: w(Ie.name),
                      class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-heading) mb-4 font-inter"
                    }, N(Ie.name), 9, c8)) : k("", !0),
                    v("div", f8, [
                      (c(!0), g(ce, null, Re(Ie.items, (ve) => (c(), g("div", {
                        key: ve.key,
                        class: "flex items-center gap-(--spacing-2-5) p-px"
                      }, [
                        v("div", h8, [
                          re(I($n), {
                            id: $(ve.key),
                            "model-value": ve.visible,
                            variant: "default",
                            "onUpdate:modelValue": (we) => se(ve)
                          }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
                        ]),
                        v("label", {
                          for: $(ve.key),
                          class: "flex-1 min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) font-inter truncate text-(--colors-text-heading) cursor-pointer"
                        }, N(ve.label), 9, b8),
                        v("div", g8, [
                          ve.pinned || ve.badge ? (c(), g("span", {
                            key: 0,
                            class: C(["inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", D(ve.badge ?? "fige")])
                          }, N(M(ve)), 3)) : k("", !0),
                          re(I(ft), {
                            text: J(ve),
                            position: "top",
                            tabindex: G(ve) ? void 0 : 0
                          }, {
                            default: xe(() => [
                              v("button", {
                                type: "button",
                                class: C([
                                  "inline-flex items-center justify-center size-6 rounded-(--border-border-radius-rounded-xs) transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                                  ve.pinned ? "text-(--colors-text-black-default)" : "text-(--colors-text-body-subtle) hover:text-(--colors-text-black-default)"
                                ]),
                                disabled: !G(ve),
                                "aria-label": q(ve),
                                "aria-pressed": ve.pinned,
                                onClick: Ye((we) => Se(ve), ["stop"])
                              }, [
                                v("i", {
                                  class: C([ve.pinned ? "ri-pushpin-2-fill" : "ri-pushpin-2-line", "text-(length:--icon-size-lg) leading-(--line-height-xxl)"])
                                }, null, 2)
                              ], 10, m8)
                            ]),
                            _: 2
                          }, 1032, ["text", "tabindex"])
                        ])
                      ]))), 128))
                    ])
                  ], 8, u8))), 128)),
                  Y.value.length === 0 ? (c(), g("div", p8, N(o.value.emptySearchText), 1)) : k("", !0)
                ])) : u.value === "order" ? (c(), g("div", v8, [
                  d.value.trim() && z.value.length > 0 ? (c(), g("div", x8, [
                    Le[4] || (Le[4] = v("i", { class: "ri-information-line text-(length:--icon-size-xs) shrink-0" }, null, -1)),
                    v("span", null, N(o.value.orderSearchHint), 1)
                  ])) : k("", !0),
                  v("div", {
                    class: "flex flex-col gap-3",
                    role: "list",
                    "aria-label": o.value.orderListLabel
                  }, [
                    (c(!0), g(ce, null, Re(z.value, (Ie, ve) => (c(), H(MD, {
                      key: Ie.key,
                      label: Ie.label,
                      disabled: Ie.disabled || Ie.alwaysVisible,
                      reorderable: me(Ie),
                      class: C([
                        "transition-all duration-150 ease-out rounded-(--border-border-radius-rounded-l) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                        b.value === ve && f.value !== ve ? "ring-2 ring-(--border-border-hover) rounded-(--border-border-radius-rounded-l)" : "",
                        f.value === ve ? "opacity-40" : "",
                        p.value === ve ? "ring-2 ring-(--border-border-accent) rounded-(--border-border-radius-rounded-l)" : ""
                      ]),
                      role: "listitem",
                      "aria-roledescription": me(Ie) ? "sortable" : void 0,
                      "data-picked-up": p.value === ve ? "true" : void 0,
                      tabindex: "0",
                      onDragstart: (we) => O(ve, we),
                      onDragover: Ye((we) => ne(ve), ["prevent"]),
                      onDragend: ue,
                      onDrop: Ye((we) => fe(ve), ["prevent"]),
                      onKeydown: (we) => te(ve, we)
                    }, {
                      badge: xe(() => [
                        Ie.pinned || Ie.badge ? (c(), g("span", {
                          key: 0,
                          class: C(["shrink-0 inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", D(Ie.badge ?? "fige")])
                        }, N(M(Ie)), 3)) : k("", !0)
                      ]),
                      actions: xe(() => [
                        Ie.disabled || Ie.alwaysVisible ? (c(), H(I(ft), {
                          key: 0,
                          text: o.value.pinTooltip,
                          position: "top"
                        }, {
                          default: xe(() => [
                            v("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center",
                              disabled: "",
                              "aria-label": o.value.pinTooltip
                            }, [...Le[5] || (Le[5] = [
                              v("i", { class: "ri-pushpin-2-fill text-(length:--icon-size-lg) leading-(--line-height-xxl) text-(--colors-text-body-subtle)" }, null, -1)
                            ])], 8, k8)
                          ]),
                          _: 1
                        }, 8, ["text"])) : (c(), H(I(ft), {
                          key: 1,
                          text: J(Ie),
                          position: "top",
                          tabindex: G(Ie) ? void 0 : 0
                        }, {
                          default: xe(() => [
                            v("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center rounded-(--border-border-radius-rounded-xs) transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                              disabled: !G(Ie),
                              "aria-label": q(Ie),
                              "aria-pressed": Ie.pinned,
                              onClick: Ye((we) => Se(Ie), ["stop"])
                            }, [
                              v("i", {
                                class: C([
                                  Ie.pinned ? "ri-pushpin-2-fill text-(--colors-text-black-default)" : "ri-pushpin-2-line text-(--colors-text-body-subtle)",
                                  "text-(length:--icon-size-lg) leading-(--line-height-xxl)"
                                ])
                              }, null, 2)
                            ], 8, w8)
                          ]),
                          _: 2
                        }, 1032, ["text", "tabindex"]))
                      ]),
                      _: 2
                    }, 1032, ["label", "disabled", "reorderable", "class", "aria-roledescription", "data-picked-up", "onDragstart", "onDragover", "onDrop", "onKeydown"]))), 128))
                  ], 8, y8),
                  z.value.length === 0 ? (c(), g("div", C8, N(o.value.emptyOrderText), 1)) : k("", !0)
                ])) : k("", !0)
              ]),
              _: 1
            })
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["model-value", "title", "subtitle", "aria-close-label", "actions"]));
  }
}), $8 = /* @__PURE__ */ ot(S8, [["__scopeId", "data-v-bacb0a0c"]]);
function Rq(e = {}) {
  const { defaultOpen: n = !1, onClose: t } = e, a = R(n);
  return { isOpen: a, open: () => {
    a.value = !0;
  }, close: () => {
    a.value = !1, t == null || t();
  }, toggle: () => {
    a.value = !a.value;
  } };
}
function ex(e, n, t) {
  function a() {
    var s;
    const o = (s = e.value) == null ? void 0 : s.querySelector("[data-table-search]"), i = o != null && o.matches(ba) ? o : o == null ? void 0 : o.querySelector(ba);
    return i == null || i.focus(), !!i && document.activeElement === i;
  }
  function l() {
    if (a()) return;
    const o = e.value;
    o && (o.tabIndex = -1, o.setAttribute("role", "group"), o.setAttribute("aria-label", t()), o.addEventListener(
      "blur",
      () => {
        o.removeAttribute("tabindex"), o.removeAttribute("role"), o.removeAttribute("aria-label");
      },
      { once: !0 }
    ), o.focus());
  }
  function r() {
    var o;
    (o = n.value) != null && o.focusFilterTrigger() || l();
  }
  return { focusSearchOrRoot: l, focusAfterFiltersCleared: r };
}
const I8 = ["aria-busy"], T8 = {
  key: 0,
  class: "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
}, L8 = ["id", "role", "aria-labelledby", "aria-busy"], A8 = {
  key: 1,
  class: "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) px-5 py-3 bg-white dark:bg-(--colors-background-black-default) rounded-b-xl"
}, E8 = {
  key: 0,
  "data-testid": "table-skeleton-footer",
  "aria-hidden": "true",
  class: "flex items-center justify-between h-7"
}, R8 = { class: "flex items-center gap-2.5" }, Bq = /* @__PURE__ */ ke({
  __name: "TableShell",
  props: {
    query: {},
    views: { default: void 0 },
    permissions: { default: () => ({}) },
    labels: { default: void 0 },
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: ms },
    markSearchStale: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] },
    columnSettings: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    skeletonColumns: { default: void 0 },
    skeletonRows: { default: void 0 },
    bordered: { type: Boolean, default: !1 }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "toggle-filter-bar", "edit-filter", "tab-requested", "tab-reordered"],
  setup(e, { expose: n, emit: t }) {
    const a = Yt(), l = e, r = t;
    nn(er, l.query), l.views && nn(gs, l.views), l.columnSettings && nn(TO, l.columnSettings);
    const o = m(() => l.permissions ?? {});
    nn(Gv, o.value);
    const i = m(() => ({ ...Xv, ...l.labels }));
    nn(Kv, i);
    const s = je(), d = m(() => {
      var D;
      const E = l.query.state.activeViewId;
      return l.showTopbar && !!E && !!((D = l.views) != null && D.presetViews.value.some((M) => M.id === E)) ? Jv(s, E) : null;
    });
    nn(Yv, { id: s, isTabpanel: m(() => d.value !== null) });
    const u = R(!1), f = R(!0), b = Yn("controls"), h = Yn("shellRoot"), { focusSearchOrRoot: p, focusAfterFiltersCleared: x } = ex(
      h,
      b,
      () => i.value.tableLabel
    );
    function y() {
      u.value = !u.value, r("toggle-filter-panel");
    }
    function w() {
      f.value = !f.value, r("toggle-filter-bar", f.value);
    }
    n({ toggleFilterPanel: y });
    const $ = m(
      () => l.skeletonColumns ?? (l.columnSettings && l.columnSettings.settingsItems.value.filter((E) => E.visible).length || void 0) ?? 5
    ), S = m(() => l.skeletonRows ?? l.query.state.pageSize), L = m(
      () => l.markSearchStale && l.query.searchPending.value && !l.loading
    ), T = m(
      () => {
        var E, A;
        return l.showControls && (l.showFilter || ((E = l.permissions) == null ? void 0 : E.canSaveView) !== !1 || ((A = l.permissions) == null ? void 0 : A.canShareView) !== !1 || a("controls-info") || a("controls-actions") || a("filter"));
      }
    );
    return (E, A) => (c(), g(ce, null, [
      v("div", {
        ref_key: "shellRoot",
        ref: h,
        "data-table-shell-root": "",
        class: "w-full flex flex-col flex-1 min-h-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue",
        "aria-busy": e.loading || void 0
      }, [
        e.showTopbar ? (c(), H(Zv, {
          key: 0,
          "search-placeholder": e.searchPlaceholder,
          "show-search": e.showSearch,
          "search-debounce": e.searchDebounce,
          "show-view-selector": e.showViewSelector,
          "tab-dropdowns": e.tabDropdowns,
          onRenameView: A[0] || (A[0] = (D) => r("rename-view", D)),
          onDeleteView: A[1] || (A[1] = (D) => r("delete-view", D)),
          onSetDefault: A[2] || (A[2] = (D) => r("set-default", D)),
          onTabRequested: A[3] || (A[3] = (D, M) => r("tab-requested", D, M)),
          onTabReordered: A[4] || (A[4] = (D, M) => r("tab-reordered", D, M))
        }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns"])) : k("", !0),
        v("div", {
          class: C([
            "flex flex-col flex-1 min-h-0 bg-white dark:bg-(--colors-background-black-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] overflow-hidden",
            e.showTopbar ? T.value ? "rounded-b-xl rounded-tr-xl" : "rounded-b-xl" : "rounded-xl",
            // -mt-px pulls this card up 1px over the tabs row above so its own top border sits
            // underneath the tabs' bottom edge instead of showing as a seam; pt-px compensates
            // so the card's own content doesn't shift up with it.
            e.bordered && "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) -mt-px pt-px"
          ])
        }, [
          T.value ? (c(), H(Qv, {
            key: 0,
            ref_key: "controls",
            ref: b,
            "is-filter-panel-open": u.value,
            "is-filter-bar-visible": f.value,
            "show-filter": e.showFilter,
            bordered: !e.bordered,
            onFocusFallback: I(p),
            onToggleFilterPanel: y,
            onToggleFilterBar: w,
            onSaveView: A[5] || (A[5] = (D) => r("save-view")),
            onShareView: A[6] || (A[6] = (D) => r("share-view"))
          }, ta({ _: 2 }, [
            E.$slots.filter ? {
              name: "filter",
              fn: xe(() => [
                Ae(E.$slots, "filter")
              ]),
              key: "0"
            } : void 0,
            E.$slots["controls-info"] ? {
              name: "controls-info",
              fn: xe(() => [
                Ae(E.$slots, "controls-info")
              ]),
              key: "1"
            } : void 0,
            E.$slots["controls-actions"] ? {
              name: "controls-actions",
              fn: xe(() => [
                Ae(E.$slots, "controls-actions")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "bordered", "onFocusFallback"])) : k("", !0),
          re(wt, {
            "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0 opacity-0",
            "enter-to-class": "max-h-[600px] opacity-100",
            "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[600px] opacity-100",
            "leave-to-class": "max-h-0 opacity-0"
          }, {
            default: xe(() => [
              u.value ? (c(), g("div", T8, [
                Ae(E.$slots, "filter-panel", {
                  close: () => u.value = !1
                })
              ])) : k("", !0)
            ]),
            _: 3
          }),
          re(wt, {
            "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0",
            "enter-to-class": "max-h-[100px]",
            "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[100px]",
            "leave-to-class": "max-h-0"
          }, {
            default: xe(() => [
              f.value ? (c(), H(_v, {
                key: 0,
                bordered: !e.bordered,
                onEditFilter: A[7] || (A[7] = (D) => r("edit-filter", D)),
                onLastFilterRemoved: I(x)
              }, null, 8, ["bordered", "onLastFilterRemoved"])) : k("", !0)
            ]),
            _: 1
          }),
          v("div", {
            id: I(s),
            role: d.value ? "tabpanel" : void 0,
            "aria-labelledby": d.value ?? void 0,
            class: C(["flex-1 overflow-x-hidden min-h-0 transition-opacity", L.value && "opacity-50"]),
            "aria-busy": L.value || void 0,
            "data-testid": "table-shell-body"
          }, [
            e.loading ? (c(), H(aP, {
              key: 0,
              columns: $.value,
              rows: S.value
            }, null, 8, ["columns", "rows"])) : Ae(E.$slots, "table", { key: 1 })
          ], 10, L8),
          e.loading || I(a)("pagination") ? (c(), g("div", A8, [
            e.loading ? (c(), g("div", E8, [
              A[9] || (A[9] = v("div", { class: "flex items-center gap-3" }, [
                v("div", { class: "skeleton h-1.5 w-36 rounded-full" }),
                v("div", { class: "skeleton h-1.5 w-11 rounded-full" })
              ], -1)),
              v("div", R8, [
                (c(), g(ce, null, Re(5, (D) => v("div", {
                  key: `skeleton-page-${D}`,
                  class: "skeleton size-7 rounded-md"
                })), 64))
              ])
            ])) : Ae(E.$slots, "pagination", { key: 1 })
          ])) : k("", !0)
        ], 2)
      ], 8, I8),
      e.columnSettings ? (c(), H(I($8), {
        key: 0,
        modelValue: e.columnSettings.drawerOpen.value,
        "onUpdate:modelValue": A[8] || (A[8] = (D) => e.columnSettings.drawerOpen.value = D),
        columns: e.columnSettings.settingsItems.value,
        "default-columns": e.columnSettings.defaultSettingsItems.value,
        "column-order": e.columnSettings.order.value,
        labels: e.columnSettings.labels.value,
        onSave: e.columnSettings.handleSave,
        onReset: e.columnSettings.handleReset
      }, null, 8, ["modelValue", "columns", "default-columns", "column-order", "labels", "onSave", "onReset"])) : k("", !0)
    ], 64));
  }
}), B8 = {
  key: 0,
  class: "border-b border-gainsboro dark:border-(--colors-border-base)"
}, Dq = /* @__PURE__ */ ke({
  __name: "TableHeader",
  props: {
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: ms },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "edit-filter", "tab-requested"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = R(!1), r = R(!0), o = Yn("controls"), i = Yn("headerRoot"), s = tr(), { focusSearchOrRoot: d, focusAfterFiltersCleared: u } = ex(
      i,
      o,
      () => s.value.tableLabel
    );
    function f() {
      l.value = !l.value, a("toggle-filter-panel");
    }
    function b() {
      r.value = !r.value;
    }
    return n({ toggleFilterPanel: f }), (h, p) => (c(), g("div", {
      ref_key: "headerRoot",
      ref: i,
      class: "flex flex-col focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue"
    }, [
      e.showTopbar ? (c(), H(Zv, {
        key: 0,
        "search-placeholder": e.searchPlaceholder,
        "show-search": e.showSearch,
        "search-debounce": e.searchDebounce,
        "show-view-selector": e.showViewSelector,
        "tab-dropdowns": e.tabDropdowns,
        onRenameView: p[0] || (p[0] = (x) => a("rename-view", x)),
        onDeleteView: p[1] || (p[1] = (x) => a("delete-view", x)),
        onSetDefault: p[2] || (p[2] = (x) => a("set-default", x)),
        onTabRequested: p[3] || (p[3] = (x, y) => a("tab-requested", x, y))
      }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns"])) : k("", !0),
      e.showControls ? (c(), H(Qv, {
        key: 1,
        ref_key: "controls",
        ref: o,
        "is-filter-panel-open": l.value,
        "is-filter-bar-visible": r.value,
        "show-filter": e.showFilter,
        onFocusFallback: I(d),
        onToggleFilterPanel: f,
        onToggleFilterBar: b,
        onSaveView: p[4] || (p[4] = (x) => a("save-view")),
        onShareView: p[5] || (p[5] = (x) => a("share-view"))
      }, ta({ _: 2 }, [
        h.$slots.filter ? {
          name: "filter",
          fn: xe(() => [
            Ae(h.$slots, "filter")
          ]),
          key: "0"
        } : void 0,
        h.$slots["controls-info"] ? {
          name: "controls-info",
          fn: xe(() => [
            Ae(h.$slots, "controls-info")
          ]),
          key: "1"
        } : void 0,
        h.$slots["controls-actions"] ? {
          name: "controls-actions",
          fn: xe(() => [
            Ae(h.$slots, "controls-actions")
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "onFocusFallback"])) : k("", !0),
      re(wt, {
        "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0 opacity-0",
        "enter-to-class": "max-h-[600px] opacity-100",
        "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[600px] opacity-100",
        "leave-to-class": "max-h-0 opacity-0"
      }, {
        default: xe(() => [
          l.value ? (c(), g("div", B8, [
            Ae(h.$slots, "filter-panel", {
              close: () => l.value = !1
            })
          ])) : k("", !0)
        ]),
        _: 3
      }),
      re(wt, {
        "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0",
        "enter-to-class": "max-h-[100px]",
        "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[100px]",
        "leave-to-class": "max-h-0"
      }, {
        default: xe(() => [
          r.value ? (c(), H(_v, {
            key: 0,
            onEditFilter: p[6] || (p[6] = (x) => a("edit-filter", x)),
            onLastFilterRemoved: I(u)
          }, null, 8, ["onLastFilterRemoved"])) : k("", !0)
        ]),
        _: 1
      })
    ], 512));
  }
});
function Mq(e = {}) {
  const n = R(e.initialViews ?? []), t = m(() => n.value.filter((d) => d.isPreset)), a = m(() => n.value.filter((d) => !d.isPreset));
  function l(d) {
    n.value.push(d);
  }
  function r(d, u) {
    const f = n.value.findIndex((b) => b.id === d);
    f !== -1 && (n.value[f] = { ...n.value[f], ...u });
  }
  function o(d) {
    n.value = n.value.filter((u) => u.id !== d);
  }
  function i(d) {
    n.value.forEach((u) => {
      u.isDefault = u.id === d;
    });
  }
  function s(d) {
    const u = new Map(d.map((h, p) => [h, p])), f = n.value.filter((h) => h.isPreset).sort(
      (h, p) => (u.get(h.id) ?? Number.MAX_SAFE_INTEGER) - (u.get(p.id) ?? Number.MAX_SAFE_INTEGER)
    ), b = n.value.filter((h) => !h.isPreset);
    n.value = [...f, ...b];
  }
  return {
    views: n,
    presetViews: t,
    savedViews: a,
    addView: l,
    updateView: r,
    removeView: o,
    setDefault: i,
    reorderViews: s
  };
}
const xb = 10, D8 = 30, M8 = 900;
function zq() {
  function e() {
    return typeof window > "u" ? xb : window.innerHeight >= M8 ? D8 : xb;
  }
  const n = R(e());
  function t() {
    n.value = e();
  }
  return dt(() => {
    n.value = e(), window.addEventListener("resize", t, { passive: !0 });
  }), gt(() => {
    window.removeEventListener("resize", t);
  }), { pageSize: n };
}
function Oq(e) {
  const { defaultVisibility: n, defaultOrder: t = [] } = e, a = e.defaultPinning ?? {
    left: Rt(e.columns).filter((B) => B.pinned).map((B) => B.key),
    right: []
  }, l = m(
    () => new Set(
      Rt(e.columns).filter((B) => B.disabled || B.alwaysVisible).map((B) => B.key)
    )
  ), r = m(() => [...l.value]), o = (B) => l.value.has(B), i = sl(
    n ?? Object.fromEntries(Rt(e.columns).map((B) => [B.key, B.visible ?? !0]))
  ), s = Array.from(/* @__PURE__ */ new Set([...r.value, ...a.left])), d = R({
    left: s,
    right: [...a.right]
  }), u = R([...t]), f = R(!1), b = (B) => {
    var W;
    return ((W = d.value.left) == null ? void 0 : W.includes(B)) ?? !1;
  }, h = m(
    () => Rt(e.columns).filter((B) => (o(B.key) || (i[B.key] ?? !0)) && (o(B.key) || b(B.key))).length
  ), p = m(() => h.value >= Mr);
  function x(B) {
    return b(B) || !p.value;
  }
  const y = m(() => Rt(e.columns).map((B) => ({
    ...B,
    visible: i[B.key] ?? !0,
    pinned: b(B.key)
  }))), w = m(() => {
    const B = n ?? Object.fromEntries(Rt(e.columns).map((U) => [U.key, U.visible ?? !0])), W = new Set(a.left);
    return Rt(e.columns).map((U) => ({
      ...U,
      visible: B[U.key] ?? !0,
      pinned: W.has(U.key)
    }));
  }), $ = m(() => Rt(e.labels) ?? {});
  function S() {
    f.value = !0;
  }
  function L() {
    f.value = !1;
  }
  function T(B) {
    for (const G of B)
      i[G.key] = o(G.key) ? !0 : G.visible;
    const W = [], U = [], z = [], P = [];
    for (const G of B)
      o(G.key) ? W.push(G.key) : G.visible ? G.pinned ? U.push(G.key) : z.push(G.key) : P.push(G.key);
    u.value = [...W, ...U, ...z, ...P, ...e.trailingColumns ?? []];
    const K = new Set(Rt(e.columns).map((G) => G.key)), j = (d.value.left ?? []).filter((G) => !K.has(G));
    d.value = {
      left: [...j, ...W, ...U],
      right: [...d.value.right ?? []]
    };
  }
  function E() {
    const B = n ?? Object.fromEntries(Rt(e.columns).map((U) => [U.key, U.visible ?? !0]));
    Object.keys(i).forEach((U) => {
      i[U] = o(U) ? !0 : B[U] ?? !0;
    }), u.value = [...t];
    const W = Array.from(/* @__PURE__ */ new Set([...r.value, ...a.left]));
    d.value = { left: W, right: [...a.right] };
  }
  function A() {
    return u.value.length > 0 ? [...u.value] : [...Rt(e.columns).map((B) => B.key), ...e.trailingColumns ?? []];
  }
  function D(B) {
    if (b(B) || !x(B)) return;
    const W = [...d.value.left ?? [], B];
    d.value = { ...d.value, left: W };
    const U = new Set(W), z = A().filter((K) => K !== B);
    let P = -1;
    for (let K = 0; K < z.length; K++)
      U.has(z[K]) && (P = K);
    z.splice(P + 1, 0, B), u.value = z;
  }
  function M(B) {
    o(B) || (d.value = {
      ...d.value,
      left: (d.value.left ?? []).filter((W) => W !== B)
    });
  }
  function F(B, W) {
    if (B.length !== W.length) return !1;
    for (let U = 0; U < B.length; U++) if (B[U] !== W[U]) return !1;
    return !0;
  }
  function X(B) {
    const W = e.trailingColumns ?? [], U = new Set(W), z = B.filter((G) => !U.has(G)), P = [...z, ...W];
    F(P, u.value) || (u.value = P);
    const K = new Set(d.value.left ?? []), j = z.filter((G) => K.has(G));
    F(j, d.value.left ?? []) || (d.value = { ...d.value, left: j });
  }
  function _(B) {
    const W = new Set(Rt(e.columns).map((G) => G.key)), U = B.filter((G) => W.has(G));
    if (U.length <= Mr) return B;
    const z = U.filter((G) => o(G)), P = U.filter((G) => !o(G)), K = Math.max(0, Mr - z.length), j = /* @__PURE__ */ new Set([...z, ...P.slice(0, K)]);
    return B.filter((G) => !W.has(G) || j.has(G));
  }
  function Y(B) {
    const W = _(B.left ?? []), U = B.right ?? [], z = d.value.left ?? [], P = d.value.right ?? [];
    F(W, z) && F(U, P) || (d.value = { left: [...W], right: [...U] });
  }
  return {
    // State
    visibility: i,
    pinning: d,
    order: u,
    drawerOpen: f,
    // Computed
    settingsItems: y,
    defaultSettingsItems: w,
    labels: $,
    isPinned: b,
    isFrozenLimitReached: p,
    canPinColumn: x,
    // Actions
    openDrawer: S,
    closeDrawer: L,
    handleSave: T,
    handleReset: E,
    pinColumn: D,
    unpinColumn: M,
    setOrder: X,
    setPinning: Y
  };
}
const z8 = {
  "data-testid": "filter-field-picker",
  class: "flex min-h-0 flex-col"
}, O8 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "filter-field-picker-status"
}, P8 = {
  class: "flex min-h-0 flex-col pb-2",
  "data-testid": "filter-field-picker-content"
}, F8 = ["aria-label"], V8 = ["data-empty-reason"], tx = /* @__PURE__ */ ke({
  __name: "FilterFieldPicker",
  props: {
    fields: {},
    groups: { default: () => [] },
    activeGroup: { default: void 0 },
    strictGroups: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: {},
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupsLabel: { default: void 0 },
    groupAriaLabel: { default: void 0 },
    listLabel: {},
    selectedKey: { default: void 0 },
    selectable: { type: Boolean, default: !0 },
    noResultsLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    noFieldsLabel: { default: void 0 },
    emptyGroupLabel: { default: void 0 }
  },
  emits: ["select", "update:activeGroup", "update:searchQuery"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null), o = R(null), i = m(() => {
      let A = a.fields;
      return a.groups.length && a.activeGroup && (A = A.filter((D) => D.group === a.activeGroup || !D.group && !a.strictGroups)), a.searchQuery.trim() && (A = A.filter((D) => qu(D.label, a.searchQuery))), A;
    }), s = m(() => a.searchQuery.trim() ? a.noResultsLabel : a.fields.length ? a.emptyGroupLabel ?? a.noFieldsLabel : a.noFieldsLabel), d = m(() => a.searchQuery.trim() ? "no-results" : a.fields.length ? "empty-group" : "no-fields"), { focusedIndex: u, handleRovingKeydown: f, handleSearchFieldKeydown: b, clampFocusedIndex: h } = ro(), p = m(() => i.value.findIndex((A) => A.key === a.selectedKey));
    $e(
      [p, () => i.value.length],
      ([A, D]) => {
        A >= 0 ? u.value = A : h(D);
      },
      { immediate: !0 }
    );
    function x(A) {
      return !a.selectable || !!A.disabled;
    }
    function y(A) {
      x(A) || l("select", A.key);
    }
    function w(A, D) {
      return {
        role: "option",
        "aria-selected": A.key === a.selectedKey,
        tabindex: D === u.value ? 0 : -1,
        "data-listbox-index": D,
        onClick: () => y(A),
        onKeydown: ut(Ye(() => y(A), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          u.value = D;
        }
      };
    }
    function $(A) {
      f(A, i.value.length, o.value);
    }
    function S(A) {
      if (!(A.target instanceof HTMLInputElement)) return;
      const D = p.value;
      b(A, i.value.length, o.value, D >= 0 ? { downIndex: D, upIndex: D } : {});
    }
    function L() {
      var A;
      return ((A = r.value) == null ? void 0 : A.focusSearch()) ?? !1;
    }
    function T(A = u.value) {
      var M;
      const D = (M = o.value) == null ? void 0 : M.querySelector(`[data-listbox-index="${A}"]`);
      return D ? (u.value = A, D.focus({ preventScroll: !0 }), D.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function E(A) {
      const D = i.value.findIndex((M) => M.key === A);
      return D >= 0 && T(D);
    }
    return n({ focusSearch: L, focusOption: T, focusField: E }), (A, D) => (c(), g("div", z8, [
      re(cl, {
        ref_key: "headerRef",
        ref: r,
        class: "shrink-0",
        "show-search": "",
        "search-query": e.searchQuery,
        "search-placeholder": e.searchPlaceholder,
        "search-label": e.searchLabel ?? e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "group-buttons": e.groups,
        "active-group": e.activeGroup,
        "group-label-left": e.groupsLabel,
        "group-aria-label": e.groupAriaLabel,
        onKeydown: S,
        "onUpdate:searchQuery": D[0] || (D[0] = (M) => l("update:searchQuery", M)),
        "onUpdate:activeGroup": D[1] || (D[1] = (M) => l("update:activeGroup", M))
      }, null, 8, ["search-query", "search-placeholder", "search-label", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"]),
      v("span", O8, N(i.value.length ? I(Hu)(e.resultsCountLabel, i.value.length) : s.value), 1),
      v("div", P8, [
        i.value.length ? (c(), g("div", {
          key: 0,
          ref_key: "listboxRef",
          ref: o,
          role: "listbox",
          "aria-label": e.listLabel,
          class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
          "data-testid": "filter-field-picker-list",
          onKeydown: $
        }, [
          (c(!0), g(ce, null, Re(i.value, (M, F) => (c(), H(Kt, Oe({
            key: M.key
          }, { ref_for: !0 }, w(M, F), {
            type: "two-icons",
            label: M.label,
            icon: M.icon,
            selected: M.key === e.selectedKey,
            "aria-disabled": x(M),
            description: M.disabled ? M.disabledReason : void 0,
            class: "shrink-0",
            "data-testid": `filter-field-picker-option-${M.key}`
          }), null, 16, ["label", "icon", "selected", "aria-disabled", "description", "data-testid"]))), 128))
        ], 40, F8)) : s.value ? (c(), g("div", {
          key: 1,
          "data-testid": "filter-field-picker-empty",
          "data-empty-reason": d.value,
          class: "flex flex-col items-center justify-center px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
        }, N(s.value), 9, V8)) : k("", !0)
      ])
    ]));
  }
}), N8 = ["id", "aria-label", "data-size"], H8 = {
  key: 0,
  "data-testid": "filter-step-list",
  class: "flex min-h-0 flex-col"
}, j8 = { class: "flex min-h-0 flex-col pb-2" }, W8 = ["aria-multiselectable", "aria-label"], q8 = {
  key: 0,
  "data-testid": "filter-select-all",
  class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
}, U8 = {
  key: 1,
  class: "min-h-0 overflow-y-auto"
}, G8 = {
  key: 1,
  "data-testid": "filter-step-list-empty",
  class: "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, K8 = {
  key: 1,
  class: "flex min-h-0 flex-col"
}, Y8 = { class: "flex min-h-0 flex-col overflow-y-auto pb-2" }, J8 = {
  key: 0,
  "data-testid": "filter-step-text",
  class: "flex flex-col gap-4 px-3 py-4"
}, X8 = { "data-testid": "filter-text-validate-error" }, Z8 = ["aria-label"], Q8 = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, _8 = ["aria-label"], eF = { class: "flex items-start gap-6" }, tF = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, Mo = 4, ur = 16, nF = 540, aF = 240, Pq = /* @__PURE__ */ ke({
  __name: "TableFilterSelector",
  props: {
    fields: {},
    fieldGroups: { default: () => [] },
    fieldGroupsLabel: { default: "" },
    triggerLabel: { default: "Filter" },
    triggerIconLeft: { default: void 0 },
    activeCount: { default: 0 },
    step1SearchPlaceholder: { default: "Search a filter…" },
    searchClearLabel: { default: "Clear search" },
    step1FooterLabel: { default: "Rechercher par :" },
    advancedFiltersLabel: { default: "Filters avancées" },
    advancedFiltersIcon: { default: "ri-equalizer-line" },
    viewAdvancedLabel: { default: "" },
    createAdvancedLabel: { default: "" },
    advancedDisabled: { type: Boolean, default: !1 },
    advancedDisabledTooltip: { default: "" },
    backLabel: { default: "Back" },
    confirmLabel: { default: "Confirm" },
    closeOnConfirm: { type: Boolean, default: !0 },
    dateRangeErrorLabel: { default: 'The "From" date must be before or equal to the "To" date.' },
    noResultsLabel: { default: "No results for" },
    noFieldResultsLabel: { default: "No field matches your search" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    selectedCountLabel: { type: Function, default: (e, n) => `${e} of ${n} selected` },
    noFieldsLabel: { default: "" },
    activeFilters: { default: () => ({}) },
    fieldsSelectable: { type: Boolean, default: !0 }
  },
  emits: ["apply", "apply-filter", "remove-filter", "advanced-filters", "view-advanced-filters", "create-advanced-filter"],
  setup(e, { expose: n, emit: t }) {
    var ho, bo;
    const a = e, l = t, r = R(null), o = m(() => {
      var be;
      return ((be = r.value) == null ? void 0 : be.$el) ?? null;
    }), { isOpen: i, dropdownRef: s, toggleDropdown: d, openDropdown: u, closeDropdown: f } = Zl({
      onClose: fo,
      ignoreSelectors: [
        '[data-testid="datepicker-dropdown-menu"]',
        '[data-testid="datepicker-dob-picker"]',
        '[data-testid="filter-selector-menu"]'
      ]
    }), b = R({}), h = R(null), p = R(null), x = R(null);
    function y() {
      var Zc, Qc;
      const be = (Zc = o.value) == null ? void 0 : Zc.getBoundingClientRect();
      if (!be) return;
      const pe = typeof window < "u" ? window.innerWidth : be.right, Te = typeof window < "u" ? window.innerHeight : be.bottom, qe = ((Qc = p.value) == null ? void 0 : Qc.offsetWidth) ?? 0, ys = be.left + be.width / 2 > pe / 2 ? be.right - qe : be.left, xx = Math.max(ur, pe - ur - qe), ks = Te - be.bottom - Mo - ur, Jc = be.top - Mo - ur, Xc = ks < aF && Jc > ks;
      b.value = {
        position: "fixed",
        ...Xc ? { bottom: `${Te - be.top + Mo}px` } : { top: `${be.bottom + Mo}px` },
        left: `${Math.max(ur, Math.min(ys, xx))}px`,
        maxHeight: `${Math.min(nF, Math.max(Xc ? Jc : ks, 0))}px`,
        zIndex: "350"
      };
    }
    function w() {
      typeof window > "u" || (window.addEventListener("scroll", y, !0), window.addEventListener("resize", y));
    }
    function $() {
      typeof window > "u" || (window.removeEventListener("scroll", y, !0), window.removeEventListener("resize", y));
    }
    $e(i, (be) => {
      be ? Ue(() => {
        var pe;
        if (y(), w(), h.value) {
          ze(h.value), h.value = null;
          return;
        }
        (pe = x.value) != null && pe.focusSearch() || ae();
      }) : $();
    }), mt($);
    function S(be) {
      !i.value && (be.key === "ArrowDown" || be.key === "ArrowUp") && (be.preventDefault(), u());
    }
    function L(be) {
      if (i.value) {
        ze(be);
        return;
      }
      h.value = be, setTimeout(d, 0);
    }
    n({ openDropdown: u, closeDropdown: f, openForField: L, triggerEl: o });
    function T(be) {
      i.value && (be.stopPropagation(), be.preventDefault(), E.value === "value" ? it() : (f(), Ue(() => {
        var pe;
        return (pe = o.value) == null ? void 0 : pe.focus();
      })));
    }
    const E = R("field"), A = R(""), D = R(((bo = (ho = a.fieldGroups) == null ? void 0 : ho[0]) == null ? void 0 : bo.value) ?? "");
    $e(
      () => a.fieldGroups,
      (be) => {
        be != null && be.length && (be.some((pe) => pe.value === D.value) || (D.value = be[0].value));
      },
      { immediate: !0 }
    );
    const M = R(null), F = R(null), X = R(""), _ = R(/* @__PURE__ */ new Set()), Y = R(""), B = R(null), W = R(null), U = R(""), z = R(""), P = m(
      () => M.value != null ? a.fields.find((be) => be.key === M.value) ?? null : null
    );
    function K(be, pe) {
      if (!be) return null;
      const Te = be.split(/[/\\\-.]/), qe = pe.toLowerCase().split(/[/\\\-.]/), St = {};
      return qe.forEach((Ga, ys) => {
        St[Ga] = parseInt(Te[ys], 10);
      }), isNaN(St.yyyy) || isNaN(St.mm) || isNaN(St.dd) ? null : new Date(St.yyyy, (St.mm || 1) - 1, St.dd || 1);
    }
    const j = m(() => {
      var be;
      return (be = P.value) != null && be.maxLength ? Y.value.length <= P.value.maxLength : !0;
    }), G = m(() => {
      var Te, qe;
      if (((Te = P.value) == null ? void 0 : Te.type) !== "text") return null;
      const be = (qe = P.value) == null ? void 0 : qe.validate;
      if (!be) return null;
      const pe = Y.value.trim();
      return pe.length === 0 ? null : be(pe);
    }), q = m(() => {
      const be = P.value;
      if (!(!be || be.type !== "text")) {
        if (be.maxLength && Y.value.length > be.maxLength)
          return be.maxLengthErrorLabel ?? `Maximum ${be.maxLength} characters`;
        if (G.value) return G.value;
      }
    }), J = je(), me = m(() => `${J}-text`), ye = m(() => `${J}-date-from`), Z = m(() => `${J}-date-to`), de = m(() => B.value == null || W.value == null ? !0 : B.value <= W.value), ge = m(() => {
      var qe;
      if (!U.value || !z.value) return !0;
      const be = ((qe = P.value) == null ? void 0 : qe.dateFormat) ?? "dd/mm/yyyy", pe = K(U.value, be), Te = K(z.value, be);
      return !pe || !Te ? !0 : pe <= Te;
    }), se = m(() => {
      var be;
      return ((be = P.value) == null ? void 0 : be.type) ?? "list";
    }), Se = m(
      () => E.value === "value" && P.value && se.value !== "list" ? "m" : "l"
    ), V = m(() => ({ width: Xu[Se.value] }));
    $e(Se, () => {
      i.value && Ue(y);
    });
    const Q = m(
      () => a.fields.map((be) => ({
        key: be.key,
        label: be.label,
        icon: be.icon,
        group: be.group,
        disabled: be.disabled,
        disabledReason: be.disabledReason
      }))
    ), le = m(() => !!a.viewAdvancedLabel && !!a.createAdvancedLabel), ee = m(() => {
      const be = a.step1FooterLabel;
      if (le.value)
        return {
          type: "buttons-column",
          label: be,
          buttons: [
            {
              label: a.createAdvancedLabel,
              variant: "primary",
              icon: "ri-add-line",
              ariaDisabled: a.advancedDisabled,
              testId: "create-advanced-filter-btn"
            },
            {
              label: a.viewAdvancedLabel,
              variant: "secondary",
              icon: a.advancedFiltersIcon,
              ariaDisabled: a.advancedDisabled,
              testId: "view-advanced-filters-btn"
            }
          ],
          description: a.advancedDisabled && a.advancedDisabledTooltip || void 0
        };
      if (!a.advancedFiltersLabel) return null;
      const pe = {
        label: a.advancedFiltersLabel,
        variant: "secondary",
        icon: a.advancedFiltersIcon,
        testId: "advanced-filters-btn"
      };
      return be ? { type: "label-button", label: be, buttons: [pe] } : { type: "button", buttons: [pe] };
    });
    function O(be) {
      le.value ? be === 0 ? co() : xs() : vs();
    }
    const ne = m(() => {
      if (!P.value || se.value !== "list") return [];
      const be = P.value.items ?? [], pe = X.value.trim().toLowerCase();
      return pe ? be.filter((Te) => Te.label.toLowerCase().includes(pe)) : be;
    }), fe = m(() => {
      var be;
      return (((be = P.value) == null ? void 0 : be.items) ?? []).length;
    }), ue = m(() => {
      var Te;
      const be = ((Te = P.value) == null ? void 0 : Te.items) ?? [];
      return be.some((qe) => typeof qe.count == "number") ? be.reduce((qe, St) => qe + (typeof St.count == "number" ? St.count : 0), 0) : fe.value;
    }), te = m(
      () => {
        var be;
        return (((be = P.value) == null ? void 0 : be.items) ?? []).filter((pe) => _.value.has(pe.id)).length;
      }
    ), oe = m(
      () => te.value === fe.value && fe.value > 0
    ), Le = m(
      () => te.value > 0 && te.value < fe.value
    ), Ie = R(null), {
      focusedIndex: ve,
      handleRovingKeydown: we,
      clampFocusedIndex: he,
      focusListboxOption: Me,
      handleSearchFieldKeydown: Ee
    } = ro(), He = m(
      () => {
        var be, pe;
        return !((be = P.value) != null && be.single) && !X.value && (((pe = P.value) == null ? void 0 : pe.items) ?? []).length > 0;
      }
    ), Ge = m(
      () => (He.value ? 1 : 0) + ne.value.length
    );
    $e(
      () => Ge.value,
      (be) => he(be)
    ), $e(E, (be) => {
      if (be === "field") {
        const pe = F.value;
        Ue(() => {
          var Te, qe;
          pe && ((Te = x.value) != null && Te.focusField(pe)) || (qe = x.value) != null && qe.focusOption(0) || ae();
        });
      }
    });
    function Ze() {
      ve.value = 0, Ue(() => {
        Me(Ie.value, 0), ae();
      });
    }
    function ae() {
      var pe, Te, qe;
      if ((pe = p.value) != null && pe.contains(document.activeElement)) return;
      (qe = ((Te = p.value) == null ? void 0 : Te.querySelector(
        'input:not([type="hidden"]):not([type="range"]), textarea, button'
      )) ?? p.value) == null || qe.focus({ preventScroll: !0 });
    }
    function ie(be) {
      we(be, Ge.value, Ie.value);
    }
    function Ce(be) {
      be.target instanceof HTMLInputElement && Ee(be, Ge.value, Ie.value);
    }
    function Fe(be, pe, Te) {
      return {
        role: "option",
        "aria-selected": pe,
        tabindex: ve.value === be ? 0 : -1,
        "data-listbox-index": be,
        onClick: Te,
        onKeydown: ut(Ye(Te, ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          ve.value = be;
        }
      };
    }
    const Ke = m(
      () => te.value > 0 ? a.selectedCountLabel(te.value, fe.value) : ""
    ), _e = m(
      () => se.value === "text" && (!j.value || !!G.value) || se.value === "dateRange" && !ge.value || se.value === "range" && !de.value
    ), Et = m(() => ({
      type: "buttons-inline",
      buttons: [
        { label: a.backLabel, variant: "secondary", icon: "ri-arrow-left-line", testId: "filter-back-btn" },
        { label: a.confirmLabel, variant: "primary", disabled: _e.value, testId: "filter-apply-btn" }
      ]
    }));
    function De(be) {
      be === 0 ? it() : zn();
    }
    function ze(be) {
      var qe, St;
      const pe = M.value === be;
      M.value = be, X.value = "";
      const Te = (qe = a.activeFilters) == null ? void 0 : qe[be];
      Te ? (Te.type === "in" ? _.value = new Set(Te.values) : _.value = /* @__PURE__ */ new Set(), Y.value = Te.type === "equals" ? String(Te.value) : "", B.value = Te.type === "range" ? Te.min : null, W.value = Te.type === "range" ? Te.max : null, U.value = Te.type === "dateRange" ? Te.from ?? "" : "", z.value = Te.type === "dateRange" ? Te.to ?? "" : "") : (_.value = /* @__PURE__ */ new Set(), Y.value = "", B.value = null, W.value = null, U.value = "", z.value = ""), E.value = "value", (!pe || !((St = p.value) != null && St.contains(document.activeElement))) && Ze();
    }
    function We(be) {
      a.fieldsSelectable && ze(be);
    }
    function it() {
      F.value = M.value, E.value = "field", M.value = null;
    }
    function Ct(be) {
      var Te;
      if ((Te = P.value) != null && Te.single) {
        _.value = _.value.has(be) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([be]);
        return;
      }
      const pe = new Set(_.value);
      pe.has(be) ? pe.delete(be) : pe.add(be), _.value = pe;
    }
    function Jt() {
      var be;
      oe.value ? _.value = /* @__PURE__ */ new Set() : _.value = new Set((((be = P.value) == null ? void 0 : be.items) ?? []).map((pe) => pe.id));
    }
    function zn() {
      const be = M.value, pe = se.value;
      if (pe === "list")
        l("apply", be, [..._.value]);
      else if (pe === "text") {
        if (G.value)
          return;
        Y.value.trim() ? l("apply-filter", be, { type: "equals", value: Y.value.trim() }) : l("remove-filter", be);
      } else pe === "range" ? B.value != null || W.value != null ? l("apply-filter", be, { type: "range", min: B.value, max: W.value }) : l("remove-filter", be) : pe === "dateRange" && (U.value || z.value ? l("apply-filter", be, {
        type: "dateRange",
        from: U.value || null,
        to: z.value || null
      }) : l("remove-filter", be));
      a.closeOnConfirm ? (f(), Ue(() => {
        var Te;
        return (Te = o.value) == null ? void 0 : Te.focus();
      })) : it();
    }
    function vs() {
      l("advanced-filters"), f();
    }
    function xs() {
      a.advancedDisabled || (l("view-advanced-filters"), f());
    }
    function co() {
      a.advancedDisabled || (l("create-advanced-filter"), f());
    }
    function fo() {
      var be, pe;
      F.value = null, E.value = "field", M.value = null, A.value = "", D.value = ((pe = (be = a.fieldGroups) == null ? void 0 : be[0]) == null ? void 0 : pe.value) ?? "", X.value = "", _.value = /* @__PURE__ */ new Set(), Y.value = "", B.value = null, W.value = null, U.value = "", z.value = "";
    }
    return (be, pe) => (c(), g("div", {
      ref_key: "dropdownRef",
      ref: s,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      onKeydown: ut(T, ["escape"])
    }, [
      re(I(Be), {
        ref_key: "triggerButtonRef",
        ref: r,
        "data-testid": "filter-selector-trigger",
        size: "xs",
        variant: "secondary",
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": "",
        "aria-expanded": I(i),
        "aria-controls": I(i) ? I(J) : void 0,
        "aria-haspopup": "dialog",
        onClick: I(d),
        onKeydown: S
      }, {
        default: xe(() => [
          et(N(e.triggerLabel) + " ", 1),
          e.activeCount > 0 ? (c(), H(ct, {
            key: 0,
            "data-testid": "filter-active-badge",
            class: "ms-1.5",
            theme: "active",
            size: "sm",
            "badge-style": "circle",
            "text-only": "",
            value: e.activeCount
          }, null, 8, ["value"])) : k("", !0)
        ]),
        _: 1
      }, 8, ["icon-left", "aria-expanded", "aria-controls", "onClick"]),
      (c(), H(Dn, { to: "body" }, [
        re(wt, {
          "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: xe(() => [
            I(i) ? (c(), g("div", {
              key: 0,
              id: I(J),
              ref_key: "panelRef",
              ref: p,
              role: "dialog",
              "aria-label": e.triggerLabel,
              "data-testid": "filter-selector-menu",
              "data-size": Se.value,
              "data-focus-trap-allow-outside": "",
              tabindex: "-1",
              style: Ne([V.value, b.value]),
              class: C([
                "flex max-h-[540px] max-w-[calc(100vw-2rem)] flex-col overflow-hidden focus-visible:outline-none",
                I(Wa)
              ]),
              onKeydown: ut(T, ["escape"])
            }, [
              E.value === "field" ? (c(), g(ce, { key: 0 }, [
                re(tx, {
                  ref_key: "pickerRef",
                  ref: x,
                  "active-group": D.value,
                  "onUpdate:activeGroup": pe[0] || (pe[0] = (Te) => D.value = Te),
                  "search-query": A.value,
                  "onUpdate:searchQuery": pe[1] || (pe[1] = (Te) => A.value = Te),
                  fields: Q.value,
                  groups: e.fieldGroups,
                  "groups-label": e.fieldGroupsLabel || void 0,
                  "group-aria-label": e.triggerLabel,
                  "search-placeholder": e.step1SearchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.step1SearchPlaceholder,
                  selectable: e.fieldsSelectable,
                  "no-results-label": e.noFieldResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel || void 0,
                  onSelect: We
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "group-aria-label", "search-placeholder", "search-clear-label", "list-label", "selectable", "no-results-label", "results-count-label", "no-fields-label"]),
                ee.value ? (c(), H(ul, Oe({ key: 0 }, ee.value, {
                  class: "shrink-0",
                  onButtonClick: O
                }), null, 16)) : k("", !0)
              ], 64)) : k("", !0),
              E.value === "value" && P.value ? (c(), g(ce, { key: 1 }, [
                se.value === "list" ? (c(), g("div", H8, [
                  re(cl, {
                    class: "shrink-0",
                    "label-left": P.value.label,
                    "label-right": Ke.value || void 0,
                    "show-search": "",
                    "search-query": X.value,
                    "search-placeholder": P.value.step2SearchPlaceholder ?? "Search…",
                    "search-label": P.value.step2SearchPlaceholder ?? "Search…",
                    "search-clear-label": e.searchClearLabel,
                    onKeydown: Ce,
                    "onUpdate:searchQuery": pe[2] || (pe[2] = (Te) => X.value = Te)
                  }, null, 8, ["label-left", "label-right", "search-query", "search-placeholder", "search-label", "search-clear-label"]),
                  v("div", j8, [
                    Ge.value ? (c(), g("div", {
                      key: 0,
                      ref_key: "step2ListboxRef",
                      ref: Ie,
                      role: "listbox",
                      "aria-multiselectable": !P.value.single,
                      "aria-label": P.value.label,
                      class: "flex min-h-0 flex-col",
                      onKeydown: ie
                    }, [
                      He.value ? (c(), g("div", q8, [
                        re(Kt, Oe(Fe(0, oe.value, Jt), {
                          type: "checkbox",
                          label: P.value.selectAllLabel ?? "Select all",
                          checked: oe.value,
                          indeterminate: Le.value,
                          count: ue.value > 0 ? `(${ue.value})` : void 0
                        }), null, 16, ["label", "checked", "indeterminate", "count"])
                      ])) : k("", !0),
                      ne.value.length ? (c(), g("div", U8, [
                        v("div", {
                          class: C(["flex flex-col gap-0.5 px-2", He.value ? "pt-0.5 pb-0.5" : "py-1.5"])
                        }, [
                          (c(!0), g(ce, null, Re(ne.value, (Te, qe) => (c(), H(Kt, Oe({
                            key: Te.id
                          }, { ref_for: !0 }, Fe(He.value ? qe + 1 : qe, _.value.has(Te.id), () => Ct(Te.id)), {
                            class: "shrink-0",
                            type: "checkbox",
                            label: Te.label,
                            checked: _.value.has(Te.id),
                            count: Te.count !== void 0 ? `(${Te.count})` : void 0,
                            "data-testid": `filter-item-${Te.id}`
                          }), null, 16, ["label", "checked", "count", "data-testid"]))), 128))
                        ], 2)
                      ])) : k("", !0)
                    ], 40, W8)) : k("", !0),
                    !ne.value.length && X.value ? (c(), g("div", G8, N(e.noResultsLabel) + ' "' + N(X.value) + '". ', 1)) : k("", !0)
                  ])
                ])) : (c(), g("div", K8, [
                  re(cl, {
                    class: "shrink-0",
                    "label-left": P.value.label
                  }, null, 8, ["label-left"]),
                  v("div", Y8, [
                    se.value === "text" ? (c(), g("div", J8, [
                      v("div", X8, [
                        re(I(Ot), {
                          id: me.value,
                          modelValue: Y.value,
                          "onUpdate:modelValue": pe[3] || (pe[3] = (Te) => Y.value = Te),
                          "aria-label": P.value.label,
                          placeholder: P.value.placeholder ?? "",
                          error: q.value,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "aria-label", "placeholder", "error"])
                      ])
                    ])) : se.value === "range" ? (c(), g("div", {
                      key: 1,
                      "data-testid": "filter-step-range",
                      role: "group",
                      "aria-label": P.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      re(I(Nv), {
                        "min-value": B.value,
                        "onUpdate:minValue": pe[4] || (pe[4] = (Te) => B.value = Te),
                        "max-value": W.value,
                        "onUpdate:maxValue": pe[5] || (pe[5] = (Te) => W.value = Te),
                        min: P.value.rangeMin ?? 0,
                        max: P.value.rangeMax ?? 1e4,
                        step: P.value.rangeStep ?? 1,
                        "separator-label": P.value.rangeSeparatorLabel ?? "to",
                        "min-label": P.value.rangeMinLabel ?? "Minimum",
                        "max-label": P.value.rangeMaxLabel ?? "Maximum",
                        "clamp-input-to-bounds": P.value.rangeClampInputToBounds ?? !0,
                        "data-min": P.value.rangeDataMin ?? null,
                        "data-max": P.value.rangeDataMax ?? null,
                        "hint-label": P.value.rangeHintLabel ?? ""
                      }, null, 8, ["min-value", "max-value", "min", "max", "step", "separator-label", "min-label", "max-label", "clamp-input-to-bounds", "data-min", "data-max", "hint-label"]),
                      de.value ? k("", !0) : (c(), g("p", Q8, N(P.value.rangeErrorLabel ?? "Min value must be less than or equal to max value"), 1))
                    ], 8, Z8)) : se.value === "dateRange" ? (c(), g("div", {
                      key: 2,
                      "data-testid": "filter-step-date-range",
                      role: "group",
                      "aria-label": P.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      v("div", eF, [
                        re(I(gu), {
                          id: ye.value,
                          modelValue: U.value,
                          "onUpdate:modelValue": pe[6] || (pe[6] = (Te) => U.value = Te),
                          class: "min-w-0 flex-1",
                          label: P.value.dateFromLabel ?? "From",
                          placeholder: P.value.datePlaceholder,
                          format: P.value.dateFormat ?? "dd/mm/yyyy",
                          language: P.value.dateLanguage,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format", "language"]),
                        re(I(gu), {
                          id: Z.value,
                          modelValue: z.value,
                          "onUpdate:modelValue": pe[7] || (pe[7] = (Te) => z.value = Te),
                          class: "min-w-0 flex-1",
                          label: P.value.dateToLabel ?? "To",
                          placeholder: P.value.datePlaceholder,
                          format: P.value.dateFormat ?? "dd/mm/yyyy",
                          language: P.value.dateLanguage,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format", "language"])
                      ]),
                      ge.value ? k("", !0) : (c(), g("p", tF, N(e.dateRangeErrorLabel), 1))
                    ], 8, _8)) : k("", !0)
                  ])
                ])),
                re(ul, Oe(Et.value, {
                  class: "shrink-0",
                  onButtonClick: De
                }), null, 16)
              ], 64)) : k("", !0)
            ], 46, N8)) : k("", !0)
          ]),
          _: 1
        })
      ]))
    ], 544));
  }
}), lF = /* @__PURE__ */ ke({
  __name: "TablePanel",
  props: {
    roundTop: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      class: C([
        "min-w-0 border border-(--border-border-base-soft) overflow-x-auto shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]",
        e.roundTop ? "rounded-xl" : "rounded-b-xl"
      ])
    }, [
      Ae(n.$slots, "default")
    ], 2));
  }
}), rF = {
  key: 0,
  class: "border-b border-(--border-border-base-soft)"
}, oF = {
  key: 1,
  "data-testid": "records-table-header",
  class: "flex items-center justify-between gap-4 px-3 py-3 border-b border-(--border-border-base-soft)"
}, iF = { class: "flex items-center gap-2.5 min-w-0" }, sF = {
  key: 0,
  class: "shrink-0 size-12 flex items-center justify-center bg-white border border-(--border-border-base-medium) rounded-lg"
}, dF = { class: "flex flex-col gap-px min-w-0" }, uF = {
  key: 0,
  class: "text-base font-medium leading-6 text-(--text-text-heading) truncate"
}, cF = {
  key: 1,
  class: "text-base font-normal leading-6 text-(--text-text-body) truncate"
}, fF = {
  key: 0,
  "data-testid": "records-table-actions",
  class: "flex items-center gap-2 shrink-0"
}, hF = ["onClick"], bF = { class: "flex items-center gap-1" }, gF = {
  key: 0,
  class: "ri-expand-up-down-line text-xs"
}, mF = { key: 0 }, pF = ["colspan"], yb = "sticky right-0 z-10 shadow-[inset_1px_0_0_var(--border-border-base-soft),-2px_0_4px_-2px_rgba(0,0,0,0.06)]", vF = "[transform:translateZ(0)]", Fq = /* @__PURE__ */ ke({
  __name: "RecordsTable",
  props: {
    columns: {},
    data: {},
    emptyText: { default: "" },
    tableClass: {},
    title: {},
    subtitle: {},
    icon: {},
    minWidth: {},
    layout: { default: "fixed" }
  },
  setup(e) {
    const n = e, t = Yt(), a = R(null), l = R("asc"), r = (i) => {
      a.value === i ? l.value = l.value === "asc" ? "desc" : "asc" : (a.value = i, l.value = "asc");
    }, o = m(() => {
      if (!a.value) return n.data;
      const i = n.columns.find((s) => s.id === a.value);
      return i != null && i.sortable ? [...n.data].sort((s, d) => {
        const u = i.sortBy(s), f = i.sortBy(d), b = String(u).localeCompare(String(f), void 0, { numeric: !0 });
        return l.value === "asc" ? b : -b;
      }) : n.data;
    });
    return (i, s) => (c(), H(lF, null, {
      default: xe(() => [
        v("div", {
          style: Ne(e.minWidth ? { minWidth: `max(100%, ${e.minWidth}px)` } : void 0)
        }, [
          I(t)("header") ? (c(), g("div", rF, [
            Ae(i.$slots, "header")
          ])) : e.title || e.subtitle || e.icon || I(t)("actions") ? (c(), g("div", oF, [
            v("div", iF, [
              e.icon ? (c(), g("div", sF, [
                v("i", {
                  class: C([e.icon, "text-[length:var(--size-5xl)] leading-none text-(--text-text-body)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ])) : k("", !0),
              v("div", dF, [
                e.title ? (c(), g("span", uF, N(e.title), 1)) : k("", !0),
                e.subtitle ? (c(), g("span", cF, N(e.subtitle), 1)) : k("", !0)
              ])
            ]),
            I(t)("actions") ? (c(), g("div", fF, [
              Ae(i.$slots, "actions")
            ])) : k("", !0)
          ])) : k("", !0),
          v("table", {
            class: C(["w-full", e.layout === "auto" ? "table-auto" : "table-fixed", e.tableClass])
          }, [
            v("thead", null, [
              v("tr", null, [
                (c(!0), g(ce, null, Re(e.columns, (d) => (c(), g("th", {
                  key: d.id,
                  class: C([
                    "h-11 px-5 overflow-hidden text-left text-sm font-medium text-(--text-text-body) border-b border-(--border-border-base-medium) bg-white",
                    d.width,
                    d.sortable && "cursor-pointer select-none",
                    d.sticky && [yb, vF]
                  ]),
                  onClick: (u) => d.sortable ? r(d.id) : void 0
                }, [
                  v("div", bF, [
                    et(N(d.header) + " ", 1),
                    d.sortable ? (c(), g("i", gF)) : k("", !0)
                  ])
                ], 10, hF))), 128))
              ])
            ]),
            v("tbody", null, [
              o.value.length ? k("", !0) : (c(), g("tr", mF, [
                v("td", {
                  colspan: e.columns.length,
                  class: "h-14 px-5 text-sm text-center text-(--text-text-body)"
                }, N(e.emptyText), 9, pF)
              ])),
              (c(!0), g(ce, null, Re(o.value, (d, u) => (c(), g("tr", {
                key: u,
                class: "border-b border-(--border-border-base-soft) last:border-b-0"
              }, [
                (c(!0), g(ce, null, Re(e.columns, (f, b) => (c(), g("td", {
                  key: f.id,
                  class: C([
                    "h-14 px-5 overflow-hidden",
                    b === 0 && e.layout === "fixed" && "max-w-0",
                    f.sticky && ["bg-white", yb]
                  ])
                }, [
                  (c(), H(lt(() => f.cell(d))))
                ], 2))), 128))
              ]))), 128))
            ])
          ], 2)
        ], 4)
      ]),
      _: 3
    }));
  }
}), xF = { class: "w-full relative shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-t-[0px] rounded-b-3xl bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex flex-col items-start text-left text-[14px] text-gray-200 dark:text-[var(--colors-text-white-default)] font-inter" }, yF = {
  key: 0,
  style: { width: "256px" }
}, kF = { class: "flex items-center justify-end gap-3 flex-shrink-0" }, wF = {
  key: 0,
  class: "skeleton h-9 w-32"
}, CF = {
  key: 1,
  class: "skeleton h-9 w-20"
}, SF = { class: "self-stretch overflow-x-auto" }, $F = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, IF = {
  key: 0,
  class: "flex flex-col items-start"
}, TF = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, LF = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, AF = ["data-testid"], EF = { class: "flex items-center justify-end gap-3 text-gray-200 dark:text-[var(--colors-text-white-default)] flex-shrink-0" }, RF = { class: "self-stretch overflow-x-auto" }, BF = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, DF = {
  key: 0,
  class: "flex flex-col items-start"
}, MF = { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, zF = { class: "flex items-center" }, OF = ["onClick"], PF = { class: "flex items-center gap-1 min-w-0" }, FF = ["title"], VF = ["src"], NF = ["onMousedown"], HF = { class: "flex-1 relative leading-[20px] overflow-hidden text-ellipsis whitespace-nowrap" }, jF = { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-[14px] text-(--colors-text-body) dark:text-(--colors-text-white-default)" }, WF = { class: "flex items-center gap-1" }, qF = { class: "relative leading-[20px] font-medium" }, UF = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, GF = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, KF = { class: "relative leading-[20px] dark:text-[var(--colors-text-white-default)]" }, YF = { class: "min-w-0 flex-1" }, JF = /* @__PURE__ */ ke({
  __name: "Table",
  props: {
    columns: {},
    rows: {},
    showCheckbox: { type: Boolean, default: !0 },
    title: { default: "Transactions" },
    searchPlaceholder: { default: "Search for transaction" },
    searchClearLabel: { default: "Clear search" },
    showSearch: { type: Boolean, default: !0 },
    showFilters: { type: Boolean, default: !0 },
    showAddButton: { type: Boolean, default: !0 },
    addButtonLabel: { default: "Add transaction" },
    showActions: { type: Boolean, default: !0 },
    rowActions: { type: [Array, Function], default: () => [
      { label: "Actions", icon: void 0, onClick: () => {
      } },
      { label: "Delete", icon: void 0, onClick: () => {
      }, isDelete: !0 }
    ] },
    enablePagination: { type: Boolean, default: !0 },
    itemsPerPage: { default: 10 },
    totalItems: { default: 1e3 },
    currentPage: { default: 1 },
    searchIcon: { default: void 0 },
    filtersIcon: { default: void 0 },
    actionsIcon: { default: void 0 },
    addButtonIconLeft: { default: void 0 },
    filterItems: { default: () => [
      { label: "All", onClick: () => {
      } },
      { label: "Completed", onClick: () => {
      } },
      { label: "Pending", onClick: () => {
      } },
      { label: "Failed", onClick: () => {
      } }
    ] },
    filterSections: { default: () => [] },
    headerActionsItems: { default: () => [
      { label: "Export CSV", onClick: () => {
      } },
      { label: "Export Excel", onClick: () => {
      } },
      { label: "Print", onClick: () => {
      } }
    ] },
    filtersLabel: { default: "Filters" },
    actionsLabel: { default: "Actions" },
    actionsColumnLabel: { default: "Actions" },
    filterResetLabel: { default: "Reset" },
    filterApplyLabel: { default: "Apply" },
    filterMenuWidth: { default: "280px" },
    paginationText: { type: Function, default: (e, n, t) => `Showing ${e}-${n} of ${t}` },
    wrap: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    serverSideSearch: { type: Boolean, default: !1 },
    serverSidePagination: { type: Boolean, default: !1 },
    searchDataTestId: { default: void 0 }
  },
  emits: ["search", "filter", "filter-apply", "filter-reset", "filter-change", "add", "action", "page-change", "selection-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => [
      {
        label: t.filterResetLabel,
        variant: "secondary",
        onClick: () => a("filter-reset"),
        keepOpen: !0
      },
      {
        label: t.filterApplyLabel,
        variant: "primary",
        onClick: () => {
          var P;
          const z = {};
          (P = t.filterSections) == null || P.forEach((K) => {
            z[K.id] = K.checked ?? K.switchChecked ?? !1;
          }), a("filter-apply", z);
        }
      }
    ]), r = R(""), o = R(/* @__PURE__ */ new Set()), i = R(null), s = R("asc"), d = R(t.currentPage);
    $e(
      () => t.currentPage,
      (z) => {
        t.serverSidePagination && z !== void 0 && (d.value = z);
      }
    );
    const u = R({}), f = R(!1), b = R(null), h = R(0), p = R(0), x = () => {
      const z = {};
      return t.columns.forEach((P) => {
        if (P.width) {
          const K = parseFloat(P.width);
          P.width.includes("px") ? z[P.key] = K : t.wrap || (z[P.key] = 200);
        } else t.wrap || (z[P.key] = 200);
      }), t.showActions && !t.wrap && (z.__actions__ = 150), z;
    };
    Object.keys(u.value).length === 0 && (u.value = x());
    const y = (z) => u.value[z] ? `${u.value[z]}px` : "200px", w = (z, P) => {
      if (f.value = !0, b.value = z, h.value = P.clientX, u.value[z])
        p.value = u.value[z];
      else {
        const j = P.target.closest(".bg-white.flex.flex-col");
        j ? p.value = j.offsetWidth : p.value = 200;
      }
      document.body.classList.add("resizing"), document.addEventListener("mousemove", $), document.addEventListener("mouseup", S), P.preventDefault(), P.stopPropagation();
    }, $ = (z) => {
      if (!f.value || !b.value) return;
      const P = z.clientX - h.value, K = p.value + P;
      K >= 50 && K <= 1e3 && (u.value[b.value] = K);
    }, S = () => {
      f.value = !1, b.value = null, document.body.classList.remove("resizing"), document.removeEventListener("mousemove", $), document.removeEventListener("mouseup", S);
    };
    $e(
      () => t.columns,
      () => {
        if (t.wrap) {
          const z = x();
          Object.keys(z).forEach((P) => {
            u.value[P] === void 0 && z[P] !== void 0 && (u.value[P] = z[P]);
          });
        } else {
          const z = t.columns.every((K) => u.value[K.key] !== void 0), P = !t.showActions || u.value.__actions__ !== void 0;
          if (!z || !P) {
            const K = x();
            Object.keys(K).forEach((j) => {
              u.value[j] === void 0 && K[j] !== void 0 && (u.value[j] = K[j]);
            });
          }
        }
      },
      { deep: !0 }
    ), $e(
      () => t.wrap,
      () => {
        u.value = x();
      }
    );
    const L = m(() => {
      let z = t.rows;
      if (r.value && t.showSearch && !t.serverSideSearch && (z = z.filter(
        (P) => JSON.stringify(P).toLowerCase().includes(r.value.toLowerCase())
      )), i.value && (z = [...z].sort((P, K) => {
        const j = P[i.value], G = K[i.value];
        return j == null && G == null ? 0 : j == null ? 1 : G == null ? -1 : j < G ? s.value === "asc" ? -1 : 1 : j > G ? s.value === "asc" ? 1 : -1 : 0;
      })), t.enablePagination && !t.serverSidePagination) {
        const P = (d.value - 1) * t.itemsPerPage, K = P + t.itemsPerPage;
        return z.slice(P, K);
      }
      return z;
    }), T = m(() => {
      if (!t.enablePagination) return 1;
      if (t.serverSidePagination) return Math.ceil((t.totalItems ?? 0) / t.itemsPerPage);
      if (t.serverSideSearch) return Math.ceil(t.rows.length / t.itemsPerPage);
      const z = t.rows.filter(
        (P) => !r.value || JSON.stringify(P).toLowerCase().includes(r.value.toLowerCase())
      );
      return Math.ceil(z.length / t.itemsPerPage);
    }), E = (z) => {
      d.value = 1, a("search", z);
    }, A = (z) => {
      z.sortable && (i.value === z.key ? s.value = s.value === "asc" ? "desc" : "asc" : (i.value = z.key, s.value = "asc"));
    }, D = (z) => {
      z ? L.value.forEach((P) => {
        o.value.add(P.id);
      }) : L.value.forEach((P) => {
        o.value.delete(P.id);
      }), a(
        "selection-change",
        Array.from(o.value).map((P) => t.rows.find((K) => K.id === P))
      );
    }, M = (z) => {
      o.value.has(z.id) ? o.value.delete(z.id) : o.value.add(z.id), a(
        "selection-change",
        Array.from(o.value).map((P) => t.rows.find((K) => K.id === P))
      );
    }, F = (z) => {
      d.value = z, a("page-change", z);
    }, X = (z, P) => {
      z.onClick(P), a("action", z, P);
    }, _ = (z) => o.value.has(z.id), Y = (z) => typeof t.rowActions == "function" ? t.rowActions(z) : t.rowActions || [], B = m(() => L.value.length === 0 ? !1 : L.value.every((z) => o.value.has(z.id))), W = (z, P) => P.render ? P.render(z[P.key], z) : z[P.key], U = (z) => {
      const P = [70, 85, 60, 90, 75, 80, 65, 95];
      return `${P[z % P.length]}%`;
    };
    return (z, P) => (c(), g("div", xF, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        v("div", {
          class: C(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), g("div", yF, [...P[4] || (P[4] = [
            v("div", { class: "skeleton h-10 w-full" }, null, -1)
          ])])) : k("", !0),
          v("div", kF, [
            e.showAddButton ? (c(), g("div", wF)) : k("", !0),
            e.showFilters ? (c(), g("div", CF)) : k("", !0),
            P[5] || (P[5] = v("div", { class: "skeleton h-9 w-20" }, null, -1))
          ])
        ], 2),
        v("div", SF, [
          v("div", $F, [
            e.showCheckbox ? (c(), g("div", IF, [
              P[7] || (P[7] = v("div", { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-4 w-4" })
              ], -1)),
              (c(!0), g(ce, null, Re(e.itemsPerPage, (K) => (c(), g("div", {
                key: `skeleton-checkbox-${K}`,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [...P[6] || (P[6] = [
                v("div", { class: "skeleton h-4 w-4" }, null, -1)
              ])]))), 128))
            ])) : k("", !0),
            (c(!0), g(ce, null, Re(e.columns, (K, j) => (c(), g("div", {
              key: `skeleton-col-${j}`,
              style: Ne(
                e.wrap ? u.value[K.key] ? { width: `${u.value[K.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: K.width ? "0 0 auto" : "1 1 0%",
                  width: K.width || "auto"
                } : { width: y(K.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative"
            }, [
              P[8] || (P[8] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-5 w-24" })
              ], -1)),
              (c(!0), g(ce, null, Re(e.itemsPerPage, (G) => (c(), g("div", {
                key: `skeleton-row-${j}-${G}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px]"
              }, [
                v("div", {
                  class: "skeleton h-5",
                  style: Ne({ width: U(G - 1) })
                }, null, 4)
              ]))), 128))
            ], 4))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), g("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
              style: Ne(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: y("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              P[10] || (P[10] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-5 w-16" })
              ], -1)),
              (c(!0), g(ce, null, Re(e.itemsPerPage, (K) => (c(), g("div", {
                key: `skeleton-actions-${K}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [...P[9] || (P[9] = [
                v("div", { class: "skeleton h-8 w-20" }, null, -1)
              ])]))), 128))
            ], 4)) : k("", !0),
            e.wrap ? k("", !0) : (c(), g("div", TF, [
              P[11] || (P[11] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), g(ce, null, Re(e.itemsPerPage, (K) => (c(), g("div", {
                key: `skeleton-spacer-${K}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), g("div", LF, [...P[12] || (P[12] = [
          v("div", { class: "skeleton h-5 w-32" }, null, -1),
          v("div", { class: "skeleton h-9 w-48" }, null, -1)
        ])])) : k("", !0)
      ], 64)) : (c(), g(ce, { key: 1 }, [
        v("div", {
          class: C(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5 text-slategray dark:text-[var(--colors-text-white-default)]", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), g("div", {
            key: 0,
            style: { width: "256px" },
            "data-testid": e.searchDataTestId
          }, [
            re(I(Zi), {
              modelValue: r.value,
              "onUpdate:modelValue": [
                P[0] || (P[0] = (K) => r.value = K),
                P[1] || (P[1] = (K) => E(K))
              ],
              placeholder: e.searchPlaceholder,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              size: "md",
              width: "256px"
            }, null, 8, ["modelValue", "placeholder", "labels", "icon-left"])
          ], 8, AF)) : k("", !0),
          v("div", EF, [
            e.showAddButton ? (c(), H(I(Be), {
              key: 0,
              variant: "primary",
              label: e.addButtonLabel,
              "icon-left": e.addButtonIconLeft,
              size: "sm",
              class: "flex-shrink-0 whitespace-nowrap",
              onClick: P[2] || (P[2] = () => z.$emit("add"))
            }, null, 8, ["label", "icon-left"])) : k("", !0),
            e.showFilters && e.filterSections && e.filterSections.length > 0 ? (c(), H(I(Zu), {
              key: 1,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterSections,
              "menu-width": e.filterMenuWidth,
              "menu-align": "right",
              "footer-buttons": l.value
            }, null, 8, ["label", "trigger-icon-left", "items", "menu-width", "footer-buttons"])) : e.showFilters && (!e.filterSections || e.filterSections.length === 0) ? (c(), H(I(ln), {
              key: 2,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon-left", "items"])) : k("", !0),
            e.headerActionsItems && e.headerActionsItems.length > 0 ? (c(), H(I(ln), {
              key: 3,
              label: e.actionsLabel,
              "trigger-icon": e.actionsIcon,
              items: e.headerActionsItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon", "items"])) : k("", !0)
          ])
        ], 2),
        v("div", RF, [
          v("div", BF, [
            e.showCheckbox ? (c(), g("div", DF, [
              v("div", MF, [
                v("div", zF, [
                  re(I($n), {
                    "model-value": B.value,
                    "onUpdate:modelValue": D
                  }, null, 8, ["model-value"])
                ])
              ]),
              (c(!0), g(ce, null, Re(L.value, (K) => (c(), g("div", {
                key: K.id,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [
                re(I($n), {
                  "model-value": _(K),
                  "onUpdate:modelValue": () => M(K)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]))), 128))
            ])) : k("", !0),
            (c(!0), g(ce, null, Re(e.columns, (K, j) => (c(), g("div", {
              key: j,
              style: Ne(
                e.wrap ? u.value[K.key] ? { width: `${u.value[K.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: K.width ? "0 0 auto" : "1 1 0%",
                  width: K.width || "auto"
                } : { width: y(K.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: C([
                "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
                e.wrap && !K.width && !u.value[K.key] ? "min-w-0" : ""
              ])
            }, [
              v("div", {
                class: C(["self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-(--colors-text-body) dark:text-(--colors-text-white-default) cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] transition-colors duration-200", { "opacity-50": !K.sortable }]),
                onClick: (G) => A(K)
              }, [
                v("div", PF, [
                  v("div", {
                    class: "relative leading-[20px] font-medium overflow-hidden text-ellipsis whitespace-nowrap",
                    title: K.label
                  }, N(K.label), 9, FF),
                  K.sortable && i.value === K.key ? (c(), g("img", {
                    key: 0,
                    class: "h-3.5 w-3.5 relative table-sort-icon",
                    style: Ne({
                      transform: s.value === "asc" ? "rotate(0deg)" : "rotate(180deg)"
                    }),
                    src: i.value === K.key ? "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22%3E%3Cpath d=%22M19 9l-7 7-7-7%22/%3E%3C/svg%3E" : "",
                    alt: ""
                  }, null, 12, VF)) : k("", !0)
                ])
              ], 10, OF),
              v("div", {
                class: C(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && b.value === K.key }]),
                onMousedown: (G) => w(K.key, G)
              }, null, 42, NF),
              (c(!0), g(ce, null, Re(L.value, (G) => (c(), g("div", {
                key: G.id,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px] text-text-body dark:text-[var(--colors-text-white-default)]"
              }, [
                v("div", HF, [
                  Ae(z.$slots, `cell-${K.key}`, {
                    value: G[K.key],
                    row: G,
                    column: K
                  }, () => [
                    et(N(W(G, K)), 1)
                  ], !0)
                ])
              ]))), 128))
            ], 6))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), g("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start text-[12px] text-text-body dark:text-[var(--colors-text-white-default)] relative",
              style: Ne(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: y("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              v("div", jF, [
                v("div", WF, [
                  v("div", qF, N(e.actionsColumnLabel), 1)
                ])
              ]),
              v("div", {
                class: C(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && b.value === "__actions__" }]),
                onMousedown: P[3] || (P[3] = (K) => w("__actions__", K))
              }, null, 34),
              (c(!0), g(ce, null, Re(L.value, (K) => (c(), g("div", {
                key: `actions-${K.id}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [
                Y(K).filter((j) => !j.isDelete).length > 0 ? (c(), H(I(ln), {
                  key: 0,
                  label: e.actionsColumnLabel,
                  items: Y(K).filter((j) => !j.isDelete).map((j) => ({
                    label: j.label,
                    icon: j.icon,
                    testId: j.testId,
                    onClick: () => X(j, K)
                  })),
                  "menu-width": "150px"
                }, null, 8, ["label", "items"])) : k("", !0),
                (c(!0), g(ce, null, Re(Y(K).filter((j) => j.isDelete), (j) => (c(), H(I(Be), {
                  key: j.label,
                  variant: "error",
                  label: j.label,
                  "icon-left": j.icon,
                  size: "xs",
                  onClick: () => X(j, K)
                }, null, 8, ["label", "icon-left", "onClick"]))), 128))
              ]))), 128))
            ], 4)) : k("", !0),
            e.wrap ? k("", !0) : (c(), g("div", UF, [
              P[13] || (P[13] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), g(ce, null, Re(L.value, (K) => (c(), g("div", {
                key: `spacer-${K.id}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), g("div", GF, [
          v("div", KF, N(e.paginationText(
            (d.value - 1) * e.itemsPerPage + 1,
            Math.min(d.value * e.itemsPerPage, e.totalItems),
            e.totalItems
          )), 1),
          v("div", YF, [
            re(I(xO), {
              "current-page": d.value,
              "total-pages": T.value,
              "total-items": e.totalItems,
              "items-per-page": e.itemsPerPage,
              "page-align": "end",
              "show-rows-per-page": !1,
              onPageChange: F
            }, null, 8, ["current-page", "total-pages", "total-items", "items-per-page"])
          ])
        ])) : k("", !0)
      ], 64))
    ]));
  }
}), Vq = /* @__PURE__ */ ot(JF, [["__scopeId", "data-v-2c369241"]]), XF = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.8284%2012.0007L15.7782%2016.9504L14.364%2018.3646L8%2012.0007L14.364%205.63672L15.7782%207.05093L10.8284%2012.0007Z'/%3e%3c/svg%3e", ZF = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.1717%2012.0007L8.22192%207.05093L9.63614%205.63672L16.0001%2012.0007L9.63614%2018.3646L8.22192%2016.9504L13.1717%2012.0007Z'/%3e%3c/svg%3e", QF = ["data-theme", "data-collapsed", "aria-label"], _F = { class: "flex items-center sidebar-logo" }, e6 = ["src"], t6 = {
  key: 0,
  class: "h-7.5 border-border-base-medium border-solid border-l box-border flex items-center justify-center py-num-0 pl-3 pr-num-0"
}, n6 = { class: "relative leading-5.5 font-semibold dark:text-(--colors-text-white-secondary)" }, a6 = ["aria-label", "aria-expanded"], l6 = ["src"], r6 = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, o6 = ["src"], i6 = {
  key: 0,
  class: "self-stretch border-border-base-soft border-solid border-b flex flex-col items-start pt-num-0 px-num-0 pb-4 shrink-0"
}, s6 = ["data-active", "aria-label", "aria-expanded", "aria-controls", "aria-current", "disabled"], d6 = ["src"], u6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, c6 = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary)"
}, f6 = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-text-black-default dark:text-(--colors-text-white-secondary) relative z-10"
}, h6 = { class: "relative leading-5 font-medium z-10 dark:text-(--colors-text-white-secondary)" }, b6 = ["src"], g6 = ["data-active", "aria-current", "aria-disabled", "disabled", "onClick"], m6 = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, p6 = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary)" }, v6 = { class: "self-stretch flex flex-col items-start gap-2 shrink-0 text-text-black-default dark:text-(--colors-text-white-secondary)" }, x6 = {
  key: 0,
  class: "self-stretch border-t border-border-base-soft my-1 sidebar-divider",
  "aria-hidden": "true"
}, y6 = {
  key: 1,
  class: "self-stretch flex flex-col items-start"
}, k6 = ["data-active", "data-opened", "data-testid", "aria-label", "aria-expanded", "aria-controls", "aria-current", "aria-disabled", "disabled", "onClick"], w6 = ["src"], C6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, S6 = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary) truncate"
}, $6 = ["src"], I6 = ["data-active", "data-testid", "aria-current", "aria-disabled", "disabled", "onClick"], T6 = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, L6 = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary) truncate" }, A6 = ["data-active", "data-testid", "aria-label", "aria-current", "aria-disabled", "disabled", "onClick"], E6 = ["src"], R6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, B6 = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10 dark:text-(--colors-text-white-secondary) truncate"
}, D6 = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, M6 = ["src"], z6 = { class: "self-stretch border-border-base-soft border-solid border-t shrink-0 pt-4 text-[12px] relative z-10" }, O6 = { key: 0 }, P6 = ["href"], F6 = {
  key: 1,
  class: "relative leading-5 font-medium mb-1 sidebar-footer-a11y"
}, V6 = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-secondary)" }, N6 = /* @__PURE__ */ ke({
  __name: "Sidebar",
  props: {
    companyIcon: { default: "/logo-eudonet-small.svg" },
    companyName: { default: "Eudonet" },
    items: { default: () => [] },
    modelValue: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: void 0 },
    width: { default: "239px" },
    collapsedWidth: { default: "80px" },
    theme: { default: "light" },
    footerText: { default: "Powered by Eudonet" },
    ariaLabel: {},
    accessibilityText: { default: "" },
    accessibilityLink: { default: void 0 },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 }
  },
  emits: ["update:modelValue", "update:collapsed", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R({}), o = () => {
      Object.keys(r.value).forEach((K) => {
        r.value[K] = !1;
      });
    };
    $e(
      () => t.collapsed,
      (K, j) => {
        K !== void 0 && (l.value = K, K ? o() : j === !0 && !Object.values(r.value).some(Boolean) && y());
      },
      { immediate: !0 }
    );
    const i = () => {
      const K = !l.value;
      l.value = K, a("update:collapsed", K), K ? o() : y();
    }, s = R(
      typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1
    );
    dt(() => {
      if (typeof window > "u") return;
      const K = window.matchMedia("(prefers-color-scheme: dark)"), j = (G) => {
        s.value = G.matches;
      };
      K.addEventListener("change", j), gt(() => K.removeEventListener("change", j));
    });
    const d = m(
      () => t.theme === "auto" ? s.value : t.theme === "dark"
    ), u = m(() => d.value ? "sidebar-dark" : "sidebar-light"), f = m(() => {
      const K = {};
      return t.backgroundColor && (K["--sidebar-bg"] = t.backgroundColor), t.textColor && (K["--sidebar-text"] = t.textColor), t.borderColor && (K["--sidebar-border"] = t.borderColor), t.accentColor && (K["--sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (K["--sidebar-hover-bg"] = t.hoverBackgroundColor), K.width = l.value ? t.collapsedWidth : t.width, K;
    }), b = (K) => K.key ?? K.label, h = m(() => t.items.find((K) => K.key === "bookmarks")), p = m(
      () => h.value ? b(h.value) : "bookmarks"
    ), x = m(() => t.items.filter((K) => K.key !== "bookmarks")), y = () => {
      t.items.forEach((K) => {
        var j;
        (j = K.children) != null && j.some((G) => G.active) && (r.value[b(K)] = !0);
      });
    };
    dt(() => {
      l.value || y();
    });
    const w = (K) => r.value[K] === !0, $ = (K) => {
      const j = !r.value[K];
      j && Object.keys(r.value).forEach((G) => {
        G !== K && (r.value[G] = !1);
      }), r.value[K] = j;
    }, S = R(null), L = R(!1), T = R(!1), E = () => {
      const K = S.value;
      K && (L.value = K.scrollTop > 4, T.value = K.scrollTop + K.clientHeight < K.scrollHeight - 4);
    }, A = () => {
      const K = S.value;
      K && K.scrollBy({ top: -100, behavior: "smooth" });
    }, D = () => {
      const K = S.value;
      K && K.scrollBy({ top: 100, behavior: "smooth" });
    };
    let M = null, F = null;
    dt(() => {
      setTimeout(() => {
        E();
        const K = S.value;
        K && (F = new ResizeObserver(() => E()), F.observe(K), M = new MutationObserver(() => E()), M.observe(K, { childList: !0, subtree: !0 }));
      }, 0);
    }), gt(() => {
      F == null || F.disconnect(), F = null, M == null || M.disconnect(), M = null;
    }), $e(
      r,
      () => {
        Ue(E), setTimeout(E, 100), setTimeout(E, 200), setTimeout(E, 350);
      },
      { deep: !0 }
    );
    const X = (K) => {
      if (K.disabled) return;
      const j = K.children !== void 0 && K.children.length > 0;
      l.value ? (l.value = !1, a("update:collapsed", !1), j ? $(b(K)) : y()) : j && $(b(K)), K.onClick && K.onClick(), a("item-click", K);
    }, _ = (K) => {
      var j;
      return K.active === !0 || l.value && (((j = K.children) == null ? void 0 : j.some((G) => G.active)) ?? !1);
    }, Y = Mn(), B = m(() => !!Y.logo), W = m(
      () => l.value ? "/logo-eudonet-small.svg" : t.companyIcon
    ), U = (K) => {
      const j = "group self-stretch flex items-center justify-start py-num-6 pl-num-32 pr-num-8 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 relative text-left sidebar-child-item";
      return K.disabled ? `${j} opacity-50 cursor-not-allowed` : K.active ? `${j} rounded-[48px] overflow-visible sidebar-item-active` : `${j} rounded-num-12 sidebar-item-hover`;
    }, z = (K) => {
      const j = "group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-simple-item";
      return K.disabled ? `${j} opacity-50 cursor-not-allowed` : K.active ? `${j} relative overflow-visible sidebar-item-active` : `${j} sidebar-item-hover`;
    }, P = () => 'h-5.5 w-5.5 rounded-full relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-full before:[background:var(--sidebar-accent)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-full after:transition-opacity after:duration-300 after:z-[1] sidebar-badge';
    return (K, j) => e.modelValue ? (c(), g("nav", {
      key: 0,
      class: C(["h-full relative shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-tl-none rounded-tr-3xl rounded-b-none box-border flex flex-col items-start text-left text-[18px] font-inter transition-all duration-300 sidebar-container", [u.value, { "sidebar-collapsed": l.value }, l.value ? "p-2" : "p-5"]]),
      "data-theme": d.value ? "dark" : "light",
      "data-collapsed": l.value ? "true" : "false",
      style: Ne(f.value),
      "aria-label": e.ariaLabel ?? "Main navigation"
    }, [
      v("div", {
        class: C([
          "self-stretch border-border-base-soft border-solid border-b pt-num-0 px-num-0 relative z-[2] shrink-0",
          l.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-5"
        ])
      }, [
        v("div", {
          class: C(["flex items-center gap-3", [{ "justify-center": l.value }, { "flex-1": !l.value }]])
        }, [
          v("div", _F, [
            B.value ? Ae(K.$slots, "logo", {
              key: 0,
              collapsed: l.value
            }, void 0, !0) : W.value ? (c(), g("img", {
              key: 1,
              class: "h-7 w-7 relative",
              src: W.value,
              alt: "Company logo"
            }, null, 8, e6)) : k("", !0)
          ]),
          l.value ? k("", !0) : (c(), g("div", t6, [
            v("div", n6, N(e.companyName), 1)
          ]))
        ], 2),
        v("button", {
          type: "button",
          class: "sidebar-toggle-button shrink-0 h-6 w-6 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center cursor-pointer hover:border-gray-300 transition-colors duration-200",
          "aria-label": l.value ? "Expand sidebar" : "Collapse sidebar",
          "aria-expanded": !l.value,
          onClick: i
        }, [
          v("img", {
            src: l.value ? I(ZF) : I(XF),
            class: "h-4 w-4 relative sidebar-toggle-icon",
            alt: "",
            "aria-hidden": "true"
          }, null, 8, l6)
        ], 8, a6)
      ], 2),
      re(wt, { name: "fade" }, {
        default: xe(() => [
          L.value ? (c(), g("div", r6, [
            v("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll up",
              onClick: A
            }, [
              v("img", {
                src: I(Zo),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, o6)
            ]),
            j[1] || (j[1] = v("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1))
          ])) : k("", !0)
        ]),
        _: 1
      }),
      v("div", {
        ref_key: "scrollAreaRef",
        ref: S,
        class: "flex-1 min-h-0 overflow-y-auto self-stretch flex flex-col gap-4 py-4 text-num-16 dark:text-(--colors-text-white-secondary) sidebar-scroll-area relative z-[2]",
        onScroll: E
      }, [
        h.value ? (c(), g("div", i6, [
          re(ft, {
            text: h.value.label,
            position: "right",
            disabled: !l.value,
            class: "self-stretch flex-col"
          }, {
            default: xe(() => {
              var G;
              return [
                v("button", {
                  type: "button",
                  class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                    { "justify-center": l.value },
                    { "sidebar-item-active": _(h.value) },
                    { "opacity-50 cursor-not-allowed": h.value.disabled }
                  ]]),
                  "data-active": _(h.value) ? "true" : "false",
                  "aria-label": l.value ? h.value.label : void 0,
                  "aria-expanded": w(p.value),
                  "aria-controls": (G = h.value.children) != null && G.length ? "sidebar-submenu-bookmarks" : void 0,
                  "aria-current": h.value.active ? "page" : void 0,
                  disabled: h.value.disabled,
                  onClick: j[0] || (j[0] = (q) => X(h.value))
                }, [
                  v("div", {
                    class: C(["flex-1 flex items-center gap-1.5", { "justify-center": l.value }])
                  }, [
                    h.value.icon ? (c(), g("img", {
                      key: 0,
                      class: "h-5 w-5 relative shrink-0",
                      src: h.value.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, d6)) : (c(), g("div", u6)),
                    l.value ? k("", !0) : (c(), g("div", c6, N(h.value.label), 1))
                  ], 2),
                  l.value ? k("", !0) : (c(), g("div", f6, [
                    v("div", {
                      class: C(P())
                    }, [
                      v("div", h6, N(h.value.badge ?? 0), 1)
                    ], 2),
                    v("img", {
                      class: "h-4 w-4 relative z-10 transition-transform duration-200",
                      src: w(p.value) ? I(Zo) : I(Dl),
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, b6)
                  ]))
                ], 10, s6)
              ];
            }),
            _: 1
          }, 8, ["text", "disabled"]),
          h.value.children && h.value.children.length > 0 ? (c(), H(Pr, {
            key: 0,
            id: "sidebar-submenu-bookmarks",
            name: "submenu",
            tag: "div",
            role: "region",
            "aria-label": `${h.value.label} submenu`,
            class: C([
              "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
              { "submenu-open": w(p.value) }
            ])
          }, {
            default: xe(() => [
              (c(!0), g(ce, null, Re(w(p.value) ? h.value.children : [], (G) => (c(), g("button", {
                key: b(G),
                type: "button",
                class: C(U(G)),
                "data-active": G.active ? "true" : "false",
                "aria-current": G.active ? "page" : void 0,
                "aria-disabled": G.disabled ? "true" : void 0,
                disabled: G.disabled,
                onClick: (q) => X(G)
              }, [
                v("div", m6, [
                  v("div", p6, N(G.label), 1)
                ])
              ], 10, g6))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "class"])) : k("", !0)
        ])) : k("", !0),
        v("div", v6, [
          (c(!0), g(ce, null, Re(x.value, (G) => (c(), g(ce, {
            key: b(G)
          }, [
            G.divider ? (c(), g("hr", x6)) : k("", !0),
            G.children !== void 0 ? (c(), g("div", y6, [
              re(ft, {
                text: G.label,
                position: "right",
                disabled: !l.value,
                class: "self-stretch flex-col"
              }, {
                default: xe(() => {
                  var q;
                  return [
                    v("button", {
                      type: "button",
                      class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                        { "justify-center": l.value },
                        { "sidebar-item-active": _(G) },
                        {
                          "sidebar-item-opened": (w(b(G)) || ((q = G.children) == null ? void 0 : q.some((J) => J.active))) && !G.active
                        },
                        { "opacity-50 cursor-not-allowed": G.disabled }
                      ]]),
                      "data-active": _(G) ? "true" : "false",
                      "data-opened": w(b(G)) ? "true" : "false",
                      "data-testid": G.testId,
                      "aria-label": l.value ? G.label : void 0,
                      "aria-expanded": w(b(G)),
                      "aria-controls": `sidebar-submenu-${b(G)}`,
                      "aria-current": G.active ? "page" : void 0,
                      "aria-disabled": G.disabled ? "true" : void 0,
                      disabled: G.disabled,
                      onClick: (J) => X(G)
                    }, [
                      v("div", {
                        class: C(["flex-1 flex items-center gap-1.5 min-w-0", { "justify-center": l.value }])
                      }, [
                        G.icon ? (c(), g("img", {
                          key: 0,
                          class: "h-5 w-5 relative shrink-0",
                          src: G.icon,
                          alt: "",
                          "aria-hidden": "true"
                        }, null, 8, w6)) : (c(), g("div", C6)),
                        l.value ? k("", !0) : (c(), g("div", S6, N(G.label), 1))
                      ], 2),
                      !l.value && G.children.length > 0 ? (c(), g("img", {
                        key: 0,
                        class: "h-4 w-4 relative transition-transform duration-200 shrink-0",
                        src: w(b(G)) ? I(Zo) : I(Dl),
                        alt: "",
                        "aria-hidden": "true"
                      }, null, 8, $6)) : k("", !0)
                    ], 10, k6)
                  ];
                }),
                _: 2
              }, 1032, ["text", "disabled"]),
              re(Pr, {
                id: `sidebar-submenu-${b(G)}`,
                name: "submenu",
                tag: "div",
                role: "region",
                "aria-label": `${G.label} submenu`,
                class: C([
                  "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                  { "submenu-open": w(b(G)) }
                ])
              }, {
                default: xe(() => [
                  (c(!0), g(ce, null, Re(w(b(G)) ? G.children : [], (q) => (c(), g("button", {
                    key: b(q),
                    type: "button",
                    class: C(U(q)),
                    "data-active": q.active ? "true" : "false",
                    "data-testid": q.testId,
                    "aria-current": q.active ? "page" : void 0,
                    "aria-disabled": q.disabled ? "true" : void 0,
                    disabled: q.disabled,
                    onClick: (J) => X(q)
                  }, [
                    v("div", T6, [
                      v("div", L6, N(q.label), 1)
                    ])
                  ], 10, I6))), 128))
                ]),
                _: 2
              }, 1032, ["id", "aria-label", "class"])
            ])) : (c(), H(ft, {
              key: 2,
              text: G.label,
              position: "right",
              disabled: !l.value,
              class: "self-stretch flex-col"
            }, {
              default: xe(() => [
                v("button", {
                  type: "button",
                  class: C([z(G), { "justify-center": l.value }]),
                  "data-active": G.active ? "true" : "false",
                  "data-testid": G.testId,
                  "aria-label": l.value ? G.label : void 0,
                  "aria-current": G.active ? "page" : void 0,
                  "aria-disabled": G.disabled ? "true" : void 0,
                  disabled: G.disabled,
                  onClick: (q) => X(G)
                }, [
                  v("div", {
                    class: C(["flex-1 flex items-center gap-1.5 relative z-10 min-w-0", { "justify-center": l.value }])
                  }, [
                    G.icon ? (c(), g("img", {
                      key: 0,
                      class: "h-5 w-5 relative z-10 shrink-0",
                      src: G.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, E6)) : (c(), g("div", R6)),
                    l.value ? k("", !0) : (c(), g("div", B6, N(G.label), 1))
                  ], 2)
                ], 10, A6)
              ]),
              _: 2
            }, 1032, ["text", "disabled"]))
          ], 64))), 128))
        ])
      ], 544),
      re(wt, { name: "fade" }, {
        default: xe(() => [
          T.value ? (c(), g("div", D6, [
            j[2] || (j[2] = v("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1)),
            v("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll down",
              onClick: D
            }, [
              v("img", {
                src: I(Dl),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, M6)
            ])
          ])) : k("", !0)
        ]),
        _: 1
      }),
      v("div", z6, [
        l.value ? k("", !0) : (c(), g("div", O6, [
          Ae(K.$slots, "footer", {}, () => [
            e.accessibilityText && e.accessibilityLink ? (c(), g("a", {
              key: 0,
              href: e.accessibilityLink,
              class: "block relative leading-5 font-medium mb-1 underline sidebar-footer-a11y-link"
            }, N(e.accessibilityText), 9, P6)) : e.accessibilityText ? (c(), g("div", F6, N(e.accessibilityText), 1)) : k("", !0),
            v("div", V6, N(e.footerText), 1)
          ], !0)
        ]))
      ])
    ], 14, QF)) : k("", !0);
  }
}), Nq = /* @__PURE__ */ ot(N6, [["__scopeId", "data-v-0fb03d0f"]]), H6 = { class: "px-4 pt-5 pb-4" }, j6 = { class: "text-lg font-semibold secondary-sidebar-title" }, W6 = { class: "flex flex-col gap-8 px-4 pb-5" }, q6 = { class: "text-xs font-medium uppercase tracking-wider secondary-sidebar-group-header" }, U6 = {
  key: 0,
  class: "flex flex-col gap-1"
}, G6 = ["aria-expanded", "aria-controls", "data-testid", "onClick"], K6 = { class: "text-sm font-medium secondary-sidebar-item-text" }, Y6 = ["id"], J6 = ["data-active", "aria-current", "data-testid", "onClick"], X6 = { class: "text-sm font-medium secondary-sidebar-item-text" }, Z6 = ["data-active", "aria-current", "data-testid", "onClick"], Q6 = { class: "text-sm font-medium secondary-sidebar-item-text" }, _6 = /* @__PURE__ */ ke({
  __name: "SecondarySidebar",
  props: {
    title: { default: "Settings" },
    groups: { default: () => [
      {
        label: "Profile management",
        items: [
          { label: "Profile" },
          { label: "Security information", active: !0 },
          { label: "Permissions" },
          { label: "Notification settings" }
        ]
      },
      {
        label: "Organisation management",
        items: [
          { label: "Global settings" },
          { label: "Users" },
          { label: "Security" },
          { label: "Configuration" },
          { label: "IA" },
          { label: "Billing & Plan" }
        ]
      },
      {
        label: "Module management",
        items: [{ label: "Global settings" }, { label: "Contact" }, { label: "Security" }]
      }
    ] },
    theme: { default: "light" },
    width: { default: "248px" },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 },
    groupHeaderColor: { default: void 0 }
  },
  emits: ["item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.theme === "auto" ? typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1 : t.theme === "dark"), r = m(() => l.value ? "secondary-sidebar-dark" : "secondary-sidebar-light"), o = m(() => {
      const S = {};
      return t.backgroundColor && (S["--secondary-sidebar-bg"] = t.backgroundColor), t.textColor && (S["--secondary-sidebar-text"] = t.textColor), t.borderColor && (S["--secondary-sidebar-border"] = t.borderColor), t.accentColor && (S["--secondary-sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (S["--secondary-sidebar-hover-bg"] = t.hoverBackgroundColor), t.groupHeaderColor && (S["--secondary-sidebar-group-header"] = t.groupHeaderColor), S.width = t.width || "248px", S;
    }), i = je(), s = (S, L) => `${i}-category-${S}-${L}`, d = (S) => S.testId ?? S.label, u = (S, L) => L.key ?? `${S.label}/${d(L)}`, f = (S) => S.children !== void 0, b = (S) => {
      var L;
      return (L = S.children) == null ? void 0 : L.find((T) => T.active);
    }, h = R({}), p = (S, L) => h.value[u(S, L)] ?? (b(L) !== void 0 || L.defaultExpanded === !0), x = (S, L) => {
      h.value = {
        ...h.value,
        [u(S, L)]: !p(S, L)
      };
    }, y = m(() => {
      const S = {};
      for (const L of t.groups)
        for (const T of L.items) {
          const E = f(T) ? b(T) : void 0;
          E && (S[u(L, T)] = d(E));
        }
      return S;
    });
    $e(y, (S, L) => {
      const T = Object.keys(S).filter((A) => S[A] !== L[A]);
      if (T.length === 0) return;
      const E = { ...h.value };
      for (const A of T) delete E[A];
      h.value = E;
    });
    const w = (S, L) => {
      S.onClick && S.onClick(), a("item-click", S, L);
    }, $ = (S) => {
      const L = "w-full text-left py-2 cursor-pointer transition-all duration-200 secondary-sidebar-item";
      return S.active ? `${L} secondary-sidebar-item-active` : `${L} secondary-sidebar-item-hover`;
    };
    return (S, L) => (c(), g("aside", {
      class: C(["h-full flex flex-col box-border overflow-y-auto overflow-x-hidden secondary-sidebar-container", r.value]),
      style: Ne(o.value)
    }, [
      v("div", H6, [
        v("h2", j6, N(e.title), 1)
      ]),
      v("div", W6, [
        (c(!0), g(ce, null, Re(e.groups, (T, E) => (c(), g("div", {
          key: E,
          class: "flex flex-col gap-1"
        }, [
          v("div", q6, N(T.label), 1),
          (c(!0), g(ce, null, Re(T.items, (A, D) => (c(), g(ce, {
            key: `${E}-${D}`
          }, [
            f(A) ? (c(), g("div", U6, [
              v("button", {
                type: "button",
                class: "w-[calc(100%+24px)] -mx-3 px-3 flex items-center justify-between gap-2 text-left py-2 rounded-lg cursor-pointer transition-colors duration-200 secondary-sidebar-item hover:bg-(--secondary-sidebar-hover-bg)",
                "aria-expanded": p(T, A) ? "true" : "false",
                "aria-controls": s(E, D),
                "data-testid": A.testId,
                onClick: (M) => x(T, A)
              }, [
                v("span", K6, N(A.label), 1),
                v("i", {
                  class: C([
                    p(T, A) ? "ri-arrow-down-s-line" : "ri-arrow-right-s-line",
                    "text-base leading-none secondary-sidebar-item-text"
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 8, G6),
              Jl(v("div", {
                id: s(E, D),
                class: "flex flex-col gap-1 pl-3"
              }, [
                (c(!0), g(ce, null, Re(A.children, (M, F) => (c(), g("button", {
                  key: `${E}-${D}-${F}`,
                  type: "button",
                  class: C($(M)),
                  "data-active": M.active ? "true" : "false",
                  "aria-current": M.active ? "page" : void 0,
                  "data-testid": M.testId,
                  onClick: (X) => w(M, T)
                }, [
                  v("span", X6, N(M.label), 1)
                ], 10, J6))), 128))
              ], 8, Y6), [
                [Tu, p(T, A)]
              ])
            ])) : (c(), g("button", {
              key: 1,
              type: "button",
              class: C($(A)),
              "data-active": A.active ? "true" : "false",
              "aria-current": A.active ? "page" : void 0,
              "data-testid": A.testId,
              onClick: (M) => w(A, T)
            }, [
              v("span", Q6, N(A.label), 1)
            ], 10, Z6))
          ], 64))), 128))
        ]))), 128))
      ])
    ], 6));
  }
}), Hq = /* @__PURE__ */ ot(_6, [["__scopeId", "data-v-4e518031"]]), eV = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "FormSaveButton",
  props: {
    enabled: { type: Boolean },
    saving: { type: Boolean },
    saveLabel: {},
    savingLabel: {},
    disabledHint: {}
  },
  emits: ["save"],
  setup(e, { expose: n }) {
    const t = R(null);
    return n({ buttonElement: m(() => {
      var a;
      return ((a = t.value) == null ? void 0 : a.$el) ?? null;
    }) }), (a, l) => (c(), H(ft, {
      text: e.disabledHint ?? "",
      disabled: e.enabled || e.saving || !e.disabledHint
    }, {
      default: xe(() => [
        re(Be, Oe({
          ref_key: "buttonRef",
          ref: t
        }, a.$attrs, {
          variant: "primary",
          "icon-left": "ri-save-line",
          label: e.saveLabel,
          "aria-disabled": !e.enabled,
          loading: e.saving,
          "loading-label": e.savingLabel,
          onClick: l[0] || (l[0] = (r) => a.$emit("save"))
        }), null, 16, ["label", "aria-disabled", "loading", "loading-label"])
      ]),
      _: 1
    }, 8, ["text", "disabled"]));
  }
}), tV = {
  class: "flex",
  "data-testid": "nav-header-badges"
}, Qo = /* @__PURE__ */ ke({
  __name: "NavHeaderBadges",
  props: {
    badges: {}
  },
  setup(e) {
    return (n, t) => (c(), g("div", tV, [
      (c(!0), g(ce, null, Re(e.badges, (a, l) => (c(), g(ce, { key: l }, [
        I(Fu)(a) ? (c(), H(Pu, {
          key: 0,
          label: a.label,
          "hidden-labels": a.hiddenLabels
        }, null, 8, ["label", "hidden-labels"])) : (c(), H(ct, {
          key: 1,
          label: a.label,
          theme: a.theme ?? "neutral",
          size: "sm",
          "left-icon": a.icon,
          "show-left-icon": !!a.icon,
          truncate: a.truncate ?? !0,
          "show-close-icon": !1
        }, null, 8, ["label", "theme", "left-icon", "show-left-icon", "truncate"]))
      ], 64))), 128))
    ]));
  }
}), nV = { class: "box-border flex w-full flex-col justify-center border-b border-solid border-(--colors-border-base-medium) px-5 pt-3 pb-[calc(--spacing(3)-1px)]" }, aV = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-5 gap-y-2 self-stretch",
  "data-testid": "navbar-editor"
}, lV = {
  class: "flex min-w-0 grow basis-48 items-center gap-5",
  "data-testid": "navbar-left"
}, rV = {
  class: "flex min-w-0 items-center",
  "data-testid": "navbar-title"
}, oV = {
  key: 0,
  class: "ml-auto flex max-w-full min-w-0 flex-wrap items-center justify-end gap-2",
  "data-testid": "navbar-actions"
}, iV = {
  key: 0,
  class: "flex min-w-0 items-center gap-1 px-px text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "navbar-status"
}, sV = {
  key: 1,
  class: "flex min-w-0 flex-wrap items-center justify-between gap-x-8 gap-y-2 self-stretch"
}, dV = {
  class: "flex min-w-0 grow basis-48 items-center gap-4",
  "data-testid": "navbar-left"
}, uV = {
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-2",
  "data-testid": "navbar-right"
}, jq = /* @__PURE__ */ ke({
  __name: "Navbar",
  props: {
    type: { default: "default" },
    backLabel: { default: void 0 },
    title: { default: "" },
    editableTitle: { type: Boolean, default: !0 },
    titleError: { default: void 0 },
    editTitleLabel: { default: "" },
    saveTitleLabel: { default: "" },
    editorBadges: { default: () => [] },
    editorStatus: { default: void 0 },
    editorActions: { default: () => [] },
    searchPlaceholder: { default: "" },
    searchLabel: { default: void 0 },
    searchControls: { default: void 0 },
    searchExpanded: { type: Boolean, default: !1 },
    searchActivedescendant: { default: void 0 },
    searchClearLabel: { default: void 0 },
    searchIcon: { default: void 0 },
    filterIcon: { default: void 0 },
    filterLabel: { default: void 0 },
    actions: { default: () => [] },
    avatar: { default: void 0 },
    searchWidth: { default: "453px" },
    searchSize: { default: "sm" },
    searchValue: { default: "" },
    searchDisabled: { type: Boolean, default: !1 },
    avatarDropdownItems: { default: void 0 },
    avatarDropdownWidth: { default: "288px" },
    avatarDropdownAriaLabel: { default: void 0 }
  },
  emits: ["action-click", "editor-action-click", "back", "update:title", "update:searchValue", "search-click", "search-keydown", "search-blur", "filter-click"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null);
    n({
      /** The `<button>` of the `form-save` editor action, or null when there is none */
      buttonElement: m(() => {
        var p, x;
        return ((x = (p = r.value) == null ? void 0 : p[0]) == null ? void 0 : x.buttonElement) ?? null;
      })
    });
    const o = R(a.searchValue || "");
    $e(
      () => a.searchValue,
      (p) => {
        o.value = p || "";
      }
    ), $e(o, (p) => {
      l("update:searchValue", p);
    });
    let i = !1;
    const s = (p) => p.target instanceof HTMLInputElement, d = (p) => {
      s(p) && (i = document.activeElement === p.target);
    }, u = (p) => {
      const x = p.relatedTarget;
      p.currentTarget.contains(x) || s(p) && l("search-click");
    }, f = (p) => {
      i = !1, p.currentTarget.contains(p.relatedTarget) || l("search-blur");
    }, b = (p) => {
      s(p) && i && l("search-click");
    }, h = (p, x) => {
      p.onClick && p.onClick(), l("action-click", p, x);
    };
    return (p, x) => (c(), g("header", nV, [
      e.type === "editor" ? (c(), g("div", aV, [
        re(I(Be), {
          variant: "ghost",
          size: "md",
          "icon-left": "ri-arrow-left-line",
          label: e.backLabel,
          "data-testid": "navbar-back",
          onClick: x[0] || (x[0] = (y) => l("back"))
        }, null, 8, ["label"]),
        x[5] || (x[5] = v("span", {
          class: "h-8 w-px shrink-0 bg-(--colors-border-base-medium)",
          "aria-hidden": "true",
          "data-testid": "navbar-divider"
        }, null, -1)),
        v("div", lV, [
          v("div", rV, [
            re(Vc, {
              "model-value": e.title,
              editable: e.editableTitle,
              error: e.titleError,
              "edit-label": e.editTitleLabel,
              "save-label": e.saveTitleLabel,
              "max-width": "100%",
              onSave: x[1] || (x[1] = (y) => l("update:title", y))
            }, null, 8, ["model-value", "editable", "error", "edit-label", "save-label"])
          ]),
          e.editorBadges.length ? (c(), H(Qo, {
            key: 0,
            badges: e.editorBadges,
            class: "shrink-0 items-start gap-1.5",
            "data-testid": "navbar-badges"
          }, null, 8, ["badges"])) : k("", !0)
        ]),
        e.editorStatus || e.editorActions.length ? (c(), g("div", oV, [
          e.editorStatus ? (c(), g("div", iV, [
            e.editorStatus.icon ? (c(), g("i", {
              key: 0,
              class: C([e.editorStatus.icon, "shrink-0 text-(length:--icon-size-xs) leading-(--icon-size-xs) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"]),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0),
            re(ht, {
              text: e.editorStatus.label,
              class: "min-w-0",
              "data-testid": "navbar-status-text"
            }, null, 8, ["text"])
          ])) : k("", !0),
          (c(!0), g(ce, null, Re(e.editorActions, (y, w) => (c(), g(ce, { key: w }, [
            y.kind === "form-save" ? (c(), H(eV, {
              key: 0,
              ref_for: !0,
              ref_key: "saveButtonRef",
              ref: r,
              enabled: y.enabled,
              saving: y.saving,
              "save-label": y.label,
              "saving-label": y.savingLabel,
              "disabled-hint": y.disabledHint,
              class: "shrink-0",
              "data-testid": "navbar-save",
              onSave: ($) => l("editor-action-click", y, w)
            }, null, 8, ["enabled", "saving", "save-label", "saving-label", "disabled-hint", "onSave"])) : (c(), H(I(Be), {
              key: 1,
              variant: y.variant,
              size: "md",
              "icon-left": y.icon,
              label: y.label,
              disabled: y.disabled,
              class: "shrink-0",
              onClick: ($) => l("editor-action-click", y, w)
            }, null, 8, ["variant", "icon-left", "label", "disabled", "onClick"]))
          ], 64))), 128))
        ])) : k("", !0)
      ])) : (c(), g("div", sV, [
        v("div", dV, [
          v("div", {
            role: "search",
            class: "min-w-0 flex-1",
            style: Ne({ maxWidth: e.searchWidth }),
            "data-testid": "navbar-search",
            onMousedown: d,
            onFocusin: u,
            onFocusout: f,
            onClick: b
          }, [
            re(Zi, {
              modelValue: o.value,
              "onUpdate:modelValue": x[2] || (x[2] = (y) => o.value = y),
              placeholder: e.searchPlaceholder,
              "aria-label": e.searchLabel,
              "aria-controls": e.searchControls,
              "aria-expanded": e.searchExpanded,
              "aria-activedescendant": e.searchActivedescendant,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              size: e.searchSize,
              disabled: e.searchDisabled,
              rounded: "full",
              onKeydown: x[3] || (x[3] = (y) => l("search-keydown", y))
            }, null, 8, ["modelValue", "placeholder", "aria-label", "aria-controls", "aria-expanded", "aria-activedescendant", "labels", "icon-left", "size", "disabled"])
          ], 36),
          e.filterIcon ? (c(), H(I(Be), {
            key: 0,
            variant: "primary",
            "icon-left": e.filterIcon,
            "icon-only": "",
            size: "xs",
            "aria-label": e.filterLabel,
            "data-testid": "navbar-filter",
            onClick: x[4] || (x[4] = () => p.$emit("filter-click"))
          }, null, 8, ["icon-left", "aria-label"])) : k("", !0)
        ]),
        v("div", uV, [
          (c(!0), g(ce, null, Re(e.actions, (y, w) => (c(), g(ce, { key: w }, [
            y.icon ? (c(), H(I(Be), {
              key: 0,
              variant: "secondary",
              "icon-left": y.icon,
              "icon-only": "",
              size: "xs",
              "aria-label": y.label || y.alt,
              onClick: ($) => h(y, w)
            }, null, 8, ["icon-left", "aria-label", "onClick"])) : k("", !0)
          ], 64))), 128)),
          e.avatar && !e.avatarDropdownItems ? (c(), H(Mt, {
            key: 0,
            name: e.avatar.name,
            img: e.avatar.img
          }, null, 8, ["name", "img"])) : k("", !0),
          e.avatar && e.avatarDropdownItems ? (c(), H(ln, {
            key: 1,
            avatar: e.avatar,
            items: e.avatarDropdownItems,
            "menu-align": "right",
            "menu-width": e.avatarDropdownWidth,
            "aria-label": e.avatarDropdownAriaLabel
          }, null, 8, ["avatar", "items", "menu-width", "aria-label"])) : k("", !0)
        ])
      ]))
    ]));
  }
}), cV = {
  "data-testid": "segmented-pager",
  role: "group",
  class: "inline-flex items-center shadow-(--blur-shadow-xs)"
}, fV = /* @__PURE__ */ ke({
  __name: "SegmentedPager",
  props: {
    prevLabel: {},
    nextLabel: {},
    prevDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", cV, [
      re(Be, {
        variant: "secondary",
        size: "md",
        "icon-left": "ri-arrow-left-s-line",
        label: e.prevLabel,
        disabled: e.prevDisabled,
        "data-testid": "segmented-pager-prev",
        class: C(I(qv)),
        onClick: l[0] || (l[0] = (r) => t("prev"))
      }, null, 8, ["label", "disabled", "class"]),
      re(Be, {
        variant: "secondary",
        size: "md",
        "icon-right": "ri-arrow-right-s-line",
        label: e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "segmented-pager-next",
        class: C(I(Uv)),
        onClick: l[1] || (l[1] = (r) => t("next"))
      }, null, 8, ["label", "disabled", "class"])
    ]));
  }
}), hV = {
  class: "nav-header-title flex min-w-0 text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-title"
}, bV = /* @__PURE__ */ ke({
  __name: "NavHeaderTitle",
  props: {
    title: {},
    placeholder: {},
    editable: {}
  },
  emits: ["save"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => t.title.trim() ? t.title : t.placeholder ?? ""), l = n;
    return (r, o) => (c(), g("h1", hV, [
      e.editable ? (c(), H(Vc, {
        key: 0,
        "model-value": e.title,
        "empty-text": e.placeholder,
        placeholder: e.placeholder,
        "edit-label": e.editable.editLabel,
        "save-label": e.editable.saveLabel,
        size: "lg",
        "max-width": "100%",
        onSave: o[0] || (o[0] = (i) => l("save", i))
      }, null, 8, ["model-value", "empty-text", "placeholder", "edit-label", "save-label"])) : (c(), H(ht, {
        key: 1,
        text: a.value,
        position: "bottom"
      }, null, 8, ["text"]))
    ]));
  }
}), gV = /* @__PURE__ */ ot(bV, [["__scopeId", "data-v-615995d8"]]), mV = {
  ref: "root",
  class: "flex min-w-0 flex-col",
  "data-testid": "nav-header"
}, pV = {
  key: 0,
  class: "flex",
  "data-testid": "nav-header-back-row"
}, vV = {
  key: 0,
  class: "flex min-w-0 items-start gap-2"
}, xV = {
  key: 0,
  class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-description"
}, yV = {
  key: 2,
  class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-description"
}, kV = {
  key: 2,
  class: "flex shrink-0 items-center gap-1.5",
  "data-testid": "nav-header-icon-actions"
}, Wq = /* @__PURE__ */ ke({
  __name: "NavHeader",
  props: {
    type: {},
    title: {},
    titlePlaceholder: { default: "" },
    back: { default: void 0 },
    description: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    avatar: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    iconActions: { default: () => [] },
    pagination: { default: void 0 },
    editableTitle: { default: void 0 }
  },
  emits: ["back", "primary-action", "primary-action-select", "secondary-action", "icon-action", "prev", "next", "title-save", "avatar-edit"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = Yn("root");
    n({
      /**
       * Focuses the button of `iconActions[index]` (the trigger, for an action with a menu). For a host
       * returning focus after the menu item it opened closed: the item is unmounted with the menu, so
       * the overlay's own focus restore has nothing to land on.
       */
      focusIconAction(S) {
        var T, E;
        const L = (T = r.value) == null ? void 0 : T.querySelectorAll(
          '[data-testid="nav-header-icon-action"]'
        );
        (E = L == null ? void 0 : L[S]) == null || E.focus();
      }
    });
    const o = m(() => a.type === "wizard"), i = m(() => a.type === "table"), s = m(() => a.type === "record"), d = m(() => a.type === "settings");
    function u(S) {
      var L;
      if ((L = a.back) != null && L.href) {
        if (S.ctrlKey || S.metaKey || S.shiftKey || S.altKey || S.button !== 0) return;
        S.preventDefault();
      }
      l("back");
    }
    const f = m(() => !!a.back && !i.value), b = m(() => {
      var S;
      return !!((S = a.description) != null && S.trim()) && !s.value;
    }), h = m(
      () => s.value ? Vu(a.badges, a.maxBadges) : a.badges
    ), p = m(() => !!a.secondaryAction && !o.value), x = m(() => a.iconActions.length > 0 && (i.value || s.value)), y = m(() => o.value ? "md" : "lg"), w = {
      wizard: "min-h-18 gap-x-4 gap-y-3",
      table: "items-start gap-x-4 gap-y-3 px-0.5 py-3",
      record: "items-start justify-between gap-x-4 gap-y-3 py-1",
      settings: "items-center gap-y-3"
    }, $ = {
      wizard: "items-end",
      table: "items-center self-stretch",
      record: "items-center self-stretch",
      settings: "items-center"
    };
    return (S, L) => (c(), g("div", mV, [
      s.value && e.back ? (c(), g("div", pV, [
        re(Be, {
          variant: "text",
          size: "sm",
          "icon-left": "ri-arrow-left-line",
          label: e.back.label,
          as: e.back.href ? "a" : "button",
          href: e.back.href,
          "data-testid": "nav-header-back",
          onClick: u
        }, null, 8, ["label", "as", "href"])
      ])) : k("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-wrap", w[e.type]]),
        "data-testid": "nav-header-row"
      }, [
        v("div", {
          class: C(["flex min-w-0 grow basis-64", {
            "flex-col items-start": o.value || d.value,
            "min-h-10 flex-col justify-center gap-1": i.value,
            "items-center gap-2": s.value
          }]),
          "data-testid": "nav-header-left"
        }, [
          f.value && !s.value ? (c(), H(Be, {
            key: 0,
            variant: "text",
            size: "sm",
            "icon-left": "ri-arrow-left-line",
            label: e.back.label,
            as: e.back.href ? "a" : "button",
            href: e.back.href,
            "data-testid": "nav-header-back",
            onClick: u
          }, null, 8, ["label", "as", "href"])) : k("", !0),
          s.value && e.avatar ? (c(), H(ft, {
            key: 1,
            text: e.avatar.editDisabledReason ?? "",
            disabled: !e.avatar.editLabel || !e.avatar.editDisabledReason
          }, {
            default: xe(() => [
              re(Mt, {
                name: e.avatar.name,
                img: e.avatar.img,
                entity: e.avatar.entity,
                "avatar-style": e.avatar.avatarStyle ?? "square",
                size: "xl",
                presentational: !e.avatar.editLabel,
                editable: !!e.avatar.editLabel,
                "edit-label": e.avatar.editLabel,
                "edit-disabled": !!e.avatar.editDisabledReason,
                "data-testid": "nav-header-avatar",
                onEdit: L[0] || (L[0] = (T) => l("avatar-edit"))
              }, null, 8, ["name", "img", "entity", "avatar-style", "presentational", "editable", "edit-label", "edit-disabled"])
            ]),
            _: 1
          }, 8, ["text", "disabled"])) : k("", !0),
          v("div", {
            class: C(["flex max-w-full min-w-0", {
              "flex-col": o.value,
              "flex-col gap-1": i.value || s.value,
              "flex-col gap-2 py-1": d.value
            }]),
            "data-testid": "nav-header-heading"
          }, [
            v("div", {
              class: C(["flex min-w-0 items-center", { "gap-4": o.value, "gap-2": d.value }])
            }, [
              re(gV, {
                title: e.title,
                placeholder: e.titlePlaceholder || void 0,
                editable: e.editableTitle,
                onSave: L[1] || (L[1] = (T) => l("title-save", T))
              }, null, 8, ["title", "placeholder", "editable"]),
              (o.value || d.value) && h.value.length ? (c(), H(Qo, {
                key: 0,
                badges: h.value,
                class: "shrink-0 items-center gap-2"
              }, null, 8, ["badges"])) : k("", !0)
            ], 2),
            i.value && (b.value || h.value.length) ? (c(), g("div", vV, [
              b.value ? (c(), g("p", xV, N(e.description), 1)) : k("", !0),
              h.value.length ? (c(), H(Qo, {
                key: 1,
                badges: h.value,
                class: "shrink-0 items-center gap-2"
              }, null, 8, ["badges"])) : k("", !0)
            ])) : k("", !0),
            s.value ? (c(), H(Qo, {
              key: 1,
              badges: h.value,
              class: "min-h-6 flex-wrap gap-1.5"
            }, null, 8, ["badges"])) : k("", !0),
            (o.value || d.value) && b.value ? (c(), g("p", yV, N(e.description), 1)) : k("", !0)
          ], 2)
        ], 2),
        e.primaryAction || p.value || x.value || o.value && e.pagination ? (c(), g("div", {
          key: 0,
          class: C(["ml-auto flex max-w-full min-w-0 flex-none flex-wrap justify-end gap-x-4 gap-y-3", $[e.type]]),
          "data-testid": "nav-header-right"
        }, [
          e.primaryAction ? (c(), g(ce, { key: 0 }, [
            e.primaryAction.menu ? (c(), H(QP, {
              key: 0,
              variant: "primary",
              size: y.value,
              label: e.primaryAction.label,
              icon: e.primaryAction.icon,
              menu: e.primaryAction.menu,
              "menu-label": e.primaryAction.menuLabel,
              disabled: e.primaryAction.disabled,
              "aria-disabled": e.primaryAction.ariaDisabled,
              loading: e.primaryAction.loading,
              "loading-label": e.primaryAction.loadingLabel,
              "data-testid": "nav-header-primary",
              onClick: L[2] || (L[2] = (T) => l("primary-action", T)),
              onSelect: L[3] || (L[3] = (T) => l("primary-action-select", T))
            }, null, 8, ["size", "label", "icon", "menu", "menu-label", "disabled", "aria-disabled", "loading", "loading-label"])) : (c(), H(Be, {
              key: 1,
              variant: "primary",
              size: y.value,
              label: e.primaryAction.label,
              "icon-left": e.primaryAction.icon,
              disabled: e.primaryAction.disabled,
              "aria-disabled": e.primaryAction.ariaDisabled,
              loading: e.primaryAction.loading,
              "loading-label": e.primaryAction.loadingLabel,
              "data-testid": "nav-header-primary",
              onClick: L[4] || (L[4] = (T) => l("primary-action", T))
            }, null, 8, ["size", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label"]))
          ], 64)) : k("", !0),
          p.value ? (c(), g(ce, { key: 1 }, [
            e.secondaryAction.menu ? (c(), H(ln, {
              key: 0,
              items: e.secondaryAction.menu,
              "menu-align": "right"
            }, {
              trigger: xe(({ triggerProps: T }) => [
                re(Be, Oe(T, {
                  variant: "secondary",
                  size: "lg",
                  label: e.secondaryAction.label,
                  "icon-left": e.secondaryAction.icon,
                  "dropdown-icon": "",
                  disabled: e.secondaryAction.disabled,
                  "aria-disabled": e.secondaryAction.ariaDisabled,
                  "data-testid": "nav-header-secondary"
                }), null, 16, ["label", "icon-left", "disabled", "aria-disabled"])
              ]),
              _: 1
            }, 8, ["items"])) : (c(), H(Be, {
              key: 1,
              variant: "secondary",
              size: "lg",
              label: e.secondaryAction.label,
              "icon-left": e.secondaryAction.icon,
              disabled: e.secondaryAction.disabled,
              "aria-disabled": e.secondaryAction.ariaDisabled,
              "data-testid": "nav-header-secondary",
              onClick: L[5] || (L[5] = (T) => l("secondary-action", T))
            }, null, 8, ["label", "icon-left", "disabled", "aria-disabled"]))
          ], 64)) : k("", !0),
          x.value ? (c(), g("div", kV, [
            (c(!0), g(ce, null, Re(e.iconActions, (T, E) => (c(), g(ce, { key: E }, [
              T.menu ? (c(), H(ln, {
                key: 0,
                items: T.menu,
                "menu-align": "right"
              }, {
                trigger: xe(({ triggerProps: A }) => [
                  re(Be, Oe({ ref_for: !0 }, A, {
                    variant: "secondary",
                    size: "lg",
                    "icon-only": "",
                    "icon-left": T.icon,
                    "aria-label": T.label,
                    disabled: T.disabled,
                    "aria-disabled": T.ariaDisabled,
                    "data-testid": "nav-header-icon-action"
                  }), null, 16, ["icon-left", "aria-label", "disabled", "aria-disabled"])
                ]),
                _: 2
              }, 1032, ["items"])) : (c(), H(Be, {
                key: 1,
                variant: "secondary",
                size: "lg",
                "icon-only": "",
                "icon-left": T.icon,
                "aria-label": T.label,
                disabled: T.disabled,
                "aria-disabled": T.ariaDisabled,
                "data-testid": "nav-header-icon-action",
                onClick: (A) => l("icon-action", T, E)
              }, null, 8, ["icon-left", "aria-label", "disabled", "aria-disabled", "onClick"]))
            ], 64))), 128))
          ])) : k("", !0),
          o.value && e.pagination ? (c(), H(fV, {
            key: 3,
            "prev-label": e.pagination.prevLabel,
            "next-label": e.pagination.nextLabel,
            "prev-disabled": e.pagination.prevDisabled,
            "next-disabled": e.pagination.nextDisabled,
            "data-testid": "nav-header-pagination",
            onPrev: L[6] || (L[6] = (T) => l("prev")),
            onNext: L[7] || (L[7] = (T) => l("next"))
          }, null, 8, ["prev-label", "next-label", "prev-disabled", "next-disabled"])) : k("", !0)
        ], 2)) : k("", !0)
      ], 2)
    ], 512));
  }
}), wV = /* @__PURE__ */ ke({
  __name: "SpeedDial",
  props: {
    primaryIcon: {},
    primaryIconAlt: { default: "" },
    items: {},
    size: { default: "md" },
    orientation: { default: "vertical" },
    direction: { default: "top" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(t.open);
    $e(
      () => t.open,
      (h) => {
        l.value = h;
      }
    );
    const r = (h) => {
      l.value = h, a("update:open", h);
    }, o = () => {
      r(!l.value);
    }, i = (h, p) => {
      h.onClick && h.onClick(p), a("item-click", h, p);
    }, s = m(() => {
      const h = "relative w-full flex p-2.5 box-border gap-2";
      return t.orientation === "horizontal" ? t.direction === "left" ? `${h} flex-row items-center` : `${h} flex-row-reverse items-center` : t.direction === "top" ? `${h} flex-col-reverse items-end` : `${h} flex-col items-end`;
    }), d = m(() => ({
      position: "relative"
    })), u = m(() => {
      const h = "flex items-center";
      return t.orientation === "horizontal" ? `${h} flex-row` : `${h} flex-col`;
    }), f = m(() => (t.orientation === "horizontal", "gap-2")), b = m(() => t.direction);
    return (h, p) => (c(), g("div", {
      class: C([s.value, "speed-dial-container"])
    }, [
      re(Pr, {
        name: `speed-dial-${b.value}`,
        tag: "div",
        class: C([[u.value, f.value], "relative"]),
        style: Ne(d.value)
      }, {
        default: xe(() => [
          (c(!0), g(ce, null, Re(l.value ? e.items : [], (x, y) => (c(), H(I(Be), {
            key: `speed-dial-item-${y}`,
            variant: "secondary",
            "icon-left": x.icon,
            "icon-only": "",
            "aria-label": x.iconAlt,
            size: e.size,
            style: Ne({
              "--index": y
            }),
            class: "relative",
            onClick: (w) => i(x, w)
          }, null, 8, ["icon-left", "aria-label", "size", "style", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["name", "class", "style"]),
      re(I(Be), {
        variant: "primary",
        "icon-left": e.primaryIcon,
        "icon-only": "",
        "aria-label": e.primaryIconAlt,
        size: e.size,
        class: "relative z-20 speed-dial-primary-button",
        onClick: o
      }, null, 8, ["icon-left", "aria-label", "size"])
    ], 2));
  }
}), qq = /* @__PURE__ */ ot(wV, [["__scopeId", "data-v-0eb94464"]]);
function CV(e) {
  return !!e.duration && e.status !== "error" && !e.link && !e.primaryAction && !e.secondaryAction;
}
function nx(e) {
  return (e.layout ?? "default") === "default" && (e.status === "error" || e.status === "warning");
}
function SV(e) {
  const n = e.layout === "withHeader" && e.avatar ? `${e.avatar.name} ${e.message}` : e.message;
  return [e.title, n].filter(Boolean).join(". ");
}
const $V = 3, Hn = R([]), zr = /* @__PURE__ */ new Map(), cr = /* @__PURE__ */ new Set();
let kb = !1;
function wb(e) {
  const n = zr.get(e);
  n != null && n.handle && clearTimeout(n.handle), zr.delete(e);
}
function IV() {
  function e(i, s) {
    s.startedAt = Date.now(), s.handle = setTimeout(() => o(i), s.remaining);
  }
  function n(i) {
    if (!CV(i)) return;
    const s = /* @__PURE__ */ new Set();
    kb && s.add("window"), cr.has(i.id) && s.add("pointer");
    const d = { remaining: i.duration, startedAt: 0, pausedBy: s };
    zr.set(i.id, d), s.size || e(i.id, d);
  }
  function t(i) {
    const s = (f) => (f.layout ?? "default") === "default", d = s(i) ? Hn.value.findIndex(
      (f) => s(f) && f.status === i.status && f.title === i.title && f.message === i.message
    ) : -1;
    if (d >= 0) {
      const f = { ariaClose: "Close", ...i, id: Hn.value[d].id };
      return wb(f.id), Hn.value[d] = f, n(f), f.id;
    }
    const u = {
      id: crypto.randomUUID(),
      ariaClose: "Close",
      ...i
    };
    if (Hn.value.length >= $V) {
      const f = Hn.value.find(
        (b) => b.status !== "error" && !b.link && !b.primaryAction && !b.secondaryAction && !cr.has(b.id)
      );
      f && o(f.id);
    }
    return Hn.value.push(u), n(u), u.id;
  }
  function a(i, s = "pointer") {
    s === "pointer" && cr.add(i);
    const d = zr.get(i);
    d && (d.pausedBy.add(s), d.handle && (clearTimeout(d.handle), d.handle = void 0, d.remaining = Math.max(0, d.remaining - (Date.now() - d.startedAt))));
  }
  function l(i, s = "pointer") {
    s === "pointer" && cr.delete(i);
    const d = zr.get(i);
    d && (d.pausedBy.delete(s), !(d.handle || d.pausedBy.size) && e(i, d));
  }
  function r(i) {
    kb = i, Hn.value.forEach(
      (s) => i ? a(s.id, "window") : l(s.id, "window")
    );
  }
  function o(i) {
    wb(i), cr.delete(i), Hn.value = Hn.value.filter((s) => s.id !== i);
  }
  return {
    toasts: Hn,
    showToast: t,
    removeToast: o,
    pauseToast: a,
    resumeToast: l,
    setWindowBlurred: r
  };
}
const hd = /* @__PURE__ */ ke({
  __name: "ToastActions",
  props: {
    primary: {},
    secondary: {}
  },
  emits: ["run"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => {
      const r = [];
      return t.primary && r.push({ action: t.primary, variant: "primary" }), t.secondary && r.push({ action: t.secondary, variant: "secondary" }), r;
    });
    return (r, o) => l.value.length ? (c(), g("div", {
      key: 0,
      "data-testid": "toast-actions",
      class: C(["grid items-center gap-3", l.value.length > 1 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), g(ce, null, Re(l.value, ({ action: i, variant: s }) => (c(), H(I(Be), {
        key: s,
        variant: s,
        size: "xs",
        "full-width": "",
        label: i.label,
        "icon-left": i.icon,
        onClick: (d) => a("run", i.onClick)
      }, null, 8, ["variant", "label", "icon-left", "onClick"]))), 128))
    ], 2)) : k("", !0);
  }
}), TV = ["role", "aria-atomic"], LV = { class: "flex min-w-0 flex-1 flex-col gap-1" }, AV = { class: "flex flex-col gap-px" }, EV = {
  key: 0,
  "data-testid": "toast-name",
  class: "text-(length:--size-l) leading-(--line-height-l-tight) font-(--weight-semi-bold)"
}, RV = {
  "data-testid": "toast-message",
  class: "text-(length:--size-m) leading-(--line-height-l)"
}, BV = {
  key: 0,
  "data-testid": "toast-time",
  class: "text-(length:--size-sm) leading-(--line-height-xs)"
}, DV = {
  key: 1,
  "data-testid": "toast-content",
  class: "flex items-start gap-3"
}, MV = { class: "flex min-w-0 flex-1 flex-col gap-3.5" }, zV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) font-(--weight-bold)"
}, OV = { "data-testid": "toast-message" }, PV = {
  key: 2,
  "data-testid": "toast-message-group",
  class: "flex min-w-0 flex-1 items-start gap-3"
}, FV = {
  "data-testid": "toast-icon",
  class: "inline-flex shrink-0 items-center justify-center",
  "aria-hidden": "true"
}, VV = { class: "flex min-w-0 flex-1 flex-col gap-1 text-(length:--size-m) leading-(--line-height-m)" }, NV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)"
}, HV = /* @__PURE__ */ ke({
  __name: "ToastItem",
  props: {
    toast: {}
  },
  emits: ["close", "pause", "resume"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    let l = !1, r = !1;
    function o($, S) {
      const L = l || r;
      l = $, r = S;
      const T = l || r;
      T && !L && a("pause"), !T && L && a("resume");
    }
    function i($) {
      $.currentTarget.contains($.relatedTarget) || o(l, !1);
    }
    function s($) {
      $.key === "Escape" && ($.stopPropagation(), $.preventDefault(), a("close"));
    }
    const d = m(() => t.toast.layout ?? "default"), u = m(() => nx(t.toast) ? "alert" : void 0), f = {
      default: "items-center justify-between gap-3 p-4",
      withHeader: "flex-col gap-4 p-[calc(--spacing(4)-1px)]",
      iconShape: "flex-col p-[calc(--spacing(4)-1px)]"
    }, b = {
      success: {
        color: "text-(--icons-icon-success)",
        leading: "leading-(--line-height-l)",
        icon: "ri-checkbox-circle-fill"
      },
      info: {
        color: "text-(--icons-icon-info)",
        leading: "leading-(--line-height-l)",
        icon: "ri-information-fill"
      },
      warning: {
        color: "text-(--icons-icon-warning)",
        leading: "leading-(--line-height-m)",
        icon: "ri-alert-fill"
      },
      error: {
        color: "text-(--icons-icon-error)",
        leading: "leading-(--line-height-l)",
        icon: "ri-error-warning-fill"
      }
    }, h = m(() => b[t.toast.status]), p = m(
      () => d.value !== "withHeader" || !t.toast.primaryAction && !t.toast.secondaryAction
    ), x = m(() => p.value && d.value !== "default" ? "pe-6" : "");
    function y($) {
      try {
        $ == null || $();
      } finally {
        a("close");
      }
    }
    function w() {
      var $;
      ($ = t.toast.link) != null && $.onClick && y(t.toast.link.onClick);
    }
    return ($, S) => (c(), g("div", {
      class: C(["relative flex w-full overflow-hidden rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-(--background-background-black-default) text-(--text-text-white-default) shadow-(--blur-shadow-toast)", f[d.value]]),
      "data-testid": "toast",
      role: u.value,
      "aria-atomic": u.value ? "true" : void 0,
      onMouseenter: S[1] || (S[1] = (L) => o(!0, I(r))),
      onMouseleave: S[2] || (S[2] = (L) => o(!1, I(r))),
      onFocusin: S[3] || (S[3] = (L) => o(I(l), !0)),
      onFocusout: i,
      onKeydown: s
    }, [
      d.value === "withHeader" ? (c(), g(ce, { key: 0 }, [
        e.toast.title ? (c(), g("div", {
          key: 0,
          "data-testid": "toast-header",
          class: C(["py-1 text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", x.value])
        }, N(e.toast.title), 3)) : k("", !0),
        v("div", {
          "data-testid": "toast-avatar-row",
          class: C(["flex items-start gap-3", !e.toast.title && x.value])
        }, [
          e.toast.avatar ? (c(), H(I(Mt), {
            key: 0,
            img: e.toast.avatar.src,
            name: e.toast.avatar.name,
            presentational: ""
          }, null, 8, ["img", "name"])) : k("", !0),
          v("div", LV, [
            v("div", AV, [
              e.toast.avatar ? (c(), g("div", EV, N(e.toast.avatar.name), 1)) : k("", !0),
              v("div", RV, N(e.toast.message), 1)
            ]),
            e.toast.time ? (c(), g("div", BV, N(e.toast.time), 1)) : k("", !0)
          ])
        ], 2),
        re(hd, {
          primary: e.toast.primaryAction,
          secondary: e.toast.secondaryAction,
          onRun: y
        }, null, 8, ["primary", "secondary"])
      ], 64)) : d.value === "iconShape" ? (c(), g("div", DV, [
        e.toast.icon ? (c(), H(Vt, {
          key: 0,
          "data-testid": "toast-icon-shape",
          color: "white",
          variant: "outlined",
          size: "md",
          icon: e.toast.icon
        }, null, 8, ["icon"])) : k("", !0),
        v("div", MV, [
          v("div", {
            class: C(["flex flex-col gap-2 text-(length:--size-m) leading-(--line-height-l)", x.value])
          }, [
            e.toast.title ? (c(), g("div", zV, N(e.toast.title), 1)) : k("", !0),
            v("div", OV, N(e.toast.message), 1)
          ], 2),
          re(hd, {
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])) : (c(), g("div", PV, [
        v("div", FV, [
          v("i", {
            class: C(["size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)", [h.value.icon, h.value.color]])
          }, null, 2)
        ]),
        v("div", VV, [
          e.toast.title ? (c(), g("div", NV, N(e.toast.title), 1)) : k("", !0),
          v("div", {
            "data-testid": "toast-message",
            class: C(h.value.leading)
          }, N(e.toast.message), 3),
          e.toast.link ? (c(), H(I(In), {
            key: 1,
            "data-testid": "toast-link",
            class: "self-start text-(--text-text-link-on-dark)!",
            as: e.toast.link.href ? "a" : "button",
            href: e.toast.link.href,
            onClick: w
          }, {
            default: xe(() => [
              et(N(e.toast.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href"])) : k("", !0),
          re(hd, {
            class: "mt-3.5",
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])),
      p.value ? (c(), g("div", {
        key: 3,
        "data-testid": "toast-close",
        class: C(d.value === "default" ? "flex shrink-0" : "absolute top-1 right-1")
      }, [
        re(I(Be), {
          class: "[&_i]:text-(--icons-icon-white-default)! hover:[&_i]:text-(--icons-icon-dark-default)! [&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
          variant: "ghost",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": t.toast.ariaClose,
          onClick: S[0] || (S[0] = (L) => a("close"))
        }, null, 8, ["aria-label"])
      ], 2)) : k("", !0)
    ], 42, TV));
  }
}), jV = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "toast-live-polite"
}, WV = 250, Uq = /* @__PURE__ */ ke({
  __name: "ToastContainer",
  setup(e) {
    const { toasts: n, removeToast: t, pauseToast: a, resumeToast: l, setWindowBlurred: r } = IV(), o = R();
    let i, s = !1, d = null;
    const u = R("");
    let f = new Map(n.value.map(($) => [$.id, $])), b = /* @__PURE__ */ new Set();
    function h($) {
      var M, F, X;
      const S = $.map((_) => {
        var Y;
        return (Y = o.value) == null ? void 0 : Y.querySelector(`[data-toast-id="${_}"]`);
      }), L = S.find((_) => _ == null ? void 0 : _.contains(document.activeElement));
      if (!L) return;
      const T = d;
      if (d = null, T != null && T.isConnected) return T.focus();
      if (!((M = document.activeElement) != null && M.matches(":focus-visible"))) return;
      const E = [...((F = o.value) == null ? void 0 : F.querySelectorAll("[data-toast-id]")) ?? []], A = E.indexOf(L), D = [...E.slice(A + 1), ...E.slice(0, A).reverse()].find(
        (_) => !S.includes(_)
      );
      (X = D == null ? void 0 : D.querySelector("button")) == null || X.focus();
    }
    $e(
      () => [...n.value],
      async ($) => {
        const S = new Map($.map((T) => [T.id, T]));
        h([...f.keys()].filter((T) => !S.has(T)));
        const L = $.filter((T) => f.has(T.id) ? f.get(T.id) !== T : !nx(T));
        if (f = S, !L.length) {
          b.size && ![...b].some((T) => S.has(T)) && (u.value = "", b = /* @__PURE__ */ new Set());
          return;
        }
        b = new Set(L.map((T) => T.id)), u.value = "", await Ue(), u.value = L.map(SV).join(" ");
      }
    );
    function p() {
      const $ = !document.hasFocus();
      $ !== s && (s = $, r($));
    }
    function x($) {
      clearInterval(i), i = void 0, $ && (p(), i = setInterval(p, WV));
    }
    $e(() => n.value.length > 0, x, { flush: "sync" });
    function y($) {
      var L;
      const S = $.relatedTarget;
      S instanceof HTMLElement && !((L = o.value) != null && L.contains(S)) && (d = S);
    }
    function w($) {
      var L;
      const S = $.relatedTarget;
      (S instanceof Node ? !((L = o.value) != null && L.contains(S)) : document.hasFocus()) && (d = null);
    }
    return dt(() => {
      s = !document.hasFocus(), r(s), x(n.value.length > 0);
    }), mt(() => {
      x(!1), r(!1);
    }), ($, S) => (c(), g("div", {
      ref_key: "root",
      ref: o,
      class: "fixed right-4 z-[500] w-80 max-w-[calc(100vw-2rem)]",
      style: { top: "var(--toast-container-top, 1rem)" },
      onFocusin: y,
      onFocusout: w
    }, [
      v("div", jV, N(u.value), 1),
      re(Pr, {
        name: "toast",
        tag: "div",
        class: "flex max-h-[calc(100vh-var(--toast-container-top,1rem)-1rem+--spacing(5))] flex-col gap-3 overflow-x-hidden overflow-y-auto not-empty:-m-2.5 not-empty:p-2.5 *:shrink-0"
      }, {
        default: xe(() => [
          (c(!0), g(ce, null, Re(I(n), (L) => (c(), H(HV, {
            key: L.id,
            toast: L,
            "data-toast-id": L.id,
            onClose: (T) => I(t)(L.id),
            onPause: (T) => I(a)(L.id, "pointer"),
            onResume: (T) => I(l)(L.id, "pointer")
          }, null, 8, ["toast", "data-toast-id", "onClose", "onPause", "onResume"]))), 128))
        ]),
        _: 1
      })
    ], 544));
  }
}), qV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"/></svg>', UV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"/></svg>', GV = { key: 0 }, KV = {
  key: 0,
  "data-testid": "form-error-summary-inline",
  class: "inline-flex items-center gap-2 px-3 py-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-error) border border-solid border-(--border-border-error-subtle) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) font-(--weight-medium)"
}, YV = ["innerHTML"], JV = ["innerHTML"], XV = {
  key: 0,
  "data-testid": "form-error-summary-menu",
  class: "absolute left-0 top-[calc(100%+4px)] z-50 min-w-56 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-error-subtle) bg-white-50-opacity-bold p-3 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--border-border-base) dark:bg-(--background-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, ZV = {
  key: 0,
  "data-testid": "form-error-summary-list-heading",
  class: "mb-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, QV = { class: "flex flex-col gap-1" }, _V = ["onClick"], eN = ["innerHTML"], Gq = /* @__PURE__ */ ke({
  __name: "FormErrorSummary",
  props: {
    errors: {},
    mode: { default: "inline" },
    heading: { default: void 0 },
    triggerLabel: { default: void 0 },
    listHeading: { default: void 0 }
  },
  emits: ["navigateToField"],
  setup(e, { emit: n }) {
    const t = n, { isOpen: a, dropdownRef: l, toggleDropdown: r, closeDropdown: o } = Zl(), i = m(
      () => qV.replace("<svg", '<svg width="16" height="16" style="display: block;"')
    ), s = m(
      () => UV.replace("<svg", '<svg width="12" height="12" style="display: block;"')
    ), d = (u) => {
      o(), t("navigateToField", u);
    };
    return (u, f) => e.errors.length > 0 ? (c(), g("div", GV, [
      e.mode === "inline" ? (c(), g("div", KV, [
        v("span", {
          class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
          innerHTML: i.value
        }, null, 8, YV),
        v("span", null, N(e.heading), 1)
      ])) : (c(), g("div", {
        key: 1,
        ref_key: "dropdownRef",
        ref: l,
        class: "relative inline-block"
      }, [
        v("button", {
          type: "button",
          "data-testid": "form-error-summary-trigger",
          class: "inline-flex items-center gap-1.5 rounded-(--border-border-radius-rounded-full) border border-solid border-(--border-border-error-subtle) bg-(--background-background-error) px-3 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) cursor-pointer transition-opacity hover:opacity-80",
          onClick: f[0] || (f[0] = //@ts-ignore
          (...b) => I(r) && I(r)(...b))
        }, [
          v("span", {
            class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
            innerHTML: i.value
          }, null, 8, JV),
          v("span", null, N(e.triggerLabel), 1),
          (c(), g("svg", {
            class: "h-4 w-4 transition-transform duration-200",
            style: Ne({ transform: I(a) ? "rotate(180deg)" : "rotate(0deg)" }),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...f[1] || (f[1] = [
            v("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ])], 4))
        ]),
        re(wt, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: xe(() => [
            I(a) ? (c(), g("div", XV, [
              e.listHeading ? (c(), g("p", ZV, N(e.listHeading), 1)) : k("", !0),
              v("ul", QV, [
                (c(!0), g(ce, null, Re(e.errors, (b) => (c(), g("li", {
                  key: b.key
                }, [
                  v("button", {
                    type: "button",
                    "data-testid": "form-error-summary-item",
                    class: "inline-flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) px-2 py-1 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) cursor-pointer transition-colors hover:bg-(--background-background-error) dark:text-(--text-text-white-secondary) dark:hover:bg-white/8",
                    onClick: (h) => d(b.key)
                  }, [
                    v("span", {
                      class: "h-3 w-3 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
                      innerHTML: s.value
                    }, null, 8, eN),
                    v("span", null, N(b.label), 1)
                  ], 8, _V)
                ]))), 128))
              ])
            ])) : k("", !0)
          ]),
          _: 1
        })
      ], 512))
    ])) : k("", !0);
  }
}), tN = ["id"], Kq = /* @__PURE__ */ ke({
  __name: "DynamicFormField",
  props: {
    field: {},
    modelValue: {},
    error: {}
  },
  emits: ["update:modelValue", "country-change", "blur"],
  setup(e) {
    return (n, t) => (c(), g("div", {
      id: `field-${e.field.key}`
    }, [
      e.field.type === "email" ? (c(), H(cB, {
        key: 0,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        hint: e.field.hint,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[0] || (t[0] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[1] || (t[1] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "hint", "placeholder", "error"])) : e.field.type === "text" ? (c(), H(Ot, {
        key: 1,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[2] || (t[2] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[3] || (t[3] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "placeholder", "error"])) : e.field.type === "phone" ? (c(), H(IB, {
        key: 2,
        "model-value": e.modelValue,
        label: e.field.label,
        readonly: e.field.readonly,
        "show-country-selector": e.field.showCountrySelector,
        countries: e.field.countries,
        "full-width": !0,
        size: e.field.size,
        error: e.error,
        "onUpdate:modelValue": t[4] || (t[4] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[5] || (t[5] = (a) => n.$emit("blur")),
        onCountryChange: t[6] || (t[6] = (a, l) => n.$emit("country-change", { dialCode: a.dialCode, nationalNumber: l }))
      }, null, 8, ["model-value", "label", "readonly", "show-country-selector", "countries", "size", "error"])) : e.field.type === "select" ? (c(), H(El, {
        key: 3,
        "model-value": e.modelValue,
        options: e.field.options || [],
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        "full-width": !0,
        hint: e.field.hint,
        error: e.error,
        "onUpdate:modelValue": t[7] || (t[7] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[8] || (t[8] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "options", "label", "required", "readonly", "hint", "error"])) : k("", !0)
    ], 8, tN));
  }
}), nN = /* @__PURE__ */ ke({
  __name: "UnsavedChangesModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    stayLabel: {},
    leaveLabel: {},
    saveLabel: {},
    saveDisabled: { type: Boolean }
  },
  emits: ["update:modelValue", "stay", "leave", "discard", "save"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m({
      get: () => t.modelValue,
      set: (u) => a("update:modelValue", u)
    }), r = m(
      () => t.saveLabel ? [
        {
          id: "discard",
          label: t.leaveLabel,
          variant: "secondary",
          testId: "unsaved-discard",
          onClick: s
        },
        {
          id: "save",
          label: t.saveLabel,
          variant: "primary",
          disabled: t.saveDisabled,
          testId: "unsaved-save",
          onClick: d
        }
      ] : [
        { id: "leave", label: t.leaveLabel, variant: "secondary", testId: "unsaved-leave", onClick: i },
        { id: "stay", label: t.stayLabel, variant: "primary", testId: "unsaved-stay", onClick: o }
      ]
    );
    function o() {
      a("update:modelValue", !1), a("stay");
    }
    function i() {
      a("update:modelValue", !1), a("leave");
    }
    function s() {
      a("update:modelValue", !1), a("discard");
    }
    function d() {
      t.saveDisabled || a("save");
    }
    return (u, f) => (c(), H(Va, {
      modelValue: l.value,
      "onUpdate:modelValue": f[0] || (f[0] = (b) => l.value = b),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      title: e.title,
      subtitle: e.message,
      icon: "ℹ️",
      "header-align": "middle-stacked",
      "footer-align": "center",
      actions: r.value,
      "overlay-class": "!z-[400]",
      onClose: o
    }, null, 8, ["modelValue", "title", "subtitle", "actions"]));
  }
}), Yq = /* @__PURE__ */ ke({
  __name: "ConfirmDeleteModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    subtitle: {},
    confirmLabel: {},
    cancelLabel: {},
    icon: { default: "ri-delete-bin-6-line" },
    confirmDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m({
      get: () => t.modelValue,
      set: (s) => a("update:modelValue", s)
    }), r = m(() => [
      {
        id: "cancel",
        label: t.cancelLabel,
        variant: "secondary",
        testId: "confirm-delete-modal-cancel",
        onClick: i
      },
      {
        id: "confirm",
        label: t.confirmLabel,
        variant: "error",
        icon: "ri-delete-bin-6-line",
        disabled: t.confirmDisabled,
        testId: "confirm-delete-modal-confirm",
        onClick: o
      }
    ]);
    function o() {
      t.confirmDisabled || (a("update:modelValue", !1), a("confirm"));
    }
    function i() {
      a("update:modelValue", !1), a("cancel");
    }
    return (s, d) => (c(), H(Va, {
      modelValue: l.value,
      "onUpdate:modelValue": d[0] || (d[0] = (u) => l.value = u),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      title: e.title,
      subtitle: e.subtitle,
      icon: e.icon,
      "header-align": "middle-stacked",
      "footer-align": "center",
      actions: r.value,
      "data-testid": "confirm-delete-modal-body",
      onClose: i
    }, null, 8, ["modelValue", "title", "subtitle", "icon", "actions"]));
  }
}), aN = /* @__PURE__ */ ke({
  __name: "DataTableContainer",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    tableWidth: {}
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("table", {
      "data-slot": "table",
      class: C([
        "min-w-full table-fixed border-spacing-0 text-sm text-left text-text-black-default",
        n.class
      ]),
      style: Ne(e.tableWidth ? { width: e.tableWidth } : void 0)
    }, [
      Ae(t.$slots, "default")
    ], 6));
  }
}), lN = /* @__PURE__ */ ke({
  __name: "DataTableBody",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tbody", {
      "data-slot": "table-body",
      class: C(["", n.class])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), Jq = /* @__PURE__ */ ke({
  __name: "DataTableCaption",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("caption", {
      "data-slot": "table-caption",
      class: C(["text-muted-foreground mt-4 text-sm", n.class])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), mu = /* @__PURE__ */ ke({
  __name: "DataTableCell",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    noTruncate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = R(null);
    function a() {
      var r;
      const l = t.value;
      l && (l.scrollWidth > l.clientWidth ? l.title = ((r = l.textContent) == null ? void 0 : r.trim()) ?? "" : l.title = "");
    }
    return (l, r) => (c(), g("td", {
      "data-slot": "table-cell",
      class: C([
        "leading-5 font-medium text-sm p-3 h-12 align-middle [&:has([type=checkbox])]:pr-0 [&:has([type=checkbox])]:max-w-none",
        e.noTruncate ? "overflow-visible" : "overflow-hidden max-w-0",
        n.class
      ])
    }, [
      e.noTruncate ? Ae(l.$slots, "default", { key: 1 }) : (c(), g("div", {
        key: 0,
        ref_key: "truncateRef",
        ref: t,
        class: "truncate",
        onMouseenter: a
      }, [
        Ae(l.$slots, "default")
      ], 544))
    ], 2));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function rN(e) {
  return Wo(e) ? sl(new Proxy({}, {
    get(n, t, a) {
      return I(Reflect.get(e.value, t, a));
    },
    set(n, t, a) {
      return Wo(e.value[t]) && !Wo(a) ? e.value[t].value = a : e.value[t] = a, !0;
    },
    deleteProperty(n, t) {
      return Reflect.deleteProperty(e.value, t);
    },
    has(n, t) {
      return Reflect.has(e.value, t);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  })) : sl(e);
}
function oN(e) {
  return rN(m(e));
}
function iN(e, ...n) {
  const t = n.flat(), a = t[0];
  return oN(() => Object.fromEntries(typeof a == "function" ? Object.entries(_c(e)).filter(([l, r]) => !a(Rt(r), l)) : Object.entries(_c(e)).filter((l) => !t.includes(l[0]))));
}
const _o = /* @__PURE__ */ ke({
  __name: "DataTableRow",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tr", {
      "data-slot": "table-row",
      class: C([
        "bg-white dark:bg-(--colors-background-black-default) border-b border-border-base-soft dark:border-(--colors-border-base) hover:bg-(--background-background-hover) dark:hover:bg-(--color-dark-bg-tertiary)",
        n.class
      ])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), sN = { class: "flex items-center justify-center py-10" }, Xq = /* @__PURE__ */ ke({
  __name: "DataTableEmpty",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    colspan: { default: 1 }
  },
  setup(e) {
    const n = e, t = iN(n, "class");
    return (a, l) => (c(), H(_o, null, {
      default: xe(() => [
        re(mu, Oe({
          class: ["p-4 whitespace-nowrap align-middle text-sm text-foreground", n.class]
        }, I(t)), {
          default: xe(() => [
            v("div", sN, [
              Ae(a.$slots, "default")
            ])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), Zq = /* @__PURE__ */ ke({
  __name: "DataTableFooter",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tfoot", {
      "data-slot": "table-footer",
      class: C(["", n.class])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
}), dN = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.5%207C9.32843%207%2010%206.32843%2010%205.5C10%204.67157%209.32843%204%208.5%204C7.67157%204%207%204.67157%207%205.5C7%206.32843%207.67157%207%208.5%207ZM8.5%2013.5C9.32843%2013.5%2010%2012.8284%2010%2012C10%2011.1716%209.32843%2010.5%208.5%2010.5C7.67157%2010.5%207%2011.1716%207%2012C7%2012.8284%207.67157%2013.5%208.5%2013.5ZM10%2018.5C10%2019.3284%209.32843%2020%208.5%2020C7.67157%2020%207%2019.3284%207%2018.5C7%2017.6716%207.67157%2017%208.5%2017C9.32843%2017%2010%2017.6716%2010%2018.5ZM15.5%207C16.3284%207%2017%206.32843%2017%205.5C17%204.67157%2016.3284%204%2015.5%204C14.6716%204%2014%204.67157%2014%205.5C14%206.32843%2014.6716%207%2015.5%207ZM17%2012C17%2012.8284%2016.3284%2013.5%2015.5%2013.5C14.6716%2013.5%2014%2012.8284%2014%2012C14%2011.1716%2014.6716%2010.5%2015.5%2010.5C16.3284%2010.5%2017%2011.1716%2017%2012ZM15.5%2020C16.3284%2020%2017%2019.3284%2017%2018.5C17%2017.6716%2016.3284%2017%2015.5%2017C14.6716%2017%2014%2017.6716%2014%2018.5C14%2019.3284%2014.6716%2020%2015.5%2020Z'/%3e%3c/svg%3e", uN = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18%203V5H17V11L19%2014V16H13V23H11V16H5V14L7%2011V5H6V3H18Z'/%3e%3c/svg%3e", cN = ["aria-sort"], fN = { class: "flex items-center gap-1 min-w-0" }, hN = ["src", "data-drag-handle", "draggable"], bN = {
  key: 1,
  class: "me-auto min-w-0"
}, gN = ["src"], mN = {
  key: 4,
  ref: "menuRef",
  class: "relative shrink-0"
}, pN = ["aria-label"], vN = /* @__PURE__ */ ke({
  __name: "DataTableHead",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isDraggable: { type: Boolean, default: !1 },
    isPinned: { type: Boolean, default: !1 },
    isLastPinned: { type: Boolean, default: !1 },
    isLocked: { type: Boolean, default: !1 },
    isPinIconVisible: { type: Boolean, default: !0 },
    headerMenuItems: { default: void 0 },
    isCustomHeader: { type: Boolean, default: !1 },
    isResizingActive: { type: Boolean, default: !1 },
    isResizable: { type: Boolean, default: !0 },
    menuAriaLabel: { default: "Column menu" },
    sortDirection: { default: void 0 }
  },
  emits: ["resize-start", "resize-auto", "drag-handle-start"],
  setup(e, { emit: n }) {
    const t = e, a = m(() => {
      if (t.sortDirection !== void 0)
        return t.sortDirection === "asc" ? "ascending" : t.sortDirection === "desc" ? "descending" : "none";
    }), l = m(() => t.sortDirection === "asc" ? "ri-arrow-up-s-line" : t.sortDirection === "desc" ? "ri-arrow-down-s-line" : "ri-expand-up-down-fill"), r = n;
    let o = 0;
    function i(f) {
      const b = Date.now();
      if (b - o < 300) {
        o = 0, r("resize-auto");
        return;
      }
      o = b, r("resize-start", f);
    }
    const s = m(() => {
      if (t.headerMenuItems)
        return t.headerMenuItems.map((f, b, h) => {
          const p = h[b + 1];
          return {
            label: f.label,
            icon: f.icon,
            onClick: f.onClick,
            disabled: f.disabled,
            hasDividerAfter: (p == null ? void 0 : p.dividerBefore) === !0
          };
        });
    }), d = R(null);
    function u() {
      var b;
      const f = d.value;
      f && (f.scrollWidth > f.clientWidth ? f.title = ((b = f.textContent) == null ? void 0 : b.trim()) ?? "" : f.title = "");
    }
    return (f, b) => (c(), g("th", {
      "data-slot": "table-head",
      scope: "col",
      "aria-sort": a.value,
      class: C([
        "relative h-10 px-3 min-w-32.5 text-left align-middle font-semibold whitespace-nowrap text-(--text-text-heading) dark:text-(--colors-text-white-default) [&:has([type=checkbox])]:min-w-auto [&:has([type=checkbox])]:w-10 [&:has([type=checkbox])]:pr-0 [&_button]:border-0 [&>div>div>button]:p-0",
        e.isPinned ? "bg-white dark:bg-(--colors-background-black-default) z-20" : "z-0",
        t.class
      ])
    }, [
      v("div", fN, [
        e.isDraggable || e.isLocked ? (c(), g("img", {
          key: 0,
          class: C([
            "size-3.5 shrink-0 dark:invert",
            e.isLocked ? "opacity-40 cursor-not-allowed" : "cursor-grab"
          ]),
          src: I(dN),
          alt: "",
          "data-drag-handle": e.isLocked ? "false" : "true",
          draggable: e.isLocked ? "false" : "true",
          onDragstart: b[0] || (b[0] = Ye((h) => !e.isLocked && r("drag-handle-start", h), ["stop"]))
        }, null, 42, hN)) : k("", !0),
        e.isCustomHeader ? (c(), g("div", bN, [
          Ae(f.$slots, "default")
        ])) : (c(), g("div", {
          key: 2,
          ref_key: "headerTextRef",
          ref: d,
          class: "truncate me-auto min-w-0",
          onMouseenter: u
        }, [
          Ae(f.$slots, "default")
        ], 544)),
        e.isPinned && e.isPinIconVisible ? (c(), g("img", {
          key: 3,
          class: C(["size-3.5 shrink-0 ms-auto dark:invert", e.isLocked ? "opacity-40" : ""]),
          src: I(uN),
          alt: ""
        }, null, 10, gN)) : k("", !0),
        e.headerMenuItems ? (c(), g("div", mN, [
          re(ln, {
            "menu-align": "right",
            items: s.value
          }, {
            trigger: xe(({ triggerProps: h, isOpen: p }) => [
              v("button", Oe({
                type: "button",
                "data-testid": "dropdown-trigger",
                class: "inline-flex min-h-6 min-w-6 cursor-pointer items-center justify-center rounded-(--border-border-radius-rounded-full) bg-white transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2 dark:bg-(--colors-background-black-default)",
                "aria-label": e.menuAriaLabel
              }, h), [
                v("i", {
                  class: C([[l.value, { "rotate-180": p }], "inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) transition-transform duration-200 ease-in-out motion-reduce:transition-none"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, pN)
            ]),
            _: 1
          }, 8, ["items"])
        ], 512)) : k("", !0)
      ]),
      e.isResizable ? (c(), g("div", {
        key: 0,
        class: C(["absolute top-0 right-0 w-0.5 h-full cursor-col-resize z-10 bg-(--background-background-gray)/40 hover:bg-blue-400 hover:opacity-50 transition-colors", { "bg-blue-500 opacity-50": e.isResizingActive }]),
        onMousedown: b[1] || (b[1] = Ye((h) => i(h), ["stop", "prevent"])),
        onClick: b[2] || (b[2] = Ye(() => {
        }, ["stop", "prevent"]))
      }, null, 34)) : k("", !0)
    ], 10, cN));
  }
}), xN = /* @__PURE__ */ ke({
  __name: "DataTableHeader",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isSticky: { type: Boolean }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("thead", {
      "data-slot": "table-header",
      class: C([
        "shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] [&_tr:hover]:bg-transparent",
        n.isSticky && "sticky top-0 z-30 bg-white dark:bg-(--colors-background-black-default)",
        n.class
      ])
    }, [
      Ae(t.$slots, "default")
    ], 2));
  }
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ta(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function pn(e, n) {
  return (t) => {
    n.setState((a) => ({
      ...a,
      [e]: Ta(t, a[e])
    }));
  };
}
function ps(e) {
  return e instanceof Function;
}
function yN(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function kN(e, n) {
  const t = [], a = (l) => {
    l.forEach((r) => {
      t.push(r);
      const o = n(r);
      o != null && o.length && a(o);
    });
  };
  return a(e), t;
}
function tt(e, n, t) {
  let a = [], l;
  return (r) => {
    let o;
    t.key && t.debug && (o = Date.now());
    const i = e(r);
    if (!(i.length !== a.length || i.some((u, f) => a[f] !== u)))
      return l;
    a = i;
    let d;
    if (t.key && t.debug && (d = Date.now()), l = n(...i), t == null || t.onChange == null || t.onChange(l), t.key && t.debug && t != null && t.debug()) {
      const u = Math.round((Date.now() - o) * 100) / 100, f = Math.round((Date.now() - d) * 100) / 100, b = f / 16, h = (p, x) => {
        for (p = String(p); p.length < x; )
          p = " " + p;
        return p;
      };
      console.info(`%c⏱ ${h(f, 5)} /${h(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * b, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return l;
  };
}
function nt(e, n, t, a) {
  return {
    debug: () => {
      var l;
      return (l = e == null ? void 0 : e.debugAll) != null ? l : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: a
  };
}
function wN(e, n, t, a) {
  const l = () => {
    var o;
    return (o = r.getValue()) != null ? o : e.options.renderFallbackValue;
  }, r = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(a),
    renderValue: l,
    getContext: tt(() => [e, t, n, r], (o, i, s, d) => ({
      table: o,
      column: i,
      row: s,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), nt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((o) => {
    o.createCell == null || o.createCell(r, t, n, e);
  }, {}), r;
}
function CN(e, n, t, a) {
  var l, r;
  const i = {
    ...e._getDefaultColumnDef(),
    ...n
  }, s = i.accessorKey;
  let d = (l = (r = i.id) != null ? r : s ? typeof String.prototype.replaceAll == "function" ? s.replaceAll(".", "_") : s.replace(/\./g, "_") : void 0) != null ? l : typeof i.header == "string" ? i.header : void 0, u;
  if (i.accessorFn ? u = i.accessorFn : s && (s.includes(".") ? u = (b) => {
    let h = b;
    for (const x of s.split(".")) {
      var p;
      h = (p = h) == null ? void 0 : p[x], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${x}" in deeply nested key "${s}" returned undefined.`);
    }
    return h;
  } : u = (b) => b[i.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(d)}`,
    accessorFn: u,
    parent: a,
    depth: t,
    columnDef: i,
    columns: [],
    getFlatColumns: tt(() => [!0], () => {
      var b;
      return [f, ...(b = f.columns) == null ? void 0 : b.flatMap((h) => h.getFlatColumns())];
    }, nt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: tt(() => [e._getOrderColumnsFn()], (b) => {
      var h;
      if ((h = f.columns) != null && h.length) {
        let p = f.columns.flatMap((x) => x.getLeafColumns());
        return b(p);
      }
      return [f];
    }, nt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const b of e._features)
    b.createColumn == null || b.createColumn(f, e);
  return f;
}
const Xt = "debugHeaders";
function Cb(e, n, t) {
  var a;
  let r = {
    id: (a = t.id) != null ? a : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const o = [], i = (s) => {
        s.subHeaders && s.subHeaders.length && s.subHeaders.map(i), o.push(s);
      };
      return i(r), o;
    },
    getContext: () => ({
      table: e,
      header: r,
      column: n
    })
  };
  return e._features.forEach((o) => {
    o.createHeader == null || o.createHeader(r, e);
  }), r;
}
const SN = {
  createTable: (e) => {
    e.getHeaderGroups = tt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, l) => {
      var r, o;
      const i = (r = a == null ? void 0 : a.map((f) => t.find((b) => b.id === f)).filter(Boolean)) != null ? r : [], s = (o = l == null ? void 0 : l.map((f) => t.find((b) => b.id === f)).filter(Boolean)) != null ? o : [], d = t.filter((f) => !(a != null && a.includes(f.id)) && !(l != null && l.includes(f.id)));
      return zo(n, [...i, ...d, ...s], e);
    }, nt(e.options, Xt, "getHeaderGroups")), e.getCenterHeaderGroups = tt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, l) => (t = t.filter((r) => !(a != null && a.includes(r.id)) && !(l != null && l.includes(r.id))), zo(n, t, e, "center")), nt(e.options, Xt, "getCenterHeaderGroups")), e.getLeftHeaderGroups = tt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, a) => {
      var l;
      const r = (l = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? l : [];
      return zo(n, r, e, "left");
    }, nt(e.options, Xt, "getLeftHeaderGroups")), e.getRightHeaderGroups = tt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, a) => {
      var l;
      const r = (l = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? l : [];
      return zo(n, r, e, "right");
    }, nt(e.options, Xt, "getRightHeaderGroups")), e.getFooterGroups = tt(() => [e.getHeaderGroups()], (n) => [...n].reverse(), nt(e.options, Xt, "getFooterGroups")), e.getLeftFooterGroups = tt(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), nt(e.options, Xt, "getLeftFooterGroups")), e.getCenterFooterGroups = tt(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), nt(e.options, Xt, "getCenterFooterGroups")), e.getRightFooterGroups = tt(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), nt(e.options, Xt, "getRightFooterGroups")), e.getFlatHeaders = tt(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), nt(e.options, Xt, "getFlatHeaders")), e.getLeftFlatHeaders = tt(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), nt(e.options, Xt, "getLeftFlatHeaders")), e.getCenterFlatHeaders = tt(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), nt(e.options, Xt, "getCenterFlatHeaders")), e.getRightFlatHeaders = tt(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), nt(e.options, Xt, "getRightFlatHeaders")), e.getCenterLeafHeaders = tt(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), nt(e.options, Xt, "getCenterLeafHeaders")), e.getLeftLeafHeaders = tt(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), nt(e.options, Xt, "getLeftLeafHeaders")), e.getRightLeafHeaders = tt(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), nt(e.options, Xt, "getRightLeafHeaders")), e.getLeafHeaders = tt(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, a) => {
      var l, r, o, i, s, d;
      return [...(l = (r = n[0]) == null ? void 0 : r.headers) != null ? l : [], ...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(s = (d = a[0]) == null ? void 0 : d.headers) != null ? s : []].map((u) => u.getLeafHeaders()).flat();
    }, nt(e.options, Xt, "getLeafHeaders"));
  }
};
function zo(e, n, t, a) {
  var l, r;
  let o = 0;
  const i = function(b, h) {
    h === void 0 && (h = 1), o = Math.max(o, h), b.filter((p) => p.getIsVisible()).forEach((p) => {
      var x;
      (x = p.columns) != null && x.length && i(p.columns, h + 1);
    }, 0);
  };
  i(e);
  let s = [];
  const d = (b, h) => {
    const p = {
      depth: h,
      id: [a, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, x = [];
    b.forEach((y) => {
      const w = [...x].reverse()[0], $ = y.column.depth === p.depth;
      let S, L = !1;
      if ($ && y.column.parent ? S = y.column.parent : (S = y.column, L = !0), w && (w == null ? void 0 : w.column) === S)
        w.subHeaders.push(y);
      else {
        const T = Cb(t, S, {
          id: [a, h, S.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: L,
          placeholderId: L ? `${x.filter((E) => E.column === S).length}` : void 0,
          depth: h,
          index: x.length
        });
        T.subHeaders.push(y), x.push(T);
      }
      p.headers.push(y), y.headerGroup = p;
    }), s.push(p), h > 0 && d(x, h - 1);
  }, u = n.map((b, h) => Cb(t, b, {
    depth: o,
    index: h
  }));
  d(u, o - 1), s.reverse();
  const f = (b) => b.filter((p) => p.column.getIsVisible()).map((p) => {
    let x = 0, y = 0, w = [0];
    p.subHeaders && p.subHeaders.length ? (w = [], f(p.subHeaders).forEach((S) => {
      let {
        colSpan: L,
        rowSpan: T
      } = S;
      x += L, w.push(T);
    })) : x = 1;
    const $ = Math.min(...w);
    return y = y + $, p.colSpan = x, p.rowSpan = y, {
      colSpan: x,
      rowSpan: y
    };
  });
  return f((l = (r = s[0]) == null ? void 0 : r.headers) != null ? l : []), s;
}
const $N = (e, n, t, a, l, r, o) => {
  let i = {
    id: n,
    index: a,
    original: t,
    depth: l,
    parentId: o,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (s) => {
      if (i._valuesCache.hasOwnProperty(s))
        return i._valuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return i._valuesCache[s] = d.accessorFn(i.original, a), i._valuesCache[s];
    },
    getUniqueValues: (s) => {
      if (i._uniqueValuesCache.hasOwnProperty(s))
        return i._uniqueValuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (i._uniqueValuesCache[s] = d.columnDef.getUniqueValues(i.original, a), i._uniqueValuesCache[s]) : (i._uniqueValuesCache[s] = [i.getValue(s)], i._uniqueValuesCache[s]);
    },
    renderValue: (s) => {
      var d;
      return (d = i.getValue(s)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => kN(i.subRows, (s) => s.subRows),
    getParentRow: () => i.parentId ? e.getRow(i.parentId, !0) : void 0,
    getParentRows: () => {
      let s = [], d = i;
      for (; ; ) {
        const u = d.getParentRow();
        if (!u) break;
        s.push(u), d = u;
      }
      return s.reverse();
    },
    getAllCells: tt(() => [e.getAllLeafColumns()], (s) => s.map((d) => wN(e, i, d, d.id)), nt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: tt(() => [i.getAllCells()], (s) => s.reduce((d, u) => (d[u.column.id] = u, d), {}), nt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let s = 0; s < e._features.length; s++) {
    const d = e._features[s];
    d == null || d.createRow == null || d.createRow(i, e);
  }
  return i;
}, IN = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, ax = (e, n, t) => {
  var a, l;
  const r = t == null || (a = t.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((l = e.getValue(n)) == null || (l = l.toString()) == null || (l = l.toLowerCase()) == null) && l.includes(r));
};
ax.autoRemove = (e) => Vn(e);
const lx = (e, n, t) => {
  var a;
  return !!(!((a = e.getValue(n)) == null || (a = a.toString()) == null) && a.includes(t));
};
lx.autoRemove = (e) => Vn(e);
const rx = (e, n, t) => {
  var a;
  return ((a = e.getValue(n)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
rx.autoRemove = (e) => Vn(e);
const ox = (e, n, t) => {
  var a;
  return (a = e.getValue(n)) == null ? void 0 : a.includes(t);
};
ox.autoRemove = (e) => Vn(e);
const ix = (e, n, t) => !t.some((a) => {
  var l;
  return !((l = e.getValue(n)) != null && l.includes(a));
});
ix.autoRemove = (e) => Vn(e) || !(e != null && e.length);
const sx = (e, n, t) => t.some((a) => {
  var l;
  return (l = e.getValue(n)) == null ? void 0 : l.includes(a);
});
sx.autoRemove = (e) => Vn(e) || !(e != null && e.length);
const dx = (e, n, t) => e.getValue(n) === t;
dx.autoRemove = (e) => Vn(e);
const ux = (e, n, t) => e.getValue(n) == t;
ux.autoRemove = (e) => Vn(e);
const qc = (e, n, t) => {
  let [a, l] = t;
  const r = e.getValue(n);
  return r >= a && r <= l;
};
qc.resolveFilterValue = (e) => {
  let [n, t] = e, a = typeof n != "number" ? parseFloat(n) : n, l = typeof t != "number" ? parseFloat(t) : t, r = n === null || Number.isNaN(a) ? -1 / 0 : a, o = t === null || Number.isNaN(l) ? 1 / 0 : l;
  if (r > o) {
    const i = r;
    r = o, o = i;
  }
  return [r, o];
};
qc.autoRemove = (e) => Vn(e) || Vn(e[0]) && Vn(e[1]);
const ia = {
  includesString: ax,
  includesStringSensitive: lx,
  equalsString: rx,
  arrIncludes: ox,
  arrIncludesAll: ix,
  arrIncludesSome: sx,
  equals: dx,
  weakEquals: ux,
  inNumberRange: qc
};
function Vn(e) {
  return e == null || e === "";
}
const TN = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: pn("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      return typeof a == "string" ? ia.includesString : typeof a == "number" ? ia.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? ia.equals : Array.isArray(a) ? ia.arrIncludes : ia.weakEquals;
    }, e.getFilterFn = () => {
      var t, a;
      return ps(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (a = n.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? t : ia[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, a, l;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((a = n.options.enableColumnFilters) != null ? a : !0) && ((l = n.options.enableFilters) != null ? l : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((a) => a.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, a;
      return (t = (a = n.getState().columnFilters) == null ? void 0 : a.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((a) => {
        const l = e.getFilterFn(), r = a == null ? void 0 : a.find((u) => u.id === e.id), o = Ta(t, r ? r.value : void 0);
        if (Sb(l, o, e)) {
          var i;
          return (i = a == null ? void 0 : a.filter((u) => u.id !== e.id)) != null ? i : [];
        }
        const s = {
          id: e.id,
          value: o
        };
        if (r) {
          var d;
          return (d = a == null ? void 0 : a.map((u) => u.id === e.id ? s : u)) != null ? d : [];
        }
        return a != null && a.length ? [...a, s] : [s];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), a = (l) => {
        var r;
        return (r = Ta(n, l)) == null ? void 0 : r.filter((o) => {
          const i = t.find((s) => s.id === o.id);
          if (i) {
            const s = i.getFilterFn();
            if (Sb(s, o.value, i))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (n) => {
      var t, a;
      e.setColumnFilters(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Sb(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const LN = (e, n, t) => t.reduce((a, l) => {
  const r = l.getValue(e);
  return a + (typeof r == "number" ? r : 0);
}, 0), AN = (e, n, t) => {
  let a;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (a > r || a === void 0 && r >= r) && (a = r);
  }), a;
}, EN = (e, n, t) => {
  let a;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (a < r || a === void 0 && r >= r) && (a = r);
  }), a;
}, RN = (e, n, t) => {
  let a, l;
  return t.forEach((r) => {
    const o = r.getValue(e);
    o != null && (a === void 0 ? o >= o && (a = l = o) : (a > o && (a = o), l < o && (l = o)));
  }), [a, l];
}, BN = (e, n) => {
  let t = 0, a = 0;
  if (n.forEach((l) => {
    let r = l.getValue(e);
    r != null && (r = +r) >= r && (++t, a += r);
  }), t) return a / t;
}, DN = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((r) => r.getValue(e));
  if (!yN(t))
    return;
  if (t.length === 1)
    return t[0];
  const a = Math.floor(t.length / 2), l = t.sort((r, o) => r - o);
  return t.length % 2 !== 0 ? l[a] : (l[a - 1] + l[a]) / 2;
}, MN = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), zN = (e, n) => new Set(n.map((t) => t.getValue(e))).size, ON = (e, n) => n.length, bd = {
  sum: LN,
  min: AN,
  max: EN,
  extent: RN,
  mean: BN,
  median: DN,
  unique: MN,
  uniqueCount: zN,
  count: ON
}, PN = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: pn("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((a) => a !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, a;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((a = n.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      if (typeof a == "number")
        return bd.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return bd.extent;
    }, e.getAggregationFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return ps(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (a = n.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? t : bd[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, a;
      e.setGrouping(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const a = n.getColumn(t);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, a) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var l;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((l = t.subRows) != null && l.length);
    };
  }
};
function FN(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const a = e.filter((r) => !n.includes(r.id));
  return t === "remove" ? a : [...n.map((r) => e.find((o) => o.id === r)).filter(Boolean), ...a];
}
const VN = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: pn("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = tt((t) => [Or(n, t)], (t) => t.findIndex((a) => a.id === e.id), nt(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var a;
      return ((a = Or(n, t)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var a;
      const l = Or(n, t);
      return ((a = l[l.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = tt(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, a) => (l) => {
      let r = [];
      if (!(n != null && n.length))
        r = l;
      else {
        const o = [...n], i = [...l];
        for (; i.length && o.length; ) {
          const s = o.shift(), d = i.findIndex((u) => u.id === s);
          d > -1 && r.push(i.splice(d, 1)[0]);
        }
        r = [...r, ...i];
      }
      return FN(r, t, a);
    }, nt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, gd = () => ({
  left: [],
  right: []
}), NN = {
  getInitialState: (e) => ({
    columnPinning: gd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: pn("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const a = e.getLeafColumns().map((l) => l.id).filter(Boolean);
      n.setColumnPinning((l) => {
        var r, o;
        if (t === "right") {
          var i, s;
          return {
            left: ((i = l == null ? void 0 : l.left) != null ? i : []).filter((f) => !(a != null && a.includes(f))),
            right: [...((s = l == null ? void 0 : l.right) != null ? s : []).filter((f) => !(a != null && a.includes(f))), ...a]
          };
        }
        if (t === "left") {
          var d, u;
          return {
            left: [...((d = l == null ? void 0 : l.left) != null ? d : []).filter((f) => !(a != null && a.includes(f))), ...a],
            right: ((u = l == null ? void 0 : l.right) != null ? u : []).filter((f) => !(a != null && a.includes(f)))
          };
        }
        return {
          left: ((r = l == null ? void 0 : l.left) != null ? r : []).filter((f) => !(a != null && a.includes(f))),
          right: ((o = l == null ? void 0 : l.right) != null ? o : []).filter((f) => !(a != null && a.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var l, r, o;
      return ((l = a.columnDef.enablePinning) != null ? l : !0) && ((r = (o = n.options.enableColumnPinning) != null ? o : n.options.enablePinning) != null ? r : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((i) => i.id), {
        left: a,
        right: l
      } = n.getState().columnPinning, r = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => l == null ? void 0 : l.includes(i));
      return r ? "left" : o ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const l = e.getIsPinned();
      return l ? (t = (a = n.getState().columnPinning) == null || (a = a[l]) == null ? void 0 : a.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = tt(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, a, l) => {
      const r = [...a ?? [], ...l ?? []];
      return t.filter((o) => !r.includes(o.column.id));
    }, nt(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = tt(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, a) => (a ?? []).map((r) => t.find((o) => o.column.id === r)).filter(Boolean).map((r) => ({
      ...r,
      position: "left"
    })), nt(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = tt(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, a) => (a ?? []).map((r) => t.find((o) => o.column.id === r)).filter(Boolean).map((r) => ({
      ...r,
      position: "right"
    })), nt(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, a;
      return e.setColumnPinning(n ? gd() : (t = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? t : gd());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const a = e.getState().columnPinning;
      if (!n) {
        var l, r;
        return !!((l = a.left) != null && l.length || (r = a.right) != null && r.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e.getLeftLeafColumns = tt(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((a) => n.find((l) => l.id === a)).filter(Boolean), nt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = tt(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((a) => n.find((l) => l.id === a)).filter(Boolean), nt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = tt(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a) => {
      const l = [...t ?? [], ...a ?? []];
      return n.filter((r) => !l.includes(r.id));
    }, nt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function HN(e) {
  return e || (typeof document < "u" ? document : null);
}
const Oo = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, md = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), jN = {
  getDefaultColumnDef: () => Oo,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: md(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: pn("columnSizing", e),
    onColumnSizingInfoChange: pn("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, a, l;
      const r = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : Oo.minSize, (a = r ?? e.columnDef.size) != null ? a : Oo.size), (l = e.columnDef.maxSize) != null ? l : Oo.maxSize);
    }, e.getStart = tt((t) => [t, Or(n, t), n.getState().columnSizing], (t, a) => a.slice(0, e.getIndex(t)).reduce((l, r) => l + r.getSize(), 0), nt(n.options, "debugColumns", "getStart")), e.getAfter = tt((t) => [t, Or(n, t), n.getState().columnSizing], (t, a) => a.slice(e.getIndex(t) + 1).reduce((l, r) => l + r.getSize(), 0), nt(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: a,
          ...l
        } = t;
        return l;
      });
    }, e.getCanResize = () => {
      var t, a;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((a = n.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const a = (l) => {
        if (l.subHeaders.length)
          l.subHeaders.forEach(a);
        else {
          var r;
          t += (r = l.column.getSize()) != null ? r : 0;
        }
      };
      return a(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const a = n.getColumn(e.column.id), l = a == null ? void 0 : a.getCanResize();
      return (r) => {
        if (!a || !l || (r.persist == null || r.persist(), pd(r) && r.touches && r.touches.length > 1))
          return;
        const o = e.getSize(), i = e ? e.getLeafHeaders().map((w) => [w.column.id, w.column.getSize()]) : [[a.id, a.getSize()]], s = pd(r) ? Math.round(r.touches[0].clientX) : r.clientX, d = {}, u = (w, $) => {
          typeof $ == "number" && (n.setColumnSizingInfo((S) => {
            var L, T;
            const E = n.options.columnResizeDirection === "rtl" ? -1 : 1, A = ($ - ((L = S == null ? void 0 : S.startOffset) != null ? L : 0)) * E, D = Math.max(A / ((T = S == null ? void 0 : S.startSize) != null ? T : 0), -0.999999);
            return S.columnSizingStart.forEach((M) => {
              let [F, X] = M;
              d[F] = Math.round(Math.max(X + X * D, 0) * 100) / 100;
            }), {
              ...S,
              deltaOffset: A,
              deltaPercentage: D
            };
          }), (n.options.columnResizeMode === "onChange" || w === "end") && n.setColumnSizing((S) => ({
            ...S,
            ...d
          })));
        }, f = (w) => u("move", w), b = (w) => {
          u("end", w), n.setColumnSizingInfo(($) => ({
            ...$,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, h = HN(t), p = {
          moveHandler: (w) => f(w.clientX),
          upHandler: (w) => {
            h == null || h.removeEventListener("mousemove", p.moveHandler), h == null || h.removeEventListener("mouseup", p.upHandler), b(w.clientX);
          }
        }, x = {
          moveHandler: (w) => (w.cancelable && (w.preventDefault(), w.stopPropagation()), f(w.touches[0].clientX), !1),
          upHandler: (w) => {
            var $;
            h == null || h.removeEventListener("touchmove", x.moveHandler), h == null || h.removeEventListener("touchend", x.upHandler), w.cancelable && (w.preventDefault(), w.stopPropagation()), b(($ = w.touches[0]) == null ? void 0 : $.clientX);
          }
        }, y = WN() ? {
          passive: !1
        } : !1;
        pd(r) ? (h == null || h.addEventListener("touchmove", x.moveHandler, y), h == null || h.addEventListener("touchend", x.upHandler, y)) : (h == null || h.addEventListener("mousemove", p.moveHandler, y), h == null || h.addEventListener("mouseup", p.upHandler, y)), n.setColumnSizingInfo((w) => ({
          ...w,
          startOffset: s,
          startSize: o,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: i,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? md() : (t = e.initialState.columnSizingInfo) != null ? t : md());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Po = null;
function WN() {
  if (typeof Po == "boolean") return Po;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return Po = e, Po;
}
function pd(e) {
  return e.type === "touchstart";
}
const qN = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: pn("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((a) => ({
        ...a,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, a;
      const l = e.columns;
      return (t = l.length ? l.some((r) => r.getIsVisible()) : (a = n.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, a;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((a = n.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = tt(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((a) => a.column.getIsVisible()), nt(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = tt(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, a, l) => [...t, ...a, ...l], nt(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, a) => tt(() => [a(), a().filter((l) => l.getIsVisible()).map((l) => l.id).join("_")], (l) => l.filter((r) => r.getIsVisible == null ? void 0 : r.getIsVisible()), nt(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var a;
      e.setColumnVisibility(t ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var a;
      t = (a = t) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((l, r) => ({
        ...l,
        [r.id]: t || !(r.getCanHide != null && r.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var a;
      e.toggleAllColumnsVisible((a = t.target) == null ? void 0 : a.checked);
    };
  }
};
function Or(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const UN = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, GN = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: pn("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const a = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, a, l, r;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((a = n.options.enableGlobalFilter) != null ? a : !0) && ((l = n.options.enableFilters) != null ? l : !0) && ((r = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? r : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ia.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: a
      } = e.options;
      return ps(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[a]) != null ? n : ia[a];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, KN = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: pn("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var a, l;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (l = e.options.autoResetAll) != null ? l : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var l, r;
      e.setExpanded(a ? {} : (l = (r = e.initialState) == null ? void 0 : r.expanded) != null ? l : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((l) => !l.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((r) => {
        const o = r.split(".");
        a = Math.max(a, o.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((a) => {
        var l;
        const r = a === !0 ? !0 : !!(a != null && a[e.id]);
        let o = {};
        if (a === !0 ? Object.keys(n.getRowModel().rowsById).forEach((i) => {
          o[i] = !0;
        }) : o = a, t = (l = t) != null ? l : !r, !r && t)
          return {
            ...o,
            [e.id]: !0
          };
        if (r && !t) {
          const {
            [e.id]: i,
            ...s
          } = o;
          return s;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var t;
      const a = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : a === !0 || a != null && a[e.id]);
    }, e.getCanExpand = () => {
      var t, a, l;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((a = n.options.enableExpanding) != null ? a : !0) && !!((l = e.subRows) != null && l.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, a = e;
      for (; t && a.parentId; )
        a = n.getRow(a.parentId, !0), t = a.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, pu = 0, vu = 10, vd = () => ({
  pageIndex: pu,
  pageSize: vu
}), YN = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...vd(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: pn("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var a, l;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (l = e.options.autoResetAll) != null ? l : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (a) => {
      const l = (r) => Ta(a, r);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(l);
    }, e.resetPagination = (a) => {
      var l;
      e.setPagination(a ? vd() : (l = e.initialState.pagination) != null ? l : vd());
    }, e.setPageIndex = (a) => {
      e.setPagination((l) => {
        let r = Ta(a, l.pageIndex);
        const o = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return r = Math.max(0, Math.min(r, o)), {
          ...l,
          pageIndex: r
        };
      });
    }, e.resetPageIndex = (a) => {
      var l, r;
      e.setPageIndex(a ? pu : (l = (r = e.initialState) == null || (r = r.pagination) == null ? void 0 : r.pageIndex) != null ? l : pu);
    }, e.resetPageSize = (a) => {
      var l, r;
      e.setPageSize(a ? vu : (l = (r = e.initialState) == null || (r = r.pagination) == null ? void 0 : r.pageSize) != null ? l : vu);
    }, e.setPageSize = (a) => {
      e.setPagination((l) => {
        const r = Math.max(1, Ta(a, l.pageSize)), o = l.pageSize * l.pageIndex, i = Math.floor(o / r);
        return {
          ...l,
          pageIndex: i,
          pageSize: r
        };
      });
    }, e.setPageCount = (a) => e.setPagination((l) => {
      var r;
      let o = Ta(a, (r = e.options.pageCount) != null ? r : -1);
      return typeof o == "number" && (o = Math.max(-1, o)), {
        ...l,
        pageCount: o
      };
    }), e.getPageOptions = tt(() => [e.getPageCount()], (a) => {
      let l = [];
      return a && a > 0 && (l = [...new Array(a)].fill(null).map((r, o) => o)), l;
    }, nt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, l = e.getPageCount();
      return l === -1 ? !0 : l === 0 ? !1 : a < l - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, xd = () => ({
  top: [],
  bottom: []
}), JN = {
  getInitialState: (e) => ({
    rowPinning: xd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: pn("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, a, l) => {
      const r = a ? e.getLeafRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], o = l ? e.getParentRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], i = /* @__PURE__ */ new Set([...o, e.id, ...r]);
      n.setRowPinning((s) => {
        var d, u;
        if (t === "bottom") {
          var f, b;
          return {
            top: ((f = s == null ? void 0 : s.top) != null ? f : []).filter((x) => !(i != null && i.has(x))),
            bottom: [...((b = s == null ? void 0 : s.bottom) != null ? b : []).filter((x) => !(i != null && i.has(x))), ...Array.from(i)]
          };
        }
        if (t === "top") {
          var h, p;
          return {
            top: [...((h = s == null ? void 0 : s.top) != null ? h : []).filter((x) => !(i != null && i.has(x))), ...Array.from(i)],
            bottom: ((p = s == null ? void 0 : s.bottom) != null ? p : []).filter((x) => !(i != null && i.has(x)))
          };
        }
        return {
          top: ((d = s == null ? void 0 : s.top) != null ? d : []).filter((x) => !(i != null && i.has(x))),
          bottom: ((u = s == null ? void 0 : s.bottom) != null ? u : []).filter((x) => !(i != null && i.has(x)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: a,
        enablePinning: l
      } = n.options;
      return typeof a == "function" ? a(e) : (t = a ?? l) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: a,
        bottom: l
      } = n.getState().rowPinning, r = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => l == null ? void 0 : l.includes(i));
      return r ? "top" : o ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const l = e.getIsPinned();
      if (!l) return -1;
      const r = (t = l === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : t.map((o) => {
        let {
          id: i
        } = o;
        return i;
      });
      return (a = r == null ? void 0 : r.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, a;
      return e.setRowPinning(n ? xd() : (t = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? t : xd());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const a = e.getState().rowPinning;
      if (!n) {
        var l, r;
        return !!((l = a.top) != null && l.length || (r = a.bottom) != null && r.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e._getPinnedRows = (n, t, a) => {
      var l;
      return ((l = e.options.keepPinnedRows) == null || l ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((o) => {
          const i = e.getRow(o, !0);
          return i.getIsAllParentsExpanded() ? i : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((o) => n.find((i) => i.id === o))
      )).filter(Boolean).map((o) => ({
        ...o,
        position: a
      }));
    }, e.getTopRows = tt(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, t) => e._getPinnedRows(n, t, "top"), nt(e.options, "debugRows", "getTopRows")), e.getBottomRows = tt(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, t) => e._getPinnedRows(n, t, "bottom"), nt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = tt(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, a) => {
      const l = /* @__PURE__ */ new Set([...t ?? [], ...a ?? []]);
      return n.filter((r) => !l.has(r.id));
    }, nt(e.options, "debugRows", "getCenterRows"));
  }
}, XN = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: pn("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const a = {
          ...t
        }, l = e.getPreGroupedRowModel().flatRows;
        return n ? l.forEach((r) => {
          r.getCanSelect() && (a[r.id] = !0);
        }) : l.forEach((r) => {
          delete a[r.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const a = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), l = {
        ...t
      };
      return e.getRowModel().rows.forEach((r) => {
        xu(l, r.id, a, !0, e);
      }), l;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = tt(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? yd(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, nt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = tt(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? yd(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, nt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = tt(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? yd(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, nt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let a = !!(n.length && Object.keys(t).length);
      return a && n.some((l) => l.getCanSelect() && !t[l.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((l) => l.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let a = !!n.length;
      return a && n.some((l) => !t[l.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, a) => {
      const l = e.getIsSelected();
      n.setRowSelection((r) => {
        var o;
        if (t = typeof t < "u" ? t : !l, e.getCanSelect() && l === t)
          return r;
        const i = {
          ...r
        };
        return xu(i, e.id, t, (o = a == null ? void 0 : a.selectChildren) != null ? o : !0, n), i;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return Uc(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return yu(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return yu(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (a) => {
        var l;
        t && e.toggleSelected((l = a.target) == null ? void 0 : l.checked);
      };
    };
  }
}, xu = (e, n, t, a, l) => {
  var r;
  const o = l.getRow(n, !0);
  t ? (o.getCanMultiSelect() || Object.keys(e).forEach((i) => delete e[i]), o.getCanSelect() && (e[n] = !0)) : delete e[n], a && (r = o.subRows) != null && r.length && o.getCanSelectSubRows() && o.subRows.forEach((i) => xu(e, i.id, t, a, l));
};
function yd(e, n) {
  const t = e.getState().rowSelection, a = [], l = {}, r = function(o, i) {
    return o.map((s) => {
      var d;
      const u = Uc(s, t);
      if (u && (a.push(s), l[s.id] = s), (d = s.subRows) != null && d.length && (s = {
        ...s,
        subRows: r(s.subRows)
      }), u)
        return s;
    }).filter(Boolean);
  };
  return {
    rows: r(n.rows),
    flatRows: a,
    rowsById: l
  };
}
function Uc(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function yu(e, n, t) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let l = !0, r = !1;
  return e.subRows.forEach((o) => {
    if (!(r && !l) && (o.getCanSelect() && (Uc(o, n) ? r = !0 : l = !1), o.subRows && o.subRows.length)) {
      const i = yu(o, n);
      i === "all" ? r = !0 : (i === "some" && (r = !0), l = !1);
    }
  }), l ? "all" : r ? "some" : !1;
}
const ku = /([0-9]+)/gm, ZN = (e, n, t) => cx(Na(e.getValue(t)).toLowerCase(), Na(n.getValue(t)).toLowerCase()), QN = (e, n, t) => cx(Na(e.getValue(t)), Na(n.getValue(t))), _N = (e, n, t) => Gc(Na(e.getValue(t)).toLowerCase(), Na(n.getValue(t)).toLowerCase()), e9 = (e, n, t) => Gc(Na(e.getValue(t)), Na(n.getValue(t))), t9 = (e, n, t) => {
  const a = e.getValue(t), l = n.getValue(t);
  return a > l ? 1 : a < l ? -1 : 0;
}, n9 = (e, n, t) => Gc(e.getValue(t), n.getValue(t));
function Gc(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Na(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function cx(e, n) {
  const t = e.split(ku).filter(Boolean), a = n.split(ku).filter(Boolean);
  for (; t.length && a.length; ) {
    const l = t.shift(), r = a.shift(), o = parseInt(l, 10), i = parseInt(r, 10), s = [o, i].sort();
    if (isNaN(s[0])) {
      if (l > r)
        return 1;
      if (r > l)
        return -1;
      continue;
    }
    if (isNaN(s[1]))
      return isNaN(o) ? -1 : 1;
    if (o > i)
      return 1;
    if (i > o)
      return -1;
  }
  return t.length - a.length;
}
const fr = {
  alphanumeric: ZN,
  alphanumericCaseSensitive: QN,
  text: _N,
  textCaseSensitive: e9,
  datetime: t9,
  basic: n9
}, a9 = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: pn("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const l of t) {
        const r = l == null ? void 0 : l.getValue(e.id);
        if (Object.prototype.toString.call(r) === "[object Date]")
          return fr.datetime;
        if (typeof r == "string" && (a = !0, r.split(ku).length > 1))
          return fr.alphanumeric;
      }
      return a ? fr.text : fr.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return ps(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (a = n.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? t : fr[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, a) => {
      const l = e.getNextSortingOrder(), r = typeof t < "u" && t !== null;
      n.setSorting((o) => {
        const i = o == null ? void 0 : o.find((h) => h.id === e.id), s = o == null ? void 0 : o.findIndex((h) => h.id === e.id);
        let d = [], u, f = r ? t : l === "desc";
        if (o != null && o.length && e.getCanMultiSort() && a ? i ? u = "toggle" : u = "add" : o != null && o.length && s !== o.length - 1 ? u = "replace" : i ? u = "toggle" : u = "replace", u === "toggle" && (r || l || (u = "remove")), u === "add") {
          var b;
          d = [...o, {
            id: e.id,
            desc: f
          }], d.splice(0, d.length - ((b = n.options.maxMultiSortColCount) != null ? b : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? d = o.map((h) => h.id === e.id ? {
          ...h,
          desc: f
        } : h) : u === "remove" ? d = o.filter((h) => h.id !== e.id) : d = [{
          id: e.id,
          desc: f
        }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var t, a;
      return ((t = (a = e.columnDef.sortDescFirst) != null ? a : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var a, l;
      const r = e.getFirstSortDir(), o = e.getIsSorted();
      return o ? o !== r && ((a = n.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(t && (l = n.options.enableMultiRemove) != null) || l) ? !1 : o === "desc" ? "asc" : "desc" : r;
    }, e.getCanSort = () => {
      var t, a;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((a = n.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, a;
      return (t = (a = e.columnDef.enableMultiSort) != null ? a : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const a = (t = n.getState().sorting) == null ? void 0 : t.find((l) => l.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, a;
      return (t = (a = n.getState().sorting) == null ? void 0 : a.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (a) => {
        t && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, a;
      e.setSorting(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, l9 = [
  SN,
  qN,
  VN,
  NN,
  IN,
  TN,
  UN,
  //depends on ColumnFaceting
  GN,
  //depends on ColumnFiltering
  a9,
  PN,
  //depends on RowSorting
  KN,
  YN,
  JN,
  XN,
  jN
];
function r9(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...l9, ...(n = e._features) != null ? n : []];
  let l = {
    _features: a
  };
  const r = l._features.reduce((b, h) => Object.assign(b, h.getDefaultOptions == null ? void 0 : h.getDefaultOptions(l)), {}), o = (b) => l.options.mergeOptions ? l.options.mergeOptions(r, b) : {
    ...r,
    ...b
  };
  let s = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  l._features.forEach((b) => {
    var h;
    s = (h = b.getInitialState == null ? void 0 : b.getInitialState(s)) != null ? h : s;
  });
  const d = [];
  let u = !1;
  const f = {
    _features: a,
    options: {
      ...r,
      ...e
    },
    initialState: s,
    _queue: (b) => {
      d.push(b), u || (u = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        u = !1;
      }).catch((h) => setTimeout(() => {
        throw h;
      })));
    },
    reset: () => {
      l.setState(l.initialState);
    },
    setOptions: (b) => {
      const h = Ta(b, l.options);
      l.options = o(h);
    },
    getState: () => l.options.state,
    setState: (b) => {
      l.options.onStateChange == null || l.options.onStateChange(b);
    },
    _getRowId: (b, h, p) => {
      var x;
      return (x = l.options.getRowId == null ? void 0 : l.options.getRowId(b, h, p)) != null ? x : `${p ? [p.id, h].join(".") : h}`;
    },
    getCoreRowModel: () => (l._getCoreRowModel || (l._getCoreRowModel = l.options.getCoreRowModel(l)), l._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => l.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (b, h) => {
      let p = (h ? l.getPrePaginationRowModel() : l.getRowModel()).rowsById[b];
      if (!p && (p = l.getCoreRowModel().rowsById[b], !p))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${b}`) : new Error();
      return p;
    },
    _getDefaultColumnDef: tt(() => [l.options.defaultColumn], (b) => {
      var h;
      return b = (h = b) != null ? h : {}, {
        header: (p) => {
          const x = p.header.column.columnDef;
          return x.accessorKey ? x.accessorKey : x.accessorFn ? x.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (p) => {
          var x, y;
          return (x = (y = p.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? x : null;
        },
        ...l._features.reduce((p, x) => Object.assign(p, x.getDefaultColumnDef == null ? void 0 : x.getDefaultColumnDef()), {}),
        ...b
      };
    }, nt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => l.options.columns,
    getAllColumns: tt(() => [l._getColumnDefs()], (b) => {
      const h = function(p, x, y) {
        return y === void 0 && (y = 0), p.map((w) => {
          const $ = CN(l, w, y, x), S = w;
          return $.columns = S.columns ? h(S.columns, $, y + 1) : [], $;
        });
      };
      return h(b);
    }, nt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: tt(() => [l.getAllColumns()], (b) => b.flatMap((h) => h.getFlatColumns()), nt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: tt(() => [l.getAllFlatColumns()], (b) => b.reduce((h, p) => (h[p.id] = p, h), {}), nt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: tt(() => [l.getAllColumns(), l._getOrderColumnsFn()], (b, h) => {
      let p = b.flatMap((x) => x.getLeafColumns());
      return h(p);
    }, nt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (b) => {
      const h = l._getAllFlatColumnsById()[b];
      return process.env.NODE_ENV !== "production" && !h && console.error(`[Table] Column with id '${b}' does not exist.`), h;
    }
  };
  Object.assign(l, f);
  for (let b = 0; b < l._features.length; b++) {
    const h = l._features[b];
    h == null || h.createTable == null || h.createTable(l);
  }
  return l;
}
function o9() {
  return (e) => tt(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, a = function(l, r, o) {
      r === void 0 && (r = 0);
      const i = [];
      for (let d = 0; d < l.length; d++) {
        const u = $N(e, e._getRowId(l[d], d, o), l[d], d, r, void 0, o == null ? void 0 : o.id);
        if (t.flatRows.push(u), t.rowsById[u.id] = u, i.push(u), e.options.getSubRows) {
          var s;
          u.originalSubRows = e.options.getSubRows(l[d], d), (s = u.originalSubRows) != null && s.length && (u.subRows = a(u.originalSubRows, r + 1, u));
        }
      }
      return i;
    };
    return t.rows = a(n), t;
  }, nt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Fo() {
  return !0;
}
const i9 = Symbol("merge-proxy"), s9 = {
  get(e, n, t) {
    return n === i9 ? t : e.get(n);
  },
  has(e, n) {
    return e.has(n);
  },
  set: Fo,
  deleteProperty: Fo,
  getOwnPropertyDescriptor(e, n) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(n);
      },
      set: Fo,
      deleteProperty: Fo
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function kd(e) {
  return "value" in e ? e.value : e;
}
function vr() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return new Proxy({
    get(a) {
      for (let l = n.length - 1; l >= 0; l--) {
        const r = kd(n[l])[a];
        if (r !== void 0) return r;
      }
    },
    has(a) {
      for (let l = n.length - 1; l >= 0; l--)
        if (a in kd(n[l])) return !0;
      return !1;
    },
    keys() {
      const a = [];
      for (let l = 0; l < n.length; l++) a.push(...Object.keys(kd(n[l])));
      return [...Array.from(new Set(a))];
    }
  }, s9);
}
const $b = ke({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? Kn(e.render, e.props) : e.render
});
function Ib(e) {
  return vr(e, {
    data: I(e.data)
  });
}
function d9(e) {
  const n = Wo(e.data), t = vr({
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    mergeOptions(r, o) {
      return n ? {
        ...r,
        ...o
      } : vr(r, o);
    }
  }, n ? Ib(e) : e), a = r9(t);
  if (n) {
    const r = Yl(e.data);
    $e(r, () => {
      a.setState((o) => ({
        ...o,
        data: r.value
      }));
    }, {
      immediate: !0
    });
  }
  const l = R(a.initialState);
  return qb(() => {
    a.setOptions((r) => {
      var o;
      const i = new Proxy({}, {
        get: (s, d) => l.value[d]
      });
      return vr(r, n ? Ib(e) : e, {
        // merge the initialState and `options.state`
        // create a new proxy on each `setOptions` call
        // and get the value from state on each property access
        state: vr(i, (o = e.state) != null ? o : {}),
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: (s) => {
          s instanceof Function ? l.value = s(l.value) : l.value = s, e.onStateChange == null || e.onStateChange(s);
        }
      });
    });
  }), a;
}
const u9 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.21232%2014.0601C1.91928%2012.6755%201.93115%2011.2743%202.21316%209.94038C3.32308%2010.0711%204.29187%209.7035%204.60865%208.93871C4.92544%208.17392%204.50032%207.22896%203.62307%206.53655C4.3669%205.3939%205.34931%204.39471%206.53554%203.62289C7.228%204.50059%208.17324%204.92601%208.93822%204.60914C9.7032%204.29227%2010.0708%203.32308%209.93979%202.21281C11.3243%201.91977%2012.7255%201.93164%2014.0595%202.21364C13.9288%203.32356%2014.2964%204.29235%2015.0612%204.60914C15.8259%204.92593%2016.7709%204.5008%2017.4633%203.62356C18.606%204.36739%2019.6052%205.3498%2020.377%206.53602C19.4993%207.22849%2019.0739%208.17373%2019.3907%208.93871C19.7076%209.70369%2020.6768%2010.0713%2021.7871%209.94028C22.0801%2011.3248%2022.0682%2012.726%2021.7862%2014.06C20.6763%2013.9293%2019.7075%2014.2969%2019.3907%2015.0616C19.0739%2015.8264%2019.4991%2016.7714%2020.3763%2017.4638C19.6325%2018.6064%2018.6501%2019.6056%2017.4638%2020.3775C16.7714%2019.4998%2015.8261%2019.0743%2015.0612%2019.3912C14.2962%2019.7081%2013.9286%2020.6773%2014.0596%2021.7875C12.675%2022.0806%2011.2738%2022.0687%209.93989%2021.7867C10.0706%2020.6768%209.70301%2019.708%208.93822%2019.3912C8.17343%2019.0744%207.22848%2019.4995%206.53606%2020.3768C5.39341%2019.633%204.39422%2018.6506%203.62241%2017.4643C4.5001%2016.7719%204.92552%2015.8266%204.60865%2015.0616C4.29179%2014.2967%203.32259%2013.9291%202.21232%2014.0601ZM3.99975%2012.2104C5.09956%2012.5148%206.00718%2013.2117%206.45641%2014.2963C6.90564%2015.3808%206.75667%2016.5154%206.19421%2017.5083C6.29077%2017.61%206.38998%2017.7092%206.49173%2017.8056C7.4846%2017.2432%208.61912%2017.0943%209.70359%2017.5435C10.7881%2017.9927%2011.485%2018.9002%2011.7894%2019.9999C11.9295%2020.0037%2012.0697%2020.0038%2012.2099%2020.0001C12.5143%2018.9003%2013.2112%2017.9927%2014.2958%2017.5435C15.3803%2017.0942%2016.5149%2017.2432%2017.5078%2017.8057C17.6096%2017.7091%2017.7087%2017.6099%2017.8051%2017.5081C17.2427%2016.5153%2017.0938%2015.3807%2017.543%2014.2963C17.9922%2013.2118%2018.8997%2012.5149%2019.9994%2012.2105C20.0032%2012.0704%2020.0033%2011.9301%2019.9996%2011.7899C18.8998%2011.4856%2017.9922%2010.7886%2017.543%209.70407C17.0937%208.61953%2017.2427%207.48494%2017.8052%206.49204C17.7086%206.39031%2017.6094%206.2912%2017.5076%206.19479C16.5148%206.75717%2015.3803%206.9061%2014.2958%206.4569C13.2113%206.0077%2012.5144%205.10016%2012.21%204.00044C12.0699%203.99666%2011.9297%203.99659%2011.7894%204.00024C11.4851%205.10005%2010.7881%206.00767%209.70359%206.4569C8.61904%206.90613%207.48446%206.75715%206.49155%206.1947C6.38982%206.29126%206.29071%206.39047%206.19431%206.49222C6.75668%207.48509%206.90561%208.61961%206.45641%209.70407C6.00721%2010.7885%205.09967%2011.4855%203.99995%2011.7899C3.99617%2011.93%203.9961%2012.0702%203.99975%2012.2104ZM11.9997%2015.0002C10.3428%2015.0002%208.99969%2013.657%208.99969%2012.0002C8.99969%2010.3433%2010.3428%209.00018%2011.9997%209.00018C13.6565%209.00018%2014.9997%2010.3433%2014.9997%2012.0002C14.9997%2013.657%2013.6565%2015.0002%2011.9997%2015.0002ZM11.9997%2013.0002C12.552%2013.0002%2012.9997%2012.5525%2012.9997%2012.0002C12.9997%2011.4479%2012.552%2011.0002%2011.9997%2011.0002C11.4474%2011.0002%2010.9997%2011.4479%2010.9997%2012.0002C10.9997%2012.5525%2011.4474%2013.0002%2011.9997%2013.0002Z'/%3e%3c/svg%3e";
function c9(e) {
  return e.map((n) => {
    const t = typeof n.header == "function" ? (l) => n.header({
      table: {
        getIsAllPageRowsSelected: () => l.table.getIsAllPageRowsSelected(),
        getIsSomePageRowsSelected: () => l.table.getIsSomePageRowsSelected(),
        toggleAllPageRowsSelected: (r) => l.table.toggleAllPageRowsSelected(r)
      }
    }) : n.header, a = {
      id: n.id,
      header: t,
      enableSorting: n.sortable,
      enableResizing: n.resizable,
      enablePinning: n.enablePinning ?? !1,
      meta: {
        enableColumnDragging: n.draggable,
        headerMenuItems: n.headerMenuItems,
        headerMenuAriaLabel: n.headerMenuAriaLabel,
        isCustomHeader: n.customHeader,
        noTruncate: n.noTruncate,
        // CONSTRAINT: no `??` here — `undefined` and `null` are two different headers downstream.
        sortDirection: n.sortDirection,
        locked: n.locked,
        showPinIcon: n.showPinIcon ?? !0
      }
    };
    return n.width !== void 0 && (a.size = n.width), n.minWidth !== void 0 && (a.minSize = n.minWidth), n.maxWidth !== void 0 && (a.maxSize = n.maxWidth), n.cell && (a.cell = (l) => n.cell({
      row: {
        original: l.row.original,
        getValue: (r) => l.row.getValue(r),
        id: l.row.id,
        getIsSelected: () => l.row.getIsSelected(),
        toggleSelected: (r) => l.row.toggleSelected(r)
      },
      getValue: () => l.getValue()
    })), n.key ? { ...a, accessorKey: n.key } : a;
  });
}
const f9 = ["aria-label"], h9 = { key: 0 }, b9 = {
  key: 1,
  class: "sticky right-0 z-30 w-10 p-0 bg-white dark:bg-(--colors-background-black-default)"
}, g9 = ["aria-label"], m9 = ["src"], p9 = { key: 0 }, v9 = {
  key: 1,
  "data-testid": "data-row-end",
  class: "row-end-cell sticky right-0 z-10 w-10 p-0 bg-white dark:bg-(--colors-background-black-default)"
}, x9 = { class: "flex items-center justify-center" }, y9 = {
  key: 2,
  "aria-hidden": "true"
}, k9 = 40, w9 = /* @__PURE__ */ ke({
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    hasSettings: { type: Boolean },
    columnVisibility: {},
    columnOrder: {},
    stickyHeader: { type: Boolean },
    maxHeight: {},
    emptyText: {},
    settingsAriaLabel: {},
    regionLabel: {},
    columnPinning: {},
    columnSizing: {},
    isRowMuted: { type: Function },
    isRowHighlighted: { type: Function }
  },
  emits: ["settings-click", "pin-column", "update:columnOrder", "update:columnPinning", "update:columnSizing"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(a.columnOrder ?? []);
    $e(
      () => a.columnOrder,
      (j) => {
        j && (r.value = j);
      }
    );
    const o = R({}), i = R(a.columnPinning ?? { left: [], right: [] }), s = R(null), d = R(null), u = R(0), f = m(() => a.hasSettings ? k9 : 0), b = R({}), h = R({}), p = /* @__PURE__ */ new Set(), y = R({ ...{
      startOffset: null,
      startSize: null,
      deltaOffset: null,
      deltaPercentage: null,
      isResizingColumn: !1,
      columnSizingStart: []
    } }), w = R(!1), $ = d9({
      get data() {
        return a.data;
      },
      get columns() {
        return c9(a.columns);
      },
      columnResizeMode: "onChange",
      enableRowSelection: !0,
      enableColumnPinning: !0,
      defaultColumn: {
        minSize: 130
      },
      state: {
        get columnOrder() {
          return r.value;
        },
        get columnVisibility() {
          return a.columnVisibility ?? {};
        },
        get columnSizing() {
          return b.value;
        },
        get columnSizingInfo() {
          return y.value;
        },
        get columnPinning() {
          return i.value;
        },
        get rowSelection() {
          return o.value;
        }
      },
      onColumnOrderChange: (j) => {
        const G = typeof j == "function" ? j(r.value) : j;
        r.value = G, l("update:columnOrder", G);
      },
      onColumnSizingChange: (j) => {
        b.value = typeof j == "function" ? j(b.value) : j;
      },
      onColumnSizingInfoChange: (j) => {
        y.value = typeof j == "function" ? j(y.value) : j;
      },
      onColumnPinningChange: (j) => {
        const G = typeof j == "function" ? j(i.value) : j, q = i.value, J = (G.left ?? []).length === (q.left ?? []).length && (G.left ?? []).every((ye, Z) => ye === (q.left ?? [])[Z]), me = (G.right ?? []).length === (q.right ?? []).length && (G.right ?? []).every((ye, Z) => ye === (q.right ?? [])[Z]);
        J && me || (i.value = G, l("update:columnPinning", G));
      },
      onRowSelectionChange: (j) => {
        o.value = typeof j == "function" ? j(o.value) : j;
      },
      getCoreRowModel: o9()
    }), S = m(() => ({
      allSelected: $.getIsAllPageRowsSelected(),
      someSelected: $.getIsSomePageRowsSelected(),
      toggleAll: (j) => $.toggleAllPageRowsSelected(j),
      isSelected: (j) => {
        var G;
        return ((G = $.getRowModel().rows.find((q) => q.original === j)) == null ? void 0 : G.getIsSelected()) ?? !1;
      },
      toggleRow: (j, G) => {
        var q;
        return (q = $.getRowModel().rows.find((J) => J.original === j)) == null ? void 0 : q.toggleSelected(G);
      }
    }));
    function L(j, G = "left") {
      const q = $.getColumn(j);
      q && (q.pin(G), l("pin-column", j, G));
    }
    function T(j) {
      L(j, !1);
    }
    function E(j) {
      r.value = j;
    }
    $e(
      () => a.columnPinning,
      (j) => {
        if (!j) return;
        const G = j.left ?? [], q = j.right ?? [], J = i.value, me = G.length === (J.left ?? []).length && G.every((Z, de) => Z === (J.left ?? [])[de]), ye = q.length === (J.right ?? []).length && q.every((Z, de) => Z === (J.right ?? [])[de]);
        me && ye || (i.value = { left: [...G], right: [...q] });
      },
      { deep: !0 }
    ), n({ selection: S, pinColumn: L, unpinColumn: T, setColumnOrder: E });
    function A() {
      var J, me;
      if (!d.value || Object.keys(b.value).length > 0) return;
      const j = Array.from(d.value.querySelectorAll("thead th")), G = ((J = $.getHeaderGroups()[0]) == null ? void 0 : J.headers) ?? [], q = {};
      if (G.forEach((ye, Z) => {
        const de = j[Z];
        if (de) {
          const ge = ye.column.columnDef.maxSize;
          q[ye.column.id] = ge !== void 0 ? Math.min(de.offsetWidth, ge) : de.offsetWidth;
        }
      }), Object.keys(q).length > 0) {
        const ye = d.value.clientWidth, Z = ye - f.value, ge = Object.values(q).reduce((se, Se) => se + Se, 0) - Z;
        if (ge !== 0) {
          const se = (me = [...G].reverse().find((Se) => Se.column.columnDef.maxSize === void 0)) == null ? void 0 : me.column.id;
          se !== void 0 && (q[se] = Math.max(130, q[se] - ge));
        }
        $.setColumnSizing(q), u.value = ye, h.value = { ...q }, w.value = !0, D();
      }
    }
    function D() {
      if (!w.value) return;
      const j = a.columnSizing ?? {}, G = Object.keys(j);
      if (G.length === 0) {
        p.size > 0 && (b.value = { ...h.value }, p.clear());
        return;
      }
      const q = new Set($.getAllLeafColumns().map((Z) => Z.id)), J = {};
      for (const Z of G) {
        const de = j[Z];
        q.has(Z) && typeof de == "number" && de > 0 && (J[Z] = de);
      }
      const me = Object.keys(J);
      me.length === p.size && me.every((Z) => b.value[Z] === J[Z]) || (b.value = { ...h.value, ...J }, p.clear(), me.forEach((Z) => p.add(Z)));
    }
    function M() {
      const j = {};
      p.forEach((G) => {
        const q = b.value[G];
        typeof q == "number" && (j[G] = q);
      }), l("update:columnSizing", j);
    }
    $e(
      () => y.value.isResizingColumn,
      (j, G) => {
        G && !j && (p.add(G), M());
      }
    ), $e(() => a.columnSizing, D, { deep: !0 });
    function F(j) {
      var de;
      if (!w.value) return;
      const G = j - u.value;
      if (G === 0) return;
      const J = (((de = $.getHeaderGroups()[0]) == null ? void 0 : de.headers) ?? []).filter(
        (ge) => ge.column.columnDef.maxSize === void 0 || ge.column.columnDef.maxSize >= Number.MAX_SAFE_INTEGER
      );
      if (J.length === 0) return;
      const me = { ...b.value }, ye = J.reduce(
        (ge, se) => ge + (me[se.column.id] ?? se.column.getSize()),
        0
      );
      let Z = G;
      J.forEach((ge, se) => {
        const Se = me[ge.column.id] ?? ge.column.getSize(), V = ge.column.columnDef.minSize ?? 130, Q = se === J.length - 1 ? Z : Math.round(G * (Se / ye));
        me[ge.column.id] = Math.max(V, Se + Q), Z -= Q;
      }), b.value = me, u.value = j;
    }
    let X = null;
    dt(() => {
      Ue(() => {
        d.value && (X = new ResizeObserver((j) => {
          var q, J;
          const G = ((q = j[0]) == null ? void 0 : q.contentRect.width) ?? ((J = d.value) == null ? void 0 : J.clientWidth) ?? 0;
          w.value ? F(Math.round(G)) : G > 0 && A();
        }), X.observe(d.value), d.value.clientWidth > 0 && A());
      });
    }), gt(() => {
      X == null || X.disconnect(), X = null;
    });
    const _ = m(() => {
      if (w.value)
        return `${$.getTotalSize() + f.value}px`;
    }), Y = m(() => w.value ? $.getTotalSize() + f.value < u.value : !1);
    function B(j) {
      var q;
      const G = $.getColumn(j);
      ((q = G == null ? void 0 : G.columnDef.meta) == null ? void 0 : q.locked) !== !0 && (s.value = j);
    }
    function W(j) {
      var G;
      return ((G = j.columnDef.meta) == null ? void 0 : G.locked) === !0 ? "locked" : j.getIsPinned() === "left" ? "pinned" : "regular";
    }
    function U(j) {
      return (G) => {
        if (G.preventDefault(), !s.value) return;
        const q = $.getVisibleLeafColumns().map((V) => V.id), J = q.indexOf(s.value), me = q.indexOf(j);
        if (me === 0 || J === -1 || me === -1) return;
        const ye = $.getColumn(s.value), Z = $.getColumn(j);
        if (!ye || !Z) {
          s.value = null;
          return;
        }
        const de = W(ye), ge = W(Z);
        if (de === "locked" || ge === "locked" || de !== ge) {
          s.value = null;
          return;
        }
        if (de === "pinned" && ge === "pinned") {
          const V = [...$.getState().columnPinning.left ?? []], Q = V.indexOf(s.value), le = V.indexOf(j);
          if (Q !== -1 && le !== -1 && Q !== le) {
            const [ee] = V.splice(Q, 1);
            V.splice(le, 0, ee), $.setColumnPinning({
              left: V,
              right: $.getState().columnPinning.right ?? []
            });
          }
        }
        const se = [...q], [Se] = se.splice(J, 1);
        se.splice(me, 0, Se), $.setColumnOrder(se), s.value = null;
      };
    }
    function z(j) {
      const G = j.style.width, q = j.style.maxWidth;
      j.style.width = "max-content", j.style.maxWidth = "none";
      const J = j.scrollWidth;
      return j.style.width = G, j.style.maxWidth = q, J;
    }
    function P(j) {
      var le, ee, O;
      if (!d.value) return;
      const G = (le = $.getHeaderGroups()[0]) == null ? void 0 : le.headers.findIndex((ne) => ne.column.id === j);
      if (G === void 0 || G < 0) return;
      const J = Array.from(d.value.querySelectorAll("thead th"))[G], me = J == null ? void 0 : J.querySelector(".truncate, [data-slot]"), ye = me ? z(me) : (J == null ? void 0 : J.scrollWidth) ?? 0, Z = d.value.querySelectorAll("tbody tr");
      let de = 0;
      Z.forEach((ne) => {
        const ue = ne.querySelectorAll("td")[G];
        if (ue) {
          const te = ue.querySelector(".truncate");
          de = Math.max(de, te ? z(te) : ue.scrollWidth);
        }
      });
      const ge = (O = (ee = $.getHeaderGroups()[0]) == null ? void 0 : ee.headers[G]) == null ? void 0 : O.column, se = (ge == null ? void 0 : ge.columnDef.minSize) ?? 130, Se = (ge == null ? void 0 : ge.columnDef.maxSize) ?? 1e3, V = Math.min(
        Se,
        Math.max(se, Math.max(ye, de) + 24)
      ), Q = { ...b.value, [j]: V };
      $.setColumnSizing(Q), p.add(j), M();
    }
    function K(j) {
      const G = j.getIsPinned();
      if (!G)
        return w.value ? { width: `${j.getSize()}px` } : void 0;
      const q = {
        position: "sticky",
        zIndex: "10"
      };
      return G === "left" && (q.left = `${j.getStart("left")}px`), w.value && (q.width = `${j.getSize()}px`), q;
    }
    return (j, G) => (c(), g("div", {
      class: C(["relative border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)", { "h-full flex flex-col": e.stickyHeader && !e.maxHeight }])
    }, [
      v("div", {
        ref_key: "containerRef",
        ref: d,
        role: "region",
        "aria-label": e.regionLabel ?? "Data table",
        "data-testid": "data-table-container",
        class: C(["relative overflow-x-auto text-(--text-text-heading)", { "overflow-y-auto flex-1 min-h-0": e.stickyHeader && !e.maxHeight }]),
        style: Ne({ scrollbarGutter: "stable", ...e.maxHeight ? { maxHeight: e.maxHeight, overflowY: "auto" } : {} })
      }, [
        re(I(aN), { "table-width": _.value }, {
          default: xe(() => [
            re(I(xN), {
              "is-sticky": e.stickyHeader || !!e.maxHeight
            }, {
              default: xe(() => [
                (c(!0), g(ce, null, Re(I($).getHeaderGroups(), (q) => (c(), H(I(_o), {
                  key: q.id
                }, {
                  default: xe(() => [
                    (c(!0), g(ce, null, Re(q.headers, (J) => {
                      var me, ye, Z, de, ge, se, Se;
                      return c(), H(I(vN), {
                        key: J.id,
                        style: Ne(K(J.column)),
                        "is-pinned": J.column.getIsPinned() === "left",
                        "is-last-pinned": J.column.getIsLastColumn("left"),
                        "header-menu-items": (me = J.column.columnDef.meta) == null ? void 0 : me.headerMenuItems,
                        "menu-aria-label": (ye = J.column.columnDef.meta) == null ? void 0 : ye.headerMenuAriaLabel,
                        "is-custom-header": (Z = J.column.columnDef.meta) == null ? void 0 : Z.isCustomHeader,
                        "is-draggable": ((de = J.column.columnDef.meta) == null ? void 0 : de.enableColumnDragging) === !0,
                        "is-locked": ((ge = J.column.columnDef.meta) == null ? void 0 : ge.locked) === !0,
                        "is-pin-icon-visible": ((se = J.column.columnDef.meta) == null ? void 0 : se.showPinIcon) !== !1,
                        "sort-direction": (Se = J.column.columnDef.meta) == null ? void 0 : Se.sortDirection,
                        "is-resizable": J.column.getCanResize(),
                        "is-resizing-active": J.column.getIsResizing(),
                        class: "header-cell",
                        onDragHandleStart: (V) => B(J.column.id),
                        onDragover: G[0] || (G[0] = Ye(() => {
                        }, ["prevent"])),
                        onDrop: (V) => U(J.column.id)(V),
                        onResizeStart: (V) => J.getResizeHandler()(V),
                        onResizeAuto: (V) => P(J.column.id)
                      }, {
                        default: xe(() => [
                          J.isPlaceholder ? k("", !0) : (c(), H(I($b), {
                            key: 0,
                            render: J.column.columnDef.header,
                            props: J.getContext()
                          }, null, 8, ["render", "props"]))
                        ]),
                        _: 2
                      }, 1032, ["style", "is-pinned", "is-last-pinned", "header-menu-items", "menu-aria-label", "is-custom-header", "is-draggable", "is-locked", "is-pin-icon-visible", "sort-direction", "is-resizable", "is-resizing-active", "onDragHandleStart", "onDrop", "onResizeStart", "onResizeAuto"]);
                    }), 128)),
                    Y.value ? (c(), g("th", h9)) : k("", !0),
                    e.hasSettings ? (c(), g("th", b9, [
                      v("button", {
                        "data-testid": "data-settings",
                        "aria-label": e.settingsAriaLabel ?? "Column settings",
                        class: "data-settings-btn flex items-center justify-center w-10 h-10 p-0 cursor-pointer focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:outline-none transition-colors",
                        onClick: G[1] || (G[1] = (J) => l("settings-click"))
                      }, [
                        v("img", {
                          class: "size-5",
                          src: I(u9),
                          alt: ""
                        }, null, 8, m9)
                      ], 8, g9)
                    ])) : k("", !0)
                  ]),
                  _: 2
                }, 1024))), 128))
              ]),
              _: 1
            }, 8, ["is-sticky"]),
            re(I(lN), null, {
              default: xe(() => {
                var q;
                return [
                  (q = I($).getRowModel().rows) != null && q.length ? (c(!0), g(ce, { key: 0 }, Re(I($).getRowModel().rows, (J) => {
                    var me, ye;
                    return c(), H(I(_o), {
                      key: J.id,
                      "data-state": J.getIsSelected() ? "selected" : void 0,
                      "data-muted": (me = e.isRowMuted) != null && me.call(e, J.original) ? "true" : void 0,
                      "data-highlighted": (ye = e.isRowHighlighted) != null && ye.call(e, J.original) ? "true" : void 0
                    }, {
                      default: xe(() => [
                        (c(!0), g(ce, null, Re(J.getVisibleCells(), (Z) => {
                          var de;
                          return c(), H(I(mu), {
                            key: Z.id,
                            "no-truncate": (de = Z.column.columnDef.meta) == null ? void 0 : de.noTruncate,
                            style: Ne(K(Z.column)),
                            class: C([
                              Z.column.getIsPinned() === "left" ? "sticky z-10 bg-white dark:bg-(--colors-background-black-default) pinned-cell" : "",
                              Z.column.getIsLastColumn("left") ? "pinned-cell-last" : ""
                            ])
                          }, {
                            default: xe(() => [
                              re(I($b), {
                                render: Z.column.columnDef.cell ?? Z.getValue,
                                props: Z.getContext()
                              }, null, 8, ["render", "props"])
                            ]),
                            _: 2
                          }, 1032, ["no-truncate", "style", "class"]);
                        }), 128)),
                        Y.value ? (c(), g("td", p9)) : k("", !0),
                        e.hasSettings && j.$slots["row-end"] ? (c(), g("td", v9, [
                          v("div", x9, [
                            Ae(j.$slots, "row-end", {
                              row: J.original
                            }, void 0, !0)
                          ])
                        ])) : e.hasSettings ? (c(), g("td", y9)) : k("", !0)
                      ]),
                      _: 2
                    }, 1032, ["data-state", "data-muted", "data-highlighted"]);
                  }), 128)) : (c(), H(I(_o), {
                    key: 1,
                    class: "border-b-0! hover:bg-white! dark:hover:bg-(--colors-background-black-default)!"
                  }, {
                    default: xe(() => [
                      re(I(mu), {
                        colspan: e.columns.length + 1,
                        class: "h-24 text-center"
                      }, {
                        default: xe(() => [
                          et(N(e.emptyText ?? "No results."), 1)
                        ]),
                        _: 1
                      }, 8, ["colspan"])
                    ]),
                    _: 1
                  }))
                ];
              }),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["table-width"])
      ], 14, f9)
    ], 2));
  }
}), Qq = /* @__PURE__ */ ot(w9, [["__scopeId", "data-v-08ccb149"]]);
function _q(e, n, t) {
  return (a) => {
    const r = (e() || "").replace(/\D/g, ""), o = n() || "", i = gB[o], s = Fc(r, (i == null ? void 0 : i.hasTrunkZero) ?? !1);
    if (!s) return;
    const d = (i == null ? void 0 : i.min) ?? 6, u = (i == null ? void 0 : i.max) ?? 1 / 0, f = (i == null ? void 0 : i.name) ?? o, b = (i == null ? void 0 : i.placeholder) ?? Tl.placeholder;
    if (s.length < d)
      return t({ count: d, country: f, example: b });
    if (s.length > u)
      return t({ count: u, country: f, example: b });
  };
}
function Tb(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : !1;
}
function C9(e) {
  const n = typeof e == "string" ? { requiredMessage: e } : e, { requiredMessage: t, watchData: a } = n, l = typeof t == "function" ? t : () => t, r = R(/* @__PURE__ */ new Map()), o = m(() => Array.from(r.value.values())), i = m(() => r.value.size), s = m(() => r.value.size > 0);
  function d(x, y) {
    if (x.required && Tb(y))
      return l();
    if (x.validate)
      return x.validate(y);
  }
  function u(x, y) {
    const w = /* @__PURE__ */ new Map();
    for (const $ of x) {
      const S = d($, y[$.key]);
      S && w.set($.key, {
        key: $.key,
        label: $.label,
        message: S
      });
    }
    return r.value = w, w.size === 0;
  }
  function f(x, y) {
    const w = d(x, y);
    if (w) {
      const $ = new Map(r.value);
      return $.set(x.key, { key: x.key, label: x.label, message: w }), r.value = $, !1;
    } else
      return h(x.key), !0;
  }
  function b(x) {
    var y;
    return (y = r.value.get(x)) == null ? void 0 : y.message;
  }
  function h(x) {
    if (r.value.has(x)) {
      const y = new Map(r.value);
      y.delete(x), r.value = y;
    }
  }
  function p() {
    r.value = /* @__PURE__ */ new Map();
  }
  return a && $e(
    () => a,
    () => {
      if (s.value)
        for (const x of [...o.value]) {
          const y = a[x.key];
          Tb(y) || h(x.key);
        }
    },
    { deep: !0 }
  ), {
    errors: r,
    errorList: o,
    errorCount: i,
    hasErrors: s,
    validateAll: u,
    validateField: d,
    validateAndSetField: f,
    getFieldError: b,
    clearFieldError: h,
    clearAllErrors: p
  };
}
function S9(e) {
  const n = R(!1);
  async function t() {
    var a, l;
    if (e.validate()) {
      n.value = !0;
      try {
        await e.save(), (a = e.onSuccess) == null || a.call(e);
      } catch (r) {
        (l = e.onError) == null || l.call(e, r);
      } finally {
        n.value = !1;
      }
    }
  }
  return { isSaving: n, handleSubmit: t };
}
function Ll(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(Ll);
  const n = {};
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (n[t] = Ll(e[t]));
  return n;
}
function wu(e, n) {
  if (e === n) return !0;
  if (e === null || n === null) return e === n;
  if (typeof e != typeof n) return !1;
  if (typeof e != "object") return e === n;
  if (Array.isArray(e) && Array.isArray(n))
    return e.length !== n.length ? !1 : e.every((l, r) => wu(l, n[r]));
  if (Array.isArray(e) || Array.isArray(n)) return !1;
  const t = Object.keys(e), a = Object.keys(n);
  return t.length !== a.length ? !1 : t.every(
    (l) => wu(e[l], n[l])
  );
}
function $9(e) {
  const { data: n, enableBeforeUnload: t = !0, beforeUnloadMessage: a } = e, l = R(null), r = R(!1), o = m(() => r.value ? !0 : l.value === null ? !1 : !wu(n, l.value));
  function i() {
    l.value = Ll(n), r.value = !1;
  }
  function s() {
    l.value = Ll(n), r.value = !1;
  }
  function d() {
    l.value !== null && Object.assign(n, Ll(l.value)), r.value = !1;
  }
  function u() {
    return Ll(l.value);
  }
  function f(h) {
    r.value = h;
  }
  function b(h) {
    if (o.value) {
      h.preventDefault();
      const p = a ? a() : "";
      return h.returnValue = p, p;
    }
  }
  return dt(() => {
    i(), t && window.addEventListener("beforeunload", b);
  }), gt(() => {
    t && window.removeEventListener("beforeunload", b);
  }), {
    isDirty: o,
    markAsSaved: s,
    resetToOriginal: d,
    getOriginalData: u,
    setDirty: f
  };
}
function eU(e) {
  const n = $9({
    data: e.data,
    enableBeforeUnload: e.enableBeforeUnload,
    beforeUnloadMessage: e.beforeUnloadMessage
  }), t = C9({
    requiredMessage: e.requiredMessage,
    watchData: e.data
  }), a = S9({
    validate: () => t.validateAll(e.fields(), e.data),
    save: e.save,
    onSuccess: () => {
      var l;
      t.clearAllErrors(), n.markAsSaved(), (l = e.onSuccess) == null || l.call(e);
    },
    onError: e.onError
  });
  return {
    // Dirty state
    isDirty: n.isDirty,
    markAsSaved: n.markAsSaved,
    resetToOriginal: n.resetToOriginal,
    setDirty: n.setDirty,
    // Validation
    errorList: t.errorList,
    errorCount: t.errorCount,
    hasErrors: t.hasErrors,
    getFieldError: t.getFieldError,
    clearFieldError: t.clearFieldError,
    clearAllErrors: t.clearAllErrors,
    // Submit
    isSaving: a.isSaving,
    handleSubmit: a.handleSubmit
  };
}
function I9(e) {
  const n = R(!1);
  if (typeof window > "u") return n;
  const t = window.matchMedia(e), a = () => {
    n.value = t.matches;
  };
  return Iu() && (dt(() => {
    a(), t.addEventListener("change", a);
  }), gt(() => {
    t.removeEventListener("change", a);
  })), n;
}
const T9 = {
  key: 0,
  class: "p-3"
}, L9 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4" }, A9 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }, E9 = {
  key: 0,
  class: "flex items-center space-x-4"
}, R9 = {
  key: 1,
  class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 shrink-0"
}, B9 = {
  key: 0,
  class: "flex flex-wrap"
}, D9 = { class: "relative" }, M9 = { class: "flex-1 min-h-0 flex flex-col" }, z9 = {
  key: 1,
  class: "border-t border-gainsboro dark:border-(--colors-border-base) p-5"
}, tU = /* @__PURE__ */ ke({
  __name: "DataTableWrapper",
  props: {
    bordered: { type: Boolean }
  },
  setup(e) {
    const n = Yt();
    return (t, a) => (c(), g("div", {
      class: C([
        "relative bg-white rounded-xl flex-1 flex flex-col min-h-0",
        e.bordered ? "border border-(--border-border-base-soft) overflow-hidden shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : "border-l border-border-base-soft has-[>div:nth-child(2)>[role=data-settings]]:rounded-tr-none"
      ])
    }, [
      a[0] || (a[0] = v("div", { class: "absolute bottom-0 left-1.5 right-0 h-px bg-linear-to-r from-(--background-background-gray) to-transparent" }, null, -1)),
      I(n)("filters") || I(n)("actions") ? (c(), g("div", T9, [
        v("div", L9, [
          v("div", A9, [
            I(n)("filters") ? (c(), g("div", E9, [
              Ae(t.$slots, "filters")
            ])) : k("", !0),
            I(n)("actions") ? (c(), g("div", R9, [
              Ae(t.$slots, "actions")
            ])) : k("", !0)
          ]),
          I(n)("filter-items") ? (c(), g("div", B9, [
            Ae(t.$slots, "filter-items")
          ])) : k("", !0)
        ])
      ])) : k("", !0),
      v("div", D9, [
        v("div", {
          class: C(["absolute top-0 right-0 h-0.5 bg-border-base-soft", I(n)("filters") ? "left-0" : "left-1.5"])
        }, null, 2)
      ]),
      v("div", M9, [
        Ae(t.$slots, "table")
      ]),
      I(n)("pager") ? (c(), g("div", z9, [
        Ae(t.$slots, "pager")
      ])) : k("", !0)
    ], 2));
  }
}), O9 = {
  key: 0,
  role: "menu",
  "data-testid": "card-actions-menu",
  class: "absolute right-0 top-10 z-50 min-w-160px rounded-xl border border-(--border-border-base-soft) bg-white py-1 shadow-[0_4px_16px_rgba(0,0,0,0.12)]"
}, P9 = ["onClick"], F9 = {
  key: 0,
  class: "skeleton w-full h-192px rounded-t-3xl"
}, V9 = {
  key: 1,
  class: "skeleton h-9 w-9 rounded-full shrink-0 m-6"
}, N9 = ["src", "alt"], H9 = { class: "h-9 w-9 rounded-full border border-(--border-border-base-soft) flex items-center justify-center bg-white" }, j9 = { class: "flex flex-col flex-1" }, W9 = {
  key: 0,
  class: "self-start bg-(--background-background-white-tertiary) text-xs font-medium px-1 py-0.5 rounded text-(--text-text-black-default)"
}, q9 = {
  key: 1,
  class: "text-2xl font-bold text-(--text-text-heading) dark:text-(--colors-text-white-default) m-0"
}, U9 = {
  key: 2,
  class: "text-base text-(--text-text-body) dark:text-(--colors-text-white-secondary) m-0"
}, nU = /* @__PURE__ */ ke({
  __name: "Card",
  props: {
    layout: { default: "classic" },
    headerType: { default: "icon" },
    imageSrc: { default: void 0 },
    imageAlt: { default: "" },
    badge: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    primaryLabel: { default: void 0 },
    secondaryLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    actions: { default: void 0 }
  },
  emits: ["primary-click", "secondary-click"],
  setup(e, { emit: n }) {
    const t = n, {
      isOpen: a,
      dropdownRef: l,
      toggleDropdown: r,
      closeDropdown: o
    } = Zl(), i = (d) => {
      var u;
      (u = d.onClick) == null || u.call(d), o();
    }, s = (d) => {
      l.value = d;
    };
    return (d, u) => (c(), g("div", {
      "data-testid": "card",
      class: C([
        "relative overflow-hidden rounded-3xl border border-(--border-border-base-medium) bg-white dark:bg-(--colors-background-black-default) shadow-[0px_0px_4px_rgba(0,0,0,0.1)]",
        e.layout === "aligned" ? "flex flex-row items-center" : "flex flex-col"
      ])
    }, [
      !e.loading && e.actions && e.actions.length ? (c(), g("div", {
        key: 0,
        ref: s,
        class: "absolute top-3 right-3 z-10",
        "data-testid": "card-actions"
      }, [
        v("button", {
          type: "button",
          "data-testid": "card-actions-trigger",
          class: "h-8 w-8 rounded-full border border-(--border-border-base-soft) bg-white flex items-center justify-center cursor-pointer hover:bg-(--background-background-white-tertiary) transition-colors",
          onClick: u[0] || (u[0] = //@ts-ignore
          (...f) => I(r) && I(r)(...f))
        }, [...u[3] || (u[3] = [
          v("i", { class: "ri-more-line text-sm text-(--text-text-body)" }, null, -1)
        ])]),
        re(wt, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: xe(() => [
            I(a) ? (c(), g("div", O9, [
              (c(!0), g(ce, null, Re(e.actions, (f) => (c(), g("button", {
                key: f.label,
                type: "button",
                role: "menuitem",
                "data-testid": "card-action-item",
                class: C([
                  "w-full text-left px-4 py-2 text-sm hover:bg-(--background-background-white-tertiary) transition-colors flex items-center gap-2",
                  f.class || "text-(--text-text-black-default)"
                ]),
                onClick: (b) => i(f)
              }, [
                f.icon ? (c(), g("i", {
                  key: 0,
                  class: C(f.icon)
                }, null, 2)) : k("", !0),
                et(" " + N(f.label), 1)
              ], 10, P9))), 128))
            ])) : k("", !0)
          ]),
          _: 1
        })
      ])) : k("", !0),
      e.loading ? (c(), g(ce, { key: 1 }, [
        e.layout !== "aligned" ? (c(), g("div", F9)) : (c(), g("div", V9)),
        u[4] || (u[4] = to('<div class="flex flex-col gap-3 px-6 pb-6 pt-4 flex-1"><div class="skeleton h-5 w-16 rounded"></div><div class="skeleton h-8 w-3/4 rounded"></div><div class="skeleton h-4 w-full rounded"></div><div class="skeleton h-4 w-2/3 rounded"></div><div class="flex gap-2 pt-2"><div class="skeleton h-9 w-24 rounded-full"></div><div class="skeleton h-9 w-24 rounded-full"></div></div></div>', 1))
      ], 64)) : (c(), g(ce, { key: 2 }, [
        Ae(d.$slots, "header", {}, () => [
          e.headerType === "image" ? (c(), g("div", {
            key: 0,
            class: C(e.layout === "aligned" ? "p-6 shrink-0" : "p-6")
          }, [
            e.imageSrc ? (c(), g("img", {
              key: 0,
              src: e.imageSrc,
              alt: e.imageAlt,
              class: C(
                e.layout === "aligned" ? "h-48 w-48 object-cover rounded-xl" : "w-full h-48 object-cover rounded-xl"
              )
            }, null, 10, N9)) : k("", !0)
          ], 2)) : (c(), g("div", {
            key: 1,
            class: C(e.layout === "aligned" ? "pl-6 shrink-0" : "pt-6 pb-6 px-6")
          }, [
            v("div", H9, [
              Ae(d.$slots, "icon")
            ])
          ], 2))
        ]),
        v("div", j9, [
          Ae(d.$slots, "default", {}, () => [
            v("div", {
              class: C(["flex flex-col gap-3", e.layout === "aligned" ? "p-6" : "px-6 pb-6"])
            }, [
              e.badge ? (c(), g("span", W9, N(e.badge), 1)) : k("", !0),
              e.title ? (c(), g("p", q9, N(e.title), 1)) : k("", !0),
              e.description ? (c(), g("p", U9, N(e.description), 1)) : k("", !0)
            ], 2)
          ])
        ]),
        Ae(d.$slots, "footer", {}, () => [
          e.primaryLabel || e.secondaryLabel ? (c(), g("div", {
            key: 0,
            class: C([
              e.layout === "aligned" ? "px-6 flex flex-col gap-4 items-start shrink-0" : "px-6 pb-6 flex items-center gap-4"
            ])
          }, [
            e.primaryLabel ? (c(), H(Be, {
              key: 0,
              variant: "primary",
              size: "xs",
              label: e.primaryLabel,
              onClick: u[1] || (u[1] = (f) => t("primary-click"))
            }, null, 8, ["label"])) : k("", !0),
            e.secondaryLabel ? (c(), H(Be, {
              key: 1,
              variant: "secondary",
              size: "xs",
              label: e.secondaryLabel,
              onClick: u[2] || (u[2] = (f) => t("secondary-click"))
            }, null, 8, ["label"])) : k("", !0)
          ], 2)) : k("", !0)
        ])
      ], 64))
    ], 2));
  }
}), G9 = ["aria-checked", "aria-disabled"], K9 = { class: "flex flex-col gap-1.5" }, aU = /* @__PURE__ */ ke({
  __name: "CardSelectable",
  props: {
    icon: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconVariant: { default: "default" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    function l(r) {
      t.disabled || a("click", r);
    }
    return (r, o) => (c(), g("button", {
      type: "button",
      "data-testid": "card-selectable",
      "aria-checked": e.selected,
      "aria-disabled": e.disabled || void 0,
      class: C([
        "relative flex flex-col gap-3 p-6 rounded-xl border text-left w-full",
        "transition-colors duration-120 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-hover)",
        // Disabled wins over selected (a disabled card can't be the chosen option). Use the DS
        // disabled surface (grey fill + border) rather than a flat opacity so the disabled state
        // reads clearly against the enabled cards (OP-6222).
        e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled) cursor-not-allowed pointer-events-none" : e.selected ? "bg-(--background-background-hover) border-(--border-border-hover) shadow-[0px_0px_2px_var(--border-border-hover)] cursor-pointer" : "bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-hover) active:bg-(--background-background-hover) cursor-pointer"
      ]),
      onClick: l
    }, [
      Ae(r.$slots, "default", {}, () => [
        v("div", {
          class: C([
            "h-9 w-9 flex items-center justify-center rounded-lg border shrink-0",
            e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled)" : e.iconVariant === "accent" ? "bg-(--background-background-white) border-(--border-border-hover) shadow-[0px_0px_1px_var(--background-background-hover)]" : "bg-(--background-background-white) border-(--border-border-base-medium)"
          ])
        }, [
          v("i", {
            class: C([e.icon, "text-[20px]", e.disabled ? "text-(--colors-icon-disabled)" : "text-(--icons-icon-accent)"]),
            "aria-hidden": "true"
          }, null, 2)
        ], 2),
        v("div", K9, [
          v("span", {
            class: C(["text-lg font-semibold", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-heading)"])
          }, N(e.title), 3),
          e.description ? (c(), g("span", {
            key: 0,
            class: C(["text-sm", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-body)"])
          }, N(e.description), 3)) : k("", !0)
        ])
      ])
    ], 10, G9));
  }
}), lU = /* @__PURE__ */ ke({
  __name: "Masonry",
  props: {
    gapX: { default: 20 },
    gapY: { default: 20 },
    breakpoint: { default: 640 },
    useViewport: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Mn(), a = R([]), l = R(null), r = R([]), o = R(0), i = R(2), s = m(
      () => {
        var y;
        return (((y = t.default) == null ? void 0 : y.call(t)) ?? []).filter(
          (w) => w.type !== $u
        );
      }
    );
    function d() {
      const y = a.value;
      if (!y.length) return;
      const w = i.value, $ = Array(w).fill(0), S = [];
      for (const L of y) {
        const T = $.indexOf(Math.min(...$));
        S.push({ col: T, top: $[T] }), $[T] += L.offsetHeight + n.gapY;
      }
      r.value = S, o.value = Math.max(...$) - n.gapY;
    }
    function u(y) {
      const w = r.value[y];
      if (!w) return { visibility: "hidden" };
      const $ = i.value;
      if ($ === 1)
        return { top: `${w.top}px`, left: "0", width: "100%" };
      const S = 100 / $, L = n.gapX * ($ - 1) / $;
      return {
        top: `${w.top}px`,
        left: w.col === 0 ? "0" : `calc(${w.col * S}% + ${w.col * n.gapX / $}px)`,
        width: `calc(${S}% - ${L}px)`
      };
    }
    let f, b, h;
    function p() {
      h !== void 0 && cancelAnimationFrame(h), h = requestAnimationFrame(() => {
        h = void 0, d();
      });
    }
    function x(y) {
      i.value = y.matches ? 1 : 2, p();
    }
    return dt(async () => {
      await Ue(), n.useViewport ? (b = window.matchMedia(`(max-width: ${n.breakpoint}px)`), i.value = b.matches ? 1 : 2, b.addEventListener("change", x), d(), f = new ResizeObserver(p), a.value.forEach((y) => f.observe(y))) : (f = new ResizeObserver(() => {
        var w;
        const y = ((w = l.value) == null ? void 0 : w.offsetWidth) ?? 0;
        i.value = y < n.breakpoint ? 1 : 2, p();
      }), a.value.forEach((y) => f.observe(y)), l.value && f.observe(l.value));
    }), gt(() => {
      h !== void 0 && cancelAnimationFrame(h), f == null || f.disconnect(), b == null || b.removeEventListener("change", x);
    }), (y, w) => (c(), g("div", {
      ref_key: "containerRef",
      ref: l,
      class: "relative w-full",
      style: Ne({ height: `${o.value}px` })
    }, [
      (c(!0), g(ce, null, Re(s.value, ($, S) => (c(), g("div", {
        key: S,
        ref_for: !0,
        ref_key: "itemRefs",
        ref: a,
        class: "absolute",
        style: Ne(u(S))
      }, [
        (c(), H(lt($)))
      ], 4))), 128))
    ], 4));
  }
}), Y9 = { class: "group-hover:underline" }, J9 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "InlineLink",
  props: {
    as: {},
    iconLeft: {}
  },
  setup(e) {
    return (n, t) => (c(), H(lt(e.as), Oe(n.$attrs, { class: "flex items-center px-3 py-2 gap-1.5 group leading-5 text-sm text-(--text-text-black-default)" }), {
      default: xe(() => [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C(["text-current", e.iconLeft])
        }, null, 2)) : k("", !0),
        v("span", Y9, [
          Ae(n.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), rU = J9, X9 = ["aria-labelledby", "aria-busy"], Z9 = {
  key: 0,
  class: "flex flex-col space-y-5"
}, Q9 = {
  key: 0,
  class: "flex items-center gap-2"
}, _9 = {
  key: 0,
  class: "flex items-center gap-2 shrink-0"
}, e7 = {
  key: 1,
  class: "flex-1 min-w-0 flex flex-col gap-2"
}, t7 = ["id"], n7 = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "widget-shell-subtitle"
}, a7 = {
  key: 2,
  class: "flex items-center gap-3 shrink-0 ms-auto",
  "data-testid": "widget-shell-actions"
}, l7 = {
  key: 0,
  class: "flex items-center gap-1.5"
}, r7 = {
  key: 1,
  class: "flex items-center gap-1.5"
}, o7 = {
  key: 0,
  class: "flex-1 min-w-0 leading-6.5 text-num-16 font-medium truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, i7 = {
  key: 1,
  class: "flex items-center ms-auto shrink-0"
}, s7 = {
  key: 1,
  "data-testid": "widget-shell-footer"
}, oU = /* @__PURE__ */ ke({
  __name: "WidgetShell",
  props: {
    header: {},
    subtitle: {},
    subheader: {},
    loading: { type: Boolean },
    flush: { type: Boolean },
    stretch: { type: Boolean },
    rounded: {},
    bordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-sm)",
      m: "rounded-(--border-border-radius-rounded-l)",
      l: "rounded-(--border-border-radius-rounded-base)",
      xl: "rounded-(--border-border-radius-rounded-xl)",
      "2xl": "rounded-(--border-border-radius-rounded-xxl)"
    }, t = e, a = m(() => n[t.rounded ?? "m"]), l = je(), r = Nn(), o = m(
      () => !t.flush && t.header && !r["aria-label"] ? l : void 0
    ), i = Yt(), s = m(
      () => !!(t.header || t.subtitle || t.subheader) || i("before-actions") || i("actions") || i("nav-actions") || i("sub-info") || i("sub-actions")
    );
    return (d, u) => (c(), g("section", {
      "aria-labelledby": o.value,
      "aria-busy": e.loading || void 0,
      "data-testid": "widget-shell",
      class: C([
        a.value,
        e.bordered !== !1 ? "border border-(--border-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-s) break-inside-avoid" : void 0,
        e.bordered !== !1 ? "dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)" : void 0,
        e.flush ? "overflow-hidden" : "p-6 space-y-6",
        e.stretch ? "flex flex-col flex-1" : "inline-block w-full"
      ])
    }, [
      e.flush ? Ae(d.$slots, "default", { key: 0 }) : (c(), g(ce, { key: 1 }, [
        s.value ? (c(), g("div", Z9, [
          e.header || e.subtitle || I(i)("before-actions") || I(i)("actions") || I(i)("nav-actions") ? (c(), g("div", Q9, [
            I(i)("before-actions") ? (c(), g("div", _9, [
              Ae(d.$slots, "before-actions")
            ])) : k("", !0),
            e.header || e.subtitle ? (c(), g("div", e7, [
              e.header ? (c(), g("h2", {
                key: 0,
                id: I(l),
                class: "min-w-0 leading-6.5 text-[1.375rem] font-bold truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
              }, N(e.header), 9, t7)) : k("", !0),
              e.subtitle ? (c(), g("p", n7, N(e.subtitle), 1)) : k("", !0)
            ])) : k("", !0),
            I(i)("actions") || I(i)("nav-actions") ? (c(), g("div", a7, [
              Ae(d.$slots, "actions"),
              I(i)("nav-actions") ? (c(), g("div", l7, [
                Ae(d.$slots, "nav-actions")
              ])) : k("", !0)
            ])) : k("", !0)
          ])) : k("", !0),
          e.subheader || I(i)("sub-info") || I(i)("sub-actions") ? (c(), g("div", r7, [
            e.subheader ? (c(), g("h3", o7, N(e.subheader), 1)) : k("", !0),
            Ae(d.$slots, "sub-info"),
            I(i)("sub-actions") ? (c(), g("div", i7, [
              Ae(d.$slots, "sub-actions")
            ])) : k("", !0)
          ])) : k("", !0)
        ])) : k("", !0),
        v("div", {
          class: C(e.stretch ? "flex-1 flex flex-col" : "")
        }, [
          Ae(d.$slots, "default")
        ], 2),
        I(i)("footer") ? (c(), g("div", s7, [
          Ae(d.$slots, "footer")
        ])) : k("", !0)
      ], 64))
    ], 10, X9));
  }
}), d7 = { class: "flex flex-col min-h-0 h-full rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-white shadow-[0px_0px_4px_rgba(0,0,0,0.1)] overflow-hidden" }, iU = /* @__PURE__ */ ke({
  __name: "WidgetBlock",
  props: {
    headerBordered: { type: Boolean, default: !0 },
    footerBordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = Yt();
    return (t, a) => (c(), g("div", d7, [
      I(n)("header") ? (c(), g("div", {
        key: 0,
        "data-testid": "widget-block-header",
        class: C(["sticky top-0 z-10 bg-white px-6 py-5", e.headerBordered ? "border-b border-(--border-border-base-soft)" : ""])
      }, [
        Ae(t.$slots, "header")
      ], 2)) : k("", !0),
      v("div", {
        "data-testid": "widget-block-main",
        class: C([
          "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-6 pb-6",
          I(n)("header") && !e.headerBordered ? "pt-0" : "pt-6"
        ])
      }, [
        Ae(t.$slots, "default")
      ], 2),
      I(n)("footer") ? (c(), g("div", {
        key: 1,
        "data-testid": "widget-block-footer",
        class: C(["px-6 py-4", e.footerBordered ? "border-t border-(--border-border-base-soft)" : ""])
      }, [
        Ae(t.$slots, "footer")
      ], 2)) : k("", !0)
    ]));
  }
}), u7 = {
  key: 0,
  class: "flex flex-col gap-1",
  "data-testid": "widget-section-header"
}, c7 = {
  key: 0,
  class: "text-lg font-semibold text-(--colors-text-black-default) m-0"
}, f7 = {
  key: 0,
  class: "text-sm text-(--text-text-body) m-0"
}, sU = /* @__PURE__ */ ke({
  __name: "WidgetSection",
  props: {
    title: {},
    subtitle: {},
    bordered: { type: Boolean, default: !0 },
    padded: { type: Boolean, default: !0 },
    gap: { default: "md" }
  },
  setup(e) {
    const n = e, t = Yt(), a = m(
      () => !!n.title || !!n.subtitle || t("title") || t("subtitle")
    ), l = m(
      () => ({ sm: "gap-3", md: "gap-4", lg: "gap-5" })[n.gap]
    );
    return (r, o) => (c(), g("section", {
      class: C([
        "flex flex-col",
        l.value,
        e.bordered && "rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft)",
        e.padded && "p-6"
      ]),
      "data-testid": "widget-section"
    }, [
      a.value ? (c(), g("header", u7, [
        Ae(r.$slots, "title", {}, () => [
          e.title ? (c(), g("h3", c7, N(e.title), 1)) : k("", !0)
        ]),
        Ae(r.$slots, "subtitle", {}, () => [
          e.subtitle ? (c(), g("p", f7, N(e.subtitle), 1)) : k("", !0)
        ])
      ])) : k("", !0),
      Ae(r.$slots, "default")
    ], 2));
  }
}), h7 = {
  "data-testid": "cta-widget",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) shadow-[0px_0px_4px_rgba(0,0,0,0.1)] bg-white p-6",
  style: { "background-image": "var(--gradient-cta-widget)" }
}, b7 = { class: "flex flex-col gap-1.5 min-w-0" }, g7 = { class: "flex items-center gap-1.5" }, m7 = { class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold) text-(--text-text-black-default)" }, p7 = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-heading)" }, v7 = { class: "flex flex-col items-stretch sm:items-center sm:shrink-0" }, dU = /* @__PURE__ */ ke({
  __name: "CtaWidget",
  props: {
    title: { default: "" },
    titleIcon: { default: void 0 },
    description: { default: "" },
    ctaLabel: { default: "" },
    ctaIcon: { default: "ri-add-line" },
    ctaDisabled: { type: Boolean, default: !1 }
  },
  emits: ["cta-click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", h7, [
      v("div", b7, [
        v("div", g7, [
          e.titleIcon ? (c(), g("i", {
            key: 0,
            class: C([e.titleIcon, "text-(length:--size-l) text-(--text-text-black-default)"]),
            "aria-hidden": "true"
          }, null, 2)) : k("", !0),
          v("p", m7, [
            Ae(a.$slots, "title", {}, () => [
              et(N(e.title), 1)
            ])
          ])
        ]),
        v("p", p7, [
          Ae(a.$slots, "description", {}, () => [
            et(N(e.description), 1)
          ])
        ])
      ]),
      v("div", v7, [
        Ae(a.$slots, "actions", {}, () => [
          e.ctaLabel ? (c(), H(Be, {
            key: 0,
            variant: "primary",
            size: "xl",
            "icon-left": e.ctaIcon,
            label: e.ctaLabel,
            disabled: e.ctaDisabled,
            onClick: l[0] || (l[0] = (r) => t("cta-click", r))
          }, null, 8, ["icon-left", "label", "disabled"])) : k("", !0)
        ])
      ])
    ]));
  }
}), x7 = {
  "data-testid": "stats-widget",
  class: "flex flex-col justify-center gap-3 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, y7 = { class: "flex items-start gap-2" }, k7 = { class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)" }, w7 = { class: "flex flex-wrap items-end gap-x-2 gap-y-1" }, C7 = {
  class: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "stats-widget-value"
}, S7 = ["aria-hidden"], $7 = {
  key: 0,
  class: "sr-only"
}, I7 = {
  key: 1,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, T7 = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, uU = /* @__PURE__ */ ke({
  __name: "StatsWidget",
  props: {
    icon: { default: void 0 },
    label: { default: "" },
    value: { default: null },
    placeholder: { default: "—" },
    placeholderLabel: { default: "" },
    caption: { default: "" },
    captionInline: { type: Boolean, default: !1 },
    hint: { default: "" },
    valueHint: { default: "" },
    hintIcon: { default: "ri-question-line" }
  },
  setup(e) {
    const n = e, t = m(() => n.value === null || n.value === void 0 || n.value === "");
    return (a, l) => (c(), g("div", x7, [
      v("div", y7, [
        e.icon ? (c(), g("i", {
          key: 0,
          class: C([e.icon, "shrink-0 text-(length:--size-xxl) leading-(--line-height-xxl) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
          "aria-hidden": "true"
        }, null, 2)) : k("", !0),
        v("p", k7, [
          Ae(a.$slots, "label", {}, () => [
            et(N(e.label), 1)
          ])
        ]),
        e.hint ? (c(), H(ft, {
          key: 1,
          text: e.hint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.hint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-hint"
        }, {
          default: xe(() => [
            v("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0)
      ]),
      v("div", w7, [
        v("p", C7, [
          Ae(a.$slots, "value", {}, () => [
            t.value ? (c(), g(ce, { key: 0 }, [
              v("span", {
                "aria-hidden": e.placeholderLabel ? "true" : void 0
              }, N(e.placeholder), 9, S7),
              e.placeholderLabel ? (c(), g("span", $7, N(e.placeholderLabel), 1)) : k("", !0)
            ], 64)) : (c(), g(ce, { key: 1 }, [
              et(N(e.value), 1)
            ], 64))
          ])
        ]),
        e.valueHint ? (c(), H(ft, {
          key: 0,
          text: e.valueHint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.valueHint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-value-hint"
        }, {
          default: xe(() => [
            v("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-value-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0),
        e.caption && e.captionInline ? (c(), g("p", I7, N(e.caption), 1)) : k("", !0)
      ]),
      e.caption && !e.captionInline ? (c(), g("p", T7, N(e.caption), 1)) : k("", !0)
    ]));
  }
}), L7 = ["aria-expanded", "aria-controls", "disabled"], A7 = { class: "flex-shrink-0" }, E7 = {
  key: 0,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-[#009966] border border-gray-200",
  "data-testid": "collapsible-section-validated"
}, R7 = {
  key: 1,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 dark:bg-[rgba(255,255,255,0.08)]"
}, B7 = { class: "flex-1 min-w-0" }, D7 = { class: "text-base font-semibold text-text-black-default dark:text-(--colors-text-white-default)" }, M7 = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-(--colors-text-white-secondary) mt-0.5 truncate"
}, z7 = { class: "flex-shrink-0" }, O7 = ["id", "inert", "aria-hidden"], P7 = { class: "px-14 py-5" }, F7 = ["disabled"], V7 = {
  key: 0,
  class: "ri-loader-4-line animate-spin text-sm"
}, N7 = {
  key: 1,
  class: "ri-check-line text-sm"
}, H7 = ["disabled"], j7 = /* @__PURE__ */ ke({
  __name: "CollapsibleSection",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    expanded: { type: Boolean, default: !1 },
    validated: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showActions: { type: Boolean, default: !0 },
    validateDisabled: { type: Boolean, default: !1 },
    cancelDisabled: { type: Boolean, default: !1 },
    validateLoading: { type: Boolean, default: !1 },
    warning: { default: void 0 },
    validateLabel: { default: "Validate" },
    cancelLabel: { default: "Cancel" },
    actionsAlignment: { default: "start" }
  },
  emits: ["update:expanded", "validate", "cancel"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R(null), o = R(null), i = R(null), s = R(null), d = () => {
      var y, w;
      (y = o.value) == null || y.focus(), document.activeElement !== o.value && ((w = r.value) == null || w.focus());
    };
    $e(
      () => t.expanded,
      (y) => {
        var w;
        y || (l.value = !1, (w = i.value) != null && w.contains(document.activeElement) && d());
      }
    ), $e(
      () => t.validateDisabled || t.validateLoading,
      (y) => {
        y && s.value && document.activeElement === s.value && d();
      }
    );
    const u = (y) => {
      y.propertyName === "max-height" && t.expanded && (l.value = !0);
    }, f = je(), b = m(() => `${f}-content`), h = () => {
      t.disabled || a("update:expanded", !t.expanded);
    }, p = () => {
      a("validate");
    }, x = () => {
      a("cancel");
    };
    return (y, w) => (c(), g("div", {
      ref_key: "rootRef",
      ref: r,
      class: C(["rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) overflow-hidden", { "opacity-60 cursor-not-allowed": e.disabled }]),
      "data-testid": "collapsible-section",
      tabindex: "-1"
    }, [
      v("button", {
        ref_key: "headerRef",
        ref: o,
        type: "button",
        class: C(["flex w-full items-center gap-6 px-6 py-5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-hover)", [
          e.expanded ? "bg-gray-50 dark:bg-[rgba(255,255,255,0.03)]" : "",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.03)]"
        ]]),
        "aria-expanded": e.expanded,
        "aria-controls": b.value,
        disabled: e.disabled,
        "data-testid": "collapsible-section-header",
        onClick: h
      }, [
        v("div", A7, [
          e.validated ? (c(), g("div", E7, [...w[0] || (w[0] = [
            v("i", { class: "ri-check-fill text-white text-sm" }, null, -1)
          ])])) : e.icon ? (c(), g("div", R7, [
            v("i", {
              class: C([e.icon, "text-gray-500 dark:text-(--colors-text-white-secondary) text-base"])
            }, null, 2)
          ])) : k("", !0)
        ]),
        v("div", B7, [
          v("div", D7, N(e.title), 1),
          e.subtitle ? (c(), g("div", M7, N(e.subtitle), 1)) : k("", !0)
        ]),
        v("div", z7, [
          v("i", {
            class: C(["text-xl text-gray-400 dark:text-(--colors-text-white-secondary) transition-transform duration-200", e.expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"])
          }, null, 2)
        ])
      ], 10, L7),
      v("div", {
        id: b.value,
        ref_key: "contentRef",
        ref: i,
        class: C(["collapsible-content", {
          "collapsible-content--expanded": e.expanded,
          "collapsible-content--open": l.value
        }]),
        role: "region",
        inert: !e.expanded || void 0,
        "aria-hidden": !e.expanded,
        onTransitionend: u
      }, [
        v("div", P7, [
          Ae(y.$slots, "default", {}, void 0, !0),
          e.showActions ? (c(), g("div", {
            key: 0,
            class: C(["flex items-center gap-3 mt-4", e.actionsAlignment === "end" ? "flex-row-reverse" : ""])
          }, [
            Ae(y.$slots, "actions", {
              validate: p,
              cancel: x
            }, () => [
              v("button", {
                ref_key: "validateRef",
                ref: s,
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-white border border-[#6a7282] transition-colors",
                  e.validateDisabled || e.validateLoading ? "bg-[#242424] opacity-50 cursor-not-allowed" : "bg-[#242424] hover:bg-[#3a3a3a] cursor-pointer"
                ]),
                disabled: e.validateDisabled || e.validateLoading,
                "data-testid": "collapsible-section-validate",
                onClick: Ye(p, ["stop"])
              }, [
                e.validateLoading ? (c(), g("i", V7)) : (c(), g("i", N7)),
                et(" " + N(e.validateLabel), 1)
              ], 10, F7),
              v("button", {
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-text-black-default dark:text-(--colors-text-white-default) bg-white dark:bg-(--colors-background-black-default) border border-solid border-[#919191] dark:border-(--colors-border-base) transition-colors",
                  e.cancelDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] cursor-pointer"
                ]),
                disabled: e.cancelDisabled,
                "data-testid": "collapsible-section-cancel",
                onClick: Ye(x, ["stop"])
              }, N(e.cancelLabel), 11, H7)
            ], !0)
          ], 2)) : k("", !0),
          e.warning ? (c(), H(I(Kl), {
            key: 1,
            color: "danger",
            heading: e.warning,
            class: "mt-4",
            "data-testid": "collapsible-section-warning"
          }, null, 8, ["heading"])) : k("", !0)
        ])
      ], 42, O7)
    ], 2));
  }
}), cU = /* @__PURE__ */ ot(j7, [["__scopeId", "data-v-fb7f3a92"]]), W7 = ["aria-label"], q7 = { class: "flex w-full flex-col items-center gap-5" }, U7 = { class: "flex w-full flex-col items-center gap-3.5" }, G7 = {
  key: 0,
  class: "max-w-full truncate rounded border border-(--colors-border-base-soft) bg-white px-1 py-0.5 text-xs font-medium leading-5 text-(--colors-text-black-default) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)"
}, K7 = { class: "flex w-full flex-col items-center gap-2.5 text-center" }, Y7 = { class: "min-h-[48px] w-full text-xl font-bold leading-6 text-(--colors-text-heading) line-clamp-2 dark:text-(--colors-text-white-default)" }, J7 = { class: "min-h-[20px] w-full truncate text-sm leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)" }, fU = /* @__PURE__ */ ke({
  __name: "ProfileCard",
  props: {
    name: { default: void 0 },
    role: { default: void 0 },
    email: { default: void 0 },
    avatarUrl: { default: void 0 },
    buttonLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => (c(), g("article", {
      class: "flex w-full flex-col items-center gap-6",
      "aria-label": e.name
    }, [
      e.loading ? (c(), g(ce, { key: 0 }, [
        t[1] || (t[1] = to('<div class="h-16 w-16 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-5"><div class="flex w-full flex-col items-center gap-3.5"><div class="h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-2"><div class="h-6 w-4/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="h-5 w-3/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div></div></div><div class="h-7 w-32 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div></div>', 2))
      ], 64)) : (c(), g(ce, { key: 1 }, [
        re(Mt, {
          name: e.name ?? "",
          img: e.avatarUrl,
          size: "2xl",
          "avatar-style": "square",
          presentational: ""
        }, null, 8, ["name", "img"]),
        v("div", q7, [
          v("div", U7, [
            e.role ? (c(), g("span", G7, N(e.role), 1)) : k("", !0),
            v("div", K7, [
              v("p", Y7, N(e.name), 1),
              v("p", J7, N(e.email), 1)
            ])
          ]),
          re(Be, {
            variant: "secondary",
            size: "xs",
            label: e.buttonLabel,
            "icon-right": "ri-external-link-line",
            "aria-label": `${e.buttonLabel}: ${e.name}`,
            onClick: t[0] || (t[0] = (a) => n.$emit("click"))
          }, null, 8, ["label", "aria-label"])
        ])
      ], 64))
    ], 8, W7));
  }
}), X7 = ["aria-label"], Z7 = { class: "flex w-full items-center" }, Q7 = ["aria-label"], _7 = { class: "px-5 flex justify-center w-full" }, eH = { class: "flex w-full items-center" }, tH = { class: "flex flex-col items-center gap-0.5 text-center w-full px-5" }, nH = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, aH = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, lH = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, rH = ["aria-label"], oH = { class: "flex flex-col items-center" }, iH = ["aria-label"], sH = { class: "flex flex-col items-center" }, dH = { class: "flex flex-col gap-1 pb-8 pt-0.5" }, uH = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, cH = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, fH = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, hU = /* @__PURE__ */ ke({
  __name: "Timeline",
  props: {
    items: { default: () => [] },
    orientation: { default: "auto" },
    ariaLabel: { default: "Timeline" },
    loading: { type: Boolean, default: !1 },
    loadingCount: { default: 3 },
    itemMinWidth: { default: "160px" },
    showItemIcons: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = I9("(min-width: 768px)"), a = [
      "green",
      "violet",
      "yellow",
      "indigo",
      "cyan",
      "orange",
      "red",
      "purple",
      "neutral"
    ], l = (i, s) => i.badgeTheme ?? a[s % a.length], r = m(() => n.orientation === "horizontal" ? !0 : n.orientation === "vertical" ? !1 : t.value), o = m(() => Array.from({ length: n.loadingCount }));
    return (i, s) => r.value ? (c(), g("ol", {
      key: 0,
      "aria-label": e.ariaLabel,
      class: "flex w-full items-start overflow-x-auto pb-3"
    }, [
      e.loading ? (c(!0), g(ce, { key: 0 }, Re(o.value, (d, u) => (c(), g("li", {
        key: u,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ne({ minWidth: e.itemMinWidth })
      }, [
        s[1] || (s[1] = v("div", { class: "px-5 flex justify-center w-full" }, [
          v("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1)),
        v("div", Z7, [
          v("div", {
            class: C(["flex-1 h-px", u === 0 ? "invisible" : "bg-(--colors-border-base-soft)"])
          }, null, 2),
          s[0] || (s[0] = v("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          v("div", {
            class: C([
              "flex-1 h-px",
              u === o.value.length - 1 ? "invisible" : "bg-(--colors-border-base-soft)"
            ])
          }, null, 2)
        ]),
        s[2] || (s[2] = v("div", { class: "flex flex-col items-center gap-2 w-full px-5" }, [
          v("div", { class: "h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-4 w-20 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ], 4))), 128)) : (c(!0), g(ce, { key: 1 }, Re(e.items, (d, u) => (c(), g("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ne({ minWidth: e.itemMinWidth })
      }, [
        v("div", _7, [
          re(ct, {
            label: d.date,
            theme: l(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "whitespace-nowrap",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"])
        ]),
        v("div", eH, [
          v("div", {
            class: C(["flex-1 h-px bg-(--colors-border-base-medium)", u === 0 ? "invisible" : ""])
          }, null, 2),
          s[3] || (s[3] = v("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          v("div", {
            class: C([
              "flex-1 h-px bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        v("div", tH, [
          v("p", nH, N(d.title), 1),
          d.subtitle ? (c(), g("p", aH, N(d.subtitle), 1)) : k("", !0),
          d.description ? (c(), g("p", lH, N(d.description), 1)) : k("", !0)
        ])
      ], 12, Q7))), 128))
    ], 8, X7)) : (c(), g("ol", {
      key: 1,
      "aria-label": e.ariaLabel,
      class: "flex flex-col"
    }, [
      e.loading ? (c(!0), g(ce, { key: 0 }, Re(o.value, (d, u) => (c(), g("li", {
        key: u,
        class: "flex flex-row gap-4"
      }, [
        v("div", oH, [
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === 0 ? "invisible" : "animate-pulse"
            ])
          }, null, 2),
          s[4] || (s[4] = v("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === o.value.length - 1 ? "invisible" : "animate-pulse"
            ])
          }, null, 2)
        ]),
        s[5] || (s[5] = v("div", { class: "flex flex-col gap-2 pb-8 pt-0.5" }, [
          v("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-5 w-36 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-4 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ]))), 128)) : (c(!0), g(ce, { key: 1 }, Re(e.items, (d, u) => (c(), g("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-row gap-4"
      }, [
        v("div", sH, [
          v("div", {
            class: C([
              "w-px h-[9px] shrink-0 bg-(--colors-border-base-medium)",
              u === 0 ? "invisible" : ""
            ])
          }, null, 2),
          s[6] || (s[6] = v("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        v("div", dH, [
          re(ct, {
            label: d.date,
            theme: l(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "self-start",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"]),
          v("p", uH, N(d.title), 1),
          d.subtitle ? (c(), g("p", cH, N(d.subtitle), 1)) : k("", !0),
          d.description ? (c(), g("p", fH, N(d.description), 1)) : k("", !0)
        ])
      ], 8, iH))), 128))
    ], 8, rH));
  }
}), hH = ["aria-label"], bH = ["aria-orientation", "tabindex"], gH = ["id", "data-testid", "aria-selected", "aria-disabled", "aria-controls", "tabindex", "onClick"], mH = { class: "truncate" }, pH = {
  key: 1,
  class: "ri-lock-line text-(length:--icon-size-sm) leading-none text-(--icons-icon-disabled-strong)",
  "aria-hidden": "true"
}, vH = ["aria-label"], xH = "before:pointer-events-none before:absolute before:inset-x-0 before:bottom-0 before:-z-1 before:border-b-3 before:border-(--border-border-base-soft)", Lb = "nav-pill relative isolate border border-transparent py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] before:absolute before:-inset-px before:-z-10 before:rounded-[inherit] before:opacity-0 before:[background:var(--nav-pill-ring)] after:absolute after:inset-[calc(var(--border-border-width-border-sm)-1px)] after:-z-10 after:rounded-[inherit] after:opacity-0 after:bg-(--background-background-white) focus-visible:after:opacity-100 focus-visible:after:shadow-(--shadow-focus-l-inset)", Ab = "before:opacity-100 after:opacity-100 forced-colors:border-[Highlight]", wd = "text-(--text-text-disabled-strong)", yH = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "NavTabs",
  props: {
    tabs: {},
    modelValue: {},
    fullWidth: { type: Boolean, default: !1 },
    overflowLabel: {},
    overflowPreviousLabel: {},
    type: { default: "border-bottom" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = m(() => e.type === "vertical-pills"), a = m(() => [
      "relative isolate max-w-full",
      e.fullWidth || t.value ? "w-full" : "w-fit",
      e.type === "border-bottom" && xH
    ]), l = {
      "border-bottom": "size-8",
      default: "size-6",
      pills: "size-10"
    }, r = {
      "border-bottom": "scroll-px-8",
      default: "scroll-px-6",
      pills: "scroll-px-10"
    }, o = (L) => [
      "absolute top-1/2 -translate-y-1/2 z-20 inline-flex items-center justify-center cursor-pointer",
      L,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      l[e.type]
    ], i = {
      "border-bottom": "flex items-end gap-3",
      default: "flex items-center gap-3",
      pills: "flex items-center gap-3",
      "vertical-pills": "flex flex-col justify-center gap-3"
    }, s = {
      "border-bottom": {
        // Figma pads 14 px above and below with a 3 px INSIDE stroke: the bottom padding gives the
        // border back, and the underline lands on the wrapper's rule.
        base: "px-0.5 pt-3.5 pb-[calc(--spacing(3.5)-3px)] border-b-3",
        activeMark: "border-solid [border-image:var(--gradient-brand-border)_1]",
        hoverMark: "border-transparent hover:[border-image:var(--gradient-brand-border)_1]",
        restMark: "border-transparent",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      default: {
        base: "rounded-(--border-border-radius-rounded-xs)",
        activeMark: "underline",
        hoverMark: "hover:underline",
        restMark: "",
        activeText: "text-(--text-text-hover)",
        hoverText: "hover:text-(--text-text-hover)"
      },
      pills: {
        base: `${Lb} rounded-(--border-border-radius-rounded-full)`,
        activeMark: Ab,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      "vertical-pills": {
        base: `${Lb} justify-start rounded-(--border-border-radius-rounded-l)`,
        activeMark: Ab,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      }
    };
    function d(L) {
      return L.locked === !0 || L.readOnly === !0;
    }
    function u(L) {
      const T = s[e.type], E = L.key === e.modelValue, A = e.type === "pills" || e.type === "vertical-pills";
      return L.locked ? [
        E ? T.activeMark : T.restMark,
        wd,
        "cursor-not-allowed",
        A && !E ? "bg-(--background-background-white)" : ""
      ] : E ? [T.activeMark, L.readOnly ? wd : T.activeText] : [T.hoverMark, L.readOnly ? wd : "text-(--text-text-body)", T.hoverText];
    }
    const f = n, b = R(null), h = R(null), p = R(null), x = wg({
      strip: b,
      arrow: h,
      backArrow: p,
      enabled: () => !t.value,
      selection: () => e.modelValue
    }), y = Nn(), w = m(() => {
      const { class: L, style: T, ...E } = y;
      return E;
    });
    function $(L) {
      L.locked || f("update:modelValue", L.key);
    }
    function S(L) {
      var M;
      const T = Array.from(
        L.currentTarget.querySelectorAll("[role=tab]")
      ), E = document.activeElement, A = E ? T.indexOf(E) : -1;
      let D;
      switch (L.key) {
        case (t.value ? "ArrowDown" : "ArrowRight"):
          D = A < 0 ? 0 : (A + 1) % T.length;
          break;
        case (t.value ? "ArrowUp" : "ArrowLeft"):
          D = A <= 0 ? T.length - 1 : A - 1;
          break;
        case "Home":
          D = 0;
          break;
        case "End":
          D = T.length - 1;
          break;
        case "Enter":
        case " ":
          if (E && E.getAttribute("aria-disabled") !== "true") {
            const F = e.tabs[A];
            F && f("update:modelValue", F.key);
          }
          L.preventDefault();
          return;
        default:
          return;
      }
      L.preventDefault(), (M = T[D]) == null || M.focus();
    }
    return (L, T) => (c(), g("div", {
      class: C([a.value, I(y).class]),
      style: Ne(I(y).style)
    }, [
      I(x).showBackArrow.value ? (c(), g("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: p,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "nav-tabs-overflow-back-arrow",
        class: C(o("left-0")),
        onClick: T[0] || (T[0] = //@ts-ignore
        (...E) => I(x).scrollBack && I(x).scrollBack(...E))
      }, [...T[3] || (T[3] = [
        v("i", {
          class: "ri-arrow-left-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, hH)) : k("", !0),
      v("div", Oe({
        ref_key: "stripRef",
        ref: b
      }, w.value, {
        role: "tablist",
        "aria-orientation": t.value ? "vertical" : "horizontal",
        tabindex: I(x).overflowing.value ? -1 : void 0,
        class: [
          i[e.type],
          e.fullWidth || t.value ? "w-full" : "w-max max-w-full",
          !t.value && [
            "nav-tabs-scroll overflow-x-auto overflow-y-hidden",
            r[e.type]
          ]
        ],
        onKeydown: S,
        onScrollPassive: T[1] || (T[1] = //@ts-ignore
        (...E) => I(x).measure && I(x).measure(...E))
      }), [
        (c(!0), g(ce, null, Re(e.tabs, (E) => (c(), H(ft, {
          key: E.key,
          class: C(t.value ? "w-full" : e.fullWidth ? "flex-1 min-w-0" : "shrink-0"),
          text: E.lockTooltip ?? "",
          disabled: !d(E) || !E.lockTooltip,
          position: t.value ? "right" : "bottom"
        }, {
          default: xe(() => [
            v("button", {
              id: E.id,
              type: "button",
              role: "tab",
              "data-testid": `nav-tab-${E.key}`,
              "aria-selected": E.key === e.modelValue,
              "aria-disabled": E.locked ? "true" : void 0,
              "aria-controls": E.panelId,
              tabindex: E.key === e.modelValue ? 0 : -1,
              class: C([
                "inline-flex min-w-0 items-center gap-1.5 whitespace-nowrap",
                "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
                "transition-colors motion-reduce:transition-none",
                "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l-inset)",
                s[e.type].base,
                t.value ? "w-full" : e.fullWidth && "w-full justify-center",
                u(E)
              ]),
              onClick: (A) => $(E)
            }, [
              E.icon && !d(E) ? (c(), g("i", {
                key: 0,
                class: C([E.icon, "text-(length:--icon-size-sm) leading-none"]),
                "aria-hidden": "true"
              }, null, 2)) : k("", !0),
              v("span", mH, N(E.label), 1),
              d(E) ? (c(), g("i", pH)) : k("", !0)
            ], 10, gH)
          ]),
          _: 2
        }, 1032, ["class", "text", "disabled", "position"]))), 128))
      ], 16, bH),
      I(x).showArrow.value ? (c(), g("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "nav-tabs-overflow-arrow",
        class: C(o("right-0")),
        onClick: T[2] || (T[2] = //@ts-ignore
        (...E) => I(x).scrollForward && I(x).scrollForward(...E))
      }, [...T[4] || (T[4] = [
        v("i", {
          class: "ri-arrow-right-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, vH)) : k("", !0)
    ], 6));
  }
}), bU = /* @__PURE__ */ ot(yH, [["__scopeId", "data-v-a1f63d2d"]]), Eb = /* @__PURE__ */ ke({
  __name: "StepperWizardPhaseIcon",
  props: {
    icon: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (c(), H(Vt, {
      size: "md",
      type: "circle",
      variant: "outlined",
      color: e.disabled ? "disabled" : "white",
      icon: e.icon
    }, null, 8, ["color", "icon"]));
  }
}), kH = ["data-testid", "aria-current", "aria-disabled", "onClick"], wH = { class: "truncate" }, CH = ["data-testid", "aria-expanded", "aria-disabled", "onClick"], SH = { class: "flex items-center gap-3 truncate" }, $H = { class: "truncate" }, IH = ["data-testid", "aria-current", "aria-disabled", "onClick"], TH = {
  key: 1,
  class: "h-6 w-9 shrink-0",
  "aria-hidden": "true"
}, LH = { class: "py-0.5" }, Rb = "flex items-center gap-3 p-1 w-full text-left rounded-(--border-border-radius-rounded-xs) text-base font-medium leading-6", gU = /* @__PURE__ */ ke({
  __name: "StepperWizardSidenav",
  props: {
    groups: {},
    currentStepId: {},
    showStatusIcons: { type: Boolean },
    showPhaseIcons: { type: Boolean }
  },
  emits: ["step-click", "group-toggle"],
  setup(e, { emit: n }) {
    function t(h, p) {
      if (h) return "text-(--text-text-disabled-light) cursor-not-allowed";
      const x = "text-(--text-text-heading) transition-colors";
      return p ? `${x} bg-[image:var(--gradient-brand-row-highlight)]` : `${x} hover:bg-[image:var(--gradient-brand-row-highlight)]`;
    }
    const a = e, l = n, r = sl({});
    function o() {
      for (const h of a.groups)
        h.steps.length > 0 && (r[h.id] = h.defaultExpanded ?? !0);
    }
    o(), $e(
      () => a.groups,
      (h) => {
        for (const p of h)
          p.steps.length > 0 && !(p.id in r) && (r[p.id] = p.defaultExpanded ?? !0);
      },
      { deep: !1 }
    );
    const i = m(() => {
      var h;
      if (a.currentStepId)
        return (h = a.groups.find(
          (p) => p.steps.some((x) => x.id === a.currentStepId)
        )) == null ? void 0 : h.id;
    });
    $e(
      i,
      (h) => {
        h && (r[h] = !0);
      },
      { immediate: !0 }
    );
    function s(h, p) {
      return p != null && p.disabled ? "disabled" : h.id === a.currentStepId ? "current" : h.state ?? "upcoming";
    }
    function d(h) {
      switch (h) {
        case "done":
          return "ri-checkbox-circle-fill";
        case "current":
          return "ri-checkbox-circle-line";
        case "disabled":
          return "ri-checkbox-blank-circle-line";
        case "upcoming":
        default:
          return "ri-checkbox-blank-circle-line";
      }
    }
    function u(h) {
      l("step-click", h);
    }
    function f(h) {
      if (i.value === h) return;
      const p = !r[h];
      r[h] = p, l("group-toggle", h, p);
    }
    function b(h, p) {
      p != null && p.disabled || h.state !== "disabled" && (h.id, a.currentStepId, l("step-click", h.id));
    }
    return (h, p) => (c(), g("nav", {
      role: "navigation",
      class: C(["flex flex-col gap-3 pb-1.5 w-full min-w-72", h.$attrs.class])
    }, [
      (c(!0), g(ce, null, Re(e.groups, (x) => (c(), g("div", {
        key: x.id,
        class: "flex flex-col gap-2 pr-1.5"
      }, [
        x.steps.length === 0 ? (c(), H(ft, {
          key: 0,
          class: "w-full",
          text: x.lockTooltip ?? "",
          disabled: !x.disabled || !x.lockTooltip,
          position: "bottom"
        }, {
          default: xe(() => [
            v("button", {
              type: "button",
              "data-testid": `sw-step-${x.id}`,
              "aria-current": x.id === e.currentStepId ? "step" : void 0,
              "aria-disabled": x.disabled ? "true" : void 0,
              class: C([Rb, t(x.disabled, x.id === e.currentStepId)]),
              onClick: (y) => !x.disabled && u(x.id)
            }, [
              e.showPhaseIcons && x.icon ? (c(), H(Eb, {
                key: 0,
                icon: x.icon,
                disabled: x.disabled
              }, null, 8, ["icon", "disabled"])) : k("", !0),
              v("span", wH, N(x.label), 1)
            ], 10, kH)
          ]),
          _: 2
        }, 1032, ["text", "disabled"])) : (c(), g(ce, { key: 1 }, [
          re(ft, {
            class: "w-full",
            text: x.lockTooltip ?? "",
            disabled: !x.disabled || !x.lockTooltip,
            position: "bottom"
          }, {
            default: xe(() => [
              v("button", {
                type: "button",
                "data-testid": `sw-group-${x.id}`,
                "aria-expanded": r[x.id],
                "aria-disabled": x.disabled ? "true" : void 0,
                class: C([
                  Rb,
                  "justify-between",
                  t(x.disabled, i.value === x.id)
                ]),
                onClick: (y) => !x.disabled && f(x.id)
              }, [
                v("span", SH, [
                  e.showPhaseIcons && x.icon ? (c(), H(Eb, {
                    key: 0,
                    icon: x.icon,
                    disabled: x.disabled
                  }, null, 8, ["icon", "disabled"])) : k("", !0),
                  v("span", $H, N(x.label), 1)
                ]),
                v("i", {
                  class: C([
                    "ri-arrow-down-s-line text-xl shrink-0 transition-transform",
                    r[x.id] ? "-rotate-180" : ""
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 10, CH)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]),
          r[x.id] ? (c(!0), g(ce, { key: 0 }, Re(x.steps, (y) => (c(), H(ft, {
            key: y.id,
            class: "w-full",
            text: y.lockTooltip ?? "",
            disabled: s(y, x) !== "disabled" || !y.lockTooltip,
            position: "bottom"
          }, {
            default: xe(() => [
              v("button", {
                type: "button",
                "data-testid": `sw-step-${y.id}`,
                "aria-current": s(y, x) === "current" ? "step" : void 0,
                "aria-disabled": s(y, x) === "disabled" ? "true" : void 0,
                class: C([
                  "flex items-start gap-3 px-1 w-full text-left text-sm font-medium leading-5",
                  s(y, x) === "disabled" ? "text-(--text-text-disabled-strong) cursor-not-allowed" : s(y, x) === "current" ? "text-(--text-text-hover)" : "text-(--text-text-body) hover:text-(--text-text-hover) transition-colors"
                ]),
                onClick: (w) => b(y, x)
              }, [
                e.showStatusIcons ? (c(), g("i", {
                  key: 0,
                  class: C([d(s(y, x)), "text-xl shrink-0"]),
                  "aria-hidden": "true"
                }, null, 2)) : (c(), g("span", TH)),
                v("span", LH, N(y.label), 1)
              ], 10, IH)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]))), 128)) : k("", !0)
        ], 64))
      ]))), 128))
    ], 2));
  }
}), AH = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, EH = {
  key: 0,
  "data-testid": "actions-status",
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, RH = ["aria-label"], BH = { class: "inline-flex items-center gap-3.5 shrink-0" }, DH = {
  "data-testid": "actions-group",
  class: "flex items-center gap-1 min-w-0"
}, MH = {
  key: 0,
  "data-testid": "actions-loading",
  class: "flex items-center gap-2 px-2 shrink-0",
  "aria-hidden": "true"
}, zH = ["inert"], OH = { class: "hidden sm:inline" }, Cd = 640, Bb = 560, PH = 1100, FH = "ri-lock-line", Sd = 20, VH = "__untagged__", NH = 3, HH = '[data-testid="dropdown-menu"]', jH = /* @__PURE__ */ ke({
  __name: "FloatActionBar",
  props: {
    selectionCount: {},
    allPagesSelected: { type: Boolean },
    totalAcrossAllPages: {},
    actions: {},
    maxVisibleActions: { default: 4 },
    isLoading: { type: Boolean, default: !1 },
    actionsLoading: { type: Boolean, default: !1 },
    actionsError: { type: Boolean, default: !1 },
    moduleLabels: { default: void 0 },
    ariaLabel: {},
    selectedItemLabel: {},
    selectedItemsLabel: {},
    selectAllPagesLabel: {},
    moreLabel: {},
    moreActionsTitle: {},
    closeLabel: {},
    totalUnavailableLabel: {},
    selectionClearedLabel: {},
    actionsLoadingLabel: { default: void 0 }
  },
  emits: ["dismiss", "action-click", "select-all-pages"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      primary: "primary",
      secondary: "secondary",
      text: "text",
      destructive: "error-text"
    };
    function r(ae) {
      return ae.variant ? l[ae.variant] : ae.destructive ? "error-text" : "text";
    }
    function o(ae) {
      return ae.variant === "destructive" || ae.destructive === !0;
    }
    function i(ae) {
      return s(ae) ? FH : ae.icon;
    }
    function s(ae) {
      return ae.disabled ? ae.disabledReason : void 0;
    }
    const d = m(() => t.actions.some((ae) => ae.order !== void 0) ? t.actions.map((ae, ie) => ({ action: ae, index: ie })).sort(
      (ae, ie) => (ae.action.order ?? Number.MAX_SAFE_INTEGER) - (ie.action.order ?? Number.MAX_SAFE_INTEGER) || ae.index - ie.index
    ).map((ae) => ae.action) : t.actions), u = m(
      () => t.actionsLoading || t.actionsError ? [] : d.value
    ), f = m(
      () => u.value.filter((ae) => ae.placement !== "overflow")
    ), b = R(typeof window < "u" ? window.innerWidth : 1024);
    function h() {
      b.value = window.innerWidth, K.value !== null && (K.value = ye(K.value)), requestAnimationFrame($);
    }
    dt(() => window.addEventListener("resize", h)), gt(() => window.removeEventListener("resize", h));
    const p = R(null), x = R([]), y = R(t.actions.length);
    function w(ae) {
      return (ie) => {
        x.value[ae] = ie instanceof HTMLElement ? ie : null;
      };
    }
    function $() {
      const ae = p.value;
      if (!ae) {
        y.value = f.value.length;
        return;
      }
      const ie = ae.getBoundingClientRect().right, Ce = x.value.findIndex(
        (Fe) => Fe && Fe.getBoundingClientRect().right > ie + 1
      );
      y.value = Ce === -1 ? f.value.length : Ce;
    }
    let S = null;
    $e(
      p,
      (ae) => {
        S == null || S.disconnect(), ae && (S ?? (S = new ResizeObserver(() => requestAnimationFrame($))), S.observe(ae), requestAnimationFrame($));
      },
      { flush: "post", immediate: !0 }
    ), gt(() => S == null ? void 0 : S.disconnect());
    const L = m(
      () => f.value.map((ae) => `${ae.id}${ae.label}${i(ae) ?? ""}`).join("\0")
    );
    $e(L, () => requestAnimationFrame($));
    const T = m(() => b.value < Cd ? 0 : Math.min(y.value, t.maxVisibleActions));
    function E(ae) {
      return ae >= t.maxVisibleActions || b.value < Cd ? "hidden" : ae >= T.value ? "invisible" : "";
    }
    const A = m(() => {
      const ae = new Set(
        f.value.slice(0, T.value).map((ie) => ie.id)
      );
      return u.value.filter((ie) => !ae.has(ie.id));
    }), D = m(() => A.value.length > 0);
    $e(
      () => A.value.length,
      (ae) => {
        ae > Sd && console.warn(
          `[FloatActionBar] More menu has ${ae} actions; only the first ${Sd} are rendered.`
        );
      },
      { immediate: !0 }
    );
    const M = m(
      () => A.value.slice(0, Sd)
    );
    function F(ae) {
      return {
        label: ae.label,
        icon: i(ae),
        danger: o(ae),
        disabled: ae.disabled || t.isLoading,
        loading: ae.loading,
        // Shown as helper text under the label; an item carrying a description stays
        // focusable (aria-disabled) so the reason is keyboard-reachable (R74).
        description: s(ae),
        testId: "megamenu-nav-link",
        onClick: () => a("action-click", ae.id, B.value)
      };
    }
    const X = m(
      () => M.value.map(F)
    ), _ = m(() => {
      const ae = [
        ...new Set(
          M.value.map((Fe) => Fe.module).filter((Fe) => !!Fe)
        )
      ], ie = M.value.filter((Fe) => !Fe.module);
      if (ae.length + (ie.length > 0 ? 1 : 0) < 2) return;
      const Ce = ae.map((Fe) => {
        var Ke;
        return {
          key: Fe,
          // No fallback to the raw key: it is an identifier, and rendering it would ship
          // untranslated text to fr/nl users (R29). A heading-less column is the safe default.
          label: (Ke = t.moduleLabels) == null ? void 0 : Ke[Fe],
          items: M.value.filter((_e) => _e.module === Fe).map(F)
        };
      });
      return ie.length > 0 && Ce.push({ key: VH, items: ie.map(F) }), Ce;
    }), Y = m(() => b.value < PH ? 2 : 4), B = m(() => ({
      selectedCount: t.selectionCount,
      allPagesSelected: t.allPagesSelected,
      totalCount: t.totalAcrossAllPages
    })), W = m(
      () => t.allPagesSelected && t.totalAcrossAllPages !== void 0 ? t.totalAcrossAllPages : t.selectionCount
    ), U = m(
      () => W.value === 1 ? t.selectedItemLabel : t.selectedItemsLabel
    ), z = R(null), P = R(null), K = R(null), j = R(!1);
    let G = 0, q = 0, J = 0;
    function me() {
      var ae;
      return ((ae = z.value) == null ? void 0 : ae.offsetWidth) ?? 0;
    }
    function ye(ae) {
      return Math.max(16, Math.min(ae, window.innerWidth - me() - 16));
    }
    let Z = null;
    $e(
      () => z.value,
      (ae) => {
        Z == null || Z.disconnect(), !(!ae || typeof ResizeObserver > "u") && (Z ?? (Z = new ResizeObserver(() => {
          K.value !== null && (K.value = ye(K.value));
        })), Z.observe(ae));
      },
      { flush: "post" }
    ), gt(() => Z == null ? void 0 : Z.disconnect());
    let de = !1;
    function ge(ae) {
      var ie, Ce;
      !z.value || ae.button !== 0 || ((Ce = (ie = ae.currentTarget) == null ? void 0 : ie.setPointerCapture) == null || Ce.call(ie, ae.pointerId), oe(), j.value = !0, de = !1, G = ae.clientX, q = ae.clientY, J = K.value ?? (window.innerWidth - me()) / 2, ae.preventDefault());
    }
    function se(ae) {
      if (!j.value) return;
      const ie = ae.clientX - G;
      !de && Math.hypot(ie, ae.clientY - q) <= NH || (de = !0, K.value = ye(J + ie));
    }
    function Se(ae) {
      var ie, Ce;
      j.value && (j.value = !1, (Ce = (ie = ae.currentTarget) == null ? void 0 : ie.releasePointerCapture) == null || Ce.call(ie, ae.pointerId), ae.type === "pointerup" && (V.value = de ? !1 : !V.value));
    }
    const V = R(!1);
    function Q(ae) {
      var ie;
      if (ae.detail === 0) {
        V.value = !1;
        return;
      }
      if (ae.button === 0) {
        if (le(ae.target)) {
          (ie = P.value) != null && ie.contains(ae.target) || (V.value = !1);
          return;
        }
        ae.preventDefault(), ae.stopPropagation(), K.value = ye(ae.clientX - me() / 2), V.value = !1;
      }
    }
    function le(ae) {
      var ie;
      return ae instanceof Node && (!!((ie = z.value) != null && ie.contains(ae)) || te(ae));
    }
    function ee(ae) {
      ae.button !== 0 || le(ae.target) || (ae.preventDefault(), ae.stopPropagation());
    }
    const O = [
      ["click", Q],
      ["pointerdown", ee],
      ["mousedown", ee],
      ["pointerup", ee],
      ["mouseup", ee]
    ];
    function ne(ae) {
      for (const [ie, Ce] of O)
        ae ? document.addEventListener(ie, Ce, !0) : document.removeEventListener(ie, Ce, !0);
    }
    let fe = "";
    $e(V, (ae) => {
      ne(ae);
      const ie = document.documentElement;
      ae ? (fe = ie.style.cursor, ie.style.cursor = "crosshair") : ie.style.cursor = fe;
    }), gt(() => {
      ne(!1), V.value && (document.documentElement.style.cursor = fe);
    });
    const ue = R(null);
    function te(ae) {
      return ae instanceof Element && !!ae.closest(HH);
    }
    function oe() {
      var Ce, Fe, Ke;
      if (!((Ce = ue.value) != null && Ce.isOpen)) return;
      const ae = document.activeElement, ie = !!ae && te(ae);
      ue.value.close(), ie && ((Ke = (Fe = z.value) == null ? void 0 : Fe.querySelector('[data-testid="more-btn"]')) == null || Ke.focus());
    }
    $e(
      () => {
        var ae;
        return (ae = ue.value) == null ? void 0 : ae.isOpen;
      },
      (ae) => {
        ae && (V.value = !1);
      }
    );
    const Le = R(null), Ie = R([]);
    function ve(ae) {
      return (ie) => {
        Ie.value[ae] = ie ?? null;
      };
    }
    function we() {
      var ae;
      return (ae = Le.value) != null && ae.isVisible ? Le.value : Ie.value.find((ie) => ie == null ? void 0 : ie.isVisible) ?? null;
    }
    const he = Symbol("float-action-bar");
    function Me(ae) {
      var Ce, Fe, Ke;
      if (ae.key !== "Escape" || (Ce = ue.value) != null && Ce.isOpen) return;
      const ie = we();
      if (ie) {
        ae.stopPropagation(), ae.preventDefault(), ie.hide();
        return;
      }
      if (V.value) {
        if (!ha(he)) return;
        ae.preventDefault(), ae.target instanceof Node && ((Fe = z.value) != null && Fe.contains(ae.target)) && ae.stopPropagation(), V.value = !1;
        return;
      }
      Ee.value && ha(he) && (ae.preventDefault(), ae.target instanceof Node && ((Ke = z.value) != null && Ke.contains(ae.target)) && ae.stopPropagation(), a("dismiss"));
    }
    dt(() => window.addEventListener("keydown", Me, !0)), gt(() => {
      window.removeEventListener("keydown", Me, !0), Rn(he);
    });
    const Ee = m(() => t.selectionCount > 0);
    let He = null;
    $e(Ee, (ae) => {
      ae || (V.value = !1, j.value = !1);
    }), $e(
      Ee,
      (ae) => ae ? Qn(he) : Rn(he)
    );
    let Ge = !1;
    dt(() => {
      Ge = !0, Ue(() => {
        Ge && Ee.value && Qn(he);
      });
    }), gt(() => {
      Ge = !1;
    }), $e(Ee, (ae) => {
      var ie;
      if (ae) {
        He = document.activeElement instanceof HTMLElement && document.activeElement !== document.body ? document.activeElement : null;
        return;
      }
      (ie = z.value) != null && ie.contains(document.activeElement) && He && document.contains(He) && He.focus();
    });
    const Ze = R("");
    return $e(
      () => [t.selectionCount, t.allPagesSelected, t.totalAcrossAllPages],
      ([ae], ie) => {
        const Ce = ie == null ? void 0 : ie[0];
        ae > 0 ? Ze.value = `${W.value} ${U.value}` : Ce !== void 0 && Ce > 0 && (Ze.value = t.selectionClearedLabel);
      },
      { immediate: !0 }
    ), (ae, ie) => (c(), g(ce, null, [
      v("span", AH, N(Ze.value), 1),
      e.actionsLoadingLabel ? (c(), g("span", EH, N(e.actionsLoading ? e.actionsLoadingLabel : ""), 1)) : k("", !0),
      re(wt, {
        name: "float-bar",
        appear: ""
      }, {
        default: xe(() => [
          e.selectionCount > 0 ? (c(), g("div", {
            key: 0,
            ref_key: "barRef",
            ref: z,
            "data-testid": "float-action-bar",
            role: "toolbar",
            "aria-label": e.ariaLabel,
            class: "inline-flex items-center gap-3.5 p-1.5 rounded-full overflow-hidden z-40 bg-(--background-background-black-default) shadow-(--shadow-xl)",
            style: Ne({
              position: "fixed",
              bottom: "24px",
              left: K.value !== null ? `${K.value}px` : "16px",
              right: K.value !== null ? void 0 : "16px",
              width: K.value !== null ? "max-content" : "fit-content",
              margin: K.value !== null ? void 0 : "0 auto",
              maxWidth: "calc(100vw - 32px)",
              cursor: j.value ? "grabbing" : V.value ? "crosshair" : void 0
            })
          }, [
            v("button", {
              ref_key: "handleRef",
              ref: P,
              "data-testid": "drag-handle",
              tabindex: "-1",
              "aria-hidden": "true",
              class: C([V.value ? "cursor-crosshair" : "cursor-grab", "flex shrink-0 items-center justify-center size-9 rounded-full bg-transparent border-none touch-none focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-(--border-border-accent)"]),
              onPointerdown: ge,
              onPointermove: se,
              onPointerup: Se,
              onPointercancel: Se,
              onClick: ie[0] || (ie[0] = Ye(() => {
              }, ["prevent"]))
            }, [...ie[3] || (ie[3] = [
              v("i", {
                class: "ri-draggable text-(length:--icon-size-md) leading-(--icon-size-md) text-(--icons-icon-white-default)",
                "aria-hidden": "true"
              }, null, -1)
            ])], 34),
            v("div", BH, [
              re(Be, {
                "data-testid": "selection-count",
                variant: "secondary",
                size: "xs",
                label: b.value >= Bb ? `${W.value} ${U.value}` : `${W.value}`,
                "icon-right": "ri-close-fill",
                "aria-label": `${W.value} ${U.value}`,
                class: "shrink-0",
                onClick: ie[1] || (ie[1] = (Ce) => a("dismiss"))
              }, null, 8, ["label", "aria-label"]),
              re(ft, {
                ref_key: "selectAllTooltipRef",
                ref: Le,
                text: e.totalUnavailableLabel,
                disabled: e.totalAcrossAllPages !== void 0
              }, {
                default: xe(() => [
                  re($n, {
                    variant: "dark",
                    "model-value": e.allPagesSelected,
                    label: b.value >= Bb ? e.selectAllPagesLabel : "",
                    "aria-label": e.selectAllPagesLabel,
                    "aria-disabled": e.totalAcrossAllPages === void 0,
                    class: "px-1 shrink-0 w-auto!",
                    "onUpdate:modelValue": ie[2] || (ie[2] = (Ce) => a("select-all-pages", Ce))
                  }, null, 8, ["model-value", "label", "aria-label", "aria-disabled"])
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            v("div", DH, [
              v("div", {
                ref_key: "btnAreaRef",
                ref: p,
                "data-testid": "action-buttons-area",
                class: "dark flex items-center gap-1 overflow-hidden min-w-0"
              }, [
                e.actionsLoading ? (c(), g("div", MH, [...ie[4] || (ie[4] = [
                  v("i", { class: "ri-loader-4-line animate-spin text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-white-default)" }, null, -1),
                  v("span", { class: "h-2 w-16 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1),
                  v("span", { class: "h-2 w-10 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1)
                ])])) : k("", !0),
                (c(!0), g(ce, null, Re(f.value, (Ce, Fe) => (c(), g("div", {
                  key: Ce.id,
                  ref_for: !0,
                  ref: w(Fe),
                  class: C(["shrink-0", E(Fe)]),
                  inert: Fe >= T.value || void 0
                }, [
                  re(ft, {
                    ref_for: !0,
                    ref: ve(Fe),
                    text: s(Ce) ?? "",
                    disabled: !s(Ce)
                  }, {
                    default: xe(() => [
                      re(Be, {
                        "data-testid": `action-btn-${Ce.id}`,
                        variant: r(Ce),
                        size: "xs",
                        "icon-left": i(Ce),
                        "icon-only": b.value < Cd,
                        loading: Ce.loading,
                        disabled: !s(Ce) && (Ce.disabled || e.isLoading),
                        "aria-disabled": !!s(Ce),
                        "aria-label": Ce.label,
                        onClick: (Ke) => a("action-click", Ce.id, B.value)
                      }, {
                        default: xe(() => [
                          v("span", OH, N(Ce.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["data-testid", "variant", "icon-left", "icon-only", "loading", "disabled", "aria-disabled", "aria-label", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["text", "disabled"])
                ], 10, zH))), 128))
              ], 512),
              D.value ? (c(), H(ln, {
                key: 0,
                ref_key: "dropdownRef",
                ref: ue,
                class: "shrink-0",
                "menu-item-variant": "nav",
                items: X.value,
                groups: _.value,
                columns: Y.value,
                "menu-header": e.moreActionsTitle,
                closeable: "",
                "close-label": e.closeLabel,
                "menu-reference": z.value,
                "menu-align": "right",
                "menu-side": "top",
                "menu-offset": 4
              }, {
                trigger: xe(({ triggerProps: Ce }) => [
                  re(Be, Oe({
                    "data-testid": "more-btn",
                    variant: "secondary",
                    size: "xs",
                    "icon-left": "ri-more-line",
                    label: e.moreLabel,
                    class: "shrink-0"
                  }, Ce), null, 16, ["label"])
                ]),
                _: 1
              }, 8, ["items", "groups", "columns", "menu-header", "close-label", "menu-reference"])) : k("", !0)
            ])
          ], 12, RH)) : k("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), mU = /* @__PURE__ */ ot(jH, [["__scopeId", "data-v-ed745030"]]);
function pU(e, n = {}) {
  const t = Yl([]), a = R(!1), l = R(!1), r = R(null), o = R(void 0);
  let i = 0;
  async function s() {
    const d = ++i;
    a.value = !0, l.value = !1, r.value = null, t.value = [];
    try {
      const u = await e();
      if (d !== i) return;
      t.value = (u == null ? void 0 : u.actions) ?? [], o.value = u == null ? void 0 : u.version;
    } catch (u) {
      if (d !== i) return;
      l.value = !0, r.value = u, t.value = [];
    } finally {
      d === i && (a.value = !1);
    }
  }
  return n.immediate !== !1 && s(), { actions: t, isLoading: a, hasError: l, error: r, version: o, load: s };
}
const WH = {
  "data-testid": "field-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, qH = {
  key: 0,
  class: "flex items-center gap-2"
}, UH = {
  key: 0,
  class: "h-5 pb-0.5 flex items-center"
}, GH = /* @__PURE__ */ ke({
  __name: "FieldSkeleton",
  props: {
    variant: { default: "input" },
    size: { default: "md" },
    showLabel: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = {
      sm: "h-[32px]",
      md: "h-[36px]",
      lg: "h-[48px]",
      xl: "h-[52px]"
    };
    return (t, a) => (c(), g("div", WH, [
      e.variant === "checkbox" || e.variant === "toggle" ? (c(), g("div", qH, [
        v("div", {
          class: C([
            "skeleton shrink-0",
            e.variant === "toggle" ? "h-5 w-9 rounded-full" : "size-4 rounded"
          ])
        }, null, 2),
        a[0] || (a[0] = v("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1))
      ])) : (c(), g(ce, { key: 1 }, [
        e.showLabel ? (c(), g("div", UH, [...a[1] || (a[1] = [
          v("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1)
        ])])) : k("", !0),
        v("div", {
          class: C([
            "skeleton w-full rounded-xl",
            e.variant === "textarea" ? "h-24" : n[e.size]
          ])
        }, null, 2)
      ], 64))
    ]));
  }
}), vU = /* @__PURE__ */ ke({
  __name: "FormSkeleton",
  props: {
    fields: { default: 6 },
    columns: { default: 2 },
    size: { default: "md" },
    showLabels: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      "data-testid": "form-skeleton",
      "aria-hidden": "true",
      class: C(["grid gap-x-5 gap-y-4", e.columns === 2 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), g(ce, null, Re(e.fields, (a) => (c(), H(GH, {
        key: `form-skeleton-field-${a}`,
        size: e.size,
        "show-label": e.showLabels
      }, null, 8, ["size", "show-label"]))), 128))
    ], 2));
  }
}), KH = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-palette"
}, YH = { class: "flex min-w-0 flex-1 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)]" }, JH = { class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)" }, XH = ["aria-label"], ZH = ["aria-label", "aria-selected", "tabindex", "data-listbox-index", "onClick", "onFocus"], Vo = 6, QH = /* @__PURE__ */ ke({
  __name: "ColorPickerPalette",
  props: {
    swatches: {},
    modelValue: {},
    labels: {},
    showReset: { type: Boolean }
  },
  emits: ["select", "reset", "custom"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = R(null), o = m(
      () => a.modelValue ? a.swatches.findIndex((h) => h.hex === a.modelValue) : -1
    ), i = R(Math.max(0, o.value));
    $e(
      () => a.swatches.length,
      (h) => {
        i.value >= h && (i.value = Math.max(0, h - 1));
      }
    );
    function s() {
      const h = a.swatches[i.value];
      h && l("select", h.hex);
    }
    function d(h) {
      var p, x;
      i.value = h, (x = (p = r.value) == null ? void 0 : p.querySelector(`[data-listbox-index="${h}"]`)) == null || x.focus();
    }
    function u() {
      i.value = Math.max(0, o.value), Ue(() => d(i.value));
    }
    function f(h) {
      const p = a.swatches.length - 1, x = i.value;
      let y;
      switch (h.key) {
        case "ArrowRight":
          y = Math.min(p, x + 1);
          break;
        case "ArrowLeft":
          y = Math.max(0, x - 1);
          break;
        case "ArrowDown":
          y = x + Vo <= p ? x + Vo : x;
          break;
        case "ArrowUp":
          y = x - Vo >= 0 ? x - Vo : x;
          break;
        case "Home":
          y = 0;
          break;
        case "End":
          y = p;
          break;
        case "Enter":
          h.preventDefault(), s();
          return;
        case " ":
          h.preventDefault();
          return;
        default:
          return;
      }
      h.preventDefault(), h.stopPropagation(), d(y);
    }
    function b(h) {
      h.key === " " && (h.preventDefault(), s());
    }
    return n({ focusInitial: u }), (h, p) => (c(), g("div", KH, [
      v("button", {
        type: "button",
        class: "flex w-full items-center gap-(--spacing-2) rounded-(--border-border-radius-rounded-xs) cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
        "data-testid": "color-picker-custom",
        onClick: p[0] || (p[0] = (x) => l("custom"))
      }, [
        v("span", YH, [
          v("span", {
            class: "h-(--spacing-6) w-full rounded-(--border-border-radius-rounded-xxs)",
            style: Ne({ backgroundColor: e.modelValue ?? "transparent" }),
            "data-testid": "color-picker-palette-preview"
          }, null, 4)
        ]),
        v("span", JH, N(e.labels.pickColor), 1)
      ]),
      v("div", {
        ref_key: "listboxRef",
        ref: r,
        role: "listbox",
        "aria-label": e.labels.palette,
        class: "grid w-fit grid-cols-6 gap-(--spacing-1)",
        "data-testid": "color-picker-swatches",
        onKeydown: f,
        onKeyup: b
      }, [
        (c(!0), g(ce, null, Re(e.swatches, (x, y) => (c(), g("div", {
          key: y,
          role: "option",
          "aria-label": x.name,
          "aria-selected": y === o.value ? "true" : "false",
          tabindex: y === i.value ? 0 : -1,
          "data-listbox-index": y,
          class: C([
            "size-(--spacing-6) rounded-(--border-border-radius-rounded-xs) border border-solid cursor-pointer focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
            // Selected mark reuses the Button focus treatment: accent border + soft glow.
            y === o.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_0px_var(--background-background-hover)]" : "border-(--border-border-base-soft)"
          ]),
          style: Ne({ backgroundColor: x.hex }),
          "data-testid": "color-picker-swatch",
          onClick: (w) => l("select", x.hex),
          onFocus: (w) => i.value = y
        }, null, 46, ZH))), 128))
      ], 40, XH),
      e.showReset ? (c(), H(Be, {
        key: 0,
        class: "self-center",
        variant: "ghost",
        size: "xs",
        "icon-left": "ri-restart-line",
        label: e.labels.resetColor,
        "data-testid": "color-picker-reset",
        onClick: p[1] || (p[1] = (x) => l("reset"))
      }, null, 8, ["label"])) : k("", !0)
    ]));
  }
}), Un = (e, n, t) => Math.min(t, Math.max(n, e));
function sa(e) {
  const n = e.trim().replace(/^#/, "");
  return /^[0-9a-f]{3}$/i.test(n) ? `#${n.split("").map((t) => t + t).join("").toUpperCase()}` : /^[0-9a-f]{6}$/i.test(n) ? `#${n.toUpperCase()}` : null;
}
function _H(e) {
  const n = sa(e) ?? "#000000", t = parseInt(n.slice(1), 16);
  return { r: t >> 16 & 255, g: t >> 8 & 255, b: t & 255 };
}
function Db({ r: e, g: n, b: t }) {
  const a = (l) => Math.round(Un(l, 0, 255)).toString(16).padStart(2, "0");
  return `#${a(e)}${a(n)}${a(t)}`.toUpperCase();
}
function Cu({ r: e, g: n, b: t }) {
  const a = e / 255, l = n / 255, r = t / 255, o = Math.max(a, l, r), i = o - Math.min(a, l, r);
  let s = 0;
  return i !== 0 && (o === a ? s = (l - r) / i % 6 : o === l ? s = (r - a) / i + 2 : s = (a - l) / i + 4, s = (s * 60 + 360) % 360), { h: s, s: o === 0 ? 0 : i / o * 100, v: o * 100 };
}
function No({ h: e, s: n, v: t }) {
  const a = Un(n, 0, 100) / 100, l = Un(t, 0, 100) / 100, r = (o) => {
    const i = (o + (e % 360 + 360) / 60) % 6;
    return l - l * a * Math.max(0, Math.min(i, 4 - i, 1));
  };
  return { r: Math.round(r(5) * 255), g: Math.round(r(3) * 255), b: Math.round(r(1) * 255) };
}
function Mb({ r: e, g: n, b: t }) {
  const a = e / 255, l = n / 255, r = t / 255, o = Math.max(a, l, r), i = Math.min(a, l, r), s = (o + i) / 2, d = o - i, u = d === 0 ? 0 : d / (1 - Math.abs(2 * s - 1));
  return { h: Cu({ r: e, g: n, b: t }).h, s: u * 100, l: s * 100 };
}
function ej({ h: e, s: n, l: t }) {
  const a = Un(n, 0, 100) / 100, l = Un(t, 0, 100) / 100, r = a * Math.min(l, 1 - l), o = (i) => {
    const s = (i + (e % 360 + 360) / 30) % 12;
    return l - r * Math.max(-1, Math.min(s - 3, 9 - s, 1));
  };
  return { r: Math.round(o(0) * 255), g: Math.round(o(8) * 255), b: Math.round(o(4) * 255) };
}
const tj = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-spectrum"
}, nj = ["value", "aria-label", "aria-valuetext"], aj = ["value", "aria-label", "aria-valuetext"], lj = { class: "flex items-center gap-(--spacing-2)" }, rj = ["aria-label"], oj = ["value", "aria-label", "aria-valuetext"], ij = { class: "flex items-end gap-(--spacing-1)" }, sj = { class: "flex min-w-0 flex-1 gap-(--spacing-2)" }, dj = { class: "flex w-[69px] shrink-0 flex-col items-center gap-[10px]" }, uj = ["id", "value", "onKeydown"], cj = ["for"], fj = ["id", "value", "aria-label", "data-testid", "onInput", "onKeydown"], hj = ["for"], bj = ["aria-label"], zb = "h-(--spacing-9) w-full min-w-0 rounded-(--border-border-radius-rounded-sm) border border-solid border-(--border-border-base-soft) bg-transparent px-(--spacing-1) text-center text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", Ob = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading)", gj = /* @__PURE__ */ ke({
  __name: "ColorPickerSpectrum",
  props: {
    modelValue: {},
    labels: {}
  },
  emits: ["update", "commit"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = je(), o = R(null), i = R(null), s = R(null), d = R(null), u = R({ h: 0, s: 100, v: 100 }), f = m(() => Db(No(u.value))), b = m(() => `hsl(${u.value.h} 100% 50%)`);
    function h(Z) {
      if (!Z || sa(Z) === f.value) return;
      const de = Cu(_H(Z));
      u.value = de.s === 0 || de.v === 0 ? { ...de, h: u.value.h } : de;
    }
    $e(() => a.modelValue, h, { immediate: !0 });
    function p(Z) {
      u.value = { ...u.value, ...Z }, l("update", f.value);
    }
    function x(Z) {
      h(Z), l("update", f.value);
    }
    const y = R(null);
    function w(Z, de) {
      const ge = de.getBoundingClientRect();
      return {
        x: ge.width ? Un((Z.clientX - ge.left) / ge.width, 0, 1) : 0,
        y: ge.height ? Un((Z.clientY - ge.top) / ge.height, 0, 1) : 0
      };
    }
    function $(Z) {
      if (y.value === "area" && o.value) {
        const { x: de, y: ge } = w(Z, o.value);
        p({ s: de * 100, v: (1 - ge) * 100 });
      } else y.value === "hue" && i.value && p({ h: w(Z, i.value).x * 360 });
    }
    function S(Z, de) {
      var ge, se, Se;
      de.preventDefault(), y.value = Z, (se = (ge = de.currentTarget).setPointerCapture) == null || se.call(ge, de.pointerId), $(de), (Se = (Z === "area" ? s : d).value) == null || Se.focus();
    }
    function L(Z) {
      y.value && $(Z);
    }
    function T() {
      y.value && (y.value = null, l("commit"));
    }
    function E(Z, de, ge) {
      if (!Z.shiftKey) return;
      const se = { ArrowRight: 10, ArrowUp: 10, ArrowLeft: -10, ArrowDown: -10 }[Z.key];
      se !== void 0 && (Z.preventDefault(), p({ [de]: Un(u.value[de] + se, 0, ge) }), l("commit"));
    }
    const A = {
      ArrowRight: ["s", 1],
      ArrowLeft: ["s", -1],
      ArrowUp: ["v", 1],
      ArrowDown: ["v", -1],
      PageUp: ["v", 10],
      PageDown: ["v", -10]
    };
    function D(Z) {
      const de = A[Z.key];
      if (!de) return;
      const [ge, se] = de;
      Z.preventDefault();
      const Se = Z.shiftKey && Math.abs(se) === 1 ? se * 10 : se;
      p({ [ge]: Un(Math.round(u.value[ge]) + Se, 0, 100) }), l("commit");
    }
    function M(Z, de) {
      p({ [de]: Number(Z.target.value) });
    }
    const F = R(!1), X = m(
      () => `${a.labels.saturation} ${Math.round(u.value.s)} %, ${a.labels.brightness} ${Math.round(u.value.v)} %`
    ), _ = R(!1), Y = R("rgb"), B = R(null), W = R(null), U = m(() => {
      const Z = No(u.value);
      if (Y.value === "rgb")
        return [
          { short: "R", name: a.labels.red, value: Z.r, max: 255 },
          { short: "G", name: a.labels.green, value: Z.g, max: 255 },
          { short: "B", name: a.labels.blue, value: Z.b, max: 255 }
        ];
      const de = Mb(Z);
      return [
        { short: "H", name: a.labels.hue, value: Math.round(u.value.h), max: 360 },
        { short: "S", name: a.labels.saturation, value: Math.round(de.s), max: 100 },
        { short: "L", name: a.labels.lightness, value: Math.round(de.l), max: 100 }
      ];
    });
    function z() {
      if (B.value === null) return;
      const Z = sa(B.value);
      B.value = null, !(!Z || Z === f.value) && (x(Z), l("commit"));
    }
    function P(Z, de) {
      const ge = Un(Math.round(de), 0, U.value[Z].max);
      if (Y.value === "rgb") {
        const V = No(u.value), Q = [V.r, V.g, V.b];
        Q[Z] = ge, x(Db({ r: Q[0], g: Q[1], b: Q[2] }));
        return;
      }
      const se = Mb(No(u.value)), Se = { h: u.value.h, s: se.s, l: se.l };
      Z === 0 ? Se.h = ge : Z === 1 ? Se.s = ge : Se.l = ge, p({ ...Cu(ej(Se)), h: Se.h });
    }
    function K(Z, de) {
      const ge = de.target.value;
      W.value = { index: Z, text: ge };
      const se = Number.parseInt(ge, 10);
      Number.isFinite(se) && P(Z, se);
    }
    function j(Z, de) {
      const ge = { ArrowUp: 1, ArrowDown: -1 }[de.key];
      if (ge === void 0) {
        de.key === "Enter" && (de.preventDefault(), G());
        return;
      }
      de.preventDefault(), W.value = null, P(Z, U.value[Z].value + ge * (de.shiftKey ? 10 : 1)), l("commit");
    }
    function G() {
      W.value !== null && (W.value = null, l("commit"));
    }
    const q = R(!1);
    dt(() => {
      q.value = typeof window.EyeDropper == "function";
    });
    async function J() {
      const Z = window.EyeDropper;
      if (Z)
        try {
          const { sRGBHex: de } = await new Z().open(), ge = sa(de);
          if (!ge) return;
          x(ge), l("commit");
        } catch {
        }
    }
    const me = `linear-gradient(to right, ${[0, 60, 120, 180, 240, 300, 360].map((Z) => `hsl(${Z} 100% 50%)`).join(", ")})`;
    function ye() {
      var Z;
      (Z = s.value) == null || Z.focus();
    }
    return n({ focusInitial: ye }), (Z, de) => (c(), g("div", tj, [
      v("div", {
        ref_key: "areaRef",
        ref: o,
        class: "relative h-[119px] w-full touch-none cursor-crosshair rounded-(--border-border-radius-rounded-xs) outline-1 outline-solid outline-(--border-border-base-soft)",
        style: Ne({
          backgroundImage: `linear-gradient(to top, var(--colors-color-picker-black), transparent), linear-gradient(to right, var(--colors-background-white), ${b.value})`
        }),
        "data-testid": "color-picker-area",
        onPointerdown: de[8] || (de[8] = (ge) => S("area", ge)),
        onMousedown: de[9] || (de[9] = Ye(() => {
        }, ["prevent"])),
        onPointermove: L,
        onPointerup: T,
        onPointercancel: T
      }, [
        v("span", {
          class: C([
            "pointer-events-none absolute size-[14px] -translate-x-1/2 translate-y-1/2 rounded-full border-3 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-handle)",
            F.value && "ring-2 ring-(--border-border-accent)"
          ]),
          style: Ne({ left: `${u.value.s}%`, bottom: `${u.value.v}%` }),
          "data-testid": "color-picker-area-handle"
        }, null, 6),
        v("input", {
          ref_key: "saturationInputRef",
          ref: s,
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(u.value.s),
          "aria-label": e.labels.saturation,
          "aria-valuetext": X.value,
          "data-testid": "color-picker-saturation",
          onInput: de[0] || (de[0] = (ge) => M(ge, "s")),
          onChange: de[1] || (de[1] = (ge) => l("commit")),
          onKeydown: D,
          onFocus: de[2] || (de[2] = (ge) => F.value = !0),
          onBlur: de[3] || (de[3] = (ge) => F.value = !1)
        }, null, 40, nj),
        v("input", {
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(u.value.v),
          "aria-label": e.labels.brightness,
          "aria-valuetext": X.value,
          tabindex: "-1",
          "data-testid": "color-picker-brightness",
          onInput: de[4] || (de[4] = (ge) => M(ge, "v")),
          onChange: de[5] || (de[5] = (ge) => l("commit")),
          onKeydown: D,
          onFocus: de[6] || (de[6] = (ge) => F.value = !0),
          onBlur: de[7] || (de[7] = (ge) => F.value = !1)
        }, null, 40, aj)
      ], 36),
      v("div", lj, [
        q.value ? (c(), g("button", {
          key: 0,
          type: "button",
          class: "relative flex size-(--icon-size-md) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-md) text-(--icons-icon-dark-default) after:absolute after:-inset-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": e.labels.eyedropper,
          "data-testid": "color-picker-eyedropper",
          onClick: J
        }, [...de[19] || (de[19] = [
          v("i", {
            class: "ri-sip-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, rj)) : k("", !0),
        v("span", {
          class: "size-(--spacing-6) shrink-0 rounded-full",
          style: Ne({ backgroundColor: f.value }),
          "aria-hidden": "true",
          "data-testid": "color-picker-current"
        }, null, 4),
        v("div", {
          ref_key: "hueRef",
          ref: i,
          class: "relative h-[10px] min-w-0 flex-1 touch-none cursor-pointer rounded-(--border-border-radius-rounded-sm) outline-1 outline-solid outline-(--border-border-base-soft)",
          style: Ne({ backgroundImage: me }),
          "data-testid": "color-picker-hue",
          onPointerdown: de[15] || (de[15] = (ge) => S("hue", ge)),
          onMousedown: de[16] || (de[16] = Ye(() => {
          }, ["prevent"])),
          onPointermove: L,
          onPointerup: T,
          onPointercancel: T
        }, [
          v("span", {
            class: C([
              "pointer-events-none absolute top-1/2 size-(--spacing-4) -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-thumb)",
              _.value && "ring-2 ring-(--border-border-accent)"
            ]),
            style: Ne({ left: `${u.value.h / 360 * 100}%`, backgroundColor: b.value }),
            "data-testid": "color-picker-hue-thumb"
          }, null, 6),
          v("input", {
            ref_key: "hueInputRef",
            ref: d,
            type: "range",
            class: "sr-only",
            min: "0",
            max: "360",
            step: "1",
            value: Math.round(u.value.h),
            "aria-label": e.labels.hue,
            "aria-valuetext": `${Math.round(u.value.h)}°`,
            "data-testid": "color-picker-hue-input",
            onInput: de[10] || (de[10] = (ge) => M(ge, "h")),
            onChange: de[11] || (de[11] = (ge) => l("commit")),
            onKeydown: de[12] || (de[12] = (ge) => E(ge, "h", 360)),
            onFocus: de[13] || (de[13] = (ge) => _.value = !0),
            onBlur: de[14] || (de[14] = (ge) => _.value = !1)
          }, null, 40, oj)
        ], 36)
      ]),
      v("div", ij, [
        v("div", sj, [
          v("div", dj, [
            v("input", {
              id: `${I(r)}-hex`,
              type: "text",
              maxlength: "7",
              spellcheck: "false",
              class: C(zb),
              value: B.value ?? f.value,
              "data-testid": "color-picker-hex",
              onInput: de[17] || (de[17] = (ge) => B.value = ge.target.value),
              onBlur: z,
              onKeydown: ut(Ye(z, ["prevent"]), ["enter"])
            }, null, 40, uj),
            v("label", {
              for: `${I(r)}-hex`,
              class: C(Ob)
            }, N(e.labels.hex), 9, cj)
          ]),
          (c(!0), g(ce, null, Re(U.value, (ge, se) => {
            var Se;
            return c(), g("div", {
              key: `${Y.value}-${ge.short}`,
              class: "flex min-w-0 flex-1 flex-col items-center gap-[10px]"
            }, [
              v("input", {
                id: `${I(r)}-${ge.short}`,
                type: "text",
                inputmode: "numeric",
                class: C(zb),
                value: ((Se = W.value) == null ? void 0 : Se.index) === se ? W.value.text : ge.value,
                "aria-label": `${ge.name} (${ge.short})`,
                "data-testid": `color-picker-channel-${ge.short}`,
                onInput: (V) => K(se, V),
                onKeydown: (V) => j(se, V),
                onBlur: G
              }, null, 40, fj),
              v("label", {
                for: `${I(r)}-${ge.short}`,
                class: C(Ob),
                "aria-hidden": "true"
              }, N(ge.short), 9, hj)
            ]);
          }), 128))
        ]),
        v("button", {
          type: "button",
          class: "relative flex size-(--icon-size-sm) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-sm) text-(--icons-icon-dark-default) after:absolute after:-inset-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": Y.value === "rgb" ? e.labels.switchToHsl : e.labels.switchToRgb,
          "data-testid": "color-picker-format",
          onClick: de[18] || (de[18] = (ge) => Y.value = Y.value === "rgb" ? "hsl" : "rgb")
        }, [...de[20] || (de[20] = [
          v("i", {
            class: "ri-expand-up-down-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, bj)
      ])
    ]));
  }
}), mj = {
  dialog: "Color picker",
  openPicker: "Choose a color",
  pickColor: "Pick a color",
  resetColor: "Reset color",
  palette: "Colors",
  saturation: "Saturation",
  brightness: "Brightness",
  hue: "Hue",
  hex: "Hex",
  red: "Red",
  green: "Green",
  blue: "Blue",
  lightness: "Lightness",
  eyedropper: "Pick a color from the screen",
  switchToHsl: "Switch to HSL",
  switchToRgb: "Switch to RGB",
  invalidHex: "Enter a color in the #RRGGBB format"
}, pj = {
  fr: {
    dialog: "Sélecteur de couleur",
    openPicker: "Choisir une couleur",
    pickColor: "Choisir une couleur",
    resetColor: "Réinitialiser la couleur",
    palette: "Couleurs",
    saturation: "Saturation",
    brightness: "Brillance",
    hue: "Teinte",
    hex: "Hex",
    red: "Rouge",
    green: "Vert",
    blue: "Bleu",
    lightness: "Luminosité",
    eyedropper: "Prélever une couleur à l'écran",
    switchToHsl: "Passer en TSL",
    switchToRgb: "Passer en RVB",
    invalidHex: "Saisissez une couleur au format #RRGGBB"
  },
  nl: {
    dialog: "Kleurkiezer",
    openPicker: "Kies een kleur",
    pickColor: "Kies een kleur",
    resetColor: "Kleur resetten",
    palette: "Kleuren",
    saturation: "Verzadiging",
    brightness: "Helderheid",
    hue: "Tint",
    hex: "Hex",
    red: "Rood",
    green: "Groen",
    blue: "Blauw",
    lightness: "Lichtheid",
    eyedropper: "Kleur van het scherm kiezen",
    switchToHsl: "Wisselen naar HSL",
    switchToRgb: "Wisselen naar RGB",
    invalidHex: "Voer een kleur in als #RRGGBB"
  }
}, Pb = {
  en: {
    indigo: "Indigo",
    green: "Green",
    yellow: "Yellow",
    red: "Red",
    orange: "Orange",
    violet: "Violet",
    purple: "Purple",
    pink: "Pink",
    cyan: "Cyan",
    gray: "Gray",
    slate: "Slate"
  },
  fr: {
    indigo: "Indigo",
    green: "Vert",
    yellow: "Jaune",
    red: "Rouge",
    orange: "Orange",
    violet: "Violet",
    purple: "Pourpre",
    pink: "Rose",
    cyan: "Cyan",
    gray: "Gris",
    slate: "Ardoise"
  },
  nl: {
    indigo: "Indigo",
    green: "Groen",
    yellow: "Geel",
    red: "Rood",
    orange: "Oranje",
    violet: "Violet",
    purple: "Paars",
    pink: "Roze",
    cyan: "Cyaan",
    gray: "Grijs",
    slate: "Leisteen"
  }
}, vj = [
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#00A870", family: "green", shade: 500 },
  { hex: "#EECC01", family: "yellow", shade: 500 },
  { hex: "#F04438", family: "red", shade: 500 },
  { hex: "#FF881E", family: "orange", shade: 500 },
  { hex: "#00D492", family: "green", shade: 400 },
  { hex: "#615FFF", family: "indigo", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#4542FF", family: "indigo", shade: 500 },
  { hex: "#FF993E", family: "orange", shade: 400 },
  { hex: "#FFDDC1", family: "orange", shade: 100 },
  { hex: "#DA9DFF", family: "purple", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#D9D6FE", family: "violet", shade: 200 },
  { hex: "#FECDCA", family: "red", shade: 200 },
  { hex: "#FDA5D5", family: "pink", shade: 300 },
  { hex: "#FCD9BD", family: "orange", shade: 200 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007595", family: "cyan", shade: 700 },
  { hex: "#BE5900", family: "orange", shade: 700 },
  { hex: "#FFF085", family: "yellow", shade: 200 },
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#1430FF", family: "indigo", shade: 600 },
  { hex: "#52DBF5", family: "cyan", shade: 300 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#5EE9B5", family: "green", shade: 300 },
  { hex: "#F6339A", family: "pink", shade: 500 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007A55", family: "green", shade: 700 },
  { hex: "#1E2939", family: "gray", shade: 800 },
  { hex: "#006045", family: "green", shade: 800 },
  { hex: "#6C3A8A", family: "purple", shade: 800 },
  { hex: "#CAD5E2", family: "slate", shade: 300 },
  { hex: "#F1F5F9", family: "slate", shade: 100 },
  { hex: "#F8FAFC", family: "slate", shade: 50 }
];
function xj(e) {
  const n = Pb[e] ?? Pb.en;
  return vj.map(({ hex: t, family: a, shade: l }) => ({
    hex: t,
    name: `${n[a]} ${l}`
  }));
}
const yj = ["disabled", "aria-label", "aria-expanded", "aria-controls"], kj = ["aria-label"], xU = /* @__PURE__ */ ke({
  __name: "ColorPicker",
  props: {
    modelValue: { default: null },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    placeholder: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    width: { default: "384px" },
    fullWidth: { type: Boolean, default: !1 },
    language: { default: "en" },
    labels: { default: void 0 },
    swatches: { default: void 0 },
    showReset: { type: Boolean, default: !0 },
    resetValue: { default: null }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = m(() => t.language.slice(0, 2).toLowerCase()), r = m(() => ({
      ...pj[l.value] ?? mj,
      ...t.labels
    })), o = m(
      () => (t.swatches ?? xj(l.value)).map((Z) => ({
        ...Z,
        hex: sa(Z.hex) ?? Z.hex
      }))
    ), i = m(() => t.modelValue ? sa(t.modelValue) : null), s = je(), d = m(() => t.id ?? `${s}-input`), u = `${s}-panel`, f = m(
      () => t.label ? `${r.value.openPicker}, ${t.label}` : r.value.openPicker
    ), b = R(null), h = R(null), p = R(null), x = R(null), y = R(null), w = R(!1), $ = R("palette"), S = Symbol("color-picker");
    let L = null;
    const T = R(i.value ?? t.modelValue ?? ""), E = R(!1);
    let A = null, D = null;
    $e(
      () => t.modelValue,
      (Z) => {
        const de = Z ? sa(Z) : null;
        T.value = de ?? Z ?? "", E.value = !1, de !== A && (A = null, D = de);
      }
    );
    const M = m(
      () => t.error ?? (E.value ? r.value.invalidHex : void 0)
    );
    function F(Z, de) {
      T.value = Z ?? "", E.value = !1, Z !== i.value && (a("update:modelValue", Z), de && a("change", Z));
    }
    function X() {
      const Z = T.value.trim();
      if (Z === "") {
        F(null, !0);
        return;
      }
      const de = sa(Z);
      de ? F(de, !0) : E.value = !0;
    }
    async function _() {
      var Z;
      t.disabled || w.value || ($.value = "palette", A = null, w.value = !0, Qn(S), await Ue(), !(!w.value || L || !h.value || !p.value) && (L = ja(h.value, p.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          // altAxis keeps the panel inside a short viewport (200 % zoom) when neither side fits.
          { name: "preventOverflow", options: { padding: 8, altAxis: !0 } }
        ]
      }), (Z = x.value) == null || Z.focusInitial()));
    }
    function Y(Z) {
      w.value && ($.value === "spectrum" && me(), w.value = !1, Rn(S), L == null || L.destroy(), L = null, Z && Ue(() => {
        var de;
        return (de = h.value) == null ? void 0 : de.focus();
      }));
    }
    function B() {
      w.value ? Y(!1) : _();
    }
    async function W() {
      var Z;
      $.value = "spectrum", D = i.value, await Ue(), await (L == null ? void 0 : L.update()), (Z = y.value) == null || Z.focusInitial();
    }
    function U(Z) {
      Z.key !== "Escape" || !w.value || !ha(S) || (Z.stopPropagation(), Z.preventDefault(), Y(!0));
    }
    function z() {
      return p.value ? Array.from(
        p.value.querySelectorAll(
          "button:not([disabled]), input:not([disabled]), [tabindex]"
        )
      ).filter((Z) => {
        var de;
        return !((de = Z.getAttribute("tabindex")) != null && de.startsWith("-"));
      }) : [];
    }
    function P(Z, de) {
      de && (Z.preventDefault(), Z.stopPropagation(), de.focus());
    }
    function K(Z) {
      Z.key === "Tab" && !Z.shiftKey && w.value && P(Z, z()[0]);
    }
    function j(Z) {
      if (Z.key !== "Tab") {
        U(Z);
        return;
      }
      const de = z();
      Z.shiftKey && document.activeElement === de[0] ? P(Z, h.value) : !Z.shiftKey && document.activeElement === de.at(-1) && P(Z, document.getElementById(d.value));
    }
    function G(Z) {
      var ge;
      const de = Z.relatedTarget;
      de && !((ge = p.value) != null && ge.contains(de)) && de !== h.value && Y(!1);
    }
    Qi(b, () => Y(!1), {
      isActive: () => w.value,
      ignoreElements: () => [p.value]
    }), $e(
      () => t.disabled,
      (Z) => {
        Z && Y(!1);
      }
    ), mt(() => Y(!1));
    function q(Z) {
      F(Z, !0), Y(!0);
    }
    function J(Z) {
      A = Z, F(Z, !1);
    }
    function me() {
      const Z = A ?? i.value;
      Z !== D && (D = Z, a("change", Z));
    }
    function ye() {
      F(t.resetValue ? sa(t.resetValue) : null, !0);
    }
    return (Z, de) => (c(), g("div", {
      ref_key: "rootRef",
      ref: b,
      class: C(["relative flex min-w-0 items-start gap-(--spacing-1\\.5)", { "w-full": e.fullWidth }]),
      style: Ne(e.fullWidth ? void 0 : { width: e.width }),
      "data-testid": "color-picker",
      onKeydown: U
    }, [
      v("button", {
        ref_key: "triggerRef",
        ref: h,
        type: "button",
        disabled: e.disabled,
        "aria-label": f.value,
        "aria-haspopup": "dialog",
        "aria-expanded": w.value ? "true" : "false",
        "aria-controls": w.value ? u : void 0,
        class: C([
          // Figma strokes sit inside the box: the padding gives back the 1px border.
          "flex size-(--spacing-9) shrink-0 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)] focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
          // Aligns the swatch with the input row: TextInput's label line (20px) + its 2px gap.
          e.label && "mt-[calc(var(--line-height-l)+2px)]",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer"
        ]),
        "data-testid": "color-picker-trigger",
        onClick: B,
        onKeydown: K
      }, [
        v("span", {
          class: "size-full rounded-(--border-border-radius-rounded-xs)",
          style: Ne({ backgroundColor: i.value ?? "transparent" }),
          "data-testid": "color-picker-trigger-preview"
        }, null, 4)
      ], 42, yj),
      (c(), H(Dn, { to: "body" }, [
        w.value ? (c(), g("div", {
          key: 0,
          id: u,
          ref_key: "panelRef",
          ref: p,
          role: "dialog",
          tabindex: "-1",
          "aria-label": r.value.dialog,
          "data-focus-trap-allow-outside": "",
          class: C([
            "fixed z-[350] flex flex-col rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-3)-1px)] shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] outline-none",
            $.value === "palette" ? "w-(--color-picker-width-palette)" : "w-(--color-picker-width-spectrum)"
          ]),
          "data-testid": "color-picker-panel",
          onFocusout: G,
          onKeydown: j
        }, [
          $.value === "palette" ? (c(), H(QH, {
            key: 0,
            ref_key: "paletteRef",
            ref: x,
            swatches: o.value,
            "model-value": i.value,
            labels: r.value,
            "show-reset": e.showReset,
            onSelect: q,
            onReset: ye,
            onCustom: W
          }, null, 8, ["swatches", "model-value", "labels", "show-reset"])) : (c(), H(gj, {
            key: 1,
            ref_key: "spectrumRef",
            ref: y,
            "model-value": i.value,
            labels: r.value,
            onUpdate: J,
            onCommit: me
          }, null, 8, ["model-value", "labels"]))
        ], 42, kj)) : k("", !0)
      ])),
      re(Ot, {
        id: d.value,
        modelValue: T.value,
        "onUpdate:modelValue": de[0] || (de[0] = (ge) => T.value = ge),
        class: "min-w-0 flex-1",
        "full-width": "",
        size: "md",
        name: e.name,
        label: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        error: M.value,
        hint: e.hint,
        placeholder: e.placeholder,
        onBlur: X,
        onKeydown: ut(X, ["enter"])
      }, {
        iconRight: xe(() => [...de[1] || (de[1] = [
          v("i", {
            class: "ri-search-line text-(length:--icon-size-sm) text-(--icons-icon-disabled-strong)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["id", "modelValue", "name", "label", "required", "required-indicator", "disabled", "error", "hint", "placeholder"])
    ], 38));
  }
}), wj = ["aria-label"], Cj = {
  key: 1,
  role: "list",
  class: "stepper-navigation-scroll flex items-center gap-2 sm:gap-(--spacing-5) overflow-x-auto"
}, Sj = ["aria-label"], $j = {
  key: 0,
  "aria-hidden": "true",
  class: "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
}, Ij = {
  key: 2,
  role: "list",
  class: "stepper-navigation-scroll overflow-x-auto"
}, Tj = { class: "relative flex w-max min-w-full items-center justify-between gap-2" }, Lj = ["aria-label"], Aj = ["aria-label"], Ej = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Rj = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Bj = {
  key: 4,
  role: "list",
  class: "flex flex-col items-start"
}, Dj = ["aria-label"], Mj = { class: "flex items-center gap-(--spacing-3)" }, zj = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Oj = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Pj = {
  key: 5,
  role: "list",
  class: "stepper-navigation-scroll flex flex-col items-start gap-(--spacing-4) w-full overflow-x-auto"
}, Fj = ["aria-label"], Vj = {
  "aria-hidden": "true",
  class: "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap"
}, Nj = {
  "aria-hidden": "true",
  class: "flex-1 font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl)"
}, Hj = /* @__PURE__ */ ke({
  __name: "StepperNavigation",
  props: {
    steps: {},
    type: { default: "default" },
    labels: {},
    breakpoint: { default: "auto" }
  },
  emits: ["step-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = /* @__PURE__ */ new Set([
      "completed",
      "active",
      "error"
    ]);
    function r(W) {
      return l.has(W);
    }
    function o(W, U, z) {
      const P = t.labels.state[W.state];
      return `${W.label}, ${t.labels.step} ${U + 1} ${t.labels.of} ${z}, ${P}`;
    }
    function i(W) {
      a("step-click", W.id);
    }
    function s(W, U) {
      const z = r(W.state);
      return {
        type: z ? "button" : void 0,
        "data-testid": `stepper-navigation-step-${W.id}`,
        "aria-current": W.state === "active" ? "step" : void 0,
        "aria-disabled": z ? void 0 : "true",
        "aria-label": o(W, U, t.steps.length),
        onClick: z ? () => i(W) : void 0
      };
    }
    function d(W) {
      return r(W) ? "cursor-pointer focus:outline-none focus-visible:shadow-[0_0_2px_2px_var(--background-background-hover)]" : "";
    }
    const u = {
      upcoming: { variant: "outlined", color: "text" },
      active: { variant: "outlined", color: "gradient" },
      completed: { variant: "filled", color: "success" },
      error: { variant: "filled", color: "error" },
      disabled: { variant: "outlined", color: "disabled" }
    }, f = {
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    function b(W, U) {
      const z = u[W.state], P = f[W.state];
      return P ? { ...z, icon: P } : { ...z, label: String(U + 1) };
    }
    function h(W, U) {
      const z = u[W.state], P = f[W.state];
      return P ? { ...z, icon: P } : W.icon ? { ...z, icon: W.icon, ...W.state === "upcoming" && { color: "white" } } : { ...z, label: String(U + 1) };
    }
    const p = {
      auto: "gap-2 sm:gap-(--spacing-4)",
      mobile: "gap-2",
      desktop: "gap-(--spacing-4)"
    }, x = {
      auto: "gap-1.5 sm:gap-(--spacing-2)",
      mobile: "gap-1.5",
      desktop: "gap-(--spacing-2)"
    }, y = {
      auto: "text-(length:--size-m) sm:text-(length:--size-l) leading-(--line-height-l) sm:leading-(--line-height-xxl)",
      mobile: "text-(length:--size-m) leading-(--line-height-l)",
      desktop: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, w = m(() => t.type === "defaultVertical" ? "flex-col" : ""), $ = m(() => t.breakpoint !== "mobile"), S = m(() => t.breakpoint !== "desktop"), L = {
      auto: "flex-col gap-(--spacing-5) w-fit sm:w-auto sm:flex-row sm:items-center sm:gap-(--spacing-5) sm:overflow-x-auto",
      mobile: "flex-col gap-(--spacing-5) w-fit",
      desktop: "flex-row items-center gap-(--spacing-5) overflow-x-auto"
    }, T = {
      auto: "sm:w-36",
      mobile: "",
      desktop: "w-36"
    }, E = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, A = {
      upcoming: "bg-(--background-background-white) border border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-white) border border-(--border-border-success-strong)",
      error: "bg-(--background-background-white) border border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white) border border-(--border-border-disabled-subtle)"
    }, D = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-disabled-light)"
    }, M = {
      upcoming: "text-(--text-text-black-default)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, F = {
      auto: "h-14 sm:h-10",
      mobile: "h-14",
      desktop: "h-10"
    }, X = {
      auto: "top-9 sm:top-11",
      mobile: "top-9",
      desktop: "top-11"
    }, _ = {
      upcoming: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-success) border-(--border-border-success)",
      error: "bg-(--background-background-error) border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)"
    }, Y = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-body)"
    }, B = {
      active: "ri-arrow-right-line",
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    return (W, U) => e.type === "default" || e.type === "defaultVertical" ? (c(), g("div", {
      key: 0,
      role: "list",
      class: C(["stepper-navigation-scroll flex items-center overflow-x-auto", p[e.breakpoint]])
    }, [
      (c(!0), g(ce, null, Re(e.steps, (z, P) => (c(), g(ce, {
        key: z.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(z, P, e.steps.length),
          class: "contents"
        }, [
          (c(), H(lt(r(z.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(z, P), {
            class: [
              "flex items-center shrink-0",
              w.value,
              x[e.breakpoint],
              d(z.state)
            ]
          }), {
            default: xe(() => [
              re(Vt, Oe({
                type: "circle",
                size: "sm"
              }, { ref_for: !0 }, b(z, P)), null, 16),
              v("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) whitespace-nowrap",
                  y[e.breakpoint],
                  E[z.state]
                ])
              }, N(z.label), 3)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, wj),
        P < e.steps.length - 1 && $.value ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t border-(--border-border-base-soft)"
          ])
        }, null, 2)) : k("", !0),
        P < e.steps.length - 1 && S.value ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "sm:hidden" : "",
            "flex h-4 w-[3.5px] shrink-0 items-center justify-center"
          ])
        }, [...U[0] || (U[0] = [
          v("span", { class: "h-4 w-px rotate-[10.98deg] skew-x-[1.87deg] bg-(--border-border-base-soft)" }, null, -1)
        ])], 2)) : k("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "onlyIcons" ? (c(), g("div", Cj, [
      (c(!0), g(ce, null, Re(e.steps, (z, P) => (c(), g(ce, {
        key: z.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(z, P, e.steps.length),
          class: "contents"
        }, [
          (c(), H(lt(r(z.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(z, P), {
            class: ["flex items-center shrink-0", d(z.state)]
          }), {
            default: xe(() => [
              re(Vt, Oe({
                type: "circle",
                size: "md"
              }, { ref_for: !0 }, h(z, P)), null, 16)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Sj),
        P < e.steps.length - 1 ? (c(), g("span", $j)) : k("", !0)
      ], 64))), 128))
    ])) : e.type === "withDots" ? (c(), g("div", Ij, [
      v("div", Tj, [
        v("span", {
          "aria-hidden": "true",
          class: C([
            "absolute inset-x-0 h-0 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)",
            X[e.breakpoint]
          ])
        }, null, 2),
        (c(!0), g(ce, null, Re(e.steps, (z, P) => (c(), g("span", {
          key: z.id,
          role: "listitem",
          "aria-label": o(z, P, e.steps.length),
          class: "contents"
        }, [
          (c(), H(lt(r(z.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(z, P), {
            class: [
              "relative flex flex-col items-center gap-(--spacing-3)",
              d(z.state)
            ]
          }), {
            default: xe(() => [
              v("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                  D[z.state]
                ])
              }, N(z.label), 3),
              v("span", {
                "aria-hidden": "true",
                class: C(["h-4 w-4 rounded-full", A[z.state]])
              }, null, 2)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Lj))), 128))
      ])
    ])) : e.type === "iconsAndText" ? (c(), g("div", {
      key: 3,
      role: "list",
      class: C(["stepper-navigation-scroll flex", L[e.breakpoint]])
    }, [
      (c(!0), g(ce, null, Re(e.steps, (z, P) => (c(), g(ce, {
        key: z.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(z, P, e.steps.length),
          class: "contents"
        }, [
          (c(), H(lt(r(z.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(z, P), {
            class: [
              "flex items-center gap-(--spacing-3) text-left shrink-0",
              P === 0 ? "" : T[e.breakpoint],
              d(z.state)
            ]
          }), {
            default: xe(() => [
              v("span", {
                class: C(e.breakpoint === "auto" ? "hidden sm:contents" : "contents")
              }, [
                $.value ? (c(), H(Vt, Oe({
                  key: 0,
                  type: "circle",
                  size: "sm"
                }, { ref_for: !0 }, h(z, P)), null, 16)) : k("", !0)
              ], 2),
              v("span", {
                class: C(e.breakpoint === "auto" ? "contents sm:hidden" : "contents")
              }, [
                S.value ? (c(), H(Vt, Oe({
                  key: 0,
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, h(z, P)), null, 16)) : k("", !0)
              ], 2),
              v("span", Ej, [
                v("span", {
                  "aria-hidden": "true",
                  class: C([
                    "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                    E[z.state]
                  ])
                }, N(z.label), 3),
                z.helperText ? (c(), g("span", Rj, N(z.helperText), 1)) : k("", !0)
              ])
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Aj),
        P < e.steps.length - 1 && $.value ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
          ])
        }, null, 2)) : k("", !0),
        P < e.steps.length - 1 && S.value ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "block sm:hidden" : "",
            "self-center h-6 w-(--border-border-width-border-base) bg-(--border-border-base-soft)"
          ])
        }, null, 2)) : k("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "vertical" ? (c(), g("div", Bj, [
      (c(!0), g(ce, null, Re(e.steps, (z, P) => (c(), g(ce, {
        key: z.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(z, P, e.steps.length),
          class: "contents"
        }, [
          (c(), H(lt(r(z.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(z, P), {
            class: ["flex items-center justify-between w-full text-left", d(z.state)]
          }), {
            default: xe(() => [
              v("span", Mj, [
                re(Vt, Oe({
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, b(z, P)), null, 16),
                v("span", zj, [
                  v("span", {
                    "aria-hidden": "true",
                    class: C([
                      "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                      M[z.state]
                    ])
                  }, N(z.label), 3),
                  z.helperText ? (c(), g("span", Oj, N(z.helperText), 1)) : k("", !0)
                ])
              ]),
              $.value ? (c(), g("i", {
                key: 0,
                "aria-hidden": "true",
                class: C([e.breakpoint === "auto" ? "hidden sm:block" : "", "ri-arrow-right-s-line text-base shrink-0"])
              }, null, 2)) : k("", !0)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Dj),
        P < e.steps.length - 1 ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C(["ml-[17.5px] w-px bg-(--border-border-base-soft)", F[e.breakpoint]])
        }, null, 2)) : k("", !0)
      ], 64))), 128))
    ])) : e.type === "cards" ? (c(), g("div", Pj, [
      (c(!0), g(ce, null, Re(e.steps, (z, P) => (c(), g("span", {
        key: z.id,
        role: "listitem",
        "aria-label": o(z, P, e.steps.length),
        class: "contents"
      }, [
        (c(), H(lt(r(z.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(z, P), {
          class: [
            "flex items-center gap-(--spacing-2) w-full min-w-40 p-(--spacing-4) rounded-(--border-border-radius-rounded-l) border border-solid text-left",
            _[z.state],
            Y[z.state],
            d(z.state)
          ]
        }), {
          default: xe(() => [
            v("span", Vj, N(P + 1), 1),
            v("span", Nj, N(z.label), 1),
            B[z.state] ? (c(), g("i", {
              key: 0,
              "aria-hidden": "true",
              class: C([B[z.state], "text-xl leading-none shrink-0"])
            }, null, 2)) : k("", !0)
          ]),
          _: 2
        }, 1040, ["class"]))
      ], 8, Fj))), 128))
    ])) : k("", !0);
  }
}), yU = /* @__PURE__ */ ot(Hj, [["__scopeId", "data-v-4839e094"]]);
function fx(e) {
  return "conditions" in e;
}
function Kc(e) {
  return e.kind === "group";
}
const jj = /* @__PURE__ */ new Set(["isNull", "isNotNull"]), Wj = /* @__PURE__ */ new Set(["in", "notIn", "between"]);
function eo(e) {
  return jj.has(e);
}
function Yc(e) {
  return Wj.has(e);
}
function qj(e) {
  return !e.field || !e.op ? !1 : eo(e.op) ? !0 : Yc(e.op) ? e.op === "between" ? e.values.length === 2 && e.values.every((n) => n !== "") : e.values.length > 0 : e.value !== null && e.value !== "";
}
function Ho(e) {
  return hx(e);
}
function hx(e) {
  const n = [];
  for (const t of e.children)
    if (Kc(t)) {
      const a = hx(t);
      a.conditions.length > 0 && n.push(a);
    } else qj(t) && n.push(Uj(t));
  return { operator: e.operator, conditions: n };
}
function Uj(e) {
  const n = {
    field: e.field,
    op: e.op
  };
  return eo(e.op) || (Yc(e.op) ? n.values = [...e.values] : n.value = e.value), n;
}
function Fb(e, n) {
  return fx(e) ? {
    _id: n(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => Su(t, n))
  } : {
    _id: n(),
    kind: "group",
    operator: "and",
    children: [Su(e, n)]
  };
}
function Su(e, n) {
  return fx(e) ? {
    _id: n(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => Su(t, n))
  } : {
    _id: n(),
    kind: "criterion",
    field: e.field,
    op: e.op,
    value: e.value ?? null,
    values: e.values ? [...e.values] : []
  };
}
const Gj = /* @__PURE__ */ new Set(["lastNDays", "nextNDays"]);
function Kj(e) {
  return e.field === null && e.op === null;
}
function Yj(e, n) {
  if (e === "DateTime") {
    const l = Date.parse(String(n[0])), r = Date.parse(String(n[1]));
    return Number.isNaN(l) || Number.isNaN(r) ? null : [l, r];
  }
  const t = Number(n[0]), a = Number(n[1]);
  return Number.isNaN(t) || Number.isNaN(a) ? null : [t, a];
}
function Jj(e, n) {
  if (Kj(e))
    return [];
  const t = e.field ? n.find((l) => l.path === e.field) : void 0;
  if (e.field && !t)
    return ["fieldOrphan"];
  if (!e.field || !e.op || !t)
    return ["valueRequired"];
  const a = [];
  if (t.operators.includes(e.op) || a.push("operatorIllegal"), eo(e.op))
    return a;
  if (Gj.has(e.op)) {
    const l = Number(e.value);
    return (e.value === null || e.value === "" || !Number.isInteger(l) || l < 1) && a.push("daysInvalid"), a;
  }
  if (e.op === "between") {
    if (e.values.length !== 2 || e.values.some((r) => r === ""))
      return a.push("valueRequired"), a;
    const l = Yj(t.type, e.values);
    return (l === null || l[0] > l[1]) && a.push("rangeInvalid"), a;
  }
  return Yc(e.op) ? (e.values.length === 0 && a.push("valueRequired"), a) : e.value === null || e.value === "" ? (a.push("valueRequired"), a) : (t.type === "Number" || t.type === "Decimal" ? (typeof e.value != "number" || Number.isNaN(e.value)) && a.push("valueInvalid") : t.type === "DateTime" && Number.isNaN(Date.parse(String(e.value))) && a.push("valueInvalid"), a);
}
function Vb(e, n) {
  const t = /* @__PURE__ */ new Map(), a = (l) => {
    for (const r of l.children)
      if (Kc(r))
        a(r);
      else {
        const o = Jj(r, n);
        o.length > 0 && t.set(r._id, o);
      }
  };
  return a(e), t;
}
let Nb = 0;
function Al() {
  return Nb += 1, `afb-${Nb}`;
}
function Hb() {
  return { _id: Al(), kind: "group", operator: "and", children: [] };
}
function jb() {
  return { _id: Al(), kind: "criterion", field: null, op: null, value: null, values: [] };
}
function jo(e) {
  const n = (t) => t.kind === "group" ? {
    _id: t._id,
    kind: "group",
    operator: t.operator,
    children: t.children.map(n)
  } : {
    _id: t._id,
    kind: "criterion",
    field: t.field,
    op: t.op,
    value: t.value,
    values: [...t.values]
  };
  return n(e);
}
function bx(e, n) {
  if (e.kind !== n.kind)
    return !1;
  if (e.kind === "group" && n.kind === "group")
    return e.operator === n.operator && e.children.length === n.children.length && e.children.every((l, r) => bx(l, n.children[r]));
  const t = e, a = n;
  return t.field === a.field && t.op === a.op && t.value === a.value && t.values.length === a.values.length && t.values.every((l, r) => l === a.values[r]);
}
function Xj(e, n) {
  const t = R(e ? Fb(e, Al) : Hb()), a = R(jo(t.value)), l = R(/* @__PURE__ */ new Map()), r = m(() => l.value.size > 0), o = m(() => Rt(n) ?? []), i = m(
    () => Vb(t.value, o.value).size === 0
  ), s = m(
    () => !bx(t.value, a.value)
  );
  function d(E) {
    E.children.push(jb());
  }
  function u(E) {
    E.children.push({ _id: Al(), kind: "group", operator: "and", children: [jb()] });
  }
  function f(E) {
    const A = [E._id];
    if (E.kind === "group")
      for (const D of E.children)
        A.push(...f(D));
    return A;
  }
  function b(E, A) {
    const D = E.children.find((F) => F._id === A), M = D ? f(D) : [A];
    E.children = E.children.filter((F) => F._id !== A);
    for (const F of M)
      $(F);
  }
  function h(E, A) {
    E.operator = A;
  }
  function p(E) {
    return E.children.length >= 2;
  }
  function x(E) {
    const A = (D, M) => {
      if (D._id === E._id)
        return M;
      if (D.kind === "group")
        for (const F of D.children) {
          const X = A(F, M + 1);
          if (X !== null)
            return X;
        }
      return null;
    };
    return A(t.value, 1) ?? 1;
  }
  function y(E, A) {
    return x(E) < A;
  }
  function w(E) {
    return l.value = Vb(t.value, E), l.value.size === 0;
  }
  function $(E) {
    if (l.value.has(E)) {
      const A = new Map(l.value);
      A.delete(E), l.value = A;
    }
  }
  function S() {
    a.value = jo(t.value);
  }
  function L() {
    t.value = jo(a.value), l.value = /* @__PURE__ */ new Map();
  }
  function T(E) {
    t.value = E ? Fb(E, Al) : Hb(), a.value = jo(t.value), l.value = /* @__PURE__ */ new Map();
  }
  return {
    root: t,
    addCriterion: d,
    addGroup: u,
    removeNode: b,
    setConjunction: h,
    showConjunction: p,
    depthOf: x,
    canNest: y,
    snapshot: S,
    reset: L,
    reseed: T,
    newId: Al,
    errors: l,
    hasErrors: r,
    isValidLive: i,
    isDirty: s,
    validate: w,
    clearNodeErrors: $
  };
}
function gx(e) {
  const n = Xj(e.modelValue(), e.fields);
  function t() {
    n.root.value.children.length === 0 && (n.addCriterion(n.root.value), n.snapshot());
  }
  t(), dt(() => {
    n.snapshot();
  });
  function a(u) {
    n.reseed(u), t();
  }
  $e(
    n.root,
    () => {
      e.emitUpdate(Ho(n.root.value));
    },
    { deep: !0 }
  );
  const l = m(
    () => Ho(n.root.value).conditions.length > 0
  ), r = m(
    () => !e.busy() && l.value && n.isValidLive.value
  ), o = m(() => r.value || e.busy() ? null : l.value ? e.labels().saveDisabledInvalid ?? null : e.labels().saveDisabledEmpty ?? null);
  function i() {
    e.busy() || n.validate(e.fields()) && e.emitApply(Ho(n.root.value));
  }
  function s() {
    e.busy() || (n.reset(), e.emitReset());
  }
  function d() {
    r.value && e.emitSave(Ho(n.root.value));
  }
  return {
    builder: n,
    hasCompleteCriterion: l,
    canSave: r,
    saveDisabledReason: o,
    onApply: i,
    onReset: s,
    onSave: d,
    reseedFrom: a
  };
}
const mx = '[data-testid="filter-field-select-panel"]', Zj = ["disabled", "aria-expanded"], Qj = {
  key: 0,
  "data-testid": "filter-field-select-trigger-label",
  class: "sr-only"
}, _j = { class: "flex min-w-0 flex-1" }, eW = {
  key: 0,
  class: "flex min-h-4.5 items-center gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, tW = ["aria-label"], nW = /* @__PURE__ */ ke({
  __name: "FilterFieldSelect",
  props: {
    fields: {},
    groups: { default: () => [] },
    modelValue: { default: "" },
    placeholder: {},
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    groupsLabel: {},
    noResultsLabel: {},
    resultsCountLabel: {},
    noFieldsLabel: {},
    emptyGroupLabel: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(null), r = R(null), o = R(""), i = R(""), { isOpen: s, dropdownRef: d, toggleDropdown: u, closeDropdown: f } = Zl({
      onClose: b,
      // The panel is teleported to <body>, so every click inside it reads as an
      // "outside" click to useDropdown unless it is explicitly ignored. The selector is
      // shared with the consumers that must ignore it too.
      ignoreSelectors: [mx]
    });
    function b() {
      o.value = "", i.value = "";
    }
    const h = R({}), p = 4, x = 8, y = 540, w = 240;
    function $() {
      var le;
      const J = (le = l.value) == null ? void 0 : le.getBoundingClientRect();
      if (!J) return;
      const me = typeof window < "u" ? window.innerWidth : J.right, ye = typeof window < "u" ? window.innerHeight : J.bottom, ge = J.left + J.width / 2 > me / 2 ? { right: `${me - J.right}px` } : { left: `${J.left}px` }, se = ye - J.bottom - p - x, Se = J.top - p - x, V = se < w && Se > se, Q = V ? { bottom: `${ye - J.top + p}px` } : { top: `${J.bottom + p}px` };
      h.value = {
        position: "fixed",
        ...ge,
        ...Q,
        maxHeight: `${Math.min(y, Math.max(V ? Se : se, 0))}px`,
        zIndex: "350"
      };
    }
    function S() {
      typeof window > "u" || (window.addEventListener("scroll", $, !0), window.addEventListener("resize", $));
    }
    function L() {
      typeof window > "u" || (window.removeEventListener("scroll", $, !0), window.removeEventListener("resize", $));
    }
    $e(s, (J) => {
      J ? Ue(() => {
        var me;
        $(), S(), (me = r.value) == null || me.focusSearch();
      }) : L();
    }), mt(L);
    const T = m(
      () => t.modelValue ? t.fields.find((J) => J.path === t.modelValue) ?? null : null
    ), E = m(
      () => t.fields.map((J) => ({ key: J.path, label: J.label, icon: J.icon, group: J.group }))
    );
    function A() {
      var me, ye;
      const J = (me = T.value) == null ? void 0 : me.group;
      return J && t.groups.some((Z) => Z.value === J) ? J : ((ye = t.groups[0]) == null ? void 0 : ye.value) ?? "";
    }
    function D() {
      o.value = "", i.value = A(), u();
    }
    function M() {
      if (!t.disabled) {
        if (s.value) {
          f();
          return;
        }
        D();
      }
    }
    const F = R(null), X = R(!1), _ = R(!1), Y = m(() => _.value || s.value ? !1 : X.value ? !0 : void 0);
    function B(J) {
      try {
        X.value = J.target.matches(":focus-visible");
      } catch {
        X.value = !0;
      }
    }
    function W() {
      X.value = !1, _.value = !1;
    }
    function U(J) {
      var me;
      if (J.key === "Escape" && !s.value && !_.value && X.value && ((me = F.value) != null && me.isTruncated)) {
        J.stopPropagation(), J.preventDefault(), _.value = !0;
        return;
      }
      t.disabled || s.value || J.key !== "ArrowDown" && J.key !== "ArrowUp" || (J.preventDefault(), D());
    }
    function z(J) {
      a("update:modelValue", J), f(), Ue(() => {
        var me;
        return (me = l.value) == null ? void 0 : me.focus();
      });
    }
    function P(J) {
      s.value && (J.stopPropagation(), J.preventDefault(), f(), Ue(() => {
        var me;
        return (me = l.value) == null ? void 0 : me.focus();
      }));
    }
    const K = {
      sm: {
        container: "h-[32px] px-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      md: {
        container: "h-[36px] px-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      lg: {
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      },
      xl: {
        container: "h-[52px] px-[calc(--spacing(4)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, j = m(() => K[t.size]), G = m(() => !!t.error), q = m(() => {
      const J = "relative flex min-w-0 items-center w-full rounded-(--border-border-radius-rounded-l) border border-solid box-border text-left font-inter transition-colors select-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)";
      return t.disabled ? `${J} cursor-not-allowed bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)` : G.value ? `${J} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)` : s.value ? `${J} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)` : `${J} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    });
    return (J, me) => {
      var ye;
      return c(), g("div", {
        ref_key: "dropdownRef",
        ref: d,
        class: C(["relative min-w-0 text-left", e.fullWidth ? "w-full" : "inline-block max-w-full"]),
        onKeydown: ut(P, ["escape"])
      }, [
        v("button", {
          ref_key: "triggerRef",
          ref: l,
          type: "button",
          "data-testid": "filter-field-select-trigger",
          class: C([q.value, j.value.container]),
          disabled: e.disabled,
          "aria-expanded": I(s),
          "aria-haspopup": "dialog",
          onClick: M,
          onKeydown: U,
          onFocus: B,
          onBlur: W
        }, [
          T.value ? (c(), g("span", Qj, N(e.placeholder), 1)) : k("", !0),
          v("span", _j, [
            re(ht, {
              ref_key: "labelRef",
              ref: F,
              text: ((ye = T.value) == null ? void 0 : ye.label) ?? e.placeholder,
              focusable: !1,
              open: Y.value,
              "text-class": [
                j.value.text,
                e.disabled ? "" : T.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
              ].join(" ")
            }, null, 8, ["text", "open", "text-class"])
          ]),
          v("i", {
            class: C(["ri-arrow-down-s-line shrink-0 transition-transform duration-200 ease-in-out", [
              j.value.icon,
              e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)",
              I(s) ? "rotate-180" : "rotate-0"
            ]]),
            "aria-hidden": "true"
          }, null, 2)
        ], 42, Zj),
        e.error ? (c(), g("p", eW, [
          me[2] || (me[2] = v("i", {
            class: "ri-error-warning-fill",
            "aria-hidden": "true"
          }, null, -1)),
          v("span", null, N(e.error), 1)
        ])) : k("", !0),
        (c(), H(Dn, { to: "body" }, [
          re(wt, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: xe(() => [
              I(s) ? (c(), g("div", {
                key: 0,
                role: "dialog",
                "aria-label": e.placeholder,
                "data-testid": "filter-field-select-panel",
                "data-focus-trap-allow-outside": "",
                style: Ne([{ width: I(Xu).l }, h.value]),
                class: C(["flex max-w-[calc(100vw-2rem)] flex-col overflow-hidden", I(Wa)]),
                onKeydown: ut(P, ["escape"])
              }, [
                re(tx, {
                  ref_key: "pickerRef",
                  ref: r,
                  "active-group": i.value,
                  "onUpdate:activeGroup": me[0] || (me[0] = (Z) => i.value = Z),
                  "search-query": o.value,
                  "onUpdate:searchQuery": me[1] || (me[1] = (Z) => o.value = Z),
                  fields: E.value,
                  groups: e.groups,
                  "strict-groups": "",
                  "groups-label": e.groupsLabel,
                  "search-placeholder": e.searchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.searchPlaceholder,
                  "selected-key": e.modelValue || void 0,
                  "no-results-label": e.noResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel,
                  "empty-group-label": e.emptyGroupLabel,
                  onSelect: z
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "search-placeholder", "search-clear-label", "list-label", "selected-key", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label"])
              ], 46, tW)) : k("", !0)
            ]),
            _: 1
          })
        ]))
      ], 34);
    };
  }
}), aW = ["aria-label"], lW = { class: "flex flex-wrap items-start gap-3 py-1" }, rW = { class: "w-[100px] shrink-0" }, oW = ["aria-label"], iW = {
  key: 1,
  class: "flex h-[36px] w-full items-center rounded-xl border border-solid border-(--colors-border-base-medium) bg-(--background-background-white) px-2.5 text-sm font-medium text-(--colors-text-body) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)",
  "aria-hidden": "true"
}, sW = { class: "min-w-0 flex-1" }, dW = {
  key: 4,
  class: "flex items-start gap-2"
}, uW = {
  "data-testid": "afb-days-suffix",
  class: "flex h-9 shrink-0 items-center text-sm text-(--colors-text-body)"
}, cW = ["data-testid"], fW = { class: "flex items-start gap-3" }, hW = { class: "flex flex-wrap items-center gap-3 pt-1" }, bW = /* @__PURE__ */ ke({
  __name: "CriteriaGroup",
  props: {
    group: {},
    fields: {},
    labels: {},
    maxDepth: {},
    builder: {},
    depth: {},
    fieldGroups: {}
  },
  setup(e) {
    const n = e;
    function t(F) {
      return F ? n.fields.find((X) => X.path === F) : void 0;
    }
    function a(F, X) {
      const _ = F.type === "DateTime" ? n.labels.dateOperatorLabels : F.type === "String" ? n.labels.stringOperatorLabels : F.type === "Enum" || F.type === "Guid" ? n.labels.listOperatorLabels : void 0;
      return (_ == null ? void 0 : _[X]) ?? n.labels.operatorLabels[X] ?? X;
    }
    function l(F) {
      const X = t(F.field);
      return X ? X.operators.map((_) => ({
        value: _,
        label: a(X, _)
      })) : [];
    }
    function r(F) {
      var _;
      if (F.field && !t(F.field))
        return "orphan";
      if (!F.field || !F.op)
        return "placeholder";
      if (eo(F.op))
        return "none";
      const X = (_ = t(F.field)) == null ? void 0 : _.type;
      return F.op === "lastNDays" || F.op === "nextNDays" ? "days" : F.op === "between" ? X === "DateTime" ? "dateRange" : "numberRange" : F.op === "in" || F.op === "notIn" ? "tags" : X === "Bool" ? "bool" : X === "Number" || X === "Decimal" ? "number" : X === "DateTime" ? "date" : "text";
    }
    function o(F) {
      const X = r(F);
      return X === "dateRange" || X === "numberRange" || X === "tags";
    }
    const i = m(() => [
      { value: "and", label: n.labels.and },
      { value: "or", label: n.labels.or }
    ]);
    function s(F, X) {
      n.builder.clearNodeErrors(F._id), F.field = X || null, F.op = null, F.value = null, F.values = [];
    }
    function d(F) {
      return !F || eo(F) ? "none" : F === "between" ? "between" : F === "in" || F === "notIn" ? "set" : F === "lastNDays" || F === "nextNDays" ? "days" : "scalar";
    }
    function u(F, X) {
      n.builder.clearNodeErrors(F._id);
      const _ = F.op;
      F.op = X || null, d(F.op) !== d(_) && (F.value = null, F.values = []);
    }
    function f(F, X) {
      var Y;
      n.builder.clearNodeErrors(F._id);
      const _ = (Y = t(F.field)) == null ? void 0 : Y.type;
      if (_ === "Number" || _ === "Decimal") {
        F.value = X === "" ? null : Number(X);
        return;
      }
      F.value = X === "" ? null : X;
    }
    function b(F, X) {
      n.builder.clearNodeErrors(F._id), F.value = X === "" ? null : Number(X);
    }
    function h(F, X, _) {
      n.builder.clearNodeErrors(F._id);
      const Y = [F.values[0] ?? "", F.values[1] ?? ""];
      Y[X] = _ === null ? "" : _, F.values = Y;
    }
    function p(F, X) {
      var Y;
      n.builder.clearNodeErrors(F._id);
      const _ = (Y = t(F.field)) == null ? void 0 : Y.type;
      if (_ === "Number" || _ === "Decimal") {
        F.values = X.map(Number).filter((B) => Number.isFinite(B));
        return;
      }
      F.values = [...X];
    }
    function x(F, X) {
      n.builder.clearNodeErrors(F._id), F.value = X === "" ? null : X === "true";
    }
    function y(F) {
      return F.value === null || F.value === void 0 ? "" : String(F.value);
    }
    function w(F) {
      return Kc(F);
    }
    const $ = {
      valueRequired: "errorValueRequired",
      valueInvalid: "errorValueInvalid",
      rangeInvalid: "errorRangeInvalid",
      daysInvalid: "errorDaysInvalid",
      operatorIllegal: "errorOperatorIllegal",
      fieldOrphan: "errorFieldOrphan"
    };
    function S(F) {
      const X = n.builder.errors.value.get(F._id);
      return X != null && X.length ? n.labels[$[X[0]]] : null;
    }
    function L() {
      n.builder.addCriterion(n.group);
    }
    function T() {
      n.builder.addGroup(n.group);
    }
    function E(F) {
      n.builder.removeNode(n.group, F);
    }
    function A(F) {
      n.builder.setConjunction(n.group, F);
    }
    const D = m(() => n.builder.canNest(n.group, n.maxDepth)), M = m(
      () => n.group.operator === "or" ? n.labels.or : n.labels.and
    );
    return (F, X) => {
      const _ = Tx("CriteriaGroup", !0);
      return c(), g("div", {
        class: C([
          "flex flex-col gap-2",
          // The root level sits directly on the modal body (no card, per Figma);
          // only nested groups get a neutral-gray bordered card so they read as a
          // sub-scope. The lavender accent card was a divergence from the design.
          e.depth > 1 ? "rounded-xl border border-solid border-(--colors-border-base-soft) bg-(--colors-background-white-secondary) p-4 dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)" : ""
        ]),
        role: "group",
        "aria-label": e.labels.title
      }, [
        (c(!0), g(ce, null, Re(e.group.children, (Y, B) => (c(), g(ce, {
          key: Y._id
        }, [
          v("div", lW, [
            v("div", rW, [
              B === 1 ? (c(), g("div", {
                key: 0,
                role: "group",
                "aria-label": `${e.labels.and} / ${e.labels.or}`
              }, [
                re(El, {
                  "data-testid": "afb-conjunction",
                  "model-value": e.group.operator,
                  options: i.value,
                  placeholder: e.labels.and,
                  "aria-label": `${e.labels.and} / ${e.labels.or}`,
                  size: "sm",
                  "full-width": "",
                  "onUpdate:modelValue": A
                }, null, 8, ["model-value", "options", "placeholder", "aria-label"])
              ], 8, oW)) : B >= 2 ? (c(), g("span", iW, N(M.value), 1)) : k("", !0)
            ]),
            w(Y) ? (c(), g(ce, { key: 0 }, [
              re(_, {
                class: "min-w-0 flex-1",
                group: Y,
                fields: e.fields,
                labels: e.labels,
                "max-depth": e.maxDepth,
                builder: e.builder,
                depth: e.depth + 1,
                "field-groups": e.fieldGroups
              }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "depth", "field-groups"]),
              re(Be, {
                "data-testid": `afb-remove-${B}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (W) => E(Y._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : r(Y) === "orphan" ? (c(), g(ce, { key: 1 }, [
              v("div", sW, [
                re(Ot, {
                  "model-value": Y.field ?? "",
                  disabled: "",
                  "full-width": "",
                  error: e.labels.errorFieldOrphan
                }, null, 8, ["model-value", "error"])
              ]),
              re(Be, {
                "data-testid": `afb-remove-${B}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (W) => E(Y._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : (c(), g(ce, { key: 2 }, [
              re(nW, {
                "data-testid": `afb-field-${B}`,
                class: "min-w-0 flex-1",
                "model-value": Y.field ?? "",
                fields: e.fields,
                groups: e.fieldGroups,
                placeholder: e.labels.fieldPlaceholder,
                "search-placeholder": e.labels.fieldSearchPlaceholder,
                "search-clear-label": e.labels.fieldSearchClear,
                "groups-label": e.labels.fieldGroupsLabel,
                "no-results-label": e.labels.fieldNoResults,
                "results-count-label": e.labels.fieldResultsCount,
                "no-fields-label": e.labels.fieldNoFields,
                "empty-group-label": e.labels.fieldEmptyGroup,
                "full-width": "",
                "onUpdate:modelValue": (W) => s(Y, W)
              }, null, 8, ["data-testid", "model-value", "fields", "groups", "placeholder", "search-placeholder", "search-clear-label", "groups-label", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label", "onUpdate:modelValue"]),
              re(El, {
                "data-testid": `afb-operator-${B}`,
                class: "min-w-0 flex-1",
                "model-value": Y.op ?? "",
                options: l(Y),
                placeholder: e.labels.operatorPlaceholder,
                "aria-label": e.labels.operatorPlaceholder,
                disabled: !Y.field,
                "full-width": "",
                "onUpdate:modelValue": (W) => u(Y, W)
              }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "disabled", "onUpdate:modelValue"]),
              v("div", {
                class: C(o(Y) ? "order-last basis-full min-w-0 pl-[112px]" : "min-w-0 flex-1")
              }, [
                r(Y) === "placeholder" ? (c(), H(Ot, {
                  key: 0,
                  "model-value": "",
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  disabled: "",
                  "full-width": ""
                }, null, 8, ["placeholder", "aria-label"])) : r(Y) === "bool" ? (c(), H(El, {
                  key: 1,
                  "data-testid": `afb-value-${B}`,
                  "model-value": Y.value === null ? "" : String(Y.value),
                  options: [
                    { value: "true", label: e.labels.boolTrue },
                    { value: "false", label: e.labels.boolFalse }
                  ],
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => x(Y, W)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "onUpdate:modelValue"])) : r(Y) === "numberRange" ? (c(), H(Nv, {
                  key: 2,
                  "data-testid": `afb-value-${B}`,
                  "min-value": Y.values[0] === void 0 || Y.values[0] === "" ? null : Number(Y.values[0]),
                  "max-value": Y.values[1] === void 0 || Y.values[1] === "" ? null : Number(Y.values[1]),
                  "show-slider": !1,
                  "clamp-input-to-bounds": !1,
                  "min-placeholder": e.labels.rangeFrom,
                  "max-placeholder": e.labels.rangeTo,
                  "min-aria-label": e.labels.rangeFrom,
                  "max-aria-label": e.labels.rangeTo,
                  "separator-label": e.labels.rangeTo,
                  "onUpdate:minValue": (W) => h(Y, 0, W),
                  "onUpdate:maxValue": (W) => h(Y, 1, W)
                }, null, 8, ["data-testid", "min-value", "max-value", "min-placeholder", "max-placeholder", "min-aria-label", "max-aria-label", "separator-label", "onUpdate:minValue", "onUpdate:maxValue"])) : r(Y) === "dateRange" ? (c(), H(Jz, {
                  key: 3,
                  "data-testid": `afb-value-${B}`,
                  "start-date": String(Y.values[0] ?? ""),
                  "end-date": String(Y.values[1] ?? ""),
                  "start-placeholder": e.labels.rangeFrom,
                  "end-placeholder": e.labels.rangeTo,
                  "start-label": "",
                  "end-label": "",
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:startDate": (W) => h(Y, 0, W),
                  "onUpdate:endDate": (W) => h(Y, 1, W)
                }, null, 8, ["data-testid", "start-date", "end-date", "start-placeholder", "end-placeholder", "language", "onUpdate:startDate", "onUpdate:endDate"])) : r(Y) === "days" ? (c(), g("div", dW, [
                  re(If, {
                    "data-testid": `afb-value-${B}`,
                    "model-value": y(Y),
                    placeholder: e.labels.valuePlaceholder,
                    "aria-label": e.labels.valuePlaceholder,
                    "full-width": "",
                    "onUpdate:modelValue": (W) => b(Y, W)
                  }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"]),
                  v("span", uW, N(e.labels.daysSuffix), 1)
                ])) : r(Y) === "tags" ? (c(), H(q4, {
                  key: 5,
                  "data-testid": `afb-value-${B}`,
                  "model-value": Y.values.map(String),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "remove-label": e.labels.removeValue,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => p(Y, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "remove-label", "onUpdate:modelValue"])) : r(Y) === "number" ? (c(), H(If, {
                  key: 6,
                  "data-testid": `afb-value-${B}`,
                  "model-value": y(Y),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => f(Y, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : r(Y) === "date" ? (c(), H(gu, {
                  key: 7,
                  "data-testid": `afb-value-${B}`,
                  "model-value": y(Y),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:modelValue": (W) => f(Y, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "language", "onUpdate:modelValue"])) : r(Y) === "text" ? (c(), H(Ot, {
                  key: 8,
                  "data-testid": `afb-value-${B}`,
                  "model-value": y(Y),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => f(Y, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : k("", !0)
              ], 2),
              re(Be, {
                "data-testid": `afb-remove-${B}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (W) => E(Y._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64))
          ]),
          !w(Y) && S(Y) ? (c(), g("p", {
            key: 0,
            "data-testid": `afb-error-${B}`,
            class: "ml-[112px] -mt-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
            role: "status"
          }, N(S(Y)), 9, cW)) : k("", !0)
        ], 64))), 128)),
        v("div", fW, [
          X[0] || (X[0] = v("div", {
            class: "w-[100px] shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          v("div", hW, [
            re(In, {
              "data-testid": "afb-add-criterion",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: L
            }, {
              default: xe(() => [
                et(N(e.labels.addCriterion), 1)
              ]),
              _: 1
            }),
            D.value ? (c(), H(In, {
              key: 0,
              "data-testid": "afb-add-group",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: T
            }, {
              default: xe(() => [
                et(N(e.labels.addGroup), 1)
              ]),
              _: 1
            })) : k("", !0)
          ])
        ])
      ], 10, aW);
    };
  }
}), gW = /* @__PURE__ */ ot(bW, [["__scopeId", "data-v-30236fdf"]]), mW = {
  "data-testid": "afb-body",
  class: "flex flex-col gap-6"
}, px = /* @__PURE__ */ ke({
  __name: "AdvancedFilterBody",
  props: {
    builder: {},
    fields: {},
    labels: {},
    maxDepth: { default: 2 },
    fieldGroups: {},
    showInfoAlert: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g(ce, null, [
      e.builder.hasErrors.value ? (c(), H(Kl, {
        key: 0,
        "data-testid": "afb-error-alert",
        color: "danger",
        surface: "card",
        layout: "inline",
        heading: e.labels.errorAlert
      }, null, 8, ["heading"])) : k("", !0),
      e.showInfoAlert ? (c(), H(Kl, {
        key: 1,
        color: "info",
        surface: "card",
        layout: "inline",
        heading: e.labels.alert
      }, null, 8, ["heading"])) : k("", !0),
      v("div", mW, [
        re(gW, {
          group: e.builder.root.value,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          builder: e.builder,
          depth: 1,
          "field-groups": e.fieldGroups
        }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "field-groups"])
      ])
    ], 64));
  }
}), pW = {
  "data-testid": "afb-footer-actions",
  class: "ms-auto flex flex-wrap items-center justify-end gap-4"
}, vx = /* @__PURE__ */ ke({
  __name: "AdvancedFilterFooter",
  props: {
    labels: {},
    busy: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 },
    showSave: { type: Boolean, default: !1 },
    canSave: { type: Boolean },
    saveDisabledReason: {}
  },
  emits: ["reset", "cancel", "save", "apply"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g(ce, null, [
      re(Be, {
        "data-testid": "afb-reset",
        variant: "secondary",
        size: "md",
        label: e.labels.reset,
        disabled: e.busy,
        "icon-left": "ri-refresh-line",
        onClick: l[0] || (l[0] = (r) => t("reset"))
      }, null, 8, ["label", "disabled"]),
      v("div", pW, [
        e.showCancel ? (c(), H(Be, {
          key: 0,
          "data-testid": "afb-cancel",
          variant: "secondary",
          size: "md",
          label: e.labels.cancel,
          disabled: e.busy,
          onClick: l[1] || (l[1] = (r) => t("cancel"))
        }, null, 8, ["label", "disabled"])) : k("", !0),
        e.showSave ? (c(), H(ft, {
          key: 1,
          text: e.saveDisabledReason ?? "",
          disabled: e.saveDisabledReason === null,
          tabindex: e.saveDisabledReason ? 0 : void 0,
          "data-testid": "afb-save-tooltip",
          position: "top"
        }, {
          default: xe(() => [
            re(Be, {
              "data-testid": "afb-save",
              variant: "secondary",
              size: "md",
              label: e.labels.save,
              disabled: !e.canSave,
              "icon-left": "ri-save-3-fill",
              onClick: l[2] || (l[2] = (r) => t("save"))
            }, null, 8, ["label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"])) : k("", !0),
        re(Be, {
          "data-testid": "afb-apply",
          variant: "primary",
          size: "md",
          label: e.labels.apply,
          disabled: e.busy,
          loading: e.busy,
          "icon-left": "ri-check-fill",
          onClick: l[3] || (l[3] = (r) => t("apply"))
        }, null, 8, ["label", "disabled", "loading"])
      ])
    ], 64));
  }
}), kU = /* @__PURE__ */ ke({
  __name: "AdvancedFilterBuilder",
  props: {
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    labels: {},
    showSave: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "apply", "reset", "cancel", "close", "save"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = gx({
      modelValue: () => t.modelValue,
      fields: () => t.fields,
      busy: () => t.busy,
      labels: () => t.labels,
      emitUpdate: (s) => a("update:modelValue", s),
      emitApply: (s) => a("apply", s),
      emitReset: () => a("reset"),
      emitSave: (s) => a("save", s)
    }), r = R(!0);
    function o() {
      t.busy || a("cancel");
    }
    function i() {
      r.value = !1, a("close");
    }
    return (s, d) => (c(), H(Va, {
      modelValue: r.value,
      "onUpdate:modelValue": d[0] || (d[0] = (u) => r.value = u),
      size: "lg",
      "footer-position": "split",
      title: e.labels.title,
      icon: "ri-shuffle-line",
      "header-align": "middle-stacked",
      "show-header-border": !1,
      onClose: i
    }, {
      footer: xe(() => [
        re(vx, {
          labels: e.labels,
          busy: e.busy,
          "show-cancel": e.showCancel,
          "show-save": e.showSave,
          "can-save": I(l).canSave.value,
          "save-disabled-reason": I(l).saveDisabledReason.value,
          onReset: I(l).onReset,
          onCancel: o,
          onSave: I(l).onSave,
          onApply: I(l).onApply
        }, null, 8, ["labels", "busy", "show-cancel", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
      ]),
      default: xe(() => [
        re(px, {
          builder: I(l).builder,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          "field-groups": e.fieldGroups,
          "show-info-alert": ""
        }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]));
  }
}), vW = ["aria-labelledby"], xW = {
  "data-testid": "afp-header",
  class: "flex min-w-0 shrink-0 items-center justify-between gap-2 max-sm:flex-wrap"
}, yW = ["aria-labelledby"], kW = {
  "data-testid": "afp-scroll",
  class: "flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-y-auto px-6 py-5"
}, wW = {
  "data-testid": "afp-footer",
  class: "flex min-w-0 shrink-0 flex-wrap items-center justify-between gap-3 px-6"
}, wU = /* @__PURE__ */ ke({
  __name: "AdvancedFilterPopover",
  props: {
    open: { type: Boolean },
    anchorEl: {},
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    showSave: { type: Boolean, default: !1 },
    labels: {}
  },
  emits: ["update:open", "update:modelValue", "apply", "reset", "save", "view-all"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = gx({
      modelValue: () => a.modelValue,
      fields: () => a.fields,
      busy: () => a.busy,
      labels: () => a.labels,
      emitUpdate: (B) => l("update:modelValue", B),
      emitApply: (B) => l("apply", B),
      emitReset: () => l("reset"),
      emitSave: (B) => l("save", B)
    }), o = je(), i = R(null);
    Ji({
      active: wn(a, "open"),
      container: i,
      containFocus: !0,
      // AC 10 — restore focus to the STABLE "Filtrer" trigger, not whatever had focus when the
      // panel opened: the opening click can come from a transient, self-closing control (e.g.
      // TableFilterSelector's own step-1 "Créer un filtre avancé"/"Voir tous les filtres
      // avancés" items — TableFilterSelector.vue's handleCreateAdvanced/handleViewAdvanced emit
      // then immediately closeDropdown(), unmounting the very button that was just clicked).
      // useFocusTrap's default previousActive-based restore captures that transient node's live
      // reference at open time, but by close time it's detached from the document — `.focus()`
      // on a detached node is a silent no-op, so focus fell back to `<body>`. `anchorEl` is
      // already the stable anchor this popover receives for positioning; reusing it here covers
      // both the direct-anchorEl-click case and the transient-control case identically.
      restoreFocusTo: () => a.anchorEl
    });
    const s = [
      mx,
      '[data-testid="dropdown-menu"]',
      '[data-testid="datepicker-dropdown-menu"]',
      '[role="tooltip"]',
      '[role="dialog"]',
      '[data-testid="modal-backdrop"]'
    ], d = 996, u = 588, f = 8, b = 4, h = R({});
    function p() {
      var G;
      const B = (G = a.anchorEl) == null ? void 0 : G.getBoundingClientRect();
      if (!B) return;
      const W = window.innerWidth, U = window.innerHeight, z = Math.min(d, W - 2 * f), P = B.bottom + b, K = Math.min(
        Math.max(f, B.left),
        Math.max(f, W - z - f)
      ), j = Math.min(u, U - P - f);
      h.value = {
        position: "fixed",
        top: `${P}px`,
        left: `${K}px`,
        width: `${z}px`,
        maxHeight: `${j}px`,
        // Page-level only: stays under the elevated save modal (z-300) that opens over it.
        zIndex: "50"
      };
    }
    function x() {
      window.addEventListener("scroll", p, !0), window.addEventListener("resize", p);
    }
    function y() {
      window.removeEventListener("scroll", p, !0), window.removeEventListener("resize", p);
    }
    let w = a.modelValue;
    $e(
      () => a.open,
      (B) => {
        if (B) {
          const W = a.modelValue !== w, U = r.builder.isDirty.value;
          (W || U) && (r.reseedFrom(a.modelValue), w = a.modelValue), Ue(() => {
            p(), x();
          });
        } else
          y();
      },
      { immediate: !0 }
    );
    const $ = Symbol("advanced-filter-popover");
    $e(
      () => a.open,
      (B) => {
        B ? Qn($) : Rn($);
      },
      { immediate: !0 }
    ), mt(() => {
      y(), Rn($);
    });
    const S = R(!1), L = R(null);
    let T = !1;
    function E() {
      if (!r.builder.isDirty.value) {
        F();
        return;
      }
      S.value = !0;
    }
    function A() {
      L.value = () => l("view-all"), E();
    }
    function D(B) {
      L.value = B, E();
    }
    function M() {
      Ue(() => {
        var B;
        return (B = a.anchorEl) == null ? void 0 : B.focus();
      });
    }
    function F() {
      if (S.value = !1, r.builder.reset(), l("update:open", !1), L.value) {
        T = !0;
        const B = L.value;
        L.value = null, B();
      } else
        M();
    }
    function X() {
      S.value = !1, L.value = null;
    }
    function _() {
      if (r.builder.reset(), T) {
        T = !1;
        return;
      }
      M();
    }
    n({ requestCloseThen: D, discard: _ });
    function Y(B) {
      a.open && ha($) && (B.defaultPrevented || (B.stopPropagation(), B.preventDefault(), E()));
    }
    return Qi(i, E, {
      isActive: () => a.open,
      ignoreSelectors: s
    }), (B, W) => (c(), H(Dn, { to: "body" }, [
      e.open ? (c(), g("div", {
        key: 0,
        ref_key: "panelRef",
        ref: i,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": I(o),
        "data-testid": "afp-panel",
        style: Ne(h.value),
        class: "flex flex-col gap-2 rounded-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        onKeydown: ut(Y, ["escape"])
      }, [
        v("div", xW, [
          v("h2", {
            "data-testid": "afp-title",
            class: "flex min-w-0",
            "aria-labelledby": I(o)
          }, [
            re(Nr, {
              id: I(o),
              type: "h5",
              "icon-left": "ri-shuffle-line",
              label: e.labels.title,
              "info-right": e.labels.titleInfo,
              "data-testid": "afp-heading"
            }, null, 8, ["id", "label", "info-right"])
          ], 8, yW),
          re(In, {
            "data-testid": "afp-view-all",
            size: "l",
            class: "max-w-full shrink-0 text-left",
            onClick: A
          }, {
            default: xe(() => [
              et(N(e.labels.viewAllFilters), 1)
            ]),
            _: 1
          })
        ]),
        v("div", kW, [
          re(px, {
            builder: I(r).builder,
            fields: e.fields,
            labels: e.labels,
            "max-depth": e.maxDepth,
            "field-groups": e.fieldGroups,
            "show-info-alert": !1
          }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
        ]),
        v("div", wW, [
          re(vx, {
            labels: e.labels,
            busy: e.busy,
            "show-cancel": !1,
            "show-save": e.showSave,
            "can-save": I(r).canSave.value,
            "save-disabled-reason": I(r).saveDisabledReason.value,
            onReset: I(r).onReset,
            onSave: I(r).onSave,
            onApply: I(r).onApply
          }, null, 8, ["labels", "busy", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
        ]),
        S.value ? (c(), H(nN, {
          key: 0,
          "model-value": S.value,
          title: e.labels.confirmCloseTitle,
          message: e.labels.confirmCloseMessage,
          "stay-label": e.labels.confirmCloseStay,
          "leave-label": e.labels.confirmCloseLeave,
          "onUpdate:modelValue": W[0] || (W[0] = (U) => S.value = U),
          onStay: X,
          onLeave: F
        }, null, 8, ["model-value", "title", "message", "stay-label", "leave-label"])) : k("", !0)
      ], 44, vW)) : k("", !0)
    ]));
  }
}), CW = {
  key: 0,
  "data-testid": "banner",
  class: "@container/banner w-full min-w-0"
}, SW = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "banner-live"
}, $W = {
  key: 0,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 items-center justify-center gap-2.5"
}, IW = {
  key: 0,
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, TW = {
  key: 1,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 flex-col gap-4 @5xl/banner:flex-row @5xl/banner:items-center @5xl/banner:justify-between @5xl/banner:gap-0"
}, LW = {
  key: 0,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 flex-col gap-1"
}, AW = {
  key: 1,
  "data-testid": "banner-description",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, EW = {
  key: 1,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 items-center gap-4"
}, RW = {
  key: 0,
  "data-testid": "banner-logo",
  class: "flex shrink-0 items-center"
}, BW = {
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, DW = 150, MW = 5e3, CU = /* @__PURE__ */ ke({
  __name: "Banner",
  props: {
    type: { default: "default" },
    text: { default: void 0 },
    heading: { default: void 0 },
    description: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: "ri-notification-4-line" },
    link: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    closeLabel: {}
  },
  emits: ["close", "link", "primary", "secondary"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = R(!1), r = R("");
    let o;
    const i = m(
      () => (t.type === "heading" ? [t.heading, t.description] : [t.text]).filter(Boolean).join(" ")
    );
    function s() {
      clearTimeout(o), r.value = "", o = setTimeout(() => {
        r.value = i.value, o = setTimeout(() => r.value = "", MW);
      }, DW);
    }
    dt(s), $e(i, () => Ue(s)), mt(() => clearTimeout(o));
    const d = m(() => [
      "flex w-full min-w-0 p-4 bg-(--background-background-white) rounded-(--border-border-radius-rounded-l) dark:bg-(--background-background-black-default)",
      t.type === "logo" ? "items-start border border-(--border-border-base-soft) shadow-(--blur-shadow-s) dark:border-(--border-border-base) dark:shadow-(--blur-shadow-m-dark) @5xl/banner:items-center @5xl/banner:justify-between" : "border-b border-(--border-border-base-soft) dark:border-(--border-border-base)",
      t.type === "heading" ? "items-start @5xl/banner:items-center" : "",
      t.type === "default" ? "items-center" : ""
    ]);
    function u() {
      a("close"), l.value = !0;
    }
    return (f, b) => l.value ? k("", !0) : (c(), g("div", CW, [
      v("div", SW, N(r.value), 1),
      v("div", {
        "data-testid": "banner-surface",
        class: C(d.value)
      }, [
        e.type === "default" ? (c(), g("div", $W, [
          re(Vt, {
            icon: e.icon,
            color: "gradient",
            size: "sm",
            type: "circle",
            variant: "filled",
            class: "shrink-0"
          }, null, 8, ["icon"]),
          e.text ? (c(), g("p", IW, N(e.text), 1)) : k("", !0),
          e.link ? (c(), H(In, {
            key: 1,
            "data-testid": "banner-link",
            as: e.link.href ? "a" : "button",
            href: e.link.href,
            "aria-label": e.link.ariaLabel,
            size: "s",
            "icon-right": "ri-arrow-right-line",
            class: "shrink-0",
            onClick: b[0] || (b[0] = (h) => e.link.href || a("link"))
          }, {
            default: xe(() => [
              et(N(e.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href", "aria-label"])) : k("", !0)
        ])) : (c(), g("div", TW, [
          e.type === "heading" ? (c(), g("div", LW, [
            e.heading ? (c(), H(lt(`h${e.headingLevel}`), {
              key: 0,
              "data-testid": "banner-heading",
              class: "wrap-break-word text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--text-text-white-default)"
            }, {
              default: xe(() => [
                et(N(e.heading), 1)
              ]),
              _: 1
            })) : k("", !0),
            e.description ? (c(), g("p", AW, N(e.description), 1)) : k("", !0)
          ])) : (c(), g("div", EW, [
            f.$slots.logo ? (c(), g("div", RW, [
              Ae(f.$slots, "logo")
            ])) : k("", !0),
            e.text ? (c(), g("div", {
              key: 1,
              "data-testid": "banner-text-frame",
              class: C(["flex min-w-0 flex-1 items-center", f.$slots.logo ? "border-l border-(--border-border-base-soft) pl-[calc(--spacing(4)-1px)] dark:border-(--border-border-base)" : ""])
            }, [
              v("p", BW, N(e.text), 1)
            ], 2)) : k("", !0)
          ])),
          e.secondaryAction || e.primaryAction ? (c(), g("div", {
            key: 2,
            "data-testid": "banner-actions",
            class: C(["flex shrink-0 flex-wrap items-center gap-3", e.type === "logo" ? "justify-end" : ""])
          }, [
            e.type === "heading" && e.secondaryAction ? (c(), H(Be, {
              key: 0,
              "data-testid": "banner-secondary",
              variant: "secondary",
              size: "xs",
              "icon-left": "ri-arrow-left-line",
              label: e.secondaryAction.label,
              onClick: b[1] || (b[1] = (h) => a("secondary"))
            }, null, 8, ["label"])) : k("", !0),
            e.primaryAction ? (c(), H(Be, {
              key: 1,
              "data-testid": "banner-primary",
              variant: "primary",
              size: "xs",
              "icon-right": e.type === "heading" ? "ri-arrow-right-line" : void 0,
              label: e.primaryAction.label,
              onClick: b[2] || (b[2] = (h) => a("primary"))
            }, null, 8, ["icon-right", "label"])) : k("", !0)
          ], 2)) : k("", !0)
        ])),
        re(Be, {
          "data-testid": "banner-close",
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": e.closeLabel,
          class: C(["shrink-0", e.type === "default" ? "" : "@5xl/banner:ml-3"]),
          onClick: u
        }, null, 8, ["aria-label", "class"])
      ], 2)
    ]));
  }
}), SU = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Violet.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Violet.50}",
  "Background-background-accent-strong": "{Colors.Indigo.600}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.300}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.100}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Primary.800-opacity-bold}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.500}",
  "Text-text-disabled-strong": "{Colors.Gray.500}",
  "Text-text-disabled-light": "{Colors.Gray.400}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Violet.500}",
  "Text-Text-hover": "{Colors.Violet.800}",
  "Text-Text-info": "{Colors.Indigo.700}",
  "Text-Text-accent": "{Colors.Indigo.500}",
  "Icons-icon-black": "{black}",
  "Icons-icon-white": "{white}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.100}",
  "Icons-icon-disabled-strong": "{Colors.Gray.500}",
  "Icons-icon-disabled-light": "{Colors.Gray.400}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Violet.500}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.400}",
  "Icons-icon-warning": "{Colors.Warning.600}",
  "Icons-icon-error": "{Colors.Error.700}",
  "Icons-icon-info": "{Colors.Indigo.700}",
  "Icons-icon-hover": "{Colors.Violet.800}",
  "Icons-icon-accent": "{Colors.Indigo.500}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.500}",
  "Icons-icon-color-default": "{Colors.Cyan.600}",
  "Components-Button-button-disabled": "{Colors.Gray.200-opacity-bold}",
  "Components-Button-Primary-button-primary": "{Colors.Primary.800-base}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{white}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.50}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Indigo.50}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.100}",
  "Components-Button-Tab-button-tab": "{white}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{white}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.50}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.700}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.800}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.800}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.900}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.900}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.300}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.500}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.500}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.500}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.300}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.500}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.300}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.500}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.400}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.400}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.400}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.400}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.500}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.500}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{Colors.Neutral.050}",
  "Components-Badge-Text-badge-black-text": "{black}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-body-text": "{Colors.Gray.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.300}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{Colors.Neutral.400}",
  "Components-Badge-Border-badge-base-soft-border": "{Colors.Gray.200}",
  "Components-Badge-Border-badge-black-border": "{black}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.500}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.700}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.600}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.600}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.500}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.400}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.700}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Neutral.200}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Error.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.500}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Primary.800-base}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Error.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.400}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.400}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.300}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.300}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.500}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.400}",
  "Border-border-accent": "{Colors.Indigo.500}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Violet.800}",
  "Border-border-info": "{Colors.Indigo.500}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.700}",
  "Border-border-success": "{Colors.Success.500}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.600}",
  "Border-border-error-subtle": "{Colors.Error.200}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, $U = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Indigo.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Indigo.50}",
  "Background-background-accent-strong": "{Colors.Indigo.50}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.400}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.050}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Gray.700}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.600}",
  "Text-text-disabled-strong": "{Colors.Gray.800}",
  "Text-text-disabled-light": "{Colors.Gray.300}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Indigo.400}",
  "Text-Text-hover": "{Colors.Indigo.300}",
  "Text-Text-info": "{Colors.Indigo.600}",
  "Text-Text-accent": "{Colors.Indigo.400}",
  "Icons-icon-black": "{Colors.Primary.800-base}",
  "Icons-icon-white": "{Colors.Primary.800-base}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.050}",
  "Icons-icon-disabled-strong": "{Colors.Gray.800}",
  "Icons-icon-disabled-light": "{Colors.Gray.300}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Indigo.400}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.300}",
  "Icons-icon-warning": "{Colors.Warning.300}",
  "Icons-icon-error": "{Colors.Error.500}",
  "Icons-icon-info": "{Colors.Indigo.400}",
  "Icons-icon-hover": "{Colors.Indigo.300}",
  "Icons-icon-accent": "{Colors.Indigo.400}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.600}",
  "Icons-icon-color-default": "{Colors.Cyan.700}",
  "Components-Button-button-disabled": "{Colors.Gray.400}",
  "Components-Button-Primary-button-primary": "{Colors.Black opacity.50-opacity-bold}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{Colors.Neutral.050}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.500}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Primary.800-base}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.200-opacity-medium}",
  "Components-Button-Tab-button-tab": "{Colors.Neutral.050}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{Colors.Gray.050}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.400}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.200}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.500}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.300}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.500}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.700}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.600}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{white}",
  "Components-Badge-Text-badge-black-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-body-text": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{white}",
  "Components-Badge-Border-badge-base-soft-border": "{white}",
  "Components-Badge-Border-badge-black-border": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Neutral.700}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.100}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.100}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.100}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.100}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.100}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Gray.500}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Cyan.600}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.500}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.500}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.400}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.200}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.400}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity-medium}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.300}",
  "Border-border-accent": "{Colors.Indigo.400}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Indigo.400}",
  "Border-border-info": "{Colors.Indigo.400}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.600}",
  "Border-border-success": "{Colors.Success.400}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.500}",
  "Border-border-error-subtle": "{Colors.Error.300}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, IU = {
  "spacing-0": "{number.0}",
  "spacing-1": "{number.1}",
  "spacing-2": "{number.2}",
  "spacing-3": "{number.3}",
  "spacing-4": "{number.4}",
  "spacing-5": "{number.5}",
  "spacing-6": "{number.6}",
  "spacing-8": "{number.8}",
  "spacing-9": "{number.9}",
  "spacing-10": "{number.10}",
  "spacing-12": "{number.12}",
  "spacing-14": "{number.14}",
  "spacing-16": "{number.16}",
  "spacing-20": "{number.20}",
  "spacing-24": "{number.24}",
  "spacing-px": "{number.px}",
  "spacing-0.5": "{number.0.5}",
  "spacing-1.5": "{number.1.5}",
  "spacing-3.5": "{number.3.5}",
  "icon-size-xs": "{number.3.5}",
  "icon-size-sm": "{number.4}",
  "icon-size-md": "{number.5}",
  "icon-size-lg": "{number.6}",
  "border-border-radius-rounded-0": "{border.border-radius.rounded-0}",
  "border-border-radius-rounded-xxs": "{border.border-radius.rounded-xxs}",
  "border-border-radius-rounded-xs": "{border.border-radius.rounded-xs}",
  "border-border-radius-rounded-sm": "{border.border-radius.rounded-sm}",
  "border-border-radius-rounded-l": "{border.border-radius.rounded-l}",
  "border-border-radius-rounded-base": "{border.border-radius.rounded-base}",
  "border-border-radius-rounded-xl": "{border.border-radius.rounded-xl}",
  "border-border-radius-rounded-xxl": "{border.border-radius.rounded-xxl}",
  "border-border-radius-rounded-full": "{border.border-radius.rounded-full}",
  "border-border-width-border-0": "{border.border-width.border-0}",
  "border-border-width-border": "{border.border-width.border}",
  "border-border-width-border-sm": "{border.border-width.border-sm}",
  "border-border-width-border-base": "{border.border-width.border-2}",
  "border-border-width-border-md": "{border.border-width.border-3}",
  "border-border-width-border-lg": "{border.border-width.border-4}",
  "border-border-width-border-xl": "{border.border-width.border-8}"
}, TU = {
  "Family-heading": "inter",
  "Family-text": "inter",
  "Size-xs": 10,
  "Size-sm": 12,
  "Size-m": 14,
  "Size-l": 16,
  "Size-xl": 18,
  "Size-xxl": 20,
  "Size-3xl": 22,
  "Size-4xl": 24,
  "Size-5xl": 28,
  "Size-6xl": 36,
  "Size-7xl": 40,
  "Size-8xl": 48,
  "Size-9xl": 52,
  "Weight-thin": 100,
  "Weight-extra-light": 200,
  "Weight-light": 300,
  "Weight-regular": 400,
  "Weight-medium": 500,
  "Weight-semi-bold": 600,
  "Weight-bold": 700,
  "Weight-extra-bold": 800,
  "Weight-black": 900,
  "Line-height-xs": 12,
  "Line-height-s": 14,
  "Line-height-m": 18,
  "Line-height-l": 20,
  "Line-height-xl": 22,
  "Line-height-xxl": 24,
  "Line-height-3xl": 26,
  "Line-height-4xl": 29,
  "Line-height-5xl": 34,
  "Line-height-6xl": 43,
  "Letter-spacing-Letter-spacing": 0,
  "Letter-case-case-original": "none",
  "Letter-case-case-upper": "uppercase",
  "Letter-case-case-lower": "lowercase",
  "Letter-case-case-title": "capitalize",
  "Letter-case-case-smallcaps": "smallcaps"
}, LU = {
  "Grid-grid-columns-l": "{number.2}",
  "Grid-grid-columns-m": "{number.1}",
  "Grid-grid-columns-xs": "{number.px}",
  "Grid-margin-4xl": "{number.24}",
  "Grid-margin-l": "{number.24}",
  "Grid-gutter": "{number.5}",
  "Grid-Sidebar-sidebar-open": 317,
  "Grid-Sidebar-sidebar-close": 158,
  "Grid-Sidebar-sidebar-toolbox": 279,
  "Grid-Container-cont-size": 1563,
  "Grid-Container-cont-size-navclosed": 1762,
  "Grid-Container-cont-size-toolbox": 1664,
  "Grid-Navbar-navbar-size": 1601,
  "Grid-Navbar-navbarclosed-size": 1762,
  "Breakpoints-width-XL": 1440,
  "Breakpoints-width-XXL": 1920
};
export {
  Kb as ACCORDION_CONTEXT_KEY,
  Yb as ACCORDION_ITEM_CONTEXT_KEY,
  NW as AccessSettings,
  OW as Accordion,
  PW as AccordionItem,
  vq as AddressInput,
  px as AdvancedFilterBody,
  kU as AdvancedFilterBuilder,
  vx as AdvancedFilterFooter,
  wU as AdvancedFilterPopover,
  Kl as Alert,
  d3 as AutoComplete,
  kq as AutoCompleteAllResultsModal,
  Mt as Avatar,
  Dv as AvatarGroup,
  yq as AvatarLabel,
  ct as Badge,
  CU as Banner,
  zP as Breadcrumb,
  Be as Button,
  Cg as ButtonGroup,
  FW as ButtonLink,
  nU as Card,
  aU as CardSelectable,
  $n as Checkbox,
  eq as CheckboxForm,
  _W as CheckboxGroup,
  j4 as CollapsibleSearch,
  cU as CollapsibleSection,
  xU as ColorPicker,
  Tq as CompactPager,
  Yq as ConfirmDeleteModal,
  XW as CopyInput,
  gW as CriteriaGroup,
  dU as CtaWidget,
  ab as DEFAULT_COUNTRY,
  Tl as DEFAULT_PHONE_FORMAT,
  Xv as DEFAULT_TABLE_LABELS,
  Qq as DataTable,
  lN as DataTableBody,
  Jq as DataTableCaption,
  mu as DataTableCell,
  aN as DataTableContainer,
  Xq as DataTableEmpty,
  Zq as DataTableFooter,
  vN as DataTableHead,
  xN as DataTableHeader,
  _o as DataTableRow,
  tU as DataTableWrapper,
  uq as DateGroupHeader,
  gu as DatePickerInput,
  Jz as DateRangePickerInput,
  Dr as DatepickerCell,
  Az as DatepickerControls,
  Iz as DatepickerDobPicker,
  jc as DatepickerDropdownMenu,
  Mv as DatepickerPanel,
  MD as DraggableListItem,
  YP as Drawer,
  ln as Dropdown,
  yf as DropdownItemButton,
  Kt as DropdownListItem,
  ul as DropdownPanelFooter,
  cl as DropdownPanelHeader,
  Kq as DynamicFormField,
  Vc as EditableTitle,
  cB as EmailInput,
  mx as FILTER_FIELD_SELECT_PANEL_SELECTOR,
  Mr as FROZEN_COLUMN_LIMIT,
  $8 as FacetedSearchDrawer,
  JW as FieldGroup,
  xt as FieldHelper,
  yt as FieldLabel,
  GH as FieldSkeleton,
  jS as FileUploadInput,
  Zu as FilterDropdown,
  tx as FilterFieldPicker,
  nW as FilterFieldSelect,
  eP as FilterPill,
  mU as FloatActionBar,
  Gq as FormErrorSummary,
  eV as FormSaveButton,
  vU as FormSkeleton,
  Vt as IconShape,
  tq as ImageInput,
  gq as ImageUploadInput,
  rU as InlineLink,
  cq as InteractionListItem,
  Nr as LabelDropdown,
  $M as ListItem,
  hq as ListItemAccordion,
  bq as ListItemAccordionRow,
  DD as ListItemCard,
  sD as ListItemGroup,
  Iq as LookupInput,
  Eq as MainDrawer,
  dq as MaskedInput,
  lU as Masonry,
  fq as MeetingListItem,
  YW as MetricCardAction,
  KW as MetricCardProgress,
  jW as MetricCardSimple,
  UW as MetricCardWithBadge,
  GW as MetricCardWithChart,
  WW as MetricCardWithIcon,
  qW as MetricCardWithTrend,
  Va as Modal,
  T1 as MultipleSelect,
  Wq as NavHeader,
  bU as NavTabs,
  jq as Navbar,
  If as NumberInput,
  Nv as NumberRangeInput,
  $q as OtpInput,
  Gn as PHONE_FORMATS,
  gB as PHONE_FORMATS_BY_DIAL_CODE,
  xO as Pager,
  rq as PasswordInput,
  sq as PhoneDisplay,
  IB as PhoneInput,
  Vv as Popover,
  fU as ProfileCard,
  Gu as ProgressBar,
  uC as RadioButton,
  ZW as RadioForm,
  QW as RadioFormGroup,
  Fq as RecordsTable,
  xq as RelationInput,
  lq as RichTextEditor,
  Zi as SearchInput,
  Hq as SecondarySidebar,
  fV as SegmentedPager,
  El as SelectInput,
  Nq as Sidebar,
  VW as SortDropdown,
  qq as SpeedDial,
  zu as Spinner,
  QP as SplitButton,
  uU as StatsWidget,
  yU as StepperNavigation,
  gU as StepperWizardSidenav,
  TO as TABLE_COLUMN_SETTINGS_KEY,
  Kv as TABLE_LABELS_KEY,
  Gv as TABLE_PERMISSIONS_KEY,
  er as TABLE_QUERY_KEY,
  ms as TABLE_SEARCH_DEBOUNCE_MS,
  gs as TABLE_VIEWS_KEY,
  Vq as Table,
  Qv as TableControls,
  _v as TableFilterBar,
  Pq as TableFilterSelector,
  Dq as TableHeader,
  lF as TablePanel,
  Bq as TableShell,
  aP as TableSkeleton,
  Zv as TableTopbar,
  q4 as TagInput,
  Ot as TextInput,
  In as TextLink,
  nq as Textarea,
  wq as TimePickerInput,
  hU as Timeline,
  Uq as ToastContainer,
  HV as ToastItem,
  Sq as ToggleGroup,
  Cq as ToggleInput,
  Ja as ToggleSwitch,
  ft as Tooltip,
  ht as TruncatedText,
  nN as UnsavedChangesModal,
  pq as UrlInput,
  HW as WeekNavigator,
  iU as WidgetBlock,
  sU as WidgetSection,
  oU as WidgetShell,
  mq as YearMonthPickerInput,
  $g as attachedPartClasses,
  Vy as buttonGroupTabId,
  $U as colorsDark,
  SU as colorsLight,
  _q as createPhoneValidator,
  Lv as datePatternFromFormat,
  Ev as deleteAcrossSeparator,
  hB as digitMaskFromPattern,
  za as fieldButtonSize,
  Hu as formatCountLabel,
  _r as formatGroupedDigits,
  mB as formatPhoneForDisplay,
  cu as groupMaskFromPlaceholder,
  sr as groupPreservingTrunkZero,
  Kc as isDraftGroup,
  fx as isGroupNode,
  Yc as isMultiValue,
  eo as isValueless,
  Lq as mapApiPaginated,
  nb as maskGroupedInput,
  Av as maskLiveInput,
  Fb as parse,
  LU as semanticBreakpoints,
  IU as semanticSpacing,
  TU as semanticTypography,
  Ho as serialize,
  Fc as significantDigitCount,
  lb as stripTrunkZero,
  iq as toE164,
  gx as useAdvancedFilterActions,
  Oq as useColumnSettings,
  Xj as useCriteriaBuilder,
  $9 as useDirtyState,
  Jb as useDisclosure,
  Rq as useDrawer,
  Zl as useDropdown,
  pU as useFloatActionBarActions,
  Ji as useFocusTrap,
  eU as useForm,
  S9 as useFormSubmit,
  C9 as useFormValidation,
  Yt as useHasSlot,
  Bv as useListRowSurface,
  I9 as useMediaQuery,
  zq as useResponsivePageSize,
  ro as useRovingListbox,
  _w as useSortable,
  tr as useTableLabels,
  Aq as useTableQuery,
  Mq as useTableViews,
  IV as useToast,
  H0 as useTruncationDetector,
  oq as withHeuristicTrunkZero
};
